var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// internal/src/client/symbols.tsx
var _analytics, _configuration, _configure, _configUser, _dispatch, _dispose, _disposed, _instanceAttributes, _isProxy, _loadEditor, _onEditorPathChange, _shareEditorRouteWithBar, _updateEditorPreviewDevice, _getEditorPreviewDevice, _perf, _programmaticTheme, _queue, _reload, _reloadCommands, _reloadOrganization, _reloadPlaceholders, _reloadNudges, _reloadHelpHub, _reloadThemes, _reloadFlags, _previewRecommendationSet, _previewCopilotSettings, _stopRecommendationSetPreview, _startNudgeDebug, _getDebugSnapshot, _showNudgeStepMock, _closeNudgeMocks, _stopChecklistPreview, _stopNudgeDebug, _previewChecklist, _reloadChecklists, _report, _search, _sentry, _setDashboard, _setPreviewMode, _setTestMode, _setEditorVisible, _shareConfig, _shareContextSettings, _shareProgrammaticCommands, _showGuide, _showMessage, _state, _unwrap, _user, _fingerprint, _userProperties, _eventSubscriptions, _metaAttributes, _updateEditorRoute, _startDebug, _stopDebug, _shareTrackedEvents, _setThemeV2, _showWidgetTableau, _setActiveChat, _getActiveChat, _updateEditorCopilotOverrides;
var init_symbols = __esm({
  "internal/src/client/symbols.tsx"() {
    "use strict";
    _analytics = Symbol.for("CommandBar::analytics");
    _configuration = Symbol.for("CommandBar::configuration");
    _configure = Symbol.for("CommandBar::configure");
    _configUser = Symbol.for("CommandBar::configUser");
    _dispatch = Symbol.for("CommandBar::dispatch");
    _dispose = Symbol.for("CommandBar::dispose");
    _disposed = Symbol.for("CommandBar::disposed");
    _instanceAttributes = Symbol.for("CommandBar::instanceAttributes");
    _isProxy = Symbol.for("CommandBar::isProxy");
    _loadEditor = Symbol.for("CommandBar::loadEditor");
    _onEditorPathChange = Symbol.for("CommandBar::onEditorPathChange");
    _shareEditorRouteWithBar = Symbol.for("CommandBar::shareEditorRouteWithBar");
    _updateEditorPreviewDevice = Symbol.for("CommandBar::updateEditorPreviewDevice");
    _getEditorPreviewDevice = Symbol.for("CommandBar::getEditorPreviewDevice");
    _perf = Symbol.for("CommandBar::perf");
    _programmaticTheme = Symbol.for("CommandBar::programmaticTheme");
    _queue = Symbol.for("CommandBar::queue");
    _reload = Symbol.for("CommandBar::reload");
    _reloadCommands = Symbol.for("CommandBar::reloadCommands");
    _reloadOrganization = Symbol.for("CommandBar::reloadOrganization");
    _reloadPlaceholders = Symbol.for("CommandBar::reloadPlaceholders");
    _reloadNudges = Symbol.for("CommandBar::reloadNudges");
    _reloadHelpHub = Symbol.for("CommandBar::reloadHelpHub");
    _reloadThemes = Symbol.for("CommandBar::reloadThemes");
    _reloadFlags = Symbol.for("CommandBar::reloadFlags");
    _previewRecommendationSet = Symbol.for("CommandBar::previewRecommendationSet");
    _previewCopilotSettings = Symbol.for("CommandBar::previewCopilotSettings");
    _stopRecommendationSetPreview = Symbol.for("CommandBar::stopRecommendationSetPreview");
    _startNudgeDebug = Symbol.for("CommandBar::startNudgeDebug");
    _getDebugSnapshot = Symbol.for("CommandBar::getDebugSnapshot");
    _showNudgeStepMock = Symbol.for("CommandBar::showNudgeStepMock");
    _closeNudgeMocks = Symbol.for("CommandBar::closeNudgeMocks");
    _stopChecklistPreview = Symbol.for("CommandBar::stopChecklistPreview");
    _stopNudgeDebug = Symbol.for("CommandBar::stopNudgeDebug");
    _previewChecklist = Symbol.for("CommandBar::previewChecklist");
    _reloadChecklists = Symbol.for("CommandBar::reloadChecklists");
    _report = Symbol.for("CommandBar::report");
    _search = Symbol.for("CommandBar::search");
    _sentry = Symbol.for("CommandBar::sentry");
    _setDashboard = Symbol.for("CommandBar::setDashboard");
    _setPreviewMode = Symbol.for("CommandBar::setPreviewMode");
    _setTestMode = Symbol.for("CommandBar::setTestMode");
    _setEditorVisible = Symbol.for("CommandBar::setEditorVisible");
    _shareConfig = Symbol.for("CommandBar::shareConfig");
    _shareContextSettings = Symbol.for("CommandBar::shareContextSettings");
    _shareProgrammaticCommands = Symbol.for("CommandBar::shareProgrammaticCommands");
    _showGuide = Symbol.for("CommandBar::showGuide");
    _showMessage = Symbol.for("CommandBar::showMessage");
    _state = Symbol.for("CommandBar::state");
    _unwrap = Symbol.for("CommandBar::unwrap");
    _user = Symbol.for("CommandBar::user");
    _fingerprint = Symbol.for("CommandBar::fingerprint");
    _userProperties = Symbol.for("CommandBar::userProperties");
    _eventSubscriptions = Symbol.for("CommandBar::eventSubscriptions");
    _metaAttributes = Symbol.for("CommandBar::metaAttributes");
    _updateEditorRoute = Symbol.for("CommandBar::updateEditorRoute");
    _startDebug = Symbol.for("CommandBar::startDebug");
    _stopDebug = Symbol.for("CommandBar::stopDebug");
    _shareTrackedEvents = Symbol.for("CommandBar::shareTrackedEvents");
    _setThemeV2 = Symbol.for("CommandBar::setThemeV2");
    _showWidgetTableau = Symbol.for("CommandBar::showWidgetTableau");
    _setActiveChat = Symbol.for("CommandBar::setActiveChat");
    _getActiveChat = Symbol.for("CommandBar::getActiveChat");
    _updateEditorCopilotOverrides = Symbol.for("CommandBar::updateEditorCopilotOverrides");
  }
});

// internal/src/util/Disposable.tsx
function dispose(x) {
  if (x === void 0)
    return;
  if (isPrivateDisposable(x)) {
    x[_dispose]();
  } else {
    x.dispose();
  }
}
var isPublicDisposable, isPrivateDisposable, isDisposable, isDisposed;
var init_Disposable = __esm({
  "internal/src/util/Disposable.tsx"() {
    "use strict";
    init_symbols();
    isPublicDisposable = (x) => x !== void 0 && x.dispose !== void 0;
    isPrivateDisposable = (x) => x !== void 0 && x[_dispose] !== void 0;
    isDisposable = (x) => x === void 0 || isPublicDisposable(x) || isPrivateDisposable(x);
    isDisposed = (x) => x === void 0 || isPublicDisposable(x) && x._disposed === true || isPrivateDisposable(x) && x[_disposed] === true;
  }
});

// internal/src/client/CommandBarClientSDK.tsx
var ASYNC_METHODS_SNIPPET, ASYNC_METHODS, LEGACY_INLINE_BAR, PRODUCTS, DEFAULT_INSTANCE_ATTRIBUTES, DEFAULT_META_ATTRIBUTES;
var init_CommandBarClientSDK = __esm({
  "internal/src/client/CommandBarClientSDK.tsx"() {
    "use strict";
    ASYNC_METHODS_SNIPPET = [
      "addCommand",
      "boot",
      "addEventSubscriber",
      "addRecordAction",
      "setFormFactor"
    ];
    ASYNC_METHODS = [
      "addCommand",
      "boot",
      "addEventSubscriber",
      "addEventHandler",
      "addRecordAction",
      "setFormFactor"
    ];
    LEGACY_INLINE_BAR = {
      dee37b08: true
    };
    PRODUCTS = ["spotlight", "nudges", "checklists", "help_hub"];
    DEFAULT_INSTANCE_ATTRIBUTES = {
      canOpenEditor: true,
      formFactor: { type: "modal" },
      products: ["spotlight", "nudges", "checklists", "help_hub"]
    };
    DEFAULT_META_ATTRIBUTES = {};
  }
});

// internal/src/client/proxy.ts
function getProxySDK() {
  const proxy2 = window.CommandBar;
  if (isDisposed(proxy2) || typeof proxy2[_isProxy] !== "boolean")
    initProxySDK();
  return window.CommandBar[_unwrap]();
}
function initProxySDK() {
  var _a2, _b2;
  const legacyProxy = window.CommandBar;
  const existingProxy = window.CommandBar;
  let orgId;
  let queue;
  let apiOrigin;
  if (Array.isArray(legacyProxy == null ? void 0 : legacyProxy.q) || typeof (legacyProxy == null ? void 0 : legacyProxy.uid) === "string") {
    orgId = legacyProxy == null ? void 0 : legacyProxy.uid;
    queue = legacyProxy == null ? void 0 : legacyProxy.q;
    apiOrigin = legacyProxy == null ? void 0 : legacyProxy.api;
  } else {
    orgId = (_a2 = existingProxy == null ? void 0 : existingProxy[_configuration]) == null ? void 0 : _a2.uuid;
    queue = existingProxy == null ? void 0 : existingProxy[_queue];
    apiOrigin = (_b2 = existingProxy == null ? void 0 : existingProxy[_configuration]) == null ? void 0 : _b2.api;
  }
  const proxy2 = {
    [_configuration]: {
      uuid: typeof orgId === "string" ? orgId : "",
      api: typeof apiOrigin === "string" ? apiOrigin : void 0
    },
    [_disposed]: false,
    [_isProxy]: true,
    [_queue]: Array.isArray(queue) ? queue : [],
    [_unwrap]: () => proxy2,
    [_eventSubscriptions]: void 0,
    [_sentry]: void 0
  };
  const sdk = proxy2;
  Object.assign(proxy2, {
    shareCallbacks: () => ({}),
    shareContext: () => ({})
  });
  window.CommandBar = new Proxy(proxy2, {
    get: function(_, prop) {
      if (prop in sdk)
        return sdk[prop];
      if (prop === "then")
        return void 0;
      if (ASYNC_METHODS_SNIPPET.includes(prop)) {
        return function() {
          const a = Array.prototype.slice.call(arguments);
          return new Promise((resolve, reject) => {
            a.unshift(prop, resolve, reject);
            proxy2[_queue].push(a);
          });
        };
      }
      return function() {
        const a = Array.prototype.slice.call(arguments);
        a.unshift(prop);
        proxy2[_queue].push(a);
      };
    }
  });
}
var init_proxy = __esm({
  "internal/src/client/proxy.ts"() {
    "use strict";
    init_Disposable();
    init_CommandBarClientSDK();
    init_symbols();
  }
});

// internal/src/util/LocalStorage.tsx
var frameName, PREFIX, set, get, remove, LocalStorage, LocalStorage_default;
var init_LocalStorage = __esm({
  "internal/src/util/LocalStorage.tsx"() {
    "use strict";
    frameName = true ? "CommandBar".toLowerCase() : "__";
    PREFIX = `commandbar.${frameName}`;
    if (["commandbar", "proxy"].includes(frameName)) {
      PREFIX = "commandbar";
    }
    set = (label, value) => {
      try {
        localStorage.setItem(`${PREFIX}.${label}`, value.toString());
        return value;
      } catch (err) {
        return "";
      }
    };
    get = (label, defaultValue, prefixOverride) => {
      let value;
      const prefix = prefixOverride != null ? prefixOverride : PREFIX;
      try {
        value = localStorage.getItem(`${prefix}.${label}`);
      } catch (err) {
        value = null;
      }
      if (value === null) {
        return defaultValue;
      } else {
        if (value === "false")
          return false;
        if (value === "true")
          return true;
        if (+value)
          return +value;
        return value;
      }
    };
    remove = (label) => {
      try {
        localStorage.removeItem(`${PREFIX}.${label}`);
        return;
      } catch (err) {
        return;
      }
    };
    LocalStorage = {
      set,
      get,
      remove
    };
    LocalStorage_default = LocalStorage;
  }
});

// internal/src/util/Logger.tsx
import Debug from "debug";
var debug, configInStorage, log, info, warn, error, red, green, blue, orange, yellow, purple, black, portalsend, portalreceive, Logger, Logger_default;
var init_Logger = __esm({
  "internal/src/util/Logger.tsx"() {
    "use strict";
    init_LocalStorage();
    debug = Debug("cb");
    configInStorage = localStorage.getItem("debug");
    if (configInStorage === null || !configInStorage.startsWith("cb")) {
      Debug.enable("*:warn,*:error");
    }
    log = debug.extend("CommandBar" ? "CommandBar".toLowerCase() : "__");
    log.log = console.log.bind(console);
    info = log.extend("info");
    info.log = console.info.bind(console);
    warn = log.extend("warn");
    warn.log = console.warn.bind(console);
    error = log.extend("error");
    error.log = console.info.bind(console);
    red = (...args) => log("%c   ", "background: red; color: white; display: block;", ...args);
    green = (...args) => log("%c   ", "background: green; color: black; display: block;", ...args);
    blue = (...args) => log("%c   ", "background: blue; color: black; display: block;", ...args);
    orange = (...args) => log("%c   ", "background: orange; color: black; display: block;", ...args);
    yellow = (...args) => log("%c   ", "background: yellow; color: black; display: block;", ...args);
    purple = (...args) => log("%c   ", "background: purple; color: black; display: block;", ...args);
    black = (...args) => log("%c   ", "background: black; color: black; display: block;", ...args);
    portalsend = !!LocalStorage_default.get("debug.portal", false) ? console.log.bind(
      window.console,
      `%c ###SEND [${"CommandBar"}] `,
      "background: darkcyan; color: black; display: block;"
    ) : () => {
      return;
    };
    portalreceive = !!LocalStorage_default.get("debug.portal", false) ? console.log.bind(
      window.console,
      `%c ###RECEIVE  [${"CommandBar"}] `,
      "background: steelblue; color: black; display: block;"
    ) : () => {
      return;
    };
    Logger = {
      debug,
      log,
      info,
      warn,
      error,
      red,
      green,
      blue,
      orange,
      yellow,
      purple,
      black,
      portalsend,
      portalreceive
    };
    Logger_default = Logger;
  }
});

// style-helper:index.js
function inject_style(text) {
  if (typeof document !== "undefined") {
    var style3 = document.createElement("style");
    var node = document.createTextNode(text);
    style3.appendChild(node);
    document.head.appendChild(style3);
  }
}
var init_index = __esm({
  "style-helper:index.js"() {
  }
});

// internal/src/middleware/network.ts
var getSentryForNetwork, MAX_WAIT_TIME_MS, baseUrl, getBaseURL, DEFAULT_HEADERS, assertNotAirgapped, isRetryable, getCookie, put, post, get2, patch, del, getFetchHeaders, _fetch;
var init_network = __esm({
  "internal/src/middleware/network.ts"() {
    "use strict";
    init_Logger();
    init_proxy();
    init_symbols();
    getSentryForNetwork = () => {
      var _a2;
      return (_a2 = getProxySDK()) == null ? void 0 : _a2[_sentry];
    };
    MAX_WAIT_TIME_MS = 3e4;
    getBaseURL = () => {
      var _a2, _b2, _c2;
      if (baseUrl) {
        return baseUrl;
      }
      let url = (_b2 = (_a2 = getProxySDK()) == null ? void 0 : _a2[_configuration]) == null ? void 0 : _b2.api;
      if (url === void 0) {
        const override = new URL(window.location.href).searchParams.get("api");
        if (!!override) {
          url = override;
        } else {
          const lc = localStorage.getItem("commandbar.lc");
          if (lc && lc.includes("api=preview_")) {
            url = `https://${(_c2 = /api=preview_([^;$]+)/.exec(lc)) == null ? void 0 : _c2[1]}.commandbar.xyz:8000`;
          } else {
            url = `${"https://api.commandbar.com"}`;
          }
        }
      }
      Logger_default.blue("[target]", url);
      return url;
    };
    DEFAULT_HEADERS = {
      "Content-Type": "application/json",
      accept: "application/json"
    };
    assertNotAirgapped = () => {
      var _a2;
      const airgap = (_a2 = getProxySDK()[_configuration]) == null ? void 0 : _a2.airgap;
      if (airgap) {
        Logger_default.red("blocking unexpected request in airgapped mode");
        throw new Error("unexpected request in airgapped mode");
      }
    };
    isRetryable = ({ method, path }) => {
      const shouldRetryForMethod = method.toLowerCase() === "get";
      const shouldRetryForEndpoint = ["commands", "categories", "placeholders", "settings", "contexts"].includes(path) || path.includes("/config/");
      return shouldRetryForMethod && shouldRetryForEndpoint;
    };
    getCookie = (name) => {
      if (document.cookie && document.cookie !== "") {
        const cookies = document.cookie.split(";");
        const cookie = cookies.find((cookie2) => {
          const [key, _] = cookie2.split("=");
          if (key.trim() === name) {
            return true;
          }
          return false;
        });
        if (cookie) {
          const [, value] = cookie.split("=");
          return value;
        }
      }
      return void 0;
    };
    put = (url, data = void 0, options = {}) => _fetch("PUT", url, data, options);
    post = (url, data = void 0, options = {}) => _fetch("POST", url, data, options);
    get2 = (url, options = {}) => _fetch("GET", url, void 0, options);
    patch = (url, data = void 0, options = {}) => _fetch("PATCH", url, data, options);
    del = (url, data = void 0, options = {}) => _fetch("DELETE", url, data, options);
    getFetchHeaders = (uploadFile) => {
      var _a2, _b2;
      const csrftoken = getCookie("csrftoken");
      const sentryProject = "";
      const sentryRelease = "";
      const launchcode = (_b2 = (_a2 = getProxySDK()) == null ? void 0 : _a2[_configuration]) == null ? void 0 : _b2.launchcode;
      return {
        ...uploadFile ? { accept: "application/json" } : DEFAULT_HEADERS,
        ...launchcode && { "X-cb-lc": launchcode },
        ...sentryProject && { "X-cb-proj": sentryProject },
        ...sentryRelease && { "X-cb-release": sentryRelease },
        "X-CSRFToken": csrftoken != null ? csrftoken : ""
      };
    };
    _fetch = async (method, path, data, options = {}, numRetries = 5) => {
      var _a2, _b2;
      assertNotAirgapped();
      const uploadFile = path.endsWith("upload_file/") || path.endsWith("upload");
      if (data !== void 0 && typeof data !== "string" && !(uploadFile && data instanceof FormData) && !(data instanceof Blob)) {
        data = JSON.stringify(data);
      }
      let _baseURL = getBaseURL();
      if (path.endsWith("/t/") && ["https://api.commandbar.com"].includes(_baseURL)) {
        _baseURL = "https://t.commandbar.com";
        options.credentials = "omit";
      }
      let json, response2, responseHeaders;
      while (path.startsWith("/"))
        path = path.slice(1);
      let n = 0;
      do {
        response2 = await fetch(_baseURL + "/" + path, {
          method,
          credentials: options.credentials || "include",
          headers: {
            ...getFetchHeaders(uploadFile),
            ...options.headers
          },
          body: data,
          signal: options.signal,
          keepalive: options.keepalive
        });
        responseHeaders = Object.fromEntries(response2.headers.entries());
        let shouldRetry = false;
        if (!response2.ok) {
          if (isRetryable({ method, path })) {
            shouldRetry = true;
          } else {
            try {
              let data2 = await response2.text();
              try {
                data2 = JSON.parse(data2);
              } catch (e) {
                (_a2 = getSentryForNetwork()) == null ? void 0 : _a2.captureException(e);
              }
              return Promise.reject(data2 || "Something went wrong");
            } catch (e) {
              (_b2 = getSentryForNetwork()) == null ? void 0 : _b2.captureException(e);
              throw new Error("Something went wrong");
            }
          }
          json = null;
        } else {
          if (response2.status === 204)
            json = null;
          else if (response2.headers.get("content-length") === "0")
            json = null;
          else
            json = await response2.json();
        }
        if (!shouldRetry)
          break;
        await new Promise(
          (resolve) => (
            // wait 2^n * 100ms + random jitter up to 1s, up to a max of 30s
            setTimeout(resolve, Math.min(Math.pow(2, n) * 100 + Math.floor(Math.random() * 1e3), MAX_WAIT_TIME_MS))
          )
        );
        n++;
      } while (n <= numRetries);
      return {
        data: json,
        status: response2.status,
        statusText: response2.statusText,
        headers: responseHeaders
      };
    };
  }
});

// internal/src/middleware/generics.tsx
import * as t from "io-ts";
import { PathReporter as reporter } from "io-ts/PathReporter";
import { pipe } from "fp-ts/function";
import { fold } from "fp-ts/Either";
function mkQueryString(params) {
  let queryString = "";
  if (params) {
    const urlSearchParams = new URLSearchParams(params);
    queryString = "?" + urlSearchParams.toString();
  }
  return queryString;
}
function decodeToPromise(validator, input) {
  const result = validator.decode(input);
  return pipe(
    result,
    fold(
      (_errors) => {
        const messages = reporter.report(result);
        const _payload = {
          error: `io-ts error -> ${messages.join("; ").toString()}`,
          errorDetail: JSON.stringify(input),
          url: window.location.href
        };
        return Promise.reject(new Error(messages.join("\n")));
      },
      (value) => {
        return Promise.resolve(value);
      }
    )
  );
}
function decodeToPromiseExact(validator, input) {
  return decodeToPromise(t.exact(validator), input);
}
function decodeThrowing(validator, input) {
  const result = validator.decode(input);
  return pipe(
    result,
    fold(
      (_errors) => {
        const messages = reporter.report(result);
        const _payload = {
          error: `io-ts error -> ${messages.join("; ").toString()}`,
          errorDetail: JSON.stringify(input),
          url: window.location.href
        };
        throw new Error(`${messages.join("\n")}
when parsing ${JSON.stringify(input, null, 2)}`);
      },
      (value) => value
    )
  );
}
function decodeErr(err) {
  var _a2;
  if (typeof err === "string")
    return err;
  if (err instanceof Error)
    return err.toString();
  return ((_a2 = err == null ? void 0 : err.response) == null ? void 0 : _a2.data) || JSON.stringify(err);
}
function createObject(output, input, url, params, options) {
  return async (object2, onSuccess, onError) => {
    try {
      const queryString = mkQueryString(params);
      const result = await post(`${url}/${queryString}`, t.exact(input).encode(object2), options);
      if (!!onSuccess) {
        onSuccess();
      }
      return await decodeToPromiseExact(output, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!onError) {
        onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function readObject(arg, url, options) {
  return async (id2, params = {}, callbacks) => {
    try {
      const queryString = mkQueryString(params);
      const result = await get2(`${url}/${id2}/${queryString}`, options);
      if (!!(callbacks == null ? void 0 : callbacks.onSuccess)) {
        callbacks.onSuccess();
      }
      return await decodeToPromiseExact(arg, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!(callbacks == null ? void 0 : callbacks.onError)) {
        callbacks == null ? void 0 : callbacks.onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function listObject(arg, obj, options) {
  return async (params, onSuccess, onError) => {
    let objects = [];
    let path = `${obj}/`;
    while (path !== null) {
      try {
        const queryString = mkQueryString(params);
        const result = await get2(`${path}${queryString}`, options);
        const data = result.data;
        if (data.hasOwnProperty("results")) {
          objects = objects.concat(data["results"]);
        } else {
          objects = data;
          path = null;
        }
        if (data.hasOwnProperty("next")) {
          path = new URL(data["next"]).pathname;
        } else {
          path = null;
        }
        if (!!onSuccess) {
          onSuccess();
        }
      } catch (err) {
        const data = decodeErr(err);
        if (!!onError) {
          onError(JSON.stringify(data));
        }
        path = null;
      }
    }
    return objects;
  };
}
function updateObject(output, input, url, params, options) {
  return async (object2, onSuccess, onError) => {
    try {
      const queryString = mkQueryString(params);
      const result = await patch(
        `${url}/${object2.id}/${queryString}`,
        t.exact(input).encode(object2),
        options
      );
      if (!!onSuccess) {
        onSuccess();
      }
      return await decodeToPromiseExact(output, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!onError) {
        onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function deleteObject(arg, url, options) {
  return async (id2, params, onSuccess, onError) => {
    try {
      const _result = await del(`${url}/${id2}/`, { ...params }, options);
      if (!!onSuccess) {
        onSuccess();
      }
      return Promise.resolve();
    } catch (err) {
      const data = decodeErr(err);
      if (!!onError) {
        onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function getURLString(urlArgs) {
  let urlString = "";
  if (urlArgs) {
    Object.keys(urlArgs).forEach((key, i2) => {
      if (i2 === 0) {
        urlString = `?${key}=${urlArgs[key]}`;
      } else {
        urlString = `${urlString}&${key}=${urlArgs[key]}`;
      }
    });
  }
  urlString = urlString.replace(/\+/g, "%2B");
  return urlString;
}
function readObjectDetail(arg, url, detail, options) {
  return async (id2, urlArgs, onSuccess, onError) => {
    const urlString = getURLString(urlArgs);
    try {
      const result = await get2(`${url}/${id2}/${detail}/${urlString}`, options);
      if (!!onSuccess) {
        onSuccess();
      }
      return await decodeToPromiseExact(arg, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!onError) {
        onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function updateObjectDetail(output, input, url, detail, options) {
  return async (object2, urlArgs, onSuccess, onError) => {
    const urlString = getURLString(urlArgs);
    try {
      const result = await patch(
        `${url}/${object2.id}/${detail}/${urlString}`,
        t.exact(input).encode(object2),
        options
      );
      if (!!onSuccess) {
        onSuccess();
      }
      return await decodeToPromiseExact(output, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!onError) {
        onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function read(output, url, options) {
  return async (params = {}, callbacks) => {
    try {
      const queryString = mkQueryString(params);
      const result = await get2(`${url}/${queryString}`, options);
      if (!!(callbacks == null ? void 0 : callbacks.onSuccess)) {
        callbacks.onSuccess();
      }
      return await decodeToPromiseExact(output, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!(callbacks == null ? void 0 : callbacks.onError)) {
        callbacks == null ? void 0 : callbacks.onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
function update(output, input, url, options) {
  return async (object2, params = {}, callbacks) => {
    try {
      const queryString = mkQueryString(params);
      const result = await patch(`${url}/${queryString}`, t.exact(input).encode(object2), options);
      if (!!(callbacks == null ? void 0 : callbacks.onSuccess)) {
        callbacks.onSuccess();
      }
      return await decodeToPromiseExact(output, result.data);
    } catch (err) {
      const data = decodeErr(err);
      if (!!(callbacks == null ? void 0 : callbacks.onError)) {
        callbacks == null ? void 0 : callbacks.onError(JSON.stringify(data));
      }
      return Promise.reject(data);
    }
  };
}
var GenericObject, GenericBatchRequest;
var init_generics = __esm({
  "internal/src/middleware/generics.tsx"() {
    "use strict";
    init_network();
    GenericObject = t.type({
      id: t.union([t.number, t.string])
    });
    GenericBatchRequest = t.type({
      batch: t.array(t.unknown),
      note: t.string
    });
  }
});

// internal/src/middleware/utils.tsx
import * as t2 from "io-ts";
function compareObjs(a, b) {
  if (a.sort_key === b.sort_key) {
    if (a.id === b.id)
      return 0;
    if (b.id === null || b.id === void 0)
      return -1;
    if (a.id === null || a.id === void 0)
      return 1;
    return a.id - b.id;
  } else {
    if (b.sort_key === null || b.sort_key === void 0)
      return -1;
    if (a.sort_key === null || a.sort_key === void 0)
      return 1;
    return a.sort_key - b.sort_key;
  }
}
function pick(Model, keys) {
  const pickedProps = {};
  keys.forEach((key) => {
    pickedProps[key] = Model.props[key];
  });
  return t2.type(pickedProps);
}
function omit(Model, keys) {
  const allKeys = Object.keys(Model.props);
  const keysToKeep = allKeys.filter((x) => !keys.includes(x));
  return pick(Model, keysToKeep);
}
var maybePluralize;
var init_utils = __esm({
  "internal/src/middleware/utils.tsx"() {
    "use strict";
    maybePluralize = (count, singular, plural = `${singular}s`, includeNum = false) => {
      if (includeNum)
        return `${count} ${count !== 1 ? plural : singular}`;
      return `${count !== 1 ? plural : singular}`;
    };
  }
});

// internal/src/middleware/helpers/argument.tsx
import * as t3 from "io-ts";
var ConditionOperatorV, ConditionV, ContextArgumentV, SetArgumentV, DashboardV, DashboardArgumentV, DynamicArgumentV, ArgumentTypeV, ArgumentMapV, StepArgumentTypeV;
var init_argument = __esm({
  "internal/src/middleware/helpers/argument.tsx"() {
    "use strict";
    ConditionOperatorV = t3.union([
      t3.literal("=="),
      t3.literal("!="),
      t3.literal("isTruthy"),
      t3.literal("isFalsy")
    ]);
    ConditionV = t3.type({
      field: t3.string,
      operator: ConditionOperatorV,
      value: t3.union([t3.string, t3.undefined])
    });
    ContextArgumentV = t3.intersection([
      t3.type({
        type: t3.literal("context"),
        value: t3.string,
        order_key: t3.number
      }),
      t3.partial({
        label: t3.string,
        chosen: t3.union([t3.string, t3.number]),
        selected: t3.array(t3.any),
        input_type: t3.string,
        preselected_key: t3.string,
        label_field: t3.string,
        loaded: t3.array(t3.any),
        allow_create: t3.boolean,
        allow_create_label: t3.string,
        show_in_record_action_list: t3.boolean,
        show_in_default_list: t3.boolean,
        auto_choose: t3.boolean,
        is_private: t3.boolean
      })
      // FIXME: this should allow any primitive type
    ]);
    SetArgumentV = t3.intersection([
      t3.type({
        type: t3.literal("set"),
        value: t3.union([t3.array(t3.string), t3.array(t3.number), t3.array(t3.UnknownRecord)]),
        order_key: t3.number
      }),
      t3.partial({
        label: t3.string,
        chosen: t3.union([t3.string, t3.number]),
        selected: t3.array(t3.any),
        input_type: t3.string,
        preselected_key: t3.string,
        label_field: t3.string,
        loaded: t3.array(t3.any),
        allow_create: t3.boolean,
        allow_create_label: t3.string,
        auto_choose: t3.boolean,
        is_private: t3.boolean
      })
    ]);
    DashboardV = t3.intersection([
      t3.type({
        source: t3.string
      }),
      t3.partial({
        title: t3.string,
        description: t3.string,
        url: t3.string
      })
    ]);
    DashboardArgumentV = t3.intersection([
      t3.type({
        type: t3.union([t3.literal("video"), t3.literal("html")]),
        value: DashboardV,
        order_key: t3.number
      }),
      t3.partial({
        label: t3.string,
        chosen: t3.union([t3.string, t3.number]),
        selected: t3.array(t3.any),
        input_type: t3.string,
        preselected_key: t3.string,
        label_field: t3.string,
        loaded: t3.array(t3.any),
        allow_create: t3.boolean,
        allow_create_label: t3.string,
        is_private: t3.boolean,
        auto_choose: t3.boolean
      })
    ]);
    DynamicArgumentV = t3.intersection([
      t3.type({
        type: t3.literal("provided"),
        //FIXME: update to dynamic
        value: t3.union([t3.literal("text"), t3.literal("time")]),
        order_key: t3.number
      }),
      t3.partial({
        label: t3.string,
        chosen: t3.union([t3.string, t3.number]),
        selected: t3.array(t3.any),
        input_type: t3.string,
        preselected_key: t3.string,
        label_field: t3.string,
        loaded: t3.array(t3.any),
        dateTimeArgumentTypeId: t3.number,
        allow_create: t3.boolean,
        allow_create_label: t3.string,
        auto_choose: t3.boolean,
        is_private: t3.boolean
      })
    ]);
    ArgumentTypeV = t3.union([ContextArgumentV, SetArgumentV, DynamicArgumentV, DashboardArgumentV]);
    ArgumentMapV = t3.record(t3.string, ArgumentTypeV);
    StepArgumentTypeV = t3.intersection([
      t3.type({
        userDefinedName: t3.string,
        // Name to show to end users
        userDefinedValue: t3.string
        // Value to pass to callbacks
      }),
      ArgumentTypeV
    ]);
  }
});

// types/src/entities/command/actions.ts
import * as t4 from "io-ts";
var AdminAction, CallbackAction, OpenBarAction, OpenHelpHubAction, OpenCopilotAction, LinkAction, OpenChatActionTypeV, OpenChatActionV, ChatHandoffActionTypeV, ChatHandoffActionV, DismissAction, StepBackAction, SnoozeInterval, SnoozeValue, SnoozeAction, ClickAction, BuiltInAction, WebhookAction, AppcuesAction, PendoGuideAction, ScriptAction, VideoAction, HelpDocAction, CommandActionMetaTypeV, CommandActionV, NoAction, ClickActionNew, NudgeActionV, GoToNudgeStepActionV, QuestlistActionV, ActionV, LabeledActionV, isAction, MethodV, RequestV, RequestAction, TriggerAction;
var init_actions = __esm({
  "types/src/entities/command/actions.ts"() {
    "use strict";
    AdminAction = t4.type({
      type: t4.literal("admin"),
      value: t4.string
    });
    CallbackAction = t4.type({
      type: t4.literal("callback"),
      value: t4.string
    });
    OpenBarAction = t4.intersection([
      t4.type({
        type: t4.literal("open_bar")
      }),
      t4.partial({
        value: t4.string,
        categoryFilter: t4.number
      })
    ]);
    OpenHelpHubAction = t4.type({ type: t4.literal("open_helphub") });
    OpenCopilotAction = t4.intersection([
      t4.type({ type: t4.literal("open_copilot") }),
      t4.partial({ query: t4.string })
    ]);
    LinkAction = t4.intersection([
      t4.type({
        type: t4.literal("link"),
        value: t4.string
      }),
      t4.partial({
        operation: t4.union([t4.literal("router"), t4.literal("self"), t4.literal("blank"), t4.undefined]),
        meta: t4.type({
          command: t4.string
        })
      })
    ]);
    OpenChatActionTypeV = t4.union([
      t4.literal("intercom"),
      t4.literal("helpscout"),
      t4.literal("freshdesk"),
      t4.literal("freshchat"),
      t4.literal("crisp"),
      t4.literal("zendesk"),
      t4.literal("liveChat"),
      t4.literal("gist"),
      t4.literal("olark"),
      t4.literal("hubspot"),
      t4.literal("drift"),
      t4.literal("pylon"),
      t4.literal("talkdesk_v2"),
      t4.literal("zendesk_handoff"),
      t4.literal("")
    ]);
    OpenChatActionV = t4.type({
      type: t4.literal("open_chat"),
      meta: t4.type({
        type: OpenChatActionTypeV
      })
    });
    ChatHandoffActionTypeV = t4.union([
      t4.literal("intercom"),
      t4.literal("freshchat"),
      t4.literal("zendesk"),
      t4.literal("sfdc_chat"),
      t4.literal("sfdc_messaging"),
      t4.literal("")
    ]);
    ChatHandoffActionV = t4.type({
      type: t4.literal("chat_handoff"),
      meta: t4.type({
        type: ChatHandoffActionTypeV
      })
    });
    DismissAction = t4.type({
      type: t4.literal("dismiss")
    });
    StepBackAction = t4.type({
      type: t4.literal("step_back")
    });
    SnoozeInterval = t4.union([t4.literal("hour"), t4.literal("day"), t4.literal("week")]);
    SnoozeValue = t4.number;
    SnoozeAction = t4.intersection([
      t4.type({
        type: t4.literal("snooze")
      }),
      t4.partial({
        interval: SnoozeInterval,
        value: SnoozeValue
      })
    ]);
    ClickAction = t4.type({
      type: t4.union([t4.literal("click"), t4.literal("clickBySelector"), t4.literal("clickByXpath")]),
      value: t4.array(t4.string)
    });
    BuiltInAction = t4.type({
      type: t4.literal("builtin"),
      value: t4.string
    });
    WebhookAction = t4.type({
      type: t4.literal("webhook"),
      value: t4.string
    });
    AppcuesAction = t4.type({
      type: t4.literal("appcues"),
      value: t4.string
    });
    PendoGuideAction = t4.type({
      type: t4.literal("pendo_guide"),
      value: t4.string
    });
    ScriptAction = t4.type({
      type: t4.literal("script"),
      value: t4.string
    });
    VideoAction = t4.type({
      type: t4.literal("video"),
      value: t4.string
    });
    HelpDocAction = t4.intersection([
      t4.type({
        type: t4.literal("helpdoc"),
        value: t4.string
      }),
      t4.partial({
        operation: t4.union([
          t4.literal("router"),
          t4.literal("self"),
          t4.literal("blank"),
          t4.literal("help_hub"),
          t4.undefined
        ]),
        doc_metadata: t4.partial({
          content_type: t4.string,
          date: t4.string
        })
      })
    ]);
    CommandActionMetaTypeV = t4.union([
      t4.literal("action"),
      t4.literal("link"),
      t4.literal("helpdoc"),
      t4.literal("video")
    ]);
    CommandActionV = t4.type({
      type: t4.literal("execute_command"),
      meta: t4.intersection([
        t4.type({
          command: t4.string
        }),
        t4.partial({
          type: CommandActionMetaTypeV
        })
      ])
    });
    NoAction = t4.type({ type: t4.literal("no_action") });
    ClickActionNew = t4.type({
      type: t4.literal("click"),
      value: t4.string
    });
    NudgeActionV = t4.type({
      type: t4.literal("nudge"),
      value: t4.number
    });
    GoToNudgeStepActionV = t4.type({
      type: t4.literal("go_to_step"),
      value: t4.number
    });
    QuestlistActionV = t4.type({
      type: t4.literal("questlist"),
      value: t4.number
    });
    ActionV = t4.union([
      CommandActionV,
      NoAction,
      ClickActionNew,
      ClickAction,
      LinkAction,
      OpenChatActionV,
      ChatHandoffActionV,
      DismissAction,
      SnoozeAction,
      QuestlistActionV,
      NudgeActionV,
      GoToNudgeStepActionV,
      StepBackAction,
      OpenBarAction,
      OpenHelpHubAction,
      OpenCopilotAction
    ]);
    LabeledActionV = t4.type({
      cta: t4.string,
      action: ActionV
    });
    isAction = (o) => {
      return o.action !== void 0;
    };
    MethodV = t4.union([
      t4.literal("get"),
      t4.literal("delete"),
      t4.literal("head"),
      t4.literal("options"),
      t4.literal("post"),
      t4.literal("put"),
      t4.literal("patch")
    ]);
    RequestV = t4.intersection([
      t4.type({
        method: MethodV,
        url: t4.string
      }),
      t4.partial({
        headers: t4.UnknownRecord,
        body: t4.UnknownRecord,
        onSend: t4.string,
        onSuccess: t4.string,
        onError: t4.string
      })
    ]);
    RequestAction = t4.type({
      type: t4.literal("request"),
      value: RequestV
    });
    TriggerAction = t4.type({
      type: t4.literal("trigger"),
      value: ActionV
    });
  }
});

// types/src/entities/command/template.ts
import * as t5 from "io-ts";
var TemplateOptionsV, AdminTemplateV, CallbackTemplateV, LinkTemplateV, ClickTemplateV, BuiltInTemplateV, WebhookTemplateV, ScriptTemplateV, RequestTemplateV, AppcuesTemplateV, PendoGuideTemplateV, VideoTemplateV, HelpDocTemplateV, TriggerTemplateV, TemplateV;
var init_template = __esm({
  "types/src/entities/command/template.ts"() {
    "use strict";
    init_actions();
    TemplateOptionsV = t5.intersection([
      t5.type({}),
      t5.partial({
        commandType: t5.union([t5.literal("independent"), t5.literal("object"), t5.literal("help")]),
        object: t5.string,
        hoverTooltip: t5.boolean,
        // fixme: can remove?
        operation: t5.union([
          t5.literal("router"),
          t5.literal("self"),
          t5.literal("help_hub"),
          t5.literal("blank"),
          t5.undefined
        ]),
        metadata: t5.UnknownRecord
      })
    ]);
    AdminTemplateV = t5.intersection([AdminAction, TemplateOptionsV]);
    CallbackTemplateV = t5.intersection([CallbackAction, TemplateOptionsV]);
    LinkTemplateV = t5.intersection([LinkAction, TemplateOptionsV]);
    ClickTemplateV = t5.intersection([ClickAction, TemplateOptionsV]);
    BuiltInTemplateV = t5.intersection([BuiltInAction, TemplateOptionsV]);
    WebhookTemplateV = t5.intersection([WebhookAction, TemplateOptionsV]);
    ScriptTemplateV = t5.intersection([ScriptAction, TemplateOptionsV]);
    RequestTemplateV = t5.intersection([RequestAction, TemplateOptionsV]);
    AppcuesTemplateV = t5.intersection([AppcuesAction, TemplateOptionsV]);
    PendoGuideTemplateV = t5.intersection([PendoGuideAction, TemplateOptionsV]);
    VideoTemplateV = t5.intersection([VideoAction, TemplateOptionsV]);
    HelpDocTemplateV = t5.intersection([
      HelpDocAction,
      t5.partial({
        doc_type: t5.union([t5.literal("answer"), t5.literal("doc")])
      }),
      TemplateOptionsV
    ]);
    TriggerTemplateV = t5.intersection([TriggerAction, TemplateOptionsV]);
    TemplateV = t5.union([
      AdminTemplateV,
      CallbackTemplateV,
      LinkTemplateV,
      ClickTemplateV,
      BuiltInTemplateV,
      WebhookTemplateV,
      ScriptTemplateV,
      RequestTemplateV,
      AppcuesTemplateV,
      PendoGuideTemplateV,
      VideoTemplateV,
      HelpDocTemplateV,
      TriggerTemplateV
    ]);
  }
});

// internal/src/middleware/helpers/rules.ts
import * as t6 from "io-ts";
function keyObject(arr) {
  return Object.fromEntries(arr.map((v) => [v, null]));
}
function isMultiValueRule(rule) {
  return "values" in rule && isMultiValueRuleType(rule.type);
}
function isMultiValueRuleType(type39) {
  return type39 === "browser" || type39 === "os" || type39 === "language";
}
function isInteractionCondition(condition) {
  return isInteractionConditionType(condition.type);
}
function isInteractionConditionType(type39) {
  return type39 === "nudge_interaction" || type39 === "questlist_interaction";
}
var listOperators, legacyListOperators, equalityOperators, numericOperators, operators, OperatorV, MultiValueOperatorV, EqualityOperatorV, InteractionStateV, NudgeInteractionConditionV, QuestlistInteractionConditionV, InteractionConditionV, ConditionBaseV, MultiValueConditionV, SingleValueConditionV, ConditionV2, getConditions, RuleExpressionAndV, RuleExpressionOrV, RuleExpressionLiteralV, RuleExpressionConditionV, RuleExpressionV, NamedRuleReferenceV, RecommendationRuleAlwaysV, AvailabilityRuleV, RecommendationRuleV, EditorAvailabilityRuleV, EditorRecommendationRuleV, NamedRuleBaseV, NamedRuleAdditionalV, NamedRuleV, countConditions, scoreRecommendationSet;
var init_rules = __esm({
  "internal/src/middleware/helpers/rules.ts"() {
    "use strict";
    listOperators = ["isInList", "isNotInList"];
    legacyListOperators = ["includes", "doesNotInclude"];
    equalityOperators = ["is", "isNot"];
    numericOperators = ["isGreaterThan", "isLessThan"];
    operators = [
      ...listOperators,
      "isTrue",
      "isFalse",
      "isTruthy",
      "isFalsy",
      "startsWith",
      "endsWith",
      "matchesRegex",
      "isDefined",
      "isNotDefined",
      "classnameOnPage",
      "idOnPage",
      "selectorOnPage",
      "classnameNotOnPage",
      "idNotOnPage",
      "selectorNotOnPage",
      ...legacyListOperators,
      ...equalityOperators,
      ...numericOperators
    ];
    OperatorV = t6.keyof(keyObject(operators));
    MultiValueOperatorV = t6.keyof(keyObject(legacyListOperators));
    EqualityOperatorV = t6.keyof(keyObject(equalityOperators));
    InteractionStateV = t6.union([t6.literal("viewed"), t6.literal("completed"), t6.literal("dismissed")]);
    NudgeInteractionConditionV = t6.intersection([
      t6.type({
        type: t6.literal("nudge_interaction"),
        operator: EqualityOperatorV,
        value: InteractionStateV,
        nudge_id: t6.number
      }),
      t6.partial({
        reason: t6.string
      })
    ]);
    QuestlistInteractionConditionV = t6.intersection([
      t6.type({
        type: t6.literal("questlist_interaction"),
        operator: EqualityOperatorV,
        value: InteractionStateV,
        questlist_id: t6.number
      }),
      t6.partial({
        reason: t6.string
      })
    ]);
    InteractionConditionV = t6.union([NudgeInteractionConditionV, QuestlistInteractionConditionV]);
    ConditionBaseV = t6.intersection([
      t6.type({
        type: t6.union([
          t6.literal("user_property"),
          t6.literal("audience"),
          t6.literal("event_property"),
          t6.literal("context"),
          t6.literal("url"),
          t6.literal("hostname"),
          t6.literal("element"),
          t6.literal("executions"),
          t6.literal("shortcuts"),
          t6.literal("last_seen"),
          t6.literal("first_seen"),
          t6.literal("sessions"),
          t6.literal("opens"),
          t6.literal("deadends"),
          t6.literal("heap"),
          t6.literal("hubspot"),
          t6.literal("amplitude"),
          t6.literal("device_type"),
          t6.literal("ab_test"),
          t6.literal("intent"),
          t6.literal("help_doc_interaction"),
          t6.literal("video_interaction"),
          t6.literal("survey_response")
        ]),
        operator: OperatorV
      }),
      t6.partial({
        field: t6.string,
        value: t6.string,
        reason: t6.string,
        rule_id: t6.union([t6.number, t6.string]),
        audience_id: t6.number
      })
    ]);
    MultiValueConditionV = t6.intersection([
      t6.type({
        type: t6.union([t6.literal("browser"), t6.literal("os"), t6.literal("language")]),
        operator: MultiValueOperatorV,
        values: t6.array(t6.string)
      }),
      t6.partial({
        reason: t6.string
      })
    ]);
    SingleValueConditionV = t6.union([ConditionBaseV, InteractionConditionV]);
    ConditionV2 = t6.union([SingleValueConditionV, MultiValueConditionV]);
    getConditions = (expr) => {
      if (expr.type === "CONDITION") {
        return [expr.condition];
      } else {
        if (expr.type === "AND" || expr.type === "OR") {
          return expr.exprs.flatMap(getConditions);
        }
        return [];
      }
    };
    RuleExpressionAndV = t6.recursion(
      "RuleExpressionAndV",
      () => t6.type({
        type: t6.literal("AND"),
        exprs: t6.array(RuleExpressionV)
      })
    );
    RuleExpressionOrV = t6.recursion(
      "RuleExpressionOrV",
      () => t6.type({
        type: t6.literal("OR"),
        exprs: t6.array(RuleExpressionV)
      })
    );
    RuleExpressionLiteralV = t6.recursion(
      "RuleExpressionLiteralV",
      () => t6.type({
        type: t6.literal("LITERAL"),
        value: t6.boolean
      })
    );
    RuleExpressionConditionV = t6.recursion(
      "RuleExpressionConditionV",
      () => t6.type({
        type: t6.literal("CONDITION"),
        condition: t6.union([ConditionV2, NamedRuleReferenceV])
      })
    );
    RuleExpressionV = t6.recursion(
      "RuleExpressionV",
      () => t6.union([RuleExpressionAndV, RuleExpressionOrV, RuleExpressionLiteralV, RuleExpressionConditionV])
    );
    NamedRuleReferenceV = t6.intersection([
      t6.type({
        type: t6.literal("named_rule"),
        rule_id: t6.union([t6.number, t6.string])
      }),
      t6.partial({ reason: t6.string })
    ]);
    RecommendationRuleAlwaysV = t6.intersection([
      t6.type({
        type: t6.literal("always")
      }),
      t6.partial({
        operator: t6.union([t6.undefined, t6.null]),
        field: t6.union([t6.undefined, t6.null]),
        value: t6.union([t6.undefined, t6.null]),
        reason: t6.union([t6.undefined, t6.null]),
        rule_id: t6.union([t6.number, t6.string])
      })
    ]);
    AvailabilityRuleV = ConditionV2;
    RecommendationRuleV = t6.union([RecommendationRuleAlwaysV, ConditionV2]);
    EditorAvailabilityRuleV = t6.union([AvailabilityRuleV, NamedRuleReferenceV]);
    EditorRecommendationRuleV = t6.union([RecommendationRuleV, NamedRuleReferenceV]);
    NamedRuleBaseV = t6.type({
      id: t6.union([t6.number, t6.string]),
      name: t6.string,
      expression: RuleExpressionV,
      created: t6.union([t6.string, t6.undefined])
    });
    NamedRuleAdditionalV = t6.type({
      is_audience: t6.boolean
    });
    NamedRuleV = t6.intersection([NamedRuleBaseV, NamedRuleAdditionalV]);
    countConditions = (expression) => {
      const conditions = getConditions(expression);
      return conditions.length;
    };
    scoreRecommendationSet = (recommendationSet) => {
      const audienceScore = recommendationSet.audience.type === "rule_expression" ? countConditions(recommendationSet.audience.expression) : 0;
      const showExpressionScore = countConditions(recommendationSet.show_expression);
      return audienceScore + showExpressionScore;
    };
  }
});

// internal/src/middleware/confetti.tsx
import * as t7 from "io-ts";
var ConfettiConfigV;
var init_confetti = __esm({
  "internal/src/middleware/confetti.tsx"() {
    "use strict";
    ConfettiConfigV = t7.partial({
      angle: t7.number,
      spread: t7.number,
      width: t7.string,
      height: t7.string,
      duration: t7.number,
      dragFriction: t7.number,
      stagger: t7.number,
      startVelocity: t7.number,
      elementCount: t7.number,
      decay: t7.number,
      colors: t7.array(t7.string),
      random: t7.any
    });
  }
});

// internal/src/middleware/detailPreview.tsx
import * as t8 from "io-ts";
var DetailPreviewObjectV, DetailPreviewV, DEFAULT_DETAIL_PREVIEW_TYPE, standardize, standardizeString;
var init_detailPreview = __esm({
  "internal/src/middleware/detailPreview.tsx"() {
    "use strict";
    DetailPreviewObjectV = t8.intersection([
      t8.type({
        type: t8.union([
          t8.literal("plaintext"),
          t8.literal("markdown"),
          t8.literal("html"),
          t8.literal("react"),
          t8.literal("video"),
          t8.literal("component")
        ]),
        value: t8.string
      }),
      t8.partial({ position: t8.union([t8.literal("inline"), t8.literal("popover")]) })
    ]);
    DetailPreviewV = t8.union([
      t8.string,
      DetailPreviewObjectV,
      t8.array(t8.union([DetailPreviewObjectV, t8.string]))
    ]);
    DEFAULT_DETAIL_PREVIEW_TYPE = "html";
    standardize = (item) => {
      if (!item)
        return null;
      if (Array.isArray(item) && item.length === 0)
        return null;
      if (Array.isArray(item)) {
        return item.filter((i2) => {
          return !!i2;
        }).map((i2) => {
          return standardizeString(i2);
        });
      }
      return [standardizeString(item)];
    };
    standardizeString = (item) => {
      if (typeof item === "string")
        return { type: DEFAULT_DETAIL_PREVIEW_TYPE, value: item };
      return item;
    };
  }
});

// internal/src/middleware/helpers/audience.tsx
import * as t9 from "io-ts";
var AudienceV;
var init_audience = __esm({
  "internal/src/middleware/helpers/audience.tsx"() {
    "use strict";
    init_rules();
    AudienceV = t9.union([
      t9.type({
        type: t9.literal("all_users")
      }),
      t9.type({
        type: t9.literal("rule_expression"),
        expression: RuleExpressionV
      }),
      t9.type({ type: t9.literal("named_rule_reference"), rule_reference: NamedRuleReferenceV })
    ]);
  }
});

// internal/src/middleware/CommandFromClientV.ts
import * as t10 from "io-ts";
var CommandFromClientV;
var init_CommandFromClientV = __esm({
  "internal/src/middleware/CommandFromClientV.ts"() {
    "use strict";
    init_template();
    init_argument();
    init_rules();
    init_confetti();
    init_detailPreview();
    init_audience();
    CommandFromClientV = t10.intersection(
      [
        t10.type({
          name: t10.string,
          template: t10.union([
            CallbackTemplateV,
            LinkTemplateV,
            WebhookTemplateV,
            ClickTemplateV,
            RequestTemplateV,
            AppcuesTemplateV,
            PendoGuideTemplateV,
            HelpDocTemplateV
          ]),
          text: t10.string
        }),
        t10.partial({
          shortcut_mac: t10.array(t10.string),
          shortcut_win: t10.array(t10.string),
          hotkey_mac: t10.string,
          hotkey_win: t10.string,
          tags: t10.array(t10.string),
          explanation: t10.string,
          heading: t10.string,
          sort_key: t10.union([t10.number, t10.null]),
          arguments: ArgumentMapV,
          category: t10.union([t10.number, t10.string, t10.null]),
          icon: t10.union([t10.string, t10.null]),
          icon_color: t10.union([t10.string, t10.null]),
          image_color: t10.union([t10.string, t10.null]),
          image: t10.union([t10.string, t10.null]),
          celebrate: t10.union([t10.boolean, ConfettiConfigV, t10.null]),
          availability_rules: t10.array(AvailabilityRuleV),
          // experimental feature
          recommend_rules: t10.array(RecommendationRuleV),
          // experimental feature
          availability_expression: t10.array(RuleExpressionV),
          // experimental feature
          recommend_expression: t10.array(RuleExpressionV),
          // experimental feature
          audience: AudienceV,
          detail: t10.union([t10.string, DetailPreviewObjectV, t10.array(DetailPreviewObjectV)]),
          content: t10.union([t10.string, DetailPreviewObjectV, t10.array(DetailPreviewObjectV)]),
          show_preview: t10.boolean,
          extra: t10.union([t10.string, t10.null])
        })
      ],
      "Command"
    );
  }
});

// internal/src/middleware/helpers/tags.tsx
import * as t11 from "io-ts";
var GeneratedTagsV;
var init_tags = __esm({
  "internal/src/middleware/helpers/tags.tsx"() {
    "use strict";
    GeneratedTagsV = t11.partial({
      automated: t11.union([t11.array(t11.string), t11.null]),
      manual: t11.union([t11.array(t11.string), t11.null]),
      deny: t11.union([t11.array(t11.string), t11.null])
    });
  }
});

// internal/src/middleware/command.tsx
import * as t12 from "io-ts";
var CommandBaseV, CommandAdditionalV, EditorCommandAdditionalV, defaults, editorDefaults, HelpSyncCommandAdditionalV, _CommandV, CommandV, EditorCommandV, CommandLiteV, EditorCommandLiteV, BatchOperationV, BatchEditorCommandResponseV, COMMANDS_ROUTE, create, update2, del2, get3, validateFromClient, decode, createWithoutThrottle, updateWithoutThrottle, deleteWithoutThrottle, commandUID, isProgrammatic, ContentTypeV, getContentType, isRecordAction, isHelpSyncCommand, showInDefaultList, HelpSyncCommandV, listHelpCenter, updateHelpSyncCommandWithoutThrottle;
var init_command = __esm({
  "internal/src/middleware/command.tsx"() {
    "use strict";
    init_generics();
    init_utils();
    init_argument();
    init_template();
    init_CommandFromClientV();
    init_rules();
    init_tags();
    init_detailPreview();
    init_confetti();
    init_actions();
    init_audience();
    CommandBaseV = t12.intersection(
      [
        t12.type({
          id: t12.number,
          text: t12.string,
          template: TemplateV
        }),
        t12.partial({
          disabledReason: t12.string,
          source: t12.string,
          name: t12.string,
          last_available: t12.union([t12.string, t12.null]),
          modified: t12.string,
          isAsync: t12.boolean
        })
      ],
      "CommandBase"
    );
    CommandAdditionalV = t12.type(
      {
        arguments: ArgumentMapV,
        tags: t12.array(t12.string),
        // DEPRECATED
        availability_rules: t12.array(AvailabilityRuleV),
        recommend_rules: t12.array(RecommendationRuleV),
        availability_expression: t12.union([RuleExpressionV, t12.null]),
        recommend_expression: t12.union([RuleExpressionV, t12.null]),
        always_recommend: t12.boolean,
        audience: t12.union([AudienceV, t12.null]),
        confirm: t12.string,
        shortcut: t12.array(t12.string),
        explanation: t12.string,
        heading: t12.string,
        is_live: t12.boolean,
        category: t12.union([t12.number, t12.null]),
        sort_key: t12.union([t12.number, t12.null]),
        icon: t12.union([t12.string, t12.null]),
        icon_color: t12.union([t12.string, t12.null]),
        image_color: t12.union([t12.string, t12.null]),
        image: t12.union([t12.string, t12.null]),
        celebrate: t12.union([t12.boolean, ConfettiConfigV, t12.null]),
        recommend_sort_key: t12.union([t12.number, t12.null]),
        shortcut_mac: t12.array(t12.string),
        shortcut_win: t12.array(t12.string),
        hotkey_mac: t12.string,
        hotkey_win: t12.string,
        detail: t12.union([t12.null, t12.string, DetailPreviewObjectV, t12.array(t12.union([t12.string, DetailPreviewObjectV]))]),
        content: t12.union([t12.null, t12.string, DetailPreviewObjectV, t12.array(t12.union([t12.string, DetailPreviewObjectV]))]),
        show_preview: t12.boolean,
        next_steps: t12.array(t12.union([t12.string, t12.number, LabeledActionV])),
        extra: t12.union([t12.string, t12.null]),
        thumbnail: t12.union([
          t12.null,
          t12.type({
            src: t12.string,
            file_name: t12.string,
            size: t12.string
          })
        ]),
        copilot_suggest: t12.boolean,
        show_in_spotlight_search: t12.boolean,
        show_in_helphub_search: t12.boolean,
        copilot_cta_label: t12.string,
        copilot_description: t12.string,
        copilot_use_verbatim: t12.boolean
      },
      "CommandAdditional"
    );
    EditorCommandAdditionalV = t12.type(
      {
        arguments: ArgumentMapV,
        tags: t12.array(t12.string),
        availability_rules: t12.union([t12.array(EditorAvailabilityRuleV), t12.array(AvailabilityRuleV)]),
        recommend_rules: t12.union([t12.array(EditorRecommendationRuleV), t12.array(RecommendationRuleV)]),
        availability_expression: RuleExpressionV,
        recommend_expression: RuleExpressionV,
        always_recommend: t12.boolean,
        confirm: t12.string,
        shortcut: t12.array(t12.string),
        explanation: t12.string,
        heading: t12.string,
        is_live: t12.boolean,
        category: t12.union([t12.number, t12.null]),
        sort_key: t12.union([t12.number, t12.null]),
        icon: t12.union([t12.string, t12.null]),
        icon_color: t12.union([t12.string, t12.null]),
        image_color: t12.union([t12.string, t12.null]),
        image: t12.union([t12.string, t12.null]),
        celebrate: t12.union([t12.boolean, ConfettiConfigV, t12.null]),
        recommend_sort_key: t12.union([t12.number, t12.null]),
        shortcut_mac: t12.array(t12.string),
        shortcut_win: t12.array(t12.string),
        hotkey_mac: t12.string,
        hotkey_win: t12.string,
        detail: t12.union([t12.null, t12.string, DetailPreviewObjectV, t12.array(t12.union([t12.string, DetailPreviewObjectV]))]),
        content: t12.union([t12.null, t12.string, DetailPreviewObjectV, t12.array(t12.union([t12.string, DetailPreviewObjectV]))]),
        show_preview: t12.boolean,
        thumbnail: t12.union([
          t12.null,
          t12.type({
            src: t12.string,
            file_name: t12.string,
            size: t12.string
          })
        ]),
        next_steps: t12.array(t12.union([t12.string, t12.number, LabeledActionV])),
        generated_tags: GeneratedTagsV,
        copilot_suggest: t12.boolean,
        show_in_spotlight_search: t12.boolean,
        show_in_helphub_search: t12.boolean,
        copilot_cta_label: t12.string,
        copilot_description: t12.string,
        copilot_use_verbatim: t12.boolean,
        editor_tags: t12.array(t12.string),
        labels: t12.union([t12.null, t12.array(t12.string)])
      },
      "EditorCommandAdditional"
    );
    defaults = {
      arguments: {},
      tags: [],
      recommend_rules: [],
      availability_rules: [],
      // if the new *_expression fields are not set, use the old *_rules ones
      availability_expression: null,
      recommend_expression: null,
      always_recommend: false,
      audience: null,
      confirm: "",
      shortcut: [],
      explanation: "",
      heading: "",
      is_live: false,
      category: null,
      sort_key: null,
      icon: null,
      icon_color: null,
      image_color: null,
      image: null,
      celebrate: null,
      recommend_sort_key: null,
      shortcut_mac: [],
      shortcut_win: [],
      hotkey_mac: "",
      hotkey_win: "",
      detail: null,
      content: null,
      show_preview: false,
      thumbnail: null,
      next_steps: [],
      extra: null,
      copilot_suggest: false,
      show_in_spotlight_search: true,
      show_in_helphub_search: false,
      copilot_cta_label: "",
      copilot_description: "",
      copilot_use_verbatim: false
    };
    editorDefaults = {
      ...defaults,
      availability_expression: { type: "LITERAL", value: true },
      recommend_expression: { type: "LITERAL", value: false },
      always_recommend: false,
      generated_tags: {},
      editor_tags: [],
      labels: []
    };
    HelpSyncCommandAdditionalV = t12.partial(
      {
        third_party_source: t12.union([t12.string, t12.null]),
        third_party_id: t12.union([t12.string, t12.null]),
        training_only: t12.boolean,
        integration: t12.union([
          t12.type({
            id: t12.number,
            helphub_view_article_button_hidden: t12.union([t12.boolean, t12.undefined]),
            audience: t12.union([AudienceV, t12.undefined])
          }),
          t12.null
        ])
      },
      "CommandHelpSyncAdditional"
    );
    _CommandV = t12.intersection([CommandBaseV, CommandAdditionalV, HelpSyncCommandAdditionalV], "Command");
    CommandV = new t12.Type(
      _CommandV.name,
      _CommandV.is,
      (i2, c) => _CommandV.validate({ ...defaults, ...i2 }, c),
      _CommandV.encode
    );
    EditorCommandV = t12.intersection(
      [CommandBaseV, EditorCommandAdditionalV, HelpSyncCommandAdditionalV],
      "EditorCommand"
    );
    CommandLiteV = t12.intersection(
      [CommandBaseV, omit(CommandAdditionalV, ["content", "detail", "explanation"]), HelpSyncCommandAdditionalV],
      "CommandLite"
    );
    EditorCommandLiteV = t12.intersection(
      [CommandBaseV, omit(EditorCommandAdditionalV, ["content", "detail", "explanation"]), HelpSyncCommandAdditionalV],
      "EditorCommandLite"
    );
    BatchOperationV = t12.union([
      t12.type({
        op: t12.literal("update"),
        id: t12.number,
        data: t12.unknown
      }),
      t12.type({
        op: t12.literal("create"),
        data: t12.unknown
      }),
      t12.type({
        op: t12.literal("delete"),
        id: t12.number
      })
    ]);
    BatchEditorCommandResponseV = t12.type({
      batch: t12.array(EditorCommandV)
    });
    COMMANDS_ROUTE = "/commands";
    create = createObject(EditorCommandV, EditorCommandV, COMMANDS_ROUTE);
    update2 = updateObject(EditorCommandV, EditorCommandV, COMMANDS_ROUTE);
    del2 = deleteObject(EditorCommandV, COMMANDS_ROUTE);
    get3 = readObject(EditorCommandV, COMMANDS_ROUTE);
    validateFromClient = (data) => decodeToPromise(CommandFromClientV, data);
    decode = (data) => decodeThrowing(CommandV, data);
    createWithoutThrottle = createObject(EditorCommandV, EditorCommandV, COMMANDS_ROUTE, {
      integration: "true"
    });
    updateWithoutThrottle = updateObject(EditorCommandV, EditorCommandV, COMMANDS_ROUTE, {
      integration: "true"
    });
    deleteWithoutThrottle = deleteObject(EditorCommandV, COMMANDS_ROUTE);
    commandUID = (cmd) => {
      var _a2;
      if (cmd.id >= 1)
        return `${cmd.id}`;
      return (_a2 = cmd.name) != null ? _a2 : "";
    };
    isProgrammatic = (cmd) => {
      return cmd.source === "programmatic" || cmd.id < 1;
    };
    ContentTypeV = t12.union([t12.literal("source"), t12.literal("answer"), t12.literal("file"), t12.literal("video")]);
    getContentType = (cmd) => {
      var _a2;
      if (cmd.template.type === "helpdoc") {
        if ((_a2 = cmd.integration) == null ? void 0 : _a2.id) {
          return "source";
        } else if (cmd.template.doc_type === "answer") {
          return "answer";
        } else {
          return "file";
        }
      } else if (cmd.template.type === "video") {
        return "video";
      }
      return null;
    };
    isRecordAction = (cmd, recordKey) => {
      const isRecordActionForArg = (arg) => {
        var _a2;
        return !!arg && arg.type === "context" && !!((_a2 = arg.show_in_record_action_list) != null ? _a2 : true);
      };
      return !!Object.keys(cmd.arguments).find((k) => {
        var _a2;
        if (!!recordKey) {
          return isRecordActionForArg(cmd.arguments[k]) && ((_a2 = cmd.arguments[k]) == null ? void 0 : _a2.value) === recordKey;
        } else {
          return isRecordActionForArg(cmd.arguments[k]);
        }
      });
    };
    isHelpSyncCommand = (cmd) => {
      return !!cmd.third_party_id;
    };
    showInDefaultList = (cmd) => {
      return !isRecordAction(cmd) || !!Object.keys(cmd.arguments).find((k) => {
        var _a2, _b2;
        const arg = cmd.arguments[k];
        return arg.type === "context" && !!((_a2 = arg.show_in_record_action_list) != null ? _a2 : true) && !!((_b2 = arg.show_in_default_list) != null ? _b2 : true);
      });
    };
    HelpSyncCommandV = t12.intersection(
      [CommandBaseV, EditorCommandAdditionalV, HelpSyncCommandAdditionalV],
      "HelpSyncCommand"
    );
    listHelpCenter = listObject(EditorCommandLiteV, "commands/helpdocs");
    updateHelpSyncCommandWithoutThrottle = updateObject(HelpSyncCommandV, HelpSyncCommandV, "commands", {
      integration: "true"
    });
  }
});

// types/src/entities/endUser.ts
import * as t13 from "io-ts";
var ChecklistInteractionStateV, NudgeInteractionStateV, ChecklistInteractionsV, NudgeInteractionsV, UserRemotePropertiesV, EndUserStoreDataV, EndUserV, DecideExperienceResponseV, DecideResponseV;
var init_endUser = __esm({
  "types/src/entities/endUser.ts"() {
    "use strict";
    ChecklistInteractionStateV = t13.intersection([
      t13.partial({
        isSkipped: t13.boolean,
        isCompleted: t13.boolean,
        isExpanded: t13.boolean,
        isSeen: t13.boolean,
        items: t13.record(
          t13.string,
          t13.type({
            completedTS: t13.string
          })
        )
      }),
      t13.partial({})
    ]);
    NudgeInteractionStateV = t13.intersection([
      t13.partial({
        currentStep: t13.number,
        nudgeSeen: t13.boolean,
        nudgeInteracted: t13.boolean,
        seenTs: t13.array(t13.number),
        snoozedUntilTs: t13.number,
        nudgeDismissed: t13.boolean,
        nudgeCompleted: t13.boolean,
        nudgeDismissedTs: t13.array(t13.number),
        nudgeCompletedTs: t13.array(t13.number)
      }),
      t13.partial({
        stepIndexStack: t13.array(t13.number)
      })
    ]);
    ChecklistInteractionsV = t13.record(t13.number, ChecklistInteractionStateV);
    NudgeInteractionsV = t13.record(t13.number, NudgeInteractionStateV);
    UserRemotePropertiesV = t13.record(t13.string, t13.any);
    EndUserStoreDataV = t13.type({
      hotkeys: t13.any,
      checklist_interactions: t13.partial({
        activeChecklistId: t13.union([t13.number, t13.null]),
        checklists: ChecklistInteractionsV
      }),
      nudges_interactions: t13.union([NudgeInteractionsV, t13.undefined]),
      analytics: t13.union([
        t13.type({
          num_command_executions: t13.number,
          num_shortcut_command_executions: t13.number,
          num_sessions: t13.number,
          num_opens: t13.number,
          num_deadends: t13.number,
          first_seen_at: t13.string,
          last_seen_at: t13.string
        }),
        t13.undefined,
        t13.null
      ]),
      properties: UserRemotePropertiesV
    });
    EndUserV = t13.type({
      username: t13.string,
      slug: t13.string,
      organization: t13.string,
      has_access: t13.boolean,
      has_opened: t13.boolean,
      hotkeys_debug: t13.boolean,
      hmac: t13.union([t13.string, t13.undefined]),
      identifier: t13.string
    });
    DecideExperienceResponseV = t13.record(
      t13.union([t13.string, t13.number]),
      t13.union([t13.boolean, t13.record(t13.string, t13.any), t13.undefined, t13.null])
    );
    DecideResponseV = t13.union([
      t13.type({
        user_property_targeting: t13.union([t13.boolean, t13.undefined, t13.null]),
        nudges: t13.union([DecideExperienceResponseV, t13.undefined, t13.null]),
        checklists: t13.union([DecideExperienceResponseV, t13.undefined, t13.null]),
        recommendation_sets: t13.union([DecideExperienceResponseV, t13.undefined, t13.null]),
        commands: t13.union([DecideExperienceResponseV, t13.undefined, t13.null])
      }),
      t13.undefined,
      t13.null
    ]);
  }
});

// node_modules/@sentry/utils/esm/is.js
function isError(wat) {
  switch (objectToString.call(wat)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}
function isErrorEvent(wat) {
  return isBuiltin(wat, "ErrorEvent");
}
function isDOMError(wat) {
  return isBuiltin(wat, "DOMError");
}
function isDOMException(wat) {
  return isBuiltin(wat, "DOMException");
}
function isString(wat) {
  return isBuiltin(wat, "String");
}
function isPrimitive(wat) {
  return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function isPlainObject(wat) {
  return isBuiltin(wat, "Object");
}
function isEvent(wat) {
  return typeof Event !== "undefined" && isInstanceOf(wat, Event);
}
function isElement(wat) {
  return typeof Element !== "undefined" && isInstanceOf(wat, Element);
}
function isThenable(wat) {
  return Boolean(wat && wat.then && typeof wat.then === "function");
}
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function isNaN2(wat) {
  return typeof wat === "number" && wat !== wat;
}
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}
var objectToString;
var init_is = __esm({
  "node_modules/@sentry/utils/esm/is.js"() {
    objectToString = Object.prototype.toString;
  }
});

// node_modules/@sentry/utils/esm/string.js
function truncate(str, max = 0) {
  if (typeof str !== "string" || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}
function safeJoin(input, delimiter2) {
  if (!Array.isArray(input)) {
    return "";
  }
  const output = [];
  for (let i2 = 0; i2 < input.length; i2++) {
    const value = input[i2];
    try {
      output.push(String(value));
    } catch (e) {
      output.push("[value cannot be serialized]");
    }
  }
  return output.join(delimiter2);
}
var init_string = __esm({
  "node_modules/@sentry/utils/esm/string.js"() {
  }
});

// node_modules/@sentry/utils/esm/worldwide.js
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : void 0;
}
function getGlobalObject() {
  return GLOBAL_OBJ;
}
function getGlobalSingleton(name, creator, obj) {
  const gbl = obj || GLOBAL_OBJ;
  const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}
var GLOBAL_OBJ;
var init_worldwide = __esm({
  "node_modules/@sentry/utils/esm/worldwide.js"() {
    GLOBAL_OBJ = typeof globalThis == "object" && isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
    typeof window == "object" && isGlobalObj(window) || typeof self == "object" && isGlobalObj(self) || typeof window == "object" && isGlobalObj(window) || function() {
      return this;
    }() || {};
  }
});

// node_modules/@sentry/utils/esm/browser.js
function htmlTreeAsString(elem, options = {}) {
  try {
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = " > ";
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = !Array.isArray(options) && options.maxStringLength || DEFAULT_MAX_STRING_LENGTH;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) {
        break;
      }
      out.push(nextStr);
      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
  } catch (_oO) {
    return "<unknown>";
  }
}
function _htmlElementAsString(el, keyAttrs) {
  const elem = el;
  const out = [];
  let className;
  let classes;
  let key;
  let attr2;
  let i2;
  if (!elem || !elem.tagName) {
    return "";
  }
  out.push(elem.tagName.toLowerCase());
  const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr) => elem.getAttribute(keyAttr)).map((keyAttr) => [keyAttr, elem.getAttribute(keyAttr)]) : null;
  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach((keyAttrPair) => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }
    className = elem.className;
    if (className && isString(className)) {
      classes = className.split(/\s+/);
      for (i2 = 0; i2 < classes.length; i2++) {
        out.push(`.${classes[i2]}`);
      }
    }
  }
  const allowedAttrs = ["aria-label", "type", "name", "title", "alt"];
  for (i2 = 0; i2 < allowedAttrs.length; i2++) {
    key = allowedAttrs[i2];
    attr2 = elem.getAttribute(key);
    if (attr2) {
      out.push(`[${key}="${attr2}"]`);
    }
  }
  return out.join("");
}
var WINDOW, DEFAULT_MAX_STRING_LENGTH;
var init_browser = __esm({
  "node_modules/@sentry/utils/esm/browser.js"() {
    init_is();
    init_worldwide();
    WINDOW = getGlobalObject();
    DEFAULT_MAX_STRING_LENGTH = 80;
  }
});

// node_modules/@sentry/utils/esm/logger.js
function consoleSandbox(callback) {
  if (!("console" in GLOBAL_OBJ)) {
    return callback();
  }
  const originalConsole = GLOBAL_OBJ.console;
  const wrappedLevels = {};
  CONSOLE_LEVELS.forEach((level) => {
    const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level];
      originalConsole[level] = originalWrappedFunc;
    }
  });
  try {
    return callback();
  } finally {
    Object.keys(wrappedLevels).forEach((level) => {
      originalConsole[level] = wrappedLevels[level];
    });
  }
}
function makeLogger() {
  let enabled = false;
  const logger2 = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    }
  };
  if (false) {
    CONSOLE_LEVELS.forEach((name) => {
      logger2[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            GLOBAL_OBJ.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach((name) => {
      logger2[name] = () => void 0;
    });
  }
  return logger2;
}
var CONSOLE_LEVELS, logger;
var init_logger = __esm({
  "node_modules/@sentry/utils/esm/logger.js"() {
    init_worldwide();
    CONSOLE_LEVELS = ["debug", "info", "warn", "error", "log", "assert", "trace"];
    if (false) {
      logger = getGlobalSingleton("logger", makeLogger);
    } else {
      logger = makeLogger();
    }
  }
});

// node_modules/@sentry/utils/esm/dsn.js
function isValidProtocol(protocol) {
  return protocol === "http" || protocol === "https";
}
function dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
function dsnFromString(str) {
  const match2 = DSN_REGEX.exec(str);
  if (!match2) {
    console.error(`Invalid Sentry Dsn: ${str}`);
    return void 0;
  }
  const [protocol, publicKey, pass = "", host, port = "", lastPath] = match2.slice(1);
  let path = "";
  let projectId = lastPath;
  const split = projectId.split("/");
  if (split.length > 1) {
    path = split.slice(0, -1).join("/");
    projectId = split.pop();
  }
  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }
  return dsnFromComponents({ host, pass, path, projectId, port, protocol, publicKey });
}
function dsnFromComponents(components3) {
  return {
    protocol: components3.protocol,
    publicKey: components3.publicKey || "",
    pass: components3.pass || "",
    host: components3.host,
    port: components3.port || "",
    path: components3.path || "",
    projectId: components3.projectId
  };
}
function validateDsn(dsn) {
  if (true) {
    return true;
  }
  const { port, projectId, protocol } = dsn;
  const requiredComponents = ["protocol", "publicKey", "host", "projectId"];
  const hasMissingRequiredComponent = requiredComponents.find((component) => {
    if (!dsn[component]) {
      logger.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });
  if (hasMissingRequiredComponent) {
    return false;
  }
  if (!projectId.match(/^\d+$/)) {
    logger.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }
  if (!isValidProtocol(protocol)) {
    logger.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }
  if (port && isNaN(parseInt(port, 10))) {
    logger.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }
  return true;
}
function makeDsn(from) {
  const components3 = typeof from === "string" ? dsnFromString(from) : dsnFromComponents(from);
  if (!components3 || !validateDsn(components3)) {
    return void 0;
  }
  return components3;
}
var DSN_REGEX;
var init_dsn = __esm({
  "node_modules/@sentry/utils/esm/dsn.js"() {
    init_logger();
    DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
  }
});

// node_modules/@sentry/utils/esm/error.js
var SentryError;
var init_error = __esm({
  "node_modules/@sentry/utils/esm/error.js"() {
    SentryError = class extends Error {
      /** Display name of this error instance. */
      constructor(message, logLevel = "warn") {
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
      }
    };
  }
});

// node_modules/@sentry/utils/esm/object.js
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }
  const original = source[name];
  const wrapped = replacementFactory(original);
  if (typeof wrapped === "function") {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
    }
  }
  source[name] = wrapped;
}
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value,
    writable: true,
    configurable: true
  });
}
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, "__sentry_original__", original);
}
function getOriginalFunction(func) {
  return func.__sentry_original__;
}
function urlEncode(object2) {
  return Object.keys(object2).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(object2[key])}`).join("&");
}
function convertToPlainObject(value) {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value)
    };
  } else if (isEvent(value)) {
    const newObj = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value)
    };
    if (typeof CustomEvent !== "undefined" && isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }
    return newObj;
  } else {
    return value;
  }
}
function serializeEventTarget(target) {
  try {
    return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return "<unknown>";
  }
}
function getOwnProperties(obj) {
  if (typeof obj === "object" && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = obj[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();
  if (!keys.length) {
    return "[object has no keys]";
  }
  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }
  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(", ");
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return truncate(serialized, maxLength);
  }
  return "";
}
function dropUndefinedKeys(inputValue) {
  const memoizationMap = /* @__PURE__ */ new Map();
  return _dropUndefinedKeys(inputValue, memoizationMap);
}
function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPlainObject(inputValue)) {
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) {
      return memoVal;
    }
    const returnValue = {};
    memoizationMap.set(inputValue, returnValue);
    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== "undefined") {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }
    return returnValue;
  }
  if (Array.isArray(inputValue)) {
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== void 0) {
      return memoVal;
    }
    const returnValue = [];
    memoizationMap.set(inputValue, returnValue);
    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });
    return returnValue;
  }
  return inputValue;
}
var init_object = __esm({
  "node_modules/@sentry/utils/esm/object.js"() {
    init_browser();
    init_is();
    init_string();
  }
});

// node_modules/@sentry/utils/esm/stacktrace.js
function createStackParser(...parsers2) {
  const sortedParsers = parsers2.sort((a, b) => a[0] - b[0]).map((p) => p[1]);
  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split("\n");
    for (let i2 = skipFirst; i2 < lines.length; i2++) {
      const line = lines[i2];
      if (line.length > 1024) {
        continue;
      }
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, "$1") : line;
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }
      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);
        if (frame) {
          frames.push(frame);
          break;
        }
      }
      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }
    return stripSentryFramesAndReverse(frames);
  };
}
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }
  const localStack = Array.from(stack);
  if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) {
    localStack.pop();
  }
  localStack.reverse();
  if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
    localStack.pop();
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
      localStack.pop();
    }
  }
  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map((frame) => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || "?"
  }));
}
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== "function") {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    return defaultFunctionName;
  }
}
var STACKTRACE_FRAME_LIMIT, WEBPACK_ERROR_REGEXP, STRIP_FRAME_REGEXP, defaultFunctionName;
var init_stacktrace = __esm({
  "node_modules/@sentry/utils/esm/stacktrace.js"() {
    STACKTRACE_FRAME_LIMIT = 50;
    WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
    STRIP_FRAME_REGEXP = /captureMessage|captureException/;
    defaultFunctionName = "<anonymous>";
  }
});

// node_modules/@sentry/utils/esm/supports.js
function supportsFetch() {
  if (!("fetch" in WINDOW2)) {
    return false;
  }
  try {
    new Headers();
    new Request("http://www.example.com");
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }
  if (isNativeFetch(WINDOW2.fetch)) {
    return true;
  }
  let result = false;
  const doc = WINDOW2.document;
  if (doc && typeof doc.createElement === "function") {
    try {
      const sandbox = doc.createElement("iframe");
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
    }
  }
  return result;
}
var WINDOW2;
var init_supports = __esm({
  "node_modules/@sentry/utils/esm/supports.js"() {
    init_worldwide();
    WINDOW2 = getGlobalObject();
  }
});

// node_modules/@sentry/utils/esm/vendor/supportsHistory.js
function supportsHistory() {
  const chrome3 = WINDOW3.chrome;
  const isChromePackagedApp = chrome3 && chrome3.app && chrome3.app.runtime;
  const hasHistoryApi = "history" in WINDOW3 && !!WINDOW3.history.pushState && !!WINDOW3.history.replaceState;
  return !isChromePackagedApp && hasHistoryApi;
}
var WINDOW3;
var init_supportsHistory = __esm({
  "node_modules/@sentry/utils/esm/vendor/supportsHistory.js"() {
    init_worldwide();
    WINDOW3 = getGlobalObject();
  }
});

// node_modules/@sentry/utils/esm/instrument.js
function instrument(type39) {
  if (instrumented[type39]) {
    return;
  }
  instrumented[type39] = true;
  switch (type39) {
    case "console":
      instrumentConsole();
      break;
    case "dom":
      instrumentDOM();
      break;
    case "xhr":
      instrumentXHR();
      break;
    case "fetch":
      instrumentFetch();
      break;
    case "history":
      instrumentHistory();
      break;
    case "error":
      instrumentError();
      break;
    case "unhandledrejection":
      instrumentUnhandledRejection();
      break;
    default:
      return;
  }
}
function addInstrumentationHandler(type39, callback) {
  handlers[type39] = handlers[type39] || [];
  handlers[type39].push(callback);
  instrument(type39);
}
function triggerHandlers(type39, data) {
  if (!type39 || !handlers[type39]) {
    return;
  }
  for (const handler of handlers[type39] || []) {
    try {
      handler(data);
    } catch (e) {
    }
  }
}
function instrumentConsole() {
  if (!("console" in WINDOW4)) {
    return;
  }
  CONSOLE_LEVELS.forEach(function(level) {
    if (!(level in WINDOW4.console)) {
      return;
    }
    fill(WINDOW4.console, level, function(originalConsoleMethod) {
      return function(...args) {
        triggerHandlers("console", { args, level });
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(WINDOW4.console, args);
        }
      };
    });
  });
}
function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }
  fill(WINDOW4, "fetch", function(originalFetch) {
    return function(...args) {
      const { method, url } = parseFetchArgs(args);
      const handlerData = {
        args,
        fetchData: {
          method,
          url
        },
        startTimestamp: Date.now()
      };
      triggerHandlers("fetch", {
        ...handlerData
      });
      return originalFetch.apply(WINDOW4, args).then(
        (response2) => {
          triggerHandlers("fetch", {
            ...handlerData,
            endTimestamp: Date.now(),
            response: response2
          });
          return response2;
        },
        (error3) => {
          triggerHandlers("fetch", {
            ...handlerData,
            endTimestamp: Date.now(),
            error: error3
          });
          throw error3;
        }
      );
    };
  });
}
function hasProp(obj, prop) {
  return !!obj && typeof obj === "object" && !!obj[prop];
}
function getUrlFromResource(resource) {
  if (typeof resource === "string") {
    return resource;
  }
  if (!resource) {
    return "";
  }
  if (hasProp(resource, "url")) {
    return resource.url;
  }
  if (resource.toString) {
    return resource.toString();
  }
  return "";
}
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: "GET", url: "" };
  }
  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs;
    return {
      url: getUrlFromResource(url),
      method: hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
    };
  }
  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg),
    method: hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
  };
}
function instrumentXHR() {
  if (!("XMLHttpRequest" in WINDOW4)) {
    return;
  }
  const xhrproto = XMLHttpRequest.prototype;
  fill(xhrproto, "open", function(originalOpen) {
    return function(...args) {
      const url = args[1];
      const xhrInfo = this[SENTRY_XHR_DATA_KEY] = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: isString(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
        request_headers: {}
      };
      if (isString(url) && xhrInfo.method === "POST" && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }
      const onreadystatechangeHandler = () => {
        const xhrInfo2 = this[SENTRY_XHR_DATA_KEY];
        if (!xhrInfo2) {
          return;
        }
        if (this.readyState === 4) {
          try {
            xhrInfo2.status_code = this.status;
          } catch (e) {
          }
          triggerHandlers("xhr", {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr: this
          });
        }
      };
      if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") {
        fill(this, "onreadystatechange", function(original) {
          return function(...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener("readystatechange", onreadystatechangeHandler);
      }
      fill(this, "setRequestHeader", function(original) {
        return function(...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs;
          const xhrInfo2 = this[SENTRY_XHR_DATA_KEY];
          if (xhrInfo2) {
            xhrInfo2.request_headers[header.toLowerCase()] = value;
          }
          return original.apply(this, setRequestHeaderArgs);
        };
      });
      return originalOpen.apply(this, args);
    };
  });
  fill(xhrproto, "send", function(originalSend) {
    return function(...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];
      if (sentryXhrData && args[0] !== void 0) {
        sentryXhrData.body = args[0];
      }
      triggerHandlers("xhr", {
        args,
        startTimestamp: Date.now(),
        xhr: this
      });
      return originalSend.apply(this, args);
    };
  });
}
function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }
  const oldOnPopState = WINDOW4.onpopstate;
  WINDOW4.onpopstate = function(...args) {
    const to = WINDOW4.location.href;
    const from = lastHref;
    lastHref = to;
    triggerHandlers("history", {
      from,
      to
    });
    if (oldOnPopState) {
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
      }
    }
  };
  function historyReplacementFunction(originalHistoryFunction) {
    return function(...args) {
      const url = args.length > 2 ? args[2] : void 0;
      if (url) {
        const from = lastHref;
        const to = String(url);
        lastHref = to;
        triggerHandlers("history", {
          from,
          to
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }
  fill(WINDOW4.history, "pushState", historyReplacementFunction);
  fill(WINDOW4.history, "replaceState", historyReplacementFunction);
}
function shouldShortcircuitPreviousDebounce(previous, current) {
  if (!previous) {
    return true;
  }
  if (previous.type !== current.type) {
    return true;
  }
  try {
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
  }
  return false;
}
function shouldSkipDOMEvent(event) {
  if (event.type !== "keypress") {
    return false;
  }
  try {
    const target = event.target;
    if (!target || !target.tagName) {
      return true;
    }
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
      return false;
    }
  } catch (e) {
  }
  return true;
}
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    if (!event || lastCapturedEvent === event) {
      return;
    }
    if (shouldSkipDOMEvent(event)) {
      return;
    }
    const name = event.type === "keypress" ? "input" : event.type;
    if (debounceTimerID === void 0) {
      handler({
        event,
        name,
        global: globalListener
      });
      lastCapturedEvent = event;
    } else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event,
        name,
        global: globalListener
      });
      lastCapturedEvent = event;
    }
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW4.setTimeout(() => {
      debounceTimerID = void 0;
    }, debounceDuration);
  };
}
function instrumentDOM() {
  if (!("document" in WINDOW4)) {
    return;
  }
  const triggerDOMHandler = triggerHandlers.bind(null, "dom");
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW4.document.addEventListener("click", globalDOMEventHandler, false);
  WINDOW4.document.addEventListener("keypress", globalDOMEventHandler, false);
  ["EventTarget", "Node"].forEach((target) => {
    const proto = WINDOW4[target] && WINDOW4[target].prototype;
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) {
      return;
    }
    fill(proto, "addEventListener", function(originalAddEventListener) {
      return function(type39, listener, options) {
        if (type39 === "click" || type39 == "keypress") {
          try {
            const el = this;
            const handlers2 = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
            const handlerForType = handlers2[type39] = handlers2[type39] || { refCount: 0 };
            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type39, handler, options);
            }
            handlerForType.refCount++;
          } catch (e) {
          }
        }
        return originalAddEventListener.call(this, type39, listener, options);
      };
    });
    fill(
      proto,
      "removeEventListener",
      function(originalRemoveEventListener) {
        return function(type39, listener, options) {
          if (type39 === "click" || type39 == "keypress") {
            try {
              const el = this;
              const handlers2 = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers2[type39];
              if (handlerForType) {
                handlerForType.refCount--;
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type39, handlerForType.handler, options);
                  handlerForType.handler = void 0;
                  delete handlers2[type39];
                }
                if (Object.keys(handlers2).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
            }
          }
          return originalRemoveEventListener.call(this, type39, listener, options);
        };
      }
    );
  });
}
function instrumentError() {
  _oldOnErrorHandler = WINDOW4.onerror;
  WINDOW4.onerror = function(msg, url, line, column, error3) {
    triggerHandlers("error", {
      column,
      error: error3,
      line,
      msg,
      url
    });
    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      return _oldOnErrorHandler.apply(this, arguments);
    }
    return false;
  };
  WINDOW4.onerror.__SENTRY_INSTRUMENTED__ = true;
}
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = WINDOW4.onunhandledrejection;
  WINDOW4.onunhandledrejection = function(e) {
    triggerHandlers("unhandledrejection", e);
    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }
    return true;
  };
  WINDOW4.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}
var WINDOW4, SENTRY_XHR_DATA_KEY, handlers, instrumented, lastHref, debounceDuration, debounceTimerID, lastCapturedEvent, _oldOnErrorHandler, _oldOnUnhandledRejectionHandler;
var init_instrument = __esm({
  "node_modules/@sentry/utils/esm/instrument.js"() {
    init_is();
    init_logger();
    init_object();
    init_supports();
    init_worldwide();
    init_supportsHistory();
    WINDOW4 = getGlobalObject();
    SENTRY_XHR_DATA_KEY = "__sentry_xhr_v2__";
    handlers = {};
    instrumented = {};
    debounceDuration = 1e3;
    _oldOnErrorHandler = null;
    _oldOnUnhandledRejectionHandler = null;
  }
});

// node_modules/@sentry/utils/esm/memo.js
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === "function";
  const inner = hasWeakSet ? /* @__PURE__ */ new WeakSet() : [];
  function memoize3(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    for (let i2 = 0; i2 < inner.length; i2++) {
      const value = inner[i2];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }
  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i2 = 0; i2 < inner.length; i2++) {
        if (inner[i2] === obj) {
          inner.splice(i2, 1);
          break;
        }
      }
    }
  }
  return [memoize3, unmemoize];
}
var init_memo = __esm({
  "node_modules/@sentry/utils/esm/memo.js"() {
  }
});

// node_modules/@sentry/utils/esm/misc.js
function uuid4() {
  const gbl = GLOBAL_OBJ;
  const crypto = gbl.crypto || gbl.msCrypto;
  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, "");
  }
  const getRandomByte = crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;
  return ([1e7] + 1e3 + 4e3 + 8e3 + 1e11).replace(
    /[018]/g,
    (c) => (
      // eslint-disable-next-line no-bitwise
      (c ^ (getRandomByte() & 15) >> c / 4).toString(16)
    )
  );
}
function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : void 0;
}
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }
  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || "<unknown>";
  }
  return eventId || "<unknown>";
}
function addExceptionTypeValue(event, value, type39) {
  const exception = event.exception = event.exception || {};
  const values = exception.values = exception.values || [];
  const firstException = values[0] = values[0] || {};
  if (!firstException.value) {
    firstException.value = value || "";
  }
  if (!firstException.type) {
    firstException.type = type39 || "Error";
  }
}
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }
  const defaultMechanism = { type: "generic", handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };
  if (newMechanism && "data" in newMechanism) {
    const mergedData = { ...currentMechanism && currentMechanism.data, ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}
function checkOrSetAlreadyCaught(exception) {
  if (exception && exception.__sentry_captured__) {
    return true;
  }
  try {
    addNonEnumerableProperty(exception, "__sentry_captured__", true);
  } catch (err) {
  }
  return false;
}
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}
var init_misc = __esm({
  "node_modules/@sentry/utils/esm/misc.js"() {
    init_object();
    init_worldwide();
  }
});

// node_modules/@sentry/utils/esm/env.js
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
function getSDKSource() {
  return "npm";
}
var init_env = __esm({
  "node_modules/@sentry/utils/esm/env.js"() {
  }
});

// node_modules/@sentry/utils/esm/node.js
function isNodeEnv() {
  return !isBrowserBundle() && Object.prototype.toString.call(typeof process !== "undefined" ? process : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
  return mod.require(request);
}
var init_node = __esm({
  "node_modules/@sentry/utils/esm/node.js"() {
    init_env();
  }
});

// node_modules/@sentry/utils/esm/normalize.js
function normalize(input, depth = 100, maxProperties = Infinity) {
  try {
    return visit("", input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}
function normalizeToSize(object2, depth = 3, maxSize = 100 * 1024) {
  const normalized = normalize(object2, depth);
  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object2, depth - 1, maxSize);
  }
  return normalized;
}
function visit(key, value, depth = Infinity, maxProperties = Infinity, memo2 = memoBuilder()) {
  const [memoize3, unmemoize] = memo2;
  if (value == null || // this matches null and undefined -> eqeq not eqeqeq
  ["number", "boolean", "string"].includes(typeof value) && !isNaN2(value)) {
    return value;
  }
  const stringified = stringifyValue(key, value);
  if (!stringified.startsWith("[object ")) {
    return stringified;
  }
  if (value["__sentry_skip_normalization__"]) {
    return value;
  }
  const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
  if (remainingDepth === 0) {
    return stringified.replace("object ", "");
  }
  if (memoize3(value)) {
    return "[Circular ~]";
  }
  const valueWithToJSON = value;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      return visit("", jsonValue, remainingDepth - 1, maxProperties, memo2);
    } catch (err) {
    }
  }
  const normalized = Array.isArray(value) ? [] : {};
  let numAdded = 0;
  const visitable = convertToPlainObject(value);
  for (const visitKey in visitable) {
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }
    if (numAdded >= maxProperties) {
      normalized[visitKey] = "[MaxProperties ~]";
      break;
    }
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo2);
    numAdded++;
  }
  unmemoize(value);
  return normalized;
}
function stringifyValue(key, value) {
  try {
    if (key === "domain" && value && typeof value === "object" && value._events) {
      return "[Domain]";
    }
    if (key === "domainEmitter") {
      return "[DomainEmitter]";
    }
    if (typeof window !== "undefined" && value === window) {
      return "[Global]";
    }
    if (typeof window !== "undefined" && value === window) {
      return "[Window]";
    }
    if (typeof document !== "undefined" && value === document) {
      return "[Document]";
    }
    if (isSyntheticEvent(value)) {
      return "[SyntheticEvent]";
    }
    if (typeof value === "number" && value !== value) {
      return "[NaN]";
    }
    if (typeof value === "function") {
      return `[Function: ${getFunctionName(value)}]`;
    }
    if (typeof value === "symbol") {
      return `[${String(value)}]`;
    }
    if (typeof value === "bigint") {
      return `[BigInt: ${String(value)}]`;
    }
    const objName = getConstructorName(value);
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }
    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);
  return prototype ? prototype.constructor.name : "null prototype";
}
function utf8Length(value) {
  return ~-encodeURI(value).split(/%..|./).length;
}
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}
var init_normalize = __esm({
  "node_modules/@sentry/utils/esm/normalize.js"() {
    init_is();
    init_memo();
    init_object();
    init_stacktrace();
  }
});

// node_modules/@sentry/utils/esm/syncpromise.js
function resolvedSyncPromise(value) {
  return new SyncPromise((resolve) => {
    resolve(value);
  });
}
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}
var States, SyncPromise;
var init_syncpromise = __esm({
  "node_modules/@sentry/utils/esm/syncpromise.js"() {
    init_is();
    (function(States2) {
      const PENDING = 0;
      States2[States2["PENDING"] = PENDING] = "PENDING";
      const RESOLVED = 1;
      States2[States2["RESOLVED"] = RESOLVED] = "RESOLVED";
      const REJECTED = 2;
      States2[States2["REJECTED"] = REJECTED] = "REJECTED";
    })(States || (States = {}));
    SyncPromise = class _SyncPromise {
      constructor(executor) {
        _SyncPromise.prototype.__init.call(this);
        _SyncPromise.prototype.__init2.call(this);
        _SyncPromise.prototype.__init3.call(this);
        _SyncPromise.prototype.__init4.call(this);
        this._state = States.PENDING;
        this._handlers = [];
        try {
          executor(this._resolve, this._reject);
        } catch (e) {
          this._reject(e);
        }
      }
      /** JSDoc */
      then(onfulfilled, onrejected) {
        return new _SyncPromise((resolve, reject) => {
          this._handlers.push([
            false,
            (result) => {
              if (!onfulfilled) {
                resolve(result);
              } else {
                try {
                  resolve(onfulfilled(result));
                } catch (e) {
                  reject(e);
                }
              }
            },
            (reason) => {
              if (!onrejected) {
                reject(reason);
              } else {
                try {
                  resolve(onrejected(reason));
                } catch (e) {
                  reject(e);
                }
              }
            }
          ]);
          this._executeHandlers();
        });
      }
      /** JSDoc */
      catch(onrejected) {
        return this.then((val) => val, onrejected);
      }
      /** JSDoc */
      finally(onfinally) {
        return new _SyncPromise((resolve, reject) => {
          let val;
          let isRejected;
          return this.then(
            (value) => {
              isRejected = false;
              val = value;
              if (onfinally) {
                onfinally();
              }
            },
            (reason) => {
              isRejected = true;
              val = reason;
              if (onfinally) {
                onfinally();
              }
            }
          ).then(() => {
            if (isRejected) {
              reject(val);
              return;
            }
            resolve(val);
          });
        });
      }
      /** JSDoc */
      __init() {
        this._resolve = (value) => {
          this._setResult(States.RESOLVED, value);
        };
      }
      /** JSDoc */
      __init2() {
        this._reject = (reason) => {
          this._setResult(States.REJECTED, reason);
        };
      }
      /** JSDoc */
      __init3() {
        this._setResult = (state, value) => {
          if (this._state !== States.PENDING) {
            return;
          }
          if (isThenable(value)) {
            void value.then(this._resolve, this._reject);
            return;
          }
          this._state = state;
          this._value = value;
          this._executeHandlers();
        };
      }
      /** JSDoc */
      __init4() {
        this._executeHandlers = () => {
          if (this._state === States.PENDING) {
            return;
          }
          const cachedHandlers = this._handlers.slice();
          this._handlers = [];
          cachedHandlers.forEach((handler) => {
            if (handler[0]) {
              return;
            }
            if (this._state === States.RESOLVED) {
              handler[1](this._value);
            }
            if (this._state === States.REJECTED) {
              handler[2](this._value);
            }
            handler[0] = true;
          });
        };
      }
    };
  }
});

// node_modules/@sentry/utils/esm/promisebuffer.js
function makePromiseBuffer(limit) {
  const buffer = [];
  function isReady() {
    return limit === void 0 || buffer.length < limit;
  }
  function remove2(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }
  function add(taskProducer) {
    if (!isReady()) {
      return rejectedSyncPromise(new SentryError("Not adding Promise because buffer limit was reached."));
    }
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task.then(() => remove2(task)).then(
      null,
      () => remove2(task).then(null, () => {
      })
    );
    return task;
  }
  function drain(timeout) {
    return new SyncPromise((resolve, reject) => {
      let counter = buffer.length;
      if (!counter) {
        return resolve(true);
      }
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);
      buffer.forEach((item) => {
        void resolvedSyncPromise(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }
  return {
    $: buffer,
    add,
    drain
  };
}
var init_promisebuffer = __esm({
  "node_modules/@sentry/utils/esm/promisebuffer.js"() {
    init_error();
    init_syncpromise();
  }
});

// node_modules/@sentry/utils/esm/url.js
function parseUrl(url) {
  if (!url) {
    return {};
  }
  const match2 = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!match2) {
    return {};
  }
  const query = match2[6] || "";
  const fragment = match2[8] || "";
  return {
    host: match2[4],
    path: match2[5],
    protocol: match2[2],
    search: query,
    hash: fragment,
    relative: match2[5] + query + fragment
    // everything minus origin
  };
}
var init_url = __esm({
  "node_modules/@sentry/utils/esm/url.js"() {
  }
});

// node_modules/@sentry/utils/esm/severity.js
function severityLevelFromString(level) {
  return level === "warn" ? "warning" : validSeverityLevels.includes(level) ? level : "log";
}
var validSeverityLevels;
var init_severity = __esm({
  "node_modules/@sentry/utils/esm/severity.js"() {
    validSeverityLevels = ["fatal", "error", "warning", "log", "info", "debug"];
  }
});

// node_modules/@sentry/utils/esm/time.js
function getBrowserPerformance() {
  const { performance: performance2 } = WINDOW5;
  if (!performance2 || !performance2.now) {
    return void 0;
  }
  const timeOrigin = Date.now() - performance2.now();
  return {
    now: () => performance2.now(),
    timeOrigin
  };
}
function getNodePerformance() {
  try {
    const perfHooks = dynamicRequire(module, "perf_hooks");
    return perfHooks.performance;
  } catch (_) {
    return void 0;
  }
}
var WINDOW5, dateTimestampSource, platformPerformance, timestampSource, dateTimestampInSeconds, timestampInSeconds, _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin;
var init_time = __esm({
  "node_modules/@sentry/utils/esm/time.js"() {
    init_node();
    init_worldwide();
    WINDOW5 = getGlobalObject();
    dateTimestampSource = {
      nowSeconds: () => Date.now() / 1e3
    };
    platformPerformance = isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
    timestampSource = platformPerformance === void 0 ? dateTimestampSource : {
      nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1e3
    };
    dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
    timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
    browserPerformanceTimeOrigin = (() => {
      const { performance: performance2 } = WINDOW5;
      if (!performance2 || !performance2.now) {
        _browserPerformanceTimeOriginMode = "none";
        return void 0;
      }
      const threshold = 3600 * 1e3;
      const performanceNow = performance2.now();
      const dateNow = Date.now();
      const timeOriginDelta = performance2.timeOrigin ? Math.abs(performance2.timeOrigin + performanceNow - dateNow) : threshold;
      const timeOriginIsReliable = timeOriginDelta < threshold;
      const navigationStart = performance2.timing && performance2.timing.navigationStart;
      const hasNavigationStart = typeof navigationStart === "number";
      const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
      const navigationStartIsReliable = navigationStartDelta < threshold;
      if (timeOriginIsReliable || navigationStartIsReliable) {
        if (timeOriginDelta <= navigationStartDelta) {
          _browserPerformanceTimeOriginMode = "timeOrigin";
          return performance2.timeOrigin;
        } else {
          _browserPerformanceTimeOriginMode = "navigationStart";
          return navigationStart;
        }
      }
      _browserPerformanceTimeOriginMode = "dateNow";
      return dateNow;
    })();
  }
});

// node_modules/@sentry/utils/esm/envelope.js
function createEnvelope(headers, items = []) {
  return [headers, items];
}
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]];
}
function forEachEnvelopeItem(envelope, callback) {
  const envelopeItems = envelope[1];
  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);
    if (result) {
      return true;
    }
  }
  return false;
}
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;
  let parts = JSON.stringify(envHeaders);
  function append(next) {
    if (typeof parts === "string") {
      parts = typeof next === "string" ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === "string" ? encodeUTF8(next, textEncoder) : next);
    }
  }
  for (const item of items) {
    const [itemHeaders, payload] = item;
    append(`
${JSON.stringify(itemHeaders)}
`);
    if (typeof payload === "string" || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }
  return typeof parts === "string" ? parts : concatBuffers(parts);
}
function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);
  const merged = new Uint8Array(totalLength);
  let offset6 = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset6);
    offset6 += buffer.length;
  }
  return merged;
}
function createAttachmentEnvelopeItem(attachment, textEncoder) {
  const buffer = typeof attachment.data === "string" ? encodeUTF8(attachment.data, textEncoder) : attachment.data;
  return [
    dropUndefinedKeys({
      type: "attachment",
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType
    }),
    buffer
  ];
}
function envelopeItemTypeToDataCategory(type39) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type39];
}
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}
function createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...sdkInfo && { sdk: sdkInfo },
    ...!!tunnel && { dsn: dsnToString(dsn) },
    ...dynamicSamplingContext && {
      trace: dropUndefinedKeys({ ...dynamicSamplingContext })
    }
  };
}
var ITEM_TYPE_TO_DATA_CATEGORY_MAP;
var init_envelope = __esm({
  "node_modules/@sentry/utils/esm/envelope.js"() {
    init_dsn();
    init_normalize();
    init_object();
    ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
      session: "session",
      sessions: "session",
      attachment: "attachment",
      transaction: "transaction",
      event: "error",
      client_report: "internal",
      user_report: "default",
      profile: "profile",
      replay_event: "replay",
      replay_recording: "replay",
      check_in: "monitor"
    };
  }
});

// node_modules/@sentry/utils/esm/clientreport.js
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
  const clientReportItem = [
    { type: "client_report" },
    {
      timestamp: timestamp || dateTimestampInSeconds(),
      discarded_events
    }
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}
var init_clientreport = __esm({
  "node_modules/@sentry/utils/esm/clientreport.js"() {
    init_envelope();
    init_time();
  }
});

// node_modules/@sentry/utils/esm/ratelimit.js
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1e3;
  }
  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }
  return DEFAULT_RETRY_AFTER;
}
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}
function updateRateLimits(limits, { statusCode, headers }, now = Date.now()) {
  const updatedRateLimits = {
    ...limits
  };
  const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
  const retryAfterHeader = headers && headers["retry-after"];
  if (rateLimitHeader) {
    for (const limit of rateLimitHeader.trim().split(",")) {
      const [retryAfter, categories] = limit.split(":", 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1e3;
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(";")) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1e3;
  }
  return updatedRateLimits;
}
var DEFAULT_RETRY_AFTER;
var init_ratelimit = __esm({
  "node_modules/@sentry/utils/esm/ratelimit.js"() {
    DEFAULT_RETRY_AFTER = 60 * 1e3;
  }
});

// node_modules/@sentry/utils/esm/index.js
var init_esm = __esm({
  "node_modules/@sentry/utils/esm/index.js"() {
    init_browser();
    init_dsn();
    init_error();
    init_worldwide();
    init_instrument();
    init_is();
    init_logger();
    init_misc();
    init_normalize();
    init_object();
    init_promisebuffer();
    init_severity();
    init_stacktrace();
    init_string();
    init_supports();
    init_syncpromise();
    init_time();
    init_env();
    init_envelope();
    init_clientreport();
    init_ratelimit();
    init_url();
  }
});

// node_modules/@sentry/core/esm/constants.js
var DEFAULT_ENVIRONMENT;
var init_constants = __esm({
  "node_modules/@sentry/core/esm/constants.js"() {
    DEFAULT_ENVIRONMENT = "production";
  }
});

// node_modules/@sentry/core/esm/session.js
function makeSession(context) {
  const startingTime = timestampInSeconds();
  const session = {
    sid: uuid4(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: "ok",
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session)
  };
  if (context) {
    updateSession(session, context);
  }
  return session;
}
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }
    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }
  session.timestamp = context.timestamp || timestampInSeconds();
  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    session.sid = context.sid.length === 32 ? context.sid : uuid4();
  }
  if (context.init !== void 0) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === "number") {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = void 0;
  } else if (typeof context.duration === "number") {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === "number") {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === "ok") {
    context = { status: "exited" };
  }
  updateSession(session, context);
}
function sessionToJSON(session) {
  return dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1e3).toISOString(),
    timestamp: new Date(session.timestamp * 1e3).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : void 0,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent
    }
  });
}
var init_session = __esm({
  "node_modules/@sentry/core/esm/session.js"() {
    init_esm();
  }
});

// node_modules/@sentry/core/esm/scope.js
function getGlobalEventProcessors() {
  return getGlobalSingleton("globalEventProcessors", () => []);
}
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}
function generatePropagationContext() {
  return {
    traceId: uuid4(),
    spanId: uuid4().substring(16),
    sampled: false
  };
}
var DEFAULT_MAX_BREADCRUMBS, Scope;
var init_scope = __esm({
  "node_modules/@sentry/core/esm/scope.js"() {
    init_esm();
    init_session();
    DEFAULT_MAX_BREADCRUMBS = 100;
    Scope = class _Scope {
      /** Flag if notifying is happening. */
      /** Callback for client to receive scope changes. */
      /** Callback list that will be called after {@link applyToEvent}. */
      /** Array of breadcrumbs. */
      /** User */
      /** Tags */
      /** Extra */
      /** Contexts */
      /** Attachments */
      /** Propagation Context for distributed tracing */
      /**
       * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
       * sent to Sentry
       */
      /** Fingerprint */
      /** Severity */
      // eslint-disable-next-line deprecation/deprecation
      /** Transaction Name */
      /** Span */
      /** Session */
      /** Request Mode Session Status */
      // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
      constructor() {
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = generatePropagationContext();
      }
      /**
       * Inherit values from the parent scope.
       * @param scope to clone.
       */
      static clone(scope) {
        const newScope = new _Scope();
        if (scope) {
          newScope._breadcrumbs = [...scope._breadcrumbs];
          newScope._tags = { ...scope._tags };
          newScope._extra = { ...scope._extra };
          newScope._contexts = { ...scope._contexts };
          newScope._user = scope._user;
          newScope._level = scope._level;
          newScope._span = scope._span;
          newScope._session = scope._session;
          newScope._transactionName = scope._transactionName;
          newScope._fingerprint = scope._fingerprint;
          newScope._eventProcessors = [...scope._eventProcessors];
          newScope._requestSession = scope._requestSession;
          newScope._attachments = [...scope._attachments];
          newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
          newScope._propagationContext = { ...scope._propagationContext };
        }
        return newScope;
      }
      /**
       * Add internal on change listener. Used for sub SDKs that need to store the scope.
       * @hidden
       */
      addScopeListener(callback) {
        this._scopeListeners.push(callback);
      }
      /**
       * @inheritDoc
       */
      addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
      }
      /**
       * @inheritDoc
       */
      setUser(user) {
        this._user = user || {};
        if (this._session) {
          updateSession(this._session, { user });
        }
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      getUser() {
        return this._user;
      }
      /**
       * @inheritDoc
       */
      getRequestSession() {
        return this._requestSession;
      }
      /**
       * @inheritDoc
       */
      setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
      }
      /**
       * @inheritDoc
       */
      setTags(tags2) {
        this._tags = {
          ...this._tags,
          ...tags2
        };
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setTag(key, value) {
        this._tags = { ...this._tags, [key]: value };
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setExtras(extras) {
        this._extra = {
          ...this._extra,
          ...extras
        };
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setExtra(key, extra) {
        this._extra = { ...this._extra, [key]: extra };
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setContext(key, context) {
        if (context === null) {
          delete this._contexts[key];
        } else {
          this._contexts[key] = context;
        }
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      getSpan() {
        return this._span;
      }
      /**
       * @inheritDoc
       */
      getTransaction() {
        const span = this.getSpan();
        return span && span.transaction;
      }
      /**
       * @inheritDoc
       */
      setSession(session) {
        if (!session) {
          delete this._session;
        } else {
          this._session = session;
        }
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      getSession() {
        return this._session;
      }
      /**
       * @inheritDoc
       */
      update(captureContext) {
        if (!captureContext) {
          return this;
        }
        if (typeof captureContext === "function") {
          const updatedScope = captureContext(this);
          return updatedScope instanceof _Scope ? updatedScope : this;
        }
        if (captureContext instanceof _Scope) {
          this._tags = { ...this._tags, ...captureContext._tags };
          this._extra = { ...this._extra, ...captureContext._extra };
          this._contexts = { ...this._contexts, ...captureContext._contexts };
          if (captureContext._user && Object.keys(captureContext._user).length) {
            this._user = captureContext._user;
          }
          if (captureContext._level) {
            this._level = captureContext._level;
          }
          if (captureContext._fingerprint) {
            this._fingerprint = captureContext._fingerprint;
          }
          if (captureContext._requestSession) {
            this._requestSession = captureContext._requestSession;
          }
          if (captureContext._propagationContext) {
            this._propagationContext = captureContext._propagationContext;
          }
        } else if (isPlainObject(captureContext)) {
          captureContext = captureContext;
          this._tags = { ...this._tags, ...captureContext.tags };
          this._extra = { ...this._extra, ...captureContext.extra };
          this._contexts = { ...this._contexts, ...captureContext.contexts };
          if (captureContext.user) {
            this._user = captureContext.user;
          }
          if (captureContext.level) {
            this._level = captureContext.level;
          }
          if (captureContext.fingerprint) {
            this._fingerprint = captureContext.fingerprint;
          }
          if (captureContext.requestSession) {
            this._requestSession = captureContext.requestSession;
          }
          if (captureContext.propagationContext) {
            this._propagationContext = captureContext.propagationContext;
          }
        }
        return this;
      }
      /**
       * @inheritDoc
       */
      clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = void 0;
        this._transactionName = void 0;
        this._fingerprint = void 0;
        this._requestSession = void 0;
        this._span = void 0;
        this._session = void 0;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = generatePropagationContext();
        return this;
      }
      /**
       * @inheritDoc
       */
      addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;
        if (maxCrumbs <= 0) {
          return this;
        }
        const mergedBreadcrumb = {
          timestamp: dateTimestampInSeconds(),
          ...breadcrumb
        };
        this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
      }
      /**
       * @inheritDoc
       */
      clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
      }
      /**
       * @inheritDoc
       */
      addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
      }
      /**
       * @inheritDoc
       */
      getAttachments() {
        return this._attachments;
      }
      /**
       * @inheritDoc
       */
      clearAttachments() {
        this._attachments = [];
        return this;
      }
      /**
       * Applies data from the scope to the event and runs all event processors on it.
       *
       * @param event Event
       * @param hint Object containing additional information about the original exception, for use by the event processors.
       * @hidden
       */
      applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) {
          event.extra = { ...this._extra, ...event.extra };
        }
        if (this._tags && Object.keys(this._tags).length) {
          event.tags = { ...this._tags, ...event.tags };
        }
        if (this._user && Object.keys(this._user).length) {
          event.user = { ...this._user, ...event.user };
        }
        if (this._contexts && Object.keys(this._contexts).length) {
          event.contexts = { ...this._contexts, ...event.contexts };
        }
        if (this._level) {
          event.level = this._level;
        }
        if (this._transactionName) {
          event.transaction = this._transactionName;
        }
        if (this._span) {
          event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
          const transaction = this._span.transaction;
          if (transaction) {
            event.sdkProcessingMetadata = {
              dynamicSamplingContext: transaction.getDynamicSamplingContext(),
              ...event.sdkProcessingMetadata
            };
            const transactionName = transaction.name;
            if (transactionName) {
              event.tags = { transaction: transactionName, ...event.tags };
            }
          }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [...event.breadcrumbs || [], ...this._breadcrumbs];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : void 0;
        event.sdkProcessingMetadata = {
          ...event.sdkProcessingMetadata,
          ...this._sdkProcessingMetadata,
          propagationContext: this._propagationContext
        };
        return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
      }
      /**
       * Add data which will be accessible during event processing but won't get sent to Sentry
       */
      setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };
        return this;
      }
      /**
       * @inheritDoc
       */
      setPropagationContext(context) {
        this._propagationContext = context;
        return this;
      }
      /**
       * @inheritDoc
       */
      getPropagationContext() {
        return this._propagationContext;
      }
      /**
       * This will be called after {@link applyToEvent} is finished.
       */
      _notifyEventProcessors(processors, event, hint, index3 = 0) {
        return new SyncPromise((resolve, reject) => {
          const processor = processors[index3];
          if (event === null || typeof processor !== "function") {
            resolve(event);
          } else {
            const result = processor({ ...event }, hint);
            if (isThenable(result)) {
              void result.then((final) => this._notifyEventProcessors(processors, final, hint, index3 + 1).then(resolve)).then(null, reject);
            } else {
              void this._notifyEventProcessors(processors, result, hint, index3 + 1).then(resolve).then(null, reject);
            }
          }
        });
      }
      /**
       * This will be called on every set call.
       */
      _notifyScopeListeners() {
        if (!this._notifyingListeners) {
          this._notifyingListeners = true;
          this._scopeListeners.forEach((callback) => {
            callback(this);
          });
          this._notifyingListeners = false;
        }
      }
      /**
       * Applies fingerprint from the scope to the event if there's one,
       * uses message if there's one instead or get rid of empty fingerprint
       */
      _applyFingerprint(event) {
        event.fingerprint = event.fingerprint ? arrayify(event.fingerprint) : [];
        if (this._fingerprint) {
          event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        if (event.fingerprint && !event.fingerprint.length) {
          delete event.fingerprint;
        }
      }
    };
  }
});

// node_modules/@sentry/core/esm/hub.js
function getMainCarrier() {
  GLOBAL_OBJ.__SENTRY__ = GLOBAL_OBJ.__SENTRY__ || {
    extensions: {},
    hub: void 0
  };
  return GLOBAL_OBJ;
}
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}
function getCurrentHub() {
  const registry = getMainCarrier();
  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();
    if (hub) {
      return hub;
    }
  }
  return getGlobalHub(registry);
}
function getGlobalHub(registry = getMainCarrier()) {
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }
  return getHubFromCarrier(registry);
}
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function getHubFromCarrier(carrier) {
  return getGlobalSingleton("hub", () => new Hub(), carrier);
}
function setHubOnCarrier(carrier, hub) {
  if (!carrier)
    return false;
  const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
  __SENTRY__.hub = hub;
  return true;
}
var API_VERSION, DEFAULT_BREADCRUMBS, Hub;
var init_hub = __esm({
  "node_modules/@sentry/core/esm/hub.js"() {
    init_esm();
    init_constants();
    init_scope();
    init_session();
    API_VERSION = 4;
    DEFAULT_BREADCRUMBS = 100;
    Hub = class {
      /** Is a {@link Layer}[] containing the client and scope */
      /** Contains the last event id of a captured event.  */
      /**
       * Creates a new instance of the hub, will push one {@link Layer} into the
       * internal stack on creation.
       *
       * @param client bound to the hub.
       * @param scope bound to the hub.
       * @param version number, higher number means higher priority.
       */
      constructor(client2, scope = new Scope(), _version = API_VERSION) {
        this._version = _version;
        this._stack = [{ scope }];
        if (client2) {
          this.bindClient(client2);
        }
      }
      /**
       * @inheritDoc
       */
      isOlderThan(version) {
        return this._version < version;
      }
      /**
       * @inheritDoc
       */
      bindClient(client2) {
        const top = this.getStackTop();
        top.client = client2;
        if (client2 && client2.setupIntegrations) {
          client2.setupIntegrations();
        }
      }
      /**
       * @inheritDoc
       */
      pushScope() {
        const scope = Scope.clone(this.getScope());
        this.getStack().push({
          client: this.getClient(),
          scope
        });
        return scope;
      }
      /**
       * @inheritDoc
       */
      popScope() {
        if (this.getStack().length <= 1)
          return false;
        return !!this.getStack().pop();
      }
      /**
       * @inheritDoc
       */
      withScope(callback) {
        const scope = this.pushScope();
        try {
          callback(scope);
        } finally {
          this.popScope();
        }
      }
      /**
       * @inheritDoc
       */
      getClient() {
        return this.getStackTop().client;
      }
      /** Returns the scope of the top stack. */
      getScope() {
        return this.getStackTop().scope;
      }
      /** Returns the scope stack for domains or the process. */
      getStack() {
        return this._stack;
      }
      /** Returns the topmost scope layer in the order domain > local > process. */
      getStackTop() {
        return this._stack[this._stack.length - 1];
      }
      /**
       * @inheritDoc
       */
      captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4();
        const syntheticException = new Error("Sentry syntheticException");
        this._withClient((client2, scope) => {
          client2.captureException(
            exception,
            {
              originalException: exception,
              syntheticException,
              ...hint,
              event_id: eventId
            },
            scope
          );
        });
        return eventId;
      }
      /**
       * @inheritDoc
       */
      captureMessage(message, level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4();
        const syntheticException = new Error(message);
        this._withClient((client2, scope) => {
          client2.captureMessage(
            message,
            level,
            {
              originalException: message,
              syntheticException,
              ...hint,
              event_id: eventId
            },
            scope
          );
        });
        return eventId;
      }
      /**
       * @inheritDoc
       */
      captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : uuid4();
        if (!event.type) {
          this._lastEventId = eventId;
        }
        this._withClient((client2, scope) => {
          client2.captureEvent(event, { ...hint, event_id: eventId }, scope);
        });
        return eventId;
      }
      /**
       * @inheritDoc
       */
      lastEventId() {
        return this._lastEventId;
      }
      /**
       * @inheritDoc
       */
      addBreadcrumb(breadcrumb, hint) {
        const { scope, client: client2 } = this.getStackTop();
        if (!client2)
          return;
        const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } = client2.getOptions && client2.getOptions() || {};
        if (maxBreadcrumbs <= 0)
          return;
        const timestamp = dateTimestampInSeconds();
        const mergedBreadcrumb = { timestamp, ...breadcrumb };
        const finalBreadcrumb = beforeBreadcrumb ? consoleSandbox(() => beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null)
          return;
        if (client2.emit) {
          client2.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        }
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
      }
      /**
       * @inheritDoc
       */
      setUser(user) {
        this.getScope().setUser(user);
      }
      /**
       * @inheritDoc
       */
      setTags(tags2) {
        this.getScope().setTags(tags2);
      }
      /**
       * @inheritDoc
       */
      setExtras(extras) {
        this.getScope().setExtras(extras);
      }
      /**
       * @inheritDoc
       */
      setTag(key, value) {
        this.getScope().setTag(key, value);
      }
      /**
       * @inheritDoc
       */
      setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
      }
      /**
       * @inheritDoc
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      setContext(name, context) {
        this.getScope().setContext(name, context);
      }
      /**
       * @inheritDoc
       */
      configureScope(callback) {
        const { scope, client: client2 } = this.getStackTop();
        if (client2) {
          callback(scope);
        }
      }
      /**
       * @inheritDoc
       */
      run(callback) {
        const oldHub = makeMain(this);
        try {
          callback(this);
        } finally {
          makeMain(oldHub);
        }
      }
      /**
       * @inheritDoc
       */
      getIntegration(integration) {
        const client2 = this.getClient();
        if (!client2)
          return null;
        try {
          return client2.getIntegration(integration);
        } catch (_oO) {
          return null;
        }
      }
      /**
       * @inheritDoc
       */
      startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if (false) {
          console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
      }
      /**
       * @inheritDoc
       */
      traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
      }
      /**
       * @inheritDoc
       */
      captureSession(endSession2 = false) {
        if (endSession2) {
          return this.endSession();
        }
        this._sendSessionUpdate();
      }
      /**
       * @inheritDoc
       */
      endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) {
          closeSession(session);
        }
        this._sendSessionUpdate();
        scope.setSession();
      }
      /**
       * @inheritDoc
       */
      startSession(context) {
        const { scope, client: client2 } = this.getStackTop();
        const { release, environment = DEFAULT_ENVIRONMENT } = client2 && client2.getOptions() || {};
        const { userAgent } = GLOBAL_OBJ.navigator || {};
        const session = makeSession({
          release,
          environment,
          user: scope.getUser(),
          ...userAgent && { userAgent },
          ...context
        });
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") {
          updateSession(currentSession, { status: "exited" });
        }
        this.endSession();
        scope.setSession(session);
        return session;
      }
      /**
       * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
       * when Tracing is used.
       */
      shouldSendDefaultPii() {
        const client2 = this.getClient();
        const options = client2 && client2.getOptions();
        return Boolean(options && options.sendDefaultPii);
      }
      /**
       * Sends the current Session on the scope
       */
      _sendSessionUpdate() {
        const { scope, client: client2 } = this.getStackTop();
        const session = scope.getSession();
        if (session && client2 && client2.captureSession) {
          client2.captureSession(session);
        }
      }
      /**
       * Internal helper function to call a method on the top client if it exists.
       *
       * @param method The method to call on the client.
       * @param args Arguments to pass to the client function.
       */
      _withClient(callback) {
        const { scope, client: client2 } = this.getStackTop();
        if (client2) {
          callback(client2, scope);
        }
      }
      /**
       * Calls global extension method and binding current instance to the function call
       */
      // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      _callExtensionMethod(method, ...args) {
        const carrier = getMainCarrier();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") {
          return sentry.extensions[method].apply(this, args);
        }
      }
    };
  }
});

// node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
function getDynamicSamplingContextFromClient(trace_id, client2, scope) {
  const options = client2.getOptions();
  const { publicKey: public_key } = client2.getDsn() || {};
  const { segment: user_segment } = scope && scope.getUser() || {};
  const dsc = dropUndefinedKeys({
    environment: options.environment || DEFAULT_ENVIRONMENT,
    release: options.release,
    user_segment,
    public_key,
    trace_id
  });
  client2.emit && client2.emit("createDsc", dsc);
  return dsc;
}
var init_dynamicSamplingContext = __esm({
  "node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js"() {
    init_esm();
    init_constants();
  }
});

// node_modules/@sentry/core/esm/api.js
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
  const port = dsn.port ? `:${dsn.port}` : "";
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
function _encodedAuth(dsn, sdkInfo) {
  return urlEncode({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }
  });
}
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnelOrOptions = {}) {
  const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? void 0 : tunnelOrOptions._metadata.sdk;
  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}
var SENTRY_API_VERSION;
var init_api = __esm({
  "node_modules/@sentry/core/esm/api.js"() {
    init_esm();
    SENTRY_API_VERSION = "7";
  }
});

// node_modules/@sentry/core/esm/envelope.js
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...event.sdk.integrations || [], ...sdkInfo.integrations || []];
  event.sdk.packages = [...event.sdk.packages || [], ...sdkInfo.packages || []];
  return event;
}
function createSessionEnvelope(session, dsn, metadata, tunnel) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...sdkInfo && { sdk: sdkInfo },
    ...!!tunnel && { dsn: dsnToString(dsn) }
  };
  const envelopeItem = "aggregates" in session ? [{ type: "sessions" }, session] : [{ type: "session" }, session.toJSON()];
  return createEnvelope(envelopeHeaders, [envelopeItem]);
}
function createEventEnvelope(event, dsn, metadata, tunnel) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);
  delete event.sdkProcessingMetadata;
  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}
var init_envelope2 = __esm({
  "node_modules/@sentry/core/esm/envelope.js"() {
    init_esm();
  }
});

// node_modules/@sentry/core/esm/integration.js
function setupIntegrations(integrations) {
  const integrationIndex = {};
  integrations.forEach((integration) => {
    if (integration) {
      setupIntegration(integration, integrationIndex);
    }
  });
  return integrationIndex;
}
function setupIntegration(integration, integrationIndex) {
  integrationIndex[integration.name] = integration;
  if (installedIntegrations.indexOf(integration.name) === -1) {
    integration.setupOnce(addGlobalEventProcessor, getCurrentHub);
    installedIntegrations.push(integration.name);
  }
}
var installedIntegrations;
var init_integration = __esm({
  "node_modules/@sentry/core/esm/integration.js"() {
    init_hub();
    init_scope();
    installedIntegrations = [];
  }
});

// node_modules/@sentry/core/esm/utils/prepareEvent.js
function prepareEvent(options, event, hint, scope) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1e3 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || uuid4(),
    timestamp: event.timestamp || dateTimestampInSeconds()
  };
  const integrations = hint.integrations || options.integrations.map((i2) => i2.name);
  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);
  if (event.type === void 0) {
    applyDebugIds(prepared, options.stackParser);
  }
  let finalScope = scope;
  if (hint.captureContext) {
    finalScope = Scope.clone(finalScope).update(hint.captureContext);
  }
  let result = resolvedSyncPromise(prepared);
  if (finalScope) {
    if (finalScope.getAttachments) {
      const attachments = [...hint.attachments || [], ...finalScope.getAttachments()];
      if (attachments.length) {
        hint.attachments = attachments;
      }
    }
    result = finalScope.applyToEvent(prepared, hint);
  }
  return result.then((evt) => {
    if (evt) {
      applyDebugMeta(evt);
    }
    if (typeof normalizeDepth === "number" && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;
  if (!("environment" in event)) {
    event.environment = "environment" in options ? environment : DEFAULT_ENVIRONMENT;
  }
  if (event.release === void 0 && release !== void 0) {
    event.release = release;
  }
  if (event.dist === void 0 && dist !== void 0) {
    event.dist = dist;
  }
  if (event.message) {
    event.message = truncate(event.message, maxValueLength);
  }
  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = truncate(exception.value, maxValueLength);
  }
  const request = event.request;
  if (request && request.url) {
    request.url = truncate(request.url, maxValueLength);
  }
}
function applyDebugIds(event, stackParser) {
  const debugIdMap = GLOBAL_OBJ._sentryDebugIds;
  if (!debugIdMap) {
    return;
  }
  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = /* @__PURE__ */ new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }
    for (let i2 = parsedStack.length - 1; i2 >= 0; i2--) {
      const stackFrame = parsedStack[i2];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});
  try {
    event.exception.values.forEach((exception) => {
      exception.stacktrace.frames.forEach((frame) => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
  }
}
function applyDebugMeta(event) {
  const filenameDebugIdMap = {};
  try {
    event.exception.values.forEach((exception) => {
      exception.stacktrace.frames.forEach((frame) => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
  }
  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach((filename) => {
    images.push({
      type: "sourcemap",
      code_file: filename,
      debug_id: filenameDebugIdMap[filename]
    });
  });
}
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...event.sdk.integrations || [], ...integrationNames];
  }
}
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }
  const normalized = {
    ...event,
    ...event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map((b) => ({
        ...b,
        ...b.data && {
          data: normalize(b.data, depth, maxBreadth)
        }
      }))
    },
    ...event.user && {
      user: normalize(event.user, depth, maxBreadth)
    },
    ...event.contexts && {
      contexts: normalize(event.contexts, depth, maxBreadth)
    },
    ...event.extra && {
      extra: normalize(event.extra, depth, maxBreadth)
    }
  };
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
    }
  }
  if (event.spans) {
    normalized.spans = event.spans.map((span) => {
      if (span.data) {
        span.data = normalize(span.data, depth, maxBreadth);
      }
      return span;
    });
  }
  return normalized;
}
var debugIdStackParserCache;
var init_prepareEvent = __esm({
  "node_modules/@sentry/core/esm/utils/prepareEvent.js"() {
    init_esm();
    init_constants();
    init_scope();
    debugIdStackParserCache = /* @__PURE__ */ new WeakMap();
  }
});

// node_modules/@sentry/core/esm/baseclient.js
function _validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if (isThenable(beforeSendResult)) {
    return beforeSendResult.then(
      (event) => {
        if (!isPlainObject(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      (e) => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      }
    );
  } else if (!isPlainObject(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}
function processBeforeSend(options, event, hint) {
  const { beforeSend, beforeSendTransaction } = options;
  if (isErrorEvent2(event) && beforeSend) {
    return beforeSend(event, hint);
  }
  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }
  return event;
}
function isErrorEvent2(event) {
  return event.type === void 0;
}
function isTransactionEvent(event) {
  return event.type === "transaction";
}
var BaseClient;
var init_baseclient = __esm({
  "node_modules/@sentry/core/esm/baseclient.js"() {
    init_esm();
    init_api();
    init_envelope2();
    init_integration();
    init_session();
    init_dynamicSamplingContext();
    init_prepareEvent();
    BaseClient = class {
      /** Options passed to the SDK. */
      /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
      /** Array of set up integrations. */
      /** Indicates whether this client's integrations have been set up. */
      /** Number of calls being processed */
      /** Holds flushable  */
      // eslint-disable-next-line @typescript-eslint/ban-types
      /**
       * Initializes this client instance.
       *
       * @param options Options for the client.
       */
      constructor(options) {
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        if (options.dsn) {
          this._dsn = makeDsn(options.dsn);
        } else {
        }
        if (this._dsn) {
          const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
          this._transport = options.transport({
            recordDroppedEvent: this.recordDroppedEvent.bind(this),
            ...options.transportOptions,
            url
          });
        }
      }
      /**
       * @inheritDoc
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
      captureException(exception, hint, scope) {
        if (checkOrSetAlreadyCaught(exception)) {
          return;
        }
        let eventId = hint && hint.event_id;
        this._process(
          this.eventFromException(exception, hint).then((event) => this._captureEvent(event, hint, scope)).then((result) => {
            eventId = result;
          })
        );
        return eventId;
      }
      /**
       * @inheritDoc
       */
      captureMessage(message, level, hint, scope) {
        let eventId = hint && hint.event_id;
        const promisedEvent = isPrimitive(message) ? this.eventFromMessage(String(message), level, hint) : this.eventFromException(message, hint);
        this._process(
          promisedEvent.then((event) => this._captureEvent(event, hint, scope)).then((result) => {
            eventId = result;
          })
        );
        return eventId;
      }
      /**
       * @inheritDoc
       */
      captureEvent(event, hint, scope) {
        if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
          return;
        }
        let eventId = hint && hint.event_id;
        this._process(
          this._captureEvent(event, hint, scope).then((result) => {
            eventId = result;
          })
        );
        return eventId;
      }
      /**
       * @inheritDoc
       */
      captureSession(session) {
        if (!this._isEnabled()) {
          return;
        }
        if (!(typeof session.release === "string")) {
        } else {
          this.sendSession(session);
          updateSession(session, { init: false });
        }
      }
      /**
       * @inheritDoc
       */
      getDsn() {
        return this._dsn;
      }
      /**
       * @inheritDoc
       */
      getOptions() {
        return this._options;
      }
      /**
       * @see SdkMetadata in @sentry/types
       *
       * @return The metadata of the SDK
       */
      getSdkMetadata() {
        return this._options._metadata;
      }
      /**
       * @inheritDoc
       */
      getTransport() {
        return this._transport;
      }
      /**
       * @inheritDoc
       */
      flush(timeout) {
        const transport = this._transport;
        if (transport) {
          return this._isClientDoneProcessing(timeout).then((clientFinished) => {
            return transport.flush(timeout).then((transportFlushed) => clientFinished && transportFlushed);
          });
        } else {
          return resolvedSyncPromise(true);
        }
      }
      /**
       * @inheritDoc
       */
      close(timeout) {
        return this.flush(timeout).then((result) => {
          this.getOptions().enabled = false;
          return result;
        });
      }
      /**
       * Sets up the integrations
       */
      setupIntegrations() {
        if (this._isEnabled() && !this._integrationsInitialized) {
          this._integrations = setupIntegrations(this._options.integrations);
          this._integrationsInitialized = true;
        }
      }
      /**
       * Gets an installed integration by its `id`.
       *
       * @returns The installed integration or `undefined` if no integration with that `id` was installed.
       */
      getIntegrationById(integrationId) {
        return this._integrations[integrationId];
      }
      /**
       * @inheritDoc
       */
      getIntegration(integration) {
        try {
          return this._integrations[integration.id] || null;
        } catch (_oO) {
          return null;
        }
      }
      /**
       * @inheritDoc
       */
      addIntegration(integration) {
        setupIntegration(integration, this._integrations);
      }
      /**
       * @inheritDoc
       */
      sendEvent(event, hint = {}) {
        if (this._dsn) {
          let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);
          for (const attachment of hint.attachments || []) {
            env = addItemToEnvelope(
              env,
              createAttachmentEnvelopeItem(
                attachment,
                this._options.transportOptions && this._options.transportOptions.textEncoder
              )
            );
          }
          const promise = this._sendEnvelope(env);
          if (promise) {
            promise.then((sendResponse) => this.emit("afterSendEvent", event, sendResponse), null);
          }
        }
      }
      /**
       * @inheritDoc
       */
      sendSession(session) {
        if (this._dsn) {
          const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
          void this._sendEnvelope(env);
        }
      }
      /**
       * @inheritDoc
       */
      recordDroppedEvent(reason, category, _event) {
        if (this._options.sendClientReports) {
          const key = `${reason}:${category}`;
          this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
      }
      // Keep on() & emit() signatures in sync with types' client.ts interface
      /** @inheritdoc */
      /** @inheritdoc */
      on(hook, callback) {
        if (!this._hooks[hook]) {
          this._hooks[hook] = [];
        }
        this._hooks[hook].push(callback);
      }
      /** @inheritdoc */
      /** @inheritdoc */
      emit(hook, ...rest) {
        if (this._hooks[hook]) {
          this._hooks[hook].forEach((callback) => callback(...rest));
        }
      }
      /** Updates existing session based on the provided event */
      _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
          errored = true;
          for (const ex of exceptions) {
            const mechanism = ex.mechanism;
            if (mechanism && mechanism.handled === false) {
              crashed = true;
              break;
            }
          }
        }
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
          updateSession(session, {
            ...crashed && { status: "crashed" },
            errors: session.errors || Number(errored || crashed)
          });
          this.captureSession(session);
        }
      }
      /**
       * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
       * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
       *
       * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
       * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
       * `true`.
       * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
       * `false` otherwise
       */
      _isClientDoneProcessing(timeout) {
        return new SyncPromise((resolve) => {
          let ticked = 0;
          const tick = 1;
          const interval = setInterval(() => {
            if (this._numProcessing == 0) {
              clearInterval(interval);
              resolve(true);
            } else {
              ticked += tick;
              if (timeout && ticked >= timeout) {
                clearInterval(interval);
                resolve(false);
              }
            }
          }, tick);
        });
      }
      /** Determines whether this SDK is enabled and a valid Dsn is present. */
      _isEnabled() {
        return this.getOptions().enabled !== false && this._dsn !== void 0;
      }
      /**
       * Adds common information to events.
       *
       * The information includes release and environment from `options`,
       * breadcrumbs and context (extra, tags and user) from the scope.
       *
       * Information that is already present in the event is never overwritten. For
       * nested objects, such as the context, keys are merged.
       *
       * @param event The original event.
       * @param hint May contain additional information about the original exception.
       * @param scope A scope containing event metadata.
       * @returns A new event with more information.
       */
      _prepareEvent(event, hint, scope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) {
          hint.integrations = integrations;
        }
        return prepareEvent(options, event, hint, scope).then((evt) => {
          if (evt === null) {
            return evt;
          }
          const { propagationContext } = evt.sdkProcessingMetadata || {};
          const trace2 = evt.contexts && evt.contexts.trace;
          if (!trace2 && propagationContext) {
            const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext;
            evt.contexts = {
              trace: {
                trace_id,
                span_id: spanId,
                parent_span_id: parentSpanId
              },
              ...evt.contexts
            };
            const dynamicSamplingContext = dsc ? dsc : getDynamicSamplingContextFromClient(trace_id, this, scope);
            evt.sdkProcessingMetadata = {
              dynamicSamplingContext,
              ...evt.sdkProcessingMetadata
            };
          }
          return evt;
        });
      }
      /**
       * Processes the event and logs an error in case of rejection
       * @param event
       * @param hint
       * @param scope
       */
      _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then(
          (finalEvent) => {
            return finalEvent.event_id;
          },
          (reason) => {
            if (false) {
              const sentryError = reason;
              if (sentryError.logLevel === "log") {
                logger.log(sentryError.message);
              } else {
                logger.warn(sentryError);
              }
            }
            return void 0;
          }
        );
      }
      /**
       * Processes an event (either error or message) and sends it to Sentry.
       *
       * This also adds breadcrumbs and context information to the event. However,
       * platform specific meta data (such as the User's IP address) must be added
       * by the SDK implementor.
       *
       *
       * @param event The event to send to Sentry.
       * @param hint May contain additional information about the original exception.
       * @param scope A scope containing event metadata.
       * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
       */
      _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate } = options;
        if (!this._isEnabled()) {
          return rejectedSyncPromise(new SentryError("SDK not enabled, will not capture event.", "log"));
        }
        const isTransaction = isTransactionEvent(event);
        const isError2 = isErrorEvent2(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        if (isError2 && typeof sampleRate === "number" && Math.random() > sampleRate) {
          this.recordDroppedEvent("sample_rate", "error", event);
          return rejectedSyncPromise(
            new SentryError(
              `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
              "log"
            )
          );
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        return this._prepareEvent(event, hint, scope).then((prepared) => {
          if (prepared === null) {
            this.recordDroppedEvent("event_processor", dataCategory, event);
            throw new SentryError("An event processor returned `null`, will not send event.", "log");
          }
          const isInternalException = hint.data && hint.data.__sentry__ === true;
          if (isInternalException) {
            return prepared;
          }
          const result = processBeforeSend(options, prepared, hint);
          return _validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent) => {
          if (processedEvent === null) {
            this.recordDroppedEvent("before_send", dataCategory, event);
            throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
          }
          const session = scope && scope.getSession();
          if (!isTransaction && session) {
            this._updateSessionFromEvent(session, processedEvent);
          }
          const transactionInfo = processedEvent.transaction_info;
          if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
            const source = "custom";
            processedEvent.transaction_info = {
              ...transactionInfo,
              source
            };
          }
          this.sendEvent(processedEvent, hint);
          return processedEvent;
        }).then(null, (reason) => {
          if (reason instanceof SentryError) {
            throw reason;
          }
          this.captureException(reason, {
            data: {
              __sentry__: true
            },
            originalException: reason
          });
          throw new SentryError(
            `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${reason}`
          );
        });
      }
      /**
       * Occupies the client with processing and event
       */
      _process(promise) {
        this._numProcessing++;
        void promise.then(
          (value) => {
            this._numProcessing--;
            return value;
          },
          (reason) => {
            this._numProcessing--;
            return reason;
          }
        );
      }
      /**
       * @inheritdoc
       */
      _sendEnvelope(envelope) {
        if (this._transport && this._dsn) {
          this.emit("beforeEnvelope", envelope);
          return this._transport.send(envelope).then(null, (reason) => {
          });
        } else {
        }
      }
      /**
       * Clears outcomes on this client and returns them.
       */
      _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key) => {
          const [reason, category] = key.split(":");
          return {
            reason,
            category,
            quantity: outcomes[key]
          };
        });
      }
      /**
       * @inheritDoc
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    };
  }
});

// node_modules/@sentry/core/esm/transports/base.js
function createTransport(options, makeRequest, buffer = makePromiseBuffer(
  options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE
)) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);
  function send2(envelope) {
    const filteredEnvelopeItems = [];
    forEachEnvelopeItem(envelope, (item, type39) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type39);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type39);
        options.recordDroppedEvent("ratelimit_backoff", envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });
    if (filteredEnvelopeItems.length === 0) {
      return resolvedSyncPromise();
    }
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems);
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type39) => {
        const event = getEventForEnvelopeItem(item, type39);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type39), event);
      });
    };
    const requestTask = () => makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
      (response2) => {
        if (response2.statusCode !== void 0 && (response2.statusCode < 200 || response2.statusCode >= 300)) {
        }
        rateLimits = updateRateLimits(rateLimits, response2);
        return response2;
      },
      (error3) => {
        recordEnvelopeLoss("network_error");
        throw error3;
      }
    );
    return buffer.add(requestTask).then(
      (result) => result,
      (error3) => {
        if (error3 instanceof SentryError) {
          recordEnvelopeLoss("queue_overflow");
          return resolvedSyncPromise();
        } else {
          throw error3;
        }
      }
    );
  }
  send2.__sentry__baseTransport__ = true;
  return {
    send: send2,
    flush
  };
}
function getEventForEnvelopeItem(item, type39) {
  if (type39 !== "event" && type39 !== "transaction") {
    return void 0;
  }
  return Array.isArray(item) ? item[1] : void 0;
}
var DEFAULT_TRANSPORT_BUFFER_SIZE;
var init_base = __esm({
  "node_modules/@sentry/core/esm/transports/base.js"() {
    init_esm();
    DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
  }
});

// node_modules/@sentry/core/esm/version.js
var SDK_VERSION;
var init_version = __esm({
  "node_modules/@sentry/core/esm/version.js"() {
    SDK_VERSION = "7.64.0";
  }
});

// node_modules/@sentry/core/esm/integrations/functiontostring.js
var originalFunctionToString, FunctionToString;
var init_functiontostring = __esm({
  "node_modules/@sentry/core/esm/integrations/functiontostring.js"() {
    init_esm();
    FunctionToString = class _FunctionToString {
      /**
       * @inheritDoc
       */
      static __initStatic() {
        this.id = "FunctionToString";
      }
      /**
       * @inheritDoc
       */
      constructor() {
        this.name = _FunctionToString.id;
      }
      /**
       * @inheritDoc
       */
      setupOnce() {
        originalFunctionToString = Function.prototype.toString;
        try {
          Function.prototype.toString = function(...args) {
            const context = getOriginalFunction(this) || this;
            return originalFunctionToString.apply(context, args);
          };
        } catch (e) {
        }
      }
    };
    FunctionToString.__initStatic();
  }
});

// node_modules/@sentry/core/esm/integrations/index.js
var init_integrations = __esm({
  "node_modules/@sentry/core/esm/integrations/index.js"() {
    init_functiontostring();
  }
});

// node_modules/@sentry/core/esm/index.js
var init_esm2 = __esm({
  "node_modules/@sentry/core/esm/index.js"() {
    init_hub();
    init_baseclient();
    init_base();
    init_version();
  }
});

// node_modules/@sentry/browser/esm/eventbuilder.js
function exceptionFromError(stackParser, ex) {
  const frames = parseStackFrames(stackParser, ex);
  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex)
  };
  if (frames.length) {
    exception.stacktrace = { frames };
  }
  if (exception.type === void 0 && exception.value === "") {
    exception.value = "Unrecoverable error caught";
  }
  return exception;
}
function eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
  const hub = getCurrentHub();
  const client2 = hub.getClient();
  const normalizeDepth = client2 && client2.getOptions().normalizeDepth;
  const event = {
    exception: {
      values: [
        {
          type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection })
        }
      ]
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth)
    }
  };
  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception.values[0].stacktrace = { frames };
    }
  }
  return event;
}
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)]
    }
  };
}
function parseStackFrames(stackParser, ex) {
  const stacktrace = ex.stacktrace || ex.stack || "";
  const popSize = getPopSize(ex);
  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
  }
  return [];
}
function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === "number") {
      return ex.framesToPop;
    }
    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }
  return 0;
}
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return "No error message";
  }
  if (message.error && typeof message.error.message === "string") {
    return message.error.message;
  }
  return message;
}
function eventFromException(stackParser, exception, hint, attachStacktrace) {
  const syntheticException = hint && hint.syntheticException || void 0;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  addExceptionMechanism(event);
  event.level = "error";
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return resolvedSyncPromise(event);
}
function eventFromMessage(stackParser, message, level = "info", hint, attachStacktrace) {
  const syntheticException = hint && hint.syntheticException || void 0;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return resolvedSyncPromise(event);
}
function eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
  let event;
  if (isErrorEvent(exception) && exception.error) {
    const errorEvent = exception;
    return eventFromError(stackParser, errorEvent.error);
  }
  if (isDOMError(exception) || isDOMException(exception)) {
    const domException = exception;
    if ("stack" in exception) {
      event = eventFromError(stackParser, exception);
    } else {
      const name = domException.name || (isDOMError(domException) ? "DOMError" : "DOMException");
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      addExceptionTypeValue(event, message);
    }
    if ("code" in domException) {
      event.tags = { ...event.tags, "DOMException.code": `${domException.code}` };
    }
    return event;
  }
  if (isError(exception)) {
    return eventFromError(stackParser, exception);
  }
  if (isPlainObject(exception) || isEvent(exception)) {
    const objectException = exception;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    addExceptionMechanism(event, {
      synthetic: true
    });
    return event;
  }
  event = eventFromString(stackParser, exception, syntheticException, attachStacktrace);
  addExceptionTypeValue(event, `${exception}`, void 0);
  addExceptionMechanism(event, {
    synthetic: true
  });
  return event;
}
function eventFromString(stackParser, input, syntheticException, attachStacktrace) {
  const event = {
    message: input
  };
  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }]
      };
    }
  }
  return event;
}
function getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }) {
  const keys = extractExceptionKeysForMessage(exception);
  const captureType = isUnhandledRejection ? "promise rejection" : "exception";
  if (isErrorEvent(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }
  if (isEvent(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }
  return `Object captured as ${captureType} with keys: ${keys}`;
}
function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : void 0;
  } catch (e) {
  }
}
var reactMinifiedRegexp;
var init_eventbuilder = __esm({
  "node_modules/@sentry/browser/esm/eventbuilder.js"() {
    init_esm2();
    init_esm();
    reactMinifiedRegexp = /Minified React error #\d+;/i;
  }
});

// node_modules/@sentry/browser/esm/helpers.js
var WINDOW6;
var init_helpers = __esm({
  "node_modules/@sentry/browser/esm/helpers.js"() {
    init_esm();
    WINDOW6 = GLOBAL_OBJ;
  }
});

// node_modules/@sentry/browser/esm/integrations/breadcrumbs.js
function _domBreadcrumb(dom) {
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : void 0;
    let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : void 0;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }
    if (typeof keyAttrs === "string") {
      keyAttrs = [keyAttrs];
    }
    try {
      const event = handlerData.event;
      target = _isEvent(event) ? htmlTreeAsString(event.target, { keyAttrs, maxStringLength }) : htmlTreeAsString(event, { keyAttrs, maxStringLength });
    } catch (e) {
      target = "<unknown>";
    }
    if (target.length === 0) {
      return;
    }
    getCurrentHub().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global
      }
    );
  }
  return _innerDomBreadcrumb;
}
function _consoleBreadcrumb(handlerData) {
  for (let i2 = 0; i2 < handlerData.args.length; i2++) {
    if (handlerData.args[i2] === "ref=Ref<") {
      handlerData.args[i2 + 1] = "viewRef";
      break;
    }
  }
  const breadcrumb = {
    category: "console",
    data: {
      arguments: handlerData.args,
      logger: "console"
    },
    level: severityLevelFromString(handlerData.level),
    message: safeJoin(handlerData.args, " ")
  };
  if (handlerData.level === "assert") {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${safeJoin(handlerData.args.slice(1), " ") || "console.assert"}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      return;
    }
  }
  getCurrentHub().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level
  });
}
function _xhrBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;
  const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];
  if (!startTimestamp || !endTimestamp || !sentryXhrData) {
    return;
  }
  const { method, url, status_code, body } = sentryXhrData;
  const data = {
    method,
    url,
    status_code
  };
  const hint = {
    xhr: handlerData.xhr,
    input: body,
    startTimestamp,
    endTimestamp
  };
  getCurrentHub().addBreadcrumb(
    {
      category: "xhr",
      data,
      type: "http"
    },
    hint
  );
}
function _fetchBreadcrumb(handlerData) {
  const { startTimestamp, endTimestamp } = handlerData;
  if (!endTimestamp) {
    return;
  }
  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") {
    return;
  }
  if (handlerData.error) {
    const data = handlerData.fetchData;
    const hint = {
      data: handlerData.error,
      input: handlerData.args,
      startTimestamp,
      endTimestamp
    };
    getCurrentHub().addBreadcrumb(
      {
        category: "fetch",
        data,
        level: "error",
        type: "http"
      },
      hint
    );
  } else {
    const data = {
      ...handlerData.fetchData,
      status_code: handlerData.response && handlerData.response.status
    };
    const hint = {
      input: handlerData.args,
      response: handlerData.response,
      startTimestamp,
      endTimestamp
    };
    getCurrentHub().addBreadcrumb(
      {
        category: "fetch",
        data,
        type: "http"
      },
      hint
    );
  }
}
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(WINDOW6.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }
  getCurrentHub().addBreadcrumb({
    category: "navigation",
    data: {
      from,
      to
    }
  });
}
function _isEvent(event) {
  return !!event && !!event.target;
}
var MAX_ALLOWED_STRING_LENGTH, BREADCRUMB_INTEGRATION_ID, Breadcrumbs;
var init_breadcrumbs = __esm({
  "node_modules/@sentry/browser/esm/integrations/breadcrumbs.js"() {
    init_esm2();
    init_esm();
    init_helpers();
    MAX_ALLOWED_STRING_LENGTH = 1024;
    BREADCRUMB_INTEGRATION_ID = "Breadcrumbs";
    Breadcrumbs = class _Breadcrumbs {
      /**
       * @inheritDoc
       */
      static __initStatic() {
        this.id = BREADCRUMB_INTEGRATION_ID;
      }
      /**
       * @inheritDoc
       */
      /**
       * Options of the breadcrumbs integration.
       */
      // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
      /**
       * @inheritDoc
       */
      constructor(options) {
        this.name = _Breadcrumbs.id;
        this.options = {
          console: true,
          dom: true,
          fetch: true,
          history: true,
          sentry: true,
          xhr: true,
          ...options
        };
      }
      /**
       * Instrument browser built-ins w/ breadcrumb capturing
       *  - Console API
       *  - DOM API (click/typing)
       *  - XMLHttpRequest API
       *  - Fetch API
       *  - History API
       */
      setupOnce() {
        if (this.options.console) {
          addInstrumentationHandler("console", _consoleBreadcrumb);
        }
        if (this.options.dom) {
          addInstrumentationHandler("dom", _domBreadcrumb(this.options.dom));
        }
        if (this.options.xhr) {
          addInstrumentationHandler("xhr", _xhrBreadcrumb);
        }
        if (this.options.fetch) {
          addInstrumentationHandler("fetch", _fetchBreadcrumb);
        }
        if (this.options.history) {
          addInstrumentationHandler("history", _historyBreadcrumb);
        }
      }
      /**
       * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
       */
      addSentryBreadcrumb(event) {
        if (this.options.sentry) {
          getCurrentHub().addBreadcrumb(
            {
              category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
              event_id: event.event_id,
              level: event.level,
              message: getEventDescription(event)
            },
            {
              event
            }
          );
        }
      }
    };
    Breadcrumbs.__initStatic();
  }
});

// node_modules/@sentry/browser/esm/userfeedback.js
function createUserFeedbackEnvelope(feedback, {
  metadata,
  tunnel,
  dsn
}) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: (/* @__PURE__ */ new Date()).toISOString(),
    ...metadata && metadata.sdk && {
      sdk: {
        name: metadata.sdk.name,
        version: metadata.sdk.version
      }
    },
    ...!!tunnel && !!dsn && { dsn: dsnToString(dsn) }
  };
  const item = createUserFeedbackEnvelopeItem(feedback);
  return createEnvelope(headers, [item]);
}
function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: "user_report"
  };
  return [feedbackHeaders, feedback];
}
var init_userfeedback = __esm({
  "node_modules/@sentry/browser/esm/userfeedback.js"() {
    init_esm();
  }
});

// node_modules/@sentry/browser/esm/client.js
var BrowserClient;
var init_client = __esm({
  "node_modules/@sentry/browser/esm/client.js"() {
    init_esm2();
    init_esm();
    init_eventbuilder();
    init_helpers();
    init_breadcrumbs();
    init_userfeedback();
    BrowserClient = class extends BaseClient {
      /**
       * Creates a new Browser SDK instance.
       *
       * @param options Configuration options for this SDK.
       */
      constructor(options) {
        const sdkSource = WINDOW6.SENTRY_SDK_SOURCE || getSDKSource();
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
          name: "sentry.javascript.browser",
          packages: [
            {
              name: `${sdkSource}:@sentry/browser`,
              version: SDK_VERSION
            }
          ],
          version: SDK_VERSION
        };
        super(options);
        if (options.sendClientReports && WINDOW6.document) {
          WINDOW6.document.addEventListener("visibilitychange", () => {
            if (WINDOW6.document.visibilityState === "hidden") {
              this._flushOutcomes();
            }
          });
        }
      }
      /**
       * @inheritDoc
       */
      eventFromException(exception, hint) {
        return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
      }
      /**
       * @inheritDoc
       */
      eventFromMessage(message, level = "info", hint) {
        return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
      }
      /**
       * @inheritDoc
       */
      sendEvent(event, hint) {
        const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID);
        if (breadcrumbIntegration && breadcrumbIntegration.addSentryBreadcrumb) {
          breadcrumbIntegration.addSentryBreadcrumb(event);
        }
        super.sendEvent(event, hint);
      }
      /**
       * Sends user feedback to Sentry.
       */
      captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
          return;
        }
        const envelope = createUserFeedbackEnvelope(feedback, {
          metadata: this.getSdkMetadata(),
          dsn: this.getDsn(),
          tunnel: this.getOptions().tunnel
        });
        void this._sendEnvelope(envelope);
      }
      /**
       * @inheritDoc
       */
      _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
      }
      /**
       * Sends client reports as an envelope.
       */
      _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
          return;
        }
        if (!this._dsn) {
          return;
        }
        const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsnToString(this._dsn));
        void this._sendEnvelope(envelope);
      }
    };
  }
});

// node_modules/@sentry/browser/esm/stack-parsers.js
function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true
    // All browser frames are considered in_app
  };
  if (lineno !== void 0) {
    frame.lineno = lineno;
  }
  if (colno !== void 0) {
    frame.colno = colno;
  }
  return frame;
}
var UNKNOWN_FUNCTION, CHROME_PRIORITY, WINJS_PRIORITY, GECKO_PRIORITY, chromeRegex, chromeEvalRegex, chrome2, chromeStackLineParser, geckoREgex, geckoEvalRegex, gecko, geckoStackLineParser, winjsRegex, winjs, winjsStackLineParser, defaultStackLineParsers, defaultStackParser, extractSafariExtensionDetails;
var init_stack_parsers = __esm({
  "node_modules/@sentry/browser/esm/stack-parsers.js"() {
    init_esm();
    UNKNOWN_FUNCTION = "?";
    CHROME_PRIORITY = 30;
    WINJS_PRIORITY = 40;
    GECKO_PRIORITY = 50;
    chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
    chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
    chrome2 = (line) => {
      const parts = chromeRegex.exec(line);
      if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0;
        if (isEval) {
          const subMatch = chromeEvalRegex.exec(parts[2]);
          if (subMatch) {
            parts[2] = subMatch[1];
            parts[3] = subMatch[2];
            parts[4] = subMatch[3];
          }
        }
        const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);
        return createFrame(filename, func, parts[3] ? +parts[3] : void 0, parts[4] ? +parts[4] : void 0);
      }
      return;
    };
    chromeStackLineParser = [CHROME_PRIORITY, chrome2];
    geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
    geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
    gecko = (line) => {
      const parts = geckoREgex.exec(line);
      if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
          const subMatch = geckoEvalRegex.exec(parts[3]);
          if (subMatch) {
            parts[1] = parts[1] || "eval";
            parts[3] = subMatch[1];
            parts[4] = subMatch[2];
            parts[5] = "";
          }
        }
        let filename = parts[3];
        let func = parts[1] || UNKNOWN_FUNCTION;
        [func, filename] = extractSafariExtensionDetails(func, filename);
        return createFrame(filename, func, parts[4] ? +parts[4] : void 0, parts[5] ? +parts[5] : void 0);
      }
      return;
    };
    geckoStackLineParser = [GECKO_PRIORITY, gecko];
    winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
    winjs = (line) => {
      const parts = winjsRegex.exec(line);
      return parts ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : void 0) : void 0;
    };
    winjsStackLineParser = [WINJS_PRIORITY, winjs];
    defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];
    defaultStackParser = createStackParser(...defaultStackLineParsers);
    extractSafariExtensionDetails = (func, filename) => {
      const isSafariExtension = func.indexOf("safari-extension") !== -1;
      const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
      return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
      ] : [func, filename];
    };
  }
});

// node_modules/@sentry/browser/esm/transports/utils.js
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }
  if (isNativeFetch(WINDOW6.fetch)) {
    return cachedFetchImpl = WINDOW6.fetch.bind(WINDOW6);
  }
  const document2 = WINDOW6.document;
  let fetchImpl = WINDOW6.fetch;
  if (document2 && typeof document2.createElement === "function") {
    try {
      const sandbox = document2.createElement("iframe");
      sandbox.hidden = true;
      document2.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document2.head.removeChild(sandbox);
    } catch (e) {
    }
  }
  return cachedFetchImpl = fetchImpl.bind(WINDOW6);
}
function clearCachedFetchImplementation() {
  cachedFetchImpl = void 0;
}
var cachedFetchImpl;
var init_utils2 = __esm({
  "node_modules/@sentry/browser/esm/transports/utils.js"() {
    init_esm();
    init_helpers();
    cachedFetchImpl = void 0;
  }
});

// node_modules/@sentry/browser/esm/transports/fetch.js
function makeFetchTransport(options, nativeFetch = getNativeFetchImplementation()) {
  let pendingBodySize = 0;
  let pendingCount = 0;
  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;
    const requestOptions = {
      body: request.body,
      method: "POST",
      referrerPolicy: "origin",
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 6e4 && pendingCount < 15,
      ...options.fetchOptions
    };
    try {
      return nativeFetch(options.url, requestOptions).then((response2) => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response2.status,
          headers: {
            "x-sentry-rate-limits": response2.headers.get("X-Sentry-Rate-Limits"),
            "retry-after": response2.headers.get("Retry-After")
          }
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return rejectedSyncPromise(e);
    }
  }
  return createTransport(options, makeRequest);
}
var init_fetch = __esm({
  "node_modules/@sentry/browser/esm/transports/fetch.js"() {
    init_esm2();
    init_esm();
    init_utils2();
  }
});

// internal/src/util/sentry.tsx
import React2 from "react";
var SENTRY_COMMANDBAR_DSN, envsToReportSentry, sentryHubFactory, initSentryAndAddToSdk, getSentry, startSentryTransaction, SentryErrorBoundary;
var init_sentry = __esm({
  "internal/src/util/sentry.tsx"() {
    "use strict";
    init_esm2();
    init_client();
    init_stack_parsers();
    init_fetch();
    init_integrations();
    init_proxy();
    init_symbols();
    init_network();
    SENTRY_COMMANDBAR_DSN = "https://28f1bf69de3e02797eb88c9715ade4d1@o13027.ingest.us.sentry.io/4508255164039168";
    envsToReportSentry = ["dev", "labs", "prod"];
    sentryHubFactory = (dsn) => {
      try {
        const isProd = true;
        const environment = "prod";
        const release = "local";
        const enabled = envsToReportSentry.includes(environment) || false;
        const config2 = {
          dsn: enabled ? dsn : "",
          tunnel: `${getBaseURL()}/e/`,
          environment,
          release,
          attachStacktrace: true,
          autoSessionTracking: true,
          debug: !isProd,
          enabled,
          normalizeDepth: 6,
          beforeSend(event) {
            var _a2, _b2;
            const airgap = (_b2 = (_a2 = getProxySDK()) == null ? void 0 : _a2[_configuration]) == null ? void 0 : _b2.airgap;
            return airgap ? null : event;
          },
          transport: makeFetchTransport,
          stackParser: defaultStackParser,
          integrations: [new FunctionToString()],
          sampleRate: 1e-3,
          tracesSampler: (samplingContext) => {
            var _a2;
            if (environment === "labs" && true) {
              const transaction = samplingContext.transactionContext;
              if (((_a2 = transaction.tags) == null ? void 0 : _a2.section) === "nudges") {
                return 0.05;
              }
            }
            return 0;
          }
        };
        const client2 = new BrowserClient(config2);
        client2.setupIntegrations();
        return new Hub(client2);
      } catch (err) {
        console.error(err);
        return void 0;
      }
    };
    initSentryAndAddToSdk = () => {
      const sdk = getProxySDK();
      if (sdk[_sentry]) {
        return;
      }
      const sentry = sentryHubFactory(SENTRY_COMMANDBAR_DSN);
      if (sentry && "0.5.86") {
        sentry.setTag("foobar-version", "0.5.86");
      }
      if (sentry) {
        sdk[_sentry] = sentry;
      }
    };
    getSentry = () => {
      return getProxySDK()[_sentry];
    };
    startSentryTransaction = (...args) => {
      var _a2;
      return true ? (_a2 = getSentry()) == null ? void 0 : _a2.startTransaction(...args) : null;
    };
    SentryErrorBoundary = class extends React2.Component {
      constructor(props2) {
        super(props2);
        this.captureRejection = (ev) => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(ev.reason);
          ev.preventDefault();
        };
        this.state = { error: false };
      }
      static getDerivedStateFromError(_error) {
        return { error: true };
      }
      componentDidCatch(error3, errorInfo) {
        const sentry = getProxySDK()[_sentry];
        sentry == null ? void 0 : sentry.withScope((scope) => {
          scope.setContext("errorInfo", {
            componentStack: errorInfo.componentStack
          });
          sentry.captureException(error3);
        });
      }
      render() {
        if (this.state.error) {
          return /* @__PURE__ */ React2.createElement("div", { "data-testid": "commandbar-fatal-error" });
        }
        return this.props.children;
      }
    };
  }
});

// commandbar/src/shared/services/end-users/identify.ts
var identify;
var init_identify = __esm({
  "commandbar/src/shared/services/end-users/identify.ts"() {
    "use strict";
    init_Logger();
    init_network();
    init_generics();
    init_endUser();
    init_sentry();
    identify = async (orgId, distinctId, options, hmac) => {
      var _a2;
      if (options.properties) {
        const unsupportedReservedKeys = ["$set", "$set_once", "$unset", "$delete", "$append", "$remove", "$union", "$add"];
        for (const key of unsupportedReservedKeys) {
          if (key in options.properties) {
            Logger_default.warn(`Reserved property key '${key}' was used in identify. This is not supported yet.`);
          }
        }
      }
      try {
        const body = {
          organization_id: orgId,
          distinct_id: distinctId,
          properties: options.properties
        };
        const headers = {};
        if (hmac) {
          headers["X-USER-AUTHORIZATION"] = hmac;
        }
        const res = await post(`/t/identify/`, body, {
          headers,
          credentials: "omit"
        });
        const { data } = res;
        return await decodeToPromise(EndUserV, data);
      } catch (error3) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
        return null;
      }
    };
  }
});

// internal/src/util/operatingSystem.tsx
var EDITOR_MOBILE_PREVIEW_SCREEN_HEIGHT, EDITOR_MOBILE_PREVIEW_SCREEN_WIDTH, isTouchDevice, isMobileDevice, getDeviceType, getBrowser, getOperatingSystem, getTriggerKey, osControlKey;
var init_operatingSystem = __esm({
  "internal/src/util/operatingSystem.tsx"() {
    "use strict";
    EDITOR_MOBILE_PREVIEW_SCREEN_HEIGHT = 932;
    EDITOR_MOBILE_PREVIEW_SCREEN_WIDTH = 430;
    isTouchDevice = () => window.matchMedia("(pointer: coarse)").matches;
    isMobileDevice = () => {
      if (/Android|webOS|iPhone|iPad|iPod|Mobile Safari|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true;
      }
      return false;
    };
    getDeviceType = () => {
      if (isMobileDevice()) {
        return "mobile";
      }
      return "desktop";
    };
    getBrowser = () => {
      var _a2;
      const userAgent = navigator.userAgent;
      if (!!((_a2 = navigator.brave) == null ? void 0 : _a2.isBrave)) {
        return "brave";
      } else if (getComputedStyle(document.documentElement).getPropertyValue("--arc-palette-background")) {
        return "arc";
      } else if (userAgent.match(/msie/i)) {
        return "ie10";
      } else if (userAgent.match(/trident/i)) {
        return "ie11";
      } else if (userAgent.match(/edg/i)) {
        return "edge";
      } else if (userAgent.match(/opr\//i)) {
        return "opera";
      } else if (userAgent.match(/chrome|chromium|crios/i)) {
        return "chrome";
      } else if (userAgent.match(/firefox|fxios/i)) {
        return "firefox";
      } else if (userAgent.match(/safari/i)) {
        return "safari";
      }
      return null;
    };
    getOperatingSystem = () => {
      const userAgent = window.navigator.userAgent;
      const platform = window.navigator.platform;
      const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
      const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
      const iosPlatforms = ["iPhone", "iPad", "iPod"];
      let os2 = "mac";
      if (macosPlatforms.indexOf(platform) !== -1) {
        os2 = "mac";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os2 = "ios";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os2 = "windows";
      } else if (/Android/.test(userAgent)) {
        os2 = "android";
      } else if (/Linux/.test(platform)) {
        os2 = "linux";
      }
      return os2;
    };
    getTriggerKey = (event) => {
      if (["windows", "android", "linux"].includes(getOperatingSystem())) {
        return event.ctrlKey;
      } else {
        return event.metaKey;
      }
    };
    osControlKey = (suffix) => {
      if (["windows", "android", "linux"].includes(getOperatingSystem())) {
        if (!!suffix) {
          return `Ctrl+${suffix}`;
        }
        return "Ctrl";
      } else {
        if (!!suffix) {
          return `\u2318${suffix}`;
        }
        return "\u2318";
      }
    };
  }
});

// internal/src/client/globals.tsx
function getSDK() {
  return window._CommandBarTmpQueueProcessing || window.CommandBar;
}
var SDK_INTERNAL_PREFIX;
var init_globals = __esm({
  "internal/src/client/globals.tsx"() {
    "use strict";
    SDK_INTERNAL_PREFIX = "__commandbar_INTERNAL_";
  }
});

// internal/src/middleware/helpers/optionGroup.tsx
import * as t14 from "io-ts";
var OptionGroupRenderAsV;
var init_optionGroup = __esm({
  "internal/src/middleware/helpers/optionGroup.tsx"() {
    "use strict";
    OptionGroupRenderAsV = t14.union([t14.literal("list"), t14.literal("grid")]);
  }
});

// internal/src/middleware/tab.tsx
import * as t15 from "io-ts";
var TabV, defaults2, Tab;
var init_tab = __esm({
  "internal/src/middleware/tab.tsx"() {
    "use strict";
    init_generics();
    init_optionGroup();
    TabV = t15.type(
      {
        id: t15.number,
        organization: t15.union([t15.number, t15.string]),
        category_ids: t15.array(t15.number),
        sort_key: t15.number,
        icon: t15.union([t15.string, t15.null]),
        label: t15.string,
        header: t15.union([t15.string, t15.null]),
        description: t15.string,
        placeholder: t15.union([t15.string, t15.null]),
        render_as: OptionGroupRenderAsV
      },
      "Tab"
    );
    defaults2 = {};
    Tab = class {
    };
    Tab.decode = (data) => decodeThrowing(TabV, { ...defaults2, ...data });
  }
});

// internal/src/middleware/commandCategory.tsx
import * as t16 from "io-ts";
var CommandCategoryBaseV, CommandCategoryAdditionalV, defaults3, CommandCategoryConfigAdditionalV, CommandCategoryV, BatchEditorCategoryResponseV, CommandCategory;
var init_commandCategory = __esm({
  "internal/src/middleware/commandCategory.tsx"() {
    "use strict";
    init_generics();
    init_network();
    init_optionGroup();
    CommandCategoryBaseV = t16.intersection(
      [
        t16.type({
          id: t16.number,
          organization: t16.union([t16.number, t16.string]),
          name: t16.string
        }),
        t16.partial({})
      ],
      "CommandCategoryBase"
    );
    CommandCategoryAdditionalV = t16.type(
      {
        sort_key: t16.union([t16.number, t16.null]),
        icon: t16.union([t16.string, t16.null]),
        icon_color: t16.union([t16.string, t16.null]),
        image_color: t16.union([t16.string, t16.null]),
        image: t16.union([t16.string, t16.null]),
        render_as: OptionGroupRenderAsV,
        setting_hide_before_search: t16.boolean,
        setting_max_options_count: t16.union([t16.number, t16.null]),
        setting_pin_to_bottom: t16.boolean,
        search_tab_enabled: t16.boolean,
        search_tab_name: t16.string,
        slash_filter_enabled: t16.boolean,
        slash_filter_keyword: t16.union([t16.string, t16.null]),
        search_tab_instruction: t16.string,
        track_recents: t16.boolean
      },
      "CommandCategoryAdditional"
    );
    defaults3 = {
      sort_key: null,
      icon: null,
      icon_color: null,
      image_color: null,
      image: null,
      render_as: "list",
      setting_hide_before_search: false,
      setting_max_options_count: null,
      setting_pin_to_bottom: false,
      search_tab_enabled: false,
      search_tab_name: "",
      slash_filter_enabled: true,
      slash_filter_keyword: null,
      search_tab_instruction: "",
      track_recents: false
    };
    CommandCategoryConfigAdditionalV = t16.partial({
      contains_hotloaded_commands: t16.boolean
    });
    CommandCategoryV = t16.intersection(
      [CommandCategoryBaseV, CommandCategoryAdditionalV, CommandCategoryConfigAdditionalV],
      "CommandCategory"
    );
    BatchEditorCategoryResponseV = t16.type({
      batch: t16.array(CommandCategoryV)
    });
    CommandCategory = class {
    };
    CommandCategory.create = createObject(CommandCategoryV, CommandCategoryV, "categories");
    CommandCategory.update = updateObject(CommandCategoryV, CommandCategoryV, "categories");
    CommandCategory.delete = deleteObject(CommandCategoryV, "categories");
    CommandCategory.decode = (data) => decodeThrowing(CommandCategoryV, { ...defaults3, ...data });
    CommandCategory.batch = async (request) => {
      const result = await post("categories/batch/", request);
      return await decodeToPromise(BatchEditorCategoryResponseV, result.data);
    };
  }
});

// types/src/decode.ts
import { pipe as pipe2 } from "fp-ts/function";
import { fold as fold2 } from "fp-ts/Either";
import { PathReporter as reporter2 } from "io-ts/PathReporter";
function decodeThrowing2(validator, input) {
  const result = validator.decode(input);
  return pipe2(
    result,
    fold2(
      (_errors) => {
        const messages = reporter2.report(result);
        const _payload = {
          error: `io-ts error -> ${messages.join("; ").toString()}`,
          errorDetail: JSON.stringify(input),
          url: window.location.href
        };
        throw new Error(`${messages.join("\n")}
when parsing ${JSON.stringify(input, null, 2)}`);
      },
      (value) => value
    )
  );
}
function decodeToPromise2(validator, input) {
  const result = validator.decode(input);
  return pipe2(
    result,
    fold2(
      (_errors) => {
        const messages = reporter2.report(result);
        const _payload = {
          error: `io-ts error -> ${messages.join("; ").toString()}`,
          errorDetail: JSON.stringify(input),
          url: window.location.href
        };
        return Promise.reject(new Error(messages.join("\n")));
      },
      (value) => {
        return Promise.resolve(value);
      }
    )
  );
}
var init_decode = __esm({
  "types/src/decode.ts"() {
    "use strict";
  }
});

// internal/src/middleware/RecordSettingsV.ts
import * as t17 from "io-ts";
var SearchFieldConfigV, RecordSettingsV, RecordSettingsByContextKeyV;
var init_RecordSettingsV = __esm({
  "internal/src/middleware/RecordSettingsV.ts"() {
    "use strict";
    init_detailPreview();
    init_optionGroup();
    SearchFieldConfigV = t17.type({
      key: t17.string,
      label: t17.string
    });
    RecordSettingsV = t17.partial({
      name: t17.string,
      search: t17.boolean,
      label_field: t17.string,
      useCategory: t17.boolean,
      search_fields: t17.array(t17.union([t17.string, SearchFieldConfigV])),
      auto_execute: t17.boolean,
      unfurl: t17.boolean,
      description_field: t17.string,
      icon: t17.string,
      icon_color: t17.string,
      image_color: t17.string,
      image: t17.string,
      sort_key: t17.number,
      max_options_count: t17.union([t17.number, t17.null]),
      sortFunction: t17.any,
      onInputChangeOptions: t17.partial({
        applySort: t17.boolean
      }),
      default_command_id: t17.union([t17.number, t17.string, t17.undefined]),
      render_as: OptionGroupRenderAsV,
      showResources: t17.boolean,
      show_with_no_results: t17.boolean,
      search_tab_enabled: t17.boolean,
      search_tab_name: t17.union([t17.string, t17.null]),
      slash_filter_enabled: t17.boolean,
      slash_filter_keyword: t17.union([t17.string, t17.null]),
      search_tab_instruction: t17.union([t17.string, t17.null]),
      setting_pin_to_bottom: t17.boolean,
      track_recents: t17.boolean,
      detail: t17.union([t17.null, t17.string, DetailPreviewObjectV, t17.array(t17.union([t17.string, DetailPreviewObjectV]))]),
      content: t17.union([t17.null, t17.string, DetailPreviewObjectV, t17.array(t17.union([t17.string, DetailPreviewObjectV]))]),
      show_preview: t17.boolean
    });
    RecordSettingsByContextKeyV = t17.record(t17.string, RecordSettingsV);
  }
});

// internal/src/middleware/helpHub.tsx
import * as t18 from "io-ts";
var HelpHubSearchActionsV, HelpHubLauncherPositionsV, HelpHubLauncherTypesV, HelpHubLauncherSettingsV, getHelpHubLauncherSettingKeys, getHelpHubLauncherSettings;
var init_helpHub = __esm({
  "internal/src/middleware/helpHub.tsx"() {
    "use strict";
    HelpHubSearchActionsV = t18.union([t18.literal("search"), t18.literal("ask")]);
    HelpHubLauncherPositionsV = t18.union([
      t18.literal("topRight"),
      t18.literal("topLeft"),
      t18.literal("bottomRight"),
      t18.literal("bottomLeft")
    ]);
    HelpHubLauncherTypesV = t18.union([
      t18.literal("bookOpen"),
      t18.literal("graduationHat"),
      t18.literal("bookClosed"),
      t18.literal("bookmark"),
      t18.literal("chatCircle"),
      t18.literal("askAI"),
      t18.literal("custom"),
      t18.literal("none")
    ]);
    HelpHubLauncherSettingsV = t18.type({
      helphub_launcher_offset_x: t18.number,
      helphub_launcher_offset_y: t18.number,
      helphub_launcher_anchor: t18.string,
      helphub_launcher_position: HelpHubLauncherPositionsV,
      helphub_launcher_type: HelpHubLauncherTypesV,
      helphub_mobile_launcher_offset_x: t18.number,
      helphub_mobile_launcher_offset_y: t18.number,
      helphub_mobile_launcher_anchor: t18.string,
      helphub_mobile_launcher_position: HelpHubLauncherPositionsV,
      helphub_mobile_launcher_type: HelpHubLauncherTypesV
    });
    getHelpHubLauncherSettingKeys = (deviceType) => {
      if (deviceType === "mobile") {
        return {
          type: "helphub_mobile_launcher_type",
          anchor: "helphub_mobile_launcher_anchor",
          position: "helphub_mobile_launcher_position",
          offsetX: "helphub_mobile_launcher_offset_x",
          offsetY: "helphub_mobile_launcher_offset_y"
        };
      }
      return {
        type: "helphub_launcher_type",
        anchor: "helphub_launcher_anchor",
        position: "helphub_launcher_position",
        offsetX: "helphub_launcher_offset_x",
        offsetY: "helphub_launcher_offset_y"
      };
    };
    getHelpHubLauncherSettings = (deviceType, organization) => {
      const settingsKeys = getHelpHubLauncherSettingKeys(deviceType);
      return {
        type: organization[settingsKeys.type],
        anchor: organization[settingsKeys.anchor],
        position: organization[settingsKeys.position],
        offsetX: organization[settingsKeys.offsetX],
        offsetY: organization[settingsKeys.offsetY]
      };
    };
  }
});

// internal/src/middleware/theme.tsx
import * as t19 from "io-ts";
var ThemeModeV, ThemeV2V, ThemeV, ThemePatchV, ThemeSlugReponseV;
var init_theme = __esm({
  "internal/src/middleware/theme.tsx"() {
    "use strict";
    ThemeModeV = t19.type({
      var_defaults: t19.record(t19.string, t19.union([t19.string, t19.number])),
      var_overrides: t19.record(t19.string, t19.union([t19.string, t19.number])),
      component_overrides: t19.record(t19.string, t19.any),
      mobile_overrides: t19.record(t19.string, t19.any)
    });
    ThemeV2V = t19.union([
      t19.type({
        light_mode: ThemeModeV,
        dark_mode: ThemeModeV
      }),
      t19.null,
      t19.undefined
    ]);
    ThemeV = t19.type(
      {
        id: t19.string,
        uuid: t19.union([t19.string, t19.null, t19.undefined]),
        slug: t19.string,
        name: t19.string,
        default: t19.boolean,
        themeV2: ThemeV2V,
        themeV2_draft: ThemeV2V,
        organization: t19.string,
        archived: t19.boolean
      },
      "Theme"
    );
    ThemePatchV = t19.partial({
      id: t19.string,
      slug: t19.string,
      name: t19.string,
      default: t19.boolean,
      themeV2: ThemeV2V,
      themeV2_draft: ThemeV2V,
      organization: t19.string,
      archived: t19.boolean
    });
    ThemeSlugReponseV = t19.type({
      slug: t19.string
    });
  }
});

// internal/src/middleware/helpers/copilotPersonality.tsx
import * as t20 from "io-ts";
var CopilotPersonalityTemplateV, CopilotPersonalityAdjectiveV, CopilotPersonalityResponseLengthV, CopilotPersonalityResponseFormatV, CopilotPersonalityCustomV, CopilotPersonalityV;
var init_copilotPersonality = __esm({
  "internal/src/middleware/helpers/copilotPersonality.tsx"() {
    "use strict";
    CopilotPersonalityTemplateV = t20.type({
      template: t20.union([
        t20.literal("professional"),
        t20.literal("friendly"),
        t20.literal("confident"),
        t20.literal("serious"),
        t20.literal("empathetic")
      ])
    });
    CopilotPersonalityAdjectiveV = t20.union([
      t20.literal("abrasive"),
      t20.literal("adventurous"),
      t20.literal("affable"),
      t20.literal("arrogant"),
      t20.literal("assertive"),
      t20.literal("assured"),
      t20.literal("belligerent"),
      t20.literal("brave"),
      t20.literal("cheerful"),
      t20.literal("compassionate"),
      t20.literal("condescending"),
      t20.literal("courteous"),
      t20.literal("creative"),
      t20.literal("cynical"),
      t20.literal("decisive"),
      t20.literal("detached"),
      t20.literal("diligent"),
      t20.literal("eloquent"),
      t20.literal("empathetic"),
      t20.literal("evasive"),
      t20.literal("formal"),
      t20.literal("frivolous"),
      t20.literal("garrulous"),
      t20.literal("generous"),
      t20.literal("impulsive"),
      t20.literal("innovative"),
      t20.literal("intense"),
      t20.literal("judgmental"),
      t20.literal("jovial"),
      t20.literal("manipulative"),
      t20.literal("obstinate"),
      t20.literal("optimistic"),
      t20.literal("perceptive"),
      t20.literal("pessimistic"),
      t20.literal("quarrelsome"),
      t20.literal("respectful"),
      t20.literal("resourceful"),
      t20.literal("sarcastic"),
      t20.literal("sincere"),
      t20.literal("sociable"),
      t20.literal("solemn"),
      t20.literal("supportive"),
      t20.literal("tactful"),
      t20.literal("thoughtful"),
      t20.literal("understanding"),
      t20.literal("unreliable"),
      t20.literal("vain"),
      t20.literal("vivacious"),
      t20.literal("warm"),
      t20.literal("withdrawn"),
      t20.literal("witty"),
      t20.literal("zealous")
    ]);
    CopilotPersonalityResponseLengthV = t20.union([
      t20.literal("short"),
      t20.literal("conversational"),
      t20.literal("long")
    ]);
    CopilotPersonalityResponseFormatV = t20.union([
      t20.literal("lists"),
      t20.literal("paragraphs"),
      t20.literal("mixed")
    ]);
    CopilotPersonalityCustomV = t20.type({
      template: t20.literal("custom"),
      adjectives: t20.array(CopilotPersonalityAdjectiveV),
      response_length: CopilotPersonalityResponseLengthV,
      response_format: CopilotPersonalityResponseFormatV
    });
    CopilotPersonalityV = t20.union([CopilotPersonalityTemplateV, CopilotPersonalityCustomV]);
  }
});

// internal/src/middleware/OrganizationV.ts
import * as t21 from "io-ts";
var OrganizationBaseV, OrganizationAdditionalV, defaults4, OrganizationV, unknownOrganization;
var init_OrganizationV = __esm({
  "internal/src/middleware/OrganizationV.ts"() {
    "use strict";
    init_RecordSettingsV();
    init_actions();
    init_helpHub();
    init_theme();
    init_copilotPersonality();
    init_audience();
    OrganizationBaseV = t21.intersection(
      [
        t21.type({
          id: t21.union([t21.number, t21.string]),
          name: t21.string,
          created: t21.string
        }),
        t21.partial({})
      ],
      "OrganizationBase"
    );
    OrganizationAdditionalV = t21.intersection([
      t21.type({
        disabled: t21.boolean,
        launcher_type: t21.union([t21.literal("minimal"), t21.literal("alternate"), t21.literal("prompt"), t21.literal("none")]),
        launcher_position: t21.union([
          t21.literal("topRight"),
          t21.literal("topLeft"),
          t21.literal("bottomRight"),
          t21.literal("bottomLeft")
        ]),
        show_launcher_recommendations: t21.boolean,
        recommendations_type: t21.union([t21.literal("None"), t21.literal("Custom"), t21.literal("Algorithm"), t21.undefined]),
        // DEPRECATED
        launcher_offset_x: t21.number,
        launcher_offset_y: t21.number,
        base_url: t21.string,
        theme: t21.object,
        themeV2: ThemeV2V,
        icon: t21.string,
        icon_suggest: t21.string,
        icon_tutorial: t21.string,
        icon_go_forward: t21.string,
        logo_spotlight: t21.union([t21.string, t21.null]),
        chat_system_prompt_modifier: t21.string,
        helphub_chat_welcome_message: t21.string,
        helphub_chat_avatar: t21.string,
        resource_options: RecordSettingsByContextKeyV,
        should_show_onboarding: t21.boolean,
        last_snippet_request: t21.union([t21.string, t21.null]),
        last_snippet_request_in_production: t21.union([t21.string, t21.null]),
        branding: t21.string,
        custom_call_to_action: t21.string,
        // DEPRECATED
        search_fuzzy_threshold: t21.union([t21.number, t21.null]),
        show_skin_editor: t21.boolean,
        allow_event_handlers: t21.boolean,
        in_bar_feedback: t21.boolean,
        summon_hotkey_override: t21.union([t21.string, t21.null]),
        end_user_hotkeys: t21.union([t21.undefined, t21.boolean]),
        force_end_user_identity_verification: t21.boolean,
        /* @deprecated */
        force_end_user_identity_verification_for_helphub: t21.boolean,
        end_user_shortcuts_enabled: t21.boolean,
        end_user_recents_enabled: t21.boolean,
        releases_available: t21.boolean,
        releases_enabled: t21.boolean,
        fallback_commands: t21.array(t21.number),
        event_attribute_block_list: t21.array(t21.string),
        tab_direction: t21.union([t21.literal("horizontal"), t21.literal("vertical")]),
        recommended_tab_enabled: t21.boolean,
        recents_tab_enabled: t21.boolean,
        recommended_tab_instruction: t21.string,
        recents_tab_instruction: t21.string,
        hotload_help_docs: t21.boolean,
        slash_filters_enabled: t21.boolean,
        recents_sort_key: t21.union([t21.number, t21.null]),
        recommended_sort_key: t21.union([t21.number, t21.null]),
        experiences_sort_key: t21.union([t21.number, t21.null]),
        show_suggested_synonyms: t21.boolean,
        has_hotloaded_help_docs: t21.boolean,
        bar_enabled: t21.boolean,
        in_bar_doc_search: t21.boolean,
        featured_item_cards: t21.boolean,
        helphub_suggested_queries_enabled: t21.boolean,
        helphub_continuations_enabled: t21.boolean,
        helphub_enabled: t21.boolean,
        helphub_chat_fallback_message: t21.union([t21.string, t21.null]),
        helphub_chat_fallback_actions: t21.array(LabeledActionV),
        helphub_search_action: HelpHubSearchActionsV,
        helphub_custom_theme: t21.union([t21.string, t21.null]),
        product_tours_custom_theme: t21.union([t21.string, t21.null]),
        announcements_custom_theme: t21.union([t21.string, t21.null]),
        surveys_custom_theme: t21.union([t21.string, t21.null]),
        checklists_custom_theme: t21.union([t21.string, t21.null]),
        copilot_chat_history_enabled: t21.boolean,
        copilot_negative_feedback_fallback_enabled: t21.boolean,
        copilot_negative_feedback_fallback_message: t21.union([t21.string, t21.null]),
        copilot_negative_feedback_fallback_actions: t21.array(LabeledActionV),
        copilot_expand_read_more_by_default: t21.boolean,
        helphub_manual_suggested_queries: t21.array(t21.string),
        copilot_name: t21.string,
        copilot_avatar: t21.string,
        copilot_avatar_v2: t21.union([t21.type({ src: t21.string, file_name: t21.string, size: t21.string }), t21.null]),
        copilot_personality: CopilotPersonalityV,
        nudge_rate_limit: t21.union([t21.null, t21.number]),
        bar_hide_completed_nudges_questlists: t21.boolean,
        nudge_rate_period: t21.union([t21.literal("day"), t21.literal("week"), t21.literal("session")]),
        share_link_param: t21.string,
        installed_at: t21.union([t21.string, t21.null]),
        integrations: t21.partial({
          algolia: t21.type({
            indexes: t21.record(t21.string, t21.union([t21.string, t21.record(t21.string, t21.string)])),
            applicationID: t21.union([t21.string, t21.undefined]),
            apiKey: t21.union([t21.string, t21.undefined])
          }),
          heap: t21.type({
            segments: t21.record(t21.string, t21.string),
            send_events_to_heap: t21.boolean
          }),
          amplitude: t21.intersection([
            t21.type({
              enabled: t21.boolean
            }),
            t21.partial({
              cohorts: t21.record(t21.string, t21.string),
              api_key: t21.string
            })
          ]),
          logrocket: t21.type({
            enabled: t21.boolean
          }),
          mixpanel: t21.type({
            enabled: t21.boolean
          }),
          posthog: t21.type({
            enabled: t21.boolean
          }),
          rudderstack: t21.type({
            enabled: t21.boolean
          }),
          slack: t21.type({
            channelId: t21.string,
            configuration: t21.type({
              analytic_events: t21.array(t21.string)
            })
          }),
          hubspot: t21.partial({
            send_events_to_hubspot: t21.boolean,
            lists: t21.record(t21.string, t21.string)
          }),
          sunshine: t21.partial({
            enabled: t21.boolean,
            app_id: t21.string,
            key_id: t21.string,
            secret_key: t21.string,
            integration_id: t21.string,
            webhook_shared_secret: t21.string,
            switchboard_id: t21.string
          }),
          freshchat: t21.partial({
            topic_name: t21.union([t21.string, t21.null]),
            conversation_property_name: t21.union([t21.string, t21.null])
          }),
          intercom: t21.partial({
            enabled: t21.boolean,
            token: t21.string
          }),
          sfdc_chat: t21.type({
            enabled: t21.boolean
          }),
          sfdc_messaging: t21.type({
            enabled: t21.boolean
          })
        }),
        copilot_enabled: t21.boolean,
        user_property_targeting: t21.boolean,
        ab_test_conditions: t21.boolean,
        spotlight_ask_copilot_enabled: t21.boolean,
        spotlight_ask_copilot_label: t21.union([t21.string, t21.null]),
        spotlight_custom_theme: t21.union([t21.string, t21.null]),
        spotlight_ask_copilot_audience: t21.union([AudienceV, t21.null]),
        themes_v2_self_serve_migration_date: t21.union([t21.null, t21.string]),
        /** @deprecated Replaced by the `copilot_enabled` field */
        helphub_ai_enabled: t21.boolean,
        /** @deprecated Removed entirely */
        copilot_experiences_enabled: t21.boolean,
        /** @deprecated Replaced by a combination of `copilot_enabled` and `helphub_enabled` */
        helphub_chat_only_mode: t21.boolean
      }),
      HelpHubLauncherSettingsV
    ]);
    defaults4 = {
      allow_event_handlers: true,
      branding: "",
      base_url: "",
      custom_call_to_action: "",
      disabled: false,
      icon: "iconic",
      icon_suggest: "",
      icon_tutorial: "",
      icon_go_forward: "",
      logo_spotlight: null,
      chat_system_prompt_modifier: "",
      helphub_chat_welcome_message: "",
      helphub_chat_avatar: "",
      in_bar_feedback: false,
      summon_hotkey_override: null,
      last_snippet_request: "",
      last_snippet_request_in_production: "",
      launcher_offset_x: 0,
      launcher_offset_y: 0,
      launcher_position: "bottomRight",
      helphub_launcher_offset_x: 0,
      helphub_launcher_offset_y: 60,
      helphub_launcher_anchor: "",
      helphub_launcher_position: "bottomRight",
      helphub_launcher_type: "none",
      helphub_mobile_launcher_offset_x: 0,
      helphub_mobile_launcher_offset_y: 60,
      helphub_mobile_launcher_anchor: "",
      helphub_mobile_launcher_position: "bottomRight",
      helphub_mobile_launcher_type: "none",
      launcher_type: "minimal",
      recommendations_type: void 0,
      resource_options: {},
      search_fuzzy_threshold: null,
      should_show_onboarding: false,
      show_launcher_recommendations: false,
      show_skin_editor: false,
      theme: {},
      themeV2: null,
      end_user_hotkeys: false,
      end_user_shortcuts_enabled: false,
      end_user_recents_enabled: false,
      force_end_user_identity_verification: false,
      force_end_user_identity_verification_for_helphub: false,
      releases_available: false,
      releases_enabled: false,
      fallback_commands: [],
      event_attribute_block_list: [],
      tab_direction: "horizontal",
      recommended_tab_enabled: false,
      recents_tab_enabled: false,
      recommended_tab_instruction: "",
      recents_tab_instruction: "",
      hotload_help_docs: false,
      slash_filters_enabled: true,
      recents_sort_key: null,
      recommended_sort_key: null,
      experiences_sort_key: null,
      show_suggested_synonyms: false,
      has_hotloaded_help_docs: false,
      bar_enabled: true,
      helphub_enabled: false,
      helphub_suggested_queries_enabled: false,
      helphub_continuations_enabled: false,
      helphub_chat_fallback_message: "",
      helphub_chat_fallback_actions: [],
      helphub_manual_suggested_queries: [],
      helphub_search_action: "search",
      copilot_name: "Copilot",
      copilot_avatar: "",
      copilot_avatar_v2: null,
      copilot_personality: { template: "professional" },
      copilot_chat_history_enabled: false,
      copilot_negative_feedback_fallback_enabled: false,
      copilot_negative_feedback_fallback_message: "",
      copilot_negative_feedback_fallback_actions: [],
      copilot_expand_read_more_by_default: false,
      nudge_rate_limit: null,
      bar_hide_completed_nudges_questlists: false,
      nudge_rate_period: "day",
      in_bar_doc_search: false,
      featured_item_cards: true,
      installed_at: null,
      integrations: {},
      copilot_enabled: false,
      share_link_param: "cb-eid",
      user_property_targeting: false,
      ab_test_conditions: false,
      spotlight_ask_copilot_enabled: true,
      spotlight_ask_copilot_label: null,
      helphub_custom_theme: null,
      product_tours_custom_theme: null,
      announcements_custom_theme: null,
      surveys_custom_theme: null,
      checklists_custom_theme: null,
      spotlight_custom_theme: null,
      spotlight_ask_copilot_audience: null,
      themes_v2_self_serve_migration_date: null,
      /** @deprecated Replaced by the `copilot_enabled` field */
      helphub_ai_enabled: false,
      /** @deprecated Removed entirely */
      copilot_experiences_enabled: false,
      /** @deprecated Replaced by a combination of `copilot_enabled` and `helphub_enabled` */
      helphub_chat_only_mode: false
    };
    OrganizationV = t21.intersection([OrganizationBaseV, OrganizationAdditionalV], "Organization");
    unknownOrganization = {
      id: "42424242",
      name: "Unknown",
      created: "",
      ...defaults4
    };
  }
});

// internal/src/middleware/placeholder.tsx
import * as t22 from "io-ts";
var PlaceholderV, Placeholder;
var init_placeholder = __esm({
  "internal/src/middleware/placeholder.tsx"() {
    "use strict";
    init_generics();
    PlaceholderV = t22.intersection(
      [
        t22.type({
          id: t22.number,
          organization: t22.string,
          slug: t22.string,
          text: t22.string
        }),
        t22.partial({})
      ],
      "Placeholder"
    );
    Placeholder = class {
    };
    Placeholder.create = createObject(PlaceholderV, PlaceholderV, "placeholders");
    Placeholder.update = updateObject(PlaceholderV, PlaceholderV, "placeholders");
    Placeholder.delete = deleteObject(PlaceholderV, "placeholders");
    Placeholder.list = listObject(PlaceholderV, "placeholders");
    Placeholder.read = readObject(PlaceholderV, "placeholders");
  }
});

// internal/src/middleware/organization.tsx
import * as t23 from "io-ts";
var OrganizationStatusV, KeyEventV, InternalSettingsV, read2, update3, getCommandByUrl, listPlaceholders, listRules, readHealth, readInternal, updateInternal, decode2;
var init_organization = __esm({
  "internal/src/middleware/organization.tsx"() {
    "use strict";
    init_decode();
    init_generics();
    init_OrganizationV();
    init_placeholder();
    init_rules();
    init_command();
    init_network();
    init_OrganizationV();
    OrganizationStatusV = t23.type({
      id: t23.union([t23.number, t23.string]),
      uuid: t23.string,
      errors_72h: t23.number,
      suggestions_72h: t23.number,
      executions_total: t23.number,
      users_total: t23.number
    });
    KeyEventV = t23.union([
      t23.literal("Client-Error"),
      t23.literal("Command execution"),
      t23.literal("Command suggestion"),
      t23.literal("Abandoned search"),
      t23.literal("Search miss")
    ]);
    InternalSettingsV = t23.type({
      id: t23.string,
      integrations: t23.record(t23.string, t23.record(t23.string, t23.any))
    });
    read2 = readObject(OrganizationV, "organizations");
    update3 = updateObject(OrganizationV, OrganizationV, "organizations");
    getCommandByUrl = async (orgUID, url) => {
      const result = await get2(`organizations/${orgUID}/commands/by_url/?url=${encodeURIComponent(url)}`);
      return await decodeToPromise2(CommandV, result.data);
    };
    listPlaceholders = (orgUID) => listObject(PlaceholderV, `organizations/${orgUID}/placeholders`)();
    listRules = (orgUID) => listObject(NamedRuleV, `organizations/${orgUID}/rules`)();
    readHealth = readObjectDetail(OrganizationStatusV, "organizations", "health");
    readInternal = readObjectDetail(InternalSettingsV, "organizations", "internal");
    updateInternal = updateObjectDetail(
      InternalSettingsV,
      InternalSettingsV,
      "organizations",
      "internal"
    );
    decode2 = (data) => decodeThrowing2(OrganizationV, { ...defaults4, ...data });
  }
});

// internal/src/middleware/environment.tsx
import * as t24 from "io-ts";
var EnvironmentV, defaults5, Environment;
var init_environment = __esm({
  "internal/src/middleware/environment.tsx"() {
    "use strict";
    init_generics();
    EnvironmentV = t24.type({
      env: t24.string,
      version: t24.union([t24.number, t24.string, t24.null, t24.undefined])
    });
    defaults5 = {};
    Environment = class {
    };
    Environment.decode = (data) => decodeThrowing(EnvironmentV, { ...defaults5, ...data });
  }
});

// internal/src/middleware/helpers/frequencyLimit.tsx
import * as t25 from "io-ts";
var FrequencyLimitV;
var init_frequencyLimit = __esm({
  "internal/src/middleware/helpers/frequencyLimit.tsx"() {
    "use strict";
    FrequencyLimitV = t25.union([
      t25.literal("no_limit"),
      t25.literal("once_per_session"),
      t25.literal("once_per_user"),
      t25.literal("until_interaction")
    ]);
  }
});

// internal/src/middleware/helpers/pushTrigger.tsx
import * as t26 from "io-ts";
var PushTriggerV, isNudge, generateTriggerableEntityId;
var init_pushTrigger = __esm({
  "internal/src/middleware/helpers/pushTrigger.tsx"() {
    "use strict";
    init_rules();
    PushTriggerV = t26.union([
      t26.type({ type: t26.literal("when_conditions_pass") }),
      /** DEPRECATED: no longer selectable as trigger type  */
      t26.type({ type: t26.literal("when_page_reached"), meta: t26.type({ url: t26.string }) }),
      t26.type({ type: t26.literal("on_command_execution"), meta: t26.type({ command: t26.string }) }),
      t26.type({
        type: t26.literal("on_event"),
        meta: t26.type({
          event: t26.string,
          condition_group: t26.union([RuleExpressionV, t26.null, t26.undefined])
        })
      }),
      t26.type({ type: t26.literal("when_element_appears"), meta: t26.type({ selector: t26.string }) }),
      t26.type({ type: t26.literal("on_user_confusion") }),
      t26.type({ type: t26.literal("on_rage_click") }),
      t26.type({ type: t26.literal("smart_delay") }),
      t26.type({
        type: t26.literal("after_time"),
        meta: t26.type({ unit: t26.union([t26.literal("minute"), t26.literal("second")]), value: t26.number })
      }),
      /**
       * Note: this trigger does not have to be set for share linking to work.
       * Rather, nudges/QLs with this trigger cannot be viewed unless it is via share link
       */
      t26.type({ type: t26.literal("when_share_link_viewed") }),
      t26.type({
        type: t26.literal("scheduled"),
        meta: t26.type({ interval: t26.union([t26.literal("day"), t26.literal("week"), t26.literal("month")]), value: t26.number })
      })
    ]);
    isNudge = (triggerable) => "frequency_limit" in triggerable;
    generateTriggerableEntityId = (triggerableEntity) => `${isNudge(triggerableEntity) ? "nudge" /* NUDGE */ : "checklist" /* CHECKLIST */}-${triggerableEntity.id}`;
  }
});

// internal/src/middleware/nudge.tsx
import * as t27 from "io-ts";
var NudgeContentMarkdownBlockV, NudgeContentImageBlockV, NudgeContentVideoBlockV, Required, SurveyValidation, NudgeContentListBlockV, NudgeContentHelpDocBlockV, NudgeButtonActionV, NudgeConditionalActionV, NudgeContentButtonBlockV, NudgeContentSurveyTextBlockV, NudgeStepContentSurveyTextShortBlockTypeV, NudgeContentSurveyRatingBlockV, NudgeContentBlockV, NudgeStepBaseV, NudgeStepLayoutV, ElementSelectorV, NudgeStepAdditionalV, stepDefaults, NudgeStepV, NudgeAdditionalV, defaults6, NudgeBaseV, NudgeV, OldNudgeBaseV, OldNudgeAdditionalV, OldNudgeV, NudgeResetResponse, Nudge;
var init_nudge = __esm({
  "internal/src/middleware/nudge.tsx"() {
    "use strict";
    init_actions();
    init_generics();
    init_audience();
    init_frequencyLimit();
    init_pushTrigger();
    init_rules();
    init_network();
    NudgeContentMarkdownBlockV = t27.type({
      type: t27.literal("markdown"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.type({ value: t27.string })
    });
    NudgeContentImageBlockV = t27.type({
      type: t27.literal("image"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.type({ src: t27.string, file_name: t27.string, size: t27.string })
    });
    NudgeContentVideoBlockV = t27.type({
      type: t27.literal("video"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.union([
        t27.type({ type: t27.literal("url"), src: t27.string }),
        t27.type({ type: t27.literal("command"), command: t27.string })
      ])
    });
    Required = t27.union([
      t27.type({
        value: t27.literal(true),
        message: t27.string
      }),
      t27.type({
        value: t27.literal(false),
        message: t27.null
      })
    ]);
    SurveyValidation = t27.partial({
      validation: t27.partial({
        required: Required
      })
    });
    NudgeContentListBlockV = t27.type({
      type: t27.literal("survey_list"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.intersection([
        t27.type({
          options: t27.array(t27.string),
          list_type: t27.union([t27.literal("single"), t27.literal("multiple")]),
          display_type: t27.union([t27.literal("dropdown"), t27.literal("list"), t27.literal("grid")])
        }),
        SurveyValidation
      ])
    });
    NudgeContentHelpDocBlockV = t27.type({
      type: t27.literal("help_doc_command"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.type({ command: t27.string })
    });
    NudgeButtonActionV = t27.union([
      CommandActionV,
      t27.type({ type: t27.literal("no_action") }),
      ClickActionNew,
      ClickAction,
      LinkAction,
      OpenChatActionV,
      ChatHandoffActionV,
      DismissAction,
      SnoozeAction,
      QuestlistActionV,
      StepBackAction,
      NudgeActionV,
      GoToNudgeStepActionV,
      OpenBarAction,
      OpenHelpHubAction,
      OpenCopilotAction
    ]);
    NudgeConditionalActionV = t27.type({
      operator: t27.union([t27.literal("eq"), t27.literal("neq"), t27.literal("gt"), t27.literal("lt")]),
      operand: t27.union([t27.string, t27.number]),
      action: NudgeButtonActionV
    });
    NudgeContentButtonBlockV = t27.type({
      type: t27.literal("button"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.union([
        t27.partial({
          label: t27.string,
          action: NudgeButtonActionV,
          button_type: t27.union([t27.literal("primary"), t27.literal("secondary"), t27.literal("snooze")], void 0),
          conditional_actions: t27.array(NudgeConditionalActionV)
        }),
        t27.null
      ])
    });
    NudgeContentSurveyTextBlockV = t27.type({
      type: t27.literal("survey_text"),
      meta: t27.intersection([t27.type({ prompt: t27.string }), SurveyValidation]),
      sort_key: t27.union([t27.number, t27.undefined])
    });
    NudgeStepContentSurveyTextShortBlockTypeV = t27.type({
      type: t27.literal("survey_text_short"),
      meta: t27.intersection([t27.type({ prompt: t27.string }), SurveyValidation]),
      sort_key: t27.union([t27.number, t27.undefined])
    });
    NudgeContentSurveyRatingBlockV = t27.type({
      type: t27.literal("survey_rating"),
      sort_key: t27.union([t27.number, t27.undefined]),
      meta: t27.intersection([
        t27.union([
          t27.type({
            type: t27.literal("emojis"),
            lower_label: t27.string,
            upper_label: t27.string,
            options: t27.number,
            emojis: t27.array(t27.string)
          }),
          t27.type({
            type: t27.literal("numbers"),
            lower_label: t27.string,
            upper_label: t27.string,
            options: t27.number
          }),
          t27.type({
            type: t27.literal("stars"),
            lower_label: t27.string,
            upper_label: t27.string,
            options: t27.number
          }),
          t27.type({
            type: t27.literal("nps"),
            lower_label: t27.string,
            upper_label: t27.string,
            options: t27.number
          })
        ]),
        SurveyValidation
      ])
    });
    NudgeContentBlockV = t27.union([
      NudgeContentMarkdownBlockV,
      NudgeContentImageBlockV,
      NudgeContentVideoBlockV,
      NudgeContentHelpDocBlockV,
      NudgeContentButtonBlockV,
      NudgeContentSurveyTextBlockV,
      NudgeStepContentSurveyTextShortBlockTypeV,
      NudgeContentSurveyRatingBlockV,
      NudgeContentListBlockV
    ]);
    NudgeStepBaseV = t27.type({
      id: t27.number,
      title: t27.string,
      content: t27.array(NudgeContentBlockV),
      is_live: t27.boolean,
      preview_url: t27.union([t27.string, t27.null, t27.undefined])
    });
    NudgeStepLayoutV = t27.union([t27.literal("classic"), t27.literal("horizontal"), t27.literal("vertical")]);
    ElementSelectorV = t27.type({
      selector: t27.string,
      text: t27.string,
      tag: t27.string,
      attributes: t27.record(t27.string, t27.string)
    });
    NudgeStepAdditionalV = t27.intersection(
      [
        t27.type({
          form_factor: t27.union([
            t27.intersection([
              t27.type({
                type: t27.literal("modal")
              }),
              t27.partial({
                layout: NudgeStepLayoutV,
                click_outside_of_modal_to_close: t27.boolean
              })
            ]),
            t27.intersection([
              t27.type({
                type: t27.literal("popover"),
                position: t27.union([
                  t27.literal("top-left"),
                  t27.literal("top-right"),
                  t27.literal("bottom-right"),
                  t27.literal("bottom-left"),
                  t27.literal("center")
                ])
              }),
              t27.partial({
                layout: NudgeStepLayoutV
              })
            ]),
            t27.intersection([
              t27.type({
                type: t27.literal("banner"),
                position: t27.union([t27.literal("top"), t27.literal("bottom")]),
                placement: t27.union([t27.literal("default"), t27.literal("overlay"), t27.literal("sticky")])
              }),
              t27.partial({
                layout: t27.literal("classic")
              })
            ]),
            t27.intersection([
              t27.type({
                type: t27.literal("pin"),
                anchor: t27.string
              }),
              t27.partial({
                anchor_selector: ElementSelectorV,
                is_open_by_default: t27.boolean,
                is_showing_mask: t27.boolean,
                advance_trigger: t27.string,
                offset: t27.type({
                  x: t27.string,
                  y: t27.string
                }),
                position: t27.union([
                  t27.literal("auto"),
                  t27.literal("top"),
                  t27.literal("bottom"),
                  t27.literal("left"),
                  t27.literal("right")
                ]),
                alignment: t27.union([
                  t27.literal("center"),
                  t27.literal("top"),
                  t27.literal("bottom"),
                  t27.literal("left"),
                  t27.literal("right")
                ]),
                copilot_intro: t27.boolean,
                layout: NudgeStepLayoutV
              })
            ]),
            t27.intersection([
              t27.type({
                type: t27.literal("tooltip"),
                anchor: t27.string,
                show_on: t27.union([t27.literal("hover"), t27.literal("click")]),
                marker: t27.intersection([
                  t27.union([
                    t27.type({
                      type: t27.literal("beacon")
                    }),
                    t27.type({
                      type: t27.literal("icon"),
                      icon: t27.union([
                        t27.literal("helpCircle"),
                        t27.literal("helpSquare"),
                        t27.literal("infoCircle"),
                        t27.literal("bookClosed"),
                        t27.literal("lightBulb"),
                        t27.literal("lightning")
                      ])
                    }),
                    t27.type({
                      type: t27.literal("image"),
                      source: t27.string
                    })
                  ]),
                  t27.type({
                    positioning: t27.type({
                      position: t27.union([
                        t27.literal("left"),
                        t27.literal("right"),
                        t27.literal("inline_left"),
                        t27.literal("inline_right")
                      ]),
                      offset: t27.type({
                        x: t27.string,
                        y: t27.string
                      })
                    })
                  })
                ])
              }),
              t27.partial({
                layout: NudgeStepLayoutV,
                anchor_selector: ElementSelectorV
              })
            ])
          ])
        }),
        t27.partial({
          has_survey_response: t27.boolean
        })
      ],
      "NudgeStepAdditional"
    );
    stepDefaults = {
      form_factor: {
        type: "popover",
        position: "top-right"
      }
    };
    NudgeStepV = t27.intersection([NudgeStepBaseV, NudgeStepAdditionalV], "Nudge");
    NudgeAdditionalV = t27.type(
      {
        template_source: t27.string,
        show_step_counter: t27.boolean,
        dismissible: t27.boolean,
        snoozable: t27.boolean,
        snoozable_on_all_steps: t27.boolean,
        share_page_url_or_path: t27.string,
        copilot_suggest: t27.boolean,
        show_in_spotlight_search: t27.boolean,
        show_in_helphub_search: t27.boolean,
        copilot_cta_label: t27.string,
        copilot_description: t27.string,
        is_scheduled: t27.boolean,
        scheduled_start_time: t27.union([t27.string, t27.null, t27.undefined]),
        scheduled_end_time: t27.union([t27.string, t27.null, t27.undefined]),
        snooze_label: t27.string,
        snooze_duration: t27.type({
          interval: SnoozeInterval,
          value: SnoozeValue
        }),
        type: t27.union([t27.literal("announcement"), t27.literal("product_tour"), t27.literal("survey"), t27.null]),
        editor_tags: t27.array(t27.string),
        preview_url: t27.union([t27.string, t27.null, t27.undefined]),
        custom_theme: t27.union([t27.string, t27.null, t27.undefined])
      },
      "NudgeAdditional"
    );
    defaults6 = {
      template_source: "none",
      show_step_counter: false,
      dismissible: true,
      snoozable: false,
      snoozable_on_all_steps: true,
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      snooze_label: "Snooze",
      snooze_duration: {
        interval: "day",
        value: 3
      },
      type: "announcement",
      editor_tags: [],
      preview_url: null,
      custom_theme: null
    };
    NudgeBaseV = t27.intersection(
      [
        t27.type({
          slug: t27.string,
          id: t27.union([t27.number, t27.string]),
          organization: t27.string,
          show_expression: RuleExpressionV,
          trigger: PushTriggerV,
          frequency_limit: FrequencyLimitV,
          steps: t27.array(NudgeStepV),
          is_live: t27.boolean
        }),
        t27.partial({
          old_nudge_id: t27.union([t27.number, t27.null]),
          archived: t27.boolean,
          audience: t27.union([AudienceV, t27.null])
        })
      ],
      "NudgeBase"
    );
    NudgeV = t27.intersection([NudgeBaseV, NudgeAdditionalV], "Nudge");
    OldNudgeBaseV = t27.intersection(
      [
        t27.type({
          id: t27.number,
          organization: t27.string,
          slug: t27.string,
          content: t27.string,
          show_expression: RuleExpressionV,
          trigger: t27.union([
            t27.type({ type: t27.literal("when_conditions_pass") }),
            t27.type({ type: t27.literal("on_command_execution"), meta: t27.type({ command: t27.string }) }),
            t27.type({
              type: t27.literal("on_event"),
              meta: t27.type({ event: t27.string, condition_group: t27.union([RuleExpressionV, t27.null, t27.undefined]) })
            }),
            /**
             * Note: this trigger does not have to be set for share linking to work.
             * Rather, nudges/QLs with this trigger cannot be viewed unless it is via share link
             */
            t27.type({ type: t27.literal("when_share_link_viewed") })
          ]),
          on_select: t27.union([t27.type({ type: t27.literal("no_action") }), CommandActionV]),
          timeout_ms: t27.union([t27.number, t27.null]),
          frequency_limit: t27.union([
            t27.literal("no_limit"),
            t27.literal("once_per_session"),
            t27.literal("once_per_user"),
            t27.literal("until_interaction")
          ])
        }),
        t27.partial({
          title: t27.string,
          html: t27.string,
          cta: t27.string,
          is_live: t27.boolean,
          media: t27.union([
            t27.type({ type: t27.literal("image"), meta: t27.type({ src: t27.string, file_name: t27.string, size: t27.string }) }),
            t27.type({ type: t27.literal("help_doc_command"), meta: t27.type({ command: t27.string }) }),
            t27.null
          ]),
          is_html_override: t27.boolean,
          call_custom_handler: t27.boolean
        })
      ],
      "OldNudgeBase"
    );
    OldNudgeAdditionalV = t27.type(
      {
        form_factor: t27.union([
          t27.type({
            type: t27.literal("modal")
          }),
          t27.type({
            type: t27.literal("popover"),
            position: t27.union([
              t27.literal("top-left"),
              t27.literal("top-right"),
              t27.literal("bottom-right"),
              t27.literal("bottom-left"),
              t27.literal("center")
            ])
          }),
          t27.type({
            type: t27.literal("pin"),
            anchor: t27.string
          })
        ]),
        template_source: t27.string
      },
      "OldNudgeAdditional"
    );
    OldNudgeV = t27.intersection([OldNudgeBaseV, OldNudgeAdditionalV], "OldNudge");
    NudgeResetResponse = t27.type({
      did_reset: t27.boolean
    });
    Nudge = class {
    };
    Nudge.decode = (data) => decodeThrowing(NudgeV, { ...defaults6, steps: [stepDefaults], ...data });
    Nudge.create = createObject(NudgeV, NudgeV, "nudges");
    Nudge.update = updateObject(NudgeV, NudgeV, "nudges");
    Nudge.delete = deleteObject(NudgeV, "nudges");
    Nudge.list = listObject(NudgeV, "nudges");
    Nudge.read = readObject(NudgeV, "nudges");
    /**
     * Returns true if the nudge is new (not yet saved to the backend)
     */
    Nudge.isNew = (nudge) => {
      if (typeof nudge.id === "number") {
        return nudge.id < 0;
      }
      return false;
    };
    Nudge.resetNudgeInteractions = async (endUserSlug, nudgeId) => {
      const result = await patch("nudges/reset_nudge_for_end_user/", {
        end_user_slug: endUserSlug,
        nudge_id: nudgeId
      });
      return await decodeToPromise(t27.exact(NudgeResetResponse), result.data);
    };
  }
});

// internal/src/middleware/helpers/goals.tsx
import * as t28 from "io-ts";
var CommandGoal, PageVisitedGoal, ElementClickedGoal, ConditionsMetGoal, CTAClickedGoal, EventTrackedGoal;
var init_goals = __esm({
  "internal/src/middleware/helpers/goals.tsx"() {
    "use strict";
    init_rules();
    CommandGoal = t28.type({
      type: t28.literal("command_executed"),
      meta: t28.type({
        command: t28.string
      })
    });
    PageVisitedGoal = t28.type({
      type: t28.literal("page_visited"),
      value: t28.string
    });
    ElementClickedGoal = t28.type({
      type: t28.literal("element_clicked"),
      value: t28.string
    });
    ConditionsMetGoal = t28.type({
      type: t28.literal("conditions_met"),
      expression: RuleExpressionV
    });
    CTAClickedGoal = t28.type({
      type: t28.literal("cta_clicked")
    });
    EventTrackedGoal = t28.intersection([
      t28.type({
        type: t28.literal("event_tracked"),
        event: t28.string
      }),
      t28.partial({
        condition_group: t28.union([RuleExpressionV, t28.null, t28.undefined])
      })
    ]);
  }
});

// internal/src/middleware/checklist.tsx
import * as t29 from "io-ts";
var ChecklistItemBaseV, ChecklistItemAdditionalV, ChecklistItemV, ChecklistBaseV, ChecklistAdditionalV, defaults7, ChecklistV, itemDefaults, ResetResponse, Checklist;
var init_checklist = __esm({
  "internal/src/middleware/checklist.tsx"() {
    "use strict";
    init_generics();
    init_actions();
    init_audience();
    init_goals();
    init_pushTrigger();
    init_rules();
    init_network();
    ChecklistItemBaseV = t29.intersection(
      [
        t29.type({
          id: t29.number,
          title: t29.string,
          goal: t29.union([
            CommandGoal,
            PageVisitedGoal,
            ElementClickedGoal,
            ConditionsMetGoal,
            CTAClickedGoal,
            EventTrackedGoal
          ]),
          action: ActionV,
          celebrate: t29.boolean
        }),
        t29.partial({
          description: t29.string,
          cta: t29.string,
          celebration: t29.union([t29.literal("confetti"), t29.literal("coin")])
        })
      ],
      "ChecklistItemBase"
    );
    ChecklistItemAdditionalV = t29.type(
      {
        skippable: t29.boolean
      },
      "ChecklistItemAdditional"
    );
    ChecklistItemV = t29.intersection([ChecklistItemAdditionalV, ChecklistItemBaseV], "ChecklistItem");
    ChecklistBaseV = t29.intersection(
      [
        t29.type({
          id: t29.number,
          title: t29.string,
          show_expression: RuleExpressionV,
          trigger: PushTriggerV,
          items: t29.array(ChecklistItemV)
        }),
        t29.partial({
          description: t29.string,
          is_live: t29.boolean,
          audience: t29.union([AudienceV, t29.null])
        })
      ],
      "ChecklistBase"
    );
    ChecklistAdditionalV = t29.type(
      {
        celebrate: t29.boolean,
        template_source: t29.string,
        position: t29.union([t29.literal("bottomRight"), t29.literal("bottomLeft")]),
        skippable: t29.boolean,
        dismissible: t29.boolean,
        open_by_default: t29.boolean,
        share_page_url_or_path: t29.string,
        show_in_spotlight_search: t29.boolean,
        show_in_helphub_search: t29.boolean,
        copilot_suggest: t29.boolean,
        copilot_cta_label: t29.string,
        copilot_description: t29.string,
        editor_tags: t29.array(t29.string),
        custom_theme: t29.union([t29.string, t29.null, t29.undefined])
      },
      "ChecklistAdditional"
    );
    defaults7 = {
      celebrate: false,
      position: "bottomRight",
      open_by_default: true,
      skippable: true,
      dismissible: false,
      template_source: "none",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      editor_tags: [],
      custom_theme: null
    };
    ChecklistV = t29.intersection([ChecklistBaseV, ChecklistAdditionalV], "Checklist");
    itemDefaults = {
      skippable: false
    };
    ResetResponse = t29.type({
      did_reset: t29.boolean
    });
    Checklist = class {
    };
    Checklist.decode = (data) => {
      const items = data.items.map(
        (item) => ({
          ...itemDefaults,
          ...item
        })
      );
      return decodeThrowing(ChecklistV, { ...defaults7, ...data, items });
    };
    Checklist.create = createObject(ChecklistV, ChecklistV, "checklists");
    Checklist.update = updateObject(ChecklistV, ChecklistV, "checklists");
    Checklist.delete = deleteObject(ChecklistV, "checklists");
    Checklist.list = listObject(ChecklistV, "checklists");
    Checklist.read = readObject(ChecklistV, "checklists");
    Checklist.resetInteractions = async (endUserSlug, checklistId) => {
      const result = await patch("checklists/reset_for_end_user/", {
        end_user_slug: endUserSlug,
        checklist_id: checklistId
      });
      return await decodeToPromise(t29.exact(ResetResponse), result.data);
    };
  }
});

// internal/src/middleware/additionalResource.tsx
import * as t30 from "io-ts";
var AdditionalResourceBaseV, AdditionalResourceAdditionalV, AdditionalResourceV, defaults8, BatchAdditionalResourceResponseV, decode3, list, create2, del3, update4;
var init_additionalResource = __esm({
  "internal/src/middleware/additionalResource.tsx"() {
    "use strict";
    init_generics();
    init_actions();
    AdditionalResourceBaseV = t30.intersection(
      [
        t30.type({
          id: t30.number,
          organization: t30.string,
          widget: t30.string,
          sort_key: t30.number,
          icon: t30.union([t30.string, t30.null]),
          icon_color: t30.union([t30.string, t30.null]),
          label: t30.string,
          action: ActionV,
          show_as_primary_cta: t30.boolean
        }),
        t30.partial({})
      ],
      "AdditionalResourceBase"
    );
    AdditionalResourceAdditionalV = t30.type({}, "AdditionalResourceAdditional");
    AdditionalResourceV = t30.intersection(
      [AdditionalResourceAdditionalV, AdditionalResourceBaseV],
      "AdditionalResource"
    );
    defaults8 = {};
    BatchAdditionalResourceResponseV = t30.type({
      batch: t30.array(AdditionalResourceV)
    });
    decode3 = (data) => {
      const additionalResource = { ...defaults8, ...data };
      return decodeThrowing(AdditionalResourceV, additionalResource);
    };
    list = listObject(AdditionalResourceV, "additional_resources");
    create2 = createObject(AdditionalResourceV, AdditionalResourceV, "additional_resources");
    del3 = deleteObject(AdditionalResourceV, "additional_resources");
    update4 = updateObject(AdditionalResourceV, AdditionalResourceV, "additional_resources");
  }
});

// internal/src/middleware/recommendationSet.tsx
import * as t31 from "io-ts";
var RecommendationSetBaseV, RecommendationSetAdditionalV, RecommendationSetV, defaults9, RecommendationSet;
var init_recommendationSet = __esm({
  "internal/src/middleware/recommendationSet.tsx"() {
    "use strict";
    init_generics();
    init_audience();
    init_actions();
    init_rules();
    RecommendationSetBaseV = t31.type(
      {
        id: t31.number,
        widget: t31.string,
        default: t31.boolean,
        name: t31.string,
        show_expression: RuleExpressionV,
        audience: AudienceV
      },
      "RecommendationSetBase"
    );
    RecommendationSetAdditionalV = t31.type(
      {
        actions: t31.array(
          t31.type({
            action: ActionV,
            cta: t31.string
          })
        ),
        is_live: t31.boolean
      },
      "RecommendationSetAdditional"
    );
    RecommendationSetV = t31.intersection(
      [RecommendationSetBaseV, RecommendationSetAdditionalV],
      "RecommendationSet"
    );
    defaults9 = {
      actions: [],
      is_live: true
    };
    RecommendationSet = class {
    };
    RecommendationSet.decode = (data) => {
      const recommendationSet = { ...defaults9, ...data };
      return decodeThrowing(RecommendationSetV, recommendationSet);
    };
    RecommendationSet.create = createObject(RecommendationSetV, RecommendationSetV, "recommendation_sets");
    RecommendationSet.update = updateObject(RecommendationSetV, RecommendationSetV, "recommendation_sets");
    RecommendationSet.delete = deleteObject(RecommendationSetV, "recommendation_sets");
    RecommendationSet.list = listObject(RecommendationSetV, "recommendation_sets");
    RecommendationSet.read = readObject(RecommendationSetV, "recommendation_sets");
  }
});

// types/src/entities/theme.ts
import * as t32 from "io-ts";
var ThemeModeV2, ThemeV2V2, ThemeV2, defaults10, ThemePatchV2, ThemeSlugReponseV2, decode4;
var init_theme2 = __esm({
  "types/src/entities/theme.ts"() {
    "use strict";
    init_decode();
    ThemeModeV2 = t32.type({
      var_defaults: t32.record(t32.string, t32.union([t32.string, t32.number])),
      var_overrides: t32.record(t32.string, t32.union([t32.string, t32.number])),
      component_overrides: t32.record(t32.string, t32.any),
      mobile_overrides: t32.record(t32.string, t32.any)
    });
    ThemeV2V2 = t32.union([
      t32.type({
        light_mode: ThemeModeV2,
        dark_mode: ThemeModeV2
      }),
      t32.null,
      t32.undefined
    ]);
    ThemeV2 = t32.type(
      {
        id: t32.string,
        uuid: t32.union([t32.string, t32.null, t32.undefined]),
        slug: t32.string,
        name: t32.string,
        default: t32.boolean,
        themeV2: ThemeV2V2,
        themeV2_draft: ThemeV2V2,
        organization: t32.string,
        archived: t32.boolean
      },
      "Theme"
    );
    defaults10 = {};
    ThemePatchV2 = t32.partial({
      id: t32.string,
      slug: t32.string,
      name: t32.string,
      default: t32.boolean,
      themeV2: ThemeV2V2,
      themeV2_draft: ThemeV2V2,
      organization: t32.string,
      archived: t32.boolean
    });
    ThemeSlugReponseV2 = t32.type({
      slug: t32.string
    });
    decode4 = (data) => decodeThrowing2(ThemeV2, { ...defaults10, ...data });
  }
});

// commandbar/src/shared/services/analytics/types.ts
var init_types = __esm({
  "commandbar/src/shared/services/analytics/types.ts"() {
    "use strict";
  }
});

// commandbar/src/shared/services/analytics/helpers.tsx
import _get from "lodash/get";
import _set from "lodash/set";
var CATEGORY_DENY_LIST, isDevelopmentMode, getUserType, isUserEvent, isInternalEvent, getEventCategory, shouldReport, shouldReportToServer, isSilentMode, getEventAttributeBlockList, hasCircularReferences, sanitizeField, stripEventAttributes, getAdditionalCommandDetails;
var init_helpers2 = __esm({
  "commandbar/src/shared/services/analytics/helpers.tsx"() {
    "use strict";
    init_types();
    init_proxy();
    init_symbols();
    init_LocalStorage();
    init_sentry();
    CATEGORY_DENY_LIST = {
      commands: ["attrs.command", "attrs.commandText"],
      help_hub_search: ["attrs.helpHub.query", "attrs.helpHubDoc.query"],
      user_inputs_and_deadends: [
        "attrs.inputText",
        /*
          We need to define this path as an array of strings since lodash parses `inputText[*]`
          as string
        */
        ["attrs", "inputText[*]"],
        "attrs.selections"
      ],
      records: ["attrs.resource", "attrs.record"],
      urls: ["attrs.url", "context.page", "attrs.commandDetails.url"]
    };
    isDevelopmentMode = () => {
      return false;
    };
    getUserType = (isAdmin) => {
      if (isAdmin)
        return "admin";
      if (!!LocalStorage_default.get("adm", ""))
        return "likely-admin";
      return "end_user";
    };
    isUserEvent = (eventType) => {
      return ["t" /* Track */, "i" /* Identify */, "l" /* Log */].includes(eventType);
    };
    isInternalEvent = (eventType) => {
      return ["a" /* Availability */].includes(eventType);
    };
    getEventCategory = (eventType) => {
      if (isUserEvent(eventType))
        return "user";
      if (eventType === "e" /* Error */)
        return "error";
      if (isInternalEvent(eventType))
        return "internal";
      return "unknown";
    };
    shouldReport = (eventType, hasBooted) => {
      const eventCategory = getEventCategory(eventType);
      switch (eventCategory) {
        case "user": {
          return hasBooted;
        }
        case "internal": {
          return hasBooted;
        }
        case "error": {
          return true;
        }
        case "unknown":
        default: {
          return false;
        }
      }
    };
    shouldReportToServer = (sendToServerInLocalHost, debugMode) => {
      var _a2;
      const notSilentMode = !isSilentMode();
      const notAirgapped = !((_a2 = getProxySDK()[_configuration]) == null ? void 0 : _a2.airgap);
      const canReportToServerInThisEnv = !isDevelopmentMode() || sendToServerInLocalHost || !!LocalStorage_default.get("testAnalytics", false) || debugMode;
      return notSilentMode && notAirgapped && canReportToServerInThisEnv;
    };
    isSilentMode = () => {
      var _a2, _b2, _c2;
      const proxy2 = getProxySDK();
      const silent = (_a2 = proxy2[_configuration]) == null ? void 0 : _a2.silent;
      if (silent === void 0) {
        (_c2 = getSentry()) == null ? void 0 : _c2.addBreadcrumb({
          message: "Silent mode configuration is undefined",
          data: {
            configuration: proxy2[_configuration],
            org: (_b2 = proxy2[_configuration]) == null ? void 0 : _b2.uuid
          }
        });
      }
      return silent !== false;
    };
    getEventAttributeBlockList = () => {
      var _a2, _b2, _c2;
      const proxy2 = getProxySDK();
      const eventAttributeBlockList = (_a2 = proxy2[_configuration]) == null ? void 0 : _a2.eventAttributeBlockList;
      if (!eventAttributeBlockList) {
        (_c2 = getSentry()) == null ? void 0 : _c2.addBreadcrumb({
          message: "Event Attribute Block List is undefined",
          data: {
            configuration: proxy2[_configuration],
            org: (_b2 = proxy2[_configuration]) == null ? void 0 : _b2.uuid
          }
        });
      }
      return eventAttributeBlockList || [];
    };
    hasCircularReferences = (obj) => {
      try {
        JSON.stringify(obj);
        return false;
      } catch (err) {
        return true;
      }
    };
    sanitizeField = (payload, field) => {
      const value = _get(payload, field);
      if (typeof value === "string" || typeof value === "number") {
        return _set(payload, field, "*".repeat(`${value}`.length));
      }
      if (typeof value === "object") {
        for (const key of Object.keys(value)) {
          if (hasCircularReferences(value)) {
            return _set(payload, field, {});
          }
          payload = _set(payload, field, sanitizeField(value, key));
        }
      }
      return payload;
    };
    stripEventAttributes = (payload, categories) => {
      let strippedPayload = structuredClone(payload);
      for (const category of categories) {
        const denyList = CATEGORY_DENY_LIST[category] || [];
        for (const field of denyList) {
          strippedPayload = sanitizeField(strippedPayload, field);
        }
      }
      return strippedPayload;
    };
    getAdditionalCommandDetails = (command) => {
      const commandDetails = {};
      if (command.template.type === "link") {
        commandDetails.url = command.template.value;
      }
      return commandDetails;
    };
  }
});

// commandbar/src/shared/services/analytics/event-queue.ts
var EventQueue;
var init_event_queue = __esm({
  "commandbar/src/shared/services/analytics/event-queue.ts"() {
    "use strict";
    EventQueue = class {
      constructor(handleEvents, maxQueueSize = 5) {
        this._queue = [];
        this.maxQueueSize = maxQueueSize;
        this.handleEvents = handleEvents;
      }
      enqueue(event, forceFlush) {
        this._queue.push(event);
        if (forceFlush || this._queue.length >= this.maxQueueSize) {
          this.flush();
        }
      }
      flush(options) {
        const events = this._queue.splice(0, this._queue.length);
        if (events.length === 0) {
          return;
        }
        this.handleEvents(events, options || {});
      }
      destroy() {
        this.flush();
      }
    };
  }
});

// commandbar/src/shared/services/analytics/EventHandler.tsx
var CLIENT_HANDLER_EVENT_TYPES;
var init_EventHandler = __esm({
  "commandbar/src/shared/services/analytics/EventHandler.tsx"() {
    "use strict";
    CLIENT_HANDLER_EVENT_TYPES = [
      { internal: "Abandoned search", external: "abandoned_search" },
      { internal: "Command suggestion", external: "command_suggestion" },
      { internal: "Command execution", external: "command_execution" },
      { internal: "New search", external: "opened" },
      { internal: "Exited", external: "closed" },
      { internal: "No results for query", external: "no_results_for_query" },
      { internal: "Client-Error", external: "client_error" },
      { internal: "User changed shortcut", external: "shortcut_edited" },
      { internal: "Preview shown", external: "preview_shown" },
      { internal: "Next step selected", external: "next_step_selected" },
      { internal: "Preview link opened", external: "preview_link_opened" },
      { internal: "Preview engagement", external: "preview_engagement" },
      { internal: "Nudge shown", external: "nudge_shown" },
      { internal: "Nudge clicked", external: "nudge_clicked" },
      { internal: "Nudge completed", external: "nudge_completed" },
      { internal: "Nudge dismissed", external: "nudge_dismissed" },
      { internal: "Nudge snoozed", external: "nudge_snoozed" },
      { internal: "Questlist shown", external: "questlist_shown" },
      { internal: "Questlist engagement", external: "questlist_engagement" },
      { internal: "Questlist item engagement", external: "questlist_item_engagement" },
      { internal: "HelpHub opened", external: "help_hub_opened" },
      { internal: "HelpHub closed", external: "help_hub_closed" },
      { internal: "HelpHub unminimized", external: "help_hub_unminimized" },
      { internal: "HelpHub minimized", external: "help_hub_minimized" },
      { internal: "HelpHub engagement", external: "help_hub_engagement" },
      { internal: "HelpHub doc opened", external: "help_hub_doc_opened" },
      { internal: "HelpHub doc closed", external: "help_hub_doc_closed" },
      { internal: "HelpHub doc engagement", external: "help_hub_doc_engagement" },
      { internal: "Survey response", external: "survey_response" },
      { internal: "No chat response", external: "no_chat_response" }
    ];
  }
});

// commandbar/src/shared/services/analytics/Analytics.tsx
var getCurrentTimeStamp, sendEvents, Analytics, analytics, Analytics_default;
var init_Analytics = __esm({
  "commandbar/src/shared/services/analytics/Analytics.tsx"() {
    "use strict";
    init_LocalStorage();
    init_network();
    init_globals();
    init_symbols();
    init_helpers2();
    init_Logger();
    init_sentry();
    init_network();
    init_types();
    init_event_queue();
    init_EventHandler();
    getCurrentTimeStamp = () => {
      return (/* @__PURE__ */ new Date()).toISOString();
    };
    sendEvents = (events, useBeacon = false) => {
      const clientFlushedTimestamp = getCurrentTimeStamp();
      const body = {
        events: events.map((e) => ({ ...e, clientFlushedTimestamp })),
        organization: getSDK()[_configuration].uuid,
        id: getSDK()[_user]
      };
      const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
      let baseUrl2 = getBaseURL();
      if (["https://api.commandbar.com"].includes(baseUrl2)) {
        baseUrl2 = "https://t.commandbar.com";
      }
      if ("sendBeacon" in navigator && useBeacon) {
        navigator.sendBeacon(`${baseUrl2}/t/`, blob);
      } else {
        post("/t/", JSON.stringify(body), { keepalive: true }).catch((e) => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
        });
      }
    };
    Analytics = class {
      constructor({ debugMode, sendToServerInLocalhost }) {
        this.hasBooted = false;
        this.isAdmin = false;
        this.enrichEvent = (type39, name, attrs) => {
          var _a2, _b2, _c2, _d, _e;
          const userType = getUserType(this.isAdmin);
          const userID = typeof getSDK()[_user] === "string" ? getSDK()[_user] : null;
          const formFactor = (_b2 = (_a2 = getSDK()[_instanceAttributes]) == null ? void 0 : _a2.formFactor) == null ? void 0 : _b2.type;
          return {
            context: {
              page: {
                path: (_c2 = window.location) == null ? void 0 : _c2.pathname,
                title: document == null ? void 0 : document.title,
                url: (_d = window.location) == null ? void 0 : _d.href,
                search: (_e = window.location) == null ? void 0 : _e.search
              },
              userAgent: navigator == null ? void 0 : navigator.userAgent,
              meta: getSDK()[_metaAttributes],
              groupId: getSDK()[_configuration].uuid,
              cbSource: getSDK()[_configuration]
            },
            clientEventTimestamp: getCurrentTimeStamp(),
            userType,
            type: type39,
            attrs: { formFactor, ...attrs },
            name,
            id: userID,
            session: getSDK()[_configuration].session,
            search: getSDK()[_search],
            reportToSegment: this.shouldReportToEventHandler(name),
            ...!userID && { fingerprint: getSDK()[_fingerprint] }
          };
        };
        /**
         * Event destination 1: CB Server
         *
         * Events reported to CB's server are put in a queue to reduce the number of network requests.
         * When the queue exceeds maxQueueSize, or an event has the forceFlush attribute, the queue is flushed.
         * Events are enriched with context information (url, device, userType, etc.) before they're sent
         **/
        this.addEventToServerQueue = (type39, name, attrs, forceFlush) => {
          const eventAttributeBlockList = getEventAttributeBlockList();
          const enrichedEvent = this.enrichEvent(type39, name, attrs);
          this.eventQueue.enqueue(stripEventAttributes(enrichedEvent, eventAttributeBlockList), forceFlush);
        };
        this.flushServerQueue = (useSendBeacon = false) => {
          this.eventQueue.flush({
            useSendBeacon
          });
        };
        /**
         * Event Destination 2: Client event handler
         *
         * Client can add an event handler function using window.CommandBar.addEventHandler.
         * Once added, this sends a set of whitelisted events to the client provided function as they happen.
         **/
        this.whitelistedEventHandlerEvents = CLIENT_HANDLER_EVENT_TYPES.map((x) => x.internal);
        this.shouldReportToEventHandler = (eventName) => {
          return this.whitelistedEventHandlerEvents.includes(eventName);
        };
        this.debugMode = debugMode;
        this.eventQueue = new EventQueue((events, { useSendBeacon }) => {
          var _a2;
          if (!shouldReportToServer(sendToServerInLocalhost, debugMode))
            return;
          try {
            sendEvents(events, useSendBeacon);
          } catch (e) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
          }
        });
      }
      /**
       * Triage the event and send it to the respective destination(s)
       **/
      onEvent(type39, name, attrs, forceFlush) {
        var _a2, _b2, _c2;
        try {
          if (shouldReport(type39, this.hasBooted) || name === "SDK method called") {
            if (this.debugMode) {
              console.log(
                "-- New Event:",
                name,
                type39,
                "\nData",
                attrs,
                "\nFull payload",
                this.enrichEvent(type39, name, attrs)
              );
            }
            const externalName = (_a2 = CLIENT_HANDLER_EVENT_TYPES.find((x) => x.internal === name)) == null ? void 0 : _a2.external;
            if (!!externalName) {
              attrs.type = externalName;
            }
            this.addEventToServerQueue(type39, name, attrs, forceFlush);
            if (this.shouldReportToEventHandler(name)) {
              const userAttributes = getSDK()[_userProperties] || {};
              if (!!externalName) {
                const eventHandler = (_b2 = getSDK().shareCallbacks()) == null ? void 0 : _b2["commandbar-event-handler"];
                const context = { ...attrs, userAttributes };
                if (eventHandler)
                  eventHandler(externalName, context);
                const eventSubscriptions = getSDK()[_eventSubscriptions];
                const iterator = eventSubscriptions instanceof Map ? eventSubscriptions.values() : void 0;
                if (iterator) {
                  while (true) {
                    const { value, done } = iterator.next();
                    if (done)
                      break;
                    const [subscriber, options] = value;
                    if (!options) {
                      subscriber(externalName, context);
                    }
                  }
                }
              }
            }
          }
        } catch (error3) {
          Logger_default.warn("Unexpected error logging event; ignoring", { type: type39, name, error: error3 });
          (_c2 = getSentry()) == null ? void 0 : _c2.captureException(error3);
        }
      }
      /**
       * API
       *
       * identify: [UserEvent] identify the user
       * log: [UserEvent] for remaining events
       * error: [ErrorEvent] for errors
       * availability: [InternalEvent] reporting which commands are available
       *
       * identifyAsAdmin: tell Analytics that the user is an admin (for data enrichment)
       * userHasBooted: tell Analytics that the user has been booted, so start tracking events
       */
      log(eventName, attrs, forceFlush) {
        var _a2;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({
          category: "log",
          message: eventName,
          data: attrs
        });
        this.onEvent("l" /* Log */, eventName, attrs, forceFlush);
      }
      identify(attrs) {
        var _a2;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({
          category: "identify",
          message: "Identify",
          data: attrs
        });
        this.onEvent("i" /* Identify */, "Identify", attrs, true);
      }
      error(attrs) {
        this.onEvent("e" /* Error */, "Client-Error", attrs, true);
      }
      availability(commands) {
        var _a2;
        const attrs = { commands };
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({
          category: "availability",
          message: "Calculate availability",
          data: attrs
        });
        this.onEvent("a" /* Availability */, "Internal-Event", attrs);
      }
      identifyAsAdmin() {
        this.isAdmin = true;
        LocalStorage_default.set("adm", true);
        this.identify({ isAdmin: true });
      }
      setBootStatus(hasBooted) {
        this.hasBooted = hasBooted;
      }
    };
    analytics = new Analytics({
      /* Use commandbar.debugAnalytics to turn on debug mode */
      debugMode: !!LocalStorage_default.get("debugAnalytics", false),
      sendToServerInLocalhost: false
    });
    Analytics_default = analytics;
  }
});

// commandbar/src/shared/store/util/doNotTrack.ts
import { ref } from "valtio";
var doNotTrack, doNotTrackContext;
var init_doNotTrack = __esm({
  "commandbar/src/shared/store/util/doNotTrack.ts"() {
    "use strict";
    doNotTrack = (o) => {
      if (typeof o === "object" && o !== null)
        ref(o);
    };
    doNotTrackContext = (ctx) => {
      Object.values(ctx).forEach((v) => {
        if (Array.isArray(v)) {
          v.forEach(doNotTrack);
        } else {
          doNotTrack(v);
        }
      });
    };
  }
});

// internal/src/middleware/types.tsx
var isContextArgument, isTimeArgument, isSurveyBlock, isAnchorableStep;
var init_types2 = __esm({
  "internal/src/middleware/types.tsx"() {
    "use strict";
    isContextArgument = (argument) => {
      return argument.type === "context";
    };
    isTimeArgument = (argument) => {
      return argument.type === "provided" && argument.value === "time";
    };
    isSurveyBlock = (block) => block.type === "survey_text" || block.type === "survey_text_short" || block.type === "survey_rating" || block.type === "survey_list";
    isAnchorableStep = (step) => (step == null ? void 0 : step.form_factor.type) === "pin" || (step == null ? void 0 : step.form_factor.type) === "tooltip";
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/Step.tsx
var initStep;
var init_Step = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/Step.tsx"() {
    "use strict";
    initStep = (type39) => ({ completed: false, type: type39 });
  }
});

// commandbar/src/shared/util/hooks/useCommandBarContainer.tsx
import { createContext as createContext2, useContext } from "react";
var CommandBarContainerContext, useCommandBarContainer;
var init_useCommandBarContainer = __esm({
  "commandbar/src/shared/util/hooks/useCommandBarContainer.tsx"() {
    "use strict";
    CommandBarContainerContext = createContext2({});
    useCommandBarContainer = () => {
      return useContext(CommandBarContainerContext);
    };
  }
});

// internal/src/client/Z.tsx
var Z_INDEX_MAX, Z_COMMANDBAR, Z_EDITOR, Z_EDITOR_OVERLAY, Z_CHECKLIST, Z_NUDGE, Z_HELPHUB, Z_LAUNCHER, Z_EDITOR_BANNER, Z_TOOLTIPS, Z_MESSAGES, Z_DRAGGERS, Z_MODALS, Z_RECORDER, Z_DROPDOWNS, Z_KEYBOARD_SHORTCUTS, Z_CONFETTI, Z_MASK, Z, Z_default;
var init_Z = __esm({
  "internal/src/client/Z.tsx"() {
    "use strict";
    Z_INDEX_MAX = 2147483647;
    Z_COMMANDBAR = Z_INDEX_MAX - 2;
    Z_EDITOR = Z_INDEX_MAX - 3;
    Z_EDITOR_OVERLAY = Z_INDEX_MAX - 2;
    Z_CHECKLIST = Z_INDEX_MAX - 3;
    Z_NUDGE = Z_COMMANDBAR - 1;
    Z_HELPHUB = Z_NUDGE - 1;
    Z_LAUNCHER = Z_HELPHUB - 1;
    Z_EDITOR_BANNER = Z_HELPHUB - 1;
    Z_TOOLTIPS = Z_INDEX_MAX;
    Z_MESSAGES = Z_INDEX_MAX;
    Z_DRAGGERS = Z_INDEX_MAX;
    Z_MODALS = Z_INDEX_MAX;
    Z_RECORDER = Z_INDEX_MAX - 1;
    Z_DROPDOWNS = Z_INDEX_MAX - 1;
    Z_KEYBOARD_SHORTCUTS = Z_INDEX_MAX - 1;
    Z_CONFETTI = Z_INDEX_MAX;
    Z_MASK = Z_MODALS - 3;
    Z = {
      Z_INDEX_MAX,
      Z_MESSAGES,
      Z_COMMANDBAR,
      Z_EDITOR,
      Z_EDITOR_OVERLAY,
      Z_DROPDOWNS,
      Z_TOOLTIPS,
      Z_MODALS,
      Z_RECORDER,
      Z_DRAGGERS,
      Z_KEYBOARD_SHORTCUTS,
      Z_CONFETTI,
      Z_CHECKLIST,
      Z_HELPHUB,
      Z_LAUNCHER,
      Z_EDITOR_BANNER,
      Z_NUDGE,
      Z_MASK
    };
    Z_default = Z;
  }
});

// commandbar/src/products/spotlight/components/Tooltip.tsx
import React3 from "react";
import RcTooltip from "rc-tooltip";
var Tooltip, Tooltip_default;
var init_Tooltip = __esm({
  "commandbar/src/products/spotlight/components/Tooltip.tsx"() {
    "use strict";
    init_useCommandBarContainer();
    init_Z();
    Tooltip = (props2) => {
      var _a2, _b2, _c2, _d;
      const { root } = useCommandBarContainer();
      if (!!props2.disabled)
        return (_a2 = props2.children) != null ? _a2 : null;
      if (!root)
        return (_b2 = props2.children) != null ? _b2 : null;
      const rcTooltipContainer = root.getElementById((_c2 = props2 == null ? void 0 : props2.containerId) != null ? _c2 : "commandbar-rc-tooltip-container");
      if (!rcTooltipContainer)
        return (_d = props2.children) != null ? _d : null;
      return /* @__PURE__ */ React3.createElement(
        RcTooltip,
        {
          prefixCls: "commandbar-tooltip",
          getTooltipContainer: () => rcTooltipContainer,
          overlayStyle: { zIndex: Z_default.Z_INDEX_MAX },
          ...props2
        }
      );
    };
    Tooltip_default = Tooltip;
  }
});

// commandbar/src/products/spotlight/components/Tag.tsx
import React4 from "react";
var Tag, Tag_default;
var init_Tag = __esm({
  "commandbar/src/products/spotlight/components/Tag.tsx"() {
    "use strict";
    Tag = (props2) => {
      var _a2;
      const backgroundColor = props2.backgroundColor ? props2.backgroundColor : props2.color.alpha(0.2).css();
      const borderColor = props2.borderColor ? props2.borderColor : "transparent";
      return /* @__PURE__ */ React4.createElement(
        "span",
        {
          "aria-hidden": true,
          id: props2.id,
          style: {
            display: "inline-flex",
            backgroundColor,
            borderRadius: (_a2 = props2.borderRadius) != null ? _a2 : "2px",
            border: "1px solid transparent",
            borderColor,
            fontSize: props2.fontSize ? props2.fontSize : "12px",
            padding: "4px 7px",
            transition: "all 0.3s",
            color: props2.color.css(),
            minWidth: 24,
            height: 24,
            textAlign: "center",
            alignItems: "center",
            justifyContent: "space-around",
            ...props2.style || {}
          },
          onClick: props2.onClick || void 0
        },
        props2.children
      );
    };
    Tag_default = Tag;
  }
});

// internal/src/util/useWindowSize.tsx
import * as React5 from "react";
var useWindowSize, useWindowSize_default;
var init_useWindowSize = __esm({
  "internal/src/util/useWindowSize.tsx"() {
    "use strict";
    useWindowSize = () => {
      const getSize = () => {
        return {
          width: window.innerWidth,
          height: window.innerHeight
        };
      };
      const [windowSize, setWindowSize] = React5.useState(getSize);
      React5.useEffect(() => {
        const handleResize = () => {
          setWindowSize(getSize());
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
      return windowSize;
    };
    useWindowSize_default = useWindowSize;
  }
});

// commandbar/src/products/spotlight/types.ts
var init_types3 = __esm({
  "commandbar/src/products/spotlight/types.ts"() {
    "use strict";
    init_Step();
  }
});

// commandbar/src/products/spotlight/components/select/input/placeholderHelpers.ts
var DEFAULT_PLACEHOLDER, placeholderStyles;
var init_placeholderHelpers = __esm({
  "commandbar/src/products/spotlight/components/select/input/placeholderHelpers.ts"() {
    "use strict";
    DEFAULT_PLACEHOLDER = "What do you want to do?";
    placeholderStyles = (theme) => ({
      color: theme.placeholder.color,
      fontFamily: theme.placeholder.fontFamily,
      fontSize: theme.placeholder.fontSize,
      fontWeight: theme.placeholder.fontWeight
    });
  }
});

// internal/src/util/location.ts
var isStudioPreview, isHelpHubMarketingSiteURL, isHelpHubMarketingSite, isValidURL, DEBUG_NUDGE_PARAM;
var init_location = __esm({
  "internal/src/util/location.ts"() {
    "use strict";
    isStudioPreview = () => document.getElementById("commandbar-is-studio-preview") !== null;
    isHelpHubMarketingSiteURL = (hostURL) => {
      const HELPHUB_MARKETING_SITE_URL = "https://helphub.commandbar.com";
      const COPILOT_MARKETING_SITE_URL = "https://copilot.commandbar.com";
      const DEV_STANDALONE_EDITOR_URL = "http://localhost:5001";
      return hostURL.startsWith(DEV_STANDALONE_EDITOR_URL) || hostURL.startsWith(HELPHUB_MARKETING_SITE_URL) || hostURL.startsWith(COPILOT_MARKETING_SITE_URL);
    };
    isHelpHubMarketingSite = (() => {
      if (typeof window.location.href !== "string") {
        return false;
      }
      return isHelpHubMarketingSiteURL(window.location.href);
    })();
    isValidURL = (str, protocolOptional = false) => {
      try {
        if (protocolOptional && !str.includes("://") && str.includes(".")) {
          str = "https://" + str;
        }
        const url = new URL(str);
        return url.protocol === "http:" || url.protocol === "https:";
      } catch (err) {
        return false;
      }
    };
    DEBUG_NUDGE_PARAM = "debug_nudge";
  }
});

// commandbar/src/shared/store/end-user/selectors.ts
var recentUIDs, isRemoteEnduserStoreEnabled;
var init_selectors = __esm({
  "commandbar/src/shared/store/end-user/selectors.ts"() {
    "use strict";
    init_location();
    recentUIDs = (recents) => {
      return Array.from(new Set(recents.map((r) => r.optionUID)));
    };
    isRemoteEnduserStoreEnabled = (_) => {
      var _a2;
      const canDoNonVerified = !((_a2 = _.organization) == null ? void 0 : _a2.force_end_user_identity_verification);
      return !!_.endUser && !isStudioPreview() && (!!_.endUser.hmac || canDoNonVerified);
    };
  }
});

// commandbar/src/shared/store/end-user/state.ts
function parseLocalStorageJSON(field, defaultValue) {
  var _a2;
  try {
    return JSON.parse(LocalStorage_default.get(field, "false")) || defaultValue;
  } catch (err) {
    (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
    return defaultValue;
  }
}
function getStoreKey(store, enduser) {
  return !!(enduser == null ? void 0 : enduser.slug) ? `userstore.${enduser.slug}.${store}` : `userstore.${store}`;
}
function getFromEndUserStore(field, defaultValue, enduser) {
  const storekey = getStoreKey(field, enduser);
  return parseLocalStorageJSON(storekey, defaultValue);
}
var emptyEndUserStoreState, initLocalEndUserState;
var init_state = __esm({
  "commandbar/src/shared/store/end-user/state.ts"() {
    "use strict";
    init_LocalStorage();
    init_sentry();
    init_selectors();
    emptyEndUserStoreState = () => {
      return {
        data: {
          recents: [],
          hotkeys: {},
          checklist_interactions: {},
          nudges_interactions: {},
          analytics: void 0,
          properties: {}
        },
        verified: false,
        hasRemoteLoaded: false,
        derived: {
          recentUIDs: []
        }
      };
    };
    initLocalEndUserState = (enabledKeys, endUser) => {
      const retVal = emptyEndUserStoreState();
      if (typeof endUser == "undefined")
        return retVal;
      let recents = enabledKeys.includes("recents") ? getFromEndUserStore("recents", [], endUser) : [];
      if (recents.length === 0 && enabledKeys.includes("recents")) {
        const legacyRecents = parseLocalStorageJSON(`userstore.recents`, []);
        if (legacyRecents.length > 0) {
          recents = legacyRecents;
          LocalStorage_default.set(getStoreKey("recents", endUser), JSON.stringify(recents));
        }
      }
      recents = recents.filter((r) => r.timestamp > Date.now() - 1e3 * 60 * 60 * 72);
      if (enabledKeys.includes("recents")) {
        retVal.data.recents = recents;
        retVal.derived.recentUIDs = recentUIDs(recents);
      }
      if (enabledKeys.includes("hotkeys") && !(endUser == null ? void 0 : endUser.hotkeys_debug)) {
        retVal.data.hotkeys = getFromEndUserStore("hotkeys", {}, endUser);
      }
      if (enabledKeys.includes("checklist_interactions")) {
        retVal.data.checklist_interactions = getFromEndUserStore("checklist_interactions", {}, endUser);
      }
      if (enabledKeys.includes("nudges_interactions")) {
        retVal.data.nudges_interactions = getFromEndUserStore("nudges_interactions", {}, endUser);
      }
      if (enabledKeys.includes("analytics")) {
        retVal.data.analytics = getFromEndUserStore("analytics", void 0, endUser);
      }
      if (enabledKeys.includes("properties")) {
        retVal.data.properties = getFromEndUserStore("properties", {}, endUser);
      }
      return retVal;
    };
  }
});

// commandbar/src/shared/store/util/hasOp.ts
import isEqual from "lodash/isEqual";
var hasOp, findOp, getPrevValue, hasSetOp, hasMatchingOp;
var init_hasOp = __esm({
  "commandbar/src/shared/store/util/hasOp.ts"() {
    "use strict";
    hasOp = (opType, path, ops) => {
      return ops.some((op) => op[0] === opType && isEqual(op[1], path));
    };
    findOp = (opType, path, ops) => {
      return ops.find((op) => op[0] === opType && isEqual(op[1], path));
    };
    getPrevValue = (op) => {
      if (op === void 0)
        return void 0;
      if (op[0] === "set")
        return op[3];
      if (op[0] === "delete")
        return op[2];
    };
    hasSetOp = hasOp.bind(null, "set");
    hasMatchingOp = (dependencies, ops) => dependencies === "*" || ops.some(
      ([_, updatePath]) => dependencies.some((dep) => {
        const len = Math.min(dep.length, updatePath.length);
        for (let i2 = 0; i2 < len; i2++) {
          if (dep[i2] !== "*" && dep[i2] !== updatePath[i2]) {
            return false;
          }
        }
        return true;
      })
    );
  }
});

// commandbar/src/shared/store/util/sub.ts
import { subscribe } from "valtio";
var sub;
var init_sub = __esm({
  "commandbar/src/shared/store/util/sub.ts"() {
    "use strict";
    init_hasOp();
    init_LocalStorage();
    sub = (state, action, dependencies, async = true) => {
      const log2 = LocalStorage_default.get("logChanges", false);
      return subscribe(
        state,
        (ops) => {
          if (hasMatchingOp(dependencies, ops)) {
            if (log2)
              console.log("subscription triggered: ", action.name, ops);
            action(state, ops);
          }
        },
        !async
      );
    };
  }
});

// internal/src/util/dom.ts
function clickElementsWithPause(index3, selectors, logError) {
  var _a2;
  if (index3 >= selectors.length) {
    return;
  }
  let pause = 150;
  let blur = false;
  const element = getElement(selectors[index3]);
  const type39 = getQueryStringType(selectors[index3]);
  if (type39 === "pause") {
    pause = (_a2 = parseInt(selectors[index3].replace(/^pause/, ""))) != null ? _a2 : 150;
  } else if (type39 === "blur") {
    blur = true;
  }
  if (!element && type39 !== "pause") {
    logError == null ? void 0 : logError(selectors[index3]);
    return;
  }
  if (element instanceof HTMLElement) {
    element.click();
  } else if (element instanceof SVGElement) {
    element.dispatchEvent(new MouseEvent("click", { bubbles: true }));
  }
  if (blur) {
    const selector2 = selectors[index3].replace(/^blur /, "");
    let count = 0;
    const intervalID = setInterval(() => {
      count += 1;
      const element2 = getElement(selector2);
      if (element2 === (document == null ? void 0 : document.activeElement) && element2 instanceof HTMLElement) {
        element2.blur();
        clearInterval(intervalID);
      }
      if (count > 200) {
        clearInterval(intervalID);
      }
    }, 10);
  }
  setTimeout(() => {
    clickElementsWithPause(index3 + 1, selectors, logError);
  }, pause);
}
function clickElement(selector2, logError) {
  const element = getElement(selector2);
  if (!element) {
    if (logError) {
      logError(selector2);
    }
    return;
  }
  if (element instanceof HTMLElement) {
    element.click();
  } else if (element instanceof SVGElement) {
    element.dispatchEvent(new MouseEvent("click", { bubbles: true }));
  }
}
function isVisibleOnPage(element) {
  const style3 = window.getComputedStyle(element);
  if (style3.display === "none" || style3.visibility === "hidden") {
    return false;
  }
  const rect = element.getBoundingClientRect();
  let parent = element.parentNode;
  while (parent && parent !== document.body && parent instanceof Element) {
    const parentStyle = window.getComputedStyle(parent);
    const parentRect = parent.getBoundingClientRect();
    if (isElementHidden(rect, parentRect, parentStyle)) {
      return false;
    }
    parent = parent.parentNode;
  }
  const windowHeight = window.innerHeight || document.documentElement.clientHeight;
  const windowWidth = window.innerWidth || document.documentElement.clientWidth;
  const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
  const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
  return vertInView && horInView;
}
var getQueryStringType, loadFromXPath, loadFromSelector, checkSelector, isShadowDOMSelector, splitShadowDOMSelector, getNextContext, deepSelectShadowDOMElement, isElementInformation, getElement, isElementHidden, checkSelectorAndVisibility, fastIsElementVisible, isWithinCommandBar;
var init_dom = __esm({
  "internal/src/util/dom.ts"() {
    "use strict";
    getQueryStringType = (x) => {
      if (x.startsWith("pause")) {
        return "pause";
      } else if (x.startsWith("blur")) {
        return "blur";
      } else if (x.substring(0, 2) === "//") {
        return "xpath";
      } else {
        return "css";
      }
    };
    loadFromXPath = (x, doc = null, logError) => {
      if (typeof x !== "string" || x.length === 0)
        return null;
      if (!doc)
        doc = document;
      try {
        const xPathRes = doc.evaluate(x, doc, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
        if (xPathRes.singleNodeValue) {
          return xPathRes.singleNodeValue;
        } else {
          return null;
        }
      } catch (e) {
        if (logError) {
          logError(x);
        }
        return null;
      }
    };
    loadFromSelector = (x, doc = null, logError) => {
      if (typeof x !== "string" || x.length === 0)
        return null;
      if (!doc)
        doc = document;
      try {
        const elem = doc.querySelector(x);
        return elem;
      } catch (e) {
        if (logError) {
          logError(x);
        }
        return null;
      }
    };
    checkSelector = (selector2) => !!getElement(selector2);
    isShadowDOMSelector = (selector2) => /^\[[^,]+(,[^,]+)+\]$/.test(selector2);
    splitShadowDOMSelector = (selector2) => selector2.slice(1, -1).split(",");
    getNextContext = (context, selector2) => {
      var _a2, _b2;
      if (context instanceof Element) {
        return (_b2 = context.querySelector(selector2) || ((_a2 = context.shadowRoot) == null ? void 0 : _a2.querySelector(selector2))) != null ? _b2 : null;
      }
      return context instanceof Document || context instanceof ShadowRoot ? context.querySelector(selector2) : null;
    };
    deepSelectShadowDOMElement = (selectors, currentContext = document) => {
      if (selectors.length === 0) {
        return currentContext;
      }
      const [currentSelector] = selectors;
      const nextContext = getNextContext(currentContext, currentSelector);
      if (nextContext) {
        return deepSelectShadowDOMElement(selectors.slice(1), nextContext);
      }
    };
    isElementInformation = (selector2) => selector2.selector !== void 0;
    getElement = (elementInformationOrSelector, doc) => {
      let selector2 = elementInformationOrSelector;
      if (isElementInformation(selector2)) {
        selector2 = selector2.selector;
      }
      if (selector2 !== null && selector2 !== void 0 && selector2.length > 0) {
        const type39 = getQueryStringType(selector2);
        if (isShadowDOMSelector(selector2)) {
          const shadowDOMPath = splitShadowDOMSelector(selector2);
          const node2 = deepSelectShadowDOMElement(shadowDOMPath);
          if (node2 instanceof Element) {
            return node2;
          }
        }
        const node = type39 === "xpath" ? loadFromXPath(selector2, doc) : loadFromSelector(selector2, doc);
        if (node instanceof Element) {
          return node;
        }
      }
      if (isElementInformation(elementInformationOrSelector) && elementInformationOrSelector.text) {
        if (elementInformationOrSelector.tag) {
          const xpathExpression2 = `//${elementInformationOrSelector.tag}[normalize-space(.) = '${elementInformationOrSelector.text}']`;
          const node2 = loadFromXPath(xpathExpression2, doc);
          if (node2 instanceof Element) {
            return node2;
          }
        }
        const xpathExpression = `//*[normalize-space(text()) = '${elementInformationOrSelector.text}']`;
        const node = loadFromXPath(xpathExpression, doc);
        if (node instanceof Element) {
          return node;
        }
      }
    };
    isElementHidden = (rect, parentRect, parentStyle) => {
      const isDisplayNone = parentStyle.display === "none";
      const isVisibilityHidden = parentStyle.visibility === "hidden";
      const isOverflowHidden = parentStyle.overflow === "hidden";
      const isOverflowXHidden = parentStyle.overflowX === "hidden";
      const isOverflowYHidden = parentStyle.overflowY === "hidden";
      const isHorizontallyHidden = (isOverflowHidden || isOverflowXHidden) && (rect.right < parentRect.left || rect.left > parentRect.right);
      const isVerticallyHidden = (isOverflowHidden || isOverflowYHidden) && (rect.bottom < parentRect.top || rect.top > parentRect.bottom);
      return isDisplayNone || isVisibilityHidden || isHorizontallyHidden || isVerticallyHidden;
    };
    checkSelectorAndVisibility = (selector2) => {
      const element = getElement(selector2);
      return element && element instanceof Element ? { elementFound: true, elementVisible: isVisibleOnPage(element) } : { elementFound: false, elementVisible: false };
    };
    fastIsElementVisible = (element) => {
      if (!element)
        return false;
      const style3 = window.getComputedStyle(element);
      const checkNullPosition = (element2) => {
        const rect = element2 == null ? void 0 : element2.getBoundingClientRect();
        return (rect == null ? void 0 : rect.width) === 0 && (rect == null ? void 0 : rect.height) === 0 || (rect == null ? void 0 : rect.x) === 0 && (rect == null ? void 0 : rect.y) === 0;
      };
      return !(style3.display === "none" || style3.opacity === "0" || style3.visibility === "hidden" || checkNullPosition(element));
    };
    isWithinCommandBar = (node) => {
      const wrapper = document.getElementById("commandbar-wrapper");
      if (wrapper) {
        return wrapper.contains(node);
      }
      const editorDrawer = document.getElementById("commandbar-editor-drawer");
      if (editorDrawer) {
        return editorDrawer.contains(node);
      }
      return false;
    };
  }
});

// commandbar/src/products/spotlight/store/search/fuzzysort-fork/fuzzysort.js
function UMD() {
  function fuzzysortNew(instanceOptions) {
    var fuzzysort3 = {
      single: function(search3, target, options) {
        if (!search3)
          return null;
        if (!isObj(search3))
          search3 = fuzzysort3.getPreparedSearch(search3);
        if (!target)
          return null;
        if (!isObj(target))
          target = fuzzysort3.getPrepared(target);
        var allowTypo = options && options.allowTypo !== void 0 ? options.allowTypo : instanceOptions && instanceOptions.allowTypo !== void 0 ? instanceOptions.allowTypo : true;
        var algorithm = allowTypo ? fuzzysort3.algorithm : fuzzysort3.algorithmNoTypo;
        return algorithm(search3, target, search3[0]);
      },
      /*
       * @COMMANDBAR START
       *   Modification to only look for exact matches in long strings
       *       - Dramatically improves performance
       *       - Better results
       */
      performSearch: function(targetString, targetPrepared, queryString, queryPrepared, queryLowerCode, algorithm, options) {
        const shouldExactSearch = fuzzysort3.shouldExactSearch(targetString, options.minLengthForExactSearch);
        if (shouldExactSearch) {
          return fuzzysort3.exactSearch(queryString, targetString, targetPrepared);
        } else {
          return algorithm(queryPrepared, targetPrepared, queryLowerCode);
        }
      },
      /** @COMMANDBAR END */
      go: function(queryString, targets, options) {
        if (!queryString)
          return noResults;
        var queryPrepared = fuzzysort3.prepareSearch(queryString);
        var queryLowerCode = queryPrepared[0];
        var queryReversedString = queryString.split(" ").reverse().join(" ");
        var queryReversedPrepared = fuzzysort3.prepareSearch(queryReversedString);
        var queryReversedLowerCode = queryReversedPrepared[0];
        var ignoreReversed = queryString.split(" ").filter((token) => !!token).length <= 1;
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991;
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991;
        var allowTypo = options && options.allowTypo !== void 0 ? options.allowTypo : instanceOptions && instanceOptions.allowTypo !== void 0 ? instanceOptions.allowTypo : true;
        var algorithm = allowTypo ? fuzzysort3.algorithm : fuzzysort3.algorithmNoTypo;
        var resultsLen = 0;
        var limitedCount = 0;
        var targetsLen = targets.length;
        function pickBestResult(result1, result2) {
          if (!result1 && !result2)
            return result1;
          if (!!result1 && !result2)
            return result1;
          if (!result1 && !!result2)
            return result2;
          return result1.score >= result2.score ? result1 : result2;
        }
        function getBestSearchResult(targetString, preparedTargetString) {
          const normalSearchResult = fuzzysort3.performSearch(
            targetString,
            preparedTargetString,
            queryString,
            queryPrepared,
            queryLowerCode,
            algorithm,
            options
          );
          if (ignoreReversed)
            return normalSearchResult;
          const reverseSearchResult = fuzzysort3.performSearch(
            targetString,
            preparedTargetString,
            queryReversedString,
            queryReversedPrepared,
            queryReversedLowerCode,
            algorithm,
            options
          );
          return pickBestResult(normalSearchResult, reverseSearchResult);
        }
        var shouldSort = options && (options.shouldSort === void 0 || options.shouldSort);
        var allResults = [];
        if (options && options.keys) {
          var scoreFn = options.scoreFn || defaultScoreFn;
          var keys = options.keys;
          var keysLen = keys.length;
          for (var i2 = 0; i2 < targetsLen; i2++) {
            var obj = targets[i2];
            var objResults = new Array(keysLen);
            for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
              var key = keys[keyI];
              var target = options.getFn(obj, key);
              if (!target || typeof target !== "string" && !Array.isArray(target)) {
                objResults[keyI] = null;
                continue;
              }
              try {
                if (Array.isArray(target)) {
                  if (target.length === 0) {
                    objResults[keyI] = null;
                    continue;
                  }
                  const result = target.reduce((bestMatch, targetString) => {
                    if (typeof targetString !== "string")
                      return bestMatch;
                    if (!targetString)
                      return bestMatch;
                    const targetPrepared2 = fuzzysort3.prepare(targetString);
                    const value = getBestSearchResult(targetString, targetPrepared2);
                    if (!bestMatch)
                      return value;
                    if (!value)
                      return bestMatch;
                    if (value.score > bestMatch.score)
                      return value;
                    return bestMatch;
                  }, null);
                  objResults[keyI] = result;
                } else {
                  var targetPrepared = fuzzysort3.getPrepared(target);
                  const result = getBestSearchResult(target, targetPrepared);
                  objResults[keyI] = result;
                }
              } catch (e) {
                console.error(e);
                objResults[keyI] = null;
                continue;
              }
            }
            objResults.obj = obj;
            var score = scoreFn(objResults);
            if (score === null)
              continue;
            if (score < threshold)
              continue;
            objResults.score = score;
            if (resultsLen < limit) {
              if (!shouldSort) {
                allResults.push(objResults);
              } else {
                q.add(objResults);
              }
              ++resultsLen;
            } else {
              ++limitedCount;
              if (!shouldSort) {
                allResults.push(objResults);
              } else {
                if (score > q.peek().score)
                  q.replaceTop(objResults);
              }
            }
          }
        } else {
          console.error("Keys not provided");
        }
        if (resultsLen === 0)
          return noResults;
        if (!shouldSort) {
          return allResults;
        }
        var results = new Array(resultsLen);
        for (var i2 = resultsLen - 1; i2 >= 0; --i2)
          results[i2] = q.poll();
        results.total = resultsLen + limitedCount;
        return results;
      },
      goAsync: function(search3, targets, options) {
        var canceled = false;
        var p = new Promise(function(resolve, reject) {
          if (!search3)
            return resolve(noResults);
          search3 = fuzzysort3.prepareSearch(search3);
          var searchLowerCode = search3[0];
          var q2 = fastpriorityqueue();
          var iCurrent = targets.length - 1;
          var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991;
          var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991;
          var allowTypo = options && options.allowTypo !== void 0 ? options.allowTypo : instanceOptions && instanceOptions.allowTypo !== void 0 ? instanceOptions.allowTypo : true;
          var algorithm = allowTypo ? fuzzysort3.algorithm : fuzzysort3.algorithmNoTypo;
          var resultsLen = 0;
          var limitedCount = 0;
          function step() {
            if (canceled)
              return reject("canceled");
            var startMs = Date.now();
            if (options && options.keys) {
              var scoreFn = options.scoreFn || defaultScoreFn;
              var keys = options.keys;
              var keysLen = keys.length;
              for (; iCurrent >= 0; --iCurrent) {
                var obj = targets[iCurrent];
                var objResults = new Array(keysLen);
                for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                  var key = keys[keyI];
                  var target = getValue(obj, key);
                  if (!target) {
                    objResults[keyI] = null;
                    continue;
                  }
                  if (!isObj(target))
                    target = fuzzysort3.getPrepared(target);
                  objResults[keyI] = algorithm(search3, target, searchLowerCode);
                }
                objResults.obj = obj;
                var score = scoreFn(objResults);
                if (score === null)
                  continue;
                if (score < threshold)
                  continue;
                objResults.score = score;
                if (resultsLen < limit) {
                  q2.add(objResults);
                  ++resultsLen;
                } else {
                  ++limitedCount;
                  if (score > q2.peek().score)
                    q2.replaceTop(objResults);
                }
                if (iCurrent % 1e3 === 0) {
                  if (Date.now() - startMs >= 10) {
                    isNode ? setImmediate(step) : setTimeout(step);
                    return;
                  }
                }
              }
            } else if (options && options.key) {
              var key = options.key;
              for (; iCurrent >= 0; --iCurrent) {
                var obj = targets[iCurrent];
                var target = getValue(obj, key);
                if (!target)
                  continue;
                if (!isObj(target))
                  target = fuzzysort3.getPrepared(target);
                var result = algorithm(search3, target, searchLowerCode);
                if (result === null)
                  continue;
                if (result.score < threshold)
                  continue;
                result = {
                  target: result.target,
                  _targetLowerCodes: null,
                  _nextBeginningIndexes: null,
                  score: result.score,
                  indexes: result.indexes,
                  obj
                };
                if (resultsLen < limit) {
                  q2.add(result);
                  ++resultsLen;
                } else {
                  ++limitedCount;
                  if (result.score > q2.peek().score)
                    q2.replaceTop(result);
                }
                if (iCurrent % 1e3 === 0) {
                  if (Date.now() - startMs >= 10) {
                    isNode ? setImmediate(step) : setTimeout(step);
                    return;
                  }
                }
              }
            } else {
              for (; iCurrent >= 0; --iCurrent) {
                var target = targets[iCurrent];
                if (!target)
                  continue;
                if (!isObj(target))
                  target = fuzzysort3.getPrepared(target);
                var result = algorithm(search3, target, searchLowerCode);
                if (result === null)
                  continue;
                if (result.score < threshold)
                  continue;
                if (resultsLen < limit) {
                  q2.add(result);
                  ++resultsLen;
                } else {
                  ++limitedCount;
                  if (result.score > q2.peek().score)
                    q2.replaceTop(result);
                }
                if (iCurrent % 1e3 === 0) {
                  if (Date.now() - startMs >= 10) {
                    isNode ? setImmediate(step) : setTimeout(step);
                    return;
                  }
                }
              }
            }
            if (resultsLen === 0)
              return resolve(noResults);
            var results = new Array(resultsLen);
            for (var i2 = resultsLen - 1; i2 >= 0; --i2)
              results[i2] = q2.poll();
            results.total = resultsLen + limitedCount;
            resolve(results);
          }
          isNode ? setImmediate(step) : step();
        });
        p.cancel = function() {
          canceled = true;
        };
        return p;
      },
      highlight: function(result, hOpen, hClose) {
        if (result === null)
          return null;
        if (hOpen === void 0)
          hOpen = "<b>";
        if (hClose === void 0)
          hClose = "</b>";
        var highlighted = "";
        var matchesIndex = 0;
        var opened = false;
        var target = result.target;
        var targetLen = target.length;
        var matchesBest = result.indexes;
        for (var i2 = 0; i2 < targetLen; ++i2) {
          var char = target[i2];
          if (matchesBest[matchesIndex] === i2) {
            ++matchesIndex;
            if (!opened) {
              opened = true;
              highlighted += hOpen;
            }
            if (matchesIndex === matchesBest.length) {
              highlighted += char + hClose + target.substr(i2 + 1);
              break;
            }
          } else {
            if (opened) {
              opened = false;
              highlighted += hClose;
            }
          }
          highlighted += char;
        }
        return highlighted;
      },
      prepare: function(target) {
        if (!target)
          return;
        return {
          target,
          _targetLowerCodes: fuzzysort3.prepareLowerCodes(target),
          _nextBeginningIndexes: null,
          score: null,
          indexes: null,
          obj: null
        };
      },
      prepareSlow: function(target) {
        if (!target)
          return;
        return {
          target,
          _targetLowerCodes: fuzzysort3.prepareLowerCodes(target),
          _nextBeginningIndexes: fuzzysort3.prepareNextBeginningIndexes(target),
          score: null,
          indexes: null,
          obj: null
        };
      },
      prepareSearch: function(search3) {
        if (!search3)
          return;
        return fuzzysort3.prepareLowerCodes(search3);
      },
      // Below this point is only internal code
      // Below this point is only internal code
      // Below this point is only internal code
      // Below this point is only internal code
      getPrepared: function(target) {
        if (target.length > 999)
          return fuzzysort3.prepare(target);
        var targetPrepared = preparedCache.get(target);
        if (targetPrepared !== void 0)
          return targetPrepared;
        targetPrepared = fuzzysort3.prepare(target);
        preparedCache.set(target, targetPrepared);
        return targetPrepared;
      },
      getPreparedSearch: function(search3) {
        if (search3.length > 999)
          return fuzzysort3.prepareSearch(search3);
        var searchPrepared = preparedSearchCache.get(search3);
        if (searchPrepared !== void 0)
          return searchPrepared;
        searchPrepared = fuzzysort3.prepareSearch(search3);
        preparedSearchCache.set(search3, searchPrepared);
        return searchPrepared;
      },
      algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
        var targetLowerCodes = prepared._targetLowerCodes;
        var searchLen = searchLowerCodes.length;
        var targetLen = targetLowerCodes.length;
        var searchI = 0;
        var targetI = 0;
        var typoSimpleI = 0;
        var matchesSimpleLen = 0;
        for (; ; ) {
          var isMatch = searchLowerCode === targetLowerCodes[targetI];
          if (isMatch) {
            matchesSimple[matchesSimpleLen++] = targetI;
            ++searchI;
            if (searchI === searchLen)
              break;
            searchLowerCode = searchLowerCodes[typoSimpleI === 0 ? searchI : typoSimpleI === searchI ? searchI + 1 : typoSimpleI === searchI - 1 ? searchI - 1 : searchI];
          }
          ++targetI;
          if (targetI >= targetLen) {
            for (; ; ) {
              if (searchI <= 1)
                return null;
              if (typoSimpleI === 0) {
                --searchI;
                var searchLowerCodeNew = searchLowerCodes[searchI];
                if (searchLowerCode === searchLowerCodeNew)
                  continue;
                typoSimpleI = searchI;
              } else {
                if (typoSimpleI === 1)
                  return null;
                --typoSimpleI;
                searchI = typoSimpleI;
                searchLowerCode = searchLowerCodes[searchI + 1];
                var searchLowerCodeNew = searchLowerCodes[searchI];
                if (searchLowerCode === searchLowerCodeNew)
                  continue;
              }
              matchesSimpleLen = searchI;
              targetI = matchesSimple[matchesSimpleLen - 1] + 1;
              break;
            }
          }
        }
        var searchI = 0;
        var typoStrictI = 0;
        var successStrict = false;
        var matchesStrictLen = 0;
        var nextBeginningIndexes = prepared._nextBeginningIndexes;
        if (nextBeginningIndexes === null)
          nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort3.prepareNextBeginningIndexes(
            prepared.target
          );
        var firstPossibleI = targetI = matchesSimple[0] === 0 ? 0 : nextBeginningIndexes[matchesSimple[0] - 1];
        if (targetI !== targetLen)
          for (; ; ) {
            if (typeof targetI !== "number")
              break;
            if (targetI >= targetLen) {
              if (searchI <= 0) {
                ++typoStrictI;
                if (typoStrictI > searchLen - 2)
                  break;
                if (searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI + 1])
                  continue;
                targetI = Number(firstPossibleI);
                continue;
              }
              --searchI;
              var lastMatch = matchesStrict[--matchesStrictLen];
              targetI = nextBeginningIndexes[lastMatch];
            } else {
              var isMatch = searchLowerCodes[typoStrictI === 0 ? searchI : typoStrictI === searchI ? searchI + 1 : typoStrictI === searchI - 1 ? searchI - 1 : searchI] === targetLowerCodes[targetI];
              if (isMatch) {
                matchesStrict[matchesStrictLen++] = targetI;
                ++searchI;
                if (searchI === searchLen) {
                  successStrict = true;
                  break;
                }
                ++targetI;
              } else {
                targetI = Number(nextBeginningIndexes[targetI]);
              }
            }
          }
        {
          if (successStrict) {
            var matchesBest = matchesStrict;
            var matchesBestLen = matchesStrictLen;
          } else {
            var matchesBest = matchesSimple;
            var matchesBestLen = matchesSimpleLen;
          }
          var score = 0;
          var lastTargetI = -1;
          for (var i2 = 0; i2 < searchLen; ++i2) {
            var targetI = matchesBest[i2];
            if (lastTargetI !== targetI - 1)
              score -= targetI;
            lastTargetI = targetI;
          }
          if (!successStrict) {
            score *= 1e3;
            if (typoSimpleI !== 0)
              score += -20;
          } else {
            if (typoStrictI !== 0)
              score += -20;
          }
          score -= targetLen - searchLen;
          prepared.score = score;
          prepared.indexes = new Array(matchesBestLen);
          for (var i2 = matchesBestLen - 1; i2 >= 0; --i2)
            prepared.indexes[i2] = matchesBest[i2];
          return prepared;
        }
      },
      /*
       * @COMMANDBAR START
       *   Handle exact matches for long strings
       */
      shouldExactSearch: function(targetString, minLengthForExactSearch) {
        if (minLengthForExactSearch === void 0)
          return false;
        return targetString.length > minLengthForExactSearch;
      },
      exactSearch: function(searchString, targetString, targetPrepared) {
        const index3 = targetString.toLowerCase().indexOf(searchString.toLowerCase());
        if (index3 === -1)
          return null;
        else {
          var indexes = [];
          for (var highlightIndex = index3; highlightIndex <= index3 + searchString.length; highlightIndex++) {
            indexes.push(highlightIndex);
          }
          return { ...targetPrepared, score: -50, indexes };
        }
      },
      /***************** @COMMANDBAR END ***********************/
      algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
        var targetLowerCodes = prepared._targetLowerCodes;
        var searchLen = searchLowerCodes.length;
        var targetLen = targetLowerCodes.length;
        var searchI = 0;
        var targetI = 0;
        var matchesSimpleLen = 0;
        for (; ; ) {
          var isMatch = searchLowerCode === targetLowerCodes[targetI];
          if (isMatch) {
            matchesSimple[matchesSimpleLen++] = targetI;
            ++searchI;
            if (searchI === searchLen)
              break;
            searchLowerCode = searchLowerCodes[searchI];
          }
          ++targetI;
          if (targetI >= targetLen)
            return null;
        }
        var searchI = 0;
        var successStrict = false;
        var matchesStrictLen = 0;
        var nextBeginningIndexes = prepared._nextBeginningIndexes;
        if (nextBeginningIndexes === null)
          nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort3.prepareNextBeginningIndexes(
            prepared.target
          );
        var firstPossibleI = targetI = matchesSimple[0] === 0 ? 0 : nextBeginningIndexes[matchesSimple[0] - 1];
        if (targetI !== targetLen)
          for (; ; ) {
            if (typeof targetI !== "number")
              break;
            if (targetI >= targetLen) {
              if (searchI <= 0)
                break;
              --searchI;
              var lastMatch = matchesStrict[--matchesStrictLen];
              targetI = nextBeginningIndexes[lastMatch];
            } else {
              var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI];
              if (isMatch) {
                matchesStrict[matchesStrictLen++] = targetI;
                ++searchI;
                if (searchI === searchLen) {
                  successStrict = true;
                  break;
                }
                ++targetI;
              } else {
                targetI = nextBeginningIndexes[targetI];
              }
            }
          }
        {
          if (successStrict) {
            var matchesBest = matchesStrict;
            var matchesBestLen = matchesStrictLen;
          } else {
            var matchesBest = matchesSimple;
            var matchesBestLen = matchesSimpleLen;
          }
          var score = 0;
          var lastTargetI = -1;
          for (var i2 = 0; i2 < searchLen; ++i2) {
            var targetI = matchesBest[i2];
            if (lastTargetI !== targetI - 1)
              score -= targetI;
            lastTargetI = targetI;
          }
          if (!successStrict)
            score *= 1e3;
          score -= targetLen - searchLen;
          prepared.score = score;
          prepared.indexes = new Array(matchesBestLen);
          for (var i2 = matchesBestLen - 1; i2 >= 0; --i2)
            prepared.indexes[i2] = matchesBest[i2];
          return prepared;
        }
      },
      prepareLowerCodes: function(str) {
        var strLen = str.length;
        var lowerCodes = [];
        var lower = str.toLowerCase();
        for (var i2 = 0; i2 < strLen; ++i2)
          lowerCodes[i2] = lower.charCodeAt(i2);
        return lowerCodes;
      },
      prepareBeginningIndexes: function(target) {
        var targetLen = target.length;
        var beginningIndexes = [];
        var beginningIndexesLen = 0;
        var wasUpper = false;
        var wasAlphanum = false;
        for (var i2 = 0; i2 < targetLen; ++i2) {
          var targetCode = target.charCodeAt(i2);
          var isUpper = targetCode >= 65 && targetCode <= 90;
          var isAlphanum = isUpper || targetCode >= 97 && targetCode <= 122 || targetCode >= 48 && targetCode <= 57;
          var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum;
          wasUpper = isUpper;
          wasAlphanum = isAlphanum;
          if (isBeginning)
            beginningIndexes[beginningIndexesLen++] = i2;
        }
        return beginningIndexes;
      },
      prepareNextBeginningIndexes: function(target) {
        var targetLen = target.length;
        var beginningIndexes = fuzzysort3.prepareBeginningIndexes(target);
        var nextBeginningIndexes = [];
        var lastIsBeginning = beginningIndexes[0];
        var lastIsBeginningI = 0;
        for (var i2 = 0; i2 < targetLen; ++i2) {
          if (lastIsBeginning > i2) {
            nextBeginningIndexes[i2] = lastIsBeginning;
          } else {
            lastIsBeginning = beginningIndexes[++lastIsBeginningI];
            nextBeginningIndexes[i2] = lastIsBeginning === void 0 ? targetLen : lastIsBeginning;
          }
        }
        return nextBeginningIndexes;
      },
      cleanup: cleanup2,
      new: fuzzysortNew
    };
    return fuzzysort3;
  }
  var isNode = typeof window === "undefined";
  var preparedCache = /* @__PURE__ */ new Map();
  var preparedSearchCache = /* @__PURE__ */ new Map();
  var noResults = [];
  noResults.total = 0;
  var matchesSimple = [];
  var matchesStrict = [];
  function cleanup2() {
    preparedCache.clear();
    preparedSearchCache.clear();
    matchesSimple = [];
    matchesStrict = [];
  }
  function defaultScoreFn(a) {
    var max = -9007199254740991;
    for (var i2 = a.length - 1; i2 >= 0; --i2) {
      var result = a[i2];
      if (result === null)
        continue;
      var score = result.score;
      if (score > max)
        max = score;
    }
    if (max === -9007199254740991)
      return null;
    return max;
  }
  function getValue(obj, prop) {
    var tmp = obj[prop];
    if (tmp !== void 0)
      return tmp;
    var segs = prop;
    if (!Array.isArray(prop))
      segs = prop.split(".");
    var len = segs.length;
    var i2 = -1;
    while (obj && ++i2 < len)
      obj = obj[segs[i2]];
    return obj;
  }
  function isObj(x) {
    return typeof x === "object";
  }
  var fastpriorityqueue = function() {
    var r = [], o = 0, e = {};
    function n() {
      for (var e2 = 0, n2 = r[e2], c = 1; c < o; ) {
        var f = c + 1;
        e2 = c, f < o && r[f].score < r[c].score && (e2 = f), r[e2 - 1 >> 1] = r[e2], c = 1 + (e2 << 1);
      }
      for (var a = e2 - 1 >> 1; e2 > 0 && n2.score < r[a].score; a = (e2 = a) - 1 >> 1)
        r[e2] = r[a];
      r[e2] = n2;
    }
    return e.add = function(e2) {
      var n2 = o;
      r[o++] = e2;
      for (var c = n2 - 1 >> 1; n2 > 0 && e2.score < r[c].score; c = (n2 = c) - 1 >> 1)
        r[n2] = r[c];
      r[n2] = e2;
    }, e.poll = function() {
      if (0 !== o) {
        var e2 = r[0];
        return r[0] = r[--o], n(), e2;
      }
    }, e.peek = function(e2) {
      if (0 !== o)
        return r[0];
    }, e.replaceTop = function(o2) {
      r[0] = o2, n();
    }, e;
  };
  var q = fastpriorityqueue();
  return fuzzysortNew();
}
var fuzzysort_default;
var init_fuzzysort = __esm({
  "commandbar/src/products/spotlight/store/search/fuzzysort-fork/fuzzysort.js"() {
    "use strict";
    fuzzysort_default = UMD;
  }
});

// internal/src/client/hotkeyConstants.ts
var orderedModifiers, SPECIAL_KEYS;
var init_hotkeyConstants = __esm({
  "internal/src/client/hotkeyConstants.ts"() {
    "use strict";
    orderedModifiers = ["meta", "mod", "cmd", "command", "ctrl", "alt", "option", "shift"];
    SPECIAL_KEYS = [
      "backspace",
      "tab",
      "enter",
      "return",
      "capslock",
      "esc",
      "escape",
      "space",
      "pageup",
      "pagedown",
      "end",
      "home",
      "left",
      "up",
      "right",
      "down",
      "ins",
      "del",
      "plus",
      "f1",
      "f2",
      "f3",
      "f4",
      "f5",
      "f6",
      "f7",
      "f8",
      "f9",
      "f10",
      "f11",
      "f12"
    ];
  }
});

// internal/src/client/Hotkey.ts
function escapeStringRegexp(commandHotkey) {
  return commandHotkey.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
var toArray, toString, toPlatformSpecificString, toModString, INVALID_ANCHORS, validate, validateEditorShortcutValues, isModifier, sortKeys, normalizeSequence, normalizeSequencePart, normalize2, translateToPlatformSymbol, mapHotkeysMacToWin, mapHotkeysWinToMac, checkForConflicts, Hotkey, Hotkey_default;
var init_Hotkey = __esm({
  "internal/src/client/Hotkey.ts"() {
    "use strict";
    init_hotkeyConstants();
    toArray = (v) => {
      if (typeof v !== "string" || v === "") {
        return [];
      }
      let _v = v.split(" ");
      _v = _v.reduce((acc, val, idx) => {
        if (idx === _v.length - 1) {
          return [...acc, val];
        }
        return [...acc, val, "then"];
      }, []);
      _v = _v.reduce((acc, val) => {
        if (val.includes("+")) {
          return [...acc, ...val.split("+")];
        }
        return [...acc, val];
      }, []);
      return _v;
    };
    toString = (v, platform = "mac") => {
      if (v.length === 0) {
        return "";
      }
      let _v = v.map((k) => {
        if (k === "command")
          return "mod";
        if (k === "option")
          return "alt";
        if (k === "ctrl" && platform === "win")
          return "mod";
        if (k === "meta" && platform === "mac")
          return "mod";
        return k;
      });
      _v = _v.join("+");
      _v = _v.split(/\+then\d?\+/);
      _v = _v.map((combo) => {
        if (typeof combo === "string") {
          return normalize2(combo);
        } else {
          return combo.join("+");
        }
      }).join(" ");
      return _v;
    };
    toPlatformSpecificString = (v, platform = "mac") => {
      if (v.length === 0) {
        return "";
      }
      if (platform === "mac") {
        v = v.replace(/mod/g, "command");
        v = v.replace(/meta/g, "command");
        v = v.replace(/alt/g, "option");
      } else {
        v = v.replace(/mod/g, "ctrl");
      }
      return v;
    };
    toModString = (v, platform = "mac") => {
      if (v.length === 0) {
        return "";
      }
      if (platform === "mac") {
        v = v.replace(/command/g, "mod");
        v = v.replace(/meta/g, "mod");
        v = v.replace(/option/g, "alt");
      } else {
        v = v.replace(/ctrl/g, "mod");
      }
      return v;
    };
    INVALID_ANCHORS = [" ", "+"];
    validate = (hotkey, allowUnknownKeys = false) => {
      if (hotkey === null || hotkey === void 0 || hotkey === "" || hotkey === " ")
        return false;
      const validAnchors = INVALID_ANCHORS.every((anchor) => {
        if (hotkey.startsWith(anchor))
          return false;
        if (hotkey.endsWith(anchor))
          return false;
        return true;
      });
      if (!validAnchors)
        return false;
      if (hotkey.split(" ").length > 3) {
        return false;
      }
      const sequence = hotkey.split(" ").map((i2) => {
        return i2.split("+");
      });
      const validItems = sequence.every((i2) => {
        if (i2.length === 0)
          return false;
        if (i2.length === 1 && isModifier(i2[0]))
          return false;
        let numNonModifiers = 0;
        const modifiers = {};
        for (const key of i2) {
          if (isModifier(key)) {
            modifiers[key] = (modifiers[key] || 0) + 1;
            if (modifiers[key] > 1)
              return false;
          } else {
            numNonModifiers++;
          }
        }
        if (numNonModifiers > 1)
          return false;
        if (!allowUnknownKeys) {
          const onlyKnownKeys = i2.every((j) => {
            if (j.length === 1 || isModifier(j) || SPECIAL_KEYS.includes(j)) {
              return true;
            } else {
              return false;
            }
          });
          return onlyKnownKeys;
        }
        return true;
      });
      if (!validItems)
        return false;
      return true;
    };
    validateEditorShortcutValues = (values) => {
      if (values.length === 0) {
        return [true, "ok"];
      }
      if (values.includes("then")) {
        return [false, "use a space to separate shortcut sequence parts"];
      }
      if ((values.match(/\s/g) || []).length > 2) {
        return [false, "at most 3 sequence parts are allowed"];
      }
      if (JSON.stringify(values) === JSON.stringify(["alt", "shift"]) || JSON.stringify(values) === JSON.stringify(["ctrl", "option"])) {
        return [false, "this is a browser protected accessibility shortcut"];
      }
      if (!validate(values)) {
        return [false, "a shortcut must be a combination of distinct modifiers and at most one non-modifier key"];
      }
      return [true, "ok"];
    };
    isModifier = (key) => {
      return orderedModifiers.includes(key);
    };
    sortKeys = (x, y) => {
      if (isModifier(x) && !isModifier(y)) {
        return -1;
      } else if (!isModifier(x) && isModifier(y)) {
        return 1;
      }
      return orderedModifiers.indexOf(x) - orderedModifiers.indexOf(y);
    };
    normalizeSequence = (sequence) => {
      return sequence.map((combo) => {
        if (typeof combo === "string") {
          return normalizeSequencePart(combo);
        }
        return combo.sort(sortKeys).join("+");
      }).join(" ");
    };
    normalizeSequencePart = (shortcut) => {
      return shortcut.toLowerCase().split("+").sort(sortKeys).join("+");
    };
    normalize2 = (shortcut) => {
      return normalizeSequence(shortcut.split(" "));
    };
    translateToPlatformSymbol = (k, platform = "mac", isLastKey = false) => {
      if (platform === "mac") {
        switch (k.toLowerCase()) {
          case "then":
            return " then ";
          case "command":
          case "meta":
          case "mod":
            return "\u2318";
          case "option":
          case "alt":
            return "\u2325";
          case "ctrl":
            return "^";
          case "shift":
            return "\u21E7";
          case "return":
            return "Return";
          default:
            if (k.length > 1) {
              return k.toLowerCase();
            } else {
              return k.toUpperCase();
            }
        }
      } else {
        switch (k.toLowerCase()) {
          case "then":
            return " then ";
          case "mod":
          case "ctrl":
            return isLastKey ? "Ctrl" : "Ctrl+";
          case "shift":
            return isLastKey ? "Shift" : "Shift+";
          case "option":
          case "alt":
            return isLastKey ? "Alt" : "Alt+";
          case "meta":
            return "\u229E";
          case "return":
            return "Return";
          default:
            if (k.length > 1) {
              return k.toLowerCase();
            } else {
              return k.toUpperCase();
            }
        }
      }
    };
    mapHotkeysMacToWin = (v) => {
      v = v.replace(/(command|meta)\+ctrl/g, "ctrl+alt");
      v = v.replace(/(command|meta)/g, "ctrl");
      v = v.replace(/option/g, "alt");
      return v;
    };
    mapHotkeysWinToMac = (v) => {
      v = v.replace(/ctrl/g, "command");
      v = v.replace(/meta/g, "command");
      v = v.replace(/alt/g, "option");
      return v;
    };
    checkForConflicts = (hotkey1, hotkey2) => {
      if (!hotkey1 || !hotkey2) {
        return false;
      }
      const isConflicting = new RegExp(`^${escapeStringRegexp(hotkey1)}($|\\s)`).test(hotkey2) || new RegExp(`^${escapeStringRegexp(hotkey2)}($|\\s)`).test(hotkey1);
      return isConflicting;
    };
    Hotkey = {
      toArray,
      toString,
      toPlatformSpecificString,
      toModString,
      translateToPlatformSymbol,
      validate,
      isModifier,
      normalize: normalize2,
      normalizeSequence,
      validateEditorShortcutValues,
      mapHotkeysMacToWin,
      mapHotkeysWinToMac,
      checkForConflicts
    };
    Hotkey_default = Hotkey;
  }
});

// commandbar/src/shared/util/Errors.tsx
var InternalError;
var init_Errors = __esm({
  "commandbar/src/shared/util/Errors.tsx"() {
    "use strict";
    InternalError = class extends Error {
      constructor(message) {
        super(message);
        this.name = "InternalError";
      }
    };
  }
});

// commandbar/src/shared/util/Interpolate.tsx
import _get2 from "lodash/get";
var COMMANDBAR_VARIABLE_REGEXP_INTERPOLATE, COMMANDBAR_CONTEXT_REFERENCE_REGEXP_INTERPOLATE, _getValue, _replaceString, interpolateObject, interpolate, interpolatePreviewItem, interpolatePreview;
var init_Interpolate = __esm({
  "commandbar/src/shared/util/Interpolate.tsx"() {
    "use strict";
    init_service_selectors4();
    init_Errors();
    COMMANDBAR_VARIABLE_REGEXP_INTERPOLATE = new RegExp(/{{([^{{]+)}}+/g);
    COMMANDBAR_CONTEXT_REFERENCE_REGEXP_INTERPOLATE = new RegExp(/{{(?:context|metadata).([^{{]+)}}+/g);
    _getValue = (value, key, throwErrorIfUndefined) => {
      if (value === void 0 || value === null) {
        return void 0;
      }
      switch (typeof value) {
        case "string":
        case "number":
          return value;
        case "object":
          if (Array.isArray(value)) {
            return value.toString();
          }
          if (key) {
            const toRet = _get2(value, key);
            if (toRet === void 0 && throwErrorIfUndefined) {
              throw new InternalError(`Cannot interpolate ${key} from metadata`);
            }
            return toRet;
          }
          return "";
      }
    };
    _replaceString = (str, re, fn) => {
      if (str === "") {
        return [""];
      }
      const result = str.split(re);
      for (let i2 = 1, length = result.length; i2 < length; i2 += 2) {
        result[i2] = fn(result[i2]);
      }
      return result;
    };
    interpolateObject = (args) => {
      const s = args.s;
      if (typeof s === "string") {
        const { _, interpolateContext, interpolateArgs, throwErrorIfUndefined, activeRecord } = args;
        return interpolate(s, _, interpolateContext, interpolateArgs, throwErrorIfUndefined, activeRecord);
      } else if (Array.isArray(s)) {
        const a = [];
        for (const value of s) {
          a.push(
            interpolateObject({
              ...args,
              s: value
            })
          );
        }
        return a;
      } else if (s && typeof s === "object") {
        const o = {};
        for (const p of Reflect.ownKeys(s)) {
          o[p] = interpolateObject({
            ...args,
            s: s[p]
          });
        }
        return o;
      }
      return s;
    };
    interpolate = (s, _, interpolateContext, interpolateArgs, throwErrorIfUndefined, activeRecord) => {
      let toRet = s;
      if (interpolateContext && (s.includes("{{context") || s.includes("{{metadata"))) {
        toRet = _replaceString(s, COMMANDBAR_CONTEXT_REFERENCE_REGEXP_INTERPOLATE, (match2) => {
          var _a2;
          const [contextKey, fallback] = match2.replace(/\s*\|\s*/g, "|").split("|");
          const contextValue = _getValue(
            _.context,
            contextKey || match2,
            // Throw an error only if there is no fallback
            !fallback && throwErrorIfUndefined
          );
          return (_a2 = _getValue(contextValue, "value", throwErrorIfUndefined)) != null ? _a2 : fallback;
        }).join("");
      }
      if (interpolateArgs && s.includes("{{")) {
        toRet = _replaceString(toRet, COMMANDBAR_VARIABLE_REGEXP_INTERPOLATE, (match2) => {
          const arg = match2.split(".")[0];
          const key = match2.split(".").slice(1).join(".");
          const selections = {
            ...getArgumentSelections(_),
            ...activeRecord && { record: activeRecord.parameter }
          };
          if (selections.hasOwnProperty(arg)) {
            return _getValue(selections[arg], key || "value");
          }
          return "";
        }).join("");
      }
      return toRet;
    };
    interpolatePreviewItem = (detailPreview, _, interpolateContext, interpolateArgs) => {
      if (typeof detailPreview === "string")
        return interpolate(detailPreview, _, interpolateContext, interpolateArgs);
      return {
        ...detailPreview,
        type: detailPreview.type,
        value: interpolate(detailPreview.value, _, interpolateContext, interpolateArgs)
      };
    };
    interpolatePreview = (detailPreview, _, interpolateContext, interpolateArgs) => {
      if (!detailPreview)
        return detailPreview;
      if (Array.isArray(detailPreview) && detailPreview.length === 0)
        return detailPreview;
      if (Array.isArray(detailPreview)) {
        return detailPreview.filter((i2) => {
          return !!i2;
        }).map((i2) => {
          return interpolatePreviewItem(i2, _, interpolateContext, interpolateArgs);
        });
      }
      return interpolatePreviewItem(detailPreview, _, interpolateContext, interpolateArgs);
    };
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/Option.tsx
var initOption;
var init_Option = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/Option.tsx"() {
    "use strict";
    init_detailPreview();
    init_Interpolate();
    initOption = (_, type39, label, value, _searchKeys, _detailPreview) => {
      const detailPreview = standardize(interpolatePreview(_detailPreview, _, true, false));
      const defaultCategoryMetadata = {
        label: "",
        contextKey: "",
        limit: null,
        renderAs: "list"
      };
      return {
        type: type39,
        label,
        value,
        detailPreview,
        optionDisabled: { isDisabled: false, isDisabledReason: "", reasonIsUserDefined: false },
        searchMatches: [],
        searchScore: void 0,
        groupKey: void 0,
        category: defaultCategoryMetadata
      };
    };
  }
});

// commandbar/src/shared/sdk/utils.tsx
function isEditorBeingSummoned(text) {
  var _a2;
  const dontAllowEditorOpen = ((_a2 = getSDK()[_instanceAttributes]) == null ? void 0 : _a2.canOpenEditor) === false;
  if (dontAllowEditorOpen)
    return false;
  return EDITOR_SUMMON_COMMANDS.includes(text.toLowerCase());
}
function isPrimitive2(a) {
  if (typeof a === "string")
    return true;
  if (typeof a === "number")
    return true;
  if (typeof a === "boolean")
    return true;
  return false;
}
function isHTML(str) {
  return /<\/?[a-z][\s\S]*>/i.test(str);
}
var EDITOR_SUMMON_COMMANDS;
var init_utils3 = __esm({
  "commandbar/src/shared/sdk/utils.tsx"() {
    "use strict";
    init_globals();
    init_symbols();
    EDITOR_SUMMON_COMMANDS = ["sudo editor", "open editor"];
  }
});

// commandbar/src/products/spotlight/store/DateTime/constants.ts
var WORDS_TO_AUTOCOMPLETE, DATES_TO_SUGGEST, MONTHS, FIXED_DATES, WEEKDAYS, THIS_NEXT_UNITS, IN_UNITS_PLURAL, IN_UNITS_SINGULAR, DATE_ONLY_IN_UNITS_SINGULAR, DATE_ONLY_IN_UNITS_PLURAL, AT_SUGGESTIONS, DEFAULTS_TIME_OPTIONS, NUMBERS, IN_SUGGESTIONS, ONLY_DATE_IN_SUGGESTIONS, DEFAULT_SUGGESTIONS, DEFAULT_DATE_ONLY_SUGGESTIONS;
var init_constants2 = __esm({
  "commandbar/src/products/spotlight/store/DateTime/constants.ts"() {
    "use strict";
    WORDS_TO_AUTOCOMPLETE = ["next", "this", "tomorrow", "today"];
    DATES_TO_SUGGEST = ["1st", "2nd", "3rd"];
    MONTHS = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ];
    FIXED_DATES = ["tomorrow", "tonight", "today", "evening", "yesterday", "weekend"];
    WEEKDAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    THIS_NEXT_UNITS = ["week", "weekend", "month"];
    IN_UNITS_PLURAL = ["minutes", "hours", "days", "weeks", "months", "years"];
    IN_UNITS_SINGULAR = ["minute", "hour", "day", "week", "month", "year"];
    DATE_ONLY_IN_UNITS_SINGULAR = ["hour", "day", "week", "month", "year"];
    DATE_ONLY_IN_UNITS_PLURAL = ["hours", "days", "weeks", "months", "years"];
    AT_SUGGESTIONS = ["today at 3pm", "tomorrow at 4pm", "Friday at 5pm"];
    DEFAULTS_TIME_OPTIONS = {
      hour: 8,
      minute: 0
    };
    NUMBERS = {
      1: "one",
      2: "two",
      3: "three",
      4: "four",
      5: "five",
      6: "six",
      7: "seven",
      8: "eight",
      9: "nine",
      10: "ten",
      15: "fifteen",
      20: "twenty",
      30: "thirty"
    };
    IN_SUGGESTIONS = [
      "in a few minutes",
      "in an hour",
      "in a minute",
      "in a day",
      "in a week",
      "in two weeks",
      "in a month"
    ];
    ONLY_DATE_IN_SUGGESTIONS = ["in a day", "in a week", "in two weeks", "in a month"];
    DEFAULT_SUGGESTIONS = [...IN_SUGGESTIONS, ...FIXED_DATES];
    DEFAULT_DATE_ONLY_SUGGESTIONS = [...ONLY_DATE_IN_SUGGESTIONS, ...FIXED_DATES];
  }
});

// commandbar/src/products/spotlight/store/DateTime/helpers.ts
import dayjs from "dayjs";
import objectSupport from "dayjs/plugin/objectSupport";
import { casual as chronoCasual } from "chrono-node";
function getNextDayOfWeek(date, dayOfWeek) {
  const resultDate = new Date(date.getTime());
  resultDate.setDate(date.getDate() + (7 + dayOfWeek - date.getDay()) % 7);
  return resultDate;
}
var getThisWeekend, getNextWeekend, customChrono, parseDate, specialUnits, getText, isMonth, suggestAt, getHour, randomDate, getWordByIndex, hasSpecialUnits, normalizeNumber, parseToSuggestionFormat, getSpecialUnitsSuggestions, getSuggestionsFromStringArray, getDefaultSuggestions;
var init_helpers3 = __esm({
  "commandbar/src/products/spotlight/store/DateTime/helpers.ts"() {
    "use strict";
    init_constants2();
    dayjs.extend(objectSupport);
    getThisWeekend = () => {
      return getNextDayOfWeek(/* @__PURE__ */ new Date(), 6);
    };
    getNextWeekend = () => {
      const date = /* @__PURE__ */ new Date();
      date.setDate(date.getDate() + 7);
      return getNextDayOfWeek(date, 6);
    };
    customChrono = chronoCasual.clone();
    customChrono.refiners.push({
      refine: (context, results) => {
        results.forEach((result) => {
          const hour = result.start.get("hour");
          if (!result.start.isCertain("meridiem") && result.start.isCertain("hour") && hour > 0 && hour < 12) {
            result.start.assign("meridiem", 1);
            result.start.assign("hour", hour + 12);
          }
        });
        return results;
      }
    });
    customChrono.parsers.push({
      pattern: () => {
        return /\bthis weekend\b/;
      },
      extract: (_context, _match) => {
        const date = getThisWeekend();
        return {
          day: date.getDate(),
          month: date.getMonth() + 1,
          hour: 8,
          minute: 0,
          meridiem: 0
        };
      }
    });
    customChrono.parsers.push({
      pattern: () => {
        return /\bnext weekend\b/i;
      },
      extract: (_context, _match) => {
        const date = getNextWeekend();
        return {
          day: date.getDate(),
          month: date.getMonth() + 1,
          hour: 8,
          minute: 0,
          meridiem: 0
        };
      }
    });
    customChrono.parsers.push({
      pattern: () => {
        return /\bweekend\b/i;
      },
      extract: (_context, _match) => {
        const date = getThisWeekend();
        return {
          day: date.getDate(),
          month: date.getMonth() + 1,
          hour: 8,
          minute: 0,
          meridiem: 0
        };
      }
    });
    parseDate = (input) => {
      return customChrono.parse(input, void 0);
    };
    specialUnits = {
      someday: () => ({ type: "datetime", date: dayjs(randomDate()) }),
      sometime: () => ({ type: "datetime", date: dayjs(randomDate()) })
    };
    getText = (string38, originalString) => {
      const splitOriginalString = originalString == null ? void 0 : originalString.split(" ");
      const originalStringFirstWord = splitOriginalString && splitOriginalString[0];
      const splitString = string38.split(" ");
      const firstWord = splitString[0];
      if (originalString && (originalStringFirstWord == null ? void 0 : originalStringFirstWord.toLocaleLowerCase()) === "in") {
        return originalString;
      }
      if (firstWord.toLowerCase() === "an") {
        return `in ${string38}`;
      }
      if (firstWord.toLowerCase() === "on") {
        return string38;
      }
      if (MONTHS.find((month) => month.toLowerCase().includes(firstWord.trim().toLowerCase()))) {
        splitString.unshift("on");
        return splitString.join(" ");
      }
      if (WEEKDAYS.find((day) => day.toLowerCase().includes(firstWord.trim().toLowerCase()))) {
        splitString.unshift("on");
        return splitString.join(" ");
      }
      return string38;
    };
    isMonth = (inputValue) => {
      const firstWord = inputValue.split(" ")[0];
      return MONTHS.find((month) => month.toLowerCase() === firstWord.toLowerCase());
    };
    suggestAt = (words) => {
      const res = ["8am", "9am", "10am"].map((time) => words.concat(time).join(" "));
      return res;
    };
    getHour = (text, knownHour, impliedHour) => {
      if (["morning", "noon", "afternoon", "evening", "midnight", "tonight", "night"].find(
        (item) => text.toLowerCase().includes(item)
      )) {
        return impliedHour;
      }
      if (knownHour === 0) {
        return knownHour;
      }
      return knownHour || DEFAULTS_TIME_OPTIONS.hour;
    };
    randomDate = (start2 = /* @__PURE__ */ new Date(), end = new Date(2050, 0, 1)) => {
      return new Date(start2.getTime() + Math.random() * (end.getTime() - start2.getTime()));
    };
    getWordByIndex = (query, index3) => {
      return query.split(" ")[index3];
    };
    hasSpecialUnits = (query) => {
      return Object.keys(specialUnits).some((unit) => query.startsWith(unit));
    };
    normalizeNumber = (word) => {
      if (isNaN(+word)) {
        return Object.keys(NUMBERS).find((key) => NUMBERS[key].includes(word));
      }
      return +word;
    };
    parseToSuggestionFormat = (parsingResults, specificType, query) => {
      return parsingResults.map((chronoObject) => {
        const result = {
          type: "datetime",
          specificType,
          label: getText(chronoObject.text, query),
          date: dayjs({
            year: chronoObject.start.get("year"),
            month: chronoObject.start.get("month") - 1,
            // align month (dayjs starts month counting from 0, but chrono starts from 1).
            day: chronoObject.start.get("day"),
            hour: getHour(chronoObject.text, chronoObject.start.knownValues.hour, chronoObject.start.impliedValues.hour),
            minute: chronoObject.start.knownValues.minute || DEFAULTS_TIME_OPTIONS.minute
          })
        };
        return result;
      });
    };
    getSpecialUnitsSuggestions = (inputValue) => {
      return Object.keys(specialUnits).filter((unit) => unit === inputValue).reduce((acc, cur) => {
        const formatted = {
          label: cur,
          ...specialUnits[cur]()
        };
        return acc.concat(formatted);
      }, []);
    };
    getSuggestionsFromStringArray = (array27, specificType) => {
      const suggestions = array27.reduce((acc, cur) => {
        const parsingResults = parseDate(cur);
        return acc.concat(...parseToSuggestionFormat(parsingResults, specificType, cur));
      }, []);
      return suggestions;
    };
    getDefaultSuggestions = (defaults11, specificType) => {
      return getSuggestionsFromStringArray(defaults11, specificType);
    };
  }
});

// commandbar/src/products/spotlight/store/DateTime/handlers.ts
var getInUnits, handleInSuggestions, handleOnSuggestions, handleThisNextSuggestions, handleAtSuggestions, handleNumberSuggestion;
var init_handlers = __esm({
  "commandbar/src/products/spotlight/store/DateTime/handlers.ts"() {
    "use strict";
    init_constants2();
    init_DateTime();
    init_helpers3();
    getInUnits = (isSingular, formatId) => {
      if (isSingular) {
        return formatId === DATE_AND_TIME_FORMAT_ID ? IN_UNITS_SINGULAR : DATE_ONLY_IN_UNITS_SINGULAR;
      }
      return formatId === DATE_AND_TIME_FORMAT_ID ? IN_UNITS_PLURAL : DATE_ONLY_IN_UNITS_PLURAL;
    };
    handleInSuggestions = (formatId, beginning, secondWord, thirdWord) => {
      const number31 = normalizeNumber(secondWord);
      if (MONTHS.includes(secondWord)) {
        return parseToSuggestionFormat(parseDate(`${beginning} ${secondWord}`), formatId);
      }
      const isSingularUnits = number31 === 1 || number31 === "one";
      const inUnits = getInUnits(isSingularUnits, formatId);
      if (!thirdWord) {
        const withSuggestedUnits = inUnits.map((unit) => `${beginning} ${number31} ${unit}`);
        return getSuggestionsFromStringArray(withSuggestedUnits, formatId);
      }
      const suggestedThirdWord = inUnits.find((unit) => unit.startsWith(thirdWord));
      if (suggestedThirdWord) {
        const string38 = `${beginning} ${number31} ${suggestedThirdWord}`;
        return parseToSuggestionFormat(parseDate(string38), formatId, string38);
      }
    };
    handleOnSuggestions = (formatId, beginning, secondWord, thirdWord, completeString) => {
      if (!secondWord) {
        return getSuggestionsFromStringArray(
          WEEKDAYS.map((day2) => `on ${day2}`),
          formatId
        );
      }
      const day = WEEKDAYS.find((day2) => day2.toLowerCase().includes(secondWord.trim().toLowerCase()));
      if (day && !thirdWord) {
        return parseToSuggestionFormat(parseDate(`${beginning} ${day}`), formatId);
      }
      if (thirdWord !== "at") {
        return parseToSuggestionFormat(parseDate(completeString), formatId);
      }
      const words = completeString.split(" ");
      const indexOfAt = words.indexOf("at");
      if (indexOfAt !== -1 && indexOfAt !== 0 && words.length - indexOfAt < 3) {
        const lastWord = words[words.length - 1];
        if (lastWord && lastWord !== "at") {
          return parseToSuggestionFormat(parseDate(completeString), formatId);
        }
        return getSuggestionsFromStringArray(suggestAt(words), formatId);
      }
      return parseToSuggestionFormat(parseDate(completeString), formatId);
    };
    handleThisNextSuggestions = (formatId, beginning, secondWord, thirdWord) => {
      if (!secondWord) {
        return getSuggestionsFromStringArray(
          THIS_NEXT_UNITS.map((unit) => `${beginning} ${unit}`),
          formatId
        );
      }
      const toSuggest = WEEKDAYS.concat(THIS_NEXT_UNITS).filter((day) => day.startsWith(secondWord));
      if (toSuggest.length && !thirdWord) {
        return getSuggestionsFromStringArray(
          toSuggest.map((suggestion) => `${beginning} ${suggestion}`),
          formatId
        );
      }
    };
    handleAtSuggestions = (formatId, beginning, secondWord, thirdWord, completeString) => {
      if (secondWord) {
        return parseToSuggestionFormat(parseDate(completeString), formatId);
      }
      return getSuggestionsFromStringArray(AT_SUGGESTIONS, formatId);
    };
    handleNumberSuggestion = (integer, formatId) => {
      const isSingular = parseInt(integer, 10) === 1;
      const day = isSingular ? "day" : "days";
      const week = isSingular ? "week" : "weeks";
      const suggestions = [`in ${integer} ${day}`, `in ${integer} ${week}`];
      return getSuggestionsFromStringArray(suggestions, formatId);
    };
  }
});

// commandbar/src/products/spotlight/store/DateTime/modifiers.ts
var completeSomeNumbers, completeMonth, capitalizeDay, autoCompleteMonth, autoCompleteWord, parseIfNumber;
var init_modifiers = __esm({
  "commandbar/src/products/spotlight/store/DateTime/modifiers.ts"() {
    "use strict";
    init_constants2();
    init_helpers3();
    completeSomeNumbers = (words) => {
      return words.map((item) => {
        if (item === "1s") {
          return "1st";
        }
        if (item === "2n") {
          return "2nd";
        }
        if (item === "3r") {
          return "3rd";
        }
        return item;
      });
    };
    completeMonth = (inputValue, formatId) => {
      const firstWord = inputValue.split(" ")[0];
      const secondWord = inputValue.split(" ")[1];
      if (secondWord !== "" && secondWord) {
        return parseToSuggestionFormat(parseDate(inputValue), formatId);
      }
      const datesSuggestions = DATES_TO_SUGGEST.map((date) => `${firstWord} ${date}`);
      return getSuggestionsFromStringArray(datesSuggestions, formatId);
    };
    capitalizeDay = (words) => {
      return words.map((word, i2) => {
        if (!word) {
          return word;
        }
        if (word.length < 1) {
          return word;
        }
        if (word.toLowerCase().startsWith("mon") && i2 === 2) {
          return word;
        }
        const day = WEEKDAYS.filter((day2) => day2.toLowerCase().startsWith(word.toLowerCase()))[0];
        return day || word;
      });
    };
    autoCompleteMonth = (words) => {
      return words.map((word, i2) => {
        if (!word || word.length < 3) {
          return word;
        }
        if (word.toLowerCase().startsWith("mon") && i2 === 2) {
          return word;
        }
        const month = MONTHS.filter((month2) => month2.toLowerCase().startsWith(word.toLowerCase()))[0];
        return month || word;
      });
    };
    autoCompleteWord = (words) => {
      return words.map((word) => {
        if (word.length < 2) {
          return word;
        }
        const autocompleted = WORDS_TO_AUTOCOMPLETE.find((completed) => completed.startsWith(word));
        return autocompleted || word;
      });
    };
    parseIfNumber = (words) => {
      return words.map((word) => {
        const index3 = word.indexOf("t");
        if (index3 === -1) {
          return word;
        }
        const number31 = word.slice(0, index3);
        if (!number31 || isNaN(+number31)) {
          return word;
        }
        return number31;
      });
    };
  }
});

// commandbar/src/products/spotlight/store/DateTime/DateTime.tsx
import fuzzysort from "fuzzysort";
function isNormalInteger(str) {
  return /^\+?(0|[1-9]\d*)$/.test(str);
}
var DATE_AND_TIME_FORMAT_ID, DATE_ONLY_FORMAT_ID, TIME_ONLY_FORMAT_ID, DEFAULT_DAY_SUGGESTIONS, getParsedString, suggestionHandlers, FUZZY_TARGET, getFuzzyDefaultSuggestions, dateAndTime, dayOnly, parsers, search, display, clientReturnValue, DateTime, DateTime_default;
var init_DateTime = __esm({
  "commandbar/src/products/spotlight/store/DateTime/DateTime.tsx"() {
    "use strict";
    init_constants2();
    init_handlers();
    init_helpers3();
    init_modifiers();
    DATE_AND_TIME_FORMAT_ID = 1;
    DATE_ONLY_FORMAT_ID = 2;
    TIME_ONLY_FORMAT_ID = 3;
    DEFAULT_DAY_SUGGESTIONS = ["today", "tomorrow", "next Monday", "next week"];
    getParsedString = (input) => {
      const handlers2 = [autoCompleteWord, autoCompleteMonth, parseIfNumber, capitalizeDay, completeSomeNumbers];
      return handlers2.reduce((acc, cur) => {
        return cur(acc);
      }, input.split(" ")).join(" ");
    };
    suggestionHandlers = {
      in: handleInSuggestions,
      on: handleOnSuggestions,
      this: handleThisNextSuggestions,
      next: handleThisNextSuggestions,
      at: handleAtSuggestions
    };
    FUZZY_TARGET = [
      "this day",
      "this month",
      "this weekend",
      "next day",
      "next month",
      "last day",
      "last month",
      "last Monday",
      "last week",
      "last weekend",
      "today",
      "tomorrow",
      "on Monday",
      "on Tuesday",
      "on Wednesday",
      "on Thursday",
      "on Friday",
      "on Saturday",
      "on Sunday",
      "weekend",
      "week",
      "at 3pm",
      "at 8pm"
    ];
    getFuzzyDefaultSuggestions = (query, formatId) => {
      const fuzyResult = fuzzysort.go(query, FUZZY_TARGET).map(({ target }) => target);
      return getSuggestionsFromStringArray(fuzyResult, formatId);
    };
    dateAndTime = (inputValue, specificType) => {
      const parsedInput = getParsedString(inputValue);
      if (!parsedInput) {
        return getDefaultSuggestions(DEFAULT_SUGGESTIONS, specificType);
      }
      const filtered = DEFAULT_SUGGESTIONS.filter(
        (suggestion) => suggestion.toLowerCase().startsWith(parsedInput.toLowerCase())
      );
      if (filtered.length) {
        return getSuggestionsFromStringArray(filtered, specificType);
      }
      const beginning = getWordByIndex(parsedInput, 0);
      const secondWord = getWordByIndex(parsedInput, 1);
      const thirdWord = getWordByIndex(parsedInput, 2);
      if (isNormalInteger(beginning) && !secondWord) {
        return handleNumberSuggestion(beginning, specificType);
      }
      const handleSuggestions = suggestionHandlers[beginning];
      if (handleSuggestions) {
        const handledSuggestions = handleSuggestions(
          DATE_AND_TIME_FORMAT_ID,
          beginning,
          secondWord,
          thirdWord,
          parsedInput
        );
        if (handledSuggestions == null ? void 0 : handledSuggestions.length) {
          return handledSuggestions;
        }
        const parsedSuggestions = parseToSuggestionFormat(parseDate(parsedInput), specificType, parsedInput);
        if (parsedSuggestions.length) {
          return parsedSuggestions;
        }
        return getFuzzyDefaultSuggestions(inputValue, specificType);
      }
      if (hasSpecialUnits(parsedInput)) {
        const specialUnitsSuggestion = getSpecialUnitsSuggestions(parsedInput);
        if (specialUnitsSuggestion.length) {
          return specialUnitsSuggestion;
        }
        return getFuzzyDefaultSuggestions(inputValue, specificType);
      }
      const words = parsedInput.split(" ");
      const indexOfAt = words.map((item) => item.toLowerCase()).indexOf("at");
      if (indexOfAt !== -1 && indexOfAt !== 0 && words.length - indexOfAt < 3) {
        const lastWord = words[words.length - 1];
        if (lastWord && lastWord !== "at") {
          const suggestions3 = parseToSuggestionFormat(parseDate(parsedInput), specificType, parsedInput);
          return suggestions3.length ? suggestions3 : getFuzzyDefaultSuggestions(inputValue, specificType);
        }
        const suggestions2 = getSuggestionsFromStringArray(suggestAt(words), specificType);
        return suggestions2.length ? suggestions2 : getFuzzyDefaultSuggestions(inputValue, specificType);
      }
      if (isMonth(parsedInput)) {
        const monthSuggestions = completeMonth(parsedInput, specificType);
        return monthSuggestions.length ? monthSuggestions : getFuzzyDefaultSuggestions(inputValue, specificType);
      }
      const suggestions = parseToSuggestionFormat(parseDate(parsedInput), specificType, parsedInput);
      return suggestions.length ? suggestions : getFuzzyDefaultSuggestions(inputValue, specificType);
    };
    dayOnly = (inputValue, _) => {
      const parsedInput = getParsedString(inputValue);
      if (!parsedInput) {
        return getDefaultSuggestions(DEFAULT_DAY_SUGGESTIONS, DATE_ONLY_FORMAT_ID);
      }
      const filtered = DEFAULT_DATE_ONLY_SUGGESTIONS.filter(
        (suggestion) => suggestion.toLowerCase().startsWith(parsedInput.toLowerCase())
      );
      if (filtered.length) {
        return getSuggestionsFromStringArray(filtered, DATE_ONLY_FORMAT_ID);
      }
      const beginning = getWordByIndex(parsedInput, 0);
      const secondWord = getWordByIndex(parsedInput, 1);
      const thirdWord = getWordByIndex(parsedInput, 2);
      if (isNormalInteger(beginning) && !secondWord) {
        const numberSuggestions = handleNumberSuggestion(beginning, DATE_ONLY_FORMAT_ID);
        if (numberSuggestions.length) {
          return numberSuggestions;
        }
        return getFuzzyDefaultSuggestions(inputValue, DATE_AND_TIME_FORMAT_ID);
      }
      const handleSuggestions = suggestionHandlers[beginning];
      if (handleSuggestions) {
        const handledSuggestions = handleSuggestions(DATE_ONLY_FORMAT_ID, beginning, secondWord, thirdWord, parsedInput);
        if (handledSuggestions == null ? void 0 : handledSuggestions.length) {
          return handledSuggestions;
        }
        const parsedSuggestions = parseToSuggestionFormat(parseDate(parsedInput), DATE_ONLY_FORMAT_ID, parsedInput);
        if (parsedSuggestions.length) {
          return parsedSuggestions;
        }
        return getFuzzyDefaultSuggestions(inputValue, DATE_ONLY_FORMAT_ID);
      }
      if (hasSpecialUnits(parsedInput)) {
        const specialUnitsSuggestion = getSpecialUnitsSuggestions(parsedInput);
        if (specialUnitsSuggestion.length) {
          return specialUnitsSuggestion;
        }
        return getFuzzyDefaultSuggestions(inputValue, DATE_ONLY_FORMAT_ID);
      }
      const words = parsedInput.split(" ");
      const indexOfAt = words.map((item) => item.toLowerCase()).indexOf("at");
      if (indexOfAt !== -1 && indexOfAt !== 0 && words.length - indexOfAt < 3) {
        const lastWord = words[words.length - 1];
        if (lastWord && lastWord !== "at") {
          const suggestions3 = parseToSuggestionFormat(parseDate(parsedInput), DATE_ONLY_FORMAT_ID, parsedInput);
          return suggestions3.length ? suggestions3 : getFuzzyDefaultSuggestions(inputValue, DATE_ONLY_FORMAT_ID);
        }
        const suggestions2 = getSuggestionsFromStringArray(suggestAt(words), DATE_ONLY_FORMAT_ID);
        return suggestions2.length ? suggestions2 : getFuzzyDefaultSuggestions(inputValue, DATE_ONLY_FORMAT_ID);
      }
      if (isMonth(parsedInput)) {
        const monthSuggestions = completeMonth(parsedInput, DATE_ONLY_FORMAT_ID);
        return monthSuggestions.length ? monthSuggestions : getFuzzyDefaultSuggestions(inputValue, DATE_ONLY_FORMAT_ID);
      }
      const suggestions = parseToSuggestionFormat(parseDate(parsedInput), DATE_ONLY_FORMAT_ID, parsedInput);
      return suggestions.length ? suggestions : getFuzzyDefaultSuggestions(inputValue, DATE_ONLY_FORMAT_ID);
    };
    parsers = {
      [DATE_AND_TIME_FORMAT_ID]: dateAndTime,
      [DATE_ONLY_FORMAT_ID]: dayOnly,
      [TIME_ONLY_FORMAT_ID]: dateAndTime
    };
    search = (params) => {
      const {
        inputValue = "",
        // this string to parsed
        type: type39
      } = params;
      const parserInstance = parsers[type39];
      if (!parserInstance) {
        return dateAndTime(inputValue, DATE_AND_TIME_FORMAT_ID);
      }
      return parserInstance(inputValue, type39);
    };
    display = (date, specificType, upperCase = true) => {
      switch (specificType) {
        case DATE_AND_TIME_FORMAT_ID: {
          return upperCase ? date.format("ddd, MMM D, YYYY, h:mm A").toUpperCase() : date.format("ddd, MMM D, YYYY, h:mm A");
        }
        case DATE_ONLY_FORMAT_ID: {
          return upperCase ? date.format("ddd, MMM D, YYYY").toUpperCase() : date.format("ddd, MMM D, YYYY");
        }
        case TIME_ONLY_FORMAT_ID: {
          return upperCase ? date.format("h:mm A").toUpperCase() : date.format("h:mm A");
        }
        default: {
          return upperCase ? date.format("ddd, MMM D, YYYY").toUpperCase() : date.format("ddd, MMM D, YYYY");
        }
      }
    };
    clientReturnValue = (date) => {
      return date.toDate();
    };
    DateTime = {
      search,
      display,
      clientReturnValue
    };
    DateTime_default = DateTime;
  }
});

// commandbar/src/products/spotlight/store/options/record-option-selectors.ts
var getDefaultCommandId, getRecordCategoryIcon, getRecordCategoryImage;
var init_record_option_selectors = __esm({
  "commandbar/src/products/spotlight/store/options/record-option-selectors.ts"() {
    "use strict";
    getDefaultCommandId = (o) => {
      var _a2;
      return (_a2 = o.searchOptions) == null ? void 0 : _a2.default_command_id;
    };
    getRecordCategoryIcon = (o) => {
      var _a2, _b2;
      return { icon: ((_a2 = o.searchOptions) == null ? void 0 : _a2.icon) || null, icon_color: ((_b2 = o.searchOptions) == null ? void 0 : _b2.icon_color) || null };
    };
    getRecordCategoryImage = (o) => {
      var _a2, _b2;
      return { image: ((_a2 = o.searchOptions) == null ? void 0 : _a2.image) || null, image_color: ((_b2 = o.searchOptions) == null ? void 0 : _b2.image_color) || null };
    };
  }
});

// commandbar/src/shared/util/a11y.ts
var A11Y_CONFIG, a11y_default;
var init_a11y = __esm({
  "commandbar/src/shared/util/a11y.ts"() {
    "use strict";
    A11Y_CONFIG = {
      listId: "commandbar-menu",
      optionId: (index3) => `commandbar-option-${index3}`,
      optionContentId: (index3) => `commandbar-option-${index3}-content`,
      listLabel: "List of options",
      dialogLabel: "commandbar",
      listRole: "listbox",
      inputRole: "combobox",
      optionRole: "option",
      groupRole: "group",
      emptyListId: "commandbar-empty-menu",
      commandbarInputId: "commandbar-input-search",
      categoryId: (opt) => `category-${opt.name}`
    };
    a11y_default = A11Y_CONFIG;
  }
});

// commandbar/src/shared/store/helpers.ts
var extractSlashFilter, isAvailableToEndUser;
var init_helpers4 = __esm({
  "commandbar/src/shared/store/helpers.ts"() {
    "use strict";
    extractSlashFilter = (input) => {
      const words = input.split(" ");
      const lastWord = words.pop();
      if (!!lastWord && lastWord.startsWith("/")) {
        const slashIndex = words.reduce((previousValue, currentValue) => previousValue + currentValue.length, 0) + words.length;
        return {
          inputText: input.substring(0, slashIndex),
          slashFilter: lastWord,
          slashFilterKeyword: lastWord.substring(1)
        };
      } else {
        return { inputText: input, slashFilter: "", slashFilterKeyword: "" };
      }
    };
    isAvailableToEndUser = (_, item) => item.is_live || _.isAdmin;
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/DashboardStep.tsx
var initDashboardStep;
var init_DashboardStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/DashboardStep.tsx"() {
    "use strict";
    init_Step();
    initDashboardStep = (argument, command) => {
      const s = initStep("dashboard" /* Dashboard */);
      s.command = command;
      s.argument = argument;
      s.selected = null;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/dashboard-step-helpers.ts
var getDashboardStepBreadcrumb, selectDashboardStep;
var init_dashboard_step_helpers = __esm({
  "commandbar/src/products/spotlight/store/steps/dashboard-step-helpers.ts"() {
    "use strict";
    init_DashboardStep();
    getDashboardStepBreadcrumb = (s) => {
      if (!!s.argument.label) {
        return s.argument.label;
      }
      if (s.argument.type === "video") {
        return "Watch Video";
      }
      if (s.argument.type === "html") {
        return "Read Document";
      }
      return s.argument.label || "Watch Video";
    };
    selectDashboardStep = (s) => {
      const newStep = initDashboardStep(s.argument);
      newStep.completed = s.completed;
      return newStep;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/BaseStep.tsx
var initBaseStep;
var init_BaseStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/BaseStep.tsx"() {
    "use strict";
    init_Step();
    initBaseStep = (resource) => {
      const s = initStep("base" /* Base */);
      s.selected = null;
      s.resource = resource;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/choose-step-helpers.ts
var getBaseStepBlock, selectBaseStep;
var init_choose_step_helpers = __esm({
  "commandbar/src/products/spotlight/store/steps/choose-step-helpers.ts"() {
    "use strict";
    init_helpers8();
    init_BaseStep();
    getBaseStepBlock = (s) => {
      if (s.selected !== null && s.selected.type === "command") {
        return s.selected.label;
      }
      if (s.resource) {
        return s.resource.label;
      }
      return void 0;
    };
    selectBaseStep = (s, o) => {
      if (isCommandOption(o)) {
        const newStep = initBaseStep(s.resource);
        newStep.selected = {
          type: "command",
          label: o.label,
          category: o.command.category,
          data: o.command
        };
        newStep.completed = s.completed;
        return newStep;
      }
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/MultiSelectStep.tsx
var initMultiSelectStep;
var init_MultiSelectStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/MultiSelectStep.tsx"() {
    "use strict";
    init_Step();
    initMultiSelectStep = (argument) => {
      const s = initStep("multiselect" /* MultiSelect */);
      s.argument = argument;
      s.selected = null;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/multi-select-step-helpers.ts
import isEqual2 from "lodash/isEqual";
var getMultiSelectStepBlock, selectMultiSelectStep;
var init_multi_select_step_helpers = __esm({
  "commandbar/src/products/spotlight/store/steps/multi-select-step-helpers.ts"() {
    "use strict";
    init_DateTime();
    init_helpers8();
    init_MultiSelectStep();
    init_selectors3();
    getMultiSelectStepBlock = (s, _) => {
      if (s.selected === null) {
        return s.argument.userDefinedName;
      }
      if (s.selected.type !== "parameter") {
        return s.argument.userDefinedName;
      }
      if (!Array.isArray(s.selected.data)) {
        throw new Error("Multi select selected must be an array");
      } else {
        if (s.selected.data.length === 0) {
          return s.argument.userDefinedName;
        }
        const contextSettings = getContextSettings(_);
        const selectedChoicesLabels = s.selected.data.map((val) => {
          return getArgumentChoiceLabel(s.argument, val, contextSettings);
        });
        return selectedChoicesLabels.join(", ");
      }
    };
    selectMultiSelectStep = (s, o) => {
      var _a2;
      if (!isParameterOption(o)) {
        return s;
      }
      let newParam = o.parameter;
      if (isDateTimeOption(o)) {
        newParam = DateTime_default.clientReturnValue(o.parameter.date);
      }
      const newSelections = ((_a2 = s.selected) == null ? void 0 : _a2.data) ? [...s.selected.data] : [];
      const index3 = newSelections.findIndex((s2) => isEqual2(s2, newParam));
      if (index3 > -1) {
        newSelections.splice(index3, 1);
      } else {
        newSelections.push(newParam);
      }
      const newStep = initMultiSelectStep(s.argument);
      newStep.selected = {
        type: "parameter",
        category: null,
        data: newSelections
      };
      newStep.completed = s.completed;
      return newStep;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/SelectStep.tsx
var initSelectStep;
var init_SelectStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/SelectStep.tsx"() {
    "use strict";
    init_Step();
    initSelectStep = (argument) => {
      const s = initStep("select" /* Select */);
      s.argument = argument;
      s.selected = null;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/select-step-helpers.ts
var getSelectStepBlock, selectSelectStep;
var init_select_step_helpers = __esm({
  "commandbar/src/products/spotlight/store/steps/select-step-helpers.ts"() {
    "use strict";
    init_DateTime();
    init_SelectStep();
    init_selectors3();
    init_helpers8();
    getSelectStepBlock = (s, _) => {
      if (!s.completed || s.selected === null) {
        return s.argument.userDefinedName;
      }
      if (s.selected.type !== "parameter") {
        return s.argument.userDefinedName;
      }
      if (Array.isArray(s.selected.data)) {
        throw new Error("Selected must be an object");
      } else {
        const contextSettings = getContextSettings(_);
        return getArgumentChoiceLabel(s.argument, s.selected.data, contextSettings);
      }
    };
    selectSelectStep = (s, o) => {
      if (!isParameterOption(o)) {
        return s;
      }
      const newStep = initSelectStep(s.argument);
      let data = o.parameter;
      if (isDateTimeOption(o)) {
        data = DateTime_default.clientReturnValue(o.parameter.date);
      }
      newStep.selected = {
        type: "parameter",
        category: null,
        data
      };
      newStep.completed = s.completed;
      return newStep;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/TextInputStep.tsx
var initTextInputStep;
var init_TextInputStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/TextInputStep.tsx"() {
    "use strict";
    init_Step();
    initTextInputStep = (argument) => {
      const s = initStep("textinput" /* TextInput */);
      s.argument = argument;
      s.selected = null;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/LongTextInputStep.tsx
var initLongTextInputStep;
var init_LongTextInputStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/LongTextInputStep.tsx"() {
    "use strict";
    init_Step();
    init_TextInputStep();
    initLongTextInputStep = (argument) => {
      const s = initTextInputStep(argument);
      s.type = "longtextinput" /* LongTextInput */;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/steps/text-input-step-helpers.ts
var getTextInputStepBlock, selectTextInputStep;
var init_text_input_step_helpers = __esm({
  "commandbar/src/products/spotlight/store/steps/text-input-step-helpers.ts"() {
    "use strict";
    init_LongTextInputStep();
    init_TextInputStep();
    init_helpers8();
    getTextInputStepBlock = (s) => {
      if (s.selected === null) {
        return s.argument.userDefinedName;
      }
      if (s.selected.type !== "parameter") {
        return s.argument.userDefinedName;
      }
      return s.selected.data;
    };
    selectTextInputStep = (s, o) => {
      if (!isParameterOption(o)) {
        return s;
      }
      const newStep = s.type === "longtextinput" ? initLongTextInputStep(s.argument) : initTextInputStep(s.argument);
      newStep.selected = {
        type: "parameter",
        category: null,
        data: String(o.value)
      };
      newStep.completed = s.completed;
      return newStep;
    };
  }
});

// commandbar/src/shared/util/assertNever.ts
var assertNever;
var init_assertNever = __esm({
  "commandbar/src/shared/util/assertNever.ts"() {
    "use strict";
    assertNever = (_) => {
      throw new Error("Invariant Violation: unreachable code detected");
    };
  }
});

// commandbar/src/products/spotlight/store/steps/helpers.ts
var getStepBlock, getStepPlaceholder, getStepSelection, hasArgument, selectStep;
var init_helpers5 = __esm({
  "commandbar/src/products/spotlight/store/steps/helpers.ts"() {
    "use strict";
    init_dashboard_step_helpers();
    init_choose_step_helpers();
    init_multi_select_step_helpers();
    init_select_step_helpers();
    init_text_input_step_helpers();
    init_Step();
    init_assertNever();
    init_choose_step_helpers();
    init_multi_select_step_helpers();
    init_select_step_helpers();
    init_text_input_step_helpers();
    getStepBlock = (s, _) => {
      switch (s.type) {
        case "base" /* Base */:
          return getBaseStepBlock(s);
        case "execute" /* Execute */:
          return void 0;
        case "dashboard" /* Dashboard */:
          return getDashboardStepBreadcrumb(s);
        case "multiselect" /* MultiSelect */:
          return getMultiSelectStepBlock(s, _);
        case "select" /* Select */:
          return getSelectStepBlock(s, _);
        case "textinput" /* TextInput */:
        case "longtextinput" /* LongTextInput */:
          return getTextInputStepBlock(s);
        default:
          return assertNever(s);
      }
    };
    getStepPlaceholder = (s) => hasArgument(s) ? String(s.argument.userDefinedName) : null;
    getStepSelection = (s) => {
      switch (s.type) {
        case "base" /* Base */:
        case "dashboard" /* Dashboard */:
        case "execute" /* Execute */:
          return {};
        case "longtextinput" /* LongTextInput */:
        case "multiselect" /* MultiSelect */:
        case "select" /* Select */:
        case "textinput" /* TextInput */:
          if (s.selected === null) {
            return s.type === "multiselect" /* MultiSelect */ ? { [s.argument.userDefinedValue]: [] } : {};
          }
          if (s.selected.type !== "parameter") {
            return {};
          }
          return { [s.argument.userDefinedValue]: s.selected.data };
        default:
          return assertNever(s);
      }
    };
    hasArgument = (s) => {
      switch (s.type) {
        case "base" /* Base */:
        case "dashboard" /* Dashboard */:
        case "execute" /* Execute */:
          return false;
        case "longtextinput" /* LongTextInput */:
        case "multiselect" /* MultiSelect */:
        case "select" /* Select */:
        case "textinput" /* TextInput */:
          return true;
        default:
          return assertNever(s);
      }
    };
    selectStep = (s, o) => {
      switch (s.type) {
        case "base" /* Base */:
          return selectBaseStep(s, o);
        case "execute" /* Execute */:
          return s;
        case "dashboard" /* Dashboard */:
          return selectDashboardStep(s);
        case "longtextinput" /* LongTextInput */:
        case "textinput" /* TextInput */:
          return selectTextInputStep(s, o);
        case "multiselect" /* MultiSelect */:
          return selectMultiSelectStep(s, o);
        case "select" /* Select */:
          return selectSelectStep(s, o);
        default:
          return assertNever(s);
      }
    };
  }
});

// internal/src/util/slugify.ts
function slugify(str) {
  str = str.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "").replace(/-+/g, "-");
  return str;
}
var slugify_default;
var init_slugify = __esm({
  "internal/src/util/slugify.ts"() {
    "use strict";
    slugify_default = slugify;
  }
});

// commandbar/src/shared/util/constants.ts
var SUMMON_HOTKEY_SLUG;
var init_constants3 = __esm({
  "commandbar/src/shared/util/constants.ts"() {
    "use strict";
    SUMMON_HOTKEY_SLUG = "__commandbar_summon_hotkey";
  }
});

// commandbar/src/products/spotlight/store/search/ClientSearch.tsx
var get4, isDefined, ClientSearch, ClientSearch_default;
var init_ClientSearch = __esm({
  "commandbar/src/products/spotlight/store/search/ClientSearch.tsx"() {
    "use strict";
    init_Logger();
    get4 = (key, _) => {
      const searchResults = _.spotlight.records[key];
      let records;
      if (searchResults) {
        records = searchResults.records;
      } else {
        records = _.context[key];
      }
      if (!Array.isArray(records)) {
        Logger_default.warn(`Client search results and initial value for ${key} must be an array`);
      }
      return records;
    };
    isDefined = (key, _) => {
      return Object.keys(_.callbacks).some((callbackKey) => callbackKey.includes(`commandbar-search-${key}`));
    };
    ClientSearch = {
      isDefined,
      get: get4
    };
    ClientSearch_default = ClientSearch;
  }
});

// internal/src/client/RulesParser.ts
import _get3 from "lodash/get";
var trimQuotes, parsePossibleNumericValue, parseStringValue, sanitizeUrl, getLeftOperand, getOptionalNumbericOperand, getOptionalDateOperand, getAnalyticsLeftOperand, evaluateMultiValueRule, evaluateRule, evaluateRules, end_user_analytics_keys, evaluateRuleExpression, RulesParser_default;
var init_RulesParser = __esm({
  "internal/src/client/RulesParser.ts"() {
    "use strict";
    init_rules();
    init_dom();
    init_operatingSystem();
    init_location();
    trimQuotes = (str) => str.replace(/(^["']|["']$)/gm, "");
    parsePossibleNumericValue = (value) => {
      if (value === "null") {
        return null;
      }
      return isNaN(Number(value)) ? `${parseStringValue(value)}` : Number(value);
    };
    parseStringValue = (value) => {
      const trimmedString = `${value == null ? void 0 : value.toString()}`.trim();
      return trimQuotes(trimmedString);
    };
    sanitizeUrl = (location) => {
      const params = new URLSearchParams(location.search);
      params.delete("cb-eid");
      let newURL = location.pathname;
      const paramString = params.toString();
      if (paramString) {
        newURL += "?" + paramString;
      }
      newURL += location.hash;
      return newURL;
    };
    getLeftOperand = (rule, context, location, analytics2, remoteProperties, interactions, eventProperties) => {
      var _a2, _b2, _c2, _d, _e, _f;
      switch (rule.type) {
        case "executions":
        case "shortcuts":
        case "last_seen":
        case "first_seen":
        case "sessions":
        case "opens":
        case "deadends":
          return getAnalyticsLeftOperand(rule, analytics2);
        case "url":
          return sanitizeUrl(location);
        case "hostname":
          return location.hostname;
        case "context":
          if (!!rule.field) {
            return _get3(context, rule.field);
          }
          break;
        case "event_property":
          if (!!rule.field) {
            return _get3(eventProperties, rule.field);
          }
          break;
        case "heap":
          if (!!rule.field) {
            return _get3(remoteProperties, "heap." + rule.field);
          }
          break;
        case "hubspot":
          if (!!rule.field) {
            return _get3(remoteProperties, "hubspot." + rule.field);
          }
          break;
        case "amplitude": {
          if (rule.field) {
            return _get3(remoteProperties, "amplitude." + rule.field);
          }
          break;
        }
        case "device_type":
          return getDeviceType();
        case "browser":
          return getBrowser();
        case "os":
          return getOperatingSystem();
        case "language":
          return navigator.language;
        case "questlist_interaction":
          if (!!(interactions == null ? void 0 : interactions.checklists)) {
            const isViewed = !!((_a2 = interactions == null ? void 0 : interactions.checklists[rule.questlist_id]) == null ? void 0 : _a2.isSeen);
            const isCompleted = !!((_b2 = interactions == null ? void 0 : interactions.checklists[rule.questlist_id]) == null ? void 0 : _b2.isCompleted);
            const isDismissed = !!((_c2 = interactions == null ? void 0 : interactions.checklists[rule.questlist_id]) == null ? void 0 : _c2.isSkipped);
            const states5 = [];
            if (isCompleted)
              states5.push("completed");
            if (isDismissed)
              states5.push("dismissed");
            if (isViewed)
              states5.push("viewed");
            return states5;
          }
          break;
        case "nudge_interaction":
          if (!!(interactions == null ? void 0 : interactions.nudges)) {
            const isViewed = !!((_d = interactions == null ? void 0 : interactions.nudges[rule.nudge_id]) == null ? void 0 : _d.nudgeSeen);
            const isCompleted = !!((_e = interactions == null ? void 0 : interactions.nudges[rule.nudge_id]) == null ? void 0 : _e.nudgeCompleted);
            const isDismissed = !!((_f = interactions == null ? void 0 : interactions.nudges[rule.nudge_id]) == null ? void 0 : _f.nudgeDismissed);
            const states5 = [];
            if (isCompleted)
              states5.push("completed");
            if (isDismissed)
              states5.push("dismissed");
            if (isViewed)
              states5.push("viewed");
            return states5;
          }
          break;
        case "intent":
        case "help_doc_interaction":
        case "video_interaction":
        case "survey_response":
          return true;
      }
    };
    getOptionalNumbericOperand = (num) => {
      return !!num ? num : 0;
    };
    getOptionalDateOperand = (date) => {
      if (!!date) {
        const one_day = 1e3 * 60 * 60 * 24;
        const now = (/* @__PURE__ */ new Date()).getTime();
        const d = new Date(date);
        const diff_ms = now - d.getTime();
        return Math.floor(diff_ms / one_day);
      }
      return 0;
    };
    getAnalyticsLeftOperand = (rule, analytics2) => {
      if (!!analytics2) {
        switch (rule.type) {
          case "executions":
            return getOptionalNumbericOperand(analytics2.num_command_executions);
          case "shortcuts":
            return getOptionalNumbericOperand(analytics2.num_shortcut_command_executions);
          case "sessions":
            return getOptionalNumbericOperand(analytics2.num_sessions);
          case "opens":
            return getOptionalNumbericOperand(analytics2.num_opens);
          case "deadends":
            return getOptionalNumbericOperand(analytics2.num_deadends);
          case "last_seen":
            return getOptionalDateOperand(analytics2.last_seen_at);
          case "first_seen":
            return getOptionalDateOperand(analytics2.first_seen_at);
        }
      }
      return 0;
    };
    evaluateMultiValueRule = (context, location, analytics2, remoteProperties, interactions, rule) => {
      const { operator, values } = rule;
      const leftOperand = getLeftOperand(rule, context, location, analytics2, remoteProperties, interactions, {});
      const evaluateValue = (value) => {
        if (rule.type === "language") {
          const [language, country] = value.split("-");
          const [leftLanguage, leftCountry] = leftOperand.split("-");
          const isEqual15 = (a, b) => a === b || a === void 0 || b === void 0;
          return isEqual15(leftLanguage, language) && isEqual15(leftCountry, country);
        }
        return value.toLowerCase() === leftOperand.toLowerCase();
      };
      switch (operator) {
        case "includes":
          return values.some(evaluateValue);
        case "doesNotInclude":
          return !values.some(evaluateValue);
      }
    };
    evaluateRule = (context, location, analytics2, remoteProperties, interactions, eventProperties, rule) => {
      if (rule.type === "user_property" || rule.type === "ab_test") {
        return false;
      }
      const { operator, value } = rule;
      const leftOperand = getLeftOperand(
        rule,
        context,
        location,
        analytics2,
        remoteProperties,
        interactions,
        eventProperties
      );
      const valueAsStringOrNumber = parsePossibleNumericValue(value);
      switch (operator) {
        case "is":
          if (isInteractionCondition(rule)) {
            return leftOperand == null ? void 0 : leftOperand.includes(valueAsStringOrNumber);
          }
          return leftOperand === valueAsStringOrNumber || `${leftOperand}` === `${valueAsStringOrNumber}`;
        case "isNot":
          if (isInteractionCondition(rule)) {
            return !(leftOperand == null ? void 0 : leftOperand.includes(valueAsStringOrNumber));
          }
          return leftOperand !== valueAsStringOrNumber && `${leftOperand}` !== `${valueAsStringOrNumber}`;
        case "isTruthy":
          return !!leftOperand;
        case "isTrue":
          return !!leftOperand;
        case "isFalse":
          return !leftOperand;
        case "isFalsy":
          return !leftOperand;
        case "isDefined":
          return leftOperand !== void 0;
        case "isNotDefined":
          return leftOperand === void 0;
        case "startsWith":
          return leftOperand.startsWith(parseStringValue(value));
        case "endsWith":
          return leftOperand.endsWith(parseStringValue(value));
        case "includes":
          return leftOperand.includes(parseStringValue(value));
        case "doesNotInclude":
          return !leftOperand.includes(parseStringValue(value));
        case "matchesRegex":
          return new RegExp(parseStringValue(value)).test(leftOperand);
        case "isGreaterThan":
          return Number(leftOperand) > Number(value);
        case "isLessThan":
          return Number(leftOperand) < Number(value);
        case "idOnPage":
          return document.getElementById(parseStringValue(value)) !== null;
        case "classnameOnPage":
          return document.getElementsByClassName(parseStringValue(value)).length > 0;
        case "selectorOnPage":
          return value ? checkSelector(value) : false;
        case "idNotOnPage":
          return document.getElementById(parseStringValue(value)) === null;
        case "classnameNotOnPage":
          return document.getElementsByClassName(parseStringValue(value)).length === 0;
        case "selectorNotOnPage":
          return value ? !checkSelector(value) : false;
        case void 0:
          return true;
        default:
          return true;
      }
    };
    evaluateRules = (rules, context, location, analytics2, remoteProperties, interactions) => {
      const failedRules = [];
      for (const rule of rules) {
        if (rule.type === "always") {
          return { passed: true };
        }
        if (isMultiValueRule(rule)) {
          if (!evaluateMultiValueRule(context, location, analytics2, remoteProperties, interactions, rule)) {
            failedRules.push(rule);
          }
        } else if (!evaluateRule(context, location, analytics2, remoteProperties, interactions, {}, rule)) {
          failedRules.push(rule);
        }
      }
      if (failedRules.length > 0) {
        return { passed: false, failedRules };
      } else {
        return { passed: true };
      }
    };
    end_user_analytics_keys = ["executions", "shortcuts", "last_seen", "first_seen", "sessions", "opens", "deadends"];
    evaluateRuleExpression = (expr, context, location, analytics2, remoteProperties, interactions, isRemoteDataAvailable, syncedHeapSegments, syncedHubSpotLists, syncedAmplitudeCohorts, eventProperties) => {
      var _a2, _b2;
      switch (expr.type) {
        case "AND": {
          const results = [];
          for (const e of expr.exprs) {
            const result = evaluateRuleExpression(
              e,
              context,
              location,
              analytics2,
              remoteProperties,
              interactions,
              isRemoteDataAvailable,
              syncedHeapSegments,
              syncedHubSpotLists,
              syncedAmplitudeCohorts,
              eventProperties
            );
            if (!result.passed && !result.userDefinedReason) {
              return {
                passed: false,
                userDefinedReason: void 0
              };
            }
            results.push(result);
          }
          const failedResults = results.filter((r) => !r.passed);
          return {
            passed: results.every((r) => r.passed),
            userDefinedReason: failedResults.every((r) => r.userDefinedReason) ? (_a2 = failedResults[0]) == null ? void 0 : _a2.userDefinedReason : void 0
          };
        }
        case "OR": {
          const results = expr.exprs.map(
            (e) => evaluateRuleExpression(
              e,
              context,
              location,
              analytics2,
              remoteProperties,
              interactions,
              isRemoteDataAvailable,
              syncedHeapSegments,
              syncedHubSpotLists,
              syncedAmplitudeCohorts,
              eventProperties
            )
          );
          const failedResults = results.filter((r) => !r.passed);
          const passed2 = results.some((r) => r.passed) || results.length === 0;
          return {
            passed: passed2,
            userDefinedReason: !passed2 && failedResults.every((r) => r.userDefinedReason) ? (_b2 = failedResults[0]) == null ? void 0 : _b2.userDefinedReason : void 0
          };
        }
        case "LITERAL":
          return { passed: expr.value };
        case "CONDITION":
          if (expr.condition.type === "named_rule") {
            throw new Error("Named rule should have been replaced by an expression by the backend");
          }
          if (end_user_analytics_keys.some((e) => e === expr.condition.type)) {
            if (isRemoteDataAvailable === false) {
              throw new Error(
                "Analytics-based rules are only available when HMAC is set or force_end_user_identity_verification is disabled AND org is not in silent mode."
              );
            }
          }
          if ("heap" === expr.condition.type) {
            if (isRemoteDataAvailable === false && !isStudioPreview || !syncedHeapSegments.includes(expr.condition.field || "")) {
              throw new Error("Heap Segment used in condition is not synced with CommandBar.");
            }
          }
          if ("hubspot" === expr.condition.type) {
            if (isRemoteDataAvailable === false && !isStudioPreview || !syncedHubSpotLists.includes(expr.condition.field || "")) {
              throw new Error("HubSpot List used in condition is not synced with CommandBar.");
            }
          }
          if ("amplitude" === expr.condition.type) {
            if (isRemoteDataAvailable === false && !isStudioPreview || !syncedAmplitudeCohorts.includes(expr.condition.field || "")) {
              throw new Error("Amplitude Cohort used in condition is not synced with CommandBar.");
            }
          }
          if (isMultiValueRule(expr.condition)) {
            const passed2 = evaluateMultiValueRule(
              context,
              location,
              analytics2,
              remoteProperties,
              interactions,
              expr.condition
            );
            return { passed: passed2 };
          }
          const passed = evaluateRule(
            context,
            location,
            analytics2,
            remoteProperties,
            interactions,
            eventProperties,
            expr.condition
          );
          return { passed, userDefinedReason: expr.condition.reason };
      }
    };
    RulesParser_default = evaluateRules;
  }
});

// commandbar/src/shared/services/targeting/helpers.ts
var trackDecideError, runBooleanExpression, runBooleanConditions;
var init_helpers6 = __esm({
  "commandbar/src/shared/services/targeting/helpers.ts"() {
    "use strict";
    init_sentry();
    init_selectors();
    init_RulesParser();
    init_helpers2();
    trackDecideError = (_, experience, error3) => {
      var _a2;
      (_a2 = getSentry()) == null ? void 0 : _a2.withScope((scope) => {
        var _a3, _b2;
        scope.setTag("feature:server-side-targeting", "true");
        scope.setContext("experience", experience);
        scope.setContext("endUser", {
          identifier: (_a3 = _.endUser) == null ? void 0 : _a3.identifier
        });
        scope.setContext("endUserStore", {
          store: _.endUserStore
        });
        scope.setContext("remoteDecideResult", _.decide || {});
        (_b2 = getSentry()) == null ? void 0 : _b2.captureException(error3);
      });
    };
    runBooleanExpression = (expr, _, prefix = "", context = {}) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i;
      const { eventProperties = {} } = context;
      const failed = (msg, reasonIsUserDefined = false) => {
        return { passed: false, reason: msg, reasonIsUserDefined };
      };
      const passed = () => {
        return { passed: true, reason: "", reasonIsUserDefined: false };
      };
      try {
        const isEndUserAnalyticsAvailable = isRemoteEnduserStoreEnabled(_) && isSilentMode() !== true;
        const result = evaluateRuleExpression(
          expr,
          _.context,
          _.location,
          _.endUserStore.data.analytics,
          _.endUserStore.data.properties,
          {
            nudges: _.endUserStore.data.nudges_interactions,
            checklists: _.endUserStore.data.checklist_interactions.checklists
          },
          isEndUserAnalyticsAvailable,
          Object.keys(((_c2 = (_b2 = (_a2 = _ == null ? void 0 : _.organization) == null ? void 0 : _a2.integrations) == null ? void 0 : _b2.heap) == null ? void 0 : _c2.segments) || {}),
          Object.keys(((_f = (_e = (_d = _ == null ? void 0 : _.organization) == null ? void 0 : _d.integrations) == null ? void 0 : _e.hubspot) == null ? void 0 : _f.lists) || {}),
          Object.keys(((_i = (_h = (_g = _ == null ? void 0 : _.organization) == null ? void 0 : _g.integrations) == null ? void 0 : _h.amplitude) == null ? void 0 : _i.cohorts) || {}),
          eventProperties
        );
        if (result.passed) {
          return passed();
        } else {
          if (result.userDefinedReason) {
            return failed(result.userDefinedReason, true);
          } else {
            return failed(`${prefix}: Rules were not met.`);
          }
        }
      } catch (e) {
        return failed(`${prefix}: Something went wrong in parsing rules. ${String(e)}`);
      }
    };
    runBooleanConditions = (conditions, _, prefix) => {
      var _a2, _b2;
      const failed = (msg, reasonIsUserDefined = false) => {
        return { passed: false, reason: msg, reasonIsUserDefined };
      };
      const passed = () => {
        return { passed: true, reason: "", reasonIsUserDefined: false };
      };
      try {
        const result = RulesParser_default(
          conditions,
          _.context,
          _.location,
          _.endUserStore.data.analytics,
          _.endUserStore.data.properties,
          {
            nudges: _.endUserStore.data.nudges_interactions,
            checklists: _.endUserStore.data.checklist_interactions.checklists
          }
        );
        if (result.passed) {
          return passed();
        } else {
          const userDefinedReason = (_b2 = (_a2 = result.failedRules) == null ? void 0 : _a2.find((rule) => !!rule.reason)) == null ? void 0 : _b2.reason;
          if (userDefinedReason) {
            return failed(userDefinedReason, true);
          } else {
            return failed(`${prefix}: Rules were not met.`);
          }
        }
      } catch (e) {
        return failed(`${prefix}: Something went wrong in parsing rules. ${String(e)}`);
      }
    };
  }
});

// commandbar/src/shared/services/targeting/command-targeting.ts
var isCommandAvailable, isCommandAvailableLegacy;
var init_command_targeting = __esm({
  "commandbar/src/shared/services/targeting/command-targeting.ts"() {
    "use strict";
    init_helpers6();
    isCommandAvailable = (command, _) => {
      if (command.availability_expression) {
        const expr = command.availability_expression;
        const { passed, reason, reasonIsUserDefined } = runBooleanExpression(expr, _, "Availability condition");
        return { isAvailable: passed, isAvailableReason: reason, reasonIsUserDefined };
      } else {
        return isCommandAvailableLegacy(command, _);
      }
    };
    isCommandAvailableLegacy = (command, _) => {
      const conditions = command.availability_rules;
      if (conditions.length === 0) {
        return { isAvailable: true, isAvailableReason: "", reasonIsUserDefined: false };
      }
      const { passed, reason, reasonIsUserDefined } = runBooleanConditions(conditions, _, "Availability condition");
      return { isAvailable: passed, isAvailableReason: reason, reasonIsUserDefined };
    };
  }
});

// commandbar/src/shared/services/targeting/audience.ts
var passesAudienceConditions, passesLocalConditions, passesDecide;
var init_audience2 = __esm({
  "commandbar/src/shared/services/targeting/audience.ts"() {
    "use strict";
    init_helpers6();
    init_helpers6();
    init_command();
    init_location();
    passesAudienceConditions = (_, experienceType, experience) => {
      var _a2, _b2, _c2;
      if (isStudioPreview()) {
        return true;
      }
      let useRemoteDecideResult = (_a2 = _.decide) == null ? void 0 : _a2.user_property_targeting;
      if (experienceType === "commands") {
        const remoteDecideResult = (_c2 = (_b2 = _.decide) == null ? void 0 : _b2[experienceType]) == null ? void 0 : _c2[experience.id];
        const commandIsInDecide = typeof remoteDecideResult !== "undefined" && remoteDecideResult !== null;
        if (!!_.decide && !commandIsInDecide || isProgrammatic(experience)) {
          useRemoteDecideResult = false;
        }
      }
      if (_.decide && typeof _.decide.user_property_targeting === "undefined") {
        useRemoteDecideResult = true;
      }
      const localAudienceResult = passesLocalConditions(_, experience);
      const remoteAudienceResult = passesDecide(_, localAudienceResult, experienceType, experience);
      let audienceResult = localAudienceResult;
      if (useRemoteDecideResult) {
        audienceResult = remoteAudienceResult;
      }
      return audienceResult;
    };
    passesLocalConditions = (_, experience) => {
      let audience = experience.audience;
      if ("template" in experience && experience.template.type === "helpdoc" && experience.integration) {
        audience = experience.integration.audience;
      }
      if (audience) {
        switch (audience.type) {
          case "all_users":
            return true;
          case "rule_expression":
            return runBooleanExpression(audience.expression, _, "").passed;
          default:
            return false;
        }
      }
      return true;
    };
    passesDecide = (_, localResult, experienceType, experience) => {
      var _a2, _b2;
      const remoteDecideResult = (_b2 = (_a2 = _.decide) == null ? void 0 : _a2[experienceType]) == null ? void 0 : _b2[experience.id];
      if (typeof remoteDecideResult === "undefined" || remoteDecideResult === null) {
        return false;
      }
      if (typeof remoteDecideResult === "boolean") {
        return remoteDecideResult;
      } else if (typeof remoteDecideResult === "object") {
        return localResult;
      }
      trackDecideError(_, experience, new Error("remoteDecideResult is not a boolean or object"));
      return false;
    };
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/OptionValidate.tsx
import _get4 from "lodash/get";
var hasInitialValueFnDefined, isValidArg, isClickableArg, isAvailable, isExecutable, isValid;
var init_OptionValidate = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/OptionValidate.tsx"() {
    "use strict";
    init_Interpolate();
    init_dom();
    init_ClientSearch();
    init_selectors3();
    init_Errors();
    init_Logger();
    init_location();
    init_sentry();
    init_command_targeting();
    init_audience2();
    hasInitialValueFnDefined = (key, _) => Object.keys(_.callbacks).some((callbackKey) => callbackKey.includes(`commandbar-initialvalue-${key}`));
    isValidArg = (command, arg, _) => {
      var _a2;
      const invalid = (msg) => {
        return { isValid: false, isValidReason: msg };
      };
      const valid = () => {
        return { isValid: true, isValidReason: "" };
      };
      const argumentConfig = command.arguments[arg];
      if (!argumentConfig) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureMessage("Config for argument is missing.", "error", {
          captureContext: {
            contexts: {
              command
            }
          }
        });
        return invalid(`Config for ${arg} is missing.`);
      }
      switch (argumentConfig.type) {
        case "context":
          const options = _get4(_.context, argumentConfig.value);
          if (ClientSearch_default.isDefined(argumentConfig.value, _)) {
            return valid();
          }
          if (hasInitialValueFnDefined(argumentConfig.value, _)) {
            return valid();
          }
          if (options === void 0) {
            return invalid(`${argumentConfig.value} isn't defined in context.`);
          }
          if (!Array.isArray(options)) {
            return invalid(`${argumentConfig.value} isn't an array in context.`);
          }
          if (options.length === 0) {
            return invalid(`${argumentConfig.value} is an empty array in context.`);
          }
          return valid();
        default:
          return valid();
      }
    };
    isClickableArg = (command, arg, _) => {
      const notClickable = (msg) => {
        return { isClickable: false, isClickableReason: msg };
      };
      const clickable = () => {
        return { isClickable: true, isClickableReason: "" };
      };
      if (command.template.type === "click" || command.template.type === "clickBySelector" || command.template.type === "clickByXpath") {
        let values;
        try {
          values = command.template.value.map((el) => interpolate(el, _, true, true));
        } catch (e) {
          return notClickable(String(e));
        }
        if (!checkSelector(values[0])) {
          return notClickable(`Cannot find element to click: [${values[0]}]`);
        }
      }
      return clickable();
    };
    isAvailable = (option, _) => {
      var _a2, _b2;
      if (!isCommandOption(option)) {
        return { isAvailable: true, isAvailableReason: "", reasonIsUserDefined: false };
      }
      if (option.command.show_in_spotlight_search === false && ((_a2 = _.flags) == null ? void 0 : _a2["release-search-experiences-in-spotlight"]) && option.command.template.type !== "helpdoc") {
        return { isAvailable: false, isAvailableReason: "Not available in Spotlight search", reasonIsUserDefined: false };
      }
      if (((_b2 = _.flags) == null ? void 0 : _b2["release-audiences-for-command-types"]) && !passesAudienceConditions(_, "commands", option.command)) {
        return { isAvailable: false, isAvailableReason: "Not available for current audience", reasonIsUserDefined: false };
      }
      return isCommandAvailable(option.command, _);
    };
    isExecutable = (command, _) => {
      switch (command.template.type) {
        case "helpdoc":
        case "link":
          const _url = interpolate(command.template.value, _, true, true, true);
          switch (command.template.operation) {
            case "router":
              const routerFunc = _.callbacks["commandbar-router"];
              if (!routerFunc) {
                throw new InternalError("Link is of router type, but router is not defined.");
              }
              return;
            case "self":
            case "blank":
            default:
              return;
          }
        case "admin":
        case "builtin":
        case "callback":
          const callbackName = command.template.value;
          const callback = _.callbacks[callbackName];
          if (!callback) {
            throw new InternalError(`Callback is not available: [${callbackName}]`);
          }
          return;
        case "clickByXpath":
        case "clickBySelector":
        case "click":
          const values = command.template.value.map((el) => interpolate(el, _, true, true));
          if (!checkSelector(values[0])) {
            throw new InternalError(`Cannot find element to click: [${values[0]}]`);
          }
          return;
        case "appcues":
          if (!window.Appcues || !window.Appcues.show) {
            throw new InternalError("Appcues is not available");
          }
          return;
        case "pendo_guide":
          if (!window.pendo || !window.pendo.showGuideById) {
            throw new InternalError("Pendo is not available");
          }
          return;
        case "request":
          const { url, headers, body, onSuccess, onError } = command.template.value;
          const _interpolatedRequest = interpolateObject({
            s: {
              url,
              headers,
              body
            },
            _,
            interpolateContext: true,
            interpolateArgs: true
          });
          let onSuccessFunc = void 0;
          if (onSuccess) {
            onSuccessFunc = _.callbacks[onSuccess];
            if (!onSuccessFunc) {
              Logger_default.error(`onSuccess callback for request is not available, [${onSuccess}]`);
            }
          }
          let onErrorFunc = void 0;
          if (onError) {
            onErrorFunc = _.callbacks[onError];
            if (!onErrorFunc) {
              Logger_default.error(`onError callback for request is not available, [${onError}]`);
            }
          }
          return;
        case "webhook":
        case "video":
        case "trigger":
        case "script":
          return;
        default:
          throw new InternalError("Invalid command execute type.");
      }
    };
    isValid = (commandOption, _) => {
      var _a2;
      const args = Object.keys(commandOption.command.arguments);
      for (const arg of args) {
        const { isValid: isValid2, isValidReason } = isValidArg(commandOption.command, arg, _);
        if (!isValid2) {
          return { isValid: isValid2, isValidReason };
        }
        const { isClickable, isClickableReason } = isClickableArg(commandOption.command, arg, _);
        if (!isClickable) {
          return { isValid: isClickable, isValidReason: isClickableReason };
        }
      }
      if (isStudioPreview()) {
        return { isValid: true, isValidReason: "" };
      }
      try {
        isExecutable(commandOption.command, _);
      } catch (err) {
        if (err instanceof InternalError) {
          return { isValid: false, isValidReason: err.message };
        } else {
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
          return { isValid: false, isValidReason: "Failed to validate if command is executable" };
        }
      }
      return { isValid: true, isValidReason: "" };
    };
  }
});

// commandbar/src/products/spotlight/store/options/command-option-selectors.ts
var hex_regex, getSortedArgs, isCommandOptionValid, isHexColor, getdeprecatedColor, getCommandIcon, getCategoryIcon, getCategoryImage, getCommandImage, isCommandOptionRecommended;
var init_command_option_selectors = __esm({
  "commandbar/src/products/spotlight/store/options/command-option-selectors.ts"() {
    "use strict";
    init_OptionValidate();
    init_helpers6();
    init_selectors3();
    hex_regex = /^[0-9a-fA-F]{3,8}$/;
    getSortedArgs = (option) => {
      return Object.keys(option.command.arguments).map((argName) => {
        return {
          ...option.command.arguments[argName],
          userDefinedName: option.command.arguments[argName].label || argName,
          userDefinedValue: argName
        };
      }).sort((a, b) => {
        return a.order_key - b.order_key;
      });
    };
    isCommandOptionValid = (_, o) => {
      return isValid(o, _);
    };
    isHexColor = (color) => hex_regex.test(color);
    getdeprecatedColor = (icon) => (icon == null ? void 0 : icon.includes("#")) && !!isHexColor(icon.split("#")[1]) ? icon == null ? void 0 : icon.split("#")[1] : null;
    getCommandIcon = (_, o) => {
      const icon = o.command.icon;
      const icon_color = o.command.icon_color ? o.command.icon_color : getdeprecatedColor(icon);
      return { icon, icon_color };
    };
    getCategoryIcon = (_, o) => {
      if (o.command.category) {
        const icon = getCategoryField(_, o.command.category, "icon");
        const icon_color = getCategoryField(_, o.command.category, "icon_color");
        return { icon, icon_color: icon_color ? icon_color : getdeprecatedColor(icon) };
      }
      return { icon: null, icon_color: null };
    };
    getCategoryImage = (_, o) => {
      if (o.command.category) {
        const image = getCategoryField(_, o.command.category, "image");
        const image_color = getCategoryField(_, o.command.category, "image_color");
        return { image, image_color: image_color ? image_color : getdeprecatedColor(image) };
      }
      return { image: null, image_color: null };
    };
    getCommandImage = (_, o) => {
      const image = o.command.image;
      const image_color = o.command.image_color;
      return { image, image_color: image_color ? image_color : getdeprecatedColor(image) };
    };
    isCommandOptionRecommended = (_, o) => {
      var _a2;
      if (((_a2 = _.organization) == null ? void 0 : _a2.recommendations_type) === "None")
        return false;
      if (o.command.recommend_expression) {
        if (o.command.always_recommend)
          return true;
        const { passed } = runBooleanExpression(o.command.recommend_expression, _, "Recommendations:");
        return passed;
      } else {
        if (!o.command.recommend_rules || o.command.recommend_rules.length === 0)
          return false;
        const { passed } = runBooleanConditions(o.command.recommend_rules, _, "Recommendations:");
        return passed;
      }
    };
  }
});

// commandbar/src/products/spotlight/store/options/selectors.ts
var isOptionExecutable, isOptionValid, selectTabProperties, selectSearchTabs, validateOptionAvailable, validateOptionDisabled;
var init_selectors2 = __esm({
  "commandbar/src/products/spotlight/store/options/selectors.ts"() {
    "use strict";
    init_command_option_selectors();
    init_Option();
    init_OptionGroup();
    init_assertNever();
    init_selectors3();
    init_helpers8();
    init_OptionValidate();
    isOptionExecutable = (_, o) => {
      switch (o.type) {
        case "command" /* Command */:
        case "parameter" /* Parameter */:
          return { isExecutable: true, isExecutableReason: "" };
        default:
          return assertNever(o);
      }
    };
    isOptionValid = (_, o) => {
      switch (o.type) {
        case "command":
          return isCommandOptionValid(_, o);
        case "parameter":
          return { isValid: true, isValidReason: "" };
        default:
          throw new Error("unreachable code");
      }
    };
    selectTabProperties = (_, groupKey) => {
      const tab = _.spotlight.tabs.find((t44) => getTabKey(groupKey) === `${t44.id}`);
      if (!tab) {
        return {};
      }
      return { icon: tab == null ? void 0 : tab.icon, header: tab == null ? void 0 : tab.header };
    };
    selectSearchTabs = (_, includeHeaders) => {
      const { currentGroups } = _.spotlight;
      let retVal = currentGroups.filter((g) => !!g.searchTabEnabled).sort(compareOptionGroups).map((group) => {
        const tabGroup = { ...selectTabProperties(_, group.key), ...group };
        return tabGroup;
      });
      const minSortKeys = {};
      if (!!includeHeaders) {
        const headerSortCompare = (a, b) => {
          const aHeader = a.header || "__no_header__";
          const bHeader = b.header || "__no_header__";
          if (!aHeader && !bHeader) {
            return compareOptionGroups(a, b);
          }
          if (!bHeader) {
            return -1;
          }
          if (!aHeader) {
            return 1;
          }
          if (aHeader === bHeader) {
            return compareOptionGroups(a, b);
          }
          if (typeof minSortKeys[aHeader] === "undefined" && typeof minSortKeys[bHeader] === "undefined") {
            return aHeader.localeCompare(bHeader);
          }
          if (typeof minSortKeys[bHeader] === "undefined") {
            return -1;
          }
          if (typeof minSortKeys[aHeader] === "undefined") {
            return 1;
          }
          if (minSortKeys[aHeader] < minSortKeys[bHeader]) {
            return -1;
          } else if (minSortKeys[aHeader] > minSortKeys[bHeader]) {
            return 1;
          } else {
            return aHeader.localeCompare(bHeader);
          }
        };
        for (const group of retVal) {
          const headerkey = group.header || "__no_header__";
          if (group.sortKey !== null) {
            if (typeof minSortKeys[headerkey] === "number") {
              minSortKeys[headerkey] = Math.min(group.sortKey, minSortKeys[headerkey]);
            } else {
              minSortKeys[headerkey] = group.sortKey;
            }
          }
        }
        retVal = retVal.sort(headerSortCompare);
      }
      return retVal;
    };
    validateOptionAvailable = (_, o) => {
      switch (o.type) {
        case "parameter":
          if (!isRecordOption(o))
            break;
          return { isAvailable: true, isAvailableReason: "", reasonIsUserDefined: false };
      }
      return isAvailable(o, _);
    };
    validateOptionDisabled = (_, o) => {
      const disabled = (msg, reasonIsUserDefined2 = false) => {
        return { isDisabled: true, isDisabledReason: msg, reasonIsUserDefined: reasonIsUserDefined2 };
      };
      const { isValid: isValid2, isValidReason } = isOptionValid(_, o);
      if (!isValid2) {
        o.optionDisabled = disabled(isValidReason);
        return o.optionDisabled;
      }
      const { isExecutable: isExecutable2, isExecutableReason } = isOptionExecutable(_, o);
      if (!isExecutable2) {
        o.optionDisabled = disabled(isExecutableReason);
        return o.optionDisabled;
      }
      const { isAvailable: isAvailable2, isAvailableReason, reasonIsUserDefined } = validateOptionAvailable(_, o);
      if (!isAvailable2) {
        o.optionDisabled = disabled(isAvailableReason, reasonIsUserDefined);
        return o.optionDisabled;
      }
      return { isDisabled: false, isDisabledReason: "", reasonIsUserDefined: false };
    };
  }
});

// commandbar/src/products/spotlight/store/generate-options/option-list-selectors.tsx
import partition from "lodash/partition";
var nestOptionsByGroup, applyPinToBottom, reorderSelectedToBeginning, applyOptionSortOverrides, applyGroupLimits, flattenToFinalList, includeGroupsWithNoResults, addGroupsWithNoResults, sortOptionsAndInsertGroups;
var init_option_list_selectors = __esm({
  "commandbar/src/products/spotlight/store/generate-options/option-list-selectors.tsx"() {
    "use strict";
    init_utils();
    init_OptionGroup();
    init_selectors8();
    init_Step();
    init_selectors3();
    init_selectors3();
    init_helpers8();
    nestOptionsByGroup = (options, categories, _, showRecommendedGroup) => {
      const nestedOptions = {};
      options.forEach((o) => {
        var _a2;
        const groupInstance = getGroupOfOption(o, categories, _, showRecommendedGroup);
        setOptionGroupKey(o, groupInstance.key);
        if (groupInstance.key in nestedOptions) {
          const { group, list: list2, searchScore } = nestedOptions[groupInstance.key];
          list2.push(o);
          nestedOptions[groupInstance.key].group = incrementOptionGroupSize(group);
          if (searchScore === Number.NEGATIVE_INFINITY && o.searchScore !== void 0) {
            nestedOptions[group.key].searchScore = o.searchScore;
          }
        } else {
          nestedOptions[groupInstance.key] = {
            group: { ...groupInstance, size: 1 },
            list: [o],
            searchScore: (_a2 = o.searchScore) != null ? _a2 : Number.NEGATIVE_INFINITY
          };
        }
      });
      return nestedOptions;
    };
    applyPinToBottom = (groups) => {
      const [unpinned, pinned] = partition(groups, (g) => !g.pinnedToBottom);
      return [...unpinned, ...pinned];
    };
    reorderSelectedToBeginning = (options, currentStep) => {
      return [...options].sort((a, b) => {
        if (!isParameterOption(a) || !isParameterOption(b))
          return 0;
        const isASelected = isParameterOptionSelected(a, currentStep);
        const isBSelected = isParameterOptionSelected(b, currentStep);
        return isASelected === isBSelected ? 0 : isASelected ? -1 : 1;
      });
    };
    applyOptionSortOverrides = (nestedOptions, currentStep, recentUIDs2) => {
      Object.keys(nestedOptions).forEach((key) => {
        var _a2;
        const { group, list: list2 } = nestedOptions[key];
        const compareFunction = group.sortFunction;
        if (!!compareFunction) {
          const newList = [...list2].sort((a, b) => {
            if (!isParameterOption(a) || !isParameterOption(b))
              return 0;
            return compareFunction(
              { value: a.parameter, searchMatches: a.searchMatches },
              { value: b.parameter, searchMatches: b.searchMatches }
            );
          });
          nestedOptions[key].list = newList;
        } else if (group.key === recommendedGroup().key) {
          const newList = [...list2].sort((a, b) => {
            if (!isCommandOption(a) || !isCommandOption(b))
              return 0;
            return compareObjs(
              { sort_key: a.command.recommend_sort_key, id: 0 },
              { sort_key: b.command.recommend_sort_key, id: 0 }
            );
          });
          nestedOptions[key].list = newList;
        } else if (((_a2 = currentStep == null ? void 0 : currentStep.selected) == null ? void 0 : _a2.data) && currentStep.type === "multiselect" /* MultiSelect */) {
          const newList = reorderSelectedToBeginning(list2, currentStep);
          nestedOptions[key].list = newList;
        } else if (group.key === recentsGroup().key) {
          const newList = [...list2].sort((a, b) => {
            const indexA = recentUIDs2.findIndex((v) => v === getOptionUID(a));
            const indexB = recentUIDs2.findIndex((v) => v === getOptionUID(b));
            const sortKeyA = indexA > -1 ? indexA : 0;
            const sortKeyB = indexB > -1 ? indexB : 0;
            return compareObjs({ sort_key: sortKeyA, id: 0 }, { sort_key: sortKeyB, id: 0 });
          });
          nestedOptions[key].list = newList;
        }
      });
    };
    applyGroupLimits = (nestedOptions, expandedGroupKeys) => {
      Object.keys(nestedOptions).forEach((key) => {
        const { group, list: list2 } = nestedOptions[key];
        if (group.limit && shouldEnforceOptionGroupLimit(group, expandedGroupKeys)) {
          const truncatedList = list2.slice(0, group.limit);
          nestedOptions[key].list = truncatedList;
        }
      });
    };
    flattenToFinalList = (nestedOptions, isEmptyState, includeGroupsWithNoResults2) => {
      const sortedGroups = (() => {
        if (isEmptyState) {
          return Object.values(nestedOptions).sort((a, b) => compareOptionGroups(a.group, b.group)).map(({ group }) => group);
        } else {
          return applyPinToBottom(
            Object.values(nestedOptions).sort((a, b) => b.searchScore - a.searchScore || compareOptionGroups(a.group, b.group)).map(({ group }) => group)
          );
        }
      })();
      return sortedGroups.reduce((acc, g) => {
        const { group, list: list2 } = nestedOptions[g.key];
        if (list2.length > 0) {
          return [...acc, group, ...list2];
        } else if (includeGroupsWithNoResults2 && g.showWithNoResults) {
          return [...acc, g];
        } else {
          return acc;
        }
      }, []);
    };
    includeGroupsWithNoResults = (step, inputText, numOptions, searchFilter) => {
      const isDefaultStep = (step == null ? void 0 : step.type) === "base" /* Base */ && step.resource === null;
      if (!isDefaultStep)
        return false;
      if (!!searchFilter)
        return false;
      if (inputText.length === 0)
        return false;
      if (numOptions === 0)
        return false;
      return true;
    };
    addGroupsWithNoResults = (nestedOptions, _) => {
      const commandCategories = _.spotlight.categories.map((c) => initOptionGroupFromCommandCategory(c, _));
      const recordCategories = Object.entries(getContextSettings(_)).map(
        ([k, v]) => initOptionGroupFromRecordCategory(k, _, v)
      );
      const groupsToShowWithNoResults = [...commandCategories, ...recordCategories].filter(
        (g) => !!g.showWithNoResults
      );
      const recentsGroupKey = recentsGroup().key;
      const recentsContextKeys = /* @__PURE__ */ new Set();
      if (recentsGroupKey in nestedOptions) {
        nestedOptions[recentsGroupKey].list.forEach((option) => {
          if (!!option.category.contextKey) {
            recentsContextKeys.add(option.category.contextKey);
          }
        });
      }
      groupsToShowWithNoResults.forEach((g) => {
        const groupContextKey = getRecordGroupKey(g);
        if (!(g.key in nestedOptions) && !recentsContextKeys.has(groupContextKey)) {
          nestedOptions[g.key] = { group: g, list: [], searchScore: Number.NEGATIVE_INFINITY };
        }
      });
    };
    sortOptionsAndInsertGroups = (options, _) => {
      const isEmptyState = _.spotlight.inputText.length === 0;
      const showRecommendedGroup = isEmptyState && !_.spotlight.searchFilter;
      const { currentStep } = currentStepAndIndex(_);
      const nestedOptions = nestOptionsByGroup(options, _.spotlight.categories, _, showRecommendedGroup);
      applyOptionSortOverrides(nestedOptions, void 0, _.endUserStore.derived.recentUIDs);
      applyGroupLimits(nestedOptions, _.spotlight.expandedGroupKeys);
      addGroupsWithNoResults(nestedOptions, _);
      return flattenToFinalList(
        nestedOptions,
        isEmptyState,
        includeGroupsWithNoResults(currentStep, _.spotlight.inputText, options.length, _.spotlight.searchFilter)
      );
    };
  }
});

// commandbar/src/products/spotlight/store/search/fuzzysort-fork/deepGet/types.js
function isArray(value) {
  return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
}
function baseToString(value) {
  if (typeof value === "string") {
    return value;
  }
  let result = value + "";
  return result === "0" && 1 / value === -INFINITY ? "-0" : result;
}
function toString2(value) {
  return value == null ? "" : baseToString(value);
}
function isString2(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number";
}
function isBoolean(value) {
  return value === true || value === false || isObjectLike(value) && getTag(value) === "[object Boolean]";
}
function isObject(value) {
  return typeof value === "object";
}
function isObjectLike(value) {
  return isObject(value) && value !== null;
}
function isDefined2(value) {
  return value !== void 0 && value !== null;
}
function getTag(value) {
  return value == null ? value === void 0 ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
}
var INFINITY;
var init_types4 = __esm({
  "commandbar/src/products/spotlight/store/search/fuzzysort-fork/deepGet/types.js"() {
    "use strict";
    INFINITY = 1 / 0;
  }
});

// commandbar/src/products/spotlight/store/search/fuzzysort-fork/deepGet/deepGet.js
function get5(obj, path) {
  let list2 = [];
  let arr = false;
  const deepGet = (obj2, path2, index3) => {
    if (!isDefined2(obj2)) {
      return;
    }
    if (!path2[index3]) {
      list2.push(obj2);
    } else {
      let key = path2[index3];
      const value = obj2[key];
      if (!isDefined2(value)) {
        return;
      }
      if (index3 === path2.length - 1 && (isString2(value) || isNumber(value) || isBoolean(value))) {
        list2.push(toString2(value));
      } else if (isArray(value)) {
        arr = true;
        for (let i2 = 0, len = value.length; i2 < len; i2 += 1) {
          deepGet(value[i2], path2, index3 + 1);
        }
      } else if (path2.length) {
        deepGet(value, path2, index3 + 1);
      }
    }
  };
  deepGet(obj, isString2(path) ? path.split(".") : path, 0);
  return arr ? list2 : list2[0];
}
var init_deepGet = __esm({
  "commandbar/src/products/spotlight/store/search/fuzzysort-fork/deepGet/deepGet.js"() {
    "use strict";
    init_types4();
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/ParameterOption.tsx
import get6 from "lodash/get";
var initParameterOption;
var init_ParameterOption = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/ParameterOption.tsx"() {
    "use strict";
    init_Option();
    init_deepGet();
    init_helpers8();
    init_selectors2();
    initParameterOption = (_, label, parameter, searchOptions, detailPreview) => {
      var _a2, _b2;
      let value = label;
      if (typeof parameter === "string") {
        value = parameter;
      } else if (!!parameter && parameter.hasOwnProperty("value")) {
        value = parameter == null ? void 0 : parameter["value"];
      }
      const o = initOption(_, "parameter" /* Parameter */, label, value, void 0, detailPreview);
      o.parameter = parameter;
      o.tags = ((searchOptions == null ? void 0 : searchOptions.search_fields) || []).map((t44) => {
        if (typeof t44 === "string") {
          let result = t44.split(".")[0];
          result = result.replace("_", " ");
          result = result.replace(/([A-Z])/g, " $1");
          const label2 = result.charAt(0).toUpperCase() + result.slice(1).toLowerCase();
          return { key: t44, label: label2 };
        }
        return t44;
      }).map(({ key, label: label2 }) => ({
        key,
        label: label2,
        // deepGet used to fetch nested objs, i.e., comments.text where comments is an array
        value: get5(parameter, key)
      }));
      o.searchOptions = searchOptions;
      o.description = (searchOptions == null ? void 0 : searchOptions.description_field) && get6(o.parameter, searchOptions.description_field);
      o.heading = getReservedField(o, "__heading");
      const category = {
        label: (_a2 = o.groupKey) != null ? _a2 : "",
        contextKey: "",
        limit: (_b2 = searchOptions == null ? void 0 : searchOptions.max_options_count) != null ? _b2 : null,
        renderAs: "list"
      };
      o.category = category;
      validateOptionDisabled(_, o);
      return o;
    };
  }
});

// commandbar/src/products/spotlight/store/options/parameter-option-selectors.ts
var convertParameterToOption;
var init_parameter_option_selectors = __esm({
  "commandbar/src/products/spotlight/store/options/parameter-option-selectors.ts"() {
    "use strict";
    init_types2();
    init_ParameterOption();
    init_selectors3();
    convertParameterToOption = (_, parameter, argument) => {
      const contextSettings = getContextSettings(_);
      const label = getArgumentChoiceLabel(argument, parameter, contextSettings);
      const contextSettingsForKey = isContextArgument(argument) ? contextSettings[argument.value.toString()] : void 0;
      return initParameterOption(_, label, parameter, contextSettingsForKey);
    };
  }
});

// commandbar/src/products/spotlight/store/selectors.ts
import get7 from "lodash/get";
import dayjs2 from "dayjs";
var currentOptionHasArguments, findDefaultFocusOptionIndex, getDefaultCommandForCurrentStep, getFocusableChildrenAtIndex, canFocusOnOptionGroup, getNextFocusedIndex, getContextObjectLabel, getArgumentChoiceLabel, getLabelFieldFromContextSettings, selectInitialValueCallbacks, selectIsHotkeyEditable, selectDefaultSummonHotkey, selectSummonHotkey, getCategoryField, getContextSettings, selectHiddenCategories, selectMenuIsOpen, selectSlashFilterGroups, selectSlashFilterHint, selectSlashFilter, selectIsFinalStep, getTabKey, selectCurrentTab, showRotatingPlaceholders, selectAllPlaceholders, selectFirstPlaceholder, isGridView, optionIsInGrid, getNextStepOptions, getDetailPreviewContent, isArgumentClientSearchActive, isVisible;
var init_selectors3 = __esm({
  "commandbar/src/products/spotlight/store/selectors.ts"() {
    "use strict";
    init_utils3();
    init_selectors8();
    init_DateTime();
    init_Step();
    init_record_option_selectors();
    init_helpers8();
    init_a11y();
    init_helpers4();
    init_helpers8();
    init_helpers5();
    init_utils();
    init_Available();
    init_selectors8();
    init_slugify();
    init_detailPreview();
    init_Interpolate();
    init_placeholderHelpers();
    init_actions();
    init_operatingSystem();
    init_constants3();
    init_types2();
    init_ClientSearch();
    init_Option();
    init_helpers5();
    init_selectors8();
    init_helpers8();
    init_selectors2();
    init_option_list_selectors();
    init_command_option_selectors();
    init_parameter_option_selectors();
    init_record_option_selectors();
    currentOptionHasArguments = (_) => {
      const currentOption = _.spotlight.sortedOptions[_.spotlight.focusedIndex];
      if (isCommandOption(currentOption)) {
        if (Object.keys(currentOption.command.arguments).length > 0) {
          return true;
        }
      }
      return false;
    };
    findDefaultFocusOptionIndex = (_) => {
      const options = _.spotlight.sortedOptions;
      for (let i2 = 0; i2 < options.length; i2++) {
        const option = options[i2];
        if (isOption(option) && (!(option.type === "command" /* Command */ && option.command.name === "__commandbar_ask_copilot") || !options[i2 + 1])) {
          return i2;
        }
      }
      return 1;
    };
    getDefaultCommandForCurrentStep = (_) => {
      const { currentStep } = currentStepAndIndex(_);
      const activeRecord = (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && currentStep.resource;
      if (!activeRecord) {
        return;
      }
      const defaultCommandId = getDefaultCommandId(activeRecord);
      if (!defaultCommandId) {
        let l = _.spotlight.initialOptions.length;
        while (l--) {
          if (isCommandOption(_.spotlight.initialOptions[l])) {
            return _.spotlight.initialOptions[l];
          }
        }
        return void 0;
      }
      return _.spotlight.initialOptions.find(
        (option) => isCommandOption(option) && (option.command.id === defaultCommandId || option.command.name === defaultCommandId)
      );
    };
    getFocusableChildrenAtIndex = (index3) => {
      const option = document.getElementById(a11y_default.optionId(index3));
      return option == null ? void 0 : option.querySelectorAll('[role="switch"]');
    };
    canFocusOnOptionGroup = (_, tabKey, index3) => {
      if (typeof tabKey == "undefined" || !tabKey)
        return false;
      if (!isOptionGroup(_.spotlight.sortedOptions[index3]))
        return false;
      const children = getFocusableChildrenAtIndex(index3);
      if (children && children.length > 0) {
        return true;
      }
      return false;
    };
    getNextFocusedIndex = (_, direction, tabKey) => {
      const { sortedOptions, focusedIndex } = _.spotlight;
      switch (direction) {
        case "up":
          for (let i2 = 1; i2 < sortedOptions.length; i2++) {
            const offset6 = focusedIndex - i2;
            const index3 = offset6 >= 0 ? offset6 : sortedOptions.length + offset6;
            if (isOption(sortedOptions[index3])) {
              return index3;
            } else if (canFocusOnOptionGroup(_, tabKey, index3)) {
              return index3;
            }
          }
          break;
        case "down":
          for (let i2 = 1; i2 < sortedOptions.length; i2++) {
            const index3 = (focusedIndex + i2) % sortedOptions.length;
            if (isOption(sortedOptions[index3])) {
              return index3;
            } else if (canFocusOnOptionGroup(_, tabKey, index3)) {
              return index3;
            }
          }
          break;
      }
      return focusedIndex;
    };
    getContextObjectLabel = (contextSettings, object2, key, defaultLabelField = "label") => {
      if (isPrimitive2(object2))
        return object2.toString();
      else {
        const labelField = getLabelFieldFromContextSettings(contextSettings, key);
        return get7(object2, labelField || defaultLabelField);
      }
    };
    getArgumentChoiceLabel = (arg, object2, contextSettings) => {
      if (isPrimitive2(object2)) {
        return object2.toString();
      } else {
        const defaultLabelField = arg.label_field || "label";
        if (isContextArgument(arg)) {
          return getContextObjectLabel(contextSettings, object2, arg.value, defaultLabelField);
        } else if (isTimeArgument(arg) && object2 instanceof Date) {
          return DateTime_default.display(dayjs2(object2.toString()), arg.dateTimeArgumentTypeId || 1, false);
        } else {
          return get7(object2, defaultLabelField);
        }
      }
    };
    getLabelFieldFromContextSettings = (contextSettings, key) => {
      const config2 = contextSettings[key];
      return config2 == null ? void 0 : config2.label_field;
    };
    selectInitialValueCallbacks = (_) => Object.keys(_.callbacks).filter((k) => k.startsWith("commandbar-initialvalue-"));
    selectIsHotkeyEditable = (_) => {
      var _a2;
      if (!((_a2 = _.organization) == null ? void 0 : _a2.end_user_shortcuts_enabled))
        return false;
      return true;
    };
    selectDefaultSummonHotkey = (_) => {
      var _a2, _b2, _c2;
      let summonHotkey = "mod+k";
      if (((_a2 = _.organization) == null ? void 0 : _a2.summon_hotkey_override) === "none") {
        summonHotkey = "";
      } else if (((_b2 = _.organization) == null ? void 0 : _b2.summon_hotkey_override) !== void 0 && ((_c2 = _.organization) == null ? void 0 : _c2.summon_hotkey_override) !== null) {
        summonHotkey = _.organization.summon_hotkey_override;
      }
      return summonHotkey;
    };
    selectSummonHotkey = (_) => {
      var _a2, _b2;
      let summonHotkey = selectDefaultSummonHotkey(_);
      if (!((_a2 = _.organization) == null ? void 0 : _a2.end_user_shortcuts_enabled))
        return summonHotkey;
      if (!((_b2 = _.flags) == null ? void 0 : _b2["disable-custom-spotlight-hotkey"]) && typeof _.endUserStore.data.hotkeys[SUMMON_HOTKEY_SLUG] === "string") {
        summonHotkey = _.endUserStore.data.hotkeys[SUMMON_HOTKEY_SLUG];
      }
      return summonHotkey;
    };
    getCategoryField = (_, categoryId, field) => {
      const { categories } = _.spotlight;
      const category = categories.find((obj) => obj.id === categoryId);
      if (category && category[field]) {
        return category[field];
      }
      return null;
    };
    getContextSettings = (_) => _.contextSettings;
    selectHiddenCategories = (_) => _.spotlight.categories.filter((category) => category.setting_hide_before_search).map((category) => category.id);
    selectMenuIsOpen = (_) => {
      const inlineFormFactor = _.spotlight.formFactor.type === "inline";
      const menuIsClosed = _.spotlight.dashboard || inlineFormFactor && !_.spotlight.visible;
      return !menuIsClosed;
    };
    selectSlashFilterGroups = (_) => {
      var _a2;
      if (!((_a2 = _.organization) == null ? void 0 : _a2.slash_filters_enabled)) {
        return [];
      }
      const retval = _.spotlight.currentGroups.filter((group) => {
        return group.slash_filter_enabled;
      });
      return retval;
    };
    selectSlashFilterHint = (_, keyword) => {
      const groups = selectSlashFilterGroups(_);
      const getMatch = (text, theme) => {
        if (!text || text === "") {
          return;
        }
        text = text.toLowerCase();
        const labelAllTab = !!theme ? slugify_default(theme.searchTab.labelAllTab) : "all";
        if (labelAllTab.toLowerCase().startsWith(text)) {
          return labelAllTab;
        }
        const match3 = groups.filter((group) => {
          return !!group.slash_filter_keyword && group.slash_filter_keyword.toLowerCase() !== text.toLowerCase() && group.slash_filter_keyword.toLowerCase().startsWith(text.toLowerCase());
        }).sort(
          (a, b) => !a.slash_filter_keyword || !b.slash_filter_keyword ? 0 : a.slash_filter_keyword.length - b.slash_filter_keyword.length
        )[0];
        if (match3) {
          return match3.slash_filter_keyword;
        } else {
          return;
        }
      };
      if (typeof keyword === "undefined") {
        const { slashFilterKeyword } = selectSlashFilter(_);
        keyword = slashFilterKeyword;
      }
      const match2 = getMatch(keyword, _.theme);
      const length = keyword.length;
      if (!match2) {
        return "";
      } else {
        return match2.slice(length);
      }
    };
    selectSlashFilter = (_) => {
      return extractSlashFilter(_.spotlight.rawInput);
    };
    selectIsFinalStep = (_) => {
      const { currentStep, currentStepIndex } = currentStepAndIndex(_);
      if (!currentStep) {
        return false;
      }
      return isFinalStep(currentStep, _.spotlight.steps, currentStepIndex);
    };
    getTabKey = (optionGroupKey) => {
      if (!optionGroupKey || !optionGroupKey.startsWith("TAB")) {
        return null;
      } else {
        const lastIndex = optionGroupKey.lastIndexOf("-");
        return optionGroupKey.slice(lastIndex + 1);
      }
    };
    selectCurrentTab = (_) => {
      const currentFilter = _.spotlight.searchFilter;
      return _.spotlight.tabs.find((t44) => getTabKey(currentFilter == null ? void 0 : currentFilter.slug) === `${t44.id}`);
    };
    showRotatingPlaceholders = (_) => {
      const placeholders = selectAllPlaceholders(_);
      return !_.spotlight.rawInput && (_.spotlight.visible || _.spotlight.formFactor.type === "inline") && Array.isArray(placeholders) && placeholders.length > 1;
    };
    selectAllPlaceholders = (_) => {
      const { showLoadingIndicator, searchFilter, placeholders } = _.spotlight;
      if (showLoadingIndicator) {
        return "Loading...";
      }
      if (!!(searchFilter == null ? void 0 : searchFilter.placeholder)) {
        return interpolate(searchFilter.placeholder, _, true, false);
      }
      const { currentStep } = currentStepAndIndex(_);
      const stepPlaceholder = currentStep && getStepPlaceholder(currentStep);
      if (stepPlaceholder)
        return stepPlaceholder;
      const userDefinedPlaceholders = placeholders.map((p) => p.text);
      if (!userDefinedPlaceholders.length)
        return DEFAULT_PLACEHOLDER;
      return userDefinedPlaceholders;
    };
    selectFirstPlaceholder = (_) => {
      const placeholders = selectAllPlaceholders(_);
      if (Array.isArray(placeholders)) {
        return placeholders[0];
      } else {
        return placeholders;
      }
    };
    isGridView = (_) => {
      var _a2, _b2;
      if (isMobileDevice()) {
        return false;
      }
      const { currentStep } = currentStepAndIndex(_);
      return (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && ((_a2 = _.spotlight.searchFilter) == null ? void 0 : _a2.renderAs) === "grid" || isSelectStep(currentStep) && isContextArgument(currentStep.argument) && ((_b2 = getContextSettings(_)[currentStep.argument.value]) == null ? void 0 : _b2.render_as) === "grid";
    };
    optionIsInGrid = (_, option) => {
      return isGridView(_);
    };
    getNextStepOptions = (_) => {
      var _a2;
      const { currentStep } = currentStepAndIndex(_);
      let nextStepCommands = [];
      if ((currentStep == null ? void 0 : currentStep.type) === "dashboard" /* Dashboard */) {
        nextStepCommands = ((_a2 = currentStep == null ? void 0 : currentStep.command) == null ? void 0 : _a2.next_steps) || [];
      } else {
        const focusedOption = _.spotlight.sortedOptions[_.spotlight.focusedIndex];
        if (focusedOption && isCommandOption(focusedOption) && focusedOption.detailPreview) {
          nextStepCommands = focusedOption.command.next_steps;
        }
      }
      if (nextStepCommands.length === 0) {
        return [];
      }
      const nextStepOptions = availableCommands(_).filter((o) => nextStepCommands.indexOf(o.command.id) !== -1).sort((a, b) => {
        if (a.isRecommended && b.isRecommended) {
          return compareObjs(
            {
              sort_key: a.command.recommend_sort_key,
              id: a.command.id
            },
            {
              sort_key: b.command.recommend_sort_key,
              id: b.command.id
            }
          );
        }
        if (a.isRecommended) {
          return -1;
        }
        if (b.isRecommended) {
          return 1;
        }
        return nextStepCommands.indexOf(a.command.id) - nextStepCommands.indexOf(b.command.id);
      });
      const labeledActions = nextStepCommands.filter((c) => isAction(c));
      return nextStepOptions.concat(labeledActions);
    };
    getDetailPreviewContent = (_, row) => {
      if (isOptionGroup(row))
        return null;
      if (isGridView(_))
        return null;
      if (row.detailPreview) {
        return standardize(row.detailPreview);
      } else if (!!_.detailPreviewGenerator) {
        return standardize(_.detailPreviewGenerator(getOptionData(row), getOptionMetadata(row)));
      } else {
        return null;
      }
    };
    isArgumentClientSearchActive = (_) => {
      const getActiveArgumentClientSearchKey = () => {
        const { currentStep } = currentStepAndIndex(_);
        const activeContextKey = isSelectStep(currentStep) && isContextArgument(currentStep.argument) ? currentStep.argument.value : void 0;
        if (activeContextKey && ClientSearch_default.isDefined(activeContextKey, _)) {
          return activeContextKey;
        }
        return void 0;
      };
      return !!getActiveArgumentClientSearchKey();
    };
    isVisible = (_) => _.spotlight.previewMode ? true : _.spotlight.visible;
  }
});

// commandbar/src/shared/util/hooks/useMutableState.tsx
import React6 from "react";
var useMutableState;
var init_useMutableState = __esm({
  "commandbar/src/shared/util/hooks/useMutableState.tsx"() {
    "use strict";
    init_GlobalStoreProvider();
    useMutableState = () => React6.useContext(GlobalStoreContext);
  }
});

// commandbar/src/shared/util/hooks/useAction.tsx
import React7 from "react";
var useAction;
var init_useAction = __esm({
  "commandbar/src/shared/util/hooks/useAction.tsx"() {
    "use strict";
    init_useMutableState();
    useAction = (actionFn, deps = []) => React7.useCallback(actionFn.bind(null, useMutableState()), deps);
  }
});

// commandbar/src/shared/util/hooks/useTheme.tsx
import { useTheme as _useTheme } from "emotion-theming";
function useTheme() {
  return _useTheme();
}
function getMargins(css79) {
  const margins = css79.split(" ");
  switch (margins.length) {
    case 1: {
      return {
        top: margins[0],
        right: margins[0],
        bottom: margins[0],
        left: margins[0]
      };
    }
    case 2: {
      return {
        top: margins[0],
        right: margins[1],
        bottom: margins[0],
        left: margins[1]
      };
    }
    case 3: {
      return {
        top: margins[0],
        right: margins[1],
        bottom: margins[2],
        left: margins[1]
      };
    }
    case 4: {
      return {
        top: margins[0],
        right: margins[1],
        bottom: margins[2],
        left: margins[3]
      };
    }
    default: {
      return {
        top: "",
        right: "",
        bottom: "",
        left: ""
      };
    }
  }
}
var init_useTheme = __esm({
  "commandbar/src/shared/util/hooks/useTheme.tsx"() {
    "use strict";
  }
});

// design-system/src/colors.ts
var CB_COLORS;
var init_colors = __esm({
  "design-system/src/colors.ts"() {
    "use strict";
    CB_COLORS = {
      primary: "#2755f0",
      white: "#ffffff",
      black: "#000000",
      neutral0: "#F7F7F8",
      neutral100: "#EDEDEE",
      neutral200: "#E7E7E9",
      neutral300: "#DFDFE2",
      neutral400: "#CDCDD0",
      neutral500: "#A2A2A9",
      neutral600: "#7A7A85",
      neutral700: "#51515C",
      neutral800: "#42424D",
      neutral900: "#1E1E29",
      neutral1000: "#0A0A0F",
      blue0: "#F5F7FF",
      blue100: "#E6ECFE",
      blue200: "#C4D1FD",
      blue300: "#90A8F9",
      blue400: "#6887EE",
      blue500: "#456BE8",
      blue600: "#2755F0",
      blue700: "#0E3FDD",
      blue800: "#072EAB",
      blue900: "#031963",
      blue1000: "#030F38",
      green500: "#2C5009",
      red500: "#9A3412"
    };
  }
});

// internal/src/client/themesV2/defaults.ts
var DEFAULT_THEME;
var init_defaults = __esm({
  "internal/src/client/themesV2/defaults.ts"() {
    "use strict";
    DEFAULT_THEME = {
      dark_mode: {
        var_defaults: {
          "--base-accent": "rgb(120, 86, 255)",
          "--base-white": "rgb(255, 255, 255)",
          "--base-black": "rgb(0, 0, 0)",
          "--font-font-family": 'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          "--font-weight-regular": 400,
          "--font-weight-medium": 500,
          "--font-weight-semibold": 600,
          "--font-weight-bold": 700,
          "--font-size-small": "12px",
          "--font-size-base": "14px",
          "--font-size-large": "16px",
          "--font-size-extra-large": "22px",
          "--font-line-height-none": "1",
          "--font-line-height-tight": "1.2",
          "--font-line-height-snug": "1.375",
          "--font-line-height-normal": "1.5",
          "--content-primary": "rgb(255, 255, 255)",
          "--content-secondary": "rgb(167, 167, 167)",
          "--content-disabled": "rgb(86, 86, 86)",
          "--content-primary-hover": "var(--content-primary)",
          "--content-secondary-hover": "var(--content-secondary)",
          "--content-link": "var(--base-accent)",
          "--content-link-hover": "color-mix(in srgb, var(--content-link) 80%, white)",
          "--content-link-visited": "color-mix(in srgb, var(--content-link) 80%, black)",
          "--border-primary": "rgb(59, 59, 59)",
          "--border-primary-hover": "rgb(71, 71, 71)",
          "--border-primary-disabled": "rgb(54, 54, 54)",
          "--background-primary": "rgb(30, 30, 30)",
          "--background-primary-hover": "rgb(43, 43, 43)",
          "--background-secondary": "rgb(15, 15, 15)",
          "--background-secondary-hover": "rgb(28, 28, 28)",
          "--background-disabled": "var(--background-secondary)",
          "--header-height": "40px",
          "--height-small": "16px",
          "--form-control-height": "32px",
          "--form-control-width": "100%",
          "--form-control-padding-x": "8px",
          "--form-control-gap": "8px",
          "--form-control-active-background": "rgb(from var(--base-accent) r g b / .10)",
          "--form-control-focus-ring-color": "rgb(from var(--base-accent) r g b / .24)",
          "--form-control-focus-ring-width": "3px",
          "--layout-radius-button": "6px",
          "--layout-radius-card": "8px",
          "--layout-radius-circle": "100px",
          "--layout-padding": "12px",
          "--layout-gap": "8px",
          "--layout-shadow": "0px 4px 16px 0px",
          "--layout-shadow-color": "rgba(0, 0, 0, 0.08)",
          "--form-control-shadow": "none",
          "--form-control-shadow-color": "rgba(0, 0, 0, 0)",
          "--form-control-background": "var(--background-primary)",
          "--form-control-background-hover": "var(--background-primary-hover)",
          "--form-control-background-disabled": "var(--background-secondary)",
          "--form-control-border-color": "var(--border-primary)",
          "--form-control-border-color-hover": "var(--border-primary-hover)",
          "--form-control-border-color-disabled": "var(--border-primary-disabled)",
          "--tooltip-max-width": "300px",
          "--popover-width": "300px",
          "--modal-width": "360px",
          "--checklist-width": "360px",
          "--checklist-max-height": "500px",
          "--helphub-width": "440px",
          "--helphub-height": "calc(100vh - 24px)",
          "--spotlight-width": "670px",
          "--spotlight-max-height": "400px",
          "--button-primary-background": "var(--base-accent)",
          "--button-primary-background-hover": "color-mix(in srgb, var(--base-accent) 80%, white)",
          "--button-primary-border-color": "var(--button-primary-background)",
          "--button-primary-border-color-hover": "var(--button-primary-background-hover)",
          "--button-primary-content": "rgb(255, 255, 255)",
          "--button-primary-content-hover": "rgb(255, 255, 255)",
          "--button-secondary-background": "var(--background-primary)",
          "--button-secondary-background-hover": "var(--background-primary-hover)",
          "--button-secondary-border-color": "var(--border-primary)",
          "--button-secondary-border-color-hover": "var(--border-primary-hover)",
          "--button-secondary-content": "var(--content-secondary)",
          "--button-secondary-content-hover": "var(--content-primary)",
          "--button-tertiary-background": "rgba(255, 255, 255, 0)",
          "--button-tertiary-background-hover": "var(--background-primary-hover)",
          "--button-tertiary-border-color": "rgba(255, 255, 255, 0)",
          "--button-tertiary-border-color-hover": "rgba(255, 255, 255, 0)",
          "--button-tertiary-content": "var(--content-secondary)",
          "--button-tertiary-content-hover": "var(--content-primary)",
          "--nudge-rating-star-color": "rgb(221, 158, 35)",
          "--nudge-rating-star-color-selected": "var(--nudge-rating-star-color)",
          "--highlight-color": "rgb(240, 233, 187)",
          "--anim-transition-duration": "260ms",
          "--anim-transform-initial--spring": "scale(.85)",
          "--anim-transform-animated--spring": "scale(1)",
          "--anim-transform-initial--scale": "scale(0.85)",
          "--anim-transform-animated--scale": "scale(1)",
          "--anim-transition-property--instant": "none",
          "--anim-transition-property--fade": "opacity",
          "--anim-transition-property--spring": "opacity, transform",
          "--anim-transition-property--scale": "opacity, transform",
          "--anim-transition-timing--instant": "none",
          "--anim-transition-timing--fade": "ease-in-out",
          "--anim-transition-timing--spring": "cubic-bezier(0.33, 1.56, 0.60, 1)",
          "--anim-transition-timing--scale": "cubic-bezier(0.33, 1.25, 0.65, 1)",
          "--modal-anim-transition-property": "var(--anim-transition-property--instant)",
          "--modal-anim-transition-duration": "var(--anim-transition-duration)",
          "--modal-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--popover-anim-transition-property": "var(--anim-transition-property--instant)",
          "--popover-anim-transition-duration": "var(--anim-transition-duration)",
          "--popover-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--tooltip-anim-transition-property": "var(--anim-transition-property--instant)",
          "--tooltip-anim-transition-duration": "var(--anim-transition-duration)",
          "--tooltip-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--spotlight-anim-transition-property": "var(--anim-transition-property--instant)",
          "--spotlight-anim-transition-duration": "var(--anim-transition-duration)",
          "--spotlight-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--helphub-anim-transition-property": "var(--anim-transition-property--instant)",
          "--helphub-anim-transition-duration": "var(--anim-transition-duration)",
          "--helphub-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--checklist-anim-transition-property": "var(--anim-transition-property--instant)",
          "--checklist-anim-transition-duration": "var(--anim-transition-duration)",
          "--checklist-anim-transition-timing": "var(--anim-transition-timing--instant)"
        },
        var_overrides: {},
        component_overrides: {},
        mobile_overrides: {}
      },
      light_mode: {
        var_defaults: {
          "--base-accent": "rgb(120, 86, 255)",
          "--base-black": "rgb(0, 0, 0)",
          "--base-white": "rgb(255, 255, 255)",
          "--font-font-family": 'system-ui, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          "--font-weight-regular": 400,
          "--font-weight-medium": 500,
          "--font-weight-semibold": 600,
          "--font-weight-bold": 700,
          "--font-size-small": "12px",
          "--font-size-base": "14px",
          "--font-size-large": "16px",
          "--font-size-extra-large": "22px",
          "--font-line-height-none": "1",
          "--font-line-height-tight": "1.2",
          "--font-line-height-snug": "1.375",
          "--font-line-height-normal": "1.5",
          "--content-primary": "rgb(55, 53, 48)",
          "--content-secondary": "rgb(125, 124, 120)",
          "--content-disabled": "rgb(192, 192, 192)",
          "--content-primary-hover": "var(--content-primary)",
          "--content-secondary-hover": "var(--content-secondary)",
          "--content-link": "var(--base-accent)",
          "--content-link-hover": "color-mix(in srgb, var(--content-link) 80%, white)",
          "--content-link-visited": "color-mix(in srgb, var(--content-link) 80%, black)",
          "--border-primary": "rgb(226, 226, 226)",
          "--border-primary-hover": "rgb(201, 201, 201)",
          "--border-primary-disabled": "rgb(232, 232, 232)",
          "--background-primary": "rgb(255, 255, 255)",
          "--background-primary-hover": "rgb(242, 242, 242)",
          "--background-secondary": "rgb(247, 247, 247)",
          "--background-secondary-hover": "rgb(235, 235, 235)",
          "--background-disabled": "var(--background-secondary)",
          "--header-height": "40px",
          "--height-small": "16px",
          "--form-control-height": "32px",
          "--form-control-width": "100%",
          "--form-control-padding-x": "8px",
          "--form-control-gap": "8px",
          "--form-control-active-background": "rgb(from var(--base-accent) r g b / .10)",
          "--form-control-focus-ring-color": "rgb(from var(--base-accent) r g b / .24)",
          "--form-control-focus-ring-width": "3px",
          "--layout-radius-button": "6px",
          "--layout-radius-card": "8px",
          "--layout-radius-circle": "100px",
          "--layout-padding": "12px",
          "--layout-gap": "8px",
          "--layout-shadow": "0px 4px 16px 0px",
          "--layout-shadow-color": "rgba(0, 0, 0, 0.08)",
          "--form-control-shadow": "none",
          "--form-control-shadow-color": "rgba(0, 0, 0, 0)",
          "--form-control-background": "var(--background-primary)",
          "--form-control-background-hover": "var(--background-primary-hover)",
          "--form-control-background-disabled": "var(--background-secondary)",
          "--form-control-border-color": "var(--border-primary)",
          "--form-control-border-color-hover": "var(--border-primary-hover)",
          "--form-control-border-color-disabled": "var(--border-primary-disabled)",
          "--tooltip-max-width": "300px",
          "--popover-width": "300px",
          "--modal-width": "360px",
          "--checklist-width": "360px",
          "--checklist-max-height": "500px",
          "--helphub-width": "440px",
          "--helphub-height": "calc(100vh - 24px)",
          "--spotlight-width": "670px",
          "--spotlight-max-height": "400px",
          "--button-primary-background": "var(--base-accent)",
          "--button-primary-background-hover": "color-mix(in srgb, var(--base-accent) 80%, white)",
          "--button-primary-border-color": "var(--button-primary-background)",
          "--button-primary-border-color-hover": "var(--button-primary-background-hover)",
          "--button-primary-content": "rgb(255, 255, 255)",
          "--button-primary-content-hover": "rgb(255, 255, 255)",
          "--button-secondary-background": "var(--background-primary)",
          "--button-secondary-background-hover": "var(--background-primary-hover)",
          "--button-secondary-border-color": "var(--border-primary)",
          "--button-secondary-border-color-hover": "var(--border-primary-hover)",
          "--button-secondary-content": "var(--content-secondary)",
          "--button-secondary-content-hover": "var(--content-primary)",
          "--button-tertiary-background": "rgba(255, 255, 255, 0)",
          "--button-tertiary-background-hover": "var(--background-primary-hover)",
          "--button-tertiary-border-color": "rgba(255, 255, 255, 0)",
          "--button-tertiary-border-color-hover": "rgba(255, 255, 255, 0)",
          "--button-tertiary-content": "var(--content-secondary)",
          "--button-tertiary-content-hover": "var(--content-primary)",
          "--nudge-rating-star-color": "rgb(221, 158, 35)",
          "--nudge-rating-star-color-selected": "var(--nudge-rating-star-color)",
          "--highlight-color": "rgb(240, 233, 187)",
          "--anim-transition-duration": "260ms",
          "--anim-transform-initial--spring": "scale(.85)",
          "--anim-transform-animated--spring": "scale(1)",
          "--anim-transform-initial--scale": "scale(0.85)",
          "--anim-transform-animated--scale": "scale(1)",
          "--anim-transition-property--instant": "none",
          "--anim-transition-property--fade": "opacity",
          "--anim-transition-property--spring": "opacity, transform",
          "--anim-transition-property--scale": "opacity, transform",
          "--anim-transition-timing--instant": "none",
          "--anim-transition-timing--fade": "ease-in-out",
          "--anim-transition-timing--spring": "cubic-bezier(0.33, 1.56, 0.60, 1)",
          "--anim-transition-timing--scale": "cubic-bezier(0.33, 1.25, 0.65, 1)",
          "--modal-anim-transition-property": "var(--anim-transition-property--instant)",
          "--modal-anim-transition-duration": "var(--anim-transition-duration)",
          "--modal-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--popover-anim-transition-property": "var(--anim-transition-property--instant)",
          "--popover-anim-transition-duration": "var(--anim-transition-duration)",
          "--popover-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--tooltip-anim-transition-property": "var(--anim-transition-property--instant)",
          "--tooltip-anim-transition-duration": "var(--anim-transition-duration)",
          "--tooltip-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--spotlight-anim-transition-property": "var(--anim-transition-property--instant)",
          "--spotlight-anim-transition-duration": "var(--anim-transition-duration)",
          "--spotlight-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--helphub-anim-transition-property": "var(--anim-transition-property--instant)",
          "--helphub-anim-transition-duration": "var(--anim-transition-duration)",
          "--helphub-anim-transition-timing": "var(--anim-transition-timing--instant)",
          "--checklist-anim-transition-property": "var(--anim-transition-property--instant)",
          "--checklist-anim-transition-duration": "var(--anim-transition-duration)",
          "--checklist-anim-transition-timing": "var(--anim-transition-timing--instant)"
        },
        var_overrides: {},
        component_overrides: {},
        mobile_overrides: {}
      }
    };
  }
});

// commandbar/src/shared/components/ThemeV2Context.tsx
import React8, { useEffect as useEffect2, useRef } from "react";
var COMMANDBAR_WIDGET_CLASSNAME, ThemeV2Context, useThemeV2Context, idCounter, BindThemeV2, BindThemeV2ByUUID, BindThemeV2ForNudge;
var init_ThemeV2Context = __esm({
  "commandbar/src/shared/components/ThemeV2Context.tsx"() {
    "use strict";
    init_defaults();
    init_location();
    init_useCommandBarContainer();
    init_useStore();
    COMMANDBAR_WIDGET_CLASSNAME = "cb-widget-ce80a7eb65";
    ThemeV2Context = React8.createContext(void 0);
    useThemeV2Context = () => React8.useContext(ThemeV2Context);
    idCounter = 0;
    BindThemeV2 = (props2) => {
      var _a2, _b2;
      const parentContext = useThemeV2Context();
      const { root } = useCommandBarContainer();
      const mode = (_b2 = (_a2 = props2.mode) != null ? _a2 : parentContext.mode) != null ? _b2 : "light_mode";
      const { themeV2, children } = props2;
      const generatedCSSClassnameRef = useRef(null);
      let generatedCSSClassname = generatedCSSClassnameRef.current;
      if (!generatedCSSClassname) {
        generatedCSSClassnameRef.current = `${COMMANDBAR_WIDGET_CLASSNAME}-${idCounter++}`;
        generatedCSSClassname = generatedCSSClassnameRef.current;
      }
      useEffect2(() => {
        const roots = /* @__PURE__ */ new Set([document, root]);
        let sheet;
        try {
          sheet = new CSSStyleSheet();
        } catch (e) {
          return;
        }
        const themeObject = {
          ...DEFAULT_THEME[mode].var_defaults,
          ...themeV2 == null ? void 0 : themeV2[mode].var_defaults,
          ...themeV2 == null ? void 0 : themeV2.light_mode.var_overrides,
          ...themeV2 == null ? void 0 : themeV2[mode].var_overrides
        };
        const cssVars = Object.entries(themeObject).map(([key, value]) => {
          if (isStudioPreview() && key === "--font-font-family") {
            return `${key}: ${value}, ${DEFAULT_THEME.light_mode.var_defaults["--font-font-family"]};`;
          }
          return `${key}: ${value};`;
        }).join("\n");
        sheet.insertRule(`.${generatedCSSClassname} { ${cssVars} }`);
        roots.forEach((r) => {
          var _a3;
          if (r)
            r.adoptedStyleSheets = [...(_a3 = r.adoptedStyleSheets) != null ? _a3 : [], sheet];
        });
        return () => {
          roots.forEach((r) => {
            var _a3;
            if (r)
              r.adoptedStyleSheets = (_a3 = r.adoptedStyleSheets) == null ? void 0 : _a3.filter((s) => s !== sheet);
          });
        };
      }, [themeV2 == null ? void 0 : themeV2[mode].var_defaults, themeV2 == null ? void 0 : themeV2.light_mode.var_overrides, themeV2 == null ? void 0 : themeV2[mode].var_overrides, mode, root]);
      return /* @__PURE__ */ React8.createElement(ThemeV2Context.Provider, { value: { themeV2, mode, generatedCSSClassname } }, /* @__PURE__ */ React8.createElement("div", { className: generatedCSSClassname, style: { display: "contents" } }, children));
    };
    BindThemeV2ByUUID = (props2) => {
      var _a2, _b2, _c2, _d;
      const _ = useStore();
      const { themeUUID, mode, children, nudge } = props2;
      if (!themeUUID && !nudge && !((_a2 = _.themeV2Override) == null ? void 0 : _a2.themeV2))
        return /* @__PURE__ */ React8.createElement(React8.Fragment, null, children);
      let themeV2 = (_b2 = _.themeV2Override) == null ? void 0 : _b2.themeV2;
      if (!themeV2) {
        themeV2 = (_c2 = _.themes.find((t44) => t44.uuid === themeUUID)) == null ? void 0 : _c2.themeV2;
      }
      if (!themeV2) {
        themeV2 = (_d = _.themes.find((t44) => t44.default)) == null ? void 0 : _d.themeV2;
      }
      if (themeV2) {
        return /* @__PURE__ */ React8.createElement(BindThemeV2, { themeV2, mode }, children);
      }
      return /* @__PURE__ */ React8.createElement(React8.Fragment, null, children);
    };
    BindThemeV2ForNudge = (props2) => {
      const { organization } = useStore();
      const categoryThemeOverride = (() => {
        switch (props2.nudge.type) {
          case "announcement":
            return organization == null ? void 0 : organization.announcements_custom_theme;
          case "product_tour":
            return organization == null ? void 0 : organization.product_tours_custom_theme;
          case "survey":
            return organization == null ? void 0 : organization.surveys_custom_theme;
        }
      })();
      return /* @__PURE__ */ React8.createElement(BindThemeV2ByUUID, { themeUUID: props2.nudge.custom_theme || categoryThemeOverride, nudge: props2.nudge }, props2.children);
    };
  }
});

// commandbar/src/shared/util/hooks/useMobileExperience.tsx
import { useEffect as useEffect3, useRef as useRef2 } from "react";
var getNativeCallback, useMobileExperience;
var init_useMobileExperience = __esm({
  "commandbar/src/shared/util/hooks/useMobileExperience.tsx"() {
    "use strict";
    init_operatingSystem();
    init_useStore();
    init_useTheme();
    init_location();
    init_Z();
    init_ThemeV2Context();
    init_global_store();
    getNativeCallback = () => {
      var _a2, _b2, _c2, _d;
      if ((_c2 = (_b2 = (_a2 = window.webkit) == null ? void 0 : _a2.messageHandlers) == null ? void 0 : _b2.commandbar__onFallbackAction) == null ? void 0 : _c2.postMessage) {
        return window.webkit.messageHandlers.commandbar__onFallbackAction.postMessage.bind(
          window.webkit.messageHandlers.commandbar__onFallbackAction
        );
      } else if ((_d = window.CommandBarAndroidInterface) == null ? void 0 : _d.commandbar__onFallbackAction) {
        return window.CommandBarAndroidInterface.commandbar__onFallbackAction.bind(window.CommandBarAndroidInterface);
      }
      return void 0;
    };
    useMobileExperience = (preview) => {
      const store = !preview ? useStore() : emptyGlobalStore();
      const editorPreviewDevice = store.editorPreviewDevice;
      const isStudioMobilePreview = editorPreviewDevice === "mobile" && isStudioPreview();
      const studioMobilePreviewWrapper = useRef2(
        document.getElementById("commandbar-mobile-preview-wrapper")
      );
      const { theme } = useTheme();
      const themeV2Context = useThemeV2Context();
      const isMobileDevice2 = isMobileDevice();
      useEffect3(() => {
        var _a2;
        if (!isStudioMobilePreview)
          return;
        studioMobilePreviewWrapper.current = document.getElementById("commandbar-mobile-preview-wrapper");
        (_a2 = studioMobilePreviewWrapper.current) == null ? void 0 : _a2.classList.add(themeV2Context.generatedCSSClassname);
      }, [isStudioMobilePreview]);
      const mobileStyles = {
        checklists: {
          container: {
            fontFamily: theme == null ? void 0 : theme.questlists.fontFamily,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "0px",
            margin: "16px",
            width: "auto",
            background: theme == null ? void 0 : theme.questlists.bodyBackground,
            boxShadow: theme == null ? void 0 : theme.questlists.boxShadow,
            borderRadius: theme == null ? void 0 : theme.questlists.borderRadius,
            bottom: "0px",
            right: "0px",
            left: "0px",
            overflow: "hidden",
            zIndex: Z_default.Z_CHECKLIST,
            position: isStudioMobilePreview ? "absolute" : "fixed"
          }
        },
        nudges: {
          modal: {
            contentContainer: {
              width: "100%",
              height: "100%"
            },
            mask: {
              backgroundColor: theme == null ? void 0 : theme.nudgeModal.maskBackgroundColor,
              zIndex: Z_default.Z_EDITOR - 2,
              width: "100%",
              height: "100%",
              maxWidth: EDITOR_MOBILE_PREVIEW_SCREEN_WIDTH,
              maxHeight: EDITOR_MOBILE_PREVIEW_SCREEN_HEIGHT,
              position: "absolute"
            },
            wrap: {
              width: "100%",
              height: "100%",
              maxWidth: EDITOR_MOBILE_PREVIEW_SCREEN_WIDTH,
              maxHeight: EDITOR_MOBILE_PREVIEW_SCREEN_HEIGHT,
              position: "absolute"
            },
            container: {
              width: "100%",
              height: theme == null ? void 0 : theme.nudgeModal.height,
              margin: "16px",
              borderRadius: theme == null ? void 0 : theme.nudgeModal.borderRadius,
              boxShadow: theme == null ? void 0 : theme.nudgeModal.boxShadow,
              backgroundColor: theme == null ? void 0 : theme.nudgeModal.background,
              fontFamily: theme == null ? void 0 : theme.nudgeModal.fontFamily,
              color: theme == null ? void 0 : theme.nudgeModal.color
            }
          },
          pin: {
            container: {
              position: "absolute",
              display: "flex",
              gap: "16px",
              pointerEvents: "none",
              zIndex: Z_default.Z_COMMANDBAR - 3
            }
          },
          tooltip: {
            container: {
              position: "absolute",
              display: "flex",
              gap: "16px",
              pointerEvents: "none",
              zIndex: Z_default.Z_COMMANDBAR - 3
            }
          },
          popover: {
            container: {
              width: "100%",
              display: "flex",
              flexDirection: "column",
              background: theme == null ? void 0 : theme.nudges.background,
              borderRadius: theme == null ? void 0 : theme.nudges.borderRadius,
              color: theme == null ? void 0 : theme.nudges.color,
              zIndex: Z_default.Z_COMMANDBAR - 2,
              boxShadow: theme == null ? void 0 : theme.nudges.boxShadow,
              fontFamily: theme == null ? void 0 : theme.nudges.fontFamily,
              transition: "opacity 0.15s ease-in-out",
              pointerEvents: "all",
              position: "relative"
            }
          },
          popoverMobileThemesV2: {
            container: {
              width: "100%",
              display: "flex",
              flexDirection: "column",
              zIndex: Z_default.Z_COMMANDBAR - 2,
              transition: "opacity 0.15s ease-in-out",
              pointerEvents: "all",
              position: "relative"
            }
          },
          banner: {
            container: {
              position: "absolute",
              display: "flex",
              gap: "16px",
              zIndex: Z_default.Z_COMMANDBAR - 3
            },
            body: {
              flexDirection: "column",
              marginRight: "var(--layout-padding)",
              justifyContent: "space-between"
            },
            closeButtonContainer: {
              position: "absolute",
              display: "flex",
              top: "calc(max(var(--layout-padding) - 4px, 0px))",
              right: "calc(max(var(--layout-padding) - 12px, 0px))",
              maxHeight: "32px",
              maxWidth: "32px",
              borderRadius: "var(--layout-radius-button)",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden"
            },
            spaceContainer: {
              display: "none"
            },
            title: {
              flexDirection: "column",
              fontSize: "var(--font-size-large)",
              lineHeight: "var(--font-line-height-snug)",
              alignSelf: "flex-start"
            },
            actionBar: {
              padding: "0px",
              width: "100%"
            },
            stickyContainer: {
              width: "100%",
              top: "0px",
              position: "fixed",
              pointerEvents: "none",
              zIndex: Z_default.Z_NUDGE,
              height: "100%"
            },
            inlineContainer: {
              width: "100%",
              zIndex: Z_default.Z_NUDGE
            }
          }
        },
        toast: {
          modal: { bottom: "0px" },
          container: { position: "relative", width: "100%", height: "100%" },
          contentContainer: {
            position: "absolute",
            zIndex: Z_default.Z_INDEX_MAX,
            pointerEvents: "none"
          }
        }
      };
      return {
        isMobileDevice: isMobileDevice2 || isStudioMobilePreview,
        isStudioMobilePreview,
        studioMobilePreviewWrapper: studioMobilePreviewWrapper.current,
        mobileStyles
      };
    };
  }
});

// commandbar/src/products/helphub/components/useStyles.tsx
var asHelpHubStyles, useStyles;
var init_useStyles = __esm({
  "commandbar/src/products/helphub/components/useStyles.tsx"() {
    "use strict";
    init_useTheme();
    init_colors();
    init_useMobileExperience();
    asHelpHubStyles = (styles51) => styles51;
    useStyles = (disableMobile = false, preview, providedTheme) => {
      const { theme } = providedTheme ? { theme: providedTheme } : useTheme();
      const disabledMobileOverrides = { isMobileDevice: false, isStudioMobilePreview: false };
      const mobile = !disableMobile ? useMobileExperience(preview) : disabledMobileOverrides;
      const { isMobileDevice: isMobileDevice2, isStudioMobilePreview } = mobile;
      const headerPadding = getMargins(theme.helpHub.headerPadding);
      return asHelpHubStyles({
        modalContainer: {
          position: "fixed",
          bottom: "12px",
          right: "12px",
          width: theme.helpHub.width,
          height: theme.helpHub.height,
          borderRadius: theme.helpHub.borderRadius,
          boxShadow: "0px 16px 40px rgba(10, 10, 15, 0.24)",
          border: `none`,
          zIndex: theme.helpHub.zIndex,
          color: "#0A0A0F",
          fontFamily: theme.helpHub.fontFamily,
          transform: "none",
          overflow: "hidden"
        },
        modal: {
          height: "100%",
          width: "100%",
          background: theme.helpHub.heroBackground,
          borderRadius: theme.helpHub.borderRadius,
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          fontFamily: theme.helpHub.fontFamily,
          zIndex: theme.helpHub.zIndex
        },
        strings: {
          title: theme.helpHub.title,
          featuredContentLabel: theme.helpHub.featuredContentLabel,
          chatInputPlaceholder: theme.helpHub.chatInputPlaceholder,
          docLinkText: theme.helpHub.docLinkText,
          askAICustomCTAButtonLabel: theme.helpHub.ctaLabel
        },
        highlightMark: {
          color: theme.helpHub.highlightTextColor,
          borderRadius: theme.helpHub.highlightBorderRadius,
          backgroundColor: theme.helpHub.highlightBackgroundColor
        },
        contentContainer: {
          display: "flex",
          flexDirection: "column",
          width: "100%",
          height: "100%",
          overflowY: "hidden"
        },
        inputContainer: {
          height: "74px",
          padding: "4px 16px 16px 16px",
          width: "100%",
          background: theme.helpHub.inputContainer
        },
        input: {
          width: "100%",
          padding: "0px 102px 0px 16px",
          height: "48px",
          fontFamily: theme.helpHubInput.fontFamily,
          fontSize: theme.helpHubInput.fontSize,
          fontWeight: theme.helpHubInput.fontWeight,
          lineHeight: "19.36px",
          border: "none",
          background: theme.helpHubInput.background,
          color: theme.helpHubInput.color,
          textOverflow: "ellipsis",
          outline: "none",
          "&::placeholder": {
            color: theme.helpHubInput.placeholderColor
          },
          "&::-ms-input-placeholder": {
            color: theme.helpHubInput.placeholderColor
          }
        },
        docInputContainer: { padding: "16px", width: "100%", background: theme.helpHub.inputContainer, zIndex: 1 },
        docInputWrapper: {
          position: "relative"
        },
        docInput: {
          width: "100%",
          padding: "0px 40px 0px 40px",
          borderRadius: theme.helpHubInput.borderRadius,
          height: "48px",
          fontFamily: theme.helpHubInput.fontFamily,
          fontSize: theme.helpHubInput.fontSize,
          fontWeight: theme.helpHubInput.fontWeight,
          lineHeight: "19.36px",
          border: `1px solid ${theme.helpHubInput.borderColor}`,
          background: theme.helpHubInput.background,
          color: theme.helpHubInput.color,
          textOverflow: "ellipsis",
          "&:focus": {
            boxShadow: `0px 0px 0px 3px ${theme.helpHubInput.hoverBorderShadowColor}`,
            border: `1px solid ${theme.helpHubInput.hoverBorderColor}`
          },
          "&:focus-visible": {
            boxShadow: `0px 0px 0px 3px ${theme.helpHubInput.hoverBorderShadowColor}`,
            border: `1px solid ${theme.helpHubInput.hoverBorderColor}`,
            outline: "none"
          },
          "&::placeholder": {
            color: theme.helpHubInput.placeholderColor
          },
          "&::-ms-input-placeholder": {
            color: theme.helpHubInput.placeholderColor
          }
        },
        chatTextAreaContainer: { padding: "16px", width: "100%", background: "#FFF" },
        chatTextAreaWrapper: {
          position: "relative"
        },
        inlineAskAi: {
          position: "absolute",
          top: "50%",
          right: "8px"
        },
        chatTextArea: {
          width: "100%",
          fontFamily: theme.helpHubInput.fontFamily,
          fontSize: theme.helpHubInput.fontSize,
          fontWeight: theme.helpHubInput.fontWeight,
          borderRadius: theme.helpHubInput.borderRadius,
          border: "1px solid transparent",
          background: CB_COLORS.neutral100,
          color: "#1E1E29",
          lineHeight: "22px",
          padding: "12px 72px 12px 20px",
          marginBottom: "-8px",
          height: "auto",
          minHeight: "48px",
          maxHeight: "192px",
          resize: "none",
          display: "inline-block",
          transition: `background ${theme.main.transitionTime}`,
          "&:focus": {
            boxShadow: `0px 0px 0px 3px ${theme.helpHubInput.hoverBorderShadowColor}`,
            border: `1px solid ${theme.helpHubInput.hoverBorderColor}`,
            background: CB_COLORS.neutral0
          },
          "&:focus-visible": {
            boxShadow: `0px 0px 0px 3px ${theme.helpHubInput.hoverBorderShadowColor}`,
            border: `1px solid ${theme.helpHubInput.hoverBorderColor}`,
            outline: "none"
          },
          "&::placeholder": {
            color: "#757575"
          },
          "&::-ms-input-placeholder": {
            color: "#757575"
          }
        },
        AIProfileIcon: {
          width: "73px",
          height: "74px",
          minWidth: "73px",
          minHeight: "74px",
          margin: "-17px"
        },
        chatSuggestion: {
          cursor: "pointer",
          width: "100%",
          alignItems: "center",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "16px",
          display: "flex",
          color: "#51515C",
          padding: "8px",
          transition: `background ${theme.main.transitionTime}`,
          "&:hover": {
            background: "#EDEDEE",
            borderRadius: "4px"
          }
        },
        inputWrapper: {
          position: "absolute",
          zIndex: 100,
          width: "calc(100% - 32px)",
          borderRadius: theme.helpHubInput.borderRadius,
          overflow: "hidden",
          border: `1px solid ${theme.helpHubInput.borderColor}`
        },
        inputWrapperFocused: {
          boxShadow: `0px 0px 0px 3px ${theme.helpHubInput.hoverBorderShadowColor}`,
          border: `1px solid ${theme.helpHubInput.hoverBorderColor}`,
          outline: "none"
        },
        largeAskAIButtonContainer: {
          background: "#ffffff",
          padding: "12px",
          display: "flex",
          flexDirection: "row",
          gap: "8px",
          alignItems: "center",
          justifyContent: "center"
        },
        suggestionsContainer: {
          width: "100%",
          background: "#ffffff",
          padding: "0px 4px",
          flexDirection: "column"
        },
        searchIcon: {
          position: "absolute",
          top: "16px",
          right: "16px"
        },
        closeIcon: {
          position: "absolute",
          top: "16px",
          cursor: "pointer"
        },
        initialLoadingIcon: {
          position: "absolute",
          inset: "50%"
        },
        headerContainer: {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          width: "100%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          background: theme.helpHub.headerBackground,
          borderBottom: `1px solid ${theme.helpHub.headerDividerColor}`
        },
        headerText: {
          fontWeight: theme.helpHub.headerFontWeight,
          fontSize: theme.helpHub.headerFontSize,
          lineHeight: theme.helpHub.headerLineHeight,
          paddingLeft: "8px",
          color: theme.helpHub.headerColor
        },
        headerActionIcons: {
          display: "flex",
          gap: "12px",
          paddingTop: headerPadding.top,
          paddingRight: headerPadding.right,
          paddingBottom: headerPadding.bottom
        },
        headerIcon: {
          fontWeight: theme.helpHub.headerFontWeight,
          fontSize: theme.helpHub.headerFontSize,
          lineHeight: "18px",
          cursor: "pointer",
          color: theme.helpHub.headerIconColor,
          opacity: theme.helpHub.headerIconOpacity
        },
        headerCloseIcon: {
          display: theme.helpHub.headerCloseIconDisplay
        },
        headerMinimizeIcon: {
          display: theme.helpHub.headerMinimizeIconDisplay
        },
        subheader: {
          display: "flex",
          alignItems: "center",
          flex: 1,
          paddingTop: headerPadding.top,
          paddingLeft: headerPadding.left,
          paddingBottom: headerPadding.bottom
        },
        recommendationsContainer: {
          position: "relative",
          overflowY: "auto",
          height: "100%",
          paddingBottom: "16px",
          background: `linear-gradient(${theme.helpHub.heroBackground}, ${theme.helpHub.heroBackground}) top / 100% 168px,
                linear-gradient(${theme.helpHub.background}, ${theme.helpHub.background}) bottom / 100% calc(100% - 168px)`,
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "local"
        },
        recommendationsListContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          padding: "0 16px",
          gap: "16px"
        },
        recommendationsHeading: {
          zIndex: 1,
          display: "flex",
          padding: "16px 16px 8px",
          margin: 0,
          fontWeight: theme.helpHub.subheaderFontWeight,
          fontSize: theme.helpHub.subheaderFontSize,
          lineHeight: theme.helpHub.subheaderLineHeight,
          color: theme.helpHub.subheaderColor
        },
        gridItems: {
          zIndex: 1,
          display: "flex",
          width: "100%",
          gap: "8px",
          flexWrap: "wrap"
        },
        gridItem: {
          all: "unset",
          position: "relative",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          padding: "0",
          overflow: "hidden",
          gap: "8px",
          minWidth: "calc(50% - 4px)",
          maxWidth: "calc(50% - 4px)",
          width: "100%",
          borderRadius: theme.helpHubGridItem.borderRadius,
          cursor: "pointer",
          boxShadow: theme.helpHubGridItem.boxShadow,
          aspectRatio: "4 / 3"
        },
        gridItemPreview: {
          position: "absolute",
          display: "flex",
          alignItems: "center",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          padding: "0 16px",
          borderRadius: theme.helpHubGridItem.borderRadius,
          cursor: "pointer",
          pointerEvents: "all",
          overflow: "hidden",
          border: theme.helpHubGridItem.border,
          transition: `border ${theme.main.transitionTime} ease-in-out, box-shadow ${theme.main.transitionTime} ease-in-out`
        },
        gridItemPreviewActive: {
          border: theme.helpHubGridItem.hoverBorder,
          boxShadow: theme.helpHubGridItem.hoverBoxShadow,
          transition: `border ${theme.main.transitionTime} ease-in-out, box-shadow ${theme.main.transitionTime} ease-in-out`
        },
        gridItemPreviewButton: {
          position: "absolute",
          right: "12px",
          bottom: "12px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: theme.helpHubGridItem.ctaButtonSize,
          height: theme.helpHubGridItem.ctaButtonSize,
          backgroundColor: theme.helpHubGridItem.ctaButtonBackground,
          borderRadius: theme.helpHubGridItem.ctaButtonBorderRadius,
          overflow: "hidden",
          boxShadow: theme.helpHubGridItem.ctaButtonBoxShadow,
          border: theme.helpHubGridItem.ctaButtonBorder
        },
        gridItemTitle: {
          fontWeight: theme.helpHubGridItem.fontWeight,
          fontSize: theme.helpHubGridItem.fontSize,
          lineHeight: theme.helpHubGridItem.lineHeight,
          overflowWrap: "break-word",
          color: theme.helpHubGridItem.color,
          mixBlendMode: theme.helpHubGridItem.mixBlendMode,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 4,
          overflow: "hidden"
        },
        gridItemTitleWithGradient: {
          fontWeight: theme.helpHubGridItem.fontWeight,
          fontSize: theme.helpHubGridItem.fontSize,
          lineHeight: theme.helpHubGridItem.lineHeight,
          overflowWrap: "break-word",
          color: theme.helpHubGridItem.color,
          mixBlendMode: theme.helpHubGridItem.mixBlendMode,
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 4,
          overflow: "hidden",
          "&::before": {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: theme.helpHubGridItem.mixBlendMode !== "normal" ? "linear-gradient(180deg,transparent calc(66.67% - 16px),gray calc(93.08% - 16px))" : "none",
            content: '""'
          }
        },
        recommendedGridItemsEmptyContainer: {
          display: "flex",
          justifyContent: "center",
          width: "100%",
          gap: "4px"
        },
        recommendedGridItemsEmpty: {
          flex: "1",
          background: "linear-gradient(74.86deg, #D9D9D9 16.22%, #CCCCCC 31.6%, #D9D9D9 47.44%)",
          border: "1px solid #DFDFE2",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.24)",
          borderRadius: "8px",
          position: "relative",
          aspectRatio: "4 / 3"
        },
        recommendedGridItemsEmptyDot: {
          position: "absolute",
          width: "32px",
          height: "32px",
          right: "12px",
          bottom: "12px",
          background: "#F0F0F0",
          borderRadius: "100px"
        },
        recommendedListItemsEmpty: {
          width: isMobileDevice2 ? "100%" : "400px",
          height: "69px",
          background: "linear-gradient(88.74deg, #D9D9D9 13.8%, #C9C9C9 30.92%, #D9D9D9 48.56%)",
          borderRadius: "8px",
          position: "relative",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "16px 16px 16px 20px",
          gap: "16px"
        },
        recommendedListItemEmptyDot: {
          width: "24px",
          height: "24px",
          background: "#F0F0F0",
          borderRadius: "4px"
        },
        recommendedListItemEmptyRowTop: {
          width: "195px",
          height: "16px",
          background: "#F0F0F0",
          borderRadius: "4px",
          marginBottom: "4px"
        },
        recommendedListItemEmptyRowBottom: {
          width: "290px",
          height: "12px",
          background: "#F0F0F0",
          borderRadius: "4px"
        },
        recommendedListItems: {
          zIndex: 1,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          width: "100%"
        },
        recommendedListItem: {
          all: "unset",
          width: isMobileDevice2 || isStudioMobilePreview ? "unset" : "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: theme.helpHubListItem.padding,
          gap: theme.helpHubListItem.gap,
          border: theme.helpHubListItem.border,
          background: theme.helpHubListItem.background,
          borderRadius: theme.helpHubListItem.borderRadius,
          cursor: "pointer",
          boxShadow: theme.helpHubListItem.boxShadow,
          transition: `border ${theme.main.transitionTime} ease-in-out, box-shadow ${theme.main.transitionTime} ease-in-out`
        },
        recommendedListItemActive: {
          background: theme.helpHubListItem.hoverBackground,
          border: theme.helpHubListItem.hoverBorder,
          boxShadow: theme.helpHubListItem.hoverBoxShadow,
          transition: `border ${theme.main.transitionTime} ease-in-out, box-shadow ${theme.main.transitionTime} ease-in-out`
        },
        recommendedListItemIcon: {
          display: "flex",
          alignItems: "center",
          color: "#7A7A85"
        },
        recommendedListItemText: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "2px",
          flexGrow: 1,
          minWidth: 0
        },
        recommendedListItemTitle: {
          fontWeight: theme.helpHubListItem.titleFontWeight,
          fontSize: theme.helpHubListItem.titleFontSize,
          lineHeight: theme.helpHubListItem.titleLineHeight,
          color: theme.helpHubListItem.titleColor,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden"
        },
        recommendedListItemDescription: {
          fontWeight: theme.helpHubListItem.descriptionFontWeight,
          fontSize: theme.helpHubListItem.descriptionFontSize,
          lineHeight: theme.helpHubListItem.descriptionLineHeight,
          color: theme.helpHubListItem.descriptionColor,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden"
        },
        resultList: { overflowY: "auto", height: "100%", padding: "0 16px 16px" },
        resultListHeader: {
          width: "100%",
          padding: "16px 0 8px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        },
        resultListHeaderTitle: {
          margin: 0,
          fontSize: theme.helpHub.subHeaderFontSize,
          fontWeight: theme.helpHub.subHeaderFontWeight,
          color: theme.helpHub.subHeaderColor
        },
        resultListHeaderResultsFound: {
          fontSize: theme.helpHub.resultsFoundFontSize,
          fontWeight: theme.helpHub.resultsFoundFontWeight,
          color: theme.helpHub.resultsFoundColor
        },
        resultListContainer: {
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "100%",
          gap: "8px"
        },
        resultCard: {
          all: "unset",
          width: "100%",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: theme.helpHubListItem.padding,
          gap: theme.helpHubListItem.gap,
          border: theme.helpHubListItem.border,
          background: theme.helpHubListItem.background,
          borderRadius: theme.helpHubListItem.borderRadius,
          cursor: "pointer",
          boxShadow: theme.helpHubListItem.boxShadow,
          transition: `border ${theme.main.transitionTime} ease-in-out, box-shadow ${theme.main.transitionTime} ease-in-out`
        },
        resultCardActive: {
          border: theme.helpHubListItem.hoverBorder,
          background: theme.helpHubListItem.hoverBackground,
          boxShadow: theme.helpHubListItem.hoverBoxShadow,
          transition: `border ${theme.main.transitionTime} ease-in-out, box-shadow ${theme.main.transitionTime} ease-in-out`
        },
        resultCardAnswer: {
          background: "linear-gradient(99.43deg, rgb(230.85, 235.68, 255) 6.02%, rgb(255, 255, 255) 26.86%)",
          boxShadow: "inset 0px -2px 0px #00000012, 0px 1px 3px #000000122"
        },
        resultCardRightCaret: {
          display: "flex",
          alignItems: "center",
          color: "#7A7A85"
        },
        resultCardIcon: {
          display: "flex",
          alignItems: "center"
        },
        resultCardTextContainer: {
          display: "flex",
          flexDirection: "column",
          paddingTop: "4px",
          paddingBottom: "4px",
          flexGrow: 1,
          minWidth: 0
        },
        resultCardMeta: {
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "8px"
        },
        resultCardContentType: {
          padding: "2px 4px 2px 4px",
          borderRadius: "4px",
          background: theme.helpHubListItem.contentTypeBackground,
          fontSize: theme.helpHubListItem.contentTypeFontSize,
          fontWeight: theme.helpHubListItem.contentTypeFontWeight,
          color: theme.helpHubListItem.contentTypeColor,
          textTransform: "capitalize"
        },
        resultCardDate: {
          padding: "2px 0 2px 0",
          fontSize: "12px",
          fontWeight: 500,
          color: "#7A7A85"
        },
        resultCardText: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "2px",
          flexGrow: 1,
          minWidth: 0
        },
        resultCardTitle: {
          fontWeight: theme.helpHubListItem.titleFontWeight,
          fontSize: theme.helpHubListItem.titleFontSize,
          lineHeight: theme.helpHubListItem.titleLineHeight,
          color: theme.helpHubListItem.titleColor,
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          overflow: "hidden"
        },
        resultCardExcerpt: {
          fontSize: theme.helpHubListItem.descriptionFontSize,
          lineHeight: theme.helpHubListItem.descriptionLineHeight,
          fontWeight: theme.helpHubListItem.descriptionFontWeight,
          color: theme.helpHubListItem.descriptionColor,
          overflowWrap: "break-word",
          maxHeight: "72px",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 2,
          overflow: "hidden"
        },
        answerCard: {
          fontFamily: "inherit",
          all: "unset",
          background: theme.helpHubInstantAnswerItem.background,
          width: "100%",
          padding: "16px",
          borderTop: "1px solid #DFDFE2",
          position: "relative",
          border: `1px solid ${theme.helpHubDocItem.dividerColor}`,
          borderRadius: "8px",
          transition: `all ${theme.main.transitionTime}`,
          "&:hover": {
            background: theme.helpHubInstantAnswerItem.hoverBackground
          }
        },
        answerCardIcon: {
          marginRight: "8px",
          paddingBottom: "3px",
          display: "flex"
        },
        docTitle: {
          width: "100%",
          padding: "16px 24px 8px 24px",
          background: theme.helpHubDocItem.background,
          fontSize: theme.helpHubDocItem.titleFontSize,
          lineHeight: theme.helpHubDocItem.titleLineHeight,
          color: theme.helpHubDocItem.titleColor,
          fontWeight: theme.helpHubDocItem.titleFontWeight
        },
        docContainer: { height: "100%", backgroundColor: theme.helpHubDocItem.background },
        docExcerpt: {
          width: "100%",
          padding: "0 24px",
          background: theme.helpHubDocItem.background,
          fontSize: theme.helpHubDocItem.videoExcerptFontSize,
          lineHeight: theme.helpHubDocItem.videoExcerptLineHeight,
          color: theme.helpHubDocItem.videoExcerptColor,
          fontWeight: theme.helpHubDocItem.videoExcerptFontWeight
        },
        docContent: {
          background: theme.helpHubDocItem.background,
          width: "100%",
          padding: "0px 24px 16px 24px",
          fontSize: theme.helpHubDocItem.contentFontSize,
          lineHeight: theme.helpHubDocItem.contentLineHeight,
          fontWeight: theme.helpHubDocItem.contentFontWeight,
          color: theme.helpHubDocItem.paragraphColor,
          flexGrow: 1,
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px"
        },
        docHeader: {
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          padding: "16px",
          background: theme.helpHubDocItem.background
        },
        docHeaderRight: {
          display: "flex",
          padding: 0,
          gap: "8px"
        },
        docHeaderButton: {
          all: "unset",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "32px",
          padding: isStudioMobilePreview ? "0px" : "8px 12px 8px 8px",
          gap: "2px",
          background: theme.helpHub.buttonBackground,
          border: theme.helpHub.buttonBorder,
          boxShadow: theme.helpHub.buttonBoxShadow,
          borderRadius: "4px",
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "16px",
          color: theme.helpHub.buttonColor,
          cursor: "pointer",
          transition: `border ${theme.main.transitionTime} ease-in-out`,
          "&:hover": {
            color: theme.helpHub.buttonHoverColor,
            background: theme.helpHub.buttonHoverBackground,
            border: theme.helpHub.buttonHoverBorder,
            boxShadow: theme.helpHub.buttonHoverBoxShadow
          }
        },
        searchDocsButton: {
          all: "unset",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "32px",
          padding: isStudioMobilePreview ? "0px" : "8px 12px 8px 8px",
          gap: "4px",
          background: "#FFFFFF",
          border: "1px solid #DFDFE2",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -1px 0px rgba(0, 0, 0, 0.07)",
          borderRadius: "4px",
          fontWeight: 600,
          fontSize: "14px",
          lineHeight: "16px",
          color: "#51515C",
          cursor: "pointer",
          flex: "1",
          transition: `border ${theme.main.transitionTime} ease-in-out, color ${theme.main.transitionTime} ease-in-out`,
          "&:hover": {
            border: "1px solid #2755F0",
            color: "#031963"
          }
        },
        askAITooltip: {
          margin: "8px 0px 0px",
          padding: "2px 10px",
          border: `1px solid ${theme.helpHubInput.borderColor}`,
          borderRadius: "6px",
          fontSize: "12px",
          width: "fit-content",
          cursor: "pointer",
          userSelect: "none"
        },
        askAITooltipIcon: {
          color: "transparent"
        },
        askAICustomCTAButton: theme.helpHub.ctaCustom !== "false" ? {
          fontSize: theme.helpHub.ctaFontSize,
          fontWeight: theme.helpHub.ctaFontWeight,
          color: theme.helpHub.ctaColor,
          background: theme.helpHub.ctaBackground,
          borderRadius: theme.helpHub.ctaBorderRadius,
          border: theme.helpHub.ctaBorder,
          boxShadow: theme.helpHub.ctaBoxShadow,
          "&:hover": {
            fontSize: theme.helpHub.hoverCtaFontSize,
            fontWeight: theme.helpHub.hoverCtaFontWeight,
            color: theme.helpHub.hoverCtaColor,
            background: theme.helpHub.hoverCtaBackground,
            borderRadius: theme.helpHub.hoverCtaBorderRadius,
            border: theme.helpHub.hoverCtaBorder,
            boxShadow: theme.helpHub.hoverCtaBoxShadow
          }
        } : null,
        additionalResourcesContainer: {
          position: "relative",
          bottom: 0,
          width: "100%",
          background: theme.helpHubAdditionalResources.background,
          borderTop: theme.helpHubAdditionalResources.borderTop,
          boxShadow: theme.helpHubAdditionalResources.boxShadow,
          padding: "16px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          pointerEvents: "auto",
          zIndex: 1
        },
        additionalResourcesTitle: {
          color: theme.helpHubAdditionalResources.titleColor,
          fontWeight: theme.helpHubAdditionalResources.titleFontWeight,
          fontSize: theme.helpHubAdditionalResources.titleFontSize,
          userSelect: "none",
          lineHeight: 1.2,
          display: "flex",
          alignItems: "center",
          cursor: "pointer"
        },
        additionalResourcesArrowExpanded: {
          margin: "-1px 0 0 8px",
          transform: "rotate(0deg)",
          color: theme.helpHubAdditionalResources.arrowColor
        },
        additionalResourcesArrowCollapsed: {
          margin: "3px 0 0 8px",
          transform: "rotate(180deg)",
          color: theme.helpHubAdditionalResources.arrowColor
        },
        additionalResourcesLinkContainer: {
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          marginTop: "8px",
          cursor: "pointer"
        },
        additionalResourcesLink: {
          color: theme.helpHubAdditionalResources.linkColor,
          fontWeight: theme.helpHubAdditionalResources.linkFontWeight,
          fontSize: theme.helpHubAdditionalResources.linkFontSize,
          lineHeight: 1.2,
          textDecoration: theme.helpHubAdditionalResources.linkTextDecoration,
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          width: `calc(${theme.helpHub.width} * 0.5 - 18px)`,
          padding: theme.helpHubAdditionalResources.linkPadding,
          transition: `all ${theme.main.transitionTime}`,
          "&:hover": {
            color: theme.helpHubAdditionalResources.linkHoverColor,
            textDecoration: "underline"
          },
          "&:active": {
            color: theme.helpHubAdditionalResources.linkColor,
            textDecoration: "underline"
          }
        },
        additionalResourcesLinkIcon: {
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 0,
          width: theme.helpHubAdditionalResources.linkIconSize,
          height: theme.helpHubAdditionalResources.linkIconSize,
          minWidth: theme.helpHubAdditionalResources.linkIconSize,
          minHeight: theme.helpHubAdditionalResources.linkIconSize,
          marginRight: theme.helpHubAdditionalResources.linkIconMarginRight,
          color: theme.helpHubAdditionalResources.linkIconColor
        },
        additionalResourcesCTA: {
          all: "unset",
          display: "inline-flex",
          alignItems: "center",
          color: theme.helpHubAdditionalResources.ctaColor,
          background: theme.helpHubAdditionalResources.ctaBackground,
          fontWeight: theme.helpHubAdditionalResources.ctaFontWeight,
          fontSize: theme.helpHubAdditionalResources.ctaFontSize,
          lineHeight: 1.2,
          border: theme.helpHubAdditionalResources.ctaBorder,
          padding: isStudioMobilePreview ? "0px" : theme.helpHubAdditionalResources.ctaPadding,
          height: theme.helpHubAdditionalResources.ctaHeight,
          width: theme.helpHubAdditionalResources.ctaWidth,
          borderRadius: theme.helpHubAdditionalResources.ctaBorderRadius,
          justifyContent: "center",
          cursor: "pointer",
          boxShadow: theme.helpHubAdditionalResources.ctaBoxShadow,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          textAlign: "center",
          transition: `all ${theme.main.transitionTime}`,
          "&:hover": {
            background: theme.helpHubAdditionalResources.hoverCTABackground,
            border: theme.helpHubAdditionalResources.hoverCTABorder,
            boxShadow: theme.helpHubAdditionalResources.hoverCTABoxShadow,
            color: theme.helpHubAdditionalResources.hoverCTAColor
          }
        },
        continuation: {
          fontFamily: theme.helpHub.fontFamily,
          background: "#E7E7E9",
          padding: "8px 16px",
          cursor: "pointer",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "16px",
          color: "#1E1E29",
          borderRadius: "100px",
          display: "flex",
          alignItems: "center",
          flexDirection: "row"
        },
        actionButtons: {
          padding: "12px 16px",
          alignItems: "center",
          display: "inline-flex",
          borderRadius: "4px",
          gap: "4px",
          justifyContent: "center",
          position: "relative",
          cursor: "pointer",
          transition: `all ${theme.main.transitionTime}`,
          border: "none",
          primary: {
            backgroundImage: "linear-gradient(89deg, #0A0A0F 0.52%, #0A0A0F 11.93%, #454545 15.47%, #0A0A0F 30.8%, #0A0A0F 98.49%)",
            position: "relative",
            overflow: "hidden",
            backgroundSize: "600% 100%",
            color: CB_COLORS.white,
            "&:hover:not([disabled])": {
              backgroundColor: CB_COLORS.neutral900,
              animation: "none",
              transition: "none",
              backgroundImage: "none"
            }
          },
          secondary: {
            backgroundColor: CB_COLORS.white,
            color: CB_COLORS.neutral900,
            border: `1px solid #0000003d`,
            "&:hover:not([disabled])": {
              backgroundColor: CB_COLORS.neutral0
            }
          },
          continuation: {
            backgroundColor: CB_COLORS.white,
            color: CB_COLORS.neutral900,
            border: `1px solid #0000003d`,
            borderRadius: "9999px",
            fontSize: "12px",
            padding: "8px 16px",
            "&:hover:not([disabled])": {
              backgroundColor: CB_COLORS.neutral0
            }
          },
          disabled: {
            backgroundColor: CB_COLORS.neutral300,
            color: CB_COLORS.neutral600,
            cursor: "not-allowed"
          }
        },
        feedBackButtonsParent: {
          regular: {
            "& .chat-feedback": {
              transition: `opacity ${theme.main.transitionTime}`,
              opacity: 0
            },
            "&:hover .chat-feedback": {
              opacity: 1
            }
          },
          preview: {
            "& .chat-feedback": {
              transition: `opacity ${theme.main.transitionTime}`,
              opacity: 0
            }
          }
        },
        poweredBy: {
          all: "unset",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          width: "100%",
          zIndex: 1,
          cursor: "pointer",
          fontWeight: 500,
          fontSize: "14px",
          lineHeight: "13px",
          color: "#7A7A85",
          "& path": {
            fill: "#7A7A85"
          }
        }
      });
    };
  }
});

// commandbar/src/shared/util/hooks/useHasScroll.tsx
import { useState as useState2, useEffect as useEffect4 } from "react";
var useHasScroll, useHasScroll_default;
var init_useHasScroll = __esm({
  "commandbar/src/shared/util/hooks/useHasScroll.tsx"() {
    "use strict";
    useHasScroll = (ref12) => {
      const [hasScrolled, setHasScrolled] = useState2(false);
      useEffect4(() => {
        const onScroll = () => setHasScrolled(true);
        ref12.current && ref12.current.addEventListener("scroll", onScroll);
        return () => {
          if (ref12.current)
            return ref12.current.removeEventListener("scroll", onScroll);
        };
      }, [hasScrolled]);
      return { hasScrolled };
    };
    useHasScroll_default = useHasScroll;
  }
});

// commandbar/src/shared/components/EngagementTracking.tsx
import React9 from "react";
var EngagementTracking;
var init_EngagementTracking = __esm({
  "commandbar/src/shared/components/EngagementTracking.tsx"() {
    "use strict";
    EngagementTracking = (props2) => {
      const [ref12, setRef] = React9.useState(null);
      const [dirty, setDirty] = React9.useState(0);
      React9.useEffect(() => {
        if (!ref12)
          return;
        const observer = new MutationObserver(() => {
          setDirty((x) => x + 1);
        });
        observer.observe(ref12, { subtree: true, childList: true });
        return () => {
          observer.disconnect();
        };
      }, [ref12]);
      React9.useEffect(() => {
        if (!ref12)
          return;
        const anchors = ref12.querySelectorAll("a");
        const videos = ref12.querySelectorAll("video");
        const unsub = [];
        anchors.forEach((element) => {
          element.addEventListener("click", props2.anchorClickHandler);
          unsub.push(() => element.removeEventListener("click", props2.anchorClickHandler));
        });
        videos.forEach((element) => {
          element.addEventListener("play", props2.videoPlayHandler);
          unsub.push(() => element.removeEventListener("play", props2.videoPlayHandler));
        });
        return () => {
          unsub.forEach((u) => u());
        };
      }, [ref12, dirty]);
      return /* @__PURE__ */ React9.createElement("div", { ref: setRef, style: { height: "100%" } }, props2.children);
    };
  }
});

// design-system/src/icons/react/AlertHexagon.tsx
import * as React10 from "react";
var AlertHexagon, AlertHexagon_default;
var init_AlertHexagon = __esm({
  "design-system/src/icons/react/AlertHexagon.tsx"() {
    "use strict";
    AlertHexagon = (props2) => /* @__PURE__ */ React10.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React10.createElement("path", { fill: "currentColor", d: "m12 2 9 5v10l-9 5-9-5V7l9-5Z", opacity: 0.12 }), /* @__PURE__ */ React10.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 8v4m0 4h.01M3 7.942v8.117c0 .342 0 .514.05.666a1 1 0 0 0 .215.364c.109.119.258.202.558.368l7.4 4.111c.284.158.425.237.575.268.133.027.27.027.403 0 .15-.031.292-.11.576-.268l7.4-4.11c.3-.167.45-.25.558-.369a.999.999 0 0 0 .215-.364c.05-.152.05-.324.05-.666V7.942c0-.343 0-.514-.05-.667a1 1 0 0 0-.215-.364c-.109-.119-.258-.202-.558-.368l-7.4-4.111c-.284-.158-.425-.237-.575-.267a1 1 0 0 0-.403 0c-.15.03-.292.11-.576.267l-7.4 4.11c-.3.167-.45.25-.558.369a1 1 0 0 0-.215.364C3 7.428 3 7.599 3 7.942Z"
      }
    ));
    AlertHexagon_default = AlertHexagon;
  }
});

// design-system/src/icons/react/ArrowDown.tsx
import * as React11 from "react";
var ArrowDown, ArrowDown_default;
var init_ArrowDown = __esm({
  "design-system/src/icons/react/ArrowDown.tsx"() {
    "use strict";
    ArrowDown = (props2) => /* @__PURE__ */ React11.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React11.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 5v14m0 0 7-7m-7 7-7-7"
      }
    ));
    ArrowDown_default = ArrowDown;
  }
});

// design-system/src/icons/react/ArrowNarrowRight.tsx
import * as React12 from "react";
var ArrowNarrowRight, ArrowNarrowRight_default;
var init_ArrowNarrowRight = __esm({
  "design-system/src/icons/react/ArrowNarrowRight.tsx"() {
    "use strict";
    ArrowNarrowRight = (props2) => /* @__PURE__ */ React12.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React12.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 12h16m0 0-6-6m6 6-6 6"
      }
    ));
    ArrowNarrowRight_default = ArrowNarrowRight;
  }
});

// design-system/src/icons/react/ArrowRight.tsx
import * as React13 from "react";
var ArrowRight, ArrowRight_default;
var init_ArrowRight = __esm({
  "design-system/src/icons/react/ArrowRight.tsx"() {
    "use strict";
    ArrowRight = (props2) => /* @__PURE__ */ React13.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React13.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 12h14m0 0-7-7m7 7-7 7"
      }
    ));
    ArrowRight_default = ArrowRight;
  }
});

// design-system/src/icons/react/ArrowUp.tsx
import * as React14 from "react";
var ArrowUp, ArrowUp_default;
var init_ArrowUp = __esm({
  "design-system/src/icons/react/ArrowUp.tsx"() {
    "use strict";
    ArrowUp = (props2) => /* @__PURE__ */ React14.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React14.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 19V5m0 0-7 7m7-7 7 7"
      }
    ));
    ArrowUp_default = ArrowUp;
  }
});

// design-system/src/icons/react/ArrowUpRight.tsx
import * as React15 from "react";
var ArrowUpRight, ArrowUpRight_default;
var init_ArrowUpRight = __esm({
  "design-system/src/icons/react/ArrowUpRight.tsx"() {
    "use strict";
    ArrowUpRight = (props2) => /* @__PURE__ */ React15.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React15.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 17 17 7m0 0H7m10 0v10"
      }
    ));
    ArrowUpRight_default = ArrowUpRight;
  }
});

// design-system/src/icons/react/Attachment01.tsx
import * as React16 from "react";
var Attachment01, Attachment01_default;
var init_Attachment01 = __esm({
  "design-system/src/icons/react/Attachment01.tsx"() {
    "use strict";
    Attachment01 = (props2) => /* @__PURE__ */ React16.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React16.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21.152 10.9-9.015 9.015a5.25 5.25 0 0 1-7.425-7.425l9.016-9.015a3.5 3.5 0 1 1 4.95 4.95l-8.662 8.662a1.75 1.75 0 1 1-2.475-2.475l7.601-7.602"
      }
    ));
    Attachment01_default = Attachment01;
  }
});

// design-system/src/icons/react/BookClosed.tsx
import * as React17 from "react";
var BookClosed, BookClosed_default;
var init_BookClosed = __esm({
  "design-system/src/icons/react/BookClosed.tsx"() {
    "use strict";
    BookClosed = (props2) => /* @__PURE__ */ React17.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React17.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8V19a3 3 0 0 1 3-3h13V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React17.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 19v-3H7a3 3 0 0 0-3 3m4.8 3h8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C20 20.48 20 19.92 20 18.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C18.48 2 17.92 2 16.8 2h-8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22Z"
      }
    ));
    BookClosed_default = BookClosed;
  }
});

// design-system/src/icons/react/BookOpen01.tsx
import * as React18 from "react";
var BookOpen01, BookOpen01_default;
var init_BookOpen01 = __esm({
  "design-system/src/icons/react/BookOpen01.tsx"() {
    "use strict";
    BookOpen01 = (props2) => /* @__PURE__ */ React18.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React18.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2 6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 3 4.08 3 5.2 3h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 6.04 12 7.16 12 9.4V21l-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a4 4 0 0 0-1.378-.737C8.453 18 7.827 18 6.575 18H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V6.2Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React18.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12 21-.1-.15c-.695-1.042-1.042-1.563-1.5-1.94a4 4 0 0 0-1.378-.737C8.453 18 7.827 18 6.575 18H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 16.48 2 15.92 2 14.8V6.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 3 4.08 3 5.2 3h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 6.04 12 7.16 12 9.4M12 21V9.4M12 21l.1-.15c.695-1.042 1.042-1.563 1.5-1.94a3.999 3.999 0 0 1 1.378-.737C15.547 18 16.173 18 17.425 18H18.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 16.48 22 15.92 22 14.8V6.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 3 19.92 3 18.8 3h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C12 6.04 12 7.16 12 9.4"
      }
    ));
    BookOpen01_default = BookOpen01;
  }
});

// design-system/src/icons/react/BookOpen02.tsx
import * as React19 from "react";
var BookOpen02, BookOpen02_default;
var init_BookOpen02 = __esm({
  "design-system/src/icons/react/BookOpen02.tsx"() {
    "use strict";
    BookOpen02 = (props2) => /* @__PURE__ */ React19.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React19.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2 7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 7.04 12 8.16 12 10.4V20H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.48 2 17.92 2 16.8V7.2Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React19.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 20H5.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C2 18.48 2 17.92 2 16.8V7.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C3.52 4 4.08 4 5.2 4h.4c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C12 7.04 12 8.16 12 10.4m0 9.6v-9.6m0 9.6h6.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 18.48 22 17.92 22 16.8V7.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 4 19.92 4 18.8 4h-.4c-2.24 0-3.36 0-4.216.436a4 4 0 0 0-1.748 1.748C12 7.04 12 8.16 12 10.4"
      }
    ));
    BookOpen02_default = BookOpen02;
  }
});

// design-system/src/icons/react/Bookmark.tsx
import * as React20 from "react";
var Bookmark, Bookmark_default;
var init_Bookmark = __esm({
  "design-system/src/icons/react/Bookmark.tsx"() {
    "use strict";
    Bookmark = (props2) => /* @__PURE__ */ React20.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React20.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 3 8.12 3 9.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.28 19 6.12 19 7.8V21l-7-4-7 4V7.8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React20.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 3 8.12 3 9.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.28 19 6.12 19 7.8V21l-7-4-7 4V7.8Z"
      }
    ));
    Bookmark_default = Bookmark;
  }
});

// design-system/src/icons/react/BookmarkCheck.tsx
import * as React21 from "react";
var BookmarkCheck, BookmarkCheck_default;
var init_BookmarkCheck = __esm({
  "design-system/src/icons/react/BookmarkCheck.tsx"() {
    "use strict";
    BookmarkCheck = (props2) => /* @__PURE__ */ React21.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React21.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C7.28 3 8.12 3 9.8 3h4.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 5.28 19 6.12 19 7.8V21l-7-4-7 4V7.8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React21.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 10.5 2 2L15.5 8M19 21V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C16.72 3 15.88 3 14.2 3H9.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C5 5.28 5 6.12 5 7.8V21l7-4 7 4Z"
      }
    ));
    BookmarkCheck_default = BookmarkCheck;
  }
});

// design-system/src/icons/react/Caret.tsx
import * as React22 from "react";
var Caret, Caret_default;
var init_Caret = __esm({
  "design-system/src/icons/react/Caret.tsx"() {
    "use strict";
    Caret = (props2) => /* @__PURE__ */ React22.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React22.createElement(
      "path",
      {
        stroke: "currentColor",
        fill: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M0.0581149 0.912761L3.78978 5.40359C3.8966 5.53214 4.10227 5.53214 4.21022 5.40359L7.94189 0.912761C8.08052 0.745298 7.95552 0.500001 7.73167 0.500001L0.268334 0.5C0.0444793 0.5 -0.0805154 0.745298 0.0581149 0.912761Z"
      }
    ));
    Caret_default = Caret;
  }
});

// design-system/src/icons/react/Check.tsx
import * as React23 from "react";
var Check, Check_default;
var init_Check = __esm({
  "design-system/src/icons/react/Check.tsx"() {
    "use strict";
    Check = (props2) => /* @__PURE__ */ React23.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React23.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M20 6 9 17l-5-5" }));
    Check_default = Check;
  }
});

// design-system/src/icons/react/CheckCircleBroken.tsx
import * as React24 from "react";
var CheckCircleBroken, CheckCircleBroken_default;
var init_CheckCircleBroken = __esm({
  "design-system/src/icons/react/CheckCircleBroken.tsx"() {
    "use strict";
    CheckCircleBroken = (props2) => /* @__PURE__ */ React24.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React24.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React24.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 11.086v.92a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3"
      }
    ));
    CheckCircleBroken_default = CheckCircleBroken;
  }
});

// design-system/src/icons/react/CheckSquareBroken.tsx
import * as React25 from "react";
var CheckSquareBroken, CheckSquareBroken_default;
var init_CheckSquareBroken = __esm({
  "design-system/src/icons/react/CheckSquareBroken.tsx"() {
    "use strict";
    CheckSquareBroken = (props2) => /* @__PURE__ */ React25.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React25.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React25.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 11 3 3L22 4m-6-1H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V12"
      }
    ));
    CheckSquareBroken_default = CheckSquareBroken;
  }
});

// design-system/src/icons/react/ChevronDown.tsx
import * as React26 from "react";
var ChevronDown, ChevronDown_default;
var init_ChevronDown = __esm({
  "design-system/src/icons/react/ChevronDown.tsx"() {
    "use strict";
    ChevronDown = (props2) => /* @__PURE__ */ React26.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React26.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m6 9 6 6 6-6" }));
    ChevronDown_default = ChevronDown;
  }
});

// design-system/src/icons/react/ChevronLeft.tsx
import * as React27 from "react";
var ChevronLeft, ChevronLeft_default;
var init_ChevronLeft = __esm({
  "design-system/src/icons/react/ChevronLeft.tsx"() {
    "use strict";
    ChevronLeft = (props2) => /* @__PURE__ */ React27.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React27.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m15 18-6-6 6-6" }));
    ChevronLeft_default = ChevronLeft;
  }
});

// design-system/src/icons/react/ChevronLeftFilled.tsx
import * as React28 from "react";
var ChevronLeftFilled, ChevronLeftFilled_default;
var init_ChevronLeftFilled = __esm({
  "design-system/src/icons/react/ChevronLeftFilled.tsx"() {
    "use strict";
    ChevronLeftFilled = (props2) => /* @__PURE__ */ React28.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 5 8", ...props2 }, /* @__PURE__ */ React28.createElement(
      "path",
      {
        fill: "#7A7A85",
        fillRule: "evenodd",
        d: "M4.8481 7.3536c.1953-.1953.1465-.7072.1465-.7072V1.3537s.0488-.512-.1466-.7073a.5.5 0 0 0-.707 0l-3 3a.5.5 0 0 0 0 .7072l3 3a.5.5 0 0 0 .707 0Z",
        clipRule: "evenodd"
      }
    ));
    ChevronLeftFilled_default = ChevronLeftFilled;
  }
});

// design-system/src/icons/react/ChevronRight.tsx
import * as React29 from "react";
var ChevronRight, ChevronRight_default;
var init_ChevronRight = __esm({
  "design-system/src/icons/react/ChevronRight.tsx"() {
    "use strict";
    ChevronRight = (props2) => /* @__PURE__ */ React29.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React29.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m9 18 6-6-6-6" }));
    ChevronRight_default = ChevronRight;
  }
});

// design-system/src/icons/react/ChevronRightFilled.tsx
import * as React30 from "react";
var ChevronRightFilled, ChevronRightFilled_default;
var init_ChevronRightFilled = __esm({
  "design-system/src/icons/react/ChevronRightFilled.tsx"() {
    "use strict";
    ChevronRightFilled = (props2) => /* @__PURE__ */ React30.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 5 8", ...props2 }, /* @__PURE__ */ React30.createElement(
      "path",
      {
        fill: "#7A7A85",
        fillRule: "evenodd",
        d: "M1.1465 7.3536c-.1953-.1953-.1464-.7072-.1464-.7072V1.3537s-.0489-.512.1464-.7073a.5.5 0 0 1 .7071 0l3 3a.5.5 0 0 1 0 .7072l-3 3a.5.5 0 0 1-.7071 0Z",
        clipRule: "evenodd"
      }
    ));
    ChevronRightFilled_default = ChevronRightFilled;
  }
});

// design-system/src/icons/react/ChevronUp.tsx
import * as React31 from "react";
var ChevronUp, ChevronUp_default;
var init_ChevronUp = __esm({
  "design-system/src/icons/react/ChevronUp.tsx"() {
    "use strict";
    ChevronUp = (props2) => /* @__PURE__ */ React31.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React31.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "m18 15-6-6-6 6" }));
    ChevronUp_default = ChevronUp;
  }
});

// design-system/src/icons/react/Clock.tsx
import * as React32 from "react";
var Clock, Clock_default;
var init_Clock = __esm({
  "design-system/src/icons/react/Clock.tsx"() {
    "use strict";
    Clock = (props2) => /* @__PURE__ */ React32.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React32.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React32.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 6v6l4 2m6-2c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      }
    ));
    Clock_default = Clock;
  }
});

// design-system/src/icons/react/CornerDownLeft.tsx
import * as React33 from "react";
var CornerDownLeft, CornerDownLeft_default;
var init_CornerDownLeft = __esm({
  "design-system/src/icons/react/CornerDownLeft.tsx"() {
    "use strict";
    CornerDownLeft = (props2) => /* @__PURE__ */ React33.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React33.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M20 4v1.4c0 3.36 0 5.04-.654 6.324a6 6 0 0 1-2.622 2.622C15.44 15 13.76 15 10.4 15H4m0 0 5-5m-5 5 5 5"
      }
    ));
    CornerDownLeft_default = CornerDownLeft;
  }
});

// design-system/src/icons/react/CursorClick02.tsx
import * as React34 from "react";
var CursorClick02, CursorClick02_default;
var init_CursorClick02 = __esm({
  "design-system/src/icons/react/CursorClick02.tsx"() {
    "use strict";
    CursorClick02 = (props2) => /* @__PURE__ */ React34.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React34.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m8.5 8.5 4.111 12.778 2.889-2.89L19.111 22 22 19.111 18.389 15.5l2.889-2.889L8.5 8.5Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React34.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 3.5V2M5.06 5.06 4 4m1.06 9L4 14.06m9-9L14.06 4M3.5 9H2m6.5-.5 4.111 12.778 2.889-2.89L19.111 22 22 19.111 18.389 15.5l2.889-2.889L8.5 8.5Z"
      }
    ));
    CursorClick02_default = CursorClick02;
  }
});

// design-system/src/icons/react/DotsHorizontal.tsx
import * as React35 from "react";
var DotsHorizontal, DotsHorizontal_default;
var init_DotsHorizontal = __esm({
  "design-system/src/icons/react/DotsHorizontal.tsx"() {
    "use strict";
    DotsHorizontal = (props2) => /* @__PURE__ */ React35.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React35.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm7 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    ));
    DotsHorizontal_default = DotsHorizontal;
  }
});

// design-system/src/icons/react/DotsVertical.tsx
import * as React36 from "react";
var DotsVertical, DotsVertical_default;
var init_DotsVertical = __esm({
  "design-system/src/icons/react/DotsVertical.tsx"() {
    "use strict";
    DotsVertical = (props2) => /* @__PURE__ */ React36.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React36.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
      }
    ));
    DotsVertical_default = DotsVertical;
  }
});

// design-system/src/icons/react/Expand02.tsx
import * as React37 from "react";
var Expand02, Expand02_default;
var init_Expand02 = __esm({
  "design-system/src/icons/react/Expand02.tsx"() {
    "use strict";
    Expand02 = (props2) => /* @__PURE__ */ React37.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React37.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 21 21 3M3 21h6m-6 0v-6M21 3h-6m6 0v6"
      }
    ));
    Expand02_default = Expand02;
  }
});

// design-system/src/icons/react/FileSearch02.tsx
import * as React38 from "react";
var FileSearch02, FileSearch02_default;
var init_FileSearch02 = __esm({
  "design-system/src/icons/react/FileSearch02.tsx"() {
    "use strict";
    FileSearch02 = (props2) => /* @__PURE__ */ React38.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React38.createElement("path", { fill: "currentColor", d: "M18 21.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z", opacity: 0.12 }), /* @__PURE__ */ React38.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M14 11H8m2 4H8m8-8H8m12 3.5V6.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 2 16.88 2 15.2 2H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4 4.28 4 5.12 4 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.28 22 7.12 22 8.8 22h2.7M22 22l-1.5-1.5m1-2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z"
      }
    ));
    FileSearch02_default = FileSearch02;
  }
});

// design-system/src/icons/react/FlipBackward.tsx
import * as React39 from "react";
var FlipBackward, FlipBackward_default;
var init_FlipBackward = __esm({
  "design-system/src/icons/react/FlipBackward.tsx"() {
    "use strict";
    FlipBackward = (props2) => /* @__PURE__ */ React39.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React39.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M3 9h13.5a4.5 4.5 0 1 1 0 9H12M3 9l4-4M3 9l4 4"
      }
    ));
    FlipBackward_default = FlipBackward;
  }
});

// design-system/src/icons/react/GraduationHat02.tsx
import * as React40 from "react";
var GraduationHat02, GraduationHat02_default;
var init_GraduationHat02 = __esm({
  "design-system/src/icons/react/GraduationHat02.tsx"() {
    "use strict";
    GraduationHat02 = (props2) => /* @__PURE__ */ React40.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React40.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12.358 3.679a1.066 1.066 0 0 0-.266-.111.5.5 0 0 0-.184 0 1.093 1.093 0 0 0-.266.11L2 8.5l9.642 4.821c.131.066.197.099.266.111.06.012.123.012.184 0 .069-.012.135-.045.266-.11L22 8.5l-9.642-4.82Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React40.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 14.5v-3.005c0-.18 0-.27-.027-.349a.5.5 0 0 0-.116-.187c-.058-.06-.139-.1-.3-.18L12 8.5m-8 1v6.807c0 .372 0 .558.058.72a1 1 0 0 0 .244.381c.124.12.293.198.631.353l6.4 2.934c.246.112.368.168.496.19.113.02.229.02.342 0 .128-.022.25-.078.496-.19l6.4-2.934c.338-.155.507-.232.63-.353a1 1 0 0 0 .245-.38c.058-.163.058-.35.058-.721V9.5m-18-1 9.642-4.821c.131-.066.197-.098.266-.111a.5.5 0 0 1 .184 0c.069.013.135.045.266.11L22 8.5l-9.642 4.821a1.028 1.028 0 0 1-.266.111.501.501 0 0 1-.184 0c-.069-.012-.135-.045-.266-.11L2 8.5Z"
      }
    ));
    GraduationHat02_default = GraduationHat02;
  }
});

// design-system/src/icons/react/HelpCircle.tsx
import * as React41 from "react";
var HelpCircle, HelpCircle_default;
var init_HelpCircle = __esm({
  "design-system/src/icons/react/HelpCircle.tsx"() {
    "use strict";
    HelpCircle = (props2) => /* @__PURE__ */ React41.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React41.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React41.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      }
    ));
    HelpCircle_default = HelpCircle;
  }
});

// design-system/src/icons/react/HelpSquare.tsx
import * as React42 from "react";
var HelpSquare, HelpSquare_default;
var init_HelpSquare = __esm({
  "design-system/src/icons/react/HelpSquare.tsx"() {
    "use strict";
    HelpSquare = (props2) => /* @__PURE__ */ React42.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React42.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React42.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      }
    ));
    HelpSquare_default = HelpSquare;
  }
});

// design-system/src/icons/react/History.tsx
import * as React43 from "react";
var History, History_default;
var init_History = __esm({
  "design-system/src/icons/react/History.tsx"() {
    "use strict";
    History = (props2) => /* @__PURE__ */ React43.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", ...props2 }, /* @__PURE__ */ React43.createElement(
      "path",
      {
        d: "M11.6667 7.33333H8.33333M11.6667 10H8.33333M11.6667 4.66667H8.33333M6 2L6 14M5.2 2H10.8C11.9201 2 12.4802 2 12.908 2.21799C13.2843 2.40973 13.5903 2.71569 13.782 3.09202C14 3.51984 14 4.0799 14 5.2V10.8C14 11.9201 14 12.4802 13.782 12.908C13.5903 13.2843 13.2843 13.5903 12.908 13.782C12.4802 14 11.9201 14 10.8 14H5.2C4.07989 14 3.51984 14 3.09202 13.782C2.71569 13.5903 2.40973 13.2843 2.21799 12.908C2 12.4802 2 11.9201 2 10.8V5.2C2 4.07989 2 3.51984 2.21799 3.09202C2.40973 2.71569 2.71569 2.40973 3.09202 2.21799C3.51984 2 4.0799 2 5.2 2Z",
        stroke: "#7D7C78",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ));
    History_default = History;
  }
});

// design-system/src/icons/react/Image01.tsx
import * as React44 from "react";
var Image01, Image01_default;
var init_Image01 = __esm({
  "design-system/src/icons/react/Image01.tsx"() {
    "use strict";
    Image01 = (props2) => /* @__PURE__ */ React44.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React44.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m6.366 19.634 8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L21 15v1.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 0 1-.173-.42c.014-.183.228-.397.657-.826ZM8.5 10.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React44.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16.2 21H6.931c-.605 0-.908 0-1.049-.12a.5.5 0 0 1-.173-.42c.014-.183.228-.397.657-.826l8.503-8.503c.396-.396.594-.594.822-.668a1 1 0 0 1 .618 0c.228.074.426.272.822.668L21 15v1.2M16.2 21c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2M16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4M10.5 8.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      }
    ));
    Image01_default = Image01;
  }
});

// design-system/src/icons/react/InfoCircle.tsx
import * as React45 from "react";
var InfoCircle, InfoCircle_default;
var init_InfoCircle = __esm({
  "design-system/src/icons/react/InfoCircle.tsx"() {
    "use strict";
    InfoCircle = (props2) => /* @__PURE__ */ React45.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React45.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React45.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 16v-4m0-4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Z"
      }
    ));
    InfoCircle_default = InfoCircle;
  }
});

// design-system/src/icons/react/Lightbulb04.tsx
import * as React46 from "react";
var Lightbulb04, Lightbulb04_default;
var init_Lightbulb04 = __esm({
  "design-system/src/icons/react/Lightbulb04.tsx"() {
    "use strict";
    Lightbulb04 = (props2) => /* @__PURE__ */ React46.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React46.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M15 15.326a7 7 0 1 0-6 0V16c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16v-.674Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React46.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9.5 22h5M10 10h4m-2 0v6m3-.674a7 7 0 1 0-6 0V16c0 .932 0 1.398.152 1.765a2 2 0 0 0 1.083 1.083C10.602 19 11.068 19 12 19c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.083C15 17.398 15 16.932 15 16v-.674Z"
      }
    ));
    Lightbulb04_default = Lightbulb04;
  }
});

// design-system/src/icons/react/Lightning01.tsx
import * as React47 from "react";
var Lightning01, Lightning01_default;
var init_Lightning01 = __esm({
  "design-system/src/icons/react/Lightning01.tsx"() {
    "use strict";
    Lightning01 = (props2) => /* @__PURE__ */ React47.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React47.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 2 4.094 12.688c-.35.418-.524.628-.526.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 8.907-10.688c.349-.418.523-.628.526-.804a.5.5 0 0 0-.186-.397c-.138-.111-.41-.111-.955-.111H12l1-8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React47.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M13 2 4.093 12.688c-.348.418-.523.628-.525.804a.5.5 0 0 0 .185.397c.138.111.41.111.955.111H12l-1 8 8.907-10.688c.348-.418.523-.628.525-.804a.5.5 0 0 0-.185-.397c-.138-.111-.41-.111-.955-.111H12l1-8Z"
      }
    ));
    Lightning01_default = Lightning01;
  }
});

// design-system/src/icons/react/Link01.tsx
import * as React48 from "react";
var Link01, Link01_default;
var init_Link01 = __esm({
  "design-system/src/icons/react/Link01.tsx"() {
    "use strict";
    Link01 = (props2) => /* @__PURE__ */ React48.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React48.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m12.707 18.364-1.414 1.414a5 5 0 1 1-7.071-7.07l1.414-1.415m12.728 1.414 1.414-1.414a5 5 0 0 0-7.07-7.071l-1.415 1.414M8.5 15.5l7-7"
      }
    ));
    Link01_default = Link01;
  }
});

// design-system/src/icons/react/Link04.tsx
import * as React49 from "react";
var Link04, Link04_default;
var init_Link04 = __esm({
  "design-system/src/icons/react/Link04.tsx"() {
    "use strict";
    Link04 = (props2) => /* @__PURE__ */ React49.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React49.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7.5 7H7a5 5 0 0 0 0 10h2a5 5 0 0 0 5-5m2.5 5h.5a5 5 0 0 0 0-10h-2a5 5 0 0 0-5 5"
      }
    ));
    Link04_default = Link04;
  }
});

// design-system/src/icons/react/Link05.tsx
import * as React50 from "react";
var Link05, Link05_default;
var init_Link05 = __esm({
  "design-system/src/icons/react/Link05.tsx"() {
    "use strict";
    Link05 = (props2) => /* @__PURE__ */ React50.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React50.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M17 17h-1.222a.778.778 0 0 1-.778-.778V7.778c0-.43.348-.778.778-.778H17a5 5 0 0 1 0 10Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React50.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M8 12h10m-9 5H7A5 5 0 0 1 7 7h2m6.778 10H17a5 5 0 0 0 0-10h-1.222a.778.778 0 0 0-.778.778v8.444c0 .43.348.778.778.778Z"
      }
    ));
    Link05_default = Link05;
  }
});

// design-system/src/icons/react/LinkExternal01.tsx
import * as React51 from "react";
var LinkExternal01, LinkExternal01_default;
var init_LinkExternal01 = __esm({
  "design-system/src/icons/react/LinkExternal01.tsx"() {
    "use strict";
    LinkExternal01 = (props2) => /* @__PURE__ */ React51.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React51.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M7.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.72 19 17.88 19 16.2V14l-9-9H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.28 3 8.12 3 9.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React51.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 9V3m0 0h-6m6 0-8 8m-3-6H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 7.28 3 8.12 3 9.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C19 18.72 19 17.88 19 16.2V14"
      }
    ));
    LinkExternal01_default = LinkExternal01;
  }
});

// design-system/src/icons/react/Loading01.tsx
import * as React52 from "react";
var Loading01, Loading01_default;
var init_Loading01 = __esm({
  "design-system/src/icons/react/Loading01.tsx"() {
    "use strict";
    Loading01 = (props2) => /* @__PURE__ */ React52.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React52.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M12 2.25v2.5M12 18v4M5.75 12h-3.5m19 0h-1.5m-1.293 6.457-.707-.707m.914-12.334L17.25 6.83M4.922 19.078 7.75 16.25M5.129 5.209 7.25 7.33"
      }
    ));
    Loading01_default = Loading01;
  }
});

// design-system/src/icons/react/MessageChatCircle.tsx
import * as React53 from "react";
var MessageChatCircle, MessageChatCircle_default;
var init_MessageChatCircle = __esm({
  "design-system/src/icons/react/MessageChatCircle.tsx"() {
    "use strict";
    MessageChatCircle = (props2) => /* @__PURE__ */ React53.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React53.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M13 16.5c0 3.038-2.403 5.5-5.368 5.5a5.246 5.246 0 0 1-1.75-.299c-.208-.073-.312-.11-.382-.124a.843.843 0 0 0-.189-.019c-.071 0-.153.01-.316.033L2 22l.611-2.762c.04-.18.06-.271.065-.351a.852.852 0 0 0-.01-.213 3.496 3.496 0 0 0-.126-.427 5.617 5.617 0 0 1-.277-1.747c0-3.038 2.404-5.5 5.369-5.5S13 13.462 13 16.5Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React53.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M6.094 11.229A8.01 8.01 0 0 1 6 10c0-4.418 3.605-8 8.053-8 4.447 0 8.052 3.582 8.052 8a7.94 7.94 0 0 1-.52 2.835c-.07.182-.105.274-.12.345a.897.897 0 0 0-.024.194c-.002.073.008.153.028.314l.403 3.27c.043.355.065.532.006.66a.5.5 0 0 1-.257.252c-.13.055-.306.03-.66-.022l-3.184-.467c-.167-.024-.25-.037-.326-.036a.898.898 0 0 0-.2.021 2.989 2.989 0 0 0-.358.122 8.174 8.174 0 0 1-4.07.42M7.632 22C10.597 22 13 19.538 13 16.5S10.597 11 7.632 11c-2.965 0-5.369 2.462-5.369 5.5 0 .61.097 1.198.277 1.747.075.232.113.348.126.427.013.083.015.13.01.213-.005.08-.025.17-.065.351L2 22l2.995-.409c.163-.022.245-.034.316-.033.076 0 .115.005.19.02.07.013.173.05.381.123a5.246 5.246 0 0 0 1.75.299Z"
      }
    ));
    MessageChatCircle_default = MessageChatCircle;
  }
});

// design-system/src/icons/react/MessageChatSquare.tsx
import * as React54 from "react";
var MessageChatSquare, MessageChatSquare_default;
var init_MessageChatSquare = __esm({
  "design-system/src/icons/react/MessageChatSquare.tsx"() {
    "use strict";
    MessageChatSquare = (props2) => /* @__PURE__ */ React54.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React54.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M22 14.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 11 19.92 11 18.8 11h-5.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C10 12.52 10 13.08 10 14.2v2.514c0 1.12 0 1.68.218 2.108a2 2 0 0 0 .874.874c.428.218.988.218 2.108.218h1.797c.373 0 .559 0 .739.033.16.03.314.079.462.145.167.076.32.182.626.395L19 22v-2.086c.932 0 1.398 0 1.765-.152a2 2 0 0 0 1.083-1.082c.152-.368.152-.834.152-1.766V14.2Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React54.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m10 15-3.075 3.114c-.43.434-.644.651-.828.666a.5.5 0 0 1-.421-.172c-.12-.14-.12-.446-.12-1.056v-1.56c0-.548-.449-.944-.99-1.024v0a3 3 0 0 1-2.534-2.533C2 12.219 2 11.96 2 11.445V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h7.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C19 4.28 19 5.12 19 6.8V11m0 11-2.176-1.513c-.306-.213-.46-.32-.626-.395a2.002 2.002 0 0 0-.462-.145c-.18-.033-.367-.033-.74-.033H13.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C10 18.394 10 17.834 10 16.714V14.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C11.52 11 12.08 11 13.2 11h5.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C22 12.52 22 13.08 22 14.2v2.714c0 .932 0 1.398-.152 1.766a2 2 0 0 1-1.083 1.082c-.367.152-.833.152-1.765.152V22Z"
      }
    ));
    MessageChatSquare_default = MessageChatSquare;
  }
});

// design-system/src/icons/react/MessageCircle01.tsx
import * as React55 from "react";
var MessageCircle01, MessageCircle01_default;
var init_MessageCircle01 = __esm({
  "design-system/src/icons/react/MessageCircle01.tsx"() {
    "use strict";
    MessageCircle01 = (props2) => /* @__PURE__ */ React55.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React55.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M21 11.5a8.5 8.5 0 0 1-11.555 7.934c-.173-.066-.26-.1-.329-.116a.901.901 0 0 0-.186-.024 2.313 2.313 0 0 0-.303.021l-5.121.53c-.489.05-.733.075-.877-.013a.5.5 0 0 1-.233-.35c-.026-.166.09-.382.324-.814l1.635-3.027c.135-.25.202-.374.233-.494a.899.899 0 0 0 .028-.326c-.01-.123-.064-.283-.173-.604A8.5 8.5 0 1 1 21 11.5Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React55.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M21 11.5a8.5 8.5 0 0 1-11.555 7.934c-.173-.066-.26-.1-.329-.116a.901.901 0 0 0-.186-.024 2.313 2.313 0 0 0-.303.021l-5.121.53c-.489.05-.733.075-.877-.013a.5.5 0 0 1-.233-.35c-.026-.166.09-.382.324-.814l1.635-3.027c.135-.25.202-.374.233-.494a.899.899 0 0 0 .028-.326c-.01-.123-.064-.283-.173-.604A8.5 8.5 0 1 1 21 11.5Z"
      }
    ));
    MessageCircle01_default = MessageCircle01;
  }
});

// design-system/src/icons/react/Minus.tsx
import * as React56 from "react";
var Minus, Minus_default;
var init_Minus = __esm({
  "design-system/src/icons/react/Minus.tsx"() {
    "use strict";
    Minus = (props2) => /* @__PURE__ */ React56.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React56.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M5 12h14" }));
    Minus_default = Minus;
  }
});

// design-system/src/icons/react/NotificationBox.tsx
import * as React57 from "react";
var NotificationBox, NotificationBox_default;
var init_NotificationBox = __esm({
  "design-system/src/icons/react/NotificationBox.tsx"() {
    "use strict";
    NotificationBox = (props2) => /* @__PURE__ */ React57.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React57.createElement("path", { fill: "currentColor", d: "M20.121 3.879A3 3 0 1 1 15.88 8.12a3 3 0 0 1 4.24-4.24Z", opacity: 0.12 }), /* @__PURE__ */ React57.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2V13m.121-9.121A3 3 0 1 1 15.88 8.12a3 3 0 0 1 4.24-4.24Z"
      }
    ));
    NotificationBox_default = NotificationBox;
  }
});

// design-system/src/icons/react/Play.tsx
import * as React58 from "react";
var Play, Play_default;
var init_Play = __esm({
  "design-system/src/icons/react/Play.tsx"() {
    "use strict";
    Play = (props2) => /* @__PURE__ */ React58.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React58.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M5 4.99c0-.972 0-1.457.202-1.725a1 1 0 0 1 .738-.395c.335-.02.74.25 1.548.788l10.515 7.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948l-10.515 7.01c-.809.54-1.213.809-1.548.789a1 1 0 0 1-.738-.395C5 20.467 5 19.98 5 19.01V4.99Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React58.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M5 4.99c0-.972 0-1.457.202-1.725a1 1 0 0 1 .738-.395c.335-.02.74.25 1.548.788l10.515 7.01c.668.446 1.002.668 1.118.949a1 1 0 0 1 0 .766c-.116.28-.45.503-1.118.948l-10.515 7.01c-.809.54-1.213.809-1.548.789a1 1 0 0 1-.738-.395C5 20.467 5 19.98 5 19.01V4.99Z"
      }
    ));
    Play_default = Play;
  }
});

// design-system/src/icons/react/Plus.tsx
import * as React59 from "react";
var Plus, Plus_default;
var init_Plus = __esm({
  "design-system/src/icons/react/Plus.tsx"() {
    "use strict";
    Plus = (props2) => /* @__PURE__ */ React59.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React59.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 5v14m-7-7h14" }));
    Plus_default = Plus;
  }
});

// design-system/src/icons/react/RefreshCcw01.tsx
import * as React60 from "react";
var RefreshCcw01, RefreshCcw01_default;
var init_RefreshCcw01 = __esm({
  "design-system/src/icons/react/RefreshCcw01.tsx"() {
    "use strict";
    RefreshCcw01 = (props2) => /* @__PURE__ */ React60.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React60.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 10s2.005-2.732 3.634-4.362A9 9 0 1 1 12 21a9.004 9.004 0 0 1-8.648-6.5M2 10V4m0 6h6"
      }
    ));
    RefreshCcw01_default = RefreshCcw01;
  }
});

// design-system/src/icons/react/RefreshCw01.tsx
import * as React61 from "react";
var RefreshCw01, RefreshCw01_default;
var init_RefreshCw01 = __esm({
  "design-system/src/icons/react/RefreshCw01.tsx"() {
    "use strict";
    RefreshCw01 = (props2) => /* @__PURE__ */ React61.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React61.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 10s-2.005-2.732-3.634-4.362a9 9 0 1 0 2.282 8.862M22 10V4m0 6h-6"
      }
    ));
    RefreshCw01_default = RefreshCw01;
  }
});

// design-system/src/icons/react/SearchSm.tsx
import * as React62 from "react";
var SearchSm, SearchSm_default;
var init_SearchSm = __esm({
  "design-system/src/icons/react/SearchSm.tsx"() {
    "use strict";
    SearchSm = (props2) => /* @__PURE__ */ React62.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React62.createElement("path", { fill: "currentColor", d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z", opacity: 0.12 }), /* @__PURE__ */ React62.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m21 21-6-6m2-5a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
      }
    ));
    SearchSm_default = SearchSm;
  }
});

// design-system/src/icons/react/Send03.tsx
import * as React63 from "react";
var Send03, Send03_default;
var init_Send03 = __esm({
  "design-system/src/icons/react/Send03.tsx"() {
    "use strict";
    Send03 = (props2) => /* @__PURE__ */ React63.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React63.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M2.574 4.73c-.182-.547-.272-.82-.206-.99a.5.5 0 0 1 .331-.298c.174-.049.437.07.962.306L20.38 11.27c.514.23.771.347.85.507a.5.5 0 0 1 0 .444c-.079.16-.336.276-.85.508L3.667 20.25c-.527.237-.79.355-.965.307a.5.5 0 0 1-.331-.3c-.066-.169.026-.443.21-.99l2.334-6.976a1.06 1.06 0 0 0 .054-.188.5.5 0 0 0 0-.129c-.006-.048-.022-.095-.053-.188L2.574 4.729Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React63.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M10.5 12H5m-.085.291L2.58 19.267c-.183.548-.275.822-.209.99a.5.5 0 0 0 .331.3c.175.05.438-.07.965-.306l16.712-7.52c.514-.232.771-.348.85-.508a.5.5 0 0 0 0-.444c-.079-.16-.336-.276-.85-.508L3.66 3.748c-.525-.237-.788-.355-.962-.306a.5.5 0 0 0-.331.299c-.066.168.024.442.206.988l2.342 7.057c.031.094.047.14.053.188a.5.5 0 0 1 0 .129 1.06 1.06 0 0 1-.054.188Z"
      }
    ));
    Send03_default = Send03;
  }
});

// design-system/src/icons/react/SlashDivider.tsx
import * as React64 from "react";
var SlashDivider, SlashDivider_default;
var init_SlashDivider = __esm({
  "design-system/src/icons/react/SlashDivider.tsx"() {
    "use strict";
    SlashDivider = (props2) => /* @__PURE__ */ React64.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React64.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M7 22 17 2" }));
    SlashDivider_default = SlashDivider;
  }
});

// design-system/src/icons/react/Star01.tsx
import * as React65 from "react";
var Star01, Star01_default;
var init_Star01 = __esm({
  "design-system/src/icons/react/Star01.tsx"() {
    "use strict";
    Star01 = (props2) => /* @__PURE__ */ React65.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React65.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M11.283 3.453c.23-.467.345-.7.502-.775a.5.5 0 0 1 .43 0c.157.075.272.308.502.775l2.187 4.43c.068.138.102.207.152.26a.502.502 0 0 0 .155.114c.067.03.143.042.295.064l4.891.715c.515.075.773.113.892.238a.5.5 0 0 1 .133.41c-.023.172-.21.353-.582.716l-3.54 3.446c-.11.108-.165.162-.2.226a.5.5 0 0 0-.06.183c-.009.072.004.148.03.3l.835 4.867c.088.514.132.77.05.922a.5.5 0 0 1-.349.253c-.17.032-.4-.09-.862-.332l-4.373-2.3c-.136-.07-.204-.107-.276-.12a.498.498 0 0 0-.192 0c-.072.013-.14.05-.276.12l-4.373 2.3c-.461.243-.692.364-.862.332a.5.5 0 0 1-.348-.253c-.083-.152-.039-.409.05-.922l.834-4.867c.026-.152.039-.228.03-.3a.5.5 0 0 0-.06-.184c-.035-.063-.09-.117-.2-.225L3.16 10.4c-.373-.363-.56-.544-.582-.716a.5.5 0 0 1 .132-.41c.12-.125.377-.163.892-.238l4.891-.715c.152-.022.228-.034.295-.064a.5.5 0 0 0 .155-.113c.05-.054.084-.123.152-.26l2.187-4.43Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React65.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11.283 3.453c.23-.467.345-.7.502-.775a.5.5 0 0 1 .43 0c.157.075.272.308.502.775l2.187 4.43c.068.138.102.207.152.26a.502.502 0 0 0 .155.114c.067.03.143.042.295.064l4.891.715c.515.075.773.113.892.238a.5.5 0 0 1 .133.41c-.023.172-.21.353-.582.716l-3.54 3.446c-.11.108-.165.162-.2.226a.5.5 0 0 0-.06.183c-.009.072.004.148.03.3l.835 4.867c.088.514.132.77.05.922a.5.5 0 0 1-.349.253c-.17.032-.4-.09-.862-.332l-4.373-2.3c-.136-.07-.204-.107-.276-.12a.498.498 0 0 0-.192 0c-.072.013-.14.05-.276.12l-4.373 2.3c-.461.243-.692.364-.862.332a.5.5 0 0 1-.348-.253c-.083-.152-.039-.409.05-.922l.834-4.867c.026-.152.039-.228.03-.3a.5.5 0 0 0-.06-.184c-.035-.063-.09-.117-.2-.225L3.16 10.4c-.373-.363-.56-.544-.582-.716a.5.5 0 0 1 .132-.41c.12-.125.377-.163.892-.238l4.891-.715c.152-.022.228-.034.295-.064a.5.5 0 0 0 .155-.113c.05-.054.084-.123.152-.26l2.187-4.43Z"
      }
    ));
    Star01_default = Star01;
  }
});

// design-system/src/icons/react/SwitchVertical02.tsx
import * as React66 from "react";
var SwitchVertical02, SwitchVertical02_default;
var init_SwitchVertical02 = __esm({
  "design-system/src/icons/react/SwitchVertical02.tsx"() {
    "use strict";
    SwitchVertical02 = (props2) => /* @__PURE__ */ React66.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React66.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 4v16m0 0-4-4m4 4 4-4m6 4V4m0 0-4 4m4-4 4 4"
      }
    ));
    SwitchVertical02_default = SwitchVertical02;
  }
});

// design-system/src/icons/react/Target04.tsx
import * as React67 from "react";
var Target04, Target04_default;
var init_Target04 = __esm({
  "design-system/src/icons/react/Target04.tsx"() {
    "use strict";
    Target04 = (props2) => /* @__PURE__ */ React67.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React67.createElement("path", { fill: "currentColor", d: "m19 2-3 3v3h3l3-3-2-1-1-2Zm-7 15a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z", opacity: 0.12 }), /* @__PURE__ */ React67.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M16 8V5l3-3 1 2 2 1-3 3h-3Zm0 0-4 4m10 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m5 10a5 5 0 1 1-5-5"
      }
    ));
    Target04_default = Target04;
  }
});

// design-system/src/icons/react/ThumbsDown.tsx
import * as React68 from "react";
var ThumbsDown, ThumbsDown_default;
var init_ThumbsDown = __esm({
  "design-system/src/icons/react/ThumbsDown.tsx"() {
    "use strict";
    ThumbsDown = (props2) => /* @__PURE__ */ React68.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React68.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M18.8 2H17v11h1.8c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 11.48 22 10.92 22 9.8V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React68.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M17 2v11m5-3.2V5.2c0-1.12 0-1.68-.218-2.108a2 2 0 0 0-.874-.874C20.48 2 19.92 2 18.8 2H8.118c-1.461 0-2.192 0-2.782.267A3 3 0 0 0 4.06 3.361c-.354.542-.465 1.265-.687 2.71l-.523 3.4c-.293 1.904-.44 2.857-.157 3.598a3 3 0 0 0 1.32 1.539C4.704 15 5.667 15 7.595 15H8.4c.56 0 .84 0 1.054.109a1 1 0 0 1 .437.437c.11.214.11.494.11 1.054v2.934A2.466 2.466 0 0 0 12.465 22a.82.82 0 0 0 .751-.488l3.36-7.562c.154-.344.23-.516.35-.642a1 1 0 0 1 .384-.249c.164-.059.352-.059.729-.059h.76c1.12 0 1.68 0 2.108-.218a2 2 0 0 0 .874-.874C22 11.48 22 10.92 22 9.8Z"
      }
    ));
    ThumbsDown_default = ThumbsDown;
  }
});

// design-system/src/icons/react/ThumbsUp.tsx
import * as React69 from "react";
var ThumbsUp, ThumbsUp_default;
var init_ThumbsUp = __esm({
  "design-system/src/icons/react/ThumbsUp.tsx"() {
    "use strict";
    ThumbsUp = (props2) => /* @__PURE__ */ React69.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React69.createElement("path", { fill: "currentColor", d: "M2 13v7a2 2 0 0 0 2 2h3V11H4a2 2 0 0 0-2 2Z", opacity: 0.12 }), /* @__PURE__ */ React69.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M7 22V11m-5 2v7a2 2 0 0 0 2 2h13.426a3 3 0 0 0 2.965-2.544l1.077-7A3 3 0 0 0 18.503 9H15a1 1 0 0 1-1-1V4.466A2.466 2.466 0 0 0 11.534 2a.822.822 0 0 0-.75.488l-3.52 7.918A1 1 0 0 1 6.35 11H4a2 2 0 0 0-2 2Z"
      }
    ));
    ThumbsUp_default = ThumbsUp;
  }
});

// design-system/src/icons/react/UserIncognito.tsx
import * as React70 from "react";
var UserIncognito, UserIncognito_default;
var init_UserIncognito = __esm({
  "design-system/src/icons/react/UserIncognito.tsx"() {
    "use strict";
    UserIncognito = (props2) => /* @__PURE__ */ React70.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React70.createElement(
      "path",
      {
        fill: "#797C85",
        d: "M5.8855 9.4477c1.0414 1.0414 1.0414 2.7298 0 3.7712-1.0414 1.0414-2.7298 1.0414-3.7712 0-1.0414-1.0414-1.0414-2.7298 0-3.7712 1.0414-1.0414 2.7298-1.0414 3.7712 0Zm8 0c1.0414 1.0414 1.0414 2.7298 0 3.7712-1.0414 1.0414-2.7298 1.0414-3.7712 0-1.0414-1.0414-1.0414-2.7298 0-3.7712 1.0414-1.0414 2.7298-1.0414 3.7712 0Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React70.createElement(
      "path",
      {
        stroke: "#797C85",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.5,
        d: "M6.6666 11.0231c.8223-.4753 1.8442-.4753 2.6666 0M5.8855 9.4477c1.0414 1.0414 1.0414 2.7298 0 3.7712-1.0414 1.0414-2.7298 1.0414-3.7712 0-1.0414-1.0414-1.0414-2.7298 0-3.7712 1.0414-1.0414 2.7298-1.0414 3.7712 0Zm8 0c1.0414 1.0414 1.0414 2.7298 0 3.7712-1.0414 1.0414-2.7298 1.0414-3.7712 0-1.0414-1.0414-1.0414-2.7298 0-3.7712 1.0414-1.0414 2.7298-1.0414 3.7712 0Z"
      }
    ), /* @__PURE__ */ React70.createElement("path", { stroke: "#797C85", strokeLinecap: "round", strokeWidth: 1.5, d: "M1.3333 6.6666h13.3333" }), /* @__PURE__ */ React70.createElement(
      "path",
      {
        stroke: "#797C85",
        strokeWidth: 1.5,
        d: "m4.6668 6.6667 1.06-4.24c.1203-.4812.7195-.6472 1.0701-.2965.6645.6645 1.7418.6645 2.4063 0 .3507-.3507.9499-.1847 1.0702.2965l1.06 4.24"
      }
    ));
    UserIncognito_default = UserIncognito;
  }
});

// design-system/src/icons/react/UserSquare.tsx
import * as React71 from "react";
var UserSquare, UserSquare_default;
var init_UserSquare = __esm({
  "design-system/src/icons/react/UserSquare.tsx"() {
    "use strict";
    UserSquare = (props2) => /* @__PURE__ */ React71.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React71.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M12 13.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm4 3.5H8a4 4 0 0 0-4 4 1 1 0 0 0 1 1h14a1 1 0 0 0 1-1 4 4 0 0 0-4-4Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React71.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M4 21.817C4.603 22 5.416 22 6.8 22h10.4c1.384 0 2.197 0 2.8-.183m-16 0a2.18 2.18 0 0 1-.362-.144 3 3 0 0 1-1.311-1.311C2 19.72 2 18.88 2 17.2V6.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 2 5.12 2 6.8 2h10.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C22 4.28 22 5.12 22 6.8v10.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311 2.18 2.18 0 0 1-.362.144m-16 0c0-.809.005-1.237.077-1.597a4 4 0 0 1 3.143-3.143C7.606 17 8.07 17 9 17h6c.93 0 1.394 0 1.78.077a4 4 0 0 1 3.143 3.143c.072.36.077.788.077 1.597M16 9.5a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"
      }
    ));
    UserSquare_default = UserSquare;
  }
});

// design-system/src/icons/react/VideoRecorder.tsx
import * as React72 from "react";
var VideoRecorder, VideoRecorder_default;
var init_VideoRecorder = __esm({
  "design-system/src/icons/react/VideoRecorder.tsx"() {
    "use strict";
    VideoRecorder = (props2) => /* @__PURE__ */ React72.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React72.createElement(
      "path",
      {
        fill: "currentColor",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M2 9.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 5 5.12 5 6.8 5h5.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.28 17 8.12 17 9.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 19 13.88 19 12.2 19H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 16.72 2 15.88 2 14.2V9.8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React72.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M22 8.931c0-.605 0-.908-.12-1.049a.5.5 0 0 0-.42-.173c-.183.014-.397.228-.826.657L17 12l3.634 3.634c.429.429.643.643.827.657a.5.5 0 0 0 .42-.173c.119-.14.119-.444.119-1.05V8.932ZM2 9.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C4.28 5 5.12 5 6.8 5h5.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C17 7.28 17 8.12 17 9.8v4.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C14.72 19 13.88 19 12.2 19H6.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 16.72 2 15.88 2 14.2V9.8Z"
      }
    ));
    VideoRecorder_default = VideoRecorder;
  }
});

// design-system/src/icons/react/XClose.tsx
import * as React73 from "react";
var XClose, XClose_default;
var init_XClose = __esm({
  "design-system/src/icons/react/XClose.tsx"() {
    "use strict";
    XClose = (props2) => /* @__PURE__ */ React73.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React73.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M18 6 6 18M6 6l12 12" }));
    XClose_default = XClose;
  }
});

// design-system/src/icons/react/ZapFast.tsx
import * as React74 from "react";
var ZapFast, ZapFast_default;
var init_ZapFast = __esm({
  "design-system/src/icons/react/ZapFast.tsx"() {
    "use strict";
    ZapFast = (props2) => /* @__PURE__ */ React74.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React74.createElement(
      "path",
      {
        fill: "currentColor",
        d: "m17 3-6.596 9.235c-.292.409-.438.613-.432.784a.5.5 0 0 0 .194.377c.135.104.386.104.889.104H16L15 21l6.596-9.235c.292-.409.438-.613.432-.784a.5.5 0 0 0-.194-.377c-.135-.104-.386-.104-.889-.104H16L17 3Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React74.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M9 17.5H3.5m3-5.5H2m7-5.5H4M17 3l-6.596 9.235c-.292.409-.438.613-.432.784a.5.5 0 0 0 .194.377c.135.104.386.104.889.104H16L15 21l6.596-9.235c.292-.409.438-.613.432-.784a.5.5 0 0 0-.194-.377c-.135-.104-.386-.104-.889-.104H16L17 3Z"
      }
    ));
    ZapFast_default = ZapFast;
  }
});

// design-system/src/icons/react/index.tsx
var init_react = __esm({
  "design-system/src/icons/react/index.tsx"() {
    "use strict";
    init_AlertHexagon();
    init_ArrowDown();
    init_ArrowNarrowRight();
    init_ArrowRight();
    init_ArrowUp();
    init_ArrowUpRight();
    init_Attachment01();
    init_BookClosed();
    init_BookOpen01();
    init_BookOpen02();
    init_Bookmark();
    init_BookmarkCheck();
    init_Caret();
    init_Check();
    init_CheckCircleBroken();
    init_CheckSquareBroken();
    init_ChevronDown();
    init_ChevronLeft();
    init_ChevronLeftFilled();
    init_ChevronRight();
    init_ChevronRightFilled();
    init_ChevronUp();
    init_Clock();
    init_CornerDownLeft();
    init_CursorClick02();
    init_DotsHorizontal();
    init_DotsVertical();
    init_Expand02();
    init_FileSearch02();
    init_FlipBackward();
    init_GraduationHat02();
    init_HelpCircle();
    init_HelpSquare();
    init_History();
    init_Image01();
    init_InfoCircle();
    init_Lightbulb04();
    init_Lightning01();
    init_Link01();
    init_Link04();
    init_Link05();
    init_LinkExternal01();
    init_Loading01();
    init_MessageChatCircle();
    init_MessageChatSquare();
    init_MessageCircle01();
    init_Minus();
    init_NotificationBox();
    init_Play();
    init_Plus();
    init_RefreshCcw01();
    init_RefreshCw01();
    init_SearchSm();
    init_Send03();
    init_SlashDivider();
    init_Star01();
    init_SwitchVertical02();
    init_Target04();
    init_ThumbsDown();
    init_ThumbsUp();
    init_UserIncognito();
    init_UserSquare();
    init_VideoRecorder();
    init_XClose();
    init_ZapFast();
  }
});

// commandbar/src/shared/components/video/players/videoPlayer.ts
var getYoutubePlayer, getLoomPlayer, getVimeoPlayer, getVidyardPlayer;
var init_videoPlayer = __esm({
  "commandbar/src/shared/components/video/players/videoPlayer.ts"() {
    "use strict";
    getYoutubePlayer = (url, autoPlay = true) => {
      const videoID = new URL(url).searchParams.get("v");
      if (!videoID) {
        return void 0;
      }
      return `
    <iframe
      src="https://www.youtube.com/embed/${videoID}?autoplay=${autoPlay ? 1 : 0}"
      title="YouTube video player"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  `;
    };
    getLoomPlayer = (url) => {
      const videoID = new URL(url).pathname.split("/").slice(-1)[0];
      if (!videoID) {
        return void 0;
      }
      return `
    <iframe
      src="https://www.loom.com/embed/${videoID}"
      title="Loom video player"
      frameborder="0"
      allowfullscreen
    ></iframe>
  `;
    };
    getVimeoPlayer = (url, autoPlay = true) => {
      const videoID = new URL(url).pathname;
      if (!videoID) {
        return void 0;
      }
      return `
    <iframe
      src="https://player.vimeo.com/video${videoID}?autoplay=${autoPlay ? 1 : 0}"
      title="Vimeo video player"
      frameborder="0"
      allowfullscreen
    ></iframe>
  `;
    };
    getVidyardPlayer = (url) => {
      const videoID = new URL(url).pathname.split("/").slice(-1)[0];
      if (!videoID) {
        return void 0;
      }
      return `
  <iframe
    src="//play.vidyard.com/${videoID}"
    title="VidyardPlayer video player"
    frameborder="0"
    allowfullscreen
  ></iframe>
`;
    };
  }
});

// commandbar/src/shared/components/video/players/index.ts
var getPlayer, players_default;
var init_players = __esm({
  "commandbar/src/shared/components/video/players/index.ts"() {
    "use strict";
    init_sentry();
    init_videoPlayer();
    getPlayer = (url, autoPlay) => {
      var _a2;
      try {
        const { hostname } = new URL(url);
        switch (hostname) {
          case "www.youtube.com": {
            if (url.includes("shorts")) {
              url = url.replace("shorts/", "watch?v=");
            }
            return getYoutubePlayer(url, autoPlay);
          }
          case "youtu.be": {
            url = `https://www.youtube.com/watch?v=${url.split("/").pop()}`;
            return getYoutubePlayer(url, autoPlay);
          }
          case "www.loom.com": {
            return getLoomPlayer(url);
          }
          case "vimeo.com": {
            return getVimeoPlayer(url, autoPlay);
          }
          case "player.vimeo.com": {
            url = `https://vimeo.com/${url.split("/").pop()}`;
            return getVimeoPlayer(url, autoPlay);
          }
          case "share.vidyard.com":
          case "play.vidyard.com":
          case "video.vidyard.com": {
            return getVidyardPlayer(url);
          }
          default: {
            return void 0;
          }
        }
      } catch (err) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
        return void 0;
      }
    };
    players_default = getPlayer;
  }
});

// internal/src/util/chroma.ts
import chroma2 from "chroma-js";
var getChromaColor;
var init_chroma = __esm({
  "internal/src/util/chroma.ts"() {
    "use strict";
    getChromaColor = (color) => {
      return chroma2.valid(color) ? chroma2(color) : chroma2("#000");
    };
  }
});

// internal/src/util/sanitizeHtml.ts
import createDOMPurify from "dompurify";
var DEFAULT_ADD_ATTR, DEFAULT_ADD_TAGS, sanitizeHtml, sanitizeHtml_default;
var init_sanitizeHtml = __esm({
  "internal/src/util/sanitizeHtml.ts"() {
    "use strict";
    DEFAULT_ADD_ATTR = [
      "onclick",
      "id",
      "class",
      "style",
      "allow",
      "allowfullscreen",
      "frameborder",
      "height",
      "src",
      "title",
      "width",
      "target"
    ];
    DEFAULT_ADD_TAGS = ["iframe"];
    if (false) {
      sanitizeHtml = (html, allowTags) => sanitizer(html, {
        allowedAttributes: {
          ...sanitizer.defaults.allowedAttributes,
          "*": DEFAULT_ADD_ATTR
        },
        parseStyleAttributes: false,
        allowedTags: sanitizer.defaults.allowedTags.concat((allowTags == null ? void 0 : allowTags.length) ? allowTags : DEFAULT_ADD_TAGS)
      });
    } else {
      const DOMPurify = createDOMPurify();
      DOMPurify.addHook("uponSanitizeAttribute", (_, data) => {
        if (data.attrName === "onclick") {
          const script = data.attrValue;
          if (!/^window\.CommandBar\.execute\(.{1,50}\)$/.test(script)) {
            return data.attrValue = "";
          }
        }
      });
      sanitizeHtml = (html, allowTags) => DOMPurify.sanitize(html, {
        ADD_TAGS: allowTags ? allowTags : DEFAULT_ADD_TAGS,
        ADD_ATTR: DEFAULT_ADD_ATTR,
        FORCE_BODY: true
      });
    }
    sanitizeHtml_default = sanitizeHtml;
  }
});

// commandbar/src/shared/components/video/Previews.tsx
import { jsx } from "@emotion/core";
import React75 from "react";
var EmbeddedVideo, URLVideo;
var init_Previews = __esm({
  "commandbar/src/shared/components/video/Previews.tsx"() {
    "use strict";
    init_useStore();
    init_chroma();
    init_useTheme();
    init_sanitizeHtml();
    EmbeddedVideo = ({ source, isDashBoard }) => {
      const { theme } = useTheme();
      const { testMode } = useStore();
      const _html = React75.useMemo(() => {
        return sanitizeHtml_default(source);
      }, [source]);
      if (!_html && testMode) {
        return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(
          "div",
          {
            css: {
              width: "100%",
              aspectRatio: "16 / 9",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              borderRadius: isDashBoard ? `${theme.main.borderRadius} ${theme.main.borderRadius} 0 0` : void 0,
              background: getChromaColor(theme.main.background).darken().css()
            }
          },
          /* @__PURE__ */ jsx("h2", null, "Unsupported")
        ));
      }
      return /* @__PURE__ */ jsx("div", null, /* @__PURE__ */ jsx(
        "div",
        {
          css: {
            width: "100%",
            aspectRatio: "16 / 9",
            position: "relative",
            borderRadius: isDashBoard ? `${theme.main.borderRadius} ${theme.main.borderRadius} 0 0` : void 0,
            overflow: "hidden",
            "& > iframe": {
              width: "100%",
              height: "100%",
              position: "absolute",
              inset: 0
            }
          },
          dangerouslySetInnerHTML: { __html: _html }
        }
      ));
    };
    URLVideo = ({ source, autoPlay }) => {
      return /* @__PURE__ */ jsx(
        "video",
        {
          style: {
            width: "100%",
            aspectRatio: "16 / 9",
            maxHeight: "100%"
          },
          controls: true,
          autoPlay
        },
        /* @__PURE__ */ jsx("source", { src: source, type: "video/mp4" }),
        /* @__PURE__ */ jsx("track", { src: "captions_en.vtt", kind: "captions", label: "english_captions" }),
        "Your browser does not support HTML video."
      );
    };
  }
});

// commandbar/src/shared/components/video/VideoContainer.tsx
import { jsx as jsx2 } from "@emotion/core";
var VideoContainer, VideoContainer_default;
var init_VideoContainer = __esm({
  "commandbar/src/shared/components/video/VideoContainer.tsx"() {
    "use strict";
    init_players();
    init_Previews();
    init_location();
    VideoContainer = ({ source, containerStyles: containerStyles4, autoPlay }) => {
      const isEmbeddablePreview = !isValidURL(source) || players_default(source);
      return /* @__PURE__ */ jsx2(
        "div",
        {
          "data-testid": "commandbar-video",
          style: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            padding: "10px",
            ...containerStyles4
          }
        },
        !isEmbeddablePreview ? /* @__PURE__ */ jsx2(URLVideo, { source, autoPlay }) : /* @__PURE__ */ jsx2(EmbeddedVideo, { source: players_default(source, autoPlay) || source })
      );
    };
    VideoContainer_default = VideoContainer;
  }
});

// internal/src/middleware/helpDocsSearch.tsx
import * as t33 from "io-ts";
var FilterV, HelpDocHitV, SearchHelpDocsResponseV, SearchHelpDocsPayloadV, HelpDocsSearch;
var init_helpDocsSearch = __esm({
  "internal/src/middleware/helpDocsSearch.tsx"() {
    "use strict";
    init_network();
    init_generics();
    init_command();
    FilterV = t33.union([t33.partial({ labels: t33.array(t33.string) }), t33.null]);
    HelpDocHitV = t33.type({
      score: t33.array(t33.number),
      command: CommandV,
      excerpt: t33.string
    });
    SearchHelpDocsResponseV = t33.type({
      data: t33.array(t33.type({ hit: HelpDocHitV }))
    });
    SearchHelpDocsPayloadV = t33.partial({
      query: t33.string,
      include_additional_docs: t33.union([t33.boolean, t33.undefined]),
      expand_rules: t33.union([t33.boolean, t33.undefined]),
      doc_id: t33.union([t33.number, t33.string, t33.undefined]),
      filter: FilterV
    });
    HelpDocsSearch = class {
    };
    HelpDocsSearch.search = async (orgUID, payload, options) => {
      const serializedPayload = Object.entries(payload).filter(([_key, value]) => Boolean(value)).map(([key, value]) => {
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        return `${key}=${encodeURIComponent(value)}`;
      }).join("&");
      const result = await get2(
        `search/helpexplorer/${orgUID}/?${serializedPayload}`,
        {
          ...options
        }
      );
      return await decodeToPromise(t33.exact(SearchHelpDocsResponseV), result.data);
    };
  }
});

// internal/src/middleware/chat.tsx
import * as t34 from "io-ts";
var ContinuationV, SourceDocV, CommandExperience, NudgeExperience, QuestlistExperience, ExperienceV, AIAnswerValue, AIMessageExtraV, AIMessageV, UserAttachmentV, UserMessageV, AgentMessageV, MessageV, QuestionSuggestionsV, QuestionSuggestionsPayloadV, ContinuationsPayloadV, CopilotSettingsPreviewV, CopilotSettingsPreviewPayloadV, AIAnswerPayloadV, AIAnswerV, CreateAnswerFeedbackPayloadV, ChatV, CreateChatPayloadV, Chat;
var init_chat = __esm({
  "internal/src/middleware/chat.tsx"() {
    "use strict";
    init_command();
    init_generics();
    init_helpDocsSearch();
    init_actions();
    init_copilotPersonality();
    init_network();
    ContinuationV = t34.string;
    SourceDocV = t34.type({
      command: CommandV,
      passage_heading: t34.union([t34.string, t34.null])
    });
    CommandExperience = t34.type({
      type: t34.literal("command"),
      value: t34.union([t34.number, t34.string]),
      // command id
      description: t34.union([t34.string, t34.undefined])
    });
    NudgeExperience = t34.type({
      type: t34.literal("nudge"),
      value: t34.number,
      // nudge id
      description: t34.union([t34.string, t34.undefined])
    });
    QuestlistExperience = t34.type({
      type: t34.literal("questlist"),
      value: t34.number,
      // command id
      description: t34.union([t34.string, t34.undefined])
    });
    ExperienceV = t34.union([CommandExperience, NudgeExperience, QuestlistExperience]);
    AIAnswerValue = t34.intersection([
      t34.type({
        answer: t34.string,
        command_id: t34.union([t34.number, t34.null]),
        command_title: t34.string,
        passage_id: t34.union([t34.number, t34.null]),
        passage_heading: t34.union([t34.string, t34.null]),
        doc: t34.union([
          t34.type({
            title: t34.string,
            excerpt: t34.string,
            content: t34.string,
            command: CommandV
          }),
          t34.null
        ]),
        source_docs: t34.array(SourceDocV)
      }),
      t34.partial({
        message_id: t34.number,
        chat_id: t34.string,
        copilot_command: CommandV,
        experiences: t34.union([t34.null, t34.array(ExperienceV)])
      })
    ]);
    AIMessageExtraV = t34.type({
      type: t34.union([t34.literal("button_primary"), t34.literal("button_secondary")]),
      text: t34.string,
      action: t34.union([ActionV, t34.undefined]),
      message: t34.union([t34.string, t34.undefined])
    });
    AIMessageV = t34.type({
      message_type: t34.literal("AI"),
      value: AIAnswerValue,
      uuid: t34.union([t34.null, t34.string]),
      error: t34.string,
      incomplete: t34.boolean,
      no_answer: t34.boolean,
      used_fallback: t34.boolean,
      feedback: t34.union([t34.null, t34.type({ rating: t34.union([t34.literal(-1), t34.literal(0), t34.literal(1)]) })]),
      continuations: t34.union([t34.null, t34.array(ContinuationV)]),
      fallback_ctas: t34.union([t34.null, t34.array(t34.string)]),
      // deprecated
      fallback_labeled_actions: t34.array(LabeledActionV),
      extras: t34.array(AIMessageExtraV),
      modified: t34.string,
      debug_info: t34.union([t34.null, t34.undefined, t34.record(t34.string, t34.any)])
    });
    UserAttachmentV = t34.type({
      type: t34.string,
      title: t34.union([t34.undefined, t34.string]),
      description: t34.union([t34.undefined, t34.string]),
      media_preview_url: t34.string
    });
    UserMessageV = t34.type({
      message_type: t34.literal("USER"),
      value: t34.type({
        question: t34.string,
        command_ids: t34.array(t34.number),
        attachments: t34.array(UserAttachmentV)
      }),
      uuid: t34.union([t34.null, t34.string]),
      modified: t34.string
    });
    AgentMessageV = t34.type({
      message_type: t34.literal("AGENT"),
      value: t34.type({
        content: t34.string,
        attachments: t34.array(UserAttachmentV)
      }),
      uuid: t34.union([t34.null, t34.string]),
      error: t34.string,
      author: t34.string,
      modified: t34.string
    });
    MessageV = t34.union([AIMessageV, UserMessageV, AgentMessageV]);
    QuestionSuggestionsV = t34.type({
      suggestions: t34.array(t34.string)
    });
    QuestionSuggestionsPayloadV = t34.partial({
      user: t34.union([t34.string, t34.null, t34.undefined]),
      page_context: t34.type({
        title: t34.string,
        description: t34.union([t34.string, t34.null]),
        h1s: t34.array(t34.string),
        h2s: t34.array(t34.string),
        h3s: t34.array(t34.string)
      })
    });
    ContinuationsPayloadV = t34.type({
      command_ids: t34.union([t34.array(t34.number), t34.undefined]),
      passage_ids: t34.union([t34.array(t34.number), t34.undefined]),
      user: t34.union([t34.string, t34.null, t34.undefined]),
      chat_id: t34.string
    });
    CopilotSettingsPreviewV = t34.union([
      t34.type({
        avatar: t34.union([t34.string, t34.null]),
        name: t34.union([t34.string, t34.null]),
        personality: t34.union([CopilotPersonalityV, t34.null]),
        custom_instructions: t34.union([t34.string, t34.null])
      }),
      t34.null
    ]);
    CopilotSettingsPreviewPayloadV = t34.union([
      t34.type({
        name: t34.union([t34.string, t34.null]),
        personality: t34.union([CopilotPersonalityV, t34.null]),
        custom_instructions: t34.union([t34.string, t34.null])
      }),
      t34.null
    ]);
    AIAnswerPayloadV = t34.intersection([
      t34.type({
        /** @deprecated Removed entirely, since we no longer can ask AI about a specific doc */
        command_ids: t34.union([t34.array(t34.number), t34.undefined]),
        query: t34.string,
        user: t34.union([t34.string, t34.null, t34.undefined]),
        chat_id: t34.union([t34.string, t34.undefined]),
        filter: t34.union([FilterV, t34.undefined]),
        disable_experiences: t34.union([t34.boolean, t34.undefined])
      }),
      t34.partial({
        system_template_override: t34.string,
        settings_override: CopilotSettingsPreviewPayloadV,
        copilot_api_headers: t34.record(t34.string, t34.string),
        user_timezone: t34.string,
        end_user_id: t34.string,
        hmac: t34.string,
        attachments: t34.array(UserAttachmentV),
        user_properties_override: t34.record(t34.string, t34.any),
        is_admin: t34.boolean
      })
    ]);
    AIAnswerV = t34.type({
      chat_id: t34.string,
      message_id: t34.string
    });
    CreateAnswerFeedbackPayloadV = t34.type({
      message_id: t34.number,
      rating: t34.number,
      user_properties_override: t34.union([t34.record(t34.string, t34.any), t34.undefined])
    });
    ChatV = t34.type({
      id: t34.string,
      answer: t34.union([t34.null, t34.number]),
      messages: t34.array(MessageV),
      created: t34.string,
      modified: t34.string,
      context: t34.any,
      organization: t34.number,
      end_user: t34.union([t34.null, t34.number, t34.string]),
      editor_tags: t34.array(t34.string),
      impersonate_mode: t34.boolean
    });
    CreateChatPayloadV = t34.type({
      organization: t34.union([t34.string, t34.number]),
      user: t34.union([t34.string, t34.null, t34.undefined]),
      impersonate_mode: t34.union([t34.null, t34.undefined, t34.boolean])
    });
    Chat = class {
    };
    Chat.get = readObject(ChatV, "ml/chats");
    Chat.update = updateObject(ChatV, ChatV, "ml/chats");
    Chat.list = listObject(ChatV, "ml/chats");
    Chat.create = async (payload) => {
      const result = await post(`ml/copilot/`, payload);
      return await decodeToPromise(
        t34.type({
          chat_id: t34.string
        }),
        result.data
      );
    };
    Chat.createAnswerFeedback = async (orgUID, payload) => {
      const result = await post(`ml/answers/${orgUID}/feedback`, payload);
      return await decodeToPromise(t34.union([t34.undefined, t34.null, t34.exact(AIAnswerV)]), result.data);
    };
    Chat.setTags = async (payload) => {
      const result = await put(`ml/chats/tags/`, payload);
      return await decodeToPromise(t34.array(t34.string), result.data);
    };
    Chat.generateAIAnswer = async (orgUID, payload, config2) => {
      const result = await post(`ml/answers/${orgUID}/live`, payload, {
        ...config2
      });
      return await decodeToPromise(t34.exact(AIAnswerV), result.data);
    };
    Chat.collectArgumentValues = async (orgUID, chat_id, command_id, user, query, attachments) => {
      const result = await post(`ml/answers/${orgUID}/arguments`, {
        command_id,
        chat_id,
        user,
        query,
        attachments
      });
      return await decodeToPromise(t34.exact(AIAnswerV), result.data);
    };
    Chat.generateQuestionSuggestions = async (orgUID, payload) => {
      const result = await post(`ml/question-suggestions/${orgUID}`, payload);
      return await decodeToPromise(t34.exact(QuestionSuggestionsV), result.data);
    };
    Chat.readMessage = async (chatId, messageId, signal) => {
      const result = await get2(`ml/chats/${chatId}/${messageId}`, { signal });
      return await decodeToPromise(MessageV, result.data);
    };
    Chat.abortAnswerGeneration = async (chatId, messageId) => {
      const response2 = await post(`ml/chats/${chatId}/${messageId}/abort`);
      return { success: response2.status === 200 };
    };
  }
});

// commandbar/src/products/helphub/store/actions.ts
var setHelpHubQuery, executeActionFromHH, setSearchSuggestions, setInitialPage, setFeedbackGiven, setHelpHubDoc, originalBodyStyles, lockBodyScroll, toggleHelpHubVisible, setHelpHubVisible, setHelpHubMinimized, setHelpHubRecommendationSets, setPreviewRecommendationSet;
var init_actions2 = __esm({
  "commandbar/src/products/helphub/store/actions.ts"() {
    "use strict";
    init_Reporting();
    init_helpers7();
    init_global_actions();
    init_selectors4();
    init_Logger();
    init_selectors4();
    init_location();
    init_chat();
    init_sentry();
    init_operatingSystem();
    init_helpdocService();
    init_LocalStorage();
    setHelpHubQuery = (_, query) => {
      _.helpHub.query = query;
    };
    executeActionFromHH = (_, navigate, action, e, type39 = "helphub_recommendation") => {
      const defaultAction = () => {
        executeAction(_, action, e, {}, { type: type39 }, (openedNewTab) => {
          if (!openedNewTab) {
            toggleHelpHubVisible(_);
          }
        });
      };
      const flags = _ == null ? void 0 : _.flags;
      if (action.type === "execute_command") {
        helpdocService_default.getHelpdocCommand(_, action.meta.command).then((command) => {
          if (command && (command.template.type === "helpdoc" || command.template.type === "video")) {
            if (((flags == null ? void 0 : flags["switch-open-help-doc-in-new-tab"]) || !!e && getTriggerKey(e)) && typeof command.template.value === "string" && command.template.value !== "") {
              window.open(command.template.value, "_blank");
            } else {
              navigate({ page: "docs", params: { docId: command.id } });
            }
          } else {
            defaultAction();
          }
        });
      } else if (action.type === "open_copilot") {
        navigate({ page: "start-chat", params: { initialQuery: action.query } });
      } else {
        defaultAction();
      }
    };
    setSearchSuggestions = (_, continuations) => {
      _.helpHub.searchSuggestions = { loading: false, continuations };
    };
    setInitialPage = (_, navigateTo) => {
      _.helpHub.initialPage = navigateTo;
    };
    setFeedbackGiven = async (_, aiAnswerValue, rating) => {
      var _a2;
      const { message_id, answer } = aiAnswerValue;
      if (!!message_id && !!_.organization) {
        _.helpHub.gaveFeedback[message_id.toString()] = rating;
        const payload = {
          message_id,
          rating,
          user_properties_override: _.helpHub.editorCopilotOverrides.userProperties
        };
        helpHubChatFeedback({ message_id, rating, message: answer });
        try {
          const response2 = await Chat.createAnswerFeedback(_.organization.id, payload);
          return response2;
        } catch (err) {
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
          Logger_default.warn(`AI feedback error: ${err}`);
        }
      }
    };
    setHelpHubDoc = (_, doc) => {
      _.helpHub.hubDoc = doc;
    };
    originalBodyStyles = { overflow: "" };
    lockBodyScroll = (_, lock) => {
      if (lock) {
        originalBodyStyles.overflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = originalBodyStyles.overflow || "";
      }
    };
    toggleHelpHubVisible = (_) => {
      if (_.helpHub.visible) {
        if (isStudioPreview() || isHelpHubMarketingSite)
          return;
        helpHubClosed({ query: _.helpHub.query });
      } else {
        helpHubOpened({ query: _.helpHub.query });
      }
      _.helpHub.visible = !_.helpHub.visible;
      if (isMobileDevice()) {
        lockBodyScroll(_, _.helpHub.visible);
      }
      setHelpHubQuery(_, "");
      if (!_.helpHub.visible) {
        removeDeepLinkParams();
        setHelpHubDoc(_, null);
        LocalStorage_default.set("copilot.open", false);
      }
    };
    setHelpHubVisible = (_, visible, config2) => {
      var _a2, _b2;
      if (!isHelpHubWidgetAvailable(_)) {
        if (visible && !(((_a2 = _.organization) == null ? void 0 : _a2.helphub_enabled) || ((_b2 = _.organization) == null ? void 0 : _b2.copilot_enabled)) && _.isAdmin) {
          Logger_default.warn(`HelpHub is not enabled. Go to https://app.commandbar.com/configure to turn it on.`);
        }
        return;
      }
      const wasVisible = _.helpHub.visible;
      const article = config2 == null ? void 0 : config2.article;
      if (article) {
        setHelpHubDoc(_, article);
      } else {
        setHelpHubDoc(_, null);
      }
      if (wasVisible === visible) {
        return;
      }
      if (visible && _.helpHub.minimized) {
        setHelpHubMinimized(_, false);
      }
      _.helpHub.visible = visible;
      if (config2 == null ? void 0 : config2.chatOnly) {
        _.helpHub.chatOnly = config2.chatOnly;
      } else {
        _.helpHub.chatOnly = false;
      }
      if (isMobileDevice()) {
        lockBodyScroll(_, _.helpHub.visible);
      }
      if (!wasVisible && visible) {
        _.helpHub.key += 1;
        helpHubOpened({ query: _.helpHub.query });
      } else if (wasVisible && !visible) {
        helpHubClosed({ query: _.helpHub.query });
      }
      if (isCopilotOnlyMode(_)) {
        helpHubEngagement({ query: _.helpHub.query }, "chat_started");
      }
      setHelpHubQuery(_, (config2 == null ? void 0 : config2.query) || "");
    };
    setHelpHubMinimized = (_, minimized) => {
      if (isStudioPreview() || isHelpHubMarketingSite) {
        return;
      }
      const wasMinimized = _.helpHub.minimized;
      _.helpHub.minimized = minimized;
      LocalStorage_default.set("copilot.minimized", minimized);
      if (!wasMinimized && minimized)
        helpHubMinimized({ query: _.helpHub.query });
      else if (wasMinimized && !minimized)
        helpHubUnminimized({ query: _.helpHub.query });
    };
    setHelpHubRecommendationSets = (_, recommendationSets) => {
      _.helpHub.recommendationSets = recommendationSets;
    };
    setPreviewRecommendationSet = (_, recommendationSet) => {
      _.helpHub.previewedRecommendationSet = recommendationSet;
    };
  }
});

// commandbar/src/shared/util/router.tsx
import React76, { useContext as useContext2, useRef as useRef3, useState as useState3 } from "react";
var useMemoryRouter, useRouter, useParams, RouterContext, ParamsContext, MemoryRouter, Routes;
var init_router = __esm({
  "commandbar/src/shared/util/router.tsx"() {
    "use strict";
    init_Logger();
    useMemoryRouter = (initialEntries, onNavigate) => {
      const [state, setState] = useState3({
        history: initialEntries.map((item, idx) => ({ ...item, id: idx })),
        nextId: initialEntries.length
      });
      const _initialEntries = useRef3(initialEntries);
      if (_initialEntries.current !== initialEntries) {
        Logger_default.warn("MemoryRouter: Changes to `initialEntries` after initial mount won't have any effect");
      }
      const navigate = (item, options) => {
        onNavigate == null ? void 0 : onNavigate(item);
        if (options == null ? void 0 : options.replace)
          pop();
        push(item);
      };
      const push = (item) => {
        setState(({ history, nextId }) => ({ history: [{ ...item, id: nextId }, ...history], nextId: nextId + 1 }));
      };
      const pop = () => {
        setState(({ history, ...rest }) => ({ history: history.slice(1), ...rest }));
      };
      return { history: state.history, navigate, back: pop };
    };
    useRouter = () => useContext2(RouterContext);
    useParams = () => useContext2(ParamsContext);
    RouterContext = React76.createContext(void 0);
    ParamsContext = React76.createContext(void 0);
    MemoryRouter = ({
      initialEntries,
      onNavigate,
      children
    }) => {
      const router = useMemoryRouter(initialEntries, onNavigate);
      return /* @__PURE__ */ React76.createElement(React76.Fragment, null, /* @__PURE__ */ React76.createElement(RouterContext.Provider, { value: router }, children));
    };
    Routes = ({ pages }) => {
      const { history } = useContext2(RouterContext);
      const renderedPages = history.map((item, idx) => {
        const p = pages.find((page) => item.page === page.page);
        if (!p)
          return null;
        const Element2 = p.element;
        return /* @__PURE__ */ React76.createElement("div", { key: item.id, style: idx === 0 ? { height: "100%", width: "100%" } : { display: "none" } }, /* @__PURE__ */ React76.createElement(ParamsContext.Provider, { value: item.params }, /* @__PURE__ */ React76.createElement(Element2, null)));
      });
      return /* @__PURE__ */ React76.createElement(React76.Fragment, null, renderedPages);
    };
  }
});

// commandbar/src/shared/components/LoadingIndicator.tsx
import { css, jsx as jsx3, keyframes } from "@emotion/core";
import { useTheme as useTheme2 } from "emotion-theming";
var rotate, LoadingIndicator, LoadingIndicator_default;
var init_LoadingIndicator = __esm({
  "commandbar/src/shared/components/LoadingIndicator.tsx"() {
    "use strict";
    init_chroma();
    rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`;
    LoadingIndicator = (props2) => {
      const { theme } = useTheme2();
      if (!props2.isLoading) {
        return null;
      } else {
        return /* @__PURE__ */ jsx3(
          "div",
          {
            "data-testid": "commandbar-loader",
            className: "commandbar-loader",
            key: "commandbar-loader",
            css: css`
          position: relative;
          border-width: 2px;
          border-style: solid;
          border-color: ${getChromaColor(theme.base.fontColor).alpha(0.2).css()};
          border-top-color: ${theme.base.fontColor};
          height: ${props2.size - 2}px;
          width: ${props2.size - 2}px;
          content: '';
          box-sizing: border-box;
          border-radius: 50%;
          animation: ${rotate} 0.6s linear infinite;
        `,
            style: { ...props2.style }
          }
        );
      }
    };
    LoadingIndicator_default = LoadingIndicator;
  }
});

// node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
var init_typeof = __esm({
  "node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/typeof.js"() {
  }
});

// node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var init_toPrimitive = __esm({
  "node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/toPrimitive.js"() {
    init_typeof();
  }
});

// node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
var init_toPropertyKey = __esm({
  "node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"() {
    init_typeof();
    init_toPrimitive();
  }
});

// node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var init_defineProperty = __esm({
  "node_modules/@emotion/styled-base/node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    init_toPropertyKey();
  }
});

// node_modules/@emotion/memoize/dist/memoize.browser.esm.js
function memoize(fn) {
  var cache = {};
  return function(arg) {
    if (cache[arg] === void 0)
      cache[arg] = fn(arg);
    return cache[arg];
  };
}
var memoize_browser_esm_default;
var init_memoize_browser_esm = __esm({
  "node_modules/@emotion/memoize/dist/memoize.browser.esm.js"() {
    memoize_browser_esm_default = memoize;
  }
});

// node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js
var reactPropsRegex, index, is_prop_valid_browser_esm_default;
var init_is_prop_valid_browser_esm = __esm({
  "node_modules/@emotion/is-prop-valid/dist/is-prop-valid.browser.esm.js"() {
    init_memoize_browser_esm();
    reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/;
    index = memoize_browser_esm_default(
      function(prop) {
        return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
      }
      /* Z+1 */
    );
    is_prop_valid_browser_esm_default = index;
  }
});

// node_modules/@emotion/utils/dist/utils.browser.esm.js
function getRegisteredStyles(registered, registeredStyles, classNames7) {
  var rawClassName = "";
  classNames7.split(" ").forEach(function(className) {
    if (registered[className] !== void 0) {
      registeredStyles.push(registered[className]);
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var isBrowser, insertStyles;
var init_utils_browser_esm = __esm({
  "node_modules/@emotion/utils/dist/utils.browser.esm.js"() {
    isBrowser = true;
    insertStyles = function insertStyles2(cache, serialized, isStringTag) {
      var className = cache.key + "-" + serialized.name;
      if (
        // we only need to add the styles to the registered cache if the
        // class name could be used further down
        // the tree but if it's a string tag, we know it won't
        // so we don't have to add it to registered cache.
        // this improves memory usage since we can avoid storing the whole style string
        (isStringTag === false || // we need to always store it if we're in compat mode and
        // in node since emotion-server relies on whether a style is in
        // the registered cache to know whether a style is global or not
        // also, note that this check will be dead code eliminated in the browser
        isBrowser === false && cache.compat !== void 0) && cache.registered[className] === void 0
      ) {
        cache.registered[className] = serialized.styles;
      }
      if (cache.inserted[serialized.name] === void 0) {
        var current = serialized;
        do {
          var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
          current = current.next;
        } while (current !== void 0);
      }
    };
  }
});

// node_modules/@emotion/hash/dist/hash.browser.esm.js
function murmur2(str) {
  var h = 0;
  var k, i2 = 0, len = str.length;
  for (; len >= 4; ++i2, len -= 4) {
    k = str.charCodeAt(i2) & 255 | (str.charCodeAt(++i2) & 255) << 8 | (str.charCodeAt(++i2) & 255) << 16 | (str.charCodeAt(++i2) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i2 + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i2 + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i2) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var hash_browser_esm_default;
var init_hash_browser_esm = __esm({
  "node_modules/@emotion/hash/dist/hash.browser.esm.js"() {
    hash_browser_esm_default = murmur2;
  }
});

// node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys, unitless_browser_esm_default;
var init_unitless_browser_esm = __esm({
  "node_modules/@emotion/unitless/dist/unitless.browser.esm.js"() {
    unitlessKeys = {
      animationIterationCount: 1,
      borderImageOutset: 1,
      borderImageSlice: 1,
      borderImageWidth: 1,
      boxFlex: 1,
      boxFlexGroup: 1,
      boxOrdinalGroup: 1,
      columnCount: 1,
      columns: 1,
      flex: 1,
      flexGrow: 1,
      flexPositive: 1,
      flexShrink: 1,
      flexNegative: 1,
      flexOrder: 1,
      gridRow: 1,
      gridRowEnd: 1,
      gridRowSpan: 1,
      gridRowStart: 1,
      gridColumn: 1,
      gridColumnEnd: 1,
      gridColumnSpan: 1,
      gridColumnStart: 1,
      msGridRow: 1,
      msGridRowSpan: 1,
      msGridColumn: 1,
      msGridColumnSpan: 1,
      fontWeight: 1,
      lineHeight: 1,
      opacity: 1,
      order: 1,
      orphans: 1,
      tabSize: 1,
      widows: 1,
      zIndex: 1,
      zoom: 1,
      WebkitLineClamp: 1,
      // SVG-related properties
      fillOpacity: 1,
      floodOpacity: 1,
      stopOpacity: 1,
      strokeDasharray: 1,
      strokeDashoffset: 1,
      strokeMiterlimit: 1,
      strokeOpacity: 1,
      strokeWidth: 1
    };
    unitless_browser_esm_default = unitlessKeys;
  }
});

// node_modules/@emotion/serialize/dist/serialize.browser.esm.js
function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
  if (interpolation == null) {
    return "";
  }
  if (interpolation.__emotion_styles !== void 0) {
    if (false) {
      throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
    }
    return interpolation;
  }
  switch (typeof interpolation) {
    case "boolean": {
      return "";
    }
    case "object": {
      if (interpolation.anim === 1) {
        cursor = {
          name: interpolation.name,
          styles: interpolation.styles,
          next: cursor
        };
        return interpolation.name;
      }
      if (interpolation.styles !== void 0) {
        var next = interpolation.next;
        if (next !== void 0) {
          while (next !== void 0) {
            cursor = {
              name: next.name,
              styles: next.styles,
              next: cursor
            };
            next = next.next;
          }
        }
        var styles51 = interpolation.styles + ";";
        if (false) {
          styles51 += interpolation.map;
        }
        return styles51;
      }
      return createStringFromObject(mergedProps, registered, interpolation);
    }
    case "function": {
      if (mergedProps !== void 0) {
        var previousCursor = cursor;
        var result = interpolation(mergedProps);
        cursor = previousCursor;
        return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
      } else if (false) {
        console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      }
      break;
    }
    case "string":
      if (false) {
        var matched = [];
        var replaced = interpolation.replace(animationRegex, function(match2, p1, p2) {
          var fakeVarName = "animation" + matched.length;
          matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, "") + "`");
          return "${" + fakeVarName + "}";
        });
        if (matched.length) {
          console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(matched, ["`" + replaced + "`"]).join("\n") + "\n\nYou should wrap it with `css` like this:\n\n" + ("css`" + replaced + "`"));
        }
      }
      break;
  }
  if (registered == null) {
    return interpolation;
  }
  var cached2 = registered[interpolation];
  if (false) {
    console.error("Interpolating a className from css`` is not recommended and will cause problems with composition.\nInterpolating a className from css`` will be completely unsupported in a future major version of Emotion");
    shouldWarnAboutInterpolatingClassNameFromCss = false;
  }
  return cached2 !== void 0 && !couldBeSelectorInterpolation ? cached2 : interpolation;
}
function createStringFromObject(mergedProps, registered, obj) {
  var string38 = "";
  if (Array.isArray(obj)) {
    for (var i2 = 0; i2 < obj.length; i2++) {
      string38 += handleInterpolation(mergedProps, registered, obj[i2], false);
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];
      if (typeof value !== "object") {
        if (registered != null && registered[value] !== void 0) {
          string38 += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string38 += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === "NO_COMPONENT_SELECTOR" && false) {
          throw new Error("Component selectors can only be used in conjunction with babel-plugin-emotion.");
        }
        if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === void 0)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string38 += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value, false);
          switch (_key) {
            case "animation":
            case "animationName": {
              string38 += processStyleName(_key) + ":" + interpolated + ";";
              break;
            }
            default: {
              if (false) {
                console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
              }
              string38 += _key + "{" + interpolated + "}";
            }
          }
        }
      }
    }
  }
  return string38;
}
var hyphenateRegex, animationRegex, isCustomProperty, isProcessableValue, processStyleName, processStyleValue, contentValuePattern, contentValues, oldProcessStyleValue, msPattern, hyphenPattern, hyphenatedCache, labelPattern, cursor, serializeStyles;
var init_serialize_browser_esm = __esm({
  "node_modules/@emotion/serialize/dist/serialize.browser.esm.js"() {
    init_hash_browser_esm();
    init_unitless_browser_esm();
    init_memoize_browser_esm();
    hyphenateRegex = /[A-Z]|^ms/g;
    animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
    isCustomProperty = function isCustomProperty2(property) {
      return property.charCodeAt(1) === 45;
    };
    isProcessableValue = function isProcessableValue2(value) {
      return value != null && typeof value !== "boolean";
    };
    processStyleName = memoize_browser_esm_default(function(styleName) {
      return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, "-$&").toLowerCase();
    });
    processStyleValue = function processStyleValue2(key, value) {
      switch (key) {
        case "animation":
        case "animationName": {
          if (typeof value === "string") {
            return value.replace(animationRegex, function(match2, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
      }
      if (unitless_browser_esm_default[key] !== 1 && !isCustomProperty(key) && typeof value === "number" && value !== 0) {
        return value + "px";
      }
      return value;
    };
    if (false) {
      contentValuePattern = /(attr|calc|counters?|url)\(/;
      contentValues = ["normal", "none", "counter", "open-quote", "close-quote", "no-open-quote", "no-close-quote", "initial", "inherit", "unset"];
      oldProcessStyleValue = processStyleValue;
      msPattern = /^-ms-/;
      hyphenPattern = /-(.)/g;
      hyphenatedCache = {};
      processStyleValue = function processStyleValue3(key, value) {
        if (key === "content") {
          if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
            console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
          }
        }
        var processed = oldProcessStyleValue(key, value);
        if (processed !== "" && !isCustomProperty(key) && key.indexOf("-") !== -1 && hyphenatedCache[key] === void 0) {
          hyphenatedCache[key] = true;
          console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, "ms-").replace(hyphenPattern, function(str, _char) {
            return _char.toUpperCase();
          }) + "?");
        }
        return processed;
      };
    }
    labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
    if (false) {
      sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
    }
    serializeStyles = function serializeStyles2(args, registered, mergedProps) {
      if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== void 0) {
        return args[0];
      }
      var stringMode = true;
      var styles51 = "";
      cursor = void 0;
      var strings = args[0];
      if (strings == null || strings.raw === void 0) {
        stringMode = false;
        styles51 += handleInterpolation(mergedProps, registered, strings, false);
      } else {
        if (false) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }
        styles51 += strings[0];
      }
      for (var i2 = 1; i2 < args.length; i2++) {
        styles51 += handleInterpolation(mergedProps, registered, args[i2], styles51.charCodeAt(styles51.length - 1) === 46);
        if (stringMode) {
          if (false) {
            console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
          }
          styles51 += strings[i2];
        }
      }
      var sourceMap;
      if (false) {
        styles51 = styles51.replace(sourceMapPattern, function(match3) {
          sourceMap = match3;
          return "";
        });
      }
      labelPattern.lastIndex = 0;
      var identifierName = "";
      var match2;
      while ((match2 = labelPattern.exec(styles51)) !== null) {
        identifierName += "-" + // $FlowFixMe we know it's not null
        match2[1];
      }
      var name = hash_browser_esm_default(styles51) + identifierName;
      if (false) {
        return {
          name,
          styles: styles51,
          map: sourceMap,
          next: cursor,
          toString: function toString3() {
            return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
          }
        };
      }
      return {
        name,
        styles: styles51,
        next: cursor
      };
    };
  }
});

// node_modules/@emotion/styled-base/dist/styled-base.browser.esm.js
import { createElement as createElement66, Fragment } from "react";
import { withEmotionCache, ThemeContext as ThemeContext2 } from "@emotion/core";
function ownKeys(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly)
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i2 = 1; i2 < arguments.length; i2++) {
    var source = arguments[i2] != null ? arguments[i2] : {};
    if (i2 % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var testOmitPropsOnStringTag, testOmitPropsOnComponent, getDefaultShouldForwardProp, Noop, createStyled, styled_base_browser_esm_default;
var init_styled_base_browser_esm = __esm({
  "node_modules/@emotion/styled-base/dist/styled-base.browser.esm.js"() {
    init_defineProperty();
    init_is_prop_valid_browser_esm();
    init_utils_browser_esm();
    init_serialize_browser_esm();
    testOmitPropsOnStringTag = is_prop_valid_browser_esm_default;
    testOmitPropsOnComponent = function testOmitPropsOnComponent2(key) {
      return key !== "theme" && key !== "innerRef";
    };
    getDefaultShouldForwardProp = function getDefaultShouldForwardProp2(tag) {
      return typeof tag === "string" && // 96 is one less than the char code
      // for "a" so this is checking that
      // it's a lowercase character
      tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
    };
    Noop = function Noop2() {
      return null;
    };
    createStyled = function createStyled2(tag, options) {
      if (false) {
        if (tag === void 0) {
          throw new Error("You are trying to create a styled element with an undefined component.\nYou may have forgotten to import it.");
        }
      }
      var identifierName;
      var shouldForwardProp;
      var targetClassName;
      if (options !== void 0) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
          return tag.__emotion_forwardProp(propName) && // $FlowFixMe
          options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
      }
      var isReal = tag.__emotion_real === tag;
      var baseTag = isReal && tag.__emotion_base || tag;
      if (typeof shouldForwardProp !== "function" && isReal) {
        shouldForwardProp = tag.__emotion_forwardProp;
      }
      var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
      var shouldUseAs = !defaultShouldForwardProp("as");
      return function() {
        var args = arguments;
        var styles51 = isReal && tag.__emotion_styles !== void 0 ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== void 0) {
          styles51.push("label:" + identifierName + ";");
        }
        if (args[0] == null || args[0].raw === void 0) {
          styles51.push.apply(styles51, args);
        } else {
          if (false) {
            console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
          }
          styles51.push(args[0][0]);
          var len = args.length;
          var i2 = 1;
          for (; i2 < len; i2++) {
            if (false) {
              console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
            }
            styles51.push(args[i2], args[0][i2]);
          }
        }
        var Styled = withEmotionCache(function(props2, context, ref12) {
          return /* @__PURE__ */ createElement66(ThemeContext2.Consumer, null, function(theme) {
            var finalTag = shouldUseAs && props2.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props2;
            if (props2.theme == null) {
              mergedProps = {};
              for (var key in props2) {
                mergedProps[key] = props2[key];
              }
              mergedProps.theme = theme;
            }
            if (typeof props2.className === "string") {
              className = getRegisteredStyles(context.registered, classInterpolations, props2.className);
            } else if (props2.className != null) {
              className = props2.className + " ";
            }
            var serialized = serializeStyles(styles51.concat(classInterpolations), context.registered, mergedProps);
            var rules = insertStyles(context, serialized, typeof finalTag === "string");
            className += context.key + "-" + serialized.name;
            if (targetClassName !== void 0) {
              className += " " + targetClassName;
            }
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === void 0 ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
            var newProps = {};
            for (var _key in props2) {
              if (shouldUseAs && _key === "as")
                continue;
              if (
                // $FlowFixMe
                finalShouldForwardProp(_key)
              ) {
                newProps[_key] = props2[_key];
              }
            }
            newProps.className = className;
            newProps.ref = ref12 || props2.innerRef;
            if (false) {
              console.error("`innerRef` is deprecated and will be removed in a future major version of Emotion, please use the `ref` prop instead" + (identifierName === void 0 ? "" : " in the usage of `" + identifierName + "`"));
            }
            var ele = /* @__PURE__ */ createElement66(finalTag, newProps);
            var possiblyStyleElement = /* @__PURE__ */ createElement66(Noop, null);
            return /* @__PURE__ */ createElement66(Fragment, null, possiblyStyleElement, ele);
          });
        });
        Styled.displayName = identifierName !== void 0 ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles51;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
          value: function value() {
            if (targetClassName === void 0 && false) {
              return "NO_COMPONENT_SELECTOR";
            }
            return "." + targetClassName;
          }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
          return createStyled2(nextTag, nextOptions !== void 0 ? _objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles51);
        };
        return Styled;
      };
    };
    styled_base_browser_esm_default = createStyled;
  }
});

// node_modules/@emotion/styled/dist/styled.browser.esm.js
var tags, newStyled, styled_browser_esm_default;
var init_styled_browser_esm = __esm({
  "node_modules/@emotion/styled/dist/styled.browser.esm.js"() {
    init_styled_base_browser_esm();
    tags = [
      "a",
      "abbr",
      "address",
      "area",
      "article",
      "aside",
      "audio",
      "b",
      "base",
      "bdi",
      "bdo",
      "big",
      "blockquote",
      "body",
      "br",
      "button",
      "canvas",
      "caption",
      "cite",
      "code",
      "col",
      "colgroup",
      "data",
      "datalist",
      "dd",
      "del",
      "details",
      "dfn",
      "dialog",
      "div",
      "dl",
      "dt",
      "em",
      "embed",
      "fieldset",
      "figcaption",
      "figure",
      "footer",
      "form",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "head",
      "header",
      "hgroup",
      "hr",
      "html",
      "i",
      "iframe",
      "img",
      "input",
      "ins",
      "kbd",
      "keygen",
      "label",
      "legend",
      "li",
      "link",
      "main",
      "map",
      "mark",
      "marquee",
      "menu",
      "menuitem",
      "meta",
      "meter",
      "nav",
      "noscript",
      "object",
      "ol",
      "optgroup",
      "option",
      "output",
      "p",
      "param",
      "picture",
      "pre",
      "progress",
      "q",
      "rp",
      "rt",
      "ruby",
      "s",
      "samp",
      "script",
      "section",
      "select",
      "small",
      "source",
      "span",
      "strong",
      "style",
      "sub",
      "summary",
      "sup",
      "table",
      "tbody",
      "td",
      "textarea",
      "tfoot",
      "th",
      "thead",
      "time",
      "title",
      "tr",
      "track",
      "u",
      "ul",
      "var",
      "video",
      "wbr",
      // SVG
      "circle",
      "clipPath",
      "defs",
      "ellipse",
      "foreignObject",
      "g",
      "image",
      "line",
      "linearGradient",
      "mask",
      "path",
      "pattern",
      "polygon",
      "polyline",
      "radialGradient",
      "rect",
      "stop",
      "svg",
      "text",
      "tspan"
    ];
    newStyled = styled_base_browser_esm_default.bind();
    tags.forEach(function(tagName2) {
      newStyled[tagName2] = newStyled(tagName2);
    });
    styled_browser_esm_default = newStyled;
  }
});

// commandbar/src/products/nudges/components/Arrow.tsx
import { jsx as jsx4 } from "@emotion/core";
var Container, Arrow, Arrow_default;
var init_Arrow = __esm({
  "commandbar/src/products/nudges/components/Arrow.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container = styled_browser_esm_default.span`
  position: absolute;
  background-color: var(--background-primary);
  border: 1px solid var(--border-primary);
  border-radius: 3px;
  transform: rotate(45deg);

  &.pin-arrow {
    width: 32px;
    height: 32px;

    &-top,
    &-top-start,
    &-top-end {
      left: -1px;
      bottom: -3px;
      top: unset;
      transform: skew(0deg, -36deg);
    }

    &-bottom,
    &-bottom-start,
    &-bottom-end {
      left: -1px;
      top: -3px;
      transform: skew(0deg, 36deg);
    }

    &-left,
    &-left-start,
    &-left-end {
      top: -1px;
      left: unset;
      right: -3px;
      transform: skew(-36deg, 0deg) rotate(0deg);
    }

    &-right,
    &-right-start,
    &-right-end {
      top: -1px;
      left: -3px;
      transform: skew(36deg, 0deg) rotate(0deg);
    }

    // Default
    top: -3px;
    left: -1px;
    transform: skew(0deg, 36deg);
  }

  &.tooltip-arrow {
    width: 24px;
    height: 24px;
    left: 0;
    right: 0;
    top: -8px;
    margin: 0 auto;
  }
`;
    Arrow = (props2) => {
      const { containerStyles: containerStyles4, type: type39 } = props2;
      return /* @__PURE__ */ jsx4(Container, { className: `commandbar-nudge-arrow ${type39}-arrow`, style: containerStyles4 });
    };
    Arrow_default = Arrow;
  }
});

// internal/src/client/themesV2/components/shared/StyledTooltip.tsx
import React77 from "react";
import { jsx as jsx5 } from "@emotion/core";
var styles, containerStyles, surveyStyles, keywordStyles, Tooltip2, Container2, StyledTooltip, StyledTooltip_default;
var init_StyledTooltip = __esm({
  "internal/src/client/themesV2/components/shared/StyledTooltip.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    init_Arrow();
    styles = {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background: "var(--background-primary)",
      width: "100%",
      borderRadius: "inherit",
      a: {
        color: "var(--content-link)",
        textDecoration: "none",
        "&:hover": {
          color: "var(--content-link-hover)",
          textDecoration: "underline"
        }
      }
    };
    containerStyles = {
      position: "relative",
      width: "var(--popover-width)",
      maxWidth: "var(--tooltip-max-width)",
      borderRadius: "var(--layout-radius-card)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--border-primary)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)",
      pointerEvents: "all"
    };
    surveyStyles = {
      minWidth: "var(--popover-width)",
      width: "unset",
      maxWidth: "unset"
    };
    keywordStyles = {
      width: "unset"
    };
    Tooltip2 = styled_browser_esm_default.div`
  z-index: ${Z_default.Z_NUDGE};
`;
    Container2 = styled_browser_esm_default.div``;
    StyledTooltip = React77.forwardRef(
      ({ children, title, arrow: arrow3, variant, themeV2, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx5(
          Container2,
          {
            ref: ref12,
            css: [
              containerStyles,
              variant === "survey" && surveyStyles,
              variant === "keyword" && keywordStyles,
              { margin: `${arrow3 ? "12px 0px" : "unset"}` }
            ].filter(Boolean),
            ...props2
          },
          /* @__PURE__ */ jsx5(Arrow_default, { type: "tooltip", containerStyles: { display: `${arrow3 ? "inline-block" : "none"}` } }),
          /* @__PURE__ */ jsx5(Tooltip2, { css: styles }, children)
        );
      }
    );
    StyledTooltip_default = StyledTooltip;
  }
});

// internal/src/client/themesV2/components/keyword/StyledKeyword.tsx
import React78 from "react";
var Keyword, StyledKeyword, StyledKeyword_default;
var init_StyledKeyword = __esm({
  "internal/src/client/themesV2/components/keyword/StyledKeyword.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Keyword = styled_browser_esm_default.span`
  border-radius: 2px;
  border-width: 1px;
  border-style: solid;
  background: rgb(from var(--button-primary-background) r g b / .10);
  border-color: rgb(from var(--button-primary-border-color) r g b / .10);
  cursor: default;

  &:hover {
    color: var(--content-primary);
    border: 1px solid var(--border-primary-hover);
    background: rgb(from var(--button-primary-background-hover)) r g b / .10);
    border-color: rgb(from var(--button-primary-border-color-hover) r g b / .10);
  }

  &:focus {
    background: rgb(from var(--button-primary-background-hover)) r g b / .10);
    border-color: rgb(from var(--button-primary-border-color-hover) r g b / .10);
    color: var(--content-primary);
    border: 1px solid var(--border-primary-hover);
    box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
  }
`;
    StyledKeyword = React78.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React78.createElement(Keyword, { ref: ref12, ...props2 }, children);
      }
    );
    StyledKeyword_default = StyledKeyword;
  }
});

// internal/src/client/markdown.ts
import snarkdown from "@bpmn-io/snarkdown";
var NEW_LINE_PATTERN, toHtml;
var init_markdown = __esm({
  "internal/src/client/markdown.ts"() {
    "use strict";
    NEW_LINE_PATTERN = /(?:\r?\n){2,}/;
    toHtml = (markdown) => markdown.split(NEW_LINE_PATTERN).map(
      (line) => [" ", "	", "#", "-", "*", ">"].some((char) => line.startsWith(char) || line === "<br>") ? snarkdown(line) : `<p>${snarkdown(line)}</p>`
    ).join("\n");
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeTitleBlock.tsx
import React79 from "react";
var NudgeTitleBlock, NudgeTitle, NudgeContent, parseMarkdown, StyledNudgeTitleBlock, StyledNudgeTitleBlock_default;
var init_StyledNudgeTitleBlock = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeTitleBlock.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_sanitizeHtml();
    init_markdown();
    init_location();
    NudgeTitleBlock = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  padding: var(--layout-padding);
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  gap: 2px;
`;
    NudgeTitle = styled_browser_esm_default.div`
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  color: var(--content-primary);

  /* label/lg/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-snug);
`;
    NudgeContent = styled_browser_esm_default.div`
  align-self: stretch;
  color: var(--content-secondary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  p,
  span,
  li,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: inherit;
    font-family: inherit;
    margin-bottom: 8px;
  }

  p:last-child,
  span:last-child,
  li:last-child {
    margin-bottom: 0;
  }

  ol,
  ul,
  li {
    all: revert;
  }

  ol,
  ul {
    padding-left: 32px;
    margin-bottom: 8px;
  }

  img {
    max-width: 100%;
  }

  pre {
    overflow: auto;
  }

  ${isStudioPreview() && `
    h1, h2, h3, h4, h5, h6 {
      display: block;
      margin-block-start: 1.33em;
      margin-block-end: 1.33em;
      margin-inline-start: 0px;
      margin-inline-end: 0px;
      font-weight: bold;
      unicode-bidi: isolate;
    }
  `}
`;
    parseMarkdown = (str) => {
      const parsed = toHtml(str).replace(/(<a href="(https?:)?\/\/.*?")>/g, '$1 target="_blank" rel="nofollow">');
      return sanitizeHtml_default(parsed);
    };
    StyledNudgeTitleBlock = ({
      title,
      content,
      dismissible,
      draggable,
      handleContentLinkClick
    }) => {
      return /* @__PURE__ */ React79.createElement(NudgeTitleBlock, null, (title || title === "") && /* @__PURE__ */ React79.createElement(
        NudgeTitle,
        {
          style: {
            marginRight: dismissible ? "calc(var(--layout-padding) + 20px)" : "0px",
            minHeight: dismissible ? "20px" : "0px",
            position: "relative"
          }
        },
        draggable && /* @__PURE__ */ React79.createElement(
          "div",
          {
            "data-draggable": "drag-zone",
            "data-testid": "drag-zone",
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              userSelect: "none",
              cursor: "move"
            }
          }
        ),
        title
      ), content && /* @__PURE__ */ React79.createElement(NudgeContent, { dangerouslySetInnerHTML: { __html: parseMarkdown(content) }, onClick: handleContentLinkClick }));
    };
    StyledNudgeTitleBlock_default = StyledNudgeTitleBlock;
  }
});

// commandbar/src/shared/components/keywords/KeywordTooltip.tsx
import React80, { useState as useState4, useRef as useRef4, useEffect as useEffect5 } from "react";
import ReactDOM from "react-dom";
var KeywordTooltip;
var init_KeywordTooltip = __esm({
  "commandbar/src/shared/components/keywords/KeywordTooltip.tsx"() {
    "use strict";
    init_StyledTooltip();
    init_StyledKeyword();
    init_Z();
    init_StyledNudgeTitleBlock();
    KeywordTooltip = (props2) => {
      const [visible, setVisible2] = useState4(false);
      const [tooltipPosition, setTooltipPosition] = useState4({
        top: 0,
        left: 0,
        valid: false
      });
      const tooltipRef = useRef4(null);
      const targetRef = useRef4(null);
      const popupContainer = React80.useMemo(() => {
        var _a2;
        return (_a2 = document.getElementById("commandbar-themeV2-root")) != null ? _a2 : null;
      }, []);
      useEffect5(() => {
        if (visible && targetRef.current && tooltipRef.current) {
          const targetRect = targetRef.current.getBoundingClientRect();
          const tooltipRect = tooltipRef.current.getBoundingClientRect();
          setTooltipPosition({
            top: targetRect.top + window.scrollY - tooltipRect.height - 4,
            left: targetRect.left + window.scrollX + targetRect.width / 2 - tooltipRect.width / 2,
            valid: true
          });
        }
      }, [visible]);
      if (!popupContainer || !props2.content) {
        return /* @__PURE__ */ React80.createElement(React80.Fragment, null, props2.children);
      }
      return /* @__PURE__ */ React80.createElement(React80.Fragment, null, /* @__PURE__ */ React80.createElement(StyledKeyword_default, { ref: targetRef, onMouseEnter: () => setVisible2(true), onMouseLeave: () => setVisible2(false) }, props2.children), visible && targetRef.current && ReactDOM.createPortal(
        /* @__PURE__ */ React80.createElement(
          StyledTooltip_default,
          {
            ref: tooltipRef,
            style: {
              position: "absolute",
              top: tooltipPosition.top,
              left: tooltipPosition.left,
              zIndex: Z_default.Z_TOOLTIPS,
              visibility: tooltipPosition.valid ? "visible" : "hidden"
            },
            themeV2: props2.themeV2,
            variant: "keyword",
            className: "commandbar-keyword-tooltip"
          },
          /* @__PURE__ */ React80.createElement(StyledNudgeTitleBlock_default, { content: props2.content, dismissible: true })
        ),
        popupContainer
      ));
    };
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var init_extends = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/extends.js"() {
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
var init_arrayWithHoles = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js"() {
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t44 = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t44) {
    var e, n, i2, u, a = [], f = true, o = false;
    try {
      if (i2 = (t44 = t44.call(r)).next, 0 === l) {
        if (Object(t44) !== t44)
          return;
        f = false;
      } else
        for (; !(f = (e = i2.call(t44)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t44["return"] && (u = t44["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
var init_iterableToArrayLimit = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js"() {
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
var init_arrayLikeToArray = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js"() {
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
var init_unsupportedIterableToArray = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js"() {
    init_arrayLikeToArray();
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var init_nonIterableRest = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js"() {
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function _slicedToArray(arr, i2) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i2) || _unsupportedIterableToArray(arr, i2) || _nonIterableRest();
}
var init_slicedToArray = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"() {
    init_arrayWithHoles();
    init_iterableToArrayLimit();
    init_unsupportedIterableToArray();
    init_nonIterableRest();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var init_classCallCheck = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof2(o) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof2(o);
}
var init_typeof2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/typeof.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function _toPrimitive2(input, hint) {
  if (_typeof2(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof2(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var init_toPrimitive2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/toPrimitive.js"() {
    init_typeof2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function _toPropertyKey2(arg) {
  var key = _toPrimitive2(arg, "string");
  return _typeof2(key) === "symbol" ? key : String(key);
}
var init_toPropertyKey2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"() {
    init_typeof2();
    init_toPrimitive2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey2(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
var init_createClass = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/createClass.js"() {
    init_toPropertyKey2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf4(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
var init_setPrototypeOf = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
var init_inherits = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/inherits.js"() {
    init_setPrototypeOf();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var init_getPrototypeOf = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var init_isNativeReflectConstruct = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
var init_assertThisInitialized = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof2(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
var init_possibleConstructorReturn = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js"() {
    init_typeof2();
    init_assertThisInitialized();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
var init_createSuper = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/createSuper.js"() {
    init_getPrototypeOf();
    init_isNativeReflectConstruct();
    init_possibleConstructorReturn();
  }
});

// node_modules/rc-util/es/raf.js
function cleanup(id2) {
  rafIds.delete(id2);
}
function wrapperRaf(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id2 = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id2);
      callback();
    } else {
      var realId = raf(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id2, realId);
    }
  }
  callRef(times);
  return id2;
}
var raf, caf, rafUUID, rafIds;
var init_raf = __esm({
  "node_modules/rc-util/es/raf.js"() {
    raf = function raf2(callback) {
      return +setTimeout(callback, 16);
    };
    caf = function caf2(num) {
      return clearTimeout(num);
    };
    if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
      raf = function raf3(callback) {
        return window.requestAnimationFrame(callback);
      };
      caf = function caf3(handle) {
        return window.cancelAnimationFrame(handle);
      };
    }
    rafUUID = 0;
    rafIds = /* @__PURE__ */ new Map();
    wrapperRaf.cancel = function(id2) {
      var realId = rafIds.get(id2);
      cleanup(realId);
      return caf(realId);
    };
  }
});

// node_modules/rc-util/es/Dom/canUseDom.js
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}
var init_canUseDom = __esm({
  "node_modules/rc-util/es/Dom/canUseDom.js"() {
  }
});

// node_modules/rc-util/es/Portal.js
import { useRef as useRef5, useEffect as useEffect6, forwardRef, useImperativeHandle } from "react";
import ReactDOM2 from "react-dom";
var Portal, Portal_default;
var init_Portal = __esm({
  "node_modules/rc-util/es/Portal.js"() {
    init_canUseDom();
    Portal = /* @__PURE__ */ forwardRef(function(props2, ref12) {
      var didUpdate = props2.didUpdate, getContainer = props2.getContainer, children = props2.children;
      var parentRef = useRef5();
      var containerRef = useRef5();
      useImperativeHandle(ref12, function() {
        return {};
      });
      var initRef = useRef5(false);
      if (!initRef.current && canUseDom()) {
        containerRef.current = getContainer();
        parentRef.current = containerRef.current.parentNode;
        initRef.current = true;
      }
      useEffect6(function() {
        didUpdate === null || didUpdate === void 0 ? void 0 : didUpdate(props2);
      });
      useEffect6(function() {
        if (containerRef.current.parentNode === null && parentRef.current !== null) {
          parentRef.current.appendChild(containerRef.current);
        }
        return function() {
          var _containerRef$current, _containerRef$current2;
          (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.parentNode) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.removeChild(containerRef.current);
        };
      }, []);
      return containerRef.current ? /* @__PURE__ */ ReactDOM2.createPortal(children, containerRef.current) : null;
    });
    Portal_default = Portal;
  }
});

// node_modules/rc-util/es/getScrollBarSize.js
function getScrollBarSize(fresh) {
  if (typeof document === "undefined") {
    return 0;
  }
  if (fresh || cached === void 0) {
    var inner = document.createElement("div");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    var outerStyle = outer.style;
    outerStyle.position = "absolute";
    outerStyle.top = "0";
    outerStyle.left = "0";
    outerStyle.pointerEvents = "none";
    outerStyle.visibility = "hidden";
    outerStyle.width = "200px";
    outerStyle.height = "150px";
    outerStyle.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
var cached;
var init_getScrollBarSize = __esm({
  "node_modules/rc-util/es/getScrollBarSize.js"() {
  }
});

// node_modules/rc-util/es/setStyle.js
function setStyle(style3) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!style3) {
    return {};
  }
  var _options$element = options.element, element = _options$element === void 0 ? document.body : _options$element;
  var oldStyle = {};
  var styleKeys = Object.keys(style3);
  styleKeys.forEach(function(key) {
    oldStyle[key] = element.style[key];
  });
  styleKeys.forEach(function(key) {
    element.style[key] = style3[key];
  });
  return oldStyle;
}
var setStyle_default;
var init_setStyle = __esm({
  "node_modules/rc-util/es/setStyle.js"() {
    setStyle_default = setStyle;
  }
});

// node_modules/rc-util/es/switchScrollingEffect.js
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}
var cacheStyle, switchScrollingEffect_default;
var init_switchScrollingEffect = __esm({
  "node_modules/rc-util/es/switchScrollingEffect.js"() {
    init_getScrollBarSize();
    init_setStyle();
    cacheStyle = {};
    switchScrollingEffect_default = function(close) {
      if (!isBodyOverflowing() && !close) {
        return;
      }
      var scrollingEffectClassName2 = "ant-scrolling-effect";
      var scrollingEffectClassNameReg2 = new RegExp("".concat(scrollingEffectClassName2), "g");
      var bodyClassName = document.body.className;
      if (close) {
        if (!scrollingEffectClassNameReg2.test(bodyClassName))
          return;
        setStyle_default(cacheStyle);
        cacheStyle = {};
        document.body.className = bodyClassName.replace(scrollingEffectClassNameReg2, "").trim();
        return;
      }
      var scrollBarSize = getScrollBarSize();
      if (scrollBarSize) {
        cacheStyle = setStyle_default({
          position: "relative",
          width: "calc(100% - ".concat(scrollBarSize, "px)")
        });
        if (!scrollingEffectClassNameReg2.test(bodyClassName)) {
          var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName2);
          document.body.className = addClassName.trim();
        }
      }
    };
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
var init_arrayLikeToArray2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray2(arr);
}
var init_arrayWithoutHoles = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js"() {
    init_arrayLikeToArray2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}
var init_iterableToArray = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/iterableToArray.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
var init_unsupportedIterableToArray2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js"() {
    init_arrayLikeToArray2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var init_nonIterableSpread = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray2(arr) || _nonIterableSpread();
}
var init_toConsumableArray = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"() {
    init_arrayWithoutHoles();
    init_iterableToArray();
    init_unsupportedIterableToArray2();
    init_nonIterableSpread();
  }
});

// node_modules/rc-util/es/Dom/scrollLocker.js
var uuid, locks, scrollingEffectClassName, scrollingEffectClassNameReg, cacheStyle2, ScrollLocker;
var init_scrollLocker = __esm({
  "node_modules/rc-util/es/Dom/scrollLocker.js"() {
    init_toConsumableArray();
    init_createClass();
    init_classCallCheck();
    init_getScrollBarSize();
    init_setStyle();
    uuid = 0;
    locks = [];
    scrollingEffectClassName = "ant-scrolling-effect";
    scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), "g");
    cacheStyle2 = /* @__PURE__ */ new Map();
    ScrollLocker = /* @__PURE__ */ _createClass(function ScrollLocker2(_options) {
      var _this = this;
      _classCallCheck(this, ScrollLocker2);
      this.lockTarget = void 0;
      this.options = void 0;
      this.getContainer = function() {
        var _this$options;
        return (_this$options = _this.options) === null || _this$options === void 0 ? void 0 : _this$options.container;
      };
      this.reLock = function(options) {
        var findLock = locks.find(function(_ref) {
          var target = _ref.target;
          return target === _this.lockTarget;
        });
        if (findLock) {
          _this.unLock();
        }
        _this.options = options;
        if (findLock) {
          findLock.options = options;
          _this.lock();
        }
      };
      this.lock = function() {
        var _this$options3;
        if (locks.some(function(_ref2) {
          var target = _ref2.target;
          return target === _this.lockTarget;
        })) {
          return;
        }
        if (locks.some(function(_ref3) {
          var _this$options2;
          var options = _ref3.options;
          return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options2 = _this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.container);
        })) {
          locks = [].concat(_toConsumableArray(locks), [{
            target: _this.lockTarget,
            options: _this.options
          }]);
          return;
        }
        var scrollBarSize = 0;
        var container = ((_this$options3 = _this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.container) || document.body;
        if (container === document.body && window.innerWidth - document.documentElement.clientWidth > 0 || container.scrollHeight > container.clientHeight) {
          scrollBarSize = getScrollBarSize();
        }
        var containerClassName = container.className;
        if (locks.filter(function(_ref4) {
          var _this$options4;
          var options = _ref4.options;
          return (options === null || options === void 0 ? void 0 : options.container) === ((_this$options4 = _this.options) === null || _this$options4 === void 0 ? void 0 : _this$options4.container);
        }).length === 0) {
          cacheStyle2.set(container, setStyle_default({
            width: scrollBarSize !== 0 ? "calc(100% - ".concat(scrollBarSize, "px)") : void 0,
            overflow: "hidden",
            overflowX: "hidden",
            overflowY: "hidden"
          }, {
            element: container
          }));
        }
        if (!scrollingEffectClassNameReg.test(containerClassName)) {
          var addClassName = "".concat(containerClassName, " ").concat(scrollingEffectClassName);
          container.className = addClassName.trim();
        }
        locks = [].concat(_toConsumableArray(locks), [{
          target: _this.lockTarget,
          options: _this.options
        }]);
      };
      this.unLock = function() {
        var _this$options5;
        var findLock = locks.find(function(_ref5) {
          var target = _ref5.target;
          return target === _this.lockTarget;
        });
        locks = locks.filter(function(_ref6) {
          var target = _ref6.target;
          return target !== _this.lockTarget;
        });
        if (!findLock || locks.some(function(_ref7) {
          var _findLock$options;
          var options = _ref7.options;
          return (options === null || options === void 0 ? void 0 : options.container) === ((_findLock$options = findLock.options) === null || _findLock$options === void 0 ? void 0 : _findLock$options.container);
        })) {
          return;
        }
        var container = ((_this$options5 = _this.options) === null || _this$options5 === void 0 ? void 0 : _this$options5.container) || document.body;
        var containerClassName = container.className;
        if (!scrollingEffectClassNameReg.test(containerClassName))
          return;
        setStyle_default(cacheStyle2.get(container), {
          element: container
        });
        cacheStyle2.delete(container);
        container.className = container.className.replace(scrollingEffectClassNameReg, "").trim();
      };
      this.lockTarget = uuid++;
      this.options = _options;
    });
  }
});

// node_modules/rc-util/es/PortalWrapper.js
import * as React81 from "react";
var openCount, supportDom, cacheOverflow, getParent, PortalWrapper, PortalWrapper_default;
var init_PortalWrapper = __esm({
  "node_modules/rc-util/es/PortalWrapper.js"() {
    init_classCallCheck();
    init_createClass();
    init_inherits();
    init_createSuper();
    init_typeof2();
    init_raf();
    init_Portal();
    init_canUseDom();
    init_switchScrollingEffect();
    init_setStyle();
    init_scrollLocker();
    openCount = 0;
    supportDom = canUseDom();
    cacheOverflow = {};
    getParent = function getParent2(getContainer) {
      if (!supportDom) {
        return null;
      }
      if (getContainer) {
        if (typeof getContainer === "string") {
          return document.querySelectorAll(getContainer)[0];
        }
        if (typeof getContainer === "function") {
          return getContainer();
        }
        if (_typeof2(getContainer) === "object" && getContainer instanceof window.HTMLElement) {
          return getContainer;
        }
      }
      return document.body;
    };
    PortalWrapper = /* @__PURE__ */ function(_React$Component) {
      _inherits(PortalWrapper2, _React$Component);
      var _super = _createSuper(PortalWrapper2);
      function PortalWrapper2(props2) {
        var _this;
        _classCallCheck(this, PortalWrapper2);
        _this = _super.call(this, props2);
        _this.container = void 0;
        _this.componentRef = /* @__PURE__ */ React81.createRef();
        _this.rafId = void 0;
        _this.scrollLocker = void 0;
        _this.renderComponent = void 0;
        _this.updateScrollLocker = function(prevProps) {
          var _ref = prevProps || {}, prevVisible = _ref.visible;
          var _this$props = _this.props, getContainer = _this$props.getContainer, visible = _this$props.visible;
          if (visible && visible !== prevVisible && supportDom && getParent(getContainer) !== _this.scrollLocker.getContainer()) {
            _this.scrollLocker.reLock({
              container: getParent(getContainer)
            });
          }
        };
        _this.updateOpenCount = function(prevProps) {
          var _ref2 = prevProps || {}, prevVisible = _ref2.visible, prevGetContainer = _ref2.getContainer;
          var _this$props2 = _this.props, visible = _this$props2.visible, getContainer = _this$props2.getContainer;
          if (visible !== prevVisible && supportDom && getParent(getContainer) === document.body) {
            if (visible && !prevVisible) {
              openCount += 1;
            } else if (prevProps) {
              openCount -= 1;
            }
          }
          var getContainerIsFunc = typeof getContainer === "function" && typeof prevGetContainer === "function";
          if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
            _this.removeCurrentContainer();
          }
        };
        _this.attachToParent = function() {
          var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
          if (force || _this.container && !_this.container.parentNode) {
            var parent = getParent(_this.props.getContainer);
            if (parent) {
              parent.appendChild(_this.container);
              return true;
            }
            return false;
          }
          return true;
        };
        _this.getContainer = function() {
          if (!supportDom) {
            return null;
          }
          if (!_this.container) {
            _this.container = document.createElement("div");
            _this.attachToParent(true);
          }
          _this.setWrapperClassName();
          return _this.container;
        };
        _this.setWrapperClassName = function() {
          var wrapperClassName = _this.props.wrapperClassName;
          if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
            _this.container.className = wrapperClassName;
          }
        };
        _this.removeCurrentContainer = function() {
          var _this$container, _this$container$paren;
          (_this$container = _this.container) === null || _this$container === void 0 ? void 0 : (_this$container$paren = _this$container.parentNode) === null || _this$container$paren === void 0 ? void 0 : _this$container$paren.removeChild(_this.container);
        };
        _this.switchScrollingEffect = function() {
          if (openCount === 1 && !Object.keys(cacheOverflow).length) {
            switchScrollingEffect_default();
            cacheOverflow = setStyle_default({
              overflow: "hidden",
              overflowX: "hidden",
              overflowY: "hidden"
            });
          } else if (!openCount) {
            setStyle_default(cacheOverflow);
            cacheOverflow = {};
            switchScrollingEffect_default(true);
          }
        };
        _this.scrollLocker = new ScrollLocker({
          container: getParent(props2.getContainer)
        });
        return _this;
      }
      _createClass(PortalWrapper2, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;
          this.updateOpenCount();
          if (!this.attachToParent()) {
            this.rafId = wrapperRaf(function() {
              _this2.forceUpdate();
            });
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          this.updateOpenCount(prevProps);
          this.updateScrollLocker(prevProps);
          this.setWrapperClassName();
          this.attachToParent();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var _this$props3 = this.props, visible = _this$props3.visible, getContainer = _this$props3.getContainer;
          if (supportDom && getParent(getContainer) === document.body) {
            openCount = visible && openCount ? openCount - 1 : openCount;
          }
          this.removeCurrentContainer();
          wrapperRaf.cancel(this.rafId);
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props4 = this.props, children = _this$props4.children, forceRender = _this$props4.forceRender, visible = _this$props4.visible;
          var portal = null;
          var childProps = {
            getOpenCount: function getOpenCount() {
              return openCount;
            },
            getContainer: this.getContainer,
            switchScrollingEffect: this.switchScrollingEffect,
            scrollLocker: this.scrollLocker
          };
          if (forceRender || visible || this.componentRef.current) {
            portal = /* @__PURE__ */ React81.createElement(Portal_default, {
              getContainer: this.getContainer,
              ref: this.componentRef
            }, children(childProps));
          }
          return portal;
        }
      }]);
      return PortalWrapper2;
    }(React81.Component);
    PortalWrapper_default = PortalWrapper;
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof3(o) {
  "@babel/helpers - typeof";
  return _typeof3 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof3(o);
}
var init_typeof3 = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/typeof.js"() {
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function _toPrimitive3(input, hint) {
  if (_typeof3(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof3(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var init_toPrimitive3 = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/toPrimitive.js"() {
    init_typeof3();
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function _toPropertyKey3(arg) {
  var key = _toPrimitive3(arg, "string");
  return _typeof3(key) === "symbol" ? key : String(key);
}
var init_toPropertyKey3 = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"() {
    init_typeof3();
    init_toPrimitive3();
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty2(obj, key, value) {
  key = _toPropertyKey3(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var init_defineProperty2 = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    init_toPropertyKey3();
  }
});

// node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function ownKeys2(e, r) {
  var t44 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t44.push.apply(t44, o);
  }
  return t44;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t44 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys2(Object(t44), true).forEach(function(r2) {
      _defineProperty2(e, r2, t44[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t44)) : ownKeys2(Object(t44)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t44, r2));
    });
  }
  return e;
}
var init_objectSpread2 = __esm({
  "node_modules/rc-dialog/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"() {
    init_defineProperty2();
  }
});

// node_modules/classnames/index.js
var require_classnames = __commonJS({
  "node_modules/classnames/index.js"(exports, module2) {
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      var nativeCodeString = "[native code]";
      function classNames7() {
        var classes = [];
        for (var i2 = 0; i2 < arguments.length; i2++) {
          var arg = arguments[i2];
          if (!arg)
            continue;
          var argType = typeof arg;
          if (argType === "string" || argType === "number") {
            classes.push(arg);
          } else if (Array.isArray(arg)) {
            if (arg.length) {
              var inner = classNames7.apply(null, arg);
              if (inner) {
                classes.push(inner);
              }
            }
          } else if (argType === "object") {
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
              classes.push(arg.toString());
              continue;
            }
            for (var key in arg) {
              if (hasOwn.call(arg, key) && arg[key]) {
                classes.push(key);
              }
            }
          }
        }
        return classes.join(" ");
      }
      if (typeof module2 !== "undefined" && module2.exports) {
        classNames7.default = classNames7;
        module2.exports = classNames7;
      } else if (false) {
        null("classnames", [], function() {
          return classNames7;
        });
      } else {
        window.classNames = classNames7;
      }
    })();
  }
});

// node_modules/rc-util/es/KeyCode.js
var KeyCode, KeyCode_default;
var init_KeyCode = __esm({
  "node_modules/rc-util/es/KeyCode.js"() {
    KeyCode = {
      /**
       * MAC_ENTER
       */
      MAC_ENTER: 3,
      /**
       * BACKSPACE
       */
      BACKSPACE: 8,
      /**
       * TAB
       */
      TAB: 9,
      /**
       * NUMLOCK on FF/Safari Mac
       */
      NUM_CENTER: 12,
      /**
       * ENTER
       */
      ENTER: 13,
      /**
       * SHIFT
       */
      SHIFT: 16,
      /**
       * CTRL
       */
      CTRL: 17,
      /**
       * ALT
       */
      ALT: 18,
      /**
       * PAUSE
       */
      PAUSE: 19,
      /**
       * CAPS_LOCK
       */
      CAPS_LOCK: 20,
      /**
       * ESC
       */
      ESC: 27,
      /**
       * SPACE
       */
      SPACE: 32,
      /**
       * PAGE_UP
       */
      PAGE_UP: 33,
      /**
       * PAGE_DOWN
       */
      PAGE_DOWN: 34,
      /**
       * END
       */
      END: 35,
      /**
       * HOME
       */
      HOME: 36,
      /**
       * LEFT
       */
      LEFT: 37,
      /**
       * UP
       */
      UP: 38,
      /**
       * RIGHT
       */
      RIGHT: 39,
      /**
       * DOWN
       */
      DOWN: 40,
      /**
       * PRINT_SCREEN
       */
      PRINT_SCREEN: 44,
      /**
       * INSERT
       */
      INSERT: 45,
      /**
       * DELETE
       */
      DELETE: 46,
      /**
       * ZERO
       */
      ZERO: 48,
      /**
       * ONE
       */
      ONE: 49,
      /**
       * TWO
       */
      TWO: 50,
      /**
       * THREE
       */
      THREE: 51,
      /**
       * FOUR
       */
      FOUR: 52,
      /**
       * FIVE
       */
      FIVE: 53,
      /**
       * SIX
       */
      SIX: 54,
      /**
       * SEVEN
       */
      SEVEN: 55,
      /**
       * EIGHT
       */
      EIGHT: 56,
      /**
       * NINE
       */
      NINE: 57,
      /**
       * QUESTION_MARK
       */
      QUESTION_MARK: 63,
      /**
       * A
       */
      A: 65,
      /**
       * B
       */
      B: 66,
      /**
       * C
       */
      C: 67,
      /**
       * D
       */
      D: 68,
      /**
       * E
       */
      E: 69,
      /**
       * F
       */
      F: 70,
      /**
       * G
       */
      G: 71,
      /**
       * H
       */
      H: 72,
      /**
       * I
       */
      I: 73,
      /**
       * J
       */
      J: 74,
      /**
       * K
       */
      K: 75,
      /**
       * L
       */
      L: 76,
      /**
       * M
       */
      M: 77,
      /**
       * N
       */
      N: 78,
      /**
       * O
       */
      O: 79,
      /**
       * P
       */
      P: 80,
      /**
       * Q
       */
      Q: 81,
      /**
       * R
       */
      R: 82,
      /**
       * S
       */
      S: 83,
      /**
       * T
       */
      T: 84,
      /**
       * U
       */
      U: 85,
      /**
       * V
       */
      V: 86,
      /**
       * W
       */
      W: 87,
      /**
       * X
       */
      X: 88,
      /**
       * Y
       */
      Y: 89,
      /**
       * Z
       */
      Z: 90,
      /**
       * META
       */
      META: 91,
      /**
       * WIN_KEY_RIGHT
       */
      WIN_KEY_RIGHT: 92,
      /**
       * CONTEXT_MENU
       */
      CONTEXT_MENU: 93,
      /**
       * NUM_ZERO
       */
      NUM_ZERO: 96,
      /**
       * NUM_ONE
       */
      NUM_ONE: 97,
      /**
       * NUM_TWO
       */
      NUM_TWO: 98,
      /**
       * NUM_THREE
       */
      NUM_THREE: 99,
      /**
       * NUM_FOUR
       */
      NUM_FOUR: 100,
      /**
       * NUM_FIVE
       */
      NUM_FIVE: 101,
      /**
       * NUM_SIX
       */
      NUM_SIX: 102,
      /**
       * NUM_SEVEN
       */
      NUM_SEVEN: 103,
      /**
       * NUM_EIGHT
       */
      NUM_EIGHT: 104,
      /**
       * NUM_NINE
       */
      NUM_NINE: 105,
      /**
       * NUM_MULTIPLY
       */
      NUM_MULTIPLY: 106,
      /**
       * NUM_PLUS
       */
      NUM_PLUS: 107,
      /**
       * NUM_MINUS
       */
      NUM_MINUS: 109,
      /**
       * NUM_PERIOD
       */
      NUM_PERIOD: 110,
      /**
       * NUM_DIVISION
       */
      NUM_DIVISION: 111,
      /**
       * F1
       */
      F1: 112,
      /**
       * F2
       */
      F2: 113,
      /**
       * F3
       */
      F3: 114,
      /**
       * F4
       */
      F4: 115,
      /**
       * F5
       */
      F5: 116,
      /**
       * F6
       */
      F6: 117,
      /**
       * F7
       */
      F7: 118,
      /**
       * F8
       */
      F8: 119,
      /**
       * F9
       */
      F9: 120,
      /**
       * F10
       */
      F10: 121,
      /**
       * F11
       */
      F11: 122,
      /**
       * F12
       */
      F12: 123,
      /**
       * NUMLOCK
       */
      NUMLOCK: 144,
      /**
       * SEMICOLON
       */
      SEMICOLON: 186,
      /**
       * DASH
       */
      DASH: 189,
      /**
       * EQUALS
       */
      EQUALS: 187,
      /**
       * COMMA
       */
      COMMA: 188,
      /**
       * PERIOD
       */
      PERIOD: 190,
      /**
       * SLASH
       */
      SLASH: 191,
      /**
       * APOSTROPHE
       */
      APOSTROPHE: 192,
      /**
       * SINGLE_QUOTE
       */
      SINGLE_QUOTE: 222,
      /**
       * OPEN_SQUARE_BRACKET
       */
      OPEN_SQUARE_BRACKET: 219,
      /**
       * BACKSLASH
       */
      BACKSLASH: 220,
      /**
       * CLOSE_SQUARE_BRACKET
       */
      CLOSE_SQUARE_BRACKET: 221,
      /**
       * WIN_KEY
       */
      WIN_KEY: 224,
      /**
       * MAC_FF_META
       */
      MAC_FF_META: 224,
      /**
       * WIN_IME
       */
      WIN_IME: 229,
      // ======================== Function ========================
      /**
       * whether text and modified key is entered at the same time.
       */
      isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        var keyCode = e.keyCode;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
          return false;
        }
        switch (keyCode) {
          case KeyCode.ALT:
          case KeyCode.CAPS_LOCK:
          case KeyCode.CONTEXT_MENU:
          case KeyCode.CTRL:
          case KeyCode.DOWN:
          case KeyCode.END:
          case KeyCode.ESC:
          case KeyCode.HOME:
          case KeyCode.INSERT:
          case KeyCode.LEFT:
          case KeyCode.MAC_FF_META:
          case KeyCode.META:
          case KeyCode.NUMLOCK:
          case KeyCode.NUM_CENTER:
          case KeyCode.PAGE_DOWN:
          case KeyCode.PAGE_UP:
          case KeyCode.PAUSE:
          case KeyCode.PRINT_SCREEN:
          case KeyCode.RIGHT:
          case KeyCode.SHIFT:
          case KeyCode.UP:
          case KeyCode.WIN_KEY:
          case KeyCode.WIN_KEY_RIGHT:
            return false;
          default:
            return true;
        }
      },
      /**
       * whether character is entered.
       */
      isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
          return true;
        }
        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
          return true;
        }
        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
          return true;
        }
        if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
          return true;
        }
        switch (keyCode) {
          case KeyCode.SPACE:
          case KeyCode.QUESTION_MARK:
          case KeyCode.NUM_PLUS:
          case KeyCode.NUM_MINUS:
          case KeyCode.NUM_PERIOD:
          case KeyCode.NUM_DIVISION:
          case KeyCode.SEMICOLON:
          case KeyCode.DASH:
          case KeyCode.EQUALS:
          case KeyCode.COMMA:
          case KeyCode.PERIOD:
          case KeyCode.SLASH:
          case KeyCode.APOSTROPHE:
          case KeyCode.SINGLE_QUOTE:
          case KeyCode.OPEN_SQUARE_BRACKET:
          case KeyCode.BACKSLASH:
          case KeyCode.CLOSE_SQUARE_BRACKET:
            return true;
          default:
            return false;
        }
      }
    };
    KeyCode_default = KeyCode;
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr))
    return arr;
}
var init_arrayWithHoles2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit2(r, l) {
  var t44 = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t44) {
    var e, n, i2, u, a = [], f = true, o = false;
    try {
      if (i2 = (t44 = t44.call(r)).next, 0 === l) {
        if (Object(t44) !== t44)
          return;
        f = false;
      } else
        for (; !(f = (e = i2.call(t44)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t44["return"] && (u = t44["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
var init_iterableToArrayLimit2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var init_nonIterableRest2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js"() {
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function _slicedToArray2(arr, i2) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i2) || _unsupportedIterableToArray2(arr, i2) || _nonIterableRest2();
}
var init_slicedToArray2 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"() {
    init_arrayWithHoles2();
    init_iterableToArrayLimit2();
    init_unsupportedIterableToArray2();
    init_nonIterableRest2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty3(obj, key, value) {
  key = _toPropertyKey2(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var init_defineProperty3 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    init_toPropertyKey2();
  }
});

// node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function ownKeys3(e, r) {
  var t44 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t44.push.apply(t44, o);
  }
  return t44;
}
function _objectSpread22(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t44 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys3(Object(t44), true).forEach(function(r2) {
      _defineProperty3(e, r2, t44[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t44)) : ownKeys3(Object(t44)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t44, r2));
    });
  }
  return e;
}
var init_objectSpread22 = __esm({
  "node_modules/rc-util/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"() {
    init_defineProperty3();
  }
});

// node_modules/rc-util/es/hooks/useId.js
import * as React82 from "react";
function getUseId() {
  var fullClone = _objectSpread22({}, React82);
  return fullClone.useId;
}
function useId(id2) {
  var _React$useState = React82.useState("ssr-id"), _React$useState2 = _slicedToArray2(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
  var useOriginId = getUseId();
  var reactNativeId = useOriginId === null || useOriginId === void 0 ? void 0 : useOriginId();
  React82.useEffect(function() {
    if (!useOriginId) {
      var nextId = uuid2;
      uuid2 += 1;
      setInnerId("rc_unique_".concat(nextId));
    }
  }, []);
  if (id2) {
    return id2;
  }
  if (false) {
    return "test-id";
  }
  return reactNativeId || innerId;
}
var uuid2;
var init_useId = __esm({
  "node_modules/rc-util/es/hooks/useId.js"() {
    init_slicedToArray2();
    init_objectSpread22();
    uuid2 = 0;
  }
});

// node_modules/rc-util/es/Dom/contains.js
function contains(root, n) {
  if (!root) {
    return false;
  }
  if (root.contains) {
    return root.contains(n);
  }
  var node = n;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
var init_contains = __esm({
  "node_modules/rc-util/es/Dom/contains.js"() {
  }
});

// node_modules/rc-util/es/pickAttrs.js
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
function pickAttrs(props2) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _objectSpread22({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props2).forEach(function(key) {
    if (
      // Aria
      mergedConfig.aria && (key === "role" || match(key, ariaPrefix)) || // Data
      mergedConfig.data && match(key, dataPrefix) || // Attr
      mergedConfig.attr && propList.includes(key)
    ) {
      attrs[key] = props2[key];
    }
  });
  return attrs;
}
var attributes, eventsName, propList, ariaPrefix, dataPrefix;
var init_pickAttrs = __esm({
  "node_modules/rc-util/es/pickAttrs.js"() {
    init_objectSpread22();
    attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
    eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
    propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
    ariaPrefix = "aria-";
    dataPrefix = "data-";
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof4(o) {
  "@babel/helpers - typeof";
  return _typeof4 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof4(o);
}
var init_typeof4 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/typeof.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function _toPrimitive4(input, hint) {
  if (_typeof4(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof4(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var init_toPrimitive4 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/toPrimitive.js"() {
    init_typeof4();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function _toPropertyKey4(arg) {
  var key = _toPrimitive4(arg, "string");
  return _typeof4(key) === "symbol" ? key : String(key);
}
var init_toPropertyKey4 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"() {
    init_typeof4();
    init_toPrimitive4();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty4(obj, key, value) {
  key = _toPropertyKey4(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var init_defineProperty4 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    init_toPropertyKey4();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function ownKeys4(e, r) {
  var t44 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t44.push.apply(t44, o);
  }
  return t44;
}
function _objectSpread23(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t44 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys4(Object(t44), true).forEach(function(r2) {
      _defineProperty4(e, r2, t44[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t44)) : ownKeys4(Object(t44)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t44, r2));
    });
  }
  return e;
}
var init_objectSpread23 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"() {
    init_defineProperty4();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles3(arr) {
  if (Array.isArray(arr))
    return arr;
}
var init_arrayWithHoles3 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit3(r, l) {
  var t44 = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t44) {
    var e, n, i2, u, a = [], f = true, o = false;
    try {
      if (i2 = (t44 = t44.call(r)).next, 0 === l) {
        if (Object(t44) !== t44)
          return;
        f = false;
      } else
        for (; !(f = (e = i2.call(t44)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t44["return"] && (u = t44["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}
var init_iterableToArrayLimit3 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i2 = 0, arr2 = new Array(len); i2 < len; i2++)
    arr2[i2] = arr[i2];
  return arr2;
}
var init_arrayLikeToArray3 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray3(o, minLen);
}
var init_unsupportedIterableToArray3 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js"() {
    init_arrayLikeToArray3();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest3() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var init_nonIterableRest3 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/nonIterableRest.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function _slicedToArray3(arr, i2) {
  return _arrayWithHoles3(arr) || _iterableToArrayLimit3(arr, i2) || _unsupportedIterableToArray3(arr, i2) || _nonIterableRest3();
}
var init_slicedToArray3 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"() {
    init_arrayWithHoles3();
    init_iterableToArrayLimit3();
    init_unsupportedIterableToArray3();
    init_nonIterableRest3();
  }
});

// node_modules/rc-util/es/Dom/findDOMNode.js
import ReactDOM3 from "react-dom";
function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }
  return ReactDOM3.findDOMNode(node);
}
var init_findDOMNode = __esm({
  "node_modules/rc-util/es/Dom/findDOMNode.js"() {
  }
});

// node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b = "function" === typeof Symbol && Symbol.for;
    var c = b ? Symbol.for("react.element") : 60103;
    var d = b ? Symbol.for("react.portal") : 60106;
    var e = b ? Symbol.for("react.fragment") : 60107;
    var f = b ? Symbol.for("react.strict_mode") : 60108;
    var g = b ? Symbol.for("react.profiler") : 60114;
    var h = b ? Symbol.for("react.provider") : 60109;
    var k = b ? Symbol.for("react.context") : 60110;
    var l = b ? Symbol.for("react.async_mode") : 60111;
    var m = b ? Symbol.for("react.concurrent_mode") : 60111;
    var n = b ? Symbol.for("react.forward_ref") : 60112;
    var p = b ? Symbol.for("react.suspense") : 60113;
    var q = b ? Symbol.for("react.suspense_list") : 60120;
    var r = b ? Symbol.for("react.memo") : 60115;
    var t44 = b ? Symbol.for("react.lazy") : 60116;
    var v = b ? Symbol.for("react.block") : 60121;
    var w = b ? Symbol.for("react.fundamental") : 60117;
    var x = b ? Symbol.for("react.responder") : 60118;
    var y = b ? Symbol.for("react.scope") : 60119;
    function z(a) {
      if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch (u) {
          case c:
            switch (a = a.type, a) {
              case l:
              case m:
              case e:
              case g:
              case f:
              case p:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case n:
                  case t44:
                  case r:
                  case h:
                    return a;
                  default:
                    return u;
                }
            }
          case d:
            return u;
        }
      }
    }
    function A(a) {
      return z(a) === m;
    }
    exports.AsyncMode = l;
    exports.ConcurrentMode = m;
    exports.ContextConsumer = k;
    exports.ContextProvider = h;
    exports.Element = c;
    exports.ForwardRef = n;
    exports.Fragment = e;
    exports.Lazy = t44;
    exports.Memo = r;
    exports.Portal = d;
    exports.Profiler = g;
    exports.StrictMode = f;
    exports.Suspense = p;
    exports.isAsyncMode = function(a) {
      return A(a) || z(a) === l;
    };
    exports.isConcurrentMode = A;
    exports.isContextConsumer = function(a) {
      return z(a) === k;
    };
    exports.isContextProvider = function(a) {
      return z(a) === h;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === c;
    };
    exports.isForwardRef = function(a) {
      return z(a) === n;
    };
    exports.isFragment = function(a) {
      return z(a) === e;
    };
    exports.isLazy = function(a) {
      return z(a) === t44;
    };
    exports.isMemo = function(a) {
      return z(a) === r;
    };
    exports.isPortal = function(a) {
      return z(a) === d;
    };
    exports.isProfiler = function(a) {
      return z(a) === g;
    };
    exports.isStrictMode = function(a) {
      return z(a) === f;
    };
    exports.isSuspense = function(a) {
      return z(a) === p;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t44 || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
    };
    exports.typeOf = z;
  }
});

// node_modules/react-is/index.js
var require_react_is = __commonJS({
  "node_modules/react-is/index.js"(exports, module2) {
    "use strict";
    if (true) {
      module2.exports = require_react_is_production_min();
    } else {
      module2.exports = null;
    }
  }
});

// node_modules/rc-util/es/hooks/useMemo.js
import * as React83 from "react";
var init_useMemo = __esm({
  "node_modules/rc-util/es/hooks/useMemo.js"() {
  }
});

// node_modules/rc-util/es/ref.js
function fillRef(ref12, node) {
  if (typeof ref12 === "function") {
    ref12(node);
  } else if (_typeof2(ref12) === "object" && ref12 && "current" in ref12) {
    ref12.current = node;
  }
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  var type39 = (0, import_react_is.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  if (typeof type39 === "function" && !((_type$prototype = type39.prototype) === null || _type$prototype === void 0 ? void 0 : _type$prototype.render)) {
    return false;
  }
  if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) === null || _nodeOrComponent$prot === void 0 ? void 0 : _nodeOrComponent$prot.render)) {
    return false;
  }
  return true;
}
var import_react_is;
var init_ref = __esm({
  "node_modules/rc-util/es/ref.js"() {
    init_typeof2();
    import_react_is = __toESM(require_react_is());
    init_useMemo();
  }
});

// node_modules/rc-motion/es/util/motion.js
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  if (domSupport) {
    if (!("AnimationEvent" in win)) {
      delete prefixes.animationend.animation;
    }
    if (!("TransitionEvent" in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i2 = 0; i2 < len; i2 += 1) {
      var styleProp = stylePropList[i2];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return "";
}
function getTransitionName(transitionName, transitionType) {
  if (!transitionName)
    return null;
  if (_typeof4(transitionName) === "object") {
    var type39 = transitionType.replace(/-\w/g, function(match2) {
      return match2[1].toUpperCase();
    });
    return transitionName[type39];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}
var vendorPrefixes, style, _document$createEleme, prefixedEventNames, internalAnimationEndName, internalTransitionEndName, supportTransition, animationEndName, transitionEndName;
var init_motion = __esm({
  "node_modules/rc-motion/es/util/motion.js"() {
    init_typeof4();
    init_canUseDom();
    vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== "undefined" ? window : {});
    style = {};
    if (canUseDom()) {
      _document$createEleme = document.createElement("div");
      style = _document$createEleme.style;
    }
    prefixedEventNames = {};
    internalAnimationEndName = getVendorPrefixedEventName("animationend");
    internalTransitionEndName = getVendorPrefixedEventName("transitionend");
    supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
    animationEndName = internalAnimationEndName || "animationend";
    transitionEndName = internalTransitionEndName || "transitionend";
  }
});

// node_modules/rc-motion/es/interface.js
var STATUS_NONE, STATUS_APPEAR, STATUS_ENTER, STATUS_LEAVE, STEP_NONE, STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED;
var init_interface = __esm({
  "node_modules/rc-motion/es/interface.js"() {
    STATUS_NONE = "none";
    STATUS_APPEAR = "appear";
    STATUS_ENTER = "enter";
    STATUS_LEAVE = "leave";
    STEP_NONE = "none";
    STEP_PREPARE = "prepare";
    STEP_START = "start";
    STEP_ACTIVE = "active";
    STEP_ACTIVATED = "end";
  }
});

// node_modules/rc-util/es/hooks/useState.js
import * as React84 from "react";
function useSafeState(defaultValue) {
  var destroyRef = React84.useRef(false);
  var _React$useState = React84.useState(defaultValue), _React$useState2 = _slicedToArray2(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
  React84.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}
var init_useState = __esm({
  "node_modules/rc-util/es/hooks/useState.js"() {
    init_slicedToArray2();
  }
});

// node_modules/rc-motion/es/hooks/useNextFrame.js
import * as React85 from "react";
var useNextFrame_default;
var init_useNextFrame = __esm({
  "node_modules/rc-motion/es/hooks/useNextFrame.js"() {
    init_raf();
    useNextFrame_default = function() {
      var nextFrameRef = React85.useRef(null);
      function cancelNextFrame() {
        wrapperRaf.cancel(nextFrameRef.current);
      }
      function nextFrame(callback) {
        var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
        cancelNextFrame();
        var nextFrameId = wrapperRaf(function() {
          if (delay <= 1) {
            callback({
              isCanceled: function isCanceled() {
                return nextFrameId !== nextFrameRef.current;
              }
            });
          } else {
            nextFrame(callback, delay - 1);
          }
        });
        nextFrameRef.current = nextFrameId;
      }
      React85.useEffect(function() {
        return function() {
          cancelNextFrame();
        };
      }, []);
      return [nextFrame, cancelNextFrame];
    };
  }
});

// node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js
import { useEffect as useEffect10, useLayoutEffect } from "react";
var useIsomorphicLayoutEffect, useIsomorphicLayoutEffect_default;
var init_useIsomorphicLayoutEffect = __esm({
  "node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js"() {
    init_canUseDom();
    useIsomorphicLayoutEffect = canUseDom() ? useLayoutEffect : useEffect10;
    useIsomorphicLayoutEffect_default = useIsomorphicLayoutEffect;
  }
});

// node_modules/rc-motion/es/hooks/useStepQueue.js
import * as React86 from "react";
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
var STEP_QUEUE, SkipStep, DoStep, useStepQueue_default;
var init_useStepQueue = __esm({
  "node_modules/rc-motion/es/hooks/useStepQueue.js"() {
    init_slicedToArray3();
    init_useState();
    init_interface();
    init_useNextFrame();
    init_useIsomorphicLayoutEffect();
    STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
    SkipStep = false;
    DoStep = true;
    useStepQueue_default = function(status, callback) {
      var _useState = useSafeState(STEP_NONE), _useState2 = _slicedToArray3(_useState, 2), step = _useState2[0], setStep = _useState2[1];
      var _useNextFrame = useNextFrame_default(), _useNextFrame2 = _slicedToArray3(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
      function startQueue() {
        setStep(STEP_PREPARE, true);
      }
      useIsomorphicLayoutEffect_default(function() {
        if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
          var index3 = STEP_QUEUE.indexOf(step);
          var nextStep = STEP_QUEUE[index3 + 1];
          var result = callback(step);
          if (result === SkipStep) {
            setStep(nextStep, true);
          } else {
            nextFrame(function(info2) {
              function doNext() {
                if (info2.isCanceled())
                  return;
                setStep(nextStep, true);
              }
              if (result === true) {
                doNext();
              } else {
                Promise.resolve(result).then(doNext);
              }
            });
          }
        }
      }, [status, step]);
      React86.useEffect(function() {
        return function() {
          cancelNextFrame();
        };
      }, []);
      return [startQueue, step];
    };
  }
});

// node_modules/rc-motion/es/hooks/useDomMotionEvents.js
import * as React87 from "react";
import { useRef as useRef9 } from "react";
var useDomMotionEvents_default;
var init_useDomMotionEvents = __esm({
  "node_modules/rc-motion/es/hooks/useDomMotionEvents.js"() {
    init_motion();
    useDomMotionEvents_default = function(callback) {
      var cacheElementRef = useRef9();
      var callbackRef = useRef9(callback);
      callbackRef.current = callback;
      var onInternalMotionEnd = React87.useCallback(function(event) {
        callbackRef.current(event);
      }, []);
      function removeMotionEvents(element) {
        if (element) {
          element.removeEventListener(transitionEndName, onInternalMotionEnd);
          element.removeEventListener(animationEndName, onInternalMotionEnd);
        }
      }
      function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) {
          removeMotionEvents(cacheElementRef.current);
        }
        if (element && element !== cacheElementRef.current) {
          element.addEventListener(transitionEndName, onInternalMotionEnd);
          element.addEventListener(animationEndName, onInternalMotionEnd);
          cacheElementRef.current = element;
        }
      }
      React87.useEffect(function() {
        return function() {
          removeMotionEvents(cacheElementRef.current);
        };
      }, []);
      return [patchMotionEvents, removeMotionEvents];
    };
  }
});

// node_modules/rc-motion/es/hooks/useStatus.js
import * as React88 from "react";
import { useRef as useRef11, useEffect as useEffect13 } from "react";
function useStatus(supportMotion, visible, getElement2, _ref) {
  var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
  var _useState = useSafeState(), _useState2 = _slicedToArray3(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
  var _useState3 = useSafeState(STATUS_NONE), _useState4 = _slicedToArray3(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
  var _useState5 = useSafeState(null), _useState6 = _slicedToArray3(_useState5, 2), style3 = _useState6[0], setStyle2 = _useState6[1];
  var mountedRef = useRef11(false);
  var deadlineRef = useRef11(null);
  function getDomElement2() {
    return getElement2();
  }
  var activeRef = useRef11(false);
  function onInternalMotionEnd(event) {
    var element = getDomElement2();
    if (event && !event.deadline && event.target !== element) {
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }
    if (status !== STATUS_NONE && currentActive && canEnd !== false) {
      setStatus(STATUS_NONE, true);
      setStyle2(null, true);
    }
  }
  var _useDomMotionEvents = useDomMotionEvents_default(onInternalMotionEnd), _useDomMotionEvents2 = _slicedToArray3(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
  var eventHandlers = React88.useMemo(function() {
    var _ref2, _ref3, _ref4;
    switch (status) {
      case STATUS_APPEAR:
        return _ref2 = {}, _defineProperty4(_ref2, STEP_PREPARE, onAppearPrepare), _defineProperty4(_ref2, STEP_START, onAppearStart), _defineProperty4(_ref2, STEP_ACTIVE, onAppearActive), _ref2;
      case STATUS_ENTER:
        return _ref3 = {}, _defineProperty4(_ref3, STEP_PREPARE, onEnterPrepare), _defineProperty4(_ref3, STEP_START, onEnterStart), _defineProperty4(_ref3, STEP_ACTIVE, onEnterActive), _ref3;
      case STATUS_LEAVE:
        return _ref4 = {}, _defineProperty4(_ref4, STEP_PREPARE, onLeavePrepare), _defineProperty4(_ref4, STEP_START, onLeaveStart), _defineProperty4(_ref4, STEP_ACTIVE, onLeaveActive), _ref4;
      default:
        return {};
    }
  }, [status]);
  var _useStepQueue = useStepQueue_default(status, function(newStep) {
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];
      if (!onPrepare) {
        return SkipStep;
      }
      return onPrepare(getDomElement2());
    }
    if (step in eventHandlers) {
      var _eventHandlers$step;
      setStyle2(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement2(), null)) || null);
    }
    if (step === STEP_ACTIVE) {
      patchMotionEvents(getDomElement2());
      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function() {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }
    return DoStep;
  }), _useStepQueue2 = _slicedToArray3(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;
  useIsomorphicLayoutEffect_default(function() {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;
    if (!supportMotion) {
      return;
    }
    var nextStatus;
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    if (nextStatus) {
      setStatus(nextStatus);
      startStep();
    }
  }, [visible]);
  useEffect13(function() {
    if (
      // Cancel appear
      status === STATUS_APPEAR && !motionAppear || // Cancel enter
      status === STATUS_ENTER && !motionEnter || // Cancel leave
      status === STATUS_LEAVE && !motionLeave
    ) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  useEffect13(function() {
    return function() {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);
  var firstMountChangeRef = React88.useRef(false);
  useEffect13(function() {
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== void 0 && status === STATUS_NONE) {
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, status]);
  var mergedStyle = style3;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread23({
      transition: "none"
    }, mergedStyle);
  }
  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}
var init_useStatus = __esm({
  "node_modules/rc-motion/es/hooks/useStatus.js"() {
    init_objectSpread23();
    init_defineProperty4();
    init_slicedToArray3();
    init_useState();
    init_interface();
    init_useStepQueue();
    init_useDomMotionEvents();
    init_useIsomorphicLayoutEffect();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var init_classCallCheck2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties2(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey4(descriptor.key), descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
var init_createClass2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/createClass.js"() {
    init_toPropertyKey4();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf2(o, p) {
  _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf4(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf2(o, p);
}
var init_setPrototypeOf2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits2(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf2(subClass, superClass);
}
var init_inherits2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/inherits.js"() {
    init_setPrototypeOf2();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf2(o) {
  _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf2(o);
}
var init_getPrototypeOf2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var init_isNativeReflectConstruct2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized2(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
var init_assertThisInitialized2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn2(self2, call) {
  if (call && (_typeof4(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized2(self2);
}
var init_possibleConstructorReturn2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js"() {
    init_typeof4();
    init_assertThisInitialized2();
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper2(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct2();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf2(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf2(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn2(this, result);
  };
}
var init_createSuper2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/createSuper.js"() {
    init_getPrototypeOf2();
    init_isNativeReflectConstruct2();
    init_possibleConstructorReturn2();
  }
});

// node_modules/rc-motion/es/DomWrapper.js
import * as React89 from "react";
var DomWrapper, DomWrapper_default;
var init_DomWrapper = __esm({
  "node_modules/rc-motion/es/DomWrapper.js"() {
    init_classCallCheck2();
    init_createClass2();
    init_inherits2();
    init_createSuper2();
    DomWrapper = /* @__PURE__ */ function(_React$Component) {
      _inherits2(DomWrapper2, _React$Component);
      var _super = _createSuper2(DomWrapper2);
      function DomWrapper2() {
        _classCallCheck2(this, DomWrapper2);
        return _super.apply(this, arguments);
      }
      _createClass2(DomWrapper2, [{
        key: "render",
        value: function render() {
          return this.props.children;
        }
      }]);
      return DomWrapper2;
    }(React89.Component);
    DomWrapper_default = DomWrapper;
  }
});

// node_modules/rc-motion/es/CSSMotion.js
import * as React90 from "react";
import { useRef as useRef13 } from "react";
function genCSSMotion(config2) {
  var transitionSupport = config2;
  if (_typeof4(config2) === "object") {
    transitionSupport = config2.transitionSupport;
  }
  function isSupportTransition(props2) {
    return !!(props2.motionName && transitionSupport);
  }
  var CSSMotion = /* @__PURE__ */ React90.forwardRef(function(props2, ref12) {
    var _props$visible = props2.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props2.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props2.forceRender, children = props2.children, motionName = props2.motionName, leavedClassName = props2.leavedClassName, eventProps = props2.eventProps;
    var supportMotion = isSupportTransition(props2);
    var nodeRef = useRef13();
    var wrapperNodeRef = useRef13();
    function getDomElement2() {
      try {
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e) {
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement2, props2), _useStatus2 = _slicedToArray3(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
    var renderedRef = React90.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }
    var setNodeRef = React90.useCallback(function(node) {
      nodeRef.current = node;
      fillRef(ref12, node);
    }, [ref12]);
    var motionChildren;
    var mergedProps = _objectSpread23(_objectSpread23({}, eventProps), {}, {
      visible
    });
    if (!children) {
      motionChildren = null;
    } else if (status === STATUS_NONE || !isSupportTransition(props2)) {
      if (mergedVisible) {
        motionChildren = children(_objectSpread23({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current) {
        motionChildren = children(_objectSpread23(_objectSpread23({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender) {
        motionChildren = children(_objectSpread23(_objectSpread23({}, mergedProps), {}, {
          style: {
            display: "none"
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var _classNames;
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = "prepare";
      } else if (isActive(statusStep)) {
        statusSuffix = "active";
      } else if (statusStep === STEP_START) {
        statusSuffix = "start";
      }
      motionChildren = children(_objectSpread23(_objectSpread23({}, mergedProps), {}, {
        className: (0, import_classnames.default)(getTransitionName(motionName, status), (_classNames = {}, _defineProperty4(_classNames, getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix)), statusSuffix), _defineProperty4(_classNames, motionName, typeof motionName === "string"), _classNames)),
        style: statusStyle
      }), setNodeRef);
    }
    if (/* @__PURE__ */ React90.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var _motionChildren = motionChildren, originNodeRef = _motionChildren.ref;
      if (!originNodeRef) {
        motionChildren = /* @__PURE__ */ React90.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /* @__PURE__ */ React90.createElement(DomWrapper_default, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = "CSSMotion";
  return CSSMotion;
}
var import_classnames, CSSMotion_default;
var init_CSSMotion = __esm({
  "node_modules/rc-motion/es/CSSMotion.js"() {
    init_defineProperty4();
    init_objectSpread23();
    init_slicedToArray3();
    init_typeof4();
    init_findDOMNode();
    init_ref();
    import_classnames = __toESM(require_classnames());
    init_motion();
    init_interface();
    init_useStatus();
    init_DomWrapper();
    init_useStepQueue();
    CSSMotion_default = genCSSMotion(supportTransition);
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
var init_extends2 = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/extends.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var init_objectWithoutPropertiesLoose = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js"() {
  }
});

// node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var init_objectWithoutProperties = __esm({
  "node_modules/rc-motion/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"() {
    init_objectWithoutPropertiesLoose();
  }
});

// node_modules/rc-motion/es/util/diff.js
function wrapKeyToObject(key) {
  var keyObj;
  if (key && _typeof4(key) === "object" && "key" in key) {
    keyObj = key;
  } else {
    keyObj = {
      key
    };
  }
  return _objectSpread23(_objectSpread23({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return keys.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var list2 = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);
  prevKeyObjects.forEach(function(keyObj) {
    var hit = false;
    for (var i2 = currentIndex; i2 < currentLen; i2 += 1) {
      var currentKeyObj = currentKeyObjects[i2];
      if (currentKeyObj.key === keyObj.key) {
        if (currentIndex < i2) {
          list2 = list2.concat(currentKeyObjects.slice(currentIndex, i2).map(function(obj) {
            return _objectSpread23(_objectSpread23({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i2;
        }
        list2.push(_objectSpread23(_objectSpread23({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }
    if (!hit) {
      list2.push(_objectSpread23(_objectSpread23({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });
  if (currentIndex < currentLen) {
    list2 = list2.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
      return _objectSpread23(_objectSpread23({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  var keys = {};
  list2.forEach(function(_ref) {
    var key = _ref.key;
    keys[key] = (keys[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys).filter(function(key) {
    return keys[key] > 1;
  });
  duplicatedKeys.forEach(function(matchKey) {
    list2 = list2.filter(function(_ref2) {
      var key = _ref2.key, status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });
    list2.forEach(function(node) {
      if (node.key === matchKey) {
        node.status = STATUS_KEEP;
      }
    });
  });
  return list2;
}
var STATUS_ADD, STATUS_KEEP, STATUS_REMOVE, STATUS_REMOVED;
var init_diff = __esm({
  "node_modules/rc-motion/es/util/diff.js"() {
    init_objectSpread23();
    init_typeof4();
    STATUS_ADD = "add";
    STATUS_KEEP = "keep";
    STATUS_REMOVE = "remove";
    STATUS_REMOVED = "removed";
  }
});

// node_modules/rc-motion/es/CSSMotionList.js
import * as React91 from "react";
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion_default;
  var CSSMotionList = /* @__PURE__ */ function(_React$Component) {
    _inherits2(CSSMotionList2, _React$Component);
    var _super = _createSuper2(CSSMotionList2);
    function CSSMotionList2() {
      var _this;
      _classCallCheck2(this, CSSMotionList2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _this.state = {
        keyEntities: []
      };
      _this.removeKey = function(removeKey) {
        var keyEntities = _this.state.keyEntities;
        var nextKeyEntities = keyEntities.map(function(entity) {
          if (entity.key !== removeKey)
            return entity;
          return _objectSpread23(_objectSpread23({}, entity), {}, {
            status: STATUS_REMOVED
          });
        });
        _this.setState({
          keyEntities: nextKeyEntities
        });
        return nextKeyEntities.filter(function(_ref) {
          var status = _ref.status;
          return status !== STATUS_REMOVED;
        }).length;
      };
      return _this;
    }
    _createClass2(CSSMotionList2, [{
      key: "render",
      value: function render() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = _objectWithoutProperties(_this$props, _excluded);
        var Component7 = component || React91.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function(prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /* @__PURE__ */ React91.createElement(Component7, restProps, keyEntities.map(function(_ref2) {
          var status = _ref2.status, eventProps = _objectWithoutProperties(_ref2, _excluded2);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /* @__PURE__ */ React91.createElement(CSSMotion, _extends2({}, motionProps, {
            key: eventProps.key,
            visible,
            eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 ? void 0 : _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                var restKeysCount = _this2.removeKey(eventProps.key);
                if (restKeysCount === 0 && onAllRemoved) {
                  onAllRemoved();
                }
              }
            }
          }), children);
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function(entity) {
            var prevEntity = keyEntities.find(function(_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
      // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
    }]);
    return CSSMotionList2;
  }(React91.Component);
  CSSMotionList.defaultProps = {
    component: "div"
  };
  return CSSMotionList;
}
var _excluded, _excluded2, MOTION_PROP_NAMES, CSSMotionList_default;
var init_CSSMotionList = __esm({
  "node_modules/rc-motion/es/CSSMotionList.js"() {
    init_extends2();
    init_objectWithoutProperties();
    init_objectSpread23();
    init_classCallCheck2();
    init_createClass2();
    init_inherits2();
    init_createSuper2();
    init_CSSMotion();
    init_motion();
    init_diff();
    _excluded = ["component", "children", "onVisibleChanged", "onAllRemoved"];
    _excluded2 = ["status"];
    MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
    CSSMotionList_default = genCSSMotionList(supportTransition);
  }
});

// node_modules/rc-motion/es/index.js
var es_default;
var init_es = __esm({
  "node_modules/rc-motion/es/index.js"() {
    init_CSSMotion();
    init_CSSMotionList();
    es_default = CSSMotion_default;
  }
});

// node_modules/rc-dialog/es/Dialog/Mask.js
import * as React92 from "react";
function Mask(props2) {
  var prefixCls = props2.prefixCls, style3 = props2.style, visible = props2.visible, maskProps = props2.maskProps, motionName = props2.motionName;
  return /* @__PURE__ */ React92.createElement(es_default, {
    key: "mask",
    visible,
    motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function(_ref) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React92.createElement("div", _extends({
      style: _objectSpread2(_objectSpread2({}, motionStyle), style3),
      className: (0, import_classnames2.default)("".concat(prefixCls, "-mask"), motionClassName)
    }, maskProps));
  });
}
var import_classnames2;
var init_Mask = __esm({
  "node_modules/rc-dialog/es/Dialog/Mask.js"() {
    init_extends();
    init_objectSpread2();
    import_classnames2 = __toESM(require_classnames());
    init_es();
  }
});

// node_modules/rc-dialog/es/util.js
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }
  return motionName;
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? "Y" : "X", "Offset")];
  var method = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w.document;
    ret = d.documentElement[method];
    if (typeof ret !== "number") {
      ret = d.body[method];
    }
  }
  return ret;
}
function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}
var init_util = __esm({
  "node_modules/rc-dialog/es/util.js"() {
  }
});

// node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js
import * as React93 from "react";
var MemoChildren_default;
var init_MemoChildren = __esm({
  "node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js"() {
    MemoChildren_default = /* @__PURE__ */ React93.memo(function(_ref) {
      var children = _ref.children;
      return children;
    }, function(_, _ref2) {
      var shouldUpdate = _ref2.shouldUpdate;
      return !shouldUpdate;
    });
  }
});

// node_modules/rc-dialog/es/Dialog/Content/Panel.js
import React94, { useRef as useRef14 } from "react";
var import_classnames3, sentinelStyle, Panel, Panel_default;
var init_Panel = __esm({
  "node_modules/rc-dialog/es/Dialog/Content/Panel.js"() {
    init_objectSpread2();
    init_extends();
    import_classnames3 = __toESM(require_classnames());
    init_MemoChildren();
    sentinelStyle = {
      width: 0,
      height: 0,
      overflow: "hidden",
      outline: "none"
    };
    Panel = /* @__PURE__ */ React94.forwardRef(function(props2, ref12) {
      var prefixCls = props2.prefixCls, className = props2.className, style3 = props2.style, title = props2.title, ariaId = props2.ariaId, footer = props2.footer, closable = props2.closable, closeIcon = props2.closeIcon, onClose = props2.onClose, children = props2.children, bodyStyle = props2.bodyStyle, bodyProps = props2.bodyProps, modalRender = props2.modalRender, onMouseDown = props2.onMouseDown, onMouseUp = props2.onMouseUp, holderRef = props2.holderRef, visible = props2.visible, forceRender = props2.forceRender, width = props2.width, height = props2.height;
      var sentinelStartRef = useRef14();
      var sentinelEndRef = useRef14();
      React94.useImperativeHandle(ref12, function() {
        return {
          focus: function focus() {
            var _sentinelStartRef$cur;
            (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 ? void 0 : _sentinelStartRef$cur.focus();
          },
          changeActive: function changeActive(next) {
            var _document = document, activeElement = _document.activeElement;
            if (next && activeElement === sentinelEndRef.current) {
              sentinelStartRef.current.focus();
            } else if (!next && activeElement === sentinelStartRef.current) {
              sentinelEndRef.current.focus();
            }
          }
        };
      });
      var contentStyle = {};
      if (width !== void 0) {
        contentStyle.width = width;
      }
      if (height !== void 0) {
        contentStyle.height = height;
      }
      var footerNode;
      if (footer) {
        footerNode = /* @__PURE__ */ React94.createElement("div", {
          className: "".concat(prefixCls, "-footer")
        }, footer);
      }
      var headerNode;
      if (title) {
        headerNode = /* @__PURE__ */ React94.createElement("div", {
          className: "".concat(prefixCls, "-header")
        }, /* @__PURE__ */ React94.createElement("div", {
          className: "".concat(prefixCls, "-title"),
          id: ariaId
        }, title));
      }
      var closer;
      if (closable) {
        closer = /* @__PURE__ */ React94.createElement("button", {
          type: "button",
          onClick: onClose,
          "aria-label": "Close",
          className: "".concat(prefixCls, "-close")
        }, closeIcon || /* @__PURE__ */ React94.createElement("span", {
          className: "".concat(prefixCls, "-close-x")
        }));
      }
      var content = /* @__PURE__ */ React94.createElement("div", {
        className: "".concat(prefixCls, "-content")
      }, closer, headerNode, /* @__PURE__ */ React94.createElement("div", _extends({
        className: "".concat(prefixCls, "-body"),
        style: bodyStyle
      }, bodyProps), children), footerNode);
      return /* @__PURE__ */ React94.createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: holderRef,
        style: _objectSpread2(_objectSpread2({}, style3), contentStyle),
        className: (0, import_classnames3.default)(prefixCls, className),
        onMouseDown,
        onMouseUp
      }, /* @__PURE__ */ React94.createElement("div", {
        tabIndex: 0,
        ref: sentinelStartRef,
        style: sentinelStyle,
        "aria-hidden": "true"
      }), /* @__PURE__ */ React94.createElement(MemoChildren_default, {
        shouldUpdate: visible || forceRender
      }, modalRender ? modalRender(content) : content), /* @__PURE__ */ React94.createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: sentinelStyle,
        "aria-hidden": "true"
      }));
    });
    if (false) {
      Panel.displayName = "Panel";
    }
    Panel_default = Panel;
  }
});

// node_modules/rc-dialog/es/Dialog/Content/index.js
import * as React95 from "react";
import { useRef as useRef15 } from "react";
var import_classnames4, Content, Content_default;
var init_Content = __esm({
  "node_modules/rc-dialog/es/Dialog/Content/index.js"() {
    init_extends();
    init_objectSpread2();
    init_slicedToArray();
    import_classnames4 = __toESM(require_classnames());
    init_es();
    init_util();
    init_Panel();
    Content = /* @__PURE__ */ React95.forwardRef(function(props2, ref12) {
      var prefixCls = props2.prefixCls, title = props2.title, style3 = props2.style, className = props2.className, visible = props2.visible, forceRender = props2.forceRender, destroyOnClose = props2.destroyOnClose, motionName = props2.motionName, ariaId = props2.ariaId, onVisibleChanged = props2.onVisibleChanged, mousePosition = props2.mousePosition;
      var dialogRef = useRef15();
      var _React$useState = React95.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
      var contentStyle = {};
      if (transformOrigin) {
        contentStyle.transformOrigin = transformOrigin;
      }
      function onPrepare() {
        var elementOffset = offset(dialogRef.current);
        setTransformOrigin(mousePosition ? "".concat(mousePosition.x - elementOffset.left, "px ").concat(mousePosition.y - elementOffset.top, "px") : "");
      }
      return /* @__PURE__ */ React95.createElement(es_default, {
        visible,
        onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender,
        motionName,
        removeOnLeave: destroyOnClose,
        ref: dialogRef
      }, function(_ref, motionRef) {
        var motionClassName = _ref.className, motionStyle = _ref.style;
        return /* @__PURE__ */ React95.createElement(Panel_default, _extends({}, props2, {
          ref: ref12,
          title,
          ariaId,
          prefixCls,
          holderRef: motionRef,
          style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionStyle), style3), contentStyle),
          className: (0, import_classnames4.default)(className, motionClassName)
        }));
      });
    });
    Content.displayName = "Content";
    Content_default = Content;
  }
});

// node_modules/rc-dialog/es/Dialog/index.js
import * as React96 from "react";
import { useRef as useRef16, useEffect as useEffect14 } from "react";
function Dialog(props2) {
  var _props$prefixCls = props2.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props2.zIndex, _props$visible = props2.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props2.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props2.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, scrollLocker = props2.scrollLocker, wrapStyle = props2.wrapStyle, wrapClassName = props2.wrapClassName, wrapProps = props2.wrapProps, onClose = props2.onClose, afterClose = props2.afterClose, transitionName = props2.transitionName, animation = props2.animation, _props$closable = props2.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props2.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props2.maskTransitionName, maskAnimation = props2.maskAnimation, _props$maskClosable = props2.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props2.maskStyle, maskProps = props2.maskProps, rootClassName = props2.rootClassName;
  var lastOutSideActiveElementRef = useRef16();
  var wrapperRef = useRef16();
  var contentRef = useRef16();
  var _React$useState = React96.useState(visible), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
  var ariaId = useId();
  function onDialogVisibleChanged(newVisible) {
    if (newVisible) {
      if (!contains(wrapperRef.current, document.activeElement)) {
        var _contentRef$current;
        lastOutSideActiveElementRef.current = document.activeElement;
        (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 ? void 0 : _contentRef$current.focus();
      }
    } else {
      setAnimatedVisible(false);
      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e) {
        }
        lastOutSideActiveElementRef.current = null;
      }
      if (animatedVisible) {
        afterClose === null || afterClose === void 0 ? void 0 : afterClose();
      }
    }
  }
  function onInternalClose(e) {
    onClose === null || onClose === void 0 ? void 0 : onClose(e);
  }
  var contentClickRef = useRef16(false);
  var contentTimeoutRef = useRef16();
  var onContentMouseDown = function onContentMouseDown2() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };
  var onContentMouseUp = function onContentMouseUp2() {
    contentTimeoutRef.current = setTimeout(function() {
      contentClickRef.current = false;
    });
  };
  var onWrapperClick = null;
  if (maskClosable) {
    onWrapperClick = function onWrapperClick2(e) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e.target) {
        onInternalClose(e);
      }
    };
  }
  function onWrapperKeyDown(e) {
    if (keyboard && e.keyCode === KeyCode_default.ESC) {
      e.stopPropagation();
      onInternalClose(e);
      return;
    }
    if (visible) {
      if (e.keyCode === KeyCode_default.TAB) {
        contentRef.current.changeActive(!e.shiftKey);
      }
    }
  }
  useEffect14(function() {
    if (visible) {
      setAnimatedVisible(true);
    }
    return function() {
    };
  }, [visible]);
  useEffect14(function() {
    return function() {
      clearTimeout(contentTimeoutRef.current);
    };
  }, []);
  useEffect14(function() {
    if (animatedVisible) {
      scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.lock();
      return scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.unLock;
    }
    return function() {
    };
  }, [animatedVisible, scrollLocker]);
  return /* @__PURE__ */ React96.createElement("div", _extends({
    className: (0, import_classnames5.default)("".concat(prefixCls, "-root"), rootClassName)
  }, pickAttrs(props2, {
    data: true
  })), /* @__PURE__ */ React96.createElement(Mask, {
    prefixCls,
    visible: mask && visible,
    motionName: getMotionName(prefixCls, maskTransitionName, maskAnimation),
    style: _objectSpread2({
      zIndex
    }, maskStyle),
    maskProps
  }), /* @__PURE__ */ React96.createElement("div", _extends({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: (0, import_classnames5.default)("".concat(prefixCls, "-wrap"), wrapClassName),
    ref: wrapperRef,
    onClick: onWrapperClick,
    style: _objectSpread2(_objectSpread2({
      zIndex
    }, wrapStyle), {}, {
      display: !animatedVisible ? "none" : null
    })
  }, wrapProps), /* @__PURE__ */ React96.createElement(Content_default, _extends({}, props2, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable,
    ariaId,
    prefixCls,
    visible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: getMotionName(prefixCls, transitionName, animation)
  }))));
}
var import_classnames5;
var init_Dialog = __esm({
  "node_modules/rc-dialog/es/Dialog/index.js"() {
    init_extends();
    init_objectSpread2();
    init_slicedToArray();
    import_classnames5 = __toESM(require_classnames());
    init_KeyCode();
    init_useId();
    init_contains();
    init_pickAttrs();
    init_Mask();
    init_util();
    init_Content();
  }
});

// node_modules/rc-dialog/es/DialogWrap.js
import * as React97 from "react";
var DialogWrap, DialogWrap_default;
var init_DialogWrap = __esm({
  "node_modules/rc-dialog/es/DialogWrap.js"() {
    init_extends();
    init_slicedToArray();
    init_PortalWrapper();
    init_Dialog();
    DialogWrap = function DialogWrap2(props2) {
      var visible = props2.visible, getContainer = props2.getContainer, forceRender = props2.forceRender, _props$destroyOnClose = props2.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props2.afterClose;
      var _React$useState = React97.useState(visible), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
      React97.useEffect(function() {
        if (visible) {
          setAnimatedVisible(true);
        }
      }, [visible]);
      if (getContainer === false) {
        return /* @__PURE__ */ React97.createElement(Dialog, _extends({}, props2, {
          getOpenCount: function getOpenCount() {
            return 2;
          }
          // 不对 body 做任何操作。。
        }));
      }
      if (!forceRender && destroyOnClose && !animatedVisible) {
        return null;
      }
      return /* @__PURE__ */ React97.createElement(PortalWrapper_default, {
        visible,
        forceRender,
        getContainer
      }, function(childProps) {
        return /* @__PURE__ */ React97.createElement(Dialog, _extends({}, props2, {
          destroyOnClose,
          afterClose: function afterClose() {
            _afterClose === null || _afterClose === void 0 ? void 0 : _afterClose();
            setAnimatedVisible(false);
          }
        }, childProps));
      });
    };
    DialogWrap.displayName = "Dialog";
    DialogWrap_default = DialogWrap;
  }
});

// node_modules/rc-dialog/es/index.js
var es_default2;
var init_es2 = __esm({
  "node_modules/rc-dialog/es/index.js"() {
    init_DialogWrap();
    init_Panel();
    es_default2 = DialogWrap_default;
  }
});

// internal/src/client/themesV2/helpers/useComponentOverrides.ts
import css2 from "@emotion/css";
var useComponentOverrides, useComponentOverrides_default;
var init_useComponentOverrides = __esm({
  "internal/src/client/themesV2/helpers/useComponentOverrides.ts"() {
    "use strict";
    useComponentOverrides = (slug21, themeV2) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      const lightModeOverrides = (_d = (_c2 = (_b2 = (_a2 = themeV2.themeV2) == null ? void 0 : _a2.light_mode) == null ? void 0 : _b2.component_overrides) == null ? void 0 : _c2[slug21]) != null ? _d : {};
      const darkModeOverrides = (_h = (_g = (_f = (_e = themeV2.themeV2) == null ? void 0 : _e.dark_mode) == null ? void 0 : _f.component_overrides) == null ? void 0 : _g[slug21]) != null ? _h : {};
      return {
        overrides: [css2(lightModeOverrides), themeV2.mode === "dark_mode" && css2(darkModeOverrides)].filter(Boolean),
        // TODO: this is hopefully temporary --
        // we're using this to get specific overrides for a component
        lightModeOverridesObject: lightModeOverrides,
        darkModeOverridesObject: darkModeOverrides
      };
    };
    useComponentOverrides_default = useComponentOverrides;
  }
});

// internal/src/client/themesV2/components/shared/StyledIconContainer.tsx
import React98 from "react";
var IconContainer, StyledIconContainer, StyledIconContainer_default;
var init_StyledIconContainer = __esm({
  "internal/src/client/themesV2/components/shared/StyledIconContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    IconContainer = styled_browser_esm_default.div`
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
    StyledIconContainer = ({ children, ...props2 }) => /* @__PURE__ */ React98.createElement(IconContainer, { ...props2 }, children);
    StyledIconContainer_default = StyledIconContainer;
  }
});

// internal/src/client/themesV2/components/shared/ButtonWithReset.tsx
var ButtonWithReset, ButtonWithReset_default;
var init_ButtonWithReset = __esm({
  "internal/src/client/themesV2/components/shared/ButtonWithReset.tsx"() {
    "use strict";
    init_styled_browser_esm();
    ButtonWithReset = styled_browser_esm_default.button`
  all: unset;
  box-sizing: border-box;
`;
    ButtonWithReset_default = ButtonWithReset;
  }
});

// internal/src/client/themesV2/components/shared/StyledSecondaryIconButton.tsx
import { css as css3, jsx as jsx6 } from "@emotion/core";
var styles2, slug, StyledSecondaryIconButton, StyledSecondaryIconButton_default;
var init_StyledSecondaryIconButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledSecondaryIconButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_StyledIconContainer();
    init_react();
    init_ButtonWithReset();
    styles2 = {
      display: "flex",
      width: "var(--form-control-height)",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      color: "var(--button-secondary-content)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--button-secondary-border-color)",
      background: "var(--button-secondary-background)",
      cursor: "pointer",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      userSelect: "none",
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        borderColor: "var(--button-secondary-border-color-hover)",
        background: "var(--button-secondary-background-hover)",
        color: "var(--button-secondary-content-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        background: "var(--button-secondary-background-hover)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed",
        borderColor: "var(--button-secondary-border-color)",
        background: "var(--button-secondary-background)",
        color: "var(--button-secondary-content)"
      }
    };
    slug = "secondaryIconButton";
    StyledSecondaryIconButton = ({
      children,
      themeV2,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug, themeV2);
      return /* @__PURE__ */ jsx6(ButtonWithReset_default, { css: [overrides, css3(styles2)], ...props2 }, /* @__PURE__ */ jsx6(StyledIconContainer_default, null, children));
    };
    StyledSecondaryIconButton.styles = styles2;
    StyledSecondaryIconButton.slug = slug;
    StyledSecondaryIconButton.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx6(StyledSecondaryIconButton, { themeV2: { themeV2, mode } }, /* @__PURE__ */ jsx6(ChevronLeft_default, null));
    StyledSecondaryIconButton_default = StyledSecondaryIconButton;
  }
});

// internal/src/client/themesV2/components/shared/StyledImageDialog.tsx
import { useState as useState10, useEffect as useEffect16, useCallback as useCallback3 } from "react";
import { css as css4, jsx as jsx7 } from "@emotion/core";
var StyledImageDialog, StyledImageDialog_default;
var init_StyledImageDialog = __esm({
  "internal/src/client/themesV2/components/shared/StyledImageDialog.tsx"() {
    "use strict";
    init_es2();
    init_StyledSecondaryIconButton();
    init_react();
    init_Z();
    init_operatingSystem();
    StyledImageDialog = ({ themeV2, src, visible, onClose }) => {
      const [imageDimensions, setImageDimensions] = useState10({ width: 0, height: 0 });
      const [containerDimensions, setContainerDimensions] = useState10({ width: 0, height: 0 });
      const updateContainerDimensions = useCallback3(() => {
        const padding = isMobileDevice() ? 56 : 80;
        setContainerDimensions({
          width: window.innerWidth - padding,
          height: window.innerHeight - padding
        });
      }, []);
      useEffect16(() => {
        updateContainerDimensions();
        window.addEventListener("resize", updateContainerDimensions);
        return () => window.removeEventListener("resize", updateContainerDimensions);
      }, [updateContainerDimensions]);
      useEffect16(() => {
        const img = new Image();
        img.onload = () => {
          setImageDimensions({ width: img.width, height: img.height });
        };
        img.src = src;
      }, [src]);
      const calculateDimensions = () => {
        const aspectRatio = imageDimensions.width / imageDimensions.height;
        let width2 = imageDimensions.width;
        let height2 = imageDimensions.height;
        if (width2 > containerDimensions.width) {
          width2 = containerDimensions.width;
          height2 = width2 / aspectRatio;
        }
        if (height2 > containerDimensions.height) {
          height2 = containerDimensions.height;
          width2 = height2 * aspectRatio;
        }
        return { width: width2, height: height2 };
      };
      const { width, height } = calculateDimensions();
      return /* @__PURE__ */ jsx7(
        es_default2,
        {
          visible,
          onClose,
          "aria-modal": "true",
          wrapClassName: `commandbar-nudge-modal ${themeV2.generatedCSSClassname}`,
          bodyStyle: {
            background: "var(--background-primary)",
            borderRadius: "0px",
            padding: "0px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          },
          style: {
            background: "var(--background-primary)",
            border: "none",
            borderRadius: "0px",
            margin: "var(--layout-padding)",
            width: `${width}px`,
            height: `${height}px`,
            maxWidth: "100%",
            maxHeight: "100%"
          },
          maskStyle: { zIndex: Z_default.Z_MASK },
          css: css4`
        .rc-dialog-close {
          opacity: 1;
        }
        .rc-dialog-content {
          background: var(--background-primary);
          border-radius: 0;
          height: 100%;
        }
      `,
          closeIcon: /* @__PURE__ */ jsx7(
            StyledSecondaryIconButton_default,
            {
              style: {
                position: "fixed",
                top: "var(--layout-padding)",
                right: "var(--layout-padding)",
                color: "var(--content-primary)"
              },
              themeV2,
              onClick: onClose
            },
            /* @__PURE__ */ jsx7(XClose_default, null)
          )
        },
        /* @__PURE__ */ jsx7(
          "img",
          {
            style: {
              width: "100%",
              height: "100%",
              objectFit: "contain"
            },
            src,
            alt: src
          }
        )
      );
    };
    StyledImageDialog_default = StyledImageDialog;
  }
});

// internal/src/client/themesV2/components/shared/StyledDocImage.tsx
import React100 from "react";
import { jsx as jsx8, css as css5 } from "@emotion/core";
var styles3, StyledDocImage, StyledDocImage_default;
var init_StyledDocImage = __esm({
  "internal/src/client/themesV2/components/shared/StyledDocImage.tsx"() {
    "use strict";
    init_StyledImageDialog();
    styles3 = {
      cursor: "pointer",
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    StyledDocImage = ({
      imgElement,
      themeV2
    }) => {
      const [showModal, setShowModal] = React100.useState(false);
      const handleClick = () => setShowModal(true);
      const handleKeyDown2 = (e) => {
        if (e.key === "Enter")
          handleClick();
      };
      return /* @__PURE__ */ jsx8(React100.Fragment, null, /* @__PURE__ */ jsx8("div", { onClick: handleClick, onKeyDown: handleKeyDown2, css: css5(styles3), tabIndex: 0, role: "button" }, /* @__PURE__ */ jsx8("img", { src: imgElement.src, alt: imgElement.alt })), /* @__PURE__ */ jsx8(
        StyledImageDialog_default,
        {
          themeV2,
          src: imgElement.src,
          visible: showModal,
          onClose: () => setShowModal(false)
        }
      ));
    };
    StyledDocImage_default = StyledDocImage;
  }
});

// commandbar/src/shared/components/EnrichedHtml.tsx
import React101, { useEffect as useEffect17, useRef as useRef17 } from "react";
import ReactDOM4 from "react-dom";
var EnrichedHtml;
var init_EnrichedHtml = __esm({
  "commandbar/src/shared/components/EnrichedHtml.tsx"() {
    "use strict";
    init_KeywordTooltip();
    init_useStore();
    init_ThemeV2Context();
    init_global_store();
    init_StyledDocImage();
    EnrichedHtml = ({ html, preview }) => {
      const containerRef = useRef17(null);
      const { keywords } = preview ? emptyGlobalStore() : useStore();
      const themeV2 = useThemeV2Context();
      useEffect17(() => {
        const container = containerRef.current;
        if (!container)
          return;
        container.innerHTML = html;
      }, [html]);
      useEffect17(() => {
        const container = containerRef.current;
        if (!container)
          return;
        const imgs = container.querySelectorAll("img");
        imgs.forEach((img) => {
          var _a2;
          const wrapperDiv = document.createElement("div");
          (_a2 = img.parentNode) == null ? void 0 : _a2.replaceChild(wrapperDiv, img);
          ReactDOM4.render(/* @__PURE__ */ React101.createElement(StyledDocImage_default, { themeV2, imgElement: img }), wrapperDiv);
        });
        return () => {
          imgs.forEach((img) => {
            const wrapperDiv = img.parentElement;
            if (wrapperDiv) {
              ReactDOM4.unmountComponentAtNode(wrapperDiv);
            }
          });
        };
      }, [html, themeV2]);
      useEffect17(() => {
        const container = containerRef.current;
        if (!container || keywords.length === 0)
          return;
        const matchedKeywords = /* @__PURE__ */ new Set();
        const replaceKeywordInText = (text, keyword, definition) => {
          const regex = new RegExp(`(?<!definition="[^"]*|style="[^"]*)\\b${keyword}(s)?\\b`, "i");
          return text.replace(regex, (match2) => {
            matchedKeywords.add(keyword);
            return `<span data-definition="${definition}">${match2}</span>`;
          });
        };
        const keywordslist = keywords.slice().sort((a, b) => b.keyword.length - a.keyword.length);
        const replaceKeywords = (node) => {
          var _a2;
          if (node.nodeType === Node.TEXT_NODE) {
            let textContent = node.textContent || "";
            for (const keywordObj of keywordslist) {
              if (!keywordObj.keyword || !keywordObj.is_live || matchedKeywords.has(keywordObj.keyword))
                continue;
              textContent = replaceKeywordInText(textContent, keywordObj.keyword, keywordObj.definition);
            }
            if (textContent !== node.textContent || "") {
              const newSpan = document.createElement("span");
              newSpan.innerHTML = textContent;
              (_a2 = node.parentNode) == null ? void 0 : _a2.replaceChild(newSpan, node);
            }
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            Array.from(node.childNodes).forEach(replaceKeywords);
          }
        };
        replaceKeywords(container);
        const spans = container.querySelectorAll("span[data-definition]");
        spans.forEach((span) => {
          const definition = span.getAttribute("data-definition");
          const spanContent = span.textContent;
          ReactDOM4.render(
            /* @__PURE__ */ React101.createElement(KeywordTooltip, { themeV2, content: definition }, spanContent),
            span
          );
        });
        return () => {
          spans.forEach((span) => {
            ReactDOM4.unmountComponentAtNode(span);
          });
        };
      }, [html, keywords, themeV2]);
      return /* @__PURE__ */ React101.createElement("div", { ref: containerRef });
    };
  }
});

// commandbar/src/products/helphub/components/ZendeskDoc.tsx
import React102, { useEffect as useEffect18, useState as useState11 } from "react";
var PLACEHOLDER_IMAGE, ZendeskDoc, ZendeskDoc_default;
var init_ZendeskDoc = __esm({
  "commandbar/src/products/helphub/components/ZendeskDoc.tsx"() {
    "use strict";
    init_sanitizeHtml();
    init_helpdocService();
    init_useStore();
    init_EnrichedHtml();
    PLACEHOLDER_IMAGE = "data:image/svg+xml;base64,CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMSAxIj48cGF0aCBkPSJNMCAwaDF2MUgwIiBmaWxsPSIjODg4Ii8+PC9zdmc+";
    ZendeskDoc = ({ docHtml, commandId }) => {
      var _a2;
      const _ = useStore();
      const [htmlContent, setHtmlContent] = useState11("");
      useEffect18(() => {
        var _a3;
        if (!((_a3 = _.organization) == null ? void 0 : _a3.id))
          return;
        const doc = document.implementation.createHTMLDocument();
        const div = doc.createElement("div");
        div.innerHTML = sanitizeHtml_default(docHtml);
        const imgTags = Array.from(div.querySelectorAll("img"));
        const imagesToLoad = [];
        for (const imgTag of imgTags) {
          const imgSrc = imgTag.getAttribute("src");
          if (!imgSrc)
            continue;
          if (imgTag.getAttribute("data-load-as-zd-article-attachment") === "true") {
            imgTag.setAttribute("src", PLACEHOLDER_IMAGE);
            imgTag.setAttribute("data-src", imgSrc);
          }
          imagesToLoad.push(imgTag);
        }
        setHtmlContent(div.innerHTML);
        for (const imgTag of imagesToLoad) {
          const imgSrc = imgTag.getAttribute("data-src");
          if (imgSrc) {
            helpdocService_default.getZendeskHelpdocAttachment(_.organization.id, commandId, _.endUser, imgSrc).then((blob) => {
              const blobUrl = URL.createObjectURL(blob);
              imgTag.setAttribute("src", blobUrl);
              setHtmlContent(div.innerHTML);
            });
          }
        }
      }, [(_a2 = _.organization) == null ? void 0 : _a2.id, commandId, _.endUser, docHtml]);
      return /* @__PURE__ */ React102.createElement(EnrichedHtml, { html: htmlContent });
    };
    ZendeskDoc_default = ZendeskDoc;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHub.tsx
import React103 from "react";
var HelpHub, FadingHelpHub, StyledHelpHub, StyledHelpHub_default;
var init_StyledHelpHub = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHub.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    HelpHub = styled_browser_esm_default.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  border-radius: 0px 0px var(--layout-radius-card) var(--layout-radius-card);
  background: var(--background-primary);

  z-index: ${Z_default.Z_HELPHUB};
`;
    FadingHelpHub = styled_browser_esm_default(HelpHub)`
  background: linear-gradient(var(--form-control-active-background) 20%, var(--background-primary) 40%);
`;
    StyledHelpHub = React103.forwardRef(
      ({ fading, children, ...props2 }, ref12) => {
        return !!fading ? /* @__PURE__ */ React103.createElement(FadingHelpHub, { ref: ref12, ...props2 }, children) : /* @__PURE__ */ React103.createElement(HelpHub, { ref: ref12, ...props2 }, children);
      }
    );
    StyledHelpHub_default = StyledHelpHub;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHeader.tsx
import React104 from "react";
var Header, StyledHeader, StyledHeader_default;
var init_StyledHeader = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Header = styled_browser_esm_default.div`
  display: flex;
  width: 100%;
  padding: var(--layout-padding);
  justify-content: space-between;
  align-items: center;
`;
    StyledHeader = React104.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React104.createElement(Header, { ref: ref12, ...props2 }, children);
      }
    );
    StyledHeader_default = StyledHeader;
  }
});

// internal/src/client/themesV2/components/helphub/StyledDoc.tsx
import React105 from "react";
var Doc, StyledDoc, StyledDoc_default;
var init_StyledDoc = __esm({
  "internal/src/client/themesV2/components/helphub/StyledDoc.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Doc = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: var(--layout-padding);
  gap: 4px;
  flex: 1 0 0;
  align-self: stretch;
  overflow: auto;

  color: var(--content-secondary);

  /* HelpHub/Paragraph */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-normal);
`;
    StyledDoc = React105.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React105.createElement(Doc, { ref: ref12, ...props2 }, children);
      }
    );
    StyledDoc_default = StyledDoc;
  }
});

// internal/src/client/themesV2/components/helphub/StyledDocTitle.tsx
import React106 from "react";
var Title, StyledDocTitle, StyledDocTitle_default;
var init_StyledDocTitle = __esm({
  "internal/src/client/themesV2/components/helphub/StyledDocTitle.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Title = styled_browser_esm_default.div`
  display: flex;
  padding-bottom: 8px;
  align-items: flex-start;
  align-self: stretch;

  color: var(--content-primary);

  /* HelpHub/H1 */
  font-family: var(--font-font-family);
  font-size: var(--font-size-extra-large);
  font-weight: var(--font-weight-bold);
  line-height: var(--font-line-height-tight);
`;
    StyledDocTitle = React106.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React106.createElement(Title, { ref: ref12, ...props2 }, children);
      }
    );
    StyledDocTitle_default = StyledDocTitle;
  }
});

// internal/src/client/themesV2/components/helphub/StyledDocContent.tsx
import React107 from "react";
var Content2, StyledDocContent, StyledDocContent_default;
var init_StyledDocContent = __esm({
  "internal/src/client/themesV2/components/helphub/StyledDocContent.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Content2 = styled_browser_esm_default.div`
  width: 100%;

  img {
    all: unset;
    display: block;
    max-width: 100%;
    height: auto;
    box-shadow: var(--form-control-shadow) var(--form-control-shadow-color);
    border: 1px solid var(--border-primary);
    margin: 1em auto;
  }
  mark {
    padding: 0;
    color: var(--content-secondary);
    border-radius: 2px;
    background-color: var(--highlight-color);
  }
  p:empty {
    display: none;
  }
  ol,
  ul {
    padding-inline-start: 0.5rem;
    margin-block-end: 1em;
    margin-block-start: 0.4em;
  }
  li {
    text-align: left;
    padding-left: 0.5em;
    margin-left: 1em;
  }
  a {
    all: unset;
    color: var(--content-link);
    text-decoration: underline;
    cursor: pointer;
  }
  a:visited {
    color: var(--content-link-visited);
  }
  a:hover {
    color: var(--content-link-hover);
  }
  p {
    margin-block-end: 1em;
  }
  strong {
    font-weight: var(--font-weight-bold);
  }
  b {
    font-weight: var(--font-weight-bold);
  }
  h1 {
    font-weight: var(--font-weight-bold);
    font-size: var(--font-size-extra-large);
    line-height: var(--font-line-height-tight);
    color: var(--content-primary);
    margin-block-end: 0.5em;
    text-align: left;
  }
  h2 {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-large);
    line-height: var(--font-line-height-tight);
    color: var(--content-primary);

    margin-block-start: 1em;
    margin-block-end: 0.5em;
    text-align: left;
    margin: 0;
  }
  h3 {
    font-weight: var(--font-weight-semibold);
    font-size: var(--font-size-base);
    line-height: var(--font-line-height-normal);
    color: var(--content-primary);

    margin-block-start: 1em;
    text-align: left;
  }
  h4 {
    font-weight: var(--font-weight-medium);
    font-size: var(--font-size-base);
    line-height: var(--font-line-height-normal);
    color: var(--content-primary);

    margin-block-start: 1em;
    text-align: left;
  }
  iframe {
    position: relative !important;
    max-width: 100%;
    width: 100% !important;
    height: auto;
    aspect-ratio: 16 / 9;
  }
  video {
    all: unset;
    width: 100%;
    height: auto;
    aspect-ratio: 16 / 9;
  }
  table {
    border-collapse: collapse;
  }
  thead {
    p {
      margin-block-start: 0.2em;
      margin-block-end: 0.2em;
    }
  }
  td {
    border: 1px solid var(--border-primary);
    padding: 0px 5px;
  }
  tbody {
    vertical-align: top;
    p {
      margin-block-start: 0.1em;
      margin-block-end: 0.1em;
    }
  }
  div {
    margin-block-end: 0.8em;
  }

  // Do not add extra margin to divs nested > 3 levels deep
  // Otherwise, there is too much whitespace in e.g. Notion docs
  div div div div {
    margin-block-end: 0;
  }

  pre {
    white-space: pre;
  }

  button {
    all: unset;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: relative;
    white-space: nowrap;
    vertical-align: middle;
    outline: transparent solid 2px;
    outline-offset: 2px;
    line-height: var(--font-line-height-tight);
    border-radius: 0.375em;
    font-weight: var(--font-weight-medium);
    transition-property: background-color, color, transform;
    height: 2em;
    min-width: 2em;
    font-size: 0.875em;
    padding-inline-start: 0.75em;
    padding-inline-end: 0.75em;
    background-color: var(--button-primary-background);
    color: var(--button-primary-content);
    &:hover {
      background-color: var(--button-primary-background-hover);
    }
  }
`;
    StyledDocContent = ({ children }) => {
      return /* @__PURE__ */ React107.createElement(Content2, null, children);
    };
    StyledDocContent_default = StyledDocContent;
  }
});

// internal/src/client/themesV2/components/shared/StyledButtonGroup.tsx
import React108 from "react";
var Container3, StyledButtonGroup, StyledButtonGroup_default;
var init_StyledButtonGroup = __esm({
  "internal/src/client/themesV2/components/shared/StyledButtonGroup.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container3 = styled_browser_esm_default.div`
  display: flex;
  align-items: flex-start;
  gap: var(--layout-gap);
`;
    StyledButtonGroup = ({ children, ...props2 }) => /* @__PURE__ */ React108.createElement(Container3, { ...props2 }, children);
    StyledButtonGroup_default = StyledButtonGroup;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeVideo.tsx
import React109 from "react";
var VideoContainer2, TopBlockVideoContainer, FullHeightVideoContainer, StyledVideo, FullHeightVideo, EmbeddedVideo2, FullHeightEmbeddedVideo, Placeholder2, containerComponents, StyledNudgeVideo, StyledNudgeVideo_default;
var init_StyledNudgeVideo = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeVideo.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_location();
    init_sanitizeHtml();
    VideoContainer2 = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px var(--layout-padding) var(--layout-padding) var(--layout-padding);
`;
    TopBlockVideoContainer = styled_browser_esm_default(VideoContainer2)`
  padding: 0;
  border-radius: var(--layout-radius-card) var(--layout-radius-card) 0 0;
  overflow: hidden;
`;
    FullHeightVideoContainer = styled_browser_esm_default(VideoContainer2)`
  height: 100%;
  padding: 0;
  border-radius: 0 var(--layout-radius-card) var(--layout-radius-card) 0;
  overflow: hidden;
`;
    StyledVideo = styled_browser_esm_default.video`
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: 100%;
`;
    FullHeightVideo = styled_browser_esm_default(StyledVideo)`
  height: 100%;
`;
    EmbeddedVideo2 = styled_browser_esm_default.div`
  width: 100%;
  aspect-ratio: 16 / 9;
  position: relative;
  overflow: hidden;

  & > iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    inset: 0;
  }
`;
    FullHeightEmbeddedVideo = styled_browser_esm_default(EmbeddedVideo2)`
  height: 100%;
`;
    Placeholder2 = styled_browser_esm_default.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #f7f4ff 0%, #d5caff 100%);
`;
    containerComponents = {
      "top-block": TopBlockVideoContainer,
      "full-height": FullHeightVideoContainer,
      default: VideoContainer2
    };
    StyledNudgeVideo = ({
      type: type39,
      src,
      getPlayer: getPlayer2,
      testMode,
      variant = "default"
    }) => {
      const isEmbeddablePreview = !isValidURL(src) || !!getPlayer2(src);
      const _html = React109.useMemo(() => {
        const source = getPlayer2(src, false) || src;
        return sanitizeHtml_default(source);
      }, [src]);
      const Container27 = containerComponents[variant];
      const getPlaceholderContainerHeight = () => {
        if (variant === "full-height") {
          return "300px";
        }
        if (type39 === "modal") {
          return "220px";
        }
        return "168px";
      };
      const Embed = variant === "full-height" ? FullHeightEmbeddedVideo : EmbeddedVideo2;
      const Video = variant === "full-height" ? FullHeightVideo : StyledVideo;
      return src ? /* @__PURE__ */ React109.createElement(
        Container27,
        {
          "data-testid": "commandbar-video",
          style: {
            padding: type39 === "helphub" ? 0 : void 0
          }
        },
        isEmbeddablePreview ? !_html && testMode ? /* @__PURE__ */ React109.createElement(Embed, null, /* @__PURE__ */ React109.createElement("h2", null, "Unsupported")) : /* @__PURE__ */ React109.createElement(Embed, { dangerouslySetInnerHTML: { __html: _html } }) : /* @__PURE__ */ React109.createElement(Video, { controls: true }, /* @__PURE__ */ React109.createElement("source", { src, type: "video/mp4" }), /* @__PURE__ */ React109.createElement("track", { src: "captions_en.vtt", kind: "captions", label: "english_captions" }), "Your browser does not support HTML video.")
      ) : /* @__PURE__ */ React109.createElement(
        Container27,
        {
          "data-testid": "commandbar-video",
          style: {
            height: getPlaceholderContainerHeight(),
            padding: type39 === "helphub" ? 0 : void 0
          }
        },
        /* @__PURE__ */ React109.createElement(Placeholder2, { "data-testid": "commandbar-nudge-video-placeholder" }, /* @__PURE__ */ React109.createElement(VideoRecorder_default, { width: "24px", height: "24px" }))
      );
    };
    StyledNudgeVideo_default = StyledNudgeVideo;
  }
});

// internal/src/client/themesV2/components/shared/StyledSecondaryButton.tsx
import { css as css6, jsx as jsx9 } from "@emotion/core";
var styles4, slug2, StyledSecondaryButton, StyledSecondaryButton_default;
var init_StyledSecondaryButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledSecondaryButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_ButtonWithReset();
    styles4 = {
      display: "flex",
      width: "100%",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      color: "var(--button-secondary-content)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--button-secondary-border-color)",
      background: "var(--button-secondary-background)",
      flex: "1 1 0",
      cursor: "pointer",
      whiteSpace: "nowrap",
      userSelect: "none",
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        borderColor: "var(--button-secondary-border-color-hover)",
        background: "var(--button-secondary-background-hover)",
        color: "var(--button-secondary-content-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        background: "var(--button-secondary-background-hover)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed",
        borderColor: "var(--button-secondary-border-color)",
        background: "var(--button-secondary-background)",
        color: "var(--button-secondary-content)"
      }
    };
    slug2 = "secondaryButton";
    StyledSecondaryButton = ({
      themeV2,
      prefixIcon,
      suffixIcon,
      textWrap,
      children,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug2, themeV2);
      return /* @__PURE__ */ jsx9(
        ButtonWithReset_default,
        {
          css: [overrides, css6(styles4)],
          ...props2,
          style: { ...textWrap && { height: "unset", width: "fit-content", whiteSpace: "unset" } }
        },
        prefixIcon,
        /* @__PURE__ */ jsx9(
          "span",
          {
            style: {
              ...!textWrap && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }
            }
          },
          children
        ),
        suffixIcon
      );
    };
    StyledSecondaryButton.styles = styles4;
    StyledSecondaryButton.slug = slug2;
    StyledSecondaryButton.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx9(StyledSecondaryButton, { themeV2: { themeV2, mode } }, "Button");
    StyledSecondaryButton_default = StyledSecondaryButton;
  }
});

// internal/src/client/themesV2/components/shared/StyledPrimaryButton.tsx
import { css as css7, jsx as jsx10 } from "@emotion/core";
var styles5, slug3, StyledPrimaryButton, StyledPrimaryButton_default;
var init_StyledPrimaryButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledPrimaryButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_ButtonWithReset();
    styles5 = {
      display: "flex",
      width: "100%",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      color: "var(--button-primary-content)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--button-primary-border-color)",
      background: "var(--button-primary-background)",
      flex: "1 1 0",
      cursor: "pointer",
      whiteSpace: "nowrap",
      userSelect: "none",
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        borderColor: "var(--button-primary-border-color-hover)",
        background: "var(--button-primary-background-hover)",
        color: "var(--button-primary-content-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        background: "var(--button-primary-background-hover)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed",
        borderColor: "var(--button-primary-border-color)",
        background: "var(--button-primary-background)",
        color: "var(--button-primary-content)"
      }
    };
    slug3 = "primaryButton";
    StyledPrimaryButton = ({
      themeV2,
      prefixIcon,
      suffixIcon,
      textWrap,
      children,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug3, themeV2);
      return /* @__PURE__ */ jsx10(
        ButtonWithReset_default,
        {
          css: [overrides, css7(styles5)],
          ...props2,
          style: { ...textWrap && { height: "unset", width: "fit-content", whiteSpace: "unset" } }
        },
        prefixIcon,
        /* @__PURE__ */ jsx10(
          "span",
          {
            style: {
              ...!textWrap && {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap"
              }
            }
          },
          children
        ),
        suffixIcon
      );
    };
    StyledPrimaryButton.styles = styles5;
    StyledPrimaryButton.slug = slug3;
    StyledPrimaryButton.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx10(StyledPrimaryButton, { themeV2: { themeV2, mode } }, "Button");
    StyledPrimaryButton_default = StyledPrimaryButton;
  }
});

// internal/src/util/nudges.ts
import { get as get8 } from "lodash";
var hasNumber, calcOffsetFromInput, getNudgeStep, isPinStep;
var init_nudges = __esm({
  "internal/src/util/nudges.ts"() {
    "use strict";
    hasNumber = (str) => /\d/.test(str);
    calcOffsetFromInput = (offset6) => hasNumber(offset6) ? Number.parseInt(offset6, 10) : 0;
    getNudgeStep = (nudge, stepIndex) => get8(nudge.steps, stepIndex, void 0);
    isPinStep = (step) => (step == null ? void 0 : step.form_factor.type) === "pin";
  }
});

// commandbar/src/shared/services/analytics/v2/serializers.ts
var MAX_DEPTH, MAX_ARRAY_LENGTH, MAX_STRING_LENGTH, MAX_OBJECT_KEYS, serializeObject, _serialize;
var init_serializers = __esm({
  "commandbar/src/shared/services/analytics/v2/serializers.ts"() {
    "use strict";
    MAX_DEPTH = 3;
    MAX_ARRAY_LENGTH = 10;
    MAX_STRING_LENGTH = 100;
    MAX_OBJECT_KEYS = 50;
    serializeObject = (obj) => {
      return obj ? _serialize(obj, 0) : void 0;
    };
    _serialize = (obj, depth) => {
      if (depth > MAX_DEPTH) {
        return "...";
      }
      if (obj === null || obj === void 0) {
        return obj;
      }
      if (Array.isArray(obj)) {
        return obj.slice(0, MAX_ARRAY_LENGTH).map((item) => _serialize(item, depth + 1));
      }
      if (typeof obj === "string") {
        return obj.slice(0, MAX_STRING_LENGTH);
      }
      if (typeof obj === "object") {
        if (depth === MAX_DEPTH) {
          return "...";
        }
        const keys = Object.keys(obj).slice(0, MAX_OBJECT_KEYS);
        return keys.reduce((acc, key) => {
          acc[key] = _serialize(obj[key], depth + 1);
          return acc;
        }, {});
      }
      return obj;
    };
  }
});

// commandbar/src/shared/services/analytics/v2/track.ts
var getClient, Track;
var init_track = __esm({
  "commandbar/src/shared/services/analytics/v2/track.ts"() {
    "use strict";
    init_globals();
    init_symbols();
    init_nudges();
    init_serializers();
    getClient = () => {
      const sdk = getSDK();
      return sdk == null ? void 0 : sdk[_analytics];
    };
    Track = {
      identify: (userProperties) => {
        var _a2, _b2;
        (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
          _a2,
          "c:identify",
          {},
          {
            end_user_properties: userProperties
          },
          true
        );
      },
      decide: (decideResult, userProperties) => {
        var _a2, _b2;
        (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
          _a2,
          "c:decide",
          {},
          { decide: decideResult || void 0, end_user_properties: userProperties },
          true
        );
      },
      internal: {
        sdkMethodCalled: (method, options) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:internal:sdk_method_called", { method, options });
        }
      },
      // NOTE: The conditional chaining on `trackCBEvent` is needed because of some very old spotlight tests that only partially initialize the SDK
      spotlight: {
        /**
         * Fired whenever Spotlight is opened.
         * @param source The source of the event.
         */
        opened: (source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
            _a2,
            "c:spotlight_opened",
            {},
            {
              source
            }
          );
        },
        /**
         * Fired whenever Spotlight is closed.
         * @param inputText The text that was in the search bar when Spotlight was closed.
         */
        closed: (inputText) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:spotlight_closed", {
            inputText
          });
        },
        /**
         * Fired whenever input is typed into the search bar in Spotlight. These are debounced to once every 500ms.
         */
        searchInput: (inputText) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:spotlight_search_input", {
            inputText
          });
        },
        /**
         * Fired whenever a search is executed in Spotlight.
         */
        searchExecuted: () => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:spotlight_search_executed", {});
        },
        /**
         * Fired whenever a search result is clicked in Spotlight.
         * @param option The search result that was clicked.
         * @param inputText The text that was in the search bar when the result was clicked.
         */
        searchResultClicked: (option, inputText) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:spotlight_search_result_clicked", {
            inputText,
            option: serializeObject(option)
          });
        }
      },
      nudge: {
        /**
         * Properties that will be included on all nudge events.
         */
        _getCommonProperties: (nudge, stepIndex) => {
          const nudgeStep = getNudgeStep(nudge, stepIndex);
          const isLastStep = stepIndex === nudge.steps.length - 1;
          return {
            nudgeType: nudge.type || "unknown",
            nudgeId: nudge.id,
            nudgeStepId: nudgeStep == null ? void 0 : nudgeStep.id,
            isLastStep
          };
        },
        /**
         * Fired whenever a nudge is viewed.
         * @param nudge The nudge that was viewed.
         * @param nudgeStep The step of the nudge that was viewed.
         * @param source The source that triggered the event, if applicable.
         */
        viewed: (nudge, stepIndex, source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_viewed", Track.nudge._getCommonProperties(nudge, stepIndex), {
            source
          });
        },
        /**
         * Fired whenever a nudge is dismissed.
         * @param nudge The nudge that was dismissed.
         * @param nudgeStep The step of the nudge that was dismissed.
         */
        dismissed: (nudge, stepIndex) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_dismissed", Track.nudge._getCommonProperties(nudge, stepIndex));
        },
        /**
         * Fired whenever a nudge is snoozed.
         * @param nudge The nudge that was snoozed.
         * @param nudgeStep The step of the nudge that was snoozed.
         */
        snoozed: (nudge, stepIndex) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_snoozed", Track.nudge._getCommonProperties(nudge, stepIndex));
        },
        /**
         * Fired whenever the CTA of a nudge is clicked.
         * @param nudge The nudge that was clicked.
         * @param nudgeStep The step of the nudge that was clicked.
         */
        ctaClicked: (nudge, stepIndex, button) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_cta_clicked", {
            ...Track.nudge._getCommonProperties(nudge, stepIndex),
            button: button ? serializeObject(button) : void 0
          });
        },
        /**
         * Fired whenever a survey is submitted.
         * @param nudge The nudge that the survey was submitted for.
         * @param nudgeStep The step of the nudge that the survey was submitted for.
         * @param response The response to the survey.
         */
        surveySubmitted: (nudge, stepIndex, response2) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_survey_submitted", {
            ...Track.nudge._getCommonProperties(nudge, stepIndex),
            response: {
              type: response2.type,
              value: response2.value,
              max: "max" in response2 ? response2.max : void 0
            }
          });
        }
      },
      checklist: {
        /**
         * Properties that will be included on all nudge events.
         */
        _getCommonProperties: (checklist3, item, hasIncompleteItems2) => {
          return {
            nudgeType: "checklist",
            nudgeId: checklist3.id,
            nudgeStepId: item == null ? void 0 : item.id,
            hasIncompleteItems: hasIncompleteItems2
          };
        },
        /**
         * Fired whenever a checklist is viewed.
         * @param checklist The checklist that was viewed.
         * @param source The source that triggered the event, if applicable.
         */
        viewed: (checklist3, source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_viewed", Track.checklist._getCommonProperties(checklist3), {
            source
          });
        },
        /**
         * Fired whenever a checklist is dismissed, or when the 'Done' button is clicked and all steps are completed/skipped.
         * @param checklist The checklist that was dismissed.
         */
        dismissed: (checklist3, hasIncompleteItems2) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
            _a2,
            "c:nudge_dismissed",
            Track.checklist._getCommonProperties(checklist3, void 0, hasIncompleteItems2)
          );
        },
        /**
         * Fired whenever all the items of a checklist have been skipped or completed.
         * @param checklist The checklist that was completed.
         */
        completed: (checklist3) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_checklist_completed", Track.checklist._getCommonProperties(checklist3));
        },
        /**
         * Fired whenever a checklist item is skipped.
         * @param checklist The checklist that was dismissed.
         * @param item The item that was skipped.
         */
        itemSkipped: (checklist3, item, hasIncompleteItems2) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
            _a2,
            "c:nudge_checklist_item_skipped",
            Track.checklist._getCommonProperties(checklist3, item, hasIncompleteItems2)
          );
        },
        /**
         * Fired whenever a checklist item is completed.
         * @param checklist The checklist that was dismissed.
         * @param item The item that was completed.
         * @param hasIncompleteItems Whether there are any incomplete items left in the checklist.
         */
        itemCompleted: (checklist3, item, hasIncompleteItems2) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
            _a2,
            "c:nudge_checklist_item_completed",
            Track.checklist._getCommonProperties(checklist3, item, hasIncompleteItems2)
          );
        },
        /**
         * Fired whenever the CTA of a checklist is clicked.
         * @param checklist The checklist that was clicked.
         * @param item The item that was clicked.
         */
        ctaClicked: (checklist3, item) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:nudge_cta_clicked", {
            ...Track.checklist._getCommonProperties(checklist3, item)
          });
        }
      },
      copilot: {
        /**
         * Properties that will be included on all Copilot events.
         * @returns The properties to include in the event.
         */
        _getCommonProperties: (chatId) => {
          return {
            chatId
          };
        },
        /**
         * Fired whenever Copilot is opened.
         * @param source The source of the event.
         */
        viewed: (source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_viewed", {}, { source });
        },
        /**
         * Fired whenever a Copilot chat is started.
         * @param chatId The ID of the chat that was started.
         * @param source The source of the event.
         */
        chatStarted: (chatId, source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_chat_started", Track.copilot._getCommonProperties(chatId), {
            source
          });
        },
        /**
         * Fired whenever a Copilot chat is restarted.
         * @param chatId The ID of the chat that was restarted.
         */
        chatRestarted: (chatId) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_chat_restarted", Track.copilot._getCommonProperties(chatId));
        },
        /**
         * Fired whenever a Copilot chat is ended.
         * @param chatId The ID of the chat that was ended.
         * @param message The message that was sent to the chat.
         */
        chatMessageSent: (chatId, message) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_chat_message_sent", {
            ...Track.copilot._getCommonProperties(chatId),
            message: serializeObject(message)
          });
        },
        /**
         * Fired whenever the feedback button is clicked in Copilot.
         * @param chatId The ID of the chat that the feedback was given for.
         * @param messageId The ID of the message that the feedback was given for.
         * @param feedback The feedback that was given. -1 for negative feedback, 1 for positive feedback.
         */
        chatMessageFeedback: (chatId, messageId, feedback) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_chat_message_feedback", {
            ...Track.copilot._getCommonProperties(chatId),
            messageId,
            feedback: feedback.toString()
          });
        },
        /**
         * Fired whenever a suggested follow-up is clicked in Copilot.
         * @param copilot The current state of Copilot when the follow-up was clicked.
         */
        followUpClicked: (chatId, followUp) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_follow_up_clicked", {
            ...Track.copilot._getCommonProperties(chatId),
            followUp
          });
        },
        /**
         * Fired whenever a source is clicked in a Copilot message.
         * @param copilot The current state of Copilot when the source was clicked.
         */
        sourceClicked: (chatId, messageId, href) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_source_clicked", {
            ...Track.copilot._getCommonProperties(chatId),
            messageId,
            href
          });
        },
        /**
         * Fired whenever a link is clicked in a Copilot message.
         * @param copilot The current state of Copilot when the link was clicked.
         */
        linkClicked: (chatId, messageId, href) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_link_clicked", {
            ...Track.copilot._getCommonProperties(chatId),
            messageId,
            href
          });
        },
        /**
         * Fired whenever an experience suggestion is clicked in Copilot.
         * @param copilot The current state of Copilot when the message was scrolled.
         */
        experienceClicked: (chatId, experience) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:copilot_experience_clicked", {
            ...Track.copilot._getCommonProperties(chatId),
            experience
          });
        }
      },
      helphub: {
        /**
         * Fired whenever HelpHub is viewed.
         * @param source The source of the event.
         * @returns void
         */
        viewed: (source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(
            _a2,
            "c:helphub_viewed",
            {},
            {
              source
            }
          );
        },
        /**
         * Fired whenever input is typed into the search bar in HelpHub. These are debounced to once every 500ms.
         * @returns void
         */
        searchInput: (inputText) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_search_input", {
            inputText
          });
        },
        /**
         * Fired whenever a search is executed in HelpHub.
         * @returns void
         */
        searchExecuted: (inputText) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_search_executed", {
            inputText
          });
        },
        /**
         * Fired whenever a search result is clicked in HelpHub.
         * @param target The search result that was clicked.
         * @returns void
         */
        searchResultClicked: (result) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_search_result_clicked", {
            result: serializeObject(result)
          });
        },
        /**
         * Fired whenever a suggested query is clicked in HelpHub.
         * @param query The suggested query that was clicked.
         * @returns void
         */
        suggestedQueryClicked: (query) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_suggested_query_clicked", {
            query
          });
        },
        /**
         * Fired whenever the link to a document in HelpHub is copied.
         * @param href The URL of the document that was copied.
         * @returns void
         */
        docLinkCopied: (href) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_doc_link_copied", {
            href
          });
        },
        /**
         * Fired whenever an item in a recommendation set is clicked in HelpHub.
         * @param recommendation The recommendation that was clicked.
         */
        recommendationClicked: (recommendation) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_recommendation_clicked", {
            recommendation: serializeObject(recommendation)
          });
        },
        /**
         * Fired whenever an item in the additional resources section is clicked in HelpHub.
         * @param resource The additional resource that was clicked.
         */
        additionalResourceClicked: (resource) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:helphub_additional_resource_clicked", {
            resource: serializeObject(resource)
          });
        }
      },
      content: {
        _getCommonProperties: (helpHubState) => {
          var _a2, _b2;
          return {
            docType: (_a2 = helpHubState.hubDoc) == null ? void 0 : _a2.type,
            docId: (_b2 = helpHubState.hubDoc) == null ? void 0 : _b2.command.id
          };
        },
        /**
         * Fired whenever a piece of content is viewed. As of right now, this is only used for HelpHub.
         * @param helpHubState The current state of HelpHub when the content was viewed. This includes the current document.
         * @param source The source of where the document was opened from - if applicable.
         */
        viewed: (helpHubState, source) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:content_viewed", Track.content._getCommonProperties(helpHubState), {
            source
          });
        },
        /**
         * Fired whenever a piece of content is closed or navigated away from. As of right now, this is only used for HelpHub.
         * @param helpHubState The current state of HelpHub when the content was closed. This includes the current document.
         */
        closed: (helpHubState) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:content_closed", Track.content._getCommonProperties(helpHubState));
        },
        /**
         * Fired whenever a link in a piece of content is clicked.
         * @param helpHubState The current state of HelpHub when the link was clicked. This includes the current document.
         */
        linkClicked: (helpHubState, href) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:content_link_clicked", {
            ...Track.content._getCommonProperties(helpHubState),
            href
          });
        },
        /**
         * Fired whenever a piece of content is scrolled.
         * @param helpHubState The current state of HelpHub when the content was scrolled. This includes the current document.
         */
        scrolled: (helpHubState) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:content_scrolled", Track.content._getCommonProperties(helpHubState));
        },
        /**
         * Fired whenever the play button of a video is clicked.
         * @param helpHubState The current state of HelpHub when the play button was clicked. This includes the current document.
         */
        playClicked: (helpHubState) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:content_play_clicked", Track.content._getCommonProperties(helpHubState));
        },
        /**
         * Fired whenever the pause button of a video is clicked.
         * @param helpHubState The current state of HelpHub when the pause button was clicked. This includes the current document.
         * @todo Instrument this event
         */
        pauseClicked: (helpHubState) => {
          var _a2, _b2;
          (_b2 = (_a2 = getClient()) == null ? void 0 : _a2.trackCBEvent) == null ? void 0 : _b2.call(_a2, "c:content_pause_clicked", Track.content._getCommonProperties(helpHubState));
        }
      }
    };
  }
});

// commandbar/src/products/helphub/components/Doc.tsx
import React110, { useCallback as useCallback4, useRef as useRef18 } from "react";
import { css as css8, jsx as jsx11 } from "@emotion/core";
import chroma3 from "chroma-js";
var copyToClipboard, generateDeepLink, isHelpDocWithLink, Doc2, StyledHtml, Doc_default;
var init_Doc = __esm({
  "commandbar/src/products/helphub/components/Doc.tsx"() {
    "use strict";
    init_useAction();
    init_useStyles();
    init_useHasScroll();
    init_useStore();
    init_Reporting();
    init_Logger();
    init_EngagementTracking();
    init_detailPreview();
    init_helpers7();
    init_react();
    init_VideoContainer();
    init_sanitizeHtml();
    init_actions();
    init_global_actions();
    init_actions2();
    init_sentry();
    init_helpdocService();
    init_router();
    init_LoadingIndicator();
    init_useMobileExperience();
    init_location();
    init_ZendeskDoc();
    init_useTheme();
    init_StyledHelpHub();
    init_StyledHeader();
    init_StyledDoc();
    init_StyledDocTitle();
    init_StyledDocContent();
    init_StyledButtonGroup();
    init_StyledNudgeVideo();
    init_StyledSecondaryButton();
    init_StyledPrimaryButton();
    init_StyledSecondaryIconButton();
    init_players();
    init_ThemeV2Context();
    init_track();
    init_Interpolate();
    init_EnrichedHtml();
    copyToClipboard = async (text) => {
      var _a2;
      try {
        await navigator.clipboard.writeText(text);
      } catch (err) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
        Logger_default.error("Failed to copy text to clipboard:", err);
      }
    };
    generateDeepLink = (commandID, query) => {
      const currentUrl = new URL(window.location.href);
      const urlParams = currentUrl.searchParams;
      urlParams.set("helphub_id" /* COMMAND_ID */, encodeURIComponent(commandID));
      urlParams.set("helphub_query" /* QUERY */, encodeURIComponent(query || ""));
      return currentUrl.toString();
    };
    isHelpDocWithLink = (template) => !!template.value && template.type === "helpdoc";
    Doc2 = () => {
      var _a2, _b2, _c2;
      const { docId } = useParams();
      const { back, navigate } = useRouter();
      const _ = useStore();
      const query = _.helpHub.query;
      const styles51 = useStyles();
      const { isStudioMobilePreview } = useMobileExperience();
      const [doc, setDoc] = React110.useState(null);
      const hasScrolledCurrentDocRef = useRef18(false);
      const [startTime] = React110.useState(Date.now());
      const [showCheckIconCopyLink, setShowCheckIconCopyLink] = React110.useState(false);
      const docTemplate = doc == null ? void 0 : doc.command.template;
      const nextSteps = (doc == null ? void 0 : doc.command.next_steps) || [];
      const scrollRef = useRef18(null);
      const { hasScrolled } = useHasScroll_default(scrollRef);
      const themeV2 = useThemeV2Context();
      const resetHelpHubScrollSettings = useAction((_2) => {
        _2.helpHub.hubDocHeading = null;
      });
      const setHelpHubMinimized2 = useAction(setHelpHubMinimized);
      const executeAction2 = useAction(
        (_2, action, e) => {
          let shouldMinimizeHelpHub = true;
          if (action.type === "execute_command") {
            const command2 = _2.commands.find((c) => c.id === parseInt(action.meta.command));
            if ((command2 == null ? void 0 : command2.template.type) === "helpdoc") {
              shouldMinimizeHelpHub = false;
            }
          }
          if (shouldMinimizeHelpHub) {
            setHelpHubMinimized2(true);
          }
          executeAction(_2, action, e);
        }
      );
      React110.useEffect(() => {
        if (_.organization && docId) {
          hasScrolledCurrentDocRef.current = false;
          helpdocService_default.getHelpdoc(_, docId, query != null ? query : void 0).then((doc2) => {
            setDoc(doc2);
          });
        }
      }, [docId]);
      const scrollToFirstMark = (container) => {
        const firstMark = container.querySelector("mark");
        if (firstMark) {
          firstMark.scrollIntoView({ behavior: "smooth", block: "center" });
          return true;
        } else {
          return false;
        }
      };
      React110.useEffect(() => {
        updateScrollPosition();
      }, [_.helpHub.hubDocHeading]);
      const updateScrollPosition = () => {
        let scrolled = false;
        const performScroll = () => {
          if (scrollRef.current) {
            if (_.helpHub.hubDocHeading) {
              scrolled = findAndScrollToHeaderBasedOnHeading(_.helpHub.hubDocHeading || "");
            } else if (!hasScrolledCurrentDocRef.current) {
              scrolled = scrollToFirstMark(scrollRef.current);
            }
            if (scrolled) {
              resetHelpHubScrollSettings();
              hasScrolledCurrentDocRef.current = true;
            }
          }
        };
        setTimeout(() => {
          performScroll();
        }, 150);
      };
      const setScrollRef = useCallback4((node) => {
        scrollRef.current = node;
        updateScrollPosition();
      }, []);
      const command = doc == null ? void 0 : doc.command;
      const docEventData = {
        query: query != null ? query : void 0,
        command: command == null ? void 0 : command.id,
        third_party_id: command == null ? void 0 : command.third_party_id,
        url: (command == null ? void 0 : command.template.type) === "helpdoc" ? command.template.value : void 0,
        title: command == null ? void 0 : command.text
      };
      React110.useEffect(() => {
        if (hasScrolled) {
          helpHubDocEngagement({ ...docEventData }, "scrolled");
          Track.content.scrolled(_.helpHub);
        }
      }, [hasScrolled]);
      React110.useEffect(() => {
        if (doc) {
          helpHubDocOpened({ ...docEventData });
          Track.content.viewed(_.helpHub);
          if (scrollRef.current) {
            const h1Element = scrollRef.current.querySelector("h1");
            if ((h1Element == null ? void 0 : h1Element.innerText) === doc.command.text) {
              h1Element.style.display = "none";
            }
          }
        }
      }, [doc]);
      React110.useEffect(() => {
        const handleKeydown = (e) => {
          if (e.key === "Enter" && e.shiftKey) {
            e.preventDefault();
            e.stopPropagation();
            back();
            removeDeepLinkParams();
          }
        };
        document.addEventListener("keydown", handleKeydown);
        return () => {
          document.removeEventListener("keydown", handleKeydown);
        };
      }, []);
      const scrollToXPath = (xpath) => {
        if (scrollRef.current && xpath.length > 1) {
          const element = document.evaluate(
            xpath,
            document,
            null,
            XPathResult.FIRST_ORDERED_NODE_TYPE,
            null
          ).singleNodeValue;
          if (element) {
            element.innerHTML = `<mark>${element.textContent}</mark>`;
            element.scrollIntoView({ behavior: "smooth", block: "center" });
            return true;
          }
        }
        return false;
      };
      const findAndScrollToHeaderBasedOnAnchor = (anchor) => {
        if (anchor.length > 1) {
          const xpath = `//*[(self::h1 or self::h2 or self::h3 or self::h4 or self::h5 or self::h6 or self::a) and (translate(text(), 'ABCDEFGHIJKLMNOPQRSTUVWXYZ ', 'abcdefghijklmnopqrstuvwxyz-')='${anchor}' or @id='${anchor}')]`;
          return scrollToXPath(xpath);
        }
        return false;
      };
      const findAndScrollToHeaderBasedOnHeading = (heading) => {
        if (heading.length > 1) {
          const xpath = `//*[self::h1 or self::h2 or self::h3 or self::h4 or self::h5 or self::h6][text()='${heading}']`;
          return scrollToXPath(xpath);
        }
        return false;
      };
      const anchorClickHandler = (event) => {
        var _a3, _b3;
        helpHubDocEngagement({ ...docEventData }, "clicked_link");
        if (event.metaKey || event.ctrlKey || !((_a3 = _.organization) == null ? void 0 : _a3.id)) {
          return;
        }
        event.stopPropagation();
        event.preventDefault();
        const fullLink = (_b3 = event == null ? void 0 : event.currentTarget) == null ? void 0 : _b3.getAttribute("href");
        const [link, anchor] = fullLink ? fullLink.split("#") : [];
        Track.content.linkClicked(_.helpHub, fullLink || "");
        if (!link) {
          if (!!anchor) {
            return findAndScrollToHeaderBasedOnAnchor(anchor);
          }
          return;
        }
        helpdocService_default.getHelpdocByUrl(_.organization.id, link).then((hubDoc) => {
          if (hubDoc) {
            navigate({
              page: "docs",
              params: {
                docId: hubDoc.command.id
              }
            });
            setTimeout(() => {
              var _a4;
              if (anchor && findAndScrollToHeaderBasedOnAnchor(anchor)) {
              } else {
                (_a4 = scrollRef.current) == null ? void 0 : _a4.scrollTo(0, 0);
              }
            }, 600);
          } else {
            window.open(link);
          }
        }).catch(() => {
          window.open(link);
        });
      };
      const videoPlayHandler = () => {
        helpHubDocEngagement({ ...docEventData }, "watched_video");
        Track.content.playClicked(_.helpHub);
      };
      const openArticleLink = (value) => {
        if (isStudioPreview()) {
          window.open(value, "_blank");
        } else {
          switch (doc == null ? void 0 : doc.command.template.operation) {
            case "self":
              return window.open(value, "_self");
            case "blank":
            case "router":
            default:
              return window.open(value, "_blank");
          }
        }
      };
      const renderContent = (content) => {
        const standardized = standardize(content);
        if (!standardized)
          return null;
        return standardized.map((contentBlock, index3) => {
          var _a3, _b3, _c3;
          switch (contentBlock.type) {
            case "html":
              return ((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) ? /* @__PURE__ */ jsx11(StyledDocContent_default, { key: index3 }, ((_b3 = _.flags) == null ? void 0 : _b3["release-authed-zendesk-image-loading"]) && true && (command == null ? void 0 : command.third_party_source) === "zendesk" && command.third_party_id ? /* @__PURE__ */ jsx11(ZendeskDoc_default, { docHtml: contentBlock.value, commandId: command.id }) : /* @__PURE__ */ jsx11(EnrichedHtml, { html: sanitizeHtml_default(contentBlock.value) })) : /* @__PURE__ */ jsx11(StyledHtml, { key: index3 }, ((_c3 = _.flags) == null ? void 0 : _c3["release-authed-zendesk-image-loading"]) && true && (command == null ? void 0 : command.third_party_source) === "zendesk" && command.third_party_id ? /* @__PURE__ */ jsx11(ZendeskDoc_default, { docHtml: contentBlock.value, commandId: command.id }) : /* @__PURE__ */ jsx11(EnrichedHtml, { html: sanitizeHtml_default(contentBlock.value) }));
            default:
              throw new Error("Invalid content type");
          }
        });
      };
      if (_.helpHub.minimized)
        return null;
      return doc && docTemplate ? /* @__PURE__ */ jsx11(EngagementTracking, { anchorClickHandler, videoPlayHandler }, ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx11(StyledHelpHub_default, null, /* @__PURE__ */ jsx11(StyledHeader_default, null, /* @__PURE__ */ jsx11("div", null, /* @__PURE__ */ jsx11(
        StyledSecondaryButton_default,
        {
          themeV2,
          "data-testid": "helphub-go-back",
          onClick: () => {
            helpHubDocClosed({ ...docEventData, time_shown: (Date.now() - startTime) / 1e3 });
            Track.content.closed(_.helpHub);
            removeDeepLinkParams();
            back();
          },
          prefixIcon: /* @__PURE__ */ jsx11(ChevronLeft_default, null)
        },
        "Back"
      )), /* @__PURE__ */ jsx11(StyledButtonGroup_default, null, /* @__PURE__ */ jsx11(
        StyledSecondaryIconButton_default,
        {
          themeV2,
          disabled: isStudioPreview(),
          onClick: async () => {
            var _a3;
            try {
              const href = generateDeepLink(doc.command.id, query);
              await copyToClipboard(href);
              Track.helphub.docLinkCopied(href);
              setShowCheckIconCopyLink(true);
              setTimeout(() => {
                setShowCheckIconCopyLink(false);
              }, 2e3);
            } catch (e) {
              (_a3 = getSentry()) == null ? void 0 : _a3.captureException(e);
            }
          }
        },
        showCheckIconCopyLink ? /* @__PURE__ */ jsx11(Check_default, null) : /* @__PURE__ */ jsx11(Link04_default, null)
      ), isHelpDocWithLink(docTemplate) && !((_b2 = doc.command.integration) == null ? void 0 : _b2.helphub_view_article_button_hidden) && /* @__PURE__ */ jsx11(
        StyledSecondaryButton_default,
        {
          themeV2,
          onClick: (e) => {
            if (e.metaKey || e.ctrlKey) {
              window.open(docTemplate.value, "_blank");
            }
            openArticleLink(docTemplate.value);
          },
          suffixIcon: /* @__PURE__ */ jsx11(ArrowUpRight_default, { height: 14, style: { flexShrink: "0" } })
        },
        interpolate(_.localizedMessages["helphub.view-article-button-label"], _, true, false)
      ))), /* @__PURE__ */ jsx11(StyledDoc_default, { className: "commandbar-helphub-article", ref: setScrollRef }, /* @__PURE__ */ jsx11(StyledDocTitle_default, { "data-testid": "helphub-article-title" }, doc.command.text), doc.type === "video" && doc.command.template.type === "video" ? /* @__PURE__ */ jsx11("div", { style: { width: "100%" } }, /* @__PURE__ */ jsx11("div", null, doc.excerpt), /* @__PURE__ */ jsx11(
        StyledNudgeVideo_default,
        {
          src: doc.command.template.value,
          type: "helphub",
          getPlayer: players_default,
          testMode: _.testMode
        }
      )) : renderContent(doc.command.content), nextSteps.length > 0 && /* @__PURE__ */ jsx11(StyledButtonGroup_default, null, nextSteps.map(
        (nextStep, index3) => isAction(nextStep) && !!nextStep.cta && /* @__PURE__ */ jsx11(
          StyledPrimaryButton_default,
          {
            themeV2,
            key: index3,
            onClick: (e) => {
              executeAction2(nextStep.action, e);
            }
          },
          nextStep.cta
        )
      )))) : /* @__PURE__ */ jsx11("div", { css: styles51.docContainer }, /* @__PURE__ */ jsx11("div", { css: styles51.docHeader }, /* @__PURE__ */ jsx11(
        "button",
        {
          "data-testid": "helphub-go-back",
          css: { ...styles51.docHeaderButton, width: "72px" },
          onClick: () => {
            helpHubDocClosed({ ...docEventData, time_shown: (Date.now() - startTime) / 1e3 });
            Track.content.closed(_.helpHub);
            removeDeepLinkParams();
            back();
          }
        },
        /* @__PURE__ */ jsx11(ChevronLeft_default, { height: 14 }),
        /* @__PURE__ */ jsx11("span", null, "Back")
      ), /* @__PURE__ */ jsx11("div", { css: styles51.docHeaderRight }, /* @__PURE__ */ jsx11(
        "button",
        {
          type: "button",
          disabled: isStudioPreview(),
          css: {
            ...styles51.docHeaderButton,
            padding: isStudioMobilePreview ? "0px" : "8px",
            width: "40px",
            ":disabled": { cursor: "not-allowed" }
          },
          onClick: async () => {
            var _a3;
            try {
              const href = generateDeepLink(doc.command.id, query);
              await copyToClipboard(href);
              Track.helphub.docLinkCopied(href);
              setShowCheckIconCopyLink(true);
              setTimeout(() => {
                setShowCheckIconCopyLink(false);
              }, 2e3);
            } catch (e) {
              (_a3 = getSentry()) == null ? void 0 : _a3.captureException(e);
            }
          }
        },
        showCheckIconCopyLink ? /* @__PURE__ */ jsx11(Check_default, { height: 16 }) : /* @__PURE__ */ jsx11(Link04_default, { height: 16 })
      ), isHelpDocWithLink(docTemplate) && !((_c2 = doc.command.integration) == null ? void 0 : _c2.helphub_view_article_button_hidden) && /* @__PURE__ */ jsx11(
        "button",
        {
          css: {
            ...styles51.docHeaderButton,
            width: "auto",
            maxWidth: "176px",
            padding: isStudioMobilePreview ? "0px 12px 0px 8px" : styles51.docHeaderButton.padding,
            ":disabled": { cursor: "not-allowed" }
          },
          onClick: (e) => {
            if (e.metaKey || e.ctrlKey) {
              window.open(docTemplate.value, "_blank");
            }
            openArticleLink(docTemplate.value);
          }
        },
        /* @__PURE__ */ jsx11(
          "span",
          {
            style: {
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden"
            }
          },
          interpolate(styles51.strings.docLinkText, _, true, false)
        ),
        /* @__PURE__ */ jsx11(ArrowUpRight_default, { height: 14, style: { flexShrink: "0" } })
      ))), /* @__PURE__ */ jsx11(
        "div",
        {
          style: { height: "calc(100% - 66px)", overflowY: "auto", paddingBottom: "50px" },
          className: "commandbar-helphub-article",
          ref: setScrollRef
        },
        /* @__PURE__ */ jsx11("div", { "data-testid": "helphub-article-title", css: styles51.docTitle }, doc.command.text),
        doc.type === "video" && doc.command.template.type === "video" && /* @__PURE__ */ jsx11("div", { css: styles51.docExcerpt }, doc.excerpt),
        /* @__PURE__ */ jsx11("div", { css: styles51.docContent }, doc.type === "video" && doc.command.template.type === "video" ? /* @__PURE__ */ jsx11(
          VideoContainer_default,
          {
            source: doc.command.template.value,
            containerStyles: { height: "auto", margin: "8px 0", padding: 0 },
            autoPlay: false
          }
        ) : renderContent(doc.command.content), nextSteps.length > 0 && /* @__PURE__ */ jsx11(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              gap: "8px",
              padding: "0px",
              alignItems: "flex-start",
              marginTop: "8px"
            }
          },
          nextSteps.map(
            (nextStep, index3) => isAction(nextStep) && !!nextStep.cta && /* @__PURE__ */ jsx11(
              "button",
              {
                key: index3,
                onClick: (e) => {
                  executeAction2(nextStep.action, e);
                },
                style: {
                  width: "100%",
                  border: "none",
                  cursor: "pointer",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  background: "#0A0A0F",
                  color: "#FFFFFF",
                  borderRadius: "4px",
                  padding: "11px 12px",
                  fontSize: "14px",
                  lineHeight: "18px",
                  fontWeight: "600",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "4px"
                }
              },
              nextStep.cta
            )
          )
        ))
      ))) : /* @__PURE__ */ jsx11("div", { css: styles51.docContainer, style: { display: "flex", flexDirection: "column" } }, /* @__PURE__ */ jsx11("div", { css: styles51.docHeader }, /* @__PURE__ */ jsx11(
        "button",
        {
          "data-testid": "helphub-go-back",
          css: { ...styles51.docHeaderButton, width: "72px" },
          onClick: () => {
            helpHubDocClosed({ ...docEventData, time_shown: (Date.now() - startTime) / 1e3 });
            Track.content.closed(_.helpHub);
            removeDeepLinkParams();
            back();
          }
        },
        /* @__PURE__ */ jsx11(ChevronLeft_default, { height: 14 }),
        /* @__PURE__ */ jsx11("span", null, "Back")
      )), /* @__PURE__ */ jsx11("div", { style: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center" } }, /* @__PURE__ */ jsx11(LoadingIndicator_default, { isLoading: true, size: 30 })));
    };
    StyledHtml = ({ children }) => {
      const { theme } = useTheme();
      const styles51 = useStyles();
      return /* @__PURE__ */ jsx11(
        "div",
        {
          css: css8`
        img {
          display: block;
          max-width: 100%;
          height: auto;
          box-shadow: ${theme.main.boxShadow};
          border: 1px solid ${theme.main.borderColors};
          margin: 1em auto;
        }
        mark {
          padding: 0;
          transition: background-color ${theme.main.transitionTime} ease;
          color: ${styles51.highlightMark.color};
          border-radius: ${styles51.highlightMark.borderRadius};
          background-color: ${styles51.highlightMark.backgroundColor};
        }
        p:empty {
          display: none;
        }
        ol,
        ul {
          padding-inline-start: 0.5rem;
          margin-block-end: 1em;
          margin-block-start: 0.4em;
        }
        li {
          text-align: left;
          padding-left: 0.5em;
          margin-left: 1em;
        }
        a {
          color: ${theme.helpHubDocItem.linkColor};
          text-decoration: underline;
        }
        a:visited {
          color: ${theme.helpHubDocItem.visitedLinkColor};
        }
        p {
          margin-block-end: 1em;
        }
        strong {
          font-weight: 600;
        }
        h1 {
          font-weight: ${theme.helpHubDocItem.contentHeadingOneFontWeight};
          font-size: ${theme.helpHubDocItem.contentHeadingOneFontSize};
          line-height: ${theme.helpHubDocItem.contentHeadingOneLineHeight};
          color: ${theme.helpHubDocItem.contentHeadingOneColor || theme.helpHubDocItem.titleColor};
          margin-block-end: 0.5em;
          text-align: left;
        }
        h2 {
          font-weight: ${theme.helpHubDocItem.contentHeadingTwoFontWeight};
          font-size: ${theme.helpHubDocItem.contentHeadingTwoFontSize};
          line-height: ${theme.helpHubDocItem.contentHeadingTwoLineHeight};
          color: ${theme.helpHubDocItem.contentHeadingTwoColor || theme.helpHubDocItem.titleColor};

          margin-block-start: 1em;
          text-align: left;
          margin: 0;
        }
        h3 {
          font-weight: ${theme.helpHubDocItem.contentHeadingThreeFontWeight};
          font-size: ${theme.helpHubDocItem.contentHeadingThreeFontSize};
          line-height: ${theme.helpHubDocItem.contentHeadingThreeLineHeight};
          color: ${theme.helpHubDocItem.contentHeadingThreeColor || theme.helpHubDocItem.titleColor};

          margin-block-start: 1.7em;
          text-align: left;
        }
        h4 {
          font-weight: ${theme.helpHubDocItem.contentHeadingFourFontWeight};
          font-size: ${theme.helpHubDocItem.contentHeadingFourFontSize};
          line-height: ${theme.helpHubDocItem.contentHeadingFourLineHeight};
          color: ${theme.helpHubDocItem.contentHeadingFourColor || theme.helpHubDocItem.titleColor};

          margin-block-start: 1.7em;
          text-align: left;
        }
        iframe {
          position: relative !important;
          max-width: 100%;
          width: 100% !important;
          height: auto;
          aspect-ratio: 16 / 9;
        }
        video {
          width: 100%;
          height: auto;
          aspect-ratio: 16 / 9;
        }
        table {
          border-collapse: collapse;
        }
        thead {
          p {
            margin-block-start: 0.2em;
            margin-block-end: 0.2em;
          }
        }
        td {
          border: 1px solid ${theme.main.borderColors};
          padding: 0px 5px;
        }
        tbody {
          vertical-align: top;
          p {
            margin-block-start: 0.1em;
            margin-block-end: 0.1em;
          }
        }
        div {
          margin-block-end: 0.8em;
        }

        pre {
          white-space: pre;
        }

        button {
          all: unset;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          position: relative;
          white-space: nowrap;
          vertical-align: middle;
          outline: transparent solid 2px;
          outline-offset: 2px;
          line-height: 1.2;
          border-radius: 0.375em;
          font-weight: 500;
          transition-property: background-color, color, transform;
          transition-duration: ${theme.main.transitionTime};
          height: 2em;
          min-width: 2em;
          font-size: 0.875em;
          padding-inline-start: 0.75em;
          padding-inline-end: 0.75em;
          background-color: ${theme.helpHubDocItem.contentButtonBackgroundColor};
          color: ${theme.helpHubDocItem.contentButtonColor};
          &:hover {
            background-color: ${chroma3.valid(theme.helpHubDocItem.contentButtonBackgroundColor) ? chroma3(theme.helpHubDocItem.contentButtonBackgroundColor).darken(0.25).css() : theme.helpHubDocItem.contentButtonBackgroundColor};
          }
        }
      `
        },
        children
      );
    };
    Doc_default = Doc2;
  }
});

// commandbar/src/products/helphub/store/helpers.ts
import partition2 from "lodash/partition";
var commandToHelpHubDoc, findHighestScoringSet, isLocationSpecificCondition, findMostSpecificRecommendationSet, removeDeepLinkParams;
var init_helpers7 = __esm({
  "commandbar/src/products/helphub/store/helpers.ts"() {
    "use strict";
    init_rules();
    init_Doc();
    commandToHelpHubDoc = (command, hit) => {
      switch (command.template.type) {
        case "video":
        case "link":
        case "helpdoc":
          return {
            type: command.template.type,
            excerpt: (hit == null ? void 0 : hit.excerpt) || command.explanation,
            command
          };
        default:
          return {
            type: "other",
            excerpt: (hit == null ? void 0 : hit.excerpt) || command.explanation,
            command
          };
      }
    };
    findHighestScoringSet = (recommendationSets) => {
      if (recommendationSets.length === 0) {
        return null;
      }
      return recommendationSets.reduce((highestScoringSet, recommendationSet) => {
        const highestScore = scoreRecommendationSet(highestScoringSet);
        const currentScore = scoreRecommendationSet(recommendationSet);
        if (currentScore > highestScore) {
          return recommendationSet;
        } else if (currentScore === highestScore) {
          return highestScoringSet.default && !recommendationSet.default ? recommendationSet : highestScoringSet;
        } else {
          return highestScoringSet;
        }
      }, recommendationSets[0]);
    };
    isLocationSpecificCondition = (expression) => {
      const conditions = getConditions(expression);
      return conditions.some((condition) => condition.type === "url" || condition.type === "element");
    };
    findMostSpecificRecommendationSet = (recommendationSets) => {
      if (recommendationSets.length === 0) {
        return null;
      }
      const [locationSpecificSets, generalSets] = partition2(
        recommendationSets,
        (recommendationSet) => isLocationSpecificCondition(recommendationSet.show_expression) || recommendationSet.audience.type === "rule_expression" && isLocationSpecificCondition(recommendationSet.audience.expression)
      );
      const highestScoringLocationSpecific = findHighestScoringSet(locationSpecificSets);
      if (highestScoringLocationSpecific) {
        return highestScoringLocationSpecific;
      }
      return findHighestScoringSet(generalSets);
    };
    removeDeepLinkParams = () => {
      const currentUrl = new URL(window.location.href);
      const urlParams = currentUrl.searchParams;
      urlParams.delete("helphub_id" /* COMMAND_ID */);
      urlParams.delete("helphub_query" /* QUERY */);
      window.history.replaceState({}, "", currentUrl);
    };
  }
});

// commandbar/src/products/helphub/store/selectors.ts
var isCopilotOnlyMode, isHelpHubWidgetAvailable, getHelpHubRecommendations;
var init_selectors4 = __esm({
  "commandbar/src/products/helphub/store/selectors.ts"() {
    "use strict";
    init_LocalStorage();
    init_helpers6();
    init_helpers7();
    init_executable_selectors();
    init_audience2();
    isCopilotOnlyMode = (_) => {
      var _a2, _b2;
      if (!!LocalStorage_default.get("chatOnlyMode", false)) {
        return true;
      }
      if (_.helpHub.chatOnly) {
        return true;
      }
      return Boolean(!_.showWidgetTableau && ((_a2 = _ == null ? void 0 : _.organization) == null ? void 0 : _a2.copilot_enabled) && !((_b2 = _ == null ? void 0 : _.organization) == null ? void 0 : _b2.helphub_enabled));
    };
    isHelpHubWidgetAvailable = (_) => {
      var _a2, _b2;
      return !!(((_a2 = _.organization) == null ? void 0 : _a2.helphub_enabled) || ((_b2 = _.organization) == null ? void 0 : _b2.copilot_enabled)) && _.products.includes("help_hub");
    };
    getHelpHubRecommendations = async (_) => {
      var _a2;
      if (_.helpHub.previewedRecommendationSet) {
        const recommendationSet = _.helpHub.previewedRecommendationSet;
        if (recommendationSet) {
          const actionsAvailability = await Promise.all(
            recommendationSet.actions.map((action) => actionIsAvailable(_, action.action))
          );
          return recommendationSet.actions.filter((_2, index3) => actionsAvailability[index3]);
        }
      }
      const passesPageConditions2 = ({ show_expression }) => !show_expression || runBooleanExpression(show_expression, _, "").passed;
      const validRecommendationSets = (_a2 = _.helpHub.recommendationSets) == null ? void 0 : _a2.filter(
        (set3) => set3.is_live && passesAudienceConditions(_, "recommendation_sets", set3) && passesPageConditions2(set3)
      );
      if (validRecommendationSets == null ? void 0 : validRecommendationSets.length) {
        const mostSpecificRecommendationSet = findMostSpecificRecommendationSet(validRecommendationSets);
        if (mostSpecificRecommendationSet) {
          const actionsAvailability = await Promise.all(
            mostSpecificRecommendationSet.actions.map((action) => actionIsAvailable(_, action.action))
          );
          const availableActions = mostSpecificRecommendationSet.actions.filter((_2, index3) => actionsAvailability[index3]);
          return availableActions;
        }
      }
      return [];
    };
  }
});

// commandbar/src/products/helphub/service-selectors.ts
var init_service_selectors = __esm({
  "commandbar/src/products/helphub/service-selectors.ts"() {
    "use strict";
    init_selectors4();
    init_helpers7();
  }
});

// commandbar/src/shared/services/services/helpdocService.ts
var HelpdocService, helpdocService, helpdocService_default;
var init_helpdocService = __esm({
  "commandbar/src/shared/services/services/helpdocService.ts"() {
    "use strict";
    init_service_selectors();
    init_helpDocsSearch();
    init_global_selectors();
    init_organization();
    init_network();
    HelpdocService = class {
      constructor() {
        this.cache = /* @__PURE__ */ new Map();
        this.cacheLimit = 100;
      }
      getCacheKey(docId, query) {
        return `${docId}${query || ""}`;
      }
      addToCache(commandId, hit, query) {
        const cacheKey = this.getCacheKey(commandId, query);
        if (this.cache.size >= this.cacheLimit) {
          this.cache.delete(this.cache.keys().next().value);
        }
        this.cache.set(cacheKey, hit);
      }
      async getHelpdocHit(orgId, commandId, endUser, query, ignoreCache) {
        if (!orgId) {
          return null;
        }
        if (!ignoreCache) {
          const cacheKey = this.getCacheKey(commandId, query);
          if (this.cache.has(cacheKey)) {
            return this.cache.get(cacheKey) || null;
          }
        }
        const response2 = await HelpDocsSearch.search(
          orgId,
          {
            query,
            doc_id: commandId,
            expand_rules: true
          },
          {
            headers: {
              ...!!(endUser == null ? void 0 : endUser.hmac) && { "X-USER-AUTHORIZATION": endUser == null ? void 0 : endUser.hmac },
              ...!!(endUser == null ? void 0 : endUser.slug) && { "X-USER-ID": endUser == null ? void 0 : endUser.slug }
            }
          }
        );
        const searchResults = response2.data;
        if (searchResults && searchResults.length > 0) {
          this.addToCache(commandId, searchResults[0].hit, query);
          return searchResults[0].hit;
        }
        return null;
      }
      async getHelpdocCommand(_, commandId) {
        var _a2;
        const command = getLocalCommandOrHelpdoc(_, commandId);
        if ((command == null ? void 0 : command.template.type) === "helpdoc") {
          return command;
        }
        const hit = await this.getHelpdocHit((_a2 = _.organization) == null ? void 0 : _a2.id, commandId, _.endUser);
        if (hit) {
          return hit.command;
        }
        return null;
      }
      async getHelpdoc(_, commandId, query, ignoreCache = false) {
        var _a2;
        if (!query && !ignoreCache) {
          const command = getLocalCommandOrHelpdoc(_, commandId);
          if ((command == null ? void 0 : command.template.type) === "helpdoc" && (command == null ? void 0 : command.template.doc_type) !== "answer") {
            return commandToHelpHubDoc(command);
          }
        }
        const hit = await this.getHelpdocHit((_a2 = _.organization) == null ? void 0 : _a2.id, commandId, _.endUser, query, ignoreCache);
        if (hit) {
          return commandToHelpHubDoc(hit.command, hit);
        }
        return null;
      }
      async getCommandOrHelpdoc(_, commandId) {
        var _a2;
        const command = getLocalCommandOrHelpdoc(_, commandId);
        if (command) {
          return command;
        }
        const hit = await this.getHelpdocHit((_a2 = _.organization) == null ? void 0 : _a2.id, commandId, _.endUser);
        if (hit) {
          return hit.command;
        }
        return null;
      }
      // FIXME: We allow getting HelpDocs by ID/URL, which is an issue with private helpdocs that have public or guessable URLs
      async getHelpdocByUrl(orgId, url) {
        const command = await getCommandByUrl(`${orgId}`, url);
        if (command) {
          this.addToCache(command.id, { command, excerpt: "", score: [0] });
          return commandToHelpHubDoc(command);
        }
        return null;
      }
      async getZendeskHelpdocAttachment(orgId, commandId, endUser, contentUrl) {
        const { hmac, slug: slug21 } = endUser || {};
        const baseURL = getBaseURL();
        const result = await fetch(
          `${baseURL}/organizations/${orgId}/commands/${commandId}/zendesk_article_attachment/?content_url=${encodeURIComponent(
            contentUrl
          )}`,
          {
            method: "GET",
            headers: {
              ...getFetchHeaders(),
              ...hmac && { "X-USER-AUTHORIZATION": hmac },
              ...slug21 && { "X-USER-ID": slug21 }
            }
          }
        );
        return await result.blob();
      }
    };
    helpdocService = new HelpdocService();
    helpdocService_default = helpdocService;
  }
});

// commandbar/src/products/nudges/store/selectors.ts
import dayjs3 from "dayjs";
import isEqual3 from "lodash/isEqual";
var MAX_RENDERED_NUDGES, getAllNudgeServices, getDebugService, getNudgeService, getNudgeServiceSnapshot, getNudgeById, getAllNudges, getDebuggedNudge, getRenderingServices, getSmartNudges, hasRageTrigger, hasSmartDelayTrigger, hasUserConfusionTrigger, isNudgeDismissible, isNudgeSnoozable, passesMaxRenderedNudges, isScheduledNudge, passesSchedule, passesGlobalLimit, passesStatus, passesFrequencyCondition, passesSnoozedConditions, passesPageConditions, passesFlip, passesTriggerMatch, stepHasTargetElement, hasRemainingSteps, getAllNudgeDataFromUserStore, getNudgeDataFromUserStore, passesPinnedElement, shouldBypassGlobalLimit, evaluateCondition, getImmediateAction, getActionBasedOnConditions, determineAction, isTooltipStep, isTooltipNudge, isBannerStep, isBannerNudge, isNoGlobalLimitFormFactorStep, isCursorStep, getPinAnchors;
var init_selectors5 = __esm({
  "commandbar/src/products/nudges/store/selectors.ts"() {
    "use strict";
    init_LocalStorage();
    init_dom();
    init_helpdocService();
    init_helpers6();
    init_global_selectors();
    init_nudges();
    MAX_RENDERED_NUDGES = 1;
    getAllNudgeServices = (_) => {
      var _a2, _b2;
      return (_b2 = (_a2 = _.nudgeManager) == null ? void 0 : _a2.getSnapshot()) == null ? void 0 : _b2.context.nudgeMachines;
    };
    getDebugService = (_) => {
      var _a2, _b2;
      const debuggingNudge = (_b2 = (_a2 = _.nudgeManager) == null ? void 0 : _a2.getSnapshot()) == null ? void 0 : _b2.context.debugMode.currentNudge;
      if (debuggingNudge) {
        return getNudgeService(_, debuggingNudge.id);
      }
    };
    getNudgeService = (_, id2) => {
      var _a2;
      return (_a2 = _.nudgeManager) == null ? void 0 : _a2.getSnapshot().context.nudgeMachines.get(id2.toString());
    };
    getNudgeServiceSnapshot = (_, id2) => {
      var _a2;
      return (_a2 = getNudgeService(_, id2)) == null ? void 0 : _a2.getSnapshot();
    };
    getNudgeById = (_, id2) => {
      var _a2;
      return (_a2 = getNudgeServiceSnapshot(_, id2)) == null ? void 0 : _a2.context.nudge;
    };
    getAllNudges = (_) => {
      var _a2;
      const nudgeServices = getAllNudgeServices(_);
      return Array.from((_a2 = nudgeServices == null ? void 0 : nudgeServices.values()) != null ? _a2 : []).map((service) => {
        var _a3, _b2;
        return (_b2 = (_a3 = service.getSnapshot()) == null ? void 0 : _a3.context) == null ? void 0 : _b2.nudge;
      }).filter((nudge) => Boolean(nudge));
    };
    getDebuggedNudge = (_, options = { getOriginal: false }) => {
      var _a2, _b2, _c2, _d, _e;
      if ((_a2 = _.nudgeManager) == null ? void 0 : _a2.initialized) {
        const debuggingNudge = options.getOriginal ? (_c2 = (_b2 = _.nudgeManager) == null ? void 0 : _b2.getSnapshot()) == null ? void 0 : _c2.context.debugMode.originalNudge : (_e = (_d = _.nudgeManager) == null ? void 0 : _d.getSnapshot()) == null ? void 0 : _e.context.debugMode.currentNudge;
        if (debuggingNudge) {
          return getNudgeById(_, debuggingNudge.id);
        }
      }
    };
    getRenderingServices = (_, serviceFilter = () => true) => {
      var _a2;
      const nudgeServices = getAllNudgeServices(_);
      const servicesInRenderLoop = Array.from((_a2 = nudgeServices == null ? void 0 : nudgeServices.values()) != null ? _a2 : []).filter((service) => {
        const nudgeMachine = service.getSnapshot();
        return (nudgeMachine == null ? void 0 : nudgeMachine.matches("Step.Render Loop")) && serviceFilter(nudgeMachine);
      });
      return servicesInRenderLoop;
    };
    getSmartNudges = (nudges) => {
      return {
        rageClick: nudges.filter((nudge) => nudge.trigger.type === "on_rage_click"),
        smartDelay: nudges.filter((nudge) => nudge.trigger.type === "smart_delay"),
        userConfusion: nudges.filter((nudge) => nudge.trigger.type === "on_user_confusion")
      };
    };
    hasRageTrigger = (_, nudges) => {
      return !!nudges.filter((nudge) => nudge.trigger.type === "on_rage_click" && passesFrequencyCondition(_, nudge)).length;
    };
    hasSmartDelayTrigger = (_, nudges) => {
      return !!nudges.filter((nudge) => nudge.trigger.type === "smart_delay" && passesFrequencyCondition(_, nudge)).length;
    };
    hasUserConfusionTrigger = (_, nudges) => {
      return !!nudges.filter((nudge) => nudge.trigger.type === "on_user_confusion" && passesFrequencyCondition(_, nudge)).length;
    };
    isNudgeDismissible = (nudge) => nudge.dismissible === void 0 ? true : nudge.dismissible;
    isNudgeSnoozable = (nudge) => !!nudge.snoozable;
    passesMaxRenderedNudges = (_) => {
      const nudgesInRenderLoop = getRenderingServices(_, (state) => {
        if (state == null ? void 0 : state.context.nudge) {
          const currentlyRunningStep = getNudgeStep(state.context.nudge, state.context.stepIndex);
          return (currentlyRunningStep == null ? void 0 : currentlyRunningStep.form_factor.type) !== "tooltip";
        }
      });
      return nudgesInRenderLoop.length < MAX_RENDERED_NUDGES;
    };
    isScheduledNudge = (nudge) => nudge.trigger.type === "scheduled";
    passesSchedule = (_, { id: id2, trigger }) => {
      var _a2;
      const nudgeData = getNudgeDataFromUserStore(_, id2);
      const lastSeen = (_a2 = nudgeData == null ? void 0 : nudgeData.seenTs) == null ? void 0 : _a2[nudgeData.seenTs.length - 1];
      const interval = trigger.meta.interval;
      const value = trigger.meta.value;
      const now = dayjs3();
      if (lastSeen) {
        const lastSeenMoment = dayjs3(lastSeen);
        const diff = now.diff(lastSeenMoment, interval);
        return diff >= value;
      }
      return true;
    };
    passesGlobalLimit = (_) => {
      var _a2, _b2, _c2, _d, _e, _f, _g;
      const limit = (_a2 = _.organization) == null ? void 0 : _a2.nudge_rate_limit;
      const period = (_b2 = _.organization) == null ? void 0 : _b2.nudge_rate_period;
      if (limit === null || limit === void 0 || !period)
        return true;
      if (period === "session") {
        const debugService = getDebugService(_);
        if (debugService) {
          const allNudgeSeenTs = (_d = (_c2 = debugService.getSnapshot()) == null ? void 0 : _c2.context) == null ? void 0 : _d.nudgeSeenThisSessionTs;
          return ((_e = allNudgeSeenTs == null ? void 0 : allNudgeSeenTs.length) != null ? _e : 0) < limit;
        }
        const allNudgeServices = getAllNudgeServices(_);
        if (allNudgeServices) {
          const allNudgeSeenTs = Array.from(allNudgeServices == null ? void 0 : allNudgeServices.values()).flatMap(
            (service) => {
              var _a3, _b3;
              return (_b3 = (_a3 = service.getSnapshot()) == null ? void 0 : _a3.context) == null ? void 0 : _b3.nudgeSeenThisSessionTs;
            }
          );
          return ((_f = allNudgeSeenTs == null ? void 0 : allNudgeSeenTs.length) != null ? _f : 0) < limit;
        }
        return true;
      }
      const allNudgesSeen = Object.values((_g = _.endUserStore.data.nudges_interactions) != null ? _g : {}).flatMap((nudgeData) => nudgeData.seenTs).filter(Boolean);
      const nudgesSeenInPeriod = allNudgesSeen.filter((timeSeen) => {
        const timeSeenMoment = dayjs3(timeSeen);
        const now = dayjs3();
        const diff = now.diff(timeSeenMoment, period);
        return diff <= 1;
      }).length;
      return nudgesSeenInPeriod < limit;
    };
    passesStatus = (nudge) => nudge.is_live;
    passesFrequencyCondition = (_, nudge) => {
      var _a2, _b2, _c2;
      switch (nudge.frequency_limit) {
        case "no_limit":
          return true;
        case "once_per_session":
          return !((_b2 = (_a2 = getNudgeServiceSnapshot(_, nudge.id)) == null ? void 0 : _a2.context) == null ? void 0 : _b2.nudgeSeenThisSessionTs.length);
        case "once_per_user":
          return !((_c2 = getNudgeDataFromUserStore(_, nudge.id)) == null ? void 0 : _c2.nudgeSeen);
        case "until_interaction": {
          const savedNudgeInteractions = getNudgeDataFromUserStore(_, nudge.id);
          return !((savedNudgeInteractions == null ? void 0 : savedNudgeInteractions.nudgeCompleted) || (savedNudgeInteractions == null ? void 0 : savedNudgeInteractions.nudgeDismissed));
        }
      }
    };
    passesSnoozedConditions = (_, nudge) => {
      var _a2;
      const snoozedUntilTs = (_a2 = getNudgeDataFromUserStore(_, nudge.id)) == null ? void 0 : _a2.snoozedUntilTs;
      return !(snoozedUntilTs && snoozedUntilTs > Date.now());
    };
    passesPageConditions = (_, nudge) => !nudge.show_expression || runBooleanExpression(nudge.show_expression, _, "").passed;
    passesFlip = (prevPassedConditions, triggerEvent, step) => {
      if (isTooltipStep(step)) {
        return true;
      }
      if (prevPassedConditions && (triggerEvent == null ? void 0 : triggerEvent.trigger.type) === "when_conditions_pass") {
        return false;
      }
      return true;
    };
    passesTriggerMatch = (_, nudge, triggerEvent) => {
      const nudgeState = getNudgeServiceSnapshot(_, nudge.id);
      if (!(nudgeState == null ? void 0 : nudgeState.done)) {
        if ((triggerEvent == null ? void 0 : triggerEvent.trigger.type) === "on_event" && nudge.trigger.type === "on_event" && (triggerEvent == null ? void 0 : triggerEvent.trigger.meta.event) === nudge.trigger.meta.event) {
          if (nudge.trigger.meta.condition_group) {
            const result = runBooleanExpression(nudge.trigger.meta.condition_group, _, "", {
              eventProperties: triggerEvent == null ? void 0 : triggerEvent.properties
            });
            return result.passed;
          }
          return true;
        }
        if ((triggerEvent == null ? void 0 : triggerEvent.trigger.type) === "when_conditions_pass" && nudge.trigger.type === "scheduled") {
          return true;
        }
        return isEqual3(triggerEvent == null ? void 0 : triggerEvent.trigger, nudge.trigger);
      }
      return false;
    };
    stepHasTargetElement = (nudge, stepIndex) => {
      const step = getNudgeStep(nudge, stepIndex);
      return (step == null ? void 0 : step.form_factor.type) === "pin";
    };
    hasRemainingSteps = (nudge) => ({ stepIndex }) => stepIndex < nudge.steps.length - 1;
    getAllNudgeDataFromUserStore = (_) => {
      let nudgesInteractions = null;
      if (_.endUserStore.data.nudges_interactions) {
        nudgesInteractions = _.endUserStore.data.nudges_interactions;
      } else {
        const savedContext = LocalStorage_default.get("nudges", false);
        const parsedSavedContext = typeof savedContext === "string" ? JSON.parse(savedContext) : void 0;
        nudgesInteractions = parsedSavedContext;
      }
      if (nudgesInteractions && typeof nudgesInteractions === "object") {
        const entriesMissingStepIndex = Object.entries(nudgesInteractions).filter(
          ([, nudgeData]) => nudgeData.stepIndexStack === void 0
        );
        if (entriesMissingStepIndex.length > 0) {
          return {
            ...nudgesInteractions,
            ...Object.fromEntries(
              entriesMissingStepIndex.map(([id2, nudgeData]) => {
                var _a2;
                return [
                  id2,
                  { ...nudgeData, stepIndexStack: Array.from({ length: (_a2 = nudgeData.currentStep) != null ? _a2 : 0 }, (_2, i2) => i2).reverse() }
                ];
              })
            )
          };
        }
      }
      return nudgesInteractions;
    };
    getNudgeDataFromUserStore = (_, nudgeId) => {
      var _a2;
      return (_a2 = getAllNudgeDataFromUserStore(_)) == null ? void 0 : _a2[Number(nudgeId)];
    };
    passesPinnedElement = (nudge, stepIndex) => {
      const step = getNudgeStep(nudge, stepIndex);
      if (!step)
        return false;
      if (step.form_factor.type === "pin" || step.form_factor.type === "tooltip") {
        return !!getElement(step.form_factor.anchor_selector || step.form_factor.anchor);
      }
      return true;
    };
    shouldBypassGlobalLimit = (_, currentStep) => (currentStep == null ? void 0 : currentStep.form_factor.type) === "tooltip" || (currentStep == null ? void 0 : currentStep.form_factor.type) === "banner" || _.nudgeDebugToolBar.visible && _.nudgeDebugToolBar.bypassGlobalLimit;
    evaluateCondition = (condition, event) => {
      var _a2, _b2, _c2, _d, _e, _f;
      if (event.surveyResponse) {
        switch (condition.operator) {
          case "eq":
            return ((_a2 = event.surveyResponse) == null ? void 0 : _a2.value) === condition.operand;
          case "neq":
            return ((_b2 = event.surveyResponse) == null ? void 0 : _b2.value) !== condition.operand;
          case "gt":
            return typeof ((_c2 = event.surveyResponse) == null ? void 0 : _c2.value) === "number" && typeof condition.operand === "number" && ((_d = event.surveyResponse) == null ? void 0 : _d.value) > condition.operand;
          case "lt":
            return typeof ((_e = event.surveyResponse) == null ? void 0 : _e.value) === "number" && typeof condition.operand === "number" && ((_f = event.surveyResponse) == null ? void 0 : _f.value) < condition.operand;
          default:
            return false;
        }
      }
      return false;
    };
    getImmediateAction = (_, step, event) => {
      var _a2, _b2;
      if (event.button_type === "help_doc") {
        const helpDocCommand = (_a2 = step.content.find(
          (block) => block.type === "help_doc_command"
        )) == null ? void 0 : _a2.meta;
        if (helpDocCommand) {
          return { type: "execute_command", meta: { command: helpDocCommand.command } };
        }
      }
      if (event.button_type === "snooze") {
        return { type: "snooze" };
      }
      const buttonMeta = (_b2 = step.content.find(
        (block) => {
          var _a3;
          return block.type === "button" && ((_a3 = block.meta) == null ? void 0 : _a3.button_type) === (event == null ? void 0 : event.button_type);
        }
      )) == null ? void 0 : _b2.meta;
      const buttonAction = buttonMeta == null ? void 0 : buttonMeta.action;
      if (buttonAction && (buttonAction == null ? void 0 : buttonAction.type) !== "no_action") {
        return buttonAction;
      }
      return null;
    };
    getActionBasedOnConditions = (_, step, event) => {
      var _a2;
      const buttonMeta = (_a2 = step.content.find(
        (block) => {
          var _a3;
          return block.type === "button" && ((_a3 = block.meta) == null ? void 0 : _a3.button_type) === (event == null ? void 0 : event.button_type);
        }
      )) == null ? void 0 : _a2.meta;
      const conditionalActions = buttonMeta == null ? void 0 : buttonMeta.conditional_actions;
      if (conditionalActions) {
        for (const conditionalAction of conditionalActions) {
          if (evaluateCondition(conditionalAction, event)) {
            return conditionalAction.action || null;
          }
        }
      }
      return null;
    };
    determineAction = (_, step, event) => {
      var _a2;
      return (_a2 = getImmediateAction(_, step, event)) != null ? _a2 : getActionBasedOnConditions(_, step, event);
    };
    isTooltipStep = (step) => (step == null ? void 0 : step.form_factor.type) === "tooltip";
    isTooltipNudge = (nudge) => nudge && isTooltipStep(getNudgeStep(nudge, 0));
    isBannerStep = (step) => (step == null ? void 0 : step.form_factor.type) === "banner";
    isBannerNudge = (nudge) => nudge && isBannerStep(getNudgeStep(nudge, 0));
    isNoGlobalLimitFormFactorStep = (nudge, stepIndex) => {
      const step = getNudgeStep(nudge, stepIndex);
      return isBannerStep(step) || isTooltipStep(step);
    };
    isCursorStep = (nudge, step) => {
      var _a2;
      return isPinStep(step) && ((_a2 = step.form_factor.copilot_intro) != null ? _a2 : true) && (nudge == null ? void 0 : nudge.steps.findIndex((_step) => isEqual3(_step, step))) === 0;
    };
    getPinAnchors = (_, { step, anchorOverride }) => {
      var _a2, _b2;
      let targetEl = void 0;
      let advanceTriggerEl = void 0;
      const isAnchor = ((_a2 = _.extension.recorder.experience) == null ? void 0 : _a2.field) === "form_factor.anchor";
      const isAdvanceTrigger = ((_b2 = _.extension.recorder.experience) == null ? void 0 : _b2.field) === "form_factor.advance_trigger";
      const advanceTriggerElAnchor = isAdvanceTrigger ? anchorOverride != null ? anchorOverride : step == null ? void 0 : step.form_factor.advance_trigger : step == null ? void 0 : step.form_factor.advance_trigger;
      const targetElAnchor = isAnchor ? anchorOverride != null ? anchorOverride : step.form_factor.anchor_selector || step.form_factor.anchor : step.form_factor.anchor_selector || step.form_factor.anchor;
      advanceTriggerEl = advanceTriggerElAnchor ? getElement(advanceTriggerElAnchor) : void 0;
      targetEl = targetElAnchor ? getElement(targetElAnchor) : void 0;
      return { targetEl, advanceTriggerEl };
    };
  }
});

// commandbar/src/products/nudges/service-selectors.ts
var init_service_selectors2 = __esm({
  "commandbar/src/products/nudges/service-selectors.ts"() {
    "use strict";
    init_selectors5();
  }
});

// commandbar/src/products/checklists/store/selectors.ts
var dontShowChecklist, previouslyShownChecklist, getChecklistData, isItemCompleted, getChecklistNumCompletedItems, hasIncompleteItems, isExpanded, isChecklistInPreviewMode, getChecklistById, checklistPassesPageConditions;
var init_selectors6 = __esm({
  "commandbar/src/products/checklists/store/selectors.ts"() {
    "use strict";
    init_helpers6();
    dontShowChecklist = (_, checklist3) => {
      const checklistData = getChecklistData(_, checklist3);
      return (checklistData == null ? void 0 : checklistData.isCompleted) || (checklistData == null ? void 0 : checklistData.isSkipped);
    };
    previouslyShownChecklist = (_) => {
      return _.checklists.find((checklist3) => {
        var _a2;
        return checklist3.id === ((_a2 = _.endUserStore.data.checklist_interactions) == null ? void 0 : _a2.activeChecklistId);
      });
    };
    getChecklistData = (_, checklist3) => {
      var _a2, _b2;
      return (_b2 = (_a2 = _.endUserStore.data.checklist_interactions) == null ? void 0 : _a2.checklists) == null ? void 0 : _b2[checklist3.id];
    };
    isItemCompleted = (_, parent, item) => {
      var _a2, _b2, _c2;
      return !!((_c2 = (_b2 = (_a2 = getChecklistData(_, parent)) == null ? void 0 : _a2.items) == null ? void 0 : _b2[item.id]) == null ? void 0 : _c2.completedTS);
    };
    getChecklistNumCompletedItems = (_, checklist3) => {
      var _a2;
      const itemData = (_a2 = getChecklistData(_, checklist3)) == null ? void 0 : _a2.items;
      return checklist3.items.filter((item) => {
        var _a3;
        return !!((_a3 = itemData == null ? void 0 : itemData[item.id]) == null ? void 0 : _a3.completedTS);
      }).length;
    };
    hasIncompleteItems = (_, checklist3) => {
      var _a2, _b2;
      const itemData = ((_a2 = getChecklistData(_, checklist3)) == null ? void 0 : _a2.items) || {};
      for (const item of checklist3.items) {
        if (!((_b2 = itemData[item.id]) == null ? void 0 : _b2.completedTS)) {
          return true;
        }
      }
      return false;
    };
    isExpanded = (_, checklist3) => {
      var _a2;
      const expandedState = (_a2 = getChecklistData(_, checklist3)) == null ? void 0 : _a2.isExpanded;
      return expandedState === void 0 ? checklist3.open_by_default : expandedState;
    };
    isChecklistInPreviewMode = (checklist3) => {
      return !!checklist3._editorState;
    };
    getChecklistById = (_, id2) => {
      return _.checklists.find((checklist3) => checklist3.id === id2);
    };
    checklistPassesPageConditions = (_, checklist3) => {
      return !checklist3.show_expression || runBooleanExpression(checklist3.show_expression, _, "").passed;
    };
  }
});

// commandbar/src/products/checklists/service-selectors.ts
var init_service_selectors3 = __esm({
  "commandbar/src/products/checklists/service-selectors.ts"() {
    "use strict";
    init_selectors6();
  }
});

// commandbar/src/shared/store/executables/executable-selectors.ts
import { snapshot } from "valtio";
var runAndReportFailure, runRequestCommandAndReportFailure, dangerouslyRunJS, selectContextForExternalUse, executeCallback, actionIsAvailable;
var init_executable_selectors = __esm({
  "commandbar/src/shared/store/executables/executable-selectors.ts"() {
    "use strict";
    init_globals();
    init_sentry();
    init_Logger();
    init_helpdocService();
    init_audience2();
    init_service_selectors2();
    init_command_targeting();
    init_service_selectors3();
    runAndReportFailure = (f, args, context, command) => {
      var _a2;
      const commandMeta = {
        source: {
          type: "action",
          // Callbacks can currently only be called from Actions
          metadata: command.template.metadata
        }
      };
      try {
        return f(args, context, commandMeta);
      } catch (e) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e, {
          captureContext: {
            contexts: {
              command
            }
          }
        });
        throw e;
      }
    };
    runRequestCommandAndReportFailure = async (request, command, onSuccess, onError) => {
      var _a2;
      try {
        const response2 = await request();
        if (response2.ok) {
          if (onSuccess) {
            onSuccess(response2);
          }
        }
        if (!response2.ok) {
          if (onError) {
            onError(response2);
          }
          Logger_default.error(
            JSON.stringify({
              statusCode: response2.status,
              command
            })
          );
        }
      } catch (e) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e, {
          captureContext: {
            contexts: {
              command
            }
          }
        });
      }
    };
    dangerouslyRunJS = (script, _args, _context) => {
      const executable = '"use strict";return ( function(args, context){' + script + "})";
      return Function(executable)()(_args, _context);
    };
    selectContextForExternalUse = (_, includeLegacyKeys = true) => {
      const context = snapshot(_.context);
      const records = snapshot(_.spotlight.records);
      const recordsWithLegacyKeys = includeLegacyKeys ? Object.fromEntries(Object.entries(records).map(([key, value]) => [`commandbar-search-${key}`, value.records])) : {};
      return Object.fromEntries(
        Object.entries({
          ...context,
          ...recordsWithLegacyKeys
        }).filter(([key]) => !key.startsWith(SDK_INTERNAL_PREFIX))
      );
    };
    executeCallback = (_, selections, command, callback) => {
      const context = selectContextForExternalUse(_, false);
      if (command.confirm) {
        if (window.confirm(command.confirm)) {
          runAndReportFailure(callback, selections, context, command);
        }
      } else {
        runAndReportFailure(callback, selections, context, command);
      }
    };
    actionIsAvailable = async (_, action) => {
      var _a2, _b2, _c2;
      if (window._cbIsWebView && (action == null ? void 0 : action.type) !== "execute_command" && (action == null ? void 0 : action.type) !== "link" && (action == null ? void 0 : action.type) !== "open_chat") {
        return false;
      }
      if ((action == null ? void 0 : action.type) === "execute_command" && action.meta.command === "") {
        return false;
      }
      switch (action == null ? void 0 : action.type) {
        case "execute_command":
          const command = await helpdocService_default.getCommandOrHelpdoc(_, action.meta.command);
          const commandPassed = command && command.is_live && passesAudienceConditions(_, "commands", command);
          if ((command == null ? void 0 : command.template.type) === "helpdoc") {
            return commandPassed;
          } else if (window._cbIsWebView) {
            return false;
          }
          return command && commandPassed && isCommandAvailable(command, _).isAvailable;
        case "questlist":
          const questlist = getChecklistById(_, action.value);
          return questlist && questlist.is_live && passesAudienceConditions(_, "checklists", questlist);
        case "nudge":
          const nudge = getNudgeById(_, action.value);
          return nudge && !nudge.archived && nudge.is_live && passesAudienceConditions(_, "nudges", nudge);
        case "open_bar":
          return (_a2 = _.organization) == null ? void 0 : _a2.bar_enabled;
        case "open_helphub":
          return (_b2 = _.organization) == null ? void 0 : _b2.helphub_enabled;
        case "open_copilot":
          return (_c2 = _.organization) == null ? void 0 : _c2.copilot_enabled;
        default:
          return true;
      }
    };
  }
});

// commandbar/src/shared/store/global-selectors.ts
var getCommands, getCommandById, getLocalCommandOrHelpdoc, selectEndUserEndpoint;
var init_global_selectors = __esm({
  "commandbar/src/shared/store/global-selectors.ts"() {
    "use strict";
    init_command();
    init_executable_selectors();
    getCommands = (_) => {
      var _a2;
      const hotloadedCommandIds = new Set(_.hotloadedCommands.map((c) => c.id));
      const commands = [
        /* commands in engine.hotloadedCommands may overlap with engine.commands, so omit those from `commands` before merging */
        ..._.commands.filter((c) => !hotloadedCommandIds.has(c.id)),
        ..._.programmaticCommands,
        ..._.hotloadedCommands
      ];
      return ((_a2 = _.organization) == null ? void 0 : _a2.in_bar_doc_search) === true ? commands : commands.filter((command) => command.template.type !== "helpdoc");
    };
    getCommandById = (_, id2) => {
      if (_.mockCommands.length > 0) {
        const mockCommand = _.mockCommands.find((c) => c.id === id2 || commandUID(c) === id2 || c.name === id2);
        if (mockCommand) {
          return mockCommand;
        }
      }
      return getCommands(_).find((c) => c.id === id2 || commandUID(c) === id2 || c.name === id2);
    };
    getLocalCommandOrHelpdoc = (_, id2) => {
      const allCommands = [..._.commands, ..._.programmaticCommands, ..._.hotloadedCommands];
      return allCommands.find((c) => c.id === id2 || commandUID(c) === id2 || c.name === id2);
    };
    selectEndUserEndpoint = (_) => {
      if (!_.endUser)
        return null;
      return `/u/${_.endUser.identifier}/`;
    };
  }
});

// internal/src/util/SVG.tsx
import * as React111 from "react";
import InlineSVG from "react-inlinesvg";
var purifiedCache, SVG, SVG_default;
var init_SVG = __esm({
  "internal/src/util/SVG.tsx"() {
    "use strict";
    init_sanitizeHtml();
    purifiedCache = /* @__PURE__ */ new Map();
    SVG = (props2) => {
      var _a2, _b2, _c2, _d;
      const { htmlstring, style: style3, useDefaultSVGColor, ariaHidden, ...restProps } = props2;
      const sanitizer = sanitizeHtml_default;
      const src = React111.useMemo(() => {
        const cached2 = purifiedCache.get(htmlstring);
        if (!!cached2) {
          return cached2;
        } else {
          const sanitized = sanitizer(htmlstring, ["use"]);
          purifiedCache.set(htmlstring, sanitized);
          return sanitized;
        }
      }, [htmlstring]);
      let extraStyles = {};
      if (src.includes("data-commandbar")) {
        const extraData = (_b2 = (_a2 = new DOMParser().parseFromString(src, "text/html").querySelector("svg")) == null ? void 0 : _a2.dataset) == null ? void 0 : _b2.commandbar;
        const isRound = extraData == null ? void 0 : extraData.includes("round");
        extraStyles = { borderRadius: isRound ? "50%" : void 0 };
      }
      return /* @__PURE__ */ React111.createElement(
        InlineSVG,
        {
          "aria-hidden": ariaHidden,
          key: `svg-${(_d = (_c2 = props2 == null ? void 0 : props2.style) == null ? void 0 : _c2["color"]) != null ? _d : ""}`,
          src,
          preProcessor: (code) => {
            if (useDefaultSVGColor) {
              return code;
            } else {
              return code.replace(/fill=".*?"/g, 'fill="currentcolor"');
            }
          },
          style: { ...style3, ...extraStyles },
          ...restProps
        }
      );
    };
    SVG_default = SVG;
  }
});

// internal/src/assets/NotificationBox.tsx
import * as React112 from "react";
var NotificationBox2, NotificationBox_default2;
var init_NotificationBox2 = __esm({
  "internal/src/assets/NotificationBox.tsx"() {
    "use strict";
    NotificationBox2 = (props2) => /* @__PURE__ */ React112.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React112.createElement("path", { fill: "currentColor", d: "M20.121 3.879A3 3 0 1 1 15.88 8.12a3 3 0 0 1 4.24-4.24Z", opacity: 0.12 }), /* @__PURE__ */ React112.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "M11 4H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 6.28 3 7.12 3 8.8v7.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h7.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 18.72 20 17.88 20 16.2V13m.121-9.121A3 3 0 1 1 15.88 8.12a3 3 0 0 1 4.24-4.24Z"
      }
    ));
    NotificationBox_default2 = NotificationBox2;
  }
});

// internal/src/assets/CheckSquareBroken.tsx
import * as React113 from "react";
var CheckSquareBroken2, CheckSquareBroken_default2;
var init_CheckSquareBroken2 = __esm({
  "internal/src/assets/CheckSquareBroken.tsx"() {
    "use strict";
    CheckSquareBroken2 = (props2) => /* @__PURE__ */ React113.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 24 24", ...props2 }, /* @__PURE__ */ React113.createElement(
      "path",
      {
        fill: "currentColor",
        d: "M3 7.8c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.28 3 6.12 3 7.8 3h8.4c1.68 0 2.52 0 3.162.327a3 3 0 0 1 1.311 1.311C21 5.28 21 6.12 21 7.8v8.4c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C18.72 21 17.88 21 16.2 21H7.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3 18.72 3 17.88 3 16.2V7.8Z",
        opacity: 0.12
      }
    ), /* @__PURE__ */ React113.createElement(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: "m9 11 3 3L22 4m-6-1H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V12"
      }
    ));
    CheckSquareBroken_default2 = CheckSquareBroken2;
  }
});

// internal/src/client/Icon.tsx
import React114 from "react";
import {
  AiFillRightSquare,
  AiFillPlusCircle,
  AiFillMinusCircle,
  AiFillClockCircle,
  AiFillEdit,
  AiFillCopy,
  AiFillDelete,
  AiFillFund,
  AiFillAlert,
  AiFillApi,
  AiFillAppstore,
  AiFillBank,
  AiFillBell,
  AiFillBulb,
  AiFillCalculator,
  AiFillCalendar,
  AiFillCloud,
  AiFillCrown,
  AiFillDashboard,
  AiFillFileAdd,
  AiFillFilter,
  AiFillFire,
  AiFillFlag,
  AiFillFolderOpen,
  AiFillHeart,
  AiFillHome,
  AiOutlineLink,
  AiFillMessage,
  AiFillPushpin,
  AiOutlineRedo,
  AiFillRocket,
  AiFillSave,
  AiFillStar,
  AiFillTool,
  AiFillThunderbolt,
  AiOutlineUndo,
  AiFillPlayCircle,
  AiFillPhone,
  AiFillMail,
  AiOutlineUsergroupAdd,
  AiOutlineUsergroupDelete,
  AiOutlineUserAdd,
  AiOutlineUserDelete,
  AiOutlineUserSwitch,
  AiOutlineUser,
  AiOutlineSearch,
  AiOutlineBook,
  AiOutlineLock,
  AiOutlineSwap,
  AiFillCloseCircle,
  AiFillAccountBook,
  AiFillBug,
  AiFillCamera,
  AiFillVideoCamera,
  AiFillBuild,
  AiFillCaretDown,
  AiFillCaretUp,
  AiFillCaretRight,
  AiFillCaretLeft,
  AiFillCheckCircle,
  AiFillCheckSquare,
  AiFillCompass,
  AiFillContacts,
  AiFillLike,
  AiFillDislike,
  AiFillFile,
  AiOutlineFileDone,
  AiFillMoneyCollect,
  AiOutlineQrcode,
  AiFillMobile,
  AiOutlineZoomOut,
  AiOutlineZoomIn,
  AiFillAudio,
  AiFillBackward,
  AiFillBoxPlot,
  AiFillCar,
  AiFillCarryOut,
  AiOutlineCodeSandbox,
  AiFillCode,
  AiFillCodepenCircle,
  AiFillContainer,
  AiFillControl,
  AiFillCreditCard,
  AiFillCustomerService,
  AiFillDatabase,
  AiFillDiff,
  AiFillFunnelPlot,
  AiFillGift,
  AiFillHourglass,
  AiFillIdcard,
  AiFillMacCommand,
  AiFillNotification,
  AiFillSound,
  AiFillSignal,
  AiFillTag,
  AiOutlineQuestion,
  AiFillFileText
} from "react-icons/ai";
var ICONS, commandDefault, renderAntIcon, getIconType, hex_regex2, maybeUrl, Icon, Icon_default;
var init_Icon = __esm({
  "internal/src/client/Icon.tsx"() {
    "use strict";
    init_SVG();
    init_NotificationBox2();
    init_CheckSquareBroken2();
    ICONS = {
      rightsquare: AiFillRightSquare,
      pluscircle: AiFillPlusCircle,
      minuscircle: AiFillMinusCircle,
      clockcircle: AiFillClockCircle,
      closecircle: AiFillCloseCircle,
      edit: AiFillEdit,
      copy: AiFillCopy,
      crown: AiFillCrown,
      delete: AiFillDelete,
      fund: AiFillFund,
      funnel: AiFillFunnelPlot,
      alert: AiFillAlert,
      api: AiFillApi,
      appstore: AiFillAppstore,
      accountbook: AiFillAccountBook,
      bank: AiFillBank,
      bell: AiFillBell,
      bulb: AiFillBulb,
      calculator: AiFillCalculator,
      calendar: AiFillCalendar,
      cloud: AiFillCloud,
      dashboard: AiFillDashboard,
      fileadd: AiFillFileAdd,
      filter: AiFillFilter,
      fire: AiFillFire,
      flag: AiFillFlag,
      folderopen: AiFillFolderOpen,
      gift: AiFillGift,
      heart: AiFillHeart,
      home: AiFillHome,
      hourglass: AiFillHourglass,
      idcard: AiFillIdcard,
      link: AiOutlineLink,
      mail: AiFillMail,
      maccommand: AiFillMacCommand,
      message: AiFillMessage,
      notification: AiFillNotification,
      play: AiFillPlayCircle,
      phone: AiFillPhone,
      pushpin: AiFillPushpin,
      redo: AiOutlineRedo,
      rocket: AiFillRocket,
      save: AiFillSave,
      signal: AiFillSignal,
      sound: AiFillSound,
      star: AiFillStar,
      tag: AiFillTag,
      tool: AiFillTool,
      thunderbolt: AiFillThunderbolt,
      undo: AiOutlineUndo,
      usergroupadd: AiOutlineUsergroupAdd,
      usergroupdelete: AiOutlineUsergroupDelete,
      useradd: AiOutlineUserAdd,
      userdelete: AiOutlineUserDelete,
      userswitch: AiOutlineUserSwitch,
      user: AiOutlineUser,
      search: AiOutlineSearch,
      book: AiOutlineBook,
      lock: AiOutlineLock,
      swap: AiOutlineSwap,
      bug: AiFillBug,
      camera: AiFillCamera,
      videocamera: AiFillVideoCamera,
      build: AiFillBuild,
      caretdown: AiFillCaretDown,
      caretup: AiFillCaretUp,
      caretright: AiFillCaretRight,
      caretleft: AiFillCaretLeft,
      checkcircle: AiFillCheckCircle,
      checksquare: AiFillCheckSquare,
      compass: AiFillCompass,
      contacts: AiFillContacts,
      like: AiFillLike,
      dislike: AiFillDislike,
      file: AiFillFile,
      filedone: AiOutlineFileDone,
      moneycollect: AiFillMoneyCollect,
      qrcode: AiOutlineQrcode,
      mobile: AiFillMobile,
      zoomin: AiOutlineZoomIn,
      zoomout: AiOutlineZoomOut,
      audio: AiFillAudio,
      backward: AiFillBackward,
      boxplot: AiFillBoxPlot,
      car: AiFillCar,
      carryout: AiFillCarryOut,
      codesandbox: AiOutlineCodeSandbox,
      code: AiFillCode,
      codepencircle: AiFillCodepenCircle,
      container: AiFillContainer,
      control: AiFillControl,
      creditcard: AiFillCreditCard,
      customerservice: AiFillCustomerService,
      database: AiFillDatabase,
      diff: AiFillDiff,
      question: AiOutlineQuestion,
      document: AiFillFileText,
      nudge: NotificationBox_default2,
      checklist: CheckSquareBroken_default2
    };
    commandDefault = (command) => {
      let defaultIcon;
      switch (command.template.type) {
        case "admin":
          defaultIcon = "thunderbolt";
          break;
        case "link":
          defaultIcon = "link";
          break;
        case "clickBySelector":
        case "clickByXpath":
        case "callback":
        case "click":
          defaultIcon = "bulb";
          break;
        case "appcues":
          defaultIcon = "question";
          break;
        case "video":
          defaultIcon = "play";
          break;
        case "pendo_guide":
        case "helpdoc":
          defaultIcon = "document";
          break;
        default:
          defaultIcon = "folderopen";
          break;
      }
      return defaultIcon;
    };
    renderAntIcon = (iconKey, style3, _filled) => {
      const IconComponent = ICONS[iconKey];
      if (IconComponent)
        return /* @__PURE__ */ React114.createElement(IconComponent, { style: style3 });
      else
        return /* @__PURE__ */ React114.createElement("div", null);
    };
    getIconType = (icon, _default) => {
      const iconWithoutStyle = icon && icon.includes("#") ? icon.split("#")[0] : icon;
      if (iconWithoutStyle && Object.keys(ICONS).includes(iconWithoutStyle.toLowerCase())) {
        return "user-defined";
      } else if ((icon == null ? void 0 : icon.startsWith("https://")) || (icon == null ? void 0 : icon.startsWith("http://"))) {
        return "url";
      } else if (icon == null ? void 0 : icon.startsWith("<svg")) {
        return "svg";
      } else if ((icon == null ? void 0 : icon.includes("<")) && (icon == null ? void 0 : icon.includes(">"))) {
        return "htmlelement";
      } else if (icon == null ? void 0 : icon.startsWith("data:image")) {
        return "image";
      } else if (icon) {
        return "emoji";
      } else if (_default && typeof _default === "string") {
        return "default-string";
      } else if (_default) {
        return "default-element";
      }
      return "none";
    };
    hex_regex2 = /^[0-9a-fA-F]{3,8}$/;
    maybeUrl = (url) => {
      try {
        return new URL(url);
      } catch (e) {
        return null;
      }
    };
    Icon = ({ size = "18px", ...props2 }) => {
      var _a2, _b2;
      let style3 = { fontSize: size, ...props2.style };
      const iconType = getIconType(props2.icon, props2.default);
      if (iconType === "svg" && props2.useDefaultSVGColor && !props2.allowDefaultSVGColorOverride) {
        style3 = { ...style3, color: void 0 };
      }
      switch (iconType) {
        case "user-defined":
          const iconWithoutStyle = props2.icon && props2.icon.includes("#") ? props2.icon.split("#")[0] : props2.icon;
          const deprecatedColor = ((_a2 = props2.icon) == null ? void 0 : _a2.includes("#")) && hex_regex2.test(props2.icon.split("#")[1]) ? (_b2 = props2.icon) == null ? void 0 : _b2.split("#")[1] : "";
          const color = props2.color ? props2.color : deprecatedColor;
          if (color) {
            style3 = { ...style3, color };
          }
          return renderAntIcon(
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            iconWithoutStyle.toLowerCase(),
            style3,
            props2.fill
          );
        case "url":
          const url = props2.icon;
          if (url) {
            const formattedURL = maybeUrl(url);
            if (formattedURL) {
              const params = new URLSearchParams(formattedURL == null ? void 0 : formattedURL.search);
              const isRound = params.get("round");
              if (isRound) {
                style3 = { ...style3, borderRadius: "50%" };
              }
              return /* @__PURE__ */ React114.createElement("img", { src: url, width: size, height: size, alt: "", style: style3 });
            }
          }
          return /* @__PURE__ */ React114.createElement("div", { style: { minWidth: size } });
        case "svg":
          return /* @__PURE__ */ React114.createElement(
            SVG_default,
            {
              style: { ...style3 },
              height: size,
              width: size,
              htmlstring: props2.icon,
              useDefaultSVGColor: props2.useDefaultSVGColor
            }
          );
        case "htmlelement":
          return /* @__PURE__ */ React114.createElement("div", { dangerouslySetInnerHTML: { __html: props2.icon } });
        case "image":
          const dataURL = props2.icon;
          if (dataURL) {
            return /* @__PURE__ */ React114.createElement("img", { src: dataURL, width: size, height: size, alt: "", style: style3 });
          }
          return /* @__PURE__ */ React114.createElement("div", { style: { minWidth: size } });
        case "emoji":
          return /* @__PURE__ */ React114.createElement(
            "span",
            {
              style: {
                fontSize: size,
                verticalAlign: "middle",
                ...props2.style
              }
            },
            props2.icon
          );
        case "default-string":
          return renderAntIcon(props2.default, style3, props2.fill);
        case "default-element":
          return /* @__PURE__ */ React114.createElement("span", null, props2.default);
        default:
          return /* @__PURE__ */ React114.createElement("div", null);
      }
    };
    Icon_default = Icon;
  }
});

// commandbar/src/shared/components/Icon.tsx
import React115 from "react";
var CBIcon, Icon_default2;
var init_Icon2 = __esm({
  "commandbar/src/shared/components/Icon.tsx"() {
    "use strict";
    init_Icon();
    init_Icon();
    CBIcon = (props2) => /* @__PURE__ */ React115.createElement(Icon_default, { ...props2 });
    Icon_default2 = CBIcon;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightMajorCategoriesContainer.tsx
import { css as css9, jsx as jsx12 } from "@emotion/core";
var styles6, StyledSpotlightMajorCategoriesContainer, StyledSpotlightMajorCategoriesContainer_default;
var init_StyledSpotlightMajorCategoriesContainer = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightMajorCategoriesContainer.tsx"() {
    "use strict";
    styles6 = css9({
      display: "flex",
      padding: "8px",
      alignItems: "flex-start",
      gap: "var(--layout-gap)",
      alignSelf: "stretch"
    });
    StyledSpotlightMajorCategoriesContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx12("div", { css: styles6, ...props2 }, children);
    };
    StyledSpotlightMajorCategoriesContainer_default = StyledSpotlightMajorCategoriesContainer;
  }
});

// internal/src/client/themesV2/components/shared/StyledToggleButton.tsx
import { css as css10, jsx as jsx13 } from "@emotion/core";
var styles7, selectedStyles, slug4, StyledToggleButton, StyledToggleButton_default;
var init_StyledToggleButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledToggleButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_ButtonWithReset();
    styles7 = {
      display: "flex",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--button-tertiary-border-color)",
      background: "var(--button-tertiary-background)",
      color: "var(--button-tertiary-content)",
      cursor: "pointer",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderColor: "var(--button-tertiary-border-color-hover)",
        background: "var(--button-tertiary-background-hover)",
        color: "var(--button-tertiary-content-hover)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed"
      }
    };
    selectedStyles = {
      background: "var(--button-primary-background)",
      borderColor: "var(--button-primary-border-color)",
      color: "var(--button-primary-content)",
      "&:hover": {
        background: "var(--button-primary-background)",
        borderColor: "var(--button-primary-border-color)",
        color: "var(--button-primary-content)"
      },
      "&:focus": {
        background: "var(--button-primary-background)"
      }
    };
    slug4 = "toggleButton";
    StyledToggleButton = ({
      themeV2,
      isSelected,
      children,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug4, themeV2);
      return /* @__PURE__ */ jsx13(ButtonWithReset_default, { css: [overrides, css10(styles7), isSelected && css10(selectedStyles)].filter(Boolean), ...props2 }, children);
    };
    StyledToggleButton.slug = slug4;
    StyledToggleButton.styles = styles7;
    StyledToggleButton.activeStyles = selectedStyles;
    StyledToggleButton.renderMock = (themeV2, mode, active, onClick) => /* @__PURE__ */ jsx13(StyledToggleButton, { themeV2: { themeV2, mode }, isSelected: !!active, onClick }, "All items");
    StyledToggleButton_default = StyledToggleButton;
  }
});

// commandbar/src/products/spotlight/components/select/SearchTabs.tsx
import { jsx as jsx14 } from "@emotion/core";
import { useTheme as useTheme3 } from "emotion-theming";
import React116 from "react";
var createSearchFilter, SearchTabs, SearchTab, tabStyle, SearchTabs_default;
var init_SearchTabs = __esm({
  "commandbar/src/products/spotlight/components/select/SearchTabs.tsx"() {
    "use strict";
    init_useStore();
    init_useAction();
    init_actions9();
    init_Icon2();
    init_selectors3();
    init_operatingSystem();
    init_StyledSpotlightMajorCategoriesContainer();
    init_StyledToggleButton();
    init_ThemeV2Context();
    createSearchFilter = (group) => {
      let emptyInputMessage = void 0;
      if (group.hasHotloadedCommands) {
        if (!!group.searchTabInstruction) {
          emptyInputMessage = group.searchTabInstruction;
        } else {
          emptyInputMessage = "Type to search";
        }
      }
      return {
        fn: group.filterFn,
        slug: group.key,
        inputTag: group.name,
        placeholder: group.searchTabInstruction || void 0,
        renderAs: group.renderAs,
        // FIXME: we need a better way to handle this. It's a way to avoid "No results" if the options are async
        emptyInputMessage
      };
    };
    SearchTabs = (props2) => {
      var _a2;
      const { theme } = useTheme3();
      const store = useStore();
      const { focusedIndex, sortedOptions, searchFilter } = store.spotlight;
      const setSearchFilter2 = useAction(setSearchFilter);
      const themeV2 = useThemeV2Context();
      const tabGroups = selectSearchTabs(store, props2.direction === "vertical");
      const focusInput = useAction((_) => {
        var _a3, _b2;
        if (!isMobileDevice()) {
          (_b2 = (_a3 = _.spotlight.refContainer) == null ? void 0 : _a3.current) == null ? void 0 : _b2.focus();
        }
      });
      const onTabSelect = (tab) => {
        setSearchFilter2(createSearchFilter(tab));
      };
      const onTabReset = () => {
        setSearchFilter2(void 0);
      };
      if (tabGroups.length === 0) {
        return /* @__PURE__ */ jsx14("div", null);
      }
      const activeTabGroup = tabGroups.find((tabGroup) => tabGroup.key === (searchFilter == null ? void 0 : searchFilter.slug));
      const isFocusable = () => {
        return focusedIndex === -1 || sortedOptions.length === 0;
      };
      const renderTabHeading = (tabs, tab, index3) => {
        if (props2.direction !== "vertical") {
          return false;
        }
        if (!!tab.header && (index3 - 1 >= 0 && tab.header !== tabGroups[index3 - 1].header || index3 === 0)) {
          return true;
        }
        if (!tab.header && index3 - 1 >= 0 && !!tabs[index3 - 1].header) {
          return true;
        }
      };
      return ((_a2 = store.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx14(
        StyledSpotlightMajorCategoriesContainer_default,
        {
          "aria-hidden": true,
          onClick: focusInput,
          id: "commandbar-search-tab-container"
        },
        /* @__PURE__ */ jsx14(StyledToggleButton_default, { themeV2, key: "all", isSelected: activeTabGroup === void 0, onClick: onTabReset }, "All"),
        tabGroups.map((tabGroup, index3) => {
          return /* @__PURE__ */ jsx14(
            StyledToggleButton_default,
            {
              themeV2,
              key: index3,
              isSelected: !!(activeTabGroup && activeTabGroup.key === tabGroup.key),
              onClick: () => onTabSelect(tabGroup)
            },
            tabGroup.name
          );
        })
      ) : /* @__PURE__ */ jsx14(
        "div",
        {
          "aria-hidden": true,
          style: {
            display: "flex",
            paddingTop: theme.searchTabsContainer.paddingTop,
            paddingRight: theme.searchTabsContainer.paddingRight,
            paddingLeft: theme.searchTabsContainer.paddingLeft,
            paddingBottom: theme.searchTabsContainer.paddingBottom,
            width: "100%"
          },
          onClick: focusInput,
          id: "commandbar-search-tab-container"
        },
        /* @__PURE__ */ jsx14(
          "div",
          {
            role: "tablist",
            css: props2.direction === "horizontal" ? {
              display: "flex",
              gap: 4,
              alignItems: "center",
              overflowX: "auto"
            } : { display: "flex", gap: 4, flexDirection: "column", width: "100%" }
          },
          /* @__PURE__ */ jsx14(
            SearchTab,
            {
              direction: props2.direction,
              name: theme.searchTab.labelAllTab,
              isFocusable: isFocusable(),
              active: activeTabGroup === void 0,
              onTabSelect: onTabReset
            }
          ),
          tabGroups.map((tabGroup, index3) => {
            var _a3;
            return /* @__PURE__ */ jsx14(React116.Fragment, { key: index3 }, renderTabHeading(tabGroups, tabGroup, index3) && /* @__PURE__ */ jsx14(
              "span",
              {
                style: {
                  padding: theme.searchTabGroupHeading.padding,
                  fontWeight: theme.searchTabGroupHeading.fontWeight,
                  textAlign: theme.searchTabGroupHeading.textAlign,
                  color: theme.searchTabGroupHeading.color,
                  fontSize: theme.searchTabGroupHeading.fontSize
                }
              },
              tabGroup.header
            ), /* @__PURE__ */ jsx14(
              SearchTab,
              {
                direction: props2.direction,
                tabGroup,
                isFocusable: isFocusable(),
                active: (_a3 = activeTabGroup && activeTabGroup.key === tabGroup.key) != null ? _a3 : false,
                onTabSelect: () => onTabSelect(tabGroup)
              }
            ));
          })
        )
      );
    };
    SearchTab = ({
      direction,
      tabGroup,
      active,
      name = (tabGroup == null ? void 0 : tabGroup.searchTabName) || (tabGroup == null ? void 0 : tabGroup.name),
      isFocusable,
      onTabSelect
    }) => {
      var _a2, _b2;
      const { theme } = useTheme3();
      const { optionCountsByTabGroup, showLoadingIndicator } = useStore().spotlight;
      const icon = (_a2 = tabGroup == null ? void 0 : tabGroup.icon) != null ? _a2 : null;
      const optionCount = (_b2 = tabGroup && optionCountsByTabGroup.get(tabGroup.key)) != null ? _b2 : null;
      const hasOptions = optionCount != null && !showLoadingIndicator ? optionCount > 0 : true;
      const style3 = React116.useMemo(
        () => tabStyle({ theme, hasOptions, isActive: active, direction }),
        [active, direction, theme, hasOptions]
      );
      return /* @__PURE__ */ jsx14(
        "button",
        {
          role: "tab",
          "aria-label": `search-filter-${name}`,
          "aria-selected": active,
          "aria-disabled": active,
          tabIndex: isFocusable ? 0 : -1,
          css: style3,
          onClick: onTabSelect,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              onTabSelect();
            }
          },
          "data-testid": "search-tab"
        },
        !!icon && /* @__PURE__ */ jsx14(
          Icon_default2,
          {
            icon,
            style: { marginRight: theme.searchTab.iconMarginRight, verticalAlign: "middle" },
            useDefaultSVGColor: true,
            size: theme.searchTab.iconSize
          }
        ),
        /* @__PURE__ */ jsx14(
          "span",
          {
            css: {
              whiteSpace: direction === "horizontal" ? "nowrap" : "normal"
            }
          },
          name
        )
      );
    };
    tabStyle = ({
      theme,
      isActive: isActive2,
      hasOptions,
      direction
    }) => {
      const {
        activeColor,
        activeBorder,
        activeBorderWidth,
        activeBackground,
        borderRadius,
        fontSize,
        fontWeight,
        inactiveColor,
        inactiveBorder,
        inactiveBorderWidth,
        inactiveBackground,
        noResultsColor,
        noResultsBorder,
        noResultsBackground,
        noResultsOpacity,
        hoverColor,
        hoverBorder,
        hoverBorderWidth,
        hoverBackground,
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        inactivePadding,
        hoverPadding,
        spacing,
        textAlign,
        transitionTime
      } = theme.searchTab;
      const styleColorAndHover = (() => {
        if (isActive2) {
          return {
            color: activeColor,
            background: activeBackground,
            border: activeBorder,
            ...activeBorderWidth && { borderWidth: activeBorderWidth }
          };
        } else {
          return {
            color: inactiveColor,
            background: inactiveBackground,
            border: inactiveBorder,
            ...inactiveBorderWidth && { borderWidth: inactiveBorderWidth },
            ...inactivePadding && { padding: inactivePadding },
            "&:hover": {
              color: hoverColor,
              border: hoverBorder,
              ...hoverBorderWidth && { borderWidth: hoverBorderWidth },
              background: hoverBackground,
              ...hoverPadding && { padding: hoverPadding }
            },
            ...!hasOptions && {
              opacity: noResultsOpacity,
              ...noResultsColor && { color: noResultsColor },
              ...noResultsBorder && { border: noResultsBorder },
              ...noResultsBackground && { background: noResultsBackground }
            }
          };
        }
      })();
      return {
        fontFamily: theme.main.fontFamily,
        fontSize,
        lineHeight: 1,
        display: "inline-block",
        textAlign,
        cursor: "pointer",
        transition: `all ${transitionTime} cubic-bezier(0.645, 0.045, 0.355, 1)`,
        fontWeight,
        height: "fit-content",
        paddingTop,
        paddingRight,
        paddingBottom,
        paddingLeft,
        marginBottom: direction === "vertical" ? spacing : 0,
        marginRight: direction === "horizontal" ? spacing : 0,
        borderRadius,
        ...direction === "horizontal" && {
          display: "flex",
          alignItems: "center"
        },
        ...styleColorAndHover,
        "&:last-child": {
          marginBottom: 0,
          marginRight: 0
        }
      };
    };
    SearchTabs_default = SearchTabs;
  }
});

// internal/src/util/dispatchCustomEvent.ts
function dispatchCustomEvent(eventType, detail, canBubble = false, cancelable = false) {
  const ev = new CustomEvent(eventType, { detail, bubbles: canBubble, cancelable });
  document.dispatchEvent(ev);
  return ev;
}
var init_dispatchCustomEvent = __esm({
  "internal/src/util/dispatchCustomEvent.ts"() {
    "use strict";
  }
});

// internal/src/client/mousetrap_fork.js
var require_mousetrap_fork = __commonJS({
  "internal/src/client/mousetrap_fork.js"(exports, module2) {
    "use strict";
    (function(window2, document2, undefined23) {
      if (!window2) {
        return;
      }
      var _MAP = {
        8: "backspace",
        9: "tab",
        13: "enter",
        16: "shift",
        17: "ctrl",
        18: "alt",
        20: "capslock",
        27: "esc",
        32: "space",
        33: "pageup",
        34: "pagedown",
        35: "end",
        36: "home",
        37: "left",
        38: "up",
        39: "right",
        40: "down",
        45: "ins",
        46: "del",
        91: "meta",
        93: "meta",
        224: "meta"
      };
      var _KEYCODE_MAP = {
        106: "*",
        107: "+",
        109: "-",
        110: ".",
        111: "/",
        186: ";",
        187: "=",
        188: ",",
        189: "-",
        190: ".",
        191: "/",
        192: "`",
        219: "[",
        220: "\\",
        221: "]",
        222: "'"
      };
      var _SHIFT_MAP = {
        "~": "`",
        "!": "1",
        "@": "2",
        "#": "3",
        $: "4",
        "%": "5",
        "^": "6",
        "&": "7",
        "*": "8",
        "(": "9",
        ")": "0",
        _: "-",
        "+": "=",
        ":": ";",
        '"': "'",
        "<": ",",
        ">": ".",
        "?": "/",
        "|": "\\"
      };
      var _SPECIAL_ALIASES = {
        option: "alt",
        command: "meta",
        return: "enter",
        escape: "esc",
        plus: "+",
        mod: /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? "meta" : "ctrl"
      };
      var _REVERSE_MAP;
      for (var i2 = 1; i2 < 20; ++i2) {
        _MAP[111 + i2] = "f" + i2;
      }
      for (i2 = 0; i2 <= 9; ++i2) {
        _MAP[i2 + 96] = i2.toString();
      }
      function _addEvent(object2, type39, callback, useCapture) {
        if (object2.addEventListener) {
          object2.addEventListener(type39, callback, useCapture);
          return;
        }
        object2.attachEvent("on" + type39, callback);
      }
      function _characterFromEvent(e) {
        if (e.type == "keypress") {
          var character = String.fromCharCode(e.which);
          if (!e.shiftKey) {
            character = character.toLowerCase();
          }
          return character;
        }
        if (_MAP[e.which]) {
          return _MAP[e.which];
        }
        if (_KEYCODE_MAP[e.which]) {
          return _KEYCODE_MAP[e.which];
        }
        return String.fromCharCode(e.which).toLowerCase();
      }
      function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(",") === modifiers2.sort().join(",");
      }
      function _eventModifiers(e) {
        var modifiers = [];
        if (e.shiftKey) {
          modifiers.push("shift");
        }
        if (e.altKey) {
          modifiers.push("alt");
        }
        if (e.ctrlKey) {
          modifiers.push("ctrl");
        }
        if (e.metaKey) {
          modifiers.push("meta");
        }
        return modifiers;
      }
      function _preventDefault(e) {
        if (e.preventDefault) {
          e.preventDefault();
          return;
        }
        e.returnValue = false;
      }
      function _stopPropagation(e) {
        if (e.stopPropagation) {
          e.stopPropagation();
          return;
        }
        e.cancelBubble = true;
      }
      function _isModifier(key) {
        return key == "shift" || key == "ctrl" || key == "alt" || key == "meta";
      }
      function _getReverseMap() {
        if (!_REVERSE_MAP) {
          _REVERSE_MAP = {};
          for (var key in _MAP) {
            if (key > 95 && key < 112) {
              continue;
            }
            if (_MAP.hasOwnProperty(key)) {
              _REVERSE_MAP[_MAP[key]] = key;
            }
          }
        }
        return _REVERSE_MAP;
      }
      function _pickBestAction(key, modifiers, action) {
        if (!action) {
          action = _getReverseMap()[key] ? "keydown" : "keypress";
        }
        if (action == "keypress" && modifiers.length) {
          action = "keydown";
        }
        return action;
      }
      function _keysFromString(combination) {
        if (combination === "+") {
          return ["+"];
        }
        combination = combination.replace(/\+{2}/g, "+plus");
        return combination.split("+");
      }
      function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i3;
        var modifiers = [];
        keys = _keysFromString(combination);
        for (i3 = 0; i3 < keys.length; ++i3) {
          key = keys[i3];
          if (_SPECIAL_ALIASES[key]) {
            key = _SPECIAL_ALIASES[key];
          }
          if (action && action != "keypress" && _SHIFT_MAP[key]) {
            key = _SHIFT_MAP[key];
            modifiers.push("shift");
          }
          if (_isModifier(key)) {
            modifiers.push(key);
          }
        }
        action = _pickBestAction(key, modifiers, action);
        return {
          key,
          modifiers,
          action
        };
      }
      function _belongsTo(element, ancestor) {
        if (element === null || element === document2) {
          return false;
        }
        if (element === ancestor) {
          return true;
        }
        return _belongsTo(element.parentNode, ancestor);
      }
      function Mousetrap5(targetElement, useCapture) {
        var self2 = this;
        targetElement = targetElement || document2;
        useCapture = !!useCapture;
        if (!(self2 instanceof Mousetrap5)) {
          return new Mousetrap5(targetElement, useCapture);
        }
        self2.target = targetElement;
        self2._callbacks = {};
        self2._directMap = {};
        var _sequenceLevels = {};
        var _resetTimer;
        var _ignoreNextKeyup = false;
        var _ignoreNextKeypress = false;
        var _nextExpectedAction = false;
        function _resetSequences(doNotReset) {
          doNotReset = doNotReset || {};
          var activeSequences = false, key;
          for (key in _sequenceLevels) {
            if (doNotReset[key]) {
              activeSequences = true;
              continue;
            }
            _sequenceLevels[key] = 0;
          }
          if (!activeSequences) {
            _nextExpectedAction = false;
          }
        }
        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
          var i3;
          var callback;
          var matches = [];
          var action = e.type;
          if (!self2._callbacks[character]) {
            return [];
          }
          if (action == "keyup" && _isModifier(character)) {
            modifiers = [character];
          }
          for (i3 = 0; i3 < self2._callbacks[character].length; ++i3) {
            callback = self2._callbacks[character][i3];
            if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
              continue;
            }
            if (action != callback.action) {
              continue;
            }
            if (action == "keypress" && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {
              var deleteCombo = !sequenceName && callback.combo == combination;
              var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
              if (deleteCombo || deleteSequence) {
                self2._callbacks[character].splice(i3, 1);
              }
              matches.push(callback);
            }
          }
          return matches;
        }
        function _fireCallback(callback, e, combo, sequence) {
          if (self2.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
            return;
          }
          if (callback(e, combo) === false) {
            _preventDefault(e);
            _stopPropagation(e);
          }
          return true;
        }
        self2._handleKey = function(character, modifiers, e) {
          var callbacks = _getMatches(character, modifiers, e);
          var i3;
          var doNotReset = {};
          var maxLevel = 0;
          var processedSequenceCallback = false;
          var processedFinalSequenceCallback = false;
          for (i3 = 0; i3 < callbacks.length; ++i3) {
            if (callbacks[i3].seq) {
              maxLevel = Math.max(maxLevel, callbacks[i3].level);
            }
          }
          const sequenceLevelsBackup = {
            ..._sequenceLevels
          };
          for (i3 = 0; i3 < callbacks.length; ++i3) {
            if (callbacks[i3].seq) {
              if (callbacks[i3].level != maxLevel) {
                continue;
              }
              processedSequenceCallback = true;
              doNotReset[callbacks[i3].seq] = 1;
              processedFinalSequenceCallback = !!_fireCallback(
                callbacks[i3].callback,
                e,
                callbacks[i3].combo,
                callbacks[i3].seq
              );
              continue;
            }
            if (!processedFinalSequenceCallback) {
              _fireCallback(callbacks[i3].callback, e, callbacks[i3].combo);
            }
          }
          for (const property in sequenceLevelsBackup) {
            if (_sequenceLevels[property] > sequenceLevelsBackup[property] + 1) {
              _sequenceLevels[property] = sequenceLevelsBackup[property] + 1;
            }
          }
          var ignoreThisKeypress = e.type == "keypress" && _ignoreNextKeypress;
          if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
            _resetSequences(doNotReset);
          }
          _ignoreNextKeypress = processedSequenceCallback && e.type == "keydown";
        };
        function _handleKeyEvent(e) {
          if (typeof e.which !== "number") {
            e.which = e.keyCode;
          }
          var character = _characterFromEvent(e);
          if (!character) {
            return;
          }
          if (e.type == "keyup" && _ignoreNextKeyup === character) {
            _ignoreNextKeyup = false;
            return;
          }
          self2.handleKey(character, _eventModifiers(e), e);
        }
        function _resetSequenceTimer() {
          clearTimeout(_resetTimer);
          _resetTimer = setTimeout(_resetSequences, 1e3);
        }
        function _bindSequence(combo, keys, callback, action) {
          action = "keydown";
          _sequenceLevels[combo] = 0;
          function _increaseSequence(nextAction) {
            return function() {
              _nextExpectedAction = nextAction;
              ++_sequenceLevels[combo];
              _resetSequenceTimer();
            };
          }
          function _callbackAndReset(e) {
            const retVal = _fireCallback(callback, e, combo);
            if (action !== "keyup") {
              _ignoreNextKeyup = _characterFromEvent(e);
            }
            setTimeout(_resetSequences, 10);
            return retVal;
          }
          for (var i3 = 0; i3 < keys.length; ++i3) {
            var isFinal = i3 + 1 === keys.length;
            var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i3 + 1]).action);
            _bindSingle(keys[i3], wrappedCallback, action, combo, i3);
          }
        }
        function _bindSingle(combination, callback, action, sequenceName, level) {
          self2._directMap[combination + ":" + action] = callback;
          combination = combination.replace(/\s+/g, " ");
          var sequence = combination.split(" ");
          var info2;
          if (sequence.length > 1) {
            _bindSequence(combination, sequence, callback, action);
            return;
          }
          info2 = _getKeyInfo(combination, action);
          self2._callbacks[info2.key] = self2._callbacks[info2.key] || [];
          self2._callbacks[info2.key][sequenceName ? "unshift" : "push"]({
            callback,
            modifiers: info2.modifiers,
            action: info2.action,
            seq: sequenceName,
            level,
            combo: combination
          });
        }
        self2._bindMultiple = function(combinations2, callback, action) {
          for (var i3 = 0; i3 < combinations2.length; ++i3) {
            _bindSingle(combinations2[i3], callback, action);
          }
        };
        _addEvent(targetElement, "keypress", _handleKeyEvent, useCapture);
        _addEvent(targetElement, "keydown", _handleKeyEvent, useCapture);
        _addEvent(targetElement, "keyup", _handleKeyEvent, useCapture);
      }
      Mousetrap5.prototype.bind = function(keys, callback, action) {
        var self2 = this;
        keys = keys instanceof Array ? keys : [keys];
        self2._bindMultiple.call(self2, keys, callback, action);
        return self2;
      };
      Mousetrap5.prototype.unbind = function(keys, action) {
        var self2 = this;
        return self2.bind.call(self2, keys, function() {
        }, action);
      };
      Mousetrap5.prototype.reset = function() {
        var self2 = this;
        self2._callbacks = {};
        self2._directMap = {};
        return self2;
      };
      Mousetrap5.prototype.stopCallback = function(e, element) {
        var self2 = this;
        if ((" " + element.className + " ").indexOf(" mousetrap ") > -1) {
          return false;
        }
        if (_belongsTo(element, self2.target)) {
          return false;
        }
        if ("composedPath" in e && typeof e.composedPath === "function") {
          var initialEventTarget = e.composedPath()[0];
          if (initialEventTarget !== e.target) {
            element = initialEventTarget;
          }
        }
        let elementToEvaluate = element;
        if (element.tagName == "IFRAME") {
          try {
            elementToEvaluate = element.contentWindow.document.activeElement;
          } catch (e2) {
          }
        }
        return elementToEvaluate.tagName == "INPUT" || elementToEvaluate.tagName == "SELECT" || elementToEvaluate.tagName == "TEXTAREA" || elementToEvaluate.isContentEditable;
      };
      Mousetrap5.prototype.handleKey = function() {
        var self2 = this;
        return self2._handleKey.apply(self2, arguments);
      };
      Mousetrap5.addKeycodes = function(object2) {
        for (var key in object2) {
          if (object2.hasOwnProperty(key)) {
            _MAP[key] = object2[key];
          }
        }
        _REVERSE_MAP = null;
      };
      Mousetrap5.init = function() {
        var documentMousetrap = Mousetrap5(document2);
        for (var method in documentMousetrap) {
          if (method.charAt(0) !== "_") {
            Mousetrap5[method] = function(method2) {
              return function() {
                return documentMousetrap[method2].apply(documentMousetrap, arguments);
              };
            }(method);
          }
        }
      };
      Mousetrap5.init();
      window2.Mousetrap = Mousetrap5;
      if (typeof module2 !== "undefined" && module2.exports) {
        module2.exports = Mousetrap5;
      }
      if (false) {
        null(function() {
          return Mousetrap5;
        });
      }
    })(typeof window !== "undefined" ? window : null, typeof window !== "undefined" ? document : null);
    (function(Mousetrap5) {
      var _originalStopCallback = Mousetrap5.prototype.stopCallback;
      Mousetrap5.prototype.stopCallback = function(e, element, combo) {
        var self2 = this;
        if (self2.paused) {
          return true;
        }
        return _originalStopCallback.call(self2, e, element, combo);
      };
      Mousetrap5.prototype.pause = function() {
        var self2 = this;
        self2.paused = true;
      };
      Mousetrap5.prototype.unpause = function() {
        var self2 = this;
        self2.paused = false;
      };
      Mousetrap5.init();
    })(Mousetrap);
  }
});

// commandbar/src/products/spotlight/store/features/selectOrCreate.ts
var CREATED_FIELD_NAME, isEnabled, recordIsCreated, addCreatedOptionToList, SelectOrCreate;
var init_selectOrCreate = __esm({
  "commandbar/src/products/spotlight/store/features/selectOrCreate.ts"() {
    "use strict";
    init_selectors8();
    init_ParameterOption();
    init_selectors3();
    CREATED_FIELD_NAME = "_createdByCommandBar";
    isEnabled = (currentStep) => {
      return isSelectStep(currentStep) && !!currentStep.argument.allow_create;
    };
    recordIsCreated = (record12) => {
      return !!record12[CREATED_FIELD_NAME];
    };
    addCreatedOptionToList = ({
      options,
      _,
      currentStep,
      inputValue
    }) => {
      var _a2, _b2;
      if (!isEnabled(currentStep)) {
        return options;
      }
      if (options.length > 0 && !isParameterOption(options[0])) {
        return options;
      }
      if (!inputValue.length) {
        return options;
      }
      const hasMatch = options.find((o) => o.label === inputValue);
      if (hasMatch) {
        return options;
      } else {
        return [
          ...options,
          initParameterOption(
            _,
            `Create new ${(_b2 = (_a2 = currentStep.argument) == null ? void 0 : _a2.allow_create_label) != null ? _b2 : currentStep.argument.userDefinedName}`,
            {
              [CREATED_FIELD_NAME]: true,
              value: inputValue
            }
          )
        ];
      }
    };
    SelectOrCreate = {
      isEnabled,
      recordIsCreated,
      addCreatedOptionToList
    };
  }
});

// internal/src/middleware/experiencesSearch.tsx
import * as t35 from "io-ts";
var FilterV2, ExperienceTypeOptions, CommandExperience2, OtherExperience, ExperienceHitV, SearchExperiencesResponseV, SearchExperiencesPayloadV, ExperiencesSearch;
var init_experiencesSearch = __esm({
  "internal/src/middleware/experiencesSearch.tsx"() {
    "use strict";
    init_network();
    init_generics();
    init_command();
    FilterV2 = t35.union([t35.partial({ labels: t35.array(t35.string) }), t35.null]);
    ExperienceTypeOptions = t35.union([
      t35.array(
        t35.union([
          t35.literal("page"),
          t35.literal("action"),
          t35.literal("helpdoc"),
          t35.literal("video"),
          t35.literal("nudge"),
          t35.literal("checklist")
        ])
      ),
      t35.undefined
    ]);
    CommandExperience2 = t35.type({
      type: t35.union([t35.literal("page"), t35.literal("action"), t35.literal("helpdoc"), t35.literal("video")]),
      experience_id: t35.number,
      experience: CommandV,
      excerpt: t35.string,
      score: t35.array(t35.number)
    });
    OtherExperience = t35.type({
      type: t35.union([t35.literal("nudge"), t35.literal("checklist")]),
      experience_id: t35.number,
      experience: t35.undefined,
      excerpt: t35.string,
      score: t35.array(t35.number)
    });
    ExperienceHitV = t35.union([CommandExperience2, OtherExperience]);
    SearchExperiencesResponseV = t35.type({
      data: t35.array(t35.type({ hit: ExperienceHitV }))
    });
    SearchExperiencesPayloadV = t35.partial({
      query: t35.string,
      widget: t35.union([t35.literal("helphub"), t35.literal("spotlight")]),
      experience_types: t35.string,
      // Messy to enumerate ('helpdoc' | 'video' | 'helpdoc,video'...)
      max_results: t35.union([t35.number, t35.undefined]),
      user_properties: t35.union([t35.record(t35.string, t35.unknown), t35.undefined]),
      distinct_id: t35.union([t35.string, t35.undefined]),
      filter: FilterV2
    });
    ExperiencesSearch = class {
    };
    ExperiencesSearch.search = async (orgUID, payload, options) => {
      const serializedPayload = Object.entries(payload).filter(([_key, value]) => Boolean(value)).map(([key, value]) => {
        if (typeof value === "object") {
          value = JSON.stringify(value);
        }
        return `${key}=${encodeURIComponent(value)}`;
      }).join("&");
      const result = await get2(
        `search/experiences/${orgUID}/?${serializedPayload}`,
        {
          ...options
        }
      );
      return await decodeToPromise(t35.exact(SearchExperiencesResponseV), result.data);
    };
  }
});

// commandbar/src/shared/sdk/search.ts
var _queryHelpDocs, queryHelpDocCommands, queryHelpDocs, queryExperiences, convertInternalChatHistoryToExternal, fetchAIChatAnswer, extractPageInfo, fetchSearchSuggestions;
var init_search = __esm({
  "commandbar/src/shared/sdk/search.ts"() {
    "use strict";
    init_globals();
    init_symbols();
    init_Logger();
    init_location();
    init_service_selectors();
    init_chat();
    init_helpDocsSearch();
    init_experiencesSearch();
    init_LocalStorage();
    init_helpdocService();
    init_end_users();
    _queryHelpDocs = async (orgId, query, endUser, expand_rules, filter, abortController) => {
      const response2 = await HelpDocsSearch.search(
        orgId,
        { query, filter, expand_rules, include_additional_docs: true },
        {
          signal: abortController == null ? void 0 : abortController.signal,
          headers: {
            ...!!(endUser == null ? void 0 : endUser.hmac) && { "X-USER-AUTHORIZATION": endUser == null ? void 0 : endUser.hmac },
            ...!!(endUser == null ? void 0 : endUser.slug) && { "X-USER-ID": endUser == null ? void 0 : endUser.slug }
          }
        }
      );
      const searchResults = response2.data;
      if (searchResults && searchResults.length > 0)
        return searchResults.map((d) => {
          const hit = d.hit;
          helpdocService_default.addToCache(hit.command.id, hit, query);
          return hit;
        });
      return [];
    };
    queryHelpDocCommands = async (orgId, query, endUser, filter, abortController) => (await _queryHelpDocs(orgId, query, endUser, true, filter, abortController)).map((hit) => ({
      ...hit.command
    }));
    queryHelpDocs = async (orgId, query, endUser, filter) => (await _queryHelpDocs(orgId, query, endUser, false, filter).catch((err) => {
      Logger_default.warn(`Search error: ${err}`);
      return [];
    })).map((hit) => commandToHelpHubDoc(hit.command, hit));
    queryExperiences = async (_, query, widget, experienceTypes, maxResults, abortController, ignoreAvailability) => {
      var _a2, _b2, _c2, _d, _e;
      if (!_.organization)
        return [];
      try {
        const userProperties = {};
        const completeUserProperties = userProperties ? addDeviceProperties(userProperties) : void 0;
        const response2 = await ExperiencesSearch.search(
          _.organization.id,
          {
            query,
            widget,
            experience_types: experienceTypes == null ? void 0 : experienceTypes.join(","),
            filter: _.helpHub.filter,
            max_results: maxResults,
            user_properties: ignoreAvailability ? void 0 : completeUserProperties,
            distinct_id: ignoreAvailability ? void 0 : (_a2 = _.endUser) == null ? void 0 : _a2.slug
          },
          {
            signal: abortController == null ? void 0 : abortController.signal,
            headers: {
              ...!!((_b2 = _.endUser) == null ? void 0 : _b2.hmac) && { "X-USER-AUTHORIZATION": (_c2 = _.endUser) == null ? void 0 : _c2.hmac },
              ...!!((_d = _.endUser) == null ? void 0 : _d.slug) && { "X-USER-ID": (_e = _.endUser) == null ? void 0 : _e.slug }
            }
          }
        );
        const searchResults = response2.data;
        if (searchResults && searchResults.length > 0)
          return searchResults.map((d) => {
            const hit = d.hit;
            if (hit.type === "helpdoc") {
              helpdocService_default.addToCache(
                hit.experience_id,
                { score: hit.score, command: hit.experience, excerpt: hit.experience.content },
                query
              );
            }
            return hit;
          });
        return [];
      } catch (err) {
        if (!(abortController == null ? void 0 : abortController.signal.aborted)) {
          Logger_default.warn(`Search error: ${err}`);
        }
        return [];
      }
    };
    convertInternalChatHistoryToExternal = (history) => {
      var _a2;
      const chat_history = [];
      if (history) {
        for (let i2 = 0; i2 < history.length; i2++) {
          const entry = history[i2];
          if (i2 === 0 && entry.message_type !== "USER") {
            continue;
          }
          if (entry.message_type === "USER") {
            chat_history.push({
              question: entry.value.question,
              answer: null
            });
          } else if (entry.message_type === "AI") {
            chat_history[chat_history.length - 1].answer = {
              message: entry.value.answer || "",
              message_id: (_a2 = entry.value) == null ? void 0 : _a2.message_id
            };
          }
        }
      }
      return chat_history;
    };
    fetchAIChatAnswer = async (organization, query, chatID, filter, endUser, abortController, previewedCopilotSettings, attachments, userPropertiesOverride, isAdmin) => {
      var _a2, _b2;
      const system_template_override = String(LocalStorage_default.get("prompt", ""));
      const previewCopilotSettingsPayload = previewedCopilotSettings ? {
        name: previewedCopilotSettings == null ? void 0 : previewedCopilotSettings.name,
        personality: previewedCopilotSettings == null ? void 0 : previewedCopilotSettings.personality,
        custom_instructions: previewedCopilotSettings == null ? void 0 : previewedCopilotSettings.custom_instructions
      } : null;
      const SDK = getSDK();
      const payload = {
        command_ids: [],
        query,
        copilot_api_headers: (_a2 = SDK[_instanceAttributes]) == null ? void 0 : _a2.copilotAPIHeaders,
        user_timezone: (_b2 = SDK[_instanceAttributes]) == null ? void 0 : _b2.userTimezone,
        user: SDK[_user],
        hmac: endUser == null ? void 0 : endUser.hmac,
        chat_id: chatID,
        filter,
        disable_experiences: !!window._cbIsWebView,
        ...!!system_template_override && { system_template_override },
        settings_override: previewCopilotSettingsPayload,
        attachments,
        user_properties_override: userPropertiesOverride,
        is_admin: isAdmin
      };
      try {
        const response2 = await Chat.generateAIAnswer(organization.id, payload, { signal: abortController == null ? void 0 : abortController.signal });
        return response2;
      } catch (err) {
        if (abortController == null ? void 0 : abortController.signal.aborted)
          return { error: "aborted" /* Aborted */ };
        Logger_default.warn(`AI chat response error: ${err}`);
        if (!!err.detail && err.detail === "Error getting response from model") {
          return { error: "model_error" /* ModelError */ };
        }
        if (!!err.detail && err.detail.startsWith("Request was throttled")) {
          return { error: "throttled" /* Throttled */ };
        }
        return { error: "unknown" /* Unknwon */ };
      }
    };
    extractPageInfo = () => {
      const title = document.title;
      const metaDescription = document.querySelector('meta[name="description"]');
      const description = metaDescription && metaDescription instanceof HTMLMetaElement ? metaDescription.content : null;
      const h1s = Array.from(document.querySelectorAll("h1")).map((h1) => h1.textContent).filter((t44) => !!t44);
      const h2s = Array.from(document.querySelectorAll("h2")).map((h2) => h2.textContent).filter((t44) => !!t44);
      const h3s = Array.from(document.querySelectorAll("h3")).map((h3) => h3.textContent).filter((t44) => !!t44);
      return {
        title,
        description,
        h1s,
        h2s,
        h3s
      };
    };
    fetchSearchSuggestions = async (organizationId) => {
      const payload = {
        ...isStudioPreview() ? {} : { page_context: extractPageInfo() },
        user: getSDK()[_user]
      };
      try {
        const response2 = await Chat.generateQuestionSuggestions(organizationId, payload);
        return response2;
      } catch (err) {
        Logger_default.warn(`Live answer error: ${err}`);
      }
      return null;
    };
  }
});

// commandbar/src/products/spotlight/store/generate-options/actions.ts
import isEqual4 from "lodash/isEqual";
function DebounceWithCancellation(fn, timeout) {
  let timeoutId = null;
  let abortLastPromise = null;
  return (...args) => {
    if (timeoutId) {
      abortLastPromise == null ? void 0 : abortLastPromise.abort();
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    return new Promise((resolve, reject) => {
      timeoutId = setTimeout(() => {
        abortLastPromise = new AbortController();
        fn(abortLastPromise)(...args).then(
          (value) => {
            if (!(abortLastPromise == null ? void 0 : abortLastPromise.signal.aborted))
              resolve(value);
          },
          (error3) => {
            if (!(abortLastPromise == null ? void 0 : abortLastPromise.signal.aborted))
              reject(error3);
          }
        );
      }, timeout);
    });
  };
}
var requestInstanceKey, defaultCommands, getHotloadedHelpdocCommands, getHotloadedHelpdocExperiences, updateHotloadedHelpdocCommands, callAllLoaders, callLoader, handleAsyncPreselect, setStepSelectionsDuringStep;
var init_actions3 = __esm({
  "commandbar/src/products/spotlight/store/generate-options/actions.ts"() {
    "use strict";
    init_selectors8();
    init_selectors3();
    init_global_actions();
    init_Logger();
    init_OptionValidate();
    init_search();
    init_sentry();
    init_service_selectors();
    init_Step();
    requestInstanceKey = "commandbar-hotload-commands";
    defaultCommands = null;
    getHotloadedHelpdocCommands = DebounceWithCancellation(
      (abort) => async (organization, input, endUser) => {
        var _a2;
        try {
          return {
            commands: await queryHelpDocCommands(
              organization.id,
              input,
              endUser,
              null,
              abort
            )
          };
        } catch (e) {
          if (abort.signal.aborted) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
          }
        }
        return null;
      },
      150
    );
    getHotloadedHelpdocExperiences = DebounceWithCancellation(
      (abort) => async (_, input) => {
        var _a2;
        try {
          return await queryExperiences(_, input, "spotlight", ["helpdoc"], void 0, abort);
        } catch (e) {
          if (abort.signal.aborted) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
          }
        }
        return null;
      },
      150
    );
    updateHotloadedHelpdocCommands = async (_) => {
      var _a2, _b2, _c2;
      if (!((_a2 = _.organization) == null ? void 0 : _a2.has_hotloaded_help_docs) || !((_b2 = _.organization) == null ? void 0 : _b2.in_bar_doc_search)) {
        return;
      }
      const setLoading2 = (isLoading) => {
        _.spotlight.loadingByKey[requestInstanceKey] = isLoading;
      };
      _.hotloadedCommands = [];
      const inputText = _.spotlight.inputText;
      if (_.spotlight.visible) {
        setLoading2(true);
      }
      if (inputText === "" && defaultCommands !== null) {
        _.hotloadedCommands = defaultCommands;
      }
      try {
        let commands;
        if ((_c2 = _.flags) == null ? void 0 : _c2["release-search-experiences-in-spotlight"]) {
          const result = await getHotloadedHelpdocExperiences(_, inputText);
          if (!result)
            return;
          commands = result.filter((hit) => hit.type === "helpdoc").map((hit) => hit.experience);
        } else {
          const result = await getHotloadedHelpdocCommands(_.organization, inputText, _ == null ? void 0 : _.endUser);
          if (!result)
            return;
          commands = result.commands;
        }
        if (commands && Array.isArray(commands)) {
          _.hotloadedCommands = commands.map((command, idx) => {
            var _a3, _b3;
            let modifiedArguments = command.arguments;
            if (command.template.type === "helpdoc" && isHelpHubWidgetAvailable(_) && ((_a3 = _.organization) == null ? void 0 : _a3.copilot_enabled) === true && ((_b3 = _.organization) == null ? void 0 : _b3.helphub_enabled) !== true) {
              const { __html__, ...rest } = command.arguments;
              modifiedArguments = rest;
            }
            return {
              ...command,
              arguments: modifiedArguments,
              sort_key: idx,
              // sort by order returned by Elastic Search -- NOT the order dictated by the user in the Editor
              isAsync: true
            };
          });
          if (inputText === "")
            defaultCommands = [..._.hotloadedCommands];
        }
      } finally {
        setLoading2(false);
      }
    };
    callAllLoaders = (_) => {
      return Promise.all(selectInitialValueCallbacks(_).map((k) => callLoader(_, k)));
    };
    callLoader = async (_, callbackKey) => {
      var _a2;
      const contextKey = callbackKey.split("commandbar-initialvalue-")[1];
      try {
        const results = await _.callbacks[callbackKey]();
        const prevResults = _.context[contextKey];
        if (prevResults !== results && !isEqual4(prevResults, results))
          addContext(_, { [contextKey]: results });
      } catch (e) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
        Logger_default.error(`Function loader caused an error. Key: ${contextKey}`);
      }
    };
    handleAsyncPreselect = async (_) => {
      var _a2, _b2, _c2;
      const { currentStep } = currentStepAndIndex(_);
      if (!isSelectStep(currentStep))
        return;
      if (!!((_a2 = currentStep == null ? void 0 : currentStep.argument) == null ? void 0 : _a2.preselected_key)) {
        if (hasInitialValueFnDefined((_b2 = currentStep == null ? void 0 : currentStep.argument) == null ? void 0 : _b2.preselected_key, _)) {
          const fnName = `commandbar-initialvalue-${(_c2 = currentStep == null ? void 0 : currentStep.argument) == null ? void 0 : _c2.preselected_key}`;
          const asyncFn = _.callbacks[fnName];
          const chosenValues = getArgumentSelections(_);
          const results = await asyncFn(chosenValues);
          setStepSelectionsDuringStep(currentStep, results);
        }
      }
    };
    setStepSelectionsDuringStep = (s, selection) => {
      if (Array.isArray(selection)) {
        if (s.type === "select" /* Select */)
          return;
      } else {
        if (s.type !== "select" /* Select */)
          selection = [selection];
      }
      if (s.type !== "select" /* Select */)
        selection = selection.slice(0);
      s.selected = {
        type: "parameter",
        category: null,
        data: selection
      };
    };
  }
});

// commandbar/src/products/spotlight/store/generate-options/selectors.ts
var generateTimeOptions, filterOptionsForDefaultState, getFallbackOptions;
var init_selectors7 = __esm({
  "commandbar/src/products/spotlight/store/generate-options/selectors.ts"() {
    "use strict";
    init_selectors8();
    init_ParameterOption();
    init_DateTime();
    init_Step();
    init_selectors3();
    init_selectors3();
    init_utils();
    init_OptionGroup();
    generateTimeOptions = (_, newInput, currentStep) => {
      return DateTime_default.search({
        inputValue: newInput,
        type: currentStep.argument.dateTimeArgumentTypeId
      }).map((suggestion) => {
        return initParameterOption(_, suggestion.label, suggestion);
      });
    };
    filterOptionsForDefaultState = (_, options, currentInput) => {
      const categoriesToHideBeforeSearch = selectHiddenCategories(_);
      const { currentStep } = currentStepAndIndex(_);
      const isDefaultStep = (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && currentStep.resource == null;
      return options.filter((opt) => {
        var _a2;
        if (isUnfurledCommandOption(opt) && currentInput.length === 0) {
          return false;
        }
        if (onlyShowDuringPowerselect(opt)) {
          const isPowerselect = (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && !!currentStep.resource;
          return isPowerselect;
        }
        if (isRecordOption(opt)) {
          const alwaysShowRecord = (_a2 = opt.searchOptions) == null ? void 0 : _a2.showResources;
          if (alwaysShowRecord)
            return true;
          if (isDefaultStep && currentInput.length === 0) {
            return opt.isRecent;
          }
          return true;
        }
        const hideCategory = (categoryId) => {
          if (isDefaultStep) {
            return categoriesToHideBeforeSearch.includes(categoryId);
          }
          return false;
        };
        if (isCommandOption(opt) && currentInput.length === 0) {
          if (!!opt.command.category && hideCategory(opt.command.category) && !opt.isRecommended) {
            return false;
          }
        }
        return true;
      });
    };
    getFallbackOptions = (_) => {
      var _a2, _b2;
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) !== "base" /* Base */) {
        return [];
      }
      const { organization } = _;
      const { inputText } = _.spotlight;
      if (!organization || !inputText) {
        return [];
      }
      const fallbackCommands = organization.fallback_commands;
      const fallbackOptions = _.spotlight.initialOptions.filter(isCommandOption).filter((c) => fallbackCommands.indexOf(c.command.id) !== -1).sort((a, b) => {
        if (a.isRecommended && b.isRecommended) {
          return compareObjs(
            {
              sort_key: a.command.recommend_sort_key,
              id: a.command.id
            },
            {
              sort_key: b.command.recommend_sort_key,
              id: b.command.id
            }
          );
        }
        if (a.isRecommended) {
          return -1;
        }
        if (b.isRecommended) {
          return 1;
        }
        return fallbackCommands.indexOf(a.command.id) - fallbackCommands.indexOf(b.command.id);
      });
      if (fallbackOptions.length) {
        const filteredOptions = filterOptionsForDefaultState(_, fallbackOptions, _.spotlight.inputText).filter(
          (_b2 = (_a2 = _.spotlight.searchFilter) == null ? void 0 : _a2.fn) != null ? _b2 : () => true
        );
        let groupInstance = fallbackGroup();
        filteredOptions.forEach((o, idx) => {
          filteredOptions[idx] = setOptionGroupKey(o, groupInstance.key);
          groupInstance = incrementOptionGroupSize(groupInstance);
        });
        if (filteredOptions.length === 0) {
          return [];
        }
        return [groupInstance, ...filteredOptions];
      }
      return fallbackOptions;
    };
  }
});

// commandbar/src/products/spotlight/store/generate-options/subscriptions.ts
import { snapshot as snapshot2, ref as ref2 } from "valtio";
var isSearchCallback, updateCurrentOptionsOnInitialOptionsChange, optionFilteringAndSorting, updateInitialOptions, callLoadersOnOpen, initGenerateOptionsSubs;
var init_subscriptions = __esm({
  "commandbar/src/products/spotlight/store/generate-options/subscriptions.ts"() {
    "use strict";
    init_selectors8();
    init_Step();
    init_sub();
    init_types2();
    init_actions9();
    init_selectors3();
    init_utils3();
    init_ParameterOption();
    init_Search();
    init_selectOrCreate();
    init_option_list_selectors();
    init_actions3();
    init_selectors7();
    init_Available();
    init_Reporting();
    isSearchCallback = (key) => key.includes("commandbar-search-");
    updateCurrentOptionsOnInitialOptionsChange = (_) => {
      var _a2, _b2, _c2, _d, _e, _f;
      const { currentStep } = currentStepAndIndex(_);
      if (((currentStep == null ? void 0 : currentStep.type) === "textinput" /* TextInput */ || (currentStep == null ? void 0 : currentStep.type) === "longtextinput" /* LongTextInput */) && ((_a2 = currentStep.selected) == null ? void 0 : _a2.data)) {
        if (_.spotlight.inputText) {
          _.spotlight.previousInputText = _.spotlight.inputText;
        }
        _.spotlight.inputText = (_b2 = currentStep.selected) == null ? void 0 : _b2.data;
        _.spotlight.rawInput = (_c2 = currentStep.selected) == null ? void 0 : _c2.data;
        _.spotlight.currentOptions = ref2(_.spotlight.initialOptions);
      }
      if (isSelectStep(currentStep) && isTimeStep(currentStep)) {
        _.spotlight.currentOptions = ref2(generateTimeOptions(_, _.spotlight.inputText, currentStep));
      } else if (isSelectStep(currentStep) && isContextFunctionStep(currentStep, _)) {
        _.spotlight.currentOptions = [];
        const fnName = isContextArgument(currentStep.argument) ? `commandbar-initialvalue-${currentStep.argument.value}` : null;
        const asyncFn = fnName && _.callbacks[fnName];
        if (asyncFn) {
          setLoading(_, fnName, true);
          const chosenValues = getArgumentSelections(_);
          try {
            const callAsyncFnAndSetResults = async () => {
              var _a3;
              const values = await asyncFn(chosenValues);
              if (values && Array.isArray(values)) {
                const newStep = currentStepAndIndex(_).currentStep;
                if (isSelectStep(newStep) && currentStep.argument.userDefinedName === ((_a3 = newStep == null ? void 0 : newStep.argument) == null ? void 0 : _a3.userDefinedName)) {
                  const parameterOptions = values.map((obj) => convertParameterToOption(_, obj, currentStep.argument));
                  _.spotlight.currentOptions = ref2(parameterOptions);
                  handleAsyncPreselect(_);
                }
              }
            };
            callAsyncFnAndSetResults();
          } finally {
            setLoading(_, fnName, false);
          }
        }
      } else {
        if (_.spotlight.inputText.length === 0) {
          if ((currentStep == null ? void 0 : currentStep.type) === "multiselect" /* MultiSelect */ && Object.keys(_.callbacks).find(isSearchCallback) && _.spotlight.initialOptions.length === 0 && Array.isArray((_d = currentStep.selected) == null ? void 0 : _d.data)) {
            _.spotlight.currentOptions = ref2(
              (((_e = currentStep.selected) == null ? void 0 : _e.data) || []).map((val) => {
                return convertParameterToOption(_, val, currentStep.argument);
              })
            );
          } else {
            _.spotlight.currentOptions = ref2(_.spotlight.initialOptions);
          }
        } else {
          if (Object.keys(_.callbacks).find((callbackKey) => callbackKey.includes("commandbar-search-")) || ((_f = _.organization) == null ? void 0 : _f.hotload_help_docs)) {
            _.spotlight.currentOptions = ref2(_.spotlight.initialOptions);
          }
        }
      }
    };
    optionFilteringAndSorting = (_) => {
      var _a2, _b2;
      const isFilterActive = !!_.spotlight.searchFilter;
      const { currentStep } = currentStepAndIndex(_);
      const options = (() => {
        if (isEditorBeingSummoned(_.spotlight.inputText)) {
          return [];
        } else if ((currentStep == null ? void 0 : currentStep.type) === "textinput" /* TextInput */) {
          return [initParameterOption(_, currentStep.argument.userDefinedName, _.spotlight.inputText)];
        } else if (isSelectStep(currentStep) && isTimeStep(currentStep)) {
          return generateTimeOptions(_, _.spotlight.inputText, currentStep);
        } else {
          let toRet = Search_default(_.spotlight.inputText, _, _.spotlight.currentOptions);
          if (SelectOrCreate.isEnabled(currentStep)) {
            toRet = SelectOrCreate.addCreatedOptionToList({
              _,
              options: toRet,
              inputValue: _.spotlight.inputText,
              currentStep
            });
          }
          return toRet;
        }
      })();
      const allFilteredOptions = isFilterActive ? options : filterOptionsForDefaultState(_, options, _.spotlight.inputText);
      const tabGroups = selectSearchTabs(_, false);
      const selectedFilteredOptions = ((_a2 = _.spotlight.searchFilter) == null ? void 0 : _a2.fn) ? allFilteredOptions.filter(_.spotlight.searchFilter.fn) : allFilteredOptions;
      let afterSort = sortOptionsAndInsertGroups(selectedFilteredOptions, _);
      const showFallbackOptions = !afterSort.length;
      if (_.spotlight.builtinAskCopilotOption && !_.spotlight.builtinAskCopilotOption.optionDisabled.isDisabled && (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && ((_b2 = _.organization) == null ? void 0 : _b2.copilot_enabled)) {
        afterSort.unshift(_.spotlight.builtinAskCopilotOption);
      }
      if (showFallbackOptions) {
        afterSort = afterSort.concat(getFallbackOptions(_));
      }
      _.spotlight.sortedOptions = ref2(afterSort);
      if (_.spotlight.inputText.length !== 0) {
        const allFilteredOptionsByGroup = new Map(
          tabGroups.map((tabGroup) => [tabGroup.key, options.filter(tabGroup.filterFn).length])
        );
        _.spotlight.optionCountsByTabGroup = ref2(allFilteredOptionsByGroup);
      } else {
        _.spotlight.optionCountsByTabGroup = ref2(/* @__PURE__ */ new Map());
      }
      if (!options.length && _.spotlight.inputText.length > 0) {
        noResultsForQuery(_.spotlight.inputText);
      }
    };
    updateInitialOptions = (_) => {
      const newOptions = _.commandsLoaded ? _.spotlight.availableOptionMemoizer.call(null, _, snapshot2(_), Available_default.available) : [];
      if (newOptions.length === 0 && _.spotlight.initialOptions.length === 0 || newOptions === _.spotlight.initialOptions)
        return;
      _.spotlight.initialOptions = ref2(newOptions);
    };
    callLoadersOnOpen = (_) => {
      if (_.spotlight.visible) {
        callAllLoaders(_);
      }
    };
    initGenerateOptionsSubs = (_) => [
      sub(_, updateInitialOptions, [
        ["spotlight", "visible"],
        ["commands"],
        ["programmaticCommands"],
        ["hotloadedCommands"],
        ["localContextSettings"],
        ["serverContextSettings"],
        ["context"],
        ["spotlight", "records"],
        ["callbacks"],
        ["testMode"]
      ]),
      sub(_, updateCurrentOptionsOnInitialOptionsChange, [["spotlight", "initialOptions"]]),
      // TODO: separate hotloaded commands into separate `engine.hotloadedCommands` state,
      // then merge with regular commands when we need allCommands
      sub(_, updateHotloadedHelpdocCommands, [["spotlight", "inputText"], ["active"]]),
      sub(_, optionFilteringAndSorting, [
        ["spotlight", "categories"],
        ["spotlight", "searchFilter"],
        ["spotlight", "expandedGroupKeys"],
        ["spotlight", "currentOptions"],
        ["spotlight", "inputText"],
        ["spotlight", "builtinAskCopilotOption"]
      ]),
      sub(_, callLoadersOnOpen, [["spotlight", "visible"]])
    ];
  }
});

// commandbar/src/products/spotlight/store/generate-options/get-records-machine.ts
import { assign, createMachine } from "xstate";
function mkMachine(callback, onError) {
  return createMachine(
    {
      // https://xstate.js.org/docs/guides/actions.html
      predictableActionArguments: true,
      context: { inputText: "", results: null },
      tsTypes: {},
      schema: { context: {}, events: {} },
      id: "Get Records from Search Function",
      initial: "initial",
      states: {
        loading: {
          invoke: {
            src: "query",
            id: "query",
            onDone: [
              {
                actions: "set results",
                target: "done"
              }
            ],
            onError: [
              {
                actions: "log error",
                target: "failure"
              }
            ]
          },
          tags: "loading"
        },
        failure: {},
        initial: {},
        debounce: {
          after: {
            "150": {
              target: "loading"
            }
          },
          tags: "loading"
        },
        done: {},
        "handle input text": {
          always: [
            {
              cond: "input text is empty",
              target: "initial"
            },
            {
              target: "debounce"
            }
          ]
        }
      },
      on: {
        "set input text": {
          actions: ["clear results", "set input text"],
          target: ".handle input text"
        }
      }
    },
    {
      services: {
        query: async (context) => await callback(context.inputText)
      },
      actions: {
        "set input text": assign({
          inputText: (_, event) => event.inputText
        }),
        "set results": assign((context, event) => {
          const data = event.data;
          if (Array.isArray(data)) {
            return { results: data };
          } else {
            console.warn("Pagination is no longer supported with records.");
            return { results: data.data };
          }
        }),
        "clear results": assign((_context) => {
          return { results: null };
        }),
        "log error": (_context, event) => {
          onError(event.data);
        }
      },
      guards: {
        "input text is empty": (context) => context.inputText === ""
      }
    }
  );
}
var init_get_records_machine = __esm({
  "commandbar/src/products/spotlight/store/generate-options/get-records-machine.ts"() {
    "use strict";
  }
});

// commandbar/src/products/spotlight/store/generate-options/get-records-subscriptions.ts
import { interpret } from "xstate";
import { ref as ref3 } from "valtio";
var COMMANDBAR_SEARCH_CALLBACK_PREFIX, isSearchCallback2, contextKeyToKey, spawnRecordsMachines, setInputText, initGlobalSubs, get_records_subscriptions_default;
var init_get_records_subscriptions = __esm({
  "commandbar/src/products/spotlight/store/generate-options/get-records-subscriptions.ts"() {
    "use strict";
    init_Logger();
    init_types2();
    init_selectors8();
    init_sub();
    init_get_records_machine();
    init_selectors3();
    init_Step();
    init_sentry();
    COMMANDBAR_SEARCH_CALLBACK_PREFIX = "commandbar-search-";
    isSearchCallback2 = (key) => key.startsWith(COMMANDBAR_SEARCH_CALLBACK_PREFIX);
    contextKeyToKey = (contextKey) => contextKey.slice(COMMANDBAR_SEARCH_CALLBACK_PREFIX.length);
    spawnRecordsMachines = (_) => {
      const machines = _.spotlight.recordsMachines;
      const searchCallbacks = new Set(Object.keys(_.callbacks).filter(isSearchCallback2));
      const machinesToSpawn = new Set(
        [...searchCallbacks].filter(
          (contextKey) => {
            var _a2;
            return !machines.has(contextKey) || ((_a2 = machines.get(contextKey)) == null ? void 0 : _a2.callback) !== _.callbacks[contextKey];
          }
        )
      );
      const machinesToStop = new Set([...machines.keys()].filter((contextKey) => !searchCallbacks.has(contextKey)));
      machinesToSpawn.forEach((contextKey) => {
        const callback = _.callbacks[contextKey];
        const key = contextKeyToKey(contextKey);
        const existingMachine = _.spotlight.recordsMachines.get(contextKey);
        if (existingMachine) {
          Logger_default.info(`Stopping existing machine for ${key}`);
          existingMachine.service.stop();
          _.spotlight.recordsMachines.delete(contextKey);
        }
        Logger_default.info("Spawning records machine", key);
        const machine3 = mkMachine(callback, (e) => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
        });
        const service = interpret(machine3);
        machines.set(contextKey, { callback, service });
        service.onTransition((state) => {
          if (!state.changed)
            return;
          const isLoading = state.hasTag("loading");
          _.spotlight.loadingByKey[key] = isLoading;
          if (state.context.results !== null) {
            _.spotlight.records[key] = {
              records: ref3(state.context.results)
            };
          } else {
            if (_.spotlight.records[key] && !isLoading) {
              delete _.spotlight.records[key];
            }
          }
        });
        service.start();
      });
      machinesToStop.forEach((contextKey) => {
        var _a2;
        (_a2 = machines.get(contextKey)) == null ? void 0 : _a2.service.stop();
        machines.delete(contextKey);
      });
    };
    setInputText = (_) => {
      const { currentStep } = currentStepAndIndex(_);
      const contextSettings = getContextSettings(_);
      const isTopLevel = (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && currentStep.resource === null || currentStep === void 0;
      const searchableFromTopLevel = Object.keys(contextSettings).filter((key) => !!contextSettings[key].search);
      const activeContextKey = isSelectStep(currentStep) && isContextArgument(currentStep.argument) ? currentStep.argument.value : void 0;
      const shouldRunCallback = (contextKey) => {
        const key = contextKeyToKey(contextKey);
        if (isTopLevel && searchableFromTopLevel.includes(key)) {
          return true;
        }
        if (!isTopLevel && activeContextKey === key) {
          return true;
        }
        return false;
      };
      _.spotlight.recordsMachines.forEach(({ service }, contextKey) => {
        if (!shouldRunCallback(contextKey))
          return;
        service.send({ type: "set input text", inputText: _.spotlight.inputText });
      });
    };
    initGlobalSubs = (_) => [
      sub(_, spawnRecordsMachines, [["callbacks"]]),
      sub(_, setInputText, [["spotlight", "inputText"]])
    ];
    get_records_subscriptions_default = initGlobalSubs;
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/CommandOption.tsx
var initCommandOption;
var init_CommandOption = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/CommandOption.tsx"() {
    "use strict";
    init_Interpolate();
    init_selectors3();
    init_Option();
    initCommandOption = (_, command, parent) => {
      var _a2;
      const o = initOption(
        _,
        "command" /* Command */,
        parent ? parent.label : interpolate(command.text, _, true, false),
        command.text,
        void 0,
        (_a2 = command.detail) != null ? _a2 : command.show_preview ? command.content : null
      );
      o.command = {
        ...command,
        explanation: interpolate(command.explanation, _, true, false),
        heading: interpolate(command.heading, _, true, false)
      };
      o.isRecommended = isCommandOptionRecommended(_, o);
      if (parent) {
        o.optionDisabled = parent.optionDisabled;
      } else {
        validateOptionDisabled(_, o);
      }
      const optionCategory = _.spotlight.categories.find((c) => c.id === command.category);
      const category = {
        label: "",
        contextKey: "",
        limit: null,
        renderAs: (optionCategory == null ? void 0 : optionCategory.render_as) || "list"
      };
      o.category = category;
      const optionUID = getOptionUID(o);
      o.isRecent = !!(optionUID && (optionCategory == null ? void 0 : optionCategory.track_recents) && _.endUserStore.derived.recentUIDs.includes(optionUID));
      return o;
    };
  }
});

// commandbar/src/products/copilot/components/BotAvatar.tsx
import React117 from "react";
var botAvatarDefaultImageSrc, BotAvatar, BotAvatar_default;
var init_BotAvatar = __esm({
  "commandbar/src/products/copilot/components/BotAvatar.tsx"() {
    "use strict";
    botAvatarDefaultImageSrc = "https://cdn.commandbar.com/_images/copilot_avatar_commandai.png";
    BotAvatar = () => {
      return /* @__PURE__ */ React117.createElement(
        "img",
        {
          src: botAvatarDefaultImageSrc,
          style: {
            width: "40px",
            height: "40px",
            flexShrink: 0
          },
          alt: ""
        }
      );
    };
    BotAvatar_default = BotAvatar;
  }
});

// commandbar/src/products/spotlight/subscriptions.ts
var import_mousetrap_fork, MIN_LOADING_TIMEOUT, refreshShowLoadingIndicator, autoChooseOption, refreshMinLoadingTimeout, refreshCommandsLoaded, resetOnCloseDashboard, refreshCurrentGroups, applyFilterIfMatchesSlashFilter, refreshCategories, experiencesCommandName, experiencesRecordKey, experiencesCallbackKey, checklistResourceKey, nudgeResourceKey, checkedIfShouldSearchExperiences, shouldSearchExperiences, checkIfShouldSearchExperiences, registerChecklistAndNudgeExperiencesAsRecords, registerBuiltinCommands, autoScrollToSelectedOption, refreshCurrentStepIndex, sendAnalyticsEventForCommandLastAvailableTime, resetFocusedIndex2, resetErrorIndexOnOptionsChange, setupShortcuts, initSpotlightSubs;
var init_subscriptions2 = __esm({
  "commandbar/src/products/spotlight/subscriptions.ts"() {
    "use strict";
    init_global_selectors();
    init_service_selectors2();
    init_actions9();
    init_global_actions();
    init_selectors3();
    init_sub();
    init_globals();
    init_Step();
    init_OptionGroup();
    init_slugify();
    init_SearchTabs();
    init_Analytics();
    init_Reporting();
    init_dispatchCustomEvent();
    init_command();
    import_mousetrap_fork = __toESM(require_mousetrap_fork());
    init_Hotkey();
    init_subscriptions();
    init_get_records_subscriptions();
    init_CommandOption();
    init_BotAvatar();
    init_search();
    init_service_selectors3();
    init_Interpolate();
    init_nudges();
    MIN_LOADING_TIMEOUT = 1e3;
    refreshShowLoadingIndicator = (_) => {
      const { loadingByKey, inMinLoadingWindow } = _.spotlight;
      const anyKeyIsLoading = Object.keys(loadingByKey).some((key) => !!loadingByKey[key]);
      _.spotlight.showLoadingIndicator = anyKeyIsLoading || inMinLoadingWindow;
    };
    autoChooseOption = (_) => {
      const updateSteps2 = updateSteps.bind(null, _);
      const { currentStep } = currentStepAndIndex(_);
      if (currentStep && currentStep.type === "select" /* Select */ && !currentStep.argument.allow_create && currentStep.argument.auto_choose && _.spotlight.initialOptions.length === 1) {
        chooseOption(_, _.spotlight.initialOptions[0], updateSteps2);
        return;
      }
      const activeRecord = (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && currentStep.resource;
      if (!activeRecord)
        return;
      const singleCommand = _.spotlight.initialOptions.length === 1 && _.spotlight.initialOptions[0];
      if (singleCommand) {
        chooseOption(_, singleCommand, updateSteps2);
        return;
      }
      return;
    };
    refreshMinLoadingTimeout = (_) => {
      if (Object.keys(_.spotlight.loadingByKey).length > 0)
        return;
      _.spotlight.inMinLoadingWindow = true;
      if (_.spotlight.minLoadingTimeout)
        clearTimeout(_.spotlight.minLoadingTimeout);
      _.spotlight.minLoadingTimeout = window.setTimeout(() => {
        _.spotlight.inMinLoadingWindow = false;
      }, MIN_LOADING_TIMEOUT);
    };
    refreshCommandsLoaded = (_) => {
      setLoading(_, "internal-commandsLoaded", !_.commandsLoaded);
    };
    resetOnCloseDashboard = (_) => {
      if (_.spotlight.dashboard === void 0 && _.spotlight.inputText !== "" && getCommands(_).length > 0) {
        setInputText2(_, "");
        reset(_);
      }
    };
    refreshCurrentGroups = (_) => {
      var _a2, _b2, _c2, _d;
      const availableCommandCategories = /* @__PURE__ */ new Set();
      const usedRecordKeys = /* @__PURE__ */ new Set();
      _.spotlight.initialOptions.forEach((option) => {
        var _a3;
        if (isCommandOption(option) || isUnfurledCommandOption(option)) {
          const categoryID = (_a3 = option.command) == null ? void 0 : _a3.category;
          if (!!categoryID) {
            availableCommandCategories.add(categoryID);
          }
          Object.keys(option.command.arguments).forEach((k) => {
            const value = option.command.arguments[k].value;
            if (typeof value === "string") {
              usedRecordKeys.add(value);
            }
          });
        }
      });
      _.spotlight.categories.filter((c) => !!c.contains_hotloaded_commands).forEach((c) => availableCommandCategories.add(c.id));
      const isValidRecord = (recordKey) => {
        const isActiveRecord = (() => {
          if (Boolean(_.context[recordKey]))
            return true;
          if (Object.keys(_.callbacks).includes(`commandbar-search-${recordKey}`))
            return true;
          if (Object.keys(_.callbacks).includes(`commandbar-initialvalue-${recordKey}`))
            return true;
          return false;
        })();
        return usedRecordKeys.has(recordKey) && isActiveRecord;
      };
      const recordGroups = Object.entries(getContextSettings(_)).filter(([k]) => isValidRecord(k)).map(([k, v]) => {
        const group = initOptionGroupFromRecordCategory(k, _, v);
        return group;
      });
      const commandGroups = _.spotlight.categories.filter((g) => availableCommandCategories.has(g.id)).map((c) => {
        const group = initOptionGroupFromCommandCategory(c, _);
        return group;
      });
      const syntheticGroups = [];
      if ((_a2 = _.organization) == null ? void 0 : _a2.end_user_recents_enabled) {
        syntheticGroups.push({
          ...initRecentsGroup(_),
          slash_filter_enabled: true,
          searchTabEnabled: ((_b2 = _.organization) == null ? void 0 : _b2.recents_tab_enabled) || false
        });
      }
      if (((_c2 = _.organization) == null ? void 0 : _c2.recommendations_type) !== "None") {
        syntheticGroups.push({
          ...initRecommendedGroup(_),
          slash_filter_enabled: true,
          searchTabEnabled: ((_d = _.organization) == null ? void 0 : _d.recommended_tab_enabled) || false
        });
      }
      const tabs = _.spotlight.tabs.map((t44) => initOptionGroupFromTab(t44, _));
      _.spotlight.currentGroups = [...commandGroups, ...recordGroups, ...syntheticGroups, ...tabs].map((group) => {
        if (!!!group.slash_filter_keyword) {
          group.slash_filter_keyword = slugify_default(group.name);
        }
        return group;
      });
    };
    applyFilterIfMatchesSlashFilter = (_) => {
      var _a2;
      if (!((_a2 = _.organization) == null ? void 0 : _a2.slash_filters_enabled)) {
        return;
      }
      const { inputText, slashFilter } = selectSlashFilter(_);
      if (slashFilter.length <= 1) {
        return;
      }
      const slashFilterKeyword = slashFilter.substring(1);
      const labelAllTab = !!_.theme ? slugify_default(_.theme.searchTab.labelAllTab) : "all";
      if (slashFilterKeyword.toLowerCase() === labelAllTab.toLowerCase()) {
        _.spotlight.searchFilter = void 0;
        _.spotlight.rawInput = inputText;
        return;
      }
      const slashFilterGroups = selectSlashFilterGroups(_);
      const slashFilterGroup = slashFilterGroups.find((o) => {
        if (o.slash_filter_keyword === slashFilterKeyword.toLowerCase()) {
          return true;
        }
        return false;
      });
      if (!!slashFilterGroup) {
        const filter = createSearchFilter(slashFilterGroup);
        setSearchFilter(_, filter);
        _.spotlight.rawInput = inputText;
        return;
      }
    };
    refreshCategories = (_) => {
      _.spotlight.categories = [..._.spotlight.localCategories, ..._.spotlight.serverCategories].map((category) => ({
        ...category,
        ..._.spotlight.categoryConfig[category.id]
      }));
    };
    experiencesCommandName = SDK_INTERNAL_PREFIX + "experiences_command";
    experiencesRecordKey = SDK_INTERNAL_PREFIX + "experiences";
    experiencesCallbackKey = SDK_INTERNAL_PREFIX + "show_experience";
    checklistResourceKey = SDK_INTERNAL_PREFIX + "completed_checklist";
    nudgeResourceKey = SDK_INTERNAL_PREFIX + "seen_nudge";
    checkedIfShouldSearchExperiences = false;
    shouldSearchExperiences = true;
    checkIfShouldSearchExperiences = async (_) => {
      if (!_.isAdmin && !checkedIfShouldSearchExperiences) {
        checkedIfShouldSearchExperiences = true;
        const results = await queryExperiences(_, "", "spotlight", void 0, 1, void 0, true);
        if (results.length === 0) {
          shouldSearchExperiences = false;
        }
      }
    };
    registerChecklistAndNudgeExperiencesAsRecords = (_) => {
      var _a2, _b2, _c2;
      if (!_.active || !((_a2 = _.flags) == null ? void 0 : _a2["release-search-experiences-in-spotlight"]))
        return;
      const sdk = getSDK();
      sdk.addCallback(experiencesCallbackKey, (item) => {
        var _a3, _b3;
        const type39 = (_a3 = item.record) == null ? void 0 : _a3.type;
        const id2 = (_b3 = item == null ? void 0 : item.record) == null ? void 0 : _b3.id;
        if (type39 === "checklist") {
          const checklist3 = getChecklistById(_, id2);
          if (checklist3) {
            activatePushExperience(_, checklist3, "questlist");
          }
        } else if (type39 === "nudge") {
          const nudge = getNudgeById(_, id2);
          if (nudge) {
            activatePushExperience(_, nudge, "nudge");
          }
        }
      });
      const onSearchExperiences = async (query) => {
        if (!shouldSearchExperiences || !query) {
          return [];
        }
        const results = await queryExperiences(_, query, "spotlight");
        return results.map((hit) => {
          var _a3, _b3, _c3, _d, _e;
          if (hit.type === "nudge") {
            const nudge = getNudgeById(_, hit.experience_id);
            if (nudge && nudge.id) {
              return {
                label: nudge.slug || ((_a3 = getNudgeStep(nudge, 0)) == null ? void 0 : _a3.title) || "Nudge",
                icon: ((_c3 = (_b3 = _.organization) == null ? void 0 : _b3.resource_options[nudgeResourceKey]) == null ? void 0 : _c3.icon) || "nudge",
                id: nudge.id,
                type: "nudge",
                description: ""
              };
            }
          } else if (hit.type === "checklist") {
            const checklist3 = getChecklistById(_, hit.experience_id);
            if (checklist3) {
              return {
                label: checklist3.title,
                icon: ((_e = (_d = _.organization) == null ? void 0 : _d.resource_options[checklistResourceKey]) == null ? void 0 : _e.icon) || "checklist",
                id: checklist3.id,
                type: "checklist",
                description: checklist3.description
              };
            }
          }
          return null;
        }).filter((experience) => experience);
      };
      sdk.addRecords(experiencesRecordKey, [], {
        onInputChange: onSearchExperiences,
        recordOptions: {
          categoryName: ((_b2 = _.theme) == null ? void 0 : _b2.categoryHeader.experiencesHeaderLabel) || "Experiences",
          showInDefaultEmptyState: false,
          maxOptionsCount: 3,
          showInRecents: false,
          categorySortKey: ((_c2 = _.organization) == null ? void 0 : _c2.experiences_sort_key) || 0
        },
        descriptionKey: "description"
      });
      sdk.addRecordAction(experiencesRecordKey, {
        name: experiencesCommandName,
        text: "Show item",
        template: { type: "callback", value: experiencesCallbackKey }
      });
      return () => {
        sdk.removeCallback(experiencesCallbackKey);
        sdk.removeContext(experiencesRecordKey);
        sdk.removeCommand(experiencesCommandName);
      };
    };
    registerBuiltinCommands = (_) => {
      var _a2, _b2, _c2, _d, _e, _f;
      if (!_.active || !_.organization || !_.organization.spotlight_ask_copilot_enabled || !_.organization.copilot_enabled) {
        _.spotlight.builtinAskCopilotOption = null;
        return;
      }
      const sdk = getSDK();
      const callbackKey = SDK_INTERNAL_PREFIX + "open-copilot";
      sdk.addCallback(callbackKey, () => {
        sdk.openCopilot({ query: _.spotlight.previousInputText });
      });
      _.spotlight.builtinAskCopilotOption = initCommandOption(_, {
        text: interpolate(
          _.organization.spotlight_ask_copilot_label || `Ask ${(_b2 = (_a2 = _.organization) == null ? void 0 : _a2.copilot_name) != null ? _b2 : "Copilot"}`,
          _,
          true,
          false
        ),
        name: "__commandbar_ask_copilot",
        arguments: {},
        template: {
          type: "callback",
          value: callbackKey,
          operation: "blank",
          commandType: "independent"
        },
        tags: [],
        availability_rules: [],
        availability_expression: ((_c2 = _.organization.spotlight_ask_copilot_audience) == null ? void 0 : _c2.type) === "rule_expression" ? _.organization.spotlight_ask_copilot_audience.expression : {
          type: "LITERAL",
          value: true
        },
        recommend_expression: {
          type: "LITERAL",
          value: false
        },
        always_recommend: false,
        recommend_rules: [],
        confirm: "",
        detail: null,
        content: null,
        show_preview: false,
        thumbnail: null,
        shortcut: [],
        shortcut_mac: [],
        shortcut_win: [],
        hotkey_mac: "",
        hotkey_win: "",
        explanation: "",
        heading: "",
        is_live: true,
        category: null,
        sort_key: null,
        icon: ((_d = _.organization) == null ? void 0 : _d.copilot_avatar) || ((_f = (_e = _.organization) == null ? void 0 : _e.copilot_avatar_v2) == null ? void 0 : _f.src) || botAvatarDefaultImageSrc,
        icon_color: null,
        image_color: null,
        image: null,
        celebrate: null,
        recommend_sort_key: null,
        next_steps: [],
        copilot_suggest: false,
        copilot_cta_label: "",
        copilot_description: "",
        copilot_use_verbatim: false,
        extra: null,
        id: -1,
        show_in_helphub_search: false,
        show_in_spotlight_search: true,
        audience: { type: "all_users" }
      });
    };
    autoScrollToSelectedOption = (_) => {
      var _a2;
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) === "select" /* Select */ && ((_a2 = currentStep.selected) == null ? void 0 : _a2.data) && _.spotlight.inputText.length === 0) {
        const selectedIndex = _.spotlight.sortedOptions.findIndex(
          (option) => isParameterOption(option) && isParameterOptionSelected(option, currentStep)
        );
        if (selectedIndex !== -1) {
          _.spotlight.focusedIndex = selectedIndex;
        }
      }
    };
    refreshCurrentStepIndex = (_) => {
      _.spotlight.currentStepIndex = currentStepAndIndex(_).currentStepIndex;
    };
    sendAnalyticsEventForCommandLastAvailableTime = (_) => {
      if (_.spotlight.visible && !_.testMode && _.spotlight.currentOptions.length > 0) {
        const availableCommands2 = _.spotlight.initialOptions.filter(isCommandOption).map((c) => c.command.id);
        Analytics_default.availability(availableCommands2);
      }
    };
    resetFocusedIndex2 = (_) => {
      resetFocusedIndex(_);
    };
    resetErrorIndexOnOptionsChange = (_) => {
      _.spotlight.errorIndex = -1;
    };
    setupShortcuts = (_) => {
      if (!(_ == null ? void 0 : _.organization))
        return;
      import_mousetrap_fork.default.reset();
      if (["mac", "windows", "linux"].includes(_.platform)) {
        getCommands(_).map((cmd) => {
          var _a2;
          let hotkey = _.platform === "mac" ? cmd.hotkey_mac : cmd.hotkey_win;
          const cmdUID = commandUID(cmd);
          if (typeof ((_a2 = _.endUserStore.data.hotkeys) == null ? void 0 : _a2[cmdUID]) !== "undefined") {
            hotkey = _.endUserStore.data.hotkeys[cmdUID];
          }
          if (hotkey.length === 0 || !cmd.is_live && !_.testMode) {
            return null;
          }
          import_mousetrap_fork.default.bind(hotkey, () => {
            const isDisabled = executeCommand(
              _,
              cmd,
              () => {
                dispatchCustomEvent("commandbar-shortcut-executed", { detail: { keys: hotkey } });
              },
              () => unavailableShortcut(Hotkey_default.toArray(hotkey), cmd)
            );
            return isDisabled;
          });
          return null;
        });
      }
    };
    initSpotlightSubs = (_) => [
      sub(_, refreshShowLoadingIndicator, [
        ["spotlight", "loadingByKey"],
        ["spotlight", "inMinLoadingWindow"]
      ]),
      sub(_, autoChooseOption, [["spotlight", "initialOptions"]]),
      sub(_, applyFilterIfMatchesSlashFilter, [["spotlight", "rawInput"]]),
      sub(_, refreshCurrentGroups, [
        ["spotlight", "categories"],
        ["spotlight", "initialOptions"],
        ["localContextSettings"],
        ["serverContextSettings"],
        ["theme", "categoryHeader"]
      ]),
      sub(_, refreshMinLoadingTimeout, [["spotlight", "loadingByKey"]]),
      sub(_, refreshCommandsLoaded, [["commandsLoaded"]]),
      sub(_, resetOnCloseDashboard, [["spotlight", "dashboard"]]),
      sub(_, refreshCategories, [
        ["spotlight", "serverCategories"],
        ["spotlight", "localCategories"],
        ["spotlight", "categoryConfig"]
      ]),
      sub(_, checkIfShouldSearchExperiences, [["spotlight", "visible"]]),
      sub(_, registerChecklistAndNudgeExperiencesAsRecords, [["active"]]),
      sub(_, registerBuiltinCommands, [["active"], ["spotlight", "visible"], ["organization"]]),
      /**
       * [Shorcuts]: set hotkeys on each change of context, callbacks, commands
       **/
      /*
        NOTE: How this can go wrong? (can move to a doc)
        This is using our existing strategy that we might consider rethinking
        We are setting the keybinds for _all_ the commands (whether or not they are admin/drafts/available/etc)
        A protective measure we take is we check availability of a shortcut command before executing it.
        Where does the preventDefault() go?
        Decision: If a keybind (say cmd-d) is set in the host app _and_ in CB, which should fire? Should this be a setting? If CB, we definitely need to exclude draft commands
        Decision: If a command isn't available in the current state, should it preventDefault?
        Mousetrap handles duplicate keybinds by only running the first one.
        How would we handle the following situation:
          - Two commands programmed to never be available at the same time
          - Attached the same keybind (because they are conceptually similar)
          - In this case, we would need to limit shortcut setup to available commands
          - Example (although there's a more elegant solution): "Toggle Dark", "Toggle Light"
         */
      sub(_, setupShortcuts, [
        ["commands"],
        ["programmaticCommands"],
        ["hotloadedCommands"],
        ["organization"],
        ["endUserStore", "data", "hotkeys"],
        ["testMode"]
      ]),
      sub(_, sendAnalyticsEventForCommandLastAvailableTime, [["spotlight", "visible"]]),
      sub(_, refreshCurrentStepIndex, [["spotlight", "steps"]], true),
      sub(_, resetErrorIndexOnOptionsChange, [["spotlight", "sortedOptions"]]),
      sub(_, resetFocusedIndex2, [["spotlight", "sortedOptions"]]),
      sub(_, autoScrollToSelectedOption, [
        ["spotlight", "steps"],
        ["spotlight", "sortedOptions"]
      ]),
      ...initGenerateOptionsSubs(_),
      ...get_records_subscriptions_default(_)
    ];
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/OptionGroup.tsx
var allowedOptionGroupTypes, capitalize, isOptionGroup2, generateOptionGroupKey, initWithDefaults, initOptionGroupFromCommandCategory, initOptionGroupFromTab, initOptionGroupFromRecordCategory, initOptionGroupFromParameterCategory, getGroupOfOption, getDefaultHeaderHeight, getRecordGroupKey, compareOptionGroups, isOptionGroupLoading, isOptionGroupOverLimit, isOptionGroupExpanded, canOptionGroupExpand, shouldEnforceOptionGroupLimit, incrementOptionGroupSize, recommendedGroup, recentsGroup, initRecentsGroup, initRecommendedGroup, noneGroup, fallbackGroup;
var init_OptionGroup = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/OptionGroup.tsx"() {
    "use strict";
    init_Interpolate();
    init_selectors3();
    init_ClientSearch();
    init_subscriptions2();
    allowedOptionGroupTypes = [
      "RECOMMENDED",
      "RECENTS",
      "RECORD_CATEGORY",
      "PARAMETER",
      "COMMAND_CATEGORY",
      "NONE",
      "TAB",
      "FALLBACK"
    ];
    capitalize = (s) => {
      if (typeof s !== "string")
        return "";
      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    isOptionGroup2 = (o) => typeof (o == null ? void 0 : o.type) === "string" && allowedOptionGroupTypes.includes(o.type);
    generateOptionGroupKey = (type39, id2) => {
      return `${type39}-${id2.toString()}`;
    };
    initWithDefaults = (name, key, type39) => {
      return {
        name,
        key,
        type: type39,
        limit: null,
        pinnedToBottom: false,
        sortFunction: void 0,
        showWithNoResults: false,
        searchTabEnabled: false,
        searchTabName: null,
        searchTabInstruction: null,
        sortKey: null,
        renderAs: "list",
        size: 0,
        slash_filter_enabled: false,
        slash_filter_keyword: null,
        filterFn: () => {
          return false;
        },
        hasHotloadedCommands: false
      };
    };
    initOptionGroupFromCommandCategory = (commandCategory, _) => {
      const groupKey = generateOptionGroupKey("COMMAND_CATEGORY", commandCategory.id);
      return {
        name: interpolate(commandCategory.name, _, true, false),
        key: groupKey,
        type: "COMMAND_CATEGORY",
        limit: commandCategory.setting_max_options_count,
        pinnedToBottom: commandCategory.setting_pin_to_bottom,
        searchTabEnabled: commandCategory.search_tab_enabled,
        searchTabName: commandCategory.search_tab_name,
        searchTabInstruction: commandCategory.search_tab_instruction,
        sortKey: commandCategory.sort_key,
        renderAs: commandCategory.render_as || "list",
        showWithNoResults: false,
        size: 0,
        slash_filter_enabled: commandCategory.slash_filter_enabled,
        slash_filter_keyword: commandCategory.slash_filter_keyword || null,
        filterFn: (o) => {
          return isCommandOption(o) && !!o.command.category && generateOptionGroupKey("COMMAND_CATEGORY", o.command.category) === groupKey;
        },
        hasHotloadedCommands: !!commandCategory.contains_hotloaded_commands
      };
    };
    initOptionGroupFromTab = (tab, _) => {
      const name = interpolate(tab.label, _, true, false);
      return {
        ...initWithDefaults(name, generateOptionGroupKey("TAB", tab.id), "TAB"),
        limit: void 0,
        pinnedToBottom: false,
        searchTabEnabled: true,
        searchTabName: tab.label,
        slash_filter_enabled: true,
        slash_filter_keyword: null,
        searchTabInstruction: tab.placeholder,
        sortKey: tab.sort_key,
        renderAs: tab.render_as,
        filterFn: (o) => {
          return isCommandOption(o) && !!o.command.category && tab.category_ids.includes(o.command.category);
        }
      };
    };
    initOptionGroupFromRecordCategory = (contextKey, _, searchOptions) => {
      var _a2, _b2, _c2;
      const categoryName = (searchOptions == null ? void 0 : searchOptions.name) || `${capitalize(contextKey)}`;
      const name = interpolate(categoryName, _, true, false);
      const groupKey = generateOptionGroupKey("RECORD_CATEGORY", contextKey);
      return {
        ...initWithDefaults(name, groupKey, "RECORD_CATEGORY"),
        limit: searchOptions == null ? void 0 : searchOptions.max_options_count,
        pinnedToBottom: !!(searchOptions == null ? void 0 : searchOptions.setting_pin_to_bottom),
        sortFunction: searchOptions == null ? void 0 : searchOptions.sortFunction,
        showWithNoResults: (searchOptions == null ? void 0 : searchOptions.search) && (searchOptions == null ? void 0 : searchOptions.show_with_no_results),
        // Note: doesn't support unfurling
        searchTabEnabled: (searchOptions == null ? void 0 : searchOptions.search_tab_enabled) && !searchOptions.unfurl || false,
        searchTabName: (searchOptions == null ? void 0 : searchOptions.search_tab_name) || null,
        searchTabInstruction: (searchOptions == null ? void 0 : searchOptions.search_tab_instruction) || null,
        sortKey: (_a2 = searchOptions == null ? void 0 : searchOptions.sort_key) != null ? _a2 : null,
        renderAs: (searchOptions == null ? void 0 : searchOptions.render_as) || "list",
        slash_filter_enabled: (_b2 = searchOptions == null ? void 0 : searchOptions.slash_filter_enabled) != null ? _b2 : true,
        slash_filter_keyword: (searchOptions == null ? void 0 : searchOptions.slash_filter_keyword) || null,
        filterFn: (o) => {
          return isRecordOption(o) && generateOptionGroupKey("RECORD_CATEGORY", o.category.contextKey) === groupKey;
        },
        hasHotloadedCommands: ClientSearch_default.isDefined(contextKey, _),
        onInputChangeOptions: {
          applySort: (_c2 = searchOptions == null ? void 0 : searchOptions.onInputChangeOptions) == null ? void 0 : _c2.applySort
        }
      };
    };
    initOptionGroupFromParameterCategory = (name, sortFunction, renderAs) => {
      return {
        ...initWithDefaults(name, generateOptionGroupKey("PARAMETER", name), "PARAMETER"),
        sortFunction,
        renderAs: renderAs || "list"
      };
    };
    getGroupOfOption = (option, categories, _, showRecommendedGroup) => {
      var _a2, _b2, _c2;
      if (isCommandOption(option)) {
        if (option.isRecommended && showRecommendedGroup) {
          return initRecommendedGroup(_);
        }
        if (option.isRecent) {
          return initRecentsGroup(_);
        }
        const categoryID = (_a2 = option.command) == null ? void 0 : _a2.category;
        if (!!categoryID) {
          const category = categories.find((obj) => obj.id === categoryID);
          if (category) {
            return initOptionGroupFromCommandCategory(category, _);
          }
        }
      } else if (isRecordOption(option)) {
        if (option.isRecent) {
          return initRecentsGroup(_);
        }
        return initOptionGroupFromRecordCategory(option.category.contextKey, _, option.searchOptions);
      } else if (isParameterOption(option)) {
        const category = getReservedField(option, "category") || "";
        const name = interpolate(category, _, true, false);
        return initOptionGroupFromParameterCategory(
          name,
          (_b2 = option.searchOptions) == null ? void 0 : _b2.sortFunction,
          (_c2 = option.searchOptions) == null ? void 0 : _c2.render_as
        );
      }
      return noneGroup();
    };
    getDefaultHeaderHeight = (theme, addPaddingTop) => {
      return parseInt(theme.categoryHeader.paddingBottom, 10) + parseInt(theme.categoryHeader.paddingTop, 10) + parseInt(theme.categoryHeader.fontSize, 10) + (addPaddingTop ? parseInt(theme.optionList.spaceBetweenCategories) : 0) + parseInt(theme.optionList.spaceBelowHeader, 10) + 1;
    };
    getRecordGroupKey = (group) => {
      if (group.type !== "RECORD_CATEGORY") {
        return null;
      } else {
        return group.key.replace("RECORD_CATEGORY-", "");
      }
    };
    compareOptionGroups = (a, b) => {
      if (a.pinnedToBottom !== b.pinnedToBottom) {
        if (a.pinnedToBottom)
          return 1;
        if (b.pinnedToBottom)
          return -1;
      }
      const specialCategories = [
        recommendedGroup().key,
        recentsGroup().key,
        `RECORD_CATEGORY-${experiencesRecordKey}`,
        noneGroup().key
      ];
      const specialIdxA = specialCategories.findIndex((k) => k === a.key && a.sortKey === null);
      const specialIdxB = specialCategories.findIndex((k) => k === b.key && b.sortKey === null);
      if (specialIdxA !== -1 && specialIdxB !== -1)
        return specialIdxA - specialIdxB;
      if (specialIdxA !== -1)
        return -1;
      if (specialIdxB !== -1)
        return 1;
      if (a.sortKey === b.sortKey)
        return 0;
      if (b.sortKey === null)
        return -1;
      if (a.sortKey === null)
        return 1;
      return a.sortKey - b.sortKey;
    };
    isOptionGroupLoading = (group, loadingByKey) => {
      const groupContextKey = getRecordGroupKey(group);
      return groupContextKey ? !!loadingByKey[groupContextKey] : false;
    };
    isOptionGroupOverLimit = (group) => {
      if (!group.limit || !group.size || group.limit >= group.size)
        return false;
      return true;
    };
    isOptionGroupExpanded = (group, expandedGroupKeys) => {
      return expandedGroupKeys.includes(group.key);
    };
    canOptionGroupExpand = (group, expandedGroupKeys) => {
      return isOptionGroupOverLimit(group) && !isOptionGroupExpanded(group, expandedGroupKeys);
    };
    shouldEnforceOptionGroupLimit = (group, expandedGroupKeys) => {
      return !!group.limit && !isOptionGroupExpanded(group, expandedGroupKeys);
    };
    incrementOptionGroupSize = (group) => {
      return { ...group, size: group.size + 1 };
    };
    recommendedGroup = (name, searchTabInstruction, sortKey) => {
      return {
        ...initWithDefaults(name || "Recommended", "RECOMMENDED-", "RECOMMENDED"),
        sortKey: typeof sortKey !== "undefined" ? sortKey : null,
        searchTabInstruction: searchTabInstruction != null ? searchTabInstruction : null,
        filterFn: (o) => isCommandOption(o) && o.isRecommended
      };
    };
    recentsGroup = (name, searchTabInstruction, sortKey) => {
      return {
        ...initWithDefaults(name || "Recents", "RECENTS-", "RECENTS"),
        limit: 5,
        sortKey: typeof sortKey !== "undefined" ? sortKey : null,
        searchTabInstruction: searchTabInstruction != null ? searchTabInstruction : null,
        filterFn: (o) => isCommandOption(o) && o.isRecent || isRecordOption(o) && o.isRecent
      };
    };
    initRecentsGroup = (_) => {
      var _a2, _b2, _c2;
      return recentsGroup(
        (_a2 = _ == null ? void 0 : _.theme) == null ? void 0 : _a2.categoryHeader.recentsHeaderLabel,
        (_b2 = _.organization) == null ? void 0 : _b2.recents_tab_instruction,
        (_c2 = _ == null ? void 0 : _.organization) == null ? void 0 : _c2.recents_sort_key
      );
    };
    initRecommendedGroup = (_) => {
      var _a2, _b2, _c2, _d;
      return recommendedGroup(
        (_b2 = (_a2 = _ == null ? void 0 : _.theme) == null ? void 0 : _a2.categoryHeader) == null ? void 0 : _b2.recommendedHeaderLabel,
        (_c2 = _.organization) == null ? void 0 : _c2.recommended_tab_instruction,
        (_d = _ == null ? void 0 : _.organization) == null ? void 0 : _d.recommended_sort_key
      );
    };
    noneGroup = () => {
      return initWithDefaults("", "NONE-", "NONE");
    };
    fallbackGroup = () => {
      return initWithDefaults("Fallbacks", "FALLBACK-", "FALLBACK");
    };
  }
});

// commandbar/src/products/spotlight/store/options/helpers.ts
import isEqual5 from "lodash/isEqual";
var isOption, isCommandOption, isHotloadedCommandOption, isOptionGroup, setOptionMatches, setOptionGroupKey, getOptionIconColorBase, getReservedField, isDateTimeOption, isParameterOption, isParameterOptionSelected, isRecordOption, isUnfurledCommandOption, onlyShowDuringPowerselect, getOptionUID, getOptionMetadata, getOptionData;
var init_helpers8 = __esm({
  "commandbar/src/products/spotlight/store/options/helpers.ts"() {
    "use strict";
    init_Option();
    init_OptionGroup();
    init_command();
    isOption = (o) => (o == null ? void 0 : o.type) === "command" /* Command */ || (o == null ? void 0 : o.type) === "parameter" /* Parameter */;
    isCommandOption = (option) => (option == null ? void 0 : option.type) === "command" /* Command */;
    isHotloadedCommandOption = (option, organization) => {
      return isCommandOption(option) && isHelpSyncCommand(option.command) && !!(organization == null ? void 0 : organization.has_hotloaded_help_docs);
    };
    isOptionGroup = (option) => isOptionGroup2(option);
    setOptionMatches = (o, matches, score) => {
      return {
        ...o,
        searchMatches: matches,
        searchScore: score
      };
    };
    setOptionGroupKey = (o, groupKey) => {
      return {
        ...o,
        groupKey
      };
    };
    getOptionIconColorBase = (theme, isFocused, isDisabled) => {
      let defaultColorFromTheme = (() => {
        if (isFocused) {
          if (isDisabled) {
            return theme.optionDisabledSelected.iconColor;
          }
          return theme.optionSelected.iconColor;
        } else {
          if (isDisabled) {
            return theme.optionDisabled.iconColor;
          }
          return theme.option.iconColor;
        }
      })();
      const useDefaultSVGColor = !defaultColorFromTheme;
      if (useDefaultSVGColor) {
        defaultColorFromTheme = theme.base.fontColor;
      }
      const opacity = isFocused ? theme.optionSelected.iconOpacity : theme.option.iconOpacity;
      return { defaultColorFromTheme, opacity, useDefaultSVGColor };
    };
    getReservedField = (o, field) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
      switch (field) {
        case "category":
          if (typeof ((_a2 = o.parameter) == null ? void 0 : _a2.category) === "string") {
            return (_b2 = o.parameter) == null ? void 0 : _b2.category;
          }
          break;
        case "icon":
          if (typeof ((_c2 = o.parameter) == null ? void 0 : _c2.icon) === "string") {
            return (_d = o.parameter) == null ? void 0 : _d.icon;
          }
          break;
        case "__actionIcon":
          if (typeof ((_e = o.parameter) == null ? void 0 : _e.__actionIcon) === "string") {
            return (_f = o.parameter) == null ? void 0 : _f.__actionIcon;
          }
          break;
        case "__image":
          if (typeof ((_g = o.parameter) == null ? void 0 : _g.__image) === "string") {
            return (_h = o.parameter) == null ? void 0 : _h.__image;
          }
          break;
        case "__preserveSVG":
          if (!!((_i = o.parameter) == null ? void 0 : _i.__preserveSVG)) {
            return (_j = o.parameter) == null ? void 0 : _j.__preserveSVG;
          }
          break;
        case "__extraHTML":
          if (!!((_k = o.parameter) == null ? void 0 : _k.__extraHTML) && (typeof ((_l = o.parameter) == null ? void 0 : _l.__extraHTML) === "string" || typeof ((_m = o.parameter) == null ? void 0 : _m.__extraHTML) === "function")) {
            return (_n = o.parameter) == null ? void 0 : _n.__extraHTML;
          }
          break;
        case "__heading":
          if (!!((_o = o.parameter) == null ? void 0 : _o.__heading) && typeof ((_p = o.parameter) == null ? void 0 : _p.__heading) === "string") {
            return (_q = o.parameter) == null ? void 0 : _q.__heading;
          }
          break;
        case "__breadcrumbs":
          if (!!((_r = o.parameter) == null ? void 0 : _r.__breadcrumbs) && typeof ((_s = o.parameter) == null ? void 0 : _s.__breadcrumbs) === "string") {
            return (_t = o.parameter) == null ? void 0 : _t.__breadcrumbs;
          }
          break;
      }
      return void 0;
    };
    isDateTimeOption = (o) => {
      var _a2, _b2;
      return ((_a2 = o.parameter) == null ? void 0 : _a2.type) === "datetime" && typeof ((_b2 = o.parameter) == null ? void 0 : _b2.specificType) === "number";
    };
    isParameterOption = (o) => (o == null ? void 0 : o.type) === "parameter";
    isParameterOptionSelected = (o, currentStep) => {
      var _a2;
      const selected = (_a2 = currentStep == null ? void 0 : currentStep.selected) == null ? void 0 : _a2.data;
      if (Array.isArray(selected)) {
        return selected.some((selected2) => isEqual5(o.parameter, selected2));
      } else {
        return isEqual5(o.parameter, selected);
      }
    };
    isRecordOption = (o) => (o == null ? void 0 : o.type) === "parameter" /* Parameter */ && (o == null ? void 0 : o._resource) === true;
    isUnfurledCommandOption = (o) => o.type === "parameter" /* Parameter */ && o.unfurled === true;
    onlyShowDuringPowerselect = (o) => {
      if (isCommandOption(o) && !isUnfurledCommandOption(o)) {
        return isRecordAction(o.command) && !showInDefaultList(o.command);
      }
      return false;
    };
    getOptionUID = (o) => {
      var _a2;
      if (isCommandOption(o)) {
        return commandUID(o.command);
      } else if (isRecordOption(o)) {
        const contextKey = (_a2 = o == null ? void 0 : o.category) == null ? void 0 : _a2.contextKey;
        if (!contextKey || !o.label) {
          return;
        }
        const slug21 = o.label.toLowerCase();
        return `${contextKey}-${slug21}`;
      } else {
        return;
      }
    };
    getOptionMetadata = (o) => {
      var _a2;
      const { type: type39, label, value } = o;
      const contextKey = isRecordOption(o) ? (_a2 = o == null ? void 0 : o.category) == null ? void 0 : _a2.contextKey : void 0;
      const uid = getOptionUID(o);
      return {
        type: type39,
        label,
        value,
        contextKey,
        uid
      };
    };
    getOptionData = (o) => {
      if (isParameterOption(o))
        return o.parameter;
      else if (isCommandOption(o))
        return o.command;
      return null;
    };
  }
});

// commandbar/src/products/spotlight/store/search/Search.tsx
import partition3 from "lodash/partition";
function weightScore(key, score) {
  if (score === null || score === void 0)
    return -Infinity;
  const cappedScore = capSearchScore(score);
  const weight = searchableFields[key].weight;
  if (!weight)
    return cappedScore;
  return cappedScore - (1 - weight) * 100;
}
function getSearchTargetFromOption(userCustomizedHotkeys, opt, key) {
  const path = searchableFields[key].path;
  let value = get5(opt, path);
  if (["command.hotkey_win", "command.hotkey_mac"].includes(path)) {
    if (isCommandOption(opt)) {
      const cmdUID = commandUID(opt.command);
      if (userCustomizedHotkeys.hasOwnProperty(cmdUID)) {
        value = userCustomizedHotkeys[cmdUID];
      }
    }
    if (!!value && Array.isArray(Hotkey_default.toArray(value))) {
      value = Hotkey_default.toArray(value).filter((shortcut) => shortcut.length === 1).join("");
    }
  }
  if (path === "label" && isUnfurledCommandOption(opt)) {
    return opt.label + " " + opt.resource.label;
  }
  return value;
}
function searchFuzzy(userCustomizedHotkeys, options, input, opts) {
  const keysToSearch = Object.keys(searchableFields);
  const results = fuzzysort2.go(input, options, {
    keys: keysToSearch,
    threshold: SEARCH_CONFIG.scoreCutoffThreshold,
    allowTypo: true,
    minLengthForExactSearch: SEARCH_CONFIG.minStringLengthToExactSearch,
    shouldSort: false,
    // Off because fuzzysort sort isn't stable
    getFn: (opt, path) => getSearchTargetFromOption(userCustomizedHotkeys, opt, path),
    scoreFn: function(a) {
      const results2 = keysToSearch.map((key, index3) => {
        var _a2;
        return weightScore(key, (_a2 = a[index3]) == null ? void 0 : _a2.score);
      });
      return Math.max(...results2);
    },
    ...opts
  });
  return results.map(
    (r, i2) => transformRawResult(r, Object.keys(searchableFields), i2)
  );
}
function isClientSearchOption(option, _) {
  if (isCommandOption(option)) {
    return option.command.isAsync ? option.command.isAsync : false;
  }
  if (isRecordOption(option)) {
    const addSearchKey = `commandbar-search-${option.category.contextKey}`;
    return !!_.callbacks[addSearchKey];
  }
  if (isParameterOption(option)) {
    const { currentStep } = currentStepAndIndex(_);
    if (!currentStep || !currentStep.argument || !currentStep.argument.value) {
      return false;
    }
    const argument = currentStep.argument;
    if (!isContextArgument(argument))
      return false;
    const addSearchKey = `commandbar-search-${argument.value}`;
    return !!_.callbacks[addSearchKey];
  }
  return false;
}
var fuzzysort2, SEARCH_CONFIG, os, searchableFields, findAllSequences, compareSearchResults, transformRawResult, capSearchScore, search2, Search_default;
var init_Search = __esm({
  "commandbar/src/products/spotlight/store/search/Search.tsx"() {
    "use strict";
    init_types2();
    init_operatingSystem();
    init_selectors8();
    init_fuzzysort();
    init_Hotkey();
    init_helpers8();
    init_command();
    init_deepGet();
    fuzzysort2 = fuzzysort_default();
    SEARCH_CONFIG = {
      defaultFuzzyThreshold: 100,
      // scale of 0 - 100
      minStringLengthToExactSearch: 100,
      // for strings > X, we run an exact search (instead of fuzzy) for speed
      scoreCutoffThreshold: -1e5,
      // anything with a score < X is cut off from results (for speed)
      maxSearchScore: -100
      // anything above this is capped so that small differences for great matches are ignored
    };
    os = getOperatingSystem();
    searchableFields = {
      label: {
        path: "label",
        weight: 1,
        desc: "[All] The label of any option. It's what you see in the bar"
      },
      categoryLabel: {
        weight: 0.5,
        path: "category.label",
        desc: "[All] The label of an option's category."
      },
      commandExplanation: {
        weight: 0.6,
        path: "command.explanation",
        desc: "[CommandOption] The explanation of a command."
      },
      commandHeading: {
        weight: 0.6,
        path: "command.heading",
        desc: "[CommandOption] The heading of a command."
      },
      commandSynonyms: {
        weight: 0.5,
        path: "command.tags",
        desc: "[CommandOption] The synonyms of a command."
      },
      parameterUserDefinedSearchFields: {
        weight: 0.8,
        path: "tags.value",
        desc: "[ParameterOption] User-defined searchable fields."
      },
      parameterDescription: {
        weight: 0.8,
        path: "description",
        desc: "[ParameterOption] The description of a parameter."
      },
      parameterHeading: {
        weight: 0.8,
        path: "heading",
        desc: "[ParameterOption] The heading of a parameter."
      },
      ...["mac"].includes(os) && {
        commandHotkeyMac: {
          weight: 1.01,
          path: "command.hotkey_mac",
          desc: "[CommandOption] The hotkey for a command on Mac."
        }
      },
      ...["windows", "linux"].includes(os) && {
        commandHotkeyWindows: {
          weight: 1.01,
          path: "command.hotkey_win",
          desc: "[CommandOption] The hotkey for a command on Windows / Linux."
        }
      }
    };
    findAllSequences = (indexes) => {
      let count = 0;
      const pairs = [];
      if (indexes.length === 1)
        return [[indexes[0], indexes[0]]];
      for (let i2 = 1; i2 < indexes.length; i2++) {
        if (i2 > 0 && indexes[i2] === indexes[i2 - 1] + 1) {
          count += 1;
        } else {
          if (count > 1) {
            const prevIndex = i2 - 1;
            pairs.push([indexes[prevIndex - count], indexes[prevIndex]]);
          }
          count = 0;
        }
      }
      if (count > 0) {
        const maxIndex = indexes.length - 1;
        pairs.push([indexes[maxIndex - count], indexes[maxIndex]]);
      }
      return pairs;
    };
    compareSearchResults = (a, b) => {
      if (a.score === b.score) {
        return a.refIndex - b.refIndex;
      }
      return b.score - a.score;
    };
    transformRawResult = (rawResult, keys, index3) => {
      const bestMatchIndex = rawResult.findIndex(
        (match2, index4) => weightScore(keys[index4], match2 == null ? void 0 : match2.score) === rawResult.score
      );
      const bestMatch = !!rawResult[bestMatchIndex] ? {
        path: searchableFields[keys[bestMatchIndex]].path,
        value: rawResult[bestMatchIndex].target,
        indices: findAllSequences(rawResult[bestMatchIndex].indexes)
      } : { path: "label", value: rawResult.obj.label, indices: [[]] };
      const toRet = { item: rawResult.obj, score: rawResult.score, refIndex: index3, matches: [bestMatch] };
      return toRet;
    };
    capSearchScore = (score) => {
      return Math.min(score, SEARCH_CONFIG.maxSearchScore);
    };
    search2 = (input, _, options) => {
      var _a2, _b2;
      if (input === "") {
        return options.map((x) => setOptionMatches(x, [], void 0));
      }
      const [standardOptions, clientSearchOptions] = partition3(options, (o) => !isClientSearchOption(o, _));
      const [clientSearchOptionsToSort, nonSortedClientSearchOptions] = partition3(
        clientSearchOptions,
        (o) => {
          var _a3, _b3;
          return isRecordOption(o) && ((_b3 = (_a3 = o.searchOptions) == null ? void 0 : _a3.onInputChangeOptions) == null ? void 0 : _b3.applySort);
        }
      );
      const fuzzyThreshold = (_b2 = (_a2 = _.organization) == null ? void 0 : _a2.search_fuzzy_threshold) != null ? _b2 : SEARCH_CONFIG.defaultFuzzyThreshold;
      const shouldUseExactSearch = fuzzyThreshold === 0;
      const standardResults = searchFuzzy(
        _,
        standardOptions,
        input,
        shouldUseExactSearch ? { minLengthForExactSearch: 0 } : {
          // Org threshold positive #. 1 (close to exact match ) => -1000; 100 (default) => -100,000
          threshold: fuzzyThreshold * -1e3
        }
      ).sort(compareSearchResults);
      const sortedClientSearchOptions = searchFuzzy(_.endUserStore.data.hotkeys, clientSearchOptionsToSort, input, {
        threshold: -Infinity,
        shouldSort: true
      });
      const unsortedClientSearchOptions = searchFuzzy(_.endUserStore.data.hotkeys, nonSortedClientSearchOptions, input, {
        threshold: -Infinity,
        shouldSort: false
      });
      const searchResults = [
        ...standardResults,
        ...sortedClientSearchOptions,
        ...unsortedClientSearchOptions
      ];
      return searchResults.map((x) => setOptionMatches(x.item, x.matches, x.score));
    };
    Search_default = search2;
  }
});

// commandbar/src/products/spotlight/service-selectors.ts
var init_service_selectors4 = __esm({
  "commandbar/src/products/spotlight/service-selectors.ts"() {
    "use strict";
    init_Search();
    init_selectors8();
    init_selectors3();
    init_CommandOption();
    init_BaseStep();
    init_Step();
  }
});

// commandbar/src/shared/services/analytics/Reporting.tsx
import debounce from "lodash/debounce";
var startSession, endSession, deadend, startSearch, endSearch, reportHelpHubDocEventEvent, reportHelpHubEventEvent, helpHubDocEngagement, helpHubEngagement, helpHubSuggestedQuery, helpHubContinuationClicked, helpHubChatActionClicked, helpHubChatMessage, helpHubChatFeedback, helpHubOpened, helpHubClosed, helpHubUnminimized, helpHubMinimized, helpHubDocOpened, helpHubDocClosed, searchInputChange, previewShown, nextStepSelected, previewLinkOpen, previewEngagement, nudgeShown, nudgeCompleted, nudgeDismissed, nudgeSnoozed, nudgeStepClicked, checklistShown, checklistEngagement, checklistItemEngagement, execution, changedShortcut, unavailableShortcut, noChatResponse, clickedBranding, surveyResponse, noResultsForQuery, error2, sdkMethodCalled;
var init_Reporting = __esm({
  "commandbar/src/shared/services/analytics/Reporting.tsx"() {
    "use strict";
    init_Analytics();
    init_service_selectors4();
    init_symbols();
    init_globals();
    init_helpers2();
    init_sentry();
    init_nudges();
    startSession = (sessionID) => {
      Analytics_default.log("New session", {
        session: sessionID
      });
    };
    endSession = () => {
      var _a2;
      const currentTime = Date.now();
      const session = getSDK()[_configuration].session;
      if (typeof session === "string") {
        try {
          const sessionLength = (currentTime - parseInt(session.substring(0, currentTime.toString().length))) / 1e3;
          Analytics_default.log(
            "End session",
            {
              length: sessionLength
            },
            true
          );
        } catch (e) {
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
        }
      }
    };
    deadend = (inputText, trigger, _) => {
      var _a2, _b2;
      const visibleOptions = Search_default(inputText, _, _.spotlight.currentOptions);
      const results = {
        numCommands: visibleOptions.filter(isCommandOption).length,
        numRecords: visibleOptions.filter(isParameterOption).length
      };
      const payload = {
        "inputText[*]": inputText,
        inputText,
        command: (_a2 = getActiveCommand(_)) == null ? void 0 : _a2.id,
        trigger,
        resource: (_b2 = getActiveRecord(_)) == null ? void 0 : _b2.category.contextKey,
        previousCommands: _.spotlight.executionHistory,
        results
      };
      Analytics_default.log("Abandoned search", payload);
    };
    startSearch = (trigger, placeholder) => {
      const searchID = `${getSDK()[_configuration].session}-${Date.now().toString()}`;
      getSDK()[_search] = searchID;
      const payload = { trigger, placeholder };
      Analytics_default.log("New search", payload);
    };
    endSearch = (inputText, _) => {
      var _a2;
      const payload = { inputText };
      Analytics_default.log("Exited", payload);
      const activeCommand = getActiveCommand(_);
      const activeRecord = (_a2 = getActiveRecord(_)) == null ? void 0 : _a2.category.contextKey;
      if (inputText !== "" || activeCommand || activeRecord) {
        deadend(inputText, "Closed with text", _);
      }
    };
    reportHelpHubDocEventEvent = (name, helpHubDoc) => {
      Analytics_default.log(name, { helpHubDoc });
    };
    reportHelpHubEventEvent = (name, helpHub) => {
      Analytics_default.log(name, { helpHub });
    };
    helpHubDocEngagement = (helpHubDoc, engagement_type) => {
      const payload = {
        helpHubDoc,
        engagement_type
      };
      Analytics_default.log("HelpHub doc engagement", payload);
    };
    helpHubEngagement = (helpHub, engagement_type) => {
      const payload = {
        helpHub,
        engagement_type
      };
      Analytics_default.log("HelpHub engagement", payload);
    };
    helpHubSuggestedQuery = (helpHub, suggested_query) => {
      const payload = {
        type: `help_hub_engagement`,
        helpHub,
        engagement_type: "suggested_query_clicked",
        suggested_query
      };
      Analytics_default.log("HelpHub engagement", payload);
    };
    helpHubContinuationClicked = (helpHub, chat_history, continuation) => {
      const payload = {
        type: `help_hub_engagement`,
        helpHub,
        engagement_type: "continuation_clicked",
        chat_history,
        continuation
      };
      Analytics_default.log("HelpHub engagement", payload);
    };
    helpHubChatActionClicked = (chat_id, action) => {
      const payload = {
        type: `help_hub_engagement`,
        engagement_type: "chat_action_clicked",
        helpHub: { query: null },
        chat_id,
        action
      };
      Analytics_default.log("HelpHub engagement", payload);
    };
    helpHubChatMessage = (from, message, fallback, chat_id) => {
      const payload = {
        type: `help_hub_engagement`,
        engagement_type: "chat_message",
        from,
        helpHub: { query: null },
        chat_id,
        message,
        fallback
      };
      Analytics_default.log("HelpHub engagement", payload);
    };
    helpHubChatFeedback = ({
      message,
      message_id,
      rating
    }) => {
      const payload = {
        type: `help_hub_engagement`,
        engagement_type: "chat_feedback",
        helpHub: { query: null },
        message_id,
        message,
        rating
      };
      Analytics_default.log("HelpHub engagement", payload);
    };
    helpHubOpened = (helpHub) => reportHelpHubEventEvent("HelpHub opened", helpHub);
    helpHubClosed = (helpHub) => reportHelpHubEventEvent("HelpHub closed", helpHub);
    helpHubUnminimized = (helpHub) => reportHelpHubEventEvent("HelpHub unminimized", helpHub);
    helpHubMinimized = (helpHub) => reportHelpHubEventEvent("HelpHub minimized", helpHub);
    helpHubDocOpened = (helpHub) => reportHelpHubDocEventEvent("HelpHub doc opened", helpHub);
    helpHubDocClosed = (helpHub) => reportHelpHubDocEventEvent("HelpHub doc closed", helpHub);
    searchInputChange = (inputText, _) => {
      var _a2;
      const activeCommand = getActiveCommand(_);
      const activeRecord = (_a2 = getActiveRecord(_)) == null ? void 0 : _a2.category.contextKey;
      Analytics_default.log("Search input", {
        "inputText[*]": inputText,
        inputText,
        command: activeCommand && activeCommand.id,
        resource: activeRecord
      });
    };
    previewShown = (preview) => {
      const payload = {
        preview
      };
      Analytics_default.log("Preview shown", payload);
    };
    nextStepSelected = (preview) => {
      const payload = {
        preview
      };
      Analytics_default.log("Next step selected", payload);
    };
    previewLinkOpen = (preview) => {
      const payload = {
        preview
      };
      Analytics_default.log("Preview link opened", payload);
    };
    previewEngagement = (preview, engagement_type) => {
      const payload = {
        preview,
        engagement_type
      };
      Analytics_default.log("Preview engagement", payload);
    };
    nudgeShown = (n, stepIndex, isSimulated) => {
      const step = getNudgeStep(n, stepIndex);
      if (!step)
        return;
      const payload = {
        nudge: {
          id: String(n.id),
          trigger: n.trigger,
          template_source: n.template_source,
          slug: n.slug,
          frequency_limit: n.frequency_limit,
          step: {
            id: step.id,
            title: step.title
          }
        },
        status: {
          is_preview: isSimulated,
          is_live: n.is_live
        }
      };
      Analytics_default.log("Nudge shown", payload);
    };
    nudgeCompleted = (n, stepIndex, isSimulated) => {
      const step = getNudgeStep(n, stepIndex);
      if (!step)
        return;
      const payload = {
        nudge: {
          id: String(n.id),
          trigger: n.trigger,
          template_source: n.template_source,
          slug: n.slug,
          frequency_limit: n.frequency_limit,
          step: {
            id: step.id,
            title: step.title
          }
        },
        status: {
          is_preview: isSimulated,
          is_live: n.is_live
        }
      };
      Analytics_default.log("Nudge completed", payload);
    };
    nudgeDismissed = (n, stepIndex, isSimulated) => {
      const step = getNudgeStep(n, stepIndex);
      if (!step)
        return;
      const payload = {
        nudge: {
          id: String(n.id),
          trigger: n.trigger,
          template_source: n.template_source,
          slug: n.slug,
          frequency_limit: n.frequency_limit,
          step: {
            id: step.id,
            title: step.title
          }
        },
        status: {
          is_preview: isSimulated,
          is_live: n.is_live
        }
      };
      Analytics_default.log("Nudge dismissed", payload);
    };
    nudgeSnoozed = (n, stepIndex, isSimulated) => {
      const step = getNudgeStep(n, stepIndex);
      if (!step)
        return;
      const payload = {
        nudge: {
          id: String(n.id),
          trigger: n.trigger,
          template_source: n.template_source,
          slug: n.slug,
          frequency_limit: n.frequency_limit,
          step: {
            id: step.id,
            title: step.title
          }
        },
        status: {
          is_preview: isSimulated,
          is_live: n.is_live
        }
      };
      Analytics_default.log("Nudge snoozed", payload);
    };
    nudgeStepClicked = (n, stepIndex, isSimulated, button) => {
      const step = getNudgeStep(n, stepIndex);
      if (!step)
        return;
      const payload = {
        nudge: {
          id: String(n.id),
          trigger: n.trigger,
          template_source: n.template_source,
          slug: n.slug,
          frequency_limit: n.frequency_limit,
          step: {
            id: step.id,
            title: step.title,
            ...button && { button }
          }
        },
        status: {
          is_preview: isSimulated,
          is_live: n.is_live
        }
      };
      Analytics_default.log("Nudge clicked", payload);
    };
    checklistShown = (c, completed) => {
      const payload = {
        questlist: {
          id: c.id,
          title: c.title,
          completed_items: 0,
          total_items: c.items.length,
          trigger: c.trigger,
          completed
        }
      };
      Analytics_default.log("Questlist shown", payload);
    };
    checklistEngagement = (c, completed_items, engagement_type, completed) => {
      const payload = {
        questlist: {
          id: c.id,
          title: c.title,
          completed_items,
          total_items: c.items.length,
          trigger: c.trigger,
          completed
        },
        engagement_type
      };
      Analytics_default.log("Questlist engagement", payload);
    };
    checklistItemEngagement = (item, questlist_id, completed, engagement_type) => {
      const payload = {
        questlist_item: {
          id: item.id,
          questlist_id,
          completed,
          cta: item.cta,
          goal: item.goal.type === "conditions_met" ? { type: "conditions_met" } : item.goal,
          title: item.title
        },
        engagement_type
      };
      Analytics_default.log("Questlist item engagement", payload);
    };
    execution = (command, inputText, meta, eventSource) => {
      var _a2;
      const payload = {
        command: (command == null ? void 0 : command.id) >= 1 ? command.id : command.name,
        // command.name used for programmatic commands
        commandText: command.text,
        commandDetails: getAdditionalCommandDetails(command),
        category: command.category,
        categoryText: meta == null ? void 0 : meta.categoryText,
        source: command.source || "standard",
        commandType: (_a2 = command.template) == null ? void 0 : _a2.type,
        "inputText[*]": inputText,
        inputText,
        eventSource: eventSource || { type: "bar" },
        ...meta || {}
      };
      Analytics_default.log("Command execution", payload);
    };
    changedShortcut = (command, oldShortcut, newShortcut, defaultShortcut, meta) => {
      const payload = {
        command: (command == null ? void 0 : command.id) >= 1 ? command.id : command.name,
        // command.name used for programmatic commands
        commandText: command.text,
        category: command.category,
        source: command.source || "standard",
        oldShortcut,
        newShortcut,
        defaultShortcut,
        ...meta || {}
      };
      Analytics_default.log("User changed shortcut", payload);
    };
    unavailableShortcut = (shortcut, command) => {
      Analytics_default.log("Unavailable shortcut", {
        shortcut,
        command: command.id,
        commandText: command.text,
        url: window.location.href
      });
    };
    noChatResponse = (chatHistory) => {
      const payload = {
        chatHistory
      };
      Analytics_default.log("No chat response", payload, true);
    };
    clickedBranding = () => {
      Analytics_default.log("Clicked branding", {});
    };
    surveyResponse = (n, step, response2, isSimulated) => {
      const payload = {
        response: response2,
        nudge: {
          id: String(n.id),
          trigger: n.trigger,
          template_source: n.template_source,
          slug: n.slug,
          frequency_limit: n.frequency_limit,
          step: {
            id: step.id,
            title: step.title
          }
        },
        status: {
          is_preview: isSimulated,
          is_live: n.is_live
        }
      };
      Analytics_default.log("Survey response", payload, true);
    };
    noResultsForQuery = debounce(
      (inputText, eventSource) => {
        const payload = {
          inputText,
          eventSource: eventSource || { type: "bar" }
        };
        Analytics_default.log("No results for query", payload);
      },
      500
    );
    error2 = (message, attrs) => {
      const payload = {
        type: "client_error",
        url: window.location.href,
        error: {
          ...attrs,
          message,
          url: window.location.href
        }
      };
      Analytics_default.error(payload);
    };
    sdkMethodCalled = (method) => {
      const payload = {
        type: "sdk_method_called",
        source: JSON.stringify({
          method
        })
      };
      Analytics_default.log("SDK method called", payload);
    };
  }
});

// commandbar/src/shared/components/Slot.tsx
import { Children, cloneElement as cloneElement2, forwardRef as forwardRef4, isValidElement as isValidElement2 } from "react";
var Slot;
var init_Slot = __esm({
  "commandbar/src/shared/components/Slot.tsx"() {
    "use strict";
    Slot = forwardRef4(({ children, ...props2 }, ref12) => {
      if (isValidElement2(children)) {
        return cloneElement2(children, {
          ...props2,
          ...children.props,
          ref: ref12,
          style: {
            ...props2.style,
            ...children.props.style
          }
        });
      }
      if (Children.count(children) > 1) {
        Children.only(null);
      }
      return null;
    });
  }
});

// commandbar/src/shared/util/hooks/useFocusTrap.tsx
import { useEffect as useEffect19 } from "react";
var FOCUSABLE_ELEMENT_SELECTOR, isHTMLOrSVGElement, useFocusTrap;
var init_useFocusTrap = __esm({
  "commandbar/src/shared/util/hooks/useFocusTrap.tsx"() {
    "use strict";
    FOCUSABLE_ELEMENT_SELECTOR = `
  button:not([disabled]),
  [href]:not([tabindex="-1"]),
  input:not([disabled]):not([type="hidden"]),
  select:not([disabled]),
  textarea:not([disabled]),
  [tabindex]:not([tabindex="-1"]),
  audio[controls]:not([tabindex="-1"]),
  video[controls]:not([tabindex="-1"]),
  summary:not([tabindex="-1"]),
  details:not([tabindex="-1"]),
  [contenteditable]:not([tabindex="-1"])
`;
    isHTMLOrSVGElement = (element) => element instanceof HTMLElement || element instanceof SVGElement;
    useFocusTrap = (elementRef, options = { shouldStealFocus: false }) => {
      useEffect19(() => {
        const element = elementRef == null ? void 0 : elementRef.current;
        if (!element || !options.shouldStealFocus)
          return;
        const originalActiveElement = document.activeElement;
        element.focus();
        return () => {
          if (originalActiveElement && isHTMLOrSVGElement(originalActiveElement)) {
            originalActiveElement.focus();
          } else {
            document.body.focus();
          }
        };
      }, [elementRef, options.shouldStealFocus]);
      useEffect19(() => {
        const element = elementRef == null ? void 0 : elementRef.current;
        if (!element)
          return;
        const handleKeyDown2 = (e) => {
          var _a2, _b2, _c2;
          const focusableElements = element.querySelectorAll(FOCUSABLE_ELEMENT_SELECTOR);
          if (document.activeElement === element && e.key === "Enter") {
            (_a2 = options.onEnterKeyDown) == null ? void 0 : _a2.call(options);
            e.preventDefault();
          }
          if (e.key === "Tab") {
            const firstElement = (_b2 = focusableElements[0]) != null ? _b2 : element;
            const lastElement = (_c2 = focusableElements[focusableElements.length - 1]) != null ? _c2 : element;
            if (e.shiftKey) {
              if (document.activeElement === firstElement && isHTMLOrSVGElement(lastElement)) {
                lastElement.focus();
                e.preventDefault();
              }
            } else {
              if (document.activeElement === lastElement && isHTMLOrSVGElement(firstElement)) {
                firstElement.focus();
                e.preventDefault();
              }
            }
          }
        };
        element.addEventListener("keydown", handleKeyDown2);
        return () => {
          element.removeEventListener("keydown", handleKeyDown2);
        };
      }, [elementRef]);
    };
  }
});

// commandbar/src/shared/util/hooks/useToast.tsx
import React118 from "react";
import ReactDOM5 from "react-dom";
var toastContext, toastStateReducer, toastDispatch, showToast, hideToast, hideAllMatchingToasts, ResponsiveNudgeInnerDiv, Toast, ToastContainerDiv, ToastContainer;
var init_useToast = __esm({
  "commandbar/src/shared/util/hooks/useToast.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Slot();
    init_useFocusTrap();
    init_useMobileExperience();
    toastContext = {
      state: {},
      subscribers: [],
      subscribe: (notifySubscriber) => {
        toastContext.subscribers.push(notifySubscriber);
        return () => {
          toastContext.subscribers = toastContext.subscribers.filter((s) => s !== notifySubscriber);
        };
      }
    };
    toastStateReducer = (state, action) => {
      switch (action.type) {
        case "SHOW":
          return {
            ...state,
            [action.id]: action.payload
          };
        case "HIDE":
          const newState = { ...state };
          delete newState[action.id];
          return newState;
        case "HIDE_ALL_MATCHING_PATTERN": {
          if (action.idPattern) {
            const newState2 = { ...state };
            for (const toastId in newState2) {
              if (toastId.match(action.idPattern)) {
                delete newState2[toastId];
              }
            }
            return newState2;
          }
          return {};
        }
        default:
          return state;
      }
    };
    toastDispatch = (action) => {
      const newState = toastStateReducer(toastContext.state, action);
      toastContext.state = newState;
      toastContext.subscribers.forEach((notifySubscriber) => notifySubscriber(newState));
    };
    showToast = (id2, payload) => {
      toastDispatch({ type: "SHOW" /* SHOW */, id: id2, payload });
    };
    hideToast = (id2) => {
      toastDispatch({ type: "HIDE" /* HIDE */, id: id2 });
    };
    hideAllMatchingToasts = (idPattern) => {
      toastDispatch({ type: "HIDE_ALL_MATCHING_PATTERN" /* HIDE_ALL_MATCHING_PATTERN */, idPattern });
    };
    ResponsiveNudgeInnerDiv = styled_browser_esm_default.div`
  @media (max-width: 400px) {
    width: 100%;
  }
`;
    Toast = ({ position, children, onEscapeKeyDown, onEnterKeyDown, shouldStealFocus }) => {
      const { isMobileDevice: isMobileDevice2, mobileStyles } = useMobileExperience();
      const dialogRef = React118.useRef(null);
      useFocusTrap(dialogRef, { shouldStealFocus, onEnterKeyDown });
      const positionStyles = {
        "top-left": { top: 0, left: 0, right: 0, justifyContent: "flex-start" },
        "top-right": { top: 0, right: 0, left: 0, justifyContent: "flex-end" },
        "bottom-left": { bottom: 0, left: 0, right: 0, justifyContent: "flex-start" },
        "bottom-right": { bottom: 0, right: 0, left: 0, justifyContent: "flex-end" },
        center: {
          justifyContent: "center"
        },
        "top-center": {
          top: 0,
          left: 0,
          right: 0,
          justifyContent: "center"
        }
      };
      return /* @__PURE__ */ React118.createElement(
        "div",
        {
          "data-testid": "commandbar-toast",
          style: {
            width: "100%",
            display: "flex",
            position: "absolute",
            transition: "all 230ms cubic-bezier(0.21, 1.02, 0.73, 1) 0s",
            ...position && (isMobileDevice2 ? mobileStyles.toast.modal : positionStyles[position])
          }
        },
        /* @__PURE__ */ React118.createElement(
          ResponsiveNudgeInnerDiv,
          {
            ref: dialogRef,
            "aria-labelledby": "commandbar-nudge-title",
            "aria-live": "polite",
            "aria-modal": "true",
            role: "dialog",
            tabIndex: -1,
            onKeyDown: (e) => {
              if (e.key === "Escape") {
                onEscapeKeyDown == null ? void 0 : onEscapeKeyDown();
              }
            }
          },
          children
        )
      );
    };
    ToastContainerDiv = styled_browser_esm_default.div`
  inset: 16px;
  @media (max-width: 400px) {
    inset: 8px;
  }
`;
    ToastContainer = ({ children, containerStyle }) => {
      const [state, setState] = React118.useState(toastContext.state);
      const { isStudioMobilePreview, studioMobilePreviewWrapper, mobileStyles } = useMobileExperience();
      React118.useEffect(() => {
        return toastContext.subscribe(setState);
      }, []);
      const content = /* @__PURE__ */ React118.createElement(
        "div",
        {
          id: "commandbar-nudge-container",
          style: isStudioMobilePreview ? mobileStyles.toast.container : { position: "relative" }
        },
        children,
        /* @__PURE__ */ React118.createElement(
          ToastContainerDiv,
          {
            id: "commandbar-toast-container" /* TOAST_CONTAINER */,
            style: isStudioMobilePreview ? mobileStyles.toast.contentContainer : {
              position: "fixed",
              pointerEvents: "none",
              ...containerStyle
            }
          },
          Object.entries(state).map(([id2, toastProps]) => {
            if (toastProps.asChild) {
              return /* @__PURE__ */ React118.createElement(Slot, { key: id2, "data-testid": "commandbar-toast", id: id2 }, toastProps.element);
            }
            const { element, position, duration, onEscapeKeyDown, onEnterKeyDown, shouldStealFocus } = toastProps;
            return /* @__PURE__ */ React118.createElement(
              Toast,
              {
                key: id2,
                duration,
                id: id2,
                position,
                shouldStealFocus,
                onEnterKeyDown,
                onEscapeKeyDown
              },
              element
            );
          })
        )
      );
      if (isStudioMobilePreview && studioMobilePreviewWrapper) {
        return ReactDOM5.createPortal(content, studioMobilePreviewWrapper);
      }
      return content;
    };
  }
});

// commandbar/src/shared/store/end-user/helpers.ts
var createFallbackHmac, cyrb53, createClientPropsFingerprint, createCanvasFingerprint, createFingerprint;
var init_helpers9 = __esm({
  "commandbar/src/shared/store/end-user/helpers.ts"() {
    "use strict";
    init_Logger();
    createFallbackHmac = () => {
      let retVal = "";
      for (let i2 = 0; i2 < 8; i2++) {
        retVal += (Math.random() + 1).toString(36).substring(2, 10);
      }
      return retVal;
    };
    cyrb53 = function(str, seed = 0) {
      let h1 = 3735928559 ^ seed, h2 = 1103547991 ^ seed;
      for (let i2 = 0, ch; i2 < str.length; i2++) {
        ch = str.charCodeAt(i2);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }
      h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
      h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
      return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    };
    createClientPropsFingerprint = () => {
      return [
        navigator.userAgent,
        navigator.language,
        navigator.hardwareConcurrency,
        window.screen.width,
        window.screen.height,
        window.screen.colorDepth,
        window.screen.pixelDepth
      ].join("|");
    };
    createCanvasFingerprint = () => {
      const canvas = document.createElement("canvas");
      let ctx = null;
      try {
        ctx = canvas.getContext("2d");
      } catch (error3) {
        return "";
      }
      if (!ctx)
        return "";
      const txt = "CommandBar.com <canvas> 65@345876";
      ctx.textBaseline = "top";
      ctx.font = "14px 'Arial'";
      ctx.textBaseline = "alphabetic";
      ctx.fillStyle = "#f60";
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = "#069";
      ctx.fillText(txt, 2, 15);
      ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
      ctx.fillText(txt, 4, 17);
      return canvas.toDataURL();
    };
    createFingerprint = () => {
      const canvasFingerprint = createCanvasFingerprint();
      const clientPropsFingerprint = createClientPropsFingerprint();
      const fingerprint = cyrb53(canvasFingerprint + clientPropsFingerprint);
      Logger_default.info("Anonymous user device fingerprint", fingerprint);
      return String(fingerprint);
    };
  }
});

// commandbar/src/shared/store/end-user/client.ts
var _getRemoteData, _patchRemoteData;
var init_client2 = __esm({
  "commandbar/src/shared/store/end-user/client.ts"() {
    "use strict";
    init_network();
    init_helpers9();
    _getRemoteData = (endpoint, hmac) => {
      return get2(endpoint, {
        headers: {
          "X-USER-AUTHORIZATION": !!hmac ? hmac : createFallbackHmac()
        },
        credentials: "omit"
      });
    };
    _patchRemoteData = (endpoint, updated, store, hmac) => {
      return patch(
        endpoint,
        { [store]: updated },
        {
          credentials: "omit",
          headers: {
            "X-USER-AUTHORIZATION": !!hmac ? hmac : createFallbackHmac()
          }
        }
      );
    };
  }
});

// commandbar/src/shared/store/end-user/actions.ts
var actions_exports3 = {};
__export(actions_exports3, {
  clearFromEndUserStore: () => clearFromEndUserStore,
  initFromLocal: () => initFromLocal,
  patchRemoteData: () => patchRemoteData,
  refreshEndUserData: () => refreshEndUserData,
  setToEndUserStore: () => setToEndUserStore,
  setVerified: () => setVerified,
  storeRecentsOnExecute: () => storeRecentsOnExecute,
  syncEndUserStore: () => syncEndUserStore,
  updateEndUserHotkey: () => updateEndUserHotkey,
  updateEndUserStore: () => updateEndUserStore
});
import isEqual6 from "lodash/isEqual";
import merge from "lodash/merge";
import isEmpty from "lodash/isEmpty";
import isObject2 from "lodash/isObject";
import mergeWith from "lodash/mergeWith";
function setToEndUserStore(_, field, value) {
  const storekey = getStoreKey(field, _.endUser);
  LocalStorage_default.set(storekey, JSON.stringify(value));
  _.endUserStore.data[field] = value;
}
function setVerified(_, isVerified) {
  _.endUserStore.verified = isVerified;
}
function clearFromEndUserStore(_, field) {
  const storekey = getStoreKey(field, _.endUser);
  LocalStorage_default.remove(storekey);
  _.endUserStore.data[field] = emptyEndUserStoreState().data[field];
}
var syncEndUserStore, refreshEndUserData, storeRecentsOnExecute, storeAsRecent, storeCommandAsRecent, prependToFixedLengthArray, storeRecordOptionAsRecent, patchRemoteData, updateEndUserStore, updateEndUserHotkey, initFromLocal;
var init_actions4 = __esm({
  "commandbar/src/shared/store/end-user/actions.ts"() {
    "use strict";
    init_command();
    init_LocalStorage();
    init_Reporting();
    init_service_selectors4();
    init_state();
    init_global_selectors();
    init_selectors();
    init_sentry();
    init_Logger();
    init_dispatchCustomEvent();
    init_helpers2();
    init_client2();
    syncEndUserStore = (_, store, remotePreferences) => {
      const remote = !!(remotePreferences == null ? void 0 : remotePreferences[store]) ? remotePreferences[store] : {};
      const local = !!_.endUserStore.data[store] ? _.endUserStore.data[store] : {};
      let merged = {};
      if (store === "checklist_interactions" || store === "nudges_interactions") {
        merged = mergeWith({}, local, remote, (_objValue, srcValue, key) => {
          if (!isNaN(Number(key)) && isObject2(srcValue) && isEmpty(srcValue)) {
            return {};
          }
        });
      } else {
        merged = merge({}, local, remote);
      }
      if (Object.keys(merged).length === 0) {
        clearFromEndUserStore(_, store);
      } else if (!isEqual6(local, merged)) {
        setToEndUserStore(_, store, merged);
      }
      if (!isEqual6(remote, merged)) {
        patchRemoteData(_, merged, store);
      }
    };
    refreshEndUserData = async (_) => {
      var _a2, _b2, _c2, _d, _e;
      initFromLocal(_);
      if (isRemoteEnduserStoreEnabled(_) && !_.airgap && _.endUser) {
        const remotePreferences = emptyEndUserStoreState().data;
        const endpoint = selectEndUserEndpoint(_);
        if (!!endpoint) {
          try {
            const endUserResponse = await _getRemoteData(endpoint, _.endUser.hmac);
            Object.assign(remotePreferences, endUserResponse.data);
            if (!!((_a2 = _.organization) == null ? void 0 : _a2.end_user_shortcuts_enabled)) {
              syncEndUserStore(_, "hotkeys", remotePreferences);
            }
            syncEndUserStore(_, "checklist_interactions", remotePreferences);
            syncEndUserStore(_, "nudges_interactions", remotePreferences);
            setToEndUserStore(_, "analytics", remotePreferences == null ? void 0 : remotePreferences["analytics"]);
            setToEndUserStore(_, "properties", remotePreferences == null ? void 0 : remotePreferences["properties"]);
            setVerified(_, !!((_b2 = _ == null ? void 0 : _.endUser) == null ? void 0 : _b2.hmac));
          } catch (error3) {
            (_c2 = getSentry()) == null ? void 0 : _c2.captureException(error3);
            Logger_default.warn("Failed to load end user data", error3);
            setVerified(_, false);
          } finally {
            dispatchCustomEvent("commandbar-remote-ready", {});
            _.endUserStore.hasRemoteLoaded = true;
            (_d = _.nudgeManager) == null ? void 0 : _d.send("END_USER_STORE_LOADED");
          }
        }
      } else {
        dispatchCustomEvent("commandbar-remote-ready", {});
        _.endUserStore.hasRemoteLoaded = true;
        (_e = _.nudgeManager) == null ? void 0 : _e.send("END_USER_STORE_LOADED");
      }
    };
    storeRecentsOnExecute = (_, executeStep) => {
      var _a2;
      if (!((_a2 = _.organization) == null ? void 0 : _a2.end_user_recents_enabled))
        return;
      const activeRecord = getActiveRecord(_);
      if (activeRecord) {
        storeRecordOptionAsRecent(_, activeRecord);
      } else {
        storeCommandAsRecent(_, executeStep.command);
      }
    };
    storeAsRecent = (_, recent) => {
      const filtered = _.endUserStore.data.recents.filter(({ optionUID: oUID }) => oUID !== recent.optionUID);
      const updated = prependToFixedLengthArray(filtered, recent, 20);
      setToEndUserStore(_, "recents", updated);
    };
    storeCommandAsRecent = (_, command) => {
      const commandWithTS = {
        type: "command",
        command,
        timestamp: Date.now(),
        optionUID: commandUID(command)
      };
      storeAsRecent(_, commandWithTS);
    };
    prependToFixedLengthArray = (input, item, length = 20) => {
      const output = [item].concat(input);
      if (output.length > length) {
        output.splice(length);
      }
      return output;
    };
    storeRecordOptionAsRecent = (_, option) => {
      const { uid, contextKey } = getOptionMetadata(option);
      if (!uid || !contextKey)
        return;
      const recordWithTS = {
        type: "record",
        record: option.parameter,
        categoryKey: contextKey,
        timestamp: Date.now(),
        optionUID: uid
      };
      storeAsRecent(_, recordWithTS);
    };
    patchRemoteData = async (_, updated, store) => {
      if (!_.endUser || !isRemoteEnduserStoreEnabled(_))
        return;
      const endpoint = selectEndUserEndpoint(_);
      if (!!endpoint) {
        _patchRemoteData(endpoint, updated, store, _.endUser.hmac).catch((error3) => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
          Logger_default.error("Failed to update end user data", error3);
        });
      }
    };
    updateEndUserStore = (_, records, store) => {
      let updated = _.endUserStore.data[store];
      for (const [key, val] of Object.entries(records)) {
        if (val === void 0) {
          const { [key]: k, ...rest } = updated;
          updated = rest;
        } else {
          updated = {
            ...updated,
            [key]: val
          };
        }
      }
      setToEndUserStore(_, store, updated);
      patchRemoteData(_, updated, store);
      return updated;
    };
    updateEndUserHotkey = (_, key, val) => {
      var _a2;
      if (!!((_a2 = _.organization) == null ? void 0 : _a2.end_user_shortcuts_enabled)) {
        const store = "hotkeys";
        const updated = updateEndUserStore(_, { [key]: val }, store);
        const updatedCommand = getCommands(_).find((command) => commandUID(command) === key);
        if (!!updatedCommand) {
          const defaultShortcut = ["windows", "linux"].includes(_.platform) ? updatedCommand == null ? void 0 : updatedCommand.hotkey_win : updatedCommand == null ? void 0 : updatedCommand.hotkey_mac;
          const oldShortcut = _.endUserStore.data.hotkeys[key] || (updatedCommand == null ? void 0 : updatedCommand.hotkey_win);
          changedShortcut(updatedCommand, oldShortcut, val, defaultShortcut || "");
        }
        return updated;
      }
    };
    initFromLocal = (_) => {
      var _a2, _b2;
      const enabledKeys = [];
      if (!!((_a2 = _.organization) == null ? void 0 : _a2.end_user_recents_enabled)) {
        enabledKeys.push("recents");
      }
      if (!!((_b2 = _.organization) == null ? void 0 : _b2.end_user_shortcuts_enabled)) {
        enabledKeys.push("hotkeys");
      }
      if (!isSilentMode()) {
        enabledKeys.push("analytics");
      }
      enabledKeys.push("checklist_interactions");
      enabledKeys.push("nudges_interactions");
      enabledKeys.push("properties");
      _.endUserStore = initLocalEndUserState(enabledKeys, _.endUser);
    };
  }
});

// commandbar/src/products/nudges/components/Pin/helpers.ts
import {
  arrow,
  autoUpdate,
  computePosition,
  hide,
  offset as offset2,
  shift
} from "@floating-ui/dom";
function isElementOffScreen(rect, scrollParent) {
  if (scrollParent) {
    const parentRect = scrollParent.getBoundingClientRect();
    return rect.bottom < parentRect.top || rect.top > parentRect.bottom || rect.right < parentRect.left || rect.left > parentRect.right;
  }
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
  const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
  return rect.top > viewportHeight || rect.bottom < 0 || rect.left > viewportWidth || rect.right < 0;
}
var BEACON_SIZE, BEACON_INSET, MIN_MARGIN, positionPin, findScrollParent, getElementCenter, calculateNewScrollPosition, scrollToElement, getDistanceFromTop, getDistanceFromBottom, getDistanceFromLeft, getDistanceFromRight, cyclePlacementsFromTop, cyclePlacementsFromBottom, cyclePlacementsFromLeft, cyclePlacementsFromRight, computeInitialPinPlacement, generatePositioningConfig, convertPlacementToTransformOrigin, helpers_default;
var init_helpers10 = __esm({
  "commandbar/src/products/nudges/components/Pin/helpers.ts"() {
    "use strict";
    init_operatingSystem();
    init_sentry();
    init_dom();
    init_nudges();
    BEACON_SIZE = 16;
    BEACON_INSET = 8;
    MIN_MARGIN = 24;
    positionPin = (pin, beaconElement, contentElement, isOpen, closePin, isAnimatedWidget) => {
      let targetEl = pin.targetEl;
      let beaconHidden;
      if (targetEl) {
        const positioningConfig = generatePositioningConfig(targetEl, contentElement, {
          position: pin.step.form_factor.position,
          alignment: pin.step.form_factor.alignment,
          offset: pin.offset
        });
        const transformOrigin = convertPlacementToTransformOrigin(positioningConfig.content.placement);
        const updateBeaconPosition = async () => {
          var _a2, _b2, _c2;
          if (targetEl) {
            const { x, y, middlewareData } = await computePosition(targetEl, beaconElement, {
              placement: positioningConfig.beacon.placement,
              middleware: [
                offset2(positioningConfig.beacon.offset),
                hide({ strategy: "escaped", ...positioningConfig.beacon.hide })
              ]
            });
            beaconHidden = !!((_a2 = middlewareData.hide) == null ? void 0 : _a2.escaped);
            Object.assign(beaconElement.style, {
              top: `${y}px`,
              left: `${x}px`,
              visibility: ((_b2 = middlewareData.hide) == null ? void 0 : _b2.escaped) ? "hidden" : "visible",
              opacity: ((_c2 = middlewareData.hide) == null ? void 0 : _c2.escaped) ? 0 : 1
            });
          }
        };
        const arrowEl = document.querySelector(".commandbar-nudge-arrow");
        const updateContentPosition = async () => {
          var _a2, _b2;
          if (targetEl) {
            const { x, y, middlewareData } = await computePosition(targetEl, contentElement, {
              placement: isMobileDevice() ? "bottom-start" : positioningConfig.content.placement,
              middleware: [
                offset2(positioningConfig.content.offset),
                shift({ padding: MIN_MARGIN }),
                hide(),
                ...arrowEl ? [arrow({ element: arrowEl })] : []
                // Conditionally include the arrow middleware
              ]
            });
            Object.assign(contentElement.style, {
              top: `${y}px`,
              left: `${x}px`,
              visibility: ((_a2 = middlewareData.hide) == null ? void 0 : _a2.referenceHidden) || beaconHidden || !isOpen ? "hidden" : "visible",
              transformOrigin,
              // There was this issue where the pin would show in the top left corner before moving to the actual target
              // We want the pin to be hidden until it's actually pinned to the target. When using visibility alone, it would show before it was ready.
              // Adding that opacity here was a possible fix for that
              //
              // In WidgetAnimations this isn't an issue since we're animating that behavior, so we don't need/shouldn't control the opacity here
              ...!isAnimatedWidget && {
                opacity: ((_b2 = middlewareData.hide) == null ? void 0 : _b2.referenceHidden) || beaconHidden || !isOpen ? 0 : 1
              }
            });
            if (arrowEl && middlewareData.arrow) {
              const placement = positioningConfig.content.placement;
              arrowEl.classList.add(`pin-arrow-${placement}`);
            }
          }
        };
        const cleanupBeacon = autoUpdate(targetEl, beaconElement, updateBeaconPosition, { animationFrame: true });
        const cleanupContent = autoUpdate(targetEl, contentElement, updateContentPosition, { animationFrame: true });
        const cleanup2 = () => {
          cleanupBeacon();
          cleanupContent();
          closePin();
          observer.disconnect();
        };
        let removalTimeout = null;
        const hideElementsAndScheduleCleanup = () => {
          beaconElement.style.visibility = "hidden";
          contentElement.style.visibility = "hidden";
          if (!removalTimeout) {
            removalTimeout = setTimeout(() => {
              cleanup2();
            }, 1e3);
          }
        };
        const clearRemovalTimeoutAndUpdatePositions = () => {
          if (removalTimeout) {
            clearTimeout(removalTimeout);
            removalTimeout = null;
          }
          updateBeaconPosition();
          updateContentPosition();
        };
        const handleMutation = (mutation) => {
          if (isWithinCommandBar(mutation.target) || Array.from(mutation.addedNodes).some(isWithinCommandBar) || Array.from(mutation.removedNodes).some(isWithinCommandBar))
            return;
          switch (mutation.type) {
            case "childList": {
              handleChildListMutation(mutation);
              break;
            }
            case "attributes": {
              if (fastIsElementVisible(targetEl)) {
                clearRemovalTimeoutAndUpdatePositions();
              } else {
                hideElementsAndScheduleCleanup();
              }
              break;
            }
            default:
              break;
          }
        };
        const handleChildListMutation = (mutation) => {
          for (const node of mutation.removedNodes) {
            if (targetEl && (node === targetEl || node.contains(targetEl))) {
              targetEl = void 0;
              hideElementsAndScheduleCleanup();
            }
          }
          for (const node of mutation.addedNodes) {
            if (fastIsElementVisible(targetEl) && (node === targetEl || node.contains(targetEl))) {
              clearRemovalTimeoutAndUpdatePositions();
            }
          }
        };
        const observer = new MutationObserver((mutations) => {
          if (!targetEl) {
            targetEl = getElement(pin.step.form_factor.anchor_selector || pin.step.form_factor.anchor);
          }
          mutations.forEach(handleMutation);
        });
        observer.observe(document.documentElement, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"]
        });
        return () => {
          cleanupBeacon();
          cleanupContent();
          observer.disconnect();
          if (removalTimeout)
            clearTimeout(removalTimeout);
        };
      }
    };
    findScrollParent = (element, nudge) => {
      var _a2, _b2;
      if (!(element instanceof Element)) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureMessage("Invalid element provided to findScrollParent.", "error", {
          captureContext: {
            tags: {
              product: "nudges"
            },
            contexts: {
              nudge
            }
          }
        });
        return null;
      }
      let currentElement2;
      const rootNode = element.getRootNode();
      if (rootNode instanceof ShadowRoot) {
        currentElement2 = rootNode.host;
      } else {
        currentElement2 = element.parentElement;
      }
      let iterationCount = 0;
      const maxIterations = 30;
      while (currentElement2 && iterationCount < maxIterations && currentElement2 !== document.body) {
        const overflowY = window.getComputedStyle(currentElement2).overflowY;
        const overflowX = window.getComputedStyle(currentElement2).overflowX;
        const isScrollable = overflowX !== "visible" && overflowX !== "hidden" || overflowY !== "visible" && overflowY !== "hidden";
        const hasOverflowingContent = currentElement2.scrollHeight > currentElement2.clientHeight || currentElement2.scrollWidth > currentElement2.clientWidth;
        if (isScrollable && hasOverflowingContent) {
          return currentElement2;
        }
        currentElement2 = currentElement2.parentElement;
        iterationCount++;
      }
      if (iterationCount >= maxIterations) {
        (_b2 = getSentry()) == null ? void 0 : _b2.captureMessage("findScrollParent exceeded maximum iteration count", "error", {
          captureContext: {
            tags: {
              product: "nudges"
            },
            contexts: {
              nudge
            }
          }
        });
        return null;
      }
      return null;
    };
    getElementCenter = (rect) => ({
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2
    });
    calculateNewScrollPosition = (elementCenter, scrollContainer, options) => {
      const containerRect = scrollContainer.getBoundingClientRect();
      return {
        x: elementCenter.x - ((options == null ? void 0 : options.isScrollableContainer) ? containerRect.left : 0) - scrollContainer.clientWidth / 2 + scrollContainer.scrollLeft,
        y: elementCenter.y - ((options == null ? void 0 : options.isScrollableContainer) ? containerRect.top : 0) - scrollContainer.clientHeight / 2 + scrollContainer.scrollTop
      };
    };
    scrollToElement = (element, options) => {
      var _a2;
      try {
        element.scrollTo(options);
      } catch (error3) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
      }
    };
    getDistanceFromTop = (element) => element.getBoundingClientRect().top + window.scrollY || document.documentElement.scrollTop;
    getDistanceFromBottom = (element) => {
      const { top, height } = element.getBoundingClientRect();
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const elementBottom = top + scrollTop + height;
      const documentHeight = Math.max(document.body.scrollHeight, document.documentElement.offsetHeight);
      return documentHeight - elementBottom;
    };
    getDistanceFromLeft = (element) => element.getBoundingClientRect().left + window.scrollX || document.documentElement.scrollLeft;
    getDistanceFromRight = (element) => {
      const { left, width } = element.getBoundingClientRect();
      const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
      const elementRight = left + scrollLeft + width;
      const documentWidth = Math.max(document.body.scrollWidth, document.documentElement.offsetWidth);
      return documentWidth - elementRight;
    };
    cyclePlacementsFromTop = (targetElement, neededSpace) => {
      const availableSpaceTop = getDistanceFromTop(targetElement);
      if (neededSpace.y <= availableSpaceTop) {
        return "top";
      }
      const availableSpaceBottom = getDistanceFromBottom(targetElement);
      if (neededSpace.y <= availableSpaceBottom) {
        return "bottom";
      }
      const availableSpaceRight = getDistanceFromRight(targetElement);
      if (neededSpace.x <= availableSpaceRight) {
        return "right";
      }
      return "left";
    };
    cyclePlacementsFromBottom = (targetElement, neededSpace) => {
      const availableSpaceBottom = getDistanceFromBottom(targetElement);
      if (neededSpace.y <= availableSpaceBottom) {
        return "bottom";
      }
      const availableSpaceTop = getDistanceFromTop(targetElement);
      if (neededSpace.y <= availableSpaceTop) {
        return "top";
      }
      const availableSpaceRight = getDistanceFromRight(targetElement);
      if (neededSpace.x <= availableSpaceRight) {
        return "right";
      }
      return "left";
    };
    cyclePlacementsFromLeft = (targetElement, neededSpace) => {
      const availableSpaceLeft = getDistanceFromLeft(targetElement);
      if (neededSpace.x <= availableSpaceLeft) {
        return "left";
      }
      const availableSpaceRight = getDistanceFromRight(targetElement);
      if (neededSpace.x <= availableSpaceRight) {
        return "right";
      }
      const availableSpaceTop = getDistanceFromTop(targetElement);
      if (neededSpace.y <= availableSpaceTop) {
        return "top";
      }
      return "bottom";
    };
    cyclePlacementsFromRight = (targetElement, neededSpace) => {
      const availableSpaceRight = getDistanceFromRight(targetElement);
      if (neededSpace.x <= availableSpaceRight) {
        return "right";
      }
      const availableSpaceLeft = getDistanceFromLeft(targetElement);
      if (neededSpace.x <= availableSpaceLeft) {
        return "left";
      }
      const availableSpaceTop = getDistanceFromTop(targetElement);
      if (neededSpace.y <= availableSpaceTop) {
        return "top";
      }
      return "bottom";
    };
    computeInitialPinPlacement = (preferredPlacement, targetElement, neededSpace) => {
      switch (preferredPlacement) {
        case "left": {
          return cyclePlacementsFromLeft(targetElement, neededSpace);
        }
        case "right": {
          return cyclePlacementsFromRight(targetElement, neededSpace);
        }
        case "top": {
          return cyclePlacementsFromTop(targetElement, neededSpace);
        }
        case "bottom": {
          return cyclePlacementsFromBottom(targetElement, neededSpace);
        }
        default: {
          const viewportCenterX = window.innerWidth / 2;
          const { x: elementCenterX } = getElementCenter(targetElement.getBoundingClientRect());
          if (elementCenterX > viewportCenterX) {
            return "left";
          }
          return "right";
        }
      }
    };
    generatePositioningConfig = (targetElement, contentElement, pinProperties) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I, _J, _K, _L, _M, _N, _O, _P, _Q, _R, _S, _T, _U, _V;
      const { width: contentWidth, height: contentHeight } = contentElement.getBoundingClientRect();
      const { height: targetHeight } = targetElement.getBoundingClientRect();
      const neededSpace = {
        x: contentWidth + MIN_MARGIN + calcOffsetFromInput(pinProperties.offset.x) + BEACON_INSET + BEACON_SIZE,
        y: contentHeight + MIN_MARGIN + calcOffsetFromInput(pinProperties.offset.y) + BEACON_INSET + BEACON_SIZE
      };
      const position = computeInitialPinPlacement(pinProperties.position, targetElement, neededSpace);
      const { alignment, offset: offset6 } = pinProperties;
      switch (position) {
        case "top": {
          const hide4 = {
            padding: {
              top: -calcOffsetFromInput(offset6.y),
              right: -calcOffsetFromInput(offset6.x),
              left: calcOffsetFromInput(offset6.x),
              bottom: calcOffsetFromInput(offset6.y)
            }
          };
          switch (alignment) {
            case "left": {
              return {
                beacon: {
                  placement: "top-start",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_a2 = offset6 == null ? void 0 : offset6.y) != null ? _a2 : "0"),
                    crossAxis: -BEACON_INSET + calcOffsetFromInput((_b2 = offset6 == null ? void 0 : offset6.x) != null ? _b2 : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "top-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_c2 = offset6 == null ? void 0 : offset6.y) != null ? _c2 : "0"),
                    alignmentAxis: calcOffsetFromInput((_d = offset6 == null ? void 0 : offset6.x) != null ? _d : "0")
                  }
                }
              };
            }
            case "right": {
              return {
                beacon: {
                  placement: "top-end",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_e = offset6 == null ? void 0 : offset6.y) != null ? _e : "0"),
                    crossAxis: BEACON_INSET + calcOffsetFromInput((_f = offset6 == null ? void 0 : offset6.x) != null ? _f : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "top-end",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_g = offset6 == null ? void 0 : offset6.y) != null ? _g : "0"),
                    crossAxis: contentWidth + calcOffsetFromInput((_h = offset6 == null ? void 0 : offset6.x) != null ? _h : "0")
                  }
                }
              };
            }
            case "center":
            default: {
              return {
                beacon: {
                  placement: "top",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_i = offset6 == null ? void 0 : offset6.y) != null ? _i : "0"),
                    crossAxis: calcOffsetFromInput((_j = offset6 == null ? void 0 : offset6.x) != null ? _j : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "top",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_k = offset6 == null ? void 0 : offset6.y) != null ? _k : "0"),
                    crossAxis: contentWidth / 2 + calcOffsetFromInput((_l = offset6 == null ? void 0 : offset6.x) != null ? _l : "0")
                  }
                }
              };
            }
          }
        }
        case "bottom": {
          const hide4 = {
            padding: {
              top: calcOffsetFromInput(offset6.y),
              right: -calcOffsetFromInput(offset6.x),
              left: calcOffsetFromInput(offset6.x),
              bottom: -calcOffsetFromInput(offset6.y)
            }
          };
          switch (alignment) {
            case "left": {
              return {
                beacon: {
                  placement: "bottom-start",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_m = offset6 == null ? void 0 : offset6.y) != null ? _m : "0"),
                    crossAxis: -BEACON_INSET + calcOffsetFromInput((_n = offset6 == null ? void 0 : offset6.x) != null ? _n : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "bottom-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_o = offset6 == null ? void 0 : offset6.y) != null ? _o : "0"),
                    crossAxis: calcOffsetFromInput((_p = offset6 == null ? void 0 : offset6.x) != null ? _p : "0")
                  }
                }
              };
            }
            case "right": {
              return {
                beacon: {
                  placement: "bottom-end",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_q = offset6 == null ? void 0 : offset6.y) != null ? _q : "0"),
                    crossAxis: BEACON_INSET + calcOffsetFromInput((_r = offset6 == null ? void 0 : offset6.x) != null ? _r : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "bottom-end",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_s = offset6 == null ? void 0 : offset6.y) != null ? _s : "0"),
                    crossAxis: contentWidth + calcOffsetFromInput((_t = offset6 == null ? void 0 : offset6.x) != null ? _t : "0")
                  }
                }
              };
            }
            case "center":
            default: {
              return {
                beacon: {
                  placement: "bottom",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_u = offset6 == null ? void 0 : offset6.y) != null ? _u : "0"),
                    crossAxis: calcOffsetFromInput((_v = offset6 == null ? void 0 : offset6.x) != null ? _v : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "bottom",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_w = offset6 == null ? void 0 : offset6.y) != null ? _w : "0"),
                    crossAxis: contentWidth / 2 + calcOffsetFromInput((_x = offset6 == null ? void 0 : offset6.x) != null ? _x : "0")
                  }
                }
              };
            }
          }
        }
        case "right": {
          const hide4 = {
            padding: {
              top: -calcOffsetFromInput(offset6.y),
              right: -calcOffsetFromInput(offset6.x),
              left: calcOffsetFromInput(offset6.x),
              bottom: calcOffsetFromInput(offset6.y)
            }
          };
          switch (alignment) {
            case "center": {
              return {
                beacon: {
                  placement: "right",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_y = offset6 == null ? void 0 : offset6.x) != null ? _y : "0"),
                    crossAxis: -calcOffsetFromInput((_z = offset6 == null ? void 0 : offset6.y) != null ? _z : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "right-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_A = offset6 == null ? void 0 : offset6.x) != null ? _A : "0"),
                    alignmentAxis: targetHeight / 2 - calcOffsetFromInput((_B = offset6 == null ? void 0 : offset6.y) != null ? _B : "0")
                  }
                }
              };
            }
            case "bottom": {
              return {
                beacon: {
                  placement: "bottom-end",
                  offset: {
                    mainAxis: -BEACON_INSET - calcOffsetFromInput((_C = offset6 == null ? void 0 : offset6.y) != null ? _C : "0"),
                    alignmentAxis: -BEACON_INSET - calcOffsetFromInput((_D = offset6 == null ? void 0 : offset6.x) != null ? _D : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "right-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_E = offset6 == null ? void 0 : offset6.x) != null ? _E : "0"),
                    alignmentAxis: targetHeight - calcOffsetFromInput((_F = offset6 == null ? void 0 : offset6.y) != null ? _F : "0")
                  }
                }
              };
            }
            case "top":
            default: {
              return {
                beacon: {
                  placement: "top-end",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_G = offset6 == null ? void 0 : offset6.y) != null ? _G : "0"),
                    alignmentAxis: -BEACON_INSET - calcOffsetFromInput((_H = offset6 == null ? void 0 : offset6.x) != null ? _H : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "right-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_I = offset6 == null ? void 0 : offset6.x) != null ? _I : "0"),
                    alignmentAxis: -calcOffsetFromInput((_J = offset6 == null ? void 0 : offset6.y) != null ? _J : "0")
                  }
                }
              };
            }
          }
        }
        case "left":
        default: {
          const hide4 = {
            padding: {
              top: -calcOffsetFromInput(offset6.y),
              right: calcOffsetFromInput(offset6.x),
              left: -calcOffsetFromInput(offset6.x),
              bottom: calcOffsetFromInput(offset6.y)
            }
          };
          switch (alignment) {
            case "center": {
              return {
                beacon: {
                  placement: "left",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_K = offset6 == null ? void 0 : offset6.x) != null ? _K : "0"),
                    crossAxis: -calcOffsetFromInput((_L = offset6 == null ? void 0 : offset6.y) != null ? _L : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "left-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_M = offset6 == null ? void 0 : offset6.x) != null ? _M : "0"),
                    alignmentAxis: targetHeight / 2 - calcOffsetFromInput((_N = offset6 == null ? void 0 : offset6.y) != null ? _N : "0")
                  }
                }
              };
            }
            case "bottom": {
              return {
                beacon: {
                  placement: "bottom-start",
                  offset: {
                    mainAxis: -BEACON_INSET - calcOffsetFromInput((_O = offset6 == null ? void 0 : offset6.y) != null ? _O : "0"),
                    alignmentAxis: -BEACON_INSET - calcOffsetFromInput((_P = offset6 == null ? void 0 : offset6.x) != null ? _P : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "left-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_Q = offset6 == null ? void 0 : offset6.x) != null ? _Q : "0"),
                    alignmentAxis: targetHeight - calcOffsetFromInput((_R = offset6 == null ? void 0 : offset6.y) != null ? _R : "0")
                  }
                }
              };
            }
            case "top":
            default: {
              return {
                beacon: {
                  placement: "top-start",
                  offset: {
                    mainAxis: -BEACON_INSET + calcOffsetFromInput((_S = offset6 == null ? void 0 : offset6.y) != null ? _S : "0"),
                    alignmentAxis: -BEACON_INSET - calcOffsetFromInput((_T = offset6 == null ? void 0 : offset6.x) != null ? _T : "0")
                  },
                  hide: hide4
                },
                content: {
                  placement: "left-start",
                  offset: {
                    mainAxis: BEACON_SIZE + BEACON_INSET + calcOffsetFromInput((_U = offset6 == null ? void 0 : offset6.x) != null ? _U : "0"),
                    alignmentAxis: -calcOffsetFromInput((_V = offset6 == null ? void 0 : offset6.y) != null ? _V : "0")
                  }
                }
              };
            }
          }
        }
      }
    };
    convertPlacementToTransformOrigin = (placement) => {
      switch (placement) {
        case "top":
          return "bottom center";
        case "bottom":
          return "top center";
        case "left":
          return "right center";
        case "right":
          return "left center";
        case "top-start":
          return "bottom left";
        case "top-end":
          return "bottom right";
        case "bottom-start":
          return "top left";
        case "bottom-end":
          return "top right";
        case "left-start":
          return "right top";
        case "left-end":
          return "right bottom";
        case "right-start":
          return "left top";
        case "right-end":
          return "left bottom";
        default:
          return "center";
      }
    };
    helpers_default = positionPin;
  }
});

// internal/src/client/themes/base.tsx
import chroma4 from "chroma-js";
var generateHelpDocPreviewGradient, generateBaseTheme, base_default;
var init_base2 = __esm({
  "internal/src/client/themes/base.tsx"() {
    "use strict";
    init_theme3();
    init_Z();
    generateHelpDocPreviewGradient = (color) => {
      const gradient = chroma4.scale([color, chroma4(color).brighten(2)]).mode("hsl");
      return `linear-gradient(140deg,
  ${gradient(0.1)} 0%,
  ${gradient(0.33)} 80%,
  ${gradient(0.39)} 98%,
  ${gradient(0.45)} 102%,
  ${gradient(0.78)} 100%)`;
    };
    generateBaseTheme = (baseVars) => {
      const base = {
        primary: baseVars.primary.css(),
        background: baseVars.background.css(),
        fontColor: baseVars.fontColor.css(),
        fontFamily: baseVars.fontFamily,
        fontSize: toPx(baseVars.fontSize)
      };
      const isLightTheme = chroma4(base.background).luminance() > 0.5;
      const theme = {
        base: { ...base, mode: isLightTheme ? "light" : "dark" },
        main: {
          background: baseVars.background.css(),
          borderRadius: toPx(8),
          borderColors: baseVars.fontColor.alpha(0.05).css(),
          boxShadow: "rgba(0, 0, 0, 0.35) 0px 10px 30px",
          fontFamily: baseVars.fontFamily,
          fontSize: toPx(baseVars.fontSize),
          color: baseVars.fontColor.css(),
          transitionTime: "0.2s"
        },
        bar: {
          top: "15%",
          width: "675px",
          menuHeight: "350px",
          menuMinHeight: "0px"
        },
        optionList: {
          paddingTop: "0px",
          paddingBottom: "0px",
          spaceBetweenCategories: "0px",
          spaceBelowHeader: "0px",
          marginTop: "0px",
          marginBottom: "0px"
        },
        placeholder: {
          color: baseVars.fontColor.alpha(0.25).css(),
          fontFamily: baseVars.fontFamily,
          fontSize: toPx(baseVars.fontSize * 1.3),
          fontWeight: 400
        },
        logo: {
          size: "20px",
          top: "25px",
          left: "17px",
          spaceBetweenLogoAndText: "12px"
        },
        input: {
          color: baseVars.fontColor.css(),
          caretColor: baseVars.primary.alpha(0.6).css(),
          fontFamily: baseVars.fontFamily,
          fontSize: toPx(baseVars.fontSize * 1.3),
          borderBottom: `1px solid ${baseVars.fontColor.alpha(0.05).css()}`,
          background: "none",
          paddingLeft: "25px",
          paddingRight: "25px",
          paddingTop: "25px",
          paddingBottom: "25px",
          border: "none",
          borderRadius: "0px",
          backgroundInactive: "none",
          colorInactive: baseVars.fontColor.css(),
          borderBottomInactive: `1px solid ${baseVars.fontColor.alpha(0.05).css()}`
        },
        option: {
          cursor: "pointer",
          color: baseVars.fontColor.alpha(0.7).css(),
          // https://www.loom.com/share/f9e1e52c9c034ffdac9f526ca7d98ee5
          // iconColor: (baseVars.fontColor.alpha(0.4).css()),
          iconColor: "",
          iconOpacity: "40%",
          spaceBetweenIconAndLabel: "18px",
          iconDisplay: "",
          iconSize: "18px",
          iconAlign: "center",
          labelFontWeight: 400,
          labelMarginTop: "0px",
          labelMarginBottom: "0px",
          lineHeight: 1.6,
          background: baseVars.background.css(),
          borderColor: baseVars.fontColor.alpha(0.01).css(),
          borderWidth: "1px",
          fontFamily: baseVars.fontFamily,
          fontSize: toPx(baseVars.fontSize),
          minHeight: "43px",
          paddingLeft: "18px",
          paddingRight: "18px",
          paddingTop: "0px",
          paddingBottom: "0px",
          marginLeft: "0px",
          marginRight: "0px",
          descriptionFontSize: "11px",
          descriptionFontStyle: "",
          descriptionMarginTop: "-3px",
          descriptionMarginBottom: "0px",
          descriptionColor: baseVars.fontColor.alpha(0.6).css(),
          borderRadius: "0px",
          breadcrumbsFontSize: "10px",
          breadcrumbsMarginTop: "0px",
          breadcrumbsMarginBottom: "1px",
          breadcrumbsColor: baseVars.fontColor.alpha(0.6).css(),
          breadcrumbsFontWeight: 400,
          actionIconSize: "18px"
        },
        optionSelected: {
          color: baseVars.fontColor.css(),
          // https://www.loom.com/share/f9e1e52c9c034ffdac9f526ca7d98ee5
          // iconColor: (baseVars.primary.css()),
          iconColor: "",
          iconOpacity: "100%",
          background: baseVars.fontColor.alpha(0.05).css(),
          borderColor: baseVars.fontColor.alpha(0.01).css(),
          borderHighlight: baseVars.primary.css(),
          borderWidth: "1px",
          fontFamily: baseVars.fontFamily,
          fontSize: toPx(baseVars.fontSize),
          descriptionColor: baseVars.fontColor.alpha(0.7).css(),
          breadcrumbsColor: baseVars.fontColor.alpha(0.7).css(),
          highlightMargin: "0px"
        },
        optionDisabled: {
          color: baseVars.fontColor.alpha(0.3).css(),
          iconColor: "",
          background: baseVars.background.css(),
          cursor: "not-allowed",
          descriptionFontStyle: "italic",
          borderWidth: "1px"
        },
        optionDisabledSelected: {
          background: baseVars.fontColor.alpha(0.02).css(),
          iconColor: ""
        },
        launcher: {
          background: baseVars.background.css()
        },
        dashboard: {
          background: baseVars.background.css(),
          fontColor: baseVars.fontColor.css()
        },
        menu: {
          borderRadius: "0px",
          border: "none",
          marginTop: "0px",
          background: "none"
        },
        menuGridContainer: {
          paddingTop: "10px",
          paddingBottom: "10px",
          paddingLeft: "12px",
          paddingRight: "12px",
          itemsPerRow: "3",
          itemGap: "10px",
          minRowHeight: ""
        },
        menuGridItemCard: {
          background: "transparent",
          paddingTop: "12px",
          paddingBottom: "12px",
          paddingRight: "13px",
          paddingLeft: "13px",
          borderRadius: "3px",
          boxShadow: "none",
          hoverBoxShadow: "0 5px 8px 0 rgb(0 0 0 / 10%), 0 -3px 8px 0 rgb(0 0 0 / 5%)",
          coverImageDisplay: ""
        },
        menuGridItemCardSelected: {
          borderColor: ""
        },
        menuGridOption: {
          iconDisplay: "none",
          iconSize: "18px",
          cursor: "pointer",
          color: baseVars.fontColor.alpha(0.7).css(),
          labelFontWeight: "600",
          labelMarginTop: "5px",
          labelMarginBottom: "0px",
          lineHeight: 1,
          background: baseVars.background.css(),
          borderColor: baseVars.fontColor.alpha(0.01).css(),
          borderWidth: "1px",
          fontFamily: baseVars.fontFamily,
          fontSize: "14.5px",
          minHeight: "0px",
          paddingLeft: "0px",
          paddingRight: "0px",
          paddingTop: "0px",
          paddingBottom: "0px",
          marginTop: "0px",
          marginBottom: "0px",
          marginLeft: "0px",
          marginRight: "0px",
          descriptionFontSize: "12.5px",
          descriptionFontStyle: "",
          descriptionMarginTop: "0px",
          descriptionMarginBottom: "0px",
          descriptionColor: "#616161",
          borderRadius: "0px",
          breadcrumbsFontSize: "10px",
          breadcrumbsMarginTop: "0px",
          breadcrumbsMarginBottom: "1px",
          breadcrumbsColor: baseVars.fontColor.alpha(0.6).css(),
          breadcrumbsFontWeight: 400,
          actionIconSize: "18px"
        },
        menuGridOptionSelected: {
          color: baseVars.fontColor.css(),
          background: baseVars.fontColor.alpha(0.05).css(),
          fontFamily: baseVars.fontFamily,
          fontSize: toPx(baseVars.fontSize),
          descriptionColor: baseVars.fontColor.alpha(0.7).css(),
          breadcrumbsColor: baseVars.fontColor.alpha(0.7).css()
        },
        menuGridOptionDisabled: {
          color: baseVars.fontColor.alpha(0.3).css(),
          background: baseVars.background.css(),
          cursor: "not-allowed",
          descriptionFontStyle: "italic"
        },
        menuGridOptionDisabledSelected: {
          background: baseVars.fontColor.alpha(0.02).css()
        },
        categoryHeader: {
          color: baseVars.fontColor.alpha(0.7).css(),
          background: baseVars.fontColor.alpha(0.05).css(),
          borderTop: "1px solid rgba(0,0,0,0.1)",
          borderBottom: "none",
          paddingTop: "5px",
          paddingRight: "20px",
          paddingBottom: "5px",
          paddingLeft: "20px",
          opacity: "1.0",
          fontSize: toPx(baseVars.fontSize * 0.85),
          fontWeight: 600,
          lineHeight: 1.25,
          loaderSize: toPx(Math.round(baseVars.fontSize * 0.85) - 1),
          expandColor: "inherit",
          expandBackground: "none",
          expandBorder: "none",
          expandFont: "inherit",
          expandSpacing: 2,
          expandPadding: "0",
          expandIconSize: "16px",
          expandTextFontWeight: 400,
          numResultsFontWeight: 700,
          textTransform: "none",
          recommendedHeaderLabel: "Recommended",
          recentsHeaderLabel: "Recents",
          experiencesHeaderLabel: "Experiences",
          fallbackCommandsHeader: 'No results for "{{query}}". Try one of the actions below:'
        },
        keyboardShortcuts: {
          color: baseVars.fontColor.css(),
          background: baseVars.fontColor.alpha(0.1).css(),
          fontSize: toPx(baseVars.fontSize * 0.85),
          borderRadius: toPx(2),
          borderColor: "transparent",
          highlight: chroma4(baseVars.primary).alpha(0.8).css(),
          fontFamily: baseVars.fontFamily,
          fontWeight: 400,
          separatorLabel: "then",
          separatorMarginLeft: "4px",
          separatorMarginRight: "4px",
          paddingTop: "4px",
          paddingBottom: "4px",
          paddingLeft: "7px",
          paddingRight: "7px",
          recordingColor: "rgb(255, 82, 82)"
        },
        previewPopover: {
          minHeight: "250px",
          maxHeight: "450px",
          minWidth: "400px",
          maxWidth: "400px",
          boxShadow: "0px 16px 24px rgba(36, 35, 41, 0.3), 0px 2px 4px rgba(36, 35, 41, 0.25)",
          opacity: 1,
          padding: "16px 24px",
          background: chroma4.mix(baseVars.background, baseVars.fontColor, 0.05).alpha(1).css(),
          titleBarBorderBottom: `1px solid  ${baseVars.fontColor.alpha(0.05).css()}`
        },
        textSearchMatch: {
          textDecoration: `${baseVars.primary} solid underline`,
          fontWeight: 400,
          emphasisFontWeight: 500,
          textUnderlinePosition: "auto",
          emphasisTextUnderlinePosition: "under"
        },
        searchableFieldMatch: {
          color: baseVars.fontColor.css(),
          background: baseVars.fontColor.alpha(0.1).css(),
          paddingTop: "0px",
          paddingBottom: "0px",
          paddingLeft: "3px",
          paddingRight: "3px",
          marginRight: "4px",
          marginLeft: "0px",
          borderRadius: "2px",
          lineHeight: "1.4"
        },
        blocks: {
          background: baseVars.background.css(),
          color: baseVars.fontColor.css(),
          border: `1px solid ${baseVars.primary.css()}`,
          paddingTop: "2px",
          paddingBottom: "2px",
          paddingRight: "4px",
          paddingLeft: "4px",
          fontSize: "12px",
          fontWeight: 500,
          borderRadius: "4px"
        },
        blocksContainer: {
          paddingTop: "10px",
          paddingBottom: "0px",
          paddingLeft: "10px",
          paddingRight: "10px"
        },
        instruction: {
          display: "block",
          fontColor: baseVars.background.css(),
          background: baseVars.fontColor.alpha(0.6).css(),
          borderRadius: "4px"
        },
        searchTabsContainer: {
          paddingTop: "8px",
          paddingRight: "14px",
          paddingBottom: "8px",
          paddingLeft: "14px"
        },
        searchTab: {
          labelAllTab: "All",
          paddingTop: "6px",
          paddingRight: "10px",
          paddingBottom: "6px",
          paddingLeft: "10px",
          spacing: "0px",
          borderRadius: "15px",
          activeColor: baseVars.background.css(),
          activeBorder: "1px solid transparent",
          activeBorderWidth: "",
          activeBackground: baseVars.primary.css(),
          inactiveColor: baseVars.fontColor.css(),
          inactiveBorder: "1px solid transparent",
          inactiveBorderWidth: "",
          inactiveBackground: baseVars.background.css(),
          inactivePadding: "",
          noResultsColor: "",
          noResultsBorder: "",
          noResultsBackground: "",
          noResultsOpacity: 0.2,
          hoverColor: baseVars.primary.css(),
          hoverBorder: "1px solid transparent",
          hoverBorderWidth: "",
          hoverBackground: baseVars.background.css(),
          hoverPadding: "",
          fontSize: toPx(baseVars.fontSize),
          fontWeight: 600,
          textAlign: "center",
          transitionTime: "0.15s",
          iconSize: "18px",
          iconMarginRight: "4px"
        },
        searchTabDescription: {
          padding: "6px 10px",
          fontSize: toPx(baseVars.fontSize)
        },
        searchTabGroupHeading: {
          color: baseVars.fontColor.css(),
          fontSize: toPx(baseVars.fontSize),
          fontWeight: 700,
          textAlign: "center",
          padding: "10px 10px 6px 10px"
        },
        footer: {
          background: "transparent",
          paddingLeft: "16px",
          paddingRight: "16px",
          paddingTop: "6px",
          paddingBottom: "6px",
          borderTop: `1px ${baseVars.fontColor.alpha(0.05).css()} solid`
        },
        noResults: {
          headerFontSize: "20px",
          headerFontWeight: 500,
          headerFontColor: baseVars.fontColor.css(),
          headerMarginTop: "0px",
          headerMarginBottom: "20px",
          headerFontFamily: baseVars.fontFamily,
          queryFontColor: baseVars.fontColor.alpha(0.7).css(),
          bodyFontSize: "12px",
          bodyFontColor: baseVars.fontColor.css(),
          bodyFontWeight: 400,
          bodyFontFamily: baseVars.fontFamily,
          linkColor: baseVars.primary.css(),
          headerText: "No results for"
        },
        navPane: {
          width: "175px",
          borderRight: `2px solid ${baseVars.fontColor.alpha(0.05).css()}`,
          background: baseVars.background.css()
        },
        nextStepCommands: {
          hidden: "false",
          borderRadius: "4px",
          color: "rgba(0,0,0,0.75)",
          background: "rgba(255, 255, 255, 0.65)",
          hoverColor: "rgba(0, 0, 0, 1)",
          hoverBackgroundColor: "rgba(255, 255, 255, 0.85)",
          boxShadow: "0 4px 30px rgb(0 0 0 / 10%)",
          iconSize: "15px"
        },
        detailPreview: {
          titleFontSize: `0.75em`,
          titleDisplay: `inline-block`,
          titleLineHeight: `1.2em`,
          titleFontWeight: `600`,
          titleColor: baseVars.fontColor.css(),
          titleMargin: "0 0 1em -0.5em",
          titlePadding: `0.25em 0.5em`,
          titleBackgroundColor: chroma4.mix(baseVars.background.css(), baseVars.fontColor.css(), 0.1).css(),
          titleBorderRadius: `2px`,
          width: "65%",
          animationDuration: "0.5s",
          padding: "16px 24px 24px 24px"
        },
        nudges: {
          width: "300px",
          padding: "16px",
          gap: "8px",
          borderRadius: "8px",
          boxShadow: "0px 16px 40px rgba(10, 10, 15, 0.24)",
          background: isLightTheme ? "#FFFFFF" : "#1E1E1E",
          color: isLightTheme ? "#42424D" : "#A6A6A6",
          fontFamily: baseVars.fontFamily,
          titleFontFamily: baseVars.fontFamily,
          titleFontSize: "16px",
          titleFontWeight: 600,
          titleLineHeight: "17px",
          titleColor: isLightTheme ? "#42424D" : "#FFFFFF",
          contentFontFamily: baseVars.fontFamily,
          contentFontSize: "14px",
          contentLineHeight: "16px",
          contentFontWeight: 400,
          contentColor: isLightTheme ? "#42424D" : "#A6A6A6",
          ctaBackground: isLightTheme ? "#0A0A0F" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaColor: "#FFFFFF",
          ctaBorder: isLightTheme ? "none" : "1px solid #101010",
          ctaBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaBorderRadius: "4px",
          ctaPadding: "11px 12px",
          ctaFontFamily: baseVars.fontFamily,
          ctaFontSize: "14px",
          ctaLineHeight: "18px",
          ctaFontWeight: "600",
          ctaSecondaryBackground: isLightTheme ? "#FFFFFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaSecondaryColor: "#0A0A0F",
          ctaSecondaryBorder: isLightTheme ? "1px solid #DFDFE2" : "1px solid #101010",
          ctaSecondaryBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaSecondaryTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaSecondaryBorderRadius: "4px",
          ctaSecondaryPadding: "11px 12px",
          ctaSecondaryFontFamily: baseVars.fontFamily,
          ctaSecondaryFontSize: "14px",
          ctaSecondaryLineHeight: "18px",
          ctaSecondaryFontWeight: "600",
          snoozeButtonBackground: "none",
          snoozeButtonColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          snoozeButtonBorder: "none",
          snoozeButtonTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          snoozeButtonWidth: "100%",
          snoozeButtonFontFamily: baseVars.fontFamily,
          snoozeButtonFontSize: "14px",
          snoozeButtonLineHeight: "18px",
          snoozeButtonFontWeight: "600",
          closeButtonColor: isLightTheme ? "#A2A2A9" : "#A6A6A6",
          closeButtonHoverColor: isLightTheme ? "#51515C" : "#E1E1E1",
          helpDocPreviewColor: "#FFFFFF",
          helpDocPreviewBackground: generateHelpDocPreviewGradient(baseVars.primary.css()),
          helpDocPreviewMixBlendMode: chroma4(baseVars.primary.css()).get("hsl.s") < 0.9 && chroma4(baseVars.primary.css()).luminance() > 0.075 ? "overlay" : "hard-light",
          stepCountColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          stepCountFontFamily: baseVars.fontFamily,
          stepCountFontWeight: 500,
          stepCountFontSize: "12px"
        },
        nudgeOptionList: {
          color: isLightTheme ? "#0D0E10" : "#FFF",
          border: `1px solid ${isLightTheme ? "rgba(10, 10, 15, 0.24)" : "#101010"}`,
          background: isLightTheme ? "#FFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          boxShadow: isLightTheme ? "0px -2px 0px 0px rgba(0, 0, 0, 0.07) inset, 0px 1px 3px 0px rgba(0, 0, 0, 0.07)" : "0px 2px 3px 0px rgba(0, 0, 0, 0.30), 0px 2px 0px 0px rgba(255, 255, 255, 0.09) inset",
          selectionBorder: `1px solid ${isLightTheme ? "#DD9E23" : "#FFB422"}`,
          selectionBackground: isLightTheme ? "#FFFAEF" : "#FFF2D9",
          selectionColor: "#0D0E10",
          selectionBoxShadow: isLightTheme ? "0px 0px 0px 3px rgba(221, 158, 35, 0.19)" : "0px 0px 0px 3px rgba(221, 158, 35, 0.32)"
        },
        nudgeOptionListCheckbox: {
          border: `1px solid ${isLightTheme ? "#BABBC0" : "#101010"}`,
          borderSelected: "1px solid #3F424A",
          backgroundColor: isLightTheme ? "#fff" : "#343434",
          check: isLightTheme ? "#000" : "#fff"
        },
        nudgeOptionListRadio: {
          border: `1px solid ${isLightTheme ? "#BABBC0" : "#101010"}`,
          borderSelected: "1px solid #3F424A",
          backgroundColor: isLightTheme ? "#fff" : "#343434",
          backgroundColorSelected: isLightTheme ? "#fff" : "#000",
          check: isLightTheme ? "#000" : "#fff"
        },
        nudgeOptionListDropdown: {
          color: isLightTheme ? "#000" : "#fff",
          border: `1px solid ${isLightTheme ? "rgba(10, 10, 15, 0.24)" : "#101010"}`,
          background: isLightTheme ? "#FFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          boxShadow: isLightTheme ? "0px -2px 0px 0px rgba(0, 0, 0, 0.07) inset, 0px 1px 3px 0px rgba(0, 0, 0, 0.07)" : "0px 2px 3px 0px rgba(0, 0, 0, 0.16), 0px 2px 0px 0px rgba(255, 255, 255, 0.09) inset"
        },
        nudgeOptionListDropdownOption: {
          color: isLightTheme ? "#000" : "#fff",
          border: `1px solid ${isLightTheme ? "A2A2A9" : "#101010"}`,
          background: isLightTheme ? "#FFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          boxShadow: isLightTheme ? "0px 8px 16px 0px rgba(0, 0, 0, 0.30)" : "0px 2px 3px 0px rgba(0, 0, 0, 0.16), 0px 2px 0px 0px rgba(255, 255, 255, 0.09) inset",
          backgroundHover: isLightTheme ? "#F7F7F8" : "#414141"
        },
        surveyTextInput: {
          background: isLightTheme ? "#FFFFFF" : "#343434",
          boxShadow: "none",
          border: isLightTheme ? "1px solid rgba(10, 10, 15, 0.24)" : "1px solid #101010",
          borderRadius: "4px",
          color: baseVars.fontColor.css(),
          fontFamily: baseVars.fontFamily,
          fontSize: baseVars.fontSize,
          padding: "8px",
          margin: "8px 0 0 0"
        },
        surveyTextInputShort: {
          background: isLightTheme ? "#FFFFFF" : "#343434",
          boxShadow: "none",
          border: isLightTheme ? "1px solid rgba(10, 10, 15, 0.24)" : "1px solid #101010",
          borderRadius: "4px",
          color: baseVars.fontColor.css(),
          fontFamily: baseVars.fontFamily,
          fontSize: baseVars.fontSize,
          padding: "8px",
          margin: "8px 0 0 0"
        },
        surveyRatingBox: {
          background: isLightTheme ? "#FFFFFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          color: baseVars.fontColor.css(),
          border: isLightTheme ? "1px solid rgba(10, 10, 15, 0.24)" : "1px solid #101010",
          boxShadow: isLightTheme ? "rgba(0, 0, 0, 0.07) 0px 1px 3px, rgba(0, 0, 0, 0.07) 0px -1px 0px inset" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          borderRadius: "4px",
          selectionBorder: "1px solid #FFB422",
          selectionBackGround: "#FFF2D9",
          selectionBoxShadow: "rgba(0, 0, 0, 0.07) 0px 1px 3px, rgba(0, 0, 0, 0.07) 0px -1px 0px inset"
        },
        questlists: {
          fontFamily: baseVars.fontFamily,
          bottom: "24px",
          right: "24px",
          left: "24px",
          boxShadow: "0px 16px 40px rgba(10, 10, 15, 0.24)",
          borderRadius: "8px",
          bodyBackground: isLightTheme ? "#FFFFFF" : "#1E1E1E",
          headerBackground: isLightTheme ? "#F7F7F8" : "#1E1E1E",
          footerBackground: isLightTheme ? "#F7F7F8" : "#1E1E1E",
          headerPadding: "16px",
          headerGap: "4px",
          footerPadding: "8px 16px",
          footerGap: "4px",
          footerHeight: "56px",
          progressPadding: "13px 16px",
          doneBackground: isLightTheme ? "#0A0A0F" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          doneColor: isLightTheme ? "#FFFFFF" : "#FFFFFF",
          doneBorderRadius: "4px",
          donePadding: "9px 12px",
          doneFontSize: "14px",
          doneLineHeight: "14px",
          doneFontWeight: "600",
          doneBorder: isLightTheme ? "1px solid #A2A2A9" : "1px solid #101010",
          doneBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          doneTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          skipBackground: isLightTheme ? "#FFFFFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          skipColor: isLightTheme ? "#51515C" : "#FFFFFF",
          skipBorderRadius: "4px",
          skipPadding: "9px 12px",
          skipFontSize: "14px",
          skipLineHeight: "14px",
          skipFontWeight: "600",
          skipBorder: isLightTheme ? "1px solid #A2A2A9" : "1px solid #101010",
          skipBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          skipTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          titleFontSize: "16px",
          titleFontWeight: "600",
          titleLineHeight: "17px",
          titleColor: isLightTheme ? "#42424D" : "#FFFFFF",
          titleChevronSize: "8px",
          titleChevronColor: "#A6A6A6",
          descriptionFontSize: "14px",
          descriptionLineHeight: "16px",
          descriptionFontWeight: 400,
          descriptionColor: isLightTheme ? "#42424D" : "#A6A6A6",
          itemsContainerMaxHeight: "50vh"
        },
        questlistItem: {
          ctaBackground: isLightTheme ? "#0A0A0F" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaColor: "#FFFFFF",
          ctaBorder: isLightTheme ? "none" : "1px solid #101010",
          ctaBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaBorderRadius: "4px",
          ctaPadding: "11px 12px",
          ctaFontSize: "14px",
          ctaLineHeight: "18px",
          ctaFontWeight: "600",
          skipBackground: "transparent",
          skipColor: isLightTheme ? "#A2A2A9" : "#A6A6A6",
          skipBorderRadius: "4px",
          skipPadding: "5px 12px",
          skipFontSize: "14px",
          skipLineHeight: "14px",
          skipFontWeight: "500",
          skipBorder: "none",
          titleFontSize: "16px",
          titleFontWeight: "500",
          titleLineHeight: "16px",
          titleColor: isLightTheme ? "#51515C" : "#FFFFFF",
          titleCompletedFontSize: "14px",
          titleCompletedFontWeight: "600",
          titleCompletedLineHeight: "16px",
          titleCompletedColor: isLightTheme ? "#7A7A85" : "#E7E7E9",
          titleCompletedtextDecorationLine: "line-through",
          descriptionFontSize: "14px",
          descriptionLineHeight: "18px",
          descriptionFontWeight: 400,
          descriptionColor: isLightTheme ? "#51515C" : "#A6A6A6",
          dividerColor: isLightTheme ? "#DFDFE2" : "#42424D"
        },
        nudgePin: {
          width: "300px",
          padding: "16px",
          gap: "8px",
          borderRadius: "8px",
          boxShadow: "0px 16px 40px rgba(10, 10, 15, 0.24)",
          background: isLightTheme ? "#FFFFFF" : "#1E1E1E",
          color: isLightTheme ? "#42424D" : "#A6A6A6",
          fontFamily: baseVars.fontFamily,
          titleFontFamily: baseVars.fontFamily,
          titleFontSize: "16px",
          titleFontWeight: 600,
          titleLineHeight: "17px",
          titleColor: isLightTheme ? "#42424D" : "#FFFFFF",
          contentFontFamily: baseVars.fontFamily,
          contentFontSize: "14px",
          contentLineHeight: "16px",
          contentFontWeight: 400,
          contentColor: isLightTheme ? "#42424D" : "#A6A6A6",
          ctaBackground: isLightTheme ? "#0A0A0F" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaColor: "#FFFFFF",
          ctaBorder: isLightTheme ? "none" : "1px solid #101010",
          ctaBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaBorderRadius: "4px",
          ctaPadding: "11px 12px",
          ctaFontFamily: baseVars.fontFamily,
          ctaFontSize: "14px",
          ctaLineHeight: "18px",
          ctaFontWeight: "600",
          ctaSecondaryBackground: isLightTheme ? "#FFFFFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaSecondaryColor: "#0A0A0F",
          ctaSecondaryBorder: isLightTheme ? "1px solid #DFDFE2" : "1px solid #101010",
          ctaSecondaryBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaSecondaryTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaSecondaryBorderRadius: "4px",
          ctaSecondaryPadding: "11px 12px",
          ctaSecondaryFontFamily: baseVars.fontFamily,
          ctaSecondaryFontSize: "14px",
          ctaSecondaryLineHeight: "18px",
          ctaSecondaryFontWeight: "600",
          snoozeButtonBackground: "none",
          snoozeButtonColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          snoozeButtonBorder: "none",
          snoozeButtonTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          snoozeButtonWidth: "100%",
          snoozeButtonFontFamily: baseVars.fontFamily,
          snoozeButtonFontSize: "14px",
          snoozeButtonLineHeight: "18px",
          snoozeButtonFontWeight: "600",
          beaconColor: isLightTheme ? "#7611F7" : "#F7C411",
          beaconPulseScale: "4",
          helpDocPreviewColor: "#FFFFFF",
          helpDocPreviewBackground: generateHelpDocPreviewGradient(baseVars.primary.css()),
          helpDocPreviewMixBlendMode: chroma4(baseVars.primary.css()).get("hsl.s") < 0.9 && chroma4(baseVars.primary.css()).luminance() > 0.075 ? "overlay" : "hard-light",
          stepCountColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          stepCountFontFamily: baseVars.fontFamily,
          stepCountFontWeight: 500,
          stepCountFontSize: "12px"
        },
        nudgeTooltip: {
          width: "300px",
          padding: "16px",
          gap: "8px",
          borderRadius: "8px",
          boxShadow: "0px 16px 40px rgba(10, 10, 15, 0.24)",
          background: isLightTheme ? "#FFFFFF" : "#1E1E1E",
          color: isLightTheme ? "#42424D" : "#A6A6A6",
          fontFamily: baseVars.fontFamily,
          titleFontFamily: baseVars.fontFamily,
          titleFontSize: "16px",
          titleFontWeight: 600,
          titleLineHeight: "17px",
          titleColor: isLightTheme ? "#42424D" : "#FFFFFF",
          contentFontFamily: baseVars.fontFamily,
          contentFontSize: "14px",
          contentLineHeight: "16px",
          contentFontWeight: 400,
          contentColor: isLightTheme ? "#42424D" : "#A6A6A6",
          ctaBackground: isLightTheme ? "#0A0A0F" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaColor: "#FFFFFF",
          ctaBorder: isLightTheme ? "none" : "1px solid #101010",
          ctaBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaBorderRadius: "4px",
          ctaPadding: "11px 12px",
          ctaFontFamily: baseVars.fontFamily,
          ctaFontSize: "14px",
          ctaLineHeight: "18px",
          ctaFontWeight: 600,
          ctaSecondaryBackground: isLightTheme ? "#FFFFFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaSecondaryColor: "#0A0A0F",
          ctaSecondaryBorder: isLightTheme ? "1px solid #DFDFE2" : "1px solid #101010",
          ctaSecondaryBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaSecondaryTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaSecondaryBorderRadius: "4px",
          ctaSecondaryPadding: "11px 12px",
          ctaSecondaryFontFamily: baseVars.fontFamily,
          ctaSecondaryFontSize: "14px",
          ctaSecondaryLineHeight: "18px",
          ctaSecondaryFontWeight: 600,
          snoozeButtonBackground: "none",
          snoozeButtonColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          snoozeButtonBorder: "none",
          snoozeButtonTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          snoozeButtonWidth: "100%",
          snoozeButtonFontFamily: baseVars.fontFamily,
          snoozeButtonFontSize: "14px",
          snoozeButtonLineHeight: "18px",
          snoozeButtonFontWeight: 600,
          markerBeaconColor: isLightTheme ? "#7611F7" : "#F7C411",
          markerBeaconPulseScale: "4",
          markerBeaconSize: 16,
          markerIconSize: 16,
          markerIconColor: "#3F424A",
          markerImageSize: 16,
          helpDocPreviewColor: "#FFFFFF",
          helpDocPreviewBackground: generateHelpDocPreviewGradient(baseVars.primary.css()),
          helpDocPreviewMixBlendMode: chroma4(baseVars.primary.css()).get("hsl.s") < 0.9 && chroma4(baseVars.primary.css()).luminance() > 0.075 ? "overlay" : "hard-light",
          stepCountColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          stepCountFontFamily: baseVars.fontFamily,
          stepCountFontWeight: 500,
          stepCountFontSize: "12px"
        },
        nudgeModal: {
          width: "400px",
          height: "auto",
          padding: "16px",
          gap: "8px",
          borderRadius: "8px",
          boxShadow: "0px 16px 40px rgba(10, 10, 15, 0.24)",
          background: isLightTheme ? "#FFFFFF" : "#1E1E1E",
          color: isLightTheme ? "#42424D" : "#A6A6A6",
          fontFamily: baseVars.fontFamily,
          maskBackgroundColor: "rgba(0, 0, 0, 0.1)",
          titleFontFamily: baseVars.fontFamily,
          titleFontSize: "16px",
          titleFontWeight: 600,
          titleLineHeight: "20px",
          titleColor: isLightTheme ? "#42424D" : "#FFFFFF",
          contentFontFamily: baseVars.fontFamily,
          contentFontSize: "14px",
          contentLineHeight: "20px",
          contentFontWeight: 500,
          contentColor: isLightTheme ? "#42424D" : "#A6A6A6",
          ctaBackground: isLightTheme ? "#0A0A0F" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaColor: "#FFFFFF",
          ctaBorder: isLightTheme ? "none" : "1px solid #101010",
          ctaBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaBorderRadius: "4px",
          ctaPadding: "11px 12px",
          ctaFontFamily: baseVars.fontFamily,
          ctaFontSize: "14px",
          ctaLineHeight: "18px",
          ctaFontWeight: "600",
          ctaSecondaryBackground: isLightTheme ? "#FFFFFF" : "linear-gradient(180deg, #343434 0%, #303030 100%)",
          ctaSecondaryColor: "#0A0A0F",
          ctaSecondaryBorder: isLightTheme ? "1px solid #DFDFE2" : "1px solid #101010",
          ctaSecondaryBoxShadow: isLightTheme ? "none" : "0px 2px 3px rgba(0, 0, 0, 0.16), inset 0px 1px 0px rgba(255, 255, 255, 0.09)",
          ctaSecondaryTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          ctaSecondaryBorderRadius: "4px",
          ctaSecondaryPadding: "11px 12px",
          ctaSecondaryFontFamily: baseVars.fontFamily,
          ctaSecondaryFontSize: "14px",
          ctaSecondaryLineHeight: "18px",
          ctaSecondaryFontWeight: "600",
          snoozeButtonBackground: "none",
          snoozeButtonColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          snoozeButtonBorder: "none",
          snoozeButtonTextShadow: isLightTheme ? "none" : "0px 1px 1px rgba(0, 0, 0, 0.26)",
          snoozeButtonWidth: "100%",
          snoozeButtonFontFamily: baseVars.fontFamily,
          snoozeButtonFontSize: "14px",
          snoozeButtonLineHeight: "18px",
          snoozeButtonFontWeight: "600",
          helpDocPreviewColor: "#FFFFFF",
          helpDocPreviewBackground: generateHelpDocPreviewGradient(baseVars.primary.css()),
          helpDocPreviewMixBlendMode: chroma4(baseVars.primary.css()).get("hsl.s") < 0.9 && chroma4(baseVars.primary.css()).luminance() > 0.075 ? "overlay" : "hard-light",
          stepCountColor: isLightTheme ? "#6E6E6E" : "#9C9C9C",
          stepCountFontFamily: baseVars.fontFamily,
          stepCountFontSize: "14px",
          stepCountFontWeight: 500,
          poweredByBorder: isLightTheme ? "1px solid #DFDFE2" : "1px solid #373737"
        },
        helpHub: {
          background: "#FFFFFF",
          height: "calc(100vh - 24px)",
          width: "449px",
          borderRadius: "8px",
          fontFamily: baseVars.fontFamily,
          zIndex: Z_default.Z_HELPHUB,
          title: "HelpHub",
          featuredContentLabel: "Recommended",
          chatInputPlaceholder: "Ask a question...",
          docLinkText: "View Article",
          heroBackground: baseVars.primary.css(),
          inputContainer: baseVars.primary.css(),
          headerBackground: "transparent",
          headerDividerColor: "transparent",
          headerPadding: "12px 16px",
          headerColor: "#000000",
          headerFontWeight: 500,
          headerFontSize: "14px",
          headerLineHeight: "18px",
          headerIconColor: "#000000",
          headerIconOpacity: "50%",
          headerCloseIconDisplay: "",
          headerMinimizeIconDisplay: "",
          subheaderFontSize: "16px",
          subheaderFontWeight: 500,
          subheaderLineHeight: "19px",
          subheaderColor: "#000000",
          highlightBackgroundColor: "#feffe6",
          highlightTextColor: "#000",
          highlightBorderRadius: "0",
          subHeaderColor: "#000",
          subHeaderFontWeight: 500,
          subHeaderFontSize: "16px",
          resultsFoundColor: "#A2A2A9",
          resultsFoundFontWeight: 500,
          resultsFoundFontSize: "12px",
          noResultsTitleFontSize: "16px",
          noResultsTitleFontWeight: 600,
          noResultsTitleColor: "#42424d",
          noResultsDescriptionFontSize: "14px",
          noResultsDescriptionFontWeight: 400,
          noResultsDescriptionColor: "#51515c",
          buttonBoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -1px 0px rgba(0, 0, 0, 0.07)",
          buttonColor: "#51515C",
          buttonBackground: "#FFFFFF",
          buttonBorder: "1px solid rgba(10, 10, 15, 0.24)",
          buttonHoverBoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -1px 0px rgba(0, 0, 0, 0.07)",
          buttonHoverColor: "#51515C",
          buttonHoverBackground: "#FFFFFF",
          buttonHoverBorder: "1px solid rgba(10, 10, 15, 0.29)",
          ctaCustom: "false",
          ctaLabel: "Ask AI",
          ctaFontSize: "14px",
          ctaFontWeight: 500,
          ctaColor: "#ffffff",
          ctaBackground: "#000000",
          ctaBorderRadius: "6.5px",
          ctaBorder: "1px solid #000",
          ctaBoxShadow: "none",
          hoverCtaFontSize: "",
          hoverCtaFontWeight: "",
          hoverCtaColor: "",
          hoverCtaBackground: "",
          hoverCtaBorderRadius: "",
          hoverCtaBorder: "",
          hoverCtaBoxShadow: ""
        },
        helpHubInput: {
          color: "#1E1E29",
          placeholderColor: "#757575",
          fontFamily: baseVars.fontFamily,
          fontSize: "14px",
          fontWeight: 500,
          containerBackground: "#ffffff",
          background: "#ffffff",
          borderRadius: "8px",
          borderColor: "#DFDFE2",
          hoverBorderColor: "#2755F0",
          hoverBorderShadowColor: "rgba(39, 85, 240, 0.24)"
        },
        helpHubGridItem: {
          fontWeight: 600,
          fontSize: "22px",
          lineHeight: "27px",
          color: "#000000",
          background: "#EDEDEE",
          hoverBackground: "#EDEDEE",
          border: "1px solid transparent",
          hoverBorder: "1px solid #A2A2A9",
          borderRadius: "8px",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.24)",
          hoverBoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.24)",
          mixBlendMode: "hard-light",
          ctaButtonForeground: "#FFFFFF",
          ctaButtonBackground: "#0A0A0F",
          ctaButtonBoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.24)",
          ctaButtonBorderRadius: "50%",
          ctaButtonBorder: "none",
          ctaButtonSize: "32px",
          iconSize: "16px"
        },
        helpHubListItem: {
          background: "#ffffff",
          hoverBackground: "#ffffff",
          borderRadius: "8px",
          border: "1px solid rgba(10, 10, 15, 0.24)",
          hoverBorder: "1px solid #A2A2A9",
          boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -2px 0px rgba(0, 0, 0, 0.07)",
          hoverBoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -2px 0px rgba(0, 0, 0, 0.07)",
          padding: "16px 16px 16px 20px",
          gap: "16px",
          titleFontWeight: 500,
          titleFontSize: "14px",
          titleLineHeight: "17px",
          titleColor: "#000000",
          contentTypeFontWeight: 500,
          contentTypeFontSize: "12px",
          contentTypeColor: "#031963",
          contentTypeBackground: "#E6ECFE",
          descriptionFontWeight: 500,
          descriptionFontSize: "14px",
          descriptionLineHeight: "18px",
          descriptionColor: "#51515C",
          iconSize: "20px"
        },
        helpHubDocItem: {
          // these styles only apply to HelpHub articles
          // we may want to rename this to be clearer in the future
          background: "white",
          dividerColor: "#DFDFE2",
          titleFontSize: "18px",
          titleLineHeight: "21px",
          titleFontWeight: 600,
          titleColor: "#0A0A0F",
          paragraphColor: "#42424D",
          linkColor: (chroma4.valid(base.fontColor) ? chroma4(base.fontColor) : chroma4("rgba(0, 0, 0, 0.85)")).darken(3).css(),
          visitedLinkColor: (chroma4.valid(base.fontColor) ? chroma4(base.fontColor) : chroma4("rgba(0, 0, 0, 0.85)")).darken(3).css(),
          videoExcerptFontSize: "14px",
          videoExcerptLineHeight: "21px",
          videoExcerptFontWeight: 500,
          videoExcerptColor: "#42424D",
          contentFontSize: "14px",
          contentLineHeight: "21px",
          contentFontWeight: 400,
          contentHeadingOneColor: "#0A0A0F",
          contentHeadingOneFontSize: "18px",
          contentHeadingOneLineHeight: "",
          contentHeadingOneFontWeight: 700,
          contentHeadingTwoColor: "#0A0A0F",
          contentHeadingTwoFontSize: "16px",
          contentHeadingTwoLineHeight: 1.4,
          contentHeadingTwoFontWeight: 600,
          contentHeadingThreeColor: "#0A0A0F",
          contentHeadingThreeFontSize: "14px",
          contentHeadingThreeLineHeight: 1.5,
          contentHeadingThreeFontWeight: 600,
          contentHeadingFourColor: "#0A0A0F",
          contentHeadingFourFontSize: "13px",
          contentHeadingFourLineHeight: "",
          contentHeadingFourFontWeight: 500,
          contentButtonBackgroundColor: baseVars.primary.css(),
          contentButtonColor: baseVars.background.css(),
          contentButtonHoverBackgroundColor: baseVars.primary.css(),
          contentButtonHoverColor: baseVars.background.css()
        },
        helpHubInstantAnswerItem: {
          background: "#F6F0FF",
          hoverBackground: "#F6F0FF",
          questionFontSize: "16px",
          questionFontWeight: 600,
          questionColor: "#401C7B",
          answerFontSize: "14px",
          answerFontWeight: 500,
          answerColor: "#401C7B"
        },
        helpHubAdditionalResources: {
          background: "#FFFFFF",
          titleFontSize: "16px",
          titleFontWeight: 500,
          titleColor: "#000000",
          borderTop: "1px solid #A2A2A9",
          arrowColor: "#7A7A85",
          boxShadow: "0px -5px 16px rgba(0, 0, 0, 0.08)",
          linkFontSize: "14px",
          linkColor: "#000000",
          linkHoverColor: "#000000",
          linkFontWeight: 500,
          linkPadding: "5px 0px",
          linkIconSize: "20px",
          linkIconColor: "#000000",
          linkIconMarginRight: "6px",
          linkTextDecoration: "underline",
          ctaFontSize: "16px",
          ctaFontWeight: 500,
          ctaColor: "#000000",
          ctaBackground: "#FFFFFF",
          ctaPadding: "10px 12px 10px 12px",
          ctaHeight: "40px",
          ctaWidth: "100%",
          ctaBorderRadius: "4px",
          ctaBorder: "1px solid rgba(10, 10, 15, 0.24)",
          ctaBoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -2px 0px rgba(0, 0, 0, 0.07)",
          hoverCTABackground: "#ffffff",
          hoverCTABorder: "1px solid #CDCDD0",
          hoverCTABoxShadow: "0px 1px 3px rgba(0, 0, 0, 0.07), inset 0px -2px 0px rgba(0, 0, 0, 0.07)",
          hoverCTAColor: "#000000"
        }
      };
      return theme;
    };
    base_default = generateBaseTheme;
  }
});

// internal/src/client/themes/inline.tsx
import chroma5 from "chroma-js";
var generateInlineBaseTheme, inline_default;
var init_inline = __esm({
  "internal/src/client/themes/inline.tsx"() {
    "use strict";
    init_theme3();
    init_base2();
    generateInlineBaseTheme = (baseVars) => {
      const inactiveFontColor = chroma5.mix(baseVars.background, baseVars.fontColor, 0.95);
      const inactiveBackgroundColor = chroma5.mix(baseVars.background, baseVars.fontColor, 0.05).alpha(1);
      const menuBorderColor = chroma5.mix(baseVars.background, baseVars.fontColor, 0.2);
      const inputBorderColor = chroma5.mix(baseVars.background, baseVars.fontColor, 0.4);
      const inlineBase = {
        main: {
          boxShadow: "none",
          // remove the shadow
          background: "rgba(255,255,255,0)"
          // make the background transparent so the space between input & menu is visible
        },
        input: {
          paddingTop: "10px",
          // smaller padding
          paddingBottom: "10px",
          // smaller padding
          fontSize: toPx(baseVars.fontSize),
          // smaller input
          background: baseVars.background.css(),
          // add a background to input now that the main background is transparent
          borderBottom: `1px solid ${inputBorderColor}`,
          border: `1px solid ${inputBorderColor}`,
          borderRadius: "4px",
          paddingLeft: "14px",
          // reduced left padding
          paddingRight: "14px",
          // reduce right padding to match left
          // add inactive colors when the menu is closed
          backgroundInactive: inactiveBackgroundColor.css(),
          colorInactive: inactiveFontColor.css(),
          borderBottomInactive: `1px solid ${inputBorderColor}`
        },
        placeholder: {
          fontSize: toPx(baseVars.fontSize)
          // smaller placeholder
        },
        option: {
          descriptionMarginTop: "-1px",
          // looks better with more space than default
          minHeight: "37px"
          // smaller rows
        },
        menu: {
          marginTop: "4px",
          // space between input and menu
          border: `1px solid ${menuBorderColor}`,
          borderRadius: "4px",
          background: baseVars.background.css()
          // add a background to menu now that main background is transparent
        },
        textSearchMatch: {
          textUnderlinePosition: "under"
          // looks better with more space than defualt
        },
        logo: {
          size: "14px",
          spaceBetweenLogoAndText: "9px"
        },
        categoryHeader: {
          background: chroma5.mix(baseVars.background, baseVars.fontColor, 0.05).css()
        }
      };
      return mergeTheme(inlineBase, base_default(baseVars));
    };
    inline_default = generateInlineBaseTheme;
  }
});

// internal/src/client/themes/modal.tsx
var generateModalBaseTheme, modal_default;
var init_modal = __esm({
  "internal/src/client/themes/modal.tsx"() {
    "use strict";
    init_theme3();
    init_base2();
    generateModalBaseTheme = (baseVars) => {
      const modalBase = {
        bar: {
          width: "675px"
        }
      };
      return mergeTheme(modalBase, base_default(baseVars));
    };
    modal_default = generateModalBaseTheme;
  }
});

// internal/src/client/theme.tsx
import chroma6 from "chroma-js";
var DEFAULTS, getDefaultColor, toPx, getThemeBaseVars, generateBaseThemeFromUserTheme, generateTheme, mergeTheme;
var init_theme3 = __esm({
  "internal/src/client/theme.tsx"() {
    "use strict";
    init_inline();
    init_modal();
    DEFAULTS = {
      primary: "rgb(174, 177, 221)",
      background: "rgba(255,255,255, 1.0)",
      fontColor: "rgba(0,0,0,0.85)",
      fontFamily: "Avenir Next, proxima-nova, sans-serif",
      fontSize: "14px"
    };
    getDefaultColor = (attribute) => {
      return (userValue) => {
        const _default = DEFAULTS[attribute];
        let _color = chroma6(_default);
        if (!!userValue) {
          try {
            _color = chroma6(userValue);
          } catch (e) {
          }
        }
        return _color;
      };
    };
    toPx = (n) => {
      return `${n}px`;
    };
    getThemeBaseVars = (userTheme) => {
      var _a2, _b2, _c2, _d, _e;
      return {
        primary: getDefaultColor("primary")((_a2 = userTheme.base) == null ? void 0 : _a2.primary),
        background: getDefaultColor("background")((_b2 = userTheme.base) == null ? void 0 : _b2.background),
        fontColor: getDefaultColor("fontColor")((_c2 = userTheme.base) == null ? void 0 : _c2.fontColor),
        fontFamily: ((_d = userTheme.base) == null ? void 0 : _d.fontFamily) || DEFAULTS.fontFamily,
        fontSize: parseInt(((_e = userTheme.base) == null ? void 0 : _e.fontSize) || DEFAULTS.fontSize, 10)
      };
    };
    generateBaseThemeFromUserTheme = (userTheme, barFormFactor = { type: "modal" }) => {
      const baseVars = getThemeBaseVars(userTheme);
      switch (barFormFactor.type) {
        case "modal":
          return modal_default(baseVars);
        case "inline":
          return inline_default(baseVars);
      }
    };
    generateTheme = (userTheme, barFormFactor = { type: "modal" }) => {
      const baseTheme = generateBaseThemeFromUserTheme(userTheme, barFormFactor);
      return mergeTheme(userTheme, baseTheme);
    };
    mergeTheme = (userTheme, baseTheme) => {
      const baseThemeCopy = JSON.parse(JSON.stringify(baseTheme));
      Object.keys(baseThemeCopy).forEach((category) => {
        Object.keys(baseThemeCopy[category]).forEach((attribute) => {
          var _a2;
          const userValue = (_a2 = userTheme == null ? void 0 : userTheme[category]) == null ? void 0 : _a2[attribute];
          if (!!userValue) {
            baseThemeCopy[category][attribute] = userValue;
          }
        });
      });
      return baseThemeCopy;
    };
  }
});

// commandbar/src/products/nudges/components/close_icon.svg
import * as React119 from "react";
var SvgCloseIcon;
var init_close_icon = __esm({
  "commandbar/src/products/nudges/components/close_icon.svg"() {
    "use strict";
    SvgCloseIcon = (props2) => /* @__PURE__ */ React119.createElement("svg", { width: 10, height: 10, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React119.createElement("path", { d: "M11 1L1 11M1 1L11 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
  }
});

// commandbar/src/products/nudges/components/CloseButton.tsx
import { jsx as jsx15 } from "@emotion/core";
var CloseButton, CloseButton_default;
var init_CloseButton = __esm({
  "commandbar/src/products/nudges/components/CloseButton.tsx"() {
    "use strict";
    init_useTheme();
    init_Z();
    init_close_icon();
    CloseButton = ({ onInteraction }) => {
      const { theme } = useTheme();
      return /* @__PURE__ */ jsx15(
        "button",
        {
          type: "button",
          "data-testid": "nudge-step-close-button",
          "aria-label": "Close",
          onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            onInteraction(e);
          },
          style: {
            // unstyled button
            display: "flex",
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            color: "inherit",
            font: "inherit",
            cursor: "pointer",
            textAlign: "inherit",
            zIndex: Z_default.Z_COMMANDBAR - 1
          }
        },
        /* @__PURE__ */ jsx15(
          SvgCloseIcon,
          {
            css: {
              width: "12px",
              height: "12px",
              cursor: "pointer",
              transition: `opacity ${theme.main.transitionTime} ease-in`,
              flexShrink: 0,
              alignSelf: "flex-start",
              color: theme.nudges.closeButtonColor,
              "&:hover": {
                color: theme.nudges.closeButtonHoverColor
              }
            }
          }
        )
      );
    };
    CloseButton_default = CloseButton;
  }
});

// commandbar/src/shared/store/util/editorUtils.ts
var checkForEditor, getEditorHandle, clickEditorHandle, openEditorIfLoaded, closeEditorIfOpen, isEditorOpen;
var init_editorUtils = __esm({
  "commandbar/src/shared/store/util/editorUtils.ts"() {
    "use strict";
    checkForEditor = () => {
      return document.getElementById("commandbar-editor-drawer");
    };
    getEditorHandle = () => {
      var _a2;
      const handle = (_a2 = document.getElementById("commandbar-editor-drawer")) == null ? void 0 : _a2.querySelector(".commandbar-editor-drawer-handle");
      if (!!handle)
        return handle;
      return null;
    };
    clickEditorHandle = () => {
      const drawerToggle = getEditorHandle();
      if (drawerToggle) {
        drawerToggle.click();
        drawerToggle.style.visibility = "visible";
      }
    };
    openEditorIfLoaded = () => {
      if (checkForEditor() && !isEditorOpen()) {
        clickEditorHandle();
      }
    };
    closeEditorIfOpen = () => {
      if (checkForEditor() && isEditorOpen()) {
        clickEditorHandle();
      }
    };
    isEditorOpen = () => {
      var _a2;
      const hasOpenClassSuffix = (_a2 = document.getElementById("commandbar-editor-drawer")) == null ? void 0 : _a2.classList.contains("commandbar-editor-drawer-open");
      return !!hasOpenClassSuffix;
    };
  }
});

// internal/src/client/ChromeExtension.ts
var COMMANDBAR_CHROME_EXTENSION_ID, COMMANDBAR_CHROME_EXTENSION_URL;
var init_ChromeExtension = __esm({
  "internal/src/client/ChromeExtension.ts"() {
    "use strict";
    COMMANDBAR_CHROME_EXTENSION_ID = "diahhhkcbpeijifhedabbjgepdgdpkcj";
    COMMANDBAR_CHROME_EXTENSION_URL = `https://chrome.google.com/webstore/detail/commandbar-editor/${COMMANDBAR_CHROME_EXTENSION_ID}`;
  }
});

// internal/src/client/extension/messages/helpers.ts
var isValidStudioOrigin;
var init_helpers11 = __esm({
  "internal/src/client/extension/messages/helpers.ts"() {
    "use strict";
    isValidStudioOrigin = (origin) => {
      const allowedOriginRegexes2 = /^(https:\/\/[a-zA-Z0-9-.]+\.commandbar\.com|https?:\/\/localhost:4000|https:\/\/[a-zA-Z0-9-.]+\.commandbar\.xyz)$/;
      return !!origin && origin.match(allowedOriginRegexes2);
    };
  }
});

// internal/src/client/extension/messages/message.ts
var _ExtensionMessage, ExtensionMessage;
var init_message = __esm({
  "internal/src/client/extension/messages/message.ts"() {
    "use strict";
    init_ChromeExtension();
    init_helpers11();
    _ExtensionMessage = class _ExtensionMessage {
      constructor(message) {
        this.message = message;
      }
      /**
       * Sends a message to the extension from outside of the extension
       * It is only allowed to be called from the Studio, see manifest.json/externally_connectable
       * @returns response from the extension
       */
      sendToExtensionFromStudio(payload) {
        return new Promise((resolve, reject) => {
          var _a2;
          (_a2 = chrome == null ? void 0 : chrome.runtime) == null ? void 0 : _a2.sendMessage(
            COMMANDBAR_CHROME_EXTENSION_ID,
            this.buildPayload(payload),
            this.wrapResponseHandler(resolve, reject)
          );
        });
      }
      /**
       * Sends a message to the content scripts running on a specific tab
       * It is only allowed to be called from the background script or the popup
       * @returns response from a content script
       */
      sendToTabFromBackground(tabId, payload) {
        return new Promise((resolve, reject) => {
          var _a2;
          (_a2 = chrome == null ? void 0 : chrome.tabs) == null ? void 0 : _a2.sendMessage(tabId, this.buildPayload(payload), this.wrapResponseHandler(resolve, reject));
        });
      }
      /**
       * Sends a message to the current page, not the content scripts
       * It is only allowed to be called from the background script or the popup
       *
       * Messages from Chrome extensions must use the `window.postMessage` API to communicate with the page
       * and therefore never has a response associated with it
       *
       * @returns there will never be a response
       */
      async sendToPageFromBackground(tabId, payload) {
        const _payload = this.buildPayload(payload);
        const _data = "data" in _payload ? _payload.data : {};
        const serializedData = encodeURIComponent(JSON.stringify(_data));
        await chrome.scripting.executeScript({
          target: { tabId },
          func: function(message, serializedData2) {
            postMessage({ message, data: JSON.parse(decodeURIComponent(serializedData2)) }, "*");
          },
          args: [_payload.message, serializedData]
        });
      }
      /**
       * Sends a message to the current page
       * It is only allowed to be called from the content scripts or CommandBar
       */
      sendToPage(payload) {
        const _payload = this.buildPayload(payload);
        window == null ? void 0 : window.postMessage(JSON.parse(JSON.stringify(_payload)), "*");
      }
      /**
       * Sends a message internally within the extension
       * It is only allowed to be called from the content scripts or the background script
       * @returns response from the background script
       */
      sendToBackgroundFromContent(payload) {
        return new Promise((resolve, reject) => {
          var _a2;
          (_a2 = chrome == null ? void 0 : chrome.runtime) == null ? void 0 : _a2.sendMessage(this.buildPayload(payload), this.wrapResponseHandler(resolve, reject));
        });
      }
      /**
       * Sends a message from a MAIN world content script, to our isolated world content script (middleware.ts)
       * The isolated world content script receives this message and sends it along to the background service worker
       * Assuming the background knows how to handle this message, it will send back a response to the isolated world content script
       * The isolated world content script will then send this response back to the MAIN world content script
       *
       * see content/middleware.ts for more details
       * @returns response from the isolated world content script
       */
      sendToBackgroundFromMainWorld(payload) {
        const _messageData = this.buildPayload(payload);
        const _payload = { data: _messageData, message: "FORWARD_TO_ISOLATED_WORLD" };
        const promise = new Promise((resolve) => {
          const handler = (evt) => {
            if (evt.data.message === this.message) {
              window.removeEventListener("message", handler);
              resolve(evt.data.data);
            }
          };
          window.addEventListener("message", handler);
        });
        window.postMessage(JSON.parse(JSON.stringify(_payload)), "*");
        return promise;
      }
      /**
       * Registers a listener to listen for messages from within the extension
       * and registers with the global chrome runtime listener
       * @returns unsubscribe function
       */
      addListener(handler) {
        _ExtensionMessage.setupGlobalListener();
        const _handler = this.wrapAsyncHandler(handler);
        _ExtensionMessage.listeners.set(this.message, _handler);
        return () => _ExtensionMessage.listeners.delete(this.message);
      }
      /**
       * Registers a listener to listen for messages coming from outside of the extension
       * and registers with the global chrome runtime listener
       *
       * It is only allowed to be registered within background scripts and will only receive messages from the Studio
       * see manifest.json/externally_connectable
       *
       * @returns unsubscribe function
       */
      addStudioListener(handler) {
        _ExtensionMessage.setupGlobalStudioListener();
        const _handler = this.wrapAsyncHandler((request, sender) => {
          if (!isValidStudioOrigin(sender.origin))
            return { status: "error", error: "Invalid origin" };
          return handler(request, sender);
        });
        _ExtensionMessage.externalListeners.set(this.message, _handler);
        return () => _ExtensionMessage.externalListeners.delete(this.message);
      }
      /**
       * Registers a listener to listen for messages coming from the current page
       * and registers with the global page listener
       *
       * Given the more indirect nature of window.postMessage, many listeners for the same message type can be registered
       * and all of the listeners will be called when the message is received
       *
       * It is only allowed to be registered within a content script or on the page itself (ie. CommandBar/Studio/Editor)
       * @returns unsubscribe function
       */
      addPageListener(handler) {
        _ExtensionMessage.setupGlobalPageListener();
        const listeners = _ExtensionMessage.pageListeners.get(this.message) || [];
        const listener = (event) => {
          handler(event.data);
        };
        listeners.push(listener);
        _ExtensionMessage.pageListeners.set(this.message, listeners);
        return () => {
          const listeners2 = _ExtensionMessage.pageListeners.get(this.message) || [];
          const index3 = listeners2.indexOf(listener);
          if (index3 > -1) {
            listeners2.splice(index3, 1);
          }
          if (listeners2.length > 0) {
            _ExtensionMessage.pageListeners.set(this.message, listeners2);
          } else {
            _ExtensionMessage.pageListeners.delete(this.message);
          }
        };
      }
      buildPayload(payload) {
        if (payload === void 0)
          return { message: this.message };
        return { message: this.message, data: payload };
      }
      wrapAsyncHandler(handler) {
        const message = this.message;
        return function(request, sender, sendResponse) {
          if (request.message !== message)
            return;
          const result = handler(request, sender);
          if (result instanceof Promise) {
            result.then(sendResponse).catch((err) => {
              sendResponse({ status: "error", error: err });
            });
            return true;
          }
          sendResponse(result);
          return false;
        };
      }
      wrapResponseHandler(resolve, reject) {
        const message = this.message;
        return function(response2) {
          var _a2, _b2;
          if ((_a2 = chrome == null ? void 0 : chrome.runtime) == null ? void 0 : _a2.lastError) {
            reject(chrome.runtime.lastError);
          } else if (response2) {
            if (response2.status === "ok") {
              resolve(response2);
            } else {
              reject((_b2 = response2.error) != null ? _b2 : `Unknown error sending ${message}`);
            }
          } else {
            reject(`No response received for ${message}`);
          }
        };
      }
      static setupGlobalListener() {
        var _a2, _b2;
        if (!_ExtensionMessage.globalListenerInitialized) {
          (_b2 = (_a2 = chrome == null ? void 0 : chrome.runtime) == null ? void 0 : _a2.onMessage) == null ? void 0 : _b2.addListener((request, sender, sendResponse) => {
            const listener = _ExtensionMessage.listeners.get(request.message);
            if (listener) {
              return listener(request, sender, sendResponse);
            }
          });
          _ExtensionMessage.globalListenerInitialized = true;
        }
      }
      static setupGlobalStudioListener() {
        var _a2, _b2;
        if (!_ExtensionMessage.globalStudioListenersInitialized) {
          (_b2 = (_a2 = chrome == null ? void 0 : chrome.runtime) == null ? void 0 : _a2.onMessageExternal) == null ? void 0 : _b2.addListener((request, sender, sendResponse) => {
            const listener = _ExtensionMessage.externalListeners.get(request.message);
            if (listener) {
              return listener(request, sender, sendResponse);
            }
          });
          _ExtensionMessage.globalStudioListenersInitialized = true;
        }
      }
      static setupGlobalPageListener() {
        if (!_ExtensionMessage.globalPageListenerInitialized) {
          window == null ? void 0 : window.addEventListener("message", (event) => {
            const listeners = _ExtensionMessage.pageListeners.get(event.data.message);
            if (listeners) {
              listeners.forEach((listener) => listener(event.data));
            }
          });
          _ExtensionMessage.globalPageListenerInitialized = true;
        }
      }
    };
    _ExtensionMessage.listeners = /* @__PURE__ */ new Map();
    _ExtensionMessage.externalListeners = /* @__PURE__ */ new Map();
    _ExtensionMessage.pageListeners = /* @__PURE__ */ new Map();
    // Static flag to track if global chrome runtime listener is initialized
    _ExtensionMessage.globalListenerInitialized = false;
    _ExtensionMessage.globalStudioListenersInitialized = false;
    _ExtensionMessage.globalPageListenerInitialized = false;
    ExtensionMessage = _ExtensionMessage;
  }
});

// internal/src/client/extension/messages/index.ts
var StartClickRecorderMessage, StopClickRecorderMessage, StartPreviewMessage, StopPreviewMessage, UpdateNudgeStepMessage, GetExtensionStateMessage, GetVersionMessage, BootCommandBar, ShareExtensionStatusMessage, ShareStudioAuthMessage, SetDefaultOrganizationIdMessage, ForwardToIsolatedWorldMessage;
var init_messages = __esm({
  "internal/src/client/extension/messages/index.ts"() {
    "use strict";
    init_message();
    StartClickRecorderMessage = new ExtensionMessage("START_CLICK_RECORDER");
    StopClickRecorderMessage = new ExtensionMessage("STOP_CLICK_RECORDER");
    StartPreviewMessage = new ExtensionMessage("START_PREVIEW");
    StopPreviewMessage = new ExtensionMessage("STOP_PREVIEW");
    UpdateNudgeStepMessage = new ExtensionMessage("UPDATE_NUDGE_STEP");
    GetExtensionStateMessage = new ExtensionMessage("GET_EXTENSION_STATE");
    GetVersionMessage = new ExtensionMessage("GET_VERSION");
    BootCommandBar = new ExtensionMessage("BOOT_COMMANDBAR");
    ShareExtensionStatusMessage = new ExtensionMessage("EXTENSION_STATUS");
    ShareStudioAuthMessage = new ExtensionMessage(
      "SHARE_STUDIO_AUTH"
    );
    SetDefaultOrganizationIdMessage = new ExtensionMessage(
      "SET_DEFAULT_ORGANIZATION_ID"
    );
    ForwardToIsolatedWorldMessage = new ExtensionMessage(
      "FORWARD_TO_ISOLATED_WORLD"
    );
  }
});

// commandbar/src/shared/components/admin-facing/DraftFooter.tsx
import React120 from "react";
var styles8, DraftFooter;
var init_DraftFooter = __esm({
  "commandbar/src/shared/components/admin-facing/DraftFooter.tsx"() {
    "use strict";
    init_symbols();
    init_location();
    init_editorUtils();
    init_useStore();
    init_messages();
    init_types2();
    styles8 = {
      container: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "4px 10px 4px 8px",
        width: "100%",
        height: "24px",
        background: "#fffcf2",
        borderTop: "1px solid #f0ede3",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px",
        fontFamily: "Inter",
        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "12px",
        lineHeight: "15px",
        color: "#413303"
      },
      row: {
        display: "flex",
        alignItems: "center"
      },
      indicator: {
        width: "8px",
        height: "8px",
        marginRight: "4px",
        background: "#edbe19",
        border: "1px solid #b18f15",
        borderRadius: "50%",
        boxShadow: "0px 0px 4px #edbe19"
      },
      underlinedText: {
        textDecoration: "underline",
        cursor: "pointer"
      }
    };
    DraftFooter = ({ details }) => {
      const _ = useStore();
      const onEditClick = () => {
        if (details.type === "nudge") {
          if (_.extension.recorder.enabled && _.extension.recorder.experience) {
            const step = details.nudge.steps[details.stepIndex];
            if (isAnchorableStep(step)) {
              StopClickRecorderMessage.sendToPage({ value: step.form_factor.anchor });
              return;
            }
          } else if (_.extension.preview.enabled) {
            StopPreviewMessage.sendToPage({ nudge: details.nudge, currentStepIndex: details.stepIndex });
            return;
          }
        }
        window.CommandBar[_updateEditorRoute](details);
        if (!isEditorOpen()) {
          window.CommandBar.openEditor();
        }
      };
      return /* @__PURE__ */ React120.createElement("div", { style: styles8.container }, /* @__PURE__ */ React120.createElement("div", { style: styles8.row }, /* @__PURE__ */ React120.createElement("div", { style: styles8.indicator }), /* @__PURE__ */ React120.createElement("div", null, "Draft (only visible to you)")), !isStudioPreview() && /* @__PURE__ */ React120.createElement(
        "button",
        {
          style: {
            ...styles8.underlinedText,
            // unstyle button
            background: "none",
            border: "none",
            padding: "0",
            font: "inherit",
            cursor: "pointer"
          },
          onClick: onEditClick
        },
        "Edit\u2197"
      ));
    };
  }
});

// commandbar/src/products/nudges/components/utils.ts
var roundByDPR, getFirstMarkdownBlock;
var init_utils4 = __esm({
  "commandbar/src/products/nudges/components/utils.ts"() {
    "use strict";
    roundByDPR = (value) => {
      const dpr = window.devicePixelRatio || 1;
      return Math.round(value * dpr) / dpr;
    };
    getFirstMarkdownBlock = (content) => content.map((block) => block.type === "markdown" && block.meta.value ? block.meta.value : void 0).filter((block) => !!block).pop();
  }
});

// internal/src/client/themesV2/components/nudge/StyledCloseButtonContainer.tsx
import React121 from "react";
var Container4, StyledCloseButtonContainer, StyledCloseButtonContainer_default;
var init_StyledCloseButtonContainer = __esm({
  "internal/src/client/themesV2/components/nudge/StyledCloseButtonContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container4 = styled_browser_esm_default.div`
  position: absolute;
  display: flex;
  top: calc(max(var(--layout-padding) - 8px, 0px));
  right: calc(max(var(--layout-padding) - 8px, 0px));
  max-height: 32px;
  max-width: 32px;
  border-radius: var(--layout-radius-button);
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;
    StyledCloseButtonContainer = ({ children }) => /* @__PURE__ */ React121.createElement(Container4, null, children);
    StyledCloseButtonContainer_default = StyledCloseButtonContainer;
  }
});

// internal/src/client/themesV2/components/shared/StyledTertiaryIconButton.tsx
import { css as css11, jsx as jsx16 } from "@emotion/core";
var styles9, slug5, StyledTertiaryIconButton, StyledTertiaryIconButton_default;
var init_StyledTertiaryIconButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledTertiaryIconButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_StyledIconContainer();
    init_react();
    init_ButtonWithReset();
    styles9 = {
      display: "flex",
      width: "var(--form-control-height)",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      color: "var(--button-tertiary-content)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--button-tertiary-border-color)",
      background: "var(--button-tertiary-background)",
      cursor: "pointer",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      userSelect: "none",
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: "var(--button-tertiary-border-color-hover)",
        background: "var(--button-tertiary-background-hover)",
        color: "var(--button-tertiary-content-hover)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        background: "var(--button-tertiary-background-hover)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed",
        borderColor: "var(--button-tertiary-border-color)",
        background: "var(--button-tertiary-background)",
        color: "var(--button-tertiary-content)"
      }
    };
    slug5 = "tertiaryIconButton";
    StyledTertiaryIconButton = ({
      themeV2,
      children,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug5, themeV2);
      return /* @__PURE__ */ jsx16(ButtonWithReset_default, { css: [overrides, css11(styles9)], ...props2 }, /* @__PURE__ */ jsx16(StyledIconContainer_default, null, children));
    };
    StyledTertiaryIconButton.styles = styles9;
    StyledTertiaryIconButton.slug = slug5;
    StyledTertiaryIconButton.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx16(StyledTertiaryIconButton, { themeV2: { themeV2, mode } }, /* @__PURE__ */ jsx16(XClose_default, null));
    StyledTertiaryIconButton_default = StyledTertiaryIconButton;
  }
});

// internal/src/hooks/useMergeRefs.tsx
import { useMemo as useMemo4 } from "react";
function assignRef(ref12, value) {
  if (ref12 == null)
    return;
  if (typeof ref12 === "function") {
    ref12(value);
    return;
  }
  ref12.current = value;
}
function mergeRefs(...refs) {
  return (node) => {
    for (const ref12 of refs) {
      assignRef(ref12, node);
    }
  };
}
function useMergeRefs(...refs) {
  return useMemo4(() => mergeRefs(...refs), refs);
}
var init_useMergeRefs = __esm({
  "internal/src/hooks/useMergeRefs.tsx"() {
    "use strict";
  }
});

// commandbar/src/shared/components/popover/constants.ts
var init_constants4 = __esm({
  "commandbar/src/shared/components/popover/constants.ts"() {
    "use strict";
  }
});

// commandbar/src/shared/components/popover/state.tsx
import {
  autoPlacement,
  autoUpdate as autoUpdate2,
  computePosition as computePosition2,
  flip,
  offset as offset3,
  shift as shift2
} from "@floating-ui/dom";
import { createActorContext } from "@xstate/react";
import React122, {
  createContext as createContext3,
  useContext as useContext3,
  useRef as useRef19
} from "react";
import { assign as assign2, createMachine as createMachine2 } from "xstate";
var hoverPopoverMachine, clickPopoverMachine, HoverMachineContext, ClickMachineContext, PopoverContext, usePopoverContext, ServiceProvider, PopoverContextProvider, isHoverPopoverService, isClickPopoverService;
var init_state2 = __esm({
  "commandbar/src/shared/components/popover/state.tsx"() {
    "use strict";
    hoverPopoverMachine = createMachine2({
      /** @xstate-layout N4IgpgJg5mDOIC5QAkD2A3MAnABABVQAcNsBiPAeQGUBJAFRooDkBtABgF1FRjYBLAC59UAO24gAHogC0AZgBMAOgCcADlUBGWbLYBWDevnzlAGhABPGRt0A2RfIW75e5RvmrjsgL5ezaTLgExAHkADIAggDCAKLsXEggvILCYglSCPJuirpsqgrKTsoA7AAs7maWCNLWdg7yTi5uHsreviD+2PhEJFikAKp4ACLhdNEA+nQASjQA4jPRk2ODNACy0Uy0zFRx4klCouLpJTZs9mxsGkXyJUWatzYVVrb2js66ru6ePn49XcHYigAxgAbVCwSCkCh4dY7BJ7FKHRAlDR2S6XNiuFGFeSPDJORQ2eQ2Yo2MrKNg2PLfdq-II9IGg8EQcjUeiMVicXZg5IHNKIDR6ezEwmUkraEpsBS45F2Nhlc7yIoaVzKEq6akdQLdAIMsGQRR8ETJACGwJZtAYzFhPG5+1SoHS0iMilUbEyYspuhKJVUPt0uN0+hUvquvusRTYRXVbU1f3pRDAIkUAAseoaoKRIqFqLFOXDbQi+QhkUp3jYcrYBSrLgGyopzkrNCVlCcNAYNbTtQCE0nUAAzPuQ6Ec+I2-h2xEIQN2XSyfSyGy3X2K-0WRAnVT166XX03AyZDsBOM6nuKfuD62JAu8h1I9T2VT6ZtFFvKymyXHhl25W4UuXOeofDaERUAgOBxFjOkAi5cdC1vKoI2-d0F0fb1fVUXFpDrJVjncXQ8gjZR6hsQ9OiggEQT1CAYJ5e1JHXexbDVPDZDFWxTDXBBXEUW5ZyVIoFy9Ipy1IrV-iwXUmQNI0hFNGiJyLL1GNJJxH1YudiU-F8H1nUlJUfBwPFE48KMZfUsDAQgwGNAR5Lg+iEEuIpFB0VR3ycIwihfB5OMuZQdNkV13i9EKimM8iJJ7Oybwc1j-PJNsWjbDFlRrTjAtkFzZA0b1CgxQlVHCrtIqspNUwCdNoroo5IwJNwtApKtUqKXENy3ZFbm9Rt2xjTtxLPUqzwHKrJyY7JZHJMV9LKKNayUBsDBylsLh6n4jwigbE0UPtUCwQFIBGosJuchLlWyprXBaziblOPIctkKMiJaZQgK8IA */
      id: "Hover Popover",
      initial: "closed",
      states: {
        closed: {
          on: {
            OPEN: {
              target: "open"
            },
            POSITION: {
              target: "open.forced",
              cond: "isForcedOpen"
            }
          },
          states: {
            initial: {
              on: {
                POSITION: {
                  target: "#Hover Popover.open",
                  cond: "isDefaultOpen"
                }
              }
            },
            repeat: {}
          },
          initial: "initial"
        },
        open: {
          initial: "hovering",
          states: {
            hovering: {
              on: {
                CLOSE: {
                  target: "off"
                }
              }
            },
            off: {
              on: {
                OPEN: {
                  target: "hovering"
                }
              },
              always: {
                target: "#Hover Popover.closed.repeat",
                actions: "updateShouldRunAnimation"
              }
            },
            forced: {
              type: "final"
            }
          }
        }
      },
      invoke: [
        {
          src: "trackTrigger",
          id: "trackTrigger"
        }
      ],
      on: {
        POSITION: {
          actions: ["updatePosition"]
        },
        PLACE: {
          actions: ["updatePlacement"]
        },
        UPDATE_TRIGGER_DIMENSIONS: {
          actions: ["updateTriggerDimensions"]
        }
      },
      schema: {
        events: {},
        context: {}
      },
      predictableActionArguments: true,
      tsTypes: {}
    });
    clickPopoverMachine = createMachine2({
      /** @xstate-layout N4IgpgJg5mDOIC5QGEA2BLAxgawAQAUB7AB0IDcwAnAYnwHkBlASQBUm6A5AbQAYBdRKFKx0AF3SEAdoJAAPRAGYATADoAjGuUAWHgA5dAdgO6tagDQgAnogC0SgKw8VATntqlH584UL7OgwC+ARZoWHhEpBQ0+AAyAILIAKK8AkggwmIS0mnyCA7OKgZaRgBsPFoKavZeBhbWCHaOLm4eSl4+fjyBwSChOAQk5FTUAKr4ACJxLIkA+iwASkwA4kuJ8zPjTACyiRzMnAwpMhniUjK5WiUFV0ruul48JWq6dbYOTq7unt6+-kEhGH6ESGlBUmFQhFgkGodHwuyOaROWXOiCUCi06gMV2KahKbXsDhKrwQlxKKhKeOcWmcmmcj2p9n+vUB4UGUTBEKhEFojFY7G4-GOkMyZxyiEMKg8V30z3cXWKxL8ZJpBiUBlx9nsPjxTL6rMiVA5kMgKnQkkyAENUDzmGxOAihMLTtlQBcaeTqZoSj4ugpdBTiRLDH7nCVTLo2mHdSyBgbQSQwJJTRBUGBqMgYoxkoLEU7kWKEApnAYVL66WpXEWtFpiZUS1pdAoDMXm-Yw6ro2FYyCVABXYgQC3iSRQXAW80AWyHWVwsFEQ7TDvSedFrsUyhctz8WoqvhK9mJmnsKi01QjWiUFUujyUQR6kkIEDgMj13aiQpEzpRhYKUucMt0OUiiKYkbE0DF3CeT0nkvGlbx6V9gXZcFjQgD8RRdOREDUC8VF+HgeE+KlvWUYknCbP1jAMM8FApMN4IBLskMNFCuVNc1xCtdCvwLCsMXRJ5ix4PiSKUQMS2DQxiPaPEtE7IE2RYzkTUoMBiDAIduPzNcEArcjOkItxiJ8MSrGwtsXFoptpO8WT5P1HsE0wpFVywwt0Tw4x7HuAitVDXxa2bdRKUqBtHh4Al7LfQ0nOTVMtNci5CMxJUdAiotvQPMySQpclKU9It6VcKLmPjdSkwAM0IShMEgBLMNyP1VCbXRvLpdL-Ky+ptzy1VQwrVUShKxTQX7Qdh1Hcd0CnZ1Z3nUQwHq78fAUE8vBKQxdHKZwlHuYlLycPQIypfRtr0Rk7yAA */
      id: "Click Popover",
      initial: "closed",
      invoke: [
        {
          src: "trackTrigger",
          id: "trackTrigger"
        }
      ],
      states: {
        closed: {
          on: {
            OPEN: "open",
            POSITION: {
              target: "open.forced",
              cond: "isForcedOpen"
            }
          },
          states: {
            initial: {
              on: {
                POSITION: {
                  target: "#Click Popover.open",
                  cond: "isDefaultOpen"
                }
              }
            },
            repeat: {}
          },
          initial: "initial"
        },
        open: {
          states: {
            idle: {
              on: {
                CLOSE: "#Click Popover.updating animation state"
              }
            },
            forced: {
              type: "final"
            }
          },
          initial: "idle"
        },
        "updating animation state": {
          always: {
            target: "closed.repeat",
            actions: "updateShouldRunAnimation"
          }
        }
      },
      on: {
        POSITION: {
          actions: ["updatePosition"]
        },
        PLACE: {
          actions: ["updatePlacement"]
        },
        UPDATE_TRIGGER_DIMENSIONS: {
          actions: ["updateTriggerDimensions"]
        }
      },
      schema: {
        events: {},
        context: {}
      },
      predictableActionArguments: true,
      tsTypes: {}
    });
    HoverMachineContext = createActorContext(hoverPopoverMachine);
    ClickMachineContext = createActorContext(clickPopoverMachine);
    PopoverContext = createContext3({ triggerType: "hover" });
    usePopoverContext = () => {
      const context = useContext3(PopoverContext);
      if (context == null) {
        throw new Error("Popover components must be wrapped in <Popover />");
      }
      return context;
    };
    ServiceProvider = ({ children }) => {
      const { triggerType } = usePopoverContext();
      const MachineContext = triggerType === "hover" ? HoverMachineContext : ClickMachineContext;
      const service = MachineContext.useActorRef();
      const useSelector3 = MachineContext.useSelector;
      return children(service, useSelector3);
    };
    PopoverContextProvider = ({
      children,
      offset: _offset,
      triggerType,
      placement,
      autoPlacement: _autoPlacement,
      flip: _flip,
      forceOpen,
      defaultOpen: defaultOpen2
    }) => {
      const triggerRef = useRef19(null);
      const contentRef = useRef19(null);
      const options = {
        guards: {
          isForcedOpen: () => forceOpen,
          isDefaultOpen: () => defaultOpen2
        },
        context: {
          trigger: {
            ref: triggerRef,
            dimensions: null
          },
          content: {
            ref: contentRef,
            position: null,
            offset: _offset,
            placement,
            shouldRunAnimation: !(defaultOpen2 || forceOpen)
          }
        },
        actions: {
          updatePosition: assign2({
            content: ({ content }, { x, y }) => ({
              ...content,
              position: {
                x,
                y
              }
            })
          }),
          updatePlacement: assign2({
            content: ({ content }, { placement: placement2 }) => ({
              ...content,
              placement: placement2
            })
          }),
          updateTriggerDimensions: assign2({
            trigger: ({ trigger }, { dimensions }) => ({
              ...trigger,
              dimensions
            })
          }),
          updateShouldRunAnimation: assign2({
            content: ({ content }, _event) => ({
              ...content,
              shouldRunAnimation: true
            })
          })
        },
        services: {
          trackTrigger: ({ trigger, content }) => (sendBack) => {
            const triggerElement = trigger.ref.current;
            const contentElement = content.ref.current;
            if (triggerElement && contentElement) {
              const updatePosition = () => {
                const middleware = [
                  offset3({
                    mainAxis: _offset
                  })
                ];
                if (_autoPlacement) {
                  middleware.push(
                    shift2({ padding: _offset }),
                    autoPlacement({
                      crossAxis: true,
                      allowedPlacements: ["top", "bottom"]
                    })
                  );
                }
                if (_flip) {
                  middleware.push(flip());
                }
                computePosition2(triggerElement, contentElement, {
                  placement,
                  middleware
                }).then(({ y, x, placement: placement2 }) => {
                  sendBack({ type: "PLACE", placement: placement2 });
                  sendBack({ type: "POSITION", x, y });
                });
              };
              const cleanupContent = autoUpdate2(triggerElement, contentElement, updatePosition);
              return () => {
                cleanupContent();
              };
            }
          }
        }
      };
      const MachineContext = triggerType === "hover" ? HoverMachineContext : ClickMachineContext;
      return /* @__PURE__ */ React122.createElement(PopoverContext.Provider, { value: { triggerType } }, /* @__PURE__ */ React122.createElement(MachineContext.Provider, { options }, /* @__PURE__ */ React122.createElement(ServiceProvider, null, children)));
    };
    isHoverPopoverService = (state) => {
      var _a2;
      return ((_a2 = state.machine) == null ? void 0 : _a2.id) === "Hover Popover";
    };
    isClickPopoverService = (state) => {
      var _a2;
      return ((_a2 = state.machine) == null ? void 0 : _a2.id) === "Click Popover";
    };
  }
});

// internal/src/client/themesV2/components/animations/helpers.ts
var convertCSSDurationToMilliseconds, getAnimationVariables, getAnimationPresetVariables, getAnimationType, convertWidgetPositionToTransformOrigin, getAdditionalAnimationProperties, getCSSVarValue, getDefaultCSSVarValue, getAnimationConfig;
var init_helpers12 = __esm({
  "internal/src/client/themesV2/components/animations/helpers.ts"() {
    "use strict";
    init_defaults();
    convertCSSDurationToMilliseconds = (timeStr, defaultDuration = 260) => {
      const defaultDurationMS = parseFloat(defaultDuration.toString()) * (/\ds$/.test(defaultDuration.toString()) ? 1e3 : 1);
      if (timeStr) {
        const num = parseFloat(timeStr.toString()) * (/\ds$/.test(timeStr.toString()) ? 1e3 : 1);
        if (!isNaN(num)) {
          return num;
        }
      }
      return defaultDurationMS;
    };
    getAnimationVariables = (widget) => {
      const transitionProperty = `--${widget}-anim-transition-property`;
      const transitionTiming = `--${widget}-anim-transition-timing`;
      const transitionDuration = `--${widget}-anim-transition-duration`;
      return { transitionProperty, transitionTiming, transitionDuration };
    };
    getAnimationPresetVariables = (type39) => {
      const transitionProperty = `--anim-transition-property--${type39}`;
      const transitionTiming = `--anim-transition-timing--${type39}`;
      const transformInitial = `--anim-transform-initial--${type39}`;
      const transformAnimated = `--anim-transform-animated--${type39}`;
      return { transitionProperty, transitionTiming, transformInitial, transformAnimated };
    };
    getAnimationType = (widget, themeV2, mode = "light_mode") => {
      var _a2, _b2, _c2;
      const vars = getAnimationVariables(widget);
      const transitionProperty = themeV2 ? (_a2 = themeV2[mode]) == null ? void 0 : _a2.var_overrides[vars.transitionProperty] : void 0;
      const transitionTiming = themeV2 ? (_b2 = themeV2[mode]) == null ? void 0 : _b2.var_overrides[vars.transitionTiming] : void 0;
      const animationTypes = ["instant", "fade", "spring", "scale"];
      return (_c2 = animationTypes.find((type39) => {
        const presetVars = getAnimationPresetVariables(type39);
        return themeV2 && transitionProperty === getDefaultCSSVarValue(themeV2, mode, presetVars.transitionProperty) && transitionTiming === getDefaultCSSVarValue(themeV2, mode, presetVars.transitionTiming);
      })) != null ? _c2 : "instant";
    };
    convertWidgetPositionToTransformOrigin = (position) => {
      if (position.includes("-")) {
        const [x, y] = position.split("-");
        return `${y} ${x}`;
      }
      switch (position) {
        case "center":
          return "center center";
        case "bottomRight":
          return "bottom right";
        case "bottomLeft":
          return "bottom left";
      }
      return position;
    };
    getAdditionalAnimationProperties = (_, widget, type39, position) => {
      const additional = {
        transformOrigin: "center"
      };
      if (type39 !== "scale") {
        return additional;
      }
      switch (widget) {
        case "modal":
          additional.transformOrigin = "center center";
          break;
        case "popover":
          additional.transformOrigin = convertWidgetPositionToTransformOrigin(position != null ? position : "center");
          break;
        case "helphub":
        case "checklist":
          additional.transformOrigin = convertWidgetPositionToTransformOrigin(position != null ? position : "bottomRight");
          break;
      }
      return additional;
    };
    getCSSVarValue = (theme, mode, cssVar) => {
      var _a2, _b2, _c2;
      return (_c2 = (_a2 = theme == null ? void 0 : theme[mode].var_overrides[cssVar]) != null ? _a2 : theme == null ? void 0 : theme[mode].var_defaults[cssVar]) != null ? _c2 : (_b2 = DEFAULT_THEME) == null ? void 0 : _b2[mode].var_defaults[cssVar];
    };
    getDefaultCSSVarValue = (theme, mode, cssVar) => {
      var _a2, _b2;
      return (_b2 = theme == null ? void 0 : theme[mode].var_defaults[cssVar]) != null ? _b2 : (_a2 = DEFAULT_THEME) == null ? void 0 : _a2[mode].var_defaults[cssVar];
    };
    getAnimationConfig = (_, widget, themeV2, mode = "light_mode", position) => {
      const type39 = getAnimationType(widget, themeV2, mode);
      const vars = getAnimationVariables(widget);
      const presetVars = getAnimationPresetVariables(type39);
      const additional = getAdditionalAnimationProperties(_, widget, type39, position);
      const durationMS = convertCSSDurationToMilliseconds(
        getCSSVarValue(themeV2, mode, vars.transitionDuration),
        getDefaultCSSVarValue(themeV2, mode, "--anim-transition-duration")
      );
      return { type: type39, vars, presetVars, additional, durationMS };
    };
  }
});

// internal/src/client/themesV2/components/animations/useAnimatedWidgetConfig.tsx
import { useMemo as useMemo5 } from "react";
var useAnimatedWidgetConfig;
var init_useAnimatedWidgetConfig = __esm({
  "internal/src/client/themesV2/components/animations/useAnimatedWidgetConfig.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_useStore();
    init_helpers12();
    useAnimatedWidgetConfig = (widget, options) => {
      var _a2, _b2;
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const isProviderEnabled = !!((_a2 = _.flags) == null ? void 0 : _a2["release-widget-animations"]) && !!((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]);
      const config2 = getAnimationConfig(_, widget, themeV2.themeV2, themeV2.mode, options == null ? void 0 : options.position);
      const prefersReducedMotion = useMemo5(() => !!window.matchMedia("(prefers-reduced-motion: reduce)").matches, []);
      const durationMS = config2.durationMS;
      const isWidgetAnimated = config2.type !== "instant" && isProviderEnabled && !prefersReducedMotion;
      const transformInitial = useMemo5(
        () => getCSSVarValue(themeV2.themeV2, themeV2.mode, config2.presetVars.transformInitial),
        [themeV2]
      );
      const transformAnimated = useMemo5(
        () => getCSSVarValue(themeV2.themeV2, themeV2.mode, config2.presetVars.transformAnimated),
        [themeV2]
      );
      const initial = !isWidgetAnimated ? {} : {
        opacity: 0,
        transform: !!transformInitial ? `var(${config2.presetVars.transformInitial})` : void 0,
        transitionProperty: `var(${config2.vars.transitionProperty})`,
        transitionTimingFunction: `var(${config2.vars.transitionTiming})`,
        transitionDuration: `var(${config2.vars.transitionDuration})`,
        transformOrigin: config2.additional.transformOrigin
      };
      const animated = !isWidgetAnimated ? {} : {
        ...initial,
        opacity: 1,
        transform: !!transformAnimated ? `var(${config2.presetVars.transformAnimated})` : void 0
      };
      return {
        animated,
        initial,
        type: config2.type,
        durationMS,
        isWidgetAnimated,
        isProviderEnabled
      };
    };
  }
});

// commandbar/src/shared/util/hooks/useDelayUnmount.tsx
import { keyframes as keyframes2, css as css12, jsx as jsx17 } from "@emotion/core";
import React123, { useEffect as useEffect20, useState as useState12 } from "react";
var useDelayUnmount, defaultAnimationProps, AnimationTransition, fadeInSlideDownExpand, fadeInSlideDown, fadeIn, fadeOut, slideUp, builtinKeyframes;
var init_useDelayUnmount = __esm({
  "commandbar/src/shared/util/hooks/useDelayUnmount.tsx"() {
    "use strict";
    useDelayUnmount = (isMounted, delayTime) => {
      const [shouldRender, setShouldRender] = useState12(false);
      useEffect20(() => {
        let timeoutId;
        if (isMounted && !shouldRender) {
          setShouldRender(true);
        } else if (!isMounted && shouldRender) {
          if (delayTime === 0) {
            setShouldRender(false);
            return;
          }
          timeoutId = setTimeout(() => setShouldRender(false), delayTime);
        }
        return () => clearTimeout(timeoutId);
      }, [isMounted, delayTime, shouldRender]);
      return shouldRender;
    };
    defaultAnimationProps = {
      timingFunction: "ease",
      durationMs: 300
    };
    AnimationTransition = (props2) => {
      const { children, entry, exit: exit2, isMounted } = props2;
      const unmountDelay = !!exit2 ? exit2.durationMs || defaultAnimationProps.durationMs : 0;
      const shouldRender = useDelayUnmount(isMounted, unmountDelay);
      const [containerStyle, setContainerStyle] = useState12(void 0);
      const generateAnimationCSS = (animationProps) => {
        if (animationProps) {
          const duration = `${animationProps.durationMs || defaultAnimationProps.durationMs}ms forwards`;
          const timingFn = animationProps.timingFunction || defaultAnimationProps.timingFunction;
          return css12`
        animation: ${animationProps.keyframes} ${duration} ${timingFn};
      `;
        }
        return void 0;
      };
      useEffect20(() => {
        if (isMounted) {
          setContainerStyle(generateAnimationCSS(entry));
        } else if (shouldRender) {
          setContainerStyle(generateAnimationCSS(exit2));
        }
      }, [isMounted, shouldRender, entry, exit2]);
      return /* @__PURE__ */ jsx17(React123.Fragment, null, shouldRender && /* @__PURE__ */ jsx17("div", { css: containerStyle, style: props2.style }, children));
    };
    fadeInSlideDownExpand = keyframes2`
0% {
  opacity: 0;
  transform: translateY(10px);
  scale: 0.85;

}
100% {
  opacity: 1;
  transform: translateY(0px);
  scale: 1;
}
`;
    fadeInSlideDown = keyframes2`
0% {
  opacity: 0;
  transform: translateY(10px);
}
100% {
  opacity: 1;
  transform: translateY(0px);
}
`;
    fadeIn = keyframes2`
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
`;
    fadeOut = keyframes2`
0% {
  opacity: 1;
}
100% {
  opacity: 0;
}
`;
    slideUp = (distance) => keyframes2`
0% {
  transform: translateY(${distance}px);
}
100% {
  transform: translateY(0px);
}
`;
    builtinKeyframes = {
      fadeInSlideDown,
      fadeOut,
      slideUp,
      fadeIn,
      fadeInSlideDownExpand
    };
  }
});

// internal/src/client/themesV2/components/animations/AnimatedWidget.tsx
import React124, { useState as useState13, createContext as createContext4, useEffect as useEffect21, useContext as useContext4 } from "react";
var AnimatedWidgetContext, AnimatedWidget, useAnimatedWidget;
var init_AnimatedWidget = __esm({
  "internal/src/client/themesV2/components/animations/AnimatedWidget.tsx"() {
    "use strict";
    init_useAnimatedWidgetConfig();
    init_useStore();
    init_useDelayUnmount();
    AnimatedWidgetContext = createContext4({
      animStyles: {},
      durationMS: 0,
      setMounted: () => {
        console.error("No AnimatedWidgetContext.Provider wrapper found");
      },
      setOpen: () => {
        console.error("No AnimatedWidgetContext.Provider wrapper found");
      },
      isAnimatedWidget: false,
      animType: "instant"
    });
    AnimatedWidget = ({
      children,
      widget,
      isMounted: _isMounted,
      keepMounted,
      isOpenByDefault,
      enterDelay,
      position
    }) => {
      const _ = useStore();
      const [isMounted, setMounted] = useState13(!!_isMounted || !!keepMounted);
      const [isOpen, setOpen] = useState13(!!isOpenByDefault);
      const config2 = useAnimatedWidgetConfig(widget, { position });
      const shouldRender = useDelayUnmount(!!keepMounted || !!isMounted, config2.durationMS);
      const [animStyles, setAnimStyles] = useState13(config2.initial);
      const enter2 = () => {
        if (enterDelay) {
          const timeout = setTimeout(() => {
            setAnimStyles(config2.animated);
            clearTimeout(timeout);
          }, enterDelay);
        } else {
          setAnimStyles(config2.animated);
        }
      };
      const isVisible2 = !keepMounted && isMounted || keepMounted && isOpen;
      useEffect21(() => {
        if (config2.isProviderEnabled) {
          if (!isVisible2) {
            setAnimStyles(config2.initial);
          } else if (isVisible2 && shouldRender) {
            enter2();
          }
        }
      }, [isVisible2, shouldRender]);
      useEffect21(() => {
        setMounted(!!_isMounted);
      }, [_isMounted]);
      return /* @__PURE__ */ React124.createElement(
        AnimatedWidgetContext.Provider,
        {
          value: {
            animStyles,
            durationMS: config2.durationMS,
            setMounted,
            setOpen,
            keepMounted,
            isAnimatedWidget: config2.isWidgetAnimated,
            animType: config2.type
          }
        },
        config2.isProviderEnabled && shouldRender && /* @__PURE__ */ React124.createElement(React124.Fragment, null, children),
        !config2.isProviderEnabled && /* @__PURE__ */ React124.createElement(React124.Fragment, null, children)
      );
    };
    useAnimatedWidget = () => {
      const context = useContext4(AnimatedWidgetContext);
      const onExit = (exitCallback, options = { cancellable: false }) => {
        if (!context.isAnimatedWidget) {
          exitCallback == null ? void 0 : exitCallback();
          return;
        }
        if (!context.keepMounted) {
          context.setMounted(false);
        } else {
          context.setOpen(false);
        }
        if (options.cancellable) {
          exitCallback == null ? void 0 : exitCallback();
        } else {
          const timeout = setTimeout(() => {
            clearTimeout(timeout);
            exitCallback == null ? void 0 : exitCallback();
          }, context.durationMS);
        }
      };
      const onEnter = () => {
        if (!context.isAnimatedWidget) {
          return;
        }
        const timeout = setTimeout(() => {
          if (!context.keepMounted) {
            context.setMounted(true);
          } else {
            context.setOpen(true);
          }
          clearTimeout(timeout);
        }, 10);
      };
      return { animStyles: context.animStyles, onExit, onEnter, isAnimatedWidget: context.isAnimatedWidget };
    };
  }
});

// commandbar/src/shared/components/popover/index.tsx
import { jsx as jsx18 } from "@emotion/core";
import {
  forwardRef as forwardRef5,
  useCallback as useCallback5
} from "react";
import { createPortal } from "react-dom";
var ClickTrigger, HoverTrigger, PopoverTrigger, wrapInPx, getHoverBufferPositioning, HoverPopoverContent, ClickPopoverContent, PopoverContent, Close, PopoverClose, MeasuredPopover, Popover;
var init_popover = __esm({
  "commandbar/src/shared/components/popover/index.tsx"() {
    "use strict";
    init_utils4();
    init_Z();
    init_StyledCloseButtonContainer();
    init_StyledTertiaryIconButton();
    init_useFocusTrap();
    init_useMergeRefs();
    init_useStore();
    init_Slot();
    init_ThemeV2Context();
    init_constants4();
    init_state2();
    init_AnimatedWidget();
    ClickTrigger = forwardRef5(
      ({ children, style: style3, asChild, ...props2 }, forwardedRef) => {
        const clickTriggerRef = ClickMachineContext.useSelector(({ context }) => context.trigger.ref);
        const open = ClickMachineContext.useSelector(({ matches }) => matches("open"));
        const { send: send2 } = ClickMachineContext.useActorRef();
        const { onEnter } = useAnimatedWidget();
        const measuredRef = useCallback5(
          (node) => {
            if (node !== null) {
              send2({ type: "UPDATE_TRIGGER_DIMENSIONS", dimensions: node.getBoundingClientRect() });
            }
          },
          [send2]
        );
        const mergedRef = useMergeRefs(clickTriggerRef, forwardedRef, measuredRef);
        const Comp = asChild ? Slot : "button";
        return /* @__PURE__ */ jsx18(
          Comp,
          {
            "data-testid": "popover-click-trigger" /* ClickTrigger */,
            ...props2,
            ref: mergedRef,
            "aria-haspopup": "dialog",
            "data-state": open ? "open" : "closed",
            style: {
              cursor: "pointer",
              ...style3
            },
            type: "button",
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              send2("OPEN");
              onEnter();
            }
          },
          children
        );
      }
    );
    HoverTrigger = forwardRef5(
      ({ children, style: style3, asChild, ...props2 }, forwardedRef) => {
        const hoverTriggerRef = HoverMachineContext.useSelector(({ context }) => context.trigger.ref);
        const open = HoverMachineContext.useSelector(({ matches }) => matches("open"));
        const { send: send2 } = HoverMachineContext.useActorRef();
        const { onEnter, onExit } = useAnimatedWidget();
        const measuredRef = useCallback5(
          (node) => {
            if (node !== null) {
              send2({ type: "UPDATE_TRIGGER_DIMENSIONS", dimensions: node.getBoundingClientRect() });
            }
          },
          [send2]
        );
        const mergedRef = useMergeRefs(hoverTriggerRef, forwardedRef, measuredRef);
        const Comp = asChild ? Slot : "button";
        return /* @__PURE__ */ jsx18(
          Comp,
          {
            "data-testid": "popover-hover-trigger" /* HoverTrigger */,
            ...props2,
            ref: mergedRef,
            "data-state": open ? "open" : "closed",
            style: {
              cursor: "default",
              ...style3
            },
            tabIndex: -1,
            type: "button",
            onMouseEnter: () => {
              send2("OPEN");
              onEnter();
            },
            onMouseLeave: () => {
              onExit(
                () => {
                  send2("CLOSE");
                },
                { cancellable: true }
              );
            }
          },
          children
        );
      }
    );
    PopoverTrigger = forwardRef5(
      ({ children, style: customStyles, ...props2 }, ref12) => {
        const { triggerType } = usePopoverContext();
        const TriggerComponent = triggerType === "hover" ? HoverTrigger : ClickTrigger;
        const style3 = {
          zIndex: 1,
          position: "absolute",
          background: "none",
          border: "none",
          padding: 0,
          ...customStyles
        };
        return /* @__PURE__ */ jsx18(TriggerComponent, { ...props2, ref: ref12, style: style3 }, children);
      }
    );
    wrapInPx = (value) => `${value}px`;
    getHoverBufferPositioning = (placement, offset6) => {
      switch (placement) {
        case "top-end":
        case "top-start":
        case "top": {
          return { bottom: -offset6, left: 0, height: offset6 };
        }
        case "bottom-end":
        case "bottom-start":
        case "bottom": {
          return { top: -offset6, left: 0, height: offset6 };
        }
        case "left-end":
        case "left-start":
        case "left": {
          return { right: -offset6, top: 0, width: offset6 };
        }
        case "right-end":
        case "right-start":
        case "right": {
          return { left: -offset6, top: 0, width: offset6 };
        }
      }
    };
    HoverPopoverContent = forwardRef5(
      ({ children, style: style3, labelledBy, describedBy, portalToId, ...props2 }, forwardedRef) => {
        var _a2;
        const { send: send2 } = HoverMachineContext.useActorRef();
        const { animStyles, isAnimatedWidget, onEnter, onExit } = useAnimatedWidget();
        const hoverContentRef = HoverMachineContext.useSelector(({ context }) => context.content.ref);
        const offset6 = HoverMachineContext.useSelector(({ context }) => context.content.offset);
        const isOpen = HoverMachineContext.useSelector(({ matches }) => matches("open"));
        const x = HoverMachineContext.useSelector(({ context }) => {
          var _a3;
          return (_a3 = context.content.position) == null ? void 0 : _a3.x;
        });
        const y = HoverMachineContext.useSelector(({ context }) => {
          var _a3;
          return (_a3 = context.content.position) == null ? void 0 : _a3.y;
        });
        const shouldRunAnimation = HoverMachineContext.useSelector(({ context }) => context.content.shouldRunAnimation);
        const placement = HoverMachineContext.useSelector(({ context }) => context.content.placement);
        const hoverBufferStyles = Object.entries(getHoverBufferPositioning(placement, offset6)).reduce((acc, [key, val]) => {
          acc[key] = wrapInPx(val);
          return acc;
        }, {});
        const mergedRef = useMergeRefs(hoverContentRef, forwardedRef);
        return (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          /* @__PURE__ */ jsx18(
            "div",
            {
              "data-testid": "popover-hover-content" /* HoverContent */,
              ...props2,
              ref: mergedRef,
              "aria-describedby": describedBy,
              "aria-labelledby": labelledBy,
              css: {
                "::before": {
                  content: '""',
                  position: "absolute",
                  height: "100%",
                  width: "100%",
                  pointerEvents: "auto",
                  opacity: 0,
                  ...hoverBufferStyles
                }
              },
              role: "tooltip",
              style: {
                ...style3,
                top: 0,
                left: 0,
                // If this is an animated widget then the control of visibility is up to the AnimatedWidget context
                ...!(isAnimatedWidget && shouldRunAnimation) && {
                  display: isOpen ? "block" : "none"
                },
                ...isAnimatedWidget && shouldRunAnimation && {
                  ...animStyles,
                  // When the state machine says that the nudge is open, respect the animation hook's opacity
                  opacity: isOpen ? animStyles.opacity : 0,
                  pointerEvents: isOpen ? "auto" : "none"
                },
                // Apply the transform at the end to keep the tooltip positioning and any animation transforms
                transform: `translate(${roundByDPR(x != null ? x : 0)}px, ${roundByDPR(y != null ? y : 0)}px) ${(_a2 = animStyles.transform) != null ? _a2 : ""}`
              },
              onMouseEnter: () => {
                send2("OPEN");
                onEnter();
              },
              onMouseLeave: () => {
                onExit(
                  () => {
                    send2("CLOSE");
                  },
                  { cancellable: true }
                );
              }
            },
            children
          )
        );
      }
    );
    ClickPopoverContent = ({
      children,
      style: style3,
      labelledBy,
      describedBy,
      shouldStealFocus = true,
      ...props2
    }) => {
      var _a2;
      const { send: send2 } = ClickMachineContext.useActorRef();
      const ref12 = ClickMachineContext.useSelector(({ context }) => context.content.ref);
      const isOpen = ClickMachineContext.useSelector(({ matches }) => matches("open"));
      const x = ClickMachineContext.useSelector(({ context }) => {
        var _a3;
        return (_a3 = context.content.position) == null ? void 0 : _a3.x;
      });
      const y = ClickMachineContext.useSelector(({ context }) => {
        var _a3;
        return (_a3 = context.content.position) == null ? void 0 : _a3.y;
      });
      const shouldRunAnimation = ClickMachineContext.useSelector(({ context }) => context.content.shouldRunAnimation);
      const { animStyles, isAnimatedWidget, onExit } = useAnimatedWidget();
      useFocusTrap(ref12, { shouldStealFocus: shouldStealFocus && isOpen });
      return (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        /* @__PURE__ */ jsx18(
          "div",
          {
            "data-testid": "popover-click-content" /* ClickContent */,
            ...props2,
            ref: ref12,
            "aria-describedby": describedBy,
            "aria-labelledby": labelledBy,
            "aria-modal": isOpen,
            role: "dialog",
            style: {
              ...style3,
              top: 0,
              left: 0,
              // If this is an animated widget then the control of visibility is up to the AnimatedWidget context
              ...!(isAnimatedWidget && shouldRunAnimation) && {
                display: isOpen ? "block" : "none"
              },
              ...isAnimatedWidget && shouldRunAnimation && {
                ...animStyles,
                // When the state machine says that the nudge is open, respect the animation hook's opacity
                opacity: isOpen ? animStyles.opacity : 0,
                pointerEvents: isOpen ? "auto" : "none"
              },
              // Apply the transform at the end to keep the tooltip positioning and any animation transforms
              transform: `translate(${roundByDPR(x != null ? x : 0)}px, ${roundByDPR(y != null ? y : 0)}px) ${(_a2 = animStyles.transform) != null ? _a2 : ""}`
            },
            tabIndex: -1,
            onKeyDown: (e) => {
              if (e.key === "Escape") {
                onExit(() => {
                  send2("CLOSE");
                });
              }
            }
          },
          children
        )
      );
    };
    PopoverContent = forwardRef5(
      ({ children, labelledBy, describedBy, portalToId, style: customStyles, ...props2 }, ref12) => {
        const { triggerType } = usePopoverContext();
        const ContentComponent = triggerType === "hover" ? HoverPopoverContent : ClickPopoverContent;
        const style3 = {
          position: "absolute",
          pointerEvents: "auto",
          zIndex: 0,
          ...customStyles
        };
        const Comp = /* @__PURE__ */ jsx18(ContentComponent, { describedBy, labelledBy, ...props2, ref: ref12, style: style3 }, children);
        if (portalToId) {
          const container = document.getElementById(portalToId);
          if (container) {
            return createPortal(Comp, container);
          }
        }
        return Comp;
      }
    );
    Close = ({ children, style: style3, ...props2 }) => {
      var _a2;
      const { send: send2 } = ClickMachineContext.useActorRef();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { onExit } = useAnimatedWidget();
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx18(StyledCloseButtonContainer_default, null, /* @__PURE__ */ jsx18(
        StyledTertiaryIconButton_default,
        {
          themeV2,
          "data-testid": "popover-close" /* Close */,
          "aria-label": "close",
          onClick: () => {
            onExit(
              () => {
                send2("CLOSE");
              },
              { cancellable: true }
            );
          }
        },
        children
      )) : /* @__PURE__ */ jsx18(
        "button",
        {
          "data-testid": "popover-close" /* Close */,
          ...props2,
          "aria-label": "close",
          style: {
            display: "flex",
            cursor: "pointer",
            pointerEvents: "auto",
            background: "none",
            border: "none",
            padding: 0,
            ...style3
          },
          type: "button",
          onClick: () => {
            send2("CLOSE");
          }
        },
        children
      );
    };
    PopoverClose = ({ children, ...props2 }) => {
      const { triggerType } = usePopoverContext();
      return triggerType === "click" ? /* @__PURE__ */ jsx18(Close, { ...props2 }, children) : null;
    };
    MeasuredPopover = ({ children }) => {
      const { triggerType } = usePopoverContext();
      const machine3 = triggerType === "hover" ? HoverMachineContext : ClickMachineContext;
      const triggerDimensions = machine3.useSelector(({ context }) => context.trigger.dimensions);
      return children(triggerDimensions);
    };
    Popover = forwardRef5(
      ({
        children,
        style: style3,
        forceOpen = false,
        defaultOpen: defaultOpen2 = false,
        placement = "bottom",
        offset: offset6 = 8,
        triggerType = "hover",
        autoPlacement: autoPlacement2 = true,
        flip: flip3 = false,
        ...props2
      }, forwardedRef) => /* @__PURE__ */ jsx18(
        PopoverContextProvider,
        {
          forceOpen,
          defaultOpen: defaultOpen2,
          offset: offset6,
          placement,
          triggerType,
          autoPlacement: autoPlacement2,
          flip: flip3
        },
        (actor, useSelector3) => /* @__PURE__ */ jsx18(MeasuredPopover, null, (triggerDimensions) => /* @__PURE__ */ jsx18(
          "div",
          {
            ref: forwardedRef,
            ...props2,
            style: {
              position: "relative",
              alignSelf: "center",
              zIndex: Z_default.Z_NUDGE - 2,
              opacity: triggerDimensions ? 1 : 0,
              top: placement === "top" ? -offset6 : 0,
              width: triggerDimensions == null ? void 0 : triggerDimensions.width,
              height: triggerDimensions == null ? void 0 : triggerDimensions.height,
              ...style3
            }
          },
          typeof children === "function" ? children(actor, useSelector3) : children
        ))
      )
    );
  }
});

// commandbar/src/products/nudges/components/CTAButton.tsx
import React125 from "react";
var CTATooltip;
var init_CTAButton = __esm({
  "commandbar/src/products/nudges/components/CTAButton.tsx"() {
    "use strict";
    init_popover();
    init_Z();
    init_AnimatedWidget();
    CTATooltip = ({ children, id: id2, message, style: style3, childrenStyle, useTooltip = true }) => {
      return useTooltip && message ? /* @__PURE__ */ React125.createElement(AnimatedWidget, { widget: "tooltip", keepMounted: true }, /* @__PURE__ */ React125.createElement(Popover, { autoPlacement: false, offset: 12, placement: "bottom", style: style3, flip: true }, /* @__PURE__ */ React125.createElement(PopoverTrigger, { asChild: true }, /* @__PURE__ */ React125.createElement(
        "div",
        {
          style: {
            cursor: "not-allowed",
            width: "100%",
            position: "relative",
            display: "flex"
          }
        },
        children
      )), /* @__PURE__ */ React125.createElement(
        PopoverContent,
        {
          labelledBy: `commandbar-disabled-cta-${id2}-tooltip`,
          describedBy: `commandbar-disabled-cta-${id2}-tooltip`,
          style: { width: "max-content", zIndex: Z_default.Z_INDEX_MAX },
          portalToId: "commandbar-rc-tooltip-container"
        },
        /* @__PURE__ */ React125.createElement(
          "div",
          {
            style: {
              display: "inline-flex",
              maxWidth: "260px",
              padding: "6px 12px",
              justifyContent: "center",
              alignItems: "center",
              gap: "8px",
              borderRadius: "6px",
              background: "#000",
              boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.16), 0px 1px 1px 0px rgba(0, 0, 0, 0.03)"
            }
          },
          /* @__PURE__ */ React125.createElement(
            "span",
            {
              id: `commandbar-disabled-cta-${id2}-tooltip`,
              style: {
                color: "#fff",
                fontFamily: "Inter",
                fontSize: "14px",
                fontStyle: "normal",
                fontWeight: 500,
                lineHeight: "140%"
              }
            },
            message
          )
        )
      ))) : /* @__PURE__ */ React125.createElement(
        "div",
        {
          style: {
            display: "flex",
            flex: "1 1 0",
            ...childrenStyle
          }
        },
        children
      );
    };
  }
});

// internal/src/client/themesV2/components/shared/StyledTextArea.tsx
import React126 from "react";
import { css as css13, jsx as jsx19 } from "@emotion/core";
var styles10, slug6, TextareaWithReset, StyledTextArea, StyledTextAreaMock, StyledTextArea_default;
var init_StyledTextArea = __esm({
  "internal/src/client/themesV2/components/shared/StyledTextArea.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useComponentOverrides();
    styles10 = {
      display: "flex",
      width: "100%",
      minHeight: "48px",
      padding: "var(--form-control-padding-x)",
      alignItems: "flex-start",
      gap: "var(--layout-gap)",
      color: "var(--content-primary)",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        color: "var(--content-primary)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-background)",
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:disabled": {
        borderColor: "var(--form-control-border-color-disabled)",
        background: "var(--form-control-background-disabled)",
        color: "var(--content-disabled)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&::placeholder": {
        color: "var(--content-secondary)"
      }
    };
    slug6 = "textarea";
    TextareaWithReset = styled_browser_esm_default.textarea`
  all: initial;
  box-sizing: border-box;
`;
    StyledTextArea = Object.assign(
      React126.forwardRef(
        ({ themeV2, ...props2 }, ref12) => {
          const { overrides } = useComponentOverrides_default(slug6, themeV2);
          return /* @__PURE__ */ jsx19(TextareaWithReset, { ref: ref12, css: [overrides, css13(styles10)], ...props2 });
        }
      ),
      {
        slug: slug6,
        styles: styles10,
        renderMock: (themeV2, mode) => /* @__PURE__ */ jsx19(StyledTextAreaMock, { themeV2, mode })
      }
    );
    StyledTextAreaMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug6, { themeV2, mode });
      return /* @__PURE__ */ jsx19(TextareaWithReset, { css: [overrides, css13(styles10)], style: { maxHeight: "400px" }, placeholder: "Text area" });
    };
    StyledTextArea_default = StyledTextArea;
  }
});

// internal/src/client/themesV2/components/nudge/StyledFormFieldBlock.tsx
import React127 from "react";
var FormFieldBlock, StyledFormFieldBlock, StyledFormFieldBlock_default;
var init_StyledFormFieldBlock = __esm({
  "internal/src/client/themesV2/components/nudge/StyledFormFieldBlock.tsx"() {
    "use strict";
    init_styled_browser_esm();
    FormFieldBlock = styled_browser_esm_default.div`
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--layout-gap);
  align-self: stretch;
  margin-top: calc(-1 * var(--form-control-focus-ring-width));
  padding: var(--form-control-focus-ring-width) var(--layout-padding) var(--layout-padding);
  max-height: 240px;
  overflow-y: auto;

  &:focus {
    box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
  }

  &:focus-visible {
    outline: none;
  }
`;
    StyledFormFieldBlock = ({ children }) => {
      return /* @__PURE__ */ React127.createElement(FormFieldBlock, null, children);
    };
    StyledFormFieldBlock_default = StyledFormFieldBlock;
  }
});

// commandbar/src/products/nudges/components/SurveyResponseProvider.tsx
import React128, { useState as useState14, useEffect as useEffect22, useRef as useRef20, useCallback as useCallback6, useContext as useContext5 } from "react";
var SurveyResponseContext, SurveyResponseProvider, useSurveyResponse;
var init_SurveyResponseProvider = __esm({
  "commandbar/src/products/nudges/components/SurveyResponseProvider.tsx"() {
    "use strict";
    init_AnimatedWidget();
    SurveyResponseContext = React128.createContext(void 0);
    SurveyResponseProvider = ({ step, service, children }) => {
      var _a2;
      const nudgeServiceSnapshot = (_a2 = service == null ? void 0 : service.getSnapshot()) == null ? void 0 : _a2.context;
      const { onExit } = useAnimatedWidget();
      const [surveyResponse2, _setSurveyResponse] = useState14(
        (nudgeServiceSnapshot == null ? void 0 : nudgeServiceSnapshot.surveyResponses[step.id]) || void 0
      );
      const advanceTimeoutId = useRef20(null);
      const setSurveyResponse = useCallback6(
        (response2) => {
          _setSurveyResponse(response2);
          if (!!response2 && response2 !== surveyResponse2 && (response2 == null ? void 0 : response2.type) !== "string" && !step.content.some((block) => (block == null ? void 0 : block.type) === "button")) {
            advanceTimeoutId.current = setTimeout(() => {
              onExit(() => {
                service == null ? void 0 : service.send({
                  type: "ADVANCE",
                  surveyResponse: response2
                });
              });
            }, 200);
          }
        },
        [service == null ? void 0 : service.id]
      );
      useEffect22(() => {
        return () => {
          if (advanceTimeoutId.current) {
            clearTimeout(advanceTimeoutId.current);
          }
        };
      }, []);
      return /* @__PURE__ */ React128.createElement(SurveyResponseContext.Provider, { value: { surveyResponse: surveyResponse2, setSurveyResponse } }, children);
    };
    useSurveyResponse = () => {
      const context = useContext5(SurveyResponseContext);
      if (!context) {
        throw new Error("useSurveyResponse must be used within a SurveyResponseProvider");
      }
      return context;
    };
  }
});

// commandbar/src/products/nudges/components/surveys/TextInputBlock.tsx
import { useTheme as useTheme4 } from "emotion-theming";
import { jsx as jsx20 } from "@emotion/core";
var TextInputBlock, TextInputBlock_default;
var init_TextInputBlock = __esm({
  "commandbar/src/products/nudges/components/surveys/TextInputBlock.tsx"() {
    "use strict";
    init_operatingSystem();
    init_useStore();
    init_StyledTextArea();
    init_StyledFormFieldBlock();
    init_ThemeV2Context();
    init_SurveyResponseProvider();
    TextInputBlock = ({ placeholder }) => {
      var _a2;
      const { theme } = useTheme4();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { surveyResponse: surveyResponse2, setSurveyResponse } = useSurveyResponse();
      const handleTextChange = (e) => {
        const value = e.target.value;
        setSurveyResponse({ type: "string", value });
      };
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx20(StyledFormFieldBlock_default, null, /* @__PURE__ */ jsx20(
        StyledTextArea_default,
        {
          themeV2,
          value: (surveyResponse2 == null ? void 0 : surveyResponse2.value) || "",
          onChange: handleTextChange,
          "aria-label": placeholder,
          placeholder,
          onClick: (e) => e.stopPropagation(),
          rows: 5
        }
      )) : /* @__PURE__ */ jsx20(
        "textarea",
        {
          value: (surveyResponse2 == null ? void 0 : surveyResponse2.value) || "",
          onChange: handleTextChange,
          "aria-label": placeholder,
          placeholder,
          onClick: (e) => e.stopPropagation(),
          rows: 5,
          style: {
            width: "100%",
            padding: theme.surveyTextInput.padding,
            margin: theme.surveyTextInput.margin,
            color: theme.surveyTextInput.color,
            fontFamily: theme.surveyTextInput.fontFamily,
            fontSize: isMobileDevice() ? "16px" : theme.surveyTextInput.fontSize,
            border: theme.surveyTextInput.border,
            borderRadius: theme.surveyTextInput.borderRadius,
            background: theme.surveyTextInput.background,
            boxShadow: theme.surveyTextInput.boxShadow,
            lineHeight: "16px",
            fontWeight: 400,
            resize: "none"
          },
          css: {
            "::placeholder": {
              color: "#A2A2A9"
            }
          }
        }
      );
    };
    TextInputBlock_default = TextInputBlock;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeRatingEmojis.tsx
import { css as css14, jsx as jsx21 } from "@emotion/core";
var RatingContainer, styles11, selectedStyles2, slug7, StyledNudgeRatingEmojis, StyledNudgeRatingEmojis_default;
var init_StyledNudgeRatingEmojis = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeRatingEmojis.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useComponentOverrides();
    init_ButtonWithReset();
    RatingContainer = styled_browser_esm_default.div`
  display: flex;
  align-items: flex-start;
  gap: var(--form-control-gap);
  align-self: stretch;
  user-select: none;
`;
    styles11 = {
      display: "flex",
      height: "var(--form-control-height)",
      width: "var(--form-control-width)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      cursor: "pointer",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    selectedStyles2 = {
      borderColor: "var(--base-accent)",
      background: "var(--form-control-active-background)",
      "&:hover": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      }
    };
    slug7 = "nudgeRatingEmojis";
    StyledNudgeRatingEmojis = ({ themeV2, numOptions, selected, onClick, emojis }) => {
      const { overrides } = useComponentOverrides_default(slug7, themeV2);
      return /* @__PURE__ */ jsx21(RatingContainer, null, [...Array(numOptions)].map((_, zeroBasedIndex) => {
        const oneBasedIndex = zeroBasedIndex + 1;
        return /* @__PURE__ */ jsx21(
          ButtonWithReset_default,
          {
            key: oneBasedIndex,
            "data-testid": "survey-option",
            css: [overrides, css14(styles11), selected(oneBasedIndex) && css14(selectedStyles2)].filter(Boolean),
            onClick: () => onClick(oneBasedIndex)
          },
          emojis.length > zeroBasedIndex ? emojis[zeroBasedIndex] : " "
        );
      }));
    };
    StyledNudgeRatingEmojis.slug = slug7;
    StyledNudgeRatingEmojis.styles = styles11;
    StyledNudgeRatingEmojis.activeStyles = selectedStyles2;
    StyledNudgeRatingEmojis.renderMock = (themeV2, mode, active, onClick) => /* @__PURE__ */ jsx21(
      StyledNudgeRatingEmojis,
      {
        themeV2: { themeV2, mode },
        numOptions: 1,
        emojis: ["\u{1F642}"],
        selected: () => !!active,
        onClick
      }
    );
    StyledNudgeRatingEmojis_default = StyledNudgeRatingEmojis;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeRatingStars.tsx
import { css as css15, jsx as jsx22 } from "@emotion/core";
var Star, RatingContainer2, styles12, selectedStyles3, StarContainer, StarSelectedContainer, slug8, StyledNudgeRatingStars, StyledNudgeRatingStars_default;
var init_StyledNudgeRatingStars = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeRatingStars.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledIconContainer();
    init_useComponentOverrides();
    init_ButtonWithReset();
    Star = () => /* @__PURE__ */ jsx22("svg", { xmlns: "http://www.w3.org/2000/svg", width: "25", height: "24", viewBox: "0 0 25 24", fill: "none" }, /* @__PURE__ */ jsx22(
      "path",
      {
        d: "M11.3452 3.4533C11.5756 2.98637 11.6909 2.7529 11.8473 2.6783C11.9834 2.6134 12.1416 2.6134 12.2777 2.6783C12.4342 2.7529 12.5494 2.98637 12.7799 3.4533L14.9666 7.88327C15.0346 8.02112 15.0686 8.09005 15.1183 8.14356C15.1624 8.19095 15.2152 8.22934 15.2738 8.25661C15.3401 8.28741 15.4161 8.29853 15.5682 8.32076L20.4595 9.03569C20.9746 9.11098 21.2321 9.14862 21.3513 9.27443C21.455 9.38388 21.5037 9.53428 21.484 9.68376C21.4613 9.85557 21.2749 10.0372 20.902 10.4004L17.3639 13.8464C17.2537 13.9538 17.1985 14.0075 17.1629 14.0715C17.1314 14.128 17.1112 14.1902 17.1034 14.2545C17.0946 14.3271 17.1076 14.403 17.1336 14.5547L17.9685 19.4221C18.0565 19.9355 18.1005 20.1922 18.0178 20.3445C17.9458 20.477 17.8179 20.57 17.6696 20.5975C17.4991 20.6291 17.2686 20.5078 16.8076 20.2654L12.4349 17.9658C12.2986 17.8942 12.2305 17.8583 12.1587 17.8443C12.0952 17.8318 12.0298 17.8318 11.9663 17.8443C11.8945 17.8583 11.8264 17.8942 11.6902 17.9658L7.31742 20.2654C6.85642 20.5078 6.62591 20.6291 6.45547 20.5975C6.30718 20.57 6.17922 20.477 6.10724 20.3445C6.0245 20.1922 6.06853 19.9355 6.15657 19.4221L6.99139 14.5547C7.01741 14.403 7.03043 14.3271 7.02162 14.2545C7.01382 14.1902 6.99361 14.128 6.96211 14.0715C6.92652 14.0075 6.87138 13.9538 6.76109 13.8464L3.22306 10.4004C2.85016 10.0372 2.66371 9.85557 2.64103 9.68376C2.62129 9.53428 2.67005 9.38388 2.77375 9.27443C2.89294 9.14862 3.15047 9.11098 3.66554 9.03569L8.55681 8.32076C8.70892 8.29853 8.78498 8.28741 8.85122 8.25661C8.90986 8.22934 8.96266 8.19095 9.00669 8.14356C9.05641 8.09005 9.09043 8.02112 9.15847 7.88327L11.3452 3.4533Z",
        stroke: "currentColor",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    ));
    RatingContainer2 = styled_browser_esm_default.div`
  display: flex;
  align-items: flex-start;
  gap: var(--form-control-gap);
  align-self: stretch;
  user-select: none;
`;
    styles12 = {
      display: "flex",
      height: "var(--form-control-height)",
      width: "var(--form-control-width)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      cursor: "pointer",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    selectedStyles3 = {
      borderColor: "var(--base-accent)",
      background: "var(--form-control-active-background)",
      "&:hover": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      },
      "& svg": {
        fill: "var(--nudge-rating-star-color-selected)"
      }
    };
    StarContainer = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--nudge-rating-star-color);

  &:hover {
    color: var(--nudge-rating-star-color);
  }
`;
    StarSelectedContainer = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--nudge-rating-star-color-selected);
`;
    slug8 = "nudgeRatingStars";
    StyledNudgeRatingStars = ({ themeV2, numOptions, selected, onClick }) => {
      const { overrides } = useComponentOverrides_default(slug8, themeV2);
      return /* @__PURE__ */ jsx22(RatingContainer2, null, [...Array(numOptions)].map((_, i2) => {
        const index3 = i2 + 1;
        const isSelected = selected(index3);
        const Container27 = isSelected ? StarSelectedContainer : StarContainer;
        return /* @__PURE__ */ jsx22(
          ButtonWithReset_default,
          {
            css: [overrides, css15(styles12), isSelected && css15(selectedStyles3)].filter(Boolean),
            key: index3,
            onClick: () => onClick(index3)
          },
          /* @__PURE__ */ jsx22(Container27, null, /* @__PURE__ */ jsx22(Star, null))
        );
      }));
    };
    StyledNudgeRatingStars.styles = styles12;
    StyledNudgeRatingStars.slug = slug8;
    StyledNudgeRatingStars.activeStyles = selectedStyles3;
    StyledNudgeRatingStars.renderMock = (themeV2, mode, active, onClick) => /* @__PURE__ */ jsx22(
      StyledNudgeRatingStars,
      {
        themeV2: { themeV2, mode },
        numOptions: 1,
        selected: () => !!active,
        onClick
      }
    );
    StyledNudgeRatingStars_default = StyledNudgeRatingStars;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeRatingNumbers.tsx
import { css as css16, jsx as jsx23 } from "@emotion/core";
var RatingContainer3, Number2, styles13, selectedStyles4, slug9, StyledNudgeRatingNumbers, StyledNudgeRatingNumbers_default;
var init_StyledNudgeRatingNumbers = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeRatingNumbers.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useComponentOverrides();
    init_ButtonWithReset();
    RatingContainer3 = styled_browser_esm_default.div`
  display: flex;
  align-items: flex-start;
  gap: var(--form-control-gap);
  align-self: stretch;
  user-select: none;
  @media (max-width: 400px) {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(0, 32%));
    gap: 4px;
  }
`;
    Number2 = styled_browser_esm_default.div`
  text-align: center;
`;
    styles13 = {
      display: "flex",
      height: "var(--form-control-height)",
      width: "var(--form-control-width)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      cursor: "pointer",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      color: "var(--content-primary)",
      "@media (max-width: 400px)": {
        padding: "auto"
      },
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    selectedStyles4 = {
      borderColor: "var(--base-accent)",
      background: "var(--form-control-active-background)",
      "&:hover": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      }
    };
    slug9 = "nudgeRatingNumbers";
    StyledNudgeRatingNumbers = ({ themeV2, numOptions, selected, onClick, isNPS }) => {
      const { overrides } = useComponentOverrides_default(slug9, themeV2);
      return /* @__PURE__ */ jsx23(RatingContainer3, null, [...Array(numOptions)].map((_, i2) => /* @__PURE__ */ jsx23(
        ButtonWithReset_default,
        {
          "data-testid": "survey-option",
          key: i2 + 1,
          css: [overrides, css16(styles13), selected(i2) && css16(selectedStyles4)].filter(Boolean),
          onClick: () => onClick(i2)
        },
        /* @__PURE__ */ jsx23(Number2, null, isNPS ? i2 : i2 + 1)
      )));
    };
    StyledNudgeRatingNumbers.styles = styles13;
    StyledNudgeRatingNumbers.slug = slug9;
    StyledNudgeRatingNumbers.activeStyles = selectedStyles4;
    StyledNudgeRatingNumbers.renderMock = (themeV2, mode, active, onClick) => /* @__PURE__ */ jsx23(
      StyledNudgeRatingNumbers,
      {
        themeV2: { themeV2, mode },
        numOptions: 1,
        selected: () => !!active,
        onClick
      }
    );
    StyledNudgeRatingNumbers_default = StyledNudgeRatingNumbers;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeRatingLabel.tsx
import React129 from "react";
var Label, StyledNudgeRatingLabel, StyledNudgeRatingLabel_default;
var init_StyledNudgeRatingLabel = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeRatingLabel.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Label = styled_browser_esm_default.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;

  color: var(--content-secondary);

  /* label/sm/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);
`;
    StyledNudgeRatingLabel = ({ left, right }) => {
      return /* @__PURE__ */ React129.createElement(Label, null, /* @__PURE__ */ React129.createElement("span", null, left), /* @__PURE__ */ React129.createElement("span", null, right));
    };
    StyledNudgeRatingLabel_default = StyledNudgeRatingLabel;
  }
});

// commandbar/src/products/nudges/components/surveys/RatingInputBlock.tsx
import { jsx as jsx24 } from "@emotion/core";
import { useState as useState15 } from "react";
import { useTheme as useTheme5 } from "emotion-theming";
var RatingInputBlock, RatingInputBlock_default;
var init_RatingInputBlock = __esm({
  "commandbar/src/products/nudges/components/surveys/RatingInputBlock.tsx"() {
    "use strict";
    init_react();
    init_operatingSystem();
    init_useStore();
    init_StyledNudgeRatingEmojis();
    init_StyledNudgeRatingStars();
    init_StyledNudgeRatingNumbers();
    init_StyledNudgeRatingLabel();
    init_StyledFormFieldBlock();
    init_ThemeV2Context();
    init_SurveyResponseProvider();
    RatingInputBlock = ({ ratingBlock }) => {
      var _a2, _b2;
      const { theme } = useTheme5();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { surveyResponse: surveyResponse2, setSurveyResponse } = useSurveyResponse();
      const [currentHovered, setcurrentHovered] = useState15(-1);
      const currentRating = (_a2 = Number(surveyResponse2 == null ? void 0 : surveyResponse2.value)) != null ? _a2 : -1;
      const inputAddition = (i2, hoverMarked, selectedMarked) => {
        switch (ratingBlock.type) {
          case "stars":
            return /* @__PURE__ */ jsx24(
              Star01_default,
              {
                width: 24,
                height: 24,
                color: hoverMarked || selectedMarked ? "#DD9E23" : void 0,
                css: {
                  opacity: hoverMarked || selectedMarked ? void 0 : 0.25
                }
              }
            );
          case "emojis":
            const zeroBasedIndex = i2 - 1;
            return /* @__PURE__ */ jsx24(
              "div",
              {
                style: {
                  lineHeight: "26px",
                  fontSize: hoverMarked || selectedMarked ? "26px" : "24px",
                  textShadow: hoverMarked || selectedMarked ? "0px 4px 7px rgba(0, 0, 0, 0.35)" : void 0,
                  transition: `all ${theme.main.transitionTime} ease-in-out`,
                  width: "26px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center"
                }
              },
              ratingBlock.emojis.length > zeroBasedIndex ? ratingBlock.emojis[zeroBasedIndex] : " "
            );
          case "numbers":
            return /* @__PURE__ */ jsx24(
              "span",
              {
                style: {
                  color: hoverMarked || selectedMarked ? "#000000" : theme.surveyRatingBox.color,
                  fontSize: "14px",
                  fontWeight: "600px"
                }
              },
              i2
            );
          case "nps":
            return /* @__PURE__ */ jsx24(
              "span",
              {
                style: {
                  color: hoverMarked || selectedMarked ? "#000000" : theme.surveyRatingBox.color,
                  fontSize: "14px",
                  fontWeight: "600px"
                }
              },
              i2
            );
        }
      };
      const setRating = (rating) => {
        if (rating === currentRating) {
          setSurveyResponse(void 0);
        } else {
          setSurveyResponse({
            type: ratingBlock.type === "nps" ? "nps" : "number",
            value: rating,
            max: ratingBlock.options,
            emoji: ratingBlock.type === "emojis" ? ratingBlock.emojis[rating - 1] : ratingBlock.type === "stars" ? "\u2B50" : void 0
          });
        }
      };
      return ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? /* @__PURE__ */ jsx24(StyledFormFieldBlock_default, null, ratingBlock.type === "emojis" ? /* @__PURE__ */ jsx24(
        StyledNudgeRatingEmojis_default,
        {
          themeV2,
          numOptions: ratingBlock.options,
          selected: (index3) => index3 === currentRating,
          onClick: (index3) => setRating(index3),
          emojis: ratingBlock.emojis
        }
      ) : ratingBlock.type === "stars" ? /* @__PURE__ */ jsx24(
        StyledNudgeRatingStars_default,
        {
          themeV2,
          numOptions: ratingBlock.options,
          selected: (index3) => index3 <= currentRating,
          onClick: (index3) => setRating(index3)
        }
      ) : ratingBlock.type === "nps" ? /* @__PURE__ */ jsx24(
        StyledNudgeRatingNumbers_default,
        {
          themeV2,
          numOptions: ratingBlock.options + 1,
          selected: (index3) => index3 === currentRating,
          onClick: (index3) => setRating(index3),
          isNPS: true
        }
      ) : /* @__PURE__ */ jsx24(
        StyledNudgeRatingNumbers_default,
        {
          themeV2,
          numOptions: ratingBlock.options,
          selected: (index3) => index3 === currentRating - 1,
          onClick: (index3) => setRating(index3 + 1)
        }
      ), /* @__PURE__ */ jsx24(StyledNudgeRatingLabel_default, { left: ratingBlock.lower_label, right: ratingBlock.upper_label })) : /* @__PURE__ */ jsx24(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0px",
            gap: "8px"
          }
        },
        /* @__PURE__ */ jsx24(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "flex-start",
              padding: "0px",
              gap: "8px",
              flex: "none",
              order: 0,
              flexGrow: 1,
              alignSelf: "stretch",
              flexWrap: isMobileDevice() ? "wrap" : "nowrap"
            }
          },
          [...Array(ratingBlock.type === "nps" ? ratingBlock.options + 1 : ratingBlock.options)].map((_2, i2) => {
            const index3 = ratingBlock.type === "nps" ? i2 : i2 + 1;
            const hoverMarked = ratingBlock.type === "stars" && index3 <= currentHovered || index3 === currentHovered;
            const selectedMarked = ratingBlock.type === "stars" && index3 <= currentRating || index3 === currentRating;
            return /* @__PURE__ */ jsx24(
              "button",
              {
                "data-testid": `rating-input-${index3}`,
                "aria-pressed": selectedMarked,
                "aria-label": `Rate ${i2 + 1} out of ${ratingBlock.options}`,
                onMouseEnter: () => setcurrentHovered(index3),
                onMouseLeave: () => setcurrentHovered(-1),
                onClick: () => setRating(index3),
                key: index3,
                style: {
                  cursor: "pointer",
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "8px",
                  gap: "6px",
                  height: "40px",
                  width: ratingBlock.type !== "emojis" ? "40px" : "auto",
                  background: hoverMarked || selectedMarked ? theme.surveyRatingBox.selectionBackGround : theme.surveyRatingBox.background,
                  border: hoverMarked || selectedMarked ? theme.surveyRatingBox.selectionBorder : theme.surveyRatingBox.border,
                  boxShadow: hoverMarked && !selectedMarked ? theme.surveyRatingBox.boxShadow : selectedMarked ? theme.surveyRatingBox.selectionBoxShadow : theme.surveyRatingBox.boxShadow,
                  borderRadius: theme.surveyRatingBox.borderRadius,
                  flex: "none",
                  order: 0,
                  flexGrow: 1
                }
              },
              inputAddition(index3, hoverMarked, selectedMarked)
            );
          })
        ),
        /* @__PURE__ */ jsx24(
          "div",
          {
            style: {
              display: ratingBlock.lower_label || ratingBlock.upper_label ? "flex" : "none",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "flex-start",
              padding: "0px",
              order: 1,
              flexGrow: 0,
              width: "100%"
            }
          },
          /* @__PURE__ */ jsx24(
            "span",
            {
              style: {
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "15px",
                color: " #A2A2A9"
              }
            },
            ratingBlock.lower_label
          ),
          /* @__PURE__ */ jsx24(
            "span",
            {
              style: {
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: "15px",
                color: " #A2A2A9"
              }
            },
            ratingBlock.upper_label
          )
        )
      );
    };
    RatingInputBlock_default = RatingInputBlock;
  }
});

// internal/src/client/themesV2/components/shared/StyledBaseInput.tsx
import React130 from "react";
import { css as css17, jsx as jsx25 } from "@emotion/core";
var styles14, slug10, InputWithReset, StyledBaseInput, StyledInputMock, StyledBaseInput_default;
var init_StyledBaseInput = __esm({
  "internal/src/client/themesV2/components/shared/StyledBaseInput.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useComponentOverrides();
    styles14 = {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "stretch",
      gap: "var(--layout-gap)",
      color: "var(--content-primary)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        borderColor: "var(--base-accent)",
        background: "var(--form-control-background)",
        outline: "none"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&::placeholder": {
        color: "var(--content-secondary)"
      }
    };
    slug10 = "input";
    InputWithReset = styled_browser_esm_default.input`
  all: unset;
  box-sizing: border-box;
`;
    StyledBaseInput = Object.assign(
      React130.forwardRef(
        ({ themeV2, ...props2 }, ref12) => {
          const { overrides } = useComponentOverrides_default(slug10, themeV2);
          return /* @__PURE__ */ jsx25(InputWithReset, { css: [overrides, css17(styles14)], ref: ref12, ...props2 });
        }
      ),
      {
        slug: slug10,
        styles: styles14,
        renderMock: (themeV2, mode) => /* @__PURE__ */ jsx25(StyledInputMock, { themeV2, mode })
      }
    );
    StyledInputMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug10, { themeV2, mode });
      return /* @__PURE__ */ jsx25(InputWithReset, { css: [overrides, css17(styles14)], placeholder: "Input" });
    };
    StyledBaseInput_default = StyledBaseInput;
  }
});

// commandbar/src/products/nudges/components/surveys/TextInputShortBlock.tsx
import { useTheme as useTheme6 } from "emotion-theming";
import { jsx as jsx26 } from "@emotion/core";
var TextInputShortBlock, TextInputShortBlock_default;
var init_TextInputShortBlock = __esm({
  "commandbar/src/products/nudges/components/surveys/TextInputShortBlock.tsx"() {
    "use strict";
    init_operatingSystem();
    init_useStore();
    init_StyledFormFieldBlock();
    init_StyledBaseInput();
    init_ThemeV2Context();
    init_SurveyResponseProvider();
    TextInputShortBlock = ({ placeholder }) => {
      var _a2;
      const { theme } = useTheme6();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { surveyResponse: surveyResponse2, setSurveyResponse } = useSurveyResponse();
      const handleTextChange = (e) => {
        const value = e.target.value;
        setSurveyResponse({ type: "string", value });
      };
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx26(StyledFormFieldBlock_default, null, /* @__PURE__ */ jsx26(
        StyledBaseInput_default,
        {
          themeV2,
          value: (surveyResponse2 == null ? void 0 : surveyResponse2.value) || "",
          onChange: handleTextChange,
          "aria-label": placeholder,
          placeholder,
          onClick: (e) => e.stopPropagation()
        }
      )) : /* @__PURE__ */ jsx26(
        "input",
        {
          value: (surveyResponse2 == null ? void 0 : surveyResponse2.value) || "",
          onChange: handleTextChange,
          "aria-label": placeholder,
          placeholder,
          onClick: (e) => e.stopPropagation(),
          style: {
            width: "100%",
            padding: theme.surveyTextInputShort.padding,
            margin: theme.surveyTextInputShort.margin,
            color: theme.surveyTextInputShort.color,
            fontFamily: theme.surveyTextInputShort.fontFamily,
            fontSize: isMobileDevice() ? "16px" : theme.surveyTextInputShort.fontSize,
            border: theme.surveyTextInputShort.border,
            borderRadius: theme.surveyTextInputShort.borderRadius,
            background: theme.surveyTextInputShort.background,
            boxShadow: theme.surveyTextInputShort.boxShadow,
            lineHeight: "16px",
            fontWeight: 400,
            resize: "none"
          },
          css: {
            "::placeholder": {
              color: "#A2A2A9"
            }
          }
        }
      );
    };
    TextInputShortBlock_default = TextInputShortBlock;
  }
});

// commandbar/src/products/nudges/components/surveys/Checkbox.tsx
import { jsx as jsx27, css as css18 } from "@emotion/core";
import { useTheme as useTheme7 } from "emotion-theming";
var checkboxStyle, Checkbox, Checkbox_default;
var init_Checkbox = __esm({
  "commandbar/src/products/nudges/components/surveys/Checkbox.tsx"() {
    "use strict";
    init_react();
    checkboxStyle = css18`
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:checked + span {
    border: 1px solid #000;
    background-color: #fff;
  }

  &:checked + span::after {
    content: '';
    position: absolute;
    font-size: 14px;
    font-weight: bold;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #000;
  }
`;
    Checkbox = ({ checked }) => {
      const { theme } = useTheme7();
      return /* @__PURE__ */ jsx27(
        "div",
        {
          style: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          }
        },
        /* @__PURE__ */ jsx27("input", { type: "checkbox", css: checkboxStyle, checked, readOnly: true }),
        /* @__PURE__ */ jsx27(
          "span",
          {
            style: {
              position: "relative",
              width: "16px",
              height: "16px",
              backgroundColor: theme.nudgeOptionListCheckbox.backgroundColor,
              border: checked ? theme.nudgeOptionListCheckbox.borderSelected : theme.nudgeOptionListCheckbox.border,
              borderRadius: "6px",
              display: "flex"
            }
          },
          checked && /* @__PURE__ */ jsx27(Check_default, { color: theme.nudgeOptionListCheckbox.check })
        )
      );
    };
    Checkbox_default = Checkbox;
  }
});

// commandbar/src/products/nudges/components/surveys/Radio.tsx
import { jsx as jsx28, css as css19 } from "@emotion/core";
import { useTheme as useTheme8 } from "emotion-theming";
var radioStyle, Radio, Radio_default;
var init_Radio = __esm({
  "commandbar/src/products/nudges/components/surveys/Radio.tsx"() {
    "use strict";
    radioStyle = css19`
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
`;
    Radio = ({ checked }) => {
      const { theme } = useTheme8();
      const afterStyle = (theme2) => css19`
    position: relative;
    width: 16px;
    height: 16px;
    background: ${theme2.nudgeOptionListRadio.backgroundColor};
    border: ${theme2.nudgeOptionListRadio.border};
    border-radius: 50%;

    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      width: 5px;
      height: 5px;
      background: ${theme2.nudgeOptionListRadio.check};
      border-radius: 50%;
      transform: translate(-50%, -50%);
      display: ${checked ? "block" : "none"};
    }
  `;
      return /* @__PURE__ */ jsx28(
        "div",
        {
          style: {
            position: "relative",
            display: "flex",
            alignItems: "center"
          }
        },
        /* @__PURE__ */ jsx28("input", { type: "radio", css: { ...radioStyle }, checked, readOnly: true }),
        /* @__PURE__ */ jsx28(
          "span",
          {
            css: afterStyle(theme),
            style: {
              border: checked ? theme.nudgeOptionListRadio.borderSelected : theme.nudgeOptionListRadio.border
            }
          }
        )
      );
    };
    Radio_default = Radio;
  }
});

// internal/src/client/themesV2/components/shared/StyledCheckboxIcon.tsx
import React131 from "react";
var Checkbox2, SelectedCheckbox, Checkmark, StyledCheckboxIcon, StyledCheckboxIcon_default;
var init_StyledCheckboxIcon = __esm({
  "internal/src/client/themesV2/components/shared/StyledCheckboxIcon.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    Checkbox2 = styled_browser_esm_default.div`
  display: flex;
  width: 16px;
  height: 16px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  border-radius: var(--layout-radius-button);
  border: 1px solid var(--form-control-border-color);
  background: var(--form-control-background);

  &:hover {
    border: 1px solid var(--form-control-border-color-hover);
  }
`;
    SelectedCheckbox = styled_browser_esm_default(Checkbox2)`
  background: var(--button-primary-background);
  border: 1px solid var(--button-primary-background);

  &:hover {
    border: 1px solid var(--button-primary-background);
  }
`;
    Checkmark = styled_browser_esm_default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--layout-padding);
  height: var(--layout-padding);
  color: var(--base-white);
`;
    StyledCheckboxIcon = ({ selected }) => {
      return selected ? /* @__PURE__ */ React131.createElement(SelectedCheckbox, null, /* @__PURE__ */ React131.createElement(Checkmark, null, /* @__PURE__ */ React131.createElement(Check_default, null))) : /* @__PURE__ */ React131.createElement(Checkbox2, null);
    };
    StyledCheckboxIcon_default = StyledCheckboxIcon;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeCheckboxOption.tsx
import { css as css20, jsx as jsx29 } from "@emotion/core";
var checkboxFormStyles, checkboxFormSelectedStyles, slug11, StyledNudgeCheckboxOption, StyledNudgeCheckboxOption_default;
var init_StyledNudgeCheckboxOption = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeCheckboxOption.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_StyledCheckboxIcon();
    init_ButtonWithReset();
    checkboxFormStyles = {
      display: "flex",
      width: "100%",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      flexShrink: 0,
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      color: "var(--content-primary)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        borderColor: "var(--form-control-border-color)",
        background: "var(--form-control-background)",
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    checkboxFormSelectedStyles = {
      borderColor: "var(--base-accent)",
      background: "var(--form-control-active-background)",
      fill: "var(--button-primary-background)",
      "&:hover": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      },
      "&:focus": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      }
    };
    slug11 = "checkboxOption";
    StyledNudgeCheckboxOption = ({
      themeV2,
      selected,
      onClick,
      children
    }) => {
      const { overrides } = useComponentOverrides_default(slug11, themeV2);
      return /* @__PURE__ */ jsx29(
        ButtonWithReset_default,
        {
          "data-testid": "survey-option",
          css: [overrides, css20(checkboxFormStyles), selected && css20(checkboxFormSelectedStyles)].filter(Boolean),
          onClick
        },
        /* @__PURE__ */ jsx29(StyledCheckboxIcon_default, { selected }),
        children
      );
    };
    StyledNudgeCheckboxOption.slug = slug11;
    StyledNudgeCheckboxOption.styles = checkboxFormStyles;
    StyledNudgeCheckboxOption.activeStyles = checkboxFormSelectedStyles;
    StyledNudgeCheckboxOption.renderMock = (themeV2, mode, active, onClick) => /* @__PURE__ */ jsx29(StyledNudgeCheckboxOption, { themeV2: { themeV2, mode }, selected: !!active, onClick }, "Checkbox option");
    StyledNudgeCheckboxOption_default = StyledNudgeCheckboxOption;
  }
});

// internal/src/client/themesV2/components/shared/StyledRadioIcon.tsx
import React132 from "react";
var Circle, Radio2, SelectedRadio, CircleContainer, StyledCheckboxIcon2, StyledRadioIcon_default;
var init_StyledRadioIcon = __esm({
  "internal/src/client/themesV2/components/shared/StyledRadioIcon.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledIconContainer();
    Circle = () => /* @__PURE__ */ React132.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "6", height: "6", viewBox: "0 0 6 6", fill: "none" }, /* @__PURE__ */ React132.createElement("circle", { cx: "3", cy: "3", r: "2.5", fill: "white" }));
    Radio2 = styled_browser_esm_default.div`
  display: flex;
  width: 16px;
  height: 16px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;

  border-radius: 1000px;
  border: 1px solid var(--form-control-border-color);
  background: var(--form-control-background);

  &:hover {
    border: 1px solid var(--form-control-border-color-hover);
  }
`;
    SelectedRadio = styled_browser_esm_default(Radio2)`
  background: var(--button-primary-background);
  border: 1px solid var(--button-primary-background);

  &:hover {
    border: 1px solid var(--button-primary-background);
  }
`;
    CircleContainer = styled_browser_esm_default(StyledIconContainer_default)`
  width: var(--layout-padding);
  height: var(--layout-padding);
  color: var(--base-white);
`;
    StyledCheckboxIcon2 = ({ selected }) => {
      return selected ? /* @__PURE__ */ React132.createElement(SelectedRadio, null, /* @__PURE__ */ React132.createElement(CircleContainer, null, /* @__PURE__ */ React132.createElement(Circle, null))) : /* @__PURE__ */ React132.createElement(Radio2, null);
    };
    StyledRadioIcon_default = StyledCheckboxIcon2;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeRadioOption.tsx
import { css as css21, jsx as jsx30 } from "@emotion/core";
var radioFormStyles, radioFormSelectedStyles, slug12, StyledNudgeRadioOption, StyledNudgeRadioOption_default;
var init_StyledNudgeRadioOption = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeRadioOption.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_StyledRadioIcon();
    init_ButtonWithReset();
    radioFormStyles = {
      display: "flex",
      width: "100%",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      flexShrink: 0,
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      color: "var(--content-primary)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)",
        background: "var(--form-control-background-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        borderColor: "var(--form-control-border-color)",
        background: "var(--form-control-background)",
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    radioFormSelectedStyles = {
      borderColor: "var(--base-accent)",
      background: "var(--form-control-active-background)",
      fill: "var(--button-primary-background)",
      "&:hover": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      },
      "&:focus": {
        borderColor: "var(--base-accent)",
        background: "var(--form-control-active-background)"
      }
    };
    slug12 = "radioOption";
    StyledNudgeRadioOption = ({
      themeV2,
      selected,
      onClick,
      children
    }) => {
      const { overrides } = useComponentOverrides_default(slug12, themeV2);
      return /* @__PURE__ */ jsx30(
        ButtonWithReset_default,
        {
          "data-testid": "survey-option",
          css: [overrides, css21(radioFormStyles), selected && css21(radioFormSelectedStyles)].filter(Boolean),
          onClick
        },
        /* @__PURE__ */ jsx30(StyledRadioIcon_default, { selected }),
        children
      );
    };
    StyledNudgeRadioOption.slug = slug12;
    StyledNudgeRadioOption.styles = radioFormStyles;
    StyledNudgeRadioOption.activeStyles = radioFormSelectedStyles;
    StyledNudgeRadioOption.renderMock = (themeV2, mode, active, onClick) => /* @__PURE__ */ jsx30(StyledNudgeRadioOption, { themeV2: { themeV2, mode }, selected: !!active, onClick }, "Radio option");
    StyledNudgeRadioOption_default = StyledNudgeRadioOption;
  }
});

// commandbar/src/products/nudges/components/surveys/ListBlock.tsx
import { jsx as jsx31 } from "@emotion/core";
import { useCallback as useCallback7 } from "react";
var ListBlock, ListBlock_default;
var init_ListBlock = __esm({
  "commandbar/src/products/nudges/components/surveys/ListBlock.tsx"() {
    "use strict";
    init_useTheme();
    init_Checkbox();
    init_Radio();
    init_useStore();
    init_StyledNudgeCheckboxOption();
    init_StyledNudgeRadioOption();
    init_StyledFormFieldBlock();
    init_ThemeV2Context();
    init_SurveyResponseProvider();
    ListBlock = ({ isMultiSelect, options }) => {
      var _a2;
      const { theme } = useTheme();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { surveyResponse: surveyResponse2, setSurveyResponse } = useSurveyResponse();
      const values = surveyResponse2 && Array.isArray(surveyResponse2.value) ? surveyResponse2.value : surveyResponse2 && surveyResponse2.value ? [surveyResponse2.value] : [];
      const handleClick = useCallback7(
        (value) => {
          if (isMultiSelect) {
            const alreadySelected = values.includes(value);
            const updatedValues = alreadySelected ? values.filter((item) => item !== value) : [...values, value];
            setSurveyResponse(updatedValues.length > 0 ? { type: "string", value: updatedValues } : void 0);
          } else {
            setSurveyResponse({ type: "string", value });
          }
        },
        [isMultiSelect, values, setSurveyResponse]
      );
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx31(StyledFormFieldBlock_default, null, isMultiSelect ? options.map((option) => /* @__PURE__ */ jsx31(
        StyledNudgeCheckboxOption_default,
        {
          themeV2,
          key: option,
          selected: values.includes(option),
          onClick: () => handleClick(option)
        },
        option
      )) : options.map((option) => /* @__PURE__ */ jsx31(
        StyledNudgeRadioOption_default,
        {
          themeV2,
          key: option,
          selected: values.includes(option),
          onClick: () => handleClick(option)
        },
        option
      ))) : /* @__PURE__ */ jsx31(
        "ul",
        {
          style: {
            maxHeight: "240px",
            overflowY: "auto",
            gap: "12px",
            display: "flex",
            flexDirection: "column",
            listStyle: "none",
            padding: "0",
            margin: "0"
          }
        },
        options.map((option) => /* @__PURE__ */ jsx31("li", { key: option }, /* @__PURE__ */ jsx31(
          "button",
          {
            role: isMultiSelect ? "checkbox" : "radio",
            "aria-checked": values.includes(option),
            style: {
              textAlign: "left",
              display: "flex",
              width: "100%",
              minHeight: "40px",
              height: "auto",
              padding: "8px 16px",
              alignItems: "center",
              gap: "8px",
              fontWeight: "600",
              fontSize: "16px",
              borderRadius: "4px",
              border: values.includes(option) ? theme.nudgeOptionList.selectionBorder : theme.nudgeOptionList.border,
              color: values.includes(option) ? theme.nudgeOptionList.selectionColor : theme.nudgeOptionList.color,
              background: values.includes(option) ? theme.nudgeOptionList.selectionBackground : theme.nudgeOptionList.background,
              cursor: "pointer",
              boxShadow: values.includes(option) ? theme.nudgeOptionList.selectionBoxShadow : theme.nudgeOptionList.boxShadow
            },
            onClick: () => handleClick(option)
          },
          isMultiSelect ? /* @__PURE__ */ jsx31(Checkbox_default, { checked: values.includes(option) }) : /* @__PURE__ */ jsx31(Radio_default, { checked: values.includes(option) }),
          option
        )))
      );
    };
    ListBlock_default = ListBlock;
  }
});

// commandbar/src/shared/img/caret.svg
import * as React134 from "react";
var SvgCaret;
var init_caret = __esm({
  "commandbar/src/shared/img/caret.svg"() {
    "use strict";
    SvgCaret = (props2) => /* @__PURE__ */ React134.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 6, height: 4, viewBox: "0 0 6 4", fill: "none", ...props2 }, /* @__PURE__ */ React134.createElement("path", { d: "M0.0435861 0.330208L2.84234 3.92287C2.92245 4.02571 3.0767 4.02571 3.15766 3.92287L5.95641 0.330208C6.06039 0.196238 5.96664 -2.81327e-09 5.79875 -1.69719e-08L0.20125 -4.89021e-07C0.0333594 -5.03179e-07 -0.0603868 0.196238 0.0435861 0.330208Z", fill: "#7A7A85" }));
  }
});

// internal/src/client/themesV2/components/shared/StyledSelect.tsx
import React135 from "react";
import { css as css22, jsx as jsx32 } from "@emotion/core";
var styles15, Container5, CaretContainer, slug13, SelectWithReset, OptionWithReset, StyledSelect, StyledSelectMock, StyledSelect_default;
var init_StyledSelect = __esm({
  "internal/src/client/themesV2/components/shared/StyledSelect.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_StyledIconContainer();
    init_useComponentOverrides();
    styles15 = {
      appearance: "none",
      display: "flex",
      height: "var(--form-control-height)",
      padding: "0px var(--form-control-padding-x)",
      justifyContent: "space-between",
      alignItems: "center",
      flex: "1 0 0",
      alignSelf: "stretch",
      cursor: "pointer",
      userSelect: "none",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--form-control-border-color)",
      background: "var(--form-control-background)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      color: "var(--content-primary)",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        background: "var(--form-control-background-hover)",
        borderColor: "var(--form-control-border-color-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)"
      },
      "&:focus": {
        borderColor: "var(--base-accent)",
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        background: "var(--form-control-background-hover)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    Container5 = styled_browser_esm_default.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
`;
    CaretContainer = styled_browser_esm_default(StyledIconContainer_default)`
  position: absolute;
  right: var(--form-control-padding-x);
  color: var(--content-secondary);
`;
    slug13 = "select";
    SelectWithReset = styled_browser_esm_default.select`
  all: unset;
  box-sizing: border-box;
`;
    OptionWithReset = styled_browser_esm_default.option`
  all: unset;
  box-sizing: border-box;
`;
    StyledSelect = Object.assign(
      React135.forwardRef(
        ({ themeV2, children, ...props2 }, ref12) => {
          const { overrides } = useComponentOverrides_default(slug13, themeV2);
          return /* @__PURE__ */ jsx32(Container5, { css: overrides }, /* @__PURE__ */ jsx32(SelectWithReset, { css: [overrides, css22(styles15)], ref: ref12, ...props2 }, children), /* @__PURE__ */ jsx32(CaretContainer, null, /* @__PURE__ */ jsx32(ChevronDown_default, null)));
        }
      ),
      {
        slug: slug13,
        styles: styles15,
        renderMock: (themeV2, mode) => /* @__PURE__ */ jsx32(StyledSelectMock, { themeV2, mode })
      }
    );
    StyledSelectMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug13, { themeV2, mode });
      return /* @__PURE__ */ jsx32(Container5, { css: overrides }, /* @__PURE__ */ jsx32(SelectWithReset, { css: [overrides, css22(styles15)] }, /* @__PURE__ */ jsx32(OptionWithReset, { key: "select" }, "Select option...")), /* @__PURE__ */ jsx32(CaretContainer, null, /* @__PURE__ */ jsx32(ChevronDown_default, null)));
    };
    StyledSelect_default = StyledSelect;
  }
});

// commandbar/src/products/nudges/components/surveys/ListDropdownBlock.tsx
import { jsx as jsx33 } from "@emotion/core";
import React136, { forwardRef as forwardRef6, useEffect as useEffect23, useRef as useRef21, useState as useState16 } from "react";
var DropdownMenu, useDropdownPosition, ListDropdownBlock;
var init_ListDropdownBlock = __esm({
  "commandbar/src/products/nudges/components/surveys/ListDropdownBlock.tsx"() {
    "use strict";
    init_caret();
    init_useTheme();
    init_Z();
    init_useStore();
    init_StyledFormFieldBlock();
    init_StyledSelect();
    init_ThemeV2Context();
    init_SurveyResponseProvider();
    DropdownMenu = forwardRef6(({ activeOption, style: style3, children }, dropdownRef) => {
      const { theme } = useTheme();
      const firstOptionRef = useRef21(null);
      useEffect23(() => {
        const originalActiveElement = document.activeElement;
        if (firstOptionRef.current)
          firstOptionRef.current.focus();
        return () => {
          if (originalActiveElement instanceof HTMLElement)
            originalActiveElement.focus();
        };
      }, []);
      return /* @__PURE__ */ jsx33(
        "ul",
        {
          ref: dropdownRef,
          tabIndex: -1,
          role: "listbox",
          "aria-activedescendant": activeOption,
          style: {
            display: "flex",
            position: "absolute",
            padding: "4px",
            flexDirection: "column",
            alignItems: "flex-start",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: "500",
            fontSize: "16px",
            maxHeight: "200px",
            overflowY: "auto",
            width: "calc(100% - 30px)",
            zIndex: Z_default.Z_INDEX_MAX,
            boxShadow: theme.nudgeOptionListDropdownOption.boxShadow,
            border: theme.nudgeOptionListDropdownOption.border,
            background: theme.nudgeOptionListDropdownOption.background,
            color: theme.nudgeOptionListDropdownOption.color,
            ...style3
          }
        },
        children(firstOptionRef)
      );
    });
    useDropdownPosition = (buttonRef, dropdownRef, isDropdownOpen) => {
      const [dropdownPosition, setDropdownPosition] = useState16("bottom");
      useEffect23(() => {
        const buttonElement = buttonRef.current;
        const dropdownElement = dropdownRef.current;
        if (!(isDropdownOpen && buttonElement && dropdownElement))
          return;
        const buttonRect = buttonElement.getBoundingClientRect();
        const dropdownHeight = dropdownElement.offsetHeight;
        const spaceBelow = window.innerHeight - (buttonRect == null ? void 0 : buttonRect.bottom);
        setDropdownPosition(spaceBelow < dropdownHeight ? "top" : "bottom");
      }, [buttonRef, dropdownRef, isDropdownOpen]);
      return dropdownPosition;
    };
    ListDropdownBlock = ({ options }) => {
      var _a2;
      const { theme } = useTheme();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { surveyResponse: surveyResponse2, setSurveyResponse } = useSurveyResponse();
      const [isDropdownOpen, setIsDropdownOpen] = React136.useState(false);
      const selectRef = useRef21(null);
      const buttonRef = useRef21(null);
      const dropdownRef = useRef21(null);
      const selectedOption = typeof (surveyResponse2 == null ? void 0 : surveyResponse2.value) === "string" && options.includes(surveyResponse2.value) ? surveyResponse2.value : "";
      const toggleDropdown = () => {
        setIsDropdownOpen((prev) => !prev);
      };
      const dropdownPosition = useDropdownPosition(buttonRef, dropdownRef, isDropdownOpen);
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx33(StyledFormFieldBlock_default, null, /* @__PURE__ */ jsx33(
        StyledSelect_default,
        {
          onChange: (e) => setSurveyResponse({ type: "string", value: e.target.value }),
          value: selectedOption,
          themeV2,
          ref: selectRef
        },
        /* @__PURE__ */ jsx33("option", { value: "" }, "Select..."),
        options.map((option) => /* @__PURE__ */ jsx33(OptionWithReset, { value: option }, option))
      )) : /* @__PURE__ */ jsx33(React136.Fragment, null, /* @__PURE__ */ jsx33(
        "button",
        {
          type: "button",
          ref: buttonRef,
          onClick: toggleDropdown,
          "aria-haspopup": "listbox",
          "aria-expanded": isDropdownOpen,
          style: {
            display: "flex",
            height: "40px",
            padding: "8px 12px",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "4px",
            fontWeight: "500",
            fontSize: "16px",
            width: "100%",
            ...theme.nudgeOptionListDropdown
          }
        },
        selectedOption || "Select option...",
        /* @__PURE__ */ jsx33(SvgCaret, null)
      ), isDropdownOpen && /* @__PURE__ */ jsx33(
        DropdownMenu,
        {
          ref: dropdownRef,
          activeOption: selectedOption,
          style: {
            marginTop: dropdownPosition === "top" ? void 0 : "8px",
            bottom: dropdownPosition === "top" ? "104px" : void 0,
            top: dropdownPosition === "bottom" ? "88px" : void 0,
            color: theme.nudgeOptionListDropdownOption.color
          }
        },
        (firstOptionRef) => options.map((option, index3) => /* @__PURE__ */ jsx33(
          "li",
          {
            ref: index3 === 0 ? firstOptionRef : null,
            id: option,
            role: "option",
            "aria-selected": selectedOption === option,
            key: option,
            tabIndex: 0,
            onClick: () => {
              setSurveyResponse({ type: "string", value: option });
              toggleDropdown();
            },
            onKeyDown: (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                setSurveyResponse({ type: "string", value: option });
                toggleDropdown();
              }
            },
            css: {
              display: "flex",
              height: "40px",
              padding: "8px",
              alignItems: "center",
              gap: "8px",
              width: "100%",
              "&:hover": {
                background: theme.nudgeOptionListDropdownOption.backgroundHover
              }
            }
          },
          option
        ))
      ));
    };
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeImage.tsx
import React137 from "react";
var ImageContainer, TopBlockImageContainer, FullHeightImageContainer, Image2, Placeholder3, TopBlockPlaceholder, FullHeightPlaceholder, components, StyledNudgeImage, StyledNudgeImage_default;
var init_StyledNudgeImage = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeImage.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    ImageContainer = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px var(--layout-padding) var(--layout-padding) var(--layout-padding);
`;
    TopBlockImageContainer = styled_browser_esm_default(ImageContainer)`
  padding: 0;
  border-radius: var(--layout-radius-card) var(--layout-radius-card) 0 0;
  overflow: hidden;
`;
    FullHeightImageContainer = styled_browser_esm_default(ImageContainer)`
  height: 100%;
  padding: 0;
  border-radius: 0 var(--layout-radius-card) var(--layout-radius-card) 0;
  overflow: hidden;
`;
    Image2 = styled_browser_esm_default.img`
  all: unset;

  box-sizing: border-box;
  height: 100%;
  width: 100%;
`;
    Placeholder3 = styled_browser_esm_default.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #f7f4ff 0%, #d5caff 100%);
`;
    TopBlockPlaceholder = styled_browser_esm_default(Placeholder3)`
  border-radius: var(--layout-radius-card) var(--layout-radius-card) 0 0;
`;
    FullHeightPlaceholder = styled_browser_esm_default(Placeholder3)`
  overflow: hidden;
  border-radius: 0 var(--layout-radius-card) var(--layout-radius-card) 0;
`;
    components = {
      "top-block": { Container: TopBlockImageContainer, PlaceholderContainer: TopBlockPlaceholder },
      "full-height": { Container: FullHeightImageContainer, PlaceholderContainer: FullHeightPlaceholder },
      default: { Container: ImageContainer, PlaceholderContainer: Placeholder3 }
    };
    StyledNudgeImage = ({
      type: type39,
      src,
      file_name,
      variant = "default"
    }) => {
      const { Container: Container27, PlaceholderContainer } = components[variant];
      const getPlaceholderContainerHeight = () => {
        if (variant === "full-height") {
          return "100%";
        }
        if (type39 === "modal") {
          return "220px";
        }
        return "168px";
      };
      return src ? /* @__PURE__ */ React137.createElement(Container27, null, /* @__PURE__ */ React137.createElement(Image2, { "data-testid": "commandbar-nudge-image", src, alt: file_name })) : /* @__PURE__ */ React137.createElement(Container27, null, /* @__PURE__ */ React137.createElement(
        PlaceholderContainer,
        {
          "data-testid": "commandbar-nudge-image-placeholder",
          style: { height: getPlaceholderContainerHeight() }
        },
        /* @__PURE__ */ React137.createElement(Image01_default, { width: "24px", height: "24px" })
      ));
    };
    StyledNudgeImage_default = StyledNudgeImage;
  }
});

// internal/src/client/themesV2/components/shared/StyledHelpDocCard.tsx
import { css as css23, jsx as jsx34 } from "@emotion/core";
import React138 from "react";
var getFeaturedCardStyles, loadingStyles, FeaturedTitle, FeaturedIconContainer, FeaturedIcon, slug14, StyledHelpDocCard, StyledHelpDocCardMock, StyledHelpDocCard_default;
var init_StyledHelpDocCard = __esm({
  "internal/src/client/themesV2/components/shared/StyledHelpDocCard.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useComponentOverrides();
    init_ButtonWithReset();
    init_StyledIconContainer();
    init_react();
    getFeaturedCardStyles = (backgroundImage) => ({
      position: "relative",
      display: "flex",
      height: "100%",
      padding: "0px 16px",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "flex-start",
      textAlign: "left",
      flex: "1 0 0",
      maxWidth: "calc(50% - var(--layout-gap) / 2)",
      cursor: "pointer",
      borderRadius: "var(--layout-radius-button)",
      border: "1px solid var(--button-primary-border-color)",
      background: "var(--button-primary-background)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      overflow: "hidden",
      ...backgroundImage ? {
        backgroundImage: `url('${encodeURI(backgroundImage)}')`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center"
      } : {},
      "&:hover": {
        ...!backgroundImage ? {
          background: "var(--button-primary-background-hover)"
        } : {},
        border: "1px solid var(--button-primary-border-color-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
        "--button-primary-content": "var(--button-primary-content-hover)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    });
    loadingStyles = {
      background: "linear-gradient(89deg, #d9d9d9 13.8%, #c9c9c9 30.92%, #d9d9d9 48.56%)"
    };
    FeaturedTitle = styled_browser_esm_default.div`
  color: var(--button-primary-content);

  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;

  /* label/xl/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-extra-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-tight);
`;
    FeaturedIconContainer = styled_browser_esm_default.div`
  display: flex;
  width: 32px;
  height: 32px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  position: absolute;
  right: 12px;
  bottom: 12px;

  border-radius: 100px;
  background: var(--base-black);
`;
    FeaturedIcon = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--base-white);
`;
    slug14 = "contentGridItem";
    StyledHelpDocCard = Object.assign(
      React138.forwardRef(
        ({ children, type: type39, label, loading, backgroundImage, icon, themeV2, style: style3, ...props2 }, ref12) => {
          const { overrides } = useComponentOverrides_default(slug14, themeV2);
          return /* @__PURE__ */ jsx34(
            ButtonWithReset_default,
            {
              css: [overrides, css23(getFeaturedCardStyles(backgroundImage)), loading && css23(loadingStyles)].filter(Boolean),
              ref: ref12,
              style: style3,
              ...props2
            },
            !loading && /* @__PURE__ */ jsx34(FeaturedTitle, null, label),
            /* @__PURE__ */ jsx34(FeaturedIconContainer, null, /* @__PURE__ */ jsx34(FeaturedIcon, null, icon))
          );
        }
      ),
      {
        slug: slug14,
        styles: getFeaturedCardStyles(),
        renderMock: (themeV2, mode) => /* @__PURE__ */ jsx34(StyledHelpDocCardMock, { themeV2, mode })
      }
    );
    StyledHelpDocCardMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug14, { themeV2, mode });
      return /* @__PURE__ */ jsx34(
        ButtonWithReset_default,
        {
          style: { height: "150px", maxWidth: "150px" },
          css: [overrides, css23(getFeaturedCardStyles())].filter(Boolean)
        },
        /* @__PURE__ */ jsx34(FeaturedTitle, null, "Grid item title"),
        /* @__PURE__ */ jsx34(FeaturedIconContainer, null, /* @__PURE__ */ jsx34(FeaturedIcon, null, /* @__PURE__ */ jsx34(BookOpen01_default, null)))
      );
    };
    StyledHelpDocCard_default = StyledHelpDocCard;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeDocument.tsx
import React139 from "react";
var StyledDocumentContainer, TopBlockDocumentContainer, FullHeightDocumentContainer, StyledPlaceholder, TopBlockPlaceholder2, FullHeightPlaceholder2, components2, StyledNudgeDocument, StyledNudgeDocument_default;
var init_StyledNudgeDocument = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeDocument.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_ThemeV2Context();
    init_react();
    init_Icon();
    init_StyledHelpDocCard();
    StyledDocumentContainer = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0px var(--layout-padding) var(--layout-padding) var(--layout-padding);
`;
    TopBlockDocumentContainer = styled_browser_esm_default(StyledDocumentContainer)`
  padding: 0px;
`;
    FullHeightDocumentContainer = styled_browser_esm_default(StyledDocumentContainer)`
  padding: 0px;
`;
    StyledPlaceholder = styled_browser_esm_default.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(180deg, #f7f4ff 0%, #d5caff 100%);
  border-radius: var(--layout-radius-card);
`;
    TopBlockPlaceholder2 = styled_browser_esm_default(StyledPlaceholder)`
  border-radius: var(--layout-radius-card) var(--layout-radius-card) 0 0;
`;
    FullHeightPlaceholder2 = styled_browser_esm_default(StyledPlaceholder)`
  border-radius: 0 var(--layout-radius-card) var(--layout-radius-card) 0;
`;
    components2 = {
      "top-block": {
        DocumentContainer: TopBlockDocumentContainer,
        Placeholder: TopBlockPlaceholder2
      },
      "full-height": {
        DocumentContainer: FullHeightDocumentContainer,
        Placeholder: FullHeightPlaceholder2
      },
      default: {
        DocumentContainer: StyledDocumentContainer,
        Placeholder: StyledPlaceholder
      }
    };
    StyledNudgeDocument = ({
      type: type39,
      document: document2,
      onClick,
      variant = "default"
    }) => {
      var _a2;
      const { DocumentContainer, Placeholder: Placeholder4 } = components2[variant];
      const themeV2 = useThemeV2Context();
      const getContainerHeight = () => {
        if (variant === "full-height") {
          return "100%";
        }
        if (type39 === "modal") {
          return "220px";
        }
        return "168px";
      };
      const DocumentIcon = (document2 == null ? void 0 : document2.icon) ? /* @__PURE__ */ React139.createElement(
        Icon_default,
        {
          icon: document2.icon,
          style: {
            ...(document2 == null ? void 0 : document2.icon_color) && { color: document2.icon_color },
            // reset featured icon color to white if it is currently black
            ...document2.icon_color === "#000000" && { color: "var(--base-white)" }
          }
        }
      ) : /* @__PURE__ */ React139.createElement(BookOpen01_default, null);
      return (document2 == null ? void 0 : document2.is_live) ? /* @__PURE__ */ React139.createElement(DocumentContainer, { style: { height: getContainerHeight() }, "data-testid": "commandbar-nudge-help-doc" }, /* @__PURE__ */ React139.createElement(
        StyledHelpDocCard_default,
        {
          type: "helpdoc",
          icon: DocumentIcon,
          backgroundImage: (_a2 = document2.thumbnail) == null ? void 0 : _a2.src,
          label: document2.thumbnail ? "" : document2.text,
          themeV2,
          onClick,
          loading: false,
          style: { maxWidth: "unset" }
        }
      )) : /* @__PURE__ */ React139.createElement(DocumentContainer, { style: { height: getContainerHeight() } }, /* @__PURE__ */ React139.createElement(Placeholder4, { "data-testid": "commandbar-nudge-document-placeholder" }, /* @__PURE__ */ React139.createElement(BookOpen02_default, { width: "24px", height: "24px" })));
    };
    StyledNudgeDocument_default = StyledNudgeDocument;
  }
});

// commandbar/src/products/nudges/components/Content.tsx
import React140, { useEffect as useEffect24 } from "react";
import { css as css24, jsx as jsx35 } from "@emotion/core";
var getStyles, EyeButton, getVariantFromLayout, Content3, Content_default2;
var init_Content2 = __esm({
  "commandbar/src/products/nudges/components/Content.tsx"() {
    "use strict";
    init_useStore();
    init_global_selectors();
    init_VideoContainer();
    init_react();
    init_TextInputBlock();
    init_RatingInputBlock();
    init_helpdocService();
    init_TextInputShortBlock();
    init_ListBlock();
    init_selectors5();
    init_ListDropdownBlock();
    init_StyledNudgeTitleBlock();
    init_StyledNudgeImage();
    init_StyledNudgeVideo();
    init_StyledNudgeDocument();
    init_players();
    init_useMobileExperience();
    init_SurveyResponseProvider();
    getStyles = () => ({
      image: { width: "100%", borderRadius: "4px", pointerEvents: "none" },
      helpDoc: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: 0,
        gap: "8px",
        height: "175px",
        borderRadius: "4px"
      },
      helpDocPreview: {
        position: "relative",
        width: "100%",
        height: "175px",
        padding: "16px 16px 0",
        borderRadius: "4px",
        cursor: "pointer",
        pointerEvents: "all",
        overflow: "hidden"
      },
      helpDocTitle: {
        fontWeight: 600,
        fontSize: "32px",
        lineHeight: "39px"
      },
      ctaWithStepCount: {
        display: "inline-flex",
        width: "auto",
        maxWidth: "50%"
      }
    });
    EyeButton = ({
      background,
      foreground
    }) => /* @__PURE__ */ jsx35(
      "svg",
      {
        style: {
          position: "absolute",
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          margin: "auto"
        },
        xmlns: "http://www.w3.org/2000/svg",
        width: "88",
        height: "88",
        fill: "none",
        viewBox: "0 0 88 80"
      },
      /* @__PURE__ */ jsx35("g", { filter: "url(#filter0_d_437_3698)" }, /* @__PURE__ */ jsx35("rect", { width: "56", height: "56", x: "16", y: "12", fill: background, rx: "28" }), /* @__PURE__ */ jsx35("path", { fill: foreground, d: "M44 42.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" }), /* @__PURE__ */ jsx35(
        "path",
        {
          fill: foreground,
          fillRule: "evenodd",
          d: "M35.103 39.54a9.38 9.38 0 0117.794-.007c.1.302.1.627 0 .928a9.38 9.38 0 01-17.794.006c-.1-.301-.1-.627 0-.928zm13.272.46a4.375 4.375 0 11-8.75 0 4.375 4.375 0 018.75 0z",
          clipRule: "evenodd"
        }
      )),
      /* @__PURE__ */ jsx35("defs", null, /* @__PURE__ */ jsx35(
        "filter",
        {
          id: "filter0_d_437_3698",
          width: "88",
          height: "88",
          x: "0",
          y: "0",
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse"
        },
        /* @__PURE__ */ jsx35("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
        /* @__PURE__ */ jsx35(
          "feColorMatrix",
          {
            in: "SourceAlpha",
            result: "hardAlpha",
            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          }
        ),
        /* @__PURE__ */ jsx35("feOffset", { dy: "4" }),
        /* @__PURE__ */ jsx35("feGaussianBlur", { stdDeviation: "8" }),
        /* @__PURE__ */ jsx35("feComposite", { in2: "hardAlpha", operator: "out" }),
        /* @__PURE__ */ jsx35("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
        /* @__PURE__ */ jsx35("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_437_3698" }),
        /* @__PURE__ */ jsx35("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_437_3698", result: "shape" })
      ))
    );
    getVariantFromLayout = (layout) => {
      switch (layout) {
        case "vertical":
          return "top-block";
        case "horizontal":
          return "full-height";
        case "classic":
        default:
          return "default";
      }
    };
    Content3 = ({
      type: type39,
      contentBlock,
      markdownStyles,
      buttonStyles,
      service,
      helpDocStyles,
      styleOverrides,
      step,
      handleContentLinkClick
    }) => {
      var _a2, _b2, _c2, _d, _e, _f, _g;
      const _ = useStore();
      const styles51 = getStyles();
      const nudgeServiceSnapshot = (_a2 = service == null ? void 0 : service.getSnapshot()) == null ? void 0 : _a2.context;
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const { setSurveyResponse } = useSurveyResponse();
      const commandId = (contentBlock == null ? void 0 : contentBlock.meta) && "command" in contentBlock.meta ? contentBlock.meta.command : void 0;
      const orgId = (_b2 = _.organization) == null ? void 0 : _b2.id;
      useEffect24(() => {
        setSurveyResponse((nudgeServiceSnapshot == null ? void 0 : nudgeServiceSnapshot.surveyResponses[step.id]) || void 0);
      }, [setSurveyResponse, contentBlock.meta, step.id]);
      const onHelpDocClick = React140.useCallback(() => {
        service == null ? void 0 : service.send({
          type: "ADVANCE",
          button_type: "help_doc",
          action: determineAction(_, step, {
            button_type: "help_doc"
          })
        });
      }, [service]);
      const [command, setCommand] = React140.useState(void 0);
      React140.useEffect(() => {
        setCommand(void 0);
        if (commandId === void 0)
          return;
        const commandFromEngine = getCommandById(_, commandId);
        if (commandFromEngine) {
          setCommand(commandFromEngine);
          return;
        }
        let canceled = false;
        (async () => {
          if (!orgId)
            return;
          const command2 = await helpdocService_default.getHelpdocCommand(_, commandId);
          if (canceled)
            return;
          if (command2)
            setCommand(command2);
        })();
        return () => {
          canceled = true;
        };
      }, [orgId, commandId]);
      switch (contentBlock == null ? void 0 : contentBlock.type) {
        case "markdown": {
          if (!!contentBlock.meta.value && !((_c2 = _.flags) == null ? void 0 : _c2["release-themes-v2"])) {
            return /* @__PURE__ */ jsx35(React140.Fragment, null, /* @__PURE__ */ jsx35(
              "div",
              {
                css: css24`
                ol,
                ul,
                li {
                  all: revert;
                }

                ol,
                ul {
                  padding-left: 32px;
                  margin-bottom: 8px;
                }

                img {
                  max-width: 100%;
                }

                p {
                  margin-bottom: 8px;
                }

                p:last-child {
                  margin-bottom: 0;
                }

                pre {
                  overflow: auto;
                }
              `,
                style: markdownStyles,
                dangerouslySetInnerHTML: { __html: parseMarkdown(contentBlock.meta.value) },
                onClick: handleContentLinkClick
              }
            ));
          }
          return null;
        }
        case "image": {
          const placeholderHeight = (() => {
            if (type39 === "popover") {
              return "168px";
            }
            if (type39 === "pin") {
              return "168px";
            }
            if (type39 === "modal") {
              return "192px";
            }
          })();
          return ((_d = _.flags) == null ? void 0 : _d["release-themes-v2"]) ? /* @__PURE__ */ jsx35(
            StyledNudgeImage_default,
            {
              type: type39,
              src: contentBlock.meta.src,
              file_name: contentBlock.meta.file_name,
              variant: getVariantFromLayout(isMobileDevice2 ? "classic" : step.form_factor.layout)
            }
          ) : contentBlock.meta.src ? /* @__PURE__ */ jsx35(
            "img",
            {
              "data-testid": "commandbar-nudge-image",
              src: contentBlock.meta.src,
              alt: contentBlock.meta.file_name,
              style: { ...styles51.image, ...styleOverrides }
            }
          ) : /* @__PURE__ */ jsx35(
            "div",
            {
              "data-testid": "commandbar-nudge-image-placeholder-v1",
              style: {
                height: placeholderHeight,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#DFDFE2",
                border: "1px solid #DFDFE2",
                borderRadius: "4px"
              }
            },
            /* @__PURE__ */ jsx35(
              Image01_default,
              {
                width: 48,
                height: 48,
                css: {
                  path: {
                    strokeWidth: 1
                  }
                }
              }
            )
          );
        }
        case "video": {
          if ((_e = _.flags) == null ? void 0 : _e["release-themes-v2"]) {
            const src = contentBlock.meta.type === "command" && (command == null ? void 0 : command.template.type) === "video" ? command.template.value : contentBlock.meta.type === "url" ? contentBlock.meta.src : "";
            return /* @__PURE__ */ jsx35(
              StyledNudgeVideo_default,
              {
                type: type39,
                src,
                getPlayer: players_default,
                testMode: _.testMode,
                variant: getVariantFromLayout(isMobileDevice2 ? "classic" : step.form_factor.layout)
              }
            );
          }
          const placeholder = /* @__PURE__ */ jsx35(
            "div",
            {
              "data-testid": "commandbar-nudge-video-placeholder",
              style: {
                height: type39 === "modal" ? "207px" : "150px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "8px",
                background: "#DFDFE2",
                border: "1px solid #DFDFE2",
                borderRadius: "4px"
              }
            },
            /* @__PURE__ */ jsx35(
              VideoRecorder_default,
              {
                width: 48,
                height: 48,
                css: {
                  path: {
                    strokeWidth: 1
                  }
                }
              }
            )
          );
          if (contentBlock.meta.type === "command") {
            if ((command == null ? void 0 : command.template.type) === "video") {
              return /* @__PURE__ */ jsx35(
                VideoContainer_default,
                {
                  source: command.template.value,
                  containerStyles: { height: "auto", marginTop: "8px", padding: 0 },
                  autoPlay: false
                }
              );
            }
            return placeholder;
          }
          if (contentBlock.meta.type === "url") {
            return contentBlock.meta.src.length > 0 ? /* @__PURE__ */ jsx35(
              VideoContainer_default,
              {
                source: contentBlock.meta.src,
                containerStyles: { height: "auto", marginTop: "8px", padding: 0 },
                autoPlay: false
              }
            ) : placeholder;
          }
          return null;
        }
        case "help_doc_command": {
          if ((_f = _.flags) == null ? void 0 : _f["release-themes-v2"]) {
            return /* @__PURE__ */ jsx35(
              StyledNudgeDocument_default,
              {
                type: type39,
                document: command,
                onClick: onHelpDocClick,
                variant: getVariantFromLayout(isMobileDevice2 ? "classic" : step.form_factor.layout)
              }
            );
          }
          if (command && command.is_live) {
            return /* @__PURE__ */ jsx35(
              "button",
              {
                type: "button",
                "data-testid": "commandbar-nudge-help-doc",
                style: {
                  // unstyle button
                  textAlign: "left",
                  background: "none",
                  border: "none",
                  padding: 0,
                  ...styles51.helpDoc,
                  ...styleOverrides
                },
                onClick: onHelpDocClick
              },
              !!(command == null ? void 0 : command.thumbnail) ? /* @__PURE__ */ jsx35(
                "div",
                {
                  style: {
                    ...styles51.helpDocPreview,
                    padding: 0,
                    overflow: "hidden",
                    width: "100%",
                    backgroundImage: ((_g = command == null ? void 0 : command.thumbnail) == null ? void 0 : _g.src) ? `url(${command.thumbnail.src})` : "",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center"
                  }
                }
              ) : /* @__PURE__ */ jsx35(
                "div",
                {
                  style: {
                    ...styles51.helpDocPreview,
                    background: helpDocStyles == null ? void 0 : helpDocStyles.background
                  }
                },
                /* @__PURE__ */ jsx35(
                  "span",
                  {
                    className: "commandbar-help-doc-title",
                    style: {
                      ...styles51.helpDocTitle,
                      color: helpDocStyles == null ? void 0 : helpDocStyles.color,
                      mixBlendMode: helpDocStyles == null ? void 0 : helpDocStyles.mixBlendMode
                    }
                  },
                  command == null ? void 0 : command.text
                ),
                /* @__PURE__ */ jsx35(EyeButton, { background: buttonStyles.backgroundColor, foreground: buttonStyles.color })
              )
            );
          }
          return /* @__PURE__ */ jsx35(
            "div",
            {
              style: {
                height: styles51.helpDoc.height,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: "#DFDFE2",
                border: "1px solid #DFDFE2",
                borderRadius: "4px"
              }
            },
            /* @__PURE__ */ jsx35(
              BookOpen02_default,
              {
                width: 48,
                height: 48,
                css: {
                  path: {
                    strokeWidth: 1
                  }
                }
              }
            )
          );
        }
        case "survey_text": {
          return /* @__PURE__ */ jsx35(TextInputBlock_default, { placeholder: contentBlock.meta.prompt });
        }
        case "survey_text_short": {
          return /* @__PURE__ */ jsx35(TextInputShortBlock_default, { placeholder: contentBlock.meta.prompt });
        }
        case "survey_rating": {
          return /* @__PURE__ */ jsx35(React140.Fragment, null, /* @__PURE__ */ jsx35(RatingInputBlock_default, { ratingBlock: contentBlock.meta }));
        }
        case "survey_list": {
          if (contentBlock.meta.display_type === "dropdown") {
            return /* @__PURE__ */ jsx35(ListDropdownBlock, { options: contentBlock.meta.options });
          }
          return /* @__PURE__ */ jsx35(ListBlock_default, { options: contentBlock.meta.options, isMultiSelect: contentBlock.meta.list_type === "multiple" });
        }
        default:
          return null;
      }
    };
    Content_default2 = Content3;
  }
});

// commandbar/src/products/nudges/components/hooks.tsx
import { useCallback as useCallback8 } from "react";
var useExecNudgeAction;
var init_hooks = __esm({
  "commandbar/src/products/nudges/components/hooks.tsx"() {
    "use strict";
    init_useStore();
    init_RenderNudge();
    init_SurveyResponseProvider();
    init_AnimatedWidget();
    useExecNudgeAction = ({ stepId, renderMode, service, onMockAction }) => {
      const _ = useStore();
      const { surveyResponse: surveyResponse2, setSurveyResponse } = useSurveyResponse();
      const { onExit } = useAnimatedWidget();
      const exec = useCallback8(
        (action, meta) => {
          if (renderMode === 1 /* MOCK */ && _.extension.recorder.enabled) {
            onMockAction == null ? void 0 : onMockAction(meta);
            return;
          }
          switch (action == null ? void 0 : action.type) {
            case "step_back": {
              service == null ? void 0 : service.send({
                type: "REGRESS",
                action
              });
              break;
            }
            case "dismiss": {
              service == null ? void 0 : service.send({
                type: "FINISH",
                action,
                surveyResponse: surveyResponse2
              });
              break;
            }
            case "snooze": {
              service == null ? void 0 : service.send({
                type: "SNOOZE",
                action
              });
              break;
            }
            default: {
              service == null ? void 0 : service.send({
                type: "ADVANCE",
                button_type: meta == null ? void 0 : meta.button_type,
                cta: meta == null ? void 0 : meta.label,
                surveyResponse: surveyResponse2,
                action,
                ...(action == null ? void 0 : action.type) === "go_to_step" && { step: action.value }
              });
              break;
            }
          }
          setSurveyResponse(void 0);
        },
        [service, stepId, surveyResponse2]
      );
      return (action, meta) => {
        onExit(() => exec(action, meta));
      };
    };
  }
});

// commandbar/src/products/nudges/components/ContentContainer.tsx
import { jsx as jsx36 } from "@emotion/core";
import React141 from "react";
var ContentBlockSortKeys, CTAWithTooltip, ContentContainer, ContentContainer_default;
var init_ContentContainer = __esm({
  "commandbar/src/products/nudges/components/ContentContainer.tsx"() {
    "use strict";
    init_useTheme();
    init_types2();
    init_sentry();
    init_useStore();
    init_selectors5();
    init_CTAButton();
    init_Content2();
    init_hooks();
    init_SurveyResponseProvider();
    ContentBlockSortKeys = /* @__PURE__ */ ((ContentBlockSortKeys2) => {
      ContentBlockSortKeys2[ContentBlockSortKeys2["markdown"] = 1] = "markdown";
      ContentBlockSortKeys2[ContentBlockSortKeys2["image"] = 2] = "image";
      ContentBlockSortKeys2[ContentBlockSortKeys2["video"] = 3] = "video";
      ContentBlockSortKeys2[ContentBlockSortKeys2["survey_text"] = 4] = "survey_text";
      ContentBlockSortKeys2[ContentBlockSortKeys2["survey_rating"] = 5] = "survey_rating";
      ContentBlockSortKeys2[ContentBlockSortKeys2["survey_list"] = 6] = "survey_list";
      ContentBlockSortKeys2[ContentBlockSortKeys2["survey_text_short"] = 7] = "survey_text_short";
      ContentBlockSortKeys2[ContentBlockSortKeys2["help_doc_command"] = 8] = "help_doc_command";
      ContentBlockSortKeys2[ContentBlockSortKeys2["button"] = 9] = "button";
      return ContentBlockSortKeys2;
    })(ContentBlockSortKeys || {});
    CTAWithTooltip = ({ id: id2, block, step, children, style: style3, childrenStyle }) => {
      var _a2, _b2, _c2, _d, _e, _f;
      const _ = useStore();
      const { surveyResponse: surveyResponse2 } = useSurveyResponse();
      const action = determineAction(_, step, {
        button_type: (_a2 = block.meta) == null ? void 0 : _a2.button_type,
        surveyResponse: surveyResponse2
      });
      const willGoBack = (action == null ? void 0 : action.type) === "step_back";
      const willSnooze = ((_b2 = block.meta) == null ? void 0 : _b2.button_type) === "snooze" || (action == null ? void 0 : action.type) === "snooze";
      const surveyBlock = step.content.find(isSurveyBlock);
      const isSurveyResponseRequired = !!((_d = (_c2 = surveyBlock == null ? void 0 : surveyBlock.meta.validation) == null ? void 0 : _c2.required) == null ? void 0 : _d.value);
      const hasIncompleteSurveyBlock = !!surveyBlock && !(surveyResponse2 == null ? void 0 : surveyResponse2.value);
      const isDisabled = isSurveyResponseRequired && hasIncompleteSurveyBlock && !willGoBack && !willSnooze;
      const message = (_f = (_e = surveyBlock == null ? void 0 : surveyBlock.meta.validation) == null ? void 0 : _e.required) == null ? void 0 : _f.message;
      const disabledStyles = {
        ...message ? (
          // we are showing a tooltip so we'll let the tooltip trigger handle on hover events
          { pointerEvents: "none" }
        ) : (
          // we are not showing a tooltip, but the button is still disabled
          { cursor: "not-allowed" }
        )
      };
      return /* @__PURE__ */ jsx36(
        CTATooltip,
        {
          id: id2,
          useTooltip: isDisabled,
          message: message != null ? message : void 0,
          style: style3,
          childrenStyle
        },
        children(action, isDisabled, disabledStyles)
      );
    };
    ContentContainer = ({
      service,
      styleOverrides,
      step,
      stepIndex,
      markdownStyles,
      primaryButtonStyles,
      secondaryButtonStyles,
      snoozeButtonStyles,
      stepCountStyles,
      stepCount,
      snoozable,
      snoozable_on_all_steps,
      snoozeLabel,
      renderMode,
      onMockAction,
      handleContentLinkClick
    }) => {
      var _a2, _b2, _c2;
      const _ = useStore();
      const { theme } = useTheme();
      const execNudgeAction = useExecNudgeAction({
        stepId: step.id,
        renderMode,
        service,
        onMockAction
      });
      const lastBlock = step.content[step.content.length - 1];
      const ctas = step.content.filter((block) => block.type === "button").sort((_a3, b) => {
        var _a4;
        return b.type === "button" && ((_a4 = b.meta) == null ? void 0 : _a4.button_type) === "secondary" ? 1 : -1;
      });
      let contentItems = step.content;
      if (ctas.length) {
        contentItems = step.content.filter((block) => block.type !== "button");
      }
      if (snoozable && (snoozable_on_all_steps || stepIndex === 0)) {
        ctas.unshift({
          type: "button",
          sort_key: -1,
          meta: {
            button_type: "snooze",
            label: snoozeLabel,
            action: {
              type: "snooze"
            }
          }
        });
      }
      try {
        contentItems = contentItems.sort((a, b) => ContentBlockSortKeys[a.type] > ContentBlockSortKeys[b.type] ? 1 : -1);
      } catch (e) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
      }
      return /* @__PURE__ */ jsx36(React141.Fragment, null, contentItems.map((block, idx) => /* @__PURE__ */ jsx36(
        Content_default2,
        {
          key: idx,
          type: step.form_factor.type,
          contentBlock: block,
          service,
          helpDocStyles: {
            color: theme.nudgeModal.helpDocPreviewColor,
            background: theme.nudgeModal.helpDocPreviewBackground,
            mixBlendMode: theme.nudgeModal.helpDocPreviewMixBlendMode
          },
          buttonStyles: primaryButtonStyles,
          styleOverrides,
          markdownStyles,
          step,
          handleContentLinkClick
        }
      )), ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? null : ctas.length ? (
        // INFO: Actions are rendered separately from the ContentContainer in themes_v2
        /* @__PURE__ */ jsx36("div", { style: { display: "flex", alignItems: "center", justifyContent: "space-between" } }, stepCount && /* @__PURE__ */ jsx36("div", { "data-testid": "commandbar-nudge-step-counter", style: stepCountStyles }, stepCount), /* @__PURE__ */ jsx36(
          "div",
          {
            style: {
              display: "flex",
              gap: "8px",
              justifyContent: stepCount || ctas.length === 1 ? "flex-end" : "center",
              width: stepCount ? "calc(100% - 36px)" : "100%",
              alignItems: "center",
              ...stepCount && {
                display: "inline-flex"
              }
            }
          },
          ctas.map((block, idx) => {
            var _a3;
            if ((_a3 = block == null ? void 0 : block.meta) == null ? void 0 : _a3.label) {
              const buttonTypeStyles = {
                primary: primaryButtonStyles,
                secondary: secondaryButtonStyles,
                snooze: snoozeButtonStyles
              };
              return /* @__PURE__ */ jsx36(
                CTAWithTooltip,
                {
                  key: idx,
                  id: idx,
                  block,
                  step,
                  style: {
                    top: 0,
                    height: "auto",
                    border: "none",
                    flex: stepCount ? void 0 : "1 1 0",
                    ...stepCount ? { width: "auto" } : { width: "100%" },
                    maxWidth: `calc(100% / ${ctas.length} - 8px *  ${ctas.length - 1} / ${ctas.length})`
                  },
                  childrenStyle: {
                    maxWidth: `calc(100% / ${ctas.length} - 8px *  ${ctas.length - 1} / ${ctas.length})`,
                    flex: stepCount ? void 0 : "1 1 0"
                  }
                },
                (action, isDisabled, disabledStyles) => {
                  var _a4, _b3, _c3;
                  return /* @__PURE__ */ jsx36(
                    "button",
                    {
                      type: "button",
                      style: {
                        width: "100%",
                        border: "none",
                        cursor: "pointer",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        ...buttonTypeStyles[(_b3 = (_a4 = block.meta) == null ? void 0 : _a4.button_type) != null ? _b3 : "primary"],
                        ...isDisabled && disabledStyles
                      },
                      disabled: isDisabled,
                      onClick: () => {
                        execNudgeAction(action, block.meta);
                      }
                    },
                    /* @__PURE__ */ jsx36(
                      "span",
                      {
                        style: {
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }
                      },
                      (_c3 = block.meta) == null ? void 0 : _c3.label
                    )
                  );
                }
              );
            }
            return null;
          })
        ))
      ) : !((lastBlock == null ? void 0 : lastBlock.type) === "button" && ((_c2 = lastBlock.meta) == null ? void 0 : _c2.label)) && stepCount && !ctas.length && /* @__PURE__ */ jsx36("div", { style: { display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "8px" } }, /* @__PURE__ */ jsx36("div", { style: stepCountStyles }, stepCount)));
    };
    ContentContainer_default = ContentContainer;
  }
});

// commandbar/src/shared/util/hooks/useMask.tsx
import React142, { useState as useState17, useEffect as useEffect25 } from "react";
var currentElement, updateMaskContainer, showMask, hideMask, Mask2, MaskContainer;
var init_useMask = __esm({
  "commandbar/src/shared/util/hooks/useMask.tsx"() {
    "use strict";
    init_Z();
    init_useTheme();
    init_AnimatedWidget();
    currentElement = null;
    updateMaskContainer = null;
    showMask = (targetEl) => {
      currentElement = targetEl;
      updateMaskContainer == null ? void 0 : updateMaskContainer();
    };
    hideMask = () => {
      currentElement = null;
      updateMaskContainer == null ? void 0 : updateMaskContainer();
    };
    Mask2 = ({ element }) => {
      const { theme } = useTheme();
      const { animStyles } = useAnimatedWidget();
      const [targetElRect, setTargetElRect] = useState17(void 0);
      const updateRect = () => {
        setTargetElRect(element == null ? void 0 : element.getBoundingClientRect());
      };
      useEffect25(() => {
        if (element) {
          updateRect();
          window.addEventListener("scroll", updateRect);
          window.addEventListener("resize", updateRect);
        }
        return () => {
          window.removeEventListener("scroll", updateRect);
          window.removeEventListener("resize", updateRect);
        };
      }, [element]);
      const targetElBorderRadius = element ? getComputedStyle(element).borderRadius : "";
      return /* @__PURE__ */ React142.createElement(React142.Fragment, null, targetElRect && /* @__PURE__ */ React142.createElement(
        "div",
        {
          style: {
            zIndex: Z_default.Z_COMMANDBAR - 5,
            position: "absolute",
            top: "0",
            left: "0"
          }
        },
        /* @__PURE__ */ React142.createElement(
          "div",
          {
            "data-testid": "commandbar-nudge-mask",
            style: {
              width: `${document.documentElement.scrollWidth}px`,
              height: `${document.documentElement.scrollHeight}px`,
              clipPath: `polygon(0% 0%, 0% 100%,
                ${targetElRect.left + window.scrollX}px 100%,
                ${targetElRect.left + window.scrollX}px ${targetElRect.top + window.scrollY}px,
                ${targetElRect.left + window.scrollX + targetElRect.width}px ${targetElRect.top + window.scrollY}px,
                ${targetElRect.left + window.scrollX + targetElRect.width}px ${targetElRect.top + window.scrollY + targetElRect.height}px,
                0% ${targetElRect.top + window.scrollY + targetElRect.height}px,
                0% 100%, 100% 100%, 100% 0%)`,
              position: "absolute"
            }
          }
        ),
        /* @__PURE__ */ React142.createElement(
          "div",
          {
            "data-testid": "commandbar-nudge-mask-inner",
            style: {
              pointerEvents: "none",
              position: "absolute",
              inset: `${targetElRect.top + window.scrollY}px ${targetElRect.left + window.scrollX}px`,
              width: `${targetElRect.width}px`,
              height: `${targetElRect.height}px`,
              padding: "4px",
              borderRadius: `${targetElBorderRadius}`,
              boxShadow: `0 0 0 ${Math.max(
                document.documentElement.scrollHeight,
                document.documentElement.scrollWidth
              )}px ${theme.nudgeModal.maskBackgroundColor}`,
              overflow: "hidden",
              // When the animation is not instant, we need to apply a similar timing function/opacity fade to the mask, but specifically
              // ignore the transform or any other transition properties that are not opacity since the mask should not animate other than fade
              opacity: animStyles.opacity,
              transitionProperty: "opacity",
              transitionDuration: animStyles.transitionDuration,
              transitionTimingFunction: animStyles.transitionTimingFunction
            }
          }
        )
      ));
    };
    MaskContainer = () => {
      const [element, setElement] = useState17(currentElement);
      useEffect25(() => {
        updateMaskContainer = () => setElement(currentElement);
        return () => {
          updateMaskContainer = null;
        };
      }, []);
      return /* @__PURE__ */ React142.createElement(React142.Fragment, null, element && /* @__PURE__ */ React142.createElement(Mask2, { element: currentElement }));
    };
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeBeacon.tsx
import { keyframes as keyframes3, jsx as jsx37, css as css25 } from "@emotion/core";
var pulseAnimation, styles16, Beacon, slug15, StyledNudgeBeacon, StyledNudgeBeacon_default;
var init_StyledNudgeBeacon = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeBeacon.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    init_useComponentOverrides();
    pulseAnimation = keyframes3`
  0% {
    transform: scale(1);
    opacity: 1;
  }
  75%, 100% {
    transform: scale(4);
    opacity: 0;
  }
`;
    styles16 = {
      position: "relative",
      borderRadius: "var(--layout-radius-circle)",
      width: "var(--height-small)",
      height: "var(--height-small)",
      backgroundColor: "var(--base-accent)",
      pointerEvents: "all",
      zIndex: Z_default.Z_NUDGE
    };
    Beacon = styled_browser_esm_default.div`
  border-radius: var(--layout-radius-circle);
  width: var(--height-small);
  height: var(--height-small);
  background-color: var(--base-accent);
  position: absolute;
  animation: ${pulseAnimation} 1.5s cubic-bezier(0, 0, 0.2, 1) infinite;
`;
    slug15 = "beacon";
    StyledNudgeBeacon = ({ themeV2, ...props2 }) => {
      const { overrides } = useComponentOverrides_default(slug15, themeV2);
      return /* @__PURE__ */ jsx37("div", { css: [overrides, css25(styles16)], ...props2 }, /* @__PURE__ */ jsx37(Beacon, null));
    };
    StyledNudgeBeacon.styles = styles16;
    StyledNudgeBeacon.slug = slug15;
    StyledNudgeBeacon.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx37(StyledNudgeBeacon, { themeV2: { themeV2, mode } }, "Button");
    StyledNudgeBeacon_default = StyledNudgeBeacon;
  }
});

// commandbar/src/products/nudges/hooks/useLinkClickHandler.tsx
import { useCallback as useCallback9 } from "react";
var defaultOpen, useLinkClickHandler;
var init_useLinkClickHandler = __esm({
  "commandbar/src/products/nudges/hooks/useLinkClickHandler.tsx"() {
    "use strict";
    init_Logger();
    init_useStore();
    defaultOpen = (url) => {
      window.open(url, "_blank");
    };
    useLinkClickHandler = (onRouterNavigation) => {
      const _ = useStore();
      const handleLinkClick = useCallback9(
        (event) => {
          const routerFunc = _.callbacks["commandbar-router"];
          const { target } = event;
          if (!(target instanceof HTMLAnchorElement)) {
            return;
          }
          if (target.classList.contains("newTab")) {
            return;
          }
          if (routerFunc) {
            event.preventDefault();
            try {
              const { hostname: targetHostname, pathname, search: search3, hash } = new URL(target.href);
              if (targetHostname === window.location.hostname) {
                routerFunc(pathname + search3 + hash);
                onRouterNavigation == null ? void 0 : onRouterNavigation();
              } else {
                defaultOpen(target.href);
              }
            } catch (e) {
              Logger_default.warn(e);
              defaultOpen(target.href);
            }
          }
        },
        [_.callbacks["commandbar-router"], onRouterNavigation]
      );
      return handleLinkClick;
    };
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeCloseButton.tsx
import { jsx as jsx38 } from "@emotion/core";
var StyledNudgeCloseButton, StyledNudgeCloseButton_default;
var init_StyledNudgeCloseButton = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeCloseButton.tsx"() {
    "use strict";
    init_react();
    init_StyledTertiaryIconButton();
    StyledNudgeCloseButton = ({ ...props2 }) => {
      return /* @__PURE__ */ jsx38(StyledTertiaryIconButton_default, { "data-testid": "nudge-step-close-button", ...props2 }, /* @__PURE__ */ jsx38(XClose_default, null));
    };
    StyledNudgeCloseButton_default = StyledNudgeCloseButton;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgePin.tsx
import React143 from "react";
import { css as css26, jsx as jsx39 } from "@emotion/core";
var styles17, containerStyles2, surveyStyles2, Pin, Container6, StyledNudgePin, StyledNudgePin_default;
var init_StyledNudgePin = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgePin.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    init_Arrow();
    styles17 = css26({
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      background: "var(--background-primary)",
      width: "100%",
      borderRadius: "inherit",
      pointerEvents: "all",
      a: {
        color: "var(--content-link)",
        textDecoration: "none",
        "&:hover": {
          color: "var(--content-link-hover)",
          textDecoration: "underline"
        }
      }
    });
    containerStyles2 = css26({
      position: "absolute",
      width: "var(--popover-width)",
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      backgroundColor: "var(--background-primary)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)",
      borderRadius: "var(--layout-radius-card)",
      border: "1px solid var(--border-primary)",
      pointerEvents: "all"
    });
    surveyStyles2 = css26({
      minWidth: "var(--popover-width)",
      width: "unset"
    });
    Pin = styled_browser_esm_default.div`
  z-index: ${Z_default.Z_NUDGE};
`;
    Container6 = styled_browser_esm_default.div``;
    StyledNudgePin = React143.forwardRef(
      ({ survey, organization, arrow: arrow3, children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx39(Container6, { ref: ref12, css: [containerStyles2, survey && surveyStyles2].filter(Boolean), ...props2 }, /* @__PURE__ */ jsx39(Arrow_default, { type: "pin", containerStyles: { display: `${arrow3 ? "inline-block" : "none"}` } }), /* @__PURE__ */ jsx39(Pin, { css: styles17 }, children));
      }
    );
    StyledNudgePin_default = StyledNudgePin;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeStepCounter.tsx
import React144 from "react";
var NudgeStepCount, StyledNudgeStepCounter, StyledNudgeStepCounter_default;
var init_StyledNudgeStepCounter = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeStepCounter.tsx"() {
    "use strict";
    init_styled_browser_esm();
    NudgeStepCount = styled_browser_esm_default.div`
  color: var(--content-secondary);
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);
`;
    StyledNudgeStepCounter = ({ stepCount }) => /* @__PURE__ */ React144.createElement(NudgeStepCount, { "data-testid": "commandbar-nudge-step-counter" }, stepCount);
    StyledNudgeStepCounter_default = StyledNudgeStepCounter;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeActionBar.tsx
import React145 from "react";
var NudgeActionBar, StyledNudgeActionBar, StyledNudgeActionBar_default;
var init_StyledNudgeActionBar = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeActionBar.tsx"() {
    "use strict";
    init_styled_browser_esm();
    NudgeActionBar = styled_browser_esm_default.div`
  display: flex;
  align-items: center;
  padding: 0px var(--layout-padding) var(--layout-padding);
  gap: var(--layout-gap);

  padding: ${({ stepCount, isBanner }) => stepCount || isBanner ? 0 : "0px var(--layout-padding) var(--layout-padding)"};
  width: ${({ stepCount, isBanner }) => stepCount || isBanner ? "auto" : "100%"};

  ${({ isBanner }) => isBanner && `
    @media (max-width: 375px) {
      padding: 0px;
      width: 100%;
    }
  `}
`;
    StyledNudgeActionBar = ({
      children,
      isBanner,
      stepCount,
      ...props2
    }) => /* @__PURE__ */ React145.createElement(NudgeActionBar, { isBanner: !!isBanner, ...props2, stepCount: !!stepCount }, children);
    StyledNudgeActionBar_default = StyledNudgeActionBar;
  }
});

// internal/src/client/themesV2/components/shared/StyledTertiaryButton.tsx
import { css as css27, jsx as jsx40 } from "@emotion/core";
var styles18, slug16, StyledTertiaryButton, StyledTertiaryButton_default;
var init_StyledTertiaryButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledTertiaryButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_ButtonWithReset();
    styles18 = {
      display: "flex",
      width: "100%",
      height: "var(--form-control-height)",
      padding: "var(--form-control-padding-x)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--form-control-gap)",
      color: "var(--button-tertiary-content)",
      borderRadius: "var(--layout-radius-button)",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: "var(--button-tertiary-border-color)",
      background: "var(--button-tertiary-background)",
      flex: "1 1 0",
      cursor: "pointer",
      whiteSpace: "nowrap",
      userSelect: "none",
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        borderColor: "var(--button-tertiary-border-color-hover)",
        background: "var(--button-tertiary-background-hover)",
        color: "var(--button-tertiary-content-hover)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        background: "var(--button-tertiary-background-hover)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed",
        borderColor: "var(--button-tertiary-border-color)",
        background: "var(--button-tertiary-background)",
        color: "var(--button-tertiary-content)"
      }
    };
    slug16 = "tertiaryButton";
    StyledTertiaryButton = ({
      themeV2,
      prefixIcon,
      suffixIcon,
      children,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug16, themeV2);
      return /* @__PURE__ */ jsx40(ButtonWithReset_default, { css: [overrides, css27(styles18)], ...props2 }, prefixIcon, /* @__PURE__ */ jsx40(
        "span",
        {
          style: {
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap"
          }
        },
        children
      ), suffixIcon);
    };
    StyledTertiaryButton.styles = styles18;
    StyledTertiaryButton.slug = slug16;
    StyledTertiaryButton.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx40(StyledTertiaryButton, { themeV2: { themeV2, mode } }, "Button");
    StyledTertiaryButton_default = StyledTertiaryButton;
  }
});

// internal/src/client/themesV2/components/shared/StyledCTAButton.tsx
import React146 from "react";
var StyledCTAButton, StyledCTAButton_default;
var init_StyledCTAButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledCTAButton.tsx"() {
    "use strict";
    init_StyledPrimaryButton();
    init_StyledSecondaryButton();
    init_StyledTertiaryButton();
    StyledCTAButton = ({
      children,
      buttonType,
      ...props2
    }) => {
      switch (buttonType) {
        case "secondary":
          return /* @__PURE__ */ React146.createElement(StyledSecondaryButton_default, { ...props2 }, children);
        case "tertiary":
        case "snooze":
          return /* @__PURE__ */ React146.createElement(StyledTertiaryButton_default, { ...props2 }, children);
        case "primary":
        default:
          return /* @__PURE__ */ React146.createElement(StyledPrimaryButton_default, { ...props2 }, children);
      }
    };
    StyledCTAButton_default = StyledCTAButton;
  }
});

// commandbar/src/products/nudges/components/Actions.tsx
import React147 from "react";
var Actions;
var init_Actions = __esm({
  "commandbar/src/products/nudges/components/Actions.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_useMobileExperience();
    init_StyledNudgeActionBar();
    init_StyledCTAButton();
    init_ContentContainer();
    init_hooks();
    Actions = ({ step, stepIndex, renderMode, snooze, service, stepCount }) => {
      const themeV2 = useThemeV2Context();
      const execNudgeAction = useExecNudgeAction({
        stepId: step.id,
        renderMode,
        service
      });
      const actions2 = step.content.filter((block) => block.type === "button").sort((_a2, b) => {
        var _a3;
        return b.type === "button" && ((_a3 = b.meta) == null ? void 0 : _a3.button_type) === "secondary" ? 1 : -1;
      });
      const snoozeAction = snooze.enabled && (snooze.enabledOnAllSteps || stepIndex === 0) ? [
        {
          type: "button",
          sort_key: -1,
          meta: {
            button_type: "snooze",
            label: snooze.label,
            action: {
              type: "snooze",
              ...snooze.duration
            }
          }
        }
      ] : [];
      const actionsWithSnooze = snoozeAction.concat(actions2);
      const { isMobileDevice: isMobileDevice2, mobileStyles } = useMobileExperience();
      if (actionsWithSnooze.length === 0) {
        return /* @__PURE__ */ React147.createElement(React147.Fragment, null);
      }
      return /* @__PURE__ */ React147.createElement(
        StyledNudgeActionBar_default,
        {
          isBanner: step.form_factor.type === "banner",
          stepCount,
          style: {
            flexWrap: step.form_factor.layout === "horizontal" ? "wrap" : void 0,
            ...isMobileDevice2 && step.form_factor.type === "banner" ? mobileStyles.nudges.banner.actionBar : {}
          }
        },
        actionsWithSnooze.filter((block) => {
          var _a2;
          return (_a2 = block.meta) == null ? void 0 : _a2.label;
        }).map((block, idx) => /* @__PURE__ */ React147.createElement(
          CTAWithTooltip,
          {
            key: idx,
            id: idx,
            block,
            step,
            style: {
              top: 0,
              height: "auto",
              border: "none",
              flex: "1 1 0",
              display: "flex",
              ...stepCount ? { width: "auto" } : { width: "100%" }
            }
          },
          (action, isDisabled, disabledStyles) => {
            var _a2, _b2;
            return /* @__PURE__ */ React147.createElement(
              StyledCTAButton_default,
              {
                themeV2,
                onClick: () => execNudgeAction(action, block.meta),
                buttonType: (_a2 = block.meta) == null ? void 0 : _a2.button_type,
                disabled: isDisabled,
                style: {
                  ...isDisabled && disabledStyles
                }
              },
              (_b2 = block.meta) == null ? void 0 : _b2.label
            );
          }
        ))
      );
    };
  }
});

// commandbar/src/products/nudges/components/LayoutTemplate.tsx
import React148 from "react";
var Classic, Horizontal, Vertical, LayoutTemplate;
var init_LayoutTemplate = __esm({
  "commandbar/src/products/nudges/components/LayoutTemplate.tsx"() {
    "use strict";
    Classic = ({
      close,
      headerAndMarkdown,
      media,
      actions: actions2,
      footer,
      stepCounter,
      maxContentWidth
    }) => /* @__PURE__ */ React148.createElement(React148.Fragment, null, /* @__PURE__ */ React148.createElement("div", { style: { maxWidth: maxContentWidth } }, headerAndMarkdown), close, media, stepCounter ? /* @__PURE__ */ React148.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "0px var(--layout-padding) var(--layout-padding)"
        }
      },
      stepCounter,
      actions2
    ) : actions2, footer);
    Horizontal = ({
      close,
      headerAndMarkdown,
      media,
      actions: actions2,
      footer,
      stepCounter,
      columnWidth
    }) => /* @__PURE__ */ React148.createElement("div", { style: { display: "flex", flexDirection: "column", maxWidth: "100%" } }, /* @__PURE__ */ React148.createElement("div", { style: { display: "flex", alignItems: "stretch" } }, /* @__PURE__ */ React148.createElement("div", { style: { display: "flex", flexDirection: "column", justifyContent: "center", width: columnWidth } }, headerAndMarkdown, /* @__PURE__ */ React148.createElement("div", { style: { zIndex: 1 } }, close), stepCounter ? /* @__PURE__ */ React148.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "0px var(--layout-padding) var(--layout-padding)"
        }
      },
      stepCounter,
      actions2
    ) : actions2), /* @__PURE__ */ React148.createElement("div", { style: { width: columnWidth } }, media)), footer);
    Vertical = ({ close, headerAndMarkdown, media, actions: actions2, footer, stepCounter }) => /* @__PURE__ */ React148.createElement(React148.Fragment, null, /* @__PURE__ */ React148.createElement("div", { style: { zIndex: 1 } }, close), media, headerAndMarkdown, stepCounter ? /* @__PURE__ */ React148.createElement(
      "div",
      {
        style: {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "0px var(--layout-padding) var(--layout-padding)"
        }
      },
      stepCounter,
      actions2
    ) : actions2, footer);
    LayoutTemplate = ({ layout, columnWidth, ...components3 }) => {
      switch (layout) {
        case "vertical":
          return /* @__PURE__ */ React148.createElement(Vertical, { ...components3 });
        case "horizontal":
          return /* @__PURE__ */ React148.createElement(Horizontal, { columnWidth, ...components3 });
        case "classic":
        default:
          return /* @__PURE__ */ React148.createElement(Classic, { maxContentWidth: columnWidth, ...components3 });
      }
    };
  }
});

// commandbar/src/products/nudges/components/Pin/Layout.tsx
import React149, { forwardRef as forwardRef7 } from "react";
var Layout;
var init_Layout = __esm({
  "commandbar/src/products/nudges/components/Pin/Layout.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_DraftFooter();
    init_useMobileExperience();
    init_useStore();
    init_StyledCloseButtonContainer();
    init_StyledNudgeCloseButton();
    init_StyledNudgePin();
    init_StyledNudgeStepCounter();
    init_StyledNudgeTitleBlock();
    init_selectors5();
    init_Actions();
    init_ContentContainer();
    init_LayoutTemplate();
    init_RenderNudge();
    init_utils4();
    init_AnimatedWidget();
    Layout = forwardRef7(
      ({ nudge, step, renderMode, handleLinkClick, stepIndex, stepCount, isOpen, dismissNudge: dismissNudge2, styles: styles51 }, ref12) => {
        var _a2;
        const _ = useStore();
        const themeV2 = useThemeV2Context();
        const nudgeService = renderMode !== 1 /* MOCK */ ? getNudgeService(_, nudge.id) : void 0;
        const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
        const { animStyles, isAnimatedWidget } = useAnimatedWidget();
        const close = isNudgeDismissible(nudge) ? /* @__PURE__ */ React149.createElement(StyledCloseButtonContainer_default, null, /* @__PURE__ */ React149.createElement(StyledNudgeCloseButton_default, { themeV2, onClick: dismissNudge2 })) : null;
        const header = /* @__PURE__ */ React149.createElement(
          StyledNudgeTitleBlock_default,
          {
            title: step.title,
            content: getFirstMarkdownBlock(step.content),
            dismissible: isNudgeDismissible(nudge),
            handleContentLinkClick: handleLinkClick
          }
        );
        const media = /* @__PURE__ */ React149.createElement(
          ContentContainer_default,
          {
            step,
            stepIndex,
            service: nudgeService,
            markdownStyles: styles51.content,
            primaryButtonStyles: styles51.ctaButton,
            secondaryButtonStyles: styles51.ctaSecondaryButton,
            snoozeButtonStyles: styles51.snoozeButton,
            stepCountStyles: styles51.stepCount,
            stepCount,
            renderMode,
            snoozable: isNudgeSnoozable(nudge),
            snoozeLabel: nudge.snooze_label,
            snoozable_on_all_steps: nudge.snoozable_on_all_steps,
            handleContentLinkClick: handleLinkClick
          }
        );
        const stepCounter = stepCount ? /* @__PURE__ */ React149.createElement(StyledNudgeStepCounter_default, { stepCount }) : null;
        const actions2 = /* @__PURE__ */ React149.createElement(
          Actions,
          {
            step,
            renderMode,
            snooze: {
              enabled: isNudgeSnoozable(nudge),
              label: nudge.snooze_label,
              enabledOnAllSteps: nudge.snoozable_on_all_steps,
              duration: nudge.snooze_duration
            },
            service: nudgeService,
            stepCount,
            stepIndex
          }
        );
        const footer = !nudge.is_live && renderMode === 1 /* MOCK */ ? /* @__PURE__ */ React149.createElement(DraftFooter, { details: { type: "nudge", nudge, stepIndex } }) : null;
        return /* @__PURE__ */ React149.createElement(BindThemeV2ForNudge, { nudge }, /* @__PURE__ */ React149.createElement(
          StyledNudgePin_default,
          {
            organization: _.organization,
            survey: !!step.content.find((block) => block.type === "survey_rating"),
            "data-testid": "commandbar-nudge-pin-content",
            ref: ref12,
            style: {
              width: step.form_factor.layout === "horizontal" && !isMobileDevice2 ? "auto" : void 0,
              ...!isAnimatedWidget && { visibility: isOpen ? "visible" : "hidden" },
              ...animStyles
            },
            "aria-labelledby": "commandbar-nudge-title",
            arrow: (_a2 = _.flags) == null ? void 0 : _a2["release-nudge-arrows"]
          },
          /* @__PURE__ */ React149.createElement(
            LayoutTemplate,
            {
              layout: isMobileDevice2 ? "classic" : step.form_factor.layout,
              headerAndMarkdown: header,
              close,
              media,
              footer,
              stepCounter,
              actions: actions2,
              columnWidth: "var(--popover-width)"
            }
          )
        ));
      }
    );
  }
});

// commandbar/src/products/nudges/components/Pin/index.tsx
import React150, { forwardRef as forwardRef8, useCallback as useCallback10, useEffect as useEffect26, useMemo as useMemo6, useState as useState18 } from "react";
import { jsx as jsx41 } from "@emotion/core";
var BEACON_SIZE2, getStyles2, Beacon2, Content4, usePinPositioning, usePinTargetClickHandler, useScrollToTargetEl, useMasking, usePin, Pin2, PinContainer, Pin_default;
var init_Pin = __esm({
  "commandbar/src/products/nudges/components/Pin/index.tsx"() {
    "use strict";
    init_useTheme();
    init_helpers10();
    init_theme3();
    init_Z();
    init_CloseButton();
    init_DraftFooter();
    init_ContentContainer();
    init_location();
    init_LocalStorage();
    init_useAction();
    init_RenderNudge();
    init_selectors5();
    init_actions6();
    init_useMobileExperience();
    init_useMask();
    init_useStore();
    init_sentry();
    init_StyledNudgeBeacon();
    init_useLinkClickHandler();
    init_ThemeV2Context();
    init_useMergeRefs();
    init_Layout();
    init_AnimatedWidget();
    init_SurveyResponseProvider();
    BEACON_SIZE2 = 16;
    getStyles2 = (theme, autoWidth) => ({
      pin: {
        position: "absolute",
        display: "flex",
        gap: "16px",
        pointerEvents: "none",
        zIndex: Z_default.Z_NUDGE
      },
      container: {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: autoWidth ? "auto" : theme.nudgePin.width,
        boxShadow: theme.nudgePin.boxShadow,
        borderRadius: theme.nudgePin.borderRadius,
        backgroundColor: theme.nudgePin.background,
        fontFamily: theme.nudgePin.fontFamily,
        color: theme.nudgePin.color,
        zIndex: Z_default.Z_NUDGE - 1,
        pointerEvents: "auto"
      },
      body: {
        display: "flex",
        flexDirection: "column",
        padding: theme.nudgePin.padding,
        gap: theme.nudgePin.gap
      },
      header: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px" },
      title: {
        fontFamily: theme.nudgePin.titleFontFamily,
        fontWeight: theme.nudgePin.titleFontWeight,
        fontSize: theme.nudgePin.titleFontSize,
        lineHeight: theme.nudgePin.titleLineHeight,
        color: theme.nudgePin.titleColor
      },
      content: {
        fontFamily: theme.nudgePin.contentFontFamily,
        fontWeight: theme.nudgePin.contentFontWeight,
        fontSize: theme.nudgePin.contentFontSize,
        lineHeight: theme.nudgePin.contentLineHeight,
        color: theme.nudgePin.contentColor
      },
      ctaButton: {
        padding: theme.nudgePin.ctaPadding,
        background: theme.nudgePin.ctaBackground,
        color: theme.nudgePin.ctaColor,
        border: theme.nudgePin.ctaBorder,
        boxShadow: theme.nudgePin.ctaBoxShadow,
        textShadow: theme.nudgePin.ctaTextShadow,
        borderRadius: theme.nudgePin.ctaBorderRadius,
        fontFamily: theme.nudgePin.ctaFontFamily,
        fontSize: theme.nudgePin.ctaFontSize,
        lineHeight: theme.nudgePin.ctaLineHeight,
        fontWeight: theme.nudgePin.ctaFontWeight
      },
      ctaSecondaryButton: {
        fontFamily: theme.nudgePin.ctaSecondaryFontFamily,
        padding: theme.nudgePin.ctaSecondaryPadding,
        background: theme.nudgePin.ctaSecondaryBackground,
        color: theme.nudgePin.ctaSecondaryColor,
        border: theme.nudgePin.ctaSecondaryBorder,
        boxShadow: theme.nudgePin.ctaSecondaryBoxShadow,
        textShadow: theme.nudgePin.ctaSecondaryTextShadow,
        borderRadius: theme.nudgePin.ctaSecondaryBorderRadius,
        fontSize: theme.nudgePin.ctaSecondaryFontSize,
        lineHeight: theme.nudgePin.ctaSecondaryLineHeight,
        fontWeight: theme.nudgePin.ctaSecondaryFontWeight
      },
      snoozeButton: {
        background: theme.nudgePin.snoozeButtonBackground,
        fontFamily: theme.nudgePin.snoozeButtonFontFamily,
        color: theme.nudgePin.snoozeButtonColor,
        border: theme.nudgePin.snoozeButtonBorder,
        textShadow: theme.nudgePin.snoozeButtonTextShadow,
        fontSize: theme.nudgePin.snoozeButtonFontSize,
        lineHeight: theme.nudgePin.snoozeButtonLineHeight,
        fontWeight: theme.nudgePin.snoozeButtonFontWeight,
        width: theme.nudgePin.snoozeButtonWidth
      },
      closeButtonOverrides: {
        position: "absolute",
        top: "16px",
        right: "16px"
      },
      beaconOuter: {
        position: "relative",
        borderRadius: "100%",
        width: toPx(BEACON_SIZE2),
        height: toPx(BEACON_SIZE2),
        backgroundColor: theme.nudgePin.beaconColor,
        zIndex: Z_default.Z_NUDGE
      },
      beaconInner: {
        borderRadius: "100%",
        width: toPx(BEACON_SIZE2),
        height: toPx(BEACON_SIZE2),
        backgroundColor: theme.nudgePin.beaconColor,
        position: "absolute",
        animationDuration: "1.5s",
        animationTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
        animationDelay: "0s",
        animationIterationCount: "infinite",
        animationDirection: "normal",
        animationFillMode: "none",
        animationPlayState: "running"
      },
      stepCount: {
        color: theme.nudgePin.stepCountColor,
        fontFamily: theme.nudgePin.stepCountFontFamily,
        fontSize: theme.nudgePin.stepCountFontSize,
        fontWeight: theme.nudgePin.stepCountFontWeight
      }
    });
    Beacon2 = ({ isOpen, onClick, styles: styles51, renderUnAnchoredMock }) => {
      var _a2, _b2;
      const { theme } = useTheme();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx41(
        StyledNudgeBeacon_default,
        {
          themeV2,
          onClick,
          style: {
            right: renderUnAnchoredMock ? "20px" : `-${BEACON_INSET}px`,
            bottom: renderUnAnchoredMock ? "20px" : `-${BEACON_INSET}px`,
            cursor: isOpen ? "auto" : "pointer",
            pointerEvents: isOpen ? "none" : "all",
            display: `${((_b2 = _.flags) == null ? void 0 : _b2["release-nudge-arrows"]) ? "none" : "inline-block"}`
          },
          "data-testid": "commandbar-nudge-pin-beacon"
        }
      ) : /* @__PURE__ */ jsx41(
        "button",
        {
          type: "button",
          "data-testid": "commandbar-nudge-pin-beacon",
          style: {
            ...styles51.beaconOuter,
            top: BEACON_INSET,
            left: BEACON_INSET,
            cursor: isOpen ? "auto" : "pointer",
            pointerEvents: isOpen ? "none" : "all",
            // unstyled button
            display: "flex",
            border: "none",
            padding: 0
          },
          onClick,
          disabled: isOpen
        },
        /* @__PURE__ */ jsx41(
          "div",
          {
            style: styles51.beaconInner,
            css: {
              animationName: "ping",
              "@keyframes ping": {
                "75%, to": {
                  transform: `scale(${theme.nudgePin.beaconPulseScale})`,
                  opacity: 0
                }
              }
            }
          }
        )
      );
    };
    Content4 = forwardRef8(
      ({ styles: styles51, pin, isOpen, service, stepCount, renderMode, dismissNudge: dismissNudge2, stepIndex, onMockAction }, ref12) => {
        var _a2;
        const _ = useStore();
        const handleLinkClick = useLinkClickHandler(dismissNudge2);
        const contentStyles = pin.targetEl ? {
          ...styles51.container,
          visibility: isOpen ? "visible" : "hidden",
          position: "absolute",
          top: 0,
          left: 0,
          transform: void 0
        } : {
          ...styles51.container,
          visibility: isOpen ? "visible" : "hidden",
          top: `${BEACON_SIZE2}px`,
          left: `${BEACON_INSET}px`
        };
        return /* @__PURE__ */ jsx41(SurveyResponseProvider, { service, step: pin.step }, ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx41(
          Layout,
          {
            ref: ref12,
            nudge: pin.nudge,
            step: pin.step,
            handleLinkClick,
            isOpen,
            dismissNudge: dismissNudge2,
            stepCount,
            service,
            styles: styles51,
            renderMode,
            stepIndex
          }
        ) : /* @__PURE__ */ jsx41(
          "div",
          {
            "data-testid": "commandbar-nudge-pin-content",
            ref: ref12,
            style: contentStyles,
            "aria-labelledby": "commandbar-nudge-title"
          },
          /* @__PURE__ */ jsx41("div", { style: styles51.body }, /* @__PURE__ */ jsx41("div", { style: styles51.header }, /* @__PURE__ */ jsx41("span", { id: "commandbar-nudge-title", style: styles51.title, role: "heading", "aria-level": 3 }, pin.step.title), isNudgeDismissible(pin.nudge) && /* @__PURE__ */ jsx41(CloseButton_default, { onInteraction: dismissNudge2 })), /* @__PURE__ */ jsx41(
            ContentContainer_default,
            {
              step: pin.step,
              service,
              markdownStyles: styles51.content,
              primaryButtonStyles: styles51.ctaButton,
              secondaryButtonStyles: styles51.ctaSecondaryButton,
              snoozeButtonStyles: styles51.snoozeButton,
              stepCountStyles: styles51.stepCount,
              stepCount,
              renderMode,
              snoozable: isNudgeSnoozable(pin.nudge),
              snoozeLabel: pin.nudge.snooze_label,
              onMockAction,
              handleContentLinkClick: handleLinkClick,
              stepIndex,
              snoozable_on_all_steps: pin.nudge.snoozable_on_all_steps
            }
          )),
          !pin.nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ jsx41(DraftFooter, { details: { type: "nudge", nudge: pin.nudge, stepIndex } })
        ));
      }
    );
    usePinPositioning = ({
      pin,
      isOpen,
      dismissNudge: dismissNudge2,
      beaconRef,
      contentRef,
      isAnimatedWidget
    }) => {
      useEffect26(() => {
        if (beaconRef.current && contentRef.current) {
          const cleanupMutationObserver = helpers_default(
            pin,
            beaconRef.current,
            contentRef.current,
            isOpen,
            dismissNudge2,
            isAnimatedWidget
          );
          return () => {
            if (cleanupMutationObserver)
              cleanupMutationObserver();
          };
        }
      }, [beaconRef, contentRef, dismissNudge2, isOpen, pin]);
    };
    usePinTargetClickHandler = ({ pin, onClick }) => {
      const handlePinTargetClick = useCallback10(
        (event) => {
          var _a2, _b2;
          const target = event.target;
          if (!(target instanceof Node))
            return;
          if (pin.step.form_factor.advance_trigger) {
            if ((_a2 = pin.advanceTriggerEl) == null ? void 0 : _a2.contains(target)) {
              onClick();
            }
          } else if ((_b2 = pin.targetEl) == null ? void 0 : _b2.contains(target)) {
            onClick();
          }
        },
        [onClick, pin.advanceTriggerEl, pin.targetEl]
      );
      useEffect26(() => {
        document.addEventListener("click", handlePinTargetClick, true);
        return () => {
          document.removeEventListener("click", handlePinTargetClick, true);
        };
      }, [handlePinTargetClick]);
    };
    useScrollToTargetEl = ({ pin, setIsScrolling }) => {
      useEffect26(() => {
        var _a2;
        try {
          const targetEl = pin.targetEl;
          if (!targetEl)
            return;
          const targetElRect = targetEl.getBoundingClientRect();
          const parentScrollable = findScrollParent(targetEl, pin.nudge);
          if (pin.isOpenByDefault && isElementOffScreen(targetElRect, parentScrollable)) {
            setIsScrolling(true);
            const elementCenter = getElementCenter(targetElRect);
            const scrollContainer = parentScrollable || document.documentElement || window;
            const newScrollPosition = calculateNewScrollPosition(elementCenter, scrollContainer, {
              isScrollableContainer: !!parentScrollable
            });
            const scrollToOptions = {
              behavior: "smooth",
              left: newScrollPosition.x,
              top: newScrollPosition.y
            };
            scrollToElement(parentScrollable || window, scrollToOptions);
            let priorCoordinates = [null, null];
            const interval = setInterval(() => {
              const updatedCoordinates = [
                targetEl.getBoundingClientRect().x,
                targetEl.getBoundingClientRect().y
              ];
              const entryIsInSamePosition = priorCoordinates[0] === updatedCoordinates[0] && priorCoordinates[1] === updatedCoordinates[1];
              if (entryIsInSamePosition) {
                setIsScrolling(false);
                clearInterval(interval);
              } else {
                priorCoordinates = updatedCoordinates;
              }
            }, 100);
          }
        } catch (error3) {
          (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
        }
      }, []);
    };
    useMasking = ({ pin, isScrolling }) => {
      useEffect26(() => {
        if (pin.isShowingMask && pin.targetEl && !isScrolling) {
          showMask(pin.targetEl);
        }
        return () => {
          hideMask();
        };
      }, [pin, isScrolling]);
    };
    usePin = (pin, renderMode, anchorOverride) => {
      const _ = useStore();
      const [context, setContext2] = useState18();
      const service = renderMode !== 1 /* MOCK */ ? getNudgeService(_, pin.nudge.id) : void 0;
      useEffect26(() => {
        if (service) {
          const unsub = service == null ? void 0 : service.subscribe(({ context: context2 }) => {
            setContext2(context2);
          });
          return () => {
            unsub == null ? void 0 : unsub.unsubscribe();
          };
        }
      }, [service]);
      const nudge = service && context ? context.nudge : pin.nudge;
      const step = service && context ? context.nudge.steps[context.stepIndex] : pin.step;
      const { targetEl, advanceTriggerEl } = getPinAnchors(_, { step, anchorOverride });
      const steps = useMemo6(
        () => nudge.steps.map((_step, index3) => {
          if (step.id === _step.id) {
            return {
              ..._step,
              index: index3
            };
          }
          return {
            ...step,
            index: index3
          };
        }),
        [step, nudge.steps]
      );
      const newNudge = useMemo6(() => ({ ...nudge, steps }), [steps, nudge]);
      const newPin = { ...pin, nudge: newNudge, step, targetEl, advanceTriggerEl };
      return { pin: newPin, service };
    };
    Pin2 = ({ pin: _pin, stepCount, stepIndex, renderMode, anchorOverride, style: style3 }) => {
      const { theme } = useTheme();
      const _ = useStore();
      const { pin, service } = usePin(_pin, renderMode, anchorOverride);
      const [isOpen, setIsOpen] = React150.useState(pin.isOpenByDefault);
      const [isScrolling, setIsScrolling] = React150.useState(false);
      const { onExit, onEnter, isAnimatedWidget } = useAnimatedWidget();
      const dismiss = useAction(dismissNudge);
      const closePin = useAction(closeNudge);
      const dismissTemporarily = useAction(dismissNudgeTemporarily);
      const handleDismissNudge = () => {
        onExit(() => {
          if (_.extension.recorder.enabled) {
            dismissTemporarily({ nudge: pin.nudge, renderMode, stepIndex, anchorOverride });
          } else {
            dismiss(pin.nudge, renderMode);
          }
        });
      };
      const handleNudgeAction = (isPinClick) => {
        onExit(() => {
          if (_.extension.recorder.enabled) {
            dismissTemporarily({ nudge: pin.nudge, renderMode, stepIndex, anchorOverride });
          } else {
            service == null ? void 0 : service.send({ type: "ADVANCE", isPinClick });
          }
        });
      };
      const { isMobileDevice: isMobileDevice2, mobileStyles } = useMobileExperience();
      const styles51 = getStyles2(
        theme,
        !isMobileDevice2 && pin.step.content.some((block) => (block == null ? void 0 : block.type) === "survey_rating" && block.meta.options === 10)
      );
      const beaconRef = React150.useRef(null);
      const contentRef = React150.useRef(null);
      const [{ width: contentWidth, height: contentHeight }, setContentDimensions] = useState18({ width: 0, height: 0 });
      const measuredContentRef = useCallback10(
        (node) => {
          if (node !== null) {
            const { width, height } = node.getBoundingClientRect();
            setContentDimensions({ width, height });
          }
        },
        [pin.step]
      );
      const mergedContentRef = useMergeRefs(contentRef, measuredContentRef);
      usePinPositioning({
        pin,
        beaconRef,
        contentRef,
        isOpen,
        dismissNudge: () => closePin(pin.nudge, renderMode),
        isAnimatedWidget
      });
      usePinTargetClickHandler({
        pin,
        onClick: () => {
          handleNudgeAction(true);
        }
      });
      useScrollToTargetEl({ pin, setIsScrolling });
      useMasking({ pin, isScrolling });
      const renderUnAnchoredMock = renderMode === 1 /* MOCK */ && (!pin.targetEl || isStudioPreview());
      const editorWidth = Number(LocalStorage_default.get("width", "770"));
      if (!(pin.targetEl || renderUnAnchoredMock)) {
        return null;
      }
      return /* @__PURE__ */ jsx41(
        "div",
        {
          "data-testid": `commandbar-pin-${pin.nudge.id}-${String(pin.step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
          ref: beaconRef,
          key: pin.step.title,
          className: `commandbar-nudge-pin ${renderUnAnchoredMock ? "commandbar-unanchored-nudge-pin" : ""}`,
          style: {
            ...styles51.pin,
            position: "absolute",
            width: "max-content",
            ...isStudioPreview() ? {
              top: `calc(50vh - ${BEACON_SIZE2}px - ${contentHeight === 0 ? contentHeight : contentHeight / 2}px - 51px)`,
              right: `calc(50% - ${BEACON_SIZE2}px + ${contentWidth === 0 ? contentWidth : contentWidth / 2}px)`,
              transform: "translate(50%, -50%)"
            } : {
              top: renderUnAnchoredMock ? `calc(50vh - ${BEACON_SIZE2}px - ${contentHeight === 0 ? contentHeight : contentHeight / 2}px)` : 0,
              left: _.isEditorVisible ? `calc((100vw - ${editorWidth}px) / 2 + ${BEACON_SIZE2}px - ${editorWidth * 1.5 + contentWidth === 0 ? contentWidth : contentWidth / 2}px)` : `calc(50% + ${BEACON_SIZE2}px - ${editorWidth * 1.5 + contentWidth === 0 ? contentWidth : contentWidth / 2}px)`,
              transform: "translate(-50%, -50%)"
            },
            ...renderUnAnchoredMock ? {} : {
              left: 0,
              visibility: "hidden",
              opacity: 0
            },
            ...isMobileDevice2 ? mobileStyles.nudges.pin.container : {},
            ...style3
          }
        },
        /* @__PURE__ */ jsx41(
          Beacon2,
          {
            isOpen,
            onClick: () => {
              setIsOpen(true);
              onEnter();
            },
            styles: styles51,
            renderUnAnchoredMock
          }
        ),
        /* @__PURE__ */ jsx41(
          Content4,
          {
            ref: mergedContentRef,
            styles: styles51,
            pin,
            isOpen,
            service,
            stepCount,
            renderMode,
            dismissNudge: () => handleDismissNudge(),
            stepIndex,
            onMockAction: () => handleNudgeAction()
          }
        )
      );
    };
    PinContainer = (props2) => {
      return /* @__PURE__ */ jsx41(BindThemeV2ForNudge, { nudge: props2.pin.nudge }, /* @__PURE__ */ jsx41(AnimatedWidget, { widget: "popover", keepMounted: true, isOpenByDefault: props2.pin.isOpenByDefault }, /* @__PURE__ */ jsx41(Pin2, { ...props2 })));
    };
    Pin_default = PinContainer;
  }
});

// commandbar/src/products/nudges/components/Pin/Cursor/constants.ts
var init_constants5 = __esm({
  "commandbar/src/products/nudges/components/Pin/Cursor/constants.ts"() {
    "use strict";
  }
});

// commandbar/src/products/nudges/components/Pin/Cursor/helpers.ts
import { computePosition as computePosition3, flip as flip2, offset as offset4 } from "@floating-ui/dom";
function* boundedRandomNumberGenerator(lower, upper, _minDifference) {
  let minDifference = _minDifference;
  let prevNumber = 0;
  const rangeSize = upper - lower + 1;
  while (true) {
    let randomNumber;
    let attempts = 0;
    const maxAttempts = rangeSize / minDifference;
    do {
      randomNumber = Math.floor(Math.random() * rangeSize) + lower;
      attempts++;
      if (attempts > maxAttempts) {
        minDifference = Math.max(minDifference - 1, 1);
        attempts = 0;
      }
    } while (Math.abs(randomNumber - prevNumber) < minDifference);
    prevNumber = randomNumber;
    yield randomNumber;
  }
}
var getRelativePosition, generatePathAround;
var init_helpers13 = __esm({
  "commandbar/src/products/nudges/components/Pin/Cursor/helpers.ts"() {
    "use strict";
    init_helpers10();
    getRelativePosition = (targetElement) => {
      const viewportCenterX = window.innerWidth / 2;
      const { x: elementCenterX } = getElementCenter(targetElement.getBoundingClientRect());
      const initialPlacement = elementCenterX < viewportCenterX ? "right-start" : "left-start";
      return {
        initialPlacement,
        computeFinalPosition: async (relativeElement, options) => {
          var _a2, _b2, _c2, _d, _e;
          const { x, y, placement, middlewareData } = await computePosition3(targetElement, relativeElement, {
            placement: initialPlacement,
            middleware: [
              offset4({
                mainAxis: (_a2 = options == null ? void 0 : options.mainAxisOffset) != null ? _a2 : 0,
                crossAxis: (_b2 = options == null ? void 0 : options.crossAxisOffset) != null ? _b2 : 0
              }),
              flip2({
                mainAxis: true,
                crossAxis: false,
                padding: {
                  left: (_c2 = options == null ? void 0 : options.padding) != null ? _c2 : 0,
                  right: (_d = options == null ? void 0 : options.padding) != null ? _d : 0
                }
              }),
              ...(_e = options == null ? void 0 : options.middleware) != null ? _e : []
            ]
          });
          return { x, y, placement, middlewareData };
        }
      };
    };
    generatePathAround = (w, h, direction) => {
      const directionModifier = direction === "counter-clockwise" ? -1 : 1;
      const top = [directionModifier * w * 0.2, -h * 0.5];
      const left = [directionModifier * w * 0.7, -h * 0.8];
      const bottom = [directionModifier * w, -h * 0.5];
      const right = [directionModifier * w * 0.6, -h * 0.1];
      const origin = "0 0";
      const originToTopCenter = `C 0 ${h * -0.3} ${directionModifier * w * 0.2} ${h * -0.5} ${top[0]} ${top[1] - 8}`;
      const topCenterToLeftCenter = `C ${directionModifier * w * 0.4} ${h * -0.7} ${directionModifier * w * 0.5} ${h * -0.8} ${left[0] - 8} ${left[1]}`;
      const leftCenterToBottomCenter = `C ${directionModifier * w * 0.9} ${h * -0.8} ${directionModifier * w} ${h * -0.7} ${bottom[0]} ${bottom[1]}`;
      const bottomCenterToRightCenter = `C ${directionModifier * w} ${h * -0.3} ${directionModifier * w * 0.8} ${h * -0.2} ${right[0]} ${right[1]}`;
      const rightCenterToOrigin = `C ${directionModifier * w * 0.3} 0 ${directionModifier * w * 0.2} 0 ${origin}`;
      return `M ${origin} ${originToTopCenter} ${topCenterToLeftCenter} ${leftCenterToBottomCenter} ${bottomCenterToRightCenter} ${rightCenterToOrigin}`;
    };
  }
});

// commandbar/src/products/helphub/service-actions.ts
var service_actions_exports = {};
__export(service_actions_exports, {
  navigate: () => setInitialPage,
  setFeedbackGiven: () => setFeedbackGiven,
  setHelpHubDoc: () => setHelpHubDoc,
  setHelpHubMinimized: () => setHelpHubMinimized,
  setHelpHubRecommendationSets: () => setHelpHubRecommendationSets,
  setHelpHubVisible: () => setHelpHubVisible,
  setPreviewRecommendationSet: () => setPreviewRecommendationSet,
  toggleHelpHubVisible: () => toggleHelpHubVisible
});
var init_service_actions = __esm({
  "commandbar/src/products/helphub/service-actions.ts"() {
    "use strict";
    init_actions2();
  }
});

// commandbar/src/products/nudges/components/Pin/Cursor/stateMachine.tsx
import { autoUpdate as autoUpdate3, hide as hide2 } from "@floating-ui/dom";
import { createActorContext as createActorContext2 } from "@xstate/react";
import React151, { useRef as useRef22 } from "react";
import { assign as assign3, createMachine as createMachine3 } from "xstate";
var TRANSLATE_DURATION, SQUIRREL_DURATION, POP_IN_DURATION, TRACING_DURATION, MIN_MARGIN2, CURSOR_INSET, cursorMachine, stateSelectors, CursorMachineContext, CursorMachineContextProvider;
var init_stateMachine = __esm({
  "commandbar/src/products/nudges/components/Pin/Cursor/stateMachine.tsx"() {
    "use strict";
    init_service_actions();
    init_useAction();
    init_useMask();
    init_useToast();
    init_Z();
    init_dom();
    init_nudges();
    init_helpers10();
    init_helpers13();
    TRANSLATE_DURATION = 1350;
    SQUIRREL_DURATION = 200;
    POP_IN_DURATION = 200;
    TRACING_DURATION = 450;
    MIN_MARGIN2 = 24;
    CURSOR_INSET = 8;
    cursorMachine = createMachine3(
      {
        /** @xstate-layout N4IgpgJg5mDOIC5QGECuAnWB7dBiAIgKIDKAKgEoDyAmgNoAMAuoqAA5awCWALp1gHYsQAD0QBaAGwAmAOwA6AJwBGejIAsMgKwKAzDokAOTQBoQAT0RqJCuVqVSDEnfX1q3EgL4fTaTDjkAtlgAbpz8UAAE3FhRAIboMNwRYAA2YAFg-Ny4AAqUxACSpAWUAHIA+shlpACCBaWE5AzMSCDsXLwCQqIIEppymlL0EkoyBlKG9KMyphYIyvLSEvQK9KpSmjr2Xj4Y2OiBIWGR0XEJYEmp6ZnZwrDcsdxgcrEAZk-oABTc6LH8sClHnx+ABKXC+faHULhKIxB7nS5pDJZZpCdo8YHdRAqKRyPo6NRSfSyBzOKSzbHDfojWQKCRaKxknYgCH+VhhfiQXL5IolCpVUq1eqNVGtdGdQStHp9AZDQxEpzKPoUhCaKZyJQGXQuHSaTSEozM1kHdn8TkQOSwAAWWAA7vxcAAJApEUVsDgYrpSxC6pR4lwSQw6BTqRxqFWDNQavrKNSbfSbGRGvZsjmQS02+2W22xVimyIAIywEDMuDuDyeL3eYC+AGN0BxYAAxWIQMBg41yU3mjN2-jZ3P5iJFktutoeiVY1XBuRqJRkzQGJRKTQqAwqmRDAZzrUyegbFdqBTJvwmtMWq2cCBth3ER2UADqY-FmO9CCX8jWBjW+5Ueno67mIgkbRtoShxno+IGCekK1lgASsKgvAwqwgK1tcWTcoUxRlJU1R1A0TRMGiE6vqAPRiM4OiKAomyalq9AaHSKpHtRag6FIujjE4Mi0UoMFslgebHBEYRlvcjzPG8HyfOwrAFKC4IpiaQlDmEz6kV65HiAethzmowwSOxtH0PqKr0hIihrlY1hbC4UgCQcsD1lgKQpMcuBNvUBR3oQ+DlMQyBUAAMsF9QAOIaR0ZEiOIzh+ke87KAoc6rpsEgqsoBh4il+4EmMrGaI5cg-LEtYifCiTiRWUnVl8pXleEHbKSVvyNSc8SJFFnqStpCB6FGnHLjIvEyKMhImEB8yEhq+7LAYkFKPSDneCyLXdum1p9nIV5pFhvK4TU5BUE+xFippvWxQgKhxnIeg4su0gqEo5l0nIVIcXomjLGBXirfwxZwEIxokdFWlXWIEGKES33qGsUiyHGKoI-Imras9RlznoxVBNCJxwp1FzJEiNygz1U6UVqchGFYu4TEtUgvVNz3ZcutKanqjGasVG0QGTk5vqMsrDOM+jBktaozFNWxRoYCgOIuugTDoSarZ2vO9va-MxT0Wx+joS59IGBhHk4k1zPN707roc6jIY-Fq+t56a-2sA5sJMIjnM7pg5duvaHdhvfYYpu6huSg2FzqzWN+X0rbsp5ds7W1ZrtYDa+DPR7vIjMqPL4ybAYgEW7R26amMDhGKsag887l7XpkGd+8BIzU4uHFuLqC3qBGUhRhLsbxviqsJ5CGuXvcODe+OvtTioOdrHZWgF7R5JTWN8i8ZqgYrMuK6eI7idwQhSEiahZUYdwTcU-ollOEMQyaCNReBuG0tWO9TjWKMKzDPuPOqREmEa+b4xAbE-CNDiC1t5jSRlNEYm9wLBlkKuCYIZirOQbG5Y4IC+qQ1MtDXU9IDL7kRubRAWhcRb0DKSNYMh6TFQahVQmV9zqzzfBxP0S4jBDBcFqUYTM5gqCMhqewFd576G2H9IAA */
        id: "Cursor",
        initial: "computing placement",
        states: {
          "moving to target element": {
            invoke: [
              {
                src: "moveCursorToTarget",
                id: "moveCursorToTarget"
              }
            ],
            on: {
              POSITION_CONTAINER: {
                actions: ["updateContainerPosition"],
                internal: true
              }
            },
            entry: "hideCopilot",
            after: {
              translation: "tracing target"
            }
          },
          pinned: {
            entry: ["showMask"],
            exit: ["hideMask"],
            invoke: [
              {
                src: "trackTargetElement",
                id: "trackTargetElement"
              },
              {
                src: "handleTargetClick",
                id: "handleTargetClick"
              }
            ],
            states: {
              shown: {
                initial: "swapping body",
                states: {
                  "swapping body": {
                    after: {
                      crossFade: "idle"
                    }
                  },
                  idle: {
                    invoke: {
                      src: "animateCursor",
                      id: "animateCursor"
                    },
                    on: {
                      POSITION_ARROW: {
                        target: "idle",
                        actions: "updateArrowPosition",
                        internal: true
                      }
                    }
                  }
                },
                on: {
                  HIDE: "hidden"
                }
              },
              hidden: {
                on: {
                  SHOW: "shown.idle"
                }
              },
              history: {
                type: "history",
                history: "deep"
              }
            },
            initial: "shown",
            on: {
              POSITION_CONTAINER: {
                actions: ["updateContainerPosition"],
                target: ".history"
              }
            }
          },
          "computing placement": {
            invoke: {
              src: "adjustPlacement",
              id: "adjustPlacement"
            },
            on: {
              POSITION_CONTAINER: {
                target: "popping in",
                actions: ["updateContainerPosition"]
              }
            }
          },
          "popping in": {
            after: {
              popIn: "scrolling"
            }
          },
          scrolling: {
            invoke: {
              src: "scrollToTargetElement",
              id: "scrollToTargetElement"
            },
            on: {
              FINISHED_SCROLLING: "moving to target element"
            }
          },
          "tracing target": {
            after: {
              tracing: "pinned"
            }
          }
        },
        on: {
          DESTROY: {
            actions: ["removeCursor"]
          }
        },
        schema: {
          events: {},
          context: {}
        },
        predictableActionArguments: true,
        tsTypes: {}
      },
      {
        actions: {
          updateContainerPosition: assign3({
            cursor: ({ cursor: cursor2 }, { coordinates, placement }) => ({
              ...cursor2,
              position: {
                ...cursor2.position,
                container: {
                  coordinates,
                  placement
                }
              }
            })
          }),
          updateArrowPosition: assign3({
            cursor: ({ cursor: cursor2 }, { coordinates }) => ({
              ...cursor2,
              position: {
                ...cursor2.position,
                arrow: {
                  ...cursor2.position.arrow,
                  coordinates
                }
              }
            })
          })
        }
      }
    );
    stateSelectors = {
      hasComputedPlacement: ({ matches }) => !matches("computing placement"),
      isPoppingIn: ({ matches }) => matches("popping in"),
      isMovingToTargetElement: ({ matches }) => matches("moving to target element"),
      isTracingTargetElement: ({ matches }) => matches("tracing target"),
      isSwappingBody: ({ matches }) => matches("pinned.shown.swapping body"),
      isShowingPartialBody: ({ matches }) => matches("popping in") || matches("scrolling") || matches("moving to target element") || matches("tracing target") || matches("pinned.shown.swapping body"),
      isRenderingFullBody: ({ matches }) => matches("pinned"),
      isHidingPin: ({ matches }) => matches("pinned.hidden"),
      isShowingPin: ({ matches }) => matches("pinned.shown")
    };
    CursorMachineContext = createActorContext2(cursorMachine);
    CursorMachineContextProvider = ({
      children,
      offset: _offset,
      anchor,
      handleDestroy,
      startCoordinates,
      shouldShowMask,
      onTargetElementClick
    }) => {
      const hideCopilot = useAction((_) => {
        setHelpHubMinimized(_, true);
      });
      const _cursorRef = useRef22(null);
      return /* @__PURE__ */ React151.createElement(
        CursorMachineContext.Provider,
        {
          options: {
            context: {
              offset: _offset,
              targetElement: getElement(anchor),
              cursor: {
                position: {
                  container: { coordinates: startCoordinates, placement: "right-start" },
                  arrow: { coordinates: [0, 0] }
                },
                ref: _cursorRef
              }
            },
            services: {
              adjustPlacement: ({ targetElement, cursor: cursor2 }) => async (sendBack) => {
                var _a2, _b2;
                const cursorElement = cursor2.ref.current;
                if (!(targetElement && cursorElement && cursor2.ref.current)) {
                  return sendBack({ type: "POSITION_CONTAINER", ...cursor2.position.container });
                }
                const toastContainer = document.getElementById("commandbar-toast-container" /* TOAST_CONTAINER */);
                if (toastContainer) {
                  toastContainer.style.zIndex = `${Z_default.Z_HELPHUB + 1}`;
                }
                const cursorElementWidth = cursor2.ref.current.getBoundingClientRect().width;
                const { computeFinalPosition } = getRelativePosition(targetElement);
                const { placement } = await computeFinalPosition(cursorElement, {
                  mainAxisOffset: -CURSOR_INSET + calcOffsetFromInput((_a2 = _offset == null ? void 0 : _offset.x) != null ? _a2 : "0"),
                  crossAxisOffset: -CURSOR_INSET - calcOffsetFromInput((_b2 = _offset == null ? void 0 : _offset.y) != null ? _b2 : "0"),
                  padding: cursorElementWidth + MIN_MARGIN2
                });
                const updatedCoordinates = placement === "right-start" ? cursor2.position.container.coordinates.map((coord) => coord - MIN_MARGIN2) : [
                  cursor2.position.container.coordinates[0] - cursorElementWidth - MIN_MARGIN2 - CURSOR_INSET,
                  cursor2.position.container.coordinates[1] - MIN_MARGIN2
                ];
                sendBack({
                  type: "POSITION_CONTAINER",
                  placement,
                  coordinates: updatedCoordinates
                });
              },
              scrollToTargetElement: ({ targetElement }) => (sendBack) => {
                if (!targetElement) {
                  return sendBack("DESTROY");
                }
                const targetElRect = targetElement.getBoundingClientRect();
                const parentScrollable = findScrollParent(targetElement);
                if (isElementOffScreen(targetElRect, parentScrollable)) {
                  const elementCenter = getElementCenter(targetElRect);
                  const scrollContainer = parentScrollable || document.documentElement || window;
                  const newScrollPosition = calculateNewScrollPosition(elementCenter, scrollContainer, {
                    isScrollableContainer: !!parentScrollable
                  });
                  let priorCoordinates = [null, null];
                  const interval = setInterval(() => {
                    const updatedCoordinates = [
                      targetElement.getBoundingClientRect().x,
                      targetElement.getBoundingClientRect().y
                    ];
                    const entryIsInSamePosition = priorCoordinates[0] === updatedCoordinates[0] && priorCoordinates[1] === updatedCoordinates[1];
                    if (entryIsInSamePosition) {
                      sendBack("FINISHED_SCROLLING");
                    } else {
                      priorCoordinates = updatedCoordinates;
                    }
                  }, 100);
                  scrollToElement(parentScrollable || window, {
                    behavior: "smooth",
                    left: newScrollPosition.x,
                    top: newScrollPosition.y
                  });
                  return () => {
                    clearInterval(interval);
                  };
                }
                sendBack("FINISHED_SCROLLING");
              },
              moveCursorToTarget: ({ targetElement, cursor: cursor2 }) => async (sendBack) => {
                var _a2, _b2;
                const cursorElement = cursor2.ref.current;
                if (!(targetElement && cursorElement && cursor2.ref.current)) {
                  return sendBack("DESTROY");
                }
                const cursorElementWidth = cursor2.ref.current.getBoundingClientRect().width;
                const { computeFinalPosition } = getRelativePosition(targetElement);
                const {
                  x: endX,
                  y: endY,
                  placement
                } = await computeFinalPosition(cursorElement, {
                  mainAxisOffset: -CURSOR_INSET + calcOffsetFromInput((_a2 = _offset == null ? void 0 : _offset.x) != null ? _a2 : "0"),
                  crossAxisOffset: -CURSOR_INSET - calcOffsetFromInput((_b2 = _offset == null ? void 0 : _offset.y) != null ? _b2 : "0"),
                  padding: cursorElementWidth + MIN_MARGIN2
                });
                sendBack({ type: "POSITION_CONTAINER", coordinates: [endX, endY], placement });
              },
              trackTargetElement: ({ targetElement, offset: _offset2, cursor: cursor2 }) => (sendBack) => {
                var _a2, _b2;
                const cursorElement = cursor2.ref.current;
                if (!(targetElement && cursorElement)) {
                  return sendBack("DESTROY");
                }
                const toastContainer = document.getElementById("commandbar-toast-container" /* TOAST_CONTAINER */);
                if (toastContainer) {
                  toastContainer.style.zIndex = Z_default.Z_NUDGE.toString();
                }
                const mainAxisOffset = -CURSOR_INSET + calcOffsetFromInput((_a2 = _offset2 == null ? void 0 : _offset2.x) != null ? _a2 : "0");
                const crossAxisOffset = -CURSOR_INSET - calcOffsetFromInput((_b2 = _offset2 == null ? void 0 : _offset2.y) != null ? _b2 : "0");
                const updateContainerPosition = async () => {
                  var _a3, _b3, _c2, _d, _e, _f, _g;
                  if (!cursor2.ref.current)
                    return;
                  const cursorElementWidth = cursor2.ref.current.getBoundingClientRect().width;
                  const { initialPlacement, computeFinalPosition } = getRelativePosition(targetElement);
                  const { x, y, placement, middlewareData } = await computeFinalPosition(cursorElement, {
                    mainAxisOffset,
                    crossAxisOffset,
                    padding: cursorElementWidth + MIN_MARGIN2,
                    middleware: [
                      hide2({
                        strategy: "escaped",
                        padding: {
                          top: -calcOffsetFromInput((_a3 = _offset2 == null ? void 0 : _offset2.y) != null ? _a3 : "0"),
                          bottom: calcOffsetFromInput((_b3 = _offset2 == null ? void 0 : _offset2.y) != null ? _b3 : "0"),
                          ...initialPlacement === "right-start" ? {
                            right: -calcOffsetFromInput((_c2 = _offset2 == null ? void 0 : _offset2.x) != null ? _c2 : "0"),
                            left: calcOffsetFromInput((_d = _offset2 == null ? void 0 : _offset2.x) != null ? _d : "0")
                          } : {
                            right: calcOffsetFromInput((_e = _offset2 == null ? void 0 : _offset2.x) != null ? _e : "0"),
                            left: -calcOffsetFromInput((_f = _offset2 == null ? void 0 : _offset2.x) != null ? _f : "0")
                          }
                        }
                      })
                    ]
                  });
                  sendBack({ type: "POSITION_CONTAINER", coordinates: [x, y], placement });
                  if ((_g = middlewareData.hide) == null ? void 0 : _g.escaped) {
                    sendBack("HIDE");
                  } else {
                    sendBack("SHOW");
                  }
                };
                const cleanupCursor = autoUpdate3(targetElement, cursorElement, updateContainerPosition);
                const cleanup2 = () => {
                  cleanupCursor();
                  observer.disconnect();
                  sendBack("DESTROY");
                };
                const observer = new MutationObserver((mutationsList) => {
                  for (const mutation of mutationsList) {
                    if (mutation.type === "childList") {
                      for (const removedNode of mutation.removedNodes) {
                        if (removedNode === targetElement || removedNode.contains(targetElement)) {
                          cleanup2();
                        }
                      }
                    }
                  }
                });
                observer.observe(document.documentElement, { childList: true, subtree: true });
                return () => {
                  cleanup2();
                };
              },
              handleTargetClick: () => () => {
                document.addEventListener("click", onTargetElementClick, true);
                return () => {
                  document.removeEventListener("click", onTargetElementClick, true);
                };
              },
              animateCursor: ({ cursor: cursor2 }, _event) => (sendBack) => {
                const MIN_INTERVAL = 1e3;
                const MAX_INTERVAL = 2e3;
                const UPPER_BOUNDS = 8;
                const LOWER_BOUNDS = -4;
                const MIN_DIFFERENCE = 4;
                const getRandomNumber = boundedRandomNumberGenerator(LOWER_BOUNDS, UPPER_BOUNDS, MIN_DIFFERENCE);
                let timeoutId;
                const updatePosition = () => {
                  const coordinates = [
                    -1 * getRandomNumber.next().value,
                    cursor2.position.container.placement === "right-start" ? -1 * getRandomNumber.next().value : getRandomNumber.next().value
                  ];
                  sendBack({
                    type: "POSITION_ARROW",
                    coordinates
                  });
                  const randomInterval = Math.floor(Math.random() * MAX_INTERVAL) + MIN_INTERVAL;
                  timeoutId = setTimeout(updatePosition, randomInterval);
                };
                timeoutId = setTimeout(updatePosition, Math.floor(Math.random() * MAX_INTERVAL) + MIN_INTERVAL);
                return () => {
                  clearTimeout(timeoutId);
                };
              }
            },
            actions: {
              removeCursor: handleDestroy,
              hideCopilot,
              showMask: ({ targetElement }, _event) => {
                if (!(targetElement && shouldShowMask)) {
                  return;
                }
                showMask(targetElement);
              },
              hideMask
            },
            delays: {
              crossFade: 400,
              translation: TRANSLATE_DURATION,
              popIn: POP_IN_DURATION,
              tracing: TRACING_DURATION
            }
          }
        },
        children
      );
    };
  }
});

// commandbar/src/products/nudges/components/Pin/Cursor/arrow.svg
import * as React152 from "react";
var SvgArrow;
var init_arrow = __esm({
  "commandbar/src/products/nudges/components/Pin/Cursor/arrow.svg"() {
    "use strict";
    SvgArrow = (props2) => /* @__PURE__ */ React152.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 56, height: 60, viewBox: "0 0 56 60", fill: "none", ...props2 }, /* @__PURE__ */ React152.createElement("g", { filter: "url(#filter0_dd_2060_1547)" }, /* @__PURE__ */ React152.createElement("path", { d: "M12.9462 13.2111C12.6856 12.4293 13.4293 11.6856 14.2111 11.9462L43.2264 21.618C44.1557 21.9277 44.1316 23.2504 43.1917 23.5262L29.2847 27.6067C28.958 27.7026 28.7025 27.958 28.6067 28.2847L24.5262 42.1917C24.2504 43.1317 22.9277 43.1557 22.6179 42.2264L12.9462 13.2111Z", fill: "var(--base-accent)" }), /* @__PURE__ */ React152.createElement("path", { d: "M13.4205 13.053C13.2902 12.6621 13.6621 12.2902 14.053 12.4205L43.0683 22.0923C43.5329 22.2472 43.5209 22.9085 43.051 23.0464L29.1439 27.1269C28.6539 27.2707 28.2707 27.6539 28.1269 28.1439L24.0464 42.051C23.9085 42.5209 23.2472 42.533 23.0923 42.0683L13.4205 13.053Z", stroke: "var(--background-primary)" })), /* @__PURE__ */ React152.createElement("defs", null, /* @__PURE__ */ React152.createElement("filter", { id: "filter0_dd_2060_1547", x: 0.893066, y: 4.89319, width: 55.0171, height: 55.017, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ React152.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ React152.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React152.createElement("feOffset", null), /* @__PURE__ */ React152.createElement("feGaussianBlur", { stdDeviation: 1 }), /* @__PURE__ */ React152.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React152.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0" }), /* @__PURE__ */ React152.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_2060_1547" }), /* @__PURE__ */ React152.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }), /* @__PURE__ */ React152.createElement("feOffset", { dy: 5 }), /* @__PURE__ */ React152.createElement("feGaussianBlur", { stdDeviation: 6 }), /* @__PURE__ */ React152.createElement("feComposite", { in2: "hardAlpha", operator: "out" }), /* @__PURE__ */ React152.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" }), /* @__PURE__ */ React152.createElement("feBlend", { mode: "normal", in2: "effect1_dropShadow_2060_1547", result: "effect2_dropShadow_2060_1547" }), /* @__PURE__ */ React152.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_2060_1547", result: "shape" }))));
  }
});

// commandbar/src/products/nudges/components/Pin/Cursor/index.tsx
import { jsx as jsx42, keyframes as keyframes4 } from "@emotion/core";
import React153, { useCallback as useCallback11, useMemo as useMemo7 } from "react";
var ARROW_WIDTH, trace, Arrow2, popOut, ringBorder, Partial, Close2, Header2, ContentThemeWrapper, Content5, popIn, Full, Body, Container7, Cursor;
var init_Cursor = __esm({
  "commandbar/src/products/nudges/components/Pin/Cursor/index.tsx"() {
    "use strict";
    init_BotAvatar();
    init_utils4();
    init_Icon2();
    init_ThemeV2Context();
    init_useMobileExperience();
    init_useStore();
    init_useTheme();
    init_react();
    init_Z();
    init_StyledCloseButtonContainer();
    init_StyledNudgePin();
    init_StyledNudgeStepCounter();
    init_StyledNudgeTitleBlock();
    init_StyledTertiaryIconButton();
    init_Pin();
    init_useLinkClickHandler();
    init_selectors5();
    init_Actions();
    init_ContentContainer();
    init_LayoutTemplate();
    init_RenderNudge();
    init_SurveyResponseProvider();
    init_constants5();
    init_helpers13();
    init_stateMachine();
    init_arrow();
    ARROW_WIDTH = 56;
    trace = keyframes4`
  0% {
    offset-distance: 0%;
  }
  100% {
    offset-distance: 100%;
  }
`;
    Arrow2 = () => {
      const placement = CursorMachineContext.useSelector(({ context }) => context.cursor.position.container.placement);
      const isTracingTargetElement = CursorMachineContext.useSelector(stateSelectors.isTracingTargetElement);
      const isShowingPin = CursorMachineContext.useSelector(stateSelectors.isShowingPin);
      const [x, y] = CursorMachineContext.useSelector(({ context }) => context.cursor.position.arrow.coordinates);
      return /* @__PURE__ */ jsx42(
        SvgArrow,
        {
          style: {
            transition: isShowingPin ? `transform ${SQUIRREL_DURATION}ms cubic-bezier(0.78, -0.28, 0.07, 1)` : void 0,
            transform: placement === "right-start" ? `translate(${roundByDPR(x)}px, ${roundByDPR(y)}px)` : `rotate(90deg) translate(${roundByDPR(x)}px, ${roundByDPR(y)}px)`,
            offsetRotate: "0deg"
          },
          css: isTracingTargetElement ? {
            offsetPath: `path("${generatePathAround(
              50,
              30,
              placement === "right-start" ? "counter-clockwise" : "clockwise"
            )}")`,
            transformOrigin: placement === "right-start" ? "0px 0px" : "-2px 58px",
            animation: `${trace} ${TRACING_DURATION}ms forwards cubic-bezier(0.45, 0, 0.55, 1)`
          } : void 0
        }
      );
    };
    popOut = keyframes4`
  from {
    scale: 1;
    opacity: 100%;
  }
  to {
    scale: 0.8;
    opacity: 20%;
  }
`;
    ringBorder = keyframes4`
  0% {
    scale: 1;
    opacity: 1;
  }
  75%, 100% {
    scale: 1.25;
    opacity: 0;
  }
`;
    Partial = () => {
      var _a2, _b2, _c2;
      const _ = useStore();
      const isPoppingIn = CursorMachineContext.useSelector(stateSelectors.isPoppingIn);
      const isFadingOut = CursorMachineContext.useSelector(stateSelectors.isSwappingBody);
      const placement = CursorMachineContext.useSelector(({ context }) => context.cursor.position.container.placement);
      return /* @__PURE__ */ jsx42(
        "div",
        {
          style: {
            position: "relative",
            gridRowStart: 1,
            gridColumnStart: 1,
            display: "inline-flex",
            padding: "var(--card-padding, 12px)",
            alignItems: "center",
            gap: "var(--card-gap, 8px)",
            borderRadius: placement === "right-start" ? "0px var(--card-radius, 8px) var(--card-radius, 8px) var(--card-radius, 8px)" : "var(--card-radius, 8px) 0px var(--card-radius, 8px) var(--card-radius, 8px)",
            border: "1px solid var(--border-primary, #E2E2E2)",
            background: "var(--background-primary, #FFF)",
            boxShadow: "0px 4px 16px 0px shadow",
            justifySelf: placement === "right-start" ? void 0 : "flex-end",
            transformOrigin: "top left"
          },
          css: {
            animation: isFadingOut ? `${popOut} 200ms forwards cubic-bezier(.42, 0, .59, 1.33)` : void 0,
            "&::before": {
              content: '""',
              width: "100%",
              height: "100%",
              zIndex: -1,
              background: "var(--base-accent)",
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 0,
              borderRadius: placement === "right-start" ? "0px var(--card-radius, 8px) var(--card-radius, 8px) var(--card-radius, 8px)" : "var(--card-radius, 8px) 0px var(--card-radius, 8px) var(--card-radius, 8px)",
              animation: isPoppingIn ? `${ringBorder} 200ms forwards cubic-bezier(0, 0, 0.2, 1)` : void 0
            }
          }
        },
        /* @__PURE__ */ jsx42(
          Icon_default2,
          {
            icon: ((_b2 = (_a2 = _.organization) == null ? void 0 : _a2.copilot_avatar_v2) == null ? void 0 : _b2.src) || ((_c2 = _.organization) == null ? void 0 : _c2.copilot_avatar) || botAvatarDefaultImageSrc,
            style: {
              width: "32px",
              height: "32px"
            }
          }
        ),
        /* @__PURE__ */ jsx42(DotsHorizontal_default, { width: "24px", height: "24px", color: "#7D7C78" })
      );
    };
    Close2 = ({ closeStep: closeStep2 }) => {
      const themeV2 = useThemeV2Context();
      return /* @__PURE__ */ jsx42(StyledCloseButtonContainer_default, null, /* @__PURE__ */ jsx42(StyledTertiaryIconButton_default, { themeV2, "data-testid": "cursor-close" /* Close */, "aria-label": "close", onClick: closeStep2 }, /* @__PURE__ */ jsx42(XClose_default, null)));
    };
    Header2 = ({ title, content, handleLinkClick }) => /* @__PURE__ */ jsx42(StyledNudgeTitleBlock_default, { title, content, handleContentLinkClick: handleLinkClick, dismissible: true });
    ContentThemeWrapper = ({ children, style: style3 }) => {
      var _a2;
      const _ = useStore();
      if ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) {
        return /* @__PURE__ */ jsx42(React153.Fragment, null, children);
      }
      return /* @__PURE__ */ jsx42("div", { style: style3 }, children);
    };
    Content5 = ({ nudge, step, handleLinkClick }) => {
      var _a2, _b2;
      const _ = useStore();
      const { theme } = useTheme();
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const styles51 = getStyles2(
        theme,
        !isMobileDevice2 && step.content.some((block) => (block == null ? void 0 : block.type) === "survey_rating" && block.meta.options === 10)
      );
      const nudgeService = getNudgeService(_, nudge.id);
      const stepIndex = (_b2 = (_a2 = nudgeService == null ? void 0 : nudgeService.getSnapshot()) == null ? void 0 : _a2.context.stepIndex) != null ? _b2 : 0;
      const stepCount = nudge.show_step_counter && stepIndex !== void 0 && nudge.steps.length > 1 ? `${stepIndex + 1}/${nudge.steps.length}` : void 0;
      return /* @__PURE__ */ jsx42(
        ContentThemeWrapper,
        {
          style: {
            display: "flex",
            flexDirection: "column",
            width: "100%",
            padding: styles51.body.padding,
            gap: "8px",
            marginTop: "-22px"
          }
        },
        /* @__PURE__ */ jsx42(
          ContentContainer_default,
          {
            step,
            service: nudgeService,
            markdownStyles: styles51.content,
            primaryButtonStyles: styles51.ctaButton,
            secondaryButtonStyles: styles51.ctaSecondaryButton,
            snoozeButtonStyles: styles51.snoozeButton,
            stepCountStyles: styles51.stepCount,
            stepCount,
            renderMode: 0 /* DEFAULT */,
            snoozable: isNudgeSnoozable(nudge),
            snoozeLabel: nudge.snooze_label,
            handleContentLinkClick: handleLinkClick,
            stepIndex,
            snoozable_on_all_steps: nudge.snoozable_on_all_steps
          }
        )
      );
    };
    popIn = keyframes4`
  from {
    scale: 0.8;
    opacity: 40%;
  }
  to {
    scale: 1;
    opacity: 100%;
  }
`;
    Full = ({ nudge, step }) => {
      var _a2, _b2, _c2, _d;
      const _ = useStore();
      const { send: send2 } = CursorMachineContext.useActorRef();
      const closeStep2 = useCallback11(() => {
        send2("DESTROY");
      }, [send2]);
      const handleLinkClick = useLinkClickHandler(closeStep2);
      const placement = CursorMachineContext.useSelector(({ context }) => context.cursor.position.container.placement);
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const nudgeService = getNudgeService(_, nudge.id);
      const stepIndex = (_b2 = (_a2 = nudgeService == null ? void 0 : nudgeService.getSnapshot()) == null ? void 0 : _a2.context.stepIndex) != null ? _b2 : 0;
      const stepCount = nudge.show_step_counter && stepIndex !== void 0 && nudge.steps.length > 1 ? `${stepIndex + 1}/${nudge.steps.length}` : void 0;
      const close = /* @__PURE__ */ jsx42(Close2, { closeStep: closeStep2 });
      const header = /* @__PURE__ */ jsx42(
        Header2,
        {
          title: step.title,
          content: (_c2 = step.content.find(
            (block) => {
              var _a3;
              return !!((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) && block.type === "markdown";
            }
          )) == null ? void 0 : _c2.meta.value,
          handleLinkClick
        }
      );
      const media = /* @__PURE__ */ jsx42(Content5, { nudge, step, handleLinkClick });
      const actions2 = ((_d = _.flags) == null ? void 0 : _d["release-themes-v2"]) ? /* @__PURE__ */ jsx42(
        Actions,
        {
          step,
          renderMode: 0 /* DEFAULT */,
          snooze: {
            enabled: isNudgeSnoozable(nudge),
            label: nudge.snooze_label,
            enabledOnAllSteps: nudge.snoozable_on_all_steps,
            duration: nudge.snooze_duration
          },
          service: nudgeService,
          stepCount,
          stepIndex
        }
      ) : null;
      const stepCounter = stepCount ? /* @__PURE__ */ jsx42(StyledNudgeStepCounter_default, { stepCount }) : null;
      return /* @__PURE__ */ jsx42(
        StyledNudgePin_default,
        {
          organization: _.organization,
          survey: !!step.content.find((block) => block.type === "survey_rating"),
          "data-testid": "commandbar-nudge-cursor-content" /* Content */,
          "aria-labelledby": "commandbar-nudge-title",
          tabIndex: -1,
          style: {
            gridRowStart: 1,
            gridColumnStart: 1,
            borderTopLeftRadius: placement === "right-start" ? 0 : void 0,
            borderTopRightRadius: placement === "left-start" ? 0 : void 0,
            zIndex: Z_default.Z_HELPHUB + 1,
            transformOrigin: "top left"
          },
          css: {
            animation: `${popIn} 200ms forwards cubic-bezier(.42, 0, .59, 1.33)`
          }
        },
        /* @__PURE__ */ jsx42(SurveyResponseProvider, { service: nudgeService, step }, /* @__PURE__ */ jsx42(
          LayoutTemplate,
          {
            layout: isMobileDevice2 ? "classic" : step.form_factor.layout,
            headerAndMarkdown: header,
            close,
            media,
            footer: null,
            stepCounter,
            actions: actions2,
            columnWidth: "var(--popover-width)"
          }
        ))
      );
    };
    Body = ({ nudge, step }) => {
      const isShowingPartial = CursorMachineContext.useSelector(stateSelectors.isShowingPartialBody);
      const isRenderingFull = CursorMachineContext.useSelector(stateSelectors.isRenderingFullBody);
      const placement = CursorMachineContext.useSelector(({ context }) => context.cursor.position.container.placement);
      return /* @__PURE__ */ jsx42(
        "div",
        {
          style: {
            display: "grid",
            position: "relative",
            placeItems: "start",
            top: "36px",
            marginLeft: placement === "right-start" ? "-18px" : void 0,
            marginRight: placement === "right-start" ? void 0 : "-18px",
            width: "var(--popover-width)"
          }
        },
        isShowingPartial && /* @__PURE__ */ jsx42(Partial, null),
        isRenderingFull && /* @__PURE__ */ jsx42(Full, { nudge, step })
      );
    };
    Container7 = ({ children }) => {
      var _a2;
      const hasComputedPlacement = CursorMachineContext.useSelector(stateSelectors.hasComputedPlacement);
      const isMovingToTargetElement = CursorMachineContext.useSelector(stateSelectors.isMovingToTargetElement);
      const isHidingPin = CursorMachineContext.useSelector(stateSelectors.isHidingPin);
      const [x, y] = CursorMachineContext.useSelector(({ context }) => context.cursor.position.container.coordinates);
      const placement = CursorMachineContext.useSelector(({ context }) => context.cursor.position.container.placement);
      const ref12 = CursorMachineContext.useSelector(({ context }) => context.cursor.ref);
      const calcVisibility = () => {
        if (isHidingPin) {
          return "hidden";
        }
        if (hasComputedPlacement) {
          return "visible";
        }
        return "hidden";
      };
      const cursorWidth = useMemo7(() => {
        var _a3;
        return (_a3 = ref12.current) == null ? void 0 : _a3.getBoundingClientRect().width;
      }, [(_a2 = ref12.current) == null ? void 0 : _a2.getBoundingClientRect]);
      return /* @__PURE__ */ jsx42(
        "div",
        {
          ref: ref12,
          style: {
            display: "flex",
            flexDirection: placement === "right-start" ? "row" : "row-reverse",
            visibility: calcVisibility(),
            transform: `translate(${roundByDPR(x)}px, ${roundByDPR(y)}px)`,
            transition: isMovingToTargetElement ? `transform ${TRANSLATE_DURATION}ms cubic-bezier(0.78, -0.28, 0.07, 1)` : void 0,
            transformOrigin: `${placement === "right-start" ? x : x + (cursorWidth != null ? cursorWidth : 0) + MIN_MARGIN2 + CURSOR_INSET + ARROW_WIDTH}px ${y}px`
          },
          css: {
            animation: hasComputedPlacement ? `${popIn} ${POP_IN_DURATION}ms forwards cubic-bezier(.42, 0, .59, 1.33)` : void 0
          }
        },
        children
      );
    };
    Cursor = ({ nudge, step, handleDestroy, sourceCoordinates, onTargetElementClick }) => /* @__PURE__ */ jsx42(
      CursorMachineContextProvider,
      {
        anchor: step.form_factor.anchor_selector || step.form_factor.anchor,
        offset: step.form_factor.offset,
        startCoordinates: sourceCoordinates,
        handleDestroy,
        shouldShowMask: step.form_factor.is_showing_mask,
        onTargetElementClick
      },
      /* @__PURE__ */ jsx42(BindThemeV2ForNudge, { nudge }, /* @__PURE__ */ jsx42(Container7, null, /* @__PURE__ */ jsx42(Arrow2, null), /* @__PURE__ */ jsx42(Body, { nudge, step })))
    );
  }
});

// commandbar/src/shared/util/hooks/useDraggable.tsx
import { useEffect as useEffect27, useRef as useRef23 } from "react";
var useDraggable, useDraggable_default;
var init_useDraggable = __esm({
  "commandbar/src/shared/util/hooks/useDraggable.tsx"() {
    "use strict";
    init_theme3();
    init_useMobileExperience();
    useDraggable = (element, allowHorizontal = true, allowVertical = true) => {
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const isBeingDragged = useRef23(false);
      const ignoreNextclick = useRef23(false);
      const initialMousePosition = useRef23();
      const initialTranslation = useRef23();
      const initialElementPosition = useRef23();
      useEffect27(() => {
        if (isMobileDevice2)
          return;
        const dragZoneElement = element == null ? void 0 : element.querySelector('[data-draggable="drag-zone"]');
        if (element && dragZoneElement instanceof HTMLElement) {
          const handleDragStart = (mouseDown) => {
            var _a2, _b2, _c2;
            initialMousePosition.current = [mouseDown.pageX, mouseDown.pageY];
            initialElementPosition.current = element.getBoundingClientRect();
            const translationMatrix = (_a2 = window.getComputedStyle(element).transform.match(/matrix.*\((.+)\)/)) == null ? void 0 : _a2[1].split(", ");
            initialTranslation.current = [Number((_b2 = translationMatrix == null ? void 0 : translationMatrix[4]) != null ? _b2 : 0), Number((_c2 = translationMatrix == null ? void 0 : translationMatrix[5]) != null ? _c2 : 0)];
            isBeingDragged.current = true;
          };
          const handleDrag = (mouseMove) => {
            if (isBeingDragged.current && initialMousePosition.current && initialTranslation.current && initialElementPosition.current) {
              dragZoneElement.style.setProperty("cursor", "grabbing");
              element.style.opacity = "0.9";
              const [initialMouseX, initialMouseY] = initialMousePosition.current;
              const [initialTranslationX, initialTranslationY] = initialTranslation.current;
              const distanceToTop = window.scrollY + initialElementPosition.current.top;
              const distanceToLeft = window.scrollX + initialElementPosition.current.left;
              const distanceToRight = document.documentElement.clientWidth - element.clientWidth - distanceToLeft;
              const distanceToBottom = document.documentElement.clientHeight - element.clientHeight - distanceToTop;
              const xDelta = !allowHorizontal ? 0 : Math.min(
                Math.max(
                  window.scrollX + mouseMove.clientX - initialMouseX + initialTranslationX,
                  -distanceToLeft + initialTranslationX + window.scrollX
                ),
                distanceToRight + initialTranslationX + window.scrollX
              );
              const yDelta = !allowVertical ? 0 : Math.min(
                Math.max(
                  window.scrollY + mouseMove.clientY - initialMouseY + initialTranslationY,
                  -distanceToTop + initialTranslationY + window.scrollY
                ),
                distanceToBottom + initialTranslationY + window.scrollY
              );
              if (Math.abs(xDelta) > 5 || Math.abs(yDelta) > 5) {
                ignoreNextclick.current = true;
              }
              element.style.setProperty("transform", `translate(${toPx(xDelta)}, ${toPx(yDelta)})`);
            }
          };
          const handleDragEnd = () => {
            if (isBeingDragged.current && initialMousePosition.current) {
              isBeingDragged.current = false;
              dragZoneElement.style.setProperty("cursor", "move");
              element.style.opacity = "1";
            }
          };
          const handleClick = (e) => {
            if (ignoreNextclick.current) {
              ignoreNextclick.current = false;
              e.stopPropagation();
              return false;
            }
          };
          dragZoneElement.addEventListener("mousedown", handleDragStart);
          document.addEventListener("mousemove", handleDrag);
          document.addEventListener("mouseup", handleDragEnd);
          dragZoneElement.addEventListener("click", handleClick);
          return () => {
            dragZoneElement.removeEventListener("mousedown", handleDragStart);
            dragZoneElement.removeEventListener("click", handleClick);
            document.removeEventListener("mousemove", handleDrag);
            document.removeEventListener("mouseup", handleDragEnd);
          };
        }
      }, [element]);
    };
    useDraggable_default = useDraggable;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgePopover.tsx
import React154 from "react";
import { css as css28, jsx as jsx43 } from "@emotion/core";
var styles19, surveyStyles3, Popover2, StyledNudgePopover, StyledNudgePopover_default;
var init_StyledNudgePopover = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgePopover.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    styles19 = css28({
      display: "flex",
      width: "var(--popover-width)",
      flexDirection: "column",
      alignItems: "flex-start",
      pointerEvents: "all",
      position: "relative",
      borderRadius: "var(--layout-radius-card)",
      border: "1px solid var(--border-primary)",
      background: "var(--background-primary)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)",
      a: {
        color: "var(--content-link)",
        textDecoration: "none",
        "&:hover": {
          color: "var(--content-link-hover)",
          textDecoration: "underline"
        }
      }
    });
    surveyStyles3 = css28({
      minWidth: "var(--popover-width)",
      width: "unset"
    });
    Popover2 = styled_browser_esm_default.div`
  z-index: ${Z_default.Z_NUDGE};
`;
    StyledNudgePopover = React154.forwardRef(
      ({ survey, organization, children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx43(Popover2, { ref: ref12, css: [styles19, survey && surveyStyles3].filter(Boolean), ...props2 }, children);
      }
    );
    StyledNudgePopover_default = StyledNudgePopover;
  }
});

// commandbar/src/products/nudges/components/Popover/Layout.tsx
import React155, { forwardRef as forwardRef9 } from "react";
var Layout2;
var init_Layout2 = __esm({
  "commandbar/src/products/nudges/components/Popover/Layout.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_DraftFooter();
    init_useAction();
    init_useMobileExperience();
    init_useStore();
    init_StyledCloseButtonContainer();
    init_StyledNudgeCloseButton();
    init_StyledNudgePopover();
    init_StyledNudgeStepCounter();
    init_StyledNudgeTitleBlock();
    init_actions6();
    init_selectors5();
    init_Actions();
    init_ContentContainer();
    init_LayoutTemplate();
    init_RenderNudge();
    init_utils4();
    init_AnimatedWidget();
    Layout2 = forwardRef9(
      ({
        nudge,
        step,
        renderMode,
        handleLinkClick,
        stepIndex,
        stepCount,
        styles: styles51,
        className,
        editorAdjustmentStyle,
        center
      }, ref12) => {
        const _ = useStore();
        const themeV2 = useThemeV2Context();
        const nudgeService = renderMode !== 1 /* MOCK */ ? getNudgeService(_, nudge.id) : void 0;
        const { onExit, animStyles } = useAnimatedWidget();
        const dismissCallback = useAction(dismissNudge);
        const dismiss = (nudge2, renderMode2) => {
          onExit(() => {
            dismissCallback(nudge2, renderMode2);
          });
        };
        const { isMobileDevice: isMobileDevice2, mobileStyles } = useMobileExperience();
        const close = isNudgeDismissible(nudge) ? /* @__PURE__ */ React155.createElement(StyledCloseButtonContainer_default, null, /* @__PURE__ */ React155.createElement(StyledNudgeCloseButton_default, { themeV2, onClick: () => dismiss(nudge, renderMode) })) : null;
        const header = /* @__PURE__ */ React155.createElement(
          StyledNudgeTitleBlock_default,
          {
            title: step.title,
            content: getFirstMarkdownBlock(step.content),
            dismissible: isNudgeDismissible(nudge),
            handleContentLinkClick: handleLinkClick,
            draggable: true
          }
        );
        const media = /* @__PURE__ */ React155.createElement(
          ContentContainer_default,
          {
            step,
            stepIndex,
            service: nudgeService,
            markdownStyles: styles51.content,
            primaryButtonStyles: styles51.ctaButton,
            secondaryButtonStyles: styles51.ctaSecondaryButton,
            snoozeButtonStyles: styles51.snoozeButton,
            stepCountStyles: styles51.stepCount,
            stepCount,
            renderMode,
            snoozable: isNudgeSnoozable(nudge),
            snoozeLabel: nudge.snooze_label,
            snoozable_on_all_steps: nudge.snoozable_on_all_steps,
            handleContentLinkClick: handleLinkClick
          }
        );
        const stepCounter = stepCount ? /* @__PURE__ */ React155.createElement(StyledNudgeStepCounter_default, { stepCount }) : null;
        const actions2 = /* @__PURE__ */ React155.createElement(
          Actions,
          {
            step,
            stepIndex,
            renderMode,
            snooze: {
              enabled: isNudgeSnoozable(nudge),
              label: nudge.snooze_label,
              enabledOnAllSteps: nudge.snoozable_on_all_steps,
              duration: nudge.snooze_duration
            },
            service: nudgeService,
            stepCount
          }
        );
        const footer = !nudge.is_live && renderMode === 1 /* MOCK */ ? /* @__PURE__ */ React155.createElement(DraftFooter, { details: { type: "nudge", nudge, stepIndex } }) : null;
        const defaultContainerStyles = () => {
          const width = (() => {
            if (step.form_factor.layout === "horizontal") {
              return "auto";
            }
            if (step.form_factor.type === "modal") {
              return "var(--modal-width)";
            }
            return void 0;
          })();
          return {
            ...center && {
              top: "50vh",
              transform: "translate(0, -50%)"
            },
            ...editorAdjustmentStyle,
            width,
            maxWidth: step.form_factor.layout === "horizontal" ? "100%" : void 0
          };
        };
        return /* @__PURE__ */ React155.createElement(
          StyledNudgePopover_default,
          {
            organization: _.organization,
            survey: !!step.content.find((block) => block.type === "survey_rating"),
            "data-testid": `commandbar-popover-${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
            key: step.id,
            ref: ref12,
            className,
            style: {
              ...isMobileDevice2 ? mobileStyles.nudges.popoverMobileThemesV2.container : defaultContainerStyles(),
              ...animStyles
            }
          },
          /* @__PURE__ */ React155.createElement(
            LayoutTemplate,
            {
              layout: isMobileDevice2 ? "classic" : step.form_factor.layout,
              headerAndMarkdown: header,
              close,
              media,
              footer,
              actions: actions2,
              stepCounter,
              columnWidth: step.form_factor.type === "modal" ? "var(--modal-width)" : "var(--popover-width)"
            }
          )
        );
      }
    );
  }
});

// commandbar/src/products/nudges/components/Popover/index.tsx
import { jsx as jsx44 } from "@emotion/core";
import { useTheme as useTheme9 } from "emotion-theming";
import React156, { forwardRef as forwardRef10 } from "react";
var getStyles3, Popover3, DraggablePopover;
var init_Popover = __esm({
  "commandbar/src/products/nudges/components/Popover/index.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_Z();
    init_LocalStorage();
    init_location();
    init_DraftFooter();
    init_editorUtils();
    init_useAction();
    init_useDraggable();
    init_useMobileExperience();
    init_useStore();
    init_useLinkClickHandler();
    init_actions6();
    init_selectors5();
    init_nudges();
    init_CloseButton();
    init_ContentContainer();
    init_RenderNudge();
    init_SurveyResponseProvider();
    init_Layout2();
    init_AnimatedWidget();
    getStyles3 = (theme, autoWidth) => ({
      container: {
        width: autoWidth ? "auto" : theme.nudges.width,
        display: "flex",
        flexDirection: "column",
        background: theme.nudges.background,
        borderRadius: theme.nudges.borderRadius,
        color: theme.nudges.color,
        zIndex: Z_default.Z_COMMANDBAR - 2,
        boxShadow: theme.nudges.boxShadow,
        fontFamily: theme.nudges.fontFamily,
        transition: "opacity 0.15s ease-in-out",
        pointerEvents: "all"
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        padding: `16px 16px ${theme.nudges.gap}`
      },
      title: {
        fontFamily: theme.nudges.titleFontFamily,
        fontSize: theme.nudges.titleFontSize,
        fontWeight: theme.nudges.titleFontWeight,
        lineHeight: theme.nudges.titleLineHeight,
        color: theme.nudges.titleColor,
        zIndex: Z_default.Z_COMMANDBAR - 1,
        cursor: "auto"
      },
      content: {
        fontFamily: theme.nudges.contentFontFamily,
        color: theme.nudges.contentColor,
        fontSize: theme.nudges.contentFontSize,
        fontWeight: theme.nudges.contentFontWeight,
        lineHeight: theme.nudges.contentLineHeight
      },
      body: {
        display: "flex",
        flexDirection: "column",
        padding: theme.nudges.padding,
        gap: theme.nudges.gap
      },
      dragZone: {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: parseInt(theme.nudges.titleFontSize, 10) + parseInt(theme.nudges.padding, 10) * 1.5,
        padding: theme.nudges.padding,
        borderTopLeftRadius: theme.nudges.borderRadius,
        borderTopRightRadius: theme.nudges.borderRadius,
        userSelect: "none",
        cursor: "move"
      },
      ctaButton: {
        fontFamily: theme.nudges.ctaFontFamily,
        padding: theme.nudges.ctaPadding,
        background: theme.nudges.ctaBackground,
        color: theme.nudges.ctaColor,
        border: theme.nudges.ctaBorder,
        boxShadow: theme.nudges.ctaBoxShadow,
        textShadow: theme.nudges.ctaTextShadow,
        borderRadius: theme.nudges.ctaBorderRadius,
        fontSize: theme.nudges.ctaFontSize,
        lineHeight: theme.nudges.ctaLineHeight,
        fontWeight: theme.nudges.ctaFontWeight
      },
      ctaSecondaryButton: {
        fontFamily: theme.nudges.ctaSecondaryFontFamily,
        padding: theme.nudges.ctaSecondaryPadding,
        background: theme.nudges.ctaSecondaryBackground,
        color: theme.nudges.ctaSecondaryColor,
        border: theme.nudges.ctaSecondaryBorder,
        boxShadow: theme.nudges.ctaSecondaryBoxShadow,
        textShadow: theme.nudges.ctaSecondaryTextShadow,
        borderRadius: theme.nudges.ctaSecondaryBorderRadius,
        fontSize: theme.nudges.ctaSecondaryFontSize,
        lineHeight: theme.nudges.ctaSecondaryLineHeight,
        fontWeight: theme.nudges.ctaSecondaryFontWeight
      },
      snoozeButton: {
        background: theme.nudges.snoozeButtonBackground,
        fontFamily: theme.nudges.snoozeButtonFontFamily,
        color: theme.nudges.snoozeButtonColor,
        border: theme.nudges.snoozeButtonBorder,
        textShadow: theme.nudges.snoozeButtonTextShadow,
        fontSize: theme.nudges.snoozeButtonFontSize,
        lineHeight: theme.nudges.snoozeButtonLineHeight,
        fontWeight: theme.nudges.snoozeButtonFontWeight,
        width: theme.nudges.snoozeButtonWidth
      },
      closeButtonOverrides: {
        position: "absolute",
        top: "16px",
        right: "16px"
      },
      stepCount: {
        fontFamily: theme.nudges.stepCountFontFamily,
        color: theme.nudges.stepCountColor,
        fontSize: theme.nudges.stepCountFontSize,
        fontWeight: theme.nudges.stepCountFontWeight
      }
    });
    Popover3 = forwardRef10(
      ({ renderMode, nudge, stepIndex, center, stepCount, preventRepositionOnEditorOpen }, popoverRef) => {
        var _a2;
        const _ = useStore();
        const { theme } = useTheme9();
        const { isMobileDevice: isMobileDevice2, mobileStyles } = useMobileExperience();
        const step = getNudgeStep(nudge, stepIndex);
        const styles51 = getStyles3(
          theme,
          !isMobileDevice2 && !!(step == null ? void 0 : step.content.some((block) => (block == null ? void 0 : block.type) === "survey_rating" && block.meta.options === 10))
        );
        const getService = (id2) => getNudgeService(_, id2);
        const { onExit } = useAnimatedWidget();
        const dismissAction = useAction(dismissNudge);
        const dismiss = (nudge2, renderMode2) => {
          onExit(() => dismissAction(nudge2, renderMode2));
        };
        const handleLinkClick = useLinkClickHandler(() => dismiss(nudge, renderMode));
        const service = renderMode !== 1 /* MOCK */ ? getService(nudge.id) : void 0;
        const editorWidth = Number(LocalStorage_default.get("width", "770"));
        const editorOpen = Number(LocalStorage_default.get("editor.open", false)) && isEditorOpen() && !isStudioPreview() && !preventRepositionOnEditorOpen;
        if (step) {
          const className = (() => {
            const formFactor = step.form_factor;
            if (!isStudioPreview() && formFactor.type === "popover") {
              if (formFactor.position.includes("right")) {
                return "commandbar-popover-nudge-right";
              } else if (formFactor.position === "center") {
                return "commandbar-popover-nudge-center";
              }
            }
            return "";
          })();
          const editorAdjustment = {
            open: {
              right: { right: `${editorWidth + 16}px` },
              center: {
                right: `${(editorWidth + 16) / 2}px`
              }
            },
            closed: {
              right: { right: "0" },
              center: { right: void 0 },
              standaloneEditor: {
                top: "calc(50vh - 51px)",
                right: "50%",
                transform: "translate(50%, -50%)",
                position: "absolute"
              }
            }
          };
          const isRightPositioned = step.form_factor.type === "popover" && step.form_factor.position.includes("right");
          const isCenterPositioned = step.form_factor.type === "popover" && step.form_factor.position === "center" || step.form_factor.type === "modal";
          const editorAdjustmentStyle = !_.showWidgetTableau ? editorAdjustment[editorOpen ? "open" : "closed"][isStudioPreview() ? "standaloneEditor" : isCenterPositioned ? "center" : isRightPositioned ? "right" : ""] : void 0;
          return /* @__PURE__ */ jsx44(SurveyResponseProvider, { service, step }, ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx44(
            Layout2,
            {
              ref: popoverRef,
              nudge,
              step,
              renderMode,
              service,
              handleLinkClick,
              className,
              stepIndex,
              styles: styles51,
              center,
              stepCount,
              editorAdjustmentStyle
            }
          ) : /* @__PURE__ */ jsx44(
            "div",
            {
              "data-testid": `commandbar-popover-${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
              key: step.id,
              ref: popoverRef,
              className,
              "aria-labelledby": "commandbar-nudge-title",
              style: isMobileDevice2 ? mobileStyles.nudges.popover.container : {
                maxHeight: "90vh",
                maxWidth: "90vw",
                position: "relative",
                ...center && {
                  top: "50vh",
                  transform: "translate(0, -50%)"
                },
                ...styles51.container,
                ...editorAdjustmentStyle
              }
            },
            /* @__PURE__ */ jsx44("div", { style: styles51.header }, /* @__PURE__ */ jsx44("div", { "data-draggable": "drag-zone", "data-testid": "drag-zone", style: styles51.dragZone }), /* @__PURE__ */ jsx44("span", { id: "commandbar-nudge-title", style: styles51.title, role: "heading", "aria-level": 3 }, step.title), isNudgeDismissible(nudge) && /* @__PURE__ */ jsx44(CloseButton_default, { onInteraction: () => dismiss(nudge, renderMode) })),
            /* @__PURE__ */ jsx44(
              "div",
              {
                "data-testid": "commandbar-nudge-popover-body",
                style: {
                  ...styles51.body,
                  overflow: "auto"
                }
              },
              /* @__PURE__ */ jsx44(
                ContentContainer_default,
                {
                  step,
                  service,
                  markdownStyles: styles51.content,
                  primaryButtonStyles: styles51.ctaButton,
                  secondaryButtonStyles: styles51.ctaSecondaryButton,
                  snoozeButtonStyles: styles51.snoozeButton,
                  stepCountStyles: styles51.stepCount,
                  stepCount,
                  renderMode,
                  snoozable: isNudgeSnoozable(nudge),
                  snoozeLabel: nudge.snooze_label,
                  handleContentLinkClick: handleLinkClick,
                  stepIndex,
                  snoozable_on_all_steps: nudge.snoozable_on_all_steps
                }
              )
            ),
            !nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ jsx44(DraftFooter, { details: { type: "nudge", nudge, stepIndex } })
          ));
        }
        return null;
      }
    );
    DraggablePopover = (props2) => {
      const [ref12, setRef] = React156.useState(null);
      useDraggable_default(ref12);
      const step = getNudgeStep(props2.nudge, props2.stepIndex);
      const position = (step == null ? void 0 : step.form_factor.type) === "popover" ? step.form_factor.position : void 0;
      return /* @__PURE__ */ jsx44(BindThemeV2ForNudge, { nudge: props2.nudge }, /* @__PURE__ */ jsx44(AnimatedWidget, { widget: "popover", isMounted: true, enterDelay: 1, position }, /* @__PURE__ */ jsx44(Popover3, { ref: setRef, ...props2 })));
    };
  }
});

// commandbar/src/products/nudges/components/Tooltip/constants.ts
var init_constants6 = __esm({
  "commandbar/src/products/nudges/components/Tooltip/constants.ts"() {
    "use strict";
  }
});

// commandbar/src/products/nudges/components/Tooltip/styles.ts
var useStyles2, styles_default;
var init_styles = __esm({
  "commandbar/src/products/nudges/components/Tooltip/styles.ts"() {
    "use strict";
    init_useTheme();
    init_Z();
    init_theme3();
    useStyles2 = () => {
      const { theme } = useTheme();
      return {
        container: {
          alignItems: "center",
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          zIndex: Z_default.Z_NUDGE - 1,
          boxShadow: theme.nudgeTooltip.boxShadow,
          borderRadius: theme.nudgeTooltip.borderRadius,
          backgroundColor: theme.nudgeTooltip.background,
          fontFamily: theme.nudgeTooltip.fontFamily,
          color: theme.nudgeTooltip.color
        },
        body: {
          display: "flex",
          flexDirection: "column",
          padding: theme.nudgeTooltip.padding,
          gap: theme.nudgeTooltip.gap
        },
        header: { display: "flex", justifyContent: "space-between", alignItems: "center", gap: "16px" },
        closeButton: {
          width: "12px",
          height: "12px",
          transition: `opacity ${theme.main.transitionTime} ease-in`,
          flexShrink: 0,
          alignSelf: "flex-start",
          color: theme.nudges.closeButtonColor,
          "&:hover": {
            color: theme.nudges.closeButtonHoverColor
          }
        },
        title: {
          fontFamily: theme.nudgeTooltip.titleFontFamily,
          fontWeight: theme.nudgeTooltip.titleFontWeight,
          fontSize: theme.nudgeTooltip.titleFontSize,
          lineHeight: theme.nudgeTooltip.titleLineHeight,
          color: theme.nudgeTooltip.titleColor
        },
        content: {
          fontFamily: theme.nudgeTooltip.contentFontFamily,
          fontWeight: theme.nudgeTooltip.contentFontWeight,
          fontSize: theme.nudgeTooltip.contentFontSize,
          lineHeight: theme.nudgeTooltip.contentLineHeight,
          color: theme.nudgeTooltip.contentColor
        },
        ctaButton: {
          padding: theme.nudgeTooltip.ctaPadding,
          background: theme.nudgeTooltip.ctaBackground,
          color: theme.nudgeTooltip.ctaColor,
          border: theme.nudgeTooltip.ctaBorder,
          boxShadow: theme.nudgeTooltip.ctaBoxShadow,
          textShadow: theme.nudgeTooltip.ctaTextShadow,
          borderRadius: theme.nudgeTooltip.ctaBorderRadius,
          fontFamily: theme.nudgeTooltip.ctaFontFamily,
          fontSize: theme.nudgeTooltip.ctaFontSize,
          lineHeight: theme.nudgeTooltip.ctaLineHeight,
          fontWeight: theme.nudgeTooltip.ctaFontWeight
        },
        ctaSecondaryButton: {
          fontFamily: theme.nudgeTooltip.ctaSecondaryFontFamily,
          padding: theme.nudgeTooltip.ctaSecondaryPadding,
          background: theme.nudgeTooltip.ctaSecondaryBackground,
          color: theme.nudgeTooltip.ctaSecondaryColor,
          border: theme.nudgeTooltip.ctaSecondaryBorder,
          boxShadow: theme.nudgeTooltip.ctaSecondaryBoxShadow,
          textShadow: theme.nudgeTooltip.ctaSecondaryTextShadow,
          borderRadius: theme.nudgeTooltip.ctaSecondaryBorderRadius,
          fontSize: theme.nudgeTooltip.ctaSecondaryFontSize,
          lineHeight: theme.nudgeTooltip.ctaSecondaryLineHeight,
          fontWeight: theme.nudgeTooltip.ctaSecondaryFontWeight
        },
        snoozeButton: {
          background: theme.nudgeTooltip.snoozeButtonBackground,
          fontFamily: theme.nudgeTooltip.snoozeButtonFontFamily,
          color: theme.nudgeTooltip.snoozeButtonColor,
          border: theme.nudgeTooltip.snoozeButtonBorder,
          textShadow: theme.nudgeTooltip.snoozeButtonTextShadow,
          fontSize: theme.nudgeTooltip.snoozeButtonFontSize,
          lineHeight: theme.nudgeTooltip.snoozeButtonLineHeight,
          fontWeight: theme.nudgeTooltip.snoozeButtonFontWeight,
          width: theme.nudgeTooltip.snoozeButtonWidth
        },
        closeButtonOverrides: {
          position: "absolute",
          top: "16px",
          right: "16px"
        },
        beaconOuter: {
          position: "relative",
          borderRadius: "100%",
          width: toPx(theme.nudgeTooltip.markerBeaconSize),
          height: toPx(theme.nudgeTooltip.markerBeaconSize),
          backgroundColor: theme.nudgeTooltip.markerBeaconColor,
          zIndex: Z_default.Z_NUDGE,
          pointerEvents: "none"
        },
        beaconHoverTarget: {
          position: "absolute",
          width: "100%",
          height: "100%",
          pointerEvents: "auto"
        },
        beaconInner: {
          borderRadius: "100%",
          width: toPx(theme.nudgeTooltip.markerBeaconSize),
          height: toPx(theme.nudgeTooltip.markerBeaconSize),
          backgroundColor: theme.nudgeTooltip.markerBeaconColor,
          position: "absolute",
          animationDuration: "1.5s",
          animationTimingFunction: "cubic-bezier(0, 0, 0.2, 1)",
          animationDelay: "0s",
          animationIterationCount: "infinite",
          animationDirection: "normal",
          animationFillMode: "none",
          animationPlayState: "running",
          animationName: "ping",
          "@keyframes ping": {
            "75%, to": {
              transform: `scale(${theme.nudgeTooltip.markerBeaconPulseScale})`,
              opacity: 0
            }
          }
        },
        image: {
          display: "flex"
        },
        imageHoverTarget: {
          pointerEvents: "auto"
        },
        iconHoverTarget: {
          border: "none",
          display: "flex",
          background: "none",
          padding: 0,
          position: "relative",
          pointerEvents: "auto",
          width: theme.nudgeTooltip.markerIconSize,
          height: theme.nudgeTooltip.markerIconSize
        },
        stepCount: {
          color: theme.nudgeTooltip.stepCountColor,
          fontFamily: theme.nudgeTooltip.stepCountFontFamily,
          fontSize: theme.nudgeTooltip.stepCountFontSize,
          fontWeight: theme.nudgeTooltip.stepCountFontWeight
        }
      };
    };
    styles_default = useStyles2;
  }
});

// commandbar/src/products/nudges/components/Tooltip/Layout.tsx
import React157 from "react";
var Layout3;
var init_Layout3 = __esm({
  "commandbar/src/products/nudges/components/Tooltip/Layout.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_DraftFooter();
    init_popover();
    init_useMobileExperience();
    init_useStore();
    init_react();
    init_StyledNudgeStepCounter();
    init_StyledNudgeTitleBlock();
    init_StyledTooltip();
    init_selectors5();
    init_Actions();
    init_ContentContainer();
    init_LayoutTemplate();
    init_RenderNudge();
    init_utils4();
    init_constants6();
    init_styles();
    Layout3 = ({
      nudge,
      step,
      renderMode,
      handleLinkClick,
      stepIndex,
      stepCount,
      isVisible: isVisible2 = true
    }) => {
      var _a2;
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const styles51 = styles_default();
      const nudgeService = renderMode !== 1 /* MOCK */ ? getNudgeService(_, nudge.id) : void 0;
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const close = /* @__PURE__ */ React157.createElement(PopoverClose, { "data-testid": "commandbar-nudge-tooltip-close" /* Close */ }, /* @__PURE__ */ React157.createElement(XClose_default, null));
      const header = /* @__PURE__ */ React157.createElement(
        StyledNudgeTitleBlock_default,
        {
          title: step.title,
          content: getFirstMarkdownBlock(step.content),
          handleContentLinkClick: handleLinkClick,
          dismissible: true
        }
      );
      const media = /* @__PURE__ */ React157.createElement(
        ContentContainer_default,
        {
          step,
          stepIndex,
          stepCount,
          service: nudgeService,
          markdownStyles: styles51.content,
          primaryButtonStyles: styles51.ctaButton,
          secondaryButtonStyles: styles51.ctaSecondaryButton,
          snoozeButtonStyles: styles51.snoozeButton,
          stepCountStyles: styles51.stepCount,
          renderMode,
          snoozable: isNudgeSnoozable(nudge),
          snoozeLabel: nudge.snooze_label,
          snoozable_on_all_steps: nudge.snoozable_on_all_steps,
          handleContentLinkClick: handleLinkClick
        }
      );
      const stepCounter = stepCount ? /* @__PURE__ */ React157.createElement(StyledNudgeStepCounter_default, { stepCount }) : null;
      const actions2 = /* @__PURE__ */ React157.createElement(
        Actions,
        {
          step,
          stepIndex,
          renderMode,
          snooze: {
            enabled: isNudgeSnoozable(nudge),
            label: nudge.snooze_label,
            enabledOnAllSteps: nudge.snoozable_on_all_steps,
            duration: nudge.snooze_duration
          },
          service: nudgeService,
          stepCount
        }
      );
      const footer = !nudge.is_live && renderMode === 1 /* MOCK */ ? /* @__PURE__ */ React157.createElement(DraftFooter, { details: { type: "nudge", nudge, stepIndex } }) : null;
      return /* @__PURE__ */ React157.createElement(BindThemeV2ForNudge, { nudge }, /* @__PURE__ */ React157.createElement(
        StyledTooltip_default,
        {
          variant: step.content.find((block) => block.type === "survey_rating") ? "survey" : "default",
          key: step.id,
          themeV2,
          style: {
            pointerEvents: isVisible2 ? "auto" : "none",
            ...step.form_factor.layout === "horizontal" && !isMobileDevice2 ? {
              width: "auto",
              maxWidth: "calc(var(--tooltip-max-width) * 2)"
            } : {}
          },
          arrow: (_a2 = _.flags) == null ? void 0 : _a2["release-nudge-arrows"]
        },
        /* @__PURE__ */ React157.createElement(
          LayoutTemplate,
          {
            layout: isMobileDevice2 ? "classic" : step.form_factor.layout,
            headerAndMarkdown: header,
            close,
            media,
            footer,
            actions: actions2,
            stepCounter,
            columnWidth: "var(--tooltip-max-width)"
          }
        )
      ));
    };
  }
});

// commandbar/src/products/nudges/components/Tooltip/icons.tsx
import React158 from "react";
var iconTypes, Icon2;
var init_icons = __esm({
  "commandbar/src/products/nudges/components/Tooltip/icons.tsx"() {
    "use strict";
    init_useTheme();
    init_react();
    iconTypes = {
      bookClosed: BookClosed_default,
      helpCircle: HelpCircle_default,
      helpSquare: HelpSquare_default,
      infoCircle: InfoCircle_default,
      lightBulb: Lightbulb04_default,
      lightning: Lightning01_default
    };
    Icon2 = ({ type: type39 }) => {
      const { theme } = useTheme();
      const SvgIcon = iconTypes[type39];
      return /* @__PURE__ */ React158.createElement(SvgIcon, { color: theme.nudgeTooltip.markerIconColor, size: theme.nudgeTooltip.markerImageSize });
    };
  }
});

// commandbar/src/products/nudges/components/Tooltip/state.tsx
import { arrow as arrow2, autoUpdate as autoUpdate4, computePosition as computePosition4, hide as hide3, offset as offset5 } from "@floating-ui/dom";
import { createActorContext as createActorContext3 } from "@xstate/react";
import debounce2 from "lodash/debounce";
import React159, { useRef as useRef24 } from "react";
import { assign as assign4, createMachine as createMachine4 } from "xstate";
var setupDomObserver, setupTargetObserver, tooltipMachine, stateSelectors2, TooltipMachineContext, TooltipMachineContextProvider;
var init_state3 = __esm({
  "commandbar/src/products/nudges/components/Tooltip/state.tsx"() {
    "use strict";
    init_useStore();
    init_dom();
    init_dom();
    init_location();
    init_nudges();
    init_RenderNudge();
    init_constants6();
    setupDomObserver = (targetElement, onRemoval) => {
      const handleDomMutations = (mutationList) => {
        for (const mutation of mutationList) {
          if (isWithinCommandBar(mutation.target) || Array.from(mutation.addedNodes).some(isWithinCommandBar) || Array.from(mutation.removedNodes).some(isWithinCommandBar))
            return;
          switch (mutation.type) {
            case "childList": {
              for (const removedNode of mutation.removedNodes) {
                if (removedNode === targetElement || removedNode.contains(targetElement)) {
                  onRemoval();
                }
              }
              break;
            }
            case "attributes": {
              if (!fastIsElementVisible(targetElement)) {
                onRemoval();
              }
              break;
            }
            default:
              break;
          }
        }
      };
      const domObserver = new MutationObserver(handleDomMutations);
      domObserver.observe(document.documentElement, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style", "class"]
      });
      return domObserver;
    };
    setupTargetObserver = (anchor, targetElement, onRemoval) => {
      const handleTargetMutations = (mutationsList) => {
        for (const _ of mutationsList) {
          if (getElement(anchor))
            return;
          onRemoval();
        }
      };
      const targetObserver = new MutationObserver(handleTargetMutations);
      targetObserver.observe(targetElement, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
      return targetObserver;
    };
    tooltipMachine = createMachine4(
      {
        /** @xstate-layout N4IgpgJg5mDOIC5QBUD2qA2AXAlgBwGIARAUQGVkAlAeQE0BtABgF1FQ9VYddUA7NkAA9EARgBMYgOwA6AGwBmBbICsYgCwAOZSMkAaEAE9EAWjUTpATkaMJIjfKkORAX2f60mXHmk4IGMARMrEggHFw8-CHCCGqy0moiypIadozyjLIiahb6Rgh28tIZDiqqjBpiGuWu7ujY+D5+AfQiweyc3Dh8AtFmccryVpKDsWIWA-K5iGJ20vIiDpJJqiJZjJI1IB713gCGvADGABaoAE44vFAEAArUZACSyPfUAHJBAmGd3VGIGpJi0mUFjU8iqqmU2T0hhMOmkkjUEIkslkFhU62qbi2dS80n2xzOFyuyAAgpQAOIkZAAfRIABkSABZEgvamURnUABqJCI7xCnwiPUQyI0gLEynKY3FAxEsimCGM42kGhRGhBFnEBUqm22OLxJ3Ol2ksBOAHdeAQABL3Ui89rhLqRUDRcSxIricqgjQWMSyLRy4xe+IKSSyMzjMTyCHKbXYhp6gmGo6+CBgc1kC3UADqttCHQFP3yIkYFjmY0kSyyQOUyv9iThS3VCSq8hDNhjngaFwwF0JjX8BGJZAeZJeVMzlGJ12uJEoOf5DsFhak0gWC1kGSBamKcrUkhEc2R8l383XFnVG0xOoaJt2nUuAAIAGZne9YXanGBYe9gfwAW1TWAEAAYtQACqLxEFSJLkpSNL0kyLJznmC4FkWSRFKoW4aCkGTIlCeQzHExSVF6shiIwqiqu2OzSDed5QE+L5vh+YBfj+YD-rwgEgeBkHQRS1J0oyzLIC0bS5va3xOqI6IYeoPrJEeKJiHKGpFOUGT2HYCRmBetQdt4XY9pcBD8bBQkIay7JcjyLAfMhUlCEKvqiuKkiotYjAIju2hFN6FiDKoLa4a4mK8KgKbwCEV54PZkmOk58r7tWZh2CIqIBVo5T+vM+6xC2CjKgoyhudROK+P4cVfAlzrenIKjJAsijjN6aiqTK0jqKMMqMOl6iKGVDQHABYCnJAVX5tJ+TKHE9gtmoC0Bas4waHK8yFD6wItloYyonpWIGbihz6oSE0oVNRaZKWFjltoCIrbK0LyhIhSoi2wyhoMQyDXsx0JlARqmgl86Oc66j7go8wQgswJFipT3GHWt2NqkLZAhkP1HfiBoA0mEApsDDk1aIRYlhYFSrJIaRbrI7n+oG+UhmGQVRpjRm8KdfJE4uqJxAk4jueusQQpMT3yIoSqHlkyKxFRl6xoZvDdhzhoVWAZ2gzJWTxKsUgecLII7sCcxhlDKTiJk0by4d7O9uz41c-Fi4LBCnV7iiu6ZEeaRG4UxZljd5b2GesiY3RuAPs+pyvu+n7fn+AEa8TCDrjIWgOGM4gVMkORPQURQKGWqwJCLYihc4QA */
        id: "Tooltip",
        initial: "idle",
        states: {
          idle: {
            always: [
              {
                target: "centered",
                cond: "shouldCenter",
                description: "This is the case when we are editing a step in the studio or with the extension and the target element is unavailable."
              },
              "waiting for target element"
            ]
          },
          centered: {
            type: "final"
          },
          anchoring: {
            initial: "hidden",
            invoke: [
              {
                src: "trackTargetElement",
                id: "trackTargetElement"
              }
            ],
            states: {
              shown: {
                on: {
                  HIDE: {
                    target: "#Tooltip.anchoring.hidden"
                  }
                }
              },
              hidden: {
                on: {
                  SHOW: "shown"
                }
              }
            },
            on: {
              POSITION: {
                actions: ["updatePosition"]
              },
              TARGET_ELEMENT_REMOVED: "waiting for target element"
            }
          },
          inlining: {
            invoke: {
              src: "wrapTargetElement",
              id: "wrapTargetElement"
            },
            states: {
              idle: {
                on: {
                  ASSIGN_WRAPPER: {
                    target: "inlined",
                    actions: ["assignInlineWrapper"]
                  }
                }
              },
              inlined: {
                type: "final"
              }
            },
            initial: "idle",
            on: {
              TARGET_ELEMENT_REMOVED: "waiting for target element"
            }
          },
          "waiting for target element": {
            on: {
              TARGET_ELEMENT_FOUND: [
                {
                  target: "inlining",
                  cond: "isInlineAligned"
                },
                "anchoring"
              ]
            },
            invoke: {
              src: "waitForTargetElement",
              id: "waitForTargetElement"
            }
          }
        },
        on: {
          DESTROY: {
            actions: ["removeTooltip"]
          }
        },
        schema: {
          events: {},
          context: {}
        },
        predictableActionArguments: true,
        tsTypes: {}
      },
      {
        actions: {
          updatePosition: assign4({
            marker: ({ marker }, { position }) => ({
              ...marker,
              position
            })
          }),
          assignInlineWrapper: assign4({
            inlineWrapperElement: (_, { inlineWrapperElement }) => inlineWrapperElement
          })
        }
      }
    );
    stateSelectors2 = {
      isIdle: ({ matches }) => matches("idle"),
      isMarkerAnchored: ({ matches }) => matches("anchoring.shown"),
      isMarkerInlined: ({ matches, context }) => matches("inlining.inlined") && !!context.inlineWrapperElement,
      isMarkerCentered: ({ matches }) => matches("centered"),
      isMarkerPositioned: ({ matches }) => matches("anchoring.shown") || matches("centered")
    };
    TooltipMachineContext = createActorContext3(tooltipMachine);
    TooltipMachineContextProvider = ({
      children,
      renderMode,
      offset: _offset,
      alignment,
      anchor,
      handleDestroy
    }) => {
      const { showWidgetTableau: showWidgetTableau2 } = useStore();
      const markerRef = useRef24(null);
      return /* @__PURE__ */ React159.createElement(
        TooltipMachineContext.Provider,
        {
          options: {
            guards: {
              shouldCenter: ({ anchor: anchor2 }) => !showWidgetTableau2 && isStudioPreview() || renderMode === 1 /* MOCK */ && !getElement(anchor2),
              isInlineAligned: () => alignment === "inline_left" || alignment === "inline_right"
            },
            context: {
              marker: {
                ref: markerRef,
                position: null,
                offset: _offset,
                alignment
              },
              renderMode,
              anchor
            },
            services: {
              waitForTargetElement: ({ anchor: anchor2 }) => (sendBack) => {
                const targetElement = getElement(anchor2);
                if (fastIsElementVisible(targetElement)) {
                  return sendBack({ type: "TARGET_ELEMENT_FOUND", targetElement });
                }
                const handleMutation = (mutation) => {
                  if (isWithinCommandBar(mutation.target) || Array.from(mutation.addedNodes).some(isWithinCommandBar) || Array.from(mutation.removedNodes).some(isWithinCommandBar))
                    return;
                  const targetElement2 = getElement(anchor2);
                  switch (mutation.type) {
                    case "childList": {
                      if (mutation.addedNodes.length > 0 && fastIsElementVisible(targetElement2)) {
                        sendBack({ type: "TARGET_ELEMENT_FOUND", targetElement: targetElement2 });
                      }
                      break;
                    }
                    case "attributes": {
                      if (fastIsElementVisible(targetElement2)) {
                        sendBack({ type: "TARGET_ELEMENT_FOUND", targetElement: targetElement2 });
                      }
                      break;
                    }
                    default:
                      break;
                  }
                };
                const debouncedObserverCallback = debounce2(
                  (mutationsList) => mutationsList.forEach(handleMutation),
                  500
                );
                const observer = new MutationObserver(debouncedObserverCallback);
                observer.observe(document.documentElement, {
                  childList: true,
                  subtree: true,
                  attributes: true,
                  attributeFilter: ["style", "class"]
                });
                return () => {
                  observer.disconnect();
                };
              },
              trackTargetElement: ({ marker }, { targetElement }) => (sendBack) => {
                const markerElement = marker.ref.current;
                if (!markerElement) {
                  return;
                }
                const { offset: _offset2, alignment: alignment2 } = marker;
                const arrowEl = document.querySelector(".commandbar-nudge-arrow");
                const updatePosition = () => {
                  var _a2, _b2, _c2, _d, _e, _f;
                  computePosition4(targetElement, markerElement, {
                    placement: alignment2 === "left" ? "left" : "right",
                    strategy: "fixed",
                    middleware: [
                      offset5({
                        mainAxis: calcOffsetFromInput(_offset2.x),
                        crossAxis: calcOffsetFromInput(_offset2.y)
                      }),
                      hide3({
                        strategy: "escaped",
                        padding: {
                          top: calcOffsetFromInput((_a2 = _offset2 == null ? void 0 : _offset2.y) != null ? _a2 : "0"),
                          bottom: -calcOffsetFromInput((_b2 = _offset2 == null ? void 0 : _offset2.y) != null ? _b2 : "0"),
                          ...alignment2 === "left" ? {
                            right: calcOffsetFromInput((_c2 = _offset2 == null ? void 0 : _offset2.x) != null ? _c2 : "0"),
                            left: -calcOffsetFromInput((_d = _offset2 == null ? void 0 : _offset2.x) != null ? _d : "0")
                          } : {
                            right: -calcOffsetFromInput((_e = _offset2 == null ? void 0 : _offset2.x) != null ? _e : "0"),
                            left: calcOffsetFromInput((_f = _offset2 == null ? void 0 : _offset2.x) != null ? _f : "0")
                          }
                        }
                      }),
                      ...arrowEl ? [arrow2({ element: arrowEl })] : []
                      // Conditionally include the arrow middleware
                    ]
                  }).then(({ y, x, middlewareData }) => {
                    var _a3, _b3;
                    sendBack({ type: "POSITION", position: { x, y } });
                    sendBack(((_a3 = middlewareData.hide) == null ? void 0 : _a3.escaped) ? "HIDE" : "SHOW");
                    if (arrowEl && middlewareData.arrow) {
                      const escapedOffsets = (_b3 = middlewareData.hide) == null ? void 0 : _b3.escapedOffsets;
                      const placement = escapedOffsets.top < escapedOffsets.bottom ? "bottom" : "top";
                      Object.assign(arrowEl.style, {
                        top: placement === "top" ? " -8px" : "unset",
                        bottom: placement === "bottom" ? " -8px" : "unset"
                      });
                    }
                  });
                };
                const cleanupMarker = autoUpdate4(targetElement, markerElement, updatePosition);
                const targetObserver = setupTargetObserver(
                  anchor,
                  targetElement,
                  () => sendBack("TARGET_ELEMENT_REMOVED")
                );
                const domObserver = setupDomObserver(targetElement, () => sendBack("TARGET_ELEMENT_REMOVED"));
                return () => {
                  cleanupMarker();
                  domObserver.disconnect();
                  targetObserver.disconnect();
                };
              },
              wrapTargetElement: ({ marker }, { targetElement }) => (sendBack) => {
                var _a2, _b2;
                const inlineWrapperElement = document.createElement("div");
                inlineWrapperElement.setAttribute("data-testid", "commandbar-nudge-tooltip-wrapper" /* Wrapper */);
                inlineWrapperElement.style.position = "relative";
                inlineWrapperElement.style.display = "inline-flex";
                inlineWrapperElement.style.alignItems = "baseline";
                inlineWrapperElement.style.width = "fit-content";
                inlineWrapperElement.style.flexDirection = marker.alignment === "inline_right" ? "row" : "row-reverse";
                (_a2 = targetElement.parentNode) == null ? void 0 : _a2.insertBefore(inlineWrapperElement, targetElement);
                (_b2 = targetElement.parentNode) == null ? void 0 : _b2.removeChild(targetElement);
                inlineWrapperElement.appendChild(targetElement);
                sendBack({ type: "ASSIGN_WRAPPER", inlineWrapperElement });
                const targetObserver = setupTargetObserver(
                  anchor,
                  targetElement,
                  () => sendBack("TARGET_ELEMENT_REMOVED")
                );
                const domObserver = setupDomObserver(targetElement, () => sendBack("TARGET_ELEMENT_REMOVED"));
                return () => {
                  domObserver.disconnect();
                  targetObserver.disconnect();
                  const parentOfWrapper = inlineWrapperElement.parentNode;
                  if (document.contains(parentOfWrapper)) {
                    parentOfWrapper == null ? void 0 : parentOfWrapper.insertBefore(targetElement, inlineWrapperElement);
                    parentOfWrapper == null ? void 0 : parentOfWrapper.removeChild(inlineWrapperElement);
                  }
                };
              }
            },
            actions: {
              removeTooltip: handleDestroy
            }
          }
        },
        children
      );
    };
  }
});

// commandbar/src/products/nudges/components/Tooltip/index.tsx
import { jsx as jsx45 } from "@emotion/core";
import { useActor } from "@xstate/react";
import { useEffect as useEffect28, useCallback as useCallback12, useMemo as useMemo8, Fragment as Fragment3 } from "react";
import { createPortal as createPortal2 } from "react-dom";
var Header3, BeaconMarker, ImageMarker, IconMarker, Marker, Trigger, TooltipComponent, TooltipProvider, Tooltip3;
var init_Tooltip2 = __esm({
  "commandbar/src/products/nudges/components/Tooltip/index.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_popover();
    init_state2();
    init_useMobileExperience();
    init_useStore();
    init_useTheme();
    init_useToast();
    init_theme3();
    init_StyledNudgeBeacon();
    init_LocalStorage();
    init_location();
    init_nudges();
    init_DraftFooter();
    init_useLinkClickHandler();
    init_selectors5();
    init_ContentContainer();
    init_RenderNudge();
    init_close_icon();
    init_Layout3();
    init_constants6();
    init_icons();
    init_state3();
    init_styles();
    init_AnimatedWidget();
    init_SurveyResponseProvider();
    Header3 = ({ title }) => {
      const styles51 = styles_default();
      return /* @__PURE__ */ jsx45("div", { css: styles51.header }, /* @__PURE__ */ jsx45("span", { "aria-level": 3, css: styles51.title, id: "commandbar-nudge-title", role: "heading" }, title), /* @__PURE__ */ jsx45(PopoverClose, { "data-testid": "commandbar-nudge-tooltip-close" /* Close */ }, /* @__PURE__ */ jsx45(SvgCloseIcon, { css: styles51.closeButton })));
    };
    BeaconMarker = () => {
      const styles51 = styles_default();
      return /* @__PURE__ */ jsx45("div", { css: styles51.beaconOuter }, /* @__PURE__ */ jsx45("div", { css: styles51.beaconHoverTarget }), /* @__PURE__ */ jsx45("div", { css: styles51.beaconInner }));
    };
    ImageMarker = ({ source }) => {
      const styles51 = styles_default();
      const isSvg = source.startsWith("<svg");
      return /* @__PURE__ */ jsx45("div", { css: styles51.imageHoverTarget }, isSvg ? /* @__PURE__ */ jsx45("div", { css: styles51.image, dangerouslySetInnerHTML: { __html: source } }) : /* @__PURE__ */ jsx45("img", { alt: "Tooltip marker", css: styles51.image, src: source }));
    };
    IconMarker = ({ type: type39 }) => {
      const styles51 = styles_default();
      return /* @__PURE__ */ jsx45("div", { css: styles51.iconHoverTarget }, /* @__PURE__ */ jsx45(Icon2, { type: type39 }));
    };
    Marker = ({ marker }) => {
      const { flags } = useStore();
      const themeV2 = useThemeV2Context();
      switch (marker.type) {
        case "image": {
          if (marker.source) {
            return /* @__PURE__ */ jsx45(ImageMarker, { source: marker.source });
          }
          return null;
        }
        case "icon":
          return /* @__PURE__ */ jsx45(IconMarker, { type: marker.icon });
        case "beacon":
          return (flags == null ? void 0 : flags["release-themes-v2"]) ? /* @__PURE__ */ jsx45(StyledNudgeBeacon_default, { themeV2 }) : /* @__PURE__ */ jsx45(BeaconMarker, null);
        default:
          return null;
      }
    };
    Trigger = ({ step }) => {
      const editorWidth = Number(LocalStorage_default.get("width", "770"));
      const isMarkerPositioned = TooltipMachineContext.useSelector(stateSelectors2.isMarkerPositioned);
      const centeredTriggerStyles = {
        visibility: isMarkerPositioned ? "visible" : "hidden",
        ...isStudioPreview() ? {
          top: "calc(40vh - 51px)",
          right: "calc(-50vw + 24px)"
        } : {
          top: "40vh",
          left: `calc((100vw - ${editorWidth}px) / 2)`,
          transform: "translate(-50%, -50%)"
        }
      };
      const top = TooltipMachineContext.useSelector(({ context }) => {
        var _a2;
        return (_a2 = context.marker.position) == null ? void 0 : _a2.y;
      });
      const left = TooltipMachineContext.useSelector(({ context }) => {
        var _a2;
        return (_a2 = context.marker.position) == null ? void 0 : _a2.x;
      });
      const floatingTriggerStyles = {
        visibility: isMarkerPositioned ? "visible" : "hidden",
        left,
        top
      };
      const inlinedTriggerStyles = {
        visibility: "visible"
      };
      const isMarkerInlined = TooltipMachineContext.useSelector(stateSelectors2.isMarkerInlined);
      const isCentered = TooltipMachineContext.useSelector(stateSelectors2.isMarkerCentered);
      const getTriggerStyles = () => {
        if (isMarkerInlined) {
          return inlinedTriggerStyles;
        }
        if (isCentered) {
          return centeredTriggerStyles;
        }
        return floatingTriggerStyles;
      };
      const ref12 = TooltipMachineContext.useSelector(({ context }) => context.marker.ref);
      return /* @__PURE__ */ jsx45(
        PopoverTrigger,
        {
          ref: ref12,
          "data-testid": "commandbar-nudge-tooltip-marker" /* Marker */,
          style: {
            ...getTriggerStyles()
          }
        },
        /* @__PURE__ */ jsx45(Marker, { marker: step.form_factor.marker })
      );
    };
    TooltipComponent = ({ nudge, step, popoverService }) => {
      var _a2, _b2, _c2, _d, _e;
      const [popoverState, popoverSend] = useActor(popoverService);
      const { theme } = useTheme();
      const styles51 = styles_default();
      const { onExit } = useAnimatedWidget();
      const _ = useStore();
      const renderMode = TooltipMachineContext.useSelector(({ context }) => context.renderMode);
      const isMarkerPositioned = TooltipMachineContext.useSelector(stateSelectors2.isMarkerPositioned);
      const nudgeService = renderMode !== 1 /* MOCK */ ? getNudgeService(_, nudge.id) : void 0;
      const stepIndex = (_b2 = (_a2 = nudgeService == null ? void 0 : nudgeService.getSnapshot()) == null ? void 0 : _a2.context.stepIndex) != null ? _b2 : 0;
      const close = useCallback12(
        () => onExit(() => {
          var _a3, _b3;
          return (_b3 = (_a3 = nudgeService == null ? void 0 : nudgeService.getSnapshot()) == null ? void 0 : _a3.context.popoverService) == null ? void 0 : _b3.send("CLOSE");
        }),
        [nudgeService == null ? void 0 : nudgeService.getSnapshot, onExit]
      );
      const handleLinkClick = useLinkClickHandler(close);
      const stepCount = nudge.show_step_counter && stepIndex !== void 0 && nudge.steps.length > 1 ? `${stepIndex + 1}/${nudge.steps.length}` : void 0;
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const shouldUseAutoWidth = !isMobileDevice2 && step.content.some((block) => (block == null ? void 0 : block.type) === "survey_rating" && block.meta.options === 10);
      const isMarkerInlined = TooltipMachineContext.useSelector(stateSelectors2.isMarkerInlined);
      useEffect28(() => {
        nudgeService == null ? void 0 : nudgeService.send({ type: "ASSIGN_POPOVER_SERVICE", service: popoverService });
      }, [popoverService, nudgeService]);
      useEffect28(() => {
        if (renderMode === 1 /* MOCK */) {
          popoverSend("OPEN");
        }
      }, [renderMode, step]);
      const isVisible2 = useMemo8(() => {
        if (isHoverPopoverService(popoverState)) {
          return popoverState.matches("open");
        }
        if (isClickPopoverService(popoverState)) {
          return popoverState.matches("open");
        }
        return false;
      }, [popoverState]);
      useEffect28(() => {
        if (!isMarkerPositioned) {
          close();
        }
      }, [isMarkerPositioned]);
      return /* @__PURE__ */ jsx45(Fragment3, null, /* @__PURE__ */ jsx45(Trigger, { step }), /* @__PURE__ */ jsx45(
        PopoverContent,
        {
          css: !((_c2 = _.flags) == null ? void 0 : _c2["release-themes-v2"]) && styles51.container,
          "data-testid": "commandbar-nudge-tooltip-content" /* Content */,
          describedBy: "commandbar-nudge-tooltip-content",
          labelledBy: "commandbar-nudge-title",
          style: {
            ...!((_d = _.flags) == null ? void 0 : _d["release-themes-v2"]) && {
              width: shouldUseAutoWidth ? "auto" : theme.nudgeTooltip.width
            }
          },
          portalToId: isMarkerInlined ? "commandbar-toast-container" /* TOAST_CONTAINER */ : void 0,
          shouldStealFocus: renderMode !== 1 /* MOCK */
        },
        /* @__PURE__ */ jsx45(SurveyResponseProvider, { service: nudgeService, step }, ((_e = _.flags) == null ? void 0 : _e["release-themes-v2"]) ? /* @__PURE__ */ jsx45(
          Layout3,
          {
            nudge,
            step,
            renderMode,
            stepCount,
            stepIndex,
            handleLinkClick,
            isVisible: isVisible2
          }
        ) : /* @__PURE__ */ jsx45("div", { css: styles51.body }, /* @__PURE__ */ jsx45(Header3, { title: step.title }), /* @__PURE__ */ jsx45(
          ContentContainer_default,
          {
            markdownStyles: styles51.content,
            primaryButtonStyles: styles51.ctaButton,
            renderMode,
            secondaryButtonStyles: styles51.ctaSecondaryButton,
            service: nudgeService,
            snoozable: isNudgeSnoozable(nudge),
            snoozeButtonStyles: styles51.snoozeButton,
            snoozeLabel: nudge.snooze_label,
            step,
            stepCount,
            stepCountStyles: styles51.stepCount,
            handleContentLinkClick: handleLinkClick,
            stepIndex,
            snoozable_on_all_steps: nudge.snoozable_on_all_steps
          }
        ), !nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ jsx45(DraftFooter, { details: { type: "nudge", nudge, stepIndex } })))
      ));
    };
    TooltipProvider = ({ nudge, step, forceOpen = false, autoPlacement: autoPlacement2 = true }) => {
      const renderMode = TooltipMachineContext.useSelector(({ context }) => context.renderMode);
      const isIdle = TooltipMachineContext.useSelector(stateSelectors2.isIdle);
      const isMarkerInlined = TooltipMachineContext.useSelector(stateSelectors2.isMarkerInlined);
      const wrapperElement = TooltipMachineContext.useSelector(({ context }) => context.inlineWrapperElement);
      const offset6 = TooltipMachineContext.useSelector(({ context }) => context.marker.offset);
      const { generatedCSSClassname } = useThemeV2Context();
      if (isIdle) {
        return null;
      }
      const [offsetX, offsetY] = [calcOffsetFromInput(offset6.x), calcOffsetFromInput(offset6.y)];
      const popoverStyle = isMarkerInlined ? {
        display: "flex",
        position: "relative",
        [step.form_factor.marker.positioning.position === "inline_left" ? "marginRight" : "marginLeft"]: toPx(offsetX),
        marginTop: toPx(offsetY),
        zIndex: "auto"
      } : {};
      const Comp = /* @__PURE__ */ jsx45(
        Popover,
        {
          "data-testid": `commandbar-tooltip-${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
          forceOpen,
          defaultOpen: renderMode === 1 /* MOCK */,
          triggerType: step.form_factor.show_on,
          style: popoverStyle,
          className: generatedCSSClassname,
          autoPlacement: autoPlacement2
        },
        (popoverService) => /* @__PURE__ */ jsx45(TooltipComponent, { nudge, step, popoverService })
      );
      return isMarkerInlined && wrapperElement ? createPortal2(Comp, wrapperElement) : Comp;
    };
    Tooltip3 = ({
      nudge,
      step,
      renderMode,
      forceOpen,
      anchorOverride,
      handleDestroy,
      autoPlacement: autoPlacement2
    }) => {
      var _a2;
      return /* @__PURE__ */ jsx45(BindThemeV2ForNudge, { nudge }, /* @__PURE__ */ jsx45(AnimatedWidget, { widget: "tooltip", keepMounted: true, isOpenByDefault: renderMode === 1 /* MOCK */ }, /* @__PURE__ */ jsx45(
        TooltipMachineContextProvider,
        {
          offset: step.form_factor.marker.positioning.offset,
          renderMode,
          alignment: step.form_factor.marker.positioning.position,
          anchor: (_a2 = anchorOverride != null ? anchorOverride : step.form_factor.anchor_selector) != null ? _a2 : step.form_factor.anchor,
          handleDestroy
        },
        /* @__PURE__ */ jsx45(TooltipProvider, { autoPlacement: autoPlacement2, forceOpen, nudge, step })
      )));
    };
  }
});

// commandbar/src/products/nudges/components/Banner/constants.ts
var init_constants7 = __esm({
  "commandbar/src/products/nudges/components/Banner/constants.ts"() {
    "use strict";
  }
});

// commandbar/src/products/nudges/components/Banner/BannerContext.tsx
import React161, { useEffect as useEffect29, useState as useState19 } from "react";
var bannerContext, bannerStateReducer, bannerDispatch, showBanner, hideAllMatchingBanners, hideBanner, BannerContainer;
var init_BannerContext = __esm({
  "commandbar/src/products/nudges/components/Banner/BannerContext.tsx"() {
    "use strict";
    init_Z();
    init_constants7();
    init_location();
    bannerContext = {
      state: {},
      subscribers: [],
      subscribe: (notifySubscriber) => {
        bannerContext.subscribers.push(notifySubscriber);
        return () => {
          bannerContext.subscribers = bannerContext.subscribers.filter((s) => s !== notifySubscriber);
        };
      }
    };
    bannerStateReducer = (state, action) => {
      switch (action.type) {
        case "SHOW" /* SHOW */:
          return {
            ...state,
            [action.id]: action.payload
          };
        case "HIDE" /* HIDE */:
          const newState = { ...state };
          delete newState[action.id];
          return newState;
        case "HIDE_ALL_MATCHING_PATTERN" /* HIDE_ALL_MATCHING_PATTERN */:
          if (action.idPattern) {
            const newState2 = { ...state };
            for (const bannerId in newState2) {
              if (bannerId.match(action.idPattern)) {
                delete newState2[bannerId];
              }
            }
            return newState2;
          }
          return {};
        default:
          return state;
      }
    };
    bannerDispatch = (action) => {
      const newState = bannerStateReducer(bannerContext.state, action);
      bannerContext.state = newState;
      bannerContext.subscribers.forEach((notifySubscriber) => notifySubscriber(newState));
    };
    showBanner = (id2, payload) => {
      bannerDispatch({ type: "SHOW" /* SHOW */, id: id2, payload });
    };
    hideAllMatchingBanners = (idPattern) => {
      bannerDispatch({ type: "HIDE_ALL_MATCHING_PATTERN" /* HIDE_ALL_MATCHING_PATTERN */, idPattern });
    };
    hideBanner = (id2) => {
      const spacerElement = document.querySelector(`[data-spacer-for="${id2}"]`);
      if (spacerElement) {
        spacerElement.remove();
      }
      bannerDispatch({ type: "HIDE" /* HIDE */, id: id2 });
    };
    BannerContainer = ({ children }) => {
      const [state, setState] = useState19(bannerContext.state);
      useEffect29(() => {
        return bannerContext.subscribe(setState);
      }, []);
      return /* @__PURE__ */ React161.createElement(React161.Fragment, null, children, /* @__PURE__ */ React161.createElement(
        "div",
        {
          id: "commandbar-nudges-banner-sticky-container" /* Sticky */,
          style: {
            width: "100%",
            top: "0px",
            position: "fixed",
            pointerEvents: "none",
            zIndex: Z_default.Z_NUDGE,
            height: "100%"
          }
        },
        Object.entries(state).filter(([, bannerProps]) => bannerProps.sticky).map(([id2, bannerProps]) => /* @__PURE__ */ React161.createElement("div", { key: id2, id: id2 }, bannerProps.element))
      ), /* @__PURE__ */ React161.createElement(
        "div",
        {
          id: `${"commandbar-nudges-banner-inline-container" /* Inline */}-top`,
          style: {
            width: "100%",
            position: "absolute",
            top: isStudioPreview() ? "50%" : "0",
            pointerEvents: "none",
            zIndex: Z_default.Z_NUDGE
          }
        },
        Object.entries(state).filter(([, bannerProps]) => !bannerProps.sticky && bannerProps.position === "top").map(([id2, bannerProps]) => /* @__PURE__ */ React161.createElement("div", { key: id2, id: id2 }, bannerProps.element))
      ), /* @__PURE__ */ React161.createElement(
        "div",
        {
          id: `${"commandbar-nudges-banner-inline-container" /* Inline */}-bottom`,
          style: {
            width: "100%",
            position: isStudioPreview() ? void 0 : "relative",
            pointerEvents: "none",
            zIndex: Z_default.Z_NUDGE
          }
        },
        Object.entries(state).filter(([, bannerProps]) => !bannerProps.sticky && bannerProps.position === "bottom").map(([id2, bannerProps]) => /* @__PURE__ */ React161.createElement("div", { key: id2, id: id2 }, bannerProps.element))
      ));
    };
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeBannerTitleBlock.tsx
import React162 from "react";
var NudgeTitleBlock2, NudgeTitle2, NudgeContent2, parseMarkdown2, StyledNudgeBannerTitleBlock, StyledNudgeBannerTitleBlock_default;
var init_StyledNudgeBannerTitleBlock = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeBannerTitleBlock.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_sanitizeHtml();
    init_markdown();
    NudgeTitleBlock2 = styled_browser_esm_default.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: center;
  font-size: 14px;
  gap: 4px;
  justify-content: center;

  @media (max-width: 641px) {
    flex-direction: column;
    font-size: var(--font-size-large);
    line-height: var(--font-line-height-snug);
  }

  @media (max-width: 375px) {
    align-self: flex-start;
  }
`;
    NudgeTitle2 = styled_browser_esm_default.div`
  display: flex;
  justify-content: space-between;
  align-self: stretch;
  color: var(--content-primary);

  /* label/lg/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-snug);
`;
    NudgeContent2 = styled_browser_esm_default.div`
  align-self: stretch;
  color: var(--content-secondary);

  ol,
  ul,
  li {
    all: revert;
  }
  img {
    max-width: 100%;
  }

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  @media (min-width: 641px) {
    font-size: var(--font-size-large);
    line-height: var(--font-line-height-snug);
  }

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }

  a {
    color: var(--content-link);
    text-decoration: none;

    &:hover {
      color: var(--content-link-hover);
      text-decoration: underline;
    }
  }
`;
    parseMarkdown2 = (str) => {
      const parsed = toHtml(str).replace(/(<a href="(https?:)?\/\/.*?")>/g, '$1 target="_blank" rel="nofollow">');
      return sanitizeHtml_default(parsed);
    };
    StyledNudgeBannerTitleBlock = ({
      title,
      content,
      handleContentLinkClick,
      ...props2
    }) => {
      return /* @__PURE__ */ React162.createElement(NudgeTitleBlock2, { ...props2 }, title && /* @__PURE__ */ React162.createElement(
        NudgeTitle2,
        {
          style: {
            position: "relative"
          }
        },
        title
      ), content && /* @__PURE__ */ React162.createElement(NudgeContent2, { dangerouslySetInnerHTML: { __html: parseMarkdown2(content) }, onClick: handleContentLinkClick }));
    };
    StyledNudgeBannerTitleBlock_default = StyledNudgeBannerTitleBlock;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeBannerSpacer.tsx
import React163 from "react";
import { jsx as jsx46 } from "@emotion/core";
var Spacer, StyledNudgeBannerSpacer, StyledNudgeBannerSpacer_default;
var init_StyledNudgeBannerSpacer = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeBannerSpacer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Spacer = styled_browser_esm_default.div`
  width: var(--form-control-height);
  height: var(--form-control-height);
  margin: var(--layout-padding);
  flex: 0 0 auto;

  @media (max-width: 641px) {
    display: none;
  }
`;
    StyledNudgeBannerSpacer = React163.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx46(Spacer, { ref: ref12, ...props2 }, children);
      }
    );
    StyledNudgeBannerSpacer_default = StyledNudgeBannerSpacer;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeBanner.tsx
import React164 from "react";
import { css as css29, jsx as jsx47 } from "@emotion/core";
var styles20, Banner, StyledNudgeBanner, StyledNudgeBanner_default;
var init_StyledNudgeBanner = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeBanner.tsx"() {
    "use strict";
    init_styled_browser_esm();
    styles20 = css29({
      position: "absolute",
      display: "flex",
      width: "100%",
      flexDirection: "column",
      alignItems: "flex-start",
      pointerEvents: "all",
      borderRadius: "var(--layout-radius-card)",
      border: "1px solid var(--border-primary)",
      background: "var(--background-primary)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)"
    });
    Banner = styled_browser_esm_default.div``;
    StyledNudgeBanner = React164.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx47(Banner, { ref: ref12, css: [styles20].filter(Boolean), ...props2 }, children);
      }
    );
    StyledNudgeBanner_default = StyledNudgeBanner;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeBannerBody.tsx
import React165 from "react";
import { jsx as jsx48 } from "@emotion/core";
var Body2, StyledNudgeBannerBody, StyledNudgeBannerBody_default;
var init_StyledNudgeBannerBody = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeBannerBody.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Body2 = styled_browser_esm_default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: row;
  padding: var(--layout-padding);
  gap: var(--layout-gap);
  flex: 1 1 auto;

  @media (max-width: 641px) {
    justify-content: space-between;
  }

  @media (max-width: 375px) {
    flex-direction: column;
    margin-right: var(--layout-padding);
  }
`;
    StyledNudgeBannerBody = React165.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx48(Body2, { ref: ref12, ...props2 }, children);
      }
    );
    StyledNudgeBannerBody_default = StyledNudgeBannerBody;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeBannerCloseButtonContainer.tsx
import React166 from "react";
var Container8, StyledNudgeBannerCloseButtonContainer, StyledNudgeBannerCloseButtonContainer_default;
var init_StyledNudgeBannerCloseButtonContainer = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeBannerCloseButtonContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container8 = styled_browser_esm_default.div`
  padding: var(--layout-padding);
  flex: 0 0 auto;

  @media (max-width: 375px) {
    position: absolute;
    display: flex;
    top: calc(max(var(--layout-padding) - 4px, 0px));
    right: calc(max(var(--layout-padding) - 12px, 0px));
    max-height: 32px;
    max-width: 32px;
    border-radius: var(--layout-radius-button);
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
`;
    StyledNudgeBannerCloseButtonContainer = React166.forwardRef(
      ({ children, ...props2 }, ref12) => /* @__PURE__ */ React166.createElement(Container8, { ref: ref12, ...props2 }, children)
    );
    StyledNudgeBannerCloseButtonContainer_default = StyledNudgeBannerCloseButtonContainer;
  }
});

// commandbar/src/products/nudges/components/Banner/useInjectPortalRoot.ts
import { useEffect as useEffect30, useState as useState20 } from "react";
var useInjectPortalRoot, useInjectPortalRoot_default;
var init_useInjectPortalRoot = __esm({
  "commandbar/src/products/nudges/components/Banner/useInjectPortalRoot.ts"() {
    "use strict";
    init_nudges();
    init_constants7();
    useInjectPortalRoot = ({ nudge, stepIndex }) => {
      const step = getNudgeStep(nudge, stepIndex);
      const [portalRootElement, setPortalRootElement] = useState20(null);
      useEffect30(() => {
        if ((step == null ? void 0 : step.form_factor.type) === "banner" && step.form_factor.placement !== "overlay") {
          const render = () => {
            var _a2, _b2;
            if ((step == null ? void 0 : step.form_factor.type) === "banner") {
              const styles51 = {
                width: "100%",
                height: "auto",
                position: ((_a2 = step.form_factor) == null ? void 0 : _a2.placement) === "sticky" ? "sticky" : "relative",
                ...((_b2 = step.form_factor) == null ? void 0 : _b2.placement) === "sticky" && {
                  [step.form_factor.position === "top" ? "top" : "bottom"]: 0
                }
              };
              const isTop = step.form_factor.position === "top";
              const targetElem = document.body;
              const insertPosition = isTop ? "afterbegin" : "beforeend";
              if (targetElem) {
                const bannerElement = document.createElement("div");
                bannerElement.id = "commandbar-nudges-banner-space-container" /* Space */;
                Object.assign(bannerElement.style, styles51);
                document.body.insertAdjacentElement(insertPosition, bannerElement);
                setPortalRootElement(bannerElement);
              }
            }
          };
          const cleanup2 = () => {
            var _a2;
            const bannerToRemove = document.getElementById("commandbar-nudges-banner-space-container" /* Space */);
            if (bannerToRemove) {
              (_a2 = bannerToRemove.parentNode) == null ? void 0 : _a2.removeChild(bannerToRemove);
            }
          };
          render();
          return cleanup2;
        }
      }, [nudge, stepIndex]);
      return {
        portalRootElement
      };
    };
    useInjectPortalRoot_default = useInjectPortalRoot;
  }
});

// commandbar/src/products/nudges/components/Banner/Banner.tsx
import { jsx as jsx49 } from "@emotion/core";
import { useEffect as useEffect31, useRef as useRef25 } from "react";
import { useTheme as useTheme10 } from "emotion-theming";
import ReactDOM6 from "react-dom";
var getStyles4, BannerComponent, Banner2, Banner_default;
var init_Banner = __esm({
  "commandbar/src/products/nudges/components/Banner/Banner.tsx"() {
    "use strict";
    init_useStore();
    init_nudges();
    init_StyledNudgeBannerTitleBlock();
    init_StyledNudgeBannerSpacer();
    init_StyledNudgeBanner();
    init_StyledNudgeBannerBody();
    init_StyledNudgeBannerCloseButtonContainer();
    init_ContentContainer();
    init_DraftFooter();
    init_selectors5();
    init_StyledNudgeCloseButton();
    init_ThemeV2Context();
    init_useAction();
    init_actions6();
    init_useLinkClickHandler();
    init_useMobileExperience();
    init_Z();
    init_RenderNudge();
    init_CloseButton();
    init_location();
    init_useInjectPortalRoot();
    init_Actions();
    init_SurveyResponseProvider();
    getStyles4 = (theme) => ({
      container: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        background: theme.nudges.background,
        color: theme.nudges.color,
        zIndex: Z_default.Z_COMMANDBAR - 2,
        boxShadow: theme.nudges.boxShadow,
        fontFamily: theme.nudges.fontFamily,
        transition: "opacity 0.15s ease-in-out",
        pointerEvents: "all",
        justifyContent: "space-between",
        alignItems: "center"
      },
      header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "16px",
        padding: `12px 12px ${theme.nudges.gap}`
      },
      title: {
        fontFamily: theme.nudges.titleFontFamily,
        fontSize: theme.nudges.titleFontSize,
        fontWeight: theme.nudges.titleFontWeight,
        lineHeight: theme.nudges.titleLineHeight,
        color: theme.nudges.titleColor,
        zIndex: Z_default.Z_COMMANDBAR - 1,
        cursor: "auto"
      },
      content: {
        fontFamily: theme.nudges.contentFontFamily,
        color: theme.nudges.contentColor,
        fontSize: theme.nudges.contentFontSize,
        fontWeight: theme.nudges.contentFontWeight,
        lineHeight: theme.nudges.contentLineHeight
      },
      body: {
        display: "flex",
        flexDirection: "row",
        gap: theme.nudges.gap,
        alignItems: "center"
      },
      ctaButton: {
        fontFamily: theme.nudges.ctaFontFamily,
        padding: theme.nudges.ctaPadding,
        background: theme.nudges.ctaBackground,
        color: theme.nudges.ctaColor,
        border: theme.nudges.ctaBorder,
        boxShadow: theme.nudges.ctaBoxShadow,
        textShadow: theme.nudges.ctaTextShadow,
        borderRadius: theme.nudges.ctaBorderRadius,
        fontSize: theme.nudges.ctaFontSize,
        lineHeight: theme.nudges.ctaLineHeight,
        fontWeight: theme.nudges.ctaFontWeight
      },
      ctaSecondaryButton: {
        fontFamily: theme.nudges.ctaSecondaryFontFamily,
        padding: theme.nudges.ctaSecondaryPadding,
        background: theme.nudges.ctaSecondaryBackground,
        color: theme.nudges.ctaSecondaryColor,
        border: theme.nudges.ctaSecondaryBorder,
        boxShadow: theme.nudges.ctaSecondaryBoxShadow,
        textShadow: theme.nudges.ctaSecondaryTextShadow,
        borderRadius: theme.nudges.ctaSecondaryBorderRadius,
        fontSize: theme.nudges.ctaSecondaryFontSize,
        lineHeight: theme.nudges.ctaSecondaryLineHeight,
        fontWeight: theme.nudges.ctaSecondaryFontWeight
      },
      snoozeButton: {
        background: theme.nudges.snoozeButtonBackground,
        fontFamily: theme.nudges.snoozeButtonFontFamily,
        color: theme.nudges.snoozeButtonColor,
        border: theme.nudges.snoozeButtonBorder,
        textShadow: theme.nudges.snoozeButtonTextShadow,
        fontSize: theme.nudges.snoozeButtonFontSize,
        lineHeight: theme.nudges.snoozeButtonLineHeight,
        fontWeight: theme.nudges.snoozeButtonFontWeight,
        width: theme.nudges.snoozeButtonWidth
      },
      closeButtonOverrides: {
        position: "absolute",
        top: "16px",
        right: "16px"
      },
      stepCount: {
        fontFamily: theme.nudges.stepCountFontFamily,
        color: theme.nudges.stepCountColor,
        fontSize: theme.nudges.stepCountFontSize,
        fontWeight: theme.nudges.stepCountFontWeight
      }
    });
    BannerComponent = ({ nudge, stepIndex, renderMode }) => {
      var _a2, _b2;
      const _ = useStore();
      const step = getNudgeStep(nudge, stepIndex);
      const { theme } = useTheme10();
      const themeV2 = useThemeV2Context();
      const { isStudioMobilePreview, studioMobilePreviewWrapper, mobileStyles, isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const getService = (id2) => getNudgeService(_, id2);
      const dismiss = useAction(dismissNudge);
      const handleLinkClick = useLinkClickHandler(() => dismiss(nudge, renderMode));
      const service = renderMode !== 1 /* MOCK */ ? getService(nudge.id) : void 0;
      const styles51 = getStyles4(theme);
      const { portalRootElement } = useInjectPortalRoot_default({ nudge, stepIndex, renderMode });
      const position = (step == null ? void 0 : step.form_factor.type) === "banner" && ((_a2 = step == null ? void 0 : step.form_factor) == null ? void 0 : _a2.position);
      const placement = (step == null ? void 0 : step.form_factor.type) === "banner" && ((_b2 = step.form_factor) == null ? void 0 : _b2.placement);
      const bannerRef = useRef25(null);
      useEffect31(() => {
        if (!isStudioPreview() && placement !== "overlay") {
          const updateHeight = () => {
            if (bannerRef.current && portalRootElement) {
              portalRootElement.style.height = `${bannerRef.current.offsetHeight}px`;
            }
          };
          updateHeight();
          const observer = new ResizeObserver(updateHeight);
          if (bannerRef.current) {
            observer.observe(bannerRef.current);
          }
          return () => {
            observer.disconnect();
          };
        }
      }, [bannerRef, portalRootElement, renderMode]);
      const content = () => {
        var _a3;
        if (step)
          return /* @__PURE__ */ jsx49(SurveyResponseProvider, { service, step }, ((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) ? /* @__PURE__ */ jsx49(
            StyledNudgeBanner_default,
            {
              ref: bannerRef,
              "data-testid": `commandbar-banner-${nudge.id}-${String(step == null ? void 0 : step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
              style: isMobileDevice2 ? {
                ...mobileStyles.nudges.banner.container,
                [position === "top" ? "top" : "bottom"]: 0
              } : {
                position: "absolute",
                top: position === "top" ? 0 : void 0,
                bottom: position === "bottom" && placement === "sticky" ? 0 : void 0,
                ...isStudioPreview() && {
                  top: "50%",
                  bottom: "auto",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "90%"
                }
              }
            },
            /* @__PURE__ */ jsx49(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  width: "100%"
                }
              },
              isNudgeDismissible(nudge) && /* @__PURE__ */ jsx49(
                StyledNudgeBannerSpacer_default,
                {
                  style: isMobileDevice2 ? mobileStyles.nudges.banner.spaceContainer : {}
                }
              ),
              /* @__PURE__ */ jsx49(StyledNudgeBannerBody_default, { style: isMobileDevice2 ? mobileStyles.nudges.banner.body : {} }, /* @__PURE__ */ jsx49(
                StyledNudgeBannerTitleBlock_default,
                {
                  title: step == null ? void 0 : step.title,
                  content: step == null ? void 0 : step.content.map((block) => block.type === "markdown" && block.meta.value ? block.meta.value : void 0).filter((block) => !!block).pop(),
                  handleContentLinkClick: handleLinkClick,
                  style: isMobileDevice2 ? mobileStyles.nudges.banner.title : {}
                }
              ), /* @__PURE__ */ jsx49(
                ContentContainer_default,
                {
                  step,
                  stepIndex,
                  service,
                  markdownStyles: styles51.content,
                  primaryButtonStyles: styles51.ctaButton,
                  secondaryButtonStyles: styles51.ctaSecondaryButton,
                  snoozeButtonStyles: styles51.snoozeButton,
                  stepCountStyles: styles51.stepCount,
                  stepCount: void 0,
                  renderMode,
                  snoozable: isNudgeSnoozable(nudge),
                  snoozeLabel: nudge.snooze_label,
                  handleContentLinkClick: handleLinkClick,
                  snoozable_on_all_steps: nudge.snoozable_on_all_steps
                }
              ), /* @__PURE__ */ jsx49(
                Actions,
                {
                  step,
                  stepCount: void 0,
                  stepIndex,
                  renderMode,
                  snooze: {
                    enabled: isNudgeSnoozable(nudge),
                    label: nudge.snooze_label,
                    enabledOnAllSteps: nudge.snoozable_on_all_steps,
                    duration: nudge.snooze_duration
                  },
                  service
                }
              )),
              isNudgeDismissible(nudge) && /* @__PURE__ */ jsx49(
                StyledNudgeBannerCloseButtonContainer_default,
                {
                  style: isMobileDevice2 ? mobileStyles.nudges.banner.closeButtonContainer : {}
                },
                /* @__PURE__ */ jsx49(StyledNudgeCloseButton_default, { themeV2, onClick: () => dismiss(nudge, renderMode) })
              )
            ),
            !nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ jsx49(DraftFooter, { details: { type: "nudge", nudge, stepIndex } })
          ) : /* @__PURE__ */ jsx49(
            "div",
            {
              "data-testid": `commandbar-banner-${nudge.id}-${String(step == null ? void 0 : step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
              key: step == null ? void 0 : step.id,
              "aria-labelledby": "commandbar-nudge-title",
              style: {
                ...styles51.container,
                position: "absolute",
                top: position === "top" ? 0 : void 0,
                bottom: position === "bottom" && placement === "sticky" ? 0 : void 0,
                ...isStudioPreview() && !isMobileDevice2 && {
                  top: "50%",
                  bottom: "auto",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "90%"
                },
                ...isMobileDevice2 && {
                  ...mobileStyles.nudges.banner.container,
                  [position === "top" ? "top" : "bottom"]: "10px",
                  flexDirection: "column",
                  width: "100%"
                }
              },
              ref: bannerRef
            },
            /* @__PURE__ */ jsx49(
              "div",
              {
                style: {
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  padding: theme.nudges.gap,
                  justifyContent: "space-between",
                  ...isMobileDevice2 && {
                    flexDirection: "column",
                    alignItems: "flex-start"
                  }
                }
              },
              isNudgeDismissible(nudge) && !isMobileDevice2 && /* @__PURE__ */ jsx49(StyledNudgeBannerSpacer_default, null),
              /* @__PURE__ */ jsx49(
                "div",
                {
                  style: {
                    ...styles51.body,
                    gap: theme.nudges.gap,
                    ...isMobileDevice2 && {
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginRight: "24px"
                    }
                  }
                },
                /* @__PURE__ */ jsx49("span", { id: "commandbar-nudge-title", style: styles51.title, role: "heading", "aria-level": 3 }, step == null ? void 0 : step.title),
                /* @__PURE__ */ jsx49(
                  ContentContainer_default,
                  {
                    step,
                    stepIndex,
                    service,
                    markdownStyles: styles51.content,
                    primaryButtonStyles: styles51.ctaButton,
                    secondaryButtonStyles: styles51.ctaSecondaryButton,
                    snoozeButtonStyles: styles51.snoozeButton,
                    stepCountStyles: styles51.stepCount,
                    stepCount: void 0,
                    renderMode,
                    snoozable: isNudgeSnoozable(nudge),
                    snoozeLabel: nudge.snooze_label,
                    handleContentLinkClick: handleLinkClick,
                    snoozable_on_all_steps: nudge.snoozable_on_all_steps
                  }
                )
              ),
              isNudgeDismissible(nudge) && /* @__PURE__ */ jsx49("div", { style: { padding: "12px", ...isMobileDevice2 && { position: "absolute", top: 0, right: 0 } } }, /* @__PURE__ */ jsx49(CloseButton_default, { onInteraction: () => dismiss(nudge, renderMode) }))
            ),
            !nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ jsx49(DraftFooter, { details: { type: "nudge", nudge, stepIndex } })
          ));
        return null;
      };
      if (isStudioMobilePreview && studioMobilePreviewWrapper) {
        return ReactDOM6.createPortal(content(), studioMobilePreviewWrapper);
      }
      if (step) {
        return content();
      }
      return null;
    };
    Banner2 = (props2) => /* @__PURE__ */ jsx49(BindThemeV2ForNudge, { nudge: props2.nudge }, /* @__PURE__ */ jsx49(BannerComponent, { ...props2 }));
    Banner_default = Banner2;
  }
});

// commandbar/src/products/nudges/components/RenderNudge.tsx
import React168 from "react";
import { ref as ref4 } from "valtio";
var renderNudge;
var init_RenderNudge = __esm({
  "commandbar/src/products/nudges/components/RenderNudge.tsx"() {
    "use strict";
    init_useToast();
    init_location();
    init_sentry();
    init_Interpolate();
    init_actions6();
    init_selectors5();
    init_nudges();
    init_Pin();
    init_Cursor();
    init_Popover();
    init_Tooltip2();
    init_BannerContext();
    init_Banner();
    renderNudge = (_, nudge, stepIndex = 0, options = {}) => {
      var _a2, _b2, _c2;
      const renderMode = (_a2 = options == null ? void 0 : options.renderMode) != null ? _a2 : 0 /* DEFAULT */;
      nudge = interpolateObject({ s: nudge, _, interpolateContext: true, interpolateArgs: false });
      const dismissible = isNudgeDismissible(nudge);
      const step = getNudgeStep(nudge, stepIndex);
      const stepCount = nudge.show_step_counter && stepIndex !== void 0 && nudge.steps.length > 1 ? `${stepIndex + 1}/${nudge.steps.length}` : void 0;
      const onEscapeKeyDown = () => {
        if (dismissible) {
          dismissNudge(_, nudge, renderMode);
        }
      };
      switch (step == null ? void 0 : step.form_factor.type) {
        case "popover": {
          if (step.form_factor.position === "center" || isStudioPreview()) {
            showToast(`${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`, {
              element: /* @__PURE__ */ React168.createElement(
                DraggablePopover,
                {
                  nudge,
                  renderMode,
                  stepCount,
                  stepIndex,
                  center: true
                }
              ),
              position: "center",
              duration: Infinity,
              onEscapeKeyDown
            });
          } else {
            showToast(`${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`, {
              element: /* @__PURE__ */ React168.createElement(DraggablePopover, { nudge, renderMode, stepCount, stepIndex }),
              position: step.form_factor.position,
              duration: Infinity,
              onEscapeKeyDown
            });
          }
          break;
        }
        case "modal": {
          _.currentModalNudge = ref4({
            nudge,
            stepIndex,
            stepCount,
            renderMode
          });
          break;
        }
        case "pin": {
          const { offset: nudgeOffset, is_open_by_default, is_showing_mask } = step.form_factor;
          const isOpenByDefault = is_open_by_default === void 0 ? true : is_open_by_default;
          const isShowingMask = !!is_showing_mask;
          const offset6 = nudgeOffset === void 0 ? { x: "0px", y: "0px" } : nudgeOffset;
          if (((_b2 = options.source) == null ? void 0 : _b2.animateIn) && isCursorStep(nudge, step)) {
            showToast(`${nudge.id}-${String(step.id)}`, {
              element: /* @__PURE__ */ React168.createElement(
                Cursor,
                {
                  nudge,
                  step,
                  sourceCoordinates: options.source.startPosition,
                  handleDestroy: () => dismissNudge(_, nudge, renderMode),
                  onTargetElementClick: (e) => {
                    const { targetEl, advanceTriggerEl } = getPinAnchors(_, {
                      step,
                      anchorOverride: options.anchorOverride
                    });
                    const target = e.target;
                    if ((advanceTriggerEl == null ? void 0 : advanceTriggerEl.contains(target)) || (targetEl == null ? void 0 : targetEl.contains(target))) {
                      if (_.extension.recorder.enabled) {
                        dismissNudgeTemporarily(_, {
                          nudge,
                          renderMode,
                          stepIndex,
                          anchorOverride: options.anchorOverride
                        });
                      } else {
                        const service = getNudgeService(_, nudge.id);
                        service == null ? void 0 : service.send({ type: "ADVANCE", isPinClick: true });
                      }
                    }
                  }
                }
              ),
              onEscapeKeyDown,
              onEnterKeyDown: () => continueNudge(_, nudge)
            });
          } else {
            showToast(`${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`, {
              element: /* @__PURE__ */ React168.createElement(
                Pin_default,
                {
                  pin: {
                    nudge,
                    step,
                    isOpenByDefault,
                    isShowingMask,
                    offset: offset6
                  },
                  renderMode,
                  stepCount,
                  stepIndex,
                  anchorOverride: options == null ? void 0 : options.anchorOverride
                }
              ),
              duration: Infinity,
              onEscapeKeyDown,
              onEnterKeyDown: () => continueNudge(_, nudge),
              shouldStealFocus: isShowingMask
            });
          }
          break;
        }
        case "tooltip": {
          if (isTooltipStep(step)) {
            const id2 = `${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`;
            showToast(id2, {
              asChild: true,
              element: /* @__PURE__ */ React168.createElement(
                Tooltip3,
                {
                  forceOpen: options == null ? void 0 : options.forceOpen,
                  nudge,
                  renderMode,
                  step,
                  anchorOverride: options == null ? void 0 : options.anchorOverride,
                  handleDestroy: () => dismissNudge(_, nudge, renderMode)
                }
              )
            });
          }
          break;
        }
        case "banner": {
          if (isBannerStep(step)) {
            const id2 = `${nudge.id}-${String(step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`;
            showBanner(id2, {
              element: /* @__PURE__ */ React168.createElement(Banner_default, { nudge, stepIndex, renderMode }),
              sticky: (step == null ? void 0 : step.form_factor.placement) === "sticky",
              position: step == null ? void 0 : step.form_factor.position
            });
          }
          break;
        }
        default: {
          (_c2 = getSentry()) == null ? void 0 : _c2.captureMessage(`Unknown form factor type: ${step == null ? void 0 : step.form_factor}`, "error", {
            captureContext: {
              tags: {
                product: "nudges"
              }
            }
          });
          showToast(`${nudge.id}-${String(step == null ? void 0 : step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`, {
            element: /* @__PURE__ */ React168.createElement(DraggablePopover, { nudge, renderMode, stepCount, stepIndex }),
            position: "top-right",
            duration: Infinity,
            onEscapeKeyDown
          });
        }
      }
    };
  }
});

// commandbar/src/shared/components/Confetti.tsx
import * as React169 from "react";
import ConfettiDOM from "react-dom-confetti";
var CB_CONFETTI_EVENT, DEFAULT_CONFIG, releaseConfetti, Confetti, Confetti_default;
var init_Confetti = __esm({
  "commandbar/src/shared/components/Confetti.tsx"() {
    "use strict";
    init_dispatchCustomEvent();
    init_Z();
    CB_CONFETTI_EVENT = "CommandBar.Confetti";
    DEFAULT_CONFIG = {
      spread: 360
    };
    releaseConfetti = (customConfig) => {
      const detail = !!customConfig && typeof customConfig !== "boolean" ? {
        ...DEFAULT_CONFIG,
        ...customConfig
      } : DEFAULT_CONFIG;
      dispatchCustomEvent(CB_CONFETTI_EVENT, { detail });
    };
    Confetti = () => {
      const [active, setActive] = React169.useState(false);
      const [config2, setConfig] = React169.useState(DEFAULT_CONFIG);
      React169.useEffect(() => {
        const listen = (e) => {
          var _a2;
          const detail = (_a2 = e == null ? void 0 : e.detail) != null ? _a2 : DEFAULT_CONFIG;
          setConfig(detail);
          setActive(true);
          setTimeout(() => setActive(false), 30);
        };
        document.addEventListener(CB_CONFETTI_EVENT, listen);
        return () => {
          document.removeEventListener(CB_CONFETTI_EVENT, listen);
        };
      }, [active]);
      return /* @__PURE__ */ React169.createElement("div", { style: { position: "absolute", top: "35vh", right: "50vw", zIndex: Z_default.Z_CONFETTI } }, /* @__PURE__ */ React169.createElement(ConfettiDOM, { active, config: config2 }));
    };
    Confetti_default = Confetti;
  }
});

// internal/src/middleware/helpDocsIntegration.tsx
import * as t36 from "io-ts";
var HelpDocsIntegrationV, SyncStatusV, HelpDocsIntegration, IntercomCreateConversationPayloadV, IntercomCreateConversationResponseV, IntercomIntegration;
var init_helpDocsIntegration = __esm({
  "internal/src/middleware/helpDocsIntegration.tsx"() {
    "use strict";
    init_network();
    init_generics();
    init_audience();
    HelpDocsIntegrationV = t36.intersection(
      [
        t36.type({
          id: t36.number,
          organization: t36.string,
          type: t36.string,
          schedule: t36.string,
          meta: t36.union([t36.record(t36.string, t36.any), t36.null]),
          audience: t36.union([AudienceV, t36.null]),
          helphub_view_article_button_hidden: t36.union([t36.boolean, t36.undefined, t36.null])
        }),
        t36.partial({
          title: t36.string,
          icon: t36.string,
          commands_count: t36.number,
          recent_sync_date: t36.union([t36.string, t36.null]),
          recent_sync_error: t36.boolean
        })
      ],
      "HelpDocsIntegrationV"
    );
    SyncStatusV = t36.intersection([
      t36.type({
        running: t36.boolean,
        numFetched: t36.number,
        numProcessed: t36.number
      }),
      t36.partial({
        deleting: t36.boolean
      })
    ]);
    HelpDocsIntegration = class {
    };
    HelpDocsIntegration.create = createObject(HelpDocsIntegrationV, HelpDocsIntegrationV, "integrations/helpdocs");
    HelpDocsIntegration.read = readObject(HelpDocsIntegrationV, "integrations/helpdocs");
    HelpDocsIntegration.list = listObject(HelpDocsIntegrationV, "integrations/helpdocs");
    HelpDocsIntegration.update = updateObject(HelpDocsIntegrationV, HelpDocsIntegrationV, "integrations/helpdocs");
    HelpDocsIntegration.delete = deleteObject(HelpDocsIntegrationV, "integrations/helpdocs");
    /** Get the status of the latest currently running sync for an integration */
    HelpDocsIntegration.readSyncStatus = (integrationId) => read(
      SyncStatusV,
      `integrations/sync/running`
    )({
      integration_id: integrationId
    });
    IntercomCreateConversationPayloadV = t36.type({
      message_id: t36.string,
      intercom_user_type: t36.union([t36.literal("visitor"), t36.literal("user")]),
      intercom_user_id: t36.union([t36.string, t36.undefined])
    });
    IntercomCreateConversationResponseV = t36.partial({
      conversation_id: t36.string
    });
    IntercomIntegration = class {
    };
    IntercomIntegration.createConversation = async (payload) => {
      const result = await post(`integrations/intercom/create_conversation/`, payload);
      return await decodeToPromise(IntercomCreateConversationResponseV, result.data);
    };
  }
});

// commandbar/src/shared/store/executables/executable-actions.ts
var helpDocExecutable, linkExecutable, clickExecutable, openIntercomChat, loadIntercomConversation, openChatExecutable, chatHandoffExecutable, executeAction, commandExecutableWithFullArgumentSelections;
var init_executable_actions = __esm({
  "commandbar/src/shared/store/executables/executable-actions.ts"() {
    "use strict";
    init_global_selectors();
    init_Errors();
    init_dom();
    init_Interpolate();
    init_service_selectors();
    init_global_actions();
    init_service_actions();
    init_Reporting();
    init_Logger();
    init_sentry();
    init_useMobileExperience();
    init_location();
    init_globals();
    init_service_selectors2();
    init_operatingSystem();
    init_helpdocService();
    init_service_actions4();
    init_executable_selectors();
    init_helpDocsIntegration();
    init_service_selectors3();
    helpDocExecutable = (_, action, command) => {
      var _a2, _b2;
      if (!isHelpHubWidgetAvailable(_) || !((_a2 = _.organization) == null ? void 0 : _a2.helphub_enabled) && ((_b2 = _.organization) == null ? void 0 : _b2.copilot_enabled))
        return linkExecutable(_, action);
      const query = _.spotlight.inputText;
      return () => {
        var _a3;
        if (!((_a3 = _.organization) == null ? void 0 : _a3.id)) {
          Logger_default.warn(`Search error: Organization ID not found`);
          linkExecutable(_, action)();
        } else {
          if (isStudioPreview() && !_.helpHub.visible) {
            _.callbacks["__standalone-editor-cb_helpdoc_triggered"](command.text);
          } else {
            setHelpHubVisible(_, true, {
              article: commandToHelpHubDoc(command),
              query
            });
          }
        }
      };
    };
    linkExecutable = (_, action, forceNewTab) => {
      const _url = interpolate(action.value, _, true, true, true);
      if (!!forceNewTab) {
        return () => window.open(_url, "_blank");
      }
      switch (action.operation) {
        case "router":
          const routerFunc = _.callbacks["commandbar-router"];
          if (routerFunc) {
            return () => routerFunc(_url);
          } else {
            throw new InternalError("Link is of router type, but router is not defined.");
          }
        case "self":
          return () => window.open(_url, "_self");
        case "blank":
          return () => window.open(_url, "_blank");
        default:
          return () => window.open(_url, "_blank");
      }
    };
    clickExecutable = (_, action) => {
      const values = action.value.map((el) => interpolate(el, _, true, true));
      if (!checkSelector(values[0])) {
        throw new InternalError(`Cannot find element to click: [${values[0]}]`);
      }
      const reportFailure = (_selector) => {
        var _a2, _b2;
        error2("checklist_item_element_not_found", {
          questlist_id: (_a2 = _.activeChecklist) == null ? void 0 : _a2.id
        });
        (_b2 = getSentry()) == null ? void 0 : _b2.captureMessage(`Click failed`);
      };
      if (action.value.length === 1) {
        return () => clickElement(values[0], reportFailure);
      } else {
        return () => clickElementsWithPause(0, values, reportFailure);
      }
    };
    openIntercomChat = async (_, args) => {
      var _a2, _b2, _c2;
      if (((_b2 = (_a2 = _.organization) == null ? void 0 : _a2.integrations.intercom) == null ? void 0 : _b2.enabled) && (args == null ? void 0 : args.messageId)) {
        const visitorId = window.Intercom("getVisitorId");
        try {
          const data = await IntercomIntegration.createConversation({
            message_id: args.messageId,
            intercom_user_id: (_c2 = window.intercomSettings.user_id) != null ? _c2 : visitorId,
            intercom_user_type: window.intercomSettings.user_id ? "user" : "visitor"
          });
          if (data == null ? void 0 : data.conversation_id) {
            await loadIntercomConversation(data.conversation_id);
            return;
          }
        } catch (err) {
        }
      }
      window.Intercom("showNewMessage");
    };
    loadIntercomConversation = async (conversationId) => {
      return new Promise((resolve) => {
        window.Intercom("onShow", () => {
          resolve();
        });
        window.Intercom("showConversation", conversationId);
      });
    };
    openChatExecutable = async (_, action, args) => {
      var _a2, _b2;
      let cb = () => void 0;
      switch ((_a2 = action == null ? void 0 : action.meta) == null ? void 0 : _a2.type) {
        case "intercom":
          cb = () => openIntercomChat(_, args);
          break;
        case "helpscout":
          cb = () => window.Beacon("open");
          break;
        case "freshdesk":
          cb = () => window.FreshworksWidget("open");
          break;
        case "freshchat": {
          cb = async () => {
            var _a3, _b3;
            const topicName = (_b3 = (_a3 = _.organization) == null ? void 0 : _a3.integrations.freshchat) == null ? void 0 : _b3.topic_name;
            window.fcWidget.open(topicName ? { name: topicName } : void 0);
          };
          break;
        }
        case "gist":
          cb = () => window.gist.chat("open");
          break;
        case "crisp":
          cb = () => {
            window.$crisp.push(["do", "chat:open"]);
            window.$crisp.push(["do", "chat:show"]);
          };
          break;
        case "talkdesk_v2":
          cb = () => {
            window.webchat.open();
          };
          break;
        case "zendesk": {
          cb = () => {
            try {
              window.zE("messenger", "open");
            } catch (_e) {
              window.zE("webWidget", "open");
              window.zE("webWidget", "show");
            }
          };
          break;
        }
        case "liveChat":
          cb = () => window.LiveChatWidget.call("maximize");
          break;
        case "olark":
          cb = () => window.olark("api.box.expand");
          break;
        case "hubspot":
          cb = () => window.HubSpotConversations.widget.open();
          break;
        case "drift":
          cb = () => window.drift.api.openChat();
          break;
        case "pylon":
          cb = () => window.Pylon("show");
      }
      const nativeCallback = getNativeCallback();
      if (window._cbIsWebView && nativeCallback) {
        cb = () => nativeCallback(JSON.stringify(action));
      }
      try {
        await cb();
      } catch (e) {
        (_b2 = getSentry()) == null ? void 0 : _b2.captureException(e);
      }
    };
    chatHandoffExecutable = async (_, action, args) => {
      var _a2, _b2;
      let cb = () => void 0;
      switch ((_a2 = action == null ? void 0 : action.meta) == null ? void 0 : _a2.type) {
        case "intercom": {
          cb = () => openIntercomChat(_, args);
          break;
        }
        case "freshchat": {
          cb = () => {
            var _a3, _b3, _c2, _d, _e;
            if (args && "chatHistory" in args) {
              const { chatHistory } = args;
              const copilot_chat_history = chatHistory.map(({ message_type, value }) => {
                var _a4;
                if (message_type === "AI") {
                  return `<strong>${((_a4 = _.organization) == null ? void 0 : _a4.copilot_name) || "Copilot"}:</strong> ${value.answer}`;
                }
                if (message_type === "USER") {
                  return `<strong>User:</strong> ${value.question}

`;
                }
                return "";
              }).join("");
              window.fcWidget.conversation.setConversationProperties({
                [`cf_${(_c2 = (_b3 = (_a3 = _.organization) == null ? void 0 : _a3.integrations.freshchat) == null ? void 0 : _b3.conversation_property_name) != null ? _c2 : "copilot_chat_history"}`]: copilot_chat_history
              });
            }
            const topicName = (_e = (_d = _.organization) == null ? void 0 : _d.integrations.freshchat) == null ? void 0 : _e.topic_name;
            window.fcWidget.open(topicName ? { name: topicName } : void 0);
          };
          break;
        }
      }
      try {
        await cb();
      } catch (e) {
        (_b2 = getSentry()) == null ? void 0 : _b2.captureException(e);
      }
    };
    executeAction = (_, action, e, args = {}, executionEventSource = { type: "helphub_recommendation" }, callback) => {
      var _a2, _b2, _c2, _d;
      let openedNewTab = false;
      switch (action == null ? void 0 : action.type) {
        case "open_bar":
          if (isStudioPreview()) {
            _.callbacks["__standalone-editor-open-spotlight-action"]();
          } else {
            getSDK().open(action.value, { categoryFilter: action.categoryFilter });
          }
          break;
        case "open_helphub":
          getSDK().openHelpHub();
          break;
        case "open_copilot":
          getSDK().openCopilot({ query: action.query });
          break;
        case "clickBySelector":
        case "clickByXpath":
        case "click":
          const value = typeof action.value === "string" ? [action.value] : action.value;
          clickExecutable(_, {
            type: action.type,
            value
          })();
          break;
        case "execute_command":
          const command = getCommandById(_, action.meta.command);
          if (command) {
            if (command.template.type === "link" && command.template.operation === "blank") {
              openedNewTab = true;
            }
            executeCommand(_, command, void 0, void 0, executionEventSource, e, true);
            let shouldRebaseAndFulfill = false;
            _.spotlight.steps.forEach((step) => {
              if (step.type === "textinput" || step.type === "longtextinput" || step.type === "select" || step.type === "multiselect") {
                const value2 = args[step.argument.userDefinedValue];
                if (value2) {
                  step.selected = {
                    data: value2,
                    type: "parameter",
                    category: null
                  };
                  step.completed = true;
                  shouldRebaseAndFulfill = true;
                }
              }
            });
            if (shouldRebaseAndFulfill) {
              rebase(completeNextStepAndSubsequentExecuteSteps(_));
            }
          } else {
            helpdocService_default.getHelpdocCommand(_, action.meta.command).then((command2) => {
              if (command2) {
                executeCommand(_, command2, void 0, void 0, executionEventSource, e, true);
              }
            });
          }
          break;
        case "link":
          if (isStudioPreview()) {
            const _url = interpolate(action.value, _, true, true, true);
            _.callbacks["commandbar-router"](_url);
            return;
          } else {
            linkExecutable(_, action, !!e && getTriggerKey(e))();
            if (action.operation === "blank") {
              openedNewTab = true;
            }
          }
          break;
        case "open_chat":
          if (isStudioPreview()) {
            const upperCase = `${(_a2 = action == null ? void 0 : action.meta) == null ? void 0 : _a2.type.charAt(0).toUpperCase()}${(_b2 = action == null ? void 0 : action.meta) == null ? void 0 : _b2.type.slice(1)}`;
            _.callbacks["__standalone-editor-cb_hh_cta"](upperCase);
          } else {
            openChatExecutable(_, action, args).then(() => {
              setHelpHubVisible(_, false, { article: null });
            });
          }
          break;
        case "chat_handoff": {
          if (isStudioPreview()) {
            const upperCase = `${(_c2 = action == null ? void 0 : action.meta) == null ? void 0 : _c2.type.charAt(0).toUpperCase()}${(_d = action == null ? void 0 : action.meta) == null ? void 0 : _d.type.slice(1)}`;
            _.callbacks["__standalone-editor-cb_hh_cta"](upperCase);
          } else {
            chatHandoffExecutable(_, action, args).then(() => {
              setHelpHubVisible(_, false, { article: null });
            });
          }
          break;
        }
        case "questlist":
          const questlist = getChecklistById(_, action.value);
          if (questlist) {
            activatePushExperience(_, questlist, "questlist");
          }
          break;
        case "nudge": {
          const nudge = getNudgeById(_, action.value);
          if (nudge) {
            const x = e == null ? void 0 : e.clientX;
            const y = e == null ? void 0 : e.clientY;
            const source = x && y ? {
              experience: executionEventSource.type,
              position: [x, y]
            } : void 0;
            activatePushExperience(_, nudge, "nudge", source);
          }
          break;
        }
      }
      if (callback) {
        callback(openedNewTab);
      }
    };
    commandExecutableWithFullArgumentSelections = (_, command, argumentSelections, overrideBehavior) => {
      var _a2;
      if (isStudioPreview()) {
        switch (command.template.type) {
          case "helpdoc":
            return helpDocExecutable(_, command.template, command);
          case "link":
            try {
              const _url = interpolate(command.template.value, _, true, true, true);
              return () => _.callbacks["commandbar-router"](_url);
            } catch (err) {
              (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
              console.error("Could not interpolate context: ", command.template.value);
              return () => _.callbacks["commandbar-router"](command.template.value);
            }
          case "admin":
          case "builtin":
          case "callback":
          case "clickByXpath":
          case "clickBySelector":
          case "click":
            return () => {
              executeCallback(_, argumentSelections, command, _.callbacks["__standalone-editor-cb"]);
            };
          default:
            break;
        }
      }
      switch (command.template.type) {
        case "helpdoc":
          return helpDocExecutable(_, command.template, command);
        case "link":
          return linkExecutable(_, command.template, overrideBehavior == null ? void 0 : overrideBehavior.openLinkInNewTab);
        case "admin":
        case "builtin":
        case "callback":
          const callbackName = command.template.value;
          const callback = _.callbacks[callbackName];
          if (!callback) {
            throw new InternalError(`Callback is not available: [${callbackName}]`);
          }
          return () => {
            executeCallback(_, argumentSelections, command, callback);
          };
        case "clickByXpath":
        case "clickBySelector":
        case "click":
          return clickExecutable(_, command.template);
        case "appcues":
          if (!window.Appcues || !window.Appcues.show) {
            throw new InternalError("Appcues is not available");
          }
          return () => {
            const contentId = command.template.value.toString();
            window.Appcues.show(contentId);
          };
        case "pendo_guide":
          if (isStudioPreview()) {
            return () => {
              _.callbacks["__standalone-editor-cb"](command.template.value);
            };
          } else if (!window.pendo) {
            throw new InternalError("Pendo is not available");
          }
          return () => {
            const guideId = command.template.value.toString();
            window.pendo.showGuideById(guideId);
          };
        case "request":
          const {
            method = "get",
            url,
            headers,
            body,
            // onSend,
            onSuccess,
            onError
          } = command.template.value;
          const interpolatedRequest = interpolateObject({
            s: {
              url,
              headers,
              body
            },
            _,
            interpolateContext: true,
            interpolateArgs: true
          });
          const requestFn = (req) => {
            const headers2 = !!req.headers ? new Headers(req.headers) : void 0;
            const requestOptions = {
              method: req.method,
              headers: headers2,
              body: ["patch", "put", "post"].includes(req.method) ? JSON.stringify(req.body) : void 0
            };
            return fetch(req.url, requestOptions);
          };
          let onSuccessFunc = void 0;
          if (onSuccess) {
            onSuccessFunc = _.callbacks[onSuccess];
            if (!onSuccessFunc) {
              Logger_default.error(`onSuccess callback for request is not available, [${onSuccess}]`);
            }
          }
          let onErrorFunc = void 0;
          if (onError) {
            onErrorFunc = _.callbacks[onError];
            if (!onErrorFunc) {
              Logger_default.error(`onError callback for request is not available, [${onError}]`);
            }
          }
          return () => {
            const request = () => requestFn({
              method,
              ...interpolatedRequest
            });
            runRequestCommandAndReportFailure(request, command, onSuccessFunc, onErrorFunc);
          };
        case "webhook":
          return () => {
            const webhook = command.template.value.toString();
            const context = selectContextForExternalUse(_, false);
            const payload = {
              args: argumentSelections,
              context
            };
            fetch(webhook, {
              method: "POST",
              headers: {
                "Content-Type": "application/json"
              },
              body: JSON.stringify(payload)
            });
          };
        case "video":
          return () => {
          };
        case "trigger":
          const action = command.template.value;
          return () => {
            executeAction(_, action, void 0, argumentSelections, { type: "bar" });
          };
        case "script":
          return () => {
            var _a3, _b2;
            let script = "";
            const org_uid = ((_a3 = _ == null ? void 0 : _.organization) == null ? void 0 : _a3.id) ? (_b2 = _ == null ? void 0 : _.organization) == null ? void 0 : _b2.id.toString() : "";
            const context = selectContextForExternalUse(_, false);
            if (["8eafe599"].includes(org_uid)) {
              script = command.template.value.toString();
            }
            dangerouslyRunJS(script, argumentSelections, context);
          };
        default:
          throw new InternalError("Invalid command execute type.");
      }
    };
  }
});

// commandbar/src/products/checklists/store/actions.ts
import isEqual7 from "lodash/isEqual";
import { ref as ref5 } from "valtio";
var showChecklist, hideChecklist, setChecklists, activateChecklist, forceTriggerChecklist, triggerChecklists, updateChecklistItemConditionsGoals, goalHasMatchingEvent, updateChecklistItemEventGoals, onChecklistItemSelect, onChecklistItemComplete, addGoalListeners, markChecklistAsCompleted, markChecklistAsSkipped, setChecklistExpandedState, clearChecklistData, clearChecklistFields, resetChecklist;
var init_actions5 = __esm({
  "commandbar/src/products/checklists/store/actions.ts"() {
    "use strict";
    init_globals();
    init_symbols();
    init_actions4();
    init_helpers6();
    init_selectors6();
    init_selectors6();
    init_dom();
    init_Logger();
    init_Reporting();
    init_Confetti();
    init_location();
    init_rules();
    init_helpers4();
    init_editorUtils();
    init_executable_actions();
    init_service_actions3();
    init_audience2();
    init_track();
    showChecklist = (_, c) => {
      _.activeChecklist = c;
    };
    hideChecklist = (_) => {
      _.activeChecklist = null;
    };
    setChecklists = (_, checklists) => {
      for (const checklist3 of checklists) {
        if (checklist3.trigger.type === "when_element_appears") {
          _.triggerableSelectors.push(checklist3.trigger.meta.selector);
        }
      }
      const hasChanged = !isEqual7(_.checklists, checklists);
      if (hasChanged) {
        _.checklists = ref5(checklists);
        if (_.activeChecklist !== null) {
          _.activeChecklist = checklists.find((c) => {
            var _a2;
            return c.id === ((_a2 = _.activeChecklist) == null ? void 0 : _a2.id);
          }) || null;
        } else {
          triggerChecklists(_, { type: "when_conditions_pass" });
        }
      }
    };
    activateChecklist = (_, checklist3) => {
      _.activeChecklist = checklist3;
      _.queuedChecklist = null;
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      const thisChecklistData = allChecklistData[checklist3.id] || {};
      const newChecklistData = { ...allChecklistData, [checklist3.id]: { ...thisChecklistData, isseen: true } };
      updateEndUserStore(_, { checklists: newChecklistData, activeChecklistId: checklist3.id }, "checklist_interactions");
      sendIndirectTrigger(_, { type: "when_conditions_pass" });
      const completed = !hasIncompleteItems(_, checklist3);
      checklistShown(checklist3, completed);
      Track.checklist.viewed(checklist3);
    };
    forceTriggerChecklist = (_, checklist3) => {
      if (isAvailableToEndUser(_, checklist3) && checklistPassesPageConditions(_, checklist3)) {
        clearChecklistFields(_, checklist3, ["isSkipped", "isCompleted", "isExpanded"]);
        activateChecklist(_, checklist3);
      }
    };
    triggerChecklists = (_, trigger, properties = {}) => {
      var _a2, _b2, _c2;
      if (typeof _.endUser === "undefined" || _.checklists.length === 0 || !_.products.includes("checklists") || isStudioPreview())
        return;
      const isTriggered = (checklist3) => {
        if (checklist3.trigger.type === "when_share_link_viewed")
          return false;
        if ((trigger == null ? void 0 : trigger.type) === "when_page_reached" && checklist3.trigger.type === "when_page_reached") {
          return trigger.meta.url.includes(checklist3.trigger.meta.url);
        }
        if ((trigger == null ? void 0 : trigger.type) === "on_event" && checklist3.trigger.type === "on_event") {
          if (trigger.meta.event !== checklist3.trigger.meta.event)
            return false;
          if (checklist3.trigger.meta.condition_group) {
            const result = runBooleanExpression(checklist3.trigger.meta.condition_group, _, "", {
              eventProperties: properties
            });
            return result.passed;
          } else {
            return true;
          }
        }
        return isEqual7(checklist3.trigger, trigger);
      };
      const previouslyShown = previouslyShownChecklist(_);
      if (!!previouslyShown) {
        const previousPassesConditions = checklistPassesPageConditions(_, previouslyShown) && isAvailableToEndUser(_, previouslyShown);
        if (!_.activeChecklist && previousPassesConditions) {
          _.activeChecklist = previouslyShown;
        } else if (!!_.activeChecklist && ((_a2 = _.activeChecklist) == null ? void 0 : _a2.id) === previouslyShown.id && !previousPassesConditions) {
          _.activeChecklist = null;
        }
      }
      if (!!_.activeChecklist && !((_b2 = _.activeChecklist) == null ? void 0 : _b2._editorState)) {
        if (_.endUserStore.hasRemoteLoaded && !!_.queuedChecklist) {
          _.queuedChecklist = null;
        }
        if (dontShowChecklist(_, _.activeChecklist)) {
          _.activeChecklist = null;
        } else if (
          // active checklist has been cleared e.g via reset checklist
          _.endUserStore.hasRemoteLoaded && ((_c2 = _.endUserStore.data.checklist_interactions) == null ? void 0 : _c2.activeChecklistId) === null
        ) {
          _.activeChecklist = null;
        } else {
          return;
        }
      }
      if (!!_.queuedChecklist && dontShowChecklist(_, _.queuedChecklist)) {
        _.queuedChecklist = null;
      }
      if (!_.queuedChecklist) {
        for (let i2 = 0; i2 < _.checklists.length; i2++) {
          const c = _.checklists[i2];
          if (!c.is_live && !_.isAdmin || dontShowChecklist(_, c)) {
            continue;
          }
          if (isTriggered(c) && passesAudienceConditions(_, "checklists", c) && checklistPassesPageConditions(_, c)) {
            _.queuedChecklist = c;
            break;
          }
        }
      }
      if (_.endUserStore.hasRemoteLoaded && !!_.queuedChecklist) {
        activateChecklist(_, _.queuedChecklist);
      }
    };
    updateChecklistItemConditionsGoals = (_) => {
      const activeChecklist = _.activeChecklist;
      if (!activeChecklist) {
        return;
      }
      activeChecklist.items.filter((item) => !isItemCompleted(_, activeChecklist, item)).forEach((item) => {
        switch (item.goal.type) {
          case "page_visited":
            if (!!item.goal.value && _.location.href.includes(item.goal.value)) {
              onChecklistItemComplete(_, item);
            }
            break;
          case "conditions_met":
            if (getConditions(item.goal.expression).length > 0 && runBooleanExpression(item.goal.expression, _, "").passed) {
              onChecklistItemComplete(_, item);
            }
            break;
          default:
            break;
        }
      });
    };
    goalHasMatchingEvent = (goal, eventKey) => goal.type === "event_tracked" && goal.event === eventKey;
    updateChecklistItemEventGoals = (_, eventKey, properties) => {
      const activeChecklist = _.activeChecklist;
      if (!activeChecklist) {
        return;
      }
      for (const item of activeChecklist.items) {
        if (!goalHasMatchingEvent(item.goal, eventKey) || isItemCompleted(_, activeChecklist, item)) {
          continue;
        }
        const shouldCompleteItem = item.goal.condition_group ? runBooleanExpression(item.goal.condition_group, _, "", {
          eventProperties: properties
        }).passed : true;
        if (shouldCompleteItem) {
          onChecklistItemComplete(_, item);
        }
      }
    };
    onChecklistItemSelect = (_, item, e) => {
      var _a2;
      if (!!_.activeChecklist) {
        const checklist3 = _.activeChecklist;
        checklistItemEngagement(item, checklist3.id, isItemCompleted(_, checklist3, item), "cta_clicked");
        Track.checklist.ctaClicked(checklist3, item);
      }
      if (isStudioPreview()) {
        _.callbacks["__standalone-editor-checklist-action-cta-clicked"]();
        return;
      }
      if (item.goal.type === "cta_clicked") {
        onChecklistItemComplete(_, item);
      }
      executeAction(_, item.action, e, {}, { type: "questlist", id: ((_a2 = _.activeChecklist) == null ? void 0 : _a2.id) || 0 });
    };
    onChecklistItemComplete = (_, item, skipped = false) => {
      if (!_.activeChecklist) {
        return;
      }
      if (item.celebrate)
        releaseConfetti();
      const checklist3 = _.activeChecklist;
      const incomplete = hasIncompleteItems(_, checklist3);
      if (skipped) {
        checklistItemEngagement(item, checklist3.id, true, "skipped");
        Track.checklist.itemSkipped(checklist3, item, incomplete);
      } else {
        Track.checklist.itemCompleted(checklist3, item, incomplete);
      }
      checklistItemEngagement(item, checklist3.id, true, "completed");
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      const thisChecklistData = allChecklistData[_.activeChecklist.id] || {};
      const items = { ...thisChecklistData == null ? void 0 : thisChecklistData.items };
      items[item.id] = { completedTS: (/* @__PURE__ */ new Date()).toISOString() };
      const newChecklistData = { ...allChecklistData, [_.activeChecklist.id]: { ...thisChecklistData, items } };
      updateEndUserStore(_, { checklists: newChecklistData }, "checklist_interactions");
      if (!hasIncompleteItems(_, checklist3)) {
        checklistEngagement(checklist3, checklist3.id, "completed", true);
        Track.checklist.completed(checklist3);
        sendIndirectTrigger(_, { type: "when_conditions_pass" });
      }
      if (checklist3.celebrate && !hasIncompleteItems(_, checklist3)) {
        releaseConfetti();
      }
    };
    addGoalListeners = (_, checklist3, items) => {
      const removeListenerFns = [];
      items.filter((item) => !isItemCompleted(_, checklist3, item)).forEach((item) => {
        var _a2;
        switch (item.goal.type) {
          case "command_executed":
            const command = item.goal.meta.command;
            const sdk = getSDK();
            if (!!sdk[_eventSubscriptions] && sdk[_eventSubscriptions] !== void 0) {
              const symbol = Symbol(`checklistItemListener-${item.id}`);
              (_a2 = sdk[_eventSubscriptions]) == null ? void 0 : _a2.set(symbol, [
                (name, data) => {
                  if (name === "command_execution") {
                    if (`${data.command}` === command && _.activeChecklist) {
                      onChecklistItemComplete(_, item);
                    }
                  }
                },
                void 0
              ]);
              removeListenerFns.push(() => {
                var _a3;
                (_a3 = sdk[_eventSubscriptions]) == null ? void 0 : _a3.delete(symbol);
              });
            }
            break;
          case "element_clicked": {
            const { goal } = item;
            const maxAttempts = 4;
            let attempts = 0;
            const attemptToAddListener = () => {
              const element = getElement(goal.value);
              if (element) {
                const clickListener = () => {
                  onChecklistItemComplete(_, item);
                };
                element.addEventListener("click", clickListener);
                removeListenerFns.push(() => {
                  element.removeEventListener("click", clickListener);
                });
                clearInterval(intervalId);
              } else {
                attempts++;
                if (attempts >= maxAttempts) {
                  clearInterval(intervalId);
                  Logger_default.warn(`Couldn't find element for click goal: ${goal.value}`);
                }
              }
            };
            const intervalId = setInterval(attemptToAddListener, 500);
            break;
          }
          case "page_visited":
            break;
          case "conditions_met":
            break;
          case "cta_clicked":
            break;
        }
      });
      return () => {
        removeListenerFns.forEach((fn) => fn());
      };
    };
    markChecklistAsCompleted = (_, checklist3) => {
      _.activeChecklist = null;
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      const thisChecklistData = allChecklistData[checklist3.id] || {};
      const newChecklistData = { ...allChecklistData, [checklist3.id]: { ...thisChecklistData, isCompleted: true } };
      updateEndUserStore(_, { checklists: newChecklistData, activeChecklistId: null }, "checklist_interactions");
      const completed = !hasIncompleteItems(_, checklist3);
      checklistEngagement(checklist3, checklist3.items.length, "dismissed", completed);
      Track.checklist.dismissed(checklist3, !completed);
      sendIndirectTrigger(_, { type: "when_conditions_pass" });
      if (isChecklistInPreviewMode(checklist3)) {
        openEditorIfLoaded();
      }
    };
    markChecklistAsSkipped = (_, checklist3) => {
      _.activeChecklist = null;
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      const thisChecklistData = allChecklistData[checklist3.id] || {};
      const newChecklistData = {
        ...allChecklistData,
        [checklist3.id]: { ...thisChecklistData, isSkipped: true }
      };
      updateEndUserStore(_, { checklists: newChecklistData, activeChecklistId: null }, "checklist_interactions");
      const completed = !hasIncompleteItems(_, checklist3);
      checklistEngagement(checklist3, getChecklistNumCompletedItems(_, checklist3), "dismissed", completed);
      Track.checklist.dismissed(checklist3, !completed);
      sendIndirectTrigger(_, { type: "when_conditions_pass" });
      if (isChecklistInPreviewMode(checklist3)) {
        openEditorIfLoaded();
      }
    };
    setChecklistExpandedState = (_, checklist3, value) => {
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      const thisChecklistData = allChecklistData[checklist3.id] || {};
      const newChecklistData = {
        ...allChecklistData,
        [checklist3.id]: { ...thisChecklistData, isExpanded: value }
      };
      updateEndUserStore(_, { checklists: newChecklistData }, "checklist_interactions");
    };
    clearChecklistData = (_, checklist3, clearFromActive = false) => {
      var _a2;
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      delete allChecklistData[checklist3.id];
      const dataUpdate = { checklists: allChecklistData };
      if (clearFromActive && ((_a2 = _.activeChecklist) == null ? void 0 : _a2.id) === checklist3.id) {
        if (!_.activeChecklist._editorState) {
          _.activeChecklist = null;
        }
        dataUpdate.activeChecklistId = null;
      }
      updateEndUserStore(_, dataUpdate, "checklist_interactions");
    };
    clearChecklistFields = (_, checklist3, fieldsToClear) => {
      const allChecklistData = { ..._.endUserStore.data.checklist_interactions.checklists };
      if (!allChecklistData[checklist3.id])
        return;
      for (const field of fieldsToClear) {
        if (allChecklistData[checklist3.id][field] !== void 0) {
          delete allChecklistData[checklist3.id][field];
        }
      }
      updateEndUserStore(_, { checklists: allChecklistData }, "checklist_interactions");
    };
    resetChecklist = (_, id2, keepOpen = false) => {
      const checklist3 = _.checklists.find(({ id: _id }) => _id === id2);
      if (checklist3) {
        clearChecklistData(_, checklist3, !keepOpen);
      }
    };
  }
});

// commandbar/src/products/checklists/service-actions.ts
var service_actions_exports4 = {};
__export(service_actions_exports4, {
  clearChecklistData: () => clearChecklistData,
  forceTriggerChecklist: () => forceTriggerChecklist,
  hideChecklist: () => hideChecklist,
  resetChecklist: () => resetChecklist,
  setChecklists: () => setChecklists,
  showChecklist: () => showChecklist,
  triggerChecklists: () => triggerChecklists,
  updateChecklistItemConditionsGoals: () => updateChecklistItemConditionsGoals,
  updateChecklistItemEventGoals: () => updateChecklistItemEventGoals
});
var init_service_actions2 = __esm({
  "commandbar/src/products/checklists/service-actions.ts"() {
    "use strict";
    init_actions5();
  }
});

// commandbar/src/products/nudges/store/nudgeStepMachine.ts
import { createMachine as createMachine5 } from "xstate";
var StepConditionsMachine, nudgeStepMachine_default;
var init_nudgeStepMachine = __esm({
  "commandbar/src/products/nudges/store/nudgeStepMachine.ts"() {
    "use strict";
    init_Reporting();
    init_selectors5();
    StepConditionsMachine = (_, {
      nudge,
      stepIndex,
      triggerEvent
    }) => createMachine5(
      {
        /** @xstate-layout N4IgpgJg5mDOIC5QGUAuYAOACAwgewDsIBLVYw2AOgAUwjiCoBiAbQAYBdRUDPWU8gW4gAHogC0AJjaUALAE55AZjayA7AA42AVnk6AbEoA0IAJ6INSyrs2SlsnXYCMsyQF83JtJlyESZCho6EkZWJy4kEF5+AKFIsQQlSQ1KNjVJbSV9eUNtJ0MTcwRLa3lbe0clF3dPEG9sfHpYqmQwAEMAJwBjAAsGKCwAMTwOrAAVTphULABRABswAFs6VCZqAEFkZBmAEQB9MfWAJQBxGbG9mYAZGYBZGYA5MfYInj4BQmEEyTU1Sg1ZLp9JkXE5tOlZIVEFUrGw0moypIkdpJPonB4vOgGn4PgQWu1un1GEMRuNJmBpvMlismCJYKg2uhKG0AGboDoACmud0eF22xxwAAkDgBJe4AeQAqmMAJRMeq+JqCfGdXr9EmjCYdKazBbLAioF7CaK4r6IH5WZJqLI5SRODQabJQhD22SUeQObSuNiWJxKbQabQeWoEPAQODCBWNfzK43vWJmhDiAGUSTyJEAtNqNHA+TO5N-SSuJTZnKyJz2pEYupYxUxwK0eiMOMxQSJhz-JxqNjyDRONjI355syIGQZNQB-QaZRdpRJV3VqM45qUVqqokDYaa8mUvUrFum+ISLKp9PJVxlHO6Z2V91dpx2bRsCp6WSL2vR3FUB54Mnaim6tSBoHgmR4INoAaUPoOYPt2yhVJCI7FDIPblPBbBTgG74+J+K5Uvq0zDAArkQIFtmB4JOFB9r6D6OiyACmTOlUVETr8DFFvY8h+ko2HYkqgT4SsWBroSQxtMQCwQGRnwUYYlD5B6dp2lkqiSDeGiSApegQapHoog6wZuEAA */
        id: "Step Conditions",
        initial: "Pending",
        states: {
          Pending: {
            always: [
              {
                target: "Searching For Target Element",
                cond: "stepHasTargetElement"
              },
              {
                target: "No Target Element"
              }
            ]
          },
          "Searching For Target Element": {
            invoke: {
              src: "searchForElement"
            },
            on: {
              PASSED_TARGET_ELEMENT: {
                target: "Element Found"
              }
            },
            after: {
              ELEMENT_SEARCH_TIMEOUT: "Element Search Failed"
            }
          },
          "No Target Element": {
            type: "final",
            data: {
              stepChecksFailed: false
            }
          },
          "Element Search Failed": {
            entry: "reportFailure",
            type: "final",
            data: {
              stepChecksFailed: true
            }
          },
          "Element Found": {
            type: "final",
            data: {
              stepChecksFailed: false
            }
          }
        },
        schema: { events: {} },
        predictableActionArguments: true,
        preserveActionOrder: true,
        tsTypes: {}
      },
      {
        actions: {
          reportFailure: (_context, _event) => {
            error2("nudge_step_element_not_found", {
              nudge_id: nudge.id
            });
          }
        },
        services: {
          searchForElement: () => (callback) => {
            const interval = setInterval(() => {
              if (passesPinnedElement(nudge, stepIndex)) {
                callback("PASSED_TARGET_ELEMENT");
              }
            }, 100);
            return () => {
              clearInterval(interval);
            };
          }
        },
        guards: {
          stepHasTargetElement: () => {
            var _a2;
            return ((_a2 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a2.pinnedElement) || stepHasTargetElement(nudge, stepIndex);
          }
        },
        delays: { ELEMENT_SEARCH_TIMEOUT: 5e3 }
      }
    );
    nudgeStepMachine_default = StepConditionsMachine;
  }
});

// commandbar/src/products/nudges/store/nudgeMachine.ts
import { createMachine as createMachine6, assign as assign5, sendParent, actions, raise } from "xstate";
var pure, NudgeMachine, nudgeMachine_default;
var init_nudgeMachine = __esm({
  "commandbar/src/products/nudges/store/nudgeMachine.ts"() {
    "use strict";
    init_Reporting();
    init_actions6();
    init_service_actions2();
    init_selectors5();
    init_nudges();
    init_RenderNudge();
    init_nudgeStepMachine();
    init_sentry();
    init_audience2();
    init_track();
    ({ pure } = actions);
    NudgeMachine = (_, initialNudge, stepIndex) => {
      var _a2, _b2;
      const nudgeInteractionState = getNudgeDataFromUserStore(_, initialNudge.id);
      const savedStep = (_a2 = nudgeInteractionState == null ? void 0 : nudgeInteractionState.currentStep) != null ? _a2 : 0;
      const stepIndexStack = (_b2 = nudgeInteractionState == null ? void 0 : nudgeInteractionState.stepIndexStack) != null ? _b2 : [];
      const surveyResponses = {};
      const nudgeContext = {
        nudge: initialNudge,
        stepIndex: typeof stepIndex !== "undefined" ? stepIndex : savedStep > initialNudge.steps.length - 1 ? initialNudge.steps.length - 1 : savedStep,
        stepIndexStack,
        surveyResponses,
        nudgeSeenThisSessionTs: [],
        triggerEvent: null,
        prevPassedConditions: false,
        nudgeDismissed: false,
        nudgeCompleted: false,
        sentryTransaction: null
      };
      return createMachine6(
        {
          /** @xstate-layout N4IgpgJg5mDOIC5QDkCu0wGIBKBRAyrgCoD6+RAgkbgNoAMAuoqAA4D2sAlgC6dsB2zEAA9EAFgBMAGhABPRBIAciugDoArAEYAzADZligOzHDi7QF9zMtBhy4AYnnwAJEsgCqAEQDitRkPYuXgEhUQRJGXkEbTpDdVUxTQBOJMSJSU1FJMtrdBhVAEkIABssImwC719seiYkEECePkF6sK1VXUMU7U1dRJ1tQ2k5REVNVQlNYzpNOk6hlTEckBt8gGEACzAAYwBrTn4oAAI1gQgmgVhVTZ39w6OKdE4wfm2sWoCOC5bQMJ6hiZJXSpCTqJSKdKRRCGWITMEZOhJOjqJGaZarMDXLZ7A7HU78c7BfhXG44+6Pc4vN6YGiaOqsL5E0LibTaCSqZFidTqAxg9S6dRQ8LaMQJOaxAVZIxJQzovKY0l3PFnb4k7FKo74fhsNgAL0gNP89UaTNaCiG7IkIq02iMdEUYiSQuB2gSyTmSUU6jZhm02SsK3lWNuuJOKqJapD9y1Ov1EBpdM+QWazOFEnZnO5vNBAqFtsUYt0iMGYiMcUUcowwbJyoJqurGoACgBDGCG+kNRkps3RIvjJSzCSesYSPqGIVDcb29SGKaaMSGMS6TKV9bq0P4wnNSM1o4ttu0jsm7u-FlsjnqLk85R83MjBBg3SqbQo5IipQ51cK9f3Tf1xWhvYABOYAAI6oFSsjtkm3ypum6hqEifTpMC9q+s6XQaF6cSXnQQ4SMiX4Nhu4bbsR9zAWBEGvFBh4waap7CpoGaXlmN45oK95Dk+XJDoYwKzH6SQikRAG-qRlzkcc+DcM23CoLA0HGl2IQ9ioiFcj0fQQkCyRCikBagladq6MCi4WAGGJSWGdYRtZMlyQpCZHipPwiCyeEXle2b8pxUSgmovEpGIHpDt6ok-rWW6SWJxxEEBnBQDAQFHAAsnJ2wbEpDLJqpjEhaKSESBaSjGFa473p6oqJEiMrzsxugWbkVaxTZ0XEtZ8WJclaUZVldHKblblhGIMQsd57G+UKSh6AkplmOmmTSuoEVRlF-6RUc9jFJwLDZZ2Q2pqN56ZteXocUKvQLgk6T8ZewlJBIq27n+dmtdtu3OfRJ7ucKnmnT5d5RMuBY9Fag6mY16TPRqr1ka13jFGwABGzbFEcAAynAALY8Ptx55b9mjXqoZjLgKwLekM2jOgKqhxOkV3FY9WgwyRtnw5tiMo2jmM43jA05bBPajemXlsedU1ccCBY2vxwmjnoVps+JHMxZt+CZZAqClPjrmppoUyGPTM5JIbqRLsiQo3m6SKznhKSmGillBq1cPq2tmpaxAOvvImg3C-lYPi2dt5+eaSJzfojqDCYl5ETJYB7RAAiYrAsncJiVmJywHwBwxv2KEW8Tzlk85sjKYiXaZSQdDaMwx6k3IJ5nLDWe7xKYCn-CYgcABubC7FnQY5+3EnEgg-dsNscnNLUedCwXbTIk+VWgsYxOztbmFg8z3piAfKQt0nY9q533e9-wA9D6o2et6f7WwJPV-T7PAjz-7i8-cv-KqGvM6zhnJoS6S4S4QgIqZNkiRTLHzbq1dKwgjjYBeBAMAIF4wLwOoHX6PI6ZsgdDyPiXpFAgLMByYmjpGqSFnJ0WB1kEFIJQWgg0gssFL0QLg+I+CuQ6VMDyfSnoNC6HTGYfkMwYgVhdlWUeyCCRoMxjqPangCj4FSio-AmCCbDVGDMJ8dB9HugoV0XQl0jBPgQqYOgkgi4zgPnQ2RqCUoY0UZgfAyAADy7iABafgXKHTUlYvRBjUSXmMZdIYT5S4vntqNRcuh7FMKcS4vAjgCCuA8D4Xx31CZhBhOkUmaFGqzhfGYS6htjZzCtKWbklthIJLkUktge01gY3cYQTR+sAlLg5MEmYoSgTVziB0UsQ4i5QKBJI5q+QZGJIUU0zA9gCjIBUc4Dp-jGIqFmvomYISFwDPvPOA+N0gQikegRGcT0pHTPvg4+RzimmqFuQlQ4mAKCeAAGoUGQGsLJ+dv6IAFFYjQm9+IihoeErkGhLFaC5Ekb0PJ6mOLmW3J5uI7CEFIOQKgvyv45IBQhUUWgAFUPBVxP0op7SSCsTobkhtJmBmkTc2Z9yUWJLRXgbwTgNFGlxdohAgLCUgpJb0aaVjjYDk5OkR0iK7mKMeWyl5FB8D4EqMgEgjZ3EavebgbAZAdXvIKD8tZ2CwjCM8pTLQmy96XSROyKYKhUiDmEvEq5mIZkNORaoCgEA+7NleGijxpBPDuOQDith-yECAPZBTGcYw+jIidAcouT58H2g9KEhcMrGlt29b6-1Lzg2huNewyNxNo2+SdvGlEIDBF9P5AMWccKs2etzX67YaLC20E-uGvFCAVCjh6TsvpeyTEHNHMbcphtuRFOMC6qZbqmUepZQ-VUXdU6qCnjfO+J8nmerduPJ+U8Z5EnnjyntfKVC9EHYY-po7-JTHZBE4RY0dn+nnaod1SLl37rPopC+G6X5bpHour9cqf2P2fgPY9c9GCsK0amKNdcBSVpCtWrixVRRmCpTMREZhnbvs-bKh5yCoAgVgFwF5xaI2IZjShhN01ibxEeosUwEJWT0u3aypdcqSNkYo1AL6fze2XqCUOox+z-Jpvpr6P0hDiysksAGbUqD4D1AxNkvlABaRNURNNMcplkM2kgSyLiIkUUoGnUxmNrmMLSIV5oVSiMxeI-FJh6GJjoIuRgVbrQjJZnsfohSlnGFkde-FgRciXD5tqG1PYUmeK8MA-nGJDimKTAigx7Tr25LTWuNV7SGxKXhDjrtNodx3BqGMepIDJd+ukGcqhiaNRUBCUJ4d+XciwrYnSyR9DRfK9ZfcSWhN8tZACWYZaHQESmDTe8+hXRGUSH6YxgwSstTKwe6ylFwKQVq2EKYgjhIb30L6Oqd6AWJBNlaWqVSzb9c261By8lVO8tTMI8Vo5lxsnqzKfSRZbYNTGEMX0a21yewG61LqSV5HpW4JlPboxHOIFmMoDk2E5jzWBHOhlYOXoPc2h9FgCPojGHiJmIY1KuR4VpsbURcRMgLgPqNe7v7rLc1RujLGuNuDE50PxemdBWR9MZqyc7fayE10F2yecr58M4+-OD-HntNZbB9hZkbqZPQLaBGbYRoXqYCPMXhWFy5brAlgcTrkV614wiMO6WbURG0JHhKZJQ1KRKuo-ffTwqdicOmus56XEiJkMbBBycLqF8yzjoeB1Ulv+SFSm7bxtgvLqDDy99pQYJDb2iavLr3J94HNkQU8mrGuexU1dPgo2xMsNi-LnaiEtezUqBnM2llxOvvslicJW0JTvRlJhI1u07GzX2nbzxhVUBO+ZECun9j-eHcKH0a6RqOfFbA8Ip7wj2avU+rbbiTvNsiVGD0J0EG1cyGxsF7MToaEVrb5A0RuBG3f3E8XKYP+KRarC4dKH10Ts9oZynoiISwj+O6zKk+pGcA-GneZsag6Q+irmI4wCXExuEwYwswsQxUi4j0im5gQAA */
          id: "Nudge",
          initial: "Idle",
          states: {
            Idle: {
              on: {
                TRIGGER: {
                  target: "Checking Conditions",
                  actions: ["setTriggerEvent"]
                }
              }
            },
            "Checking Conditions": {
              entry: "startSentryTransaction",
              exit: "finishSentryTransaction",
              initial: "Checking Nudge Match",
              states: {
                "Checking Audience": {
                  always: [
                    {
                      target: "Checking Page",
                      cond: "passesAudience"
                    },
                    {
                      target: "#Nudge.Idle",
                      actions: ["setFailedConditions"]
                    }
                  ],
                  description: `Are audience conditions satisfied?`
                },
                "Checking Snoozed": {
                  always: [
                    {
                      target: "Checking Audience",
                      cond: "passesSnoozed"
                    },
                    {
                      target: "#Nudge.Idle"
                    }
                  ],
                  description: `Is the nudge not currently snoozed?`
                },
                "Checking Page": {
                  always: [
                    {
                      target: "Checking Flip",
                      cond: "passesPage"
                    },
                    {
                      target: "#Nudge.Idle",
                      actions: ["setFailedConditions"]
                    }
                  ],
                  description: `Are page conditions satisfied?`
                },
                "Checking Frequency": {
                  always: [
                    {
                      target: "Checking Snoozed",
                      cond: "passesFrequency"
                    },
                    {
                      target: "#Nudge.Idle",
                      actions: ["cleanupSmartNudges"]
                    }
                  ],
                  description: `Has this specific nudge been seen the maximum number of times?`
                },
                "Checking Status": {
                  always: [
                    {
                      target: "Checking Schedule",
                      cond: "passesStatus"
                    },
                    {
                      target: "#Nudge.Idle"
                    }
                  ],
                  description: `Is the nudge live?`
                },
                "Checking Nudge Match": {
                  always: [
                    {
                      target: "Checking Trigger Match",
                      cond: "passesNudgeMatch"
                    },
                    {
                      target: "#Nudge.Idle"
                    }
                  ],
                  description: "Is the triggered nudge the same as this one?"
                },
                "Checking Trigger Match": {
                  always: [
                    {
                      target: "Checking Status",
                      cond: "passesTriggerMatch"
                    },
                    {
                      target: "#Nudge.Idle"
                    }
                  ],
                  description: `Is the trigger event applicable to this nudge?`
                },
                "Checking Flip": {
                  always: [
                    {
                      target: "#Nudge.Step",
                      cond: "passesFlip",
                      actions: "setPassedConditions"
                    },
                    {
                      target: "#Nudge.Idle"
                    }
                  ],
                  description: `No limit nudges will respond to all "when_conditions_pass" triggers. These are emitted whenever anything in context changes so we could have a lot of triggers emitted continuously.
This check ensures we only respond if conditions relevant to this nudge change.`
                },
                "Checking Global Limit": {
                  always: [
                    {
                      target: "Checking Frequency",
                      cond: "passesGlobalLimit"
                    },
                    {
                      target: "#Nudge.Idle",
                      actions: "cleanupSmartNudges"
                    }
                  ]
                },
                "Checking Schedule": {
                  always: [
                    {
                      target: "Checking Global Limit",
                      cond: "passesSchedule"
                    },
                    {
                      target: "#Nudge.Idle"
                    }
                  ]
                }
              }
            },
            Step: {
              initial: "Checking Conditions",
              states: {
                Done: {
                  type: "final"
                },
                "Checking Conditions": {
                  invoke: {
                    src: "stepConditions",
                    onDone: [
                      {
                        target: "Done",
                        cond: "stepChecksFailed"
                      },
                      {
                        target: "Checking Max Rendered"
                      }
                    ]
                  },
                  description: `This is where we check any step specific conditions. 
This includes searching for elements to pin to or checking availability of commands on a CTA.`
                },
                "Checking Max Rendered": {
                  always: [
                    {
                      target: "Render Loop",
                      cond: "passesMaxNudgesRendered"
                    },
                    "Done"
                  ],
                  description: `Are we already rendering the maximum number of simultaneous nudges?
Limit is currently hard-coded to 1`
                },
                "Render Loop": {
                  entry: ["markSeen", "saveSeen"],
                  states: {
                    Rendering: {
                      entry: ["renderStep", "reevaluateChecklistItemGoals", "reportSeen"],
                      exit: "closeStep",
                      on: {
                        ADVANCE: "Advancing",
                        RESET_STATE: {
                          description: "This event is dispatched when calling the sdk method `resetNudge(id: INudgeType['id'], stepIndex?: number)`.",
                          target: "Checking Conditions",
                          actions: ["setStepIndex", "saveStepIndex", "resetSurveyResponses"]
                        },
                        REGRESS: "Regressing",
                        ASSIGN_POPOVER_SERVICE: {
                          actions: ["assignPopoverService"]
                        }
                      }
                    },
                    Advancing: {
                      entry: [
                        "execAction",
                        "reportSurveyResponse",
                        "setSurveyResponses",
                        "reportInteracted",
                        actions.choose([
                          {
                            cond: "advanceToSpecificStep",
                            actions: ["setStepIndexWithHistory", raise({ type: "NOT_DONE" })]
                          },
                          { cond: "remainingSteps", actions: ["incrementStep", raise({ type: "NOT_DONE" })] },
                          { actions: [raise({ type: "DONE" })] }
                        ])
                      ],
                      // if specific step; go to that step and then go to Checking Conditions
                      // else if more steps; idx++ and go to Checking Conditions
                      // else (if no more steps); go to Done
                      on: {
                        NOT_DONE: {
                          target: "Checking Conditions",
                          actions: ["saveInteraction"]
                        },
                        DONE: [
                          {
                            target: "#Nudge.Step.Render Loop",
                            actions: ["markCompleted", "reportCompleted", "resetStep", "saveInteraction"],
                            cond: "isTooltipNudge"
                          },
                          {
                            target: "#Nudge.Step.Done",
                            actions: ["markCompleted", "reportCompleted", "resetStep", "saveInteraction"]
                          }
                        ]
                      }
                    },
                    "Checking Conditions": {
                      invoke: {
                        src: "stepConditions",
                        onDone: [
                          {
                            target: "#Nudge.Step.Done",
                            cond: "stepChecksFailed"
                          },
                          {
                            target: "Rendering"
                          }
                        ]
                      },
                      description: `Perform the same step conditions check that occurs before the render loop.`
                    },
                    Regressing: {
                      entry: ["reportInteracted"],
                      always: [
                        {
                          target: "Checking Conditions",
                          cond: "canStepBack",
                          actions: ["decrementStep", "saveInteraction"]
                        },
                        {
                          target: "#Nudge.Step.Done",
                          actions: "reportDismissed"
                        }
                      ]
                    }
                  },
                  initial: "Rendering",
                  description: `Once a nudge has rendered, it should not be interrupted by other nudges until it is dismissed, snoozed, or cannot render its next step.
The nudge manager will keep track of how many nudges are in a render loop. If we are at the limit, we will not forward any triggers.`,
                  on: {
                    DISMISS: {
                      target: "Done",
                      actions: [
                        "reportSurveyResponse",
                        "setSurveyResponses",
                        "reportInteracted",
                        "reportDismissed",
                        "markDismissed",
                        "saveInteraction"
                      ]
                    },
                    SNOOZE: {
                      target: "Done",
                      actions: ["reportInteracted", "reportSnoozed", "saveSnoozed"]
                    },
                    REFRESH_NUDGE: {
                      target: "Render Loop",
                      internal: true,
                      actions: "refreshNudge"
                    },
                    CLOSE: "Done",
                    FINISH: {
                      target: "Done",
                      actions: [
                        "reportSurveyResponse",
                        "setSurveyResponses",
                        "reportInteracted",
                        "reportCompleted",
                        "markCompleted",
                        "resetStep",
                        "saveInteraction"
                      ]
                    }
                  },
                  exit: [
                    pure((context) => {
                      var _a3, _b3;
                      if (!((_b3 = (_a3 = context == null ? void 0 : context.triggerEvent) == null ? void 0 : _a3.overrides) == null ? void 0 : _b3.simulateMode) && !isNoGlobalLimitFormFactorStep(context.nudge, context.stepIndex)) {
                        return [
                          sendParent({
                            type: "TRIGGER",
                            trigger: { type: "when_conditions_pass" },
                            overrides: { flipLimit: true }
                          })
                        ];
                      }
                      return [];
                    }),
                    "closePopover",
                    "sendExitRenderLoop"
                  ]
                }
              },
              exit: ["reevaluateChecklistItemGoals"],
              onDone: "Idle",
              entry: ["setStepIndex"]
            }
          },
          context: nudgeContext,
          schema: { events: {}, context: {}, services: {} },
          predictableActionArguments: true,
          preserveActionOrder: true,
          tsTypes: {},
          on: {
            RESET_STATE: {
              description: "This event is dispatched when calling the sdk method `resetNudge(id: INudgeType['id'], stepIndex?: number)`.",
              target: ".Idle",
              actions: ["setStepIndex", "saveStepIndex", "resetSurveyResponses"]
            },
            REFRESH_NUDGE: { target: ".Idle", actions: ["refreshNudge"] }
          }
        },
        {
          guards: {
            passesNudgeMatch: ({ triggerEvent, nudge }) => !(triggerEvent == null ? void 0 : triggerEvent.nudgeId) || nudge.id === triggerEvent.nudgeId,
            passesMaxNudgesRendered: ({ triggerEvent, nudge, stepIndex: stepIndex2 }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.maxRenderedNudges) || isNoGlobalLimitFormFactorStep(nudge, stepIndex2) || passesMaxRenderedNudges(_);
            },
            passesTriggerMatch: ({ triggerEvent, nudge }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.triggerMatch) || passesTriggerMatch(_, nudge, triggerEvent);
            },
            passesStatus: ({ triggerEvent, nudge }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.status) || passesStatus(nudge);
            },
            passesFrequency: ({ triggerEvent, nudge }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.frequency) || passesFrequencyCondition(_, nudge);
            },
            passesAudience: ({ triggerEvent, nudge }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.audience) || passesAudienceConditions(_, "nudges", nudge);
            },
            passesSnoozed: ({ triggerEvent, nudge }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.snoozed) || passesSnoozedConditions(_, nudge);
            },
            passesPage: ({ triggerEvent, nudge }) => {
              var _a3;
              return ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.page) || passesPageConditions(_, nudge);
            },
            passesFlip: ({ triggerEvent, prevPassedConditions, nudge, stepIndex: stepIndex2 }) => {
              var _a3, _b3;
              if ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.flip) {
                return true;
              }
              if (((_b3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _b3.flipLimit) && nudge.frequency_limit !== "no_limit") {
                return true;
              }
              return passesFlip(prevPassedConditions, triggerEvent, getNudgeStep(nudge, stepIndex2));
            },
            passesGlobalLimit: ({ triggerEvent, nudge, stepIndex: stepIndex2 }) => {
              var _a3;
              return shouldBypassGlobalLimit(_, getNudgeStep(nudge, stepIndex2)) || ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.globalLimit) || passesGlobalLimit(_);
            },
            passesSchedule: ({ triggerEvent, nudge }) => (triggerEvent == null ? void 0 : triggerEvent.trigger.type) === "when_conditions_pass" && isScheduledNudge(nudge) ? passesSchedule(_, nudge) : true,
            // step specific
            // @ts-expect-error: this *is* used in the machine, but because we use it in `actions.choose` action creator, typescript isn't aware of the usage.
            remainingSteps: (context, _event) => hasRemainingSteps(context.nudge)(context),
            advanceToSpecificStep: ({ nudge }, event) => event.step !== void 0 && event.step >= 0 && event.step < nudge.steps.length,
            stepChecksFailed: (_context, event) => {
              var _a3;
              return !!((_a3 = event.data) == null ? void 0 : _a3.stepChecksFailed);
            },
            canStepBack: ({ stepIndexStack: stepIndexStack2 }) => stepIndexStack2.length > 0,
            isTooltipNudge: ({ nudge }) => !!isTooltipNudge(nudge),
            isBannerNudge: ({ nudge }) => !!isBannerNudge(nudge)
          },
          actions: {
            setTriggerEvent: assign5({
              triggerEvent: (_context, triggerEvent) => triggerEvent
            }),
            setPassedConditions: assign5({
              prevPassedConditions: (_context) => true
            }),
            setFailedConditions: assign5({
              prevPassedConditions: (_context) => false
            }),
            sendExitRenderLoop: sendParent("EXIT_RENDER_LOOP"),
            cleanupSmartNudges: sendParent(({ nudge }) => ({ type: "CLEANUP_SMART_NUDGES", nudge })),
            // step specific
            renderStep: ({ stepIndex: stepIndex2, nudge, triggerEvent }) => {
              var _a3, _b3, _c2;
              const step = getNudgeStep(nudge, stepIndex2);
              const animateIn = ((_a3 = triggerEvent == null ? void 0 : triggerEvent.source) == null ? void 0 : _a3.experience) === "copilot" ? isCursorStep(nudge, step) : false;
              const options = animateIn && ((_b3 = triggerEvent == null ? void 0 : triggerEvent.source) == null ? void 0 : _b3.position) ? { source: { animateIn, startPosition: (_c2 = triggerEvent == null ? void 0 : triggerEvent.source) == null ? void 0 : _c2.position } } : void 0;
              renderNudge(_, nudge, stepIndex2, options);
            },
            // @ts-expect-error: this *is* used in the machine, but because we use it in `actions.choose` action creator, typescript isn't aware of the usage.
            incrementStep: assign5({
              stepIndex: ({ stepIndex: stepIndex2 }) => stepIndex2 + 1,
              stepIndexStack: ({ stepIndex: stepIndex2, stepIndexStack: stepIndexStack2 }) => [stepIndex2, ...stepIndexStack2]
            }),
            decrementStep: assign5({
              stepIndex: ({ stepIndexStack: stepIndexStack2 }) => stepIndexStack2[0],
              stepIndexStack: ({ stepIndexStack: stepIndexStack2 }) => stepIndexStack2.slice(1)
            }),
            closeStep: ({ stepIndex: stepIndex2, nudge }) => {
              closeStep(_, nudge, stepIndex2);
            },
            execAction: ({ triggerEvent, stepIndex: stepIndex2, nudge }, { action }) => {
              var _a3;
              ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.ctaAction) || execStepAction(_, nudge, stepIndex2, action);
            },
            reportSeen: ({ stepIndex: stepIndex2, triggerEvent, nudge }) => {
              var _a3;
              nudgeShown(nudge, stepIndex2, !!((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.simulateMode));
              Track.nudge.viewed(nudge, stepIndex2);
            },
            reportInteracted: ({ stepIndex: stepIndex2, triggerEvent, nudge }, event) => {
              var _a3;
              let button = void 0;
              if (event.type === "ADVANCE" && (event.button_type === "primary" || event.button_type === "secondary")) {
                button = { cta: event.cta || "", type: event.button_type };
              } else if (event.type === "ADVANCE" && !event.button_type && event.cta) {
                button = { cta: event.cta || "", type: "primary" };
              }
              nudgeStepClicked(nudge, stepIndex2, !!((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.simulateMode), button);
              Track.nudge.ctaClicked(nudge, stepIndex2, button);
            },
            reportSurveyResponse: ({ stepIndex: stepIndex2, triggerEvent, nudge }, event) => {
              var _a3;
              const step = getNudgeStep(nudge, stepIndex2);
              if (!((event == null ? void 0 : event.surveyResponse) && step))
                return;
              surveyResponse(nudge, step, event.surveyResponse, !!((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.simulateMode));
              Track.nudge.surveySubmitted(nudge, stepIndex2, event.surveyResponse);
            },
            reportCompleted: ({ stepIndex: stepIndex2, triggerEvent, nudge }) => {
              var _a3;
              nudgeCompleted(nudge, stepIndex2, !!((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.simulateMode));
            },
            reportDismissed: ({ stepIndex: stepIndex2, triggerEvent, nudge }) => {
              var _a3;
              nudgeDismissed(nudge, stepIndex2, !!((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.simulateMode));
              Track.nudge.dismissed(nudge, stepIndex2);
            },
            reportSnoozed: ({ stepIndex: stepIndex2, triggerEvent, nudge }) => {
              var _a3;
              nudgeSnoozed(nudge, stepIndex2, !!((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.simulateMode));
              Track.nudge.snoozed(nudge, stepIndex2);
            },
            saveSeen: ({ stepIndex: stepIndex2, stepIndexStack: stepIndexStack2, triggerEvent, nudge }) => {
              var _a3;
              if ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.saveProgress)
                return;
              saveProgressToEndUserStore(_, { nudge, stepIndex: stepIndex2, stepIndexStack: stepIndexStack2, addSeenTime: true });
            },
            saveInteraction: ({ stepIndex: stepIndex2, stepIndexStack: stepIndexStack2, triggerEvent, nudgeCompleted: nudgeCompleted2, nudgeDismissed: nudgeDismissed2, nudge }) => {
              var _a3;
              if ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.saveProgress)
                return;
              saveProgressToEndUserStore(_, {
                nudge,
                stepIndex: stepIndex2,
                stepIndexStack: stepIndexStack2,
                nudgeInteracted: true,
                nudgeCompleted: nudgeCompleted2,
                nudgeDismissed: nudgeDismissed2
              });
            },
            saveSnoozed: ({ stepIndex: stepIndex2, stepIndexStack: stepIndexStack2, triggerEvent, nudge }, { action }) => {
              var _a3, _b3, _c2;
              if ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.saveProgress)
                return;
              saveProgressToEndUserStore(_, {
                nudge,
                stepIndex: stepIndex2,
                stepIndexStack: stepIndexStack2,
                snoozed: {
                  interval: (_b3 = action == null ? void 0 : action.interval) != null ? _b3 : nudge.snooze_duration.interval,
                  value: (_c2 = action == null ? void 0 : action.value) != null ? _c2 : nudge.snooze_duration.value
                }
              });
            },
            markSeen: assign5({
              nudgeSeenThisSessionTs: ({ nudgeSeenThisSessionTs, nudge, stepIndex: stepIndex2 }, _event) => (
                // tooltips and banner should not count towards the global limit
                isNoGlobalLimitFormFactorStep(nudge, stepIndex2) ? nudgeSeenThisSessionTs : [...nudgeSeenThisSessionTs, Date.now()]
              )
            }),
            markDismissed: assign5({
              nudgeDismissed: (_context, _event) => true
            }),
            markCompleted: assign5({
              nudgeCompleted: (_context, _event) => true
            }),
            setStepIndexWithHistory: assign5(
              ({ stepIndexStack: stepIndexStack2, stepIndex: stepIndex2, nudge }, event) => {
                if (event.step === void 0 || !(event.step >= 0 && event.step < nudge.steps.length)) {
                  return {};
                }
                return {
                  stepIndex: event.step,
                  stepIndexStack: [stepIndex2, ...stepIndexStack2]
                };
              }
            ),
            setStepIndex: assign5({
              stepIndex: ({ triggerEvent, stepIndex: stepIndex2, nudge }, event) => {
                var _a3, _b3;
                if (isScheduledNudge(nudge)) {
                  return 0;
                }
                if ("step" in event && event.step >= 0 && event.step < nudge.steps.length) {
                  return event.step;
                }
                return (_b3 = (_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.stepIndex) != null ? _b3 : stepIndex2;
              }
            }),
            setSurveyResponses: assign5({
              surveyResponses: (context, event) => {
                const step = getNudgeStep(context.nudge, context.stepIndex);
                if (!step || !event.surveyResponse) {
                  return context.surveyResponses;
                }
                return {
                  ...context.surveyResponses,
                  [step.id]: event.surveyResponse
                };
              }
            }),
            resetSurveyResponses: assign5({
              surveyResponses: ({ surveyResponses: surveyResponses2, nudge }, event) => {
                if ("step" in event && event.step >= 0 && event.step < nudge.steps.length) {
                  const newRespones = { ...surveyResponses2 };
                  for (let index3 = event.step; index3 < nudge.steps.length; index3++) {
                    const step = getNudgeStep(nudge, index3);
                    if (step) {
                      delete newRespones[step.id];
                    }
                  }
                  return newRespones;
                }
                return surveyResponses2;
              }
            }),
            resetStep: assign5({
              stepIndex: (_context, _event) => 0,
              stepIndexStack: (_context, _event) => []
            }),
            reevaluateChecklistItemGoals: () => {
              updateChecklistItemConditionsGoals(_);
            },
            saveStepIndex: ({ stepIndex: stepIndex2, stepIndexStack: stepIndexStack2, triggerEvent, nudge }) => {
              var _a3;
              if ((_a3 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a3.saveProgress)
                return;
              saveProgressToEndUserStore(_, { nudge, stepIndex: stepIndex2, stepIndexStack: stepIndexStack2 });
            },
            refreshNudge: assign5({
              nudge: (_context, { nudge }) => nudge
            }),
            startSentryTransaction: assign5({
              sentryTransaction: ({ nudge }, _event) => startSentryTransaction({
                name: `Nudge ${nudge.id} step ${stepIndex}`,
                op: "state transition",
                tags: {
                  product: "nudges"
                },
                description: `Checking conditions for nudge ${nudge.id} step ${stepIndex}`
              })
            }),
            finishSentryTransaction: ({ sentryTransaction }) => {
              sentryTransaction == null ? void 0 : sentryTransaction.finish();
            },
            assignPopoverService: assign5({
              popoverService: (_context, { service }) => service
            }),
            closePopover: ({ popoverService }) => {
              popoverService == null ? void 0 : popoverService.send("CLOSE");
            }
          },
          services: {
            stepConditions: ({ stepIndex: stepIndex2, triggerEvent, nudge }) => nudgeStepMachine_default(_, { nudge, stepIndex: stepIndex2, triggerEvent })
          }
        }
      );
    };
    nudgeMachine_default = NudgeMachine;
  }
});

// commandbar/src/products/nudges/store/smartActions.ts
import debounce3 from "lodash/debounce";
var triggerSmartNudge, setupAndTriggerSmartTriggers, setupUserConfusionTrigger, setupSmartDelayTrigger, setupRageClickTrigger, removeRageTrigger, removeUserConfusionTrigger, removeSmartDelayTrigger, removeSmartListeners;
var init_smartActions = __esm({
  "commandbar/src/products/nudges/store/smartActions.ts"() {
    "use strict";
    init_selectors5();
    init_actions6();
    triggerSmartNudge = (_, trigger, overrides, properties) => {
      const debuggedNudge = getDebuggedNudge(_);
      if (debuggedNudge) {
        sendDirectedTrigger(_, debuggedNudge, trigger, overrides, properties);
      } else if (!_.activeChecklist) {
        sendIndirectTrigger(_, trigger, overrides, properties);
      }
    };
    setupAndTriggerSmartTriggers = (_, nudges, overrides, properties) => {
      if (hasRageTrigger(_, nudges)) {
        setupRageClickTrigger(_, overrides, properties);
      }
      if (hasUserConfusionTrigger(_, nudges)) {
        setupUserConfusionTrigger(_, overrides, properties);
      }
      if (hasSmartDelayTrigger(_, nudges)) {
        setupSmartDelayTrigger(_, overrides, properties);
      }
    };
    setupUserConfusionTrigger = (_, overrides, properties) => {
      const requiredStrokes = 15;
      const velocityMin = 5;
      const maxIntervalBetweenStrokesMs = 100;
      const resetTimeMs = 500;
      let strokeCount = 0;
      let lastX = -1;
      let lastY = -1;
      let lastTimestamp = -1;
      let resetTimeout;
      removeUserConfusionTrigger(_);
      const listenForUserConfusion = (event) => {
        const { clientX, clientY, timeStamp } = event;
        if (lastX !== -1 && lastY !== -1 && lastTimestamp !== -1) {
          const dx = Math.abs(clientX - lastX);
          const dy = Math.abs(clientY - lastY);
          const distance = Math.sqrt(dx ** 2 + dy ** 2);
          const velocity = distance / (timeStamp - lastTimestamp);
          if (velocity > velocityMin && timeStamp - lastTimestamp <= maxIntervalBetweenStrokesMs) {
            strokeCount += 1;
            clearTimeout(resetTimeout);
            resetTimeout = setTimeout(() => strokeCount = 0, resetTimeMs);
          }
          if (strokeCount >= requiredStrokes) {
            triggerSmartNudge(_, { type: "on_user_confusion" }, overrides, properties);
            strokeCount = 0;
            clearTimeout(resetTimeout);
          }
        }
        lastX = clientX;
        lastY = clientY;
        lastTimestamp = timeStamp;
      };
      document.body.addEventListener("mousemove", listenForUserConfusion);
      _.nudgeEventListeners.on_user_confusion = listenForUserConfusion;
      return listenForUserConfusion;
    };
    setupSmartDelayTrigger = (_, overrides, properties) => {
      const inactiveLimitMs = 5e3;
      const noActivityTriggerWindowMs = 6e4;
      let pastNoTriggerWindow = false;
      removeSmartDelayTrigger(_);
      const handleUserInactive = () => {
        if (!!pastNoTriggerWindow) {
          triggerSmartNudge(_, { type: "smart_delay" }, overrides, properties);
        }
      };
      setTimeout(() => pastNoTriggerWindow = true, noActivityTriggerWindowMs);
      const debouncedHandler = debounce3(handleUserInactive, inactiveLimitMs);
      document.body.addEventListener("mousemove", debouncedHandler);
      document.body.addEventListener("keydown", debouncedHandler);
      _.nudgeEventListeners.smart_delay = debouncedHandler;
      return debouncedHandler;
    };
    setupRageClickTrigger = (_, overrides, properties) => {
      const rageClicks = 4;
      const maxIntervalBetweenClicksMs = 500;
      const resetTimeMs = 500;
      let resetTimeout;
      let clickCount = 0;
      let lastClickTime = 0;
      removeRageTrigger(_);
      const listener = () => {
        const currentTime = Date.now();
        if (currentTime - lastClickTime <= maxIntervalBetweenClicksMs) {
          clickCount += 1;
          clearTimeout(resetTimeout);
          resetTimeout = setTimeout(() => clickCount = 0, resetTimeMs);
        }
        lastClickTime = currentTime;
        if (clickCount >= rageClicks) {
          triggerSmartNudge(_, { type: "on_rage_click" }, overrides, properties);
          clickCount = 0;
          clearTimeout(resetTimeout);
        }
      };
      document.body.addEventListener("click", listener);
      _.nudgeEventListeners.on_rage_click = listener;
      return listener;
    };
    removeRageTrigger = (_) => {
      const listener = _.nudgeEventListeners.on_rage_click;
      if (listener)
        document.body.removeEventListener("click", listener);
    };
    removeUserConfusionTrigger = (_) => {
      const listener = _.nudgeEventListeners.on_user_confusion;
      if (listener)
        document.body.removeEventListener("mousemove", listener);
    };
    removeSmartDelayTrigger = (_) => {
      const listener = _.nudgeEventListeners.smart_delay;
      if (listener) {
        document.body.removeEventListener("click", listener);
        document.body.removeEventListener("keydown", listener);
      }
    };
    removeSmartListeners = (_) => {
      removeRageTrigger(_);
      removeSmartDelayTrigger(_);
      removeUserConfusionTrigger(_);
    };
  }
});

// commandbar/src/products/nudges/store/nudgeManagerMachine.ts
import { createMachine as createMachine7, assign as assign6, spawn, send } from "xstate";
import { pure as pure2, raise as raise2 } from "xstate/lib/actions";
import isEqual8 from "lodash/isEqual";
var NudgeManagerMachine, nudgeManagerMachine_default;
var init_nudgeManagerMachine = __esm({
  "commandbar/src/products/nudges/store/nudgeManagerMachine.ts"() {
    "use strict";
    init_selectors5();
    init_actions6();
    init_nudgeMachine();
    init_editorUtils();
    init_smartActions();
    init_location();
    NudgeManagerMachine = (_, nudges) => {
      const nudgeManagerContext = {
        nudgeMachines: /* @__PURE__ */ new Map(),
        debugMode: {
          originalNudge: null,
          currentNudge: null
        },
        triggerEventQueue: [],
        triggerEvent: null,
        smartNudges: getSmartNudges(nudges)
      };
      return createMachine7(
        {
          /** @xstate-layout N4IgpgJg5mDOIC5QDkCu0wAICyBDAdrjAE4DEAygCoDyACgPoAiAogEICqA4gNoAMAuolAAHAPawAlgBcJo-EJAAPRAEYVAZgAcAOl4B2PQE51hgEx7TANgCslvQBoQAT0Q2dp3upW9Lmw715rUwAWAF9QxzQMHAIiMDIqAEEAJUomNi4+QSQQMUkZOQVlBDVTFV1gy0t1IPVTestTRxcEYPNddXVg4KMLNqNrcMj0GBjCEm1EgHdcaQl8KEx2WHjMcilRYjBSSmSASU5OZmSshTy5wpzi62Dy73VqtRMaz2bVS2DtQxVGsrrgzQmXxDEBRUZ4cbxSYzOYLJYrYhrDZbUjMZCMejscjHehUajJZj0AAy1ESLEYpxy5wK8iuiFMmms2luFk0Fj0P3MlTeCFM1iZKn5ml4hkqHL0gRBYKwELixG0ADFNjNiBB5otKMQJFASLBSABhInMRLIdgMcjYFJpU2MI7kSkicQXWmgYqGD7aUyGb0qYWaNR6fk8lR6SxfIHWTTmf3Wfx6KUjGWxCZK4gqtVwzXa3WkAkKgnkAAS9Hz1Gw9H11GQCoODtyTppRVU9y+XusKnqwUM7e+PMMmk+Dy0dhstn0CeispTytwqvVmCzOvisG0RIksCkYHw6p2+0Oxzr1NkLqUiAB5Q8Ud4jN4lRFenUPNjYa6gostmsXVvE-ByahqfTedF11bRgPiHdDwbY8mwQNkmW6dQAhuONqmCYMvB0DlEJsNotECSwfyTSF5QA2cMw1LUl2IFd9QACzAABjABrec8EUTBki3CB4kgUhIPyaC6VaSpdG+QJ6m+LRBWDFRvg6YIbjsUpjDCCJQUTMY5UVGc50zSiQLoxiWLhNiOK4niID4lRskdATLldRAB3KWxhUFENLB8TRNBkuTPAUsVlK6QjNOnNMyKA-Tl20QzmPnZZ4j4gQzig+zT1abttF9TQ7EZGMByDZxEFFPRtFsMxfH0UM2QItTpRC-8dPIhdIuo6L6NiuF4rIbhrOSuyT2KJzSoqtzQ087zCoQYrhvK4UDF8UNwjU-BRG4+Acjqqd4j650YNMB5tA+awH0MIwNBjJpJolbQTF9Mdsq7B8VGCrb5WmWYZE6hEkU2MAdsbISvDDEM1GMIJOQfNDJrfbQ-Duuo3C9cwXr-EjGoi7Nl3+wSHN5AdDoUk6zqk6weXUIxtEDBScq8wM2RR4jtLC3SKMx1q1w3Ld1Wx1Lim6MMvVuEcu14bwCpaMVPRuWx-I8iVAwZrTSJZ5q2ZXMCtQWHmBrPSxDAJ31yd8FyH2DL11EpjROR6AdvUV0LAL0tW2qM1jcHYzj8G4rYIG1mDOlMAnjpMYn-WqYNPED7pAz0YV+S0Qx7Ya5mmo1mj2uMxYur9wG6iDonJJjHk9AU3QjH9AYEJsJbQiAA */
          id: "Nudge Manager",
          context: nudgeManagerContext,
          states: {
            "Awaiting User Store": {
              on: {
                TRIGGER: {
                  actions: "enqueueTrigger",
                  target: "Awaiting User Store",
                  internal: true,
                  description: "Only triggers that match any of the spawned nudge services' triggers will be enqueued."
                },
                END_USER_STORE_LOADED: {
                  target: "Forwarding Triggers",
                  actions: "spawnNudgeMachines"
                }
              }
            },
            "Forwarding Triggers": {
              on: {
                CLEANUP_SMART_NUDGES: {
                  target: ".",
                  actions: ["updateSmartNudges", "removeUnusedSmartListeners", "updateTriggerableSelectors"]
                },
                REFRESH_FROM_CONFIG: {
                  target: "Forwarding Triggers",
                  actions: "refreshNudgeMachinesFromConfig"
                },
                REFRESH_SIMULATED_NUDGE: {
                  actions: "refreshSimulatedNudge"
                }
              },
              states: {
                Listening: {
                  on: {
                    TRIGGER: {
                      target: "Checking User",
                      actions: ["setTriggerEvent", "setDebuggingNudge"]
                    }
                  },
                  entry: "dequeueTrigger"
                },
                Triggering: {
                  entry: "forwardTrigger",
                  always: "Listening"
                },
                "Checking Max Rendered": {
                  always: [
                    {
                      target: "Triggering",
                      cond: "passesMaxNudgesRendered"
                    },
                    {
                      target: "Listening"
                    }
                  ],
                  description: `We only ever want to show MAX_RENDERED_NUDGES at a time. If we're already at that limit, abandon the trigger event.`
                },
                "Checking User": {
                  always: [
                    {
                      target: "Checking Max Rendered",
                      cond: "passesUser"
                    },
                    "Listening"
                  ],
                  description: `By default, we will only forward triggers for non-admins. This prevents nudges from popping up while using the application while logged into the editor.

This can be bypassed by setting the debug or admin overrride on a trigger.`
                }
              },
              initial: "Listening"
            }
          },
          schema: { events: {}, context: {} },
          predictableActionArguments: true,
          preserveActionOrder: true,
          tsTypes: {},
          initial: "Awaiting User Store",
          on: {
            STOP_DEBUG: {
              target: ".Forwarding Triggers",
              actions: [
                "closeNudges",
                "closeDebugToolbar",
                "unsetDebuggingNudge",
                "unsetTriggerEvent",
                "cleanupSmartNudges",
                "stopNudgeMachines",
                "spawnNudgeMachines",
                "reOpenEditor"
              ]
            },
            START_DEBUG: {
              target: ".Forwarding Triggers",
              actions: [
                "setDebuggingNudge",
                "setOriginalDebuggingNudge",
                "stopNudgeMachines",
                "initNudgeMachinesForDebug",
                "closeEditor",
                "showDebugToolbar"
              ]
            }
          }
        },
        {
          actions: {
            refreshSimulatedNudge: assign6({
              debugMode: (_2, { nudge }) => ({
                originalNudge: nudge,
                currentNudge: nudge
              })
            }),
            spawnNudgeMachines: assign6((context) => ({
              ...context,
              nudgeMachines: new Map(
                nudges.map((nudge) => [nudge.id.toString(), spawn(nudgeMachine_default(_, nudge), String(nudge.id))])
              )
            })),
            refreshNudgeMachinesFromConfig: pure2((context, event) => {
              var _a2;
              const refreshedNudgeIds = event.nudges.map((nudge) => nudge.id.toString());
              const currentNudgeIds = Array.from(context.nudgeMachines.keys());
              if (isEqual8(refreshedNudgeIds, currentNudgeIds)) {
                return Array.from(context.nudgeMachines.values()).map((machine3) => {
                  const nudge = event.nudges.find((nudge2) => {
                    var _a3;
                    return nudge2.id === ((_a3 = machine3.getSnapshot()) == null ? void 0 : _a3.context.nudge.id);
                  });
                  return send({ type: "REFRESH_NUDGE", nudge }, { to: machine3 });
                });
              }
              const newNudgeMachines = new Map(
                event.nudges.map((nudge) => [nudge.id.toString(), spawn(nudgeMachine_default(_, nudge), String(nudge.id))])
              );
              for (const nudgeMachine of context.nudgeMachines.values()) {
                (_a2 = nudgeMachine.stop) == null ? void 0 : _a2.call(nudgeMachine);
              }
              return assign6((context2, _event) => ({
                ...context2,
                nudgeMachines: newNudgeMachines
              }));
            }),
            stopNudgeMachines: ({ nudgeMachines }, { type: type39 }) => {
              var _a2, _b2, _c2;
              for (const nudgeMachine of nudgeMachines.values()) {
                if (type39 === "START_DEBUG" && ((_b2 = (_a2 = nudgeMachine.getSnapshot()) == null ? void 0 : _a2.context.nudge.steps) == null ? void 0 : _b2[0].form_factor.type) === "tooltip") {
                  continue;
                }
                (_c2 = nudgeMachine.stop) == null ? void 0 : _c2.call(nudgeMachine);
              }
            },
            initNudgeMachinesForDebug: assign6((context, _event) => {
              const currentNudges = getAllNudges(_);
              const getUpdatedNudges = () => {
                const { originalNudge: debugNudge } = context.debugMode;
                if (!debugNudge) {
                  return currentNudges;
                }
                const updatedNudges2 = currentNudges.some((nudge) => nudge.id === debugNudge.id) ? currentNudges.map((nudge) => nudge.id === debugNudge.id ? debugNudge : nudge) : [...currentNudges, debugNudge];
                return updatedNudges2;
              };
              const updatedNudges = getUpdatedNudges();
              return {
                ...context,
                nudgeMachines: new Map(
                  updatedNudges.map((nudge) => [nudge.id.toString(), spawn(nudgeMachine_default(_, nudge), String(nudge.id))])
                )
              };
            }),
            enqueueTrigger: assign6({
              // share link nudges should be prioritized in the queue
              triggerEventQueue: ({ triggerEventQueue }, triggerEvent) => triggerEvent.trigger.type === "when_share_link_viewed" ? [triggerEvent, ...triggerEventQueue] : [...triggerEventQueue, triggerEvent],
              triggerEvent: ({ triggerEventQueue }) => triggerEventQueue[0]
            }),
            dequeueTrigger: pure2((context) => {
              const { triggerEventQueue } = context;
              const triggerEvent = triggerEventQueue.shift();
              if (triggerEvent) {
                return [raise2(triggerEvent)];
              }
              return [];
            }),
            setTriggerEvent: assign6({ triggerEvent: (_context, triggerEvent) => triggerEvent }),
            forwardTrigger: pure2(({ triggerEvent, nudgeMachines, debugMode }, event) => {
              if (debugMode.currentNudge && triggerEvent) {
                const debugEvent = {
                  ...triggerEvent,
                  overrides: {
                    ...triggerEvent == null ? void 0 : triggerEvent.overrides,
                    status: true,
                    simulateMode: true
                  }
                };
                return Array.from(nudgeMachines.values()).map((machine3) => send(debugEvent, { to: machine3 }));
              }
              return Array.from(nudgeMachines.values()).map((machine3) => send(triggerEvent != null ? triggerEvent : event, { to: machine3 }));
            }),
            closeNudges: ({ nudgeMachines }) => {
              for (const nudgeMachine of nudgeMachines.values()) {
                nudgeMachine.send("CLOSE");
              }
            },
            showDebugToolbar: (_context, _event) => {
              setDebugToolBarVisibility(_, true);
            },
            closeDebugToolbar: (_context, _event) => {
              setDebugToolBarVisibility(_, false);
            },
            updateSmartNudges: assign6((context, event) => {
              const { nudge } = event;
              return {
                smartNudges: {
                  rageClick: context.smartNudges.rageClick.filter((n) => (n == null ? void 0 : n.id) !== (nudge == null ? void 0 : nudge.id)),
                  smartDelay: context.smartNudges.smartDelay.filter((n) => (n == null ? void 0 : n.id) !== (nudge == null ? void 0 : nudge.id)),
                  userConfusion: context.smartNudges.userConfusion.filter((n) => (n == null ? void 0 : n.id) !== (nudge == null ? void 0 : nudge.id))
                }
              };
            }),
            updateTriggerableSelectors: (_context, { nudge }) => {
              const { trigger } = nudge;
              if (trigger.type === "when_element_appears") {
                const matchedSelectorIndex = _.triggerableSelectors.findIndex(
                  (selector2) => selector2 === trigger.meta.selector
                );
                _.triggerableSelectors = [
                  ..._.triggerableSelectors.slice(0, matchedSelectorIndex),
                  ..._.triggerableSelectors.slice(matchedSelectorIndex + 1)
                ];
              }
            },
            removeUnusedSmartListeners: (_context, _event) => {
              if (!_context.smartNudges.rageClick.length) {
                removeRageTrigger(_);
              } else if (!_context.smartNudges.smartDelay.length) {
                removeSmartDelayTrigger(_);
              } else if (!_context.smartNudges.userConfusion.length) {
                removeUserConfusionTrigger(_);
              }
            },
            cleanupSmartNudges: (_context, _event) => {
              removeSmartListeners(_);
              removeTimedTriggers(_, "nudge" /* NUDGE */);
              cleanupElementAppearNudgeTriggers(_);
            },
            closeEditor: (_context, _event) => {
              closeEditorIfOpen();
            },
            reOpenEditor: (_context, { reopenEditor }) => {
              if (reopenEditor)
                openEditorIfLoaded();
            },
            // this gets set when simulate mode is engaged
            setOriginalDebuggingNudge: assign6({
              debugMode: ({ debugMode }, { nudge }) => ({
                ...debugMode,
                originalNudge: (debugMode == null ? void 0 : debugMode.originalNudge) ? debugMode.originalNudge : nudge
              })
            }),
            // this gets set when simulate mode is engaged and when triggering a new nudge within simulate mode
            setDebuggingNudge: assign6({
              debugMode: ({ debugMode }, event) => {
                var _a2;
                if (event.type === "START_DEBUG") {
                  return {
                    ...debugMode,
                    currentNudge: event.nudge
                  };
                }
                if (debugMode.currentNudge && event.nudgeId) {
                  return {
                    ...debugMode,
                    currentNudge: (_a2 = getNudgeById(_, event.nudgeId)) != null ? _a2 : debugMode.currentNudge
                  };
                }
                return debugMode;
              }
            }),
            // This gets set when simulate mode is disengaged.
            // When resetting simulate mode, the editor stays closed and we want to reset the current nudge to the original nudge.
            // When ending simulate mode entirely, we reopen the editor. In this case, we should also clear the original nudge.
            unsetDebuggingNudge: assign6({
              debugMode: ({ debugMode }, { reopenEditor }) => ({
                currentNudge: null,
                originalNudge: reopenEditor ? null : debugMode == null ? void 0 : debugMode.originalNudge
              })
            }),
            unsetTriggerEvent: assign6({
              triggerEvent: (_context, _event) => null
            })
          },
          guards: {
            passesUser: () => !isStudioPreview(),
            passesMaxNudgesRendered: ({ triggerEvent }) => {
              var _a2;
              return ((_a2 = triggerEvent == null ? void 0 : triggerEvent.overrides) == null ? void 0 : _a2.maxRenderedNudges) || passesMaxRenderedNudges(_);
            }
          }
        }
      );
    };
    nudgeManagerMachine_default = NudgeManagerMachine;
  }
});

// internal/src/client/share_links.ts
var isValidUrl, urlMatchesTargeting, getShareLinkType, deconstructShareLink, getAbsoluteSharePageUrl;
var init_share_links = __esm({
  "internal/src/client/share_links.ts"() {
    "use strict";
    init_rules();
    init_RulesParser();
    isValidUrl = (sharePageUrl) => {
      if (!sharePageUrl) {
        return false;
      }
      let testUrl = sharePageUrl;
      if (testUrl.startsWith("/")) {
        testUrl = "https://www.example.com" + testUrl;
      }
      if (!testUrl.startsWith("http")) {
        testUrl = "https://" + testUrl;
      }
      try {
        new URL(testUrl);
      } catch (e) {
        return false;
      }
      const urlRegex = /^(https?:\/\/)?(([\w-]+\.)+[\w]{2,}|localhost(:\d+)?)(\/\S*)?$/i;
      return urlRegex.test(testUrl);
    };
    urlMatchesTargeting = (sharePageUrl, pagetTargeting) => {
      if (!isValidUrl(sharePageUrl)) {
        return false;
      }
      if (sharePageUrl.includes("{{")) {
        return true;
      }
      const conditions = getConditions(pagetTargeting);
      if (conditions.find((c) => c.type === "element")) {
        return true;
      }
      let testUrl = sharePageUrl;
      if (testUrl.startsWith("/")) {
        testUrl = "https://www.example.com" + testUrl;
      }
      if (!testUrl.startsWith("http")) {
        testUrl = "https://" + testUrl;
      }
      const url = new URL(testUrl);
      const matchesTargeting = url && !!evaluateRuleExpression(
        pagetTargeting,
        {},
        url,
        {
          num_command_executions: 0,
          num_deadends: 0,
          num_opens: 0,
          num_sessions: 0,
          num_shortcut_command_executions: 0,
          first_seen_at: "",
          last_seen_at: ""
        },
        {},
        {},
        true,
        [],
        [],
        [],
        {}
      ).passed;
      return matchesTargeting;
    };
    getShareLinkType = (type39) => {
      switch (type39) {
        case "questlist":
        case "q":
          return "q" /* QUESTLIST */;
        case "nudge":
        case "n":
        default:
          return "n" /* NUDGE */;
      }
    };
    deconstructShareLink = (param, searchString) => {
      const searchParams = new URLSearchParams(searchString);
      const shareLinkParam = searchParams.get(param);
      if (!shareLinkParam)
        return void 0;
      const type39 = getShareLinkType(shareLinkParam[0]);
      if (!type39)
        return void 0;
      let source = "share_modal";
      const secondChar = shareLinkParam[1];
      const hasSource = isNaN(parseInt(secondChar));
      if (hasSource) {
        if (secondChar === "t")
          source = "trigger";
      }
      return {
        type: type39,
        id: Number(shareLinkParam.slice(hasSource ? 2 : 1)),
        source
      };
    };
    getAbsoluteSharePageUrl = (current, sharePage) => {
      if (!sharePage)
        return null;
      let startPage = sharePage;
      if (startPage.startsWith("/")) {
        startPage = `${current.origin}${startPage}`;
      }
      if (!startPage.startsWith("http")) {
        startPage = `${current.protocol}//${startPage}`;
      }
      return startPage ? new URL(startPage) : null;
    };
  }
});

// commandbar/src/products/nudges/store/actions.ts
import { interpret as interpret2 } from "xstate";
import { ref as ref6 } from "valtio";
import dayjs4 from "dayjs";
import set2 from "lodash/set";
var shouldDebugNudges, initNudges, sendIndirectTrigger, triggerSharelinkNudges, forceTriggerSingleNudge, sendDirectedTrigger, setupAndTriggerElementAppearNudges, cleanupElementAppearNudgeTriggers, refreshDecideResult, startDebugSession, restartDebugSession, stopDebugSession, showStepMock, closeAllNudgeMocks, closeStep, closeNudgeMock, dismissNudge, closeNudge, dismissNudgeTemporarily, continueNudge, execStepAction, saveProgressToEndUserStore, resetNudge, clearNudgeDataById, getDebugSnapshot, updateNudgeStepForPreview, setDebugToolBarVisibility, setEntityTimer, removeTimedTriggers, resetTimedTriggers, setupTimedTriggers;
var init_actions6 = __esm({
  "commandbar/src/products/nudges/store/actions.ts"() {
    "use strict";
    init_useToast();
    init_Logger();
    init_actions4();
    init_dom();
    init_global_actions();
    init_selectors5();
    init_nudges();
    init_RenderNudge();
    init_LocalStorage();
    init_nudgeManagerMachine();
    init_sentry();
    init_service_actions2();
    init_smartActions();
    init_audience2();
    init_share_links();
    init_BannerContext();
    init_globals();
    init_decide();
    init_symbols();
    init_pushTrigger();
    shouldDebugNudges = !!LocalStorage_default.get("debug:nudges", false);
    initNudges = (_, nudges) => {
      if (!_.products.includes("nudges"))
        return;
      if (_.nudgeManager) {
        _.nudgeManager.send({ type: "REFRESH_FROM_CONFIG", nudges });
        return;
      }
      const service = interpret2(nudgeManagerMachine_default(_, nudges), {
        devTools: shouldDebugNudges
      });
      _.nudgeManager = ref6(service);
      _.nudgeManager.start().onTransition((state) => {
        if (shouldDebugNudges)
          Logger_default.debug(`State transition: `, state);
      });
      setupAndTriggerElementAppearNudges(_, nudges);
      setupAndTriggerSmartTriggers(_, nudges);
      triggerSharelinkNudges(_, nudges);
      sendIndirectTrigger(_, { type: "when_conditions_pass" });
    };
    sendIndirectTrigger = (_, trigger, overrides, properties) => {
      var _a2;
      const simulatedNudge = getDebuggedNudge(_);
      if (simulatedNudge) {
        sendDirectedTrigger(_, simulatedNudge, trigger, overrides, properties);
      } else {
        (_a2 = _.nudgeManager) == null ? void 0 : _a2.send({
          type: "TRIGGER",
          trigger,
          overrides,
          properties
        });
      }
    };
    triggerSharelinkNudges = (_, nudges) => {
      var _a2;
      const deconstructedShareLink = deconstructShareLink(((_a2 = _.organization) == null ? void 0 : _a2.share_link_param) || "cb-eid", _.location.search);
      if (deconstructedShareLink) {
        if ((deconstructedShareLink == null ? void 0 : deconstructedShareLink.type) === "n" /* NUDGE */) {
          const nudge = nudges.find((n) => n.id === deconstructedShareLink.id);
          if (nudge) {
            activatePushExperience(_, nudge, "nudge");
          }
        }
      }
    };
    forceTriggerSingleNudge = (_, nudge, overrides, source) => {
      var _a2;
      const defaultOverrides = {
        // allow admins to trigger draft nudges
        status: _.isAdmin,
        // allow admins to trigger nudge outside simulate mode
        admin: true,
        // don't check page conditions
        page: true,
        // don't check audience conditions
        audience: true,
        // don't check frequency
        frequency: true,
        // don't check that conditions have changed since last trigger
        flip: true,
        // don't check global limit
        globalLimit: true,
        // always start tours at first step even if they've been seen before
        stepIndex: 0
      };
      (_a2 = _.nudgeManager) == null ? void 0 : _a2.send({
        type: "TRIGGER",
        trigger: nudge.trigger,
        nudgeId: nudge.id,
        overrides: {
          ...defaultOverrides,
          ...overrides
        },
        source
      });
    };
    sendDirectedTrigger = (_, nudge, trigger, overrides, properties, source) => {
      var _a2;
      (_a2 = _.nudgeManager) == null ? void 0 : _a2.send({
        type: "TRIGGER",
        nudgeId: nudge.id,
        trigger,
        overrides,
        properties,
        source
      });
    };
    setupAndTriggerElementAppearNudges = (_, nudges, overrides, properties) => {
      for (const nudge of nudges) {
        if (nudge.trigger.type === "when_element_appears") {
          const selector2 = nudge.trigger.meta.selector;
          _.triggerableSelectors.push(selector2);
          if (getElement(selector2)) {
            sendIndirectTrigger(_, { type: "when_element_appears", meta: { selector: selector2 } }, overrides, properties);
          }
        }
      }
    };
    cleanupElementAppearNudgeTriggers = (_) => {
      _.triggerableSelectors = [];
    };
    refreshDecideResult = async (_, options) => {
      var _a2;
      const sdk = getSDK();
      const decideResult = await decide(sdk[_configuration].uuid, (_a2 = _.endUser) == null ? void 0 : _a2.slug, {
        properties: sdk[_userProperties],
        envOverride: _.envOverride,
        env: _.env,
        version: sdk[_configuration].version,
        is_admin: !!options.isAdmin
      });
      if (decideResult) {
        _.decide = decideResult;
      }
    };
    startDebugSession = async (_, nudge, source, options = { refreshDecide: true }) => {
      var _a2;
      if (options.refreshDecide) {
        await refreshDecideResult(_, { isAdmin: true });
      }
      (_a2 = _.nudgeManager) == null ? void 0 : _a2.send({ type: "START_DEBUG", nudge });
      const overrides = {
        stepIndex: options.toStepIndex
      };
      setupAndTriggerElementAppearNudges(_, getAllNudges(_), overrides, void 0);
      setupAndTriggerSmartTriggers(_, getAllNudges(_), overrides, void 0);
      setupTimedTriggers(_, [nudge], overrides, void 0);
      sendDirectedTrigger(_, nudge, { type: "when_conditions_pass" }, overrides, void 0, source);
      sendDirectedTrigger(
        _,
        nudge,
        { type: "when_page_reached", meta: { url: _.location.href } },
        overrides,
        void 0,
        source
      );
    };
    restartDebugSession = (_, options = { resetToOriginalDebugNudge: true }) => {
      const debugNudge = getDebuggedNudge(_, { getOriginal: !!options.resetToOriginalDebugNudge });
      if (debugNudge) {
        stopDebugSession(_, { reopenEditor: false, refreshDecide: false });
        setTimeout(() => {
          startDebugSession(_, debugNudge, void 0, { toStepIndex: options.toStepIndex, refreshDecide: false });
        }, 50);
      }
    };
    stopDebugSession = async (_, options = { reopenEditor: true, refreshDecide: true }) => {
      var _a2;
      const debugNudge = getDebuggedNudge(_);
      if (debugNudge) {
        if (options.refreshDecide) {
          await refreshDecideResult(_, { isAdmin: false });
        }
        (_a2 = _.nudgeManager) == null ? void 0 : _a2.send({ type: "STOP_DEBUG", reopenEditor: options.reopenEditor });
      }
    };
    showStepMock = (_, nudge, stepIndex, options) => {
      renderNudge(_, nudge, stepIndex, {
        renderMode: 1 /* MOCK */,
        forceOpen: options == null ? void 0 : options.forceOpen,
        anchorOverride: options == null ? void 0 : options.anchorOverride
      });
    };
    closeAllNudgeMocks = (_) => {
      var _a2;
      hideAllMatchingToasts(/-mock$/);
      hideAllMatchingBanners(/-mock$/);
      if (((_a2 = _.currentModalNudge) == null ? void 0 : _a2.renderMode) === 1 /* MOCK */) {
        _.currentModalNudge = null;
      }
    };
    closeStep = (_, nudge, stepIndex) => {
      var _a2;
      const step = getNudgeStep(nudge, stepIndex);
      if ((step == null ? void 0 : step.form_factor.type) === "modal" && ((_a2 = _.currentModalNudge) == null ? void 0 : _a2.renderMode) !== 1 /* MOCK */) {
        _.currentModalNudge = null;
      } else {
        hideToast(`${nudge.id}-${String(step == null ? void 0 : step.id)}`);
        hideBanner(`${nudge.id}-${String(step == null ? void 0 : step.id)}`);
      }
    };
    closeNudgeMock = (_, nudge) => {
      var _a2;
      for (let i2 = 0; i2 < nudge.steps.length; i2++) {
        const step = getNudgeStep(nudge, i2);
        if (((_a2 = _.currentModalNudge) == null ? void 0 : _a2.renderMode) === 1 /* MOCK */) {
          _.currentModalNudge = null;
        }
        hideToast(`${nudge.id}-${String(step == null ? void 0 : step.id)}-mock`);
        hideBanner(`commandbar-banner-${nudge.id}-${String(step == null ? void 0 : step.id)}-mock`);
      }
    };
    dismissNudge = (_, nudge, renderMode) => {
      if (renderMode === 1 /* MOCK */) {
        closeNudgeMock(_, nudge);
      } else {
        const service = getNudgeService(_, nudge.id);
        service == null ? void 0 : service.send("DISMISS");
      }
    };
    closeNudge = (_, nudge, renderMode) => {
      if (renderMode === 1 /* MOCK */) {
        closeNudgeMock(_, nudge);
      } else {
        const service = getNudgeService(_, nudge.id);
        service == null ? void 0 : service.send("CLOSE");
      }
    };
    dismissNudgeTemporarily = (_, options) => {
      if (options.renderMode === 1 /* MOCK */) {
        closeNudgeMock(_, options.nudge);
        setTimeout(() => {
          showStepMock(_, options.nudge, options.stepIndex, {
            forceOpen: true,
            anchorOverride: options.anchorOverride
          });
        }, 1500);
      }
    };
    continueNudge = (_, nudge) => {
      var _a2;
      const service = (_a2 = getDebugService(_)) != null ? _a2 : getNudgeService(_, nudge.id);
      service == null ? void 0 : service.send("ADVANCE");
    };
    execStepAction = (_, nudge, stepIndex, action) => {
      if (!action)
        return;
      if ((action == null ? void 0 : action.type) === "nudge") {
        resetNudge(_, nudge.id, {
          step: stepIndex + 1,
          dismiss: !isNoGlobalLimitFormFactorStep(nudge, stepIndex)
        });
      }
      executeAction(_, action, void 0, {}, { type: "nudge", id: nudge.id });
    };
    saveProgressToEndUserStore = (_, {
      nudge,
      stepIndex,
      stepIndexStack,
      nudgeInteracted,
      nudgeCompleted: nudgeCompleted2,
      nudgeDismissed: nudgeDismissed2,
      addSeenTime,
      snoozed
    }) => {
      var _a2;
      const nudgeContext = getNudgeDataFromUserStore(_, nudge.id);
      const alreadySeen = nudgeContext == null ? void 0 : nudgeContext.nudgeSeen;
      const alreadyCompleted = nudgeContext == null ? void 0 : nudgeContext.nudgeCompleted;
      const alreadyDismissed = nudgeContext == null ? void 0 : nudgeContext.nudgeDismissed;
      const seenTs = nudgeContext == null ? void 0 : nudgeContext.seenTs;
      const nudgeCompletedTs = nudgeContext == null ? void 0 : nudgeContext.nudgeCompletedTs;
      const nudgeDismissedTs = nudgeContext == null ? void 0 : nudgeContext.nudgeDismissedTs;
      const updatedContext = {
        [Number(nudge.id)]: {
          ...nudgeContext,
          currentStep: stepIndex,
          stepIndexStack,
          nudgeSeen: true,
          nudgeInteracted: !snoozed && (alreadySeen || nudgeInteracted),
          // if they snoozed a nudge, pretend we didn't interact w/ it (rate limit handling)
          seenTs: addSeenTime ? [...seenTs != null ? seenTs : [], Date.now()] : snoozed ? seenTs == null ? void 0 : seenTs.slice(0, -1) : seenTs,
          // if they snoozed a nudge, pretend we didn't see it (rate limit handling)
          snoozedUntilTs: snoozed ? dayjs4().add(snoozed.value, snoozed.interval).valueOf() : void 0,
          nudgeCompleted: alreadyCompleted || nudgeCompleted2,
          nudgeDismissed: alreadyDismissed || nudgeDismissed2,
          nudgeCompletedTs: nudgeCompleted2 ? [...nudgeCompletedTs != null ? nudgeCompletedTs : [], Date.now()] : nudgeCompletedTs,
          nudgeDismissedTs: nudgeDismissed2 ? [...nudgeDismissedTs != null ? nudgeDismissedTs : [], Date.now()] : nudgeDismissedTs
        }
      };
      try {
        updateEndUserStore(_, updatedContext, "nudges_interactions");
      } catch (e) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e, {
          captureContext: {
            tags: {
              product: "nudges"
            }
          }
        });
        Logger_default.error("unable to save", e);
      }
    };
    resetNudge = (_, id2, options) => {
      var _a2, _b2;
      const service = (_a2 = getDebugService(_)) != null ? _a2 : getNudgeService(_, id2);
      if (service) {
        if (options == null ? void 0 : options.dismiss) {
          service.send("DISMISS");
        }
        service.send({
          type: "RESET_STATE",
          step: (_b2 = options == null ? void 0 : options.step) != null ? _b2 : 0
        });
      }
      clearNudgeDataById(_, Number(id2), options == null ? void 0 : options.step);
    };
    clearNudgeDataById = (_, id2, step) => {
      const allNudgeData = { ..._.endUserStore.data.nudges_interactions };
      if (step !== void 0 && step > 0) {
        allNudgeData[id2].currentStep = step;
      } else {
        allNudgeData[id2] = {};
      }
      updateEndUserStore(_, allNudgeData, "nudges_interactions");
    };
    getDebugSnapshot = async (_, nudge, stepIndex) => {
      var _a2, _b2, _c2, _d, _e;
      const globalChecks = {
        maxNudgesRendered: {
          result: passesMaxRenderedNudges(_),
          explanation: `The maximum number of nudges that can be rendered simultaneously is: ${MAX_RENDERED_NUDGES}.`
        },
        globalLimit: {
          result: passesGlobalLimit(_),
          explanation: "The limit for nudges shown in this period has been met.",
          detail: {
            limit: (_a2 = _.organization) == null ? void 0 : _a2.nudge_rate_limit,
            period: (_b2 = _.organization) == null ? void 0 : _b2.nudge_rate_period
          }
        }
      };
      const nudgeChecks = {
        status: { result: passesStatus(nudge), explanation: "Nudge has not been published." },
        frequency: {
          result: passesFrequencyCondition(_, nudge),
          explanation: "Nudge has been seen the maximum number of times.",
          detail: {
            frequency: nudge.frequency_limit
          }
        },
        audience: {
          result: passesAudienceConditions(_, "nudges", nudge),
          explanation: "Booted user is not targeted by this nudge.",
          detail: {
            audience: nudge.audience
          }
        },
        page: {
          result: passesPageConditions(_, nudge),
          explanation: "Nudge is not shown on this page.",
          detail: {
            page: nudge.show_expression
          }
        },
        snooze: {
          result: passesSnoozedConditions(_, nudge),
          explanation: "Nudge is snoozed.",
          detail: {
            snoozable: nudge.snoozable,
            snoozableOnAllSteps: nudge.snoozable_on_all_steps,
            snoozeDuration: nudge.snooze_duration
          }
        }
      };
      const nudgeServiceSnapshot = (_c2 = getNudgeServiceSnapshot(_, nudge.id)) == null ? void 0 : _c2.context;
      const currentStep = (_d = stepIndex != null ? stepIndex : nudgeServiceSnapshot == null ? void 0 : nudgeServiceSnapshot.stepIndex) != null ? _d : 0;
      const step = nudgeServiceSnapshot ? getNudgeStep(nudgeServiceSnapshot.nudge, currentStep) : void 0;
      const stepChecks = {
        element: {
          result: passesPinnedElement(nudge, currentStep),
          explanation: "Pinned element is not visible on the page.",
          detail: {
            element: (step == null ? void 0 : step.form_factor.type) === "pin" && (step == null ? void 0 : step.form_factor.anchor)
          }
        }
      };
      const flipCheck = nudgeServiceSnapshot ? {
        flip: {
          result: passesFlip(nudgeServiceSnapshot.prevPassedConditions, nudgeServiceSnapshot.triggerEvent, step),
          explanation: "Nudge was shown and conditions have not changed.",
          detail: {
            prevPassedConditions: nudgeServiceSnapshot.prevPassedConditions
          }
        }
      } : {};
      const snapShot = {
        ...globalChecks,
        ...nudgeChecks,
        ...stepChecks,
        ...flipCheck
      };
      return {
        willRenderIfTriggered: Object.values(snapShot).every(({ result }) => result),
        checks: Object.fromEntries(
          Object.entries(snapShot).map(([key, value]) => [
            key,
            {
              ...value,
              result: value.result ? "PASS" : "FAIL"
            }
          ])
        ),
        trigger: nudgeServiceSnapshot == null ? void 0 : nudgeServiceSnapshot.nudge.trigger,
        nudge: nudgeServiceSnapshot == null ? void 0 : nudgeServiceSnapshot.nudge,
        mostRecentTrigger: (_e = nudgeServiceSnapshot == null ? void 0 : nudgeServiceSnapshot.triggerEvent) == null ? void 0 : _e.trigger
      };
    };
    updateNudgeStepForPreview = (_, nudge, stepIndex, field, value) => {
      var _a2;
      let newNudge = { ...nudge };
      newNudge = set2(newNudge, `steps.${stepIndex}.${field}`, value);
      (_a2 = _.nudgeManager) == null ? void 0 : _a2.send({ type: "REFRESH_SIMULATED_NUDGE", nudge: newNudge });
      restartDebugSession(_, { resetToOriginalDebugNudge: false, toStepIndex: stepIndex });
    };
    setDebugToolBarVisibility = (_, visible) => {
      _.nudgeDebugToolBar.visible = visible;
    };
    setEntityTimer = (_, entity, overrides, properties) => {
      const delay = entity.trigger.meta.unit === "minute" ? entity.trigger.meta.value * 60 * 1e3 : entity.trigger.meta.value * 1e3;
      const timer = setTimeout(() => {
        if (isNudge(entity)) {
          sendDirectedTrigger(_, entity, entity.trigger, overrides, properties);
        } else {
          triggerChecklists(_, entity.trigger);
        }
      }, delay);
      _.timedTriggers.set({ id: generateTriggerableEntityId(entity), entity }, timer);
    };
    removeTimedTriggers = (_, entityType) => {
      for (const [entity, timer] of _.timedTriggers) {
        if (!entityType || entity.id.startsWith(entityType)) {
          clearTimeout(timer);
          _.timedTriggers.delete(entity);
        }
      }
    };
    resetTimedTriggers = (_) => {
      const entriesSnapshot = Array.from(_.timedTriggers.keys());
      removeTimedTriggers(_);
      for (const { entity } of entriesSnapshot) {
        setEntityTimer(_, entity);
      }
    };
    setupTimedTriggers = (_, triggerableEntities, overrides, properties) => {
      removeTimedTriggers(_);
      const delayedTriggerableEntities = triggerableEntities.filter(
        (entity) => entity.trigger.type === "after_time"
      );
      for (const entity of delayedTriggerableEntities) {
        setEntityTimer(_, entity, overrides, properties);
      }
    };
  }
});

// commandbar/src/products/nudges/service-actions.ts
var service_actions_exports3 = {};
__export(service_actions_exports3, {
  closeAllNudgeMocks: () => closeAllNudgeMocks,
  forceTriggerSingleNudge: () => forceTriggerSingleNudge,
  getDebugSnapshot: () => getDebugSnapshot,
  initNudges: () => initNudges,
  resetNudge: () => resetNudge,
  resetTimedTriggers: () => resetTimedTriggers,
  sendDirectedTrigger: () => sendDirectedTrigger,
  sendIndirectTrigger: () => sendIndirectTrigger,
  setupTimedTriggers: () => setupTimedTriggers,
  showStepMock: () => showStepMock,
  startDebugSession: () => startDebugSession,
  stopDebugSession: () => stopDebugSession,
  updateNudgeStepForPreview: () => updateNudgeStepForPreview
});
var init_service_actions3 = __esm({
  "commandbar/src/products/nudges/service-actions.ts"() {
    "use strict";
    init_actions6();
  }
});

// commandbar/src/shared/store/util/logChanges.ts
var i, logChanges;
var init_logChanges = __esm({
  "commandbar/src/shared/store/util/logChanges.ts"() {
    "use strict";
    i = 0;
    logChanges = (ops) => {
      console.group(`state change [${i++}]`);
      ops.forEach((op) => {
        console.log(`${op[0]} ${op[1].join(".")}`);
      });
      console.groupEnd();
    };
  }
});

// commandbar/src/shared/util/clientSideIntegrations.ts
function toFlatObject(obj, keySeparator = ".") {
  const flattenRecursive = (obj2, parentProperty, propertyMap = {}) => {
    for (const [key, value] of Object.entries(obj2)) {
      const property = parentProperty ? `${parentProperty}${keySeparator}${key}` : key;
      if (value && typeof value === "object") {
        flattenRecursive(value, property, propertyMap);
      } else {
        propertyMap[property] = value;
      }
    }
    return propertyMap;
  };
  return flattenRecursive(obj);
}
function isNoCodeAlgoliaIntegration(integration) {
  return integration.algolia !== void 0 && integration.algolia.apiKey !== void 0 && integration.algolia.applicationID !== void 0 && typeof integration.algolia.indexes === "object" && integration.algolia.indexes !== null && Object.keys(integration.algolia.indexes).length > 0;
}
function setupAlgoliaIntegration(integrations) {
  if (isNoCodeAlgoliaIntegration(integrations)) {
    const algoliaIndexes = integrations.algolia.indexes;
    const requestOptions = {
      method: "POST",
      headers: new Headers({
        "X-Algolia-Application-Id": integrations.algolia.applicationID,
        "X-Algolia-API-Key": integrations.algolia.apiKey
      })
    };
    const sdk = getSDK();
    for (const [key, value] of Object.entries(algoliaIndexes)) {
      sdk.addRecords(key, [], {
        onInputChange: async (query) => {
          const response2 = await fetch(
            `https://${integrations.algolia.applicationID}-dsn.algolia.net/1/indexes/${key}/query`,
            {
              ...requestOptions,
              body: JSON.stringify({ query })
            }
          );
          const { hits } = await response2.json();
          return hits.map((hit) => ({
            ...hit,
            icon: hit[value]
          }));
        }
      });
    }
    return () => {
      for (const [key] of Object.entries(algoliaIndexes)) {
        sdk.removeContext(key);
      }
    };
  }
}
function tearDownAlgoliaIntegration(integrations) {
  if (isNoCodeAlgoliaIntegration(integrations)) {
    const algoliaIndexes = integrations.algolia.indexes;
    const sdk = getSDK();
    for (const [key] of Object.entries(algoliaIndexes)) {
      sdk.removeContext(key);
    }
  }
}
var analyticsIntegrations, setupAnalyticsIntegrations;
var init_clientSideIntegrations = __esm({
  "commandbar/src/shared/util/clientSideIntegrations.ts"() {
    "use strict";
    init_globals();
    init_symbols();
    init_sentry();
    analyticsIntegrations = (integrations) => {
      var _a2, _b2, _c2, _d, _e, _f, _g;
      return [
        {
          name: "heap",
          isEnabled: !!((_a2 = integrations == null ? void 0 : integrations.heap) == null ? void 0 : _a2.send_events_to_heap),
          globalObjectName: "heap",
          methodName: "track"
        },
        {
          name: "hubspot",
          isEnabled: !!((_b2 = integrations == null ? void 0 : integrations.hubspot) == null ? void 0 : _b2.send_events_to_hubspot),
          globalObjectName: "_hsq",
          methodName: "push"
        },
        {
          name: "amplitude",
          isEnabled: !!((_c2 = integrations == null ? void 0 : integrations.amplitude) == null ? void 0 : _c2.enabled),
          globalObjectName: "amplitude",
          methodName: "track"
        },
        {
          name: "logrocket",
          isEnabled: !!((_d = integrations == null ? void 0 : integrations.logrocket) == null ? void 0 : _d.enabled),
          globalObjectName: "LogRocket",
          methodName: "track"
        },
        {
          name: "mixpanel",
          isEnabled: !!((_e = integrations == null ? void 0 : integrations.mixpanel) == null ? void 0 : _e.enabled),
          globalObjectName: "mixpanel",
          methodName: "track"
        },
        {
          name: "posthog",
          isEnabled: !!((_f = integrations == null ? void 0 : integrations.posthog) == null ? void 0 : _f.enabled),
          globalObjectName: "posthog",
          methodName: "capture"
        },
        {
          name: "rudderstack",
          isEnabled: !!((_g = integrations == null ? void 0 : integrations.rudderstack) == null ? void 0 : _g.enabled),
          globalObjectName: "rudderanalytics",
          methodName: "track"
        }
      ];
    };
    setupAnalyticsIntegrations = (integrations) => {
      for (const { name: integrationName, isEnabled: isEnabled2, globalObjectName, methodName } of analyticsIntegrations(
        integrations
      )) {
        if (!isEnabled2)
          continue;
        const sdk = getSDK();
        const eventSubscriptions = sdk[_eventSubscriptions];
        if (!eventSubscriptions)
          continue;
        const sendEvent = (name, data) => {
          var _a2, _b2;
          const platform = window[globalObjectName];
          if (!platform) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureMessage(`Integration ${integrationName} is enabled but not loaded`);
          }
          try {
            if (integrationName === "hubspot") {
              platform[methodName]([
                "trackCustomBehavioralEvent",
                { name: "CommandBar " + name, properties: toFlatObject(data) }
              ]);
            } else {
              platform[methodName]("CommandBar " + name, toFlatObject(data));
            }
          } catch (e) {
            (_b2 = getSentry()) == null ? void 0 : _b2.captureException(e, {
              captureContext: {
                contexts: {
                  integration: {
                    name: globalObjectName,
                    methodCalled: methodName
                  }
                }
              }
            });
          }
        };
        const s = Symbol();
        eventSubscriptions.set(s, [
          sendEvent,
          void 0
          /* { v2: true } */
        ]);
      }
    };
  }
});

// commandbar/src/shared/store/global-subscriptions.ts
import merge2 from "lodash/merge";
import { ref as ref7 } from "valtio";
import debounce4 from "lodash/debounce";
import isEqual9 from "lodash/isEqual";
var deriveEndUserData, mergeContextSettings, locationChanged, locationSub, helpHubSearch, mutationObserver, setupMutationObserver, persistTestMode, viewLatestViaEnvOverrideOnEditorOpen, reloadCommandsOnEnvChange, processClientSideIntegrations, extensionSub, initSharedSubs;
var init_global_subscriptions = __esm({
  "commandbar/src/shared/store/global-subscriptions.ts"() {
    "use strict";
    init_sub();
    init_dom();
    init_LocalStorage();
    init_Reporting();
    init_selectors();
    init_service_actions3();
    init_service_actions2();
    init_search();
    init_share_links();
    init_service_selectors2();
    init_global_actions();
    init_logChanges();
    init_globals();
    init_symbols();
    init_hasOp();
    init_clientSideIntegrations();
    init_service_selectors();
    init_messages();
    init_global_actions();
    init_service_selectors2();
    deriveEndUserData = (_) => {
      _.endUserStore.derived = {
        recentUIDs: recentUIDs(_.endUserStore.data.recents)
      };
    };
    mergeContextSettings = (_) => {
      _.contextSettings = merge2({}, _.serverContextSettings, _.localContextSettings);
    };
    locationChanged = (_) => {
      var _a2;
      if (!_.endUserStore.hasRemoteLoaded) {
        return false;
      }
      sendIndirectTrigger(_, { type: "when_page_reached", meta: { url: _.location.href } });
      triggerChecklists(_, { type: "when_page_reached", meta: { url: _.location.href } });
      const deconstructedShareLink = deconstructShareLink(((_a2 = _.organization) == null ? void 0 : _a2.share_link_param) || "cb-eid", _.location.search);
      if (deconstructedShareLink) {
        const currentURL = new URL(_.location.href);
        const removeUrlParameter = () => {
          currentURL.searchParams.delete("cb-eid");
          const newUrl = currentURL.toString();
          window.history.replaceState({}, document.title, newUrl);
        };
        if ((deconstructedShareLink == null ? void 0 : deconstructedShareLink.type) === "n" /* NUDGE */) {
          const nudge = getNudgeById(_, deconstructedShareLink.id);
          if (nudge) {
            activatePushExperience(_, nudge, "n");
          }
        } else if ((deconstructedShareLink == null ? void 0 : deconstructedShareLink.type) === "q" /* QUESTLIST */) {
          const sharedChecklist = _.checklists.find((checklist3) => checklist3.id === deconstructedShareLink.id);
          if (sharedChecklist) {
            activatePushExperience(_, sharedChecklist, "q");
          }
        }
        removeUrlParameter();
      }
    };
    locationSub = (_) => {
      const history = window.history;
      const pushState = history.pushState;
      const replaceState = history.replaceState;
      let cancelled = false;
      let oldHref = document.location.href;
      if (false) {
        const bodyList = document.body;
        const observer = new MutationObserver(function() {
          if (oldHref !== document.location.href) {
            oldHref = document.location.href;
            _.location = ref7({ ...window.location });
          }
        });
        observer.observe(bodyList, {
          childList: true,
          subtree: true
        });
      } else {
        history.pushState = function(...args) {
          pushState.apply(history, args);
          if (cancelled)
            return;
          if (oldHref === document.location.href)
            return;
          oldHref = document.location.href;
          _.location = ref7({ ...window.location });
        };
        history.replaceState = function(...args) {
          replaceState.apply(history, args);
          if (cancelled)
            return;
          if (oldHref === document.location.href)
            return;
          oldHref = document.location.href;
          _.location = ref7({ ...window.location });
        };
      }
      const checkHrefChange = () => {
        if (oldHref !== document.location.href) {
          oldHref = document.location.href;
          _.location = ref7({ ...window.location });
        }
      };
      window.addEventListener("hashchange", checkHrefChange);
      return () => {
        window.removeEventListener("hashchange", checkHrefChange);
        cancelled = true;
      };
    };
    helpHubSearch = async (_) => {
      var _a2;
      const query = _.helpHub.query || "";
      if (!_.organization)
        return;
      if (!query) {
        const recommendations = await getHelpHubRecommendations(_);
        if (recommendations.length) {
          return;
        }
      }
      _.helpHub.loading = true;
      let promises;
      if ((_a2 = _.flags) == null ? void 0 : _a2["release-search-experiences-in-help-hub"]) {
        const maxResults = query ? void 0 : 10;
        promises = [
          queryExperiences(_, query, "helphub", void 0, maxResults).then((experiences) => {
            _.helpHub.experienceSearchResults = experiences;
            if (!_.helpHub.experienceSearchResults.length) {
              noResultsForQuery(query, { type: "helphub" });
            }
          })
        ];
      } else {
        promises = [
          queryHelpDocs(_.organization.id, query, _.endUser, _.helpHub.filter).then((docs) => {
            _.helpHub.searchResults = docs;
            if (!_.helpHub.searchResults.length) {
              noResultsForQuery(query, { type: "helphub" });
            }
          })
        ];
      }
      Promise.allSettled(promises).finally(() => {
        _.helpHub.loading = false;
      });
    };
    mutationObserver = null;
    setupMutationObserver = (_) => {
      var _a2;
      if (mutationObserver)
        mutationObserver.disconnect();
      if (((_a2 = _.flags) == null ? void 0 : _a2["enable-when-element-appears-trigger"]) && (_.products.includes("nudges") || _.products.includes("checklists")) && _.triggerableSelectors.length > 0) {
        const debouncedTriggers = debounce4(() => {
          for (let i2 = 0; i2 < _.triggerableSelectors.length; i2++) {
            const selector2 = _.triggerableSelectors[i2];
            const element = getElement(selector2);
            if (element) {
              const style3 = window.getComputedStyle(element);
              const isDisplayNone = style3.display === "none";
              const isVisibilityHidden = style3.visibility === "hidden";
              const isHidden = isDisplayNone || isVisibilityHidden;
              if (!isHidden) {
                sendIndirectTrigger(_, { type: "when_element_appears", meta: { selector: selector2 } });
                triggerChecklists(_, { type: "when_element_appears", meta: { selector: selector2 } });
                _.triggerableSelectors.splice(i2, 1);
              }
            }
          }
        }, 1500);
        mutationObserver = new MutationObserver(() => {
          debouncedTriggers();
        });
      }
      if (_.triggerableSelectors.length > 0 && passesGlobalLimit(_)) {
        mutationObserver == null ? void 0 : mutationObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"]
        });
      }
      return () => {
        mutationObserver == null ? void 0 : mutationObserver.disconnect();
      };
    };
    persistTestMode = (_) => {
      if (!_.isAdmin)
        return;
      if (_.testMode) {
        LocalStorage_default.set("testMode", true);
      } else {
        LocalStorage_default.remove("testMode");
      }
    };
    viewLatestViaEnvOverrideOnEditorOpen = (_) => {
      if (_.isEditorVisible) {
        setEnvOverride(_, { env: "latest" });
      }
    };
    reloadCommandsOnEnvChange = (_) => {
      if (_.active) {
        getSDK()[_reloadCommands]();
      }
    };
    processClientSideIntegrations = (_, ops) => {
      var _a2, _b2;
      const replacedOrg = getPrevValue(findOp("set", ["organization"], ops));
      if (isEqual9(replacedOrg == null ? void 0 : replacedOrg.integrations, (_a2 = _.organization) == null ? void 0 : _a2.integrations)) {
        return;
      } else {
        if (replacedOrg == null ? void 0 : replacedOrg.integrations) {
          tearDownAlgoliaIntegration(replacedOrg.integrations);
        }
      }
      if (!((_b2 = _.organization) == null ? void 0 : _b2.integrations))
        return;
      setupAnalyticsIntegrations(_.organization.integrations);
      return setupAlgoliaIntegration(_.organization.integrations);
    };
    extensionSub = (_) => {
      if (_.isAdmin) {
        const unsubStartPreview = StartPreviewMessage.addPageListener(async (data) => {
          var _a2;
          await getSDK()[_configUser]();
          if (((_a2 = data.experience) == null ? void 0 : _a2.type) === "nudge") {
            _.extension.preview.enabled = true;
            _.extension.preview.experience = data.experience;
            startDebugSession(_, data.experience.nudge);
          }
        });
        const unsubStartRecorder = StartClickRecorderMessage.addPageListener(async (data) => {
          if (data.origin === "preview") {
            _.extension.recorder.enabled = true;
            return;
          }
          closeAllNudgeMocks(_);
          _.extension.recorder.enabled = true;
          _.extension.recorder.experience = data.experience;
        });
        const unsubNudgeStep = UpdateNudgeStepMessage.addPageListener(async (data) => {
          const stringSelector = isElementInformation(data.value) ? data.value.selector : data.value;
          if (data.origin === "preview" && _.extension.preview.experience) {
            _.extension.recorder.enabled = false;
            const nudge = getNudgeById(_, _.extension.preview.experience.nudge.id);
            if (nudge) {
              updateNudgeStepForPreview(_, nudge, data.stepIndex, data.field, stringSelector);
            }
          } else if (data.origin === "recorder" && _.extension.recorder.experience) {
            if (_.extension.recorder.enabled && _.extension.recorder.experience) {
              _.extension.recorder.experience.field = data.field;
              showStepMock(
                _,
                _.extension.recorder.experience.nudge,
                _.extension.recorder.experience.stepIndex,
                {
                  anchorOverride: stringSelector
                }
              );
            }
          }
        });
        return () => {
          unsubStartPreview();
          unsubNudgeStep();
          unsubStartRecorder();
        };
      }
    };
    initSharedSubs = (_) => [
      sub(_, mergeContextSettings, [["serverContextSettings"], ["localContextSettings"]]),
      sub(_, locationChanged, [
        ["endUserStore", "hasRemoteLoaded"],
        // NOTE: need this because nudges and checklist triggering depends on _.endUser
        ["location", "href"]
      ]),
      sub(_, setupMutationObserver, [["triggerableSelectors"], ["products"]]),
      sub(_, deriveEndUserData, [["endUserStore", "data", "recents"]]),
      sub(_, helpHubSearch, [
        ["helpHub", "query"],
        ["helpHub", "filter"]
      ]),
      locationSub(_),
      sub(_, LocalStorage_default.get("logChanges", false) ? (_2, ops) => logChanges(ops) : () => null, "*"),
      sub(_, persistTestMode, [["testMode"]]),
      sub(_, viewLatestViaEnvOverrideOnEditorOpen, [["isEditorVisible"]]),
      sub(_, debounce4(reloadCommandsOnEnvChange, 25), [["env"], ["envOverride"]]),
      sub(_, processClientSideIntegrations, [["organization", "integrations"]]),
      sub(_, (_2) => resetTimedTriggers(_2), [["location"]]),
      sub(_, extensionSub, [["isAdmin"]])
    ];
  }
});

// commandbar/src/products/nudges/subscriptions.ts
var initNudgesSubs;
var init_subscriptions3 = __esm({
  "commandbar/src/products/nudges/subscriptions.ts"() {
    "use strict";
    init_sub();
    init_service_actions3();
    initNudgesSubs = (_) => [
      sub(_, (_2) => sendIndirectTrigger(_2, { type: "when_conditions_pass" }), [
        ["endUserStore", "hasRemoteLoaded"],
        // NOTE: need this because triggerNudges depends on _.endUser
        ["context"],
        ["location"],
        ["products"]
      ])
    ];
  }
});

// commandbar/src/products/checklists/subscriptions.ts
var initChecklistSubs;
var init_subscriptions4 = __esm({
  "commandbar/src/products/checklists/subscriptions.ts"() {
    "use strict";
    init_sub();
    init_actions5();
    initChecklistSubs = (_) => [
      sub(_, (_2) => triggerChecklists(_2, { type: "when_conditions_pass" }), [
        ["endUserStore", "hasRemoteLoaded"],
        ["context"],
        ["location"],
        ["products"],
        ["isAdmin"]
      ]),
      sub(_, (_2) => updateChecklistItemConditionsGoals(_2), [["activeChecklist"], ["context"], ["location"]])
    ];
  }
});

// commandbar/src/shared/store/global-store.ts
import debounce5 from "lodash/debounce";
import isEqual10 from "lodash/isEqual";
import memoizeOne from "memoize-one";
import { proxy, ref as ref8 } from "valtio";
import { proxyMap } from "valtio/utils";
var spotlightAvailabilityDependenciesSnapshot, needToComputeOptions, initEmptyBaseStep, emptyGlobalStore, initValtioGlobalStore, initGlobalSubs2;
var init_global_store = __esm({
  "commandbar/src/shared/store/global-store.ts"() {
    "use strict";
    init_types3();
    init_placeholderHelpers();
    init_operatingSystem();
    init_state();
    init_global_subscriptions();
    init_subscriptions2();
    init_subscriptions3();
    init_subscriptions4();
    spotlightAvailabilityDependenciesSnapshot = (snapshot4) => {
      return {
        /** Known impact on option availability  */
        commands: snapshot4.commands,
        programmaticCommands: snapshot4.programmaticCommands,
        hotloadedCommands: snapshot4.hotloadedCommands,
        localContextSettings: snapshot4.localContextSettings,
        serverContextSettings: snapshot4.serverContextSettings,
        context: snapshot4.context,
        records: snapshot4.spotlight.records,
        callbacks: snapshot4.callbacks,
        testMode: snapshot4.testMode,
        endUserStore: snapshot4.endUserStore,
        location: snapshot4.location,
        currentStepIndex: snapshot4.spotlight.currentStepIndex
      };
    };
    needToComputeOptions = (prevSnapshot, nextSnapshot) => {
      if (!nextSnapshot.spotlight.visible)
        return false;
      const prevEngine = spotlightAvailabilityDependenciesSnapshot(prevSnapshot);
      const nextEngine = spotlightAvailabilityDependenciesSnapshot(nextSnapshot);
      const equal = isEqual10(prevEngine, nextEngine);
      return !equal;
    };
    initEmptyBaseStep = () => ({
      type: "base" /* Base */,
      completed: false,
      resource: null,
      selected: null
    });
    emptyGlobalStore = () => ({
      spotlight: {
        loadingByKey: {},
        showLoadingIndicator: false,
        inMinLoadingWindow: false,
        minLoadingTimeout: void 0,
        emptyMessage: void 0,
        previewMode: false,
        builtinAskCopilotOption: null,
        visible: false,
        refContainer: null,
        searchOptionsDebouncer: debounce5((cb) => cb(), 150),
        dashboard: void 0,
        inputText: "",
        rawInput: "",
        // Steps should always have at least one actionable step; this is the default
        steps: [initEmptyBaseStep()],
        formFactor: { type: "modal" },
        initialOptions: [],
        currentOptions: [],
        sortedOptions: [],
        optionCountsByTabGroup: /* @__PURE__ */ new Map(),
        currentGroups: [],
        expandedGroupKeys: [],
        focusedIndex: 0,
        focusableChildIndex: -1,
        // NOTE: instead of importing a function here (would cause a dependency cycle) or defining it here (would be
        // sloppy and might still cause a cycle), the caller is instead expected to pass the implementation
        // (dependency-injection style) of the function at call time.
        availableOptionMemoizer: memoizeOne(
          (_, _engine, cb) => cb(_),
          // The callback argument is expected to be static and is ignored entirely for this equality function.
          ([_n, nextSnapshot], [_p, prevSnapshot]) => prevSnapshot === nextSnapshot || !needToComputeOptions(prevSnapshot, nextSnapshot)
        ),
        currentStepIndex: 0,
        recordsMachines: proxyMap(),
        records: {},
        executionHistory: [],
        previousInputText: "",
        isBackspacing: false,
        cachedInput: "",
        reportKeystrokeDebouncer: debounce5((cb) => cb(), 500),
        searchFilter: void 0,
        showKeyboardShortcutCheatsheet: false,
        userDefinedCustomComponents: {
          footer: () => null,
          header: () => null,
          tabHeader: () => null,
          menuHeader: () => null,
          input: () => null,
          sidepanel: () => null,
          navPaneHeader: () => null,
          navPaneFooter: () => null,
          defaultState: () => null,
          emptyState: () => null
        },
        errorIndex: -1,
        errorTimestamp: 0,
        activePlaceholder: DEFAULT_PLACEHOLDER,
        placeholders: [],
        tabs: [],
        categories: [],
        categoryConfig: {},
        serverCategories: [],
        localCategories: []
      },
      /** Old 'app' state */
      active: false,
      env: null,
      envOverride: null,
      version: null,
      airgap: false,
      isEditorActive: false,
      isEditorVisible: false,
      editorPathChangeListeners: [],
      initialEditorPath: null,
      editorPreviewDevice: "desktop",
      /** Old 'engine' state */
      location: ref8(window.location),
      organization: void 0,
      products: ["spotlight", "nudges", "checklists", "help_hub"],
      endUser: void 0,
      endUserStore: emptyEndUserStoreState(),
      decide: void 0,
      logo: "",
      themeSource: "",
      localContextSettings: {},
      serverContextSettings: {},
      contextSettings: {},
      programmaticCommands: [],
      commands: [],
      hotloadedCommands: [],
      mockCommands: [],
      pageMetadata: {},
      context: {},
      callbacks: {},
      testMode: false,
      isAdmin: false,
      environments: null,
      flags: null,
      commandsLoaded: false,
      baseTheme: void 0,
      primaryColor: void 0,
      nudgeManager: null,
      currentModalNudge: null,
      nudgeDebugToolBar: {
        visible: false,
        closeTabWhenToolbarClosed: false,
        bypassGlobalLimit: true,
        position: "bottom"
      },
      nudgeEventListeners: {
        on_rage_click: void 0,
        on_user_confusion: void 0,
        smart_delay: void 0
      },
      nudgeBannerSpacersListeners: {},
      checklists: [],
      activeChecklist: null,
      queuedChecklist: null,
      keywords: [],
      triggerableSelectors: [],
      timedTriggers: /* @__PURE__ */ new Map(),
      platform: getOperatingSystem(),
      detailPreviewGenerator: null,
      components: {},
      theme: void 0,
      editingEndUserShortcutSlug: null,
      helpHub: {
        visible: false,
        key: 0,
        minimized: false,
        loading: false,
        scrollPosition: 0,
        query: null,
        searchResults: [],
        experienceSearchResults: [],
        hubDoc: null,
        hubDocHeading: null,
        recommendationSets: null,
        previewedRecommendationSet: null,
        previewedCopilotSettings: null,
        additionalResources: [],
        parsingUrlParams: false,
        searchSuggestions: { loading: true },
        gaveFeedback: {},
        chatOnly: false,
        filter: null,
        initialPage: null,
        activeChat: null,
        editorCopilotOverrides: {}
      },
      trackedAppEvents: /* @__PURE__ */ new Set(),
      showWidgetTableau: false,
      widgetTableauSelection: { type: "all", id: "" },
      themeV2Mode: "light_mode",
      extension: {
        preview: { enabled: false },
        recorder: { enabled: false }
      },
      localizedMessages: {},
      themes: []
    });
    initValtioGlobalStore = () => proxy({
      ...emptyGlobalStore()
    });
    initGlobalSubs2 = (_) => {
      const unsubs = [...initSharedSubs(_), ...initSpotlightSubs(_), ...initNudgesSubs(_), ...initChecklistSubs(_)];
      return () => unsubs.forEach((unsub) => unsub());
    };
  }
});

// commandbar/src/shared/store/GlobalStoreProvider.tsx
import React170 from "react";
import { devtools } from "valtio/utils";
import { ref as ref9 } from "valtio";
var globalInstanceId, GlobalStoreContext, GlobalStoreProvider;
var init_GlobalStoreProvider = __esm({
  "commandbar/src/shared/store/GlobalStoreProvider.tsx"() {
    "use strict";
    init_global_store();
    init_LocalStorage();
    globalInstanceId = 0;
    GlobalStoreContext = React170.createContext(void 0);
    GlobalStoreProvider = (props2) => {
      const store = React170.useRef(initValtioGlobalStore());
      React170.useEffect(() => initGlobalSubs2(store.current), []);
      store.current.spotlight.refContainer = ref9(React170.useRef(null));
      React170.useEffect(() => {
        if (true)
          return;
        if (!LocalStorage_default.get("logChanges", false))
          return;
        return devtools(store.current, `CommandBar:${globalInstanceId++}`);
      }, []);
      if (false) {
        Object.assign(window, { CB: store.current });
      }
      return /* @__PURE__ */ React170.createElement(GlobalStoreContext.Provider, { value: store.current }, props2.children);
    };
  }
});

// commandbar/src/shared/util/hooks/useStore.tsx
import React171 from "react";
import { useSnapshot } from "valtio";
var useStore;
var init_useStore = __esm({
  "commandbar/src/shared/util/hooks/useStore.tsx"() {
    "use strict";
    init_GlobalStoreProvider();
    useStore = (sync = false) => useSnapshot(React171.useContext(GlobalStoreContext), { sync });
  }
});

// internal/src/util/useOS.tsx
import React172 from "react";
var useOS, useOS_default;
var init_useOS = __esm({
  "internal/src/util/useOS.tsx"() {
    "use strict";
    init_operatingSystem();
    useOS = () => {
      const details = React172.useMemo(() => {
        return {
          getEventTrigger: getTriggerKey,
          triggerKey: osControlKey(),
          os: getOperatingSystem(),
          isMobile: isMobileDevice()
        };
      }, []);
      return details;
    };
    useOS_default = useOS;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightContentHeader.tsx
import React173 from "react";
var Header4, StyledSpotlightContentHeader, StyledSpotlightContentHeader_default;
var init_StyledSpotlightContentHeader = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightContentHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Header4 = styled_browser_esm_default.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
  gap: var(--layout-gap);
  align-items: flex-start;
`;
    StyledSpotlightContentHeader = React173.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React173.createElement(Header4, { ref: ref12, ...props2 }, children);
      }
    );
    StyledSpotlightContentHeader_default = StyledSpotlightContentHeader;
  }
});

// commandbar/src/products/spotlight/components/select/input/StatusBar.tsx
import React174 from "react";
import { css as css30, jsx as jsx50, keyframes as keyframes5 } from "@emotion/core";
import { useTheme as useTheme11 } from "emotion-theming";
var moveBarRight, MIN_BLOCKS_TO_SHOW_LEFT, useStatusBarInstructions, InstructionBlock, StatusBar, StatusBar_default;
var init_StatusBar = __esm({
  "commandbar/src/products/spotlight/components/select/input/StatusBar.tsx"() {
    "use strict";
    init_Block();
    init_useWindowSize();
    init_useStore();
    init_selectors8();
    init_Step();
    init_useOS();
    init_actions9();
    init_useAction();
    init_StyledSpotlightContentHeader();
    moveBarRight = (offset6) => {
      const bar = document.getElementById("commandbar-wrapper");
      if (bar) {
        const dialog = bar.querySelectorAll(".rc-dialog");
        if (dialog[0]) {
          dialog[0].style.left = `${offset6}px`;
        }
      }
    };
    MIN_BLOCKS_TO_SHOW_LEFT = 3;
    useStatusBarInstructions = (_) => {
      const { currentStep } = currentStepAndIndex(_);
      const { triggerKey } = useOS_default();
      const _submitLongTextInput = useAction((_2) => submitLongTextInput(_2, _2.spotlight.inputText));
      const _submitMultiSelect = useAction(submitMultiSelect);
      const _submitDashboardStep = useAction(submitDashboardStep);
      switch (currentStep == null ? void 0 : currentStep.type) {
        case "base" /* Base */:
          if (currentStep.resource === null) {
            return void 0;
          } else {
            return {
              longText: "Choose an action.",
              shortText: "Choose an action.",
              testId: "execution-intructions"
            };
          }
        case "longtextinput" /* LongTextInput */:
          return {
            longText: `Press ${triggerKey}+Enter or click here to submit`,
            shortText: "Submit",
            onClick: _submitLongTextInput,
            testId: "execution-instructions-text"
          };
        case "multiselect" /* MultiSelect */:
          return {
            longText: `${triggerKey}+Enter or click here to submit`,
            shortText: "Submit",
            onClick: _submitMultiSelect
          };
        case "textinput" /* TextInput */:
          return {
            longText: `Type text and press Enter.`,
            shortText: "Type text and press Enter"
          };
        case "dashboard" /* Dashboard */:
          return {
            longText: `Enter or click here to continue`,
            shortText: "Continue",
            onClick: _submitDashboardStep
          };
        case "select" /* Select */:
        default:
          return void 0;
      }
    };
    InstructionBlock = (props2) => {
      const { instructions, windowWidth } = props2;
      if (!instructions)
        return null;
      const instructionType = windowWidth > 700 ? "long" : windowWidth > 300 ? "short" : "none";
      if (instructionType === "none")
        return null;
      const text = instructionType === "long" ? instructions.longText : instructions.shortText;
      return /* @__PURE__ */ jsx50(
        "div",
        {
          style: {
            minWidth: 0
          }
        },
        /* @__PURE__ */ jsx50("div", { id: instructions.testId || "execution-instructions" }, /* @__PURE__ */ jsx50(
          Block_default,
          {
            key: "instruction-text",
            content: { text, type: instructions.onClick ? 5 /* CLICKABLE_INSTRUCTION */ : 4 /* INSTRUCTION */ },
            position: "top" /* TOP */,
            windowWidth,
            onClick: instructions.onClick
          }
        ))
      );
    };
    StatusBar = () => {
      var _a2;
      const { theme } = useTheme11();
      const _ = useStore();
      const content = getArgumentBlocks(_);
      const instructions = useStatusBarInstructions(_);
      const windowWidth = useWindowSize_default().width;
      const moveLeft = keyframes5`
  0% {
    left: 0px;
  }

  100% {
    left: -110px;
  }
  `;
      const position = windowWidth > 850 && content.length > MIN_BLOCKS_TO_SHOW_LEFT ? "left" /* LEFT */ : "top" /* TOP */;
      React174.useEffect(() => {
        if (position === "top" /* TOP */) {
          moveBarRight(0);
        } else {
          moveBarRight(60);
        }
      }, [position]);
      if (!instructions && !(content.length > 0))
        return /* @__PURE__ */ jsx50("div", null);
      const { currentStepIndex } = currentStepAndIndex(_);
      const showAnimation = currentStepIndex > 0 && _.spotlight.steps[currentStepIndex - 1].type === "base" /* Base */;
      const leftStyles = {
        flexDirection: "column",
        position: "absolute",
        left: -110,
        maxWidth: 100,
        zIndex: -1,
        overflow: "visible",
        alignItems: "flex-end",
        top: 0
      };
      const topStyles = {
        flexDirection: "row",
        justifyContent: "flex-start",
        maxWidth: "100%"
      };
      const animation = showAnimation ? css30`
        animation: ${moveLeft} 0.4s;
        animation-fill-mode: forwards;
      ` : null;
      const styles51 = (() => {
        switch (position) {
          case "left" /* LEFT */:
            return leftStyles;
          case "top" /* TOP */:
            return topStyles;
        }
      })();
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx50(StyledSpotlightContentHeader_default, { style: { padding: "3px" } }, position === "left" /* LEFT */ && /* @__PURE__ */ jsx50("div", null), /* @__PURE__ */ jsx50(
        "div",
        {
          css: [
            {
              display: "flex",
              flexDirection: "column",
              gap: "6px"
            },
            animation
          ]
        },
        content.map((block, i2) => {
          if (content.length <= 2 && i2 > 0)
            return /* @__PURE__ */ jsx50("div", { key: 0 });
          return /* @__PURE__ */ jsx50(Block_default, { key: `block-${i2}`, content: block, position, windowWidth });
        })
      ), /* @__PURE__ */ jsx50(InstructionBlock, { instructions, windowWidth })) : /* @__PURE__ */ jsx50("div", { style: { width: "100%" } }, /* @__PURE__ */ jsx50(
        "div",
        {
          style: {
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            paddingTop: theme.blocksContainer.paddingTop,
            paddingBottom: theme.blocksContainer.paddingBottom,
            paddingLeft: theme.blocksContainer.paddingLeft,
            paddingRight: theme.blocksContainer.paddingRight
          }
        },
        position === "left" /* LEFT */ && /* @__PURE__ */ jsx50("div", null),
        /* @__PURE__ */ jsx50(
          "div",
          {
            css: [
              {
                display: "flex",
                ...styles51
              },
              animation
            ]
          },
          content.map((block, i2) => {
            if (content.length <= 2 && i2 > 0)
              return /* @__PURE__ */ jsx50("div", { key: 0 });
            return /* @__PURE__ */ jsx50(Block_default, { key: `block-${i2}`, content: block, position, windowWidth });
          })
        ),
        /* @__PURE__ */ jsx50(InstructionBlock, { instructions, windowWidth })
      ));
    };
    StatusBar_default = StatusBar;
  }
});

// internal/src/client/themesV2/components/shared/StyledTag.tsx
import React175 from "react";
var Tag2, StyledTag, StyledTag_default;
var init_StyledTag = __esm({
  "internal/src/client/themesV2/components/shared/StyledTag.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Tag2 = styled_browser_esm_default.button`
  && {
    all: unset;

    box-sizing: border-box;
    display: flex;
    height: 24px;
    padding: 0 var(--form-control-padding-x);
    justify-content: center;
    align-items: center;
    border-radius: var(--layout-radius-button);
    border: 1px solid var(--border-primary);
    background: var(--background-secondary);
    gap: var(--form-control-gap);
    color: var(--content-secondary);
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;

    /* label/base/semibold */
    font-family: var(--font-font-family);
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-semibold);
    line-height: var(--font-line-height-normal);

    &:hover {
      border: 1px solid var(--border-primary-hover);
      background: var(--background-secondary-hover);
      color: var(--button-secondary-content-hover);
    }

    &:focus {
      border: 1px solid var(--base-accent);
      box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
      &:hover {
        background: var(--background-secondary-hover);
      }
    }

    &:focus-visible {
      border: 1px solid var(--base-accent);
      box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
      outline: none;
      &:hover {
        background: var(--background-secondary-hover);
      }
    }
  }
`;
    StyledTag = React175.forwardRef(
      ({ children, ...props2 }, ref12) => /* @__PURE__ */ React175.createElement(Tag2, { ...props2, ref: ref12 }, children)
    );
    StyledTag_default = StyledTag;
  }
});

// commandbar/src/products/spotlight/components/select/input/Block.tsx
import React176 from "react";
import { jsx as jsx51 } from "@emotion/core";
import { AiOutlineClose } from "react-icons/ai";
import chroma7 from "chroma-js";
import { BsArrowRightShort } from "react-icons/bs";
var getBlockSuffix, getMaxWidth, blockBackgroundStyle, getBlockBackgroundStyle, getBlockStyle, FadeOut, Block, Block_default;
var init_Block = __esm({
  "commandbar/src/products/spotlight/components/select/input/Block.tsx"() {
    "use strict";
    init_Tooltip();
    init_Tag();
    init_StatusBar();
    init_actions9();
    init_useAction();
    init_chroma();
    init_useStore();
    init_StyledTag();
    init_react();
    getBlockSuffix = (type39) => {
      switch (type39) {
        case 1 /* LAST_SELECTED */:
          return /* @__PURE__ */ jsx51("div", { style: { padding: "6px 0px" } }, /* @__PURE__ */ jsx51(
            "span",
            {
              style: {
                marginLeft: 3,
                display: "flex",
                alignItems: "center",
                width: 10,
                zIndex: 2,
                position: "relative"
              }
            },
            /* @__PURE__ */ jsx51(
              Tooltip_default,
              {
                overlay: /* @__PURE__ */ jsx51("span", null, /* @__PURE__ */ jsx51(Tag_default, { style: { height: 12, padding: "4px 4px" }, color: chroma7("rgb(174, 177, 221)") }, "ESC"), " ", "to remove last selection"),
                placement: "top",
                align: { offset: [0, -15] }
              },
              /* @__PURE__ */ jsx51(AiOutlineClose, { style: { fontSize: 9, position: "absolute" } })
            )
          ));
        case 5 /* CLICKABLE_INSTRUCTION */:
          return /* @__PURE__ */ jsx51(BsArrowRightShort, { style: { fontSize: 14 } });
        default:
          return /* @__PURE__ */ jsx51("div", null);
      }
    };
    getMaxWidth = (type39, position) => {
      switch (type39) {
        case 4 /* INSTRUCTION */:
          return 250;
        default:
          if (position === "left" /* LEFT */) {
            return 150;
          } else {
            return 250;
          }
      }
    };
    blockBackgroundStyle = {
      lineHeight: "19.2px",
      minWidth: 0,
      display: "flex",
      alignItems: "center",
      whiteSpace: "nowrap",
      position: "relative",
      transition: "color ease-in 0.3s",
      overflow: "hidden",
      textOverflow: "ellipsis"
    };
    getBlockBackgroundStyle = (theme, type39, position) => {
      const typeStyles = (() => {
        switch (type39) {
          case 4 /* INSTRUCTION */:
          case 5 /* CLICKABLE_INSTRUCTION */:
            return {
              marginRight: 0,
              marginBottom: 0,
              borderRadius: theme.theme.instruction.borderRadius
            };
          case 1 /* LAST_SELECTED */:
          case 0 /* SELECTED */:
            return {
              boxShadow: position === "left" /* LEFT */ ? "rgba(0, 0, 0, 0.2) 0px 5px 30px" : void 0,
              border: theme.theme.blocks.border,
              borderRadius: theme.theme.blocks.borderRadius
            };
          case 2 /* CURRENT_ARGUMENT */:
            return {
              boxShadow: position === "left" /* LEFT */ ? "rgba(0, 0, 0, 0.2) 0px 5px 30px" : void 0,
              border: `1px solid ${theme.theme.base.primary}`,
              borderRadius: theme.theme.blocks.borderRadius
            };
          case 3 /* PLACEHOLDER */:
            return {
              boxShadow: position === "left" /* LEFT */ ? "rgba(0, 0, 0, 0.2) 0px 5px 30px" : void 0,
              border: `1px solid grey`,
              borderRadius: theme.theme.blocks.borderRadius
            };
        }
      })();
      const commandbarAnimationFadeIn = {
        animation: "0.3s ease-out onEntry",
        transformOrigin: "100% 100%"
      };
      const positionSpecificStyle = (() => {
        switch (position) {
          case "left" /* LEFT */:
            return { margin: "0px 4px 8px 4px" };
          case "top" /* TOP */:
            return { margin: "4px", ":first-of-type": { marginLeft: 0 } };
        }
      })();
      return {
        ...typeStyles,
        ...blockBackgroundStyle,
        ...commandbarAnimationFadeIn,
        ...positionSpecificStyle
      };
    };
    getBlockStyle = (theme, type39, _position) => {
      switch (type39) {
        case 1 /* LAST_SELECTED */:
        case 0 /* SELECTED */:
          return {
            cursor: "pointer",
            color: theme.theme.blocks.color,
            backgroundColor: theme.theme.blocks.background,
            fontSize: theme.theme.blocks.fontSize,
            paddingTop: theme.theme.blocks.paddingTop,
            paddingBottom: theme.theme.blocks.paddingBottom,
            paddingLeft: theme.theme.blocks.paddingLeft,
            paddingRight: theme.theme.blocks.paddingRight,
            fontWeight: theme.theme.blocks.fontWeight
          };
        case 2 /* CURRENT_ARGUMENT */:
          return {
            color: getChromaColor(theme.theme.base.primary).get("lab.l") < 70 ? "white" : "black",
            backgroundColor: theme.theme.base.primary,
            fontSize: theme.theme.blocks.fontSize,
            paddingTop: theme.theme.blocks.paddingTop,
            paddingBottom: theme.theme.blocks.paddingBottom,
            paddingLeft: theme.theme.blocks.paddingLeft,
            paddingRight: theme.theme.blocks.paddingRight,
            fontWeight: theme.theme.blocks.fontWeight
          };
        case 3 /* PLACEHOLDER */:
          return {
            backgroundColor: "#dddddd",
            color: "grey",
            fontSize: theme.theme.blocks.fontSize,
            paddingTop: theme.theme.blocks.paddingTop,
            paddingBottom: theme.theme.blocks.paddingBottom,
            paddingLeft: theme.theme.blocks.paddingLeft,
            paddingRight: theme.theme.blocks.paddingRight,
            fontWeight: theme.theme.blocks.fontWeight
          };
        case 4 /* INSTRUCTION */:
        case 5 /* CLICKABLE_INSTRUCTION */:
          return {
            display: theme.theme.instruction.display,
            backgroundColor: theme.theme.instruction.background,
            color: theme.theme.instruction.fontColor,
            fontSize: theme.theme.blocks.fontSize,
            paddingTop: theme.theme.blocks.paddingTop,
            paddingBottom: theme.theme.blocks.paddingBottom,
            paddingLeft: theme.theme.blocks.paddingLeft,
            paddingRight: theme.theme.blocks.paddingRight,
            fontWeight: theme.theme.blocks.fontWeight
          };
      }
    };
    FadeOut = (props2) => {
      return /* @__PURE__ */ jsx51(Tooltip_default, { overlay: /* @__PURE__ */ jsx51("span", null, props2.text), align: { offset: [0, -7] }, placement: "top" }, /* @__PURE__ */ jsx51(
        "span",
        {
          css: (theme) => ({
            position: "absolute",
            left: 0,
            zIndex: 1,
            width: "100%",
            height: "100%",
            background: `linear-gradient(
  to right,
  ${getChromaColor(theme.theme.main.background).alpha(0).css()},
  ${getChromaColor(theme.theme.main.background).alpha(0).css()} 75%,
  ${getChromaColor(theme.theme.main.background).alpha(0.2).css()} 80%,
  ${getChromaColor(theme.theme.main.background).alpha(0.9).css()} 100%
)`
          })
        }
      ));
    };
    Block = (props2) => {
      var _a2;
      const _ = useStore();
      const ref12 = React176.useRef(void 0);
      const [showFade, setShowFade] = React176.useState(false);
      React176.useEffect(() => {
        if (ref12.current.clientWidth < ref12.current.scrollWidth) {
          setShowFade(true);
        } else {
          setShowFade(false);
        }
      }, [props2.content.text, props2.position, props2.windowWidth]);
      const { content } = props2;
      const maxWidth = getMaxWidth(content.type, props2.position);
      const handleRollback = useAction(
        (_2) => {
          rollback(_2);
          handleInputChange(_2, "");
        },
        [content]
      );
      const handleClick = (() => {
        if (props2.onClick)
          return props2.onClick;
        if (content.type === 1 /* LAST_SELECTED */)
          return handleRollback;
        return void 0;
      })();
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx51("div", null, showFade && /* @__PURE__ */ jsx51(FadeOut, { text: content.text }), /* @__PURE__ */ jsx51(
        StyledTag_default,
        {
          ref: ref12,
          className: "commandbar-block",
          "aria-label": "remove-block-" + content.text.replace(" ", "-").toLowerCase(),
          onClick: handleClick
        },
        content.text,
        content.type === 1 /* LAST_SELECTED */ && /* @__PURE__ */ jsx51(
          Tooltip_default,
          {
            overlay: /* @__PURE__ */ jsx51("span", null, /* @__PURE__ */ jsx51(Tag_default, { style: { height: 12, padding: "4px 4px" }, color: chroma7("rgb(174, 177, 221)") }, "ESC"), " ", "to remove last selection"),
            placement: "top",
            align: { offset: [0, -15] }
          },
          /* @__PURE__ */ jsx51(XClose_default, null)
        ),
        content.type === 5 /* CLICKABLE_INSTRUCTION */ && /* @__PURE__ */ jsx51(ArrowNarrowRight_default, null)
      )) : /* @__PURE__ */ jsx51(
        "div",
        {
          css: (theme) => getBlockBackgroundStyle(theme, content.type, props2.position),
          key: `${content.text}-background`,
          "data-testid": `block-${content.type}`
        },
        showFade && /* @__PURE__ */ jsx51(FadeOut, { text: content.text }),
        /* @__PURE__ */ jsx51(
          "button",
          {
            className: "commandbar-block",
            "aria-label": "remove-block-" + content.text.replace(" ", "-").toLowerCase(),
            style: {
              border: "none",
              fontStyle: "inherit",
              fontFamily: "inherit",
              outline: "inherit",
              cursor: !!handleClick ? "pointer" : "default",
              display: "flex",
              alignItems: "center"
            },
            css: (theme) => getBlockStyle(theme, content.type, props2.position),
            onClick: handleClick
          },
          /* @__PURE__ */ jsx51("span", { style: { maxWidth, minWidth: 0, color: "inherit" }, ref: ref12 }, content.text),
          getBlockSuffix(content.type)
        )
      );
    };
    Block_default = Block;
  }
});

// commandbar/src/products/spotlight/store/steps/selectors.ts
var currentStepAndIndex, selectLastStep, getArgumentSelections, getActiveCommand, getActiveRecord, isSelectStep, isDashboardStep, isTimeStep, isContextFunctionStep, isFinalStep, getArgumentBlocks;
var init_selectors8 = __esm({
  "commandbar/src/products/spotlight/store/steps/selectors.ts"() {
    "use strict";
    init_types2();
    init_Step();
    init_Block();
    init_helpers5();
    currentStepAndIndex = (_) => {
      if (_.spotlight.steps.length === 0) {
        return { currentStep: void 0, currentStepIndex: -1 };
      }
      const currentStepIndex = _.spotlight.steps.findIndex((step) => {
        return !step.completed;
      });
      return { currentStep: _.spotlight.steps[currentStepIndex], currentStepIndex };
    };
    selectLastStep = (_) => {
      return _.spotlight.steps[_.spotlight.steps.length - 1];
    };
    getArgumentSelections = (_) => {
      let obj = {};
      _.spotlight.steps.forEach((step) => {
        if (step.type === "select" /* Select */ || step.type === "multiselect" /* MultiSelect */ || step.type === "textinput" /* TextInput */ || step.type === "longtextinput" /* LongTextInput */) {
          obj = {
            ...obj,
            ...getStepSelection(step)
          };
        }
      });
      return obj;
    };
    getActiveCommand = (_) => {
      var _a2;
      if (_.spotlight.steps.length === 0)
        return void 0;
      const firstStep = _.spotlight.steps[0];
      if (firstStep.type === "base" /* Base */)
        return (_a2 = firstStep == null ? void 0 : firstStep.selected) == null ? void 0 : _a2.data;
      return void 0;
    };
    getActiveRecord = (_) => {
      if (_.spotlight.steps.length === 0)
        return null;
      for (const s of _.spotlight.steps) {
        if (s.type === "base" /* Base */ && s.resource) {
          return s.resource;
        }
      }
      return null;
    };
    isSelectStep = (currentStep) => {
      return (currentStep == null ? void 0 : currentStep.type) === "select" /* Select */ || (currentStep == null ? void 0 : currentStep.type) === "multiselect" /* MultiSelect */;
    };
    isDashboardStep = (currentStep) => {
      return (currentStep == null ? void 0 : currentStep.type) === "dashboard" /* Dashboard */;
    };
    isTimeStep = (currentStep) => {
      return isSelectStep(currentStep) && isTimeArgument(currentStep.argument);
    };
    isContextFunctionStep = (currentStep, _) => {
      if (isSelectStep(currentStep) && isContextArgument(currentStep.argument)) {
        return !!Object.keys(_.callbacks).find(
          (callbackKey) => callbackKey === `commandbar-initialvalue-${currentStep.argument.value}`
        );
      }
      return false;
    };
    isFinalStep = (step, steps, stepIndex) => {
      if (step.type === "dashboard" /* Dashboard */ && ["__video__", "__html__"].includes(step.argument.userDefinedValue)) {
        if (stepIndex + 1 < steps.length) {
          const executeStep = steps[stepIndex + 1];
          if (executeStep.type === "execute") {
            if (["video", "helpdoc"].includes(executeStep.command.template.type)) {
              return true;
            }
          }
        }
      }
      return step.type === "execute" /* Execute */;
    };
    getArgumentBlocks = (_) => {
      const { currentStep, currentStepIndex } = currentStepAndIndex(_);
      const ret = _.spotlight.steps.map((step, index3) => {
        if (isFinalStep(step, _.spotlight.steps, index3)) {
          return void 0;
        }
        const text = getStepBlock(step, _);
        if (text === void 0)
          return void 0;
        let type39 = 0 /* SELECTED */;
        if (index3 === currentStepIndex - 1 || (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */) {
          type39 = 1 /* LAST_SELECTED */;
        } else if (index3 === currentStepIndex) {
          type39 = 2 /* CURRENT_ARGUMENT */;
        } else if (index3 > currentStepIndex) {
          type39 = 3 /* PLACEHOLDER */;
        }
        return { text, type: type39 };
      }).filter((block) => !!block);
      return ret;
    };
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/RecordOption.tsx
var initRecordOption;
var init_RecordOption = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/RecordOption.tsx"() {
    "use strict";
    init_ParameterOption();
    init_selectors3();
    initRecordOption = (_, resource, label, resourceKey, searchOptions, recordActions) => {
      var _a2, _b2, _c2;
      const o = initParameterOption(
        _,
        label,
        resource,
        searchOptions,
        (resource == null ? void 0 : resource.__detailPreview) || ((_a2 = searchOptions.detail) != null ? _a2 : searchOptions.show_preview ? searchOptions.content : null)
      );
      Object.assign(o, { _resource: true });
      const category = {
        label: (_b2 = searchOptions.name) != null ? _b2 : resourceKey,
        contextKey: resourceKey,
        limit: (_c2 = searchOptions == null ? void 0 : searchOptions.max_options_count) != null ? _c2 : null,
        renderAs: searchOptions.render_as || "list"
        // FIXME: Grid
      };
      o.category = category;
      o.recordActions = [...recordActions];
      const optionUID = getOptionUID(o);
      const track_recents = searchOptions.track_recents === void 0 || searchOptions.track_recents;
      o.isRecent = !!(optionUID && track_recents && _.endUserStore.derived.recentUIDs.includes(optionUID));
      return o;
    };
  }
});

// commandbar/src/products/spotlight/store/options/option-utils/UnfurledCommandOption.tsx
var initUnfurledCommandOption;
var init_UnfurledCommandOption = __esm({
  "commandbar/src/products/spotlight/store/options/option-utils/UnfurledCommandOption.tsx"() {
    "use strict";
    init_ParameterOption();
    initUnfurledCommandOption = (_, command, parent, resource) => {
      const o = initParameterOption(_, parent.label, resource.parameter, resource.searchOptions);
      o.resource = resource;
      o.command = command;
      o.unfurled = true;
      o.label = `${command.text} > ${resource.label}`;
      return o;
    };
  }
});

// commandbar/src/products/spotlight/store/Available.tsx
import _get5 from "lodash/get";
var MAX_UNFURL_LENGTH, _optionsFromKey, actionsForRecord, _isResourceAvailableForCommand, getContextKeyValue, availableRecords, availableCommands, available, Available, Available_default;
var init_Available = __esm({
  "commandbar/src/products/spotlight/store/Available.tsx"() {
    "use strict";
    init_selectors8();
    init_utils();
    init_ClientSearch();
    init_Step();
    init_selectors3();
    init_selectors3();
    init_ParameterOption();
    init_RecordOption();
    init_UnfurledCommandOption();
    init_CommandOption();
    init_command();
    init_global_selectors();
    MAX_UNFURL_LENGTH = 5e4;
    _optionsFromKey = (_, obj, key, argument) => {
      let possibleValues;
      if (ClientSearch_default.isDefined(key, _)) {
        possibleValues = ClientSearch_default.get(key, _) || [];
      } else {
        possibleValues = _get5(obj, key);
      }
      if (possibleValues === void 0) {
        return [];
      }
      if (Array.isArray(possibleValues) && possibleValues.length > MAX_UNFURL_LENGTH) {
        possibleValues = possibleValues.slice(0, MAX_UNFURL_LENGTH);
      } else if (!Array.isArray(possibleValues)) {
        possibleValues = [possibleValues];
      }
      possibleValues = possibleValues.map((obj2) => {
        return convertParameterToOption(_, obj2, argument);
      });
      return possibleValues;
    };
    actionsForRecord = (recordKey, availableCommands2) => {
      return availableCommands2.filter((commandOption) => {
        return !!isRecordAction(commandOption.command, recordKey);
      });
    };
    _isResourceAvailableForCommand = (resource, command) => {
      const arg = Object.keys(command.command.arguments).find(
        (arg2) => command.command.arguments[arg2].type === "context" && command.command.arguments[arg2].value === resource.category.contextKey
      );
      return !!arg;
    };
    getContextKeyValue = (key, _) => {
      let retVal;
      if (ClientSearch_default.isDefined(key, _)) {
        retVal = ClientSearch_default.get(key, _);
      } else {
        const context = _.context;
        if (context.hasOwnProperty(key)) {
          retVal = context[key];
        }
      }
      return Array.isArray(retVal) ? retVal : void 0;
    };
    availableRecords = (_, availableCommands2) => {
      if (!_.organization) {
        return [];
      }
      const contextSettings = getContextSettings(_);
      const recordKeys = Object.keys(contextSettings).filter((k) => {
        return contextSettings[k].search && !!getContextKeyValue(k, _);
      });
      recordKeys.sort(
        (a, b) => compareObjs(
          { sort_key: contextSettings[a].sort_key || 0, id: 0 },
          { sort_key: contextSettings[b].sort_key || 0, id: 0 }
        )
      );
      const toRet = [];
      recordKeys.forEach((k) => {
        const commands = actionsForRecord(k, availableCommands2);
        const searchOptions = contextSettings[k];
        const unfurl = !!searchOptions.unfurl;
        const track_recents = searchOptions.track_recents === void 0 || searchOptions.track_recents;
        if (commands.length === 0) {
          return;
        }
        getContextKeyValue(k, _).forEach((r) => {
          if (!k)
            return;
          const label = getContextObjectLabel(contextSettings, r, k);
          const resource = initRecordOption(_, r, label, k, searchOptions, commands);
          if (!unfurl) {
            toRet.push(resource);
            return;
          }
          const commandsToUnfurl = commands.filter((command) => _isResourceAvailableForCommand(resource, command));
          commandsToUnfurl.forEach((c) => {
            toRet.push(initUnfurledCommandOption(_, c.command, c, resource));
          });
        });
        if (track_recents && _.spotlight.inputText.length === 0 && k && _.endUserStore.data.recents && _.endUserStore.data.recents.length > 0 && !!_.callbacks[`commandbar-search-${k}`]) {
          for (const recentRecord of _.endUserStore.data.recents) {
            if (recentRecord.type === "record" && recentRecord.categoryKey === k) {
              const r = recentRecord.record;
              const label = getContextObjectLabel(contextSettings, r, k);
              const resource = initRecordOption(_, r, label, k, searchOptions, commands);
              const thisRecordOptionUID = getOptionUID(resource);
              const isAlreadyAvailable = toRet.some((o) => getOptionUID(o) === thisRecordOptionUID);
              if (!isAlreadyAvailable && thisRecordOptionUID) {
                toRet.push(resource);
              }
            }
          }
        }
      });
      return toRet;
    };
    availableCommands = (_) => {
      return getCommands(_).filter((command) => {
        if (_.testMode) {
          return true;
        }
        return !["admin"].includes(command.template.type) && command.is_live;
      }).map((command) => {
        return initCommandOption(_, command);
      }).filter((commandOption) => {
        if (_.testMode) {
          return true;
        }
        return !commandOption.optionDisabled.isDisabled || commandOption.optionDisabled.reasonIsUserDefined;
      });
    };
    available = (_) => {
      var _a2;
      const { currentStep } = currentStepAndIndex(_);
      if (currentStep === void 0) {
        return [];
      }
      if (currentStep.type === "base" /* Base */) {
        if (currentStep.resource !== null) {
          const recordActions = actionsForRecord(currentStep.resource.category.contextKey, availableCommands(_));
          return recordActions.filter((c) => _isResourceAvailableForCommand(currentStep.resource, c));
        } else {
          const commands = availableCommands(_).sort((a, b) => compareObjs(a.command, b.command));
          const recordOptions = availableRecords(_, commands);
          return [...commands, ...recordOptions];
        }
      }
      if (isSelectStep(currentStep)) {
        if (!currentStep.argument || !currentStep.argument.type) {
          return [];
        }
        const argument = currentStep.argument;
        switch (currentStep.argument.type) {
          case "context":
            if (!!Object.keys(_.callbacks).find(
              (callbackKey) => callbackKey === `commandbar-initialvalue-${currentStep.argument.value}`
            )) {
              return [];
            }
            const context = _.context;
            const options = _optionsFromKey(_, context, currentStep.argument.value, argument);
            return options;
          case "provided":
            switch (currentStep.argument.value) {
              case "time":
                return [];
              case "text":
                return [];
              default:
                return [];
            }
          case "set":
            const set3 = currentStep.argument.value;
            if (Array.isArray(set3)) {
              return set3.slice(0, MAX_UNFURL_LENGTH).map((obj) => {
                return convertParameterToOption(_, obj, currentStep.argument);
              });
            } else {
              throw new Error(`Set for ${currentStep.argument.userDefinedName} must be an array.`);
            }
          case "video":
            return [];
          case "html":
            return [];
        }
      }
      if (currentStep.type === "longtextinput" /* LongTextInput */ || currentStep.type === "dashboard" /* Dashboard */)
        return [];
      if (currentStep.type === "textinput" /* TextInput */) {
        const textString = currentStep.argument.userDefinedName;
        const textValue = ((_a2 = currentStep.selected) == null ? void 0 : _a2.data) || "";
        const textOption = initParameterOption(_, textString, textValue);
        return [textOption];
      }
      throw new Error("Trying to calculate availability on invalid step.");
    };
    Available = {
      available
    };
    Available_default = Available;
  }
});

// commandbar/src/shared/util/featureFlags.ts
function featureFlag({ organization, orgIds, activeState, defaultState }) {
  if (!!organization && orgIds.includes(organization.id.toString())) {
    return activeState;
  }
  return defaultState;
}
var featureFlags_default;
var init_featureFlags = __esm({
  "commandbar/src/shared/util/featureFlags.ts"() {
    "use strict";
    featureFlags_default = featureFlag;
  }
});

// commandbar/src/products/spotlight/store/steps/actions.ts
import get9 from "lodash/get";
var submitLongTextInput, submitMultiSelect, submitDashboardStep, preSelectIfApplicable, runExecuteStepActionWithSideEffects;
var init_actions7 = __esm({
  "commandbar/src/products/spotlight/store/steps/actions.ts"() {
    "use strict";
    init_Step();
    init_helpers5();
    init_selectors3();
    init_Interpolate();
    init_ParameterOption();
    init_actions9();
    init_selectors8();
    init_command();
    init_Reporting();
    init_Confetti();
    init_featureFlags();
    init_actions4();
    init_global_actions();
    init_service_actions3();
    init_service_actions2();
    submitLongTextInput = (_, text) => {
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) === "longtextinput" /* LongTextInput */) {
        const option = initParameterOption(_, currentStep.argument.userDefinedName, text);
        selectOption(_, option);
      }
    };
    submitMultiSelect = (_) => {
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) === "multiselect" /* MultiSelect */) {
        fulfillAndRebase(_);
        if (_.spotlight.inputText) {
          _.spotlight.previousInputText = _.spotlight.inputText;
        }
        _.spotlight.inputText = "";
        _.spotlight.rawInput = "";
      }
    };
    submitDashboardStep = (_) => {
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) === "dashboard" /* Dashboard */) {
        const option = initParameterOption(
          _,
          currentStep.argument.userDefinedName,
          _.spotlight.inputText
        );
        selectOption(_, option);
      }
    };
    preSelectIfApplicable = (_, s, activeRecord) => {
      const arg = s.argument;
      if (arg.preselected_key === void 0)
        return s;
      if (typeof arg.preselected_key !== "string")
        return s;
      let preSelected;
      const preselected_key = arg.preselected_key;
      if (!preselected_key.startsWith("{{")) {
        preSelected = get9(_.context, arg.preselected_key);
      } else {
        preSelected = interpolate(preselected_key, _, true, true, void 0, activeRecord);
      }
      if ((preSelected === void 0 || preSelected === null) && !!preselected_key) {
        preSelected = preselected_key;
      }
      if (!preSelected) {
        return s;
      }
      if (s.type === "multiselect" /* MultiSelect */) {
        const _preSelected = Array.isArray(preSelected) ? preSelected : [preSelected];
        let newStep = s;
        _preSelected.forEach((value) => {
          const _parameterOption = convertParameterToOption(_, value, arg);
          newStep = selectStep(newStep, _parameterOption);
        });
        return newStep;
      } else {
        if (Array.isArray(preSelected))
          return s;
        const _parameterOption = convertParameterToOption(_, preSelected, arg);
        return selectStep(s, _parameterOption);
      }
    };
    runExecuteStepActionWithSideEffects = (_, s) => {
      var _a2;
      const argSelections = getArgumentSelections(_);
      const executable = commandExecutableWithFullArgumentSelections(
        _,
        s.command,
        argSelections,
        s == null ? void 0 : s.alternateBehavior
      );
      const inputToLog = s.triggeredByShortcut ? _.spotlight.inputText : _.spotlight.inputText || _.spotlight.previousInputText;
      const meta = {
        ...s.triggeredByShortcut && { shortcut: true },
        customShortcut: _.endUserStore.data.hotkeys[commandUID(s.command)],
        ranking: _.spotlight.sortedOptions.findIndex((o) => {
          const c = o;
          return (c == null ? void 0 : c.command) ? commandUID(c.command) === commandUID(s.command) : false;
        }),
        previousCommands: _.spotlight.executionHistory
      };
      storeRecentsOnExecute(_, s);
      const metaWithSelections = { ...meta, selections: argSelections };
      const metaToReport = featureFlags_default({
        organization: _.organization,
        orgIds: ["5725a2a3"],
        activeState: metaWithSelections,
        defaultState: meta
      });
      execution(
        s.command,
        inputToLog,
        {
          ...metaToReport,
          categoryText: (_a2 = _.spotlight.categories.find((c) => c.id === s.command.category)) == null ? void 0 : _a2.name
        },
        s.eventSource
      );
      _.spotlight.executionHistory.unshift(commandUID(s.command));
      sendIndirectTrigger(
        _,
        {
          type: "on_command_execution",
          meta: { command: commandUID(s.command) }
        },
        {
          // Trigger commands directly trigger nudges and should work when the admin is logged in
          admin: s.command.template.type === "trigger"
        }
      );
      triggerChecklists(_, {
        type: "on_command_execution",
        meta: { command: commandUID(s.command) }
      });
      if (!!s.command.celebrate) {
        releaseConfetti(s.command.celebrate);
      }
      setTimeout(() => {
        executable();
      }, 5);
    };
  }
});

// commandbar/src/products/spotlight/store/steps/step-utils/ExecuteStep.tsx
var initExecuteStep;
var init_ExecuteStep = __esm({
  "commandbar/src/products/spotlight/store/steps/step-utils/ExecuteStep.tsx"() {
    "use strict";
    init_Step();
    initExecuteStep = (command, triggeredByShortcut, executionEventSource, alternateBehavior) => {
      const s = initStep("execute" /* Execute */);
      s.command = command;
      s.selected = null;
      s.triggeredByShortcut = triggeredByShortcut;
      s.eventSource = executionEventSource;
      s.alternateBehavior = alternateBehavior;
      return s;
    };
  }
});

// commandbar/src/products/spotlight/store/options/actions.ts
var chooseOption, chooseRecordOption, chooseParameterOption, chooseCommandOption;
var init_actions8 = __esm({
  "commandbar/src/products/spotlight/store/options/actions.ts"() {
    "use strict";
    init_helpers8();
    init_actions9();
    init_selectors3();
    init_operatingSystem();
    init_assertNever();
    init_BaseStep();
    init_selectors8();
    init_Step();
    init_SelectStep();
    init_MultiSelectStep();
    init_DashboardStep();
    init_ParameterOption();
    init_ExecuteStep();
    init_TextInputStep();
    init_LongTextInputStep();
    chooseOption = (_, o, _updateSteps, executionEventSource, triggeredByShortcut, event) => {
      const updater = _updateSteps != null ? _updateSteps : updateSteps.bind(null, _);
      if (isRecordOption(o)) {
        const recordOption = chooseRecordOption(_, o, updater);
        const defaultCommand = getDefaultCommandForCurrentStep(_);
        if (defaultCommand && !(event == null ? void 0 : event.shiftKey)) {
          const updateSteps2 = updateSteps.bind(null, _);
          chooseOption(_, defaultCommand, updateSteps2, executionEventSource, void 0, event);
        }
        return recordOption;
      } else if (isCommandOption(o) || isUnfurledCommandOption(o)) {
        return chooseCommandOption(_, o, triggeredByShortcut, updater, executionEventSource, {
          openLinkInNewTab: !!event && getTriggerKey(event)
        });
      } else if (isParameterOption(o)) {
        return chooseParameterOption(_, o, updater);
      }
      return assertNever(o);
    };
    chooseRecordOption = (_, o, updateSteps2) => {
      const newStep = initBaseStep(o);
      const steps = [..._.spotlight.steps, newStep];
      updateSteps2(steps);
      return;
    };
    chooseParameterOption = (_, o, updateSteps2) => {
      const { currentStep, currentStepIndex } = currentStepAndIndex(_);
      if (currentStep === void 0) {
        throw new Error("Invalid parameter step");
      }
      switch (currentStep.type) {
        case "dashboard" /* Dashboard */:
        case "select" /* Select */:
        case "textinput" /* TextInput */:
        case "longtextinput" /* LongTextInput */: {
          const steps = _.spotlight.steps.map((step, index3) => {
            if (currentStepIndex === index3) {
              return selectStep(step, o);
            }
            return step;
          });
          updateSteps2(steps);
          return;
        }
        case "multiselect" /* MultiSelect */: {
          const steps = _.spotlight.steps.map((step, index3) => {
            if (currentStepIndex === index3) {
              return selectStep(step, o);
            }
            return step;
          });
          updateSteps2(steps, false);
          return;
        }
        default:
          throw new Error("Unknown parameter step");
      }
    };
    chooseCommandOption = (_, option, triggeredByShortcut, updateSteps2, executionEventSource, alternateBehavior) => {
      const { currentStepIndex } = currentStepAndIndex(_);
      const { currentStep } = currentStepAndIndex(_);
      const activeRecord = (() => {
        if ((currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && !!currentStep.resource)
          return currentStep.resource;
        if (isUnfurledCommandOption(option))
          return option.resource;
        return null;
      })();
      const sortedArgs = getSortedArgs(option);
      const argSteps = sortedArgs.map((arg) => {
        switch (arg.type) {
          case "set":
          case "context":
            if (arg.input_type === "multi-select") {
              return initMultiSelectStep(arg);
            } else {
              return initSelectStep(arg);
            }
          case "provided":
            if (arg.value === "time")
              return initSelectStep(arg);
            if (arg.value === "text") {
              if (arg.input_type === "longtext")
                return initLongTextInputStep(arg);
              else
                return initTextInputStep(arg);
            }
            throw new Error(`Invalid provided arg type`);
          case "video":
          case "html":
            return initDashboardStep(arg, option.command);
          default:
            throw new Error("Invalid arg type");
        }
      }).map((step) => {
        let newStep = step;
        if (newStep.type === "select" /* Select */ || newStep.type === "multiselect" /* MultiSelect */ || newStep.type === "longtextinput" /* LongTextInput */ || newStep.type === "textinput" /* TextInput */) {
          newStep = preSelectIfApplicable(_, newStep, activeRecord != null ? activeRecord : void 0);
        }
        if (activeRecord) {
          if (step.type === "select" /* Select */ || step.type === "multiselect" /* MultiSelect */ || step.type === "longtextinput" /* LongTextInput */ || step.type === "textinput" /* TextInput */) {
            if (step.argument !== void 0 && step.argument.type === "context") {
              if (step.argument.value === activeRecord.category.contextKey) {
                const _parameterOption = initParameterOption(
                  _,
                  activeRecord.label,
                  activeRecord.parameter,
                  void 0,
                  activeRecord.detailPreview
                );
                newStep = selectStep(step, _parameterOption);
                newStep.completed = true;
              }
            }
          }
        }
        return newStep;
      });
      const updatedSteps = _.spotlight.steps.map((step, index3) => {
        if (currentStepIndex === index3) {
          return selectStep(step, option);
        }
        return step;
      });
      const steps = [
        ...updatedSteps,
        ...argSteps,
        initExecuteStep(
          option.command,
          triggeredByShortcut || false,
          executionEventSource || { type: "bar" },
          alternateBehavior
        )
      ];
      if (updateSteps2)
        updateSteps2(steps);
    };
  }
});

// commandbar/src/products/spotlight/store/actions.ts
import isEqual11 from "lodash/isEqual";
import { ref as ref10 } from "valtio";
var completeStep, completeNextStepAndSubsequentExecuteSteps, rebase, fulfillAndRebase, updateSteps, handleInputChange, reportDeadendIfBackspaced, reportDeadendIfClosed, reportKeystroke, reset, resetFocusedIndex, rollback, setLogo, setVisible, toggleGroupExpansion, changeGroupExpanded, setInputText2, toggleTestMode, setPlaceholders, clearInput, closeBarAndReset, handleKeyDown, openBarWithOptionalText, setSearchFilter, selectCurrentOption, selectOption, setDashboard, setLoading, toggleBar, toggleBarFromLauncher, resetChildFocus, changeFocus, focusOutOfList, maintainChildFocus, tryChildFocus, changeFocusWithTab, setCategories, addCategory, setCategoryConfig;
var init_actions9 = __esm({
  "commandbar/src/products/spotlight/store/actions.ts"() {
    "use strict";
    init_Available();
    init_selectors8();
    init_actions7();
    init_Reporting();
    init_selectors3();
    init_BaseStep();
    init_Step();
    init_helpers4();
    init_selectors3();
    init_OptionGroup();
    init_a11y();
    init_commandCategory();
    init_SearchTabs();
    init_slugify();
    init_placeholderHelpers();
    init_location();
    init_actions8();
    init_track();
    init_actions7();
    init_actions3();
    init_actions8();
    completeStep = (_, step) => {
      if (step.type === "execute") {
        runExecuteStepActionWithSideEffects(_, step);
      }
      step.completed = true;
    };
    completeNextStepAndSubsequentExecuteSteps = (_) => {
      const firstIncompleteIndex = _.spotlight.steps.findIndex((step) => !step.completed);
      if (firstIncompleteIndex !== -1) {
        completeStep(_, _.spotlight.steps[firstIncompleteIndex]);
        for (let i2 = firstIncompleteIndex + 1; i2 < _.spotlight.steps.length; i2++) {
          const thisStep = _.spotlight.steps[i2];
          if (!thisStep.completed) {
            if (thisStep.type === "execute") {
              completeStep(_, thisStep);
            } else {
              break;
            }
          } else {
          }
        }
      }
      return _;
    };
    rebase = (_) => {
      const { currentStep } = currentStepAndIndex(_);
      if (currentStep === void 0) {
        if (!isStudioPreview()) {
          _.spotlight.visible = false;
        }
        _.spotlight.steps = [initBaseStep(null)];
        _.spotlight.initialOptions = ref10(Available_default.available(_));
      } else {
        _.spotlight.visible = true;
        _.spotlight.initialOptions = ref10(Available_default.available(_));
      }
    };
    fulfillAndRebase = (_) => {
      rebase(completeNextStepAndSubsequentExecuteSteps(_));
    };
    updateSteps = (_, updatedSteps, useFulfill = true) => {
      _.spotlight.steps = updatedSteps;
      if (useFulfill) {
        rebase(completeNextStepAndSubsequentExecuteSteps(_));
      }
    };
    handleInputChange = (_, newInput, event) => {
      var _a2;
      if ((event == null ? void 0 : event.action) === "input-blur" || (event == null ? void 0 : event.action) === "menu-close") {
        return;
      }
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) === "multiselect" /* MultiSelect */ && (event == null ? void 0 : event.action) === "set-value") {
        return;
      }
      reportDeadendIfClosed(_, newInput, event);
      reportDeadendIfBackspaced(_, newInput);
      _.spotlight.reportKeystrokeDebouncer(() => reportKeystroke(_, newInput));
      _.spotlight.rawInput = newInput;
      let cleaninput = newInput;
      if (!!((_a2 = _.organization) == null ? void 0 : _a2.slash_filters_enabled) && (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */) {
        const inputParts = extractSlashFilter(newInput);
        cleaninput = inputParts.inputText;
      }
      if (_.spotlight.inputText) {
        _.spotlight.previousInputText = _.spotlight.inputText;
      }
      _.spotlight.inputText = cleaninput.trim();
      if (!_.spotlight.visible && newInput !== "") {
        setVisible(_, true);
      }
    };
    reportDeadendIfBackspaced = (_, newInput) => {
      if (newInput.length === 0 && _.spotlight.isBackspacing && _.spotlight.cachedInput.length > 0) {
        deadend(_.spotlight.cachedInput, "Backspaced", _);
        _.spotlight.cachedInput = "";
      }
    };
    reportDeadendIfClosed = (_, newInput, event) => {
      const didInputClear = newInput.length === 0 && _.spotlight.inputText.length > 0;
      const didMenuClose = (event == null ? void 0 : event.action) === "menu-close";
      if (didInputClear && didMenuClose) {
        deadend(_.spotlight.inputText, "Resetting search", _);
      }
    };
    reportKeystroke = (_, newInput) => {
      searchInputChange(newInput, _);
      Track.spotlight.searchInput(newInput);
    };
    reset = (_) => {
      _.spotlight.steps = [initBaseStep(null)];
      _.spotlight.initialOptions = ref10(Available_default.available(_));
    };
    resetFocusedIndex = (_) => {
      _.spotlight.focusedIndex = findDefaultFocusOptionIndex(_);
      _.spotlight.focusableChildIndex = -1;
    };
    rollback = (_) => {
      var _a2;
      const { currentStep, currentStepIndex } = currentStepAndIndex(_);
      if (currentStep === void 0) {
        rebase(_);
        return;
      }
      let steps = _.spotlight.steps.map((step, index3) => {
        if (index3 === currentStepIndex) {
          step.selected = null;
          return step;
        }
        if (index3 === currentStepIndex - 1) {
          if (step.type === "longtextinput" /* LongTextInput */) {
            step.completed = false;
            return step;
          } else {
            if (step.type === "select" /* Select */) {
              step.argument.auto_choose = false;
            }
            step.completed = false;
            step.selected = null;
            return step;
          }
        }
        return step;
      });
      if (((_a2 = steps[currentStepIndex - 1]) == null ? void 0 : _a2.type) === "base" /* Base */) {
        steps = [initBaseStep(null)];
      }
      _.spotlight.steps = steps;
      rebase(_);
    };
    setLogo = (_, logo) => {
      _.logo = logo != null ? logo : "";
    };
    setVisible = (_, value) => {
      if (value) {
        if (_.spotlight.visible === false)
          _.spotlight.previousInputText = "";
        _.spotlight.visible = true;
      } else {
        _.spotlight.visible = false;
        _.spotlight.steps = [initBaseStep(null)];
      }
    };
    toggleGroupExpansion = (_, header) => {
      const expanded = _.spotlight.expandedGroupKeys;
      const index3 = expanded.findIndex((_header) => _header === header);
      if (index3 > -1) {
        expanded.splice(index3, 1);
      } else {
        expanded.push(header);
      }
    };
    changeGroupExpanded = (_, header, isExpanded2) => {
      const expanded = _.spotlight.expandedGroupKeys;
      const index3 = expanded.findIndex((_header) => _header === header);
      if (isExpanded2) {
        if (index3 === -1) {
          expanded.push(header);
        }
      } else {
        if (index3 > -1) {
          expanded.splice(index3, 1);
        }
      }
    };
    setInputText2 = (_, value) => {
      if (_.spotlight.inputText) {
        _.spotlight.previousInputText = _.spotlight.inputText;
      }
      _.spotlight.inputText = value;
    };
    toggleTestMode = (_) => {
      _.testMode = !_.testMode;
    };
    setPlaceholders = (_, placeholders) => {
      const hasChanged = !isEqual11(_.spotlight.placeholders, placeholders);
      if (hasChanged) {
        _.spotlight.placeholders = placeholders;
      }
    };
    clearInput = (_) => {
      var _a2, _b2;
      if (_.spotlight.inputText) {
        _.spotlight.previousInputText = _.spotlight.inputText;
      }
      _.spotlight.inputText = "";
      _.spotlight.rawInput = "";
      (_b2 = (_a2 = _.spotlight.refContainer) == null ? void 0 : _a2.current) == null ? void 0 : _b2.focus();
    };
    closeBarAndReset = (_) => {
      var _a2, _b2;
      endSearch(_.spotlight.inputText, _);
      Track.spotlight.closed(_.spotlight.inputText);
      if (((_b2 = (_a2 = _.spotlight.dashboard) == null ? void 0 : _a2.type) == null ? void 0 : _b2.name) === "SubmissionForm") {
        setDashboard(_, void 0);
        return;
      }
      setVisible(_, false);
      setDashboard(_, void 0);
      _.spotlight.searchFilter = void 0;
      resetFocusedIndex(_);
      setTimeout(() => {
        _.spotlight.previousInputText = "";
        _.spotlight.inputText = "";
        _.spotlight.rawInput = "";
      }, 100);
    };
    handleKeyDown = (_, e) => {
      if (e.key === "Backspace") {
        if (!_.spotlight.isBackspacing) {
          _.spotlight.isBackspacing = true;
          _.spotlight.cachedInput = _.spotlight.inputText;
        }
      } else {
        if (_.spotlight.isBackspacing)
          _.spotlight.isBackspacing = false;
        if (_.spotlight.cachedInput)
          _.spotlight.cachedInput = "";
      }
    };
    openBarWithOptionalText = (_, trigger, meta) => {
      var _a2;
      if (!_.products.includes("spotlight")) {
        return;
      }
      setDashboard(_, void 0);
      setVisible(_, true);
      resetFocusedIndex(_);
      if (meta == null ? void 0 : meta.startingInput) {
        handleInputChange(_, meta.startingInput);
      }
      if (meta == null ? void 0 : meta.categoryFilterID) {
        let groupToFilter = void 0;
        if (typeof meta.categoryFilterID === "number") {
          const categoryToFilter = _.spotlight.categories.find((cat) => cat.id === meta.categoryFilterID);
          if (categoryToFilter) {
            groupToFilter = initOptionGroupFromCommandCategory(categoryToFilter, _);
          }
        } else if (typeof meta.categoryFilterID === "string") {
          const recordGroups = Object.entries(getContextSettings(_)).map(([k, v]) => {
            const group = initOptionGroupFromRecordCategory(k, _, v);
            if (!!!group.slash_filter_keyword) {
              group.slash_filter_keyword = slugify_default(group.name);
            }
            return group;
          });
          const allGroups = [..._.spotlight.currentGroups, ...recordGroups];
          groupToFilter = allGroups.find((group) => meta.categoryFilterID === group.slash_filter_keyword);
          if (!groupToFilter) {
            groupToFilter = allGroups.find((group) => {
              return meta.categoryFilterID === group.name;
            });
          }
        }
        if (!!groupToFilter) {
          const filter = createSearchFilter(groupToFilter);
          setSearchFilter(_, filter);
        }
      }
      startSearch(
        trigger,
        _.spotlight.placeholders.length > 0 ? (_a2 = _.spotlight.placeholders) == null ? void 0 : _a2[0].text : DEFAULT_PLACEHOLDER
      );
      Track.spotlight.opened({
        type: trigger
      });
    };
    setSearchFilter = (_, filter) => {
      if (!!filter) {
        _.spotlight.searchFilter = filter;
        changeGroupExpanded(_, _.spotlight.searchFilter.slug, true);
      } else {
        _.spotlight.searchFilter = void 0;
        _.spotlight.expandedGroupKeys = [];
      }
    };
    selectCurrentOption = (_, event) => {
      const currentOption = _.spotlight.sortedOptions[_.spotlight.focusedIndex];
      if (isOption(currentOption)) {
        const isFallback = currentOption.groupKey === fallbackGroup().key;
        selectOption(_, currentOption, isFallback, event);
      }
    };
    selectOption = (_, opt, preserveInputText, event) => {
      const { inputText } = _.spotlight;
      const { currentStep, currentStepIndex } = currentStepAndIndex(_);
      const { isDisabled } = opt.optionDisabled;
      if (!isDisabled) {
        _.spotlight.searchFilter = void 0;
        chooseOption(_, opt, void 0, void 0, false, event);
        Track.spotlight.searchResultClicked(opt, inputText);
        if ((currentStep == null ? void 0 : currentStep.type) !== "multiselect" /* MultiSelect */) {
          handleInputChange(_, "");
          const { steps } = _.spotlight;
          if (steps.length > 1 && currentStepIndex === 0 && preserveInputText) {
            handleInputChange(_, inputText);
          }
        }
      } else {
        _.spotlight.errorIndex = _.spotlight.focusedIndex;
        _.spotlight.errorTimestamp = Date.now();
      }
    };
    setDashboard = (_, v) => {
      _.spotlight.dashboard = v;
    };
    setLoading = (_, v, isLoading) => {
      _.spotlight.loadingByKey[v] = isLoading;
    };
    toggleBar = (_, trigger) => {
      if (_.active) {
        if (_.spotlight.visible) {
          closeBarAndReset(_);
          return false;
        } else {
          openBarWithOptionalText(_, trigger);
          return true;
        }
      }
      return false;
    };
    toggleBarFromLauncher = (_) => toggleBar(_, "launcher");
    resetChildFocus = (_) => {
      _.spotlight.focusableChildIndex = -1;
      const inputEl = document.getElementById(a11y_default.commandbarInputId);
      if (inputEl) {
        inputEl.focus();
      }
    };
    changeFocus = (_, direction) => {
      _.spotlight.focusedIndex = getNextFocusedIndex(_, direction);
      resetChildFocus(_);
    };
    focusOutOfList = (_) => {
      _.spotlight.focusedIndex = -1;
      _.spotlight.focusableChildIndex = -1;
    };
    maintainChildFocus = (_) => {
      const focusableChildren = getFocusableChildrenAtIndex(_.spotlight.focusedIndex);
      if (focusableChildren && _.spotlight.focusableChildIndex < focusableChildren.length) {
        const el = focusableChildren.item(_.spotlight.focusableChildIndex);
        if (el && el instanceof HTMLElement) {
          el.focus();
        }
      }
    };
    tryChildFocus = (_, direction) => {
      const focusableChildren = getFocusableChildrenAtIndex(_.spotlight.focusedIndex);
      if (!focusableChildren) {
        return false;
      }
      const hasNextChild = focusableChildren.length > _.spotlight.focusableChildIndex + 1;
      const hasPrevChild = _.spotlight.focusableChildIndex > 0;
      if (direction === "down" && hasNextChild) {
        _.spotlight.focusableChildIndex++;
      } else if (direction === "up" && hasPrevChild) {
        _.spotlight.focusableChildIndex--;
      } else {
        resetChildFocus(_);
        return false;
      }
      const el = focusableChildren.item(_.spotlight.focusableChildIndex);
      if (el && el instanceof HTMLElement) {
        el.focus();
        return true;
      }
      return false;
    };
    changeFocusWithTab = (_, direction) => {
      if (_.spotlight.sortedOptions.length === 0) {
        return true;
      }
      if (direction === "tab") {
        focusOutOfList(_);
        return true;
      }
      if (tryChildFocus(_, direction)) {
        return false;
      }
      const next_index = getNextFocusedIndex(_, direction, true);
      if (direction === "down") {
        if (next_index < _.spotlight.focusedIndex) {
          focusOutOfList(_);
          return true;
        }
      } else if (next_index > _.spotlight.focusedIndex) {
        focusOutOfList(_);
        return true;
      }
      _.spotlight.focusedIndex = next_index;
      tryChildFocus(_, "down");
      return false;
    };
    setCategories = (_, categories) => {
      _.spotlight.serverCategories = categories;
    };
    addCategory = (_, categoryName) => {
      const existingCategoryIdx = _.spotlight.localCategories.findIndex((category) => category.name === categoryName);
      if (existingCategoryIdx === -1) {
        const id2 = -(_.spotlight.localCategories.length + 1);
        _.spotlight.localCategories.push(
          CommandCategory.decode({
            id: id2,
            organization: "",
            name: categoryName,
            slash_filter_keyword: slugify_default(categoryName)
          })
        );
        return id2;
      }
      return _.spotlight.localCategories[existingCategoryIdx].id;
    };
    setCategoryConfig = (_, categoryId, config2) => {
      var _a2;
      (_a2 = _.spotlight.categoryConfig)[categoryId] || (_a2[categoryId] = {});
      _.spotlight.categoryConfig[categoryId] = { ..._.spotlight.categoryConfig[categoryId], ...config2 };
    };
  }
});

// commandbar/src/products/spotlight/service-actions.ts
var service_actions_exports2 = {};
__export(service_actions_exports2, {
  addCategory: () => addCategory,
  chooseCommandOption: () => chooseCommandOption,
  chooseOption: () => chooseOption,
  closeBarAndReset: () => closeBarAndReset,
  completeNextStepAndSubsequentExecuteSteps: () => completeNextStepAndSubsequentExecuteSteps,
  openBarWithOptionalText: () => openBarWithOptionalText,
  rebase: () => rebase,
  setCategories: () => setCategories,
  setCategoryConfig: () => setCategoryConfig,
  setDashboard: () => setDashboard,
  setLogo: () => setLogo,
  setPlaceholders: () => setPlaceholders,
  setVisible: () => setVisible,
  toggleBar: () => toggleBar,
  toggleBarFromLauncher: () => toggleBarFromLauncher,
  updateHotloadedHelpdocCommands: () => updateHotloadedHelpdocCommands,
  updateSteps: () => updateSteps
});
var init_service_actions4 = __esm({
  "commandbar/src/products/spotlight/service-actions.ts"() {
    "use strict";
    init_actions9();
  }
});

// internal/src/client/extension/preview.ts
var PREVIEW_ELEMENT_ID;
var init_preview = __esm({
  "internal/src/client/extension/preview.ts"() {
    "use strict";
    PREVIEW_ELEMENT_ID = "commandbar-extension-preview";
  }
});

// internal/src/client/extension/recorder.ts
var RECORDER_ELEMENT_ID;
var init_recorder = __esm({
  "internal/src/client/extension/recorder.ts"() {
    "use strict";
    RECORDER_ELEMENT_ID = "commandbar-extension-recorder";
  }
});

// commandbar/src/shared/store/global-actions.ts
var global_actions_exports = {};
__export(global_actions_exports, {
  activatePushExperience: () => activatePushExperience,
  addBuiltInCallbacks: () => addBuiltInCallbacks,
  addBuiltInEventSubscriptions: () => addBuiltInEventSubscriptions,
  addCallbacks: () => addCallbacks,
  addCommand: () => addCommand,
  addContext: () => addContext,
  addMockCommand: () => addMockCommand,
  clearEnvOverride: () => clearEnvOverride,
  clickExecutable: () => clickExecutable,
  commandExecutableWithFullArgumentSelections: () => commandExecutableWithFullArgumentSelections,
  executeAction: () => executeAction,
  executeCommand: () => executeCommand,
  helpDocExecutable: () => helpDocExecutable,
  linkExecutable: () => linkExecutable,
  openEditor: () => openEditor,
  removeCallback: () => removeCallback,
  removeCommand: () => removeCommand,
  removeContext: () => removeContext,
  removeMockCommand: () => removeMockCommand,
  setBaseTheme: () => setBaseTheme,
  setCommands: () => setCommands,
  setContext: () => setContext,
  setContextState: () => setContextState,
  setEnvOverride: () => setEnvOverride,
  setIsAdmin: () => setIsAdmin,
  setLocalContextSettings: () => setLocalContextSettings,
  setOrganization: () => setOrganization,
  setTabs: () => setTabs,
  setTestMode: () => setTestMode,
  setTheme: () => setTheme,
  setThemeMode: () => setThemeMode,
  trackEvent: () => trackEvent,
  tryOpenEditor: () => tryOpenEditor,
  updateLocalContextSetting: () => updateLocalContextSetting
});
import isEqual12 from "lodash/isEqual";
import merge3 from "lodash/merge";
var addCallbacks, addCommand, addMockCommand, removeMockCommand, addContext, executeCommand, removeCallback, removeCommand, removeContext, setBaseTheme, setTabs, setCommands, setContext, setContextState, setLocalContextSettings, updateLocalContextSetting, setIsAdmin, setTheme, setThemeMode, setOrganization, setTestMode, trackEvent, areDomainsSame, arePathsSame, activatePushExperience, addBuiltInCallbacks, addBuiltInEventSubscriptions, openEditor, tryOpenEditor, setEnvOverride, clearEnvOverride;
var init_global_actions = __esm({
  "commandbar/src/shared/store/global-actions.ts"() {
    "use strict";
    init_Analytics();
    init_LocalStorage();
    init_doNotTrack();
    init_service_actions4();
    init_service_selectors4();
    init_service_actions2();
    init_service_actions3();
    init_service_selectors2();
    init_Interpolate();
    init_service_selectors2();
    init_operatingSystem();
    init_globals();
    init_location();
    init_share_links();
    init_symbols();
    init_utils3();
    init_editorUtils();
    init_service_selectors2();
    init_service_selectors3();
    init_messages();
    init_preview();
    init_recorder();
    init_Logger();
    init_executable_actions();
    addCallbacks = (_, callbacks) => {
      const callbacksAfterAdd = { ..._.callbacks, ...callbacks };
      if (isEqual12(_.callbacks, callbacksAfterAdd))
        return;
      _.callbacks = callbacksAfterAdd;
    };
    addCommand = (_, command) => {
      _.programmaticCommands = _.programmaticCommands.filter(
        (c) => !(c.name === command.name && c.category === command.category)
      );
      _.programmaticCommands.push(command);
    };
    addMockCommand = (_, command) => {
      removeMockCommand(_, command);
      _.mockCommands.push(command);
    };
    removeMockCommand = (_, command) => {
      _.mockCommands = _.mockCommands.filter((c) => c.id !== command.id);
    };
    addContext = (_, context) => {
      doNotTrackContext(context);
      Object.assign(_.context, context);
    };
    executeCommand = (_, command, onSuccess, onFail, executionEventSource = { type: "bar" }, e, ignoreSpotlightAvailability) => {
      const pseudoState = {
        ..._,
        spotlight: { ..._.spotlight, steps: [initBaseStep(null)] }
      };
      const commandOption = initCommandOption(pseudoState, command);
      const { isDisabled, isDisabledReason } = commandOption.optionDisabled;
      if (!isDisabled || ignoreSpotlightAvailability && isDisabledReason === "Not available in Spotlight search") {
        chooseCommandOption(
          _,
          commandOption,
          true,
          updateSteps.bind(null, _),
          executionEventSource,
          {
            openLinkInNewTab: !!e && getTriggerKey(e)
          }
        );
        onSuccess && onSuccess();
      } else {
        onFail && onFail();
      }
      return isDisabled;
    };
    removeCallback = (_, toRemove) => {
      if (!(toRemove in _.callbacks))
        return;
      delete _.callbacks[toRemove];
    };
    removeCommand = (_, name) => {
      _.programmaticCommands = _.programmaticCommands.filter((c) => c.name !== name);
    };
    removeContext = (_, toRemove) => {
      delete _.context[toRemove];
      delete _.localContextSettings[toRemove];
    };
    setBaseTheme = (_, theme, themeSource, color) => {
      _.baseTheme = theme;
      _.themeSource = themeSource;
      _.primaryColor = color;
    };
    setTabs = (_, tabs) => {
      _.spotlight.tabs = tabs;
    };
    setCommands = (_, commands) => {
      _.commands = [...commands];
      _.commandsLoaded = true;
    };
    setContext = (_, context) => {
      if (isEqual12(_.context, context))
        return;
      doNotTrackContext(context);
      _.context = context;
    };
    setContextState = (_, callbacks, context, contextSettings) => {
      if (context)
        doNotTrackContext(context);
      const _contextAfterAdd = !!context ? { ..._.context, ...context } : _.context;
      const _callbacksAfterAdd = !!callbacks ? { ..._.callbacks, ...callbacks } : _.callbacks;
      if (isEqual12(_.context, _contextAfterAdd) && isEqual12(_.callbacks, _callbacksAfterAdd) && isEqual12(_.localContextSettings, contextSettings)) {
        return;
      }
      _.context = _contextAfterAdd;
      _.callbacks = _callbacksAfterAdd;
      if (contextSettings) {
        _.localContextSettings = merge3({}, _.localContextSettings, contextSettings);
      }
    };
    setLocalContextSettings = (_, key, settings) => {
      const requiredSettings = { search: false };
      _.localContextSettings[key] = { ...requiredSettings, ...settings };
    };
    updateLocalContextSetting = (_, key, setting, value) => {
      const currentSettings = _.localContextSettings[key] || {};
      _.localContextSettings[key] = { ...currentSettings, [setting]: value };
    };
    setIsAdmin = (_, value) => {
      if (value)
        Analytics_default.identifyAsAdmin();
      _.isAdmin = value;
    };
    setTheme = (_, theme) => {
      _.theme = theme;
    };
    setThemeMode = (_, mode) => {
      if (["light_mode", "dark_mode", "auto"].includes(mode))
        _.themeV2Mode = mode;
    };
    setOrganization = (_, organization, themeSource) => {
      var _a2;
      _.organization = organization;
      _.logo = (_a2 = organization.icon) != null ? _a2 : "";
      _.themeSource = themeSource;
      _.serverContextSettings = organization.resource_options;
    };
    setTestMode = (_, value) => {
      if (value) {
        LocalStorage_default.set("testMode", "1");
      } else {
        LocalStorage_default.remove("testMode");
      }
      _.testMode = value;
    };
    trackEvent = (_, key, type39, properties = {}) => {
      if (type39 === "commandbar" && !key.startsWith("commandbar-")) {
        key = `commandbar-${key}`;
      }
      if (type39 === "app") {
        _.trackedAppEvents.add(key);
      }
      sendIndirectTrigger(
        _,
        { type: "on_event", meta: { event: key, condition_group: void 0 } },
        void 0,
        properties
      );
      triggerChecklists(
        _,
        { type: "on_event", meta: { event: key, condition_group: void 0 } },
        properties
      );
      updateChecklistItemEventGoals(_, key, properties);
    };
    areDomainsSame = (startPageURL, currentURL) => {
      return startPageURL.hostname.replace(/^www\./, "") === currentURL.hostname.replace(/^www\./, "");
    };
    arePathsSame = (startPageURL, currentURL) => {
      if (startPageURL.hash) {
        return startPageURL.pathname + startPageURL.hash === currentURL.pathname + currentURL.hash;
      }
      return startPageURL.pathname === currentURL.pathname;
    };
    activatePushExperience = (_, experience, type39, source) => {
      var _a2;
      if (isStudioPreview()) {
        if (type39 === "nudge") {
          _.callbacks["__standalone-editor-cb_nudge_triggered"](experience.steps[0].title);
        } else {
          _.callbacks["__standalone-editor-cb_questlist_triggered"](experience.title);
        }
        return;
      }
      const paramValue = `${getShareLinkType(type39)}t${experience.id}`;
      const currentURL = new URL(_.location.href);
      let interpolatedSharePageUrlOrPath = "";
      try {
        interpolatedSharePageUrlOrPath = interpolate(experience.share_page_url_or_path, _, true, false, true);
      } catch (error3) {
        Logger_default.warn("Failed to interpolate share page URL or path", error3);
        return;
      }
      const startPageURL = getAbsoluteSharePageUrl(currentURL, interpolatedSharePageUrlOrPath);
      const shouldRedirectToStartPage = () => {
        if (!startPageURL) {
          return false;
        }
        if (!interpolatedSharePageUrlOrPath.startsWith("/")) {
          if (!areDomainsSame(startPageURL, currentURL)) {
            return true;
          }
        }
        if (arePathsSame(startPageURL, currentURL)) {
          return false;
        }
        if (!urlMatchesTargeting(startPageURL.toString(), experience.show_expression)) {
          return false;
        }
        if (["nudge", "n"].includes(type39)) {
          const nudge = experience;
          const showExpressionPasses = passesPageConditions(_, nudge);
          const anchorFound = passesPinnedElement(nudge, 0);
          return !showExpressionPasses || !anchorFound;
        } else {
          return !checklistPassesPageConditions(_, experience);
        }
      };
      if (!startPageURL || !shouldRedirectToStartPage()) {
        if (["nudge", "n"].includes(type39)) {
          const nudge = experience;
          const servicesInRenderLoop = getRenderingServices(_);
          let isNudgeCurrentlyRendering = false;
          for (const service of servicesInRenderLoop) {
            const currentNudge = (_a2 = service.getSnapshot()) == null ? void 0 : _a2.context.nudge;
            const currentNudgeId = currentNudge == null ? void 0 : currentNudge.id;
            if (currentNudgeId === nudge.id) {
              isNudgeCurrentlyRendering = true;
              break;
            }
            if (!isTooltipNudge(currentNudge)) {
              service.send("CLOSE");
            }
          }
          if (!isNudgeCurrentlyRendering) {
            forceTriggerSingleNudge(_, nudge, { maxRenderedNudges: true }, source);
          }
          forceTriggerSingleNudge(
            _,
            nudge,
            {
              // allow admins to trigger draft nudges
              status: _.isAdmin,
              // allow admins to trigger nudge outside simulate mode
              admin: true,
              // don't check audience conditions
              audience: true,
              // don't check frequency
              frequency: true,
              // don't check that conditions have changed since last trigger
              flip: true,
              // don't check global limit
              globalLimit: true,
              // always start tours at first step even if they've been seen before
              stepIndex: 0,
              maxRenderedNudges: true
            },
            source
          );
        } else {
          forceTriggerChecklist(_, experience);
        }
      } else {
        startPageURL.searchParams.set("cb-eid", paramValue);
        const relativeUrl = startPageURL.pathname + startPageURL.search + startPageURL.hash;
        if (!interpolatedSharePageUrlOrPath.startsWith("/")) {
          if (!areDomainsSame(startPageURL, currentURL)) {
            window.open(startPageURL.toString(), "_blank");
            return;
          }
        }
        const routerFunc = _.callbacks["commandbar-router"];
        if (routerFunc) {
          routerFunc(relativeUrl);
        } else {
          window.location.href = relativeUrl;
        }
      }
    };
    addBuiltInCallbacks = (_) => {
      addCallbacks(_, {
        "commandbar-builtin-shortcuts": () => _.spotlight.showKeyboardShortcutCheatsheet = !_.spotlight.showKeyboardShortcutCheatsheet,
        "commandbar-noop": function(args) {
          alert(`This is a demo command!

You entered:

${JSON.stringify(args, null, 2)}`);
        }
      });
    };
    addBuiltInEventSubscriptions = (_) => {
      var _a2;
      const sdk = getSDK();
      if (!!sdk[_eventSubscriptions] && sdk[_eventSubscriptions] !== void 0) {
        const symbol = Symbol("commandbar-event-tracker");
        (_a2 = sdk[_eventSubscriptions]) == null ? void 0 : _a2.set(symbol, [
          (name, data) => {
            trackEvent(_, name, "commandbar", data);
          },
          void 0
        ]);
      }
    };
    openEditor = (_) => {
      var _a2, _b2;
      if (_.extension.preview.enabled || _.extension.recorder.enabled) {
        _.extension.preview = { enabled: false };
        _.extension.recorder = { enabled: false };
        (_a2 = document.getElementById(PREVIEW_ELEMENT_ID)) == null ? void 0 : _a2.remove();
        (_b2 = document.getElementById(RECORDER_ELEMENT_ID)) == null ? void 0 : _b2.remove();
        ShareExtensionStatusMessage.sendToPage({ preview: false, recorder: false });
      }
      if (checkForEditor()) {
        clickEditorHandle();
        setVisible(_, false);
        return;
      }
      const interval = setInterval(() => {
        const foundEditor = checkForEditor();
        if (!!foundEditor) {
          clearInterval(interval);
          setTimeout(() => {
            if (!isEditorOpen()) {
              clickEditorHandle();
            }
            setDashboard(_, void 0);
            setVisible(_, false);
          }, 500);
        }
      }, 500);
      setDashboard(_, "editor-loading");
      const MAX_WAIT_TIME = 6e3;
      setTimeout(() => {
        if (!checkForEditor()) {
          clearInterval(interval);
          setDashboard(_, "editor-timeout");
        }
      }, MAX_WAIT_TIME);
      getSDK()[_loadEditor]();
    };
    tryOpenEditor = (_) => {
      if (isEditorBeingSummoned(_.spotlight.inputText)) {
        openEditor(_);
        return true;
      }
      return false;
    };
    setEnvOverride = (_, envOverride) => {
      LocalStorage_default.set("envOverride", JSON.stringify(envOverride));
      _.envOverride = envOverride;
    };
    clearEnvOverride = (_) => {
      LocalStorage_default.remove("envOverride");
      _.envOverride = null;
    };
  }
});

// types/src/flags.ts
var defaultFlags;
var init_flags = __esm({
  "types/src/flags.ts"() {
    "use strict";
    defaultFlags = {
      "release-search-experiences-in-help-hub": false,
      "release-search-experiences-in-spotlight": false,
      "support-ruby-on-rails": false,
      "release-themes-v2": false,
      "release-authed-zendesk-image-loading": false,
      "enable-pendo-open-guide-action": false,
      "show-incident-banner": "",
      "show-dev-env-banner": false,
      "release-audiences-for-command-types": false,
      "copilot-v-3": false,
      "release-analytics-events-refresh": false,
      "hackweek-live-events-table": false,
      "release-analytics-v2-qa": false,
      "release-preview-v-2": false,
      "segment-webhook-destination": false,
      "amplitude-audience-integration": false,
      "show-persistent-copilot-cta": false,
      "release-copilot-attachments": false,
      "release-copilot-impersonate-users": false,
      "release-copilot-action-audience": false,
      "enable-when-element-appears-trigger": false,
      "release-copilot-avatar-cdn": false,
      "release-chat-history": false,
      "release-zoho-work-drive-integration": false,
      "switch-open-help-doc-in-new-tab": false,
      "enable-inline-tooltip-options": false,
      "release-nudge-goals": false,
      "release-capture-custom-events": false,
      "release-widget-animations": false,
      "release-copilot-fallbacks-v-2": false,
      "release-user-property-management": false,
      "release-audience-refinement": false,
      "release-skilljar-integration": false,
      "release-track-metadata-sdk-calls": false,
      "release-copilot-analytics-v2": false,
      "release-no-code-editor": false,
      "release-nudge-arrows": false,
      "disable-custom-spotlight-hotkey": false
    };
  }
});

// internal/src/middleware/flags.ts
var getSentryForFlags, _fetchFlags, fetchFlags;
var init_flags2 = __esm({
  "internal/src/middleware/flags.ts"() {
    "use strict";
    init_flags();
    init_proxy();
    init_symbols();
    init_network();
    getSentryForFlags = () => {
      return getProxySDK()[_sentry];
    };
    _fetchFlags = async (request) => {
      const sentry = getSentryForFlags();
      try {
        const response2 = await post("/flags/", request, {
          credentials: "include"
        });
        if (response2.status !== 200) {
          throw new Error(`Failed to fetch flags: ${response2.statusText}`);
        }
        if (response2.data.error) {
          throw new Error(response2.data.error);
        }
        return response2.data;
      } catch (error3) {
        sentry == null ? void 0 : sentry.captureException(error3);
        return { flags: Object.fromEntries(request.batch.map((b) => [b.key, b.default])) };
      }
    };
    fetchFlags = async (orgID) => {
      const batch = Object.entries(defaultFlags).map(([key, defaultValue]) => ({ key, default: defaultValue }));
      const { flags } = await _fetchFlags({ organization_id: orgID, batch });
      for (const flag in flags) {
        const localStorageValue = localStorage.getItem(`commandbar.flags:${flag}`);
        if (localStorageValue !== null) {
          flags[flag] = JSON.parse(localStorageValue);
        }
      }
      return { ...defaultFlags, ...flags };
    };
  }
});

// internal/src/middleware/localizedMessage.tsx
import * as t37 from "io-ts";
var LocalizedMessageV, LocalizedMessagePatchV, LOCALIZED_MESSAGE_DEFAULTS, LocalizedMessage;
var init_localizedMessage = __esm({
  "internal/src/middleware/localizedMessage.tsx"() {
    "use strict";
    init_generics();
    LocalizedMessageV = t37.type(
      {
        id: t37.number,
        msgid: t37.string,
        msgstr: t37.string
      },
      "LocalizedMessage"
    );
    LocalizedMessagePatchV = t37.intersection([
      t37.type({
        msgid: t37.string,
        msgstr: t37.string
      }),
      t37.partial({
        id: t37.number
      })
    ]);
    LOCALIZED_MESSAGE_DEFAULTS = {
      "copilot.title": "{{copilot-name}}",
      "copilot.chat-label": "Chat with {{copilot-name}}",
      "copilot.chat-input-placeholder": "What can we help you find?",
      "helphub.title": "HelpHub",
      "helphub.search-input-placeholder": "Search or ask a question",
      "helphub.ask-ai-button-label": "Ask {{copilot-name}}",
      "helphub.helphub-search-button-label": "Search",
      "helphub.featured-content-label": "Recommended",
      "helphub.additional-resources-label": "Additional resources",
      "helphub.view-article-button-label": "View article",
      "spotlight.recommended-header-label": "Recommended",
      "spotlight.recents-header-label": "Recents",
      "spotlight.experiences-header-label": "Experiences",
      "spotlight.fallback-results-header": "No results for {{query}}. Try one of the items below:"
    };
    LocalizedMessage = class {
    };
    LocalizedMessage.list = listObject(LocalizedMessageV, "localized_messages");
    LocalizedMessage.read = readObject(LocalizedMessageV, "localized_messages");
    LocalizedMessage.update = updateObject(LocalizedMessageV, LocalizedMessageV, "localized_messages");
    LocalizedMessage.create = createObject(LocalizedMessageV, LocalizedMessageV, "localized_messages");
    LocalizedMessage.delete = deleteObject(LocalizedMessageV, "localized_messages");
  }
});

// commandbar/src/shared/sdk/config.ts
function getConfig2(_) {
  var _a2;
  const sdk = getSDK();
  const { uuid: uuid3, version, config: config2, foobarVersion, airgap } = sdk[_configuration];
  const { isAdmin, env, envOverride } = _;
  if (!uuid3) {
    (_a2 = getSentry()) == null ? void 0 : _a2.captureException(new Error("Organization UUID is not set in getConfig"));
  }
  return _getConfig(_, {
    orgID: uuid3,
    envOverride,
    env,
    version,
    config: config2,
    airgap,
    clearEnvOverride: () => clearEnvOverride(_),
    isAdmin,
    foobarVersion
  });
}
function getEnvOrVersion({
  envOverride,
  env,
  version
}) {
  if (envOverride) {
    return envOverride;
  } else if (version) {
    if (typeof version === "number") {
      return { version: `v${version}` };
    }
    return { version };
  } else if (env) {
    return { env };
  }
  return { env: "latest" };
}
function guard(meta, fn, defaultValue) {
  var _a2;
  try {
    const result = fn();
    if (result === void 0)
      return defaultValue;
    return result;
  } catch (e) {
    (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
    Logger_default.error(`Error decoding config response (${meta.orgID}). Using default value for '${meta.field}'`, {
      error: e,
      field: meta.field,
      defaultValue
    });
    return defaultValue;
  }
}
async function guardAsync(meta, fn, defaultValue) {
  var _a2;
  try {
    const result = await fn();
    if (result === void 0)
      return defaultValue;
    return result;
  } catch (e) {
    (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
    Logger_default.error(`Error decoding config response (${meta.orgID}). Using default value for '${meta.field}'`, {
      error: e,
      field: meta.field,
      defaultValue
    });
    return defaultValue;
  }
}
async function fetchConfig(_, options) {
  if (options.airgap)
    throw new Error("Cannot fetch config in airgapped mode");
  const endpoint = (() => {
    const path = `organizations/${options.orgID}/${options.isAdmin ? "config_for_admin" : "config"}/`;
    const envOrVersion = getEnvOrVersion({
      envOverride: options.envOverride,
      env: options.env,
      version: options.version
    });
    let queryString = "";
    if (!localStorage.getItem("commandbar.takeover")) {
      if ("env" in envOrVersion) {
        queryString = `?env=${envOrVersion.env}`;
      } else if ("version" in envOrVersion) {
        queryString = `?version=${envOrVersion.version}`;
      }
    }
    return `${path}${queryString}`;
  })();
  let data = null;
  try {
    const token = LocalStorage_default.get("token", "");
    data = (await get2(
      endpoint,
      token ? {
        headers: {
          Authorization: `JWT ${token}`
        }
      } : {
        credentials: "omit"
      }
    )).data;
  } catch (e) {
    options.clearEnvOverride();
    LocalStorage_default.remove("token");
    _.isAdmin = false;
    if (options.isAdmin) {
      return await fetchConfig(_, { ...options, isAdmin: false });
    } else {
      Logger_default.error("Error loading config", { error: e, url: `${getBaseURL()}/${endpoint}` });
      throw e;
    }
  }
  return data;
}
async function _getConfig(_, options) {
  const sentry = getSentry();
  const { orgID } = options;
  const [data, flags] = await Promise.all([
    options.config === void 0 ? fetchConfig(_, options) : options.config,
    !options.airgap ? fetchFlags(orgID) : defaultFlags
  ]);
  const {
    commands,
    categories,
    organization,
    environments_with_versions,
    placeholders,
    nudges_v2,
    tabs,
    checklists,
    helphub_additional_resources,
    helphub_recommendation_sets,
    __meta__,
    localized_messages,
    themes,
    keywords
  } = data || {};
  const decodedNudges = nudges_v2 == null ? void 0 : nudges_v2.flatMap((nudge) => {
    var _a2;
    try {
      return [Nudge.decode(nudge)];
    } catch (e) {
      (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
      Logger_default.error("Error decoding nudge", { error: e, nudge });
      return [];
    }
  });
  if (!__already_warned_about_version_mismatch && options.foobarVersion && (__meta__ == null ? void 0 : __meta__.latest_foobar_version) && semverComparison(options.foobarVersion, __meta__ == null ? void 0 : __meta__.latest_foobar_version) < 0) {
    __already_warned_about_version_mismatch = true;
    Logger_default.warn(
      `@commandbar/foobar is out of date (your version: v${options.foobarVersion}); please upgrade to version v${__meta__ == null ? void 0 : __meta__.latest_foobar_version} or greater`
    );
    sentry == null ? void 0 : sentry.captureMessage("@commandbar/foobar is out of date", "warning", {
      captureContext: { tags: { "config:latest-foobar-version": __meta__ == null ? void 0 : __meta__.latest_foobar_version } }
    });
  }
  return {
    commands: (commands != null ? commands : []).flatMap(
      (command) => guard({ orgID, field: `command[id=${command == null ? void 0 : command.id}]` }, () => [decode(command)], [])
    ),
    categories: (categories != null ? categories : []).flatMap(
      (category) => guard({ orgID, field: `categories[id=${category == null ? void 0 : category.id}]` }, () => [CommandCategory.decode(category)], [])
    ),
    organization: guard(
      { orgID, field: "organization" },
      () => decode2(organization),
      unknownOrganization
    ),
    environments: (environments_with_versions != null ? environments_with_versions : []).flatMap(
      (env) => guard({ orgID, field: `environments_with_versions[id=${env == null ? void 0 : env.id}]` }, () => [Environment.decode(env)], [])
    ),
    placeholders: await guardAsync(
      { orgID, field: "placeholders" },
      async () => placeholders || await listPlaceholders(orgID),
      []
    ),
    nudges: (decodedNudges != null ? decodedNudges : []).flatMap(
      (nudge) => guard({ orgID, field: `nudges[id=${nudge == null ? void 0 : nudge.id}]` }, () => [nudge], [])
    ),
    checklists: (checklists != null ? checklists : []).flatMap(
      (checklist3) => guard({ orgID, field: `checklists[id=${checklist3 == null ? void 0 : checklist3.id}]` }, () => [Checklist.decode(checklist3)], [])
    ),
    helphub_additional_resources: (helphub_additional_resources != null ? helphub_additional_resources : []).flatMap(
      (additional_resource) => guard(
        { orgID, field: `helphub_additional_resources[id=${additional_resource == null ? void 0 : additional_resource.id}]` },
        () => [decode3(additional_resource)],
        []
      )
    ),
    helphub_recommendation_sets: (helphub_recommendation_sets != null ? helphub_recommendation_sets : []).flatMap(
      (recommendation_set) => guard(
        { orgID, field: `helphub_recommendation_sets[id=${recommendation_set == null ? void 0 : recommendation_set.id}]` },
        () => [RecommendationSet.decode(recommendation_set)],
        []
      )
    ),
    tabs: (tabs != null ? tabs : []).flatMap((tab) => guard({ orgID, field: `tabs[id=${tab == null ? void 0 : tab.id}]` }, () => [Tab.decode(tab)], [])),
    __meta__,
    flags,
    localized_messages: guard(
      { orgID, field: "localized_messages" },
      () => ({ ...LOCALIZED_MESSAGE_DEFAULTS, ...localized_messages }),
      {}
    ),
    themes: (themes != null ? themes : []).flatMap(
      (theme) => guard({ orgID, field: `themes[uuid=${theme == null ? void 0 : theme.uuid};slug=${theme == null ? void 0 : theme.slug}]` }, () => [decode4(theme)], [])
    ),
    keywords: (keywords != null ? keywords : []).flatMap(
      (keyword) => guard({ orgID, field: `keywords[id=${keyword == null ? void 0 : keyword.id}]` }, () => [keyword], [])
    )
  };
}
var semverComparison, __already_warned_about_version_mismatch;
var init_config = __esm({
  "commandbar/src/shared/sdk/config.ts"() {
    "use strict";
    init_globals();
    init_symbols();
    init_command();
    init_tab();
    init_commandCategory();
    init_network();
    init_organization();
    init_environment();
    init_nudge();
    init_checklist();
    init_additionalResource();
    init_recommendationSet();
    init_theme2();
    init_Logger();
    init_global_actions();
    init_sentry();
    init_LocalStorage();
    init_flags();
    init_flags2();
    init_localizedMessage();
    semverComparison = (a, b) => {
      var _a2, _b2;
      const aSplit = a.split(".");
      const bSplit = b.split(".");
      for (let i2 = 0; i2 < Math.max(aSplit.length, bSplit.length); i2++) {
        const aNum = Number((_a2 = aSplit[i2]) != null ? _a2 : 0);
        const bNum = Number((_b2 = bSplit[i2]) != null ? _b2 : 0);
        if (aNum > bNum) {
          return 1;
        } else if (aNum < bNum) {
          return -1;
        }
      }
      return 0;
    };
    __already_warned_about_version_mismatch = false;
  }
});

// commandbar/src/shared/services/end-users/decide.ts
var addDeviceProperties, decide;
var init_decide = __esm({
  "commandbar/src/shared/services/end-users/decide.ts"() {
    "use strict";
    init_operatingSystem();
    init_config();
    init_network();
    init_generics();
    init_endUser();
    init_globals();
    init_symbols();
    init_sentry();
    addDeviceProperties = (properties) => {
      return {
        ...properties,
        $device: getDeviceType(),
        $browser: getBrowser(),
        $os: getOperatingSystem(),
        $language: navigator.language
      };
    };
    decide = async (orgId, distinctId, options) => {
      var _a2, _b2, _c2;
      try {
        const completeProperties = addDeviceProperties(options.properties || {});
        const envOrVersion = getEnvOrVersion({
          envOverride: options.envOverride,
          env: options.env,
          version: options.version
        });
        let query = "";
        if (!localStorage.getItem("commandbar.takeover")) {
          if ("env" in envOrVersion) {
            query = `?env=${envOrVersion.env}`;
          } else if ("version" in envOrVersion) {
            query = `?version=${envOrVersion.version}`;
          }
        }
        const res = await post(
          `/decide/${query}`,
          {
            organization_id: orgId,
            distinct_id: distinctId,
            properties: completeProperties,
            is_admin: !!options.is_admin
          },
          {
            credentials: "omit"
          }
        );
        const { data } = res;
        const result = await decodeToPromise(DecideResponseV, data);
        (_b2 = (_a2 = getSDK()) == null ? void 0 : _a2[_analytics]) == null ? void 0 : _b2.setDecide(result);
        return result;
      } catch (error3) {
        (_c2 = getSentry()) == null ? void 0 : _c2.captureException(error3);
        return null;
      }
    };
  }
});

// commandbar/src/shared/services/end-users/getChatHistory.ts
import * as t38 from "io-ts";
var getChatHistory;
var init_getChatHistory = __esm({
  "commandbar/src/shared/services/end-users/getChatHistory.ts"() {
    "use strict";
    init_network();
    init_generics();
    init_chat();
    init_sentry();
    getChatHistory = async (hmac, identifier) => {
      var _a2;
      try {
        const headers = {};
        headers["X-USER-AUTHORIZATION"] = hmac;
        const res = await get2(`/u/${identifier}/chat_history/`, {
          headers
        });
        const { data } = res;
        return await decodeToPromise(t38.array(ChatV), data);
      } catch (error3) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
        return null;
      }
    };
  }
});

// commandbar/src/shared/services/end-users/index.ts
var init_end_users = __esm({
  "commandbar/src/shared/services/end-users/index.ts"() {
    "use strict";
    init_identify();
    init_decide();
    init_getChatHistory();
  }
});

// node_modules/@emotion/sheet/dist/sheet.browser.esm.js
function sheetForTag(tag) {
  if (tag.sheet) {
    return tag.sheet;
  }
  for (var i2 = 0; i2 < document.styleSheets.length; i2++) {
    if (document.styleSheets[i2].ownerNode === tag) {
      return document.styleSheets[i2];
    }
  }
}
function createStyleElement(options) {
  var tag = document.createElement("style");
  tag.setAttribute("data-emotion", options.key);
  if (options.nonce !== void 0) {
    tag.setAttribute("nonce", options.nonce);
  }
  tag.appendChild(document.createTextNode(""));
  return tag;
}
var StyleSheet;
var init_sheet_browser_esm = __esm({
  "node_modules/@emotion/sheet/dist/sheet.browser.esm.js"() {
    StyleSheet = /* @__PURE__ */ function() {
      function StyleSheet2(options) {
        this.isSpeedy = options.speedy === void 0 ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce;
        this.key = options.key;
        this.container = options.container;
        this.before = null;
      }
      var _proto = StyleSheet2.prototype;
      _proto.insert = function insert(rule) {
        if (this.ctr % (this.isSpeedy ? 65e3 : 1) === 0) {
          var _tag = createStyleElement(this);
          var before;
          if (this.tags.length === 0) {
            before = this.before;
          } else {
            before = this.tags[this.tags.length - 1].nextSibling;
          }
          this.container.insertBefore(_tag, before);
          this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
          var sheet = sheetForTag(tag);
          try {
            var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64;
            sheet.insertRule(
              rule,
              // we need to insert @import rules before anything else
              // otherwise there will be an error
              // technically this means that the @import rules will
              // _usually_(not always since there could be multiple style tags)
              // be the first ones in prod and generally later in dev
              // this shouldn't really matter in the real world though
              // @import is generally only used for font faces from google fonts and etc.
              // so while this could be technically correct then it would be slower and larger
              // for a tiny bit of correctness that won't matter in the real world
              isImportRule ? 0 : sheet.cssRules.length
            );
          } catch (e) {
            if (false) {
              console.warn('There was a problem inserting the following rule: "' + rule + '"', e);
            }
          }
        } else {
          tag.appendChild(document.createTextNode(rule));
        }
        this.ctr++;
      };
      _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
          return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
      };
      return StyleSheet2;
    }();
  }
});

// node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min(W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t44 = 0, B2 = e.length, J = B2 - 1, y, f = "", p = "", F2 = "", G2 = "", C; l < B2; ) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B2++, J++);
      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              f += e.charAt(l);
          }
          g = 59;
        }
        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;
            for (t44 = ++l; l < B2; ) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;
                case 125:
                  k--;
                  break;
                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }
                              break;
                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }
                          }
                        }
                        l = u;
                      }
                  }
                  break;
                case 91:
                  g++;
                case 40:
                  g++;
                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g; ) {
                  }
              }
              if (0 === k)
                break;
              l++;
            }
            k = e.substring(t44, l);
            0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ""));
                g = f.charCodeAt(1);
                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;
                  default:
                    r = O;
                }
                k = M(c, r, k, g, a + 1);
                t44 = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t44, g, a, h), f = r.join(""), void 0 !== C && 0 === (t44 = (k = C.trim()).length) && (g = 0, k = ""));
                if (0 < t44)
                  switch (g) {
                    case 115:
                      f = f.replace(da, ea);
                    case 100:
                    case 109:
                    case 45:
                      k = f + "{" + k + "}";
                      break;
                    case 107:
                      f = f.replace(fa, "$1 $2");
                      k = f + "{" + k + "}";
                      k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                      break;
                    default:
                      k = f + k, 112 === h && (k = (p += k, ""));
                  }
                else
                  k = "";
                break;
              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }
            F2 += k;
            k = I = r = u = q = 0;
            f = "";
            g = e.charCodeAt(++l);
            break;
          case 125:
          case 59:
            f = (0 < r ? f.replace(N, "") : f).trim();
            if (1 < (t44 = f.length))
              switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t44 = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t44 = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
                case 0:
                  break;
                case 64:
                  if (105 === g || 99 === g) {
                    G2 += f + e.charAt(l);
                    break;
                  }
                default:
                  58 !== f.charCodeAt(t44 - 1) && (p += P(f, q, g, f.charCodeAt(2)));
              }
            I = r = u = q = 0;
            f = "";
            g = e.charCodeAt(++l);
        }
      }
      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;
        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }
        default:
          z++;
          y = e.charAt(l);
          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b)
                switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = "";
                    break;
                  default:
                    32 !== g && (y = " ");
                }
              break;
            case 0:
              y = "\\0";
              break;
            case 12:
              y = "\\f";
              break;
            case 11:
              y = "\\v";
              break;
            case 38:
              0 === n + b + m && (r = I = 1, y = "\f" + y);
              break;
            case 108:
              if (0 === n + b + m + E && 0 < u)
                switch (l - u) {
                  case 2:
                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                  case 8:
                    111 === K && (E = K);
                }
              break;
            case 58:
              0 === n + b + m && (u = l);
              break;
            case 44:
              0 === b + v + n + m && (r = 1, y += "\r");
              break;
            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;
            case 91:
              0 === n + b + v && m++;
              break;
            case 93:
              0 === n + b + v && m--;
              break;
            case 41:
              0 === n + b + m && v--;
              break;
            case 40:
              if (0 === n + b + m) {
                if (0 === q)
                  switch (2 * x + 3 * K) {
                    case 533:
                      break;
                    default:
                      q = 1;
                  }
                v++;
              }
              break;
            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;
            case 42:
            case 47:
              if (!(0 < n + m + v))
                switch (b) {
                  case 0:
                    switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;
                      case 220:
                        t44 = l, b = 42;
                    }
                    break;
                  case 42:
                    47 === g && 42 === x && t44 + 2 !== l && (33 === e.charCodeAt(t44 + 2) && (p += e.substring(t44, l + 1)), y = "", b = 0);
                }
          }
          0 === b && (f += y);
      }
      K = x;
      x = g;
      l++;
    }
    t44 = p.length;
    if (0 < t44) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t44, h, a, h), void 0 !== C && 0 === (p = C).length))
        return G2 + p + F2;
      p = r.join(",") + "{" + p + "}";
      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);
        switch (E) {
          case 111:
            p = p.replace(ha, ":-moz-$1") + p;
            break;
          case 112:
            p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
        }
        E = 0;
      }
    }
    return G2 + p + F2;
  }
  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length, m = d.length;
    switch (m) {
      case 0:
      case 1:
        var b = 0;
        for (d = 0 === m ? "" : d[0] + " "; b < a; ++b) {
          c[b] = Z2(d, c[b], e).trim();
        }
        break;
      default:
        var v = b = 0;
        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z2(d[n] + " ", h[b], e).trim();
          }
        }
    }
    return c;
  }
  function Z2(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));
    switch (h) {
      case 38:
        return c.replace(F, "$1" + d.trim());
      case 58:
        return d.trim() + c.replace(F, "$1" + d.trim());
      default:
        if (0 < 1 * e && 0 < c.indexOf("\f"))
          return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
    }
    return d + c;
  }
  function P(d, c, e, h) {
    var a = d + ";", m = 2 * c + 3 * e + 4 * h;
    if (944 === m) {
      d = a.indexOf(":", 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ";";
      return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
    }
    if (0 === w || 2 === w && !L(a, 1))
      return a;
    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
      case 951:
        return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
      case 963:
        return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
      case 1009:
        if (100 !== a.charCodeAt(4))
          break;
      case 969:
      case 942:
        return "-webkit-" + a + a;
      case 978:
        return "-webkit-" + a + "-moz-" + a + a;
      case 1019:
      case 983:
        return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
      case 883:
        if (45 === a.charCodeAt(8))
          return "-webkit-" + a + a;
        if (0 < a.indexOf("image-set(", 11))
          return a.replace(ja, "$1-webkit-$2") + a;
        break;
      case 932:
        if (45 === a.charCodeAt(4))
          switch (a.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
            case 115:
              return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
            case 98:
              return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
          }
        return "-webkit-" + a + "-ms-" + a + a;
      case 964:
        return "-webkit-" + a + "-ms-flex-" + a + a;
      case 1023:
        if (99 !== a.charCodeAt(8))
          break;
        b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
        return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
      case 1005:
        return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf("-") + 1;
        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, "tb");
            break;
          case 232:
            b = a.replace(G, "tb-rl");
            break;
          case 220:
            b = a.replace(G, "lr");
            break;
          default:
            return a;
        }
        return "-webkit-" + a + "-ms-" + b + a;
      case 1017:
        if (-1 === a.indexOf("sticky", 9))
          break;
      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8))
              break;
          case 115:
            a = a.replace(b, "-webkit-" + b) + ";" + a;
            break;
          case 207:
          case 102:
            a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
        }
        return a + ";";
      case 938:
        if (45 === a.charCodeAt(5))
          switch (a.charCodeAt(6)) {
            case 105:
              return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
            case 115:
              return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
            default:
              return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
          }
        break;
      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4))
          break;
      case 931:
      case 953:
        if (true === la.test(d))
          return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
        break;
      case 962:
        if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10))
          return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
    }
    return a;
  }
  function L(d, c) {
    var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, "$1"), e, c);
  }
  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
  }
  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w2; g < A; ++g) {
      switch (w2 = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case false:
        case true:
        case null:
          break;
        default:
          x = w2;
      }
    }
    if (x !== c)
      return x;
  }
  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;
      default:
        if ("function" === typeof d)
          S[A++] = d;
        else if ("object" === typeof d)
          for (var c = 0, e = d.length; c < e; ++c) {
            T(d[c]);
          }
        else
          Y = !!d | 0;
    }
    return T;
  }
  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }
  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];
    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && "string" === typeof h && (c = h);
    }
    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = "";
    E = 0;
    z = D = 1;
    return a;
  }
  var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}
var stylis_browser_esm_default;
var init_stylis_browser_esm = __esm({
  "node_modules/@emotion/stylis/dist/stylis.browser.esm.js"() {
    stylis_browser_esm_default = stylis_min;
  }
});

// node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js
var init_weak_memoize_browser_esm = __esm({
  "node_modules/@emotion/weak-memoize/dist/weak-memoize.browser.esm.js"() {
  }
});

// node_modules/@emotion/cache/dist/cache.browser.esm.js
function toSheet(block) {
  if (block) {
    Sheet.current.insert(block + "}");
  }
}
var delimiter, needle, Sheet, ruleSheet, createCache, cache_browser_esm_default;
var init_cache_browser_esm = __esm({
  "node_modules/@emotion/cache/dist/cache.browser.esm.js"() {
    init_sheet_browser_esm();
    init_stylis_browser_esm();
    init_weak_memoize_browser_esm();
    delimiter = "/*|*/";
    needle = delimiter + "}";
    Sheet = {
      current: null
    };
    ruleSheet = function ruleSheet2(context, content, selectors, parents, line, column, length, ns, depth, at) {
      switch (context) {
        case 1: {
          switch (content.charCodeAt(0)) {
            case 64: {
              Sheet.current.insert(content + ";");
              return "";
            }
            case 108: {
              if (content.charCodeAt(2) === 98) {
                return "";
              }
            }
          }
          break;
        }
        case 2: {
          if (ns === 0)
            return content + delimiter;
          break;
        }
        case 3: {
          switch (ns) {
            case 102:
            case 112: {
              Sheet.current.insert(selectors[0] + content);
              return "";
            }
            default: {
              return content + (at === 0 ? delimiter : "");
            }
          }
        }
        case -2: {
          content.split(needle).forEach(toSheet);
        }
      }
    };
    createCache = function createCache2(options) {
      if (options === void 0)
        options = {};
      var key = options.key || "css";
      var stylisOptions;
      if (options.prefix !== void 0) {
        stylisOptions = {
          prefix: options.prefix
        };
      }
      var stylis = new stylis_browser_esm_default(stylisOptions);
      if (false) {
        if (/[^a-z-]/.test(key)) {
          throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + key + '" was passed');
        }
      }
      var inserted = {};
      var container;
      {
        container = options.container || document.head;
        var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
        Array.prototype.forEach.call(nodes, function(node) {
          var attrib = node.getAttribute("data-emotion-" + key);
          attrib.split(" ").forEach(function(id2) {
            inserted[id2] = true;
          });
          if (node.parentNode !== container) {
            container.appendChild(node);
          }
        });
      }
      var _insert;
      {
        stylis.use(options.stylisPlugins)(ruleSheet);
        _insert = function insert(selector2, serialized, sheet, shouldCache) {
          var name = serialized.name;
          Sheet.current = sheet;
          if (false) {
            var map = serialized.map;
            Sheet.current = {
              insert: function insert2(rule) {
                sheet.insert(rule + map);
              }
            };
          }
          stylis(selector2, serialized.styles);
          if (shouldCache) {
            cache.inserted[name] = true;
          }
        };
      }
      if (false) {
        var commentStart = /\/\*/g;
        var commentEnd = /\*\//g;
        stylis.use(function(context, content) {
          switch (context) {
            case -1: {
              while (commentStart.test(content)) {
                commentEnd.lastIndex = commentStart.lastIndex;
                if (commentEnd.test(content)) {
                  commentStart.lastIndex = commentEnd.lastIndex;
                  continue;
                }
                throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
              }
              commentStart.lastIndex = 0;
              break;
            }
          }
        });
        stylis.use(function(context, content, selectors) {
          switch (context) {
            case -1: {
              var flag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
              var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);
              if (unsafePseudoClasses && cache.compat !== true) {
                unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                  var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                  var ignore = ignoreRegExp.test(content);
                  if (unsafePseudoClass && !ignore) {
                    console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
                  }
                });
              }
              break;
            }
          }
        });
      }
      var cache = {
        key,
        sheet: new StyleSheet({
          key,
          container,
          nonce: options.nonce,
          speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted,
        registered: {},
        insert: _insert
      };
      return cache;
    };
    cache_browser_esm_default = createCache;
  }
});

// commandbar/src/shared/util/useEmotionBugWorkaroundStyleContainer.ts
import { useEffect as useEffect37, useRef as useRef28 } from "react";
var useEmotionBugWorkaroundStyleContainer, useEmotionBugWorkaroundStyleContainer_default;
var init_useEmotionBugWorkaroundStyleContainer = __esm({
  "commandbar/src/shared/util/useEmotionBugWorkaroundStyleContainer.ts"() {
    "use strict";
    useEmotionBugWorkaroundStyleContainer = (parentContainer = document.body) => {
      var _a2, _b2;
      const container = useRef28(null);
      const observer = useRef28(null);
      const parentContainerRef = useRef28(null);
      useEffect37(() => {
        return () => {
          var _a3, _b3;
          (_a3 = observer.current) == null ? void 0 : _a3.disconnect();
          (_b3 = container.current) == null ? void 0 : _b3.remove();
        };
      }, []);
      if (false) {
        return void 0;
      }
      if (container.current === null || parentContainer !== parentContainerRef.current) {
        (_a2 = observer.current) == null ? void 0 : _a2.disconnect();
        (_b2 = container.current) == null ? void 0 : _b2.remove();
        parentContainerRef.current = parentContainer;
        container.current = document.createElement("div");
        container.current.setAttribute("data-commandbar-toplevel-styles", "");
        container.current.setAttribute("hidden", "");
        parentContainer.prepend(container.current);
        observer.current = new MutationObserver(() => {
          container.current && container.current.querySelectorAll("style[data-emotion]:not([data-s])").forEach((style3) => {
            style3.setAttribute("data-s", "");
          });
        });
        observer.current.observe(container.current, {
          childList: true,
          subtree: true
        });
      }
      return container.current;
    };
    useEmotionBugWorkaroundStyleContainer_default = useEmotionBugWorkaroundStyleContainer;
  }
});

// internal/src/client/Portal.tsx
var allowedOriginRegexes, matchSubstrings, evalSource, hashCode, openChannel, serializeData, response, isMessageValid, preMessageHandler, Portal2, Portal_default2;
var init_Portal2 = __esm({
  "internal/src/client/Portal.tsx"() {
    "use strict";
    init_Logger();
    allowedOriginRegexes = [
      /^https?:\/\/localhost:3000$/,
      // Base
      /^https?:\/\/localhost:3001$/,
      // CommandBar
      /^https?:\/\/localhost:3003$/,
      // Editor
      /^https?:\/\/localhost:4000$/,
      // app.cb.com
      /^https?:\/\/localhost:5000$/,
      // Base
      /^https?:\/\/localhost:5001$/,
      // CommandBar
      /^https?:\/\/localhost:5002$/,
      // Proxy
      /^https?:\/\/localhost:5003$/,
      // Editor
      // allow `.` for subdomains like <branch>.dashboard.commandbar.com
      /^https:\/\/[a-zA-Z0-9\-.]+\.commandbar\.com$/,
      /^https:\/\/[a-zA-Z0-9\-.]+\.commandbar\.xyz$/,
      /^https:\/\/\d+--commandbar-com-branch\.netlify\.app$/
    ];
    matchSubstrings = (str, substrings) => {
      const escapedSubstrings = substrings.map((substring) => substring.replace(/\./g, "\\."));
      const regexpStr = `^.*(${escapedSubstrings.join("|")}).*$`;
      const regexp = new RegExp(regexpStr, "g");
      return !!str.match(regexp);
    };
    evalSource = (url) => {
      const commandBarSources = ["localhost:3001", "localhost:5001", "experiences.commandbar.com", "commandbar.xyz:3001"];
      const editorSources = [
        "localhost:3003",
        "localhost:4000",
        "commandbar.xyz:3003",
        "commandbar.xyz:4000",
        "localhost:5003",
        "editor.commandbar.com",
        "dashboard.commandbar.com",
        "proxy.commandbar.com",
        `frames-editor-prod.commandbar.com`,
        // to remove
        `frames-editor-labs.commandbar.com`,
        // to remove
        `frames-editor-dev.commandbar.com`,
        // to remove
        `app.commandbar.com`,
        `labs.commandbar.com`,
        "dev.commandbar.com"
      ];
      if (matchSubstrings(url, commandBarSources)) {
        return "commandbar";
      }
      if (matchSubstrings(url, editorSources) || allowedOriginRegexes.some((regexp) => regexp.test(url))) {
        return "editor";
      }
      if (["CommandBar", "Proxy"].includes("CommandBar")) {
        return "proxy";
      }
      if (["editor"].includes("CommandBar")) {
        return "editor";
      }
      return null;
    };
    hashCode = (str) => {
      return str.split("").reduce((prevHash, currVal) => (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0, 0);
    };
    openChannel = (frame) => {
      let target = null;
      let targetOrigin;
      let targetID;
      let child;
      if (frame === void 0) {
        targetID = "commandbar-commandbar";
        targetOrigin = document.referrer;
        target = window.parent;
        child = true;
        if (window.location.origin.startsWith("http://localhost")) {
          targetOrigin = "*";
        }
        if (!targetOrigin) {
          targetOrigin = "*";
        }
        if (target === window) {
          const commandbarEditorBarPreviewIFrame = document.getElementById(
            "commandbar-editor-bar-preview"
          );
          if (commandbarEditorBarPreviewIFrame) {
            targetOrigin = commandbarEditorBarPreviewIFrame.src;
            target = commandbarEditorBarPreviewIFrame.contentWindow;
          }
        }
      } else {
        targetID = `commandbar-${frame}`;
        const frameNode = document.getElementById(targetID);
        targetOrigin = frameNode.src;
        target = frameNode.contentWindow;
        child = false;
      }
      if (!target || !targetOrigin) {
        Logger_default.error("iframe not loaded yet...", frame);
        return (_msg) => Promise.resolve();
      }
      const _target = target;
      return (msg) => new Promise((resolve, reject) => {
        const uniqueID = hashCode(JSON.stringify(msg));
        Logger_default.portalsend(uniqueID, JSON.stringify(msg));
        const channel = new MessageChannel();
        channel.port1.onmessage = (props2) => {
          channel.port1.close();
          const data = JSON.parse(props2.data);
          if (data.error) {
            Logger_default.portalreceive(uniqueID, props2.data);
            reject(data.error);
          } else {
            Logger_default.portalreceive(uniqueID, props2.data);
            resolve(data);
          }
        };
        const payload = serializeData({
          ...msg,
          target: targetID,
          host: child ? void 0 : window.location.href
        });
        if (targetOrigin !== "*" && !targetOrigin.includes("://")) {
          if (!targetOrigin.includes("localhost")) {
            console.log("");
          }
          targetOrigin = `https://${targetOrigin}`;
        }
        _target.postMessage(payload, targetOrigin, [channel.port2]);
      });
    };
    serializeData = (msg) => {
      let ret;
      try {
        ret = JSON.stringify(msg);
      } catch (err) {
        Logger_default.warn("Invalid message type", err);
        ret = `${msg}`;
      }
      return ret;
    };
    response = (event, success, result) => {
      const payload = JSON.stringify({
        success,
        ...result != null ? result : {}
      });
      event.ports[0].postMessage(payload);
    };
    isMessageValid = (e) => {
      const MESSAGE_SOURCES_TO_BE_IGNORED = [
        "react-devtools-content-script",
        "react-devtools-bridge",
        "AUGURY_INSPECTED_APPLICATION"
      ];
      const shouldLogWarning = (messageSource) => {
        return MESSAGE_SOURCES_TO_BE_IGNORED.every((source) => messageSource !== source);
      };
      const isValidOrigin = allowedOriginRegexes.some((regex) => regex.test(e.origin));
      if (true) {
        if (!isValidOrigin) {
          return false;
        }
      }
      if (!e.data) {
        Logger_default.error("Message Error: packet empty");
        return false;
      }
      let data;
      try {
        data = typeof e.data === "object" ? e.data : JSON.parse(e.data);
      } catch (err) {
        return false;
      }
      const isValidTarget = data.target === `commandbar-${"CommandBar" == null ? void 0 : "CommandBar".toLowerCase()}`;
      if (!isValidTarget) {
        if (shouldLogWarning(data.source || data.messageSource)) {
          Logger_default.red("Either you sent this to the wrong target or its not coming from Command Bar", data);
        }
        return false;
      }
      const isFromMessageChannel = e.ports && e.ports.length === 0;
      if (isFromMessageChannel) {
        Logger_default.error(data);
        throw new Error("We are only accepting MessageChannel requests for now...");
      }
      return true;
    };
    preMessageHandler = (e) => {
      var _a2;
      let data;
      try {
        if (!!e.data) {
          data = typeof e.data === "object" ? e.data : JSON.parse(e.data);
        } else {
          data = "";
        }
      } catch (err) {
        data = "";
      }
      return {
        isValid: isMessageValid(e),
        sender: (_a2 = data == null ? void 0 : data.sender) != null ? _a2 : evalSource(e.origin),
        data
      };
    };
    Portal2 = {
      response,
      openChannel,
      isMessageValid,
      evalSource,
      preMessageHandler
    };
    Portal_default2 = Portal2;
  }
});

// internal/src/client/usePortal.tsx
import React180 from "react";
var respondSuccess, respondError, usePortal, usePortal_default;
var init_usePortal = __esm({
  "internal/src/client/usePortal.tsx"() {
    "use strict";
    init_Portal2();
    init_Logger();
    respondSuccess = (response2) => {
      return Promise.resolve([true, response2]);
    };
    respondError = (error3) => {
      return Promise.resolve([false, { error: error3 }]);
    };
    usePortal = (receiver) => {
      const messageHandler = async (e) => {
        var _a2, _b2;
        const { isValid: isValid2, sender, data } = Portal_default2.preMessageHandler(e);
        if (!isValid2) {
          Logger_default.info(`Invalid portal message: ${e}`, e);
          return;
        }
        if (!sender) {
          Logger_default.info(`Invalid portal sender: ${e}`);
          return;
        }
        if (!data) {
          Logger_default.info(`Invalid portal data: ${e}`);
          return;
        }
        if (receiver.hasOwnProperty(sender) && ((_a2 = receiver[sender]) == null ? void 0 : _a2.hasOwnProperty(data.action))) {
          try {
            const result = await ((_b2 = receiver[sender]) == null ? void 0 : _b2[data.action]({
              e,
              data
            }));
            if (result) {
              const [status, response2] = result;
              Portal_default2.response(e, status, response2);
            } else {
              Portal_default2.response(e, false);
            }
          } catch (err) {
            Logger_default.error(err);
            Portal_default2.response(e, false);
          }
        }
        return;
      };
      React180.useEffect(() => {
        window.addEventListener("message", messageHandler);
        return () => {
          window.removeEventListener("message", messageHandler);
        };
      }, [receiver]);
      return;
    };
    usePortal_default = usePortal;
  }
});

// commandbar/src/products/checklists/components/checklist-styles.ts
import chroma9 from "chroma-js";
var switchByMode, generateProgressGradient, CHECKLIST_WIDTH, checklist, progressBar, checklistItem, helpers, styles21, checklist_styles_default;
var init_checklist_styles = __esm({
  "commandbar/src/products/checklists/components/checklist-styles.ts"() {
    "use strict";
    init_Z();
    switchByMode = (theme, options) => {
      return options[theme.base.mode];
    };
    generateProgressGradient = (color) => {
      const gradient = chroma9.scale([color, chroma9(color).brighten(2)]).mode("hsl");
      return `linear-gradient(140deg,
  ${gradient(0.1)} 0%,
  ${gradient(0.33)} 80%,
  ${gradient(0.39)} 98%,
  ${gradient(0.45)} 102%,
  ${gradient(0.78)} 100%)`;
    };
    CHECKLIST_WIDTH = 360;
    checklist = {
      container: (theme, position) => ({
        maxHeight: `calc(100vh - ${theme.questlists.bottom})`,
        maxWidth: `calc(100vw - ${theme.questlists.right})`,
        fontFamily: theme.questlists.fontFamily,
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0px",
        margin: "0px",
        width: `${CHECKLIST_WIDTH}px`,
        background: theme.questlists.bodyBackground,
        boxShadow: theme.questlists.boxShadow,
        borderRadius: theme.questlists.borderRadius,
        bottom: theme.questlists.bottom,
        right: position === "bottomRight" ? theme.questlists.right : "auto",
        left: position === "bottomLeft" ? theme.questlists.left : "auto",
        position: "fixed",
        overflow: "auto",
        zIndex: Z_default.Z_CHECKLIST
      }),
      itemsContainer: (theme) => ({
        maxHeight: theme.questlists.itemsContainerMaxHeight,
        overflowY: "auto"
      }),
      textContainer: (theme) => ({
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: theme.questlists.headerPadding,
        gap: theme.questlists.headerGap,
        background: theme.questlists.headerBackground,
        userSelect: "none"
      }),
      title: (theme) => ({
        fontWeight: theme.questlists.titleFontWeight,
        fontSize: theme.questlists.titleFontSize,
        lineHeight: theme.questlists.titleLineHeight,
        color: theme.questlists.titleColor
      }),
      chevron: (theme) => ({
        color: theme.questlists.titleChevronColor,
        height: theme.questlists.titleChevronSize,
        width: theme.questlists.titleChevronSize
      }),
      description: (theme) => ({
        fontWeight: theme.questlists.descriptionFontWeight,
        fontSize: theme.questlists.descriptionFontSize,
        lineHeight: theme.questlists.descriptionLineHeight,
        color: theme.questlists.descriptionColor
      }),
      footer: (theme) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.questlists.footerPadding,
        gap: theme.questlists.footerGap,
        height: theme.questlists.footerHeight,
        width: "100%",
        background: theme.questlists.footerBackground
      }),
      brandingText: (theme) => ({
        fontWeight: "500",
        fontSize: "11px",
        lineHeight: "13px",
        color: switchByMode(theme, { light: "#A2A2A9", dark: "#A2A2A9" }),
        display: "flex",
        alignItems: "center"
      }),
      primaryBtn: (theme) => ({
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "fit-content",
        cursor: "pointer",
        gap: "5px",
        border: theme.questlists.doneBorder,
        color: theme.questlists.doneColor,
        padding: theme.questlists.donePadding,
        borderRadius: theme.questlists.doneBorderRadius,
        boxShadow: theme.questlists.doneBoxShadow,
        textShadow: theme.questlists.doneTextShadow,
        background: theme.questlists.doneBackground,
        fontSize: theme.questlists.doneFontSize,
        fontWeight: theme.questlists.doneFontWeight,
        lineHeight: theme.questlists.doneLineHeight
      }),
      secondaryBtn: (theme) => ({
        width: "fit-content",
        cursor: "pointer",
        border: theme.questlists.skipBorder,
        color: theme.questlists.skipColor,
        padding: theme.questlists.skipPadding,
        borderRadius: theme.questlists.skipBorderRadius,
        boxShadow: theme.questlists.skipBoxShadow,
        textShadow: theme.questlists.skipTextShadow,
        background: theme.questlists.skipBackground,
        fontSize: theme.questlists.skipFontSize,
        fontWeight: theme.questlists.skipFontWeight,
        lineHeight: theme.questlists.skipLineHeight
      }),
      divider: (theme) => ({
        width: "100%",
        height: "1px",
        background: theme.questlistItem.dividerColor
      })
    };
    progressBar = {
      container: (theme) => ({
        display: "flex",
        flexDirection: "row",
        padding: theme.questlists.progressPadding,
        alignItems: "center",
        gap: "8px",
        width: "100%"
      }),
      progressContainer: (theme) => ({
        background: switchByMode(theme, { light: "#EDEDEE", dark: "#51515C" }),
        borderRadius: "100px",
        flexGrow: 1,
        height: "8px"
      }),
      progressFill: (_theme) => ({
        background: generateProgressGradient(_theme.base.primary),
        borderRadius: "100px",
        height: "8px"
      }),
      text: (theme) => ({
        fontWeight: "600",
        fontSize: "14px",
        lineHeight: "14px",
        color: switchByMode(theme, { light: "#51515C", dark: "#CDCDD0" })
      })
    };
    checklistItem = {
      titleContainer: (_theme) => ({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        padding: "12px 16px"
      }),
      expandedTitleContainer: (_theme) => ({
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        gap: "8px",
        padding: "12px 16px 4px 16px"
      }),
      title: (theme) => ({
        fontWeight: theme.questlistItem.titleFontWeight,
        fontSize: theme.questlistItem.titleFontSize,
        lineHeight: theme.questlistItem.titleLineHeight,
        color: theme.questlistItem.titleColor
      }),
      titleCompleted: (theme) => ({
        fontWeight: theme.questlistItem.titleCompletedFontWeight,
        fontSize: theme.questlistItem.titleCompletedFontSize,
        lineHeight: theme.questlistItem.titleCompletedLineHeight,
        color: theme.questlistItem.titleCompletedColor,
        textDecorationLine: theme.questlistItem.titleCompletedtextDecorationLine
      }),
      description: (theme) => ({
        fontWeight: theme.questlistItem.descriptionFontWeight,
        fontSize: theme.questlistItem.descriptionFontSize,
        lineHeight: theme.questlistItem.descriptionLineHeight,
        color: theme.questlistItem.descriptionColor
      }),
      checkboxIncomplete: (theme) => ({
        width: "20px",
        height: "20px",
        borderWidth: "1px",
        borderRadius: "50%",
        borderStyle: "solid",
        borderColor: switchByMode(theme, { light: "#CDCDD0", dark: "#51515C" }),
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        color: "transparent"
      }),
      checkboxComplete: (theme) => ({
        width: "20px",
        height: "20px",
        borderWidth: "1px",
        borderRadius: "50%",
        borderStyle: "solid",
        borderColor: switchByMode(theme, { light: "#0A0A0F", dark: "#42424D" }),
        background: switchByMode(theme, { light: "#0A0A0F", dark: "#42424D" }),
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexShrink: 0,
        color: "#FFFFFF"
      }),
      bodyContainer: (_theme) => ({
        padding: "0px 16px 14px 44px"
      }),
      ctaButton: (theme) => ({
        gap: "6px",
        cursor: "pointer",
        border: theme.questlistItem.ctaBorder,
        color: theme.questlistItem.ctaColor,
        boxShadow: theme.questlistItem.ctaBoxShadow,
        textShadow: theme.questlistItem.ctaTextShadow,
        padding: theme.questlistItem.ctaPadding,
        borderRadius: theme.questlistItem.ctaBorderRadius,
        background: theme.questlistItem.ctaBackground,
        fontSize: theme.questlistItem.ctaFontSize,
        fontWeight: theme.questlistItem.ctaFontWeight,
        lineHeight: theme.questlistItem.ctaLineHeight
      }),
      textBtn: (theme) => ({
        width: "fit-content",
        cursor: "pointer",
        border: theme.questlistItem.skipBorder,
        color: theme.questlistItem.skipColor,
        padding: theme.questlistItem.skipPadding,
        borderRadius: theme.questlistItem.skipBorderRadius,
        background: theme.questlistItem.skipBackground,
        fontSize: theme.questlistItem.skipFontSize,
        fontWeight: theme.questlistItem.skipFontWeight,
        lineHeight: theme.questlistItem.skipLineHeight
      })
    };
    helpers = {
      noBtnStyle: {
        background: "none",
        color: "inherit",
        border: "none",
        padding: 0,
        font: "inherit",
        cursor: "pointer"
      }
    };
    styles21 = { checklist, checklistItem, helpers, progressBar };
    checklist_styles_default = styles21;
  }
});

// commandbar/src/products/checklists/components/check.svg
import * as React182 from "react";
var SvgCheck;
var init_check = __esm({
  "commandbar/src/products/checklists/components/check.svg"() {
    "use strict";
    SvgCheck = (props2) => /* @__PURE__ */ React182.createElement("svg", { width: 9, height: 7, viewBox: "0 0 10 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React182.createElement("path", { d: "M9 1L3.5 6.5L1 4", stroke: "currentColor", strokeWidth: 1.25, strokeLinecap: "round", strokeLinejoin: "round" }));
  }
});

// commandbar/src/products/checklists/constants.ts
var init_constants8 = __esm({
  "commandbar/src/products/checklists/constants.ts"() {
    "use strict";
  }
});

// commandbar/src/products/checklists/components/Collapse.tsx
import React183, { Fragment as Fragment4, useEffect as useEffect38 } from "react";
var Accordion, DynamicContainer, Collapse;
var init_Collapse = __esm({
  "commandbar/src/products/checklists/components/Collapse.tsx"() {
    "use strict";
    init_useStore();
    init_constants8();
    Accordion = (props2) => {
      const { items, divider, defaultOpenIdx, onExpandedItemChange, editorTimeStamp, containerStyles: containerStyles4 } = props2;
      React183.useEffect(() => {
        setOpenKeys(newArr(defaultOpenIdx));
      }, [defaultOpenIdx, editorTimeStamp]);
      const isValidIdx = (idx) => idx >= 0 && idx < items.length;
      const newArr = (openIdx) => {
        const arr = new Array(items.length).fill(false);
        if (typeof openIdx === "number" && isValidIdx(openIdx))
          arr[openIdx] = true;
        return arr;
      };
      const [openKeys, setOpenKeys] = React183.useState(() => newArr(defaultOpenIdx));
      const onOpenChange = (open, idx) => {
        if (open) {
          setOpenKeys(newArr(idx));
          if (!!onExpandedItemChange) {
            onExpandedItemChange(idx);
          }
        }
      };
      return /* @__PURE__ */ React183.createElement("div", { style: containerStyles4 }, items.map(({ header, children, onClickWhileOpen }, idx) => /* @__PURE__ */ React183.createElement(Fragment4, { key: idx }, /* @__PURE__ */ React183.createElement(
        Collapse,
        {
          header,
          onChange: (open) => onOpenChange(open, idx),
          isControlled: true,
          open: openKeys[idx],
          onClickWhileOpen
        },
        children
      ), divider)));
    };
    DynamicContainer = ({ children, onClick }) => {
      const { flags } = useStore();
      if (onClick) {
        return /* @__PURE__ */ React183.createElement(
          "button",
          {
            type: "button",
            onClick,
            style: {
              ...(flags == null ? void 0 : flags["release-themes-v2"]) && { all: "unset" },
              width: "100%",
              display: "flex",
              flexDirection: "column",
              cursor: "pointer",
              // unstyle button
              background: "none",
              border: "none",
              padding: 0,
              margin: 0,
              textAlign: "left"
            },
            "aria-expanded": true
          },
          children
        );
      }
      return /* @__PURE__ */ React183.createElement("div", { style: { width: "100%", display: "flex", flexDirection: "column" } }, children);
    };
    Collapse = (props2) => {
      const [isOpen, setIsOpen] = React183.useState(props2.open || props2.defaultOpen || false);
      const [height, setHeight] = React183.useState(0);
      const [panelEl, setPanelEl] = React183.useState();
      const panelRef = React183.useCallback((node) => {
        setPanelEl(node);
      }, []);
      const { flags } = useStore();
      useEffect38(() => {
        if (props2.open !== void 0)
          setIsOpen(props2.open);
      }, [props2.open, props2.editorTimeStamp]);
      useEffect38(() => {
        if (isOpen) {
          if (!panelEl)
            return void 0;
          const resizeObserver = new ResizeObserver((el) => {
            setHeight(el[0].contentRect.height);
          });
          resizeObserver.observe(panelEl);
          return () => {
            resizeObserver.disconnect();
          };
        }
        setHeight(0);
      }, [isOpen, panelEl]);
      const isControlled = !!props2.isControlled && props2.open !== void 0;
      const isWrapperAction = props2.onClickWhileOpen && isOpen;
      return /* @__PURE__ */ React183.createElement(DynamicContainer, { onClick: isWrapperAction ? props2.onClickWhileOpen : void 0 }, isWrapperAction ? props2.header(isOpen) : /* @__PURE__ */ React183.createElement(
        "button",
        {
          type: "button",
          "data-testid": "collapse-button" /* COLLAPSE_BUTTON */,
          "aria-expanded": isOpen,
          "aria-label": isOpen ? "Collapse Checklist" : "Expand Checklist",
          onClick: () => {
            !isControlled && setIsOpen(!isOpen);
            if (props2.onChange)
              props2.onChange(!isOpen);
          },
          style: {
            ...(flags == null ? void 0 : flags["release-themes-v2"]) && { all: "unset" },
            cursor: "pointer",
            // unstyle button
            background: "none",
            border: "none",
            padding: 0,
            margin: 0,
            width: "100%",
            textAlign: "left"
          }
        },
        props2.header(isOpen)
      ), /* @__PURE__ */ React183.createElement(
        "div",
        {
          style: {
            height,
            overflow: "hidden",
            // For ThemesV2 Animations on Checklists, we need to skip the original expanding/mounting animation
            // and instead apply the animation styles configured by the user on the root of Checklists but we also need to allow height transitions
            // to animate expand/collapse once the checklist mounts
            ...(!(flags == null ? void 0 : flags["release-widget-animations"]) || !(flags == null ? void 0 : flags["release-themes-v2"])) && {
              transition: "height 0.3s  cubic-bezier(0.04, 0.89, .5, 1.0)"
            }
          }
        },
        /* @__PURE__ */ React183.createElement("div", { ref: panelRef }, props2.children(isOpen))
      ), isOpen && props2.footer);
    };
  }
});

// commandbar/src/shared/util/hooks/useDisableZoom.tsx
import { useEffect as useEffect39, useRef as useRef29 } from "react";
var useDisableZoom;
var init_useDisableZoom = __esm({
  "commandbar/src/shared/util/hooks/useDisableZoom.tsx"() {
    "use strict";
    useDisableZoom = (_isZoomDisabled = false) => {
      const isDisabled = useRef29(_isZoomDisabled);
      const touchMove = (event) => {
        if (isDisabled.current && event.touches.length > 1) {
          event.preventDefault();
        }
      };
      useEffect39(() => {
        document.addEventListener("touchmove", touchMove, { passive: false });
        return () => {
          document.removeEventListener("touchmove", touchMove);
        };
      }, []);
      const handleSetZoomDisabled = (value) => {
        isDisabled.current = value;
      };
      return { setZoomDisabled: handleSetZoomDisabled };
    };
  }
});

// internal/src/client/themesV2/components/shared/StyledPoweredBy.tsx
import React184 from "react";
var PoweredBySvg, PoweredBy, StyledPoweredBy, StyledPoweredBy_default;
var init_StyledPoweredBy = __esm({
  "internal/src/client/themesV2/components/shared/StyledPoweredBy.tsx"() {
    "use strict";
    init_styled_browser_esm();
    PoweredBySvg = () => /* @__PURE__ */ React184.createElement("svg", { width: "18", height: "16", viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React184.createElement(
      "path",
      {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M11.0831 5.91814L12.7927 6.90401L11.5289 7.63423L10.3031 6.92761C10.2022 6.86993 10.1301 6.79651 10.0724 6.69556L8.99998 4.8392L7.92759 6.69556C7.86991 6.79651 7.79649 6.86993 7.69555 6.92761C5.60189 8.13634 3.50693 9.34508 1.41459 10.5538L8.35366 14.5589C8.76532 14.7962 9.23596 14.7962 9.64761 14.5589L16.5841 10.5538L14.0565 9.09468L15.3216 8.36446L17.216 9.45782C17.6184 9.68987 17.8479 10.0884 17.8479 10.5525C17.8479 11.0166 17.6171 11.4151 17.216 11.6472L10.2979 15.6431C9.47325 16.119 8.52934 16.119 7.70604 15.6431L0.785309 11.6472C0.382834 11.4151 0.153411 11.0166 0.153411 10.5525C0.153411 10.0884 0.384145 9.68987 0.785309 9.45782C2.83046 8.27662 4.87429 7.09673 6.91813 5.91683L8.4533 3.25814C8.56998 3.05756 8.76925 2.94219 9.00129 2.94219C9.23334 2.94219 9.43261 3.05756 9.54798 3.25814L11.0831 5.91683V5.91814ZM11.0831 10.0819L9.54798 12.7405C9.43261 12.9411 9.23334 13.0565 9.00129 13.0565C8.76925 13.0565 8.56998 12.9411 8.4533 12.7405L6.91813 10.0819L5.20859 9.09599L6.4737 8.36577L7.69686 9.07239C7.7978 9.13007 7.87122 9.20218 7.9289 9.30313L9.00129 11.1608L10.0737 9.30313C10.1314 9.20218 10.2035 9.13007 10.3044 9.07239C12.3994 7.86366 14.493 6.65492 16.5854 5.44619L9.64892 1.44111C9.23727 1.20251 8.76663 1.20251 8.35498 1.44111L1.4159 5.44619L3.94349 6.90532L2.67969 7.63554L0.783998 6.54218C0.381523 6.31013 0.1521 5.91159 0.1521 5.4475C0.1521 4.98341 0.382834 4.58487 0.783998 4.35282L7.70472 0.356918C8.52803 -0.118973 9.47194 -0.118973 10.2966 0.356918L17.2147 4.35282C17.6171 4.58487 17.8466 4.98341 17.8466 5.4475C17.8466 5.91159 17.6158 6.31013 17.2147 6.54218C15.1708 7.72338 13.1257 8.90327 11.0818 10.0832L11.0831 10.0819Z",
        fill: "#706E78"
      }
    ));
    PoweredBy = styled_browser_esm_default.div`
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;

  color: var(--content-secondary, #7d7c78);

  /* label/sm/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    StyledPoweredBy = ({ onClick, text }) => {
      return /* @__PURE__ */ React184.createElement(PoweredBy, { onClick }, /* @__PURE__ */ React184.createElement(PoweredBySvg, null), text);
    };
    StyledPoweredBy_default = StyledPoweredBy;
  }
});

// internal/src/client/themesV2/components/checklist/StyledChecklistHeader.tsx
import React185 from "react";
var ChecklistHeader, ChecklistTitleContainer, ChecklistTitle, ChecklistSubtitle, IconContainer2, StyledChecklistHeader, StyledChecklistHeader_default;
var init_StyledChecklistHeader = __esm({
  "internal/src/client/themesV2/components/checklist/StyledChecklistHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_StyledIconContainer();
    init_StyledTertiaryIconButton();
    init_StyledNudgeTitleBlock();
    ChecklistHeader = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  padding: var(--layout-padding);
  align-items: flex-start;
  gap: 4px;

  background: var(--background-secondary);

  &:hover {
    background: var(--background-secondary-hover);
  }

  &:focus {
    box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
    background: var(--form-control-background-hover);
  }

  &:focus-visible {
    outline: none;
  }
`;
    ChecklistTitleContainer = styled_browser_esm_default.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  justify-content: space-between;
`;
    ChecklistTitle = styled_browser_esm_default.div`
  color: var(--content-primary);

  font-family: var(--font-font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-tight);
`;
    ChecklistSubtitle = styled_browser_esm_default.div`
  color: var(--content-secondary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
    IconContainer2 = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--content-secondary);
`;
    StyledChecklistHeader = ({
      isExpanded: isExpanded2,
      title,
      subtitle,
      onClose,
      isDismissible,
      themeV2
    }) => {
      return /* @__PURE__ */ React185.createElement(ChecklistHeader, { "data-draggable": "drag-zone", "data-testid": "drag-zone", "aria-label": "Drag to move checklist" }, /* @__PURE__ */ React185.createElement(ChecklistTitleContainer, null, /* @__PURE__ */ React185.createElement("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React185.createElement(ChecklistTitle, null, title), /* @__PURE__ */ React185.createElement(IconContainer2, null, isExpanded2 ? /* @__PURE__ */ React185.createElement(ChevronDown_default, null) : /* @__PURE__ */ React185.createElement(ChevronUp_default, null))), isDismissible && /* @__PURE__ */ React185.createElement(StyledTertiaryIconButton_default, { themeV2, "aria-label": "close", onClick: onClose }, /* @__PURE__ */ React185.createElement(XClose_default, null))), !!subtitle && /* @__PURE__ */ React185.createElement(ChecklistSubtitle, { dangerouslySetInnerHTML: { __html: parseMarkdown(subtitle) } }));
    };
    StyledChecklistHeader_default = StyledChecklistHeader;
  }
});

// internal/src/client/themesV2/components/checklist/StyledChecklistItemBody.tsx
import React186 from "react";
var ChecklistItemBody, ChecklistItemContent, ChecklistItemButtonContainer, StyledChecklistItemBody, StyledChecklistItemBody_default;
var init_StyledChecklistItemBody = __esm({
  "internal/src/client/themesV2/components/checklist/StyledChecklistItemBody.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledNudgeTitleBlock();
    ChecklistItemBody = styled_browser_esm_default.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 4px;
  padding: 4px var(--layout-padding) var(--layout-padding) var(--layout-padding);
  margin-left: calc(20px + var(--layout-gap));
`;
    ChecklistItemContent = styled_browser_esm_default.div`
  align-self: stretch;
  color: var(--content-secondary);

  /* paragraph/base */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  p {
    margin-bottom: 8px;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
    ChecklistItemButtonContainer = styled_browser_esm_default.div`
  padding-top: 8px;
  display: flex;
  align-items: flex-start;
  gap: var(--layout-gap);
  width: 100%;
`;
    StyledChecklistItemBody = ({
      isExpanded: isExpanded2,
      content,
      children
    }) => {
      return /* @__PURE__ */ React186.createElement(ChecklistItemBody, { style: { visibility: isExpanded2 ? "visible" : "hidden" } }, !!content && /* @__PURE__ */ React186.createElement(ChecklistItemContent, { dangerouslySetInnerHTML: { __html: parseMarkdown(content) } }), /* @__PURE__ */ React186.createElement(ChecklistItemButtonContainer, null, children));
    };
    StyledChecklistItemBody_default = StyledChecklistItemBody;
  }
});

// internal/src/client/themesV2/components/checklist/StyledChecklistItemHeader.tsx
import React187 from "react";
var ChecklistItemHeader, ExpandedChecklistItemHeader, ChecklistItemContent2, Checkbox3, CheckboxDone, Checkmark2, StyledChecklistItemHeader, StyledChecklistItemHeader_default;
var init_StyledChecklistItemHeader = __esm({
  "internal/src/client/themesV2/components/checklist/StyledChecklistItemHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_StyledIconContainer();
    ChecklistItemHeader = styled_browser_esm_default.div`
  display: flex;
  width: var(--checklist-width);
  padding: var(--layout-padding);
  align-items: flex-start;
  gap: var(--layout-gap);
`;
    ExpandedChecklistItemHeader = styled_browser_esm_default.div`
  display: flex;
  width: var(--checklist-width);
  padding: var(--layout-padding) var(--layout-padding) 0px var(--layout-padding);
  align-items: flex-start;
  gap: var(--layout-gap);
`;
    ChecklistItemContent2 = styled_browser_esm_default.div`
  color: var(--content-primary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    Checkbox3 = styled_browser_esm_default(StyledIconContainer_default)`
  padding: 8px;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 100px;
  border: 1px solid var(--content-secondary);
  opacity: 0.5;
`;
    CheckboxDone = styled_browser_esm_default(StyledIconContainer_default)`
  padding: 8px;
  gap: 8px;
  flex-shrink: 0;
  border-radius: 100px;
  background: var(--base-accent);
`;
    Checkmark2 = styled_browser_esm_default.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: var(--layout-padding);
  height: var(--layout-padding);
  color: var(--base-white);
`;
    StyledChecklistItemHeader = ({
      isExpanded: isExpanded2,
      isCompleted,
      content
    }) => {
      return isExpanded2 ? /* @__PURE__ */ React187.createElement(ExpandedChecklistItemHeader, null, isCompleted ? /* @__PURE__ */ React187.createElement(CheckboxDone, null, /* @__PURE__ */ React187.createElement(Checkmark2, null, /* @__PURE__ */ React187.createElement(Check_default, null))) : /* @__PURE__ */ React187.createElement(Checkbox3, null), !!content && /* @__PURE__ */ React187.createElement(ChecklistItemContent2, null, content)) : /* @__PURE__ */ React187.createElement(ChecklistItemHeader, null, isCompleted ? /* @__PURE__ */ React187.createElement(CheckboxDone, null, /* @__PURE__ */ React187.createElement(Checkmark2, null, /* @__PURE__ */ React187.createElement(Check_default, null))) : /* @__PURE__ */ React187.createElement(Checkbox3, null), !!content && /* @__PURE__ */ React187.createElement(ChecklistItemContent2, null, content));
    };
    StyledChecklistItemHeader_default = StyledChecklistItemHeader;
  }
});

// internal/src/client/themesV2/components/shared/StyledFooter.tsx
import React188 from "react";
var Footer, StyledFooter, StyledFooter_default;
var init_StyledFooter = __esm({
  "internal/src/client/themesV2/components/shared/StyledFooter.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Footer = styled_browser_esm_default.div`
  display: flex;
  width: 100%;
  padding: var(--layout-padding);
  border-radius: 0px 0px var(--layout-radius-card) var(--layout-radius-card);
  justify-content: space-between;
  align-items: center;
  background: var(--background-secondary);
`;
    StyledFooter = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React188.createElement(Footer, { ...props2 }, children);
    };
    StyledFooter_default = StyledFooter;
  }
});

// internal/src/client/themesV2/components/checklist/StyledChecklistProgressBar.tsx
import { css as css31, jsx as jsx52 } from "@emotion/core";
var ChecklistProgressBar, progressBarStyles, ProgressBarFill, ProgressLabel, slug17, StyledChecklistProgressBar, StyledProgressBarMock, StyledChecklistProgressBar_default;
var init_StyledChecklistProgressBar = __esm({
  "internal/src/client/themesV2/components/checklist/StyledChecklistProgressBar.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useComponentOverrides();
    ChecklistProgressBar = styled_browser_esm_default.div`
  display: flex;
  padding: var(--layout-padding);
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: var(--layout-gap);
  flex-shrink: 0;
`;
    progressBarStyles = {
      flexGrow: 1,
      height: "var(--form-control-padding-x)",
      borderRadius: "var(--layout-radius-circle)",
      background: "var(--background-secondary)"
    };
    ProgressBarFill = styled_browser_esm_default.div`
  height: var(--form-control-padding-x);
  border-radius: var(--layout-radius-circle);
  background: var(--base-accent);
`;
    ProgressLabel = styled_browser_esm_default.div`
  color: var(--content-secondary);

  /* label/base/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);
`;
    slug17 = "checklistProgressBar";
    StyledChecklistProgressBar = ({ themeV2, numCompleted, numTotal }) => {
      const { overrides } = useComponentOverrides_default(slug17, themeV2);
      const MIN_PERCENTAGBE = 0.04 * 100;
      const percentCompleted = Math.max(MIN_PERCENTAGBE, Math.round(numCompleted * 100 / numTotal));
      return /* @__PURE__ */ jsx52(ChecklistProgressBar, null, /* @__PURE__ */ jsx52(ProgressLabel, null, `${numCompleted}/${numTotal}`), /* @__PURE__ */ jsx52("div", { css: [overrides, css31(progressBarStyles)] }, /* @__PURE__ */ jsx52(ProgressBarFill, { style: { width: `${percentCompleted}%` } })));
    };
    StyledChecklistProgressBar.styles = progressBarStyles;
    StyledChecklistProgressBar.slug = slug17;
    StyledChecklistProgressBar.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx52(StyledProgressBarMock, { themeV2, mode });
    StyledProgressBarMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug17, { themeV2, mode });
      return /* @__PURE__ */ jsx52("div", { css: [overrides, css31(progressBarStyles)], style: { width: "350px" } }, /* @__PURE__ */ jsx52(ProgressBarFill, { style: { width: "25%" } }));
    };
    StyledChecklistProgressBar_default = StyledChecklistProgressBar;
  }
});

// internal/src/client/themesV2/components/checklist/StyledChecklistDivider.tsx
import React189 from "react";
var Divider, StyledChecklistDivider, StyledChecklistDivider_default;
var init_StyledChecklistDivider = __esm({
  "internal/src/client/themesV2/components/checklist/StyledChecklistDivider.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Divider = styled_browser_esm_default.div`
  height: 1px;
  align-self: stretch;
  background: var(--border-primary);
`;
    StyledChecklistDivider = () => {
      return /* @__PURE__ */ React189.createElement(Divider, null);
    };
    StyledChecklistDivider_default = StyledChecklistDivider;
  }
});

// internal/src/client/themesV2/components/checklist/StyledChecklist.tsx
import React190 from "react";
var Checklist2, StyledChecklist, StyledChecklist_default;
var init_StyledChecklist = __esm({
  "internal/src/client/themesV2/components/checklist/StyledChecklist.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    Checklist2 = styled_browser_esm_default.div`
  display: flex;
  width: var(--checklist-width);
  flex-direction: column;
  align-items: flex-start;

  border-radius: var(--layout-radius-card);
  border: 1px solid var(--border-primary);
  background: var(--background-primary);

  box-shadow: var(--layout-shadow) var(--layout-shadow-color);
  overflow: hidden;

  z-index: ${Z_default.Z_CHECKLIST};
  position: fixed;

  bottom: 24px;
  right: ${({ position }) => position === "bottomRight" ? "24px" : "auto"};
  left: ${({ position }) => position === "bottomLeft" ? "24px" : "auto"};
`;
    StyledChecklist = React190.forwardRef(({ children, ...props2 }, ref12) => {
      return /* @__PURE__ */ React190.createElement(Checklist2, { ref: ref12, ...props2 }, children);
    });
    StyledChecklist_default = StyledChecklist;
  }
});

// commandbar/src/shared/util/languages.tsx
var translations, translate;
var init_languages = __esm({
  "commandbar/src/shared/util/languages.tsx"() {
    "use strict";
    init_LocalStorage();
    translations = {
      "Choose a command to perform on this resource..": { spanish: "Elija un comando para realizar en este recurso" },
      "Type text and press enter": { spanish: "Escribe y presiona enter" },
      "Hit enter to select. Hit tab to continue.": {
        spanish: "Presiona enter para seleccionar. Presiona tab para continuar."
      },
      "What do you want to do?": { spanish: "\xBFQue quieres encontrar o hacer?" },
      "Detail (optional)": { spanish: "Detalles" },
      "Enter test mode": { spanish: "Entre el modo de examinar" },
      "Exit test mode": { spanish: "Exita al modo de examinar" },
      "Type Ctrl+K to open and close": { spanish: "Usa Ctrl+K para abrir y cerar" },
      "Suggest a new option": { spanish: "Sugiera a un comando" },
      "Can't find what you're looking for?": { spanish: "\xBFNo puedes encontrar lo que buscas?" },
      "Thanks for the suggestion!": { spanish: "Gracias por la sugerencia" },
      Submit: { spanish: "Enviar" },
      "to start and jump": { spanish: "para empezar y saltar" },
      "to close": { spanish: "cerar" },
      "Powered by Command AI": { spanish: "Desarrollado por CommandBar" },
      Title: { spanish: "Titulo" },
      Cancel: { spanish: "Cancelar" }
    };
    translate = (text) => {
      const isSpanish = LocalStorage_default.get("language", "") === "spanish";
      if (isSpanish && text in translations)
        return translations[text].spanish;
      return text;
    };
  }
});

// commandbar/src/shared/img/powered.svg
import * as React191 from "react";
var SvgPowered;
var init_powered = __esm({
  "commandbar/src/shared/img/powered.svg"() {
    "use strict";
    SvgPowered = (props2) => /* @__PURE__ */ React191.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 17, height: 16, fill: "none", viewBox: "0 0 17 16", ...props2 }, /* @__PURE__ */ React191.createElement("path", { fill: "#706E78", fillRule: "evenodd", d: "M11.67 5.585a.362.362 0 0 1-.258.463l-1.303.349a.468.468 0 0 1-.547-.296 3.835 3.835 0 1 0-.166 3.163.468.468 0 0 1 .575-.236l1.215.466a.34.34 0 0 1 .01.004l4.54 1.743c.22.084.33.332.246.553l-.46 1.198a.428.428 0 0 1-.553.246l-2.882-1.106-.41-.157c-.296-.114-.623-.243-.846-.482a3.092 3.092 0 0 1-.183-.222 5.99 5.99 0 0 1-9.41-.123A5.992 5.992 0 1 1 11.67 5.585Z", clipRule: "evenodd" }));
  }
});

// commandbar/src/shared/util/branding.ts
var navigateToBrandingSite;
var init_branding = __esm({
  "commandbar/src/shared/util/branding.ts"() {
    "use strict";
    init_Reporting();
    navigateToBrandingSite = (org) => {
      clickedBranding();
      window.open(`https://commandbar.com/powered-by-commandbar?org=${(org == null ? void 0 : org.name) || encodeURI("This app")}`, "_blank");
    };
  }
});

// commandbar/src/products/helphub/components/PoweredBy.tsx
import { jsx as jsx53 } from "@emotion/core";
var PoweredBy2, PoweredBy_default;
var init_PoweredBy = __esm({
  "commandbar/src/products/helphub/components/PoweredBy.tsx"() {
    "use strict";
    init_useStyles();
    init_useStore();
    init_languages();
    init_powered();
    init_branding();
    PoweredBy2 = (buttonProps) => {
      const styles51 = useStyles();
      const _ = useStore();
      const { organization } = _;
      if ((organization == null ? void 0 : organization.branding) === "branded") {
        return /* @__PURE__ */ jsx53("button", { css: { ...styles51.poweredBy }, onClick: () => navigateToBrandingSite(organization), ...buttonProps }, /* @__PURE__ */ jsx53(SvgPowered, { title: "CommandBar", role: "img", focusable: false, width: 16 }), /* @__PURE__ */ jsx53("span", null, translate("Powered by Command AI")));
      }
      return null;
    };
    PoweredBy_default = PoweredBy2;
  }
});

// commandbar/src/shared/util/hooks/useSelector.tsx
import React192 from "react";
var useSelector, useSelector_default;
var init_useSelector = __esm({
  "commandbar/src/shared/util/hooks/useSelector.tsx"() {
    "use strict";
    init_useStore();
    useSelector = (selectorFn) => {
      const _ = useStore();
      return React192.useCallback(selectorFn.bind(null, _), [_]);
    };
    useSelector_default = useSelector;
  }
});

// commandbar/src/products/checklists/components/Checklist.tsx
var Checklist_exports = {};
__export(Checklist_exports, {
  Checklist: () => Checklist3,
  default: () => Checklist_default
});
import React193, { useEffect as useEffect40, useLayoutEffect as useLayoutEffect2, useMemo as useMemo9, useRef as useRef30, useState as useState23 } from "react";
import ReactDOM7 from "react-dom";
var ChecklistContainer, Checklist3, ProgressBar, ChecklistHeader2, ChecklistBody, Checklist_default;
var init_Checklist = __esm({
  "commandbar/src/products/checklists/components/Checklist.tsx"() {
    "use strict";
    init_checklist_styles();
    init_actions5();
    init_check();
    init_useStore();
    init_useAction();
    init_selectors6();
    init_Collapse();
    init_Reporting();
    init_Interpolate();
    init_dispatchCustomEvent();
    init_location();
    init_DraftFooter();
    init_theme3();
    init_useDisableZoom();
    init_useDraggable();
    init_useMobileExperience();
    init_react();
    init_StyledPrimaryButton();
    init_StyledSecondaryButton();
    init_StyledTertiaryButton();
    init_StyledPoweredBy();
    init_StyledChecklistHeader();
    init_StyledChecklistItemBody();
    init_StyledChecklistItemHeader();
    init_StyledFooter();
    init_StyledChecklistProgressBar();
    init_StyledChecklistDivider();
    init_StyledChecklist();
    init_PoweredBy();
    init_useTheme();
    init_branding();
    init_languages();
    init_useSelector();
    init_globals();
    init_symbols();
    init_ThemeV2Context();
    init_StyledNudgeTitleBlock();
    init_AnimatedWidget();
    ChecklistContainer = () => {
      var _a2, _b2;
      const _ = useStore();
      const organization = _.organization;
      const _isItemCompleted = useSelector_default(isItemCompleted);
      const [modalEl, setModalEl] = React193.useState(null);
      useDraggable_default(modalEl, true, false);
      const lastActiveChecklist = useRef30(null);
      if (_.activeChecklist) {
        lastActiveChecklist.current = _.activeChecklist;
      }
      const activeChecklist = !((_a2 = _.flags) == null ? void 0 : _a2["release-widget-animations"]) || !((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? _.activeChecklist : lastActiveChecklist.current;
      return /* @__PURE__ */ React193.createElement(
        BindThemeV2ByUUID,
        {
          themeUUID: (activeChecklist == null ? void 0 : activeChecklist.custom_theme) || (organization == null ? void 0 : organization.checklists_custom_theme),
          nudge: activeChecklist || void 0
        },
        /* @__PURE__ */ React193.createElement(AnimatedWidget, { widget: "checklist", isMounted: !!_.activeChecklist }, activeChecklist && /* @__PURE__ */ React193.createElement(Checklist3, { parentCallbackRef: setModalEl, checklist: activeChecklist, isItemCompleted: _isItemCompleted }))
      );
    };
    Checklist3 = (props2) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j;
      const { checklist: checklist3, parentCallbackRef, style: style3, isItemCompleted: isItemCompleted2 } = props2;
      const _ = useStore();
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const triggeredNudgeIdRef = React193.useRef(null);
      const { setZoomDisabled } = useDisableZoom();
      const { animStyles } = useAnimatedWidget();
      const markCompleted = useAction((_2) => markChecklistAsCompleted(_2, checklist3), [checklist3.id]);
      const markSkipped = useAction((_2) => markChecklistAsSkipped(_2, checklist3), [checklist3.id]);
      const markExpanded = useAction((_2) => setChecklistExpandedState(_2, checklist3, true), [checklist3.id]);
      const markCollapsed = useAction(
        (_2) => setChecklistExpandedState(_2, checklist3, false),
        [checklist3.id]
      );
      const ref12 = React193.useRef(null);
      const [checklistOffsetX, setChecklistOffsetX] = React193.useState(null);
      const { isMobileDevice: isMobileDevice2, isStudioMobilePreview, studioMobilePreviewWrapper, mobileStyles } = useMobileExperience();
      useLayoutEffect2(() => {
        if (isStudioPreview())
          return;
        const helphubDiv = document.getElementById("helphub-modal");
        if (helphubDiv && (ref12 == null ? void 0 : ref12.current) && !isMobileDevice2 && _.helpHub.visible) {
          const helphubDivRect = helphubDiv.getBoundingClientRect();
          const refRect = ref12.current.getBoundingClientRect();
          const isIntersecting = refRect.right > helphubDivRect.left && refRect.left < helphubDivRect.right && refRect.bottom > helphubDivRect.top && refRect.top < helphubDivRect.bottom;
          if (!isIntersecting) {
            return;
          }
          const viewportWidth = window.innerWidth;
          const style4 = window.getComputedStyle(helphubDiv);
          const transformMatrix = style4.transform;
          const helphubDivWidth = helphubDiv.offsetWidth;
          let helphubDivOffsetLeft = helphubDiv.offsetLeft;
          let spaceOnLeft = helphubDivOffsetLeft;
          let spaceOnRight = window.innerWidth - (helphubDivOffsetLeft + helphubDivWidth);
          const questlistSpaceOnRight = viewportWidth - (ref12.current.offsetLeft + ref12.current.offsetWidth);
          const matrixValues = transformMatrix.match(/matrix.*\((.+)\)/);
          if (matrixValues && matrixValues.length === 2) {
            const values = matrixValues[1].split(", ");
            const translateX = parseFloat(values[4]);
            helphubDivOffsetLeft = helphubDiv.offsetLeft + translateX;
            spaceOnLeft = helphubDivOffsetLeft;
            spaceOnRight = viewportWidth - (helphubDivOffsetLeft + helphubDivWidth);
          }
          if (checklist3.position === "bottomLeft" && ref12.current.offsetLeft + ref12.current.offsetWidth > spaceOnLeft || checklist3.position === "bottomRight" && questlistSpaceOnRight + ref12.current.offsetWidth > spaceOnRight) {
            if (spaceOnLeft > spaceOnRight) {
              setChecklistOffsetX(-(spaceOnRight + helphubDivWidth));
            } else if (spaceOnRight > spaceOnLeft) {
              setChecklistOffsetX(helphubDivWidth + spaceOnLeft);
            }
          }
        }
        return () => {
          setChecklistOffsetX(null);
        };
      }, [_.helpHub.visible]);
      const addGoalListeners2 = useAction(addGoalListeners);
      const [open, setOpen] = useState23((_b2 = (_a2 = checklist3._editorState) == null ? void 0 : _a2.expanded) != null ? _b2 : isExpanded(_, checklist3));
      useEffect40(() => {
        var _a3, _b3;
        setOpen((_b3 = (_a3 = checklist3._editorState) == null ? void 0 : _a3.expanded) != null ? _b3 : isExpanded(_, checklist3));
      }, [(_c2 = checklist3._editorState) == null ? void 0 : _c2.expanded, _.endUserStore.data.checklist_interactions]);
      useEffect40(() => {
        setZoomDisabled(open);
      }, [open]);
      const isIncomplete = hasIncompleteItems(_, checklist3);
      React193.useEffect(() => {
        const removeGoalListeners = addGoalListeners2(checklist3, checklist3.items);
        return removeGoalListeners;
      }, [checklist3.items, _.endUserStore.data.checklist_interactions, _.location.pathname]);
      const firstIncompleteIdx = React193.useMemo(
        () => checklist3.items.findIndex((i2) => !isItemCompleted2(checklist3, i2)),
        [checklist3, _.endUserStore.data.checklist_interactions, isItemCompleted2]
      );
      let defaultOpenIdx = firstIncompleteIdx;
      if (typeof ((_d = checklist3 == null ? void 0 : checklist3._editorState) == null ? void 0 : _d.initial_active_item) === "number") {
        defaultOpenIdx = checklist3._editorState.initial_active_item;
      }
      const totalItems = checklist3.items.length;
      const completedItems = checklist3.items.filter((item) => isItemCompleted2(checklist3, item)).length;
      const onExpandedItemChange = (idx) => {
        checklistItemEngagement(checklist3.items[idx], checklist3.id, !isIncomplete, "expanded");
      };
      const onSelect = useAction((_2, item) => (e) => {
        onChecklistItemSelect(_2, item, e);
        onItemClick(item);
        if (item.action.type === "nudge" || item.action.type === "open_bar" || item.action.type === "execute_command") {
          onOpenChange(false);
        }
      });
      React193.useEffect(() => {
        dispatchCustomEvent("commandbar-checklist-shown", {});
      }, [checklist3.position]);
      React193.useEffect(() => {
        var _a3;
        let unsubscribe = void 0;
        const sdk = getSDK();
        const listenerSymbol = Symbol(`checklistListener-${checklist3.id}`);
        if (!!sdk[_eventSubscriptions] && sdk[_eventSubscriptions] !== void 0) {
          (_a3 = sdk[_eventSubscriptions]) == null ? void 0 : _a3.set(listenerSymbol, [
            (_name, data) => {
              var _a4;
              if (data.type === "nudge_completed" && data.nudge.id === ((_a4 = triggeredNudgeIdRef.current) == null ? void 0 : _a4.toString())) {
                setOpen(true);
                triggeredNudgeIdRef.current = null;
              }
            },
            void 0
          ]);
          unsubscribe = () => {
            var _a4;
            (_a4 = sdk[_eventSubscriptions]) == null ? void 0 : _a4.delete(listenerSymbol);
          };
        }
        return () => {
          unsubscribe == null ? void 0 : unsubscribe();
        };
      }, []);
      const onItemClick = (item) => {
        if (item.action.type === "nudge") {
          triggeredNudgeIdRef.current = item.action.value.toString();
        }
      };
      const onOpenChange = (open2) => {
        checklistEngagement(checklist3, completedItems, open2 ? "expanded" : "collapsed", !isIncomplete);
        if (open2) {
          markExpanded();
        } else {
          markCollapsed();
        }
        setOpen(open2);
      };
      const interpolatedChecklistTitle = useMemo9(() => {
        return interpolateObject({
          s: checklist3.title,
          _,
          interpolateContext: true,
          interpolateArgs: false
        });
      }, [checklist3.title, _.context]);
      const interpolatedChecklistDescription = useMemo9(() => {
        if (!checklist3.description) {
          return "";
        }
        return interpolateObject({
          s: checklist3.description,
          _,
          interpolateContext: true,
          interpolateArgs: false
        });
      }, [checklist3.description, _.context]);
      const commandBarWrapper = (_e = document.getElementById("commandbar-wrapper")) == null ? void 0 : _e.getBoundingClientRect();
      const editorAdjustmentStyle = !_.showWidgetTableau && isStudioPreview() && !isStudioMobilePreview && commandBarWrapper ? {
        left: commandBarWrapper.left + commandBarWrapper.width / 2 - CHECKLIST_WIDTH / 2,
        right: 0,
        bottom: 24
      } : void 0;
      const content = ((_f = _.flags) == null ? void 0 : _f["release-themes-v2"]) ? /* @__PURE__ */ React193.createElement(
        StyledChecklist_default,
        {
          role: "region",
          "aria-label": interpolatedChecklistTitle,
          tabIndex: -1,
          onKeyDown: (e) => {
            if (checklist3.skippable && e.key === "Escape") {
              markSkipped();
            }
          },
          ref: (node) => {
            if (parentCallbackRef)
              parentCallbackRef(node);
            ref12.current = node;
          },
          className: "commandbar-checklist",
          position: checklist3.position,
          style: {
            ...editorAdjustmentStyle,
            ...checklistOffsetX !== null ? { transform: `translate(${toPx(checklistOffsetX)}, ${toPx(0)})` } : null,
            ...isMobileDevice2 && mobileStyles.checklists.container,
            ...style3,
            ...animStyles
          },
          "data-testid": `commandbar-checklist-${interpolatedChecklistTitle}`
        },
        /* @__PURE__ */ React193.createElement(
          Collapse,
          {
            open,
            editorTimeStamp: (_g = checklist3._editorState) == null ? void 0 : _g.timestamp,
            onChange: onOpenChange,
            footer: /* @__PURE__ */ React193.createElement(StyledFooter_default, { style: { justifyContent: ((_h = _.organization) == null ? void 0 : _h.branding) === "branded" ? "space-between" : "end" } }, ((_i = _.organization) == null ? void 0 : _i.branding) === "branded" && /* @__PURE__ */ React193.createElement(
              StyledPoweredBy_default,
              {
                onClick: () => navigateToBrandingSite(_.organization),
                text: translate("Powered by Command AI")
              }
            ), hasIncompleteItems(_, checklist3) ? checklist3.skippable && /* @__PURE__ */ React193.createElement("div", null, /* @__PURE__ */ React193.createElement(StyledSecondaryButton_default, { themeV2, onClick: markSkipped }, "Skip")) : /* @__PURE__ */ React193.createElement("div", null, /* @__PURE__ */ React193.createElement(StyledPrimaryButton_default, { onClick: markCompleted, themeV2, suffixIcon: /* @__PURE__ */ React193.createElement(SvgCheck, null) }, "Done"))),
            header: (isOpen) => /* @__PURE__ */ React193.createElement(React193.Fragment, null, /* @__PURE__ */ React193.createElement(
              StyledChecklistHeader_default,
              {
                isExpanded: !!isOpen,
                title: interpolatedChecklistTitle,
                subtitle: interpolatedChecklistDescription,
                isDismissible: checklist3.dismissible,
                onClose: (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  markSkipped();
                },
                themeV2
              }
            ), /* @__PURE__ */ React193.createElement(StyledChecklistProgressBar_default, { numCompleted: completedItems, numTotal: totalItems, themeV2 }))
          },
          () => {
            var _a3;
            return /* @__PURE__ */ React193.createElement(React193.Fragment, null, /* @__PURE__ */ React193.createElement(StyledChecklistDivider_default, null), /* @__PURE__ */ React193.createElement(
              Accordion,
              {
                containerStyles: { maxHeight: "var(--checklist-max-height)", overflow: "hidden auto" },
                onExpandedItemChange,
                items: checklist3.items.map((item) => ({
                  header: (isOpen) => /* @__PURE__ */ React193.createElement(
                    ChecklistHeader2,
                    {
                      isExpanded: !!isOpen,
                      item,
                      isCompleted: isItemCompleted2(checklist3, item),
                      key: `checklist-item-header-${item.id}`
                    }
                  ),
                  children: (isOpen) => /* @__PURE__ */ React193.createElement(
                    ChecklistBody,
                    {
                      item,
                      key: `checklist-item-body-${item.id}`,
                      isCompleted: isItemCompleted2(checklist3, item),
                      toggleChecklist: onOpenChange,
                      isExpanded: !!isOpen,
                      onItemClick
                    }
                  ),
                  divider: /* @__PURE__ */ React193.createElement(StyledChecklistDivider_default, null),
                  onClickWhileOpen: item.description || item.cta ? void 0 : onSelect(item)
                })),
                defaultOpenIdx,
                editorTimeStamp: (_a3 = checklist3._editorState) == null ? void 0 : _a3.timestamp,
                divider: /* @__PURE__ */ React193.createElement(StyledChecklistDivider_default, null)
              }
            ));
          }
        ),
        !checklist3.is_live && /* @__PURE__ */ React193.createElement(DraftFooter, { details: { type: "checklist", checklistId: checklist3.id } })
      ) : (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
        /* @__PURE__ */ React193.createElement(
          "div",
          {
            role: "region",
            "aria-label": interpolatedChecklistTitle,
            tabIndex: -1,
            onKeyDown: (e) => {
              if (checklist3.skippable && e.key === "Escape") {
                markSkipped();
              }
            },
            ref: (node) => {
              if (parentCallbackRef)
                parentCallbackRef(node);
              ref12.current = node;
            },
            className: "commandbar-checklist",
            style: {
              ...checklist_styles_default.checklist.container(theme, checklist3.position),
              ...editorAdjustmentStyle,
              ...checklistOffsetX !== null ? { transform: `translate(${toPx(checklistOffsetX)}, ${toPx(0)})` } : null,
              ...isMobileDevice2 && mobileStyles.checklists.container,
              ...style3
            },
            "data-testid": `commandbar-checklist-${interpolatedChecklistTitle}`
          },
          /* @__PURE__ */ React193.createElement(
            Collapse,
            {
              open,
              editorTimeStamp: (_j = checklist3._editorState) == null ? void 0 : _j.timestamp,
              onChange: onOpenChange,
              footer: /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.checklist.footer(theme) }, /* @__PURE__ */ React193.createElement(PoweredBy_default, { style: { color: "#71717A" } }), hasIncompleteItems(_, checklist3) ? checklist3.skippable && /* @__PURE__ */ React193.createElement("button", { style: checklist_styles_default.checklist.secondaryBtn(theme), onClick: markSkipped }, "Skip") : /* @__PURE__ */ React193.createElement("button", { style: checklist_styles_default.checklist.primaryBtn(theme), onClick: markCompleted }, "Done ", /* @__PURE__ */ React193.createElement(SvgCheck, { style: { color: "#A2A2A9" } }))),
              header: (isOpen) => /* @__PURE__ */ React193.createElement(React193.Fragment, null, /* @__PURE__ */ React193.createElement(
                "div",
                {
                  style: checklist_styles_default.checklist.textContainer(theme),
                  "data-draggable": "drag-zone",
                  "aria-label": "Drag to move checklist"
                },
                /* @__PURE__ */ React193.createElement(
                  "div",
                  {
                    style: {
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      color: "#A2A2A9",
                      width: "100%",
                      fontSize: 8
                    }
                  },
                  /* @__PURE__ */ React193.createElement(
                    "div",
                    {
                      style: {
                        display: "flex",
                        alignItems: "center",
                        gap: "8px"
                      }
                    },
                    /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.checklist.title(theme) }, interpolatedChecklistTitle),
                    /* @__PURE__ */ React193.createElement("div", { style: { cursor: "pointer", display: "flex" } }, isOpen ? /* @__PURE__ */ React193.createElement(Caret_default, { style: checklist_styles_default.checklist.chevron(theme), viewBox: "-4 0 16 6" }) : /* @__PURE__ */ React193.createElement(
                      Caret_default,
                      {
                        style: {
                          transform: "rotate(180deg)",
                          ...checklist_styles_default.checklist.chevron(theme)
                        },
                        viewBox: "-4 0 16 6"
                      }
                    ))
                  ),
                  checklist3.dismissible && /* @__PURE__ */ React193.createElement(
                    "div",
                    {
                      style: {
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center"
                      }
                    },
                    /* @__PURE__ */ React193.createElement(
                      XClose_default,
                      {
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          markSkipped();
                        }
                      }
                    )
                  )
                ),
                interpolatedChecklistDescription && /* @__PURE__ */ React193.createElement(
                  "div",
                  {
                    style: checklist_styles_default.checklist.description(theme),
                    dangerouslySetInnerHTML: { __html: parseMarkdown(interpolatedChecklistDescription) }
                  }
                )
              ), /* @__PURE__ */ React193.createElement(ProgressBar, { numCompleted: completedItems, numTotal: totalItems }))
            },
            () => {
              var _a3;
              return /* @__PURE__ */ React193.createElement(React193.Fragment, null, /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.checklist.divider(theme) }), /* @__PURE__ */ React193.createElement(
                Accordion,
                {
                  containerStyles: checklist_styles_default.checklist.itemsContainer(theme),
                  onExpandedItemChange,
                  items: checklist3.items.map((item) => ({
                    header: (isOpen) => /* @__PURE__ */ React193.createElement(
                      ChecklistHeader2,
                      {
                        isExpanded: !!isOpen,
                        item,
                        isCompleted: isItemCompleted2(checklist3, item),
                        key: `checklist-item-header-${item.id}`
                      }
                    ),
                    children: (isOpen) => /* @__PURE__ */ React193.createElement(
                      ChecklistBody,
                      {
                        item,
                        key: `checklist-item-body-${item.id}`,
                        isCompleted: isItemCompleted2(checklist3, item),
                        toggleChecklist: onOpenChange,
                        isExpanded: !!isOpen,
                        onItemClick
                      }
                    ),
                    divider: /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.checklist.divider(theme) }),
                    onClickWhileOpen: item.description || item.cta ? void 0 : onSelect(item)
                  })),
                  defaultOpenIdx,
                  editorTimeStamp: (_a3 = checklist3._editorState) == null ? void 0 : _a3.timestamp,
                  divider: /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.checklist.divider(theme) })
                }
              ));
            }
          ),
          !checklist3.is_live && /* @__PURE__ */ React193.createElement(DraftFooter, { details: { type: "checklist", checklistId: checklist3.id } })
        )
      );
      if (isStudioMobilePreview && studioMobilePreviewWrapper) {
        return ReactDOM7.createPortal(content, studioMobilePreviewWrapper);
      }
      return content;
    };
    ProgressBar = (props2) => {
      const { theme } = useTheme();
      const MIN_PERCENTAGBE = 0.04 * 100;
      const percentCompleted = Math.max(MIN_PERCENTAGBE, Math.round(props2.numCompleted * 100 / props2.numTotal));
      return /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.progressBar.container(theme) }, /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.progressBar.text(theme) }, `${props2.numCompleted}/${props2.numTotal}`), /* @__PURE__ */ React193.createElement("div", { style: checklist_styles_default.progressBar.progressContainer(theme) }, /* @__PURE__ */ React193.createElement("div", { style: { ...checklist_styles_default.progressBar.progressFill(theme), width: `${percentCompleted}%` } })));
    };
    ChecklistHeader2 = (props2) => {
      var _a2;
      const _ = useStore();
      const { item, isCompleted, isExpanded: isExpanded2 } = props2;
      const { theme } = useTheme();
      const interpolatedItemTitle = useMemo9(
        () => interpolateObject({
          s: item.title,
          _,
          interpolateContext: true,
          interpolateArgs: false
        }),
        [item.title, _.context]
      );
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React193.createElement(StyledChecklistItemHeader_default, { content: interpolatedItemTitle, isExpanded: isExpanded2, isCompleted }) : /* @__PURE__ */ React193.createElement(
        "div",
        {
          style: isExpanded2 ? checklist_styles_default.checklistItem.expandedTitleContainer(theme) : checklist_styles_default.checklistItem.titleContainer(theme)
        },
        /* @__PURE__ */ React193.createElement(
          "div",
          {
            style: isCompleted ? checklist_styles_default.checklistItem.checkboxComplete(theme) : checklist_styles_default.checklistItem.checkboxIncomplete(theme)
          },
          /* @__PURE__ */ React193.createElement(SvgCheck, { stroke: isCompleted ? "#FFF" : "#CDCDD0" })
        ),
        /* @__PURE__ */ React193.createElement("span", { style: isCompleted ? checklist_styles_default.checklistItem.titleCompleted(theme) : checklist_styles_default.checklistItem.title(theme) }, interpolatedItemTitle)
      );
    };
    ChecklistBody = (props2) => {
      var _a2;
      const { item, isCompleted, isExpanded: isExpanded2, onItemClick } = props2;
      const itemRef = React193.useRef(item);
      React193.useEffect(() => {
        itemRef.current = props2.item;
      }, [props2.item.action]);
      const _ = useStore();
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const onSelect = useAction(
        (_2, e) => onChecklistItemSelect(_2, itemRef.current, e)
      );
      const onSkip = useAction((_2) => onChecklistItemComplete(_2, item, true));
      const handleClick = (e) => {
        onSelect(e);
        onItemClick(itemRef.current);
        if (item.action.type === "nudge" || item.action.type === "open_bar" || item.action.type === "execute_command") {
          props2.toggleChecklist(false);
        }
      };
      const interpolatedItemDescription = useMemo9(() => {
        if (!item.description) {
          return "";
        }
        return interpolateObject({
          s: item.description,
          _,
          interpolateContext: true,
          interpolateArgs: false
        });
      }, [item.description, _.context]);
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React193.createElement(StyledChecklistItemBody_default, { content: interpolatedItemDescription, isExpanded: isExpanded2 }, !!item.cta && !!onSelect && /* @__PURE__ */ React193.createElement(
        StyledPrimaryButton_default,
        {
          onClick: handleClick,
          themeV2,
          style: { flex: "unset", overflow: "hidden", width: "unset" }
        },
        item.cta
      ), item.skippable && !isCompleted && /* @__PURE__ */ React193.createElement(StyledTertiaryButton_default, { themeV2, onClick: onSkip, style: { flex: "unset", width: "unset" } }, "Skip")) : /* @__PURE__ */ React193.createElement("section", { style: { ...checklist_styles_default.checklistItem.bodyContainer(theme), visibility: isExpanded2 ? "visible" : "hidden" } }, /* @__PURE__ */ React193.createElement(
        "div",
        {
          style: checklist_styles_default.checklistItem.description(theme),
          dangerouslySetInnerHTML: { __html: parseMarkdown(interpolatedItemDescription) }
        }
      ), !!item.cta && !!onSelect && /* @__PURE__ */ React193.createElement(
        "button",
        {
          type: "button",
          style: {
            ...checklist_styles_default.checklistItem.ctaButton(theme),
            marginTop: !!interpolatedItemDescription ? "14px" : "4px"
          },
          onClick: handleClick
        },
        item.cta
      ), item.skippable && !isCompleted && /* @__PURE__ */ React193.createElement("button", { type: "button", style: checklist_styles_default.checklistItem.textBtn(theme), onClick: onSkip }, "Skip"));
    };
    Checklist_default = ChecklistContainer;
  }
});

// node_modules/rc-dialog/assets/index.css
var init_assets = __esm({
  "node_modules/rc-dialog/assets/index.css"() {
    init_index();
    inject_style('.rc-dialog{position:relative;width:auto;margin:10px}.rc-dialog-wrap{position:fixed;overflow:auto;inset:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.rc-dialog-title{margin:0;font-size:14px;line-height:21px;font-weight:700}.rc-dialog-content{position:relative;background-color:#fff;border:none;border-radius:6px;background-clip:padding-box}.rc-dialog-close{cursor:pointer;border:0;background:transparent;font-size:21px;position:absolute;right:20px;top:12px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;filter:alpha(opacity=20);opacity:.2;text-decoration:none}.rc-dialog-close-x:after{content:"\xD7"}.rc-dialog-close:hover{opacity:1;filter:alpha(opacity=100);text-decoration:none}.rc-dialog-header{padding:13px 20px 14px;border-radius:5px 5px 0 0;background:#fff;color:#666;border-bottom:1px solid #e9e9e9}.rc-dialog-body{padding:20px}.rc-dialog-footer{border-top:1px solid #e9e9e9;padding:10px 20px;text-align:right;border-radius:0 0 5px 5px}.rc-dialog-zoom-enter,.rc-dialog-zoom-appear{opacity:0;animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.08,.82,.17,1);animation-play-state:paused}.rc-dialog-zoom-leave{animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.6,.04,.98,.34);animation-play-state:paused}.rc-dialog-zoom-enter.rc-dialog-zoom-enter-active,.rc-dialog-zoom-appear.rc-dialog-zoom-appear-active{animation-name:rcDialogZoomIn;animation-play-state:running}.rc-dialog-zoom-leave.rc-dialog-zoom-leave-active{animation-name:rcDialogZoomOut;animation-play-state:running}@keyframes rcDialogZoomIn{0%{opacity:0;transform:scale(0)}to{opacity:1;transform:scale(1)}}@keyframes rcDialogZoomOut{0%{transform:scale(1)}to{opacity:0;transform:scale(0)}}@media (min-width: 768px){.rc-dialog{width:600px;margin:30px auto}}.rc-dialog-mask{position:fixed;inset:0;background-color:#373737;background-color:#37373799;height:100%;filter:alpha(opacity=50);z-index:1050}.rc-dialog-mask-hidden{display:none}.rc-dialog-fade-enter,.rc-dialog-fade-appear{opacity:0;animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.55,0,.55,.2);animation-play-state:paused}.rc-dialog-fade-leave{animation-duration:.3s;animation-fill-mode:both;animation-timing-function:cubic-bezier(.55,0,.55,.2);animation-play-state:paused}.rc-dialog-fade-enter.rc-dialog-fade-enter-active,.rc-dialog-fade-appear.rc-dialog-fade-appear-active{animation-name:rcDialogFadeIn;animation-play-state:running}.rc-dialog-fade-leave.rc-dialog-fade-leave-active{animation-name:rcDialogFadeOut;animation-play-state:running}@keyframes rcDialogFadeIn{0%{opacity:0}to{opacity:1}}@keyframes rcDialogFadeOut{0%{opacity:1}to{opacity:0}}');
  }
});

// commandbar/src/style/App.ts
import { css as css32 } from "@emotion/core";
var App_default;
var init_App = __esm({
  "commandbar/src/style/App.ts"() {
    "use strict";
    App_default = css32`
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
`;
  }
});

// commandbar/src/style/rc-tooltip/style.ts
var style2, style_default;
var init_style = __esm({
  "commandbar/src/style/rc-tooltip/style.ts"() {
    "use strict";
    style2 = `
  .commandbar-tooltip.commandbar-tooltip-zoom-enter,
  .commandbar-tooltip.commandbar-tooltip-zoom-leave {
    display: block;
  }
  .commandbar-tooltip-zoom-enter,
  .commandbar-tooltip-zoom-appear {
    opacity: 0;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
    animation-play-state: paused;
  }
  .commandbar-tooltip-zoom-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
    animation-play-state: paused;
  }
  .commandbar-tooltip-zoom-enter.commandbar-tooltip-zoom-enter-active,
  .commandbar-tooltip-zoom-appear.commandbar-tooltip-zoom-appear-active {
    animation-name: rcToolTipZoomIn;
    animation-play-state: running;
  }
  .commandbar-tooltip-zoom-leave.commandbar-tooltip-zoom-leave-active {
    animation-name: rcToolTipZoomOut;
    animation-play-state: running;
  }
  @keyframes rcToolTipZoomIn {
    0% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(0, 0);
    }
    100% {
      opacity: 1;
      transform-origin: 50% 50%;
      transform: scale(1, 1);
    }
  }
  @keyframes rcToolTipZoomOut {
    0% {
      opacity: 1;
      transform-origin: 50% 50%;
      transform: scale(1, 1);
    }
    100% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(0, 0);
    }
  }
  .commandbar-tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    visibility: visible;
    font-size: 12px;
    line-height: 1.5;
    opacity: 0.9;
  }
  .commandbar-tooltip-hidden {
    display: none;
  }
  .commandbar-tooltip-placement-top,
  .commandbar-tooltip-placement-topLeft,
  .commandbar-tooltip-placement-topRight {
    padding: 5px 0 9px 0;
  }
  .commandbar-tooltip-placement-right,
  .commandbar-tooltip-placement-rightTop,
  .commandbar-tooltip-placement-rightBottom {
    padding: 0 5px 0 9px;
  }
  .commandbar-tooltip-placement-bottom,
  .commandbar-tooltip-placement-bottomLeft,
  .commandbar-tooltip-placement-bottomRight {
    padding: 9px 0 5px 0;
  }
  .commandbar-tooltip-placement-left,
  .commandbar-tooltip-placement-leftTop,
  .commandbar-tooltip-placement-leftBottom {
    padding: 0 9px 0 5px;
  }
  .commandbar-tooltip-inner {
    padding: 8px 10px;
    color: #d5d6d7 !important;
    text-align: left;
    text-decoration: none;
    background-color: #373737;
    border-radius: 6px;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.17);
  }

  .commandbar-tooltip-inner > span {
    color: inherit;
  }

  .commandbar-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
  }
  .commandbar-tooltip-placement-top .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-topLeft .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-topRight .commandbar-tooltip-arrow {
    bottom: 4px;
    margin-left: -5px;
    border-width: 5px 5px 0;
    border-top-color: #373737;
  }
  .commandbar-tooltip-placement-top .commandbar-tooltip-arrow {
    left: 50%;
  }
  .commandbar-tooltip-placement-topLeft .commandbar-tooltip-arrow {
    left: 15%;
  }
  .commandbar-tooltip-placement-topRight .commandbar-tooltip-arrow {
    right: 15%;
  }
  .commandbar-tooltip-placement-right .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-rightTop .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-rightBottom .commandbar-tooltip-arrow {
    left: 4px;
    margin-top: -5px;
    border-width: 5px 5px 5px 0;
    border-right-color: #373737;
  }
  .commandbar-tooltip-placement-right .commandbar-tooltip-arrow {
    top: 50%;
  }
  .commandbar-tooltip-placement-rightTop .commandbar-tooltip-arrow {
    top: 15%;
    margin-top: 0;
  }
  .commandbar-tooltip-placement-rightBottom .commandbar-tooltip-arrow {
    bottom: 15%;
  }
  .commandbar-tooltip-placement-left .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-leftTop .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-leftBottom .commandbar-tooltip-arrow {
    right: 4px;
    margin-top: -5px;
    border-width: 5px 0 5px 5px;
    border-left-color: #373737;
  }
  .commandbar-tooltip-placement-left .commandbar-tooltip-arrow {
    top: 50%;
  }
  .commandbar-tooltip-placement-leftTop .commandbar-tooltip-arrow {
    top: 15%;
    margin-top: 0;
  }
  .commandbar-tooltip-placement-leftBottom .commandbar-tooltip-arrow {
    bottom: 15%;
  }
  .commandbar-tooltip-placement-bottom .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-bottomLeft .commandbar-tooltip-arrow,
  .commandbar-tooltip-placement-bottomRight .commandbar-tooltip-arrow {
    top: 4px;
    margin-left: -5px;
    border-width: 0 5px 5px;
    border-bottom-color: #373737;
  }
  .commandbar-tooltip-placement-bottom .commandbar-tooltip-arrow {
    left: 50%;
  }
  .commandbar-tooltip-placement-bottomLeft .commandbar-tooltip-arrow {
    left: 15%;
  }
  .commandbar-tooltip-placement-bottomRight .commandbar-tooltip-arrow {
    right: 15%;
  }
`;
    style_default = style2;
  }
});

// commandbar/src/products/spotlight/components/EditorDashboard.tsx
import React194 from "react";
import chroma10 from "chroma-js";
import memoize2 from "lodash/memoize";
var getEditorDashboards;
var init_EditorDashboard = __esm({
  "commandbar/src/products/spotlight/components/EditorDashboard.tsx"() {
    "use strict";
    getEditorDashboards = memoize2((background) => {
      let isLightBackground = true;
      try {
        isLightBackground = chroma10(background).luminance() > 0.8;
      } catch (e) {
      }
      return {
        loading: !!isLightBackground ? /* @__PURE__ */ React194.createElement("div", null, /* @__PURE__ */ React194.createElement("img", { alt: "light paperplane", src: "https://staticassets.commandbar.com/commandbar/paperplane_white_300.gif" })) : /* @__PURE__ */ React194.createElement("div", null, /* @__PURE__ */ React194.createElement("img", { alt: "dark paperplane", src: "https://staticassets.commandbar.com/commandbar/paperplane_300.gif" })),
        timeout: /* @__PURE__ */ React194.createElement("div", null, "Something went wrong... Please try again."),
        whoaThereBuddy: /* @__PURE__ */ React194.createElement("div", null, /* @__PURE__ */ React194.createElement("div", null, "Whoa, whoa there!"), /* @__PURE__ */ React194.createElement("div", null, "How about loading the editor on your own site, why don't ya \u{1F603}"))
      };
    });
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightContentContainer.tsx
import { css as css33, jsx as jsx54 } from "@emotion/core";
var styles22, StyledSpotlightContentContainer, StyledSpotlightContentContainer_default;
var init_StyledSpotlightContentContainer = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightContentContainer.tsx"() {
    "use strict";
    styles22 = css33({
      textAlign: "center",
      padding: "var(--layout-padding)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)",
      borderRadius: "var(--layout-radius-card)",
      border: "1px solid var(--border-primary)",
      background: "var(--background-primary)"
    });
    StyledSpotlightContentContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx54("div", { css: styles22, ...props2 }, children);
    };
    StyledSpotlightContentContainer_default = StyledSpotlightContentContainer;
  }
});

// commandbar/src/products/spotlight/components/Dashboard.tsx
import * as React195 from "react";
import { jsx as jsx55 } from "@emotion/core";
var Dashboard, Container9, Dashboard_default;
var init_Dashboard = __esm({
  "commandbar/src/products/spotlight/components/Dashboard.tsx"() {
    "use strict";
    init_useAction();
    init_actions9();
    init_EditorDashboard();
    init_useTheme();
    init_useStore();
    init_StyledSpotlightContentContainer();
    Dashboard = (props2) => {
      const { theme } = useTheme();
      const handleEscape = useAction((_, e) => {
        if (e.key === "Escape")
          closeBarAndReset(_);
      });
      React195.useEffect(() => {
        document.addEventListener("keydown", handleEscape, true);
        return () => {
          document.removeEventListener("keydown", handleEscape, true);
        };
      }, [handleEscape]);
      const editorDashboards = getEditorDashboards(theme.main.background);
      switch (props2.type) {
        case "editor-loading":
          return /* @__PURE__ */ jsx55(Container9, null, editorDashboards.loading);
        case "editor-timeout":
          return /* @__PURE__ */ jsx55(Container9, null, editorDashboards.timeout);
        case "editor-access-denied":
          return /* @__PURE__ */ jsx55(Container9, null, editorDashboards.whoaThereBuddy);
        default:
          return /* @__PURE__ */ jsx55(Container9, null, /* @__PURE__ */ jsx55("div", null));
      }
    };
    Container9 = (props2) => {
      const { flags } = useStore();
      return (flags == null ? void 0 : flags["release-themes-v2"]) ? /* @__PURE__ */ jsx55(StyledSpotlightContentContainer_default, { id: "commandbar-dashboard", className: "commandbar-content-container" }, props2.children) : /* @__PURE__ */ jsx55(
        "div",
        {
          id: "commandbar-dashboard",
          className: "commandbar-content-container",
          css: (theme) => ({
            textAlign: "center",
            padding: "30px 50px",
            backgroundColor: theme.theme.dashboard.background,
            borderRadius: theme.theme.main.borderRadius,
            fontFamily: theme.theme.main.fontFamily,
            color: theme.theme.dashboard.fontColor
          })
        },
        props2.children
      );
    };
    Dashboard_default = Dashboard;
  }
});

// commandbar/src/products/spotlight/components/select/input/Input.tsx
import chroma11 from "chroma-js";
var inputStyles;
var init_Input = __esm({
  "commandbar/src/products/spotlight/components/select/input/Input.tsx"() {
    "use strict";
    init_placeholderHelpers();
    init_utils3();
    inputStyles = (theme, inputText, menuIsOpen) => {
      const isInactive = !menuIsOpen;
      const sharedStyles = {
        overflowX: "hidden",
        caretColor: theme.input.caretColor,
        fontFamily: theme.input.fontFamily,
        fontSize: theme.input.fontSize,
        width: "100%",
        margin: 0,
        // override for clickup global styles
        transition: "none !important",
        boxShadow: "none !important",
        background: "none  !important",
        isolation: "isolate",
        "*": {
          font: "inherit"
        },
        "::placeholder": placeholderStyles(theme)
      };
      const defaultReactSelectStyles = {
        gridArea: "1 / 2",
        font: "inherit",
        minWidth: "2px",
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
      };
      if (isEditorBeingSummoned(inputText)) {
        const highlightColorOptions = ["darkgreen", "plum", "indigo", "pink"];
        const contrasts = highlightColorOptions.filter((color2) => {
          return chroma11.contrast(theme.main.background, color2) > 4.5;
        });
        const color = contrasts.length > 0 ? contrasts[0] : "blue";
        return {
          ...defaultReactSelectStyles,
          ...sharedStyles,
          color,
          fontWeight: 600
        };
      }
      return {
        ...defaultReactSelectStyles,
        ...sharedStyles,
        color: isInactive ? theme.input.colorInactive : theme.input.color
      };
    };
  }
});

// commandbar/src/products/spotlight/components/select/input/ClearIndicator.tsx
import React196 from "react";
import { CgClose } from "react-icons/cg";
var ClearIndicator, ClearIndicator_default;
var init_ClearIndicator = __esm({
  "commandbar/src/products/spotlight/components/select/input/ClearIndicator.tsx"() {
    "use strict";
    init_actions9();
    init_useAction();
    init_useTheme();
    init_useStore();
    init_react();
    init_StyledTertiaryIconButton();
    init_ThemeV2Context();
    ClearIndicator = () => {
      var _a2;
      const { theme } = useTheme();
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const clearInput2 = useAction(clearInput);
      const onClick = () => {
        clearInput2();
      };
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React196.createElement(StyledTertiaryIconButton_default, { themeV2, onClick }, /* @__PURE__ */ React196.createElement(XClose_default, null)) : /* @__PURE__ */ React196.createElement(
        "div",
        {
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            width: "16px"
          }
        },
        /* @__PURE__ */ React196.createElement(CgClose, { size: 16, onClick, style: { color: theme.base.fontColor, cursor: "pointer", opacity: 0.7 } })
      );
    };
    ClearIndicator_default = ClearIndicator;
  }
});

// commandbar/src/shared/components/Button.tsx
import { jsx as jsx56 } from "@emotion/core";
var Button, buttonStyle, Button_default;
var init_Button = __esm({
  "commandbar/src/shared/components/Button.tsx"() {
    "use strict";
    init_useTheme();
    Button = (props2) => {
      const { primaryColor, backgroundColor, style: style3, children, ...btnProps } = props2;
      const customStyle = style3 || {};
      const { theme } = useTheme();
      return /* @__PURE__ */ jsx56(
        "button",
        {
          ...btnProps,
          css: {
            ...buttonStyle(theme, primaryColor, backgroundColor),
            ...customStyle
          }
        },
        children
      );
    };
    buttonStyle = (theme, color, background) => {
      const primaryColor = color || theme.base.primary;
      const backgroundColor = background || theme.main.background;
      return {
        wordBreak: "break-word",
        fontFamily: theme.main.fontFamily,
        fontSize: theme.main.fontSize,
        lineHeight: 1.5715,
        position: "relative",
        display: "inline-block",
        fontWeight: 400,
        textAlign: "center",
        border: "1px solid transparent",
        WebkitBoxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
        boxShadow: "0 2px 0 rgba(0, 0, 0, 0.015)",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)",
        height: "fit-content",
        padding: "4px 15px",
        borderRadius: 2,
        color: theme.base.fontColor,
        background: backgroundColor,
        borderColor: theme.base.fontColor,
        "&:not([disabled]):hover": {
          textDecoration: "none"
        },
        "&:not([disabled]):active": {
          outline: 0,
          boxShadow: "none"
        },
        "&[disabled]": {
          cursor: "not-allowed",
          opacity: 0.5,
          borderColor: "#d9d9d9",
          textShadow: "none",
          WebkitBoxshadow: "none",
          boxShadow: "none"
        },
        "&:hover": {
          color: primaryColor,
          background: backgroundColor,
          borderColor: primaryColor,
          textDecoration: "none"
        },
        "&:focus": {
          color: primaryColor,
          background: backgroundColor,
          borderColor: primaryColor,
          textDecoration: "none"
        },
        "&:active": {
          color: primaryColor,
          background: backgroundColor,
          borderColor: primaryColor,
          textDecoration: "none"
        }
      };
    };
    Button_default = Button;
  }
});

// commandbar/src/products/spotlight/components/select/input/SearchFilterInputTag.tsx
import React197 from "react";
import { AiOutlineClose as AiOutlineClose2, AiOutlineFilter } from "react-icons/ai";
import { useTheme as useTheme12 } from "emotion-theming";
var SearchFilterInputTag, SearchFilterInputTag_default;
var init_SearchFilterInputTag = __esm({
  "commandbar/src/products/spotlight/components/select/input/SearchFilterInputTag.tsx"() {
    "use strict";
    init_useStore();
    init_useAction();
    init_Block();
    init_selectors3();
    SearchFilterInputTag = () => {
      const clearSearchFilter = useAction((_2) => {
        _2.spotlight.searchFilter = void 0;
      });
      const { searchFilter } = useStore().spotlight;
      const { theme } = useTheme12();
      const _ = useStore();
      if (!searchFilter || !searchFilter.inputTag || !!selectSearchTabs(_).find((v) => v.key === (searchFilter == null ? void 0 : searchFilter.slug)))
        return null;
      const maxInputTagWidth = parseInt(theme.bar.width, 10) / 3;
      return /* @__PURE__ */ React197.createElement(
        "div",
        {
          css: blockBackgroundStyle,
          style: {
            border: `1px solid ${theme.base.primary}`,
            borderRadius: 4,
            display: "flex",
            alignItems: "center",
            marginRight: 10,
            fontFamily: theme.main.fontFamily,
            color: theme.base.fontColor,
            fontSize: theme.base.fontSize,
            padding: 4
          }
        },
        /* @__PURE__ */ React197.createElement(AiOutlineFilter, { style: { marginRight: 3 } }),
        /* @__PURE__ */ React197.createElement("div", { style: { maxWidth: maxInputTagWidth, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" } }, searchFilter.inputTag),
        /* @__PURE__ */ React197.createElement(
          AiOutlineClose2,
          {
            "data-testid": "commandbar-clear-filter",
            style: { cursor: "pointer", fontSize: 11, marginLeft: 4 },
            onClick: clearSearchFilter
          }
        )
      );
    };
    SearchFilterInputTag_default = SearchFilterInputTag;
  }
});

// commandbar/src/products/spotlight/components/select/input/SlashFilterInput.tsx
import { jsx as jsx57 } from "@emotion/core";
import { useTheme as useTheme13 } from "emotion-theming";
var SlashFilterInput, SlashFilterInput_default;
var init_SlashFilterInput = __esm({
  "commandbar/src/products/spotlight/components/select/input/SlashFilterInput.tsx"() {
    "use strict";
    init_useStore();
    init_selectors3();
    SlashFilterInput = (props2) => {
      const { theme } = useTheme13();
      const { inputText, slashFilter, slashFilterKeyword } = selectSlashFilter(useStore());
      const hint = selectSlashFilterHint(useStore(), slashFilterKeyword);
      if (!slashFilter) {
        return null;
      } else {
        return /* @__PURE__ */ jsx57(
          "span",
          {
            className: "rich-hint-wrapper",
            style: {
              display: "flex",
              pointerEvents: "none",
              backgroundColor: "transparent",
              borderColor: "transparent",
              boxShadow: "none",
              color: "rgba(0, 0, 0, 0.35)",
              position: "absolute",
              top: 0,
              width: "100%"
            }
          },
          /* @__PURE__ */ jsx57(
            "span",
            {
              className: "rich-text-filler",
              style: {
                visibility: "hidden",
                backgroundColor: "transparent",
                borderColor: "transparent",
                boxShadow: "none",
                pointerEvents: "none",
                whiteSpace: "pre",
                fontFamily: theme.input.fontFamily,
                fontSize: theme.input.fontSize
              }
            },
            inputText
          ),
          /* @__PURE__ */ jsx57(
            "span",
            {
              style: {
                backgroundColor: "transparent",
                borderColor: "transparent",
                color: "transparent",
                borderBottom: `1px solid ${theme.base.primary}`,
                boxShadow: "none",
                pointerEvents: "none",
                whiteSpace: "pre",
                fontFamily: theme.input.fontFamily,
                fontSize: theme.input.fontSize
              }
            },
            slashFilter
          ),
          /* @__PURE__ */ jsx57(
            "input",
            {
              className: "rich-hint",
              css: props2.inputStyles,
              style: {
                pointerEvents: "none",
                background: "transparent",
                width: "100%",
                outline: "none",
                borderBottom: `1px solid transparent`,
                boxShadow: "none",
                padding: 0,
                margin: 0,
                caretColor: "transparent"
              },
              placeholder: hint,
              tabIndex: -1
            }
          )
        );
      }
    };
    SlashFilterInput_default = SlashFilterInput;
  }
});

// commandbar/src/products/spotlight/components/RenderCustomComponent.tsx
import React198 from "react";
var RenderCustomComponent, RenderCustomComponent_default;
var init_RenderCustomComponent = __esm({
  "commandbar/src/products/spotlight/components/RenderCustomComponent.tsx"() {
    "use strict";
    RenderCustomComponent = ({
      component,
      data,
      metadata
    }) => {
      var _a2;
      const instance = React198.useRef(null);
      const mountCustomComponent = (elem) => {
        if (instance.current) {
          instance.current.unmount();
          instance.current = null;
        }
        if (elem) {
          instance.current = component.mount(elem);
          instance.current.render(data, metadata);
        }
      };
      React198.useEffect(() => {
        return () => {
          if (instance.current) {
            instance.current.unmount();
          }
        };
      }, []);
      (_a2 = instance.current) == null ? void 0 : _a2.render(data, metadata);
      return /* @__PURE__ */ React198.createElement("div", { ref: mountCustomComponent });
    };
    RenderCustomComponent_default = RenderCustomComponent;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledRotatingPlaceholder.tsx
import { css as css34, jsx as jsx58 } from "@emotion/core";
var styles23, StyledRotatingPlaceholder, StyledRotatingPlaceholder_default;
var init_StyledRotatingPlaceholder = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledRotatingPlaceholder.tsx"() {
    "use strict";
    styles23 = css34({
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      color: "var(--content-secondary)",
      position: "absolute",
      width: "100%",
      padding: "var(--form-control-padding-x)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      transform: "translateY(0)",
      zIndex: 0,
      pointerEvents: "none"
    });
    StyledRotatingPlaceholder = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx58("div", { "data-testid": "commandbar-input-placeholder", css: styles23, ...props2 }, children);
    };
    StyledRotatingPlaceholder_default = StyledRotatingPlaceholder;
  }
});

// commandbar/src/products/spotlight/components/select/input/AnimatedPlaceholder.tsx
import * as React199 from "react";
import { jsx as jsx59, keyframes as keyframes6 } from "@emotion/core";
import { useTheme as useTheme14 } from "emotion-theming";
var AnimatedPlaceholder, enter, exit, AnimatedPlaceholder_default;
var init_AnimatedPlaceholder = __esm({
  "commandbar/src/products/spotlight/components/select/input/AnimatedPlaceholder.tsx"() {
    "use strict";
    init_useStore();
    init_useDelayUnmount();
    init_placeholderHelpers();
    init_StyledRotatingPlaceholder();
    AnimatedPlaceholder = ({ isFocused }) => {
      var _a2, _b2, _c2;
      const _ = useStore();
      const { placeholders } = _.spotlight;
      const [index3, setIndex] = React199.useState(0);
      const [isFirst, setIsFirst] = React199.useState(true);
      const [isPreviousMounted, setIsPreviousMounted] = React199.useState(true);
      const [isNextMounted, setNextMounted] = React199.useState(false);
      const shouldShowPrevious = useDelayUnmount(isPreviousMounted, 500);
      const shouldShowNext = useDelayUnmount(isNextMounted, 500);
      const { theme } = useTheme14();
      const styles51 = placeholderStyles(theme);
      React199.useEffect(() => {
        if (isFocused) {
          const intervalID = setInterval(() => {
            setIndex((index4) => index4 === placeholders.length - 1 ? 0 : index4 + 1);
            setIsPreviousMounted((prev) => !prev);
            setNextMounted((next) => !next);
            setIsFirst(false);
          }, 3500);
          return () => {
            clearInterval(intervalID);
          };
        }
      }, [isFocused, placeholders]);
      return /* @__PURE__ */ jsx59(React199.Fragment, null, shouldShowPrevious && (((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx59(
        StyledRotatingPlaceholder_default,
        {
          css: {
            animation: isFirst ? "" : `${isPreviousMounted ? enter : exit} 0.5s cubic-bezier(0.25, 0.85, 0.3, 0.9)`
          }
        },
        placeholders[index3].text
      ) : /* @__PURE__ */ jsx59(
        "div",
        {
          "data-testid": "commandbar-input-placeholder",
          css: {
            ...styles51,
            position: "absolute",
            transform: "translateY(0)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            lineHeight: "1.3em",
            textOverflow: "ellipsis",
            width: "100%",
            zIndex: 0,
            pointerEvents: "none",
            animation: isFirst ? "" : `${isPreviousMounted ? enter : exit} 0.5s cubic-bezier(0.25, 0.85, 0.3, 0.9)`
          }
        },
        (_b2 = placeholders[index3]) == null ? void 0 : _b2.text
      )), shouldShowNext && (((_c2 = _.flags) == null ? void 0 : _c2["release-themes-v2"]) ? /* @__PURE__ */ jsx59(
        StyledRotatingPlaceholder_default,
        {
          css: { animation: `${isNextMounted ? enter : exit} 0.5s cubic-bezier(0.25, 0.85, 0.3, 0.9)` }
        },
        placeholders[index3].text
      ) : /* @__PURE__ */ jsx59(
        "div",
        {
          "data-testid": "commandbar-input-placeholder",
          css: {
            ...styles51,
            position: "absolute",
            transform: "translateY(0)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            lineHeight: "1.3em",
            textOverflow: "ellipsis",
            width: "100%",
            zIndex: 0,
            pointerEvents: "none",
            animation: `${isNextMounted ? enter : exit} 0.5s cubic-bezier(0.25, 0.85, 0.3, 0.9)`
          }
        },
        placeholders[index3].text
      )));
    };
    enter = keyframes6`
0% {
  opacity: 0;
  transform: translateY(50px);
}
`;
    exit = keyframes6`
100% {
  opacity: 0;
  transform: translateY(-50px);
}
`;
    AnimatedPlaceholder_default = AnimatedPlaceholder;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightInput.tsx
import React200 from "react";
import { css as css35, jsx as jsx60 } from "@emotion/core";
var styles24, modalStyles, StyledSpotlightInput, StyledSpotlightInput_default;
var init_StyledSpotlightInput = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightInput.tsx"() {
    "use strict";
    init_StyledBaseInput();
    styles24 = {
      height: "calc(var(--form-control-height) + 2 * var(--form-control-padding-x))"
    };
    modalStyles = {
      flex: "1 0 0",
      border: "none",
      background: "none",
      fontSize: "var(--font-size-large)",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
        border: "none",
        background: "none"
      },
      "&:focus": {
        boxShadow: "none",
        border: "none",
        background: "none"
      }
    };
    StyledSpotlightInput = React200.forwardRef(
      ({ isInlineBar, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx60(StyledBaseInput_default, { css: [css35(styles24), !isInlineBar && css35(modalStyles)].filter(Boolean), ref: ref12, ...props2 });
      }
    );
    StyledSpotlightInput_default = StyledSpotlightInput;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightInputWrapper.tsx
import React201 from "react";
import { css as css36, jsx as jsx61 } from "@emotion/core";
var styles25, inlineStyles, StyledSpotlightInputWrapper, StyledSpotlightInputWrapper_default;
var init_StyledSpotlightInputWrapper = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightInputWrapper.tsx"() {
    "use strict";
    styles25 = css36({
      display: "flex",
      width: "var(--spotlight-width)",
      alignItems: "center",
      gap: "8px",
      flexShrink: 0,
      alignSelf: "stretch",
      border: "1px solid var(--border-primary)",
      borderBottom: "none",
      borderRadius: "var(--layout-radius-card) var(--layout-radius-card) 0px 0px",
      background: "var(--background-primary)",
      maxWidth: "95vw"
    });
    inlineStyles = css36({
      borderRadius: "var(--layout-radius-card)",
      background: "none",
      border: "none",
      padding: "0px",
      position: "relative",
      width: "100%"
    });
    StyledSpotlightInputWrapper = React201.forwardRef(
      ({ isInlineBar, children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx61("div", { css: [styles25, isInlineBar && inlineStyles], ...props2, ref: ref12 }, children);
      }
    );
    StyledSpotlightInputWrapper_default = StyledSpotlightInputWrapper;
  }
});

// commandbar/src/shared/util/hooks/useResizeObserver2.ts
import { useState as useState25, useRef as useRef31, useCallback as useCallback13 } from "react";
var ResizeObserver2, useResizeObserver, useResizeObserver2_default;
var init_useResizeObserver2 = __esm({
  "commandbar/src/shared/util/hooks/useResizeObserver2.ts"() {
    "use strict";
    ResizeObserver2 = window.ResizeObserver;
    if (false) {
      const { ResizeObserver: Polyfill } = null;
      ResizeObserver2 = Polyfill;
    }
    useResizeObserver = () => {
      const [size, setSize] = useState25(null);
      const observer = useRef31(null);
      const callbackRef = useCallback13(
        (element) => {
          if (observer.current) {
            observer.current.disconnect();
          }
          if (!element) {
            setSize(null);
            return;
          }
          observer.current = new ResizeObserver2((entries) => {
            const [entry] = entries;
            const { width, height } = entry.contentRect;
            setSize({ width, height });
          });
          observer.current.observe(element);
        },
        [setSize]
      );
      return { ref: callbackRef, width: size == null ? void 0 : size.width, height: size == null ? void 0 : size.height };
    };
    useResizeObserver2_default = useResizeObserver;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubInputButtons.tsx
var StyledInputButtons, StyledHelpHubInputButtons_default;
var init_StyledHelpHubInputButtons = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubInputButtons.tsx"() {
    "use strict";
    init_styled_browser_esm();
    StyledInputButtons = styled_browser_esm_default.div`
  position: absolute;
  right: var(--form-control-padding-x);
  top: calc(min(var(--form-control-height) / 2, var(--form-control-padding-x)));
`;
    StyledHelpHubInputButtons_default = StyledInputButtons;
  }
});

// commandbar/src/products/spotlight/components/select/input/Control.tsx
import * as React202 from "react";
import { useTheme as useTheme15 } from "emotion-theming";
import { jsx as jsx62 } from "@emotion/core";
var controlStyles, LongTextInput, StyledSpotlightContainer, Control, Logo, Control_default;
var init_Control = __esm({
  "commandbar/src/products/spotlight/components/select/input/Control.tsx"() {
    "use strict";
    init_SVG();
    init_Z();
    init_Input();
    init_LoadingIndicator();
    init_ClearIndicator();
    init_Button();
    init_actions9();
    init_useAction();
    init_useStore();
    init_a11y();
    init_selectors3();
    init_selectors8();
    init_Step();
    init_SearchFilterInputTag();
    init_ParameterOption();
    init_SlashFilterInput();
    init_chroma();
    init_StatusBar();
    init_RenderCustomComponent();
    init_AnimatedPlaceholder();
    init_operatingSystem();
    init_StyledSpotlightInput();
    init_StyledSpotlightInputWrapper();
    init_StyledTextArea();
    init_ThemeV2Context();
    init_useResizeObserver2();
    init_StyledHelpHubInputButtons();
    init_StyledTertiaryIconButton();
    init_styled_browser_esm();
    controlStyles = (theme, inputInactive) => ({
      border: theme.input.border,
      borderRadius: theme.input.borderRadius,
      borderBottom: inputInactive ? theme.input.borderBottomInactive : theme.input.borderBottom,
      background: inputInactive ? theme.input.backgroundInactive : theme.input.background,
      // borderRadius: `${theme.main.borderRadius} ${theme.main.borderRadius} 0px 0px`,
      // fontSize: theme.input.fontSize,
      // color: theme.input.color,
      // background: theme.main.background,
      zIndex: Z_default.Z_COMMANDBAR
    });
    LongTextInput = ({ currentStep, handleInputChange: handleInputChange2, inputRef }) => {
      const _ = useStore(true);
      const { theme } = useTheme15();
      const placeholder = selectFirstPlaceholder(useStore());
      const handleSubmit = useAction((_2, e) => {
        const option = initParameterOption(_2, currentStep.argument.userDefinedName, _2.spotlight.inputText);
        selectOption(_2, option);
        e.stopPropagation();
        e.preventDefault();
      }, []);
      return /* @__PURE__ */ jsx62(
        "div",
        {
          css: {
            display: "flex",
            width: "100%",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between"
          }
        },
        /* @__PURE__ */ jsx62("div", { style: { display: "flex", justifyContent: "center", width: "100%" } }, " ", /* @__PURE__ */ jsx62(
          "textarea",
          {
            name: "longtextinput",
            value: _.spotlight.rawInput,
            placeholder,
            ref: inputRef,
            onChange: handleInputChange2,
            rows: 8,
            css: {
              display: "flex",
              width: "calc(100% + 15px)",
              padding: 16,
              color: theme.main.color,
              fontFamily: theme.main.fontFamily,
              backgroundColor: getChromaColor(theme.base.fontColor).alpha(0.03).css(),
              border: `1px solid ${getChromaColor(theme.base.fontColor).alpha(0.2).css()}`,
              borderRadius: 8,
              fontSize: theme.base.fontSize,
              lineHeight: "16px",
              fontWeight: 500,
              resize: "none",
              "&:focus": {
                outline: "none",
                border: `2px solid ${getChromaColor(theme.base.fontColor).alpha(0.2).css()}`
              }
            }
          }
        )),
        /* @__PURE__ */ jsx62(
          "div",
          {
            css: {
              display: isMobileDevice() ? "flex" : "none",
              width: "100%",
              justifyContent: "center",
              "& Button": {
                marginTop: "16px"
              }
            }
          },
          /* @__PURE__ */ jsx62(Button_default, { onClick: handleSubmit }, "Submit")
        )
      );
    };
    StyledSpotlightContainer = styled_browser_esm_default.div`
  width: 100%;
  padding: 0 12px;
`;
    Control = (props2) => {
      var _a2, _b2;
      const handleInputChange2 = useAction((_2, e) => {
        handleInputChange(_2, e.target.value);
      });
      const { theme } = useTheme15();
      const _ = useStore(true);
      const { focusedIndex, showLoadingIndicator, userDefinedCustomComponents, searchFilter } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const currentStepIsLongTextInputStep = (currentStep == null ? void 0 : currentStep.type) === "longtextinput" /* LongTextInput */;
      const menuIsOpen = selectMenuIsOpen(useStore());
      const resetFocusedIndex3 = useAction(resetFocusedIndex);
      const menuEmpty = _.spotlight.sortedOptions.length === 0;
      const logo = _.logo;
      const setSearchFilter2 = useAction((_2, filter) => _2.spotlight.searchFilter = filter);
      const component = (currentStep == null ? void 0 : currentStep.type) !== "execute" && userDefinedCustomComponents.input({ step: currentStep == null ? void 0 : currentStep.type });
      const onKeyDown = (e) => {
        if (e.key === "Backspace") {
          if (_.spotlight.rawInput === "" && !!(searchFilter == null ? void 0 : searchFilter.inputTag)) {
            setSearchFilter2(void 0);
          }
        }
      };
      const styles51 = inputStyles(theme, _.spotlight.rawInput, menuIsOpen);
      const themeV2 = useThemeV2Context();
      const placeholder = selectFirstPlaceholder(useStore());
      const [isFocused, setIsFocused] = React202.useState(false);
      const hasRotatingPlaceholders = showRotatingPlaceholders(useStore());
      const { ref: inputButtonsRef, width: inputButtonsWidth } = useResizeObserver2_default();
      const createInput = () => {
        var _a3, _b3;
        const inputEl = ((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) ? /* @__PURE__ */ jsx62(
          StyledSpotlightInput_default,
          {
            themeV2,
            onKeyDown,
            id: a11y_default.commandbarInputId,
            "data-testid": "commandbar-input",
            value: _.spotlight.rawInput,
            placeholder: hasRotatingPlaceholders ? "" : placeholder,
            onChange: handleInputChange2,
            ref: props2.inputRef,
            autoComplete: "off",
            role: a11y_default.inputRole,
            "aria-expanded": menuIsOpen,
            "aria-controls": menuEmpty ? a11y_default.emptyListId : a11y_default.listId,
            "aria-owns": menuEmpty ? a11y_default.emptyListId : a11y_default.listId,
            "aria-activedescendant": menuEmpty ? a11y_default.emptyListId : a11y_default.optionId(focusedIndex),
            "aria-label": placeholder,
            "aria-placeholder": placeholder,
            onBlur: () => setIsFocused(false),
            onFocus: (_2) => {
              setIsFocused(true);
              if (focusedIndex === -1)
                resetFocusedIndex3();
            },
            isInlineBar,
            style: { paddingRight: (inputButtonsWidth != null ? inputButtonsWidth : 0) + 8 }
          }
        ) : /* @__PURE__ */ jsx62(
          "input",
          {
            onKeyDown,
            id: a11y_default.commandbarInputId,
            "data-testid": "commandbar-input",
            css: styles51,
            value: _.spotlight.rawInput,
            placeholder: hasRotatingPlaceholders ? "" : placeholder,
            onChange: handleInputChange2,
            ref: props2.inputRef,
            autoComplete: "off",
            role: a11y_default.inputRole,
            "aria-expanded": menuIsOpen,
            "aria-controls": menuEmpty ? a11y_default.emptyListId : a11y_default.listId,
            "aria-owns": menuEmpty ? a11y_default.emptyListId : a11y_default.listId,
            "aria-activedescendant": menuEmpty ? a11y_default.emptyListId : a11y_default.optionId(focusedIndex),
            "aria-label": placeholder,
            "aria-placeholder": placeholder,
            onBlur: () => setIsFocused(false),
            onFocus: (_2) => {
              setIsFocused(true);
              if (focusedIndex === -1)
                resetFocusedIndex3();
            }
          }
        );
        return /* @__PURE__ */ jsx62(React202.Fragment, null, hasRotatingPlaceholders && /* @__PURE__ */ jsx62(AnimatedPlaceholder_default, { isFocused: isFocused || _.spotlight.formFactor.type === "modal" }), inputEl, !!((_b3 = _.organization) == null ? void 0 : _b3.slash_filters_enabled) && (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && /* @__PURE__ */ jsx62(SlashFilterInput_default, { inputStyles: styles51 }));
      };
      const isInlineBar = _.spotlight.formFactor.type === "inline";
      const focusTimer = React202.useRef();
      const openIfClosed = useAction((_2) => {
        if (!_2.spotlight.visible) {
          if (toggleBarFromLauncher(_2)) {
            clearTimeout(focusTimer.current);
            focusTimer.current = setTimeout(() => {
              var _a3;
              return (_a3 = _2.spotlight.refContainer.current) == null ? void 0 : _a3.focus();
            }, 200);
          }
        }
      });
      const logoV2 = ((_a2 = _.organization) == null ? void 0 : _a2.logo_spotlight) || logo;
      return ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? (
        // The <div> element has a child <input> element that allows keyboard interaction
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        /* @__PURE__ */ jsx62(
          StyledSpotlightInputWrapper_default,
          {
            id: "commandbar__control_wrapper",
            onClick: isInlineBar ? () => openIfClosed() : void 0,
            ref: props2.setControlWrapperRef,
            isInlineBar,
            style: { ...isMobileDevice() && { width: "100%" } }
          },
          /* @__PURE__ */ jsx62(
            "div",
            {
              style: {
                width: "100%",
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                position: "relative"
              }
            },
            /* @__PURE__ */ jsx62(StatusBar_default, null),
            /* @__PURE__ */ jsx62(StyledSpotlightContainer, null, /* @__PURE__ */ jsx62("div", { id: "commandbar__control", style: { display: "flex", alignItems: "center" } }, !currentStepIsLongTextInputStep && logoV2.length > 0 ? /* @__PURE__ */ jsx62(
              "div",
              {
                style: {
                  width: 24,
                  height: 24,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingLeft: "var(--form-control-padding-x)"
                }
              },
              /* @__PURE__ */ jsx62(
                SVG_default,
                {
                  ariaHidden: true,
                  style: {
                    width: "20px"
                  },
                  htmlstring: logoV2,
                  useDefaultSVGColor: true
                }
              )
            ) : null, /* @__PURE__ */ jsx62(SearchFilterInputTag_default, null), /* @__PURE__ */ jsx62(
              "div",
              {
                style: {
                  flexGrow: 1,
                  display: "flex",
                  alignItems: "center",
                  position: "relative",
                  justifyContent: "space-between",
                  overflow: "hidden"
                },
                className: "commandbar__input"
              },
              currentStepIsLongTextInputStep ? /* @__PURE__ */ jsx62(StyledTextArea_default, { themeV2, ref: props2.inputRef, onChange: handleInputChange2, rows: 8 }) : createInput(),
              /* @__PURE__ */ jsx62(StyledHelpHubInputButtons_default, { ref: inputButtonsRef, "aria-label": "progress bar" }, showLoadingIndicator ? /* @__PURE__ */ jsx62(StyledTertiaryIconButton_default, { themeV2, disabled: true, style: { cursor: "inherit" } }, /* @__PURE__ */ jsx62(LoadingIndicator_default, { size: 22, isLoading: true })) : _.spotlight.inputText !== "" && !currentStepIsLongTextInputStep && /* @__PURE__ */ jsx62(ClearIndicator_default, null)),
              typeof component === "string" ? /* @__PURE__ */ jsx62("div", { dangerouslySetInnerHTML: { __html: component } }) : component && /* @__PURE__ */ jsx62(RenderCustomComponent_default, { component })
            )))
          )
        )
      ) : (
        // The <div> element has a child <input> element that allows keyboard interaction
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        /* @__PURE__ */ jsx62(
          "div",
          {
            id: "commandbar__control_wrapper",
            onClick: isInlineBar ? () => openIfClosed() : void 0,
            style: controlStyles(theme, !menuIsOpen),
            ref: props2.setControlWrapperRef
          },
          /* @__PURE__ */ jsx62(
            "div",
            {
              style: {
                display: "flex",
                flexWrap: "wrap",
                flexDirection: "column",
                overflow: "hidden",
                position: "relative"
              }
            },
            /* @__PURE__ */ jsx62(StatusBar_default, null),
            /* @__PURE__ */ jsx62(
              "div",
              {
                id: "commandbar__control",
                style: {
                  display: "flex",
                  alignItems: "center",
                  paddingLeft: theme.input.paddingLeft,
                  paddingRight: theme.input.paddingRight,
                  paddingTop: theme.input.paddingTop,
                  paddingBottom: theme.input.paddingBottom,
                  cursor: "text"
                }
              },
              !currentStepIsLongTextInputStep && /* @__PURE__ */ jsx62(Logo, { ariaHidden: true, svgString: logo }),
              /* @__PURE__ */ jsx62(SearchFilterInputTag_default, null),
              /* @__PURE__ */ jsx62(
                "div",
                {
                  style: { flexGrow: 1, display: "flex", alignItems: "center", position: "relative" },
                  className: "commandbar__input"
                },
                currentStepIsLongTextInputStep ? /* @__PURE__ */ jsx62(
                  LongTextInput,
                  {
                    currentStep,
                    handleInputChange: handleInputChange2,
                    inputRef: props2.inputRef
                  }
                ) : createInput(),
                /* @__PURE__ */ jsx62(
                  "div",
                  {
                    role: "progressbar",
                    "aria-label": "progress bar",
                    style: { maxHeight: 0, display: "flex", alignItems: "center" }
                  },
                  showLoadingIndicator ? /* @__PURE__ */ jsx62("div", null, /* @__PURE__ */ jsx62(LoadingIndicator_default, { size: 22, isLoading: true })) : _.spotlight.inputText !== "" && !currentStepIsLongTextInputStep && /* @__PURE__ */ jsx62("div", null, /* @__PURE__ */ jsx62(ClearIndicator_default, null))
                ),
                typeof component === "string" ? /* @__PURE__ */ jsx62(
                  "div",
                  {
                    style: { marginLeft: theme.logo.spaceBetweenLogoAndText },
                    dangerouslySetInnerHTML: { __html: component }
                  }
                ) : component && /* @__PURE__ */ jsx62(RenderCustomComponent_default, { component })
              )
            )
          )
        )
      );
    };
    Logo = (props2) => {
      const { theme } = useTheme15();
      if (props2.svgString.length > 0) {
        return /* @__PURE__ */ jsx62(
          SVG_default,
          {
            ariaHidden: props2.ariaHidden,
            style: {
              height: theme.logo.size,
              width: theme.logo.size,
              left: theme.logo.left,
              top: theme.logo.top,
              marginRight: theme.logo.spaceBetweenLogoAndText
            },
            htmlstring: props2.svgString,
            useDefaultSVGColor: true
          }
        );
      } else {
        return null;
      }
    };
    Control_default = Control;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightCategoryHeader.tsx
import { css as css37, jsx as jsx63 } from "@emotion/core";
var styles26, StyledSpotlightCategoryHeader, StyledSpotlightCategoryHeader_default;
var init_StyledSpotlightCategoryHeader = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightCategoryHeader.tsx"() {
    "use strict";
    styles26 = css37({
      display: "flex",
      height: "32px",
      justifyContent: "space-between",
      alignItems: "center",
      alignSelf: "stretch",
      background: "var(--background-primary)",
      padding: "var(--layout-padding) var(--layout-padding) var(--layout-padding) 24px"
    });
    StyledSpotlightCategoryHeader = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx63("div", { css: styles26, ...props2 }, children);
    };
    StyledSpotlightCategoryHeader_default = StyledSpotlightCategoryHeader;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightCategoryTitle.tsx
import { css as css38, jsx as jsx64 } from "@emotion/core";
var styles27, StyledSpotlightCategoryTitle, StyledSpotlightCategoryTitle_default;
var init_StyledSpotlightCategoryTitle = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightCategoryTitle.tsx"() {
    "use strict";
    styles27 = css38({
      color: "var(--content-secondary)",
      /* label/sm/semibold */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-small)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledSpotlightCategoryTitle = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx64("div", { css: styles27, ...props2 }, children);
    };
    StyledSpotlightCategoryTitle_default = StyledSpotlightCategoryTitle;
  }
});

// internal/src/client/themesV2/components/shared/StyledInlineButton.tsx
import { css as css39, jsx as jsx65 } from "@emotion/core";
var styles28, slug18, StyledInlineButton, StyledInlineButton_default;
var init_StyledInlineButton = __esm({
  "internal/src/client/themesV2/components/shared/StyledInlineButton.tsx"() {
    "use strict";
    init_useComponentOverrides();
    init_react();
    init_ButtonWithReset();
    styles28 = {
      border: "none",
      background: "none",
      display: "inline-flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "4px",
      borderRadius: "var(--layout-radius-button)",
      cursor: "pointer",
      color: "var(--content-primary)",
      /* label/sm/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-small)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)",
      "&:hover": {
        color: "var(--content-secondary)"
      },
      "&:focus": {
        color: "var(--content-primary)",
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      "&:disabled": {
        cursor: "not-allowed",
        color: "var(--content-secondary)"
      }
    };
    slug18 = "inlineButton";
    StyledInlineButton = ({
      themeV2,
      filled,
      children,
      ...props2
    }) => {
      const { overrides } = useComponentOverrides_default(slug18, themeV2);
      return /* @__PURE__ */ jsx65(ButtonWithReset_default, { css: [overrides, css39(styles28)], ...props2 }, children);
    };
    StyledInlineButton.slug = slug18;
    StyledInlineButton.styles = styles28;
    StyledInlineButton.renderMock = (themeV2, mode) => /* @__PURE__ */ jsx65(StyledInlineButton, { themeV2: { themeV2, mode } }, "Inline button ", /* @__PURE__ */ jsx65(ChevronDown_default, null));
    StyledInlineButton_default = StyledInlineButton;
  }
});

// commandbar/src/products/spotlight/components/select/menu/OptionGroupHeader.tsx
import React203 from "react";
import { MdExpandMore } from "react-icons/md";
import { useTheme as useTheme16 } from "emotion-theming";
import truncate2 from "lodash/truncate";
var getOptionGroupDisplayName, getOptionGroupTitle, OptionGroupHeader, OptionGroupHeader_default;
var init_OptionGroupHeader = __esm({
  "commandbar/src/products/spotlight/components/select/menu/OptionGroupHeader.tsx"() {
    "use strict";
    init_OptionGroup();
    init_useStore();
    init_useAction();
    init_actions9();
    init_LoadingIndicator();
    init_StyledSpotlightCategoryHeader();
    init_StyledSpotlightCategoryTitle();
    init_StyledInlineButton();
    init_ThemeV2Context();
    getOptionGroupDisplayName = (group, themeContext, inputText) => {
      if (group.type === "RECOMMENDED" && themeContext.categoryHeader.recommendedHeaderLabel) {
        return themeContext.categoryHeader.recommendedHeaderLabel;
      }
      if (group.type === "RECENTS" && themeContext.categoryHeader.recentsHeaderLabel) {
        return themeContext.categoryHeader.recentsHeaderLabel;
      }
      if (group.type === "FALLBACK" && themeContext.categoryHeader.fallbackCommandsHeader) {
        return themeContext.categoryHeader.fallbackCommandsHeader.replace(
          "{{query}}",
          // Truncate the input text to avoid long labels
          truncate2(inputText, {
            length: 20,
            omission: "..."
          })
        );
      }
      return group.name;
    };
    getOptionGroupTitle = (group, localizedMessages, inputText) => {
      switch (group.type) {
        case "RECOMMENDED":
          return localizedMessages["spotlight.recommended-header-label"];
        case "RECENTS":
          return localizedMessages["spotlight.recents-header-label"];
        case "RECORD_CATEGORY":
          return group.key.endsWith("experiences") ? localizedMessages["spotlight.experiences-header-label"] : group.name;
        case "FALLBACK":
          const message = localizedMessages["spotlight.fallback-results-header"].replace(
            "{{query}}",
            // Truncate the input text to avoid long labels
            truncate2(inputText, {
              length: 20,
              omission: "..."
            })
          );
          return message;
        default:
          return group.name;
      }
    };
    OptionGroupHeader = (props2) => {
      var _a2;
      const _ = useStore();
      const { group } = props2;
      const themeContext = useTheme16().theme;
      const themeV2 = useThemeV2Context();
      const { inputText, searchFilter, loadingByKey, expandedGroupKeys } = useStore().spotlight;
      const focusInput = useAction((_2) => {
        var _a3, _b2;
        return (_b2 = (_a3 = _2.spotlight.refContainer) == null ? void 0 : _a3.current) == null ? void 0 : _b2.focus();
      });
      const toggleExpansion = useAction(
        (_2) => {
          toggleGroupExpansion(_2, group.key);
          if (props2.onToggleExpansion)
            props2.onToggleExpansion(group.key);
        },
        [props2.onToggleExpansion, group.key]
      );
      const hideExpansionToggle = (() => {
        const isActiveSearchTab = group.key === (searchFilter == null ? void 0 : searchFilter.slug);
        return isActiveSearchTab;
      })();
      const isLoading = isOptionGroupLoading(group, loadingByKey);
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React203.createElement(
        StyledSpotlightCategoryHeader_default,
        {
          key: group.key,
          "aria-hidden": true,
          onClick: focusInput
        },
        /* @__PURE__ */ React203.createElement(StyledSpotlightCategoryTitle_default, null, getOptionGroupTitle(group, _.localizedMessages, inputText)),
        isOptionGroupOverLimit(group) && !hideExpansionToggle && /* @__PURE__ */ React203.createElement(
          StyledInlineButton_default,
          {
            themeV2,
            id: "overlimit-" + getOptionGroupDisplayName(group, themeContext, inputText),
            role: "switch",
            tabIndex: props2.isFocused ? 0 : -1,
            "aria-checked": !canOptionGroupExpand(group, expandedGroupKeys),
            onClick: toggleExpansion
          },
          canOptionGroupExpand(group, expandedGroupKeys) ? `See more (${group.size})` : `See less (${group.size})`,
          /* @__PURE__ */ React203.createElement(
            MdExpandMore,
            {
              className: canOptionGroupExpand(group, expandedGroupKeys) ? "commandbar-category-expand" : "commandbar-category-collapse"
            }
          )
        ),
        group.size === 0 && group.showWithNoResults && /* @__PURE__ */ React203.createElement(StyledSpotlightCategoryTitle_default, null, "No results")
      ) : /* @__PURE__ */ React203.createElement(
        "div",
        {
          style: {
            paddingTop: themeContext.categoryHeader.paddingTop,
            paddingBottom: themeContext.categoryHeader.paddingBottom,
            paddingLeft: themeContext.categoryHeader.paddingLeft,
            paddingRight: themeContext.categoryHeader.paddingRight,
            color: themeContext.categoryHeader.color,
            fontSize: themeContext.categoryHeader.fontSize,
            opacity: themeContext.categoryHeader.opacity,
            fontWeight: themeContext.categoryHeader.fontWeight,
            lineHeight: themeContext.categoryHeader.lineHeight,
            background: themeContext.categoryHeader.background,
            borderTop: themeContext.categoryHeader.borderTop,
            borderBottom: themeContext.categoryHeader.borderBottom,
            marginTop: props2.addTopPadding ? themeContext.optionList.spaceBetweenCategories : 0,
            marginBottom: themeContext.optionList.spaceBelowHeader,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            userSelect: "none",
            maxHeight: getDefaultHeaderHeight(themeContext, props2.addTopPadding),
            textTransform: themeContext.categoryHeader.textTransform
          },
          key: group.key,
          "aria-hidden": true,
          onClick: focusInput
        },
        /* @__PURE__ */ React203.createElement("div", { style: { display: "flex", color: "inherit", alignItems: "center" } }, /* @__PURE__ */ React203.createElement(
          "span",
          {
            role: "heading",
            "data-testid": "option-group-header",
            "aria-level": 2,
            style: { height: "100%", color: "inherit" }
          },
          getOptionGroupDisplayName(group, themeContext, inputText)
        ), /* @__PURE__ */ React203.createElement("span", { style: { width: 5 } }), /* @__PURE__ */ React203.createElement(LoadingIndicator_default, { isLoading, size: parseInt(themeContext.categoryHeader.loaderSize, 10) })),
        /* @__PURE__ */ React203.createElement("div", null, isOptionGroupOverLimit(group) && !hideExpansionToggle && /* @__PURE__ */ React203.createElement(
          "button",
          {
            id: "overlimit-" + getOptionGroupDisplayName(group, themeContext, inputText),
            role: "switch",
            tabIndex: props2.isFocused ? 0 : -1,
            "aria-checked": !canOptionGroupExpand(group, expandedGroupKeys),
            style: {
              display: "flex",
              background: themeContext.categoryHeader.expandBackground,
              color: themeContext.categoryHeader.expandColor,
              border: themeContext.categoryHeader.expandBorder,
              padding: themeContext.categoryHeader.expandPadding,
              font: themeContext.categoryHeader.expandFont,
              cursor: "pointer"
            },
            onClick: toggleExpansion
          },
          /* @__PURE__ */ React203.createElement("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React203.createElement(
            "span",
            {
              style: {
                fontWeight: themeContext.categoryHeader.expandTextFontWeight,
                color: "inherit"
              }
            },
            canOptionGroupExpand(group, expandedGroupKeys) ? "See more" : "See less"
          ), /* @__PURE__ */ React203.createElement(
            "span",
            {
              style: {
                marginLeft: themeContext.categoryHeader.expandSpacing,
                color: "inherit"
              }
            },
            /* @__PURE__ */ React203.createElement("span", { style: { fontWeight: themeContext.categoryHeader.numResultsFontWeight } }, "(", group.size, ")"),
            " "
          ), /* @__PURE__ */ React203.createElement(
            MdExpandMore,
            {
              size: themeContext.categoryHeader.expandIconSize,
              style: { marginLeft: themeContext.categoryHeader.expandSpacing },
              className: canOptionGroupExpand(group, expandedGroupKeys) ? "commandbar-category-expand" : "commandbar-category-collapse"
            }
          ))
        ), group.size === 0 && group.showWithNoResults && /* @__PURE__ */ React203.createElement("span", { style: { fontWeight: themeContext.categoryHeader.expandTextFontWeight } }, "No results"))
      );
    };
    OptionGroupHeader_default = OptionGroupHeader;
  }
});

// commandbar/src/products/spotlight/components/select/menu/StickyHeader.tsx
import React204 from "react";
var StickyHeader, StickyHeader_default;
var init_StickyHeader = __esm({
  "commandbar/src/products/spotlight/components/select/menu/StickyHeader.tsx"() {
    "use strict";
    init_OptionGroupHeader();
    StickyHeader = (props2) => {
      const { group, ...headerProps } = props2;
      if (!group) {
        return null;
      }
      return /* @__PURE__ */ React204.createElement("div", { style: { position: "relative", width: "100%" } }, /* @__PURE__ */ React204.createElement(
        "div",
        {
          style: {
            position: "absolute",
            paddingTop: props2.paddingTop,
            top: 0,
            zIndex: 10,
            width: "100%",
            background: props2.themeContext.main.background
          }
        },
        /* @__PURE__ */ React204.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React204.createElement(OptionGroupHeader_default, { key: `sticky-header`, group, addTopPadding: false, ...headerProps }))
      ));
    };
    StickyHeader_default = StickyHeader;
  }
});

// node_modules/react-virtual/dist/react-virtual.mjs
import React205 from "react";
function _extends3() {
  _extends3 = Object.assign || function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends3.apply(this, arguments);
}
function _objectWithoutPropertiesLoose2(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
function observeRect(node, cb) {
  return {
    observe: function observe() {
      var wasEmpty = observedNodes.size === 0;
      if (observedNodes.has(node)) {
        observedNodes.get(node).callbacks.push(cb);
      } else {
        observedNodes.set(node, {
          rect: void 0,
          hasRectChanged: false,
          callbacks: [cb]
        });
      }
      if (wasEmpty)
        run();
    },
    unobserve: function unobserve() {
      var state = observedNodes.get(node);
      if (state) {
        var index3 = state.callbacks.indexOf(cb);
        if (index3 >= 0)
          state.callbacks.splice(index3, 1);
        if (!state.callbacks.length)
          observedNodes["delete"](node);
        if (!observedNodes.size)
          cancelAnimationFrame(rafId);
      }
    }
  };
}
function useRect(nodeRef, initialRect) {
  if (initialRect === void 0) {
    initialRect = {
      width: 0,
      height: 0
    };
  }
  var _React$useState = React205.useState(nodeRef.current), element = _React$useState[0], setElement = _React$useState[1];
  var _React$useReducer = React205.useReducer(rectReducer, initialRect), rect = _React$useReducer[0], dispatch = _React$useReducer[1];
  var initialRectSet = React205.useRef(false);
  useIsomorphicLayoutEffect2(function() {
    if (nodeRef.current !== element) {
      setElement(nodeRef.current);
    }
  });
  useIsomorphicLayoutEffect2(function() {
    if (element && !initialRectSet.current) {
      initialRectSet.current = true;
      var _rect = element.getBoundingClientRect();
      dispatch({
        rect: _rect
      });
    }
  }, [element]);
  React205.useEffect(function() {
    if (!element) {
      return;
    }
    var observer = observeRect(element, function(rect2) {
      dispatch({
        rect: rect2
      });
    });
    observer.observe();
    return function() {
      observer.unobserve();
    };
  }, [element]);
  return rect;
}
function rectReducer(state, action) {
  var rect = action.rect;
  if (state.height !== rect.height || state.width !== rect.width) {
    return rect;
  }
  return state;
}
function useVirtual(_ref) {
  var _measurements;
  var _ref$size = _ref.size, size = _ref$size === void 0 ? 0 : _ref$size, _ref$estimateSize = _ref.estimateSize, estimateSize = _ref$estimateSize === void 0 ? defaultEstimateSize : _ref$estimateSize, _ref$overscan = _ref.overscan, overscan = _ref$overscan === void 0 ? 1 : _ref$overscan, _ref$paddingStart = _ref.paddingStart, paddingStart = _ref$paddingStart === void 0 ? 0 : _ref$paddingStart, _ref$paddingEnd = _ref.paddingEnd, paddingEnd = _ref$paddingEnd === void 0 ? 0 : _ref$paddingEnd, parentRef = _ref.parentRef, horizontal = _ref.horizontal, scrollToFn = _ref.scrollToFn, useObserver = _ref.useObserver, initialRect = _ref.initialRect, onScrollElement = _ref.onScrollElement, scrollOffsetFn = _ref.scrollOffsetFn, _ref$keyExtractor = _ref.keyExtractor, keyExtractor = _ref$keyExtractor === void 0 ? defaultKeyExtractor : _ref$keyExtractor, _ref$measureSize = _ref.measureSize, measureSize = _ref$measureSize === void 0 ? defaultMeasureSize : _ref$measureSize, _ref$rangeExtractor = _ref.rangeExtractor, rangeExtractor = _ref$rangeExtractor === void 0 ? defaultRangeExtractor : _ref$rangeExtractor;
  var sizeKey = horizontal ? "width" : "height";
  var scrollKey = horizontal ? "scrollLeft" : "scrollTop";
  var latestRef = React205.useRef({
    scrollOffset: 0,
    measurements: []
  });
  var _React$useState = React205.useState(0), scrollOffset = _React$useState[0], setScrollOffset = _React$useState[1];
  latestRef.current.scrollOffset = scrollOffset;
  var useMeasureParent = useObserver || useRect;
  var _useMeasureParent = useMeasureParent(parentRef, initialRect), outerSize = _useMeasureParent[sizeKey];
  latestRef.current.outerSize = outerSize;
  var defaultScrollToFn = React205.useCallback(function(offset6) {
    if (parentRef.current) {
      parentRef.current[scrollKey] = offset6;
    }
  }, [parentRef, scrollKey]);
  var resolvedScrollToFn = scrollToFn || defaultScrollToFn;
  scrollToFn = React205.useCallback(function(offset6) {
    resolvedScrollToFn(offset6, defaultScrollToFn);
  }, [defaultScrollToFn, resolvedScrollToFn]);
  var _React$useState2 = React205.useState({}), measuredCache = _React$useState2[0], setMeasuredCache = _React$useState2[1];
  var measure = React205.useCallback(function() {
    return setMeasuredCache({});
  }, []);
  var pendingMeasuredCacheIndexesRef = React205.useRef([]);
  var measurements = React205.useMemo(function() {
    var min = pendingMeasuredCacheIndexesRef.current.length > 0 ? Math.min.apply(Math, pendingMeasuredCacheIndexesRef.current) : 0;
    pendingMeasuredCacheIndexesRef.current = [];
    var measurements2 = latestRef.current.measurements.slice(0, min);
    for (var i2 = min; i2 < size; i2++) {
      var key = keyExtractor(i2);
      var measuredSize = measuredCache[key];
      var _start = measurements2[i2 - 1] ? measurements2[i2 - 1].end : paddingStart;
      var _size = typeof measuredSize === "number" ? measuredSize : estimateSize(i2);
      var _end = _start + _size;
      measurements2[i2] = {
        index: i2,
        start: _start,
        size: _size,
        end: _end,
        key
      };
    }
    return measurements2;
  }, [estimateSize, measuredCache, paddingStart, size, keyExtractor]);
  var totalSize = (((_measurements = measurements[size - 1]) == null ? void 0 : _measurements.end) || paddingStart) + paddingEnd;
  latestRef.current.measurements = measurements;
  latestRef.current.totalSize = totalSize;
  var element = onScrollElement ? onScrollElement.current : parentRef.current;
  var scrollOffsetFnRef = React205.useRef(scrollOffsetFn);
  scrollOffsetFnRef.current = scrollOffsetFn;
  useIsomorphicLayoutEffect2(function() {
    if (!element) {
      setScrollOffset(0);
      return;
    }
    var onScroll = function onScroll2(event) {
      var offset6 = scrollOffsetFnRef.current ? scrollOffsetFnRef.current(event) : element[scrollKey];
      setScrollOffset(offset6);
    };
    onScroll();
    element.addEventListener("scroll", onScroll, {
      capture: false,
      passive: true
    });
    return function() {
      element.removeEventListener("scroll", onScroll);
    };
  }, [element, scrollKey]);
  var _calculateRange = calculateRange(latestRef.current), start2 = _calculateRange.start, end = _calculateRange.end;
  var indexes = React205.useMemo(function() {
    return rangeExtractor({
      start: start2,
      end,
      overscan,
      size: measurements.length
    });
  }, [start2, end, overscan, measurements.length, rangeExtractor]);
  var measureSizeRef = React205.useRef(measureSize);
  measureSizeRef.current = measureSize;
  var virtualItems = React205.useMemo(function() {
    var virtualItems2 = [];
    var _loop = function _loop2(k2, len2) {
      var i2 = indexes[k2];
      var measurement = measurements[i2];
      var item = _extends3(_extends3({}, measurement), {}, {
        measureRef: function measureRef(el) {
          if (el) {
            var measuredSize = measureSizeRef.current(el, horizontal);
            if (measuredSize !== item.size) {
              var _scrollOffset = latestRef.current.scrollOffset;
              if (item.start < _scrollOffset) {
                defaultScrollToFn(_scrollOffset + (measuredSize - item.size));
              }
              pendingMeasuredCacheIndexesRef.current.push(i2);
              setMeasuredCache(function(old) {
                var _extends22;
                return _extends3(_extends3({}, old), {}, (_extends22 = {}, _extends22[item.key] = measuredSize, _extends22));
              });
            }
          }
        }
      });
      virtualItems2.push(item);
    };
    for (var k = 0, len = indexes.length; k < len; k++) {
      _loop(k);
    }
    return virtualItems2;
  }, [indexes, defaultScrollToFn, horizontal, measurements]);
  var mountedRef = React205.useRef(false);
  useIsomorphicLayoutEffect2(function() {
    if (mountedRef.current) {
      setMeasuredCache({});
    }
    mountedRef.current = true;
  }, [estimateSize]);
  var scrollToOffset = React205.useCallback(function(toOffset, _temp) {
    var _ref2 = _temp === void 0 ? {} : _temp, _ref2$align = _ref2.align, align = _ref2$align === void 0 ? "start" : _ref2$align;
    var _latestRef$current = latestRef.current, scrollOffset2 = _latestRef$current.scrollOffset, outerSize2 = _latestRef$current.outerSize;
    if (align === "auto") {
      if (toOffset <= scrollOffset2) {
        align = "start";
      } else if (toOffset >= scrollOffset2 + outerSize2) {
        align = "end";
      } else {
        align = "start";
      }
    }
    if (align === "start") {
      scrollToFn(toOffset);
    } else if (align === "end") {
      scrollToFn(toOffset - outerSize2);
    } else if (align === "center") {
      scrollToFn(toOffset - outerSize2 / 2);
    }
  }, [scrollToFn]);
  var tryScrollToIndex = React205.useCallback(function(index3, _temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$align = _ref3.align, align = _ref3$align === void 0 ? "auto" : _ref3$align, rest = _objectWithoutPropertiesLoose2(_ref3, ["align"]);
    var _latestRef$current2 = latestRef.current, measurements2 = _latestRef$current2.measurements, scrollOffset2 = _latestRef$current2.scrollOffset, outerSize2 = _latestRef$current2.outerSize;
    var measurement = measurements2[Math.max(0, Math.min(index3, size - 1))];
    if (!measurement) {
      return;
    }
    if (align === "auto") {
      if (measurement.end >= scrollOffset2 + outerSize2) {
        align = "end";
      } else if (measurement.start <= scrollOffset2) {
        align = "start";
      } else {
        return;
      }
    }
    var toOffset = align === "center" ? measurement.start + measurement.size / 2 : align === "end" ? measurement.end : measurement.start;
    scrollToOffset(toOffset, _extends3({
      align
    }, rest));
  }, [scrollToOffset, size]);
  var scrollToIndex = React205.useCallback(function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    tryScrollToIndex.apply(void 0, args);
    requestAnimationFrame(function() {
      tryScrollToIndex.apply(void 0, args);
    });
  }, [tryScrollToIndex]);
  return {
    virtualItems,
    totalSize,
    scrollToOffset,
    scrollToIndex,
    measure
  };
}
function calculateRange(_ref4) {
  var measurements = _ref4.measurements, outerSize = _ref4.outerSize, scrollOffset = _ref4.scrollOffset;
  var size = measurements.length - 1;
  var getOffset2 = function getOffset3(index3) {
    return measurements[index3].start;
  };
  var start2 = findNearestBinarySearch(0, size, getOffset2, scrollOffset);
  var end = start2;
  while (end < size && measurements[end].end < scrollOffset + outerSize) {
    end++;
  }
  return {
    start: start2,
    end
  };
}
var props, rectChanged, observedNodes, rafId, run, useIsomorphicLayoutEffect2, defaultEstimateSize, defaultKeyExtractor, defaultMeasureSize, defaultRangeExtractor, findNearestBinarySearch;
var init_react_virtual = __esm({
  "node_modules/react-virtual/dist/react-virtual.mjs"() {
    props = ["bottom", "height", "left", "right", "top", "width"];
    rectChanged = function rectChanged2(a, b) {
      if (a === void 0) {
        a = {};
      }
      if (b === void 0) {
        b = {};
      }
      return props.some(function(prop) {
        return a[prop] !== b[prop];
      });
    };
    observedNodes = /* @__PURE__ */ new Map();
    run = function run2() {
      var changedStates = [];
      observedNodes.forEach(function(state, node) {
        var newRect = node.getBoundingClientRect();
        if (rectChanged(newRect, state.rect)) {
          state.rect = newRect;
          changedStates.push(state);
        }
      });
      changedStates.forEach(function(state) {
        state.callbacks.forEach(function(cb) {
          return cb(state.rect);
        });
      });
      rafId = window.requestAnimationFrame(run2);
    };
    useIsomorphicLayoutEffect2 = typeof window !== "undefined" ? React205.useLayoutEffect : React205.useEffect;
    defaultEstimateSize = function defaultEstimateSize2() {
      return 50;
    };
    defaultKeyExtractor = function defaultKeyExtractor2(index3) {
      return index3;
    };
    defaultMeasureSize = function defaultMeasureSize2(el, horizontal) {
      var key = horizontal ? "offsetWidth" : "offsetHeight";
      return el[key];
    };
    defaultRangeExtractor = function defaultRangeExtractor2(range) {
      var start2 = Math.max(range.start - range.overscan, 0);
      var end = Math.min(range.end + range.overscan, range.size - 1);
      var arr = [];
      for (var i2 = start2; i2 <= end; i2++) {
        arr.push(i2);
      }
      return arr;
    };
    findNearestBinarySearch = function findNearestBinarySearch2(low, high, getCurrentValue, value) {
      while (low <= high) {
        var middle = (low + high) / 2 | 0;
        var currentValue = getCurrentValue(middle);
        if (currentValue < value) {
          low = middle + 1;
        } else if (currentValue > value) {
          high = middle - 1;
        } else {
          return middle;
        }
      }
      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    };
  }
});

// commandbar/src/shared/util/hooks/useResizeObserver.tsx
import { useLayoutEffect as useLayoutEffect3, useState as useState27, useCallback as useCallback14 } from "react";
var ResizeObserver3, useResizeObserver2, useResizeObserver_default;
var init_useResizeObserver = __esm({
  "commandbar/src/shared/util/hooks/useResizeObserver.tsx"() {
    "use strict";
    ResizeObserver3 = window.ResizeObserver;
    if (false) {
      const { ResizeObserver: Polyfill } = null;
      ResizeObserver3 = Polyfill;
    }
    useResizeObserver2 = (element) => {
      const [size, setSize] = useState27();
      const handleResize = useCallback14((entries) => {
        const [entry] = entries;
        const { width, height } = entry.contentRect;
        setSize({ width, height });
      }, []);
      useLayoutEffect3(() => {
        const observer = new ResizeObserver3(handleResize);
        if (element) {
          observer.observe(element);
        } else {
          setSize({ width: 0, height: 0 });
        }
        return () => {
          observer.disconnect();
        };
      }, [element]);
      return { width: size == null ? void 0 : size.width, height: size == null ? void 0 : size.height };
    };
    useResizeObserver_default = useResizeObserver2;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOption.tsx
import { css as css40, jsx as jsx66 } from "@emotion/core";
var styles29, focusedStyles, StyledSpotlightOption, StyledSpotlightOption_default;
var init_StyledSpotlightOption = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOption.tsx"() {
    "use strict";
    styles29 = css40({
      display: "flex",
      width: "100%",
      minHeight: "48px",
      padding: "0px var(--layout-padding)",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "var(--layout-gap)",
      borderRadius: "var(--layout-radius-button)",
      color: "var(--content-secondary)"
    });
    focusedStyles = css40({
      background: "var(--form-control-active-background)",
      color: "var(--content-primary)"
    });
    StyledSpotlightOption = ({ isFocused, children, ...props2 }) => {
      return /* @__PURE__ */ jsx66("div", { css: [styles29, isFocused && focusedStyles], ...props2 }, children);
    };
    StyledSpotlightOption_default = StyledSpotlightOption;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionHeader.tsx
import { css as css41, jsx as jsx67 } from "@emotion/core";
var styles30, StyledSpotlightOptionHeader, StyledSpotlightOptionHeader_default;
var init_StyledSpotlightOptionHeader = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionHeader.tsx"() {
    "use strict";
    styles30 = css41({
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      color: "var(--content-secondary)",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledSpotlightOptionHeader = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx67("div", { css: styles30, ...props2 }, children);
    };
    StyledSpotlightOptionHeader_default = StyledSpotlightOptionHeader;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionLabel.tsx
import { css as css42, jsx as jsx68 } from "@emotion/core";
var styles31, StyledSpotlightOptionLabel, StyledSpotlightOptionLabel_default;
var init_StyledSpotlightOptionLabel = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionLabel.tsx"() {
    "use strict";
    styles31 = css42({
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      color: "var(--content-primary)",
      /* label/base/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-base)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledSpotlightOptionLabel = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx68("div", { css: styles31, ...props2 }, children);
    };
    StyledSpotlightOptionLabel_default = StyledSpotlightOptionLabel;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionDescription.tsx
import { css as css43, jsx as jsx69 } from "@emotion/core";
var styles32, StyledSpotlightOptionDescription, StyledSpotlightOptionDescription_default;
var init_StyledSpotlightOptionDescription = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionDescription.tsx"() {
    "use strict";
    styles32 = css43({
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden",
      color: "var(--content-secondary)",
      /* label/small/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-small)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledSpotlightOptionDescription = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx69("div", { css: styles32, ...props2 }, children);
    };
    StyledSpotlightOptionDescription_default = StyledSpotlightOptionDescription;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionLeftContainer.tsx
import { css as css44, jsx as jsx70 } from "@emotion/core";
var styles33, StyledSpotlightOptionLeftContainer, StyledSpotlightOptionLeftContainer_default;
var init_StyledSpotlightOptionLeftContainer = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionLeftContainer.tsx"() {
    "use strict";
    styles33 = css44({
      display: "flex",
      flexDirection: "column",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    });
    StyledSpotlightOptionLeftContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx70("div", { css: styles33, ...props2 }, children);
    };
    StyledSpotlightOptionLeftContainer_default = StyledSpotlightOptionLeftContainer;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionRightContainer.tsx
import { css as css45, jsx as jsx71 } from "@emotion/core";
var styles34, StyledSpotlightOptionRightContainer, StyledSpotlightOptionRightContainer_default;
var init_StyledSpotlightOptionRightContainer = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionRightContainer.tsx"() {
    "use strict";
    styles34 = css45({
      display: "flex",
      gap: "4px",
      flex: "1",
      justifyContent: "end",
      alignItems: "center"
    });
    StyledSpotlightOptionRightContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx71("div", { css: styles34, ...props2 }, children);
    };
    StyledSpotlightOptionRightContainer_default = StyledSpotlightOptionRightContainer;
  }
});

// commandbar/src/products/spotlight/components/option/OptionWrapper.tsx
import { css as css46, jsx as jsx72, keyframes as keyframes7 } from "@emotion/core";
import * as React206 from "react";
var getOptionWrapperStyles, OptionWrapper, OptionWrapper_default;
var init_OptionWrapper = __esm({
  "commandbar/src/products/spotlight/components/option/OptionWrapper.tsx"() {
    "use strict";
    init_useStore();
    init_selectors3();
    init_useTheme();
    init_StyledSpotlightOption();
    init_StyledSpotlightOptionHeader();
    init_StyledSpotlightOptionLabel();
    init_StyledSpotlightOptionDescription();
    init_StyledSpotlightOptionLeftContainer();
    init_StyledSpotlightOptionRightContainer();
    init_StyledIconContainer();
    getOptionWrapperStyles = (theme, isFocused, isDisabled, renderAs = "list") => {
      if (renderAs === "grid") {
        return {
          ...theme.menuGridOption,
          ...isFocused ? theme.menuGridOptionSelected : {},
          ...isDisabled ? theme.menuGridOptionDisabled : {},
          ...isFocused && isDisabled ? theme.menuGridOptionDisabledSelected : {}
        };
      }
      return {
        ...theme.option,
        ...isFocused ? theme.optionSelected : {},
        ...isDisabled ? theme.optionDisabled : {},
        ...isFocused && isDisabled ? theme.optionDisabledSelected : {}
      };
    };
    OptionWrapper = (props2) => {
      var _a2;
      const { theme } = useTheme();
      const _ = useStore();
      const { errorTimestamp, searchFilter } = _.spotlight;
      const [renderAs, isGridOption] = React206.useMemo(() => {
        const _renderAs = optionIsInGrid(_, props2.option) ? "grid" : "list";
        return [_renderAs, _renderAs === "grid"];
      }, [props2.option, searchFilter]);
      const style3 = getOptionWrapperStyles(theme, props2.isFocused, props2.isDisabled, renderAs);
      const errorAnimationKeyframes = keyframes7`
  10%,
  90% {
    transform: translate3d(-0.5px, 0, 0);
  }

  20%,
  80% {
    transform: translate3d(1px, 0, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(-2px, 0, 0);
  }

  40%,
  60% {
    transform: translate3d(2px, 0, 0);
  }
`;
      const errorAnimation = css46`
    animation: ${errorAnimationKeyframes} 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    transform: translate3d(0, 0, 0);
  `;
      const hideIcon = isGridOption ? theme.menuGridOption.iconDisplay === "none" : theme.option.iconDisplay === "none";
      if ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) {
        return /* @__PURE__ */ jsx72(
          StyledSpotlightOption_default,
          {
            key: errorTimestamp,
            css: props2.isError ? errorAnimation : {},
            className: `commandbar-option commandbar-option-${props2.type} ${!!props2.isMultiSelectSelection ? "commandbar-option-selected" : ""}`,
            isFocused: props2.isFocused,
            style: { ...isGridOption && { borderRadius: "0px", justifyContent: "flex-start" } }
          },
          /* @__PURE__ */ jsx72(StyledIconContainer_default, null, props2.icon),
          props2.draft,
          /* @__PURE__ */ jsx72(StyledSpotlightOptionLeftContainer_default, null, props2.heading && /* @__PURE__ */ jsx72(StyledSpotlightOptionHeader_default, null, props2.heading), /* @__PURE__ */ jsx72(StyledSpotlightOptionLabel_default, null, props2.label), !!props2.description && /* @__PURE__ */ jsx72(StyledSpotlightOptionDescription_default, null, props2.description), props2.extra),
          !isGridOption && /* @__PURE__ */ jsx72(StyledSpotlightOptionRightContainer_default, null, props2.shortcut, props2.goForward && /* @__PURE__ */ jsx72(StyledIconContainer_default, null, props2.goForward))
        );
      }
      if (isGridOption) {
        return /* @__PURE__ */ jsx72(
          "div",
          {
            key: errorTimestamp,
            css: props2.isError ? errorAnimation : {},
            style: {
              display: "flex",
              width: "100%",
              height: "100%",
              fontWeight: 400,
              flexDirection: "column",
              justifyContent: "space-between"
            },
            className: `commandbar-option commandbar-option-${props2.type} ${!!props2.isMultiSelectSelection && "commandbar-option-selected"}`
          },
          /* @__PURE__ */ jsx72(
            "div",
            {
              style: {
                width: "100%",
                display: "flex",
                alignItems: "center"
              }
            },
            hideIcon ? null : isGridOption ? /* @__PURE__ */ jsx72(
              "div",
              {
                role: "img",
                "aria-hidden": true,
                style: {
                  alignSelf: theme.option.iconAlign,
                  lineHeight: 0,
                  // https://stackoverflow.com/a/22300226
                  marginRight: "10px",
                  marginLeft: "10px"
                }
              },
              props2.icon
            ) : /* @__PURE__ */ jsx72(
              "div",
              {
                role: "img",
                "aria-hidden": true,
                style: {
                  alignSelf: theme.option.iconAlign,
                  lineHeight: 0
                  // https://stackoverflow.com/a/22300226
                }
              },
              props2.icon
            ),
            !isGridOption ? /* @__PURE__ */ jsx72("div", { style: { minWidth: theme.option.spaceBetweenIconAndLabel } }) : null,
            /* @__PURE__ */ jsx72(
              "div",
              {
                style: {
                  color: style3.color,
                  fontFamily: style3.fontFamily,
                  fontSize: style3.fontSize,
                  width: "100%",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  lineHeight: theme.option.lineHeight
                }
              },
              /* @__PURE__ */ jsx72("div", null, props2.heading && /* @__PURE__ */ jsx72(
                "div",
                {
                  style: {
                    fontSize: style3.breadcrumbsFontSize,
                    color: style3.breadcrumbsColor,
                    marginBottom: style3.breadcrumbsMarginBottom,
                    marginTop: style3.breadcrumbsMarginTop,
                    fontWeight: style3.breadcrumbsFontWeight
                  }
                },
                props2.heading
              ), /* @__PURE__ */ jsx72(
                "span",
                {
                  role: "heading",
                  "aria-level": 2,
                  style: {
                    display: "flex",
                    alignContent: "flex-start",
                    alignItems: "center",
                    fontWeight: style3.labelFontWeight,
                    marginTop: style3.labelMarginTop,
                    marginBottom: style3.labelMarginBottom,
                    whiteSpace: "normal"
                  }
                },
                props2.draft && /* @__PURE__ */ jsx72("div", { style: { paddingRight: 10 } }, props2.draft),
                props2.label
              ), !!props2.description && /* @__PURE__ */ jsx72(
                "div",
                {
                  role: "heading",
                  "aria-level": 3,
                  css: {
                    fontSize: style3.descriptionFontSize,
                    fontStyle: style3.descriptionFontStyle,
                    marginTop: style3.descriptionMarginTop,
                    marginBottom: style3.descriptionMarginBottom,
                    color: props2.isError ? theme.option.descriptionColor : style3.descriptionColor,
                    transition: "color 0.8s",
                    maxWidth: "100%",
                    overflow: "hidden",
                    whiteSpace: "normal",
                    textAlign: "left"
                  }
                },
                props2.description
              ), !!props2.extra && /* @__PURE__ */ jsx72("div", { role: "heading", "aria-level": 3 }, props2.extra)),
              /* @__PURE__ */ jsx72("div", null)
            ),
            props2.goForward && /* @__PURE__ */ jsx72("div", null, props2.goForward)
          ),
          /* @__PURE__ */ jsx72(
            "div",
            {
              style: {
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center"
              }
            },
            props2.shortcut
          )
        );
      }
      return /* @__PURE__ */ jsx72(
        "div",
        {
          key: errorTimestamp,
          css: props2.isError ? errorAnimation : {},
          style: {
            display: "flex",
            width: "100%",
            fontWeight: 400,
            justifyContent: "space-between",
            alignItems: "center"
          },
          className: `commandbar-option commandbar-option-${props2.type} ${!!props2.isMultiSelectSelection ? "commandbar-option-selected" : ""}`
        },
        theme.option.iconDisplay === "none" ? null : isGridOption ? /* @__PURE__ */ jsx72(
          "div",
          {
            role: "img",
            "aria-hidden": true,
            style: {
              alignSelf: theme.option.iconAlign,
              lineHeight: 0,
              // https://stackoverflow.com/a/22300226
              marginRight: "10px",
              marginLeft: "10px"
            }
          },
          props2.icon
        ) : /* @__PURE__ */ jsx72(
          "div",
          {
            role: "img",
            "aria-hidden": true,
            style: {
              ..."iconColor" in style3 && { color: style3.iconColor },
              alignSelf: theme.option.iconAlign,
              lineHeight: 0
              // https://stackoverflow.com/a/22300226
            }
          },
          props2.icon
        ),
        !isGridOption ? /* @__PURE__ */ jsx72("div", { style: { minWidth: theme.option.spaceBetweenIconAndLabel } }) : null,
        /* @__PURE__ */ jsx72(
          "div",
          {
            style: {
              color: style3.color,
              fontFamily: style3.fontFamily,
              fontSize: style3.fontSize,
              maxWidth: "90%",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden",
              lineHeight: theme.option.lineHeight
            }
          },
          props2.heading && /* @__PURE__ */ jsx72(
            "div",
            {
              style: {
                fontSize: style3.breadcrumbsFontSize,
                color: style3.breadcrumbsColor,
                marginBottom: style3.breadcrumbsMarginBottom,
                marginTop: style3.breadcrumbsMarginTop,
                fontWeight: style3.breadcrumbsFontWeight
              }
            },
            props2.heading
          ),
          /* @__PURE__ */ jsx72(
            "span",
            {
              style: {
                display: "flex",
                alignContent: "flex-start",
                alignItems: "center",
                fontWeight: style3.labelFontWeight,
                marginTop: style3.labelMarginTop,
                marginBottom: style3.labelMarginBottom
              }
            },
            props2.draft && /* @__PURE__ */ jsx72("div", { style: { paddingRight: 10 } }, props2.draft),
            props2.label
          ),
          !!props2.description && /* @__PURE__ */ jsx72(
            "div",
            {
              style: {
                fontSize: style3.descriptionFontSize,
                fontStyle: style3.descriptionFontStyle,
                marginTop: style3.descriptionMarginTop,
                marginBottom: style3.descriptionMarginBottom,
                color: props2.isError ? theme.option.descriptionColor : style3.descriptionColor,
                transition: "color 0.8s",
                maxWidth: "100%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: isGridOption ? "normal" : "nowrap"
              }
            },
            props2.description
          ),
          !!props2.extra && /* @__PURE__ */ jsx72("div", null, props2.extra)
        ),
        /* @__PURE__ */ jsx72("div", { style: { flexGrow: 1 } }),
        /* @__PURE__ */ jsx72("div", { style: { display: "flex", alignItems: "center", marginLeft: 5 } }, props2.shortcut, props2.goForward)
      );
    };
    OptionWrapper_default = OptionWrapper;
  }
});

// commandbar/src/products/spotlight/components/option/helpers.tsx
var getIconSize;
var init_helpers14 = __esm({
  "commandbar/src/products/spotlight/components/option/helpers.tsx"() {
    "use strict";
    getIconSize = (_, theme) => {
      const isGridOption = _.spotlight.searchFilter && _.spotlight.searchFilter.renderAs === "grid";
      return isGridOption ? theme.menuGridOption.iconSize : theme.option.iconSize;
    };
  }
});

// commandbar/src/products/spotlight/components/option/CommandOptionIcon.tsx
import React207 from "react";
var CommandOptionIcon;
var init_CommandOptionIcon = __esm({
  "commandbar/src/products/spotlight/components/option/CommandOptionIcon.tsx"() {
    "use strict";
    init_useStore();
    init_Icon2();
    init_selectors3();
    init_helpers14();
    init_useTheme();
    CommandOptionIcon = ({ isDisabled, isFocused, option }) => {
      const _ = useStore();
      const { theme } = useTheme();
      const { icon, icon_color } = getCommandIcon(_, option);
      const { icon: category_icon, icon_color: category_icon_color } = getCategoryIcon(_, option);
      const { defaultColorFromTheme, opacity, useDefaultSVGColor } = getOptionIconColorBase(theme, isFocused, isDisabled);
      const color = category_icon_color || icon_color || defaultColorFromTheme;
      const style3 = { color, opacity };
      return /* @__PURE__ */ React207.createElement(
        Icon_default2,
        {
          icon: category_icon || icon,
          color,
          default: commandDefault(option.command),
          style: style3,
          useDefaultSVGColor,
          size: getIconSize(_, theme)
        }
      );
    };
  }
});

// commandbar/src/products/spotlight/components/option/OptionHighlight.tsx
import React208 from "react";
import truncate3 from "lodash/truncate";
var getStringStartIndex, getTruncatedText, OptionHighlight;
var init_OptionHighlight = __esm({
  "commandbar/src/products/spotlight/components/option/OptionHighlight.tsx"() {
    "use strict";
    init_useStore();
    init_selectors3();
    init_useTheme();
    getStringStartIndex = (text, bestMatchStartIndex) => {
      if (bestMatchStartIndex <= 20) {
        return 0;
      }
      let stringStartIndex = bestMatchStartIndex - 10;
      while (text[stringStartIndex - 1] !== " " && stringStartIndex !== bestMatchStartIndex) {
        stringStartIndex++;
      }
      return stringStartIndex;
    };
    getTruncatedText = (text, length, isGridOption) => {
      return isGridOption ? truncate3(text, { length, omission: "..." }) : text;
    };
    OptionHighlight = ({ emphasize = false, labelToHighlight, option, text }) => {
      const { theme } = useTheme();
      const { flags } = useStore();
      const isGridOption = optionIsInGrid(useStore(), option);
      const maxTextLength = isGridOption ? 80 : 100;
      if (typeof text !== "string") {
        return text || null;
      }
      if (!option.searchMatches[0] || option.searchMatches[0].path !== labelToHighlight)
        return /* @__PURE__ */ React208.createElement("span", null, getTruncatedText(text, maxTextLength, !!isGridOption));
      const pairLength = (pair) => pair[1] - pair[0] + 1;
      const findBestPair = (indices) => {
        let longestMatch = void 0;
        for (const pair of indices) {
          if (pair.length > 0) {
            if (!longestMatch)
              longestMatch = pair;
            if (pairLength(pair) > pairLength(longestMatch))
              longestMatch = pair;
          }
        }
        if (longestMatch) {
          return { start: longestMatch[0], end: longestMatch[1] };
        }
        return null;
      };
      const highlightStyle = (flags == null ? void 0 : flags["release-themes-v2"]) ? { fontWeight: "var(--font-weight-semibold)" } : {
        color: "inherit",
        textDecoration: theme.textSearchMatch.textDecoration,
        textUnderlinePosition: emphasize ? theme.textSearchMatch.emphasisTextUnderlinePosition : theme.textSearchMatch.textUnderlinePosition,
        fontWeight: emphasize ? theme.textSearchMatch.emphasisFontWeight : theme.textSearchMatch.fontWeight
      };
      highlightStyle["WebkitTextDecoration"] = theme.textSearchMatch.textDecoration;
      const nodes = [];
      if (text.length < maxTextLength) {
        let start2 = 0;
        const MIN_LENGTH_TO_HIGHLIGHT = 2;
        for (const pair of option.searchMatches[0].indices) {
          if (pairLength(pair) >= MIN_LENGTH_TO_HIGHLIGHT) {
            nodes.push(text.substring(start2, pair[0]));
            nodes.push(
              /* @__PURE__ */ React208.createElement("span", { key: `search-match-${start2}-${labelToHighlight}`, style: highlightStyle }, text.substring(pair[0], pair[1] + 1))
            );
            start2 = pair[1] + 1;
          }
        }
        nodes.push(text.substring(start2, text.length));
      } else {
        const bestMatch = findBestPair(option.searchMatches[0].indices);
        if (!bestMatch)
          return /* @__PURE__ */ React208.createElement("span", null, getTruncatedText(text, maxTextLength, !!isGridOption));
        const stringStartIndex = getStringStartIndex(text, bestMatch.start);
        nodes.push(stringStartIndex > 0 && "...");
        nodes.push(text.substring(stringStartIndex, bestMatch.start));
        nodes.push(
          /* @__PURE__ */ React208.createElement("span", { key: `search-match-${bestMatch.start}-${labelToHighlight}`, style: highlightStyle }, text.substring(bestMatch.start, bestMatch.end))
        );
        const lengthRemaining = bestMatch.end - stringStartIndex;
        nodes.push(
          getTruncatedText(text.substring(bestMatch.end, text.length), maxTextLength - lengthRemaining, !!isGridOption)
        );
      }
      return /* @__PURE__ */ React208.createElement("span", { style: { color: "inherit" } }, nodes);
    };
  }
});

// internal/src/client/KeyRecorder.tsx
var KeyRecorder;
var init_KeyRecorder = __esm({
  "internal/src/client/KeyRecorder.tsx"() {
    "use strict";
    init_Hotkey();
    KeyRecorder = class {
      constructor(mousetrap, onType, onFinish, validate2 = true) {
        // are we recording?
        this.recording = true;
        // the transformed master sequence of what to return
        this.recordedSequence = [];
        // the raw user input, not transformed yet
        this.currentRecordedKeys = [];
        this.recordedCharacterKey = false;
        this.recordTimer = -1;
        this.comboCount = 0;
        this.handleKey = (character, modifiers, e) => {
          if (this.recording) {
            e.stopPropagation();
            e.preventDefault();
            if (e.type === "keydown") {
              if (!Hotkey_default.isModifier(character) && this.recordedCharacterKey) {
                this.recordCurrentCombo();
              }
              modifiers.map((modifier) => {
                this.recordKey(modifier);
                return null;
              });
              this.recordKey(character);
              if (!!this.onType) {
                const liveResults = this.recordedSequence.slice(0, this.comboCount);
                liveResults.push(this.currentRecordedKeys);
                this.onType(Hotkey_default.normalizeSequence(liveResults));
              }
            } else if (e.type === "keyup" && this.currentRecordedKeys.length > 0) {
              this.recordCurrentCombo();
              this.comboCount = this.comboCount + 1;
            }
          }
        };
        this.finishRecording = () => {
          if (!!this.onFinish) {
            let final = Hotkey_default.normalizeSequence(this.recordedSequence);
            if (this.validate && !Hotkey_default.validate(final, true))
              final = void 0;
            this.onFinish(final);
          }
          this.recording = false;
        };
        this.recordKey = (key) => {
          if (this.currentRecordedKeys.includes(key)) {
            return;
          }
          this.currentRecordedKeys.push(key);
          if (!Hotkey_default.isModifier(key)) {
            this.recordedCharacterKey = true;
          }
        };
        this.stop = () => {
          this.recording = false;
        };
        this.recordCurrentCombo = () => {
          this.recordedSequence.push(this.currentRecordedKeys);
          this.currentRecordedKeys = [];
          this.recordedCharacterKey = false;
          this.restartRecordTimer();
        };
        // Wait for 1 second after the last keypress before exiting
        this.restartRecordTimer = () => {
          clearTimeout(this.recordTimer);
          this.recordTimer = window.setTimeout(this.finishRecording, 1e3);
        };
        this.mousetrap = mousetrap;
        this.mousetrap.handleKey = this.handleKey;
        this.onType = onType;
        this.onFinish = onFinish;
        this.validate = validate2;
      }
    };
  }
});

// commandbar/src/products/spotlight/components/hotkeys/useKeypressRecorder.tsx
import React209 from "react";
var import_mousetrap_fork2, useKeypressRecorder, useKeypressRecorder_default;
var init_useKeypressRecorder = __esm({
  "commandbar/src/products/spotlight/components/hotkeys/useKeypressRecorder.tsx"() {
    "use strict";
    import_mousetrap_fork2 = __toESM(require_mousetrap_fork());
    init_KeyRecorder();
    useKeypressRecorder = (props2) => {
      const [keys, setKeys] = React209.useState("");
      React209.useEffect(() => {
        import_mousetrap_fork2.default.pause();
        const x = new KeyRecorder(new import_mousetrap_fork2.default(document.body, true), setKeys, props2.onFinish);
        return () => {
          x.stop();
          import_mousetrap_fork2.default.unpause();
        };
      }, [props2.onFinish]);
      return keys;
    };
    useKeypressRecorder_default = useKeypressRecorder;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledHotkeyTag.tsx
import { css as css47, jsx as jsx73 } from "@emotion/core";
var styles35, StyledHotkeyTag, StyledHotkeyTag_default;
var init_StyledHotkeyTag = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledHotkeyTag.tsx"() {
    "use strict";
    styles35 = css47({
      alignSelf: "center",
      color: "var(--content-secondary)",
      /* label/sm/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-small)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledHotkeyTag = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx73("div", { css: styles35, ...props2 }, children);
    };
    StyledHotkeyTag_default = StyledHotkeyTag;
  }
});

// commandbar/src/products/spotlight/components/hotkeys/HotkeyTag.tsx
import React210 from "react";
import { useTheme as useTheme17 } from "emotion-theming";
import chroma12 from "chroma-js";
var HotkeyTag, HotkeyTag_default;
var init_HotkeyTag = __esm({
  "commandbar/src/products/spotlight/components/hotkeys/HotkeyTag.tsx"() {
    "use strict";
    init_Tag();
    init_Hotkey();
    init_useStore();
    init_StyledHotkeyTag();
    HotkeyTag = (props2) => {
      const { theme } = useTheme17();
      const { flags } = useStore();
      const { platform } = useStore();
      if (props2.combo.length === 0) {
        return null;
      }
      const keys = props2.combo.split(" ");
      if (!["mac", "windows", "linux"].includes(platform)) {
        return null;
      }
      let color;
      try {
        color = chroma12(theme.keyboardShortcuts.color);
      } catch (e) {
        color = chroma12("rgba(255, 255, 255, 0.85)");
      }
      const tags2 = [];
      keys.forEach((s, index3) => {
        tags2.push(
          (flags == null ? void 0 : flags["release-themes-v2"]) ? /* @__PURE__ */ React210.createElement(StyledHotkeyTag_default, { key: index3 }, s.split("+").map((k, i2, arr) => {
            return /* @__PURE__ */ React210.createElement("span", { key: i2 }, Hotkey_default.translateToPlatformSymbol(
              k,
              ["windows", "linux"].includes(platform) ? "win" : "mac",
              i2 === arr.length - 1
            ));
          })) : /* @__PURE__ */ React210.createElement(
            Tag_default,
            {
              key: `${s}-${index3}`,
              color,
              borderRadius: theme.keyboardShortcuts.borderRadius,
              backgroundColor: theme.keyboardShortcuts.background,
              borderColor: props2.highlight ? theme.keyboardShortcuts.highlight : theme.keyboardShortcuts.borderColor,
              fontSize: theme.keyboardShortcuts.fontSize,
              style: {
                paddingTop: theme.keyboardShortcuts.paddingTop,
                paddingBottom: theme.keyboardShortcuts.paddingBottom,
                paddingLeft: theme.keyboardShortcuts.paddingLeft,
                paddingRight: theme.keyboardShortcuts.paddingRight,
                fontFamily: theme.keyboardShortcuts.fontFamily,
                fontWeight: theme.keyboardShortcuts.fontWeight,
                borderBottomColor: props2.isUserCustomized || props2.highlight ? theme.keyboardShortcuts.highlight : theme.keyboardShortcuts.borderColor,
                borderBottomWidth: props2.isUserCustomized ? "3px" : "1px",
                boxSizing: "border-box"
              }
            },
            s.split("+").map((k, i2, arr) => {
              return /* @__PURE__ */ React210.createElement("span", { key: i2 }, Hotkey_default.translateToPlatformSymbol(
                k,
                ["windows", "linux"].includes(platform) ? "win" : "mac",
                i2 === arr.length - 1
              ));
            })
          )
        );
        if (index3 !== keys.length - 1 && !(flags == null ? void 0 : flags["release-themes-v2"])) {
          tags2.push(
            /* @__PURE__ */ React210.createElement(
              "span",
              {
                "aria-hidden": true,
                key: `then-${index3}`,
                style: {
                  fontSize: theme.keyboardShortcuts.fontSize,
                  marginTop: "0px",
                  marginBottom: "0px",
                  marginLeft: theme.keyboardShortcuts.separatorMarginLeft,
                  marginRight: theme.keyboardShortcuts.separatorMarginRight
                }
              },
              theme.keyboardShortcuts.separatorLabel
            )
          );
        }
      });
      return tags2;
    };
    HotkeyTag_default = HotkeyTag;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledHotkeyTagContainer.tsx
import { css as css48, jsx as jsx74 } from "@emotion/core";
var styles36, StyledSpotlightHotkeyTagContainer, StyledHotkeyTagContainer_default;
var init_StyledHotkeyTagContainer = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledHotkeyTagContainer.tsx"() {
    "use strict";
    styles36 = css48({
      display: "flex",
      gap: "2px"
    });
    StyledSpotlightHotkeyTagContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx74("div", { css: styles36, ...props2 }, children);
    };
    StyledHotkeyTagContainer_default = StyledSpotlightHotkeyTagContainer;
  }
});

// commandbar/src/products/spotlight/components/hotkeys/EditableHotkeyTag.tsx
import React211 from "react";
import { AiOutlineStop, AiOutlineUndo as AiOutlineUndo2 } from "react-icons/ai";
import { useTheme as useTheme18 } from "emotion-theming";
import { css as css49, jsx as jsx75, keyframes as keyframes8 } from "@emotion/core";
var EditableHotkeyTag, KeypressRecorder, EditableHotkeyTag_default;
var init_EditableHotkeyTag = __esm({
  "commandbar/src/products/spotlight/components/hotkeys/EditableHotkeyTag.tsx"() {
    "use strict";
    init_useKeypressRecorder();
    init_HotkeyTag();
    init_useAction();
    init_actions4();
    init_selectors3();
    init_useStore();
    init_Tooltip();
    init_Hotkey();
    init_command();
    init_chroma();
    init_global_selectors();
    init_StyledHotkeyTagContainer();
    init_StyledHotkeyTag();
    EditableHotkeyTag = (props2) => {
      var _a2;
      const { slug: slug21, ...hotkeyTagProps } = props2;
      const { theme } = useTheme18();
      const _ = useStore();
      const { refContainer } = _.spotlight;
      const isHotkeyEditable = selectIsHotkeyEditable(useStore());
      const updateEndUserHotkey2 = useAction(updateEndUserHotkey);
      const editing = _.editingEndUserShortcutSlug === slug21;
      const setEditing = useAction(
        (_2, val) => {
          if (val) {
            _2.editingEndUserShortcutSlug = slug21;
          } else {
            if (_2.editingEndUserShortcutSlug === slug21) {
              _2.editingEndUserShortcutSlug = null;
            }
          }
        },
        [slug21]
      );
      React211.useEffect(() => {
        return () => {
          setEditing(false);
        };
      }, [setEditing]);
      const [error3, setError] = React211.useState(void 0);
      const [hovered, setHovered] = React211.useState(false);
      const [combo, setCombo] = React211.useState(hotkeyTagProps.combo);
      const hasHotkey = combo.length > 0;
      const resetInputFocus = () => {
        if (!!refContainer.current) {
          refContainer.current.focus();
        }
      };
      const onEdit = (mousetrapString) => {
        resetInputFocus();
        if (mousetrapString === void 0) {
          setEditing(false);
          setHovered(false);
          setError(/* @__PURE__ */ jsx75("span", null, "Invalid input - no changes made"));
          setTimeout(() => setError(void 0), 3e3);
        } else {
          const platformString = mousetrapString;
          mousetrapString = Hotkey_default.toModString(mousetrapString, ["mac"].includes(_.platform) ? "mac" : "win");
          const collisions = getCommands(_).filter((command) => {
            const cmdUID = commandUID(command);
            if (cmdUID === props2.slug || !mousetrapString) {
              return false;
            }
            let commandHotkey = ["mac"].includes(_.platform) ? command.hotkey_mac : command.hotkey_win;
            if (_.endUserStore.data.hotkeys.hasOwnProperty(cmdUID)) {
              commandHotkey = _.endUserStore.data.hotkeys[cmdUID];
            }
            return Hotkey_default.checkForConflicts(mousetrapString, commandHotkey);
          });
          if (collisions.length > 0) {
            setEditing(false);
            setHovered(false);
            setError(
              /* @__PURE__ */ jsx75("span", null, /* @__PURE__ */ jsx75("i", null, platformString), " conflicts with ", /* @__PURE__ */ jsx75("i", null, collisions.map((c) => c.text).join(", ")))
            );
            setTimeout(() => setError(void 0), 3e3);
            return;
          }
          setCombo(mousetrapString);
          setEditing(false);
          setHovered(false);
          updateEndUserHotkey2(props2.slug, mousetrapString);
        }
      };
      const onReset = () => {
        resetInputFocus();
        setCombo(props2.defaultCombo);
        setEditing(false);
        setHovered(false);
        updateEndUserHotkey2(props2.slug, void 0);
      };
      const onRemove = () => {
        onEdit("");
      };
      React211.useEffect(() => {
        setHovered(props2.isFocused && hasHotkey);
      }, [props2.isFocused]);
      React211.useEffect(() => {
        setCombo(props2.combo);
      }, [props2.combo]);
      if (!isHotkeyEditable)
        return /* @__PURE__ */ jsx75(HotkeyTag_default, { ...hotkeyTagProps });
      if (!editing) {
        if (!!error3) {
          return /* @__PURE__ */ jsx75(
            "div",
            {
              style: {
                color: theme.option.descriptionColor,
                fontSize: "11px",
                whiteSpace: "nowrap"
              }
            },
            error3
          );
        }
        const hotKeyTagWrapperPosition = optionIsInGrid(_) || hasHotkey || hovered ? void 0 : (
          /* when hovered, the box will be visible and take up space inline as usual */
          {
            // the box must be hoverable at all times
            // the box must be hidden when the row is not hovered
            position: "absolute",
            // the box should shift further to the left if there is an icon to the right
            right: props2.hasNextIcon ? "43px" : "18px"
          }
        );
        return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx75(
          StyledHotkeyTagContainer_default,
          {
            onMouseEnter: () => setHovered(true),
            onMouseLeave: () => setHovered(false),
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              setEditing(true);
            }
          },
          /* @__PURE__ */ jsx75(
            StyledHotkeyTag_default,
            {
              style: {
                paddingRight: "4px",
                ...!hovered && { visibility: "hidden" }
              }
            },
            hasHotkey ? "Edit" : "Add shortcut"
          ),
          /* @__PURE__ */ jsx75(
            HotkeyTag_default,
            {
              combo,
              highlight: props2.highlight,
              isUserCustomized: combo !== props2.defaultCombo && combo !== ""
            }
          )
        ) : /* @__PURE__ */ jsx75(
          "div",
          {
            "aria-hidden": true,
            style: {
              ...hotKeyTagWrapperPosition,
              background: "transparent",
              borderRadius: "4px",
              cursor: "pointer",
              whiteSpace: "nowrap",
              minWidth: hasHotkey ? "auto" : "100px",
              minHeight: hasHotkey ? "auto" : "30px"
            },
            onMouseEnter: () => setHovered(true),
            onMouseLeave: () => setHovered(false),
            onClick: (e) => {
              e.preventDefault();
              e.stopPropagation();
              setEditing(true);
            }
          },
          /* @__PURE__ */ jsx75(
            "div",
            {
              style: {
                display: "inline-block",
                margin: "6px 12px",
                fontSize: theme.keyboardShortcuts.fontSize,
                ...!hovered && { visibility: "hidden" }
              }
            },
            hasHotkey ? "Edit" : "Add shortcut"
          ),
          /* @__PURE__ */ jsx75(
            HotkeyTag_default,
            {
              combo,
              highlight: props2.highlight,
              isUserCustomized: combo !== props2.defaultCombo && combo !== ""
            }
          )
        );
      }
      return /* @__PURE__ */ jsx75(KeypressRecorder, { onFinish: onEdit, onReset, onRemove });
    };
    KeypressRecorder = (props2) => {
      const combo = useKeypressRecorder_default({ onFinish: props2.onFinish });
      const { theme } = useTheme18();
      const pulsate = keyframes8`
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 ${getChromaColor(theme.keyboardShortcuts.recordingColor).alpha(0.7).css()};
    }

    70% {
      transform: scale(1);
      box-shadow: 0 0 0 4px ${getChromaColor(theme.keyboardShortcuts.recordingColor).alpha(0).css()};
    }

    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 ${getChromaColor(theme.keyboardShortcuts.recordingColor).alpha(0).css()};
    }
`;
      return /* @__PURE__ */ jsx75(
        "div",
        {
          "aria-hidden": true,
          style: {
            display: "flex",
            alignItems: "center",
            backgroundColor: theme.keyboardShortcuts.background,
            fontSize: "11px",
            padding: "3px 6px",
            minHeight: "30px",
            cursor: "text"
          },
          onClick: (e) => {
            e.preventDefault();
            e.stopPropagation();
          }
        },
        combo.length === 0 ? /* @__PURE__ */ jsx75("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ jsx75("div", { style: { marginRight: "6px", whiteSpace: "nowrap" } }, "Press any key"), /* @__PURE__ */ jsx75(Tooltip_default, { overlay: /* @__PURE__ */ jsx75("div", { style: { fontFamily: theme.main.fontFamily } }, "Remove shortcut"), placement: "top" }, /* @__PURE__ */ jsx75(
          AiOutlineStop,
          {
            css: {
              "&:hover": {
                color: theme.base.primary,
                cursor: "pointer",
                transform: "scale(1.2)"
              },
              transition: "all .3s ease-in-out",
              fontWeight: 700,
              display: "inline-block",
              verticalAlign: "middle",
              marginRight: "6px"
            },
            onClick: props2.onRemove
          }
        )), /* @__PURE__ */ jsx75(Tooltip_default, { overlay: /* @__PURE__ */ jsx75("div", { style: { fontFamily: theme.main.fontFamily } }, "Reset shortcut"), placement: "top" }, /* @__PURE__ */ jsx75(
          AiOutlineUndo2,
          {
            css: {
              "&:hover": {
                color: theme.base.primary,
                cursor: "pointer",
                transform: "scale(1.2)"
              },
              transition: "all .3s ease-in-out",
              fontWeight: 700,
              display: "inline-block",
              verticalAlign: "middle"
            },
            onClick: props2.onReset
          }
        ))) : /* @__PURE__ */ jsx75(
          "div",
          {
            style: {
              display: "flex",
              alignItems: "center"
            }
          },
          /* @__PURE__ */ jsx75(HotkeyTag_default, { highlight: false, combo }),
          /* @__PURE__ */ jsx75(
            "div",
            {
              css: css49`
              background: ${theme.keyboardShortcuts.recordingColor};
              box-shadow: 0 0 0 0 ${theme.keyboardShortcuts.recordingColor};
              animation: ${pulsate} 2s infinite;
              border-radius: 50%;
              margin-left: 6px;
              height: 8px;
              width: 8px;
              transform: scale(1);
            `
            }
          )
        )
      );
    };
    EditableHotkeyTag_default = EditableHotkeyTag;
  }
});

// commandbar/src/products/spotlight/components/option/CommandOptionShortcut.tsx
import React212 from "react";
var CommandOptionShortcut;
var init_CommandOptionShortcut = __esm({
  "commandbar/src/products/spotlight/components/option/CommandOptionShortcut.tsx"() {
    "use strict";
    init_Tooltip();
    init_EditableHotkeyTag();
    init_command();
    init_useStore();
    init_selectors3();
    init_operatingSystem();
    init_globals();
    init_useTheme();
    CommandOptionShortcut = ({ option, isFocused, hasNextIcon }) => {
      const { theme } = useTheme();
      const _ = useStore();
      if (isUnfurledCommandOption(option))
        return null;
      if (option.command.template.value === SDK_INTERNAL_PREFIX + "open-copilot" || option.command.template.type === "helpdoc") {
        return null;
      }
      let hotkey = "";
      let defaultHotkey = "";
      const slug21 = commandUID(option.command);
      if (_.endUserStore.data.hotkeys.hasOwnProperty(slug21)) {
        hotkey = _.endUserStore.data.hotkeys[slug21];
      } else if (["mac"].includes(_.platform)) {
        hotkey = option.command.hotkey_mac;
      } else if (["windows", "linux"].includes(_.platform)) {
        hotkey = option.command.hotkey_win;
      }
      if (["mac"].includes(_.platform)) {
        defaultHotkey = option.command.hotkey_mac;
      } else if (["windows", "linux"].includes(_.platform)) {
        defaultHotkey = option.command.hotkey_win;
      }
      const highlightShortcut = () => {
        var _a2, _b2;
        if (["command.hotkey_mac", "command.hotkey_win"].includes((_a2 = option.searchMatches[0]) == null ? void 0 : _a2.path)) {
          const matchedIndices = (_b2 = option.searchMatches[0]) == null ? void 0 : _b2.indices[0];
          const isValidPair = !!matchedIndices && matchedIndices.length === 2;
          const pairLength = (pair) => pair[1] - pair[0] + 1;
          const SHORTCUT_LENGTH_TO_HIGHLIGHT = 2;
          if (isValidPair && pairLength(matchedIndices) >= SHORTCUT_LENGTH_TO_HIGHLIGHT) {
            return true;
          }
        }
        return false;
      };
      const highlight = highlightShortcut();
      const shortcut = !optionIsInGrid(_, option) && !isMobileDevice() ? /* @__PURE__ */ React212.createElement(
        EditableHotkeyTag_default,
        {
          key: `editable-${commandUID(option.command)}`,
          combo: hotkey,
          defaultCombo: defaultHotkey,
          highlight,
          slug: commandUID(option.command),
          isFocused,
          hasNextIcon
        }
      ) : null;
      return highlight ? /* @__PURE__ */ React212.createElement(
        Tooltip_default,
        {
          overlay: /* @__PURE__ */ React212.createElement("span", { style: { fontFamily: theme.main.fontFamily } }, "You can use this hotkey when the bar is closed."),
          placement: "right"
        },
        /* @__PURE__ */ React212.createElement("div", null, shortcut)
      ) : shortcut;
    };
  }
});

// commandbar/src/products/spotlight/components/option/UnderlineFormatter.tsx
import React213 from "react";
var UnderlineFormatter;
var init_UnderlineFormatter = __esm({
  "commandbar/src/products/spotlight/components/option/UnderlineFormatter.tsx"() {
    "use strict";
    init_useStore();
    UnderlineFormatter = (props2) => {
      const { prefix, suffix, delimiter: delimiter2, theme } = props2;
      const { flags } = useStore();
      return /* @__PURE__ */ React213.createElement("div", null, /* @__PURE__ */ React213.createElement("span", null, `${prefix}${delimiter2} `), /* @__PURE__ */ React213.createElement(
        "span",
        {
          style: (flags == null ? void 0 : flags["release-themes-v2"]) ? {
            fontWeight: "var(--font-weight-semibold)"
          } : {
            textDecoration: suffix && `${theme.base.primary} solid underline`,
            textUnderlinePosition: "under",
            opacity: 0.7
          }
        },
        suffix || "_"
      ));
    };
  }
});

// commandbar/src/products/spotlight/components/option/CommandOptionLabel.tsx
import React214 from "react";
var isFallbackCommandWithFirstStepTextInput, isBuiltinOpenCopilopOption, CommandOptionLabel;
var init_CommandOptionLabel = __esm({
  "commandbar/src/products/spotlight/components/option/CommandOptionLabel.tsx"() {
    "use strict";
    init_UnderlineFormatter();
    init_useStore();
    init_selectors3();
    init_OptionHighlight();
    init_globals();
    init_useTheme();
    isFallbackCommandWithFirstStepTextInput = (option) => {
      const isFallback = option.groupKey === "FALLBACK-";
      if (!isFallback) {
        return false;
      }
      const sortedArgs = getSortedArgs(option);
      if (sortedArgs.length > 0) {
        const isFirstArgumentText = sortedArgs[0].type === "provided" && sortedArgs[0].value === "text";
        return isFirstArgumentText;
      }
      return false;
    };
    isBuiltinOpenCopilopOption = (option) => {
      return option.command.template.value === SDK_INTERNAL_PREFIX + "open-copilot";
    };
    CommandOptionLabel = ({ option }) => {
      const { theme } = useTheme();
      const { inputText } = useStore().spotlight;
      if (isFallbackCommandWithFirstStepTextInput(option) || isBuiltinOpenCopilopOption(option) && inputText) {
        return /* @__PURE__ */ React214.createElement(UnderlineFormatter, { prefix: option.label, suffix: inputText, delimiter: `:`, theme });
      }
      return /* @__PURE__ */ React214.createElement("span", { style: { color: "inherit" } }, /* @__PURE__ */ React214.createElement(OptionHighlight, { option, labelToHighlight: "label", text: option.label }));
    };
  }
});

// commandbar/src/products/spotlight/components/option/UnfurledCommandOptionLabel.tsx
import React215 from "react";
var UnfurledCommandOptionLabel;
var init_UnfurledCommandOptionLabel = __esm({
  "commandbar/src/products/spotlight/components/option/UnfurledCommandOptionLabel.tsx"() {
    "use strict";
    init_OptionHighlight();
    UnfurledCommandOptionLabel = ({ option }) => {
      return /* @__PURE__ */ React215.createElement("span", null, /* @__PURE__ */ React215.createElement(OptionHighlight, { option, labelToHighlight: "label", text: option.label }), option.resource && /* @__PURE__ */ React215.createElement("span", { style: { margin: "0px 5px" } }, ">"), /* @__PURE__ */ React215.createElement("span", { style: { opacity: 0.6 } }, option.resource && /* @__PURE__ */ React215.createElement(OptionHighlight, { option, labelToHighlight: "resource.label", text: option.resource.label })));
    };
  }
});

// commandbar/src/products/spotlight/components/option/CommandOptionRow.tsx
import React216 from "react";
import chroma13 from "chroma-js";
import { AiOutlineArrowRight } from "react-icons/ai";
var CommandOptionRow;
var init_CommandOptionRow = __esm({
  "commandbar/src/products/spotlight/components/option/CommandOptionRow.tsx"() {
    "use strict";
    init_useStore();
    init_Tag();
    init_SVG();
    init_OptionWrapper();
    init_CommandOptionIcon();
    init_OptionHighlight();
    init_CommandOptionShortcut();
    init_CommandOptionLabel();
    init_selectors3();
    init_UnfurledCommandOptionLabel();
    init_RenderCustomComponent();
    init_useTheme();
    init_react();
    CommandOptionRow = ({ isError: isError2, isFocused, option }) => {
      var _a2, _b2, _c2;
      const _ = useStore();
      const { theme } = useTheme();
      let { isDisabled, isDisabledReason } = option.optionDisabled;
      const { reasonIsUserDefined } = option.optionDisabled;
      if (!isDisabled) {
        const { isValid: isValid2, isValidReason } = isOptionValid(_, option);
        if (!isValid2) {
          isDisabled = !isValid2;
          isDisabledReason = isValidReason;
        }
      }
      const icon = /* @__PURE__ */ React216.createElement(CommandOptionIcon, { option, isFocused, isDisabled });
      const draft = !option.command.is_live && _.isAdmin && /* @__PURE__ */ React216.createElement("span", null, /* @__PURE__ */ React216.createElement(Tag_default, { color: chroma13("lightgrey") }, "Draft"), " ");
      const explanation = (() => {
        if (isDisabled && isDisabledReason) {
          if (reasonIsUserDefined) {
            return /* @__PURE__ */ React216.createElement("span", null, isDisabledReason);
          }
          if (_.isAdmin) {
            return /* @__PURE__ */ React216.createElement("span", { style: { color: "orange" } }, isDisabledReason);
          }
        }
        if (isHotloadedCommandOption(option, _.organization) && option.command.show_preview) {
          return null;
        }
        if (option.command.explanation) {
          return /* @__PURE__ */ React216.createElement("span", null, /* @__PURE__ */ React216.createElement(
            OptionHighlight,
            {
              labelToHighlight: "command.explanation",
              text: option.command.explanation,
              option,
              emphasize: true
            }
          ));
        }
        return null;
      })();
      const shouldHideIcon = Object.keys(option.command.arguments).length === 0 || /**
       * Technically, video commands internally use arguments. In future, we may support video commands
       * with multiple steps. Though a use-case for this is rare, we should probably still show a
       * "go forward" icon.
       */
      option.command.template.type === "video" && Object.keys(option.command.arguments).length === 1;
      const shortcut = /* @__PURE__ */ React216.createElement(CommandOptionShortcut, { option, isFocused, hasNextIcon: !shouldHideIcon });
      const goForward = !shouldHideIcon && (((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? isFocused && (!!((_b2 = _ == null ? void 0 : _.organization) == null ? void 0 : _b2.icon_go_forward) ? /* @__PURE__ */ React216.createElement(SVG_default, { htmlstring: _.organization.icon_go_forward }) : /* @__PURE__ */ React216.createElement(ArrowNarrowRight_default, null)) : /* @__PURE__ */ React216.createElement(
        "span",
        {
          role: "img",
          "aria-hidden": true,
          style: {
            marginLeft: 10,
            marginTop: 6,
            color: isFocused ? theme.optionSelected.iconColor : theme.option.iconColor
          }
        },
        !!((_c2 = _ == null ? void 0 : _.organization) == null ? void 0 : _c2.icon_go_forward) ? /* @__PURE__ */ React216.createElement(
          SVG_default,
          {
            htmlstring: _.organization.icon_go_forward,
            height: "20px",
            width: "20px",
            style: { color: isFocused ? theme.optionSelected.iconColor : theme.option.iconColor }
          }
        ) : /* @__PURE__ */ React216.createElement(AiOutlineArrowRight, null)
      ));
      const label = isUnfurledCommandOption(option) ? /* @__PURE__ */ React216.createElement(UnfurledCommandOptionLabel, { option }) : /* @__PURE__ */ React216.createElement(CommandOptionLabel, { option });
      const extra = (() => {
        if (option.command.extra) {
          const component = _.components[option.command.extra];
          if (!component) {
            return null;
          }
          return /* @__PURE__ */ React216.createElement(
            RenderCustomComponent_default,
            {
              key: option.command.id,
              data: getOptionData(option),
              metadata: getOptionMetadata(option),
              component: component.component
            }
          );
        }
      })();
      return /* @__PURE__ */ React216.createElement(
        OptionWrapper_default,
        {
          option,
          label,
          type: "command",
          icon,
          draft,
          description: explanation,
          heading: option.command.heading ? /* @__PURE__ */ React216.createElement(OptionHighlight, { option, labelToHighlight: "command.heading", text: option.command.heading, emphasize: true }) : void 0,
          shortcut,
          goForward,
          isFocused,
          isError: isError2,
          isDisabled,
          extra
        }
      );
    };
  }
});

// commandbar/src/products/spotlight/components/select/menu/SearchMatchFormatter.tsx
import React217 from "react";
var MATCH_TYPES_TO_HIDE, showTopSearchMatch, matchesToShow, SearchMatchFormatter, SearchMatchFormatter_default;
var init_SearchMatchFormatter = __esm({
  "commandbar/src/products/spotlight/components/select/menu/SearchMatchFormatter.tsx"() {
    "use strict";
    MATCH_TYPES_TO_HIDE = [
      "label",
      "command.tags",
      "command.explanation",
      "command.heading",
      "description",
      "category.label",
      "parameter.synonyms",
      "heading"
    ];
    showTopSearchMatch = (matches) => {
      return matchesToShow(matches).length > 0;
    };
    matchesToShow = (matches) => {
      if (!matches || matches.length === 0)
        return [];
      if (MATCH_TYPES_TO_HIDE.includes(matches[0].path))
        return [];
      return matches.filter((match2) => !MATCH_TYPES_TO_HIDE.includes(match2.path));
    };
    SearchMatchFormatter = (props2) => {
      const matches = matchesToShow(props2.matches);
      if (matches.length === 0)
        return null;
      const formattedKey = props2.formatKey ? props2.formatKey(matches[0].path, matches[0].value) : matches[0].path;
      const formattedValue = props2.formatValue ? props2.formatValue(matches[0].value) : matches[0].value;
      return /* @__PURE__ */ React217.createElement(
        "span",
        {
          style: {
            fontSize: 11,
            width: 175,
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden"
          }
        },
        formattedKey,
        formattedValue
      );
    };
    SearchMatchFormatter_default = SearchMatchFormatter;
  }
});

// commandbar/src/products/spotlight/components/option/OptionActionIcon.tsx
import React218 from "react";
var OptionActionIcon;
var init_OptionActionIcon = __esm({
  "commandbar/src/products/spotlight/components/option/OptionActionIcon.tsx"() {
    "use strict";
    init_Icon2();
    init_useTheme();
    OptionActionIcon = ({ icon, isGridOption }) => {
      const { theme } = useTheme();
      const iconSize = isGridOption ? theme.menuGridOption.actionIconSize : theme.option.actionIconSize;
      if (!!icon) {
        return /* @__PURE__ */ React218.createElement(Icon_default2, { icon, style: { width: iconSize, height: iconSize }, useDefaultSVGColor: true });
      } else {
        return null;
      }
    };
  }
});

// commandbar/src/products/spotlight/components/option/ParameterOptionAddOn.tsx
import React219 from "react";
var ParameterOptionAddOn;
var init_ParameterOptionAddOn = __esm({
  "commandbar/src/products/spotlight/components/option/ParameterOptionAddOn.tsx"() {
    "use strict";
    init_DateTime();
    init_selectors3();
    init_useTheme();
    ParameterOptionAddOn = ({ option }) => {
      const { theme } = useTheme();
      if (isDateTimeOption(option)) {
        return /* @__PURE__ */ React219.createElement(
          "div",
          {
            style: {
              fontSize: parseInt(theme.option.fontSize, 10) - 2,
              fontFamily: "monospace",
              color: theme.option.color
            }
          },
          DateTime_default.display(option.parameter.date, option.parameter.specificType)
        );
      }
      return null;
    };
  }
});

// commandbar/src/products/spotlight/components/step/MultiSelectDefaultSelectedIcon.tsx
import React220 from "react";
import { CgCheck } from "react-icons/cg";
var MultiSelectDefaultSelectedIcon, MultiSelectDefaultSelectedIcon_default;
var init_MultiSelectDefaultSelectedIcon = __esm({
  "commandbar/src/products/spotlight/components/step/MultiSelectDefaultSelectedIcon.tsx"() {
    "use strict";
    MultiSelectDefaultSelectedIcon = ({ color, size = "18px" }) => {
      return /* @__PURE__ */ React220.createElement(
        "div",
        {
          style: {
            border: `2px solid ${color}`,
            borderRadius: "50%",
            height: size,
            width: size,
            display: "inline-block"
          }
        },
        /* @__PURE__ */ React220.createElement(CgCheck, { size: typeof size === "string" ? `${parseFloat(size) - 4}px` : `${size - 4}px`, style: { color } })
      );
    };
    MultiSelectDefaultSelectedIcon_default = MultiSelectDefaultSelectedIcon;
  }
});

// commandbar/src/products/spotlight/components/step/MultiSelectDefaultIcon.tsx
import React221 from "react";
var MultiSelectDefaultIcon, MultiSelectDefaultIcon_default;
var init_MultiSelectDefaultIcon = __esm({
  "commandbar/src/products/spotlight/components/step/MultiSelectDefaultIcon.tsx"() {
    "use strict";
    MultiSelectDefaultIcon = (props2) => {
      return /* @__PURE__ */ React221.createElement(
        "div",
        {
          style: {
            border: `1px solid ${props2.color}`,
            opacity: props2.opacity,
            borderRadius: "50%",
            height: props2.size,
            width: props2.size,
            display: "inline-block"
          }
        }
      );
    };
    MultiSelectDefaultIcon_default = MultiSelectDefaultIcon;
  }
});

// commandbar/src/products/spotlight/components/step/MultiSelectSelectedIcon.tsx
import React222 from "react";
var MultiSelectSelectedIcon, MultiSelectSelectedIcon_default;
var init_MultiSelectSelectedIcon = __esm({
  "commandbar/src/products/spotlight/components/step/MultiSelectSelectedIcon.tsx"() {
    "use strict";
    init_Icon2();
    init_MultiSelectDefaultSelectedIcon();
    init_selectors3();
    init_helpers14();
    init_useStore();
    init_useTheme();
    MultiSelectSelectedIcon = (props2) => {
      const _ = useStore();
      const isGridOption = isGridView(useStore());
      const { theme } = useTheme();
      const selectedColor = theme.optionSelected.iconColor;
      if (!!props2.userDefinedIcon) {
        return /* @__PURE__ */ React222.createElement(
          Icon_default2,
          {
            icon: props2.userDefinedIcon,
            default: /* @__PURE__ */ React222.createElement("div", { style: { minWidth: getIconSize(_, theme), display: "inline-block" } }),
            style: {
              minWidth: getIconSize(_, theme),
              padding: 1,
              border: isGridOption ? void 0 : `2px solid ${selectedColor}`
            },
            useDefaultSVGColor: props2.useDefaultSVGColor,
            size: getIconSize(_, theme)
          }
        );
      } else {
        return /* @__PURE__ */ React222.createElement(MultiSelectDefaultSelectedIcon_default, { color: selectedColor, size: getIconSize(_, theme) });
      }
    };
    MultiSelectSelectedIcon_default = MultiSelectSelectedIcon;
  }
});

// commandbar/src/products/spotlight/components/step/SelectDefaultIcon.tsx
import React223 from "react";
var SelectDefaultIcon, SelectDefaultIcon_default;
var init_SelectDefaultIcon = __esm({
  "commandbar/src/products/spotlight/components/step/SelectDefaultIcon.tsx"() {
    "use strict";
    SelectDefaultIcon = (props2) => {
      return /* @__PURE__ */ React223.createElement(
        "div",
        {
          style: {
            border: `1px solid ${props2.color}`,
            opacity: props2.opacity,
            borderRadius: "50%",
            height: props2.size,
            width: props2.size
          }
        }
      );
    };
    SelectDefaultIcon_default = SelectDefaultIcon;
  }
});

// commandbar/src/products/spotlight/components/option/ParameterOptionIcon.tsx
import React224 from "react";
var ParameterOptionIcon;
var init_ParameterOptionIcon = __esm({
  "commandbar/src/products/spotlight/components/option/ParameterOptionIcon.tsx"() {
    "use strict";
    init_selectors8();
    init_Icon2();
    init_useStore();
    init_MultiSelectDefaultSelectedIcon();
    init_MultiSelectDefaultIcon();
    init_MultiSelectSelectedIcon();
    init_SelectDefaultIcon();
    init_Step();
    init_selectors3();
    init_helpers14();
    init_useTheme();
    init_StyledCheckboxIcon();
    init_StyledRadioIcon();
    ParameterOptionIcon = ({ isFocused, option, isMultiSelectSelection }) => {
      var _a2, _b2, _c2;
      const _ = useStore();
      const { theme } = useTheme();
      const { defaultColorFromTheme, opacity, useDefaultSVGColor } = getOptionIconColorBase(theme, isFocused, false);
      const preserveSVG = !!getReservedField(option, "__preserveSVG");
      const userDefinedIcon = getReservedField(option, "icon");
      const { currentStep } = currentStepAndIndex(_);
      if ((currentStep == null ? void 0 : currentStep.type) === "textinput" /* TextInput */) {
        return /* @__PURE__ */ React224.createElement("div", null);
      }
      if ((currentStep == null ? void 0 : currentStep.type) === "multiselect" /* MultiSelect */) {
        if ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) {
          return /* @__PURE__ */ React224.createElement(StyledCheckboxIcon_default, { selected: isMultiSelectSelection });
        }
        if (isMultiSelectSelection) {
          return /* @__PURE__ */ React224.createElement(
            MultiSelectSelectedIcon_default,
            {
              userDefinedIcon,
              useDefaultSVGColor: useDefaultSVGColor || preserveSVG
            }
          );
        } else if (!!userDefinedIcon) {
          return /* @__PURE__ */ React224.createElement(
            Icon_default2,
            {
              icon: userDefinedIcon,
              default: /* @__PURE__ */ React224.createElement("div", { style: { minWidth: getIconSize(_, theme), display: "inline-block" } }),
              style: { color: defaultColorFromTheme, minWidth: getIconSize(_, theme) },
              useDefaultSVGColor: useDefaultSVGColor || preserveSVG,
              size: getIconSize(_, theme)
            }
          );
        } else {
          return /* @__PURE__ */ React224.createElement(MultiSelectDefaultIcon_default, { color: defaultColorFromTheme, opacity, size: getIconSize(_, theme) });
        }
      }
      if ((currentStep == null ? void 0 : currentStep.type) === "select" /* Select */) {
        const thisOptionIsSelected = isParameterOptionSelected(option, currentStep);
        const customIcon = userDefinedIcon || ((_b2 = option.searchOptions) == null ? void 0 : _b2.icon);
        const useCalculatedOpacity = !userDefinedIcon;
        if ((_c2 = _.flags) == null ? void 0 : _c2["release-themes-v2"]) {
          return /* @__PURE__ */ React224.createElement(StyledRadioIcon_default, { selected: thisOptionIsSelected });
        }
        if (thisOptionIsSelected) {
          return /* @__PURE__ */ React224.createElement(MultiSelectDefaultSelectedIcon_default, { color: theme.optionSelected.iconColor, size: getIconSize(_, theme) });
        }
        if (!!customIcon) {
          const styles51 = {
            defaultColorFromTheme,
            minWidth: getIconSize(_, theme),
            opacity: useCalculatedOpacity ? opacity : void 0
          };
          return /* @__PURE__ */ React224.createElement(
            Icon_default2,
            {
              icon: customIcon,
              default: /* @__PURE__ */ React224.createElement("div", { style: { minWidth: getIconSize(_, theme), display: "inline-block" } }),
              style: styles51,
              useDefaultSVGColor: useDefaultSVGColor || preserveSVG,
              size: getIconSize(_, theme)
            }
          );
        } else {
          return /* @__PURE__ */ React224.createElement(SelectDefaultIcon_default, { color: defaultColorFromTheme, opacity, size: getIconSize(_, theme) });
        }
      }
      return /* @__PURE__ */ React224.createElement("div", { style: { minWidth: getIconSize(_, theme) } });
    };
  }
});

// commandbar/src/products/spotlight/components/option/RecordOptionIcon.tsx
import React225 from "react";
var RecordOptionIcon, RecordOptionIcon_default;
var init_RecordOptionIcon = __esm({
  "commandbar/src/products/spotlight/components/option/RecordOptionIcon.tsx"() {
    "use strict";
    init_Icon2();
    init_selectors3();
    init_helpers14();
    init_useStore();
    init_useTheme();
    RecordOptionIcon = ({ isFocused, option }) => {
      const _ = useStore();
      const { theme } = useTheme();
      const preserveSVG = !!getReservedField(option, "__preserveSVG");
      const { icon: category_icon, icon_color: category_icon_color } = getRecordCategoryIcon(option);
      const { defaultColorFromTheme, opacity, useDefaultSVGColor } = getOptionIconColorBase(theme, isFocused, false);
      const style3 = { defaultColorFromTheme, opacity, minWidth: getIconSize(_, theme) };
      const userDefinedIcon = getReservedField(option, "icon");
      if (!!userDefinedIcon) {
        return /* @__PURE__ */ React225.createElement(
          Icon_default2,
          {
            icon: userDefinedIcon,
            default: /* @__PURE__ */ React225.createElement("div", { style: { minWidth: getIconSize(_, theme), display: "inline-block" } }),
            style: style3,
            useDefaultSVGColor: useDefaultSVGColor || preserveSVG,
            size: getIconSize(_, theme)
          }
        );
      }
      return /* @__PURE__ */ React225.createElement(
        Icon_default2,
        {
          icon: category_icon,
          color: category_icon_color,
          default: /* @__PURE__ */ React225.createElement("div", { style: { minWidth: getIconSize(_, theme), display: "inline-block" } }),
          style: style3,
          useDefaultSVGColor: useDefaultSVGColor || preserveSVG,
          size: getIconSize(_, theme)
        }
      );
    };
    RecordOptionIcon_default = RecordOptionIcon;
  }
});

// commandbar/src/products/spotlight/components/option/MultiCommandsIndicator.tsx
import React226 from "react";
import chroma14 from "chroma-js";
var MultiCommandsIndicator;
var init_MultiCommandsIndicator = __esm({
  "commandbar/src/products/spotlight/components/option/MultiCommandsIndicator.tsx"() {
    "use strict";
    MultiCommandsIndicator = ({ commandsNumber, style: style3 }) => {
      const backgroundColor = chroma14("#fff").darken(0.4);
      return /* @__PURE__ */ React226.createElement(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: backgroundColor.css(),
            color: "rgba(0,0,0,0.85)",
            fontSize: "11px",
            fontWeight: 700,
            opacity: 0.6,
            height: 14,
            padding: "0 4px",
            marginBottom: "2px",
            minWidth: 22,
            borderRadius: 2,
            boxShadow: `3px 3px ${backgroundColor.darken(1).css()}, 6px 6px 0 ${backgroundColor.darken(2).css()}`,
            ...style3
          }
        },
        commandsNumber
      );
    };
  }
});

// commandbar/src/products/spotlight/components/option/RecordOptionAddOn.tsx
import React227 from "react";
import chroma15 from "chroma-js";
var RecordOptionAddOn, RecordOptionAddOn_default;
var init_RecordOptionAddOn = __esm({
  "commandbar/src/products/spotlight/components/option/RecordOptionAddOn.tsx"() {
    "use strict";
    init_Tooltip();
    init_Tag();
    init_MultiCommandsIndicator();
    init_actions9();
    init_useAction();
    init_useTheme();
    RecordOptionAddOn = ({ isFocused, option }) => {
      const { theme } = useTheme();
      const selectOption2 = useAction((_, e) => {
        e.shiftKey = true;
        selectOption(_, option, void 0, e);
        e.stopPropagation();
        e.preventDefault();
      });
      if (!isFocused || option.recordActions.length <= 1) {
        return null;
      }
      const tagColor = chroma15("#fff");
      const tagStyle = { height: "20px", minWidth: "20px", padding: "0 4px" };
      return /* @__PURE__ */ React227.createElement(
        Tooltip_default,
        {
          overlay: /* @__PURE__ */ React227.createElement(
            "div",
            {
              style: {
                fontFamily: theme.main.fontFamily,
                fontSize: theme.main.fontSize,
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
              }
            },
            /* @__PURE__ */ React227.createElement("div", null, "Show all commands"),
            /* @__PURE__ */ React227.createElement("div", null, /* @__PURE__ */ React227.createElement(Tag_default, { color: tagColor, style: tagStyle }, "Shift"), "+", /* @__PURE__ */ React227.createElement(Tag_default, { color: tagColor, style: tagStyle }, "Enter"), " ")
          ),
          placement: "right",
          align: { offset: [10, 0] }
        },
        /* @__PURE__ */ React227.createElement(
          "div",
          {
            tabIndex: 0,
            role: "button",
            onClick: selectOption2,
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                selectOption2(e);
              }
            }
          },
          /* @__PURE__ */ React227.createElement(MultiCommandsIndicator, { commandsNumber: option.recordActions.length })
        )
      );
    };
    RecordOptionAddOn_default = RecordOptionAddOn;
  }
});

// commandbar/src/products/spotlight/components/option/ParameterOptionRow.tsx
import React228 from "react";
import _get6 from "lodash/get";
var ParameterOptionRow, ClientCustomizableBlock;
var init_ParameterOptionRow = __esm({
  "commandbar/src/products/spotlight/components/option/ParameterOptionRow.tsx"() {
    "use strict";
    init_selectors8();
    init_SearchMatchFormatter();
    init_UnderlineFormatter();
    init_selectOrCreate();
    init_OptionWrapper();
    init_useStore();
    init_OptionActionIcon();
    init_ParameterOptionAddOn();
    init_ParameterOptionIcon();
    init_OptionHighlight();
    init_RecordOptionIcon();
    init_RecordOptionAddOn();
    init_Step();
    init_selectors3();
    init_useTheme();
    ParameterOptionRow = ({ isFocused, option }) => {
      var _a2;
      const _ = useStore();
      const { theme } = useTheme();
      const { currentStep } = currentStepAndIndex(_);
      let text = option.label;
      const descriptionField = (_a2 = option.searchOptions) == null ? void 0 : _a2.description_field;
      const descriptionText = !!descriptionField && _get6(option.parameter, descriptionField);
      const extraHTML = getReservedField(option, "__extraHTML");
      const isGridOption = optionIsInGrid(useStore(), option);
      const isHTML2 = (str) => {
        return /<\/?[a-z][\s\S]*>/i.test(str);
      };
      const searchMatch = showTopSearchMatch(option.searchMatches) && /* @__PURE__ */ React228.createElement(
        SearchMatchFormatter_default,
        {
          matches: option.searchMatches,
          formatKey: (searchKey, searchValue) => {
            const matchedField = option.tags.find(
              ({ value }) => Array.isArray(value) ? value.includes(searchValue) : searchValue === value
            );
            if (!matchedField)
              return "";
            return /* @__PURE__ */ React228.createElement(
              "span",
              {
                style: {
                  color: theme.searchableFieldMatch.color,
                  background: theme.searchableFieldMatch.background,
                  paddingTop: theme.searchableFieldMatch.paddingTop,
                  paddingBottom: theme.searchableFieldMatch.paddingBottom,
                  paddingLeft: theme.searchableFieldMatch.paddingLeft,
                  paddingRight: theme.searchableFieldMatch.paddingRight,
                  marginRight: theme.searchableFieldMatch.marginRight,
                  marginLeft: theme.searchableFieldMatch.marginLeft,
                  borderRadius: theme.searchableFieldMatch.borderRadius,
                  lineHeight: theme.searchableFieldMatch.lineHeight,
                  overflow: "hidden",
                  display: "inline-flex"
                }
              },
              `${matchedField.label}`
            );
          },
          formatValue: (value) => /* @__PURE__ */ React228.createElement(OptionHighlight, { option, labelToHighlight: "tags.value", text: value })
        }
      );
      let descriptionBlock;
      if (searchMatch) {
        descriptionBlock = searchMatch;
      } else if (descriptionText) {
        descriptionBlock = /* @__PURE__ */ React228.createElement(OptionHighlight, { option, labelToHighlight: "description", text: descriptionText, emphasize: true });
      }
      let extraBlock;
      if (extraHTML) {
        if (typeof extraHTML === "string" && isHTML2(extraHTML)) {
          extraBlock = /* @__PURE__ */ React228.createElement("div", { dangerouslySetInnerHTML: { __html: extraHTML } });
        } else if (typeof extraHTML === "function") {
          extraBlock = /* @__PURE__ */ React228.createElement(ClientCustomizableBlock, { afterRender: extraHTML, record: option.parameter });
        }
      }
      if ((currentStep == null ? void 0 : currentStep.type) === "textinput" /* TextInput */ && typeof option.parameter === "string") {
        text = /* @__PURE__ */ React228.createElement(UnderlineFormatter, { prefix: option.label, suffix: option.parameter, delimiter: ":", theme });
      }
      if (SelectOrCreate.isEnabled(currentStep) && SelectOrCreate.recordIsCreated(option.parameter)) {
        text = /* @__PURE__ */ React228.createElement(UnderlineFormatter, { prefix: option.label, suffix: option.parameter.value, delimiter: ":", theme });
      }
      const isMultiSelectSelection = (currentStep == null ? void 0 : currentStep.type) === "multiselect" /* MultiSelect */ ? isParameterOptionSelected(option, currentStep) : false;
      const icon = isRecordOption(option) ? /* @__PURE__ */ React228.createElement(RecordOptionIcon_default, { isFocused, option }) : /* @__PURE__ */ React228.createElement(ParameterOptionIcon, { isFocused, option, isMultiSelectSelection });
      const shortcut = isRecordOption(option) ? /* @__PURE__ */ React228.createElement(RecordOptionAddOn_default, { isFocused, option }) : /* @__PURE__ */ React228.createElement(ParameterOptionAddOn, { option });
      return /* @__PURE__ */ React228.createElement(
        OptionWrapper_default,
        {
          option,
          label: /* @__PURE__ */ React228.createElement(OptionHighlight, { option, labelToHighlight: "label", text }),
          description: descriptionBlock,
          extra: extraBlock,
          type: "resource",
          icon,
          shortcut,
          isError: false,
          isDisabled: false,
          isFocused,
          heading: getReservedField(option, "__heading") || getReservedField(option, "__breadcrumbs") ? /* @__PURE__ */ React228.createElement(
            OptionHighlight,
            {
              option,
              labelToHighlight: "heading",
              text: getReservedField(option, "__heading") || getReservedField(option, "__breadcrumbs"),
              emphasize: true
            }
          ) : void 0,
          goForward: /* @__PURE__ */ React228.createElement(OptionActionIcon, { icon: getReservedField(option, "__actionIcon"), isGridOption: !!isGridOption }),
          isMultiSelectSelection
        }
      );
    };
    ClientCustomizableBlock = (props2) => {
      const ref12 = React228.useRef(null);
      React228.useEffect(() => {
        if (ref12.current) {
          props2.afterRender(ref12.current, props2.record);
        }
      }, [props2.record]);
      return /* @__PURE__ */ React228.createElement("div", { ref: ref12 });
    };
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionWrapper.tsx
import { css as css50, jsx as jsx76 } from "@emotion/core";
var styles37, StyledSpotlightOptionWrapper, StyledSpotlightOptionWrapper_default;
var init_StyledSpotlightOptionWrapper = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightOptionWrapper.tsx"() {
    "use strict";
    styles37 = css50({
      display: "flex",
      width: "100%",
      alignItems: "flex-start",
      alignSelf: "stretch",
      padding: "0px 8px"
    });
    StyledSpotlightOptionWrapper = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx76("div", { css: styles37, ...props2 }, children);
    };
    StyledSpotlightOptionWrapper_default = StyledSpotlightOptionWrapper;
  }
});

// commandbar/src/products/spotlight/components/select/menu/SelectOption.tsx
import { jsx as jsx77 } from "@emotion/core";
import * as React229 from "react";
var selectOptionStyles, SelectOption, AnimatedOptionFocus, SelectOption_default;
var init_SelectOption = __esm({
  "commandbar/src/products/spotlight/components/select/menu/SelectOption.tsx"() {
    "use strict";
    init_a11y();
    init_useAction();
    init_actions9();
    init_CommandOptionRow();
    init_ParameterOptionRow();
    init_selectors3();
    init_useStore();
    init_OptionGroup();
    init_useTheme();
    init_StyledSpotlightOptionWrapper();
    selectOptionStyles = (state, theme) => {
      const borderHighlightStyles = {
        borderLeft: "4px solid transparent"
      };
      const style3 = state.isGridOption ? {
        // We need to force non-focused options to have a transparent background
        // in order to show AnimatedOptionFocus behind it
        ...{ background: "transparent" },
        ...theme.menuGridOption,
        ...state.isDisabled ? theme.menuGridOptionDisabled : {}
      } : {
        ...theme.option,
        // We need to force non-focused options to have a transparent background
        // in order to show AnimatedOptionFocus behind it
        ...{ background: "transparent" },
        ...state.isDisabled ? theme.optionDisabled : {}
      };
      let backgroundColor = state.isDisabled ? theme.optionDisabled.background : theme.optionSelected.background;
      if (state.isGridOption) {
        backgroundColor = state.isDisabled ? theme.menuGridOptionDisabled.background : theme.menuGridOptionSelected.background;
      }
      return {
        ...borderHighlightStyles,
        userSelect: "none",
        transition: "background-color 0s",
        borderRadius: style3.borderRadius,
        paddingTop: style3.paddingTop,
        paddingBottom: style3.paddingBottom,
        paddingLeft: style3.paddingLeft,
        paddingRight: style3.paddingRight,
        marginLeft: style3.marginLeft,
        marginRight: style3.marginRight,
        minHeight: style3.minHeight,
        color: style3.color,
        fontSize: style3.fontSize,
        fontFamily: style3.fontFamily,
        borderBottom: `${style3.borderWidth} ${style3.borderColor} solid`,
        backgroundColor: style3.background,
        display: "flex",
        alignItems: "center",
        ":active": {
          backgroundColor
        },
        ...state.isGridOption && {
          height: "100%"
        }
      };
    };
    SelectOption = (props2) => {
      var _a2;
      const { index: index3, isError: isError2, isFocused, onOptionHover } = props2;
      const { theme } = useTheme();
      const isFallback = props2.option.groupKey === fallbackGroup().key;
      const _ = useStore();
      const refocusCommandbarInput = useAction((_2) => {
        var _a3, _b2;
        return (_b2 = (_a3 = _2.spotlight.refContainer) == null ? void 0 : _a3.current) == null ? void 0 : _b2.focus();
      });
      const onMouseMove = React229.useCallback(() => {
        if (onOptionHover)
          onOptionHover(index3);
      }, [onOptionHover, index3]);
      const onClick = useAction(
        (_2, e) => {
          selectOption(_2, props2.option, isFallback, e);
          refocusCommandbarInput();
        },
        [props2.option]
      );
      const isGridOption = optionIsInGrid(useStore(), props2.option);
      let optionRow;
      if (isCommandOption(props2.option)) {
        optionRow = /* @__PURE__ */ jsx77(CommandOptionRow, { isError: isError2, isFocused, option: props2.option });
      } else if (isParameterOption(props2.option)) {
        optionRow = /* @__PURE__ */ jsx77(ParameterOptionRow, { isFocused, option: props2.option });
      } else {
        console.warn("attempted to render invalid option", props2.option);
        optionRow = null;
      }
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx77(
        StyledSpotlightOptionWrapper_default,
        {
          "data-testid": "select-option",
          onClick: isGridOption ? void 0 : onClick,
          onMouseMove,
          id: a11y_default.optionContentId(index3),
          "aria-labelledby": "group-" + props2.option.groupKey,
          style: { ...isGridOption && { padding: "0px" } }
        },
        optionRow
      ) : (
        // eslint-disable-next-line
        /* @__PURE__ */ jsx77(
          "div",
          {
            "data-testid": "select-option",
            css: selectOptionStyles(
              {
                isDisabled: props2.option.optionDisabled.isDisabled,
                isGridOption
              },
              theme
            ),
            onClick: isGridOption ? void 0 : onClick,
            onMouseMove,
            id: a11y_default.optionContentId(index3),
            "aria-labelledby": "group-" + props2.option.groupKey
          },
          optionRow
        )
      );
    };
    AnimatedOptionFocus = (props2) => {
      var _a2;
      const { theme } = useTheme();
      const focusedItem = (_a2 = props2.virtualItems.find((v) => v.index === props2.focusedIndex)) != null ? _a2 : null;
      if (!focusedItem)
        return /* @__PURE__ */ jsx77("div", null);
      const { borderHighlight, ...style3 } = {
        ...theme.option,
        ...theme.optionSelected
      };
      const styles51 = {
        ...borderHighlight.includes("gradient") ? {
          borderLeft: "4px solid",
          borderImage: `${borderHighlight} 1`,
          borderImageWidth: "0px 0px 0px 4px"
        } : {
          borderLeft: `4px solid ${borderHighlight}`
        },
        borderRadius: style3.borderRadius,
        borderBottom: `${style3.borderWidth} ${style3.borderColor} solid`,
        backgroundColor: style3.background,
        height: "100%"
      };
      const padding = (() => {
        if (theme.optionSelected.highlightMargin !== "0px")
          return theme.optionSelected.highlightMargin;
        if (theme.option.marginLeft !== "0px" || theme.option.marginRight !== "0px") {
          return `0px ${theme.option.marginRight} 0px ${theme.option.marginLeft}`;
        }
        return "0px";
      })();
      return /* @__PURE__ */ jsx77(
        "div",
        {
          style: {
            width: "100%",
            height: focusedItem.size,
            top: 0,
            left: 0,
            position: "absolute",
            transform: `translateY(${focusedItem.start}px)`,
            transition: "0.1s transform ease-out",
            willChange: "transform",
            zIndex: 0,
            padding
          }
        },
        /* @__PURE__ */ jsx77("div", { style: styles51 })
      );
    };
    SelectOption_default = SelectOption;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightGridOption.tsx
import { css as css51, jsx as jsx78 } from "@emotion/core";
var styles38, focusedStyles2, StyledSpotlightGridOption, StyledSpotlightGridOption_default;
var init_StyledSpotlightGridOption = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightGridOption.tsx"() {
    "use strict";
    styles38 = css51({
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "flex-start",
      borderRadius: "var(--layout-radius-button)",
      color: "var(--content-secondary)",
      overflow: "hidden",
      border: "1px solid var(--form-control-border-color)",
      "&:hover": {
        borderColor: "var(--form-control-border-color-hover)"
      }
    });
    focusedStyles2 = css51({
      borderColor: "var(--base-accent)",
      boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)"
    });
    StyledSpotlightGridOption = ({ isFocused, children, ...props2 }) => {
      return /* @__PURE__ */ jsx78("div", { css: [styles38, isFocused && focusedStyles2], ...props2 }, children);
    };
    StyledSpotlightGridOption_default = StyledSpotlightGridOption;
  }
});

// commandbar/src/products/spotlight/components/select/menu/GridItem.tsx
import React230 from "react";
import { jsx as jsx79 } from "@emotion/core";
import { useTheme as useTheme19 } from "emotion-theming";
var GridItem;
var init_GridItem = __esm({
  "commandbar/src/products/spotlight/components/select/menu/GridItem.tsx"() {
    "use strict";
    init_useStore();
    init_useAction();
    init_actions9();
    init_a11y();
    init_SelectOption();
    init_selectors3();
    init_selectors8();
    init_Icon2();
    init_StyledSpotlightGridOption();
    GridItem = (props2) => {
      var _a2;
      const _ = useStore();
      const { currentStep } = currentStepAndIndex(_);
      const categories = _;
      const { errorIndex, focusedIndex } = _.spotlight;
      const { theme } = useTheme19();
      const { index: index3, onOptionHover, option } = props2;
      const refocusCommandbarInput = useAction((_2) => {
        var _a3, _b2;
        return (_b2 = (_a3 = _2.spotlight.refContainer) == null ? void 0 : _a3.current) == null ? void 0 : _b2.focus();
      });
      const onMouseMove = React230.useCallback(() => {
        if (onOptionHover)
          onOptionHover(index3);
      }, [onOptionHover, index3]);
      const onClick = useAction(
        (_2, e) => {
          if (!isOptionGroup(props2.option)) {
            selectOption(_2, props2.option, void 0, e);
          }
          refocusCommandbarInput();
        },
        [props2.option]
      );
      const image = React230.useMemo(() => {
        if (isCommandOption(option)) {
          if (option.command.category) {
            const { image: category_image, image_color: category_image_color } = getCategoryImage(_, option);
            const { icon: category_icon, icon_color: category_icon_color } = getCategoryIcon(_, option);
            const { image: command_image, image_color: command_image_color } = getCommandImage(_, option);
            const { icon: command_icon, icon_color: command_icon_color } = getCommandIcon(_, option);
            if (category_image) {
              return { src: category_image, color: category_image_color };
            } else if (command_image) {
              return { src: command_image, color: command_image_color };
            } else if (category_icon) {
              return { src: category_icon, color: category_icon_color };
            } else if (command_icon) {
              return { src: command_icon, color: command_icon_color };
            }
            return { src: null, color: null };
          }
        }
        if (isRecordOption(option)) {
          const recordImage = getReservedField(option, "__image");
          const recordIcon = getReservedField(option, "icon");
          const { image: category_image, image_color: category_image_color } = getRecordCategoryImage(option);
          const { icon: category_icon, icon_color: category_icon_color } = getRecordCategoryIcon(option);
          if (recordImage) {
            return { src: recordImage, color: null };
          } else if (category_image) {
            return { src: category_image, color: category_image_color };
          } else if (recordIcon) {
            return { src: recordIcon, color: null };
          } else if (category_icon) {
            return { src: category_icon, color: category_icon_color };
          }
          return { src: null, color: null };
        }
        if (isParameterOption(option)) {
          const image2 = getReservedField(option, "__image");
          const icon = getReservedField(option, "icon");
          return { src: image2 || icon, color: null };
        }
        return { src: null, color: null };
      }, [categories, option]);
      if (isOptionGroup(option)) {
        return null;
      }
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx79(
        StyledSpotlightGridOption_default,
        {
          onClick,
          role: a11y_default.optionRole,
          onMouseMove,
          isFocused: focusedIndex === index3
        },
        image.src ? /* @__PURE__ */ jsx79(
          Icon_default2,
          {
            color: image.color,
            style: {
              width: "100%",
              height: "100%",
              aspectRatio: "4 / 3",
              objectFit: "cover",
              fontSize: "50px"
              // Size of emoji icons
            },
            size: "100%",
            icon: image.src,
            useDefaultSVGColor: true
          }
        ) : /* @__PURE__ */ jsx79(
          "div",
          {
            style: {
              width: "100%",
              height: "100%",
              aspectRatio: "4 / 3",
              background: `linear-gradient(45deg, var(--base-accent), var(--background-primary))`
            }
          }
        ),
        /* @__PURE__ */ jsx79(
          SelectOption_default,
          {
            index: index3,
            isError: errorIndex === index3,
            isFocused: focusedIndex === index3,
            onOptionHover: void 0,
            option
          }
        )
      ) : (
        // eslint-disable-next-line
        /* @__PURE__ */ jsx79(
          "div",
          {
            onClick,
            role: a11y_default.optionRole,
            onMouseMove,
            style: {
              border: isParameterOption(option) && currentStep && isParameterOptionSelected(option, currentStep) ? `2px solid ${theme.menuGridItemCardSelected.borderColor}` : void 0,
              cursor: theme.menuGridOption.cursor,
              display: "flex",
              flexDirection: "column",
              background: theme.menuGridItemCard.background,
              paddingTop: theme.menuGridItemCard.paddingTop,
              paddingBottom: theme.menuGridItemCard.paddingBottom,
              paddingLeft: theme.menuGridItemCard.paddingLeft,
              paddingRight: theme.menuGridItemCard.paddingRight,
              overflow: "hidden",
              transition: "box-shadow .3s ease",
              borderRadius: theme.menuGridItemCard.borderRadius,
              boxShadow: focusedIndex === index3 ? theme.menuGridItemCard.hoverBoxShadow : theme.menuGridItemCard.boxShadow
            }
          },
          /* @__PURE__ */ jsx79(
            "div",
            {
              style: {
                width: "100%",
                display: theme.menuGridItemCard.coverImageDisplay === "none" ? "none" : "block",
                textAlign: "center",
                color: theme.base.fontColor
              }
            },
            image.src ? /* @__PURE__ */ jsx79(
              Icon_default2,
              {
                color: image.color,
                style: {
                  width: "100%",
                  height: "100%",
                  aspectRatio: "4 / 3",
                  objectFit: "cover",
                  borderRadius: theme.menuGridItemCard.borderRadius,
                  // Size of emoji icons
                  fontSize: "50px"
                },
                size: "100%",
                icon: image.src,
                useDefaultSVGColor: true
              }
            ) : /* @__PURE__ */ jsx79(
              "div",
              {
                style: {
                  width: "100%",
                  aspectRatio: "4 / 3",
                  background: `linear-gradient(45deg, ${theme.base.primary}, ${theme.base.background})`
                }
              }
            )
          ),
          /* @__PURE__ */ jsx79("div", { style: { flex: 1 } }, /* @__PURE__ */ jsx79(
            SelectOption_default,
            {
              index: index3,
              isError: errorIndex === index3,
              isFocused: focusedIndex === index3,
              onOptionHover: void 0,
              option
            }
          ))
        )
      );
    };
  }
});

// commandbar/src/products/spotlight/components/select/menu/MenuRow.tsx
import React231 from "react";
import { useTheme as useTheme20 } from "emotion-theming";
function hideItem(index3, menuRow) {
  const isEmptyHeaderAtTop = menuRow.type === "header" && index3 === 0 && menuRow.item.name.length === 0;
  return isEmptyHeaderAtTop;
}
var MenuRow;
var init_MenuRow = __esm({
  "commandbar/src/products/spotlight/components/select/menu/MenuRow.tsx"() {
    "use strict";
    init_useStore();
    init_a11y();
    init_OptionGroupHeader();
    init_SelectOption();
    init_selectors3();
    init_GridItem();
    MenuRow = (props2) => {
      var _a2;
      const { theme } = useTheme20();
      const _ = useStore();
      const { focusedIndex, errorIndex } = _.spotlight;
      if (!((_a2 = props2 == null ? void 0 : props2.content) == null ? void 0 : _a2.item) || hideItem(props2.index, props2.content)) {
        return /* @__PURE__ */ React231.createElement("div", { style: { height: 0 }, ref: (ref12) => props2.measureRef(ref12) });
      }
      if (props2.content.type === "grid") {
        return /* @__PURE__ */ React231.createElement(React231.Fragment, null, /* @__PURE__ */ React231.createElement(
          "div",
          {
            ref: (ref12) => props2.measureRef(ref12),
            style: {
              display: "grid",
              gap: theme.menuGridContainer.itemGap,
              gridTemplateColumns: `repeat(${theme.menuGridContainer.itemsPerRow}, 1fr)`,
              gridAutoRows: theme.menuGridContainer.minRowHeight ? `minmax(${theme.menuGridContainer.minRowHeight}, auto)` : "auto",
              position: "absolute",
              transform: `translateY(${props2.start}px)`,
              width: "100%",
              height: "auto",
              minHeight: theme.menuGridContainer.minRowHeight,
              paddingLeft: theme.menuGridContainer.paddingLeft,
              paddingRight: theme.menuGridContainer.paddingRight,
              paddingTop: theme.menuGridContainer.paddingTop,
              paddingBottom: theme.menuGridContainer.paddingBottom
            }
          },
          props2.content.item.map(
            (option, index3) => isOptionGroup(option) ? null : /* @__PURE__ */ React231.createElement(GridItem, { key: index3, option, index: props2.index + index3, onOptionHover: props2.onOptionHover })
          )
        ));
      }
      if (props2.content.type === "single" || props2.content.type === "header") {
        return /* @__PURE__ */ React231.createElement(
          "div",
          {
            role: props2.content.type === "header" ? a11y_default.groupRole : a11y_default.optionRole,
            "aria-label": props2.content.type === "header" ? a11y_default.categoryId(props2.content.item) : void 0,
            "aria-describedby": props2.content.type === "single" && props2.content.item.groupKey ? a11y_default.optionId(props2.groupPositions[props2.content.item.groupKey]) : void 0,
            id: a11y_default.optionId(props2.index),
            "aria-selected": props2.index === focusedIndex,
            style: {
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              transform: `translateY(${props2.start}px)`,
              ...props2.content.type === "single" ? { cursor: theme.option.cursor } : {},
              zIndex: 1,
              ...props2.isFirstOptionInList && { paddingTop: "var(--layout-gap)" },
              // TODO: once themesV1 deprecated, make this container its own styled component
              ...props2.isLastOptionInList && { paddingBottom: "var(--layout-gap)" }
            },
            ref: (ref12) => props2.measureRef(ref12)
          },
          props2.content.type === "header" ? /* @__PURE__ */ React231.createElement(
            OptionGroupHeader_default,
            {
              group: props2.content.item,
              isFocused: focusedIndex === props2.index,
              onToggleExpansion: props2.onToggleOptionGroup,
              addTopPadding: props2.index > 0
            }
          ) : /* @__PURE__ */ React231.createElement(
            SelectOption_default,
            {
              option: props2.content.item,
              onOptionHover: props2.onOptionHover,
              isFocused: focusedIndex === props2.index,
              isError: errorIndex === props2.index,
              index: props2.index
            }
          )
        );
      }
      return null;
    };
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightNoResults.tsx
import { css as css52, jsx as jsx80 } from "@emotion/core";
var styles39, StyledSpotlightNoResults, StyledSpotlightNoResults_default;
var init_StyledSpotlightNoResults = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightNoResults.tsx"() {
    "use strict";
    styles39 = css52({
      display: "flex",
      flexDirection: "column",
      width: "100%",
      minHeight: "104px",
      padding: "var(--layout-padding)",
      justifyContent: "center",
      alignItems: "center",
      gap: "var(--layout-gap)",
      borderRadius: "var(--layout-radius-button)",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    });
    StyledSpotlightNoResults = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx80("div", { css: styles39, ...props2 }, children);
    };
    StyledSpotlightNoResults_default = StyledSpotlightNoResults;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightNoResultsTitle.tsx
import { css as css53, jsx as jsx81 } from "@emotion/core";
var styles40, StyledSpotlightNoResultsTitle, StyledSpotlightNoResultsTitle_default;
var init_StyledSpotlightNoResultsTitle = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightNoResultsTitle.tsx"() {
    "use strict";
    styles40 = css53({
      maxWidth: "60%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      color: "var(--content-primary)",
      /* label/lg/semibold */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-large)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-snug)"
    });
    StyledSpotlightNoResultsTitle = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx81("div", { css: styles40, ...props2 }, children);
    };
    StyledSpotlightNoResultsTitle_default = StyledSpotlightNoResultsTitle;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightNoResultsSubtitle.tsx
import { css as css54, jsx as jsx82 } from "@emotion/core";
var styles41, StyledSpotlightNoResultsSubitle, StyledSpotlightNoResultsSubtitle_default;
var init_StyledSpotlightNoResultsSubtitle = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightNoResultsSubtitle.tsx"() {
    "use strict";
    styles41 = css54({
      maxWidth: "60%",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      color: "var(--content-primary)",
      /* label/small/medium */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-small)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledSpotlightNoResultsSubitle = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx82("div", { css: styles41, ...props2 }, children);
    };
    StyledSpotlightNoResultsSubtitle_default = StyledSpotlightNoResultsSubitle;
  }
});

// commandbar/src/products/spotlight/components/select/menu/EmptyMenu.tsx
import * as React232 from "react";
import { useTheme as useTheme21 } from "emotion-theming";
import { jsx as jsx83 } from "@emotion/core";
var emptyMenuStyles, CustomEmptyState, join, NoResultsWithinSearchFilter, EmptyMenu, NoResultsText, NoResults, customGustoNoResults, EmptyMenu_default;
var init_EmptyMenu = __esm({
  "commandbar/src/products/spotlight/components/select/menu/EmptyMenu.tsx"() {
    "use strict";
    init_selectors8();
    init_selectors3();
    init_utils();
    init_featureFlags();
    init_useStore();
    init_actions9();
    init_useAction();
    init_Step();
    init_a11y();
    init_selectors3();
    init_global_selectors();
    init_RenderCustomComponent();
    init_location();
    init_operatingSystem();
    init_SearchTabs();
    init_StyledSpotlightNoResults();
    init_StyledSpotlightNoResultsTitle();
    init_StyledSpotlightNoResultsSubtitle();
    init_StyledInlineButton();
    init_ThemeV2Context();
    emptyMenuStyles = (theme) => ({
      color: theme.main.color,
      fontSize: theme.main.fontSize,
      fontFamily: theme.main.fontFamily,
      width: "100%"
    });
    CustomEmptyState = () => {
      const _ = useStore();
      const { userDefinedCustomComponents } = _.spotlight;
      const component = userDefinedCustomComponents.emptyState({ step: "base" /* Base */ });
      if (typeof component === "string") {
        return /* @__PURE__ */ jsx83("div", { dangerouslySetInnerHTML: { __html: component } });
      } else if (component) {
        return /* @__PURE__ */ jsx83(RenderCustomComponent_default, { component, metadata: { inputText: _.spotlight.inputText } });
      }
      return null;
    };
    join = (items) => {
      if (items.length === 0)
        return null;
      if (items.length === 1)
        return items[0];
      if (items.length === 2)
        return /* @__PURE__ */ jsx83(React232.Fragment, null, items[0], " or ", items[1]);
      return /* @__PURE__ */ jsx83(React232.Fragment, null, items.slice(0, -1).flatMap((item, i2) => [i2 > 0 && ", ", item]), ", or ", items[items.length - 1]);
    };
    NoResultsWithinSearchFilter = () => {
      var _a2;
      const { theme } = useTheme21();
      const themeV2 = useThemeV2Context();
      const _ = useStore();
      const focusInput = useAction((_2) => {
        var _a3, _b2;
        if (!isMobileDevice()) {
          (_b2 = (_a3 = _2.spotlight.refContainer) == null ? void 0 : _a3.current) == null ? void 0 : _b2.focus();
        }
      });
      const { optionCountsByTabGroup, inputText, searchFilter } = _.spotlight;
      const setSearchFilter2 = useAction(setSearchFilter);
      const tabGroups = selectSearchTabs(_, false);
      const tabGroupsHavingOptions = tabGroups.filter((g) => {
        const optionCount = optionCountsByTabGroup.get(g.key);
        if (optionCount === void 0)
          return false;
        return optionCount > 0;
      });
      const activeTabGroup = tabGroups.find((tabGroup) => tabGroup.key === (searchFilter == null ? void 0 : searchFilter.slug));
      const activeTabGroupName = (activeTabGroup == null ? void 0 : activeTabGroup.searchTabName) || (activeTabGroup == null ? void 0 : activeTabGroup.name);
      const noResults = (() => {
        var _a3;
        if (inputText.length > 0 && activeTabGroupName) {
          return ((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) ? /* @__PURE__ */ jsx83(StyledSpotlightNoResultsTitle_default, null, "No ", /* @__PURE__ */ jsx83("strong", null, activeTabGroupName), " results for ", inputText) : /* @__PURE__ */ jsx83(
            "div",
            {
              style: {
                /* NOTE: Need width 100% here because child NoResultsText component then makes the
                 * "no search results for <query>" width 60% of this 100%. This makes long queries
                 * look good and will use an ellipsis if the query is longer than 60% of the width. */
                width: "100%"
              }
            },
            /* @__PURE__ */ jsx83(
              NoResultsText,
              {
                query: inputText,
                explanation: /* @__PURE__ */ jsx83(React232.Fragment, null, "No ", /* @__PURE__ */ jsx83("strong", null, activeTabGroupName), " results for")
              }
            )
          );
        } else {
          return /* @__PURE__ */ jsx83("div", null, (searchFilter == null ? void 0 : searchFilter.emptyInputMessage) ? searchFilter.emptyInputMessage : "No results");
        }
      })();
      const selectAnotherTab = (() => {
        var _a3;
        if (tabGroupsHavingOptions.length === 0)
          return null;
        return ((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) ? /* @__PURE__ */ jsx83(StyledSpotlightNoResultsSubtitle_default, null, "Try", " ", join(
          tabGroupsHavingOptions.map((group) => {
            const onTabSelect = () => {
              setSearchFilter2(createSearchFilter(group));
              focusInput();
            };
            return /* @__PURE__ */ jsx83(
              StyledInlineButton_default,
              {
                themeV2,
                key: group.key,
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    onTabSelect();
                  }
                },
                onClick: onTabSelect
              },
              group.searchTabName || group.name
            );
          })
        ), " ", "instead?") : /* @__PURE__ */ jsx83("div", { style: { textAlign: "center", paddingBottom: "20px" } }, "Try", " ", join(
          tabGroupsHavingOptions.map((group) => {
            const onTabSelect = () => {
              setSearchFilter2(createSearchFilter(group));
              focusInput();
            };
            return /* @__PURE__ */ jsx83(
              "button",
              {
                key: group.key,
                css: {
                  background: "none",
                  border: "none",
                  margin: 0,
                  padding: 0,
                  textDecoration: "underline",
                  color: theme.noResults.linkColor,
                  cursor: "pointer",
                  "&:hover": {
                    textDecoration: "none"
                  }
                },
                onKeyDown: (e) => {
                  if (e.key === "Enter") {
                    onTabSelect();
                  }
                },
                onClick: onTabSelect
              },
              group.searchTabName || group.name
            );
          })
        ), " ", "instead?");
      })();
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx83(StyledSpotlightNoResults_default, { id: a11y_default.emptyListId }, noResults, selectAnotherTab) : /* @__PURE__ */ jsx83("div", { style: { display: "flex", justifyContent: "center" } }, /* @__PURE__ */ jsx83(
        "div",
        {
          style: {
            marginTop: 20,
            marginBottom: 20,
            display: "flex",
            flex: 1,
            flexDirection: "column",
            gap: 4,
            alignItems: "center"
          }
        },
        noResults,
        selectAnotherTab
      ));
    };
    EmptyMenu = () => {
      const { theme } = useTheme21();
      const _ = useStore();
      const { emptyMessage, searchFilter, userDefinedCustomComponents } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const isInputEmpty = _.spotlight.inputText.length === 0;
      const numCommands = getCommands(_).length;
      const nudgeTestMode = numCommands > 0 && (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && _.isAdmin && isInputEmpty && !_.testMode;
      const displayCustomEmptyState = React232.useMemo(
        () => userDefinedCustomComponents.emptyState(),
        [userDefinedCustomComponents.emptyState]
      );
      let content;
      if (!!searchFilter && (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */) {
        content = /* @__PURE__ */ jsx83(NoResultsWithinSearchFilter, null);
      } else if (nudgeTestMode) {
        if (isStudioPreview()) {
          content = /* @__PURE__ */ jsx83("div", null, /* @__PURE__ */ jsx83("p", { style: { textAlign: "center", padding: "20px 25px" } }, "Use the editor to the left to add commands to fill out your bar, or to add Nudges or Checklists"));
        } else {
          content = /* @__PURE__ */ jsx83("div", null, /* @__PURE__ */ jsx83("p", { style: { textAlign: "center", padding: "20px 25px" } }, "Toggle ", /* @__PURE__ */ jsx83("b", null, "Test mode"), " in the Editor Panel to see your unpublished or unavailable", " ", maybePluralize(numCommands, "command"), "."));
        }
      } else if (isInputEmpty && (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */) {
        return /* @__PURE__ */ jsx83("div", null);
      } else if ((currentStep == null ? void 0 : currentStep.type) === "base" /* Base */) {
        content = featureFlags_default({
          organization: _.organization,
          orgIds: ["5725a2a3"],
          activeState: displayCustomEmptyState ? /* @__PURE__ */ jsx83(CustomEmptyState, null) : customGustoNoResults(_.spotlight.inputText),
          defaultState: displayCustomEmptyState ? /* @__PURE__ */ jsx83(CustomEmptyState, null) : /* @__PURE__ */ jsx83("div", null, emptyMessage ? emptyMessage : /* @__PURE__ */ jsx83(NoResults, { query: _.spotlight.inputText }))
        });
      } else if (isInputEmpty && isArgumentClientSearchActive(_)) {
        content = /* @__PURE__ */ jsx83("div", { style: { display: "flex", justifyContent: "center" } }, /* @__PURE__ */ jsx83("div", { style: { marginTop: 20, marginBottom: 20 } }, "Type to search"));
      } else {
        content = /* @__PURE__ */ jsx83("div", { role: "status", style: { display: "flex", justifyContent: "center" } }, /* @__PURE__ */ jsx83("div", { style: { marginTop: 20, marginBottom: 20 } }, "No results"));
      }
      return /* @__PURE__ */ jsx83("div", { id: "commandbar-menu", css: emptyMenuStyles(theme) }, /* @__PURE__ */ jsx83("div", { id: a11y_default.emptyListId }, content));
    };
    NoResultsText = (props2) => {
      var _a2;
      const { theme } = useTheme21();
      return /* @__PURE__ */ jsx83(
        "div",
        {
          role: "status",
          style: {
            fontSize: theme.noResults.headerFontSize,
            color: theme.noResults.headerFontColor,
            fontFamily: theme.noResults.headerFontFamily,
            fontWeight: theme.noResults.headerFontWeight,
            marginTop: theme.noResults.headerMarginTop,
            marginBottom: theme.noResults.headerMarginBottom,
            textAlign: "center",
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            gridTemplateColumns: "auto"
          }
        },
        /* @__PURE__ */ jsx83(
          "div",
          {
            role: "heading",
            "aria-level": 2,
            style: {
              width: "60%",
              margin: "auto",
              lineHeight: "normal",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }
          },
          (_a2 = props2.explanation) != null ? _a2 : theme.noResults.headerText,
          "\xA0",
          /* @__PURE__ */ jsx83("span", { style: { color: theme.noResults.queryFontColor } }, props2.query)
        )
      );
    };
    NoResults = (props2) => {
      const { flags } = useStore();
      return (flags == null ? void 0 : flags["release-themes-v2"]) ? /* @__PURE__ */ jsx83(StyledSpotlightNoResults_default, { id: a11y_default.emptyListId }, /* @__PURE__ */ jsx83(StyledSpotlightNoResultsTitle_default, null, "No results for ", props2.query)) : /* @__PURE__ */ jsx83(
        "div",
        {
          id: a11y_default.emptyListId,
          style: { display: "flex", flexDirection: "column", alignItems: "center", padding: "20px 0px" }
        },
        /* @__PURE__ */ jsx83(NoResultsText, { query: props2.query })
      );
    };
    customGustoNoResults = (query) => {
      return /* @__PURE__ */ jsx83(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "44px 0px 32px 0px"
          }
        },
        /* @__PURE__ */ jsx83(
          "div",
          {
            style: {
              display: "grid",
              textAlign: "center",
              width: "100%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              gridTemplateColumns: "auto"
            }
          },
          /* @__PURE__ */ jsx83(
            "div",
            {
              id: a11y_default.emptyListId,
              role: "status",
              style: {
                marginInline: "auto",
                fontSize: "32px",
                lineHeight: "40px",
                color: "#1C1C1C",
                fontWeight: 500,
                textAlign: "center",
                width: "60%",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis"
              }
            },
            `No results for`,
            "\xA0",
            /* @__PURE__ */ jsx83("span", { style: { color: "#6C6C72" } }, query)
          )
        ),
        /* @__PURE__ */ jsx83("div", { style: { fontSize: "20px", lineHeight: "28px", color: "#525257", marginTop: "24px", fontWeight: 400 } }, "Explore other Gusto resources"),
        /* @__PURE__ */ jsx83(
          "div",
          {
            className: "resource-links-container",
            style: {
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "24px",
              fontSize: "16px",
              marginTop: "16px",
              fontWeight: 400,
              lineHeight: "24px"
            }
          },
          /* @__PURE__ */ jsx83(
            "a",
            {
              className: "help-center-link",
              href: "https://support.gusto.com/?ref=cb",
              style: { display: "flex" },
              target: "_blank",
              rel: "noreferrer"
            },
            /* @__PURE__ */ jsx83("img", { src: "https://staticassets.commandbar.com/icons/5725a2a3_empty_help.svg", alt: "" }),
            /* @__PURE__ */ jsx83("span", { style: { textDecoration: "underline", color: "#0a8080", marginLeft: "8.5px" } }, "Help Center")
          ),
          /* @__PURE__ */ jsx83(
            "a",
            {
              className: "talk-shop-link",
              href: "https://gusto.com/blog?ref=cb",
              style: { display: "flex" },
              target: "_blank",
              rel: "noreferrer"
            },
            /* @__PURE__ */ jsx83("img", { src: "https://staticassets.commandbar.com/icons/5725a2a3_empty_blog.svg", alt: "" }),
            /* @__PURE__ */ jsx83("span", { style: { textDecoration: "underline", color: "#0a8080", marginLeft: "8.5px" } }, "Talk Shop blog")
          ),
          /* @__PURE__ */ jsx83(
            "a",
            {
              className: "app-directory-link",
              href: "https://app.gusto.com/payroll_admin/apps?ref=cb",
              style: { display: "flex" },
              target: "_blank",
              rel: "noreferrer"
            },
            /* @__PURE__ */ jsx83("img", { src: "https://staticassets.commandbar.com/icons/5725a2a3_empty_app.svg", alt: "" }),
            /* @__PURE__ */ jsx83("span", { style: { textDecoration: "underline", color: "#0a8080", marginLeft: "8.5px" } }, "App directory")
          ),
          /* @__PURE__ */ jsx83(
            "a",
            {
              className: "covid-19-link",
              href: "https://app.gusto.com/payroll_admin/business_center?ref=cb",
              style: { display: "flex" },
              target: "_blank",
              rel: "noreferrer"
            },
            /* @__PURE__ */ jsx83("img", { src: "https://staticassets.commandbar.com/icons/gusto-recommendations-icon.svg", alt: "" }),
            /* @__PURE__ */ jsx83("span", { style: { textDecoration: "underline", color: "#0a8080", marginLeft: "8.5px" } }, "Recommendations")
          )
        )
      );
    };
    EmptyMenu_default = EmptyMenu;
  }
});

// commandbar/src/products/spotlight/components/select/menu/MenuList.tsx
import * as React233 from "react";
import { useTheme as useTheme22 } from "emotion-theming";
import { jsx as jsx84 } from "@emotion/core";
function getMinItemHeight(index3, theme, rows) {
  if (!rows[index3]) {
    return 0;
  }
  if (hideItem(index3, rows[index3]))
    return 0;
  if (rows[index3].type === "grid") {
    return parseInt(theme.menuGridContainer.minRowHeight, 10) || 250;
  } else {
    const isHeader = rows[index3].type === "header";
    const defaultMinHeight = isHeader ? getDefaultHeaderHeight(theme, index3 > 0) : parseInt(theme.option.minHeight, 10);
    return defaultMinHeight;
  }
}
var menuListStyles, MenuList, MenuList_default;
var init_MenuList = __esm({
  "commandbar/src/products/spotlight/components/select/menu/MenuList.tsx"() {
    "use strict";
    init_OptionGroup();
    init_StickyHeader();
    init_useStore();
    init_react_virtual();
    init_useResizeObserver();
    init_a11y();
    init_MenuRow();
    init_EmptyMenu();
    init_SelectOption();
    init_selectors8();
    init_selectors3();
    init_operatingSystem();
    init_ThemeV2Context();
    init_defaults();
    menuListStyles = (_theme) => {
      return {
        scrollbarWith: "none",
        overscrollBehavior: "contain",
        msOverflowStyle: "none",
        "::-webkit-scrollbar": {
          width: 0,
          height: 0
        },
        ":focus": {
          outline: "none"
        }
      };
    };
    MenuList = (props2) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      const { theme } = useTheme22();
      const themeV2 = useThemeV2Context();
      const _ = useStore();
      const parentRef = React233.useRef(void 0);
      const { currentStepIndex } = currentStepAndIndex(_);
      const firstVisibleRowIndexRef = React233.useRef(null);
      const blockAutoScrollRef = React233.useRef(false);
      const activeStickyHeaderRef = React233.useRef(void 0);
      const sortedOptions = _.spotlight.sortedOptions;
      const isEmptyLoadingState = props2.isLoading && sortedOptions.length === 0;
      const isEmptyState = sortedOptions.length === 0;
      const isGrid = isGridView(useStore());
      const [rowsToRender, optionIndexToRowMap] = React233.useMemo(() => {
        const newRows = [];
        const newOptionIndexToRowMap = {};
        let counter = 0;
        for (let i2 = 0; i2 < sortedOptions.length; ) {
          let itemsProcessedInIteration = 0;
          const currentOption = sortedOptions[i2];
          if (isOptionGroup(currentOption)) {
            newRows.push({ type: "header", item: currentOption, index: counter });
            newOptionIndexToRowMap[counter] = newRows.length - 1;
            itemsProcessedInIteration++;
            counter++;
            if (isGrid) {
              let rowToAdd = { type: "grid", item: [], index: counter };
              for (let j = i2 + 1; j < sortedOptions.length; j++) {
                const innerCurrentOption = sortedOptions[j];
                if (isOptionGroup(innerCurrentOption)) {
                  break;
                } else {
                  rowToAdd.item.push(innerCurrentOption);
                  newOptionIndexToRowMap[counter] = newRows.length;
                  itemsProcessedInIteration++;
                  counter++;
                  if (rowToAdd.item.length >= Number(theme.menuGridContainer.itemsPerRow || 3)) {
                    newRows.push(rowToAdd);
                    rowToAdd = { type: "grid", item: [], index: counter };
                  }
                }
              }
              if (rowToAdd.item.length >= 1) {
                newRows.push(rowToAdd);
              }
            }
          } else {
            newRows.push({ type: "single", item: currentOption, index: counter });
            newOptionIndexToRowMap[counter] = newRows.length - 1;
            itemsProcessedInIteration++;
            counter++;
          }
          i2 = i2 + itemsProcessedInIteration;
        }
        return [newRows, newOptionIndexToRowMap];
      }, [sortedOptions]);
      const findActiveStickyHeader = React233.useCallback(
        (startIndex) => {
          const headerIndexesInReverse = rowsToRender.map((_2, index3) => index3).filter((index3) => rowsToRender[index3].type === "header" && !hideItem(index3, rowsToRender[index3])).reverse();
          return headerIndexesInReverse.find((headerIndex) => headerIndex <= startIndex);
        },
        [rowsToRender]
      );
      const getStickyHeader = () => {
        if (activeStickyHeaderRef.current !== void 0) {
          const row = rowsToRender[activeStickyHeaderRef.current];
          if (row.type === "header") {
            return row.item;
          }
        }
        return null;
      };
      const estimateRowHeight = React233.useCallback(
        (index3) => getMinItemHeight(index3, theme, rowsToRender),
        [theme, rowsToRender]
      );
      const rowVirtualizer = useVirtual({
        size: rowsToRender.length,
        parentRef,
        paddingStart: parseInt(theme.optionList.paddingTop, 10),
        paddingEnd: parseInt(theme.optionList.paddingBottom, 10),
        overscan: 5,
        rangeExtractor: React233.useCallback(
          (range) => {
            firstVisibleRowIndexRef.current = range.start;
            activeStickyHeaderRef.current = findActiveStickyHeader(range.start);
            return defaultRangeExtractor(range);
          },
          [findActiveStickyHeader]
        ),
        estimateSize: estimateRowHeight,
        useObserver: false ? testObserver : void 0
      });
      const itemIndexToAutoScrollTo = React233.useMemo(() => {
        if (blockAutoScrollRef.current) {
          blockAutoScrollRef.current = false;
          return void 0;
        }
        if (firstVisibleRowIndexRef.current !== null && getStickyHeader()) {
          if (props2.focusedIndex <= firstVisibleRowIndexRef.current + 1) {
            return Math.max(props2.focusedIndex - 1, 0);
          }
        }
        return optionIndexToRowMap[props2.focusedIndex];
      }, [props2.focusedIndex]);
      React233.useEffect(() => {
        if (itemIndexToAutoScrollTo !== void 0) {
          if (itemIndexToAutoScrollTo === 0) {
            rowVirtualizer.scrollToOffset(0);
          } else {
            if (itemIndexToAutoScrollTo < 3) {
              const option = rowsToRender[0].item;
              if (isCommandOption(option) && option.command.name === "__commandbar_ask_copilot") {
                rowVirtualizer.scrollToOffset(0);
              }
            } else {
              rowVirtualizer.scrollToIndex(itemIndexToAutoScrollTo);
            }
          }
        }
      }, [itemIndexToAutoScrollTo]);
      const onOptionHover = React233.useCallback(
        (index3) => {
          props2.onOptionHover(index3);
          blockAutoScrollRef.current = true;
        },
        [props2.onOptionHover, blockAutoScrollRef]
      );
      const onToggleOptionGroup = React233.useCallback(() => {
        blockAutoScrollRef.current = true;
      }, [blockAutoScrollRef]);
      const groupPositions = React233.useMemo(() => {
        const positions = {};
        sortedOptions.forEach((opt, idx) => {
          if (isOptionGroup(opt)) {
            positions[opt.key] = idx;
          }
        });
        return positions;
      }, [sortedOptions]);
      const rowRenderer = React233.useCallback(
        (item) => {
          var _a3, _b3;
          const row = rowsToRender[item.index];
          const isFirstOptionInList = !!((_a3 = _.flags) == null ? void 0 : _a3["release-themes-v2"]) && row.type === "single" && (item.index === 0 || rowsToRender[item.index - 1].type === "header");
          const isLastOptionInList = !!((_b3 = _.flags) == null ? void 0 : _b3["release-themes-v2"]) && row.type === "single" && (item.index === rowsToRender.length - 1 || rowsToRender[item.index + 1].type === "header");
          if (!row) {
            return null;
          }
          return /* @__PURE__ */ jsx84(
            MenuRow,
            {
              ...item,
              content: row,
              key: item.index,
              index: row.index,
              onToggleOptionGroup,
              onOptionHover,
              groupPositions,
              isFirstOptionInList,
              isLastOptionInList
            }
          );
        },
        [rowsToRender, optionIndexToRowMap]
      );
      let maxMenuHeight = theme.bar.menuHeight;
      if ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) {
        const styles51 = (_c2 = (_b2 = themeV2.themeV2) == null ? void 0 : _b2[themeV2.mode]) != null ? _c2 : DEFAULT_THEME[themeV2.mode];
        maxMenuHeight = (_d = styles51 == null ? void 0 : styles51.var_overrides["--spotlight-max-height"]) != null ? _d : styles51 == null ? void 0 : styles51.var_defaults["--spotlight-max-height"];
      }
      const maxHeight = false ? Number.MAX_SAFE_INTEGER : parseInt(maxMenuHeight, 10);
      const [emptyMenuEl, setEmptyMenuEl] = React233.useState(null);
      const emptyMenuRef = React233.useCallback((node) => {
        setEmptyMenuEl(node);
      }, []);
      const { height: emptyMenuHeight } = useResizeObserver_default(emptyMenuEl);
      const { height: menuWrapperHeight } = useResizeObserver_default(props2.menuWrapperRef.current);
      if ((!((_e = _.flags) == null ? void 0 : _e["release-widget-animations"]) || !((_f = _.flags) == null ? void 0 : _f["release-themes-v2"])) && !_.spotlight.visible) {
        return /* @__PURE__ */ jsx84("div", null, /* @__PURE__ */ jsx84("div", null));
      }
      const getMenuHeight = () => {
        const defaultSize = isMobileDevice() ? menuWrapperHeight : Math.min(rowVirtualizer.totalSize, maxHeight);
        if (isEmptyState) {
          return emptyMenuHeight != null ? emptyMenuHeight : defaultSize;
        }
        return defaultSize;
      };
      const menuHeight = getMenuHeight();
      return /* @__PURE__ */ jsx84(
        "div",
        {
          style: {
            height: menuHeight,
            // Hide the scrollbars if we don't compute the size of the container correctly.
            // This is a workaround for a bug causing an infinite loop involving the scrollbar
            // appearing, changing the size of the container, disappearing,
            // changing the size of the container, etc. which causes a loop.
            overflow: "hidden",
            transition: "0.1s height ease-out"
          }
        },
        isEmptyState ? /* @__PURE__ */ jsx84(
          "div",
          {
            ref: emptyMenuRef,
            id: "commandbar_empty_menu",
            style: {
              minHeight: ((_g = _.flags) == null ? void 0 : _g["release-themes-v2"]) ? 0 : theme.bar.menuMinHeight,
              display: "flex",
              justifyContent: "center"
            }
          },
          isEmptyLoadingState ? /* @__PURE__ */ jsx84(
            "div",
            {
              style: {
                display: "flex",
                alignItems: "center"
              }
            }
          ) : /* @__PURE__ */ jsx84(EmptyMenu_default, null)
        ) : ((_h = _.flags) == null ? void 0 : _h["release-themes-v2"]) ? /* @__PURE__ */ jsx84("div", null, /* @__PURE__ */ jsx84(
          StickyHeader_default,
          {
            group: getStickyHeader() || void 0,
            themeContext: theme,
            expandedGroupKeys: props2.expandedGroupKeys,
            paddingTop: "0px"
          }
        ), /* @__PURE__ */ jsx84(
          "div",
          {
            id: "commandbar_menu_list",
            style: {
              maxHeight: isMobileDevice() ? menuHeight : maxHeight,
              height: isMobileDevice() ? menuHeight : "auto",
              overflow: "auto",
              scrollbarWidth: "none"
            },
            css: menuListStyles(theme),
            ref: parentRef
          },
          /* @__PURE__ */ jsx84(
            "div",
            {
              role: a11y_default.listRole,
              "aria-label": a11y_default.listLabel,
              id: a11y_default.listId,
              style: {
                height: `${rowVirtualizer.totalSize}px`,
                width: "100%",
                position: "relative",
                overflow: "hidden",
                display: "flex"
              }
            },
            rowVirtualizer.virtualItems.map(rowRenderer)
          )
        )) : /* @__PURE__ */ jsx84("div", null, /* @__PURE__ */ jsx84(
          StickyHeader_default,
          {
            group: getStickyHeader() || void 0,
            themeContext: theme,
            expandedGroupKeys: props2.expandedGroupKeys,
            paddingTop: theme.optionList.paddingTop
          }
        ), /* @__PURE__ */ jsx84(
          "div",
          {
            id: "commandbar_menu_list",
            style: {
              marginTop: theme.optionList.marginTop,
              marginBottom: theme.optionList.marginBottom,
              maxHeight: isMobileDevice() ? menuHeight : maxHeight,
              height: isMobileDevice() ? menuHeight : "auto",
              overflow: "auto",
              scrollbarWidth: "none"
            },
            css: menuListStyles(theme),
            ref: parentRef
          },
          /* @__PURE__ */ jsx84(
            "div",
            {
              role: a11y_default.listRole,
              "aria-label": a11y_default.listLabel,
              id: a11y_default.listId,
              style: {
                height: `${rowVirtualizer.totalSize}px`,
                width: "100%",
                position: "relative",
                overflow: "hidden"
              }
            },
            !!rowsToRender[optionIndexToRowMap[props2.focusedIndex]] && rowsToRender[optionIndexToRowMap[props2.focusedIndex]].type !== "grid" && /* @__PURE__ */ jsx84(
              AnimatedOptionFocus,
              {
                key: `focus-${currentStepIndex}`,
                virtualItems: rowVirtualizer.virtualItems,
                focusedIndex: optionIndexToRowMap[props2.focusedIndex]
              }
            ),
            rowVirtualizer.virtualItems.map(rowRenderer)
          )
        ))
      );
    };
    MenuList_default = MenuList;
  }
});

// commandbar/src/products/spotlight/components/DefaultState.tsx
import React234 from "react";
var DefaultState, DefaultState_default;
var init_DefaultState = __esm({
  "commandbar/src/products/spotlight/components/DefaultState.tsx"() {
    "use strict";
    init_useStore();
    init_Step();
    init_RenderCustomComponent();
    DefaultState = () => {
      const { userDefinedCustomComponents } = useStore().spotlight;
      const component = userDefinedCustomComponents.defaultState({ step: "base" /* Base */ });
      if (typeof component === "string") {
        return /* @__PURE__ */ React234.createElement("div", { dangerouslySetInnerHTML: { __html: component } });
      } else if (component) {
        return /* @__PURE__ */ React234.createElement(RenderCustomComponent_default, { component });
      }
      return null;
    };
    DefaultState_default = DefaultState;
  }
});

// commandbar/src/products/spotlight/components/detailpreview/PlaintextPreview.tsx
import React235 from "react";
var PlaintextPreview, PlaintextPreview_default;
var init_PlaintextPreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/PlaintextPreview.tsx"() {
    "use strict";
    PlaintextPreview = ({ value }) => {
      return /* @__PURE__ */ React235.createElement("div", null, value);
    };
    PlaintextPreview_default = PlaintextPreview;
  }
});

// commandbar/src/products/spotlight/components/detailpreview/MarkdownPreview.tsx
import React236 from "react";
var MarkdownPreview, MarkdownPreview_default;
var init_MarkdownPreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/MarkdownPreview.tsx"() {
    "use strict";
    MarkdownPreview = ({ value }) => {
      return /* @__PURE__ */ React236.createElement("div", null, value);
    };
    MarkdownPreview_default = MarkdownPreview;
  }
});

// commandbar/src/products/spotlight/components/detailpreview/ReactPreview.tsx
import React237 from "react";
var ReactPreview, ReactPreview_default;
var init_ReactPreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/ReactPreview.tsx"() {
    "use strict";
    ReactPreview = ({ value }) => {
      return /* @__PURE__ */ React237.createElement("div", null, value);
    };
    ReactPreview_default = ReactPreview;
  }
});

// commandbar/src/products/spotlight/components/detailpreview/HtmlPreview.tsx
import React238, { useEffect as useEffect44 } from "react";
import chroma16 from "chroma-js";
import { css as css55, jsx as jsx85 } from "@emotion/core";
var HtmlPreview, HTMLView, HtmlPreview_default;
var init_HtmlPreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/HtmlPreview.tsx"() {
    "use strict";
    init_useStore();
    init_Logger();
    init_useCommandBarContainer();
    init_sanitizeHtml();
    init_sentry();
    init_useTheme();
    HtmlPreview = ({ value, title, scrollContainerRef }) => {
      const { inputText } = useStore().spotlight;
      return /* @__PURE__ */ jsx85(HTMLView, { scrollContainerRef, html: value, title: title != null ? title : "", inputText });
    };
    HTMLView = (props2) => {
      const { root } = useCommandBarContainer();
      const { theme } = useTheme();
      const [activeHighlightIdx, setActiveHighlightIdx] = React238.useState(0);
      const getHighlightId = (idx) => {
        return `cb-highlight-${idx}`;
      };
      const activeHighlightClassName = "active-highlight";
      const scrollContainerRef = props2.scrollContainerRef;
      const handleActiveHighlightChange = (oldIdx, newIdx) => {
        if (!scrollContainerRef) {
          return;
        }
        const oldHighlight = root == null ? void 0 : root.getElementById(getHighlightId(oldIdx));
        const newHighlight = root == null ? void 0 : root.getElementById(getHighlightId(newIdx));
        if (newHighlight) {
          if (oldHighlight) {
            oldHighlight.classList.remove(activeHighlightClassName);
          }
          setTimeout(() => {
            var _a2;
            return (_a2 = scrollContainerRef.current) == null ? void 0 : _a2.scrollTo(0, Math.max(0, (newHighlight == null ? void 0 : newHighlight.offsetTop) - 50));
          }, 100);
          newHighlight.classList.add(activeHighlightClassName);
          return true;
        }
      };
      useEffect44(() => {
        const timerId = setTimeout(() => {
          scrollToNextMatch();
        }, 200);
        return () => {
          clearTimeout(timerId);
        };
      }, [props2.inputText]);
      const scrollToNextMatch = () => {
        const nextIdx = activeHighlightIdx + 1;
        if (handleActiveHighlightChange(activeHighlightIdx, nextIdx)) {
          setActiveHighlightIdx(nextIdx);
        }
      };
      const scrollToPrevMatch = () => {
        const prevIdx = Math.max(activeHighlightIdx - 1, 0);
        handleActiveHighlightChange(activeHighlightIdx, prevIdx);
        if (handleActiveHighlightChange(activeHighlightIdx, prevIdx)) {
          setActiveHighlightIdx(prevIdx);
        }
      };
      const highlightHTML = (html, query) => {
        var _a2;
        let matchIdx = 0;
        function highlightMatches(match2) {
          if (!match2 || match2.startsWith("<"))
            return match2;
          matchIdx += 1;
          return `<mark id="${getHighlightId(matchIdx)}">` + match2 + "</mark>";
        }
        if (query.length > 2) {
          try {
            const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            const regexp = new RegExp(`<[^>]+>|(${escapedQuery})`, "gi");
            return html.replace(regexp, highlightMatches);
          } catch (err) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureException(err);
            Logger_default.error("Query could not be parsed for highlighting", err);
          }
        }
        return html;
      };
      let highlightedHTML = null;
      highlightedHTML = highlightHTML(props2.html, props2.inputText);
      React238.useEffect(() => {
        setActiveHighlightIdx(0);
      }, [props2.html]);
      if (highlightedHTML) {
        const highlightBackground = chroma16.mix(
          chroma16.valid(theme.base.background) ? theme.base.background : "#fff",
          chroma16.valid(theme.base.primary) ? theme.base.primary : "rgb(174, 177, 221)",
          0.4
        ).css();
        return /* @__PURE__ */ jsx85(
          "div",
          {
            tabIndex: 0,
            onKeyDown: (e) => {
              if (e.key === "ArrowRight") {
                scrollToNextMatch();
                e.stopPropagation();
              } else if (e.key === "ArrowLeft") {
                scrollToPrevMatch();
              }
            },
            role: "menu",
            css: css55`
          img {
            display: block;
            max-width: 100%;
            height: auto;
            box-shadow: ${theme.main.boxShadow};
            border: 1px solid ${theme.main.borderColors};
            margin: 1em auto;
          }
          mark {
            padding: 0;
            background-color: ${highlightBackground};
            transition: background-color ${theme.main.transitionTime} ease;
          }
          .${activeHighlightClassName} {
            background-color: yellow !important;
          }
          p:empty {
            display: none;
          }
          ol,
          ul {
            padding-inline-start: 0.5rem;
            margin-block-end: 1em;
            margin-block-start: 0.4em;
            color: ${theme.main.color};
          }
          li {
            text-align: left;
            padding-left: 0.5em;
            padding-bottom: 0.75em;
            margin-left: 1em;
          }
          a {
            color: ${chroma16.mix(
              chroma16.valid(theme.base.primary) ? theme.base.primary : "rgb(174, 177, 221)",
              chroma16.valid(theme.base.fontColor) ? theme.base.fontColor : "rgba(0, 0, 0, 0.85)",
              0.8
            ).css()};
            text-decoration: underline;
          }
          p {
            margin-block-end: 1em;
          }
          strong {
            font-weight: 600;
          }
          h1 {
            font-weight: 700;
            font-size: 18px;
            color: ${theme.main.color};
            margin-block-end: 0.5em;
            text-align: left;
          }
          h2 {
            font-weight: 600;
            line-height: 1.4;
            color: ${theme.main.color};
            font-size: 16px;
            margin-block-start: 1em;
            text-align: left;
          }
          h3 {
            font-weight: 600;
            font-size: 14px;
            color: ${theme.main.color};
            margin-block-start: 1.7em;
            line-height: 1.5;
            text-align: left;
          }
          h4 {
            font-weight: 500;
            font-size: 13px;
            color: ${theme.main.color};
            margin-block-start: 1.7em;
            text-align: left;
          }
          iframe {
            position: relative;
            max-width: 100%;
            width: 100%;
            height: auto;
            aspect-ratio: 16 / 9;
          }
          video {
            width: 100%;
            height: auto;
            aspect-ratio: 16 / 9;
          }
          table {
            border-collapse: collapse;
          }
          thead {
            p {
              margin-block-start: 0.2em;
              margin-block-end: 0.2em;
            }
          }
          td {
            border: 1px solid ${theme.main.borderColors};
            padding: 0px 5px;
          }
          tbody {
            vertical-align: top;
            p {
              margin-block-start: 0.1em;
              margin-block-end: 0.1em;
            }
          }
          div {
            margin-block-end: 0.8em;
          }

          pre {
            white-space: pre;
          }

          button {
            all: unset;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            position: relative;
            white-space: nowrap;
            vertical-align: middle;
            outline: transparent solid 2px;
            outline-offset: 2px;
            line-height: 1.2;
            border-radius: 0.375em;
            font-weight: 500;
            transition-property: background-color, color, transform;
            transition-duration: ${theme.main.transitionTime};
            height: 2em;
            min-width: 2em;
            font-size: 0.875em;
            padding-inline-start: 0.75em;
            padding-inline-end: 0.75em;
            background-color: ${theme.searchTab.activeBackground};
            color: ${theme.searchTab.activeColor};
            &:hover {
              background-color: ${chroma16.valid(theme.searchTab.activeBackground) ? chroma16(theme.searchTab.activeBackground).darken(0.25).css() : theme.searchTab.activeBackground};
            }
          }
        `
          },
          /* @__PURE__ */ jsx85("div", { dangerouslySetInnerHTML: { __html: sanitizeHtml_default(highlightedHTML) } })
        );
      }
      return null;
    };
    HtmlPreview_default = HtmlPreview;
  }
});

// commandbar/src/products/spotlight/components/NextStepCommandsMenu.tsx
import { jsx as jsx86 } from "@emotion/core";
import { useTheme as useTheme23 } from "emotion-theming";
function NextStepPill(props2) {
  const { theme } = useTheme23();
  return /* @__PURE__ */ jsx86(
    "div",
    {
      tabIndex: 0,
      role: "button",
      css: {
        boxSizing: "border-box",
        background: theme.nextStepCommands.background,
        boxShadow: theme.nextStepCommands.boxShadow,
        borderRadius: theme.nextStepCommands.borderRadius,
        backdropFilter: "blur(6px)",
        color: theme.nextStepCommands.color,
        textAlign: "center",
        fontSize: "0.9em",
        marginBottom: "10px",
        padding: "3px 12px",
        cursor: "pointer",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        transition: "all 0.3s ease-in",
        maxWidth: "100%",
        "&:hover": {
          background: theme.nextStepCommands.hoverBackgroundColor,
          color: theme.nextStepCommands.hoverColor
        },
        ...props2.styles
      },
      onClick: props2.onClick,
      onKeyDown: (e) => {
        if (e.key === "Enter") {
          props2.onClick();
        }
      }
    },
    /* @__PURE__ */ jsx86(
      "div",
      {
        css: {
          display: "flex",
          alignItems: "center"
        }
      },
      props2.icon && /* @__PURE__ */ jsx86(
        "div",
        {
          css: {
            marginRight: "6px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }
        },
        /* @__PURE__ */ jsx86(Icon_default2, { size: theme.nextStepCommands.iconSize, icon: props2.icon, useDefaultSVGColor: true })
      ),
      /* @__PURE__ */ jsx86(
        "div",
        {
          css: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        },
        props2.text
      )
    )
  );
}
function NextStepCommandsMenu({ width, isHidden, offset: offset6, reportPreviewEvent }) {
  const _ = useStore();
  const clearInput2 = useAction((_2) => {
    handleInputChange(_2, "");
  });
  const chooseRecordAction = useAction(
    (_2, record12, action, e) => {
      selectOption(_2, initUnfurledCommandOption(_2, action.command, action, record12), void 0, e);
    }
  );
  const chooseOption2 = useAction((_2, o, e) => {
    selectOption(_2, o, void 0, e);
  });
  const executeAction2 = useAction((_2, action, e) => {
    executeAction(_2, action.action, e);
  });
  const focusedOption = _.spotlight.sortedOptions[_.spotlight.focusedIndex];
  function isCommandOption2(o) {
    return o.command !== void 0;
  }
  const handleOnClick = (o, e) => {
    reportPreviewEvent && reportPreviewEvent("next_step_selected");
    clearInput2();
    if (isCommandOption2(o)) {
      if (focusedOption && isRecordOption(focusedOption)) {
        chooseRecordAction(focusedOption, o, e);
      } else if (o) {
        chooseOption2(o, e);
      }
    } else {
      executeAction2(o);
    }
  };
  let options;
  if (focusedOption && isRecordOption(focusedOption)) {
    options = focusedOption.recordActions;
  } else {
    options = getNextStepOptions(_);
  }
  const top = !!offset6 ? offset6 + 10 : 10;
  return /* @__PURE__ */ jsx86(
    "div",
    {
      css: {
        display: isHidden ? "none" : "flex",
        flexDirection: "column",
        position: "absolute",
        top: `${top}px`,
        right: "10px",
        width: width != null ? width : "30%",
        zIndex: 2,
        alignItems: "flex-end"
      }
    },
    options.map((o, idx) => /* @__PURE__ */ jsx86(
      NextStepPill,
      {
        key: `next-step-command-item-${idx}`,
        icon: isCommandOption2(o) ? o.command.category && getCategoryField(_, o.command.category, "icon") || o.command.icon || commandDefault(o.command) : null,
        text: interpolateObject({
          s: isCommandOption2(o) ? o.command.text : o.cta,
          _,
          interpolateContext: true,
          interpolateArgs: false
        }),
        onClick: (e) => handleOnClick(o, e)
      }
    ))
  );
}
var NextStepCommandsMenu_default;
var init_NextStepCommandsMenu = __esm({
  "commandbar/src/products/spotlight/components/NextStepCommandsMenu.tsx"() {
    "use strict";
    init_Icon2();
    init_Interpolate();
    init_UnfurledCommandOption();
    init_useAction();
    init_useStore();
    init_actions9();
    init_selectors3();
    init_global_actions();
    NextStepCommandsMenu_default = NextStepCommandsMenu;
  }
});

// commandbar/src/products/spotlight/components/detailpreview/InlinePreview.tsx
import React239 from "react";
import { css as css56, jsx as jsx87, keyframes as keyframes9 } from "@emotion/core";
var slideIn, slideOut, InlinePreview;
var init_InlinePreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/InlinePreview.tsx"() {
    "use strict";
    init_NextStepCommandsMenu();
    init_useHasScroll();
    init_useTheme();
    init_useStore();
    slideIn = keyframes9`
0% {
  transform: translateX(100%);
}
`;
    slideOut = keyframes9`
100% {
  transform: translateX(110%);
}
`;
    InlinePreview = (props2) => {
      const { theme } = useTheme();
      const { hasScrolled } = useHasScroll_default(props2.contentContainerRef);
      const { flags } = useStore();
      React239.useEffect(() => {
        if (hasScrolled) {
          props2.reportPreviewEvent("preview_engagement", "scrolled");
        }
      }, [hasScrolled]);
      return /* @__PURE__ */ jsx87(
        "div",
        {
          ref: props2.contentContainerRef,
          css: css56`
        animation: ${props2.isMounted ? slideIn : slideOut} ${theme.detailPreview.animationDuration} forwards;
        animation-timing-function: cubic-bezier(0.15, 1, 0.25, 1);
      `,
          style: {
            transform: "translateX(0%)",
            width: theme.detailPreview.width,
            height: (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--spotlight-max-height)" : theme.bar.menuHeight,
            overflow: "auto",
            color: theme.base.fontColor,
            fontSize: "14px",
            lineHeight: 1.7,
            fontFamily: theme.base.fontFamily,
            background: theme.base.background,
            boxShadow: "-4px 0px 14px -4px rgb(0 0 0 / 25%)",
            clipPath: "inset(0px 0px 0px -15px)",
            borderTop: theme.categoryHeader.borderTop,
            textAlign: "left",
            scrollBehavior: "smooth",
            padding: theme.detailPreview.padding,
            zIndex: "10",
            top: "0",
            right: "0",
            position: "absolute"
          }
        },
        /* @__PURE__ */ jsx87("div", { style: { position: "sticky", top: "0" } }, /* @__PURE__ */ jsx87(
          NextStepCommandsMenu_default,
          {
            isHidden: theme.nextStepCommands.hidden === "true",
            width: "50%",
            reportPreviewEvent: props2.reportPreviewEvent
          }
        )),
        props2.title && /* @__PURE__ */ jsx87(
          "h1",
          {
            style: {
              display: theme.detailPreview.titleDisplay,
              fontSize: theme.detailPreview.titleFontSize,
              lineHeight: theme.detailPreview.titleLineHeight,
              fontWeight: theme.detailPreview.titleFontWeight,
              color: theme.detailPreview.titleColor,
              margin: theme.detailPreview.titleMargin,
              padding: theme.detailPreview.titlePadding,
              backgroundColor: theme.detailPreview.titleBackgroundColor,
              borderRadius: theme.detailPreview.titleBorderRadius
            }
          },
          props2.title
        ),
        props2.content
      );
    };
  }
});

// commandbar/src/products/spotlight/components/detailpreview/PopOverPreview.tsx
import React240, { useEffect as useEffect45, useLayoutEffect as useLayoutEffect4, useRef as useRef34 } from "react";
import chroma17 from "chroma-js";
import ReactDOM8 from "react-dom";
import { AiOutlineClose as AiOutlineClose3 } from "react-icons/ai";
var PreviewPopover;
var init_PopOverPreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/PopOverPreview.tsx"() {
    "use strict";
    init_Z();
    init_useAction();
    init_NextStepCommandsMenu();
    init_useHasScroll();
    init_useCommandBarContainer();
    init_chroma();
    init_useTheme();
    PreviewPopover = (props2) => {
      const { root } = useCommandBarContainer();
      const refocusCommandbarInput = useAction((_) => {
        var _a2, _b2;
        return (_b2 = (_a2 = _.spotlight.refContainer) == null ? void 0 : _a2.current) == null ? void 0 : _b2.focus();
      });
      const scrollRef = useRef34(null);
      const popupContainer = React240.useMemo(() => {
        var _a2;
        return (_a2 = document.getElementById("commandbar")) != null ? _a2 : null;
      }, []);
      const { theme } = useTheme();
      const [x, setX] = React240.useState(0);
      const [y, setY] = React240.useState(0);
      const [closed, setClosed] = React240.useState(false);
      const { hasScrolled } = useHasScroll_default(scrollRef);
      useEffect45(() => {
        if (hasScrolled) {
          props2.reportPreviewEvent("preview_engagement", "scrolled");
        }
      }, [hasScrolled]);
      useEffect45(() => {
        setClosed(false);
      }, [props2.focusedIndex]);
      useLayoutEffect4(() => {
        function updateSize() {
          if (!props2.contentContainerRef.current) {
            return;
          }
          const menuElement = root == null ? void 0 : root.getElementById(`commandbar-menu__wrapper`);
          if (!menuElement) {
            return;
          }
          const yMiddlePositon = menuElement.getBoundingClientRect().top;
          let xMiddlePositon = menuElement.getBoundingClientRect().left + menuElement.getBoundingClientRect().width - 8;
          if (window.innerWidth >= props2.contentContainerRef.current.offsetWidth + xMiddlePositon) {
            setY(yMiddlePositon);
            setX(xMiddlePositon);
          } else {
            const barWidth = menuElement.clientWidth;
            const MARGIN_RIGHT_WINDOW = 10;
            const slideOffset = props2.contentContainerRef.current.offsetWidth + xMiddlePositon - window.innerWidth + MARGIN_RIGHT_WINDOW;
            const MAX_SLIDE_OFFSET = Math.max(barWidth - 175, 0);
            xMiddlePositon = xMiddlePositon - Math.min(slideOffset, MAX_SLIDE_OFFSET);
            setY(yMiddlePositon);
            setX(xMiddlePositon);
          }
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => {
          window.removeEventListener("resize", updateSize);
        };
      }, [props2.focusedIndex]);
      const floatingContainer = /* @__PURE__ */ React240.createElement(
        "div",
        {
          ref: props2.contentContainerRef,
          className: "commandbar-popover-container",
          style: {
            position: "fixed",
            zIndex: Z_default.Z_TOOLTIPS,
            minWidth: theme.previewPopover.minWidth,
            maxWidth: theme.previewPopover.maxWidth,
            maxHeight: theme.previewPopover.maxHeight,
            minHeight: theme.previewPopover.minHeight,
            color: theme.base.fontColor,
            fontFamily: theme.base.fontFamily,
            background: theme.previewPopover.background,
            boxShadow: theme.previewPopover.boxShadow,
            textAlign: "left",
            opacity: theme.previewPopover.opacity,
            borderRadius: theme.main.borderRadius,
            fontSize: "12px",
            display: "flex",
            top: y,
            left: x
          }
        },
        /* @__PURE__ */ React240.createElement(
          NextStepCommandsMenu_default,
          {
            isHidden: theme.nextStepCommands.hidden === "true",
            offset: 37,
            width: "100%",
            reportPreviewEvent: props2.reportPreviewEvent
          }
        ),
        /* @__PURE__ */ React240.createElement(
          "div",
          {
            style: {
              borderBottom: theme.previewPopover.titleBarBorderBottom,
              width: "100%",
              position: "absolute",
              top: 0,
              left: 0,
              padding: "10px 8px 8px 20px",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              whiteSpace: "nowrap",
              lineHeight: "18px",
              fontSize: "12px"
            }
          },
          props2.title && /* @__PURE__ */ React240.createElement(
            "span",
            {
              style: {
                textOverflow: "ellipsis",
                overflow: "hidden",
                fontWeight: 600
              }
            },
            props2.title
          ),
          /* @__PURE__ */ React240.createElement(
            "div",
            {
              style: {
                border: "none",
                color: theme.base.fontColor
              }
            },
            !!props2.pageLink && /* @__PURE__ */ React240.createElement(
              "a",
              {
                style: {
                  marginLeft: "6px",
                  padding: "4px 6px",
                  borderRadius: "4px",
                  background: chroma17.mix(getChromaColor(theme.base.background), getChromaColor(theme.base.fontColor), 0.15).alpha(1).css(),
                  fontFamily: theme.main.fontFamily,
                  color: theme.base.fontColor,
                  fontSize: "12px"
                },
                href: props2.pageLink,
                target: "_blank",
                rel: "noreferrer",
                onClick: () => props2.reportPreviewEvent("preview_link_open")
              },
              "Open"
            ),
            /* @__PURE__ */ React240.createElement(
              AiOutlineClose3,
              {
                style: {
                  marginLeft: "6px",
                  borderRadius: "4px",
                  fill: theme.base.fontColor,
                  cursor: "pointer",
                  verticalAlign: "middle"
                },
                onClick: () => {
                  setClosed(true);
                  refocusCommandbarInput();
                }
              }
            )
          )
        ),
        /* @__PURE__ */ React240.createElement(
          "div",
          {
            style: {
              position: "relative",
              scrollBehavior: "smooth",
              flex: "1 1 auto",
              overflowY: "auto",
              marginTop: "36px",
              padding: theme.previewPopover.padding
            }
          },
          props2.content
        )
      );
      if (!closed && popupContainer) {
        return ReactDOM8.createPortal(floatingContainer, popupContainer);
      } else {
        return null;
      }
    };
  }
});

// commandbar/src/products/spotlight/components/detailpreview/DetailPreview.tsx
import React241, { useLayoutEffect as useLayoutEffect5, useState as useState29 } from "react";
var DetailPreview, DetailPreview_default;
var init_DetailPreview = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/DetailPreview.tsx"() {
    "use strict";
    init_PlaintextPreview();
    init_MarkdownPreview();
    init_ReactPreview();
    init_HtmlPreview();
    init_VideoContainer();
    init_useStore();
    init_Logger();
    init_RenderCustomComponent();
    init_InlinePreview();
    init_PopOverPreview();
    init_Reporting();
    init_useCommandBarContainer();
    init_EngagementTracking();
    DetailPreview = (props2) => {
      const _ = useStore();
      const [renderType, setRenderType] = React241.useState("inline");
      const [positionSetByContent, setPositionSetByContent] = React241.useState(false);
      const [shouldRenderPreview, setShouldRenderPreview] = React241.useState(false);
      const [startTime] = useState29(Date.now());
      const previewEventID = `${props2 == null ? void 0 : props2.uid}-${startTime}`;
      const { root } = useCommandBarContainer();
      React241.useEffect(() => {
        const renderDelay = window.setTimeout(() => setShouldRenderPreview(true), 100);
        return () => {
          window.clearTimeout(renderDelay);
        };
      }, []);
      useLayoutEffect5(() => {
        var _a2;
        if (!positionSetByContent) {
          const barElement = (_a2 = root == null ? void 0 : root.getElementById("commandbar-menu__wrapper")) != null ? _a2 : null;
          const barWidth = (barElement == null ? void 0 : barElement.offsetWidth) || 0;
          setRenderType(barWidth > 575 ? "inline" : "popover");
        }
      });
      const reportPreviewEvent = (eventType, engagement) => {
        var _a2, _b2;
        const preview = {
          preview_type: (_b2 = (_a2 = props2 == null ? void 0 : props2.content) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.type,
          form_factor: renderType,
          id: previewEventID,
          source: {
            command: props2.optionMetadata.uid
          }
        };
        switch (eventType) {
          case "preview_engagement":
            if (!!engagement) {
              return previewEngagement({ ...preview }, engagement);
            }
            break;
          case "preview_shown":
            return previewShown({
              ...preview,
              time_shown: (Date.now() - startTime) / 1e3
            });
          case "next_step_selected":
            return nextStepSelected({ ...preview });
          case "preview_link_open":
            return previewLinkOpen({ ...preview });
          default:
            return;
        }
      };
      React241.useEffect(() => {
        const timerId = setTimeout(() => {
          if (props2.content.length > 0) {
            reportPreviewEvent("preview_shown");
          }
        }, 350);
        return () => {
          clearTimeout(timerId);
        };
      }, [props2.uid]);
      React241.useEffect(() => {
        var _a2, _b2;
        ((_a2 = props2.previewRef.current) == null ? void 0 : _a2.scrollTo) && ((_b2 = props2.previewRef.current) == null ? void 0 : _b2.scrollTo({ top: 0, behavior: "instant" }));
      }, [props2.uid]);
      const content = React241.useMemo(() => {
        const result = [];
        props2.content.forEach((_content, index3) => {
          const element = (() => {
            if (_content.position) {
              setRenderType(_content.position);
              setPositionSetByContent(true);
            } else {
              setPositionSetByContent(false);
            }
            switch (_content.type) {
              case "plaintext":
                return /* @__PURE__ */ React241.createElement(PlaintextPreview_default, { value: _content.value, key: `${index3}-${props2.uid}` });
              case "markdown":
                return /* @__PURE__ */ React241.createElement(MarkdownPreview_default, { value: _content.value, key: `${index3}-${props2.uid}` });
              case "html":
                if (_content.value.startsWith("{{") && _content.value.endsWith("}}")) {
                  return /* @__PURE__ */ React241.createElement(
                    HtmlPreview_default,
                    {
                      scrollContainerRef: props2.previewRef,
                      value: props2.optionData[_content.value.slice(2, -2)] || "",
                      key: `${index3}-${props2.uid}`,
                      title: props2.title
                    }
                  );
                } else {
                  return /* @__PURE__ */ React241.createElement(HtmlPreview_default, { value: _content.value, key: `${index3}-${props2.uid}` });
                }
              case "react":
                return /* @__PURE__ */ React241.createElement(ReactPreview_default, { value: _content.value, key: `${index3}-${props2.uid}` });
              case "video":
                return /* @__PURE__ */ React241.createElement(VideoContainer_default, { source: _content.value, key: `${index3}-${props2.uid}` });
              case "component":
                const component = _.components[_content.value];
                if (!component) {
                  Logger_default.warn(
                    `DetailPreview: Component not found: '${_content.value}' when rendering preview`,
                    JSON.parse(JSON.stringify(props2.optionData)),
                    // NOTE: JSON.stringify to de-proxyify the object
                    JSON.parse(JSON.stringify(props2.optionMetadata))
                    // NOTE: JSON.stringify to de-proxyify the object
                  );
                  return null;
                }
                return /* @__PURE__ */ React241.createElement(
                  RenderCustomComponent_default,
                  {
                    key: index3,
                    data: props2.optionData,
                    metadata: props2.optionMetadata,
                    component: component.component
                  }
                );
              default:
                throw new Error("Invalid content type");
            }
          })();
          if (element) {
            result.push(element);
          }
        });
        return result;
      }, [props2.content, props2.optionData, props2.optionMetadata]);
      if (!_.spotlight.visible || !shouldRenderPreview || !props2.shouldRenderChild && props2.content.length === 0 || renderType === "popover" && props2.content.length === 0) {
        return null;
      }
      const anchorClickHandler = () => reportPreviewEvent("preview_engagement", "clicked_link");
      const videoPlayHandler = () => reportPreviewEvent("preview_engagement", "watched_video");
      return /* @__PURE__ */ React241.createElement(EngagementTracking, { anchorClickHandler, videoPlayHandler }, renderType === "inline" ? /* @__PURE__ */ React241.createElement(
        InlinePreview,
        {
          contentContainerRef: props2.previewRef,
          reportPreviewEvent,
          content,
          title: props2.title,
          isMounted: props2.isMounted
        }
      ) : /* @__PURE__ */ React241.createElement(
        PreviewPopover,
        {
          contentContainerRef: props2.previewRef,
          content,
          title: props2.title,
          reportPreviewEvent,
          focusedIndex: props2.focusedIndex,
          pageLink: props2.pageLink
        }
      ));
    };
    DetailPreview_default = DetailPreview;
  }
});

// commandbar/src/products/spotlight/components/detailpreview/DetailPreviewContainer.tsx
import React242 from "react";
var DetailPreviewContainer, DetailPreviewContainer_default;
var init_DetailPreviewContainer = __esm({
  "commandbar/src/products/spotlight/components/detailpreview/DetailPreviewContainer.tsx"() {
    "use strict";
    init_useStore();
    init_useDelayUnmount();
    init_selectors3();
    init_Interpolate();
    init_DetailPreview();
    DetailPreviewContainer = ({ focusedOption, focusedIndex, detailPreview }) => {
      const _ = useStore();
      const previewRef = React242.useRef(null);
      const { label, optionData, optionMetadata } = React242.useMemo(() => {
        if (isOption(focusedOption) && !!detailPreview) {
          return {
            label: focusedOption.label,
            optionData: getOptionData(focusedOption),
            optionMetadata: getOptionMetadata(focusedOption)
          };
        } else {
          return { label: void 0, optionData: void 0, optionMetadata: void 0 };
        }
      }, [focusedOption]);
      const pageLink = React242.useMemo(() => {
        if (isCommandOption(focusedOption) && !!detailPreview) {
          if (focusedOption.command.template.type === "link" || focusedOption.command.template.type === "helpdoc") {
            return interpolate(focusedOption.command.template.value, _, true, true, false);
          }
        }
        return void 0;
      }, [focusedOption]);
      const [isMounted, setIsMounted] = React242.useState(false);
      const shouldRenderChild = useDelayUnmount(isMounted, 300);
      React242.useEffect(() => {
        if (focusedOption && !!detailPreview) {
          setIsMounted(true);
        } else {
          setIsMounted(false);
        }
      }, [focusedOption]);
      return /* @__PURE__ */ React242.createElement(React242.Fragment, null, shouldRenderChild && /* @__PURE__ */ React242.createElement(
        DetailPreview_default,
        {
          focusedIndex,
          shouldRenderChild,
          previewRef,
          content: detailPreview != null ? detailPreview : [],
          isMounted,
          optionData,
          optionMetadata,
          title: label,
          uid: optionMetadata == null ? void 0 : optionMetadata.uid,
          pageLink
        }
      ));
    };
    DetailPreviewContainer_default = DetailPreviewContainer;
  }
});

// commandbar/src/products/spotlight/components/select/menu/MenuWrapper.tsx
import { jsx as jsx88 } from "@emotion/core";
import React243, { useMemo as useMemo13 } from "react";
import { useTheme as useTheme24 } from "emotion-theming";
var MenuWrapper, MenuWrapper_default;
var init_MenuWrapper = __esm({
  "commandbar/src/products/spotlight/components/select/menu/MenuWrapper.tsx"() {
    "use strict";
    init_MenuList();
    init_useStore();
    init_selectors8();
    init_Step();
    init_operatingSystem();
    init_DefaultState();
    init_DetailPreviewContainer();
    init_selectors3();
    MenuWrapper = (props2) => {
      var _a2, _b2;
      const _ = useStore();
      const {
        categories,
        inputText,
        showLoadingIndicator,
        userDefinedCustomComponents,
        expandedGroupKeys,
        focusedIndex,
        sortedOptions
      } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const menuWrapperRef = React243.useRef(null);
      const { theme } = useTheme24();
      const displayCustomDefaultState = useMemo13(
        () => (currentStep == null ? void 0 : currentStep.type) === "base" && userDefinedCustomComponents.defaultState() && !inputText.length,
        [currentStep == null ? void 0 : currentStep.type, userDefinedCustomComponents.defaultState, inputText]
      );
      const focusedOption = sortedOptions[focusedIndex];
      if ((currentStep == null ? void 0 : currentStep.type) === "longtextinput" /* LongTextInput */) {
        return null;
      }
      const detailPreviewContent = !!focusedOption ? getDetailPreviewContent(_, focusedOption) : null;
      return /* @__PURE__ */ jsx88(
        "div",
        {
          id: "commandbar-menu__wrapper",
          style: {
            minHeight: ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? 0 : theme.bar.menuMinHeight,
            display: "flex",
            flexDirection: isMobileDevice() ? "column" : "row",
            position: "relative",
            overflowX: "hidden",
            ...isMobileDevice() && { flex: 1 },
            ...!!detailPreviewContent && {
              height: ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? "var(--spotlight-max-height)" : theme.bar.menuHeight
            }
          },
          ref: menuWrapperRef
        },
        /* @__PURE__ */ jsx88("div", { style: { height: "100%", flexGrow: 1 } }, displayCustomDefaultState ? /* @__PURE__ */ jsx88(DefaultState_default, null) : /* @__PURE__ */ jsx88(
          MenuList_default,
          {
            categories,
            sortedOptions,
            isLoading: showLoadingIndicator,
            focusedIndex,
            onOptionHover: props2.onOptionHover,
            expandedGroupKeys,
            menuWrapperRef
          }
        )),
        !isMobileDevice() ? /* @__PURE__ */ jsx88(
          DetailPreviewContainer_default,
          {
            focusedOption,
            focusedIndex,
            detailPreview: detailPreviewContent
          }
        ) : null
      );
    };
    MenuWrapper_default = MenuWrapper;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightFooter.tsx
import React244 from "react";
var Footer2, StyledFooter2, StyledSpotlightFooter_default;
var init_StyledSpotlightFooter = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightFooter.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Footer2 = styled_browser_esm_default.div`
  display: flex;
  width: 100%;
  padding: var(--layout-padding);
  justify-content: space-between;
  align-items: center;
  background: var(--background-primary);
  border-radius: 0px 0px var(--layout-radius-card) var(--layout-radius-card);
  border-top: 1px solid var(--form-control-border-color);
`;
    StyledFooter2 = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React244.createElement(Footer2, { ...props2 }, children);
    };
    StyledSpotlightFooter_default = StyledFooter2;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightFooterHotkey.tsx
import { css as css57, jsx as jsx89 } from "@emotion/core";
var styles42, StyledSpotlightFooterHotkey, StyledSpotlightFooterHotkey_default;
var init_StyledSpotlightFooterHotkey = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightFooterHotkey.tsx"() {
    "use strict";
    styles42 = css57({
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      gap: "4px",
      color: "var(--content-secondary)",
      /* label/sm/semibold */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-small)",
      fontWeight: "var(--font-weight-semibold)",
      lineHeight: "var(--font-line-height-normal)"
    });
    StyledSpotlightFooterHotkey = ({ children, ...props2 }) => {
      return /* @__PURE__ */ jsx89("div", { css: styles42, ...props2 }, children);
    };
    StyledSpotlightFooterHotkey_default = StyledSpotlightFooterHotkey;
  }
});

// commandbar/src/products/spotlight/components/select/footer/Footer.tsx
import { jsx as jsx90 } from "@emotion/core";
import * as React245 from "react";
import chroma18 from "chroma-js";
import { useTheme as useTheme25 } from "emotion-theming";
var Footer3, Footer_default;
var init_Footer = __esm({
  "commandbar/src/products/spotlight/components/select/footer/Footer.tsx"() {
    "use strict";
    init_Tooltip();
    init_operatingSystem();
    init_Tag();
    init_HotkeyTag();
    init_languages();
    init_useStore();
    init_selectors8();
    init_selectors3();
    init_RenderCustomComponent();
    init_StyledPoweredBy();
    init_PoweredBy();
    init_StyledSpotlightFooter();
    init_StyledSpotlightFooterHotkey();
    init_branding();
    init_react();
    Footer3 = () => {
      var _a2, _b2, _c2;
      const { theme } = useTheme25();
      const _ = useStore();
      const organization = _.organization;
      const { userDefinedCustomComponents } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const summonHotkey = selectSummonHotkey(useStore());
      const styles51 = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingTop: theme.footer.paddingTop,
        paddingBottom: theme.footer.paddingBottom,
        paddingLeft: theme.footer.paddingLeft,
        paddingRight: theme.footer.paddingRight,
        borderTop: theme.footer.borderTop,
        background: theme.footer.background,
        borderRadius: `0px 0px ${theme.main.borderRadius} ${theme.main.borderRadius}`
      };
      const customBetaTag = (organization == null ? void 0 : organization.id) === "31faae81" ? /* @__PURE__ */ jsx90(Tag_default, { color: chroma18("#5289b7"), style: { marginLeft: 12 } }, "Beta") : null;
      if (!organization) {
        return null;
      }
      const component = (currentStep == null ? void 0 : currentStep.type) !== "execute" && userDefinedCustomComponents.footer({ step: currentStep == null ? void 0 : currentStep.type });
      if (typeof component === "string") {
        return /* @__PURE__ */ jsx90("div", { style: { position: "relative" } }, /* @__PURE__ */ jsx90(
          "div",
          {
            dangerouslySetInnerHTML: {
              __html: component
            }
          }
        ));
      } else if (component) {
        return /* @__PURE__ */ jsx90(RenderCustomComponent_default, { component });
      }
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx90(StyledSpotlightFooter_default, { style: { justifyContent: ((_b2 = _.organization) == null ? void 0 : _b2.branding) === "branded" ? "space-between" : "end" } }, ((_c2 = _.organization) == null ? void 0 : _c2.branding) === "branded" && /* @__PURE__ */ jsx90(
        StyledPoweredBy_default,
        {
          onClick: () => navigateToBrandingSite(_.organization),
          text: translate("Powered by Command AI")
        }
      ), /* @__PURE__ */ jsx90("div", { style: { display: "flex", alignItems: "center", gap: "8px" } }, !isMobileDevice() && /* @__PURE__ */ jsx90(React245.Fragment, null, /* @__PURE__ */ jsx90(StyledSpotlightFooterHotkey_default, null, /* @__PURE__ */ jsx90(SwitchVertical02_default, null), "Navigate"), /* @__PURE__ */ jsx90(StyledSpotlightFooterHotkey_default, null, /* @__PURE__ */ jsx90(CornerDownLeft_default, null), "Select"), /* @__PURE__ */ jsx90(StyledSpotlightFooterHotkey_default, null, /* @__PURE__ */ jsx90("span", null, "ESC"), "Return")), customBetaTag, !isTouchDevice() && !!summonHotkey && /* @__PURE__ */ jsx90(
        Tooltip_default,
        {
          trigger: ["hover", "focus"],
          overlay: summonHotkey === "mod+k" ? /* @__PURE__ */ jsx90("span", null, translate(`Type ${osControlKey()}K to open and close`)) : /* @__PURE__ */ jsx90("span", null, /* @__PURE__ */ jsx90("span", null, "Type "), /* @__PURE__ */ jsx90(HotkeyTag_default, { combo: summonHotkey }), /* @__PURE__ */ jsx90("span", null, " to open and close")),
          placement: "bottom"
        },
        /* @__PURE__ */ jsx90(StyledSpotlightFooterHotkey_default, null, /* @__PURE__ */ jsx90(HotkeyTag_default, { key: summonHotkey, combo: summonHotkey }))
      ))) : /* @__PURE__ */ jsx90("div", { role: "contentinfo", style: { position: "relative" } }, /* @__PURE__ */ jsx90("div", { style: styles51 }, /* @__PURE__ */ jsx90("div", { style: { display: "flex", alignItems: "center", width: "100%" } }, /* @__PURE__ */ jsx90(PoweredBy_default, { style: { color: theme.main.color, opacity: 0.7 } }), /* @__PURE__ */ jsx90("div", { style: { flexGrow: 1 } }), /* @__PURE__ */ jsx90("span", { style: { width: 10 } }), customBetaTag, !isTouchDevice() && !!summonHotkey && /* @__PURE__ */ jsx90(React245.Fragment, null, /* @__PURE__ */ jsx90(
        Tooltip_default,
        {
          trigger: ["hover", "focus"],
          overlay: summonHotkey === "mod+k" ? /* @__PURE__ */ jsx90("span", { style: { fontFamily: theme.main.fontFamily } }, translate(`Type ${osControlKey()}+K to open and close`)) : /* @__PURE__ */ jsx90("span", { style: { fontFamily: theme.main.fontFamily } }, /* @__PURE__ */ jsx90("span", null, "Type "), /* @__PURE__ */ jsx90(HotkeyTag_default, { combo: summonHotkey }), /* @__PURE__ */ jsx90("span", null, " to open and close")),
          placement: "bottom"
        },
        /* @__PURE__ */ jsx90(
          "div",
          {
            tabIndex: 0,
            "aria-label": "press-command-k-to-open-and-close",
            style: {
              display: "flex",
              alignItems: "center",
              cursor: "default",
              marginLeft: 13
            }
          },
          /* @__PURE__ */ jsx90(HotkeyTag_default, { key: summonHotkey, combo: summonHotkey })
        )
      )))));
    };
    Footer_default = Footer3;
  }
});

// internal/src/util/useVisualViewportSize.tsx
import React246 from "react";
var useVisualViewportSize, useVisualViewportSize_default;
var init_useVisualViewportSize = __esm({
  "internal/src/util/useVisualViewportSize.tsx"() {
    "use strict";
    useVisualViewportSize = () => {
      const getSize = () => {
        var _a2, _b2, _c2, _d;
        return {
          width: (_b2 = (_a2 = window.visualViewport) == null ? void 0 : _a2.width) != null ? _b2 : window.innerWidth,
          height: (_d = (_c2 = window.visualViewport) == null ? void 0 : _c2.height) != null ? _d : window.innerHeight
        };
      };
      const [windowSize, setWindowSize] = React246.useState(getSize);
      React246.useEffect(() => {
        const handleResize = () => {
          setWindowSize(getSize());
        };
        if (window.visualViewport) {
          window.visualViewport.addEventListener("resize", handleResize);
        }
        return () => {
          if (window.visualViewport) {
            window.visualViewport.removeEventListener("resize", handleResize);
          }
        };
      }, []);
      return windowSize;
    };
    useVisualViewportSize_default = useVisualViewportSize;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlight.tsx
import { css as css58, jsx as jsx91 } from "@emotion/core";
var styles43, inlineStyles2, StyledSpotlight, StyledSpotlight_default;
var init_StyledSpotlight = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlight.tsx"() {
    "use strict";
    styles43 = css58({
      display: "flex",
      width: "var(--spotlight-width)",
      flexDirection: "column",
      borderRadius: "0px 0px var(--layout-radius-card) var(--layout-radius-card)",
      overflow: "hidden",
      border: "1px solid var(--border-primary)",
      background: "var(--background-primary)",
      maxWidth: "95vw"
    });
    inlineStyles2 = css58({
      borderRadius: "var(--layout-radius-card)",
      marginTop: "var(--layout-gap)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)",
      width: "100%"
    });
    StyledSpotlight = ({ isInlineBar, children, ...props2 }) => {
      return /* @__PURE__ */ jsx91("div", { css: [styles43, isInlineBar && inlineStyles2], ...props2 }, children);
    };
    StyledSpotlight_default = StyledSpotlight;
  }
});

// commandbar/src/products/spotlight/components/select/HeightAdjustableContainer.tsx
import React247, { useMemo as useMemo14 } from "react";
import { useTheme as useTheme26 } from "emotion-theming";
var MOBILE_TOP_MARGIN_PORTRAIT, MOBILE_TOP_MARGIN_LANDSCAPE, HeightAdjustableContainer;
var init_HeightAdjustableContainer = __esm({
  "commandbar/src/products/spotlight/components/select/HeightAdjustableContainer.tsx"() {
    "use strict";
    init_useWindowSize();
    init_useVisualViewportSize();
    init_operatingSystem();
    init_useStore();
    init_StyledSpotlight();
    init_AnimatedWidget();
    MOBILE_TOP_MARGIN_PORTRAIT = 54;
    MOBILE_TOP_MARGIN_LANDSCAPE = 8;
    HeightAdjustableContainer = ({ children, controlWrapperHeight = 0 }) => {
      var _a2;
      const { theme } = useTheme26();
      const _ = useStore();
      const { height: windowHeight, width: windowWidth } = useWindowSize_default();
      const { height: visualViewportHeight } = useVisualViewportSize_default();
      const { animStyles } = useAnimatedWidget();
      const height = useMemo14(() => {
        if (isMobileDevice()) {
          const deviceHeight = Math.max(windowHeight, visualViewportHeight);
          const mobileTopMargin = deviceHeight > windowWidth ? MOBILE_TOP_MARGIN_PORTRAIT : MOBILE_TOP_MARGIN_LANDSCAPE;
          const finalTopMargin = window._cbIsWebView ? 0 : mobileTopMargin;
          return `${deviceHeight - controlWrapperHeight - finalTopMargin}px`;
        }
        return "auto";
      }, [windowHeight, windowWidth, controlWrapperHeight, visualViewportHeight]);
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React247.createElement(
        StyledSpotlight_default,
        {
          isInlineBar: _.spotlight.formFactor.type === "inline",
          className: "commandbar-content-container",
          style: {
            height,
            // TODO: Remove animation entirely when the themesv2 animation is released
            ...isMobileDevice() && !_.flags["release-widget-animations"] ? { transition: "height .2s ease-in", width: "100%" } : {},
            // In a modal form factor, the styles are applied at a higher level, so we should only apply them here when working with an inline bar
            ..._.spotlight.formFactor.type === "inline" ? { ...animStyles, transformOrigin: "top" } : {}
          }
        },
        children
      ) : /* @__PURE__ */ React247.createElement(
        "div",
        {
          className: "commandbar-content-container",
          style: {
            height,
            overflow: "hidden",
            border: theme.menu.border,
            borderRadius: theme.menu.borderRadius,
            marginTop: theme.menu.marginTop,
            display: "flex",
            flexDirection: "column",
            background: theme.menu.background,
            transition: isMobileDevice() ? "height .2s ease-in" : "unset"
          }
        },
        children
      );
    };
  }
});

// commandbar/src/products/spotlight/components/select/TabDescription.tsx
import React248 from "react";
import { useTheme as useTheme27 } from "emotion-theming";
var TabDescription, TabDescription_default;
var init_TabDescription = __esm({
  "commandbar/src/products/spotlight/components/select/TabDescription.tsx"() {
    "use strict";
    init_sanitizeHtml();
    init_useStore();
    init_selectors3();
    init_markdown();
    TabDescription = () => {
      const currentTab = selectCurrentTab(useStore());
      const { theme } = useTheme27();
      if (currentTab && !!currentTab.description) {
        return /* @__PURE__ */ React248.createElement(
          "div",
          {
            style: {
              color: theme.base.fontColor,
              fontSize: theme.searchTabDescription.fontSize,
              fontFamily: theme.base.fontFamily,
              background: theme.base.background,
              padding: theme.searchTabDescription.padding
            },
            dangerouslySetInnerHTML: { __html: sanitizeHtml_default(toHtml(currentTab.description)) }
          }
        );
      }
      return null;
    };
    TabDescription_default = TabDescription;
  }
});

// commandbar/src/products/spotlight/components/select/CustomMenuHeader.tsx
import React249 from "react";
var CustomMenuHeader, CustomMenuHeader_default;
var init_CustomMenuHeader = __esm({
  "commandbar/src/products/spotlight/components/select/CustomMenuHeader.tsx"() {
    "use strict";
    init_selectors8();
    init_useStore();
    init_selectors3();
    init_RenderCustomComponent();
    CustomMenuHeader = () => {
      const _ = useStore();
      const { userDefinedCustomComponents, searchFilter } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const tabGroups = selectSearchTabs(_, false);
      const activeTabGroup = tabGroups.find((tabGroup) => tabGroup.key === (searchFilter == null ? void 0 : searchFilter.slug));
      const activeTabGroupName = (activeTabGroup == null ? void 0 : activeTabGroup.searchTabName) || (activeTabGroup == null ? void 0 : activeTabGroup.name);
      const component = (currentStep == null ? void 0 : currentStep.type) !== "execute" && userDefinedCustomComponents.menuHeader({ step: currentStep == null ? void 0 : currentStep.type, activeTab: activeTabGroupName });
      if (typeof component === "string") {
        return /* @__PURE__ */ React249.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React249.createElement("div", { dangerouslySetInnerHTML: { __html: component } }));
      } else if (component) {
        return /* @__PURE__ */ React249.createElement(RenderCustomComponent_default, { component });
      }
      return null;
    };
    CustomMenuHeader_default = CustomMenuHeader;
  }
});

// commandbar/src/products/spotlight/components/select/CustomTabHeader.tsx
import React250 from "react";
var CustomTabHeader, CustomTabHeader_default;
var init_CustomTabHeader = __esm({
  "commandbar/src/products/spotlight/components/select/CustomTabHeader.tsx"() {
    "use strict";
    init_selectors8();
    init_useStore();
    init_RenderCustomComponent();
    CustomTabHeader = () => {
      const _ = useStore();
      const { userDefinedCustomComponents } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const component = (currentStep == null ? void 0 : currentStep.type) !== "execute" && userDefinedCustomComponents.tabHeader({ step: currentStep == null ? void 0 : currentStep.type });
      if (typeof component === "string") {
        return /* @__PURE__ */ React250.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React250.createElement("div", { dangerouslySetInnerHTML: { __html: component } }));
      } else if (component) {
        return /* @__PURE__ */ React250.createElement(RenderCustomComponent_default, { component });
      }
      return null;
    };
    CustomTabHeader_default = CustomTabHeader;
  }
});

// internal/src/client/themesV2/components/spotlight/StyledSpotlightWrapper.tsx
import React251 from "react";
var InlineWrapper, Wrapper, StyledSpotlightWrapper, StyledSpotlightWrapper_default;
var init_StyledSpotlightWrapper = __esm({
  "internal/src/client/themesV2/components/spotlight/StyledSpotlightWrapper.tsx"() {
    "use strict";
    init_styled_browser_esm();
    InlineWrapper = styled_browser_esm_default.div`
  width: 100%;
`;
    Wrapper = styled_browser_esm_default(InlineWrapper)`
  border-radius: var(--layout-radius-card);
  box-shadow: var(--layout-shadow) var(--layout-shadow-color);
`;
    StyledSpotlightWrapper = React251.forwardRef(
      ({ isInlineBar, children, ...props2 }, ref12) => isInlineBar ? /* @__PURE__ */ React251.createElement(InlineWrapper, { ref: ref12, ...props2 }, children) : /* @__PURE__ */ React251.createElement(Wrapper, { ref: ref12, ...props2 }, children)
    );
    StyledSpotlightWrapper_default = StyledSpotlightWrapper;
  }
});

// commandbar/src/products/spotlight/components/select/CommandSelect.tsx
import { jsx as jsx92 } from "@emotion/core";
import React252 from "react";
import { useTheme as useTheme28 } from "emotion-theming";
var CommandMenu, CommandSelect, CommandSelect_default;
var init_CommandSelect = __esm({
  "commandbar/src/products/spotlight/components/select/CommandSelect.tsx"() {
    "use strict";
    init_selectors8();
    init_Control();
    init_operatingSystem();
    init_MenuWrapper();
    init_useStore();
    init_useAction();
    init_actions9();
    init_global_actions();
    init_selectors3();
    init_EditorDashboard();
    init_SearchTabs();
    init_Step();
    init_Footer();
    init_useResizeObserver();
    init_HeightAdjustableContainer();
    init_TabDescription();
    init_useCommandBarContainer();
    init_CustomMenuHeader();
    init_CustomTabHeader();
    init_location();
    init_StyledSpotlightWrapper();
    init_AnimatedWidget();
    CommandMenu = ({ controlWrapperHeight, currentStep, onOptionHover, menuIsOpen }) => {
      var _a2;
      const _ = useStore();
      const content = /* @__PURE__ */ jsx92(HeightAdjustableContainer, { controlWrapperHeight }, /* @__PURE__ */ jsx92(CustomTabHeader_default, null), (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && !(currentStep == null ? void 0 : currentStep.resource) && !(((_a2 = _.organization) == null ? void 0 : _a2.tab_direction) === "vertical") && /* @__PURE__ */ jsx92(SearchTabs_default, { direction: "horizontal" }), /* @__PURE__ */ jsx92(TabDescription_default, null), /* @__PURE__ */ jsx92(CustomMenuHeader_default, null), /* @__PURE__ */ jsx92(MenuWrapper_default, { onOptionHover }), /* @__PURE__ */ jsx92(Footer_default, null));
      if (_.spotlight.formFactor.type === "inline") {
        return /* @__PURE__ */ jsx92(AnimatedWidget, { widget: "spotlight", isMounted: menuIsOpen }, menuIsOpen ? content : null);
      }
      return menuIsOpen ? content : null;
    };
    CommandSelect = (props2, ref12) => {
      var _a2, _b2;
      const { root } = useCommandBarContainer();
      const handleInputChange2 = useAction(handleInputChange);
      const selectCurrentOption2 = useAction(selectCurrentOption);
      const _ = useStore();
      const { currentStep } = currentStepAndIndex(_);
      const inputRef = React252.useRef();
      const controlWrapperRef = React252.useRef(null);
      const setControlWrapperRef = React252.useCallback((element) => {
        if (element) {
          controlWrapperRef.current = element;
        }
      }, []);
      const { theme } = useTheme28();
      const blockOptionHoverRef = React252.useRef(false);
      const controlKey = React252.useMemo(osControlKey, []);
      const inlineFormFactor = _.spotlight.formFactor.type === "inline";
      const menuIsOpen = selectMenuIsOpen(useStore());
      const editorDashboards = getEditorDashboards(theme.main.background);
      const focusInput = React252.useCallback(() => {
        var _a3, _b3, _c2;
        if (((_b3 = (_a3 = root == null ? void 0 : root.activeElement) == null ? void 0 : _a3.classList) == null ? void 0 : _b3.contains("commandbar__system_panel")) || ((_c2 = root == null ? void 0 : root.activeElement) == null ? void 0 : _c2.id) === "commandbar-editor") {
          return;
        }
        setTimeout(() => {
          var _a4;
          return (_a4 = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a4.focus();
        }, 0);
      }, [inputRef]);
      const blurInput = React252.useCallback(() => {
        var _a3;
        (_a3 = inputRef == null ? void 0 : inputRef.current) == null ? void 0 : _a3.blur();
      }, [inputRef]);
      React252.useImperativeHandle(ref12, () => ({
        onInputChange: handleInputChange2,
        selectCurrentOption: selectCurrentOption2,
        focus: focusInput,
        blur: blurInput
      }));
      const { height: controlWrapperHeight } = useResizeObserver_default(controlWrapperRef.current);
      React252.useEffect(() => {
        if (isStudioPreview())
          return;
        if (!isMobileDevice() && (!inlineFormFactor || menuIsOpen)) {
          focusInput();
        }
      });
      const onKeyDown = useAction(
        (_2, e) => {
          var _a3;
          const { currentStep: currentStep2 } = currentStepAndIndex(_2);
          if (_2.spotlight.focusedIndex === -1) {
            return;
          }
          if ((currentStep2 == null ? void 0 : currentStep2.type) === "longtextinput" /* LongTextInput */) {
            if (e.key === "Enter" && getTriggerKey(e)) {
              submitLongTextInput(_2, _2.spotlight.inputText);
              e.stopPropagation();
              e.preventDefault();
            }
            return;
          }
          blockOptionHoverRef.current = true;
          if (e.key === "ArrowDown") {
            changeFocus(_2, "down");
            e.stopPropagation();
            e.preventDefault();
          }
          if (e.key === "ArrowUp") {
            changeFocus(_2, "up");
            e.stopPropagation();
            e.preventDefault();
          }
          if (e.key === "ArrowRight") {
            if (currentOptionHasArguments(_2)) {
              selectCurrentOption(_2);
              e.stopPropagation();
              e.preventDefault();
            } else {
              applySlashFilter();
            }
          }
          if (e.key === "Enter") {
            if (!!getTriggerKey(e) && ((_a3 = currentStepAndIndex(_2).currentStep) == null ? void 0 : _a3.type) === "multiselect" /* MultiSelect */) {
              submitMultiSelect(_2);
              e.preventDefault();
              e.stopPropagation();
            } else if (_2.spotlight.focusableChildIndex > -1) {
              maintainChildFocus(_2);
              return;
            } else if (tryOpenEditor(_2)) {
              e.stopPropagation();
              e.preventDefault();
            } else {
              selectCurrentOption(_2, e);
              e.stopPropagation();
              e.preventDefault();
            }
          }
          if (e.key === "n" && e.ctrlKey && controlKey.toLowerCase() !== "ctrl") {
            changeFocus(_2, "down");
            e.stopPropagation();
            e.preventDefault();
          }
          if (e.key === "p" && e.ctrlKey && controlKey.toLowerCase() !== "ctrl") {
            changeFocus(_2, "up");
            e.stopPropagation();
            e.preventDefault();
          }
          if (e.key === "Tab") {
            if (applySlashFilter()) {
              return;
            }
            if (e.getModifierState("Shift")) {
              if (changeFocusWithTab(_2, "up")) {
                return;
              }
            } else {
              if (changeFocusWithTab(_2, "tab")) {
                return;
              }
            }
            e.stopPropagation();
            e.preventDefault();
          }
          if (e.key === "Home") {
            e.stopPropagation();
            e.preventDefault();
            if (e.target instanceof HTMLInputElement) {
              if (e.shiftKey) {
                e.target.selectionStart = 0;
              } else {
                e.target.setSelectionRange(0, 0);
              }
            }
          }
          if (e.key === "End") {
            e.stopPropagation();
            e.preventDefault();
            if (e.target instanceof HTMLInputElement) {
              const len = e.target.value.length;
              if (e.shiftKey) {
                e.target.selectionEnd = len;
              } else {
                e.target.setSelectionRange(len, len);
              }
            }
          }
          handleKeyDown(_2, e);
          function applySlashFilter() {
            if (e.target instanceof HTMLInputElement) {
              const caretIsAtTextEnd = (() => {
                const isNonSelectableType = e.target.selectionEnd === null;
                const caretIsAtTextEnd2 = isNonSelectableType || e.target.selectionEnd === e.target.value.length;
                return caretIsAtTextEnd2;
              })();
              if (caretIsAtTextEnd) {
                const hint = selectSlashFilterHint(_2);
                if (hint !== "") {
                  handleInputChange(_2, _2.spotlight.rawInput + hint);
                  e.preventDefault();
                  e.stopPropagation();
                  return true;
                }
              }
            }
            return false;
          }
        },
        [blockOptionHoverRef, editorDashboards]
      );
      const onOptionHover = useAction(
        (_2, optionIndex) => {
          if (blockOptionHoverRef.current) {
            blockOptionHoverRef.current = false;
            return;
          }
          if (optionIndex === _2.spotlight.focusedIndex) {
            return;
          }
          _2.spotlight.focusedIndex = optionIndex;
        },
        [blockOptionHoverRef]
      );
      const closeBarAndReset2 = useAction(closeBarAndReset);
      const handleEscape = useAction((_2) => {
        rollback(_2);
        handleInputChange(_2, "");
      });
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx92(
        StyledSpotlightWrapper_default,
        {
          onKeyUpCapture: (e) => {
            if (e.key !== "Escape")
              return;
            e.stopPropagation();
            const { currentStepIndex } = currentStepAndIndex(_);
            const lastStep = selectLastStep(_);
            if (currentStepIndex === 0) {
              closeBarAndReset2();
            } else if (lastStep.type === "execute" && lastStep.triggeredByShortcut) {
              closeBarAndReset2();
            } else {
              handleEscape();
            }
          },
          onKeyDownCapture: (e) => {
            if (e.key === "Escape") {
              e.stopPropagation();
            }
          },
          onKeyDown,
          isInlineBar: inlineFormFactor,
          style: { ...isMobileDevice() && { width: "100%" } }
        },
        /* @__PURE__ */ jsx92(Control_default, { inputRef, setControlWrapperRef }),
        /* @__PURE__ */ jsx92(
          CommandMenu,
          {
            controlWrapperHeight,
            currentStep,
            onOptionHover,
            menuIsOpen
          }
        )
      ) : (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        /* @__PURE__ */ jsx92(
          "div",
          {
            style: { width: "100%" },
            onKeyPressCapture: (e) => {
              if (e.key !== "Escape")
                return;
              e.stopPropagation();
            },
            onKeyUpCapture: (e) => {
              if (e.key !== "Escape")
                return;
              e.stopPropagation();
              const { currentStepIndex } = currentStepAndIndex(_);
              const lastStep = selectLastStep(_);
              if (currentStepIndex === 0) {
                closeBarAndReset2();
              } else if (lastStep.type === "execute" && lastStep.triggeredByShortcut) {
                closeBarAndReset2();
              } else {
                handleEscape();
              }
            },
            onKeyDownCapture: (e) => {
              if (e.key === "Escape") {
                e.stopPropagation();
              }
            },
            onKeyDown
          },
          /* @__PURE__ */ jsx92(Control_default, { inputRef, setControlWrapperRef }),
          menuIsOpen ? /* @__PURE__ */ jsx92(HeightAdjustableContainer, { controlWrapperHeight }, /* @__PURE__ */ jsx92(CustomTabHeader_default, null), (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && !(currentStep == null ? void 0 : currentStep.resource) && !(((_b2 = _.organization) == null ? void 0 : _b2.tab_direction) === "vertical") && /* @__PURE__ */ jsx92(SearchTabs_default, { direction: "horizontal" }), /* @__PURE__ */ jsx92(TabDescription_default, null), /* @__PURE__ */ jsx92(CustomMenuHeader_default, null), /* @__PURE__ */ jsx92(MenuWrapper_default, { onOptionHover }), /* @__PURE__ */ jsx92(Footer_default, null)) : null
        )
      );
    };
    CommandSelect_default = React252.forwardRef(CommandSelect);
  }
});

// commandbar/src/products/spotlight/components/RightSidePane.tsx
import { jsx as jsx93 } from "@emotion/core";
import { AiOutlineClose as AiOutlineClose4 } from "react-icons/ai";
var RightSidePane, RightSidePane_default, headerStyle, rowStyle, SearchBar;
var init_RightSidePane = __esm({
  "commandbar/src/products/spotlight/components/RightSidePane.tsx"() {
    "use strict";
    init_es2();
    init_Z();
    init_useStore();
    init_useAction();
    init_useTheme();
    init_ThemeV2Context();
    RightSidePane = (props2) => {
      var _a2;
      const { theme } = useTheme();
      const themeV2Context = useThemeV2Context();
      const onClose = useAction((_) => {
        _.spotlight.showKeyboardShortcutCheatsheet = false;
      });
      const { showKeyboardShortcutCheatsheet } = useStore().spotlight;
      let container = false;
      if (document.getElementById("commandbar-wrapper") !== null) {
        container = (_a2 = document.getElementById("commandbar-wrapper")) != null ? _a2 : false;
      }
      return /* @__PURE__ */ jsx93(
        es_default2,
        {
          visible: showKeyboardShortcutCheatsheet,
          closable: false,
          destroyOnClose: true,
          maskStyle: { backgroundColor: "rgba(0,0,0,0.15)" },
          bodyStyle: {
            backgroundColor: theme.main.background,
            color: theme.main.color,
            height: "100vh",
            width: "375px",
            padding: "32px 40px 32px 32px"
          },
          wrapClassName: `commandbar-keboardcheatsheet ${themeV2Context.generatedCSSClassname}`,
          style: {
            fontFamily: theme.main.fontFamily,
            width: "375px",
            margin: "0px 0px 0px auto"
          },
          zIndex: Z_default.Z_KEYBOARD_SHORTCUTS,
          getContainer: container,
          mask: true,
          maskClosable: true,
          onClose
        },
        /* @__PURE__ */ jsx93("div", { style: { display: "flex", flexDirection: "column", height: "100%" } }, /* @__PURE__ */ jsx93(
          AiOutlineClose4,
          {
            style: { position: "absolute", top: 12, right: 12, fontSize: 14, cursor: "pointer", color: theme.main.color },
            onClick: onClose
          }
        ), props2.children)
      );
    };
    RightSidePane_default = RightSidePane;
    headerStyle = {
      marginTop: 24,
      fontSize: 16,
      fontWeight: 500,
      borderBottom: "1px solid #c1c7cd",
      padding: "0 0 8px 2px"
    };
    rowStyle = {
      fontSize: 14,
      borderBottom: "1px solid grey",
      display: "flex",
      justifyContent: "space-between",
      padding: "6px",
      alignItems: "center"
    };
    SearchBar = (props2) => {
      const { theme } = useTheme();
      return /* @__PURE__ */ jsx93(
        "input",
        {
          type: "text",
          name: "search",
          value: props2.searchTerm,
          onChange: props2.onSearch,
          onFocus: props2.onFocus,
          onBlur: props2.onBlur,
          placeholder: "Search...",
          autoComplete: "off",
          autoFocus: true,
          css: {
            width: "100%",
            color: theme.main.color,
            backgroundColor: "transparent",
            border: `1px solid ${theme.base.primary}`,
            borderRadius: 4,
            padding: 6,
            fontSize: 14,
            "&:focus": {
              outline: "none"
            }
          }
        }
      );
    };
  }
});

// commandbar/src/products/spotlight/components/KeyboardShortcutCheatsheet.tsx
import React253 from "react";
import { jsx as jsx94 } from "@emotion/core";
var escapeRegExp, getHighlightedText, KeyboardShortcutCheatsheet, KeyboardShortcutCheatsheet_default;
var init_KeyboardShortcutCheatsheet = __esm({
  "commandbar/src/products/spotlight/components/KeyboardShortcutCheatsheet.tsx"() {
    "use strict";
    init_HotkeyTag();
    init_RightSidePane();
    init_useStore();
    init_useAction();
    init_Available();
    init_selectors3();
    escapeRegExp = (str) => {
      return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };
    getHighlightedText = (text, highlight, isInputFocused) => {
      const parts = text.split(new RegExp(`(${escapeRegExp(highlight)})`, "gi"));
      if (!isInputFocused) {
        return parts.map((part, index3) => /* @__PURE__ */ jsx94("span", { key: `part-${part}-${index3}`, style: { opacity: 1 } }, part));
      }
      return parts.map(
        (part, index3) => part.toLowerCase() === highlight.toLowerCase() ? /* @__PURE__ */ jsx94("span", { key: `part-${part}-${index3}`, style: { opacity: 1 } }, part) : /* @__PURE__ */ jsx94("span", { key: `part-${part}-${index3}`, style: { opacity: 0.7 } }, part)
      );
    };
    KeyboardShortcutCheatsheet = () => {
      const _ = useStore();
      const { categories, showKeyboardShortcutCheatsheet: visible } = _.spotlight;
      const commands = React253.useMemo(() => availableCommands(_).map((c) => c.command), [_]);
      const summonHotkey = selectSummonHotkey(useStore());
      const setVisible2 = useAction((_2, _visible) => {
        _2.spotlight.showKeyboardShortcutCheatsheet = _visible;
      });
      const [searchTerm, setSearchTerm] = React253.useState("");
      const [isInputFocused, setIsInputFocused] = React253.useState(false);
      const handleInputFocus = () => {
        setIsInputFocused(true);
      };
      const handleInputBlur = () => {
        setIsInputFocused(false);
      };
      const onSearch = (e) => {
        setSearchTerm(e.target.value);
      };
      const handleKeydown = (e) => {
        if (e.key === "Escape") {
          setVisible2(false);
        }
      };
      React253.useEffect(() => {
        if (visible) {
          document.addEventListener("keydown", handleKeydown);
        } else {
          document.removeEventListener("keydown", handleKeydown);
        }
        return () => {
          document.removeEventListener("keydown", handleKeydown);
        };
      }, [visible]);
      const filteredCommands = commands.filter((command) => {
        if (command === void 0) {
          return false;
        }
        const search3 = searchTerm.toLowerCase();
        let hasShortcut = false;
        if (["mac"].includes(_.platform)) {
          hasShortcut = command.hotkey_mac.length > 0;
        } else if (["windows", "linux"].includes(_.platform)) {
          hasShortcut = command.hotkey_win.length > 0;
        }
        const commandMatchesSearch = search3 === "" || command.text.toLowerCase().includes(search3);
        const matchedCategories = categories.filter((category) => {
          return search3 === "" || category.name.toLowerCase().includes(search3);
        }).map((category) => {
          return category.id;
        });
        const categoryMatchesSearch = command.category !== null && matchedCategories.includes(command.category);
        return command.is_live && (hasShortcut && commandMatchesSearch || hasShortcut && categoryMatchesSearch);
      });
      const otherCommands = filteredCommands.filter((command) => {
        return command.category === null;
      });
      const commandBarRow = /* @__PURE__ */ jsx94("div", { key: `command-bar-shortcut`, style: rowStyle }, /* @__PURE__ */ jsx94("div", null, getHighlightedText("Open Command Bar", searchTerm, isInputFocused)), /* @__PURE__ */ jsx94("div", null, /* @__PURE__ */ jsx94(HotkeyTag_default, { combo: summonHotkey })));
      const showSearchBar = true;
      return /* @__PURE__ */ jsx94(RightSidePane_default, null, /* @__PURE__ */ jsx94("div", { style: { fontWeight: 500, fontSize: 20, display: "flex" } }, "Keyboard Shortcuts"), showSearchBar && /* @__PURE__ */ jsx94("div", { style: { marginTop: 15 } }, /* @__PURE__ */ jsx94(SearchBar, { searchTerm, onSearch, onFocus: handleInputFocus, onBlur: handleInputBlur })), /* @__PURE__ */ jsx94("div", { style: { flexGrow: 1, overflowY: "scroll" } }, /* @__PURE__ */ jsx94("br", null), commandBarRow, categories.map((category) => {
        const thisCategoryCommands = filteredCommands.filter((command) => {
          return command.category === category.id;
        });
        if (thisCategoryCommands.length === 0) {
          return null;
        }
        return /* @__PURE__ */ jsx94("div", { key: `category-${category.id}` }, /* @__PURE__ */ jsx94("div", { style: headerStyle }, category.name), thisCategoryCommands.map((command) => {
          let keys = "";
          if (["mac"].includes(_.platform)) {
            keys = command.hotkey_mac;
          } else if (["windows", "linux"].includes(_.platform)) {
            keys = command.hotkey_win;
          }
          return /* @__PURE__ */ jsx94("div", { key: `category-${category.id}-command-${command.id}`, style: { ...rowStyle } }, /* @__PURE__ */ jsx94("div", null, getHighlightedText(command.text, searchTerm, isInputFocused)), /* @__PURE__ */ jsx94("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ jsx94(HotkeyTag_default, { combo: keys })));
        }));
      }), otherCommands.length === 0 ? null : /* @__PURE__ */ jsx94("div", null, categories.length > 0 ? /* @__PURE__ */ jsx94("div", { style: headerStyle }, "other") : /* @__PURE__ */ jsx94("br", null), otherCommands.map((command) => {
        let keys = "";
        if (["mac"].includes(_.platform)) {
          keys = command.hotkey_mac;
        } else if (["windows", "linux"].includes(_.platform)) {
          keys = command.hotkey_win;
        }
        return /* @__PURE__ */ jsx94("div", { key: `other-${command.id}`, style: { ...rowStyle } }, /* @__PURE__ */ jsx94("div", null, getHighlightedText(command.text, searchTerm, isInputFocused)), /* @__PURE__ */ jsx94("div", null, /* @__PURE__ */ jsx94(HotkeyTag_default, { combo: keys })));
      }))));
    };
    KeyboardShortcutCheatsheet_default = KeyboardShortcutCheatsheet;
  }
});

// commandbar/src/products/spotlight/components/InlineBar.tsx
import * as React254 from "react";
var InlineBar, useOnClickOutside, InlineBar_default;
var init_InlineBar = __esm({
  "commandbar/src/products/spotlight/components/InlineBar.tsx"() {
    "use strict";
    init_Z();
    init_useAction();
    init_useCommandBarContainer();
    init_useTheme();
    init_actions9();
    init_useStore();
    InlineBar = (props2) => {
      const { flags } = useStore();
      const { theme } = useTheme();
      const closeIfOpen = useAction((_) => {
        if (_.spotlight.visible) {
          toggleBarFromLauncher(_);
          setTimeout(() => {
            var _a2;
            (_a2 = _.spotlight.refContainer.current) == null ? void 0 : _a2.blur();
          }, 200);
        }
      });
      useOnClickOutside(closeIfOpen);
      return (flags == null ? void 0 : flags["release-themes-v2"]) ? /* @__PURE__ */ React254.createElement("div", { style: { position: "relative", width: "100%" } }, /* @__PURE__ */ React254.createElement(
        "div",
        {
          style: {
            width: "inherit",
            zIndex: Z_default.Z_EDITOR,
            position: "absolute",
            top: 0
          }
        },
        props2.children
      )) : /* @__PURE__ */ React254.createElement("div", { style: { position: "relative", width: "100%" } }, /* @__PURE__ */ React254.createElement(
        "div",
        {
          style: {
            fontFamily: theme.main.fontFamily,
            backgroundColor: theme.main.background,
            borderRadius: theme.main.borderRadius,
            width: "inherit",
            zIndex: Z_default.Z_EDITOR,
            boxShadow: theme.main.boxShadow,
            position: "absolute",
            top: 0
          }
        },
        props2.children
      ));
    };
    useOnClickOutside = (onClickOutside) => {
      const { container } = useCommandBarContainer();
      React254.useEffect(() => {
        function handleClick(event) {
          var _a2;
          if (event.__commandbar_clicked_on_container)
            return;
          if ((_a2 = document.getElementById("commandbar")) == null ? void 0 : _a2.contains(event.target))
            return;
          onClickOutside();
        }
        function closeOnBlurIfClickedOnIframe() {
          setTimeout(() => {
            const activeIframe = document.activeElement;
            if ((activeIframe == null ? void 0 : activeIframe.tagName) === "IFRAME") {
              const commandBarContainer = document.getElementById("commandbar-home");
              if (commandBarContainer && !commandBarContainer.contains(activeIframe)) {
                onClickOutside();
              }
            }
          });
        }
        const handleClickInside = (event) => {
          event.__commandbar_clicked_on_container = true;
        };
        container == null ? void 0 : container.addEventListener("mousedown", handleClickInside);
        document.addEventListener("mousedown", handleClick);
        window.addEventListener("blur", closeOnBlurIfClickedOnIframe);
        return () => {
          container == null ? void 0 : container.removeEventListener("mousedown", handleClickInside);
          document.removeEventListener("mousedown", handleClick);
          window.removeEventListener("blur", closeOnBlurIfClickedOnIframe);
        };
      }, [container, onClickOutside]);
    };
    InlineBar_default = InlineBar;
  }
});

// commandbar/src/products/spotlight/components/ModalSpotlightContainer.tsx
import React255 from "react";
var ModalSpotlightContainer, ModalSpotlightContainer_default;
var init_ModalSpotlightContainer = __esm({
  "commandbar/src/products/spotlight/components/ModalSpotlightContainer.tsx"() {
    "use strict";
    init_useTheme();
    init_useStore();
    init_selectors3();
    init_AnimatedWidget();
    ModalSpotlightContainer = ({ style: style3, children }) => {
      var _a2;
      const { theme } = useTheme();
      const _ = useStore();
      const visible = isVisible(_);
      const { animStyles } = useAnimatedWidget();
      const { currentStepIndex } = currentStepAndIndex(_);
      const [animationClass, setAnimationClass] = React255.useState("commandbar-opened" /* opened */);
      React255.useEffect(() => {
        var _a3, _b2;
        if (!((_a3 = _.flags) == null ? void 0 : _a3["release-widget-animations"]) || !((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"])) {
          setAnimationClass("commandbar-opened" /* opened */);
        }
      }, [visible]);
      React255.useEffect(() => {
        setAnimationClass("commandbar-selected" /* selected */);
        const timer = setTimeout(() => {
          setAnimationClass("");
        }, 400);
        return () => {
          clearTimeout(timer);
        };
      }, [currentStepIndex]);
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React255.createElement("div", { style: { perspective: 100 } }, /* @__PURE__ */ React255.createElement(
        "div",
        {
          className: !_.flags["release-widget-animations"] || !_.flags["release-themes-v2"] ? `commandbar-animation ${animationClass}` : void 0,
          style: {
            padding: 0,
            zIndex: 1,
            ...animStyles
          }
        },
        children
      )) : /* @__PURE__ */ React255.createElement("div", { style: { perspective: 100 } }, /* @__PURE__ */ React255.createElement(
        "div",
        {
          className: `commandbar-animation ${animationClass}`,
          style: {
            backgroundColor: theme.main.background,
            borderRadius: theme.main.borderRadius,
            padding: "0px 0px 0px 0px",
            boxShadow: theme.main.boxShadow,
            zIndex: 1,
            margin: "0px 5px",
            // mobile screen padding
            ...style3
          }
        },
        children
      ));
    };
    ModalSpotlightContainer_default = ModalSpotlightContainer;
  }
});

// internal/src/middleware/historyEvent.tsx
import * as t41 from "io-ts";
var HistoryEventV, HistoryEvent;
var init_historyEvent = __esm({
  "internal/src/middleware/historyEvent.tsx"() {
    "use strict";
    init_generics();
    HistoryEventV = t41.intersection(
      [
        t41.type({
          id: t41.number,
          organization: t41.string,
          changed_by: t41.string,
          description: t41.string,
          created: t41.string,
          sha1: t41.string,
          version_num: t41.number
        }),
        t41.partial({})
      ],
      "HistoryEvent"
    );
    HistoryEvent = class {
    };
    HistoryEvent.list = listObject(HistoryEventV, "histories");
  }
});

// internal/src/middleware/releases.tsx
import * as t42 from "io-ts";
var ReleaseV, ReleaseStepV, EnvReleaseInfoV, ReleasesViewV, DiffV, Releases;
var init_releases = __esm({
  "internal/src/middleware/releases.tsx"() {
    "use strict";
    init_generics();
    init_historyEvent();
    init_network();
    ReleaseV = t42.type({
      created_by: t42.union([t42.string, t42.null]),
      created: t42.string,
      history_event: HistoryEventV,
      id: t42.number,
      notes: t42.string,
      tags: t42.array(t42.string)
    });
    ReleaseStepV = t42.type({
      created: t42.string,
      created_by: t42.union([t42.string, t42.null]),
      current: t42.union([t42.boolean, t42.null]),
      env: t42.string,
      id: t42.number,
      next_env: t42.union([t42.null, t42.string]),
      release: ReleaseV
    });
    EnvReleaseInfoV = t42.intersection([
      t42.type({
        environment: t42.string
      }),
      t42.partial({
        release_step: ReleaseStepV,
        release: ReleaseV
      })
    ]);
    ReleasesViewV = t42.type({
      environments: t42.array(EnvReleaseInfoV),
      latest_history_event: t42.union([HistoryEventV, t42.null]),
      latest_release: t42.union([ReleaseV, t42.null])
    });
    DiffV = t42.unknown;
    Releases = class {
    };
    Releases.readView = read(ReleasesViewV, "releases/view");
    Releases.createRelease = async (historyEventId, notes, tags2) => {
      const result = await post(
        `/releases/` + (historyEventId > 0 ? `?history_event_id=${historyEventId}` : ""),
        { notes, tags: tags2 }
      );
      return await decodeToPromise(t42.exact(ReleaseV), result.data);
    };
    Releases.readReleaseStepsForEnv = async (env) => {
      const result = await get2(`release_steps/?env=${encodeURIComponent(env)}`);
      return await decodeToPromise(t42.array(t42.exact(ReleaseStepV)), result.data);
    };
    Releases.rollback = async (releaseStepId) => {
      const result = await post(`/release_steps/${releaseStepId}/rollback/`);
      return await decodeToPromise(t42.exact(ReleaseStepV), result.data);
    };
    Releases.readDiff = async (fromId, toId) => {
      const result = await get2(
        `release_steps/diff/?a=${encodeURIComponent(toId)}` + (fromId !== "history_event.-1" ? `&b=${encodeURIComponent(fromId)}` : ``)
      );
      return await decodeToPromise(DiffV, result.data);
    };
    Releases.promoteReleaseStep = async (releaseStepId) => {
      const result = await post(`/release_steps/${releaseStepId}/promote/`);
      return await decodeToPromise(t42.any, result.data);
    };
    Releases.promoteReleaseToFirstEnv = async (releaseId) => {
      const result = await post(`/releases/${releaseId}/promote_to_first_env/`);
      return await decodeToPromise(t42.exact(ReleaseV), result.data);
    };
    // fixme - add pagination support
    Releases.listReleases = listObject(ReleaseV, "releases");
  }
});

// commandbar/src/products/spotlight/components/select/footer/SystemPanel.tsx
import React256 from "react";
import { jsx as jsx95 } from "@emotion/core";
import chroma19 from "chroma-js";
import { AiOutlineClose as AiOutlineClose5, AiOutlineEllipsis } from "react-icons/ai";
var labelStyles, SystemPanel, Divider2, TestModeSwitch, ReleasesSelector, CustomContextTag, Switch, DropdownOption, DropdownDivider, MiscHelpersDropdown, ToggleEditorOption, LogContextOption, LogCallbacksOption, HidePanelOptions, HideHandleOptions, SystemPanel_default;
var init_SystemPanel = __esm({
  "commandbar/src/products/spotlight/components/select/footer/SystemPanel.tsx"() {
    "use strict";
    init_useAction();
    init_useStore();
    init_global_actions();
    init_actions9();
    init_config();
    init_LocalStorage();
    init_Tag();
    init_editorUtils();
    init_Tooltip();
    init_releases();
    init_location();
    init_sentry();
    init_useTheme();
    labelStyles = () => ({
      fontSize: 11,
      fontWeight: 600,
      marginRight: 7,
      userSelect: "none",
      whiteSpace: "nowrap",
      color: "hsla(0, 0%, 0%, 0.85)"
    });
    SystemPanel = () => {
      const [visibility, setVisibility] = React256.useState("visible");
      const { environments, envOverride, isAdmin, testMode, organization } = useStore();
      const showReleasesSelector = !!(environments == null ? void 0 : environments.length) || !!(organization == null ? void 0 : organization.releases_enabled);
      const customContext = (() => {
        var _a2;
        const contextStr = LocalStorage_default.get("customcontext", "");
        if (typeof contextStr === "string" && contextStr.length > 0) {
          try {
            return JSON.parse(contextStr);
          } catch (e) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
          }
        }
        return null;
      })();
      const isActive2 = !!testMode || !!environments && !!envOverride || !!customContext;
      const containerStyles4 = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        paddingLeft: "12px",
        paddingRight: "12px",
        borderRadius: `0px 0px 6px 6px`,
        opacity: isActive2 ? 1 : 0.7,
        boxShadow: "0px 0px 4px 0px rgba(0,0,0,0.3) inset",
        background: "white",
        transition: "all 0.3s ease-in",
        overflow: "visible"
      };
      if (!isAdmin)
        return null;
      const isMinimized = visibility === "minimized";
      const isHidden = visibility === "hidden";
      return /* @__PURE__ */ jsx95(
        "div",
        {
          id: "commandbar-system-panel",
          style: {
            position: "absolute",
            display: isHidden ? "none" : "flex",
            width: "100%",
            justifyContent: "center",
            color: "grey"
          }
        },
        /* @__PURE__ */ jsx95(
          "div",
          {
            style: {
              ...containerStyles4,
              maxWidth: isMinimized ? "100px" : "1000px",
              height: isMinimized ? 25 : 45,
              transition: "all 0.3s ease-out"
            }
          },
          /* @__PURE__ */ jsx95(
            "div",
            {
              style: {
                position: "sticky",
                top: 0,
                display: "flex",
                alignItems: "center",
                width: "100%"
              }
            },
            /* @__PURE__ */ jsx95(
              "div",
              {
                "aria-hidden": true,
                style: {
                  fontSize: 12,
                  fontWeight: 600,
                  marginLeft: 5,
                  marginRight: 5,
                  cursor: "pointer",
                  whiteSpace: "nowrap"
                },
                onClick: () => isMinimized ? setVisibility("visible") : setVisibility("minimized")
              },
              "Editor Panel"
            ),
            !isMinimized && /* @__PURE__ */ jsx95(React256.Fragment, null, /* @__PURE__ */ jsx95(Divider2, null), /* @__PURE__ */ jsx95(TestModeSwitch, null), showReleasesSelector && /* @__PURE__ */ jsx95(Divider2, null), showReleasesSelector && /* @__PURE__ */ jsx95(ReleasesSelector, null), !!customContext && /* @__PURE__ */ jsx95(Divider2, null), !!customContext && /* @__PURE__ */ jsx95(CustomContextTag, { context: customContext }), !isStudioPreview() && /* @__PURE__ */ jsx95(React256.Fragment, null, /* @__PURE__ */ jsx95(Divider2, null), /* @__PURE__ */ jsx95(MiscHelpersDropdown, { changePanelVisiblity: (v) => setVisibility(v) })))
          )
        )
      );
    };
    Divider2 = () => {
      return /* @__PURE__ */ jsx95(
        "div",
        {
          style: {
            position: "relative",
            borderLeft: `2px solid rgba(215, 215, 215, 0.5)`,
            marginLeft: 10,
            marginRight: 10,
            height: 31
          }
        }
      );
    };
    TestModeSwitch = () => {
      const toggleTestMode2 = useAction(toggleTestMode);
      const { testMode } = useStore();
      return /* @__PURE__ */ jsx95("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ jsx95("span", { style: labelStyles() }, "Test mode"), /* @__PURE__ */ jsx95(Switch, { value: testMode, onChange: (_e) => toggleTestMode2(), width: 30, height: 16, spacing: 3 }));
    };
    ReleasesSelector = () => {
      const { theme } = useTheme();
      const [releases, setReleases] = React256.useState([]);
      const setEnvOverride2 = useAction(setEnvOverride);
      const clearEnvOverride2 = useAction(clearEnvOverride);
      const ref12 = React256.useRef(null);
      const { env, environments, envOverride, version, spotlight } = useStore();
      const refContainer = spotlight.refContainer;
      const envOrVersion = getEnvOrVersion({ env, envOverride, version });
      React256.useEffect(() => {
        const getReleases = async () => {
          const releases2 = await Releases.listReleases();
          setReleases(releases2.slice(0, 10));
        };
        getReleases();
      }, []);
      const selectStyles = {
        background: "#F8F8F8",
        border: "2px solid #F2F2F2",
        borderRadius: 5,
        fontSize: 11,
        fontFamily: theme.main.fontFamily,
        outline: "none",
        cursor: "pointer"
      };
      return /* @__PURE__ */ jsx95("div", null, /* @__PURE__ */ jsx95("div", { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ jsx95("span", { style: labelStyles() }, "Releases"), /* @__PURE__ */ jsx95(
        "select",
        {
          ref: ref12,
          className: (
            /* NOTE: commandbar__system_panel is a special classname to mark this element so
                that focus won't be pulled away from it. Without this, the code that
                focuses the main Bar input will pull focus away from the environment
                override selector. */
            "commandbar__system_panel"
          ),
          onBlur: () => {
            var _a2;
            (_a2 = refContainer.current) == null ? void 0 : _a2.focus();
          },
          css: selectStyles,
          value: JSON.stringify(envOrVersion),
          onChange: (e) => {
            var _a2;
            setEnvOverride2(JSON.parse(e.target.value));
            (_a2 = ref12.current) == null ? void 0 : _a2.blur();
          }
        },
        !!environments && /* @__PURE__ */ jsx95("optgroup", { label: "Environments" }, environments.map(({ env: env2, version: version2 }) => /* @__PURE__ */ jsx95("option", { disabled: version2 == null && env2 !== "latest", key: env2, value: JSON.stringify({ env: env2 }) }, env2))),
        releases.length > 0 ? /* @__PURE__ */ jsx95("optgroup", { label: "Release versions" }, releases.map((release) => {
          const version_num = release.history_event.version_num;
          return /* @__PURE__ */ jsx95("option", { key: version_num, value: JSON.stringify({ version: `v${version_num}` }) }, "v", release.history_event.version_num, " ", release.notes.length > 10 ? release.notes.substr(0, 9) + "..." : release.notes);
        })) : /* @__PURE__ */ jsx95("optgroup", { label: "Release versions" }, /* @__PURE__ */ jsx95("option", { disabled: true }, "None"))
      ), !!envOverride && /* @__PURE__ */ jsx95(Tooltip_default, { overlay: "Clear environment changes", placement: "bottom" }, /* @__PURE__ */ jsx95(
        AiOutlineClose5,
        {
          onClick: () => clearEnvOverride2(),
          style: { fontSize: 10, marginLeft: 5, cursor: "pointer" }
        }
      ))));
    };
    CustomContextTag = (props2) => {
      if (!props2.context)
        return null;
      return /* @__PURE__ */ jsx95("div", null, /* @__PURE__ */ jsx95("span", { style: labelStyles() }, "Custom context"), /* @__PURE__ */ jsx95(Tag_default, { color: chroma19("grey"), style: { padding: 2 } }, props2.context.name));
    };
    Switch = (props2) => {
      const { spacing } = props2;
      const checkRadius = props2.height - 2 * spacing;
      const activeColor = "radial-gradient(87.5% 262.5% at 76.56% 96.88%, #88fbc4 0%, #01dc73 100%)";
      const inactiveColor = "radial-gradient(93.75% 293.75% at 76.56% 96.87%, #ebe8e8 0%, #9e9e9e 100%)";
      return (
        // eslint-disable-next-line jsx-a11y/label-has-for
        /* @__PURE__ */ jsx95(
          "label",
          {
            id: "switch",
            style: { position: "relative", display: "inline-block", width: props2.width, height: props2.height }
          },
          /* @__PURE__ */ jsx95(
            "input",
            {
              type: "checkbox",
              checked: props2.value,
              onChange: props2.onChange,
              style: { opacity: 0, width: 0, height: 0 }
            }
          ),
          /* @__PURE__ */ jsx95(
            "span",
            {
              css: {
                position: "absolute",
                cursor: "pointer",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: props2.value ? activeColor : inactiveColor,
                transition: ".4s",
                borderRadius: props2.height,
                ":before": {
                  position: "absolute",
                  background: "white",
                  content: '""',
                  height: checkRadius,
                  width: checkRadius,
                  left: spacing,
                  bottom: spacing,
                  transition: ".4s",
                  borderRadius: "50%",
                  boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
                  transform: props2.value ? `translateX(${props2.width - 2 * spacing - checkRadius}px)` : "translateX(0px)"
                }
              }
            }
          )
        )
      );
    };
    DropdownOption = (props2) => {
      const { children, ...restProps } = props2;
      return /* @__PURE__ */ jsx95(
        "div",
        {
          css: {
            fontSize: 10,
            fontWeight: 500,
            background: "transparent",
            transition: "0.3s all ease-in",
            borderRadius: 3,
            padding: "3px 8px",
            cursor: "pointer",
            ":hover": {
              background: "#ddd"
            }
          },
          ...restProps
        },
        props2.children
      );
    };
    DropdownDivider = () => /* @__PURE__ */ jsx95("div", { style: { borderBottom: "1px solid #ddd", marginRight: 5, marginLeft: 5 } });
    MiscHelpersDropdown = (props2) => {
      const { theme } = useTheme();
      const [isHovered, setIsHovered] = React256.useState(false);
      return /* @__PURE__ */ jsx95(
        "div",
        {
          "aria-hidden": true,
          onMouseEnter: () => setIsHovered(true),
          onMouseLeave: () => setIsHovered(false),
          style: {
            display: "flex",
            alignItems: "center",
            fontFamily: theme.main.fontFamily,
            color: "hsla(0, 0%, 0%, 0.85)",
            padding: 4
          }
        },
        /* @__PURE__ */ jsx95(AiOutlineEllipsis, { css: { position: "relative", display: "inline-block", cursor: "pointer" } }),
        /* @__PURE__ */ jsx95(
          "div",
          {
            css: {
              // display: isHovered ? 'inline-block' : 'none',
              position: "absolute",
              backgroundColor: "#f9f9f9",
              width: "140px",
              boxShadow: "0px 8px 16px 0px rgba(0,0,0,0.2)",
              padding: "6px",
              zIndex: 1,
              top: 10,
              marginLeft: "15px",
              overflow: "hidden",
              borderRadius: 5,
              opacity: isHovered ? 1 : 0,
              display: isHovered ? "inline-block" : "none",
              transition: `opacity ${theme.main.transitionTime} ease-out`
            }
          },
          /* @__PURE__ */ jsx95(ToggleEditorOption, null),
          /* @__PURE__ */ jsx95(DropdownDivider, null),
          /* @__PURE__ */ jsx95(LogContextOption, null),
          /* @__PURE__ */ jsx95(DropdownDivider, null),
          /* @__PURE__ */ jsx95(LogCallbacksOption, null),
          /* @__PURE__ */ jsx95(DropdownDivider, null),
          /* @__PURE__ */ jsx95(HidePanelOptions, { changePanelVisiblity: props2.changePanelVisiblity }),
          /* @__PURE__ */ jsx95(DropdownDivider, null),
          /* @__PURE__ */ jsx95(HideHandleOptions, null)
        )
      );
    };
    ToggleEditorOption = () => {
      var _a2, _b2;
      const openEditor2 = useAction(openEditor);
      const closeEditor = () => {
        clickEditorHandle();
      };
      const isEditorOpen2 = (_b2 = (_a2 = checkForEditor()) == null ? void 0 : _a2.classList) == null ? void 0 : _b2.contains("drawer-open");
      return /* @__PURE__ */ jsx95(DropdownOption, { onClick: () => isEditorOpen2 ? closeEditor() : openEditor2() }, /* @__PURE__ */ jsx95("div", null, isEditorOpen2 ? "Close editor" : "Open editor"));
    };
    LogContextOption = () => {
      return /* @__PURE__ */ jsx95(DropdownOption, { onClick: () => console.log(window.CommandBar.shareContext()) }, /* @__PURE__ */ jsx95("div", null, "Console log context"));
    };
    LogCallbacksOption = () => {
      return /* @__PURE__ */ jsx95(DropdownOption, { onClick: () => console.log(Object.assign({}, window.CommandBar.shareCallbacks())) }, /* @__PURE__ */ jsx95("div", null, "Console log callbacks"));
    };
    HidePanelOptions = (props2) => {
      return /* @__PURE__ */ jsx95(React256.Fragment, null, /* @__PURE__ */ jsx95(DropdownOption, { onClick: () => props2.changePanelVisiblity("minimized") }, /* @__PURE__ */ jsx95("div", null, "Minimize panel")), /* @__PURE__ */ jsx95(DropdownDivider, null), /* @__PURE__ */ jsx95(DropdownOption, { onClick: () => props2.changePanelVisiblity("hidden") }, /* @__PURE__ */ jsx95("div", null, "Hide panel until next page refresh")));
    };
    HideHandleOptions = () => {
      const hideHandle = () => {
        const handle = getEditorHandle();
        if (handle) {
          handle.style.visibility = "hidden";
        }
      };
      return /* @__PURE__ */ jsx95(React256.Fragment, null, /* @__PURE__ */ jsx95(DropdownOption, { onClick: () => hideHandle() }, /* @__PURE__ */ jsx95("div", null, "Hide handle until next page refresh")));
    };
    SystemPanel_default = SystemPanel;
  }
});

// commandbar/src/products/spotlight/components/SidePanel.tsx
import React257 from "react";
var SidePanel, SidePanel_default;
var init_SidePanel = __esm({
  "commandbar/src/products/spotlight/components/SidePanel.tsx"() {
    "use strict";
    init_selectors8();
    init_useStore();
    init_RenderCustomComponent();
    SidePanel = () => {
      const _ = useStore();
      const { userDefinedCustomComponents } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const component = (currentStep == null ? void 0 : currentStep.type) !== "execute" && userDefinedCustomComponents.sidepanel({ step: currentStep == null ? void 0 : currentStep.type });
      if (typeof component === "string") {
        return /* @__PURE__ */ React257.createElement("div", { dangerouslySetInnerHTML: { __html: component } });
      } else if (component) {
        return /* @__PURE__ */ React257.createElement(RenderCustomComponent_default, { component });
      }
      return null;
    };
    SidePanel_default = SidePanel;
  }
});

// commandbar/src/products/spotlight/components/select/CustomHeader.tsx
import React258 from "react";
var CustomHeader, CustomHeader_default;
var init_CustomHeader = __esm({
  "commandbar/src/products/spotlight/components/select/CustomHeader.tsx"() {
    "use strict";
    init_selectors8();
    init_useStore();
    init_RenderCustomComponent();
    CustomHeader = () => {
      const _ = useStore();
      const { userDefinedCustomComponents } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const component = (currentStep == null ? void 0 : currentStep.type) !== "execute" && userDefinedCustomComponents.header({ step: currentStep == null ? void 0 : currentStep.type });
      if (typeof component === "string") {
        return /* @__PURE__ */ React258.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React258.createElement("div", { dangerouslySetInnerHTML: { __html: component } }));
      } else if (component) {
        return /* @__PURE__ */ React258.createElement(RenderCustomComponent_default, { component });
      }
      return null;
    };
    CustomHeader_default = CustomHeader;
  }
});

// commandbar/src/products/spotlight/components/VerticalNavPane.tsx
import React259 from "react";
var VerticalNavPane, VerticalNavPane_default;
var init_VerticalNavPane = __esm({
  "commandbar/src/products/spotlight/components/VerticalNavPane.tsx"() {
    "use strict";
    init_selectors8();
    init_Step();
    init_useStore();
    init_RenderCustomComponent();
    init_SearchTabs();
    init_useTheme();
    VerticalNavPane = () => {
      var _a2;
      const _ = useStore();
      const { userDefinedCustomComponents } = _.spotlight;
      const { currentStep } = currentStepAndIndex(_);
      const { theme } = useTheme();
      const inBaseState = (currentStep == null ? void 0 : currentStep.type) === "base" /* Base */ && !(currentStep == null ? void 0 : currentStep.resource);
      const showVerticalSearchTabs = ((_a2 = _.organization) == null ? void 0 : _a2.tab_direction) === "vertical";
      if (!inBaseState || !showVerticalSearchTabs) {
        return null;
      }
      const HTMLComponent = (component, key) => {
        if (typeof component === "string") {
          return /* @__PURE__ */ React259.createElement("div", { dangerouslySetInnerHTML: { __html: component }, key });
        } else if (component) {
          return /* @__PURE__ */ React259.createElement(RenderCustomComponent_default, { component, key });
        }
      };
      const children = [
        HTMLComponent(userDefinedCustomComponents.navPaneHeader({ step: currentStep == null ? void 0 : currentStep.type }), "search-tabs-header"),
        showVerticalSearchTabs ? /* @__PURE__ */ React259.createElement("div", { key: "search-tabs-container", style: { flexGrow: 1 } }, /* @__PURE__ */ React259.createElement(SearchTabs_default, { direction: "vertical" })) : null,
        HTMLComponent(userDefinedCustomComponents.navPaneFooter({ step: currentStep == null ? void 0 : currentStep.type }), "search-tabs-footer")
      ].filter((v) => !!v);
      if (children.length > 0) {
        return /* @__PURE__ */ React259.createElement(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              background: theme.navPane.background,
              borderRight: theme.navPane.borderRight,
              width: theme.navPane.width,
              borderRadius: `${theme.main.borderRadius} 0px 0px ${theme.main.borderRadius}`
            }
          },
          children
        );
      }
      return null;
    };
    VerticalNavPane_default = VerticalNavPane;
  }
});

// node_modules/tslib/tslib.es6.mjs
function __rest(s, e) {
  var t44 = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t44[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i2 = 0, p = Object.getOwnPropertySymbols(s); i2 < p.length; i2++) {
      if (e.indexOf(p[i2]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i2]))
        t44[p[i2]] = s[p[i2]];
    }
  return t44;
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2)
    for (var i2 = 0, l = from.length, ar; i2 < l; i2++) {
      if (ar || !(i2 in from)) {
        if (!ar)
          ar = Array.prototype.slice.call(from, 0, i2);
        ar[i2] = from[i2];
      }
    }
  return to.concat(ar || Array.prototype.slice.call(from));
}
var __assign;
var init_tslib_es6 = __esm({
  "node_modules/tslib/tslib.es6.mjs"() {
    __assign = function() {
      __assign = Object.assign || function __assign2(t44) {
        for (var s, i2 = 1, n = arguments.length; i2 < n; i2++) {
          s = arguments[i2];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t44[p] = s[p];
        }
        return t44;
      };
      return __assign.apply(this, arguments);
    };
  }
});

// node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var zeroRightClassName, fullWidthClassName, noScrollbarsClassName, removedBarSizeVariable;
var init_constants9 = __esm({
  "node_modules/react-remove-scroll-bar/dist/es2015/constants.js"() {
    zeroRightClassName = "right-scroll-bar-position";
    fullWidthClassName = "width-before-scroll-bar";
    noScrollbarsClassName = "with-scroll-bars-hidden";
    removedBarSizeVariable = "--removed-body-scroll-bar-size";
  }
});

// node_modules/use-callback-ref/dist/es2015/assignRef.js
function assignRef2(ref12, value) {
  if (typeof ref12 === "function") {
    ref12(value);
  } else if (ref12) {
    ref12.current = value;
  }
  return ref12;
}
var init_assignRef = __esm({
  "node_modules/use-callback-ref/dist/es2015/assignRef.js"() {
  }
});

// node_modules/use-callback-ref/dist/es2015/useRef.js
import { useState as useState30 } from "react";
function useCallbackRef(initialValue, callback) {
  var ref12 = useState30(function() {
    return {
      // value
      value: initialValue,
      // last callback
      callback,
      // "memoized" public interface
      facade: {
        get current() {
          return ref12.value;
        },
        set current(value) {
          var last = ref12.value;
          if (last !== value) {
            ref12.value = value;
            ref12.callback(value, last);
          }
        }
      }
    };
  })[0];
  ref12.callback = callback;
  return ref12.facade;
}
var init_useRef = __esm({
  "node_modules/use-callback-ref/dist/es2015/useRef.js"() {
  }
});

// node_modules/use-callback-ref/dist/es2015/useMergeRef.js
function useMergeRefs2(refs, defaultValue) {
  return useCallbackRef(defaultValue || null, function(newValue) {
    return refs.forEach(function(ref12) {
      return assignRef2(ref12, newValue);
    });
  });
}
var init_useMergeRef = __esm({
  "node_modules/use-callback-ref/dist/es2015/useMergeRef.js"() {
    init_assignRef();
    init_useRef();
  }
});

// node_modules/use-callback-ref/dist/es2015/index.js
var init_es2015 = __esm({
  "node_modules/use-callback-ref/dist/es2015/index.js"() {
    init_useMergeRef();
  }
});

// node_modules/use-sidecar/dist/es2015/medium.js
function ItoI(a) {
  return a;
}
function innerCreateMedium(defaults11, middleware) {
  if (middleware === void 0) {
    middleware = ItoI;
  }
  var buffer = [];
  var assigned = false;
  var medium = {
    read: function() {
      if (assigned) {
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      }
      if (buffer.length) {
        return buffer[buffer.length - 1];
      }
      return defaults11;
    },
    useMedium: function(data) {
      var item = middleware(data, assigned);
      buffer.push(item);
      return function() {
        buffer = buffer.filter(function(x) {
          return x !== item;
        });
      };
    },
    assignSyncMedium: function(cb) {
      assigned = true;
      while (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
      }
      buffer = {
        push: function(x) {
          return cb(x);
        },
        filter: function() {
          return buffer;
        }
      };
    },
    assignMedium: function(cb) {
      assigned = true;
      var pendingQueue = [];
      if (buffer.length) {
        var cbs = buffer;
        buffer = [];
        cbs.forEach(cb);
        pendingQueue = buffer;
      }
      var executeQueue = function() {
        var cbs2 = pendingQueue;
        pendingQueue = [];
        cbs2.forEach(cb);
      };
      var cycle = function() {
        return Promise.resolve().then(executeQueue);
      };
      cycle();
      buffer = {
        push: function(x) {
          pendingQueue.push(x);
          cycle();
        },
        filter: function(filter) {
          pendingQueue = pendingQueue.filter(filter);
          return buffer;
        }
      };
    }
  };
  return medium;
}
function createSidecarMedium(options) {
  if (options === void 0) {
    options = {};
  }
  var medium = innerCreateMedium(null);
  medium.options = __assign({ async: true, ssr: false }, options);
  return medium;
}
var init_medium = __esm({
  "node_modules/use-sidecar/dist/es2015/medium.js"() {
    init_tslib_es6();
  }
});

// node_modules/use-sidecar/dist/es2015/exports.js
import * as React260 from "react";
function exportSidecar(medium, exported) {
  medium.useMedium(exported);
  return SideCar;
}
var SideCar;
var init_exports = __esm({
  "node_modules/use-sidecar/dist/es2015/exports.js"() {
    init_tslib_es6();
    SideCar = function(_a2) {
      var sideCar = _a2.sideCar, rest = __rest(_a2, ["sideCar"]);
      if (!sideCar) {
        throw new Error("Sidecar: please provide `sideCar` property to import the right car");
      }
      var Target = sideCar.read();
      if (!Target) {
        throw new Error("Sidecar medium not found");
      }
      return React260.createElement(Target, __assign({}, rest));
    };
    SideCar.isSideCarExport = true;
  }
});

// node_modules/use-sidecar/dist/es2015/index.js
var init_es20152 = __esm({
  "node_modules/use-sidecar/dist/es2015/index.js"() {
    init_medium();
    init_exports();
  }
});

// node_modules/react-remove-scroll/dist/es2015/medium.js
var effectCar;
var init_medium2 = __esm({
  "node_modules/react-remove-scroll/dist/es2015/medium.js"() {
    init_es20152();
    effectCar = createSidecarMedium();
  }
});

// node_modules/react-remove-scroll/dist/es2015/UI.js
import * as React261 from "react";
var nothing, RemoveScroll;
var init_UI = __esm({
  "node_modules/react-remove-scroll/dist/es2015/UI.js"() {
    init_tslib_es6();
    init_constants9();
    init_es2015();
    init_medium2();
    nothing = function() {
      return;
    };
    RemoveScroll = React261.forwardRef(function(props2, parentRef) {
      var ref12 = React261.useRef(null);
      var _a2 = React261.useState({
        onScrollCapture: nothing,
        onWheelCapture: nothing,
        onTouchMoveCapture: nothing
      }), callbacks = _a2[0], setCallbacks = _a2[1];
      var forwardProps = props2.forwardProps, children = props2.children, className = props2.className, removeScrollBar = props2.removeScrollBar, enabled = props2.enabled, shards = props2.shards, sideCar = props2.sideCar, noIsolation = props2.noIsolation, inert = props2.inert, allowPinchZoom = props2.allowPinchZoom, _b2 = props2.as, Container27 = _b2 === void 0 ? "div" : _b2, rest = __rest(props2, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]);
      var SideCar2 = sideCar;
      var containerRef = useMergeRefs2([ref12, parentRef]);
      var containerProps = __assign(__assign({}, rest), callbacks);
      return React261.createElement(
        React261.Fragment,
        null,
        enabled && React261.createElement(SideCar2, { sideCar: effectCar, removeScrollBar, shards, noIsolation, inert, setCallbacks, allowPinchZoom: !!allowPinchZoom, lockRef: ref12 }),
        forwardProps ? React261.cloneElement(React261.Children.only(children), __assign(__assign({}, containerProps), { ref: containerRef })) : React261.createElement(Container27, __assign({}, containerProps, { className, ref: containerRef }), children)
      );
    });
    RemoveScroll.defaultProps = {
      enabled: true,
      removeScrollBar: true,
      inert: false
    };
    RemoveScroll.classNames = {
      fullWidth: fullWidthClassName,
      zeroRight: zeroRightClassName
    };
  }
});

// node_modules/get-nonce/dist/es2015/index.js
var currentNonce, getNonce;
var init_es20153 = __esm({
  "node_modules/get-nonce/dist/es2015/index.js"() {
    getNonce = function() {
      if (currentNonce) {
        return currentNonce;
      }
      if (typeof __webpack_nonce__ !== "undefined") {
        return __webpack_nonce__;
      }
      return void 0;
    };
  }
});

// node_modules/react-style-singleton/dist/es2015/singleton.js
function makeStyleTag() {
  if (!document)
    return null;
  var tag = document.createElement("style");
  tag.type = "text/css";
  var nonce = getNonce();
  if (nonce) {
    tag.setAttribute("nonce", nonce);
  }
  return tag;
}
function injectStyles(tag, css79) {
  if (tag.styleSheet) {
    tag.styleSheet.cssText = css79;
  } else {
    tag.appendChild(document.createTextNode(css79));
  }
}
function insertStyleTag(tag) {
  var head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(tag);
}
var stylesheetSingleton;
var init_singleton = __esm({
  "node_modules/react-style-singleton/dist/es2015/singleton.js"() {
    init_es20153();
    stylesheetSingleton = function() {
      var counter = 0;
      var stylesheet = null;
      return {
        add: function(style3) {
          if (counter == 0) {
            if (stylesheet = makeStyleTag()) {
              injectStyles(stylesheet, style3);
              insertStyleTag(stylesheet);
            }
          }
          counter++;
        },
        remove: function() {
          counter--;
          if (!counter && stylesheet) {
            stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
            stylesheet = null;
          }
        }
      };
    };
  }
});

// node_modules/react-style-singleton/dist/es2015/hook.js
import * as React262 from "react";
var styleHookSingleton;
var init_hook = __esm({
  "node_modules/react-style-singleton/dist/es2015/hook.js"() {
    init_singleton();
    styleHookSingleton = function() {
      var sheet = stylesheetSingleton();
      return function(styles51, isDynamic) {
        React262.useEffect(function() {
          sheet.add(styles51);
          return function() {
            sheet.remove();
          };
        }, [styles51 && isDynamic]);
      };
    };
  }
});

// node_modules/react-style-singleton/dist/es2015/component.js
var styleSingleton;
var init_component = __esm({
  "node_modules/react-style-singleton/dist/es2015/component.js"() {
    init_hook();
    styleSingleton = function() {
      var useStyle = styleHookSingleton();
      var Sheet2 = function(_a2) {
        var styles51 = _a2.styles, dynamic = _a2.dynamic;
        useStyle(styles51, dynamic);
        return null;
      };
      return Sheet2;
    };
  }
});

// node_modules/react-style-singleton/dist/es2015/index.js
var init_es20154 = __esm({
  "node_modules/react-style-singleton/dist/es2015/index.js"() {
    init_component();
    init_singleton();
    init_hook();
  }
});

// node_modules/react-remove-scroll-bar/dist/es2015/utils.js
var zeroGap, parse, getOffset, getGapWidth;
var init_utils5 = __esm({
  "node_modules/react-remove-scroll-bar/dist/es2015/utils.js"() {
    zeroGap = {
      left: 0,
      top: 0,
      right: 0,
      gap: 0
    };
    parse = function(x) {
      return parseInt(x || "", 10) || 0;
    };
    getOffset = function(gapMode) {
      var cs = window.getComputedStyle(document.body);
      var left = cs[gapMode === "padding" ? "paddingLeft" : "marginLeft"];
      var top = cs[gapMode === "padding" ? "paddingTop" : "marginTop"];
      var right = cs[gapMode === "padding" ? "paddingRight" : "marginRight"];
      return [parse(left), parse(top), parse(right)];
    };
    getGapWidth = function(gapMode) {
      if (gapMode === void 0) {
        gapMode = "margin";
      }
      if (typeof window === "undefined") {
        return zeroGap;
      }
      var offsets = getOffset(gapMode);
      var documentWidth = document.documentElement.clientWidth;
      var windowWidth = window.innerWidth;
      return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
      };
    };
  }
});

// node_modules/react-remove-scroll-bar/dist/es2015/component.js
import * as React263 from "react";
var Style, getStyles5, RemoveScrollBar;
var init_component2 = __esm({
  "node_modules/react-remove-scroll-bar/dist/es2015/component.js"() {
    init_es20154();
    init_constants9();
    init_utils5();
    Style = styleSingleton();
    getStyles5 = function(_a2, allowRelative, gapMode, important) {
      var left = _a2.left, top = _a2.top, right = _a2.right, gap = _a2.gap;
      if (gapMode === void 0) {
        gapMode = "margin";
      }
      return "\n  .".concat(noScrollbarsClassName, " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === "margin" && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === "padding" && "padding-right: ".concat(gap, "px ").concat(important, ";")
      ].filter(Boolean).join(""), "\n  }\n  \n  .").concat(zeroRightClassName, " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat(zeroRightClassName, " .").concat(zeroRightClassName, " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat(fullWidthClassName, " .").concat(fullWidthClassName, " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body {\n    ").concat(removedBarSizeVariable, ": ").concat(gap, "px;\n  }\n");
    };
    RemoveScrollBar = function(props2) {
      var noRelative = props2.noRelative, noImportant = props2.noImportant, _a2 = props2.gapMode, gapMode = _a2 === void 0 ? "margin" : _a2;
      var gap = React263.useMemo(function() {
        return getGapWidth(gapMode);
      }, [gapMode]);
      return React263.createElement(Style, { styles: getStyles5(gap, !noRelative, gapMode, !noImportant ? "!important" : "") });
    };
  }
});

// node_modules/react-remove-scroll-bar/dist/es2015/index.js
var init_es20155 = __esm({
  "node_modules/react-remove-scroll-bar/dist/es2015/index.js"() {
    init_component2();
    init_constants9();
    init_utils5();
  }
});

// node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js
var passiveSupported, options, nonPassive;
var init_aggresiveCapture = __esm({
  "node_modules/react-remove-scroll/dist/es2015/aggresiveCapture.js"() {
    passiveSupported = false;
    if (typeof window !== "undefined") {
      try {
        options = Object.defineProperty({}, "passive", {
          get: function() {
            passiveSupported = true;
            return true;
          }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
      } catch (err) {
        passiveSupported = false;
      }
    }
    nonPassive = passiveSupported ? { passive: false } : false;
  }
});

// node_modules/react-remove-scroll/dist/es2015/handleScroll.js
var alwaysContainsScroll, elementCanBeScrolled, elementCouldBeVScrolled, elementCouldBeHScrolled, locationCouldBeScrolled, getVScrollVariables, getHScrollVariables, elementCouldBeScrolled, getScrollVariables, getDirectionFactor, handleScroll;
var init_handleScroll = __esm({
  "node_modules/react-remove-scroll/dist/es2015/handleScroll.js"() {
    alwaysContainsScroll = function(node) {
      return node.tagName === "TEXTAREA";
    };
    elementCanBeScrolled = function(node, overflow) {
      var styles51 = window.getComputedStyle(node);
      return (
        // not-not-scrollable
        styles51[overflow] !== "hidden" && // contains scroll inside self
        !(styles51.overflowY === styles51.overflowX && !alwaysContainsScroll(node) && styles51[overflow] === "visible")
      );
    };
    elementCouldBeVScrolled = function(node) {
      return elementCanBeScrolled(node, "overflowY");
    };
    elementCouldBeHScrolled = function(node) {
      return elementCanBeScrolled(node, "overflowX");
    };
    locationCouldBeScrolled = function(axis, node) {
      var current = node;
      do {
        if (typeof ShadowRoot !== "undefined" && current instanceof ShadowRoot) {
          current = current.host;
        }
        var isScrollable = elementCouldBeScrolled(axis, current);
        if (isScrollable) {
          var _a2 = getScrollVariables(axis, current), s = _a2[1], d = _a2[2];
          if (s > d) {
            return true;
          }
        }
        current = current.parentNode;
      } while (current && current !== document.body);
      return false;
    };
    getVScrollVariables = function(_a2) {
      var scrollTop = _a2.scrollTop, scrollHeight = _a2.scrollHeight, clientHeight = _a2.clientHeight;
      return [
        scrollTop,
        scrollHeight,
        clientHeight
      ];
    };
    getHScrollVariables = function(_a2) {
      var scrollLeft = _a2.scrollLeft, scrollWidth = _a2.scrollWidth, clientWidth = _a2.clientWidth;
      return [
        scrollLeft,
        scrollWidth,
        clientWidth
      ];
    };
    elementCouldBeScrolled = function(axis, node) {
      return axis === "v" ? elementCouldBeVScrolled(node) : elementCouldBeHScrolled(node);
    };
    getScrollVariables = function(axis, node) {
      return axis === "v" ? getVScrollVariables(node) : getHScrollVariables(node);
    };
    getDirectionFactor = function(axis, direction) {
      return axis === "h" && direction === "rtl" ? -1 : 1;
    };
    handleScroll = function(axis, endTarget, event, sourceDelta, noOverscroll) {
      var directionFactor = getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
      var delta = directionFactor * sourceDelta;
      var target = event.target;
      var targetInLock = endTarget.contains(target);
      var shouldCancelScroll = false;
      var isDeltaPositive = delta > 0;
      var availableScroll = 0;
      var availableScrollTop = 0;
      do {
        var _a2 = getScrollVariables(axis, target), position = _a2[0], scroll_1 = _a2[1], capacity = _a2[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
          if (elementCouldBeScrolled(axis, target)) {
            availableScroll += elementScroll;
            availableScrollTop += position;
          }
        }
        target = target.parentNode;
      } while (
        // portaled content
        !targetInLock && target !== document.body || // self content
        targetInLock && (endTarget.contains(target) || endTarget === target)
      );
      if (isDeltaPositive && (noOverscroll && availableScroll === 0 || !noOverscroll && delta > availableScroll)) {
        shouldCancelScroll = true;
      } else if (!isDeltaPositive && (noOverscroll && availableScrollTop === 0 || !noOverscroll && -delta > availableScrollTop)) {
        shouldCancelScroll = true;
      }
      return shouldCancelScroll;
    };
  }
});

// node_modules/react-remove-scroll/dist/es2015/SideEffect.js
import * as React264 from "react";
function RemoveScrollSideCar(props2) {
  var shouldPreventQueue = React264.useRef([]);
  var touchStartRef = React264.useRef([0, 0]);
  var activeAxis = React264.useRef();
  var id2 = React264.useState(idCounter2++)[0];
  var Style2 = React264.useState(function() {
    return styleSingleton();
  })[0];
  var lastProps = React264.useRef(props2);
  React264.useEffect(function() {
    lastProps.current = props2;
  }, [props2]);
  React264.useEffect(function() {
    if (props2.inert) {
      document.body.classList.add("block-interactivity-".concat(id2));
      var allow_1 = __spreadArray([props2.lockRef.current], (props2.shards || []).map(extractRef), true).filter(Boolean);
      allow_1.forEach(function(el) {
        return el.classList.add("allow-interactivity-".concat(id2));
      });
      return function() {
        document.body.classList.remove("block-interactivity-".concat(id2));
        allow_1.forEach(function(el) {
          return el.classList.remove("allow-interactivity-".concat(id2));
        });
      };
    }
    return;
  }, [props2.inert, props2.lockRef.current, props2.shards]);
  var shouldCancelEvent = React264.useCallback(function(event, parent) {
    if ("touches" in event && event.touches.length === 2) {
      return !lastProps.current.allowPinchZoom;
    }
    var touch = getTouchXY(event);
    var touchStart = touchStartRef.current;
    var deltaX = "deltaX" in event ? event.deltaX : touchStart[0] - touch[0];
    var deltaY = "deltaY" in event ? event.deltaY : touchStart[1] - touch[1];
    var currentAxis;
    var target = event.target;
    var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? "h" : "v";
    if ("touches" in event && moveDirection === "h" && target.type === "range") {
      return false;
    }
    var canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    if (!canBeScrolledInMainDirection) {
      return true;
    }
    if (canBeScrolledInMainDirection) {
      currentAxis = moveDirection;
    } else {
      currentAxis = moveDirection === "v" ? "h" : "v";
      canBeScrolledInMainDirection = locationCouldBeScrolled(moveDirection, target);
    }
    if (!canBeScrolledInMainDirection) {
      return false;
    }
    if (!activeAxis.current && "changedTouches" in event && (deltaX || deltaY)) {
      activeAxis.current = currentAxis;
    }
    if (!currentAxis) {
      return true;
    }
    var cancelingAxis = activeAxis.current || currentAxis;
    return handleScroll(cancelingAxis, parent, event, cancelingAxis === "h" ? deltaX : deltaY, true);
  }, []);
  var shouldPrevent = React264.useCallback(function(_event) {
    var event = _event;
    if (!lockStack.length || lockStack[lockStack.length - 1] !== Style2) {
      return;
    }
    var delta = "deltaY" in event ? getDeltaXY(event) : getTouchXY(event);
    var sourceEvent = shouldPreventQueue.current.filter(function(e) {
      return e.name === event.type && e.target === event.target && deltaCompare(e.delta, delta);
    })[0];
    if (sourceEvent && sourceEvent.should) {
      if (event.cancelable) {
        event.preventDefault();
      }
      return;
    }
    if (!sourceEvent) {
      var shardNodes = (lastProps.current.shards || []).map(extractRef).filter(Boolean).filter(function(node) {
        return node.contains(event.target);
      });
      var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
      if (shouldStop) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }
    }
  }, []);
  var shouldCancel = React264.useCallback(function(name, delta, target, should) {
    var event = { name, delta, target, should };
    shouldPreventQueue.current.push(event);
    setTimeout(function() {
      shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
        return e !== event;
      });
    }, 1);
  }, []);
  var scrollTouchStart = React264.useCallback(function(event) {
    touchStartRef.current = getTouchXY(event);
    activeAxis.current = void 0;
  }, []);
  var scrollWheel = React264.useCallback(function(event) {
    shouldCancel(event.type, getDeltaXY(event), event.target, shouldCancelEvent(event, props2.lockRef.current));
  }, []);
  var scrollTouchMove = React264.useCallback(function(event) {
    shouldCancel(event.type, getTouchXY(event), event.target, shouldCancelEvent(event, props2.lockRef.current));
  }, []);
  React264.useEffect(function() {
    lockStack.push(Style2);
    props2.setCallbacks({
      onScrollCapture: scrollWheel,
      onWheelCapture: scrollWheel,
      onTouchMoveCapture: scrollTouchMove
    });
    document.addEventListener("wheel", shouldPrevent, nonPassive);
    document.addEventListener("touchmove", shouldPrevent, nonPassive);
    document.addEventListener("touchstart", scrollTouchStart, nonPassive);
    return function() {
      lockStack = lockStack.filter(function(inst) {
        return inst !== Style2;
      });
      document.removeEventListener("wheel", shouldPrevent, nonPassive);
      document.removeEventListener("touchmove", shouldPrevent, nonPassive);
      document.removeEventListener("touchstart", scrollTouchStart, nonPassive);
    };
  }, []);
  var removeScrollBar = props2.removeScrollBar, inert = props2.inert;
  return React264.createElement(
    React264.Fragment,
    null,
    inert ? React264.createElement(Style2, { styles: generateStyle(id2) }) : null,
    removeScrollBar ? React264.createElement(RemoveScrollBar, { gapMode: "margin" }) : null
  );
}
var getTouchXY, getDeltaXY, extractRef, deltaCompare, generateStyle, idCounter2, lockStack;
var init_SideEffect = __esm({
  "node_modules/react-remove-scroll/dist/es2015/SideEffect.js"() {
    init_tslib_es6();
    init_es20155();
    init_es20154();
    init_aggresiveCapture();
    init_handleScroll();
    getTouchXY = function(event) {
      return "changedTouches" in event ? [event.changedTouches[0].clientX, event.changedTouches[0].clientY] : [0, 0];
    };
    getDeltaXY = function(event) {
      return [event.deltaX, event.deltaY];
    };
    extractRef = function(ref12) {
      return ref12 && "current" in ref12 ? ref12.current : ref12;
    };
    deltaCompare = function(x, y) {
      return x[0] === y[0] && x[1] === y[1];
    };
    generateStyle = function(id2) {
      return "\n  .block-interactivity-".concat(id2, " {pointer-events: none;}\n  .allow-interactivity-").concat(id2, " {pointer-events: all;}\n");
    };
    idCounter2 = 0;
    lockStack = [];
  }
});

// node_modules/react-remove-scroll/dist/es2015/sidecar.js
var sidecar_default;
var init_sidecar = __esm({
  "node_modules/react-remove-scroll/dist/es2015/sidecar.js"() {
    init_es20152();
    init_SideEffect();
    init_medium2();
    sidecar_default = exportSidecar(effectCar, RemoveScrollSideCar);
  }
});

// node_modules/react-remove-scroll/dist/es2015/Combination.js
import * as React265 from "react";
var ReactRemoveScroll, Combination_default;
var init_Combination = __esm({
  "node_modules/react-remove-scroll/dist/es2015/Combination.js"() {
    init_tslib_es6();
    init_UI();
    init_sidecar();
    ReactRemoveScroll = React265.forwardRef(function(props2, ref12) {
      return React265.createElement(RemoveScroll, __assign({}, props2, { ref: ref12, sideCar: sidecar_default }));
    });
    ReactRemoveScroll.classNames = RemoveScroll.classNames;
    Combination_default = ReactRemoveScroll;
  }
});

// node_modules/react-remove-scroll/dist/es2015/index.js
var init_es20156 = __esm({
  "node_modules/react-remove-scroll/dist/es2015/index.js"() {
    init_Combination();
  }
});

// commandbar/src/shared/util/hooks/useTapToLaunchCommandBar.tsx
import { useCallback as useCallback18, useEffect as useEffect49 } from "react";
var useTapToLaunchCommandBar;
var init_useTapToLaunchCommandBar = __esm({
  "commandbar/src/shared/util/hooks/useTapToLaunchCommandBar.tsx"() {
    "use strict";
    init_useAction();
    init_service_actions4();
    init_useStore();
    init_operatingSystem();
    useTapToLaunchCommandBar = () => {
      const openBarWithOptionalText2 = useAction(openBarWithOptionalText);
      const { visible } = useStore().spotlight;
      const handleGestureStart = useCallback18(
        (e) => {
          if (e.touches.length >= 2 && !visible) {
            document.addEventListener("touchend", handleGestureEnd);
            document.addEventListener("touchmove", handleTouchMove);
          }
        },
        [visible]
      );
      const handleGestureEnd = useCallback18(
        (e) => {
          e.preventDefault();
          if (!visible) {
            openBarWithOptionalText2("programmatic");
          }
          document.removeEventListener("touchend", handleGestureEnd);
          document.removeEventListener("touchmove", handleTouchMove);
        },
        [visible]
      );
      const handleTouchMove = () => {
        document.removeEventListener("touchend", handleGestureEnd);
        document.removeEventListener("touchmove", handleTouchMove);
      };
      useEffect49(() => {
        if (isMobileDevice() && !window._cbIsWebView) {
          document.addEventListener("touchstart", handleGestureStart);
        }
        return () => {
          document.removeEventListener("touchstart", handleGestureStart);
          document.removeEventListener("touchend", handleGestureEnd);
          document.removeEventListener("touchmove", handleTouchMove);
        };
      }, []);
    };
  }
});

// commandbar/src/products/spotlight/components/MobileSpotlightContainer.tsx
import React266, { useCallback as useCallback19, useEffect as useEffect50, useState as useState33 } from "react";
import { useTheme as useTheme29 } from "emotion-theming";
var MobileSpotlightContainer;
var init_MobileSpotlightContainer = __esm({
  "commandbar/src/products/spotlight/components/MobileSpotlightContainer.tsx"() {
    "use strict";
    init_es20156();
    init_Z();
    init_useWindowSize();
    init_useAction();
    init_actions9();
    init_useStore();
    init_useTapToLaunchCommandBar();
    init_useDisableZoom();
    init_useMobileExperience();
    init_AnimatedWidget();
    window._cbIsWebView = window._cbIsWebView || false;
    MobileSpotlightContainer = ({ children }) => {
      var _a2;
      useTapToLaunchCommandBar();
      const { setZoomDisabled } = useDisableZoom();
      const { theme } = useTheme29();
      const openBarWithOptionalText2 = useAction(openBarWithOptionalText);
      const closeBarAndReset2 = useAction(closeBarAndReset);
      const _ = useStore();
      const { isStudioMobilePreview } = useMobileExperience();
      const visible = window._cbIsWebView || _.spotlight.visible;
      const { width, height } = useWindowSize_default();
      const animationDistance = Math.max(width, height);
      const [newY, setNewY] = useState33(0);
      const [scrollLockEnabled, setScrollLockEnabled] = useState33(false);
      const [isBarClosable, setIsBarClosable] = useState33(false);
      const { animStyles } = useAnimatedWidget();
      const open = () => {
        setNewY(animationDistance);
        setIsBarClosable(true);
      };
      const close = (_velocity = 0) => {
        setNewY(0);
        closeBarAndReset2();
        setIsBarClosable(false);
      };
      const handleBackdropClick = useCallback19(
        (event) => {
          if (event.target === event.currentTarget && isBarClosable) {
            close();
          }
        },
        [isBarClosable]
      );
      const disableWindowScroll = () => {
        setScrollLockEnabled(true);
      };
      const enableWindowScroll = () => {
        setScrollLockEnabled(false);
      };
      useEffect50(() => {
        if (!_.spotlight.visible && window._cbIsWebView) {
          openBarWithOptionalText2("programmatic");
          if (window.CommandBarToggleStateChannel) {
            window.CommandBarToggleStateChannel.postMessage("close");
          }
        }
      }, [_.spotlight.visible]);
      useEffect50(() => {
        if (visible) {
          open();
          disableWindowScroll();
          setZoomDisabled(true);
        } else {
          close();
          enableWindowScroll();
          setZoomDisabled(false);
        }
        return () => {
          enableWindowScroll();
        };
      }, [visible]);
      return /* @__PURE__ */ React266.createElement(
        "div",
        {
          id: "commandbar-mobile-container",
          style: {
            position: isStudioMobilePreview ? "absolute" : "fixed",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: Z_default.Z_EDITOR,
            touchAction: "none",
            backgroundColor: newY === 0 ? "transparent" : "rgba(0, 0, 0, 0.5)",
            display: newY === 0 ? "none" : "block"
          },
          onClick: handleBackdropClick
        },
        /* @__PURE__ */ React266.createElement(Combination_default, { enabled: scrollLockEnabled }, ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ React266.createElement(
          "div",
          {
            style: {
              touchAction: "none",
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: Z_default.Z_EDITOR,
              padding: "0px",
              ...!!_.flags["release-widget-animations"] ? animStyles : {
                transform: `translateY(${newY ? animationDistance - newY : 0}px`,
                transition: `transform ${newY === 0 || newY === animationDistance ? 0.5 : 0}s linear`
              }
            }
          },
          children
        ) : /* @__PURE__ */ React266.createElement(
          "div",
          {
            style: {
              touchAction: "none",
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              zIndex: Z_default.Z_EDITOR,
              backgroundColor: theme.main.background,
              borderRadius: theme.main.borderRadius,
              padding: "0px",
              boxShadow: theme.main.boxShadow,
              transform: `translateY(${newY ? animationDistance - newY : 0}px`,
              transition: `transform ${newY === 0 || newY === animationDistance ? 0.5 : 0}s linear`,
              margin: "16px"
            }
          },
          children
        ))
      );
    };
  }
});

// commandbar/src/products/spotlight/components/VideoDashboard.tsx
import { jsx as jsx96 } from "@emotion/core";
var VideoDashboard, VideoDashboard_default;
var init_VideoDashboard = __esm({
  "commandbar/src/products/spotlight/components/VideoDashboard.tsx"() {
    "use strict";
    init_location();
    init_players();
    init_Previews();
    VideoDashboard = ({ source }) => {
      const isEmbeddablePreview = !isValidURL(source) || players_default(source);
      if (isEmbeddablePreview) {
        return /* @__PURE__ */ jsx96(EmbeddedVideo, { isDashBoard: true, source: players_default(source) || source });
      } else {
        return /* @__PURE__ */ jsx96(URLVideo, { source });
      }
    };
    VideoDashboard_default = VideoDashboard;
  }
});

// commandbar/src/products/spotlight/components/HtmlDashboard.tsx
import { jsx as jsx97 } from "@emotion/core";
import { useTheme as useTheme30 } from "emotion-theming";
var HtmlDashboard, HtmlDashboard_default;
var init_HtmlDashboard = __esm({
  "commandbar/src/products/spotlight/components/HtmlDashboard.tsx"() {
    "use strict";
    init_HtmlPreview();
    HtmlDashboard = ({ source, style: style3 }) => {
      const { theme } = useTheme30();
      return /* @__PURE__ */ jsx97(
        "div",
        {
          style: {
            height: theme.bar.menuHeight,
            overflow: "auto",
            color: theme.base.fontColor,
            fontSize: "14px",
            lineHeight: 1.7,
            fontFamily: theme.base.fontFamily,
            background: theme.base.background,
            borderBottom: theme.categoryHeader.borderTop,
            textAlign: "left",
            scrollBehavior: "smooth",
            padding: "16px 10px 20px",
            ...style3
          }
        },
        /* @__PURE__ */ jsx97(HtmlPreview_default, { value: source })
      );
    };
    HtmlDashboard_default = HtmlDashboard;
  }
});

// commandbar/src/products/spotlight/components/step/DashboardStepDisplay.tsx
import { jsx as jsx98 } from "@emotion/core";
import { useTheme as useTheme31 } from "emotion-theming";
import { BsArrowLeft } from "react-icons/bs";
import React267, { Fragment as Fragment11 } from "react";
var DashboardStepDisplay, DashboardStepDisplay_default;
var init_DashboardStepDisplay = __esm({
  "commandbar/src/products/spotlight/components/step/DashboardStepDisplay.tsx"() {
    "use strict";
    init_useStore();
    init_players();
    init_selectors8();
    init_Reporting();
    init_useAction();
    init_actions9();
    init_service_actions3();
    init_service_actions2();
    init_Step();
    init_VideoDashboard();
    init_HtmlDashboard();
    init_NextStepCommandsMenu();
    init_selectors3();
    init_StatusBar();
    init_command();
    init_Interpolate();
    init_Footer();
    DashboardStepDisplay = ({ source, title, description, url }) => {
      const _ = useStore();
      const { currentStep } = currentStepAndIndex(_);
      const triggerNudges = useAction(sendIndirectTrigger);
      const updateChecklists = useAction(triggerChecklists);
      const goBack = useAction(rollback);
      const goForward = useAction(submitDashboardStep);
      const { theme } = useTheme31();
      const isLastStep = selectIsFinalStep(useStore());
      const activeCommand = getActiveCommand(_);
      React267.useEffect(() => {
        var _a2;
        if (isLastStep) {
          const commandToReport = activeCommand || isDashboardStep(currentStep) && currentStep.command;
          if (commandToReport) {
            execution(commandToReport, _.spotlight.inputText || _.spotlight.previousInputText, {
              categoryText: (_a2 = _.spotlight.categories.find((c) => c.id === commandToReport.category)) == null ? void 0 : _a2.name
            });
          }
          if (activeCommand) {
            triggerNudges(
              {
                type: "on_command_execution",
                meta: { command: commandUID(activeCommand) }
              },
              {
                // Trigger commands directly trigger nudges and should work when the admin is logged in
                admin: activeCommand.template.type === "trigger"
              }
            );
            updateChecklists({
              type: "on_command_execution",
              meta: { command: commandUID(activeCommand) }
            });
          }
        }
      }, [activeCommand]);
      const handleEscape = useAction((_2, e) => {
        if (e.key === "Escape") {
          goBack();
        }
      });
      const handleEnter = useAction((_2, e) => {
        if (e.key === "Enter") {
          goForward();
        }
      });
      React267.useEffect(() => {
        document.addEventListener("keyup", handleEscape, true);
        return () => {
          document.removeEventListener("keyup", handleEscape, true);
        };
      }, [handleEscape]);
      React267.useEffect(() => {
        document.addEventListener("keydown", handleEnter, true);
        return () => {
          document.removeEventListener("keydown", handleEnter, true);
        };
      }, [handleEnter]);
      if (!currentStep || !_.spotlight.visible) {
        return null;
      }
      return /* @__PURE__ */ jsx98(
        "div",
        {
          css: {
            width: "100%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            position: "relative",
            fontSize: "14px",
            background: theme.input.background,
            borderRadius: theme.input.borderRadius
          }
        },
        isLastStep && /* @__PURE__ */ jsx98(
          "div",
          {
            css: {
              position: "absolute",
              top: "10px",
              left: "10px",
              background: "rgba(255, 255, 255, 0.35)",
              boxShadow: "0 4px 30px rgb(0 0 0 / 10%)",
              borderRadius: "4px",
              backdropFilter: "blur(6px)",
              color: "rgba(0,0,0,0.5)",
              padding: "3px 12px",
              zIndex: 2,
              cursor: "pointer",
              fontSize: "0.85em",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              transition: "all 0.3s ease-in",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.7)",
                color: "rgba(0, 0, 0, 1)"
              }
            },
            tabIndex: 0,
            onClick: goBack,
            role: "button",
            onKeyDown: (e) => {
              if (e.key === "Enter") {
                goBack();
              }
            }
          },
          /* @__PURE__ */ jsx98(BsArrowLeft, { style: { marginRight: "4px" } }),
          "Back"
        ),
        !!isLastStep ? /* @__PURE__ */ jsx98(Fragment11, null, !!url && // eslint-disable-next-line jsx-a11y/click-events-have-key-events
        /* @__PURE__ */ jsx98(
          "div",
          {
            css: {
              position: "absolute",
              top: "10px",
              right: "10px",
              marginLeft: "6px",
              padding: "3px 12px",
              borderRadius: "4px",
              background: "rgba(255, 255, 255, 0.35)",
              boxShadow: "0 4px 30px rgb(0 0 0 / 10%)",
              fontFamily: theme.main.fontFamily,
              color: "rgba(0,0,0,0.5)",
              fontSize: "0.85em",
              "&:hover": {
                background: "rgba(255, 255, 255, 0.7)",
                color: "rgba(0, 0, 0, 1)"
              }
            },
            onClick: goForward,
            role: "button",
            tabIndex: 0
          },
          "Open"
        ), /* @__PURE__ */ jsx98(NextStepCommandsMenu_default, { isHidden: !isLastStep, offset: !!url ? 50 : 0 })) : /* @__PURE__ */ jsx98(StatusBar_default, null),
        (currentStep == null ? void 0 : currentStep.type) === "dashboard" /* Dashboard */ && currentStep.argument.type === "video" ? /* @__PURE__ */ jsx98(VideoDashboard_default, { source: players_default(source) || source }) : /* @__PURE__ */ jsx98(
          HtmlDashboard_default,
          {
            source,
            style: {
              ...isLastStep && { marginTop: "48px", borderTop: theme.categoryHeader.borderTop }
            }
          }
        ),
        !!title || !!description ? /* @__PURE__ */ jsx98(
          "div",
          {
            style: {
              width: "100%",
              padding: "16px 16px",
              background: theme.base.background,
              borderRadius: `0px 0px ${theme.main.borderRadius} ${theme.main.borderRadius}`,
              color: theme.base.fontColor,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }
          },
          /* @__PURE__ */ jsx98(
            "div",
            {
              css: {
                width: "100%"
              }
            },
            /* @__PURE__ */ jsx98(
              "div",
              {
                style: {
                  fontSize: "16px",
                  fontWeight: 500
                }
              },
              !!title ? interpolate(title, _, true, true) : ""
            ),
            !!description && (!isLastStep || (activeCommand == null ? void 0 : activeCommand.template.type) !== "helpdoc") && /* @__PURE__ */ jsx98(
              "p",
              {
                style: {
                  fontSize: "14px",
                  opacity: 0.9,
                  fontWeight: 400,
                  marginBottom: 0,
                  whiteSpace: "nowrap",
                  width: "100%",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  lineHeight: "1.7em"
                }
              },
              !!description ? interpolate(description, _, true, true) : ""
            )
          )
        ) : /* @__PURE__ */ jsx98(Footer_default, null)
      );
    };
    DashboardStepDisplay_default = DashboardStepDisplay;
  }
});

// commandbar/src/products/spotlight/components/Spotlight.tsx
var Spotlight_exports = {};
__export(Spotlight_exports, {
  Spotlight: () => Spotlight,
  default: () => Spotlight_default
});
import * as React268 from "react";
import { CacheProvider, jsx as jsx99 } from "@emotion/core";
import ReactDOM9 from "react-dom";
import { useMemo as useMemo16 } from "react";
var Spotlight, SpotlightContainer, ThemedSpolightContainer, Spotlight_default;
var init_Spotlight = __esm({
  "commandbar/src/products/spotlight/components/Spotlight.tsx"() {
    "use strict";
    init_assets();
    init_es2();
    init_App();
    init_style();
    init_Dashboard();
    init_CommandSelect();
    init_KeyboardShortcutCheatsheet();
    init_cache_browser_esm();
    init_selectors8();
    init_Z();
    init_useWindowSize();
    init_InlineBar();
    init_ModalSpotlightContainer();
    init_useStore();
    init_a11y();
    init_useAction();
    init_actions9();
    init_SystemPanel();
    init_selectors3();
    init_SidePanel();
    init_Logger();
    init_CustomHeader();
    init_VerticalNavPane();
    init_Step();
    init_location();
    init_MobileSpotlightContainer();
    init_DashboardStepDisplay();
    init_useCommandBarContainer();
    init_useTheme();
    init_useEmotionBugWorkaroundStyleContainer();
    init_sentry();
    init_useMobileExperience();
    init_globals();
    init_symbols();
    init_ThemeV2Context();
    init_AnimatedWidget();
    Spotlight = () => {
      var _a2;
      const sdk = getSDK();
      const _ = useStore();
      const { formFactor } = _.spotlight;
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      const menuIsOpen = selectMenuIsOpen(_);
      const { currentStep } = currentStepAndIndex(_);
      const { dashboard, refContainer } = _.spotlight;
      const content = /* @__PURE__ */ jsx99(React268.Fragment, null, /* @__PURE__ */ jsx99(
        "div",
        {
          id: "commandbar-home",
          "data-testid": "commandbar-home",
          "aria-modal": true,
          onKeyUp: (e) => {
            e.stopPropagation();
          },
          onKeyPress: (e) => {
            e.stopPropagation();
          },
          onKeyDown: (e) => {
            e.stopPropagation();
          }
        },
        /* @__PURE__ */ jsx99("style", { nonce: (_a2 = sdk[_configuration]) == null ? void 0 : _a2.nonce }, style_default),
        dashboard ? /* @__PURE__ */ jsx99(Dashboard_default, { type: dashboard }) : (currentStep == null ? void 0 : currentStep.type) === "dashboard" /* Dashboard */ ? /* @__PURE__ */ jsx99("div", { id: "commandbar-dashboard", className: "commandbar-content-container" }, /* @__PURE__ */ jsx99(DashboardStepDisplay_default, { ...currentStep.argument.value })) : /* @__PURE__ */ jsx99("div", { style: { display: "flex", flexDirection: "column" } }, /* @__PURE__ */ jsx99(CustomHeader_default, null), /* @__PURE__ */ jsx99("div", { style: { display: "flex" } }, /* @__PURE__ */ jsx99(VerticalNavPane_default, null), /* @__PURE__ */ jsx99(CommandSelect_default, { ref: refContainer }), /* @__PURE__ */ jsx99(SidePanel_default, null)))
      ), menuIsOpen && !isMobileDevice2 && !_.showWidgetTableau ? /* @__PURE__ */ jsx99(SystemPanel_default, null) : null);
      const wrapper = () => {
        switch (formFactor.type) {
          case "inline":
            return InlineBar_default;
          case "modal":
            if (isMobileDevice2)
              return MobileSpotlightContainer;
            return ModalSpotlightContainer_default;
        }
      };
      const Wrapper3 = wrapper();
      return /* @__PURE__ */ jsx99(Wrapper3, null, content);
    };
    SpotlightContainer = () => {
      var _a2, _b2, _c2, _d, _e;
      const inlineRootElementCleared = React268.useRef(false);
      const themeV2Context = useThemeV2Context();
      const closeBarAndReset2 = useAction(closeBarAndReset);
      const _ = useStore();
      const visible = isVisible(_);
      const { showKeyboardShortcutCheatsheet, formFactor } = _.spotlight;
      const { isMobileDevice: isMobileDevice2, isStudioMobilePreview, studioMobilePreviewWrapper } = useMobileExperience();
      const windowWidth = useWindowSize_default().width;
      const { theme } = useTheme();
      const { container } = useCommandBarContainer();
      if (formFactor.type === "inline" && container && !inlineRootElementCleared.current) {
        container.innerHTML = "";
        inlineRootElementCleared.current = true;
      }
      const styleContainer = useEmotionBugWorkaroundStyleContainer_default(container);
      const emotionCache = useMemo16(() => {
        var _a3, _b3;
        const sdk = getSDK();
        return cache_browser_esm_default({
          key: "commandbar-bar",
          container: styleContainer,
          // INFO: speedy mode does not work with Ruby on Rails
          // https://github.com/emotion-js/emotion/discussions/2903
          speedy: !((_a3 = _.flags) == null ? void 0 : _a3["support-ruby-on-rails"]),
          nonce: (_b3 = sdk[_configuration]) == null ? void 0 : _b3.nonce
        });
      }, [container]);
      switch (formFactor.type) {
        case "inline":
          if (!container) {
            Logger_default.error("Unable to mount; root element for 'inline' bar not found", formFactor.rootElement);
            return null;
          }
          try {
            return ReactDOM9.createPortal(
              /* @__PURE__ */ jsx99(CacheProvider, { value: emotionCache }, /* @__PURE__ */ jsx99("div", { id: "commandbar-rc-tooltip-container" }), /* @__PURE__ */ jsx99("div", { className: themeV2Context.generatedCSSClassname, css: App_default }, /* @__PURE__ */ jsx99(Spotlight, null))),
              container
            );
          } catch (e) {
            (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
            Logger_default.error(
              "Unable to mount; root element for 'inline' bar not found or not an HTMLElement",
              formFactor.rootElement,
              e
            );
            return null;
          }
        case "modal":
          if (isMobileDevice2) {
            const mobileContent = /* @__PURE__ */ jsx99(CacheProvider, { value: emotionCache }, /* @__PURE__ */ jsx99(AnimatedWidget, { widget: "spotlight", isMounted: visible }, /* @__PURE__ */ jsx99(Spotlight, null)));
            if (isStudioMobilePreview && studioMobilePreviewWrapper) {
              return ReactDOM9.createPortal(mobileContent, studioMobilePreviewWrapper);
            }
            return mobileContent;
          }
          return /* @__PURE__ */ jsx99(CacheProvider, { value: emotionCache }, /* @__PURE__ */ jsx99("div", { id: "commandbar-rc-tooltip-container" }), /* @__PURE__ */ jsx99(AnimatedWidget, { widget: "spotlight", isMounted: visible }, /* @__PURE__ */ jsx99(
            es_default2,
            {
              visible: !((_b2 = _.flags) == null ? void 0 : _b2["release-widget-animations"]) || !((_c2 = _.flags) == null ? void 0 : _c2["release-themes-v2"]) ? visible : true,
              closable: false,
              destroyOnClose: false,
              keyboard: true,
              maskStyle: { backgroundColor: "rgba(55, 55, 55, 0.95)" },
              wrapClassName: `commandbar-modal ${themeV2Context.generatedCSSClassname}`,
              wrapProps: { "aria-label": a11y_default.dialogLabel },
              className: "commandbar-dialog",
              bodyStyle: { ...((_d = _.flags) == null ? void 0 : _d["release-themes-v2"]) ? { padding: 0 } : {} },
              style: {
                ...((_e = _.flags) == null ? void 0 : _e["release-themes-v2"]) ? {
                  width: "var(--spotlight-width)",
                  top: "15%",
                  maxWidth: "95vw"
                } : {
                  fontFamily: theme.main.fontFamily,
                  backgroundColor: "transparent",
                  top: theme.bar.top,
                  width: windowWidth < parseInt(theme.bar.width, 10) ? void 0 : theme.bar.width
                }
              },
              zIndex: Z_default.Z_EDITOR,
              onClose: isStudioPreview() ? void 0 : closeBarAndReset2,
              mask: false,
              getContainer: container
            },
            /* @__PURE__ */ jsx99(Spotlight, null)
          )), showKeyboardShortcutCheatsheet && /* @__PURE__ */ jsx99(KeyboardShortcutCheatsheet_default, null));
      }
    };
    ThemedSpolightContainer = () => {
      const { organization } = useStore();
      return /* @__PURE__ */ jsx99(BindThemeV2ByUUID, { themeUUID: organization == null ? void 0 : organization.spotlight_custom_theme }, /* @__PURE__ */ jsx99(SpotlightContainer, null));
    };
    Spotlight_default = ThemedSpolightContainer;
  }
});

// commandbar/src/shared/util/hooks/useLauncherPosition.tsx
import * as React269 from "react";
var useLauncherPosition, useHelpHubLauncherPosition, useLauncherPosition_default;
var init_useLauncherPosition = __esm({
  "commandbar/src/shared/util/hooks/useLauncherPosition.tsx"() {
    "use strict";
    init_Z();
    init_helpHub();
    init_operatingSystem();
    useLauncherPosition = (isAdmin, organization) => {
      const [offsetX, setOffsetX] = React269.useState(organization.launcher_offset_x);
      const [offsetY, setOffsetY] = React269.useState(organization.launcher_offset_y);
      React269.useEffect(() => {
        setOffsetX(organization.launcher_offset_x);
        setOffsetY(organization.launcher_offset_y);
      }, [organization.launcher_offset_x, organization.launcher_offset_y]);
      const marginX = 35 + offsetX;
      const marginY = 35 + offsetY;
      const fixedStyles = {
        zIndex: Z_default.Z_LAUNCHER,
        position: "fixed",
        userSelect: "none"
      };
      let variableStyles = {};
      switch (organization.launcher_position) {
        case "topRight":
          variableStyles = {
            top: marginY,
            right: marginX
          };
          break;
        case "topLeft":
          variableStyles = {
            top: marginY,
            left: marginX
          };
          break;
        case "bottomRight":
          variableStyles = {
            bottom: marginY,
            right: marginX
          };
          break;
        case "bottomLeft":
          variableStyles = {
            bottom: marginY,
            left: marginX
          };
          break;
      }
      return {
        ...fixedStyles,
        ...variableStyles
      };
    };
    useHelpHubLauncherPosition = (_isAdmin, organization) => {
      return React269.useMemo(() => {
        if (!organization) {
          return null;
        }
        const launcherSettings = getHelpHubLauncherSettings(isMobileDevice() ? "mobile" : "desktop", organization);
        const marginX = 35 + launcherSettings.offsetX;
        const marginY = 35 + launcherSettings.offsetY;
        const fixedStyles = {
          zIndex: Z_default.Z_LAUNCHER,
          position: "fixed",
          userSelect: "none"
        };
        let variableStyles = {};
        switch (launcherSettings.position) {
          case "topRight":
            variableStyles = {
              top: marginY,
              right: marginX
            };
            break;
          case "topLeft":
            variableStyles = {
              top: marginY,
              left: marginX
            };
            break;
          case "bottomRight":
            variableStyles = {
              bottom: marginY,
              right: marginX
            };
            break;
          case "bottomLeft":
            variableStyles = {
              bottom: marginY,
              left: marginX
            };
            break;
        }
        return {
          launcherPosition: {
            ...fixedStyles,
            ...variableStyles
          },
          launcherSettings
        };
      }, [
        organization == null ? void 0 : organization.helphub_launcher_offset_x,
        organization == null ? void 0 : organization.helphub_launcher_offset_y,
        organization == null ? void 0 : organization.helphub_launcher_position,
        organization == null ? void 0 : organization.helphub_mobile_launcher_offset_x,
        organization == null ? void 0 : organization.helphub_mobile_launcher_offset_y,
        organization == null ? void 0 : organization.helphub_mobile_launcher_position,
        organization == null ? void 0 : organization.helphub_launcher_type,
        organization == null ? void 0 : organization.helphub_mobile_launcher_type
      ]);
    };
    useLauncherPosition_default = useLauncherPosition;
  }
});

// commandbar/src/shared/img/bolt.svg
import * as React270 from "react";
var SvgBolt;
var init_bolt = __esm({
  "commandbar/src/shared/img/bolt.svg"() {
    "use strict";
    SvgBolt = (props2) => /* @__PURE__ */ React270.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 682.667, height: 682.667, viewBox: "0 0 512 512", ...props2 }, /* @__PURE__ */ React270.createElement("path", { d: "M284.5 91.3c-33.1 38.6-93.4 109.1-134 156.5-40.7 47.5-74.1 86.8-74.3 87.3-.2.5 31.4.9 77.7.9H232v2.2c0 1.2-3.4 35.7-7.5 76.7-4.2 40.9-7.4 74.8-7.3 75.3.3.9 217.9-257.2 218.6-259.2.2-.6-29.9-1-82.3-1-70.4 0-82.6-.2-82.2-1.4 5.3-13.9 73.7-206.1 73.5-206.7-.2-.4-27.3 30.9-60.3 69.4z" }));
  }
});

// commandbar/src/shared/components/launcher/SpotlightLauncher.tsx
import { css as css59, jsx as jsx100, keyframes as keyframes10 } from "@emotion/core";
import chroma20 from "chroma-js";
var SpotlightLauncher, OSKeys, SpotlightLauncher_default;
var init_SpotlightLauncher = __esm({
  "commandbar/src/shared/components/launcher/SpotlightLauncher.tsx"() {
    "use strict";
    init_useLauncherPosition();
    init_bolt();
    init_operatingSystem();
    init_useStore();
    init_service_selectors4();
    init_HotkeyTag();
    init_chroma();
    init_useTheme();
    SpotlightLauncher = (props2) => {
      var _a2, _b2, _c2, _d;
      const { isAdmin, organization } = props2;
      const launcherPosition = useLauncherPosition_default(isAdmin, organization);
      const summonHotkey = selectSummonHotkey(useStore());
      const { flags } = useStore();
      const { theme } = useTheme();
      const theme_primary = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--base-accent)" : (_a2 = theme.base) == null ? void 0 : _a2.primary;
      const theme_background = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--background-primary)" : (_b2 = theme.launcher) == null ? void 0 : _b2.background;
      const theme_fontFamily = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--font-font-family)" : (_c2 = theme.main) == null ? void 0 : _c2.fontFamily;
      const theme_color = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--base-accent)" : (_d = theme.main) == null ? void 0 : _d.color;
      let LAUNCHER_WIDTH = 0;
      const showSummonHotkey = () => {
        return !isMobileDevice() && !!summonHotkey;
      };
      const entryAnimation = keyframes10`
  0% {
    transform: scale(0.06);
  }
  100% {
    transform: scale(1);
  }
`;
      let toRet = /* @__PURE__ */ jsx100("div", null);
      switch (organization == null ? void 0 : organization.launcher_type) {
        case "none":
          return null;
        case "minimal":
          let hoverBackground = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--background-primary-hover)" : theme.main.background;
          try {
            if (!(flags == null ? void 0 : flags["release-themes-v2"])) {
              hoverBackground = chroma20(hoverBackground).alpha(0.98).css();
            }
          } catch (e) {
          }
          const icon = /* @__PURE__ */ jsx100(
            SvgBolt,
            {
              id: "bolt",
              width: "26px",
              height: "26px",
              fill: theme_primary,
              style: {
                transition: "all .3s ease-in-out",
                verticalAlign: "baseline"
              }
            }
          );
          LAUNCHER_WIDTH = 50;
          toRet = /* @__PURE__ */ jsx100("div", { className: "commandbar-launcher", style: launcherPosition }, /* @__PURE__ */ jsx100(
            "div",
            {
              "aria-hidden": true,
              css: css59`
              padding: 9px 10px;
              color: ${theme_color};
              background-color: ${theme_background};
              border-radius: 27px;
              box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;
              font-family: ${theme_fontFamily};
              line-height: 1;
              transition: all 0.2s ease-in-out;
              animation: ${entryAnimation} 0.25s ease-out;
              &:hover {
                background-color: ${hoverBackground};
                cursor: pointer;
                transform: scale(1.3);
              }
            `,
              onClick: props2.onClick
            },
            icon
          ));
          break;
        case "alternate":
          LAUNCHER_WIDTH = showSummonHotkey() ? 70 : 0;
          toRet = /* @__PURE__ */ jsx100("div", { className: "commandbar-launcher", style: launcherPosition }, /* @__PURE__ */ jsx100(
            "div",
            {
              "aria-hidden": true,
              "data-testid": "launcher",
              css: css59`
              display: flex;
              justify-content: space-around;
              padding: 10px 8px;
              color: ${theme_color};
              background-color: ${theme_background};
              border-radius: 4px;
              box-shadow: 6px 8px 14px 0px rgba(0, 0, 0, 0.22);
              font-size: 13px;
              font-family: ${theme_fontFamily};
              min-width: ${LAUNCHER_WIDTH}px;
              transition: all 0.3s ease-in-out;
              line-height: 1;
              cursor: pointer;
              animation: ${entryAnimation} 0.25s ease-out;

              &:hover {
                box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.16);
                color: ${theme_color};
                cursor: pointer;
                transition: all 0.3s ease-in-out;
                transform: scale(1.1);

                #bolt {
                  transform: scale(1.2);
                  transition: all 0.3s ease-in-out;
                }
              }
            `,
              onClick: props2.onClick
            },
            /* @__PURE__ */ jsx100(
              "div",
              {
                style: { display: "flex", alignItems: "center", padding: showSummonHotkey() ? "4px 9px 4px 0px" : "4px" }
              },
              /* @__PURE__ */ jsx100(
                SvgBolt,
                {
                  id: "bolt",
                  width: "14px",
                  height: "14px",
                  fill: theme_primary,
                  style: { transition: "all .3s ease-in-out", verticalAlign: "baseline", lineHeight: 1 }
                }
              )
            ),
            showSummonHotkey() && /* @__PURE__ */ jsx100("div", null, OSKeys(theme_primary, summonHotkey))
          ));
          break;
        case "prompt":
          LAUNCHER_WIDTH = showSummonHotkey() ? 150 : 0;
          toRet = /* @__PURE__ */ jsx100("div", { className: "commandbar-launcher", style: launcherPosition }, /* @__PURE__ */ jsx100(
            "div",
            {
              "aria-hidden": true,
              css: css59`
              display: flex;
              justify-content: space-between;
              padding: 4px 8px;
              color: #8792a2;
              background-color: #f7fafc;
              border-radius: 4px;
              box-shadow: 4px 5px 10px 0px rgba(0, 0, 0, 0.16);
              font-size: 13px;
              font-family: ${theme_fontFamily};
              min-width: ${LAUNCHER_WIDTH}px;
              transition: all 0.3s ease-in-out;
              line-height: 2;
              cursor: pointer;

              &:hover {
                box-shadow: 2px 2px 2px 0px rgba(0, 0, 0, 0.16);
                color: #697386;
                cursor: pointer;
                transition: all 0.3s ease-in-out;

                #bolt {
                  transform: scale(1.3);
                  transition: all 0.3s ease-in-out;
                }
              }
            `,
              onClick: props2.onClick
            },
            /* @__PURE__ */ jsx100("div", { style: { padding: "1px 4px 0px 0px" } }, /* @__PURE__ */ jsx100(
              SvgBolt,
              {
                id: "bolt",
                width: "14px",
                height: "14px",
                fill: theme_primary,
                style: { transition: "all .3s ease-in-out", verticalAlign: "baseline" }
              }
            )),
            /* @__PURE__ */ jsx100("div", null, "Find anything"),
            showSummonHotkey() && /* @__PURE__ */ jsx100("div", { style: { flexGrow: 1 } }) && OSKeys(theme_primary, summonHotkey)
          ));
          break;
      }
      return toRet;
    };
    OSKeys = (color, summonHotkey) => {
      const Tag4 = (props2) => {
        return /* @__PURE__ */ jsx100(
          "span",
          {
            css: css59`
          background-color: ${getChromaColor(color).alpha(0.2).css()};
          border-radius: 2px;
          font-size: 12px;
          padding: 3px 5px;
          color: ${color};
        `
          },
          props2.children
        );
      };
      if (summonHotkey === "mod+k") {
        return /* @__PURE__ */ jsx100("div", { style: { display: "flex", justifyContent: "flex-end", alignItems: "center", lineHeight: 1, height: "100%" } }, /* @__PURE__ */ jsx100(Tag4, null, osControlKey()), "\xA0\xA0", /* @__PURE__ */ jsx100(Tag4, null, "K"));
      } else {
        return /* @__PURE__ */ jsx100(HotkeyTag_default, { combo: summonHotkey });
      }
    };
    SpotlightLauncher_default = SpotlightLauncher;
  }
});

// commandbar/src/shared/components/launcher/SpotlightLauncherContainer.tsx
var SpotlightLauncherContainer_exports = {};
__export(SpotlightLauncherContainer_exports, {
  default: () => SpotlightLauncherContainer_default
});
import * as React271 from "react";
import { jsx as jsx101 } from "@emotion/core";
var SpotlightLauncherContainer, SpotlightLauncherContainer_default;
var init_SpotlightLauncherContainer = __esm({
  "commandbar/src/shared/components/launcher/SpotlightLauncherContainer.tsx"() {
    "use strict";
    init_SpotlightLauncher();
    init_dispatchCustomEvent();
    init_useStore();
    init_useAction();
    init_service_actions4();
    init_useMobileExperience();
    init_location();
    SpotlightLauncherContainer = () => {
      const onLauncherClick = useAction(toggleBarFromLauncher);
      const store = useStore();
      const { isAdmin, organization } = store;
      const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
      React271.useEffect(() => {
        dispatchCustomEvent("commandbar-launcher-ready", {});
      }, []);
      if (!organization || (organization == null ? void 0 : organization.launcher_type) === "none" || isMobileDevice2 || isStudioPreview()) {
        return /* @__PURE__ */ jsx101("div", null);
      }
      return /* @__PURE__ */ jsx101("span", null, /* @__PURE__ */ jsx101(SpotlightLauncher_default, { onClick: onLauncherClick, isAdmin, organization }));
    };
    SpotlightLauncherContainer_default = SpotlightLauncherContainer;
  }
});

// internal/src/client/themesV2/components/nudge/StyledNudgeModal.tsx
import { css as css60, jsx as jsx102 } from "@emotion/core";
var styles44, surveyStyles4, Modal, StyledNudgeModal, StyledNudgeModal_default;
var init_StyledNudgeModal = __esm({
  "internal/src/client/themesV2/components/nudge/StyledNudgeModal.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_es2();
    init_Z();
    styles44 = css60({
      display: "flex",
      width: "var(--modal-width) !important",
      flexDirection: "column",
      alignItems: "flex-start",
      borderRadius: "var(--layout-radius-card)",
      border: "1px solid var(--border-primary)",
      background: "var(--background-primary)",
      boxShadow: "var(--layout-shadow) var(--layout-shadow-color)",
      a: {
        color: "var(--content-link)",
        textDecoration: "none",
        "&:hover": {
          color: "var(--content-link-hover)",
          textDecoration: "underline"
        }
      }
    });
    surveyStyles4 = css60({
      width: "unset !important"
    });
    Modal = styled_browser_esm_default(es_default2)`
  z-index: ${Z_default.Z_NUDGE};
`;
    StyledNudgeModal = ({ survey, organization, ...props2 }) => {
      return /* @__PURE__ */ jsx102(Modal, { css: [styles44, survey && surveyStyles4, props2.style].filter(Boolean), ...props2 });
    };
    StyledNudgeModal_default = StyledNudgeModal;
  }
});

// commandbar/src/products/nudges/components/Modal/Layout.tsx
import React272 from "react";
var Layout4;
var init_Layout4 = __esm({
  "commandbar/src/products/nudges/components/Modal/Layout.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_DraftFooter();
    init_editorUtils();
    init_branding();
    init_useAction();
    init_useMobileExperience();
    init_useStore();
    init_useTheme();
    init_languages();
    init_Z();
    init_StyledCloseButtonContainer();
    init_StyledNudgeCloseButton();
    init_StyledNudgeModal();
    init_StyledNudgeStepCounter();
    init_StyledNudgeTitleBlock();
    init_StyledFooter();
    init_StyledPoweredBy();
    init_LocalStorage();
    init_location();
    init_actions6();
    init_selectors5();
    init_Actions();
    init_ContentContainer();
    init_LayoutTemplate();
    init_RenderNudge();
    init_utils4();
    init_AnimatedWidget();
    Layout4 = ({
      nudge,
      step,
      renderMode,
      handleLinkClick,
      stepIndex,
      stepCount,
      styles: styles51,
      service
    }) => {
      var _a2, _b2;
      const _ = useStore();
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const { animStyles, onExit, isAnimatedWidget } = useAnimatedWidget();
      const dismissCallback = useAction(dismissNudge);
      const dismiss = (nudge2, renderMode2) => {
        onExit(() => {
          dismissCallback(nudge2, renderMode2);
        });
      };
      const { isMobileDevice: isMobileDevice2, isStudioMobilePreview, studioMobilePreviewWrapper, mobileStyles } = useMobileExperience();
      const commandBarWrapper = document.getElementById("commandbar-wrapper");
      const commandBarWrapperRect = commandBarWrapper == null ? void 0 : commandBarWrapper.getBoundingClientRect();
      const editorWidth = Number(LocalStorage_default.get("width", "770"));
      const openEditorAdjustment = renderMode === 1 /* MOCK */ ? editorWidth + 8 : 0;
      const editorOpen = Number(LocalStorage_default.get("editor.open", false)) && isEditorOpen();
      const closeOnOutsideClick = ((_a2 = step.form_factor) == null ? void 0 : _a2.click_outside_of_modal_to_close) && !isStudioPreview();
      const close = isNudgeDismissible(nudge) ? /* @__PURE__ */ React272.createElement(StyledCloseButtonContainer_default, null, /* @__PURE__ */ React272.createElement(StyledNudgeCloseButton_default, { themeV2, onClick: () => dismiss(nudge, renderMode) })) : null;
      const header = /* @__PURE__ */ React272.createElement(
        StyledNudgeTitleBlock_default,
        {
          title: step.title,
          content: getFirstMarkdownBlock(step.content),
          dismissible: isNudgeDismissible(nudge),
          handleContentLinkClick: handleLinkClick
        }
      );
      const media = /* @__PURE__ */ React272.createElement(
        ContentContainer_default,
        {
          styleOverrides: {
            margin: "8px 0"
          },
          step,
          stepIndex,
          service,
          markdownStyles: styles51.content,
          primaryButtonStyles: styles51.ctaButton,
          secondaryButtonStyles: styles51.ctaSecondaryButton,
          snoozeButtonStyles: styles51.snoozeButton,
          stepCountStyles: styles51.stepCount,
          stepCount,
          renderMode,
          snoozable: isNudgeSnoozable(nudge),
          snoozeLabel: nudge.snooze_label,
          snoozable_on_all_steps: nudge.snoozable_on_all_steps,
          handleContentLinkClick: handleLinkClick
        }
      );
      const stepCounter = stepCount ? /* @__PURE__ */ React272.createElement(StyledNudgeStepCounter_default, { stepCount }) : null;
      const actions2 = /* @__PURE__ */ React272.createElement(
        Actions,
        {
          step,
          stepIndex,
          renderMode,
          snooze: {
            enabled: isNudgeSnoozable(nudge),
            label: nudge.snooze_label,
            enabledOnAllSteps: nudge.snoozable_on_all_steps,
            duration: nudge.snooze_duration
          },
          service,
          stepCount
        }
      );
      const footer = /* @__PURE__ */ React272.createElement(React272.Fragment, null, ((_b2 = _.organization) == null ? void 0 : _b2.branding) === "branded" && /* @__PURE__ */ React272.createElement(StyledFooter_default, null, /* @__PURE__ */ React272.createElement(
        StyledPoweredBy_default,
        {
          onClick: () => navigateToBrandingSite(_.organization),
          text: translate("Powered by Command AI")
        }
      )), !nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ React272.createElement(DraftFooter, { details: { type: "nudge", nudge, stepIndex } }));
      return /* @__PURE__ */ React272.createElement(
        StyledNudgeModal_default,
        {
          organization: _.organization,
          survey: !!(step == null ? void 0 : step.content.find((block) => block.type === "survey_rating")),
          "data-testid": `commandbar-modal-${nudge.id}-${String(step == null ? void 0 : step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
          "aria-modal": "true",
          "aria-live": "polite",
          onClose: (e) => {
            if (isNudgeDismissible(nudge)) {
              if (e.type === "keydown" || e.type === "click" && closeOnOutsideClick) {
                dismiss(nudge, renderMode);
              }
            }
          },
          wrapClassName: `commandbar-nudge-modal${renderMode === 1 /* MOCK */ ? "-mock" : ""} ${themeV2.generatedCSSClassname}`,
          wrapStyle: isStudioMobilePreview ? mobileStyles.nudges.modal.wrap : {
            marginLeft: isStudioPreview() ? commandBarWrapperRect == null ? void 0 : commandBarWrapperRect.left : void 0,
            marginRight: (
              // modal should be centered halfway between the open editor and the left side of the page
              !isStudioPreview() && editorOpen ? openEditorAdjustment : 0
            )
          },
          maskStyle: {
            ...isStudioMobilePreview ? mobileStyles.nudges.modal.mask : {
              backgroundColor: theme.nudgeModal.maskBackgroundColor,
              zIndex: Z_default.Z_EDITOR - 2,
              marginLeft: isStudioPreview() ? commandBarWrapperRect == null ? void 0 : commandBarWrapperRect.left : void 0
            },
            // When the animation is not instant, we need to apply a similar timing function/opacity fade to the mask, but specifically
            // ignore the transform or any other transition properties that are not opacity since the mask should not animate other than fade
            ...isAnimatedWidget && {
              opacity: animStyles.opacity,
              transitionProperty: "opacity",
              transitionDuration: animStyles.transitionDuration,
              transitionTimingFunction: animStyles.transitionTimingFunction
            }
          },
          getContainer: isStudioMobilePreview && studioMobilePreviewWrapper ? () => studioMobilePreviewWrapper : void 0,
          modalRender: () => /* @__PURE__ */ React272.createElement(
            LayoutTemplate,
            {
              layout: isMobileDevice2 ? "classic" : step.form_factor.layout,
              headerAndMarkdown: header,
              close,
              media,
              footer,
              actions: actions2,
              stepCounter,
              columnWidth: "var(--modal-width)"
            }
          ),
          style: {
            width: step.form_factor.layout === "horizontal" && !isMobileDevice2 ? "auto !important" : void 0,
            maxWidth: step.form_factor.layout === "horizontal" && !isMobileDevice2 ? "100%" : void 0,
            ...animStyles
          },
          visible: true,
          keyboard: true
        }
      );
    };
  }
});

// commandbar/src/products/nudges/components/Modal/index.tsx
import { jsx as jsx103 } from "@emotion/core";
import { useTheme as useTheme32 } from "emotion-theming";
var getStyles6, Modal2, ModalContainer, Modal_default;
var init_Modal = __esm({
  "commandbar/src/products/nudges/components/Modal/index.tsx"() {
    "use strict";
    init_es2();
    init_Z();
    init_location();
    init_LocalStorage();
    init_CloseButton();
    init_PoweredBy();
    init_DraftFooter();
    init_useStore();
    init_ContentContainer();
    init_editorUtils();
    init_RenderNudge();
    init_selectors5();
    init_nudges();
    init_useAction();
    init_actions6();
    init_useMobileExperience();
    init_AnimatedWidget();
    init_ThemeV2Context();
    init_useLinkClickHandler();
    init_Layout4();
    init_SurveyResponseProvider();
    getStyles6 = (theme, width, margin) => ({
      container: {
        width: width != null ? width : theme.nudgeModal.width,
        height: theme.nudgeModal.height,
        margin,
        borderRadius: theme.nudgeModal.borderRadius,
        boxShadow: theme.nudgeModal.boxShadow,
        backgroundColor: theme.nudgeModal.background,
        fontFamily: theme.nudgeModal.fontFamily,
        color: theme.nudgeModal.color
      },
      body: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: theme.nudgeModal.gap,
        padding: theme.nudgeModal.padding
      },
      header: { display: "flex", justifyContent: "space-between", alignItems: "center" },
      title: {
        fontFamily: theme.nudgeModal.titleFontFamily,
        fontWeight: theme.nudgeModal.titleFontWeight,
        fontSize: theme.nudgeModal.titleFontSize,
        lineHeight: theme.nudgeModal.titleLineHeight,
        color: theme.nudgeModal.titleColor,
        margin: "0"
      },
      content: {
        fontFamily: theme.nudgeModal.contentFontFamily,
        fontWeight: theme.nudgeModal.contentFontWeight,
        fontSize: theme.nudgeModal.contentFontSize,
        lineHeight: theme.nudgeModal.contentLineHeight
      },
      ctaButton: {
        padding: theme.nudgeModal.ctaPadding,
        background: theme.nudgeModal.ctaBackground,
        color: theme.nudgeModal.ctaColor,
        border: theme.nudgeModal.ctaBorder,
        boxShadow: theme.nudgeModal.ctaBoxShadow,
        textShadow: theme.nudgeModal.ctaTextShadow,
        borderRadius: theme.nudgeModal.ctaBorderRadius,
        fontFamily: theme.nudgeModal.ctaFontFamily,
        fontSize: theme.nudgeModal.ctaFontSize,
        lineHeight: theme.nudgeModal.ctaLineHeight,
        fontWeight: theme.nudgeModal.ctaFontWeight
      },
      ctaSecondaryButton: {
        fontFamily: theme.nudgeModal.ctaSecondaryFontFamily,
        padding: theme.nudgeModal.ctaSecondaryPadding,
        background: theme.nudgeModal.ctaSecondaryBackground,
        color: theme.nudgeModal.ctaSecondaryColor,
        border: theme.nudgeModal.ctaSecondaryBorder,
        boxShadow: theme.nudgeModal.ctaSecondaryBoxShadow,
        textShadow: theme.nudgeModal.ctaSecondaryTextShadow,
        borderRadius: theme.nudgeModal.ctaSecondaryBorderRadius,
        fontSize: theme.nudgeModal.ctaSecondaryFontSize,
        lineHeight: theme.nudgeModal.ctaSecondaryLineHeight,
        fontWeight: theme.nudgeModal.ctaSecondaryFontWeight
      },
      snoozeButton: {
        background: theme.nudgeModal.snoozeButtonBackground,
        fontFamily: theme.nudgeModal.snoozeButtonFontFamily,
        color: theme.nudgeModal.snoozeButtonColor,
        border: theme.nudgeModal.snoozeButtonBorder,
        textShadow: theme.nudgeModal.snoozeButtonTextShadow,
        fontSize: theme.nudgeModal.snoozeButtonFontSize,
        lineHeight: theme.nudgeModal.snoozeButtonLineHeight,
        fontWeight: theme.nudgeModal.snoozeButtonFontWeight,
        width: theme.nudgeModal.snoozeButtonWidth
      },
      ctaButtonWithStepCounter: {
        display: "inline-flex",
        justifyContent: "flex-end"
      },
      closeButtonOverrides: {
        position: "absolute",
        top: "16px",
        right: "16px"
      },
      draft: {
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "4px 10px 4px 8px",
        background: "#FFFCF2",
        borderTop: "1px solid #F0EDE3",
        fontSize: "12px",
        borderBottomLeftRadius: theme.nudges.borderRadius,
        borderBottomRightRadius: theme.nudges.borderRadius
      },
      draftStatus: {
        boxSizing: "border-box",
        width: "8px",
        height: "8px",
        background: "#EDBE19",
        border: "1px solid #B18F15",
        boxShadow: "0px 0px 4px #EDBE19",
        borderRadius: "10px",
        marginRight: "5px"
      },
      stepCount: {
        color: theme.nudgeModal.stepCountColor,
        fontFamily: theme.nudgeModal.stepCountFontFamily,
        fontSize: theme.nudgeModal.stepCountFontSize,
        fontWeight: theme.nudgeModal.stepCountFontWeight
      }
    });
    Modal2 = ({ nudge, stepIndex, renderMode, stepCount }) => {
      var _a2;
      const { theme } = useTheme32();
      const _ = useStore();
      const { onExit } = useAnimatedWidget();
      const { isMobileDevice: isMobileDevice2, isStudioMobilePreview, studioMobilePreviewWrapper, mobileStyles } = useMobileExperience();
      const step = getNudgeStep(nudge, stepIndex);
      const styles51 = getStyles6(
        theme,
        !isMobileDevice2 && !!(step == null ? void 0 : step.content.some((block) => (block == null ? void 0 : block.type) === "survey_rating" && block.meta.options === 10)) ? "auto" : isMobileDevice2 ? "100%" : void 0,
        isMobileDevice2 ? "16px" : "0px"
      );
      const dismissible = isNudgeDismissible(nudge);
      const snoozable = isNudgeSnoozable(nudge);
      const getService = useAction(getNudgeService);
      const dismissAction = useAction(dismissNudge);
      const dismiss = (nudge2, renderMode2) => {
        onExit(() => dismissAction(nudge2, renderMode2));
      };
      const handleLinkClick = useLinkClickHandler(() => dismiss(nudge, renderMode));
      const service = renderMode !== 1 /* MOCK */ ? getService(nudge.id) : void 0;
      const commandBarWrapper = document.getElementById("commandbar-wrapper");
      const commandBarWrapperRect = commandBarWrapper == null ? void 0 : commandBarWrapper.getBoundingClientRect();
      const editorWidth = Number(LocalStorage_default.get("width", "770"));
      const openEditorAdjustment = renderMode === 1 /* MOCK */ ? editorWidth + 8 : 0;
      const editorOpen = Number(LocalStorage_default.get("editor.open", false)) && isEditorOpen();
      return /* @__PURE__ */ jsx103(SurveyResponseProvider, { service, step }, ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx103(
        Layout4,
        {
          nudge,
          step,
          renderMode,
          handleLinkClick,
          styles: styles51,
          service,
          stepCount,
          stepIndex
        }
      ) : /* @__PURE__ */ jsx103(
        es_default2,
        {
          "data-testid": `commandbar-modal-${nudge.id}-${String(step == null ? void 0 : step.id)}${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
          "aria-modal": "true",
          "aria-live": "polite",
          zIndex: Z_default.Z_EDITOR - 1,
          onClose: (e) => {
            if (dismissible) {
              if (e.type === "keydown") {
                dismiss(nudge, renderMode);
              }
            }
          },
          wrapClassName: `commandbar-nudge-modal${renderMode === 1 /* MOCK */ ? "-mock" : ""}`,
          wrapStyle: isStudioMobilePreview ? mobileStyles.nudges.modal.wrap : {
            marginLeft: isStudioPreview() ? commandBarWrapperRect == null ? void 0 : commandBarWrapperRect.left : void 0,
            marginRight: (
              // modal should be centered halfway between the open editor and the left side of the page
              !isStudioPreview() && editorOpen ? openEditorAdjustment : 0
            )
          },
          maskStyle: isStudioMobilePreview ? mobileStyles.nudges.modal.mask : {
            backgroundColor: theme.nudgeModal.maskBackgroundColor,
            zIndex: Z_default.Z_EDITOR - 2,
            marginLeft: isStudioPreview() ? commandBarWrapperRect == null ? void 0 : commandBarWrapperRect.left : void 0
          },
          style: {
            maxWidth: "100vw",
            maxHeight: "100vh",
            ...styles51.container,
            ...isMobileDevice2 && mobileStyles.nudges.modal.container
          },
          getContainer: isStudioMobilePreview && studioMobilePreviewWrapper ? () => studioMobilePreviewWrapper : void 0,
          modalRender: () => {
            return /* @__PURE__ */ jsx103("div", { style: isStudioMobilePreview ? mobileStyles.nudges.modal.contentContainer : {} }, /* @__PURE__ */ jsx103("div", { style: styles51.body }, /* @__PURE__ */ jsx103("div", { style: styles51.header }, /* @__PURE__ */ jsx103("h2", { id: "commandbar-nudge-title", style: styles51.title }, step == null ? void 0 : step.title), dismissible && /* @__PURE__ */ jsx103(CloseButton_default, { onInteraction: () => dismiss(nudge, renderMode) })), step && /* @__PURE__ */ jsx103(
              ContentContainer_default,
              {
                styleOverrides: {
                  margin: "8px 0"
                },
                step,
                service,
                markdownStyles: styles51.content,
                primaryButtonStyles: styles51.ctaButton,
                secondaryButtonStyles: styles51.ctaSecondaryButton,
                snoozeButtonStyles: styles51.snoozeButton,
                stepCountStyles: styles51.stepCount,
                stepCount,
                renderMode,
                snoozable,
                snoozeLabel: nudge.snooze_label,
                handleContentLinkClick: handleLinkClick,
                stepIndex,
                snoozable_on_all_steps: nudge.snoozable_on_all_steps
              }
            )), /* @__PURE__ */ jsx103(
              PoweredBy_default,
              {
                style: {
                  padding: "8px 0px",
                  justifyContent: "center",
                  color: `${theme.main.color}`,
                  opacity: "0.5",
                  borderTop: `${theme.nudgeModal.poweredByBorder}`
                }
              }
            ), !nudge.is_live && renderMode === 1 /* MOCK */ && /* @__PURE__ */ jsx103(DraftFooter, { details: { type: "nudge", nudge, stepIndex } }));
          },
          visible: true,
          keyboard: true
        }
      ));
    };
    ModalContainer = (props2) => {
      return /* @__PURE__ */ jsx103(BindThemeV2ForNudge, { nudge: props2.nudge }, /* @__PURE__ */ jsx103(AnimatedWidget, { widget: "modal", isMounted: true }, /* @__PURE__ */ jsx103(Modal2, { ...props2 })));
    };
    Modal_default = ModalContainer;
  }
});

// commandbar/src/shared/components/AdminOnly.tsx
import React273 from "react";
var AdminOnly, AdminOnly_default;
var init_AdminOnly = __esm({
  "commandbar/src/shared/components/AdminOnly.tsx"() {
    "use strict";
    init_useStore();
    AdminOnly = ({ children }) => {
      const _ = useStore();
      if (!_.isAdmin) {
        return null;
      }
      return /* @__PURE__ */ React273.createElement(React273.Fragment, null, children);
    };
    AdminOnly_default = AdminOnly;
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/ConditionBlock.tsx
import React274 from "react";
var ConditionBlock;
var init_ConditionBlock = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/ConditionBlock.tsx"() {
    "use strict";
    ConditionBlock = ({ children, ...props2 }) => /* @__PURE__ */ React274.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          gap: "4px"
        },
        ...props2
      },
      children
    );
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Label.tsx
import React275 from "react";
var Label2;
var init_Label = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Label.tsx"() {
    "use strict";
    Label2 = ({ children }) => /* @__PURE__ */ React275.createElement(
      "span",
      {
        style: {
          minHeight: "16px",
          color: "#3F424A",
          fontSize: "14px",
          fontWeight: 500
        }
      },
      children
    );
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/StatusBadge.tsx
import React276 from "react";
var StatusBadge;
var init_StatusBadge = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/StatusBadge.tsx"() {
    "use strict";
    StatusBadge = ({ label, statusStyles }) => /* @__PURE__ */ React276.createElement(
      "div",
      {
        "data-testid": "commandbar-toolbar-badge",
        style: {
          display: "flex",
          height: "32px",
          paddingRight: 0,
          alignItems: "center",
          borderRadius: "4px",
          cursor: "default",
          userSelect: "none",
          padding: "0px 12px",
          gap: "8px",
          borderTopLeftRadius: "4px",
          borderBottomLeftRadius: "4px",
          alignSelf: "stretch",
          background: statusStyles.background,
          fontSize: "14px",
          fontWeight: 500,
          color: statusStyles.color
        }
      },
      statusStyles.icon,
      label
    );
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Tag.tsx
import React277 from "react";
var Tag3;
var init_Tag2 = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Tag.tsx"() {
    "use strict";
    Tag3 = ({ children, style: style3, ...props2 }) => /* @__PURE__ */ React277.createElement(
      "span",
      {
        style: {
          display: "flex",
          minHeight: "24px",
          width: "fit-content",
          padding: "4px",
          border: "1px solid #EBEBEB",
          background: "#F9F9F9",
          justifyContent: "center",
          alignItems: "center",
          gap: "8px",
          borderRadius: "4px",
          color: "#000",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "normal",
          ...style3
        },
        ...props2
      },
      children
    );
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Toggle.tsx
import React278 from "react";
var Toggle;
var init_Toggle = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Toggle.tsx"() {
    "use strict";
    Toggle = ({ onToggle, isOn }) => /* @__PURE__ */ React278.createElement(
      "button",
      {
        type: "button",
        "data-testid": "commandbar-toolbar-toggle",
        style: {
          display: "flex",
          width: "32px",
          height: "16px",
          padding: 1,
          alignItems: "center",
          borderRadius: "1000px",
          boxShadow: "0px 0px 1px 0px rgba(0, 0, 0, 0.10), 0px 0px 3px 0px rgba(66, 66, 203, 0.20)",
          cursor: "pointer",
          border: "1px solid #EBEBEB",
          background: isOn ? "#2754EE" : "#F0F0F0",
          transition: "background 0.15s ease-in-out, border 0.15s ease-in-out"
        },
        onClick: () => {
          onToggle(!isOn);
        }
      },
      /* @__PURE__ */ React278.createElement(
        "div",
        {
          style: {
            width: "14px",
            height: "14px",
            flexShrink: 0,
            borderRadius: "14px",
            background: "linear-gradient(180deg, #FFF 0%, #FFF 100%)",
            boxShadow: "0px 1.5px 3px 0px rgba(0, 0, 0, 0.10)",
            transform: isOn ? "translateX(16px)" : "translateX(0px)",
            transition: "transform 0.15s ease-in-out"
          }
        }
      )
    );
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Tooltip.tsx
import { keyframes as keyframes11 } from "@emotion/core";
import React279 from "react";
var spin, LoadingSpinner, tooltipStyles, TooltipContainer, TooltipBody, TooltipFooter, DebugTooltip, Tooltip_default2;
var init_Tooltip3 = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Tooltip.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_globals();
    init_symbols();
    init_useStore();
    init_Tooltip();
    spin = keyframes11`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;
    LoadingSpinner = styled_browser_esm_default(Loading01_default)`
  animation: ${spin} 1.5s linear infinite;
`;
    tooltipStyles = `
  .commandbar-debug-toolbar-tooltip.commandbar-debug-toolbar-tooltip-zoom-enter,
  .commandbar-debug-toolbar-tooltip.commandbar-debug-toolbar-tooltip-zoom-leave {
    display: block;
  }
  .commandbar-debug-toolbar-tooltip-zoom-enter,
  .commandbar-debug-toolbar-tooltip-zoom-appear {
    opacity: 0;
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.18, 0.89, 0.32, 1.28);
    animation-play-state: paused;
  }
  .commandbar-debug-toolbar-tooltip-zoom-leave {
    animation-duration: 0.3s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.6, -0.3, 0.74, 0.05);
    animation-play-state: paused;
  }
  .commandbar-debug-toolbar-tooltip-zoom-enter.commandbar-debug-toolbar-tooltip-zoom-enter-active,
  .commandbar-debug-toolbar-tooltip-zoom-appear.commandbar-debug-toolbar-tooltip-zoom-appear-active {
    animation-name: rcToolTipZoomIn;
    animation-play-state: running;
  }
  .commandbar-debug-toolbar-tooltip-zoom-leave.commandbar-debug-toolbar-tooltip-zoom-leave-active {
    animation-name: rcToolTipZoomOut;
    animation-play-state: running;
  }
  @keyframes rcToolTipZoomIn {
    0% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(0, 0);
    }
    100% {
      opacity: 1;
      transform-origin: 50% 50%;
      transform: scale(1, 1);
    }
  }
  @keyframes rcToolTipZoomOut {
    0% {
      opacity: 1;
      transform-origin: 50% 50%;
      transform: scale(1, 1);
    }
    100% {
      opacity: 0;
      transform-origin: 50% 50%;
      transform: scale(0, 0);
    }
  }
  .commandbar-debug-toolbar-tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    visibility: visible;
    padding: 16px 0;
  }

  .commandbar-debug-toolbar-tooltip svg {
    fill: none;
  }

  .commandbar-debug-toolbar-tooltip-hidden {
    display: none;
  }
  .commandbar-debug-toolbar-tooltip-inner > span {
    color: inherit;
  }
`;
    TooltipContainer = ({ children }) => /* @__PURE__ */ React279.createElement(
      "div",
      {
        style: {
          display: "flex",
          width: "372px",
          flexDirection: "column",
          justifyContent: "center",
          borderRadius: "8px",
          border: "1px solid #DFDFE2",
          background: "#FFF",
          color: "#000",
          fontFamily: 'Inter, "Proxima Nova", sans-serif',
          boxShadow: "0px 5px 12px 0px rgba(0, 0, 0, 0.16), 0px 1px 1px 0px rgba(0, 0, 0, 0.25)"
        }
      },
      children
    );
    TooltipBody = ({ children }) => /* @__PURE__ */ React279.createElement(
      "div",
      {
        style: {
          display: "flex",
          padding: "16px",
          flexDirection: "column",
          justifyContent: "center",
          gap: "8px"
        }
      },
      children
    );
    TooltipFooter = ({ statusStyles, message, button, loading }) => /* @__PURE__ */ React279.createElement(
      "div",
      {
        style: {
          display: "flex",
          padding: "12px 16px",
          gap: "8px",
          background: statusStyles.background,
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: 500,
          lineHeight: "normal",
          borderRadius: "0px 0px 8px 8px",
          wordBreak: "break-word",
          alignItems: button ? "start" : "center"
        }
      },
      /* @__PURE__ */ React279.createElement("div", { style: { display: "flex" } }, loading ? /* @__PURE__ */ React279.createElement(LoadingSpinner, { width: 16, height: 16, color: statusStyles.color }) : statusStyles.icon),
      /* @__PURE__ */ React279.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "8px" } }, /* @__PURE__ */ React279.createElement("div", { style: { flex: 1, ...button ? {} : { overflow: "hidden", whiteSpace: "nowrap", color: "#9A3412" } } }, message), button && /* @__PURE__ */ React279.createElement("div", { style: { display: "flex" } }, button))
    );
    DebugTooltip = ({ placement, children, ...rest }) => {
      var _a2;
      const sdk = getSDK();
      const _ = useStore();
      return /* @__PURE__ */ React279.createElement(React279.Fragment, null, /* @__PURE__ */ React279.createElement("style", { nonce: (_a2 = sdk[_configuration]) == null ? void 0 : _a2.nonce }, "$", tooltipStyles), /* @__PURE__ */ React279.createElement(
        Tooltip_default,
        {
          containerId: "commandbar-nudges-rc-tooltip-container",
          placement: (placement != null ? placement : _.nudgeDebugToolBar.position === "bottom") ? "topLeft" : "bottomLeft",
          prefixCls: "commandbar-debug-toolbar-tooltip",
          ...rest
        },
        /* @__PURE__ */ React279.createElement("div", null, children)
      ));
    };
    Tooltip_default2 = DebugTooltip;
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Limit.tsx
import React280 from "react";
var states, LimitToggle, LimitTooltip, Limit;
var init_Limit = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Limit.tsx"() {
    "use strict";
    init_popover();
    init_react();
    init_Z();
    init_useAction();
    init_useStore();
    init_selectors5();
    init_ConditionBlock();
    init_Label();
    init_StatusBadge();
    init_Tag2();
    init_Toggle();
    init_Tooltip3();
    states = {
      success: {
        background: "#E6F6D6",
        icon: /* @__PURE__ */ React280.createElement(CheckCircleBroken_default, { width: 16, height: 16, color: "#1E3706" }),
        color: "#1E3706"
      },
      warning: {
        background: "#FFF7ED",
        icon: /* @__PURE__ */ React280.createElement(AlertHexagon_default, { width: 16, height: 16, color: "#9A3412" }),
        color: "#9A3412"
      }
    };
    LimitToggle = () => {
      const _ = useStore();
      const onToggle = useAction((_2) => {
        _2.nudgeDebugToolBar.bypassGlobalLimit = !_2.nudgeDebugToolBar.bypassGlobalLimit;
      });
      const isOn = _.nudgeDebugToolBar.bypassGlobalLimit;
      return /* @__PURE__ */ React280.createElement(
        "div",
        {
          style: {
            display: "flex",
            padding: "16px",
            alignItems: "center",
            gap: "8px",
            borderTop: "1px solid #F0F0F0"
          }
        },
        /* @__PURE__ */ React280.createElement(Toggle, { onToggle, isOn }),
        /* @__PURE__ */ React280.createElement("div", { style: { display: "flex", alignItems: "center", gap: 4 } }, /* @__PURE__ */ React280.createElement(
          "span",
          {
            style: {
              color: "#3F424A",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "100%"
            }
          },
          "Ignore rate limits"
        ), /* @__PURE__ */ React280.createElement(Popover, { autoPlacement: false, placement: "bottom" }, /* @__PURE__ */ React280.createElement(PopoverTrigger, { style: { display: "flex", alignItems: "center" } }, /* @__PURE__ */ React280.createElement(InfoCircle_default, { color: "#797C85" })), /* @__PURE__ */ React280.createElement(
          PopoverContent,
          {
            labelledBy: "commandbar-limit-info",
            describedBy: "commandbar-limit-info",
            style: { width: "176px", zIndex: Z_default.Z_INDEX_MAX },
            portalToId: "commandbar-nudges-rc-tooltip-container"
          },
          /* @__PURE__ */ React280.createElement(
            "div",
            {
              style: {
                display: "flex",
                padding: "6px 12px",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "6px",
                background: "#000",
                boxShadow: "0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 1px 8px 0px rgba(0, 0, 0, 0.16)",
                color: "#FFF",
                fontSize: "14px",
                fontWeight: 500
              }
            },
            /* @__PURE__ */ React280.createElement("span", { id: "commandbar-limit-info" }, "Rate limits won't be enforced while testing")
          )
        )))
      );
    };
    LimitTooltip = ({ statusStyles, pass }) => {
      var _a2, _b2, _c2;
      const _ = useStore();
      return /* @__PURE__ */ React280.createElement(TooltipContainer, null, /* @__PURE__ */ React280.createElement(TooltipBody, null, /* @__PURE__ */ React280.createElement(ConditionBlock, null, /* @__PURE__ */ React280.createElement(Label2, null, "Limit"), /* @__PURE__ */ React280.createElement(Tag3, null, ((_a2 = _.organization) == null ? void 0 : _a2.nudge_rate_limit) ? `${(_b2 = _.organization) == null ? void 0 : _b2.nudge_rate_limit} Nudges per ${(_c2 = _.organization) == null ? void 0 : _c2.nudge_rate_period}` : "No limit"))), /* @__PURE__ */ React280.createElement(LimitToggle, null), !pass && /* @__PURE__ */ React280.createElement(TooltipFooter, { statusStyles, message: "Rate limit reached" }));
    };
    Limit = () => {
      const _ = useStore();
      const pass = _.nudgeDebugToolBar.bypassGlobalLimit || passesGlobalLimit(_);
      const statusStyles = pass ? states.success : states.warning;
      return /* @__PURE__ */ React280.createElement(Tooltip_default2, { overlay: /* @__PURE__ */ React280.createElement(LimitTooltip, { pass, statusStyles }) }, /* @__PURE__ */ React280.createElement(StatusBadge, { label: "Limit", statusStyles }));
    };
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/SecondaryButton.tsx
import { css as css61, jsx as jsx104 } from "@emotion/core";
var SecondaryButton;
var init_SecondaryButton = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/SecondaryButton.tsx"() {
    "use strict";
    SecondaryButton = ({ children, ...buttonProps }) => /* @__PURE__ */ jsx104(
      "button",
      {
        type: "button",
        css: css61`
      align-items: center;
      cursor: pointer;
      display: flex;
      height: 32px;
      padding: 8px;
      border-radius: 6px;
      border: 1px solid #d6d6d6;
      background: #fff;
      box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
      color: #3f424a;

      &:hover {
        border: 1px #8e9198 solid;
      }
      &:focus {
        box-shadow: '0px -1px 3px 0px rgba(0, 0, 0, 0.08) inset, 0px -1px 1px 0px rgba(0, 0, 0, 0.03) inset, 0px 0px 0px 3px rgba(39, 84, 238, 0.16)';
      }
    `,
        ...buttonProps
      },
      children
    );
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/useSimulationContext.tsx
import React281, { createContext as createContext5, useContext as useContext6, useEffect as useEffect53, useState as useState35 } from "react";
var SimulationContext, SimulationContextProvider, useSimulationContext;
var init_useSimulationContext = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/useSimulationContext.tsx"() {
    "use strict";
    init_messages();
    init_useAction();
    init_useStore();
    init_actions6();
    SimulationContext = createContext5(void 0);
    SimulationContextProvider = ({ children }) => {
      const _ = useStore();
      const restartPreview = useAction(restartDebugSession);
      const stopPreview = useAction(stopDebugSession);
      const [simulatedNudge, setSimulatedNudge] = useState35();
      const [currentStepIndex, setCurrentStepIndex] = useState35();
      const [lastEvent, setLastEvent] = useState35(null);
      const [lastTriggerEvent, setLastTriggerEvent] = useState35(null);
      const [isNudgeRendering, setIsNudgeRendering] = useState35(false);
      const [simulatedPreviewNudge, setSimulatedPreviewNudge] = useState35();
      useEffect53(() => {
        var _a2;
        if (simulatedNudge && (simulatedNudge == null ? void 0 : simulatedNudge.id) === ((_a2 = _.extension.preview.experience) == null ? void 0 : _a2.nudge.id)) {
          setSimulatedPreviewNudge(simulatedNudge);
        }
      }, [simulatedNudge]);
      useEffect53(() => {
        var _a2;
        let nudgeSubscription;
        const managerSubscription = (_a2 = _.nudgeManager) == null ? void 0 : _a2.subscribe(({ context, event }) => {
          var _a3;
          setLastEvent(event);
          setLastTriggerEvent(context.triggerEvent);
          if (event.type === "EXIT_RENDER_LOOP") {
            setIsNudgeRendering(false);
            setLastTriggerEvent(null);
          }
          const currentlySimulatedNudge = context.debugMode.currentNudge;
          if (currentlySimulatedNudge) {
            if (currentlySimulatedNudge.id !== (simulatedNudge == null ? void 0 : simulatedNudge.id)) {
              setCurrentStepIndex(0);
              setSimulatedNudge(currentlySimulatedNudge);
            }
            const service = (_a3 = _.nudgeManager) == null ? void 0 : _a3.getSnapshot().context.nudgeMachines.get(String(currentlySimulatedNudge.id));
            nudgeSubscription = service == null ? void 0 : service.subscribe(({ context: context2, matches }) => {
              setCurrentStepIndex(context2.stepIndex);
              setSimulatedNudge(context2.nudge);
              if (matches("Step.Render Loop")) {
                setIsNudgeRendering(true);
              }
            });
          }
        });
        return () => {
          managerSubscription == null ? void 0 : managerSubscription.unsubscribe();
          nudgeSubscription == null ? void 0 : nudgeSubscription.unsubscribe();
        };
      }, [_.nudgeManager, simulatedNudge == null ? void 0 : simulatedNudge.id]);
      if (!simulatedNudge || currentStepIndex === void 0 || _.extension.preview.enabled && !simulatedPreviewNudge) {
        return null;
      }
      const onSimulationDone = async () => {
        if (_.extension.preview.enabled && simulatedPreviewNudge) {
          StopPreviewMessage.sendToPage({
            nudge: simulatedPreviewNudge,
            currentStepIndex: simulatedNudge.id !== simulatedPreviewNudge.id ? 0 : currentStepIndex
          });
        } else if (_.nudgeDebugToolBar.closeTabWhenToolbarClosed) {
          window.close();
        } else {
          stopPreview();
        }
      };
      const onSimulationRestart = () => {
        restartPreview({ toStepIndex: 0 });
        setIsNudgeRendering(false);
        setLastTriggerEvent(null);
      };
      return /* @__PURE__ */ React281.createElement(
        SimulationContext.Provider,
        {
          value: {
            simulatedNudge,
            currentStepIndex,
            lastEvent,
            lastTriggerEvent,
            isNudgeRendering,
            onSimulationDone,
            onSimulationRestart
          }
        },
        children
      );
    };
    useSimulationContext = () => {
      const context = useContext6(SimulationContext);
      if (context === void 0) {
        throw new Error("useSimulation must be used within a SimulationProvider");
      }
      return context;
    };
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/When.tsx
import { css as css62, jsx as jsx105 } from "@emotion/core";
import isEqual13 from "lodash/isEqual";
import React282, { useCallback as useCallback20, useEffect as useEffect54, useState as useState36 } from "react";
var states2, ActionButton, WhenTooltip, When;
var init_When = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/When.tsx"() {
    "use strict";
    init_react();
    init_audience2();
    init_global_selectors();
    init_useAction();
    init_useStore();
    init_actions6();
    init_selectors5();
    init_ConditionBlock();
    init_Label();
    init_StatusBadge();
    init_Tag2();
    init_Tooltip3();
    init_useSimulationContext();
    states2 = {
      success: {
        background: "#E6F6D6",
        icon: /* @__PURE__ */ jsx105(CheckCircleBroken_default, { width: 16, height: 16, color: "#1E3706" }),
        color: "#1E3706"
      },
      info: {
        background: "#EDF1FF",
        icon: /* @__PURE__ */ jsx105(InfoCircle_default, { width: 16, height: 16, color: "#1A389D" }),
        color: "#1A389D"
      },
      warning: {
        background: "#FFF7ED",
        icon: /* @__PURE__ */ jsx105(AlertHexagon_default, { width: 16, height: 16, color: "#9A3412" }),
        color: "#9A3412"
      }
    };
    ActionButton = ({ children, ...buttonProps }) => /* @__PURE__ */ jsx105(
      "button",
      {
        type: "button",
        css: css62`
      cursor: pointer;
      color: #3f424a;
      display: flex;
      height: 32px;
      padding: 8px 11px;
      align-items: center;
      border-radius: 6px;
      border: 1px solid #d6d6d6;
      background: #fff;
      box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.08), 0px 1px 1px 0px rgba(0, 0, 0, 0.03);
      gap: 4px;

      &:hover {
        border: 1px #8e9198 solid;
      }
      &:focus {
        box-shadow: '0px -1px 3px 0px rgba(0, 0, 0, 0.08) inset, 0px -1px 1px 0px rgba(0, 0, 0, 0.03) inset, 0px 0px 0px 3px rgba(39, 84, 238, 0.16)';
      }
    `,
        ...buttonProps
      },
      children
    );
    WhenTooltip = ({ statusStyles, status, nudge, resetStatus }) => {
      const _ = useStore();
      const { onSimulationRestart } = useSimulationContext();
      const triggerNudge = useAction(sendDirectedTrigger);
      const reset2 = useAction((_store) => {
        if (nudge) {
          resetNudge(_store, nudge.id);
          resetStatus();
          onSimulationRestart();
        }
      });
      const loading = (nudge == null ? void 0 : nudge.trigger.type) !== "when_share_link_viewed" && status === "info";
      const readableTrigger = (() => {
        var _a2;
        switch (nudge == null ? void 0 : nudge.trigger.type) {
          case "on_event":
            return {
              type: "On event tracked",
              value: nudge == null ? void 0 : nudge.trigger.meta.event,
              waitingMessage: "Waiting for event..."
            };
          case "when_page_reached":
            return {
              type: "When page reached",
              value: nudge == null ? void 0 : nudge.trigger.meta.url,
              waitingMessage: "Waiting for url..."
            };
          case "on_command_execution":
            return {
              type: "Action executed",
              value: (_a2 = getCommandById(_, nudge == null ? void 0 : nudge.trigger.meta.command)) == null ? void 0 : _a2.text,
              waitingMessage: "Waiting for action..."
            };
          case "when_element_appears":
            return {
              type: "When element is visible",
              value: nudge == null ? void 0 : nudge.trigger.meta.selector,
              waitingMessage: "Waiting for element to become visible..."
            };
          case "when_share_link_viewed":
            return {
              type: "None",
              waitingMessage: /* @__PURE__ */ jsx105(React282.Fragment, null, /* @__PURE__ */ jsx105("span", null, "No trigger specified. "), /* @__PURE__ */ jsx105(
                "a",
                {
                  href: "https://www.commandbar.com/docs/nudges/targeting/who-where-when/#basic-triggers",
                  style: {
                    color: "#1A389D",
                    fontSize: "14px",
                    fontWeight: 500,
                    lineHeight: "140%",
                    textDecorationLine: "underline"
                  }
                },
                "Learn more"
              ), /* @__PURE__ */ jsx105("span", null, "."))
            };
          case "on_rage_click":
            return {
              type: "On rage click",
              waitingMessage: "Waiting for user rage click..."
            };
          case "smart_delay":
            return {
              type: "Smart delay",
              waitingMessage: "Waiting for user activity..."
            };
          case "after_time": {
            const { value, unit } = nudge.trigger.meta;
            return {
              type: "Time on page",
              value: `after ${value} ${unit}s`,
              waitingMessage: `Triggering after ${value}${unit === "minute" ? "m" : "s"} on page`
            };
          }
          case "on_user_confusion":
            return {
              type: "On user confusion",
              waitingMessage: "Waiting for user confusion..."
            };
          case "scheduled": {
            const { value, interval } = nudge.trigger.meta;
            return {
              type: "Scheduled",
              waitingMessage: `Triggering in ${value} ${interval}s`,
              value: `every ${value} ${interval}s`,
              warningMessage: `User has already interacted with this Nudge within the last ${value} ${interval}s.`
            };
          }
          default:
            return {
              type: "Immediately"
            };
        }
      })();
      const readableFrequencyLimit = (() => {
        switch (nudge == null ? void 0 : nudge.frequency_limit) {
          case "once_per_session":
            return { limit: "Once per session", message: "User has already seen this nudge this session" };
          case "once_per_user":
            return {
              limit: "Once per user",
              message: "User has already seen this nudge"
            };
          case "until_interaction":
            return { limit: "Until completed or dismissed", message: "User has already interacted with this nudge" };
          default:
            return { limit: "No limit" };
        }
      })();
      const message = (() => {
        var _a2;
        switch (status) {
          case "success":
            return null;
          case "warning": {
            if (!(readableFrequencyLimit.message || readableTrigger.warningMessage)) {
              return null;
            }
            return /* @__PURE__ */ jsx105(
              "div",
              {
                style: {
                  color: "#9A3412",
                  textOverflow: "ellipsis",
                  overflow: "hidden"
                }
              },
              /* @__PURE__ */ jsx105("span", null, (_a2 = readableFrequencyLimit.message) != null ? _a2 : readableTrigger.warningMessage)
            );
          }
          default: {
            if (!readableTrigger.waitingMessage) {
              return null;
            }
            return /* @__PURE__ */ jsx105(
              "div",
              {
                style: {
                  color: "#1A389D",
                  textOverflow: "ellipsis",
                  overflow: "hidden"
                }
              },
              /* @__PURE__ */ jsx105("span", null, readableTrigger.waitingMessage)
            );
          }
        }
      })();
      const triggerNudgeButtonOnClick = useCallback20(() => {
        if (nudge) {
          triggerNudge(nudge, nudge.trigger, {
            triggerMatch: nudge.trigger.type === "on_event" && passesFrequencyCondition(_, nudge) && passesAudienceConditions(_, "nudges", nudge) && passesPageConditions(_, nudge)
          });
        }
      }, [triggerNudge, nudge]);
      const renderFooterButton = () => {
        if ((nudge == null ? void 0 : nudge.trigger.type) === "on_event" && status === "info") {
          return /* @__PURE__ */ jsx105(ActionButton, { onClick: triggerNudgeButtonOnClick }, /* @__PURE__ */ jsx105(ZapFast_default, { width: 16 }), " Trigger event");
        }
        if (nudge && status === "warning") {
          return /* @__PURE__ */ jsx105(ActionButton, { onClick: reset2 }, /* @__PURE__ */ jsx105(FlipBackward_default, { width: 16 }), " Reset user history");
        }
        return null;
      };
      return /* @__PURE__ */ jsx105(TooltipContainer, null, /* @__PURE__ */ jsx105(TooltipBody, null, /* @__PURE__ */ jsx105(ConditionBlock, null, /* @__PURE__ */ jsx105(Label2, null, "When"), /* @__PURE__ */ jsx105(
        "div",
        {
          style: {
            display: "flex",
            alignItems: "center",
            gap: "8px",
            flexFlow: "wrap"
          }
        },
        /* @__PURE__ */ jsx105(Tag3, null, readableTrigger.type),
        (readableTrigger == null ? void 0 : readableTrigger.value) && /* @__PURE__ */ jsx105(Tag3, { style: { wordBreak: "break-all" } }, readableTrigger.value)
      )), (nudge == null ? void 0 : nudge.trigger.type) !== "when_share_link_viewed" && /* @__PURE__ */ jsx105(ConditionBlock, null, /* @__PURE__ */ jsx105(Label2, null, "Limit"), /* @__PURE__ */ jsx105(Tag3, null, readableFrequencyLimit.limit))), status !== "success" && message && /* @__PURE__ */ jsx105(TooltipFooter, { statusStyles, message, button: renderFooterButton(), loading }));
    };
    When = () => {
      const { simulatedNudge, lastEvent, lastTriggerEvent, isNudgeRendering } = useSimulationContext();
      const _ = useStore();
      const [trigger, setTrigger] = useState36({ matched: false, exceededFrequencyLimit: false });
      useEffect54(() => {
        if ((lastEvent == null ? void 0 : lastEvent.type) === "STOP_DEBUG") {
          setTrigger({ matched: false, exceededFrequencyLimit: false });
        } else if (lastTriggerEvent == null ? void 0 : lastTriggerEvent.trigger) {
          setTrigger(({ matched }) => ({
            matched: lastTriggerEvent.trigger.type === "on_event" && lastTriggerEvent.trigger.meta.event === "commandbar-nudge_shown" || matched && isNudgeRendering || isEqual13(simulatedNudge.trigger, lastTriggerEvent == null ? void 0 : lastTriggerEvent.trigger),
            exceededFrequencyLimit: !(isNudgeRendering || passesFrequencyCondition(_, simulatedNudge))
          }));
        } else if (!lastTriggerEvent) {
          setTrigger({ matched: false, exceededFrequencyLimit: !passesFrequencyCondition(_, simulatedNudge) });
        }
      }, [lastEvent == null ? void 0 : lastEvent.type, lastTriggerEvent == null ? void 0 : lastTriggerEvent.trigger, simulatedNudge, isNudgeRendering]);
      const pass = isNudgeRendering || trigger.matched || simulatedNudge.trigger.type === "when_conditions_pass" && passesAudienceConditions(_, "nudges", simulatedNudge) && passesPageConditions(_, simulatedNudge);
      const status = (() => {
        if (!isNudgeRendering && (trigger.exceededFrequencyLimit || simulatedNudge.trigger.type === "scheduled")) {
          return "warning";
        }
        if (pass) {
          return "success";
        }
        return "info";
      })();
      return /* @__PURE__ */ jsx105(
        Tooltip_default2,
        {
          overlay: /* @__PURE__ */ jsx105(
            WhenTooltip,
            {
              nudge: simulatedNudge,
              status,
              statusStyles: states2[status],
              resetStatus: () => {
                setTrigger((t44) => ({
                  ...t44,
                  exceededFrequencyLimit: false
                }));
              }
            }
          )
        },
        /* @__PURE__ */ jsx105(StatusBadge, { label: "When", statusStyles: states2[status] })
      );
    };
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Where.tsx
import React283, { useMemo as useMemo18 } from "react";
var generateReadableOperator, states3, NormalSpan, BoldSpan, getUrlCheckDetails, getElementCheckDetails, WhereTooltip, Where;
var init_Where = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Where.tsx"() {
    "use strict";
    init_react();
    init_RulesParser();
    init_rules();
    init_types2();
    init_dom();
    init_nudges();
    init_sentry();
    init_useStore();
    init_selectors5();
    init_ConditionBlock();
    init_Label();
    init_StatusBadge();
    init_Tag2();
    init_Tooltip3();
    init_useSimulationContext();
    generateReadableOperator = (operator) => operator.replace(/([A-Z])/g, " $1").toLowerCase();
    states3 = {
      success: {
        background: "#E6F6D6",
        icon: /* @__PURE__ */ React283.createElement(CheckCircleBroken_default, { width: 16, height: 16, color: "#1E3706" }),
        color: "#1E3706"
      },
      warning: {
        background: "#FFF7ED",
        icon: /* @__PURE__ */ React283.createElement(AlertHexagon_default, { width: 16, height: 16, color: "#9A3412" }),
        color: "#9A3412"
      }
    };
    NormalSpan = ({ children, style: style3, ...rest }) => /* @__PURE__ */ React283.createElement(
      "span",
      {
        style: {
          fontWeight: 500,
          ...style3
        },
        ...rest
      },
      children
    );
    BoldSpan = ({ children, style: style3, ...rest }) => /* @__PURE__ */ React283.createElement(
      "span",
      {
        style: {
          fontWeight: 700,
          ...style3
        },
        ...rest
      },
      children
    );
    getUrlCheckDetails = (condition, location) => {
      var _a2;
      if (condition.type !== "url" && condition.type !== "hostname") {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureMessage(`Unknown page targeting condition: ${JSON.stringify(condition)}`);
        return null;
      }
      const typeDisplayValue = condition.type === "url" ? "URL Path" : "Domain";
      switch (condition.operator) {
        case "startsWith":
          return location.startsWith(parseStringValue(condition.value)) ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(NormalSpan, null, "The Current ", typeDisplayValue, " starts with "), /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"')) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(NormalSpan, null, "The Current ", typeDisplayValue, " does not start with "), /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'));
        case "endsWith":
          return location.endsWith(parseStringValue(condition.value)) ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(NormalSpan, null, "The Current ", typeDisplayValue, " ends with "), /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"')) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(NormalSpan, null, "The Current ", typeDisplayValue, " does not end with "), /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'));
        case "includes":
          return location.includes(parseStringValue(condition.value)) ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " included in the Current ", typeDisplayValue)) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " not included in the Current ", typeDisplayValue));
        case "doesNotInclude":
          return location.includes(parseStringValue(condition.value)) ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " included in the Current ", typeDisplayValue)) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " not included in the Current ", typeDisplayValue));
        case "matchesRegex":
          return new RegExp(parseStringValue(condition.value)).test(location) ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(NormalSpan, null, "Current ", typeDisplayValue, " matches "), /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"')) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(NormalSpan, null, "Current ", typeDisplayValue, " does not match "), /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'));
      }
    };
    getElementCheckDetails = (condition) => {
      var _a2;
      if (condition.type === "element") {
        switch (condition.operator) {
          case "idOnPage":
            return document.getElementById(parseStringValue(condition.value)) !== null ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"#', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is on the page")) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"#', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is not on the page"));
          case "classnameOnPage":
            return document.getElementsByClassName(parseStringValue(condition.value)).length > 0 ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '".', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is on the page")) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '".', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is not on the page"));
          case "selectorOnPage": {
            const isOnPage = condition.value ? checkSelector(condition.value) : false;
            return isOnPage ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is on the page")) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is not on the page"));
          }
          case "idNotOnPage":
            return document.getElementById(parseStringValue(condition.value)) === null ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"#', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is not on the page")) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"#', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is on the page"));
          case "classnameNotOnPage":
            return document.getElementsByClassName(parseStringValue(condition.value)).length === 0 ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '".', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is not on the page")) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '".', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is on the page"));
          case "selectorNotOnPage": {
            const isNotOnPage = condition.value ? !checkSelector(condition.value) : false;
            return isNotOnPage ? /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is not on the page")) : /* @__PURE__ */ React283.createElement(React283.Fragment, null, /* @__PURE__ */ React283.createElement(BoldSpan, null, '"', condition.value, '"'), /* @__PURE__ */ React283.createElement(NormalSpan, null, " is on the page"));
          }
        }
      }
      (_a2 = getSentry()) == null ? void 0 : _a2.captureMessage(`Unknown element condition: ${JSON.stringify(condition)}`);
      return null;
    };
    WhereTooltip = ({ statusStyles, nudge, passPage, passElement }) => {
      const _ = useStore();
      const { simulatedNudge, currentStepIndex } = useSimulationContext();
      const step = getNudgeStep(simulatedNudge, currentStepIndex);
      const expressions = useMemo18(() => {
        if (!(nudge == null ? void 0 : nudge.show_expression))
          return;
        const conditions = getConditions(nudge.show_expression);
        return conditions.reduce(
          (acc, condition) => {
            const getMessage = () => {
              switch (condition.type) {
                case "hostname":
                  return getUrlCheckDetails(condition, _.location.hostname);
                case "url":
                  return getUrlCheckDetails(condition, _.location.pathname + _.location.search + _.location.hash);
                case "element":
                  return getElementCheckDetails(condition);
                default:
                  return null;
              }
            };
            if (condition.type === "url" || condition.type === "element" || condition.type === "hostname") {
              return [
                ...acc,
                {
                  readableOperator: generateReadableOperator(condition.operator),
                  message: getMessage(),
                  type: condition.type === "url" ? "Current URL Path" : condition.type === "hostname" ? "Current Domain" : "DOM Element",
                  value: condition.value
                }
              ];
            }
            return acc;
          },
          []
        );
      }, [nudge == null ? void 0 : nudge.show_expression, _.location]);
      return /* @__PURE__ */ React283.createElement(TooltipContainer, null, /* @__PURE__ */ React283.createElement(TooltipBody, null, /* @__PURE__ */ React283.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "16px"
          }
        },
        isAnchorableStep(step) && /* @__PURE__ */ React283.createElement(ConditionBlock, null, /* @__PURE__ */ React283.createElement(Label2, null, "Target element"), /* @__PURE__ */ React283.createElement(Tag3, { style: { wordBreak: "break-all" } }, step.form_factor.anchor)),
        /* @__PURE__ */ React283.createElement(ConditionBlock, null, /* @__PURE__ */ React283.createElement(Label2, null, "Page Conditions"), (expressions == null ? void 0 : expressions.length) ? /* @__PURE__ */ React283.createElement("div", { style: { display: "flex", gap: "4px", flexDirection: "column" } }, expressions == null ? void 0 : expressions.map((expression, index3) => /* @__PURE__ */ React283.createElement(
          "div",
          {
            key: index3,
            style: {
              display: "flex",
              gap: "4px"
            }
          },
          /* @__PURE__ */ React283.createElement(Tag3, null, expression.type),
          /* @__PURE__ */ React283.createElement(Tag3, null, expression.readableOperator),
          (expression == null ? void 0 : expression.value) && /* @__PURE__ */ React283.createElement(Tag3, { style: { wordBreak: "break-all" } }, expression.value)
        ))) : /* @__PURE__ */ React283.createElement(Tag3, null, "On all pages")),
        /* @__PURE__ */ React283.createElement(ConditionBlock, null, /* @__PURE__ */ React283.createElement(Label2, null, "Current URL Path"), /* @__PURE__ */ React283.createElement(Tag3, null, sanitizeUrl(_.location)), /* @__PURE__ */ React283.createElement(Label2, null, "Current Domain"), /* @__PURE__ */ React283.createElement(Tag3, null, _.location.hostname))
      )), /* @__PURE__ */ React283.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column"
          }
        },
        !passPage && /* @__PURE__ */ React283.createElement(
          TooltipFooter,
          {
            statusStyles,
            message: /* @__PURE__ */ React283.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "4px" } }, (expressions == null ? void 0 : expressions.length) ? expressions == null ? void 0 : expressions.map((condition, index3) => /* @__PURE__ */ React283.createElement("span", { key: index3 }, condition.message)) : /* @__PURE__ */ React283.createElement("span", null, "There are no page conditions"))
          }
        ),
        !passElement && /* @__PURE__ */ React283.createElement(TooltipFooter, { statusStyles, message: "Target element is not visible on this page" })
      ));
    };
    Where = () => {
      const { simulatedNudge, currentStepIndex } = useSimulationContext();
      const _ = useStore();
      const passPage = passesPageConditions(_, simulatedNudge);
      const passElement = passesPinnedElement(simulatedNudge, currentStepIndex);
      const statusStyles = passPage && passElement ? states3.success : states3.warning;
      return /* @__PURE__ */ React283.createElement(
        Tooltip_default2,
        {
          overlay: /* @__PURE__ */ React283.createElement(
            WhereTooltip,
            {
              nudge: simulatedNudge,
              passPage,
              passElement,
              statusStyles
            }
          )
        },
        /* @__PURE__ */ React283.createElement(StatusBadge, { label: "Where", statusStyles })
      );
    };
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/Who.tsx
import React284, { useState as useState37, useEffect as useEffect55 } from "react";
var states4, WhoTooltip, Who;
var init_Who = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/Who.tsx"() {
    "use strict";
    init_audience2();
    init_useStore();
    init_react();
    init_organization();
    init_Label();
    init_StatusBadge();
    init_Tag2();
    init_Tooltip3();
    init_useSimulationContext();
    states4 = {
      success: {
        background: "#E6F6D6",
        icon: /* @__PURE__ */ React284.createElement(CheckCircleBroken_default, { width: 16, height: 16, color: "#1E3706" }),
        color: "#1E3706"
      },
      warning: {
        background: "#FFF7ED",
        icon: /* @__PURE__ */ React284.createElement(AlertHexagon_default, { width: 16, height: 16, color: "#9A3412" }),
        color: "#9A3412"
      }
    };
    WhoTooltip = ({ statusStyles, pass, audienceText }) => /* @__PURE__ */ React284.createElement(TooltipContainer, null, /* @__PURE__ */ React284.createElement(TooltipBody, null, /* @__PURE__ */ React284.createElement(
      "div",
      {
        style: {
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "center",
          gap: "8px",
          color: "#3F424A",
          fontSize: "14px",
          fontWeight: 500,
          lineHeight: "normal"
        }
      },
      /* @__PURE__ */ React284.createElement(Label2, null, "Audience"),
      /* @__PURE__ */ React284.createElement(Tag3, null, "Audience: ", audienceText)
    )), !pass && /* @__PURE__ */ React284.createElement(
      TooltipFooter,
      {
        statusStyles,
        message: audienceText === "Custom conditions" ? "Custom conditions not met" : "User is not a member of this audience"
      }
    ));
    Who = () => {
      const { simulatedNudge } = useSimulationContext();
      const [audienceText, setAudienceText] = useState37("");
      const _ = useStore();
      const pass = passesAudienceConditions(_, "nudges", simulatedNudge);
      const statusStyles = pass ? states4.success : states4.warning;
      useEffect55(() => {
        const getAudienceText = async () => {
          var _a2, _b2, _c2;
          const audience = simulatedNudge.audience;
          switch (audience == null ? void 0 : audience.type) {
            case "all_users":
              return "All Users";
            case "named_rule_reference": {
              const orgId = (_a2 = _.organization) == null ? void 0 : _a2.id.toString();
              if (orgId) {
                const rules = await listRules(orgId);
                return (_c2 = (_b2 = rules.find((rule) => rule.id === audience.rule_reference.rule_id)) == null ? void 0 : _b2.name) != null ? _c2 : "";
              }
              return "";
            }
            default:
              return "Custom conditions";
          }
        };
        getAudienceText().then(setAudienceText);
      }, []);
      return /* @__PURE__ */ React284.createElement(Tooltip_default2, { overlay: /* @__PURE__ */ React284.createElement(WhoTooltip, { audienceText, pass, statusStyles }) }, /* @__PURE__ */ React284.createElement(StatusBadge, { label: "Who", statusStyles }));
    };
  }
});

// commandbar/src/products/nudges/components/DebugToolBar/ToolBar.tsx
var ToolBar_exports = {};
__export(ToolBar_exports, {
  default: () => ToolBar_default
});
import { css as css63, jsx as jsx106 } from "@emotion/core";
import React285, { useRef as useRef38 } from "react";
var fadeInFromTopKeyframes, fadeInFromBottomKeyframes, Container10, Label3, Section, PositionToggle, VerticalBar, Actions2, ToolBar, ToolBar_default;
var init_ToolBar = __esm({
  "commandbar/src/products/nudges/components/DebugToolBar/ToolBar.tsx"() {
    "use strict";
    init_react();
    init_Z();
    init_messages();
    init_useAction();
    init_useStore();
    init_nudges();
    init_Limit();
    init_SecondaryButton();
    init_When();
    init_Where();
    init_Who();
    init_useSimulationContext();
    fadeInFromTopKeyframes = css63`
  @keyframes fadeInFromTop {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
    fadeInFromBottomKeyframes = css63`
  @keyframes fadeInFromBottom {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
    Container10 = ({ children }) => {
      var _a2;
      const _ = useStore();
      const position = (_a2 = _.nudgeDebugToolBar) == null ? void 0 : _a2.position;
      const animationStyle = position === "top" ? fadeInFromTopKeyframes : fadeInFromBottomKeyframes;
      const hasMountedRef = useRef38(false);
      return /* @__PURE__ */ jsx106(
        "div",
        {
          "data-testid": "debug-toolbar",
          ref: () => {
            hasMountedRef.current = true;
          },
          css: [
            !hasMountedRef.current && css63`
            animation: ${position === "top" ? "fadeInFromTop" : "fadeInFromBottom"} 0.5s ease-out forwards;

            svg {
              fill: none;
            }
          `,
            animationStyle
          ],
          style: {
            display: "flex",
            flexDirection: "column",
            boxShadow: "0px 5px 12px rgba(0, 0, 0, 0.16)",
            borderRadius: 8,
            border: "0.50px #DFDFE2 solid",
            zIndex: Z_default.Z_INDEX_MAX - 1,
            fontFamily: 'Inter, "Proxima Nova", sans-serif',
            position: "fixed",
            left: "50%",
            transform: "translateX(-50%)",
            ...position === "top" ? {
              top: 32
            } : {
              bottom: 32
            }
          }
        },
        children
      );
    };
    Label3 = () => {
      var _a2, _b2;
      const _ = useStore();
      const { simulatedNudge, currentStepIndex } = useSimulationContext();
      return /* @__PURE__ */ jsx106(
        "div",
        {
          style: {
            display: "flex",
            height: "32px",
            padding: "4px 8px",
            justifyContent: "space-between",
            alignItems: "center",
            background: "#F3F3F4",
            borderRadius: "8px 8px 0 0",
            color: "#0D0E10",
            fontSize: "14px",
            fontWeight: 500,
            lineHeight: "14px"
          }
        },
        /* @__PURE__ */ jsx106("div", { style: { display: "flex", gap: "8px", maxWidth: "270px" } }, ((_a2 = _.endUser) == null ? void 0 : _a2.slug) ? /* @__PURE__ */ jsx106(React285.Fragment, null, /* @__PURE__ */ jsx106("div", { style: { display: "flex" } }, /* @__PURE__ */ jsx106(UserSquare_default, { color: "#797C85" })), /* @__PURE__ */ jsx106(
          "span",
          {
            style: {
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          },
          _.endUser.slug
        )) : /* @__PURE__ */ jsx106(React285.Fragment, null, /* @__PURE__ */ jsx106("div", { style: { display: "flex" } }, /* @__PURE__ */ jsx106(UserIncognito_default, { color: "#797C85" })), /* @__PURE__ */ jsx106(
          "span",
          {
            style: {
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          },
          "Anonymous user"
        ))),
        /* @__PURE__ */ jsx106("div", { style: { display: "flex", gap: "4px", maxWidth: "270px", whiteSpace: "nowrap" } }, /* @__PURE__ */ jsx106(
          "span",
          {
            style: {
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          },
          simulatedNudge.slug || ((_b2 = getNudgeStep(simulatedNudge, 0)) == null ? void 0 : _b2.title) || simulatedNudge.id
        ), /* @__PURE__ */ jsx106("div", { style: { display: "flex" } }, /* @__PURE__ */ jsx106(SlashDivider_default, { color: "#797C85" })), /* @__PURE__ */ jsx106("span", null, `Step ${currentStepIndex + 1} of ${simulatedNudge.steps.length}`))
      );
    };
    Section = ({ children }) => /* @__PURE__ */ jsx106(
      "div",
      {
        style: {
          padding: "8px",
          background: "white",
          alignItems: "center",
          borderRadius: "0 0 8px 8px",
          gap: 8,
          display: "inline-flex"
        }
      },
      children
    );
    PositionToggle = () => {
      var _a2;
      const _ = useStore();
      const repositionDebugToolBar = useAction((_2, position) => {
        _2.nudgeDebugToolBar.position = position;
      });
      return /* @__PURE__ */ jsx106(
        SecondaryButton,
        {
          "data-testid": "commandbar-toolbar-position-toggle",
          onClick: () => {
            var _a3;
            repositionDebugToolBar(((_a3 = _.nudgeDebugToolBar) == null ? void 0 : _a3.position) === "bottom" ? "top" : "bottom");
          }
        },
        ((_a2 = _.nudgeDebugToolBar) == null ? void 0 : _a2.position) === "bottom" ? /* @__PURE__ */ jsx106(ArrowUp_default, null) : /* @__PURE__ */ jsx106(ArrowDown_default, null)
      );
    };
    VerticalBar = () => /* @__PURE__ */ jsx106(
      "div",
      {
        style: {
          alignSelf: "stretch",
          paddingLeft: 4,
          paddingRight: 4,
          justifyContent: "center",
          alignItems: "center",
          gap: 8,
          display: "flex"
        }
      },
      /* @__PURE__ */ jsx106("div", { style: { width: 1, height: 24, background: "#DFDFE2" } })
    );
    Actions2 = () => {
      var _a2;
      const { simulatedNudge, currentStepIndex, onSimulationDone, onSimulationRestart } = useSimulationContext();
      const _ = useStore();
      const isPreviewEnabledForNudge = _.extension.preview.enabled && ((_a2 = _.extension.preview.experience) == null ? void 0 : _a2.nudge.id) === simulatedNudge.id;
      const onClickRecorder = async () => {
        StartClickRecorderMessage.sendToPage({
          origin: "preview",
          experience: {
            type: "nudge",
            stepIndex: currentStepIndex,
            nudge: simulatedNudge
          }
        });
      };
      const currentFormFactor = simulatedNudge.steps[currentStepIndex].form_factor.type;
      const isPositionable = currentFormFactor === "pin" || currentFormFactor === "tooltip";
      return /* @__PURE__ */ jsx106("div", { style: { gap: 8, display: "flex", alignItems: "center" } }, isPreviewEnabledForNudge && isPositionable && /* @__PURE__ */ jsx106(SecondaryButton, { "data-testid": "commandbar-toolbar-target-selector", onClick: onClickRecorder }, /* @__PURE__ */ jsx106(Target04_default, null)), /* @__PURE__ */ jsx106(SecondaryButton, { "data-testid": "commandbar-toolbar-reset", onClick: onSimulationRestart }, /* @__PURE__ */ jsx106(RefreshCcw01_default, null)), /* @__PURE__ */ jsx106(
        "button",
        {
          type: "button",
          css: css63`
          align-items: center;
          cursor: pointer;
          display: flex;
          height: 32px;
          padding: 0px 12px;
          align-items: center;
          border-radius: 6px;
          background: #2754ee;
          box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.03), 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
          color: #fff;
          border: none;
          font-size: 14px;
          font-weight: 500;

          &:hover {
            background: #2046c6;
          }
          &:focus {
            box-shadow: '0px -1px 3px 0px rgba(0, 0, 0, 0.08) inset, 0px -1px 1px 0px rgba(0, 0, 0, 0.03) inset, 0px 0px 0px 3px rgba(39, 84, 238, 0.16)';
          }
        `,
          onClick: onSimulationDone
        },
        "Done"
      ));
    };
    ToolBar = () => {
      const _ = useStore();
      return /* @__PURE__ */ jsx106(SimulationContextProvider, null, !_.extension.recorder.enabled && /* @__PURE__ */ jsx106(Container10, null, /* @__PURE__ */ jsx106(Label3, null), /* @__PURE__ */ jsx106(Section, null, /* @__PURE__ */ jsx106(PositionToggle, null), /* @__PURE__ */ jsx106(VerticalBar, null), /* @__PURE__ */ jsx106(Who, null), /* @__PURE__ */ jsx106(Where, null), /* @__PURE__ */ jsx106(When, null), /* @__PURE__ */ jsx106(Limit, null), /* @__PURE__ */ jsx106(VerticalBar, null), /* @__PURE__ */ jsx106(Actions2, null))));
    };
    ToolBar_default = ToolBar;
  }
});

// commandbar/src/products/nudges/components/Nudges.tsx
var Nudges_exports = {};
__export(Nudges_exports, {
  COMPACT_TOOLBAR_WIDTH: () => COMPACT_TOOLBAR_WIDTH,
  FULL_TOOLBAR_WIDTH: () => FULL_TOOLBAR_WIDTH,
  default: () => Nudges_default
});
import { jsx as jsx107 } from "@emotion/core";
import { useEffect as useEffect56 } from "react";
import React286 from "react";
var LazyDebugToolBar, COMPACT_TOOLBAR_WIDTH, FULL_TOOLBAR_WIDTH, Nudges, Nudges_default;
var init_Nudges = __esm({
  "commandbar/src/products/nudges/components/Nudges.tsx"() {
    "use strict";
    init_assets();
    init_Modal();
    init_useStore();
    init_selectors5();
    init_useAction();
    init_actions6();
    init_location();
    init_AdminOnly();
    init_useWindowSize();
    LazyDebugToolBar = React286.lazy(() => Promise.resolve().then(() => (init_ToolBar(), ToolBar_exports)));
    COMPACT_TOOLBAR_WIDTH = 650;
    FULL_TOOLBAR_WIDTH = 900;
    Nudges = () => {
      const { currentModalNudge, nudgeDebugToolBar, isAdmin, nudgeManager, isEditorVisible } = useStore();
      const getNudge = useAction(getNudgeById);
      const startPreview = useAction(startDebugSession);
      const setShouldCloseTabWhenToolBarClosed = useAction((_) => {
        _.nudgeDebugToolBar.closeTabWhenToolbarClosed = true;
      });
      const stopSimulateSession = useAction(stopDebugSession);
      const windowWidth = useWindowSize_default().width;
      const showToolBar = nudgeDebugToolBar.visible && windowWidth > COMPACT_TOOLBAR_WIDTH;
      useEffect56(() => {
        let subscription;
        const urlParams = new URLSearchParams(window.location.search);
        const previewNudgeId = urlParams.get(DEBUG_NUDGE_PARAM);
        if (previewNudgeId && (isAdmin || false) && !nudgeDebugToolBar.closeTabWhenToolbarClosed) {
          subscription = nudgeManager == null ? void 0 : nudgeManager.subscribe(({ event }) => {
            if (event.type === "REFRESH_FROM_CONFIG") {
              const nudge = getNudge(JSON.parse(previewNudgeId));
              if (nudge) {
                setShouldCloseTabWhenToolBarClosed();
                startPreview(nudge);
                subscription == null ? void 0 : subscription.unsubscribe();
              }
            }
          });
        }
        return () => {
          subscription == null ? void 0 : subscription.unsubscribe();
        };
      }, [isAdmin]);
      useEffect56(() => {
        if (isEditorVisible) {
          stopSimulateSession();
        }
      }, [isEditorVisible]);
      return /* @__PURE__ */ jsx107("div", null, /* @__PURE__ */ jsx107("div", { id: "commandbar-nudges-rc-tooltip-container" }), currentModalNudge && /* @__PURE__ */ jsx107(
        Modal_default,
        {
          nudge: currentModalNudge.nudge,
          stepIndex: currentModalNudge.stepIndex,
          stepCount: currentModalNudge.stepCount,
          renderMode: currentModalNudge.renderMode
        }
      ), /* @__PURE__ */ jsx107(AdminOnly_default, null, showToolBar && /* @__PURE__ */ jsx107(LazyDebugToolBar, null)));
    };
    Nudges_default = Nudges;
  }
});

// design-system/src/components/AskAIButton.tsx
import { jsx as jsx108 } from "@emotion/core";
var AskAIButton, AskAIButton_default;
var init_AskAIButton = __esm({
  "design-system/src/components/AskAIButton.tsx"() {
    "use strict";
    AskAIButton = ({ onClick, small = false }) => {
      return /* @__PURE__ */ jsx108(
        "button",
        {
          onClick,
          css: {
            width: small ? 80 : 120,
            height: small ? 33 : 50,
            cursor: "pointer",
            background: `conic-gradient(
          from 109deg at 48.43% 50%,
          #0a0f1f 43.12499910593033deg,
          #272b56 103.12500357627869deg,
          #0a0f1f 191.8141007423401deg,
          #0a0f1f 309.375deg,
          #262a54 343.30342054367065deg
        )`,
            borderRadius: 13,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            transition: "all 0.05s cubic-bezier(0.85, 0, 0.15, 1)",
            ...onClick !== void 0 ? {
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "rgba(0, 0, 0, 0.35) 0px 4px 21px"
              }
            } : null,
            span: {
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: small ? 12 : 18,
              display: "flex",
              alignItems: "center",
              textAlign: "center",
              zIndex: 2,
              background: "linear-gradient(180deg, #fff 0%, #ddc5fb 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent"
            }
          }
        },
        /* @__PURE__ */ jsx108("span", null, "Ask\xA0AI")
      );
    };
    AskAIButton_default = AskAIButton;
  }
});

// commandbar/src/shared/components/launcher/useElementObserver.tsx
import { useEffect as useEffect57, useState as useState38 } from "react";
var useElementObserver, useElementObserver_default;
var init_useElementObserver = __esm({
  "commandbar/src/shared/components/launcher/useElementObserver.tsx"() {
    "use strict";
    init_dom();
    init_useStore();
    useElementObserver = (targetEl) => {
      const [element, setElement] = useState38(void 0);
      const page = document.documentElement || document.body;
      const _ = useStore();
      useEffect57(() => {
        const el = getElement(targetEl);
        setElement(el);
        if (!el) {
          const observer = new MutationObserver(() => {
            const newEl = getElement(targetEl);
            if (newEl) {
              setElement(newEl);
              observer.disconnect();
            }
          });
          observer.observe(page, { childList: true, subtree: true });
          return () => {
            observer.disconnect();
          };
        }
      }, [targetEl, _.location.pathname]);
      return element;
    };
    useElementObserver_default = useElementObserver;
  }
});

// commandbar/src/shared/components/launcher/CustomHelpHubLauncher.tsx
import { useEffect as useEffect58 } from "react";
var CustomHelpHubLauncher, CustomHelpHubLauncher_default;
var init_CustomHelpHubLauncher = __esm({
  "commandbar/src/shared/components/launcher/CustomHelpHubLauncher.tsx"() {
    "use strict";
    init_useAction();
    init_service_actions();
    init_useElementObserver();
    init_operatingSystem();
    CustomHelpHubLauncher = ({ organization }) => {
      const anchor = isMobileDevice() ? organization.helphub_mobile_launcher_anchor : organization.helphub_launcher_anchor;
      const element = useElementObserver_default(anchor);
      const toggleHelpHubVisible2 = useAction(toggleHelpHubVisible);
      useEffect58(() => {
        if (element) {
          element.addEventListener("click", toggleHelpHubVisible2);
          return () => {
            element.removeEventListener("click", toggleHelpHubVisible2);
          };
        }
      }, [element, toggleHelpHubVisible2]);
      return null;
    };
    CustomHelpHubLauncher_default = CustomHelpHubLauncher;
  }
});

// commandbar/src/shared/components/launcher/AssistanceLauncher.tsx
var AssistanceLauncher_exports = {};
__export(AssistanceLauncher_exports, {
  AssistanceLauncher: () => AssistanceLauncher,
  default: () => AssistanceLauncher_default
});
import React287 from "react";
import { css as css64, jsx as jsx109, keyframes as keyframes12 } from "@emotion/core";
import chroma21 from "chroma-js";
var icons, AssistanceLauncher, AssistanceLauncher_default;
var init_AssistanceLauncher = __esm({
  "commandbar/src/shared/components/launcher/AssistanceLauncher.tsx"() {
    "use strict";
    init_useStore();
    init_useLauncherPosition();
    init_react();
    init_AskAIButton();
    init_useTheme();
    init_CustomHelpHubLauncher();
    init_location();
    icons = {
      bookOpen: BookOpen01_default,
      graduationHat: GraduationHat02_default,
      bookClosed: BookClosed_default,
      bookmark: Bookmark_default,
      chatCircle: MessageCircle01_default
    };
    AssistanceLauncher = () => {
      var _a2, _b2, _c2;
      const engine = useStore();
      const { organization, isAdmin, flags } = engine;
      const launcher = useHelpHubLauncherPosition(isAdmin, organization);
      const { theme } = useTheme();
      const theme_primary = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--base-accent)" : (_a2 = theme.base) == null ? void 0 : _a2.primary;
      const theme_background = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--background-primary)" : (_b2 = theme.launcher) == null ? void 0 : _b2.background;
      const theme_fontFamily = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--font-font-family)" : (_c2 = theme.main) == null ? void 0 : _c2.fontFamily;
      const onClick = React287.useCallback(() => {
        window.CommandBar.toggleHelpHub();
      }, []);
      if (!organization || !(launcher == null ? void 0 : launcher.launcherPosition) || !(launcher == null ? void 0 : launcher.launcherSettings) || engine.helpHub.visible) {
        return null;
      } else if (isStudioPreview()) {
        return null;
      } else if (launcher.launcherSettings.type === "none") {
        return null;
      } else if (!engine.products.includes("help_hub") || !organization.helphub_enabled && !organization.copilot_enabled) {
        return null;
      }
      if (launcher.launcherSettings.type === "custom") {
        return /* @__PURE__ */ jsx109(CustomHelpHubLauncher_default, { organization });
      }
      if (launcher.launcherSettings.type === "askAI") {
        return /* @__PURE__ */ jsx109("div", { className: "commandbar-launcher", style: launcher.launcherPosition }, /* @__PURE__ */ jsx109(AskAIButton_default, { onClick }));
      }
      const LauncherIcon = icons[launcher.launcherSettings.type];
      let hoverBackground = (flags == null ? void 0 : flags["release-themes-v2"]) ? "var(--background-primary-hover)" : theme.main.background;
      try {
        if (!(flags == null ? void 0 : flags["release-themes-v2"])) {
          hoverBackground = chroma21(hoverBackground).alpha(0.98).css();
        }
      } catch (e) {
      }
      const entryAnimation = keyframes12`
    0% {
      transform: scale(0.06);
    }
    100% {
      transform: scale(1);
    }
  `;
      return /* @__PURE__ */ jsx109("div", { className: "commandbar-launcher", style: launcher.launcherPosition }, /* @__PURE__ */ jsx109(
        "div",
        {
          "aria-hidden": true,
          css: css64`
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 9px 10px;
          color: ${theme_primary};
          background-color: ${theme_background};
          border-radius: 27px;
          box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 6px 0px, rgba(0, 0, 0, 0.16) 0px 2px 32px 0px;
          font-family: ${theme_fontFamily};
          line-height: 1;
          transition: all ${theme.main.transitionTime} ease-in-out;
          animation: ${entryAnimation} 0.25s ease-out;
          &:hover {
            background-color: ${hoverBackground};
            cursor: pointer;
            transform: scale(1.3);
          }
        `,
          onClick
        },
        /* @__PURE__ */ jsx109(LauncherIcon, { height: 26, width: 26 })
      ));
    };
    AssistanceLauncher_default = AssistanceLauncher;
  }
});

// commandbar/src/shared/img/dotsgrid.svg
import * as React288 from "react";
var SvgDotsgrid;
var init_dotsgrid = __esm({
  "commandbar/src/shared/img/dotsgrid.svg"() {
    "use strict";
    SvgDotsgrid = (props2) => /* @__PURE__ */ React288.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React288.createElement("path", { stroke: "#A2A2A9", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "M8 4a.667.667 0 1 0 0-1.334A.667.667 0 0 0 8 4Zm0 4.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm0 4.667A.667.667 0 1 0 8 12a.667.667 0 0 0 0 1.333ZM12.667 4a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Zm0 4.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm0 4.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333ZM3.334 4a.667.667 0 1 0 0-1.334.667.667 0 0 0 0 1.334Zm0 4.666a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Zm0 4.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333Z", opacity: 0.5 }));
  }
});

// commandbar/src/shared/img/xclose.svg
import * as React289 from "react";
var SvgXclose;
var init_xclose = __esm({
  "commandbar/src/shared/img/xclose.svg"() {
    "use strict";
    SvgXclose = (props2) => /* @__PURE__ */ React289.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "none", viewBox: "0 0 16 16", ...props2 }, /* @__PURE__ */ React289.createElement("path", { stroke: "#000", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5, d: "m12 4-8 8m0-8 8 8", opacity: 0.5 }));
  }
});

// commandbar/src/products/helphub/components/Resizer.tsx
import React290 from "react";
var Resizer;
var init_Resizer = __esm({
  "commandbar/src/products/helphub/components/Resizer.tsx"() {
    "use strict";
    init_Z();
    init_theme3();
    init_useStore();
    Resizer = ({ resizeElement, minHeight = 100, minWidth = 350, setHeight, setWidth }) => {
      const { flags } = useStore();
      const isResizingTop = React290.useRef(false);
      const isResizingLeft = React290.useRef(false);
      const originalHeight = React290.useRef((flags == null ? void 0 : flags["release-themes-v2"]) ? 440 : 449);
      const originalWidth = React290.useRef((flags == null ? void 0 : flags["release-themes-v2"]) ? 440 : 449);
      const originalY = React290.useRef((flags == null ? void 0 : flags["release-themes-v2"]) ? 440 : 449);
      const originalX = React290.useRef((flags == null ? void 0 : flags["release-themes-v2"]) ? 440 : 449);
      const maxHeight = React290.useRef(Math.max(window.innerHeight - 100, resizeElement.getBoundingClientRect().height));
      const maxWidth = React290.useRef(Math.max(window.innerWidth - 100, resizeElement.getBoundingClientRect().width));
      const onTopMouseDown = (e) => {
        isResizingTop.current = true;
        originalHeight.current = resizeElement.getBoundingClientRect().height;
        originalY.current = e.clientY;
      };
      const onLeftMouseDown = (e) => {
        isResizingLeft.current = true;
        originalWidth.current = resizeElement.getBoundingClientRect().width;
        originalX.current = e.clientX;
      };
      const onTopLeftMouseDown = (e) => {
        onTopMouseDown(e);
        onLeftMouseDown(e);
      };
      React290.useEffect(() => {
        const handleMouseMove = (e) => {
          e.stopPropagation();
          if (isResizingTop.current) {
            const height = originalHeight.current - (e.clientY - originalY.current);
            if (height > minHeight && height < maxHeight.current) {
              setHeight(toPx(height));
            }
          }
          if (isResizingLeft.current) {
            const width = originalWidth.current - (e.clientX - originalX.current);
            if (width > minWidth && width < maxWidth.current) {
              setWidth(toPx(width));
            }
          }
        };
        document.addEventListener("mousemove", handleMouseMove);
        return () => {
          document.removeEventListener("mousemove", handleMouseMove);
        };
      }, []);
      React290.useEffect(() => {
        const handleMouseUp = () => {
          isResizingTop.current = false;
          isResizingLeft.current = false;
        };
        document.addEventListener("mouseup", handleMouseUp);
        return () => {
          document.removeEventListener("mouseup", handleMouseUp);
        };
      }, []);
      return /* @__PURE__ */ React290.createElement(React290.Fragment, null, /* @__PURE__ */ React290.createElement(
        "div",
        {
          role: "button",
          tabIndex: -1,
          onMouseDown: onTopMouseDown,
          style: {
            height: "5px",
            cursor: "ns-resize",
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            zIndex: Z_default.Z_DRAGGERS,
            backgroundColor: "transparent",
            margin: "0px 11px"
          }
        }
      ), /* @__PURE__ */ React290.createElement(
        "div",
        {
          role: "button",
          tabIndex: -1,
          onMouseDown: onLeftMouseDown,
          style: {
            width: "5px",
            cursor: "ew-resize",
            padding: "4px 0 0",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            zIndex: Z_default.Z_DRAGGERS,
            backgroundColor: "transparent",
            margin: "11px 0px"
          }
        }
      ), /* @__PURE__ */ React290.createElement(
        "div",
        {
          role: "button",
          tabIndex: -1,
          onMouseDown: onTopLeftMouseDown,
          style: {
            width: "11px",
            height: "11px",
            cursor: "nwse-resize",
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: Z_default.Z_DRAGGERS,
            backgroundColor: "transparent"
          }
        }
      ));
    };
  }
});

// commandbar/src/products/helphub/components/AskAIButton.tsx
import { css as css65, jsx as jsx110, keyframes as keyframes13 } from "@emotion/core";
import React291 from "react";
var glowPulseEffect, borderPulseEffect, styles45, CustomAskAIButton, AskAIButton2, AskAIButton_default2;
var init_AskAIButton2 = __esm({
  "commandbar/src/products/helphub/components/AskAIButton.tsx"() {
    "use strict";
    init_Interpolate();
    init_useStore();
    init_react();
    init_useStyles();
    glowPulseEffect = keyframes13`
    from {
      transform: scale(0.9);
    }
    to {
      transform: scale(1.025);
    }
  `;
    borderPulseEffect = keyframes13`
    to {
      transform: rotate(360deg);
    }
  `;
    styles45 = {
      glowWrapper: css65`
    width: inherit;
    display: inline-flex;
    transform: translateY(-50%);
    transition: all 0.25s;
    &:after {
      content: '';
      position: absolute;
      border-radius: 8px;
      left: 0;
      top: 0;
      background-color: #b02aef;
      width: 100%;
      height: 100%;
      box-shadow: -4px 4px 12px -2px #b02aef, 4px -4px 12px -2px #0051ff;
      animation: ${glowPulseEffect} 2s linear infinite alternate;
    }
  `,
      btnWrapper: css65`
    width: 100%;
    position: relative;
    overflow: hidden;
    background-color: transparent;
    display: inline-flex;
    border-radius: 8px;
    z-index: 1;
    transition: all 0.25s;
    top: 0px;

    &:after {
      content: '';
      display: block;
      z-index: -1;
      position: absolute;
      width: 250px;
      height: 250px;
      top: -112px;
      left: -84px;
      /* 	Controls border pulse color */
      background: linear-gradient(90deg, #ffffff 49.69%, #aa56ff 51.75%, #aa56ff 53.26%, #ffffff 55.32%);
      animation: ${borderPulseEffect} linear 4.5s infinite;
      background-position: center center;
      background-repeat: no-repeat;
      transition: all 0.25s;
    }

    &:active {
      top: 2px;
    }
  `,
      btn: css65`
    width: 100%;
    height: 32px;
    background: linear-gradient(
      94.91deg,
      #1f1f1f 12.99%,
      #262a49 25.99%,
      #1f1f1f 35.82%,
      #272c5e 73.6%,
      #1f1f1f 92.23%
    );
    color: #d2d2d2;
    margin: 1px;
    border-radius: 6.5px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 400;
    cursor: pointer;
    user-select: none;
    white-space: nowrap;
    gap: 4px;
    transition: all 0.25s;
    position: relative;

    &:hover {
      background-color: #1f1f1f;
      color: #fff;
      transition: all 0.25s;
    }

    &:hover .commandbar-ask-with-ai-btn-icon--arrow {
      opacity: 1;
      width: 10px;
      transition: all 0.25s;
    }
  `,
      btnIcon: css65`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
      btnText: css65`
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    /* identical to box height, or 114% */

    display: flex;
    align-items: center;
    text-align: center;

    background: linear-gradient(360deg, #e1c4ff 21.72%, #ffffff 46.72%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-fill-color: transparent;
  `,
      arrow: css65`
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    width: 0;
    transition: all 0.25s;

    &:hover {
      opacity: 1;
      width: 10px;
      transition: all 0.25s;
    }
  `
    };
    CustomAskAIButton = ({ onClick }) => {
      const _ = useStore();
      const styles51 = useStyles();
      if (!styles51.askAICustomCTAButton)
        return null;
      return /* @__PURE__ */ jsx110(
        "button",
        {
          css: styles51.askAICustomCTAButton,
          style: { transform: "translateY(-50%)", display: "block", padding: "4px 12px", cursor: "pointer", width: "100%" },
          onClick
        },
        interpolate(styles51.strings.askAICustomCTAButtonLabel, _, true, false)
      );
    };
    AskAIButton2 = ({ onClick }) => {
      const _ = useStore();
      const { askAICustomCTAButton, strings } = useStyles();
      if (askAICustomCTAButton) {
        return /* @__PURE__ */ jsx110(CustomAskAIButton, { onClick });
      }
      return /* @__PURE__ */ jsx110(React291.Fragment, null, /* @__PURE__ */ jsx110(
        "div",
        {
          className: "commandbar-ask-with-ai-btn-wrapper",
          css: styles45.glowWrapper,
          onClick,
          role: "button",
          tabIndex: 0,
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              onClick();
            }
          },
          "data-testid": "helphub-ask-ai"
        },
        /* @__PURE__ */ jsx110("div", { css: styles45.btnWrapper }, /* @__PURE__ */ jsx110("div", { css: styles45.btn }, /* @__PURE__ */ jsx110("div", { css: styles45.btnText }, interpolate(strings.askAICustomCTAButtonLabel, _, true, false) || "Ask AI"), /* @__PURE__ */ jsx110("div", { className: "commandbar-ask-with-ai-btn-icon--arrow", css: styles45.arrow }, /* @__PURE__ */ jsx110(ArrowRight_default, { height: 10 }))))
      ));
    };
    AskAIButton_default2 = AskAIButton2;
  }
});

// commandbar/src/shared/img/search-md.svg
import * as React292 from "react";
var SvgSearchMd;
var init_search_md = __esm({
  "commandbar/src/shared/img/search-md.svg"() {
    "use strict";
    SvgSearchMd = (props2) => /* @__PURE__ */ React292.createElement("svg", { width: 17, height: 16, viewBox: "0 0 17 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React292.createElement("path", { opacity: 0.12, d: "M7.58333 12.6667C10.5289 12.6667 12.9167 10.2789 12.9167 7.33333C12.9167 4.38781 10.5289 2 7.58333 2C4.63781 2 2.25 4.38781 2.25 7.33333C2.25 10.2789 4.63781 12.6667 7.58333 12.6667Z", fill: "black" }), /* @__PURE__ */ React292.createElement("path", { d: "M14.25 14L11.35 11.1M12.9167 7.33333C12.9167 10.2789 10.5289 12.6667 7.58333 12.6667C4.63781 12.6667 2.25 10.2789 2.25 7.33333C2.25 4.38781 4.63781 2 7.58333 2C10.5289 2 12.9167 4.38781 12.9167 7.33333Z", stroke: "#A2A2A9", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
  }
});

// commandbar/src/shared/services/end-users/getMostRecentChat.ts
var getMostRecentChat;
var init_getMostRecentChat = __esm({
  "commandbar/src/shared/services/end-users/getMostRecentChat.ts"() {
    "use strict";
    init_network();
    init_generics();
    init_chat();
    init_sentry();
    getMostRecentChat = async (identifier, hmac) => {
      var _a2;
      try {
        const headers = {};
        headers["X-USER-AUTHORIZATION"] = hmac != null ? hmac : "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx";
        const res = await get2(`/u/${identifier}/most_recent_chat/`, {
          headers
        });
        const { data } = res;
        return await decodeToPromise(ChatV, data);
      } catch (error3) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
        return null;
      }
    };
  }
});

// internal/src/util/time.tsx
import dayjs5 from "dayjs";
var getDaysSinceDate, getHoursSinceDate, getMinutesSinceDate, getTimeSinceDate;
var init_time2 = __esm({
  "internal/src/util/time.tsx"() {
    "use strict";
    getDaysSinceDate = (date) => -dayjs5(date).diff(dayjs5(), "day");
    getHoursSinceDate = (date) => -dayjs5(date).diff(dayjs5(), "hour");
    getMinutesSinceDate = (date) => -dayjs5(date).diff(dayjs5(), "minute");
    getTimeSinceDate = (date) => {
      let time = "";
      const minSince = getMinutesSinceDate(date);
      if (minSince < 60) {
        if (minSince === 0) {
          time = "Now";
        } else {
          time = minSince + " min";
          if (minSince > 1) {
            time += "s";
          }
          time += " ago";
        }
      } else {
        const hoursSince = getHoursSinceDate(date);
        if (hoursSince < 24) {
          time = hoursSince + " hour";
          if (hoursSince > 1) {
            time += "s";
          }
          time += "ago";
        } else {
          const daysSince = getDaysSinceDate(date);
          if (daysSince > 0) {
            time = daysSince + " day";
            if (daysSince > 1) {
              time += "s";
            }
            time += " ago";
          }
        }
      }
      return time;
    };
  }
});

// commandbar/src/shared/util/hooks/useStartChat.tsx
import { useCallback as useCallback21, useEffect as useEffect59, useRef as useRef39 } from "react";
var useStartChat;
var init_useStartChat = __esm({
  "commandbar/src/shared/util/hooks/useStartChat.tsx"() {
    "use strict";
    init_globals();
    init_symbols();
    init_chat();
    init_useStore();
    init_Reporting();
    init_sentry();
    init_router();
    init_track();
    init_getMostRecentChat();
    init_time2();
    init_location();
    init_LocalStorage();
    useStartChat = (options) => {
      const { replace = false } = options || {};
      const user = getSDK()[_user];
      const _ = useStore();
      const { navigate, history } = useRouter();
      const canceled = useRef39(false);
      const loading = useRef39(false);
      const { hmac } = getSDK()[_instanceAttributes];
      useEffect59(
        () => () => {
          canceled.current = true;
        },
        []
      );
      const startChat = useCallback21(
        async (initialQuery) => {
          var _a2, _b2;
          if (loading.current)
            return;
          if (!(_ == null ? void 0 : _.organization)) {
            throw new Error("Organization not found");
          }
          loading.current = true;
          const recentChat = !!LocalStorage_default.get("copilot.open", false) && ((_a2 = _.endUser) == null ? void 0 : _a2.identifier) ? await getMostRecentChat(_.endUser.identifier, hmac) : void 0;
          try {
            const modified = recentChat == null ? void 0 : recentChat.modified;
            const recent = !!(modified && getMinutesSinceDate(modified) <= 5);
            if (recent && !replace && !initialQuery) {
              window.CommandBar[_setActiveChat](recentChat.id);
              navigate({
                page: "chats",
                params: { chatId: recentChat.id, chatHistory: recentChat.messages }
              });
            } else {
              const result = await Chat.create({
                organization: _.organization.id,
                user,
                impersonate_mode: getSDK()[_configuration].studioImpersonateMode
              });
              if (!canceled.current) {
                helpHubEngagement({ query: initialQuery }, "chat_started");
                Track.copilot.chatStarted(result.chat_id);
                initialQuery && window.CommandBar[_setActiveChat](result.chat_id);
                navigate(
                  {
                    page: "chats",
                    params: { chatId: result.chat_id, initialQuery: initialQuery !== "" ? initialQuery : void 0 }
                  },
                  { replace }
                );
              }
            }
            if (!isStudioPreview()) {
              LocalStorage_default.set("copilot.open", true);
            }
          } catch (error3) {
            if (!canceled.current) {
              navigate(
                {
                  page: "error",
                  params: { error: error3 }
                },
                { replace }
              );
              (_b2 = getSentry()) == null ? void 0 : _b2.captureException(error3);
            }
          } finally {
            loading.current = false;
          }
        },
        [history]
      );
      return startChat;
    };
  }
});

// internal/src/client/themesV2/components/shared/StyledInputContainer.tsx
import React293 from "react";
var Container11, StyledInputContainer, StyledInputContainer_default;
var init_StyledInputContainer = __esm({
  "internal/src/client/themesV2/components/shared/StyledInputContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container11 = styled_browser_esm_default.div`
  position: relative;
  display: flex;
  padding: var(--layout-padding);
  flex-direction: column;
  align-items: flex-start;
  gap: var(--layout-gap);
  align-self: stretch;
`;
    StyledInputContainer = React293.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React293.createElement(Container11, { ref: ref12, ...props2 }, children);
      }
    );
    StyledInputContainer_default = StyledInputContainer;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubSearchInput.tsx
import React294 from "react";
import { css as css66, jsx as jsx111 } from "@emotion/core";
var styles46, focusStyles, StyledHelpHubSearchInput, StyledHelpHubSearchInput_default;
var init_StyledHelpHubSearchInput = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubSearchInput.tsx"() {
    "use strict";
    init_StyledBaseInput();
    styles46 = {
      height: "calc(var(--form-control-height) + 2 * var(--form-control-padding-x))",
      borderRadius: "var(--layout-radius-button) var(--layout-radius-button) 0px 0px",
      borderWidth: "0 0 1px 0",
      boxShadow: "none",
      "&:hover": {
        borderWidth: "0 0 1px 0",
        borderColor: "var(--form-control-border-color)",
        background: "var(--form-control-background)",
        color: "var(--content-primary)",
        boxShadow: "none"
      },
      "&:focus": {
        boxShadow: "none",
        borderWidth: "0 0 1px 0",
        borderColor: "var(--form-control-border-color)",
        background: "var(--form-control-background)"
      },
      "&:focus-visible": {
        outline: "none"
      }
    };
    focusStyles = {
      height: "calc(var(--form-control-height) + 2 * var(--form-control-padding-x))"
    };
    StyledHelpHubSearchInput = React294.forwardRef(({ noFocusStyles, ...props2 }, ref12) => {
      return /* @__PURE__ */ jsx111(StyledBaseInput_default, { css: !!noFocusStyles ? css66(styles46) : css66(focusStyles), ref: ref12, ...props2 });
    });
    StyledHelpHubSearchInput_default = StyledHelpHubSearchInput;
  }
});

// internal/src/client/themesV2/components/shared/StyledPaddedButtonGroup.tsx
import React295 from "react";
var Container12, StyledPaddedButtonGroup, StyledPaddedButtonGroup_default;
var init_StyledPaddedButtonGroup = __esm({
  "internal/src/client/themesV2/components/shared/StyledPaddedButtonGroup.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container12 = styled_browser_esm_default.div`
  display: flex;
  align-items: flex-start;
  gap: var(--layout-gap);
  width: 100%;
  padding: var(--layout-padding);
`;
    StyledPaddedButtonGroup = ({ children, ...props2 }) => /* @__PURE__ */ React295.createElement(Container12, { ...props2 }, children);
    StyledPaddedButtonGroup_default = StyledPaddedButtonGroup;
  }
});

// internal/src/client/themesV2/components/helphub/StyledSuggestedSearchesContainer.tsx
import React296 from "react";
var Container13, StyledSuggestedSearchesContainer, StyledSuggestedSearchesContainer_default;
var init_StyledSuggestedSearchesContainer = __esm({
  "internal/src/client/themesV2/components/helphub/StyledSuggestedSearchesContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container13 = styled_browser_esm_default.div`
  display: flex;
  width: 100%;
  padding: 4px 4px 0px 4px;
  flex-direction: column;
`;
    StyledSuggestedSearchesContainer = ({ children, ...props2 }) => /* @__PURE__ */ React296.createElement(Container13, { ...props2 }, children);
    StyledSuggestedSearchesContainer_default = StyledSuggestedSearchesContainer;
  }
});

// internal/src/client/themesV2/components/helphub/StyledSearchInputWrapper.tsx
import React297 from "react";
var Wrapper2, FocusedWrapper, StyledSearchInputWrapper, StyledSearchInputWrapper_default;
var init_StyledSearchInputWrapper = __esm({
  "internal/src/client/themesV2/components/helphub/StyledSearchInputWrapper.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Wrapper2 = styled_browser_esm_default.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  z-index: 1;
  width: calc(100% - 2 * var(--layout-padding));
`;
    FocusedWrapper = styled_browser_esm_default(Wrapper2)`
  border-radius: var(--layout-radius-button);
  border: 1px solid var(--base-accent);
  background: var(--background-primary);
  box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
`;
    StyledSearchInputWrapper = ({
      children,
      copilotEnabled,
      isFocused,
      ...props2
    }) => {
      return copilotEnabled && isFocused ? /* @__PURE__ */ React297.createElement(FocusedWrapper, { ...props2 }, children) : /* @__PURE__ */ React297.createElement(Wrapper2, { ...props2 }, children);
    };
    StyledSearchInputWrapper_default = StyledSearchInputWrapper;
  }
});

// commandbar/src/products/helphub/components/Input.tsx
import { jsx as jsx112 } from "@emotion/core";
import { useState as useState39, useRef as useRef40, useEffect as useEffect60 } from "react";
var Input, Input_default;
var init_Input2 = __esm({
  "commandbar/src/products/helphub/components/Input.tsx"() {
    "use strict";
    init_useStyles();
    init_useStore();
    init_xclose();
    init_LoadingIndicator();
    init_AskAIButton2();
    init_search_md();
    init_useStartChat();
    init_StyledInputContainer();
    init_StyledHelpHubSearchInput();
    init_StyledHelpHubInputButtons();
    init_StyledPaddedButtonGroup();
    init_StyledPrimaryButton();
    init_StyledSecondaryButton();
    init_StyledTertiaryIconButton();
    init_StyledSuggestedSearchesContainer();
    init_StyledSearchInputWrapper();
    init_StyledButtonGroup();
    init_react();
    init_useResizeObserver2();
    init_Interpolate();
    init_ThemeV2Context();
    Input = ({
      query,
      onChangeQuery,
      onSubmit,
      children
    }) => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
      const styles51 = useStyles();
      const _ = useStore();
      const { loading: isLoading, query: submittedQuery } = _.helpHub;
      const [inputFocused, setInputFocused] = useState39(true);
      const [showSuggestedQuestions, setShowSuggestedQuestions] = useState39(false);
      const inputRef = useRef40(null);
      const inputContainerRef = useRef40(null);
      const startChat = useStartChat();
      const themeV2 = useThemeV2Context();
      let inputPaddingRight = 64;
      if (((_a2 = _ == null ? void 0 : _.organization) == null ? void 0 : _a2.copilot_enabled) && !inputFocused) {
        inputPaddingRight += 60;
      }
      useEffect60(() => {
        function handleClickOutside(event) {
          var _a3, _b3;
          if (inputContainerRef.current && !inputContainerRef.current.contains(event.target)) {
            unfocusInput();
          } else if ((_a3 = inputRef.current) == null ? void 0 : _a3.contains(event.target)) {
            setInputFocused((focused) => {
              if (!focused)
                event.preventDefault();
              return true;
            });
            (_b3 = inputRef.current) == null ? void 0 : _b3.focus();
            setShowSuggestedQuestions(true);
          }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [inputContainerRef]);
      useEffect60(() => {
        var _a3;
        if (inputRef) {
          (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
        }
      }, [inputRef]);
      const focusInput = () => {
        var _a3;
        setInputFocused(true);
        (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
        setShowSuggestedQuestions(true);
      };
      const unfocusInput = () => {
        var _a3;
        setInputFocused(false);
        (_a3 = inputRef.current) == null ? void 0 : _a3.blur();
      };
      const handleSubmitQuery = () => {
        onSubmit(query != null ? query : "");
        unfocusInput();
      };
      const handleEnterKeyPress = (e) => {
        var _a3, _b3, _c3;
        if ((_a3 = _.organization) == null ? void 0 : _a3.copilot_enabled) {
          let searchAction = (_b3 = _.organization) == null ? void 0 : _b3.helphub_search_action;
          if (e.shiftKey) {
            searchAction = ((_c3 = _.organization) == null ? void 0 : _c3.helphub_search_action) === "ask" ? "search" : "ask";
          }
          if (searchAction === "ask") {
            startChat(query);
          } else {
            handleSubmitQuery();
          }
        }
      };
      const { ref: inputButtonsRef, width: inputButtonsWidth } = useResizeObserver2_default();
      const showDropdown = inputFocused && showSuggestedQuestions && !(submittedQuery && query);
      return ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? /* @__PURE__ */ jsx112(StyledInputContainer_default, { ref: inputContainerRef, id: "helphub-input-container" }, /* @__PURE__ */ jsx112(StyledSearchInputWrapper_default, { copilotEnabled: !!((_c2 = _ == null ? void 0 : _.organization) == null ? void 0 : _c2.copilot_enabled), isFocused: inputFocused }, /* @__PURE__ */ jsx112(
        StyledHelpHubSearchInput_default,
        {
          themeV2,
          style: {
            paddingRight: (inputButtonsWidth != null ? inputButtonsWidth : 0) + 8,
            ...!showDropdown && { borderWidth: "0px", borderRadius: "var(--layout-radius-button)" }
          },
          noFocusStyles: inputFocused && ((_d = _ == null ? void 0 : _.organization) == null ? void 0 : _d.copilot_enabled),
          value: query != null ? query : "",
          onChange: (e) => onChangeQuery(e.target.value),
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              handleEnterKeyPress(e);
            }
          },
          onKeyUp: () => setShowSuggestedQuestions(true),
          "data-testid": "helphub-input",
          placeholder: interpolate(_.localizedMessages["helphub.search-input-placeholder"], _, true, false),
          onBlur: () => {
            if ((query == null ? void 0 : query.length) === 0) {
              onSubmit("");
            }
          },
          ref: inputRef
        }
      ), /* @__PURE__ */ jsx112(StyledHelpHubInputButtons_default, { ref: inputButtonsRef }, /* @__PURE__ */ jsx112(StyledButtonGroup_default, null, !!query && !isLoading && /* @__PURE__ */ jsx112(
        StyledTertiaryIconButton_default,
        {
          themeV2,
          onClick: () => {
            onChangeQuery("");
            onSubmit("");
            focusInput();
          }
        },
        /* @__PURE__ */ jsx112(XClose_default, null)
      ), ((_e = _ == null ? void 0 : _.organization) == null ? void 0 : _e.copilot_enabled) && !showDropdown && /* @__PURE__ */ jsx112(
        StyledPrimaryButton_default,
        {
          themeV2,
          onClick: () => {
            startChat(query);
          }
        },
        interpolate(
          _.localizedMessages["helphub.ask-ai-button-label"].replace(
            "{{copilot-name}}",
            ((_f = _.helpHub.previewedCopilotSettings) == null ? void 0 : _f.name) || ((_g = _.organization) == null ? void 0 : _g.copilot_name) || "Copilot"
          ),
          _,
          true,
          false
        )
      ))), ((_h = _ == null ? void 0 : _.organization) == null ? void 0 : _h.copilot_enabled) && showDropdown && /* @__PURE__ */ jsx112("div", { style: { width: "100%" } }, !!children && /* @__PURE__ */ jsx112(StyledSuggestedSearchesContainer_default, { "data-testid": "helphub-suggested-searches" }, children), /* @__PURE__ */ jsx112(StyledPaddedButtonGroup_default, null, /* @__PURE__ */ jsx112(
        StyledSecondaryButton_default,
        {
          themeV2,
          onClick: () => {
            if (query && query.length > 0) {
              onSubmit(query);
              unfocusInput();
            } else {
              focusInput();
            }
          },
          "data-testid": "helphub-search"
        },
        interpolate(_.localizedMessages["helphub.helphub-search-button-label"], _, true, false)
      ), /* @__PURE__ */ jsx112(
        StyledPrimaryButton_default,
        {
          themeV2,
          onClick: () => {
            startChat(query);
          }
        },
        interpolate(
          _.localizedMessages["helphub.ask-ai-button-label"].replace(
            "{{copilot-name}}",
            ((_i = _.helpHub.previewedCopilotSettings) == null ? void 0 : _i.name) || ((_j = _.organization) == null ? void 0 : _j.copilot_name) || "Copilot"
          ),
          _,
          true,
          false
        )
      ))))) : (
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        /* @__PURE__ */ jsx112("div", { ref: inputContainerRef, css: styles51.inputContainer, id: "helphub-input-container" }, /* @__PURE__ */ jsx112(
          "div",
          {
            css: {
              ...styles51.inputWrapper,
              ...inputFocused ? styles51.inputWrapperFocused : {}
            }
          },
          /* @__PURE__ */ jsx112(
            "input",
            {
              value: query != null ? query : "",
              onChange: (e) => onChangeQuery(e.target.value),
              onKeyDown: (e) => {
                if (e.key === "Enter") {
                  handleEnterKeyPress(e);
                }
              },
              onKeyUp: () => setShowSuggestedQuestions(true),
              "data-testid": "helphub-input",
              css: {
                ...styles51.input,
                paddingRight: inputPaddingRight
              },
              placeholder: ((_k = _ == null ? void 0 : _.organization) == null ? void 0 : _k.copilot_enabled) ? "Search or ask a question..." : "What can we help you find?",
              onBlur: () => {
                if ((query == null ? void 0 : query.length) === 0) {
                  onSubmit("");
                }
              },
              ref: inputRef
            }
          ),
          query && query.length > 0 && !isLoading && /* @__PURE__ */ jsx112(
            SvgXclose,
            {
              style: {
                ...styles51.closeIcon,
                right: !((_l = _ == null ? void 0 : _.organization) == null ? void 0 : _l.copilot_enabled) || inputFocused ? "14px" : "103px"
              },
              onClick: () => {
                var _a3;
                onChangeQuery("");
                onSubmit("");
                focusInput();
                (_a3 = inputRef.current) == null ? void 0 : _a3.focus();
              }
            }
          ),
          isLoading && (query == null ? void 0 : query.length) !== 0 ? /* @__PURE__ */ jsx112(
            LoadingIndicator_default,
            {
              style: {
                ...styles51.closeIcon,
                top: "14px",
                right: "14px"
              },
              size: 22,
              isLoading: true
            }
          ) : ((_m = _ == null ? void 0 : _.organization) == null ? void 0 : _m.copilot_enabled) && !showDropdown ? /* @__PURE__ */ jsx112("div", { style: styles51.inlineAskAi }, /* @__PURE__ */ jsx112(AskAIButton_default2, { onClick: () => startChat(query) })) : null,
          /* @__PURE__ */ jsx112(
            "div",
            {
              style: {
                display: ((_n = _ == null ? void 0 : _.organization) == null ? void 0 : _n.copilot_enabled) && showDropdown && children !== null ? "flex" : "none",
                ...styles51.suggestionsContainer
              },
              "data-testid": "helphub-suggested-searches"
            },
            children
          ),
          inputFocused && ((_o = _ == null ? void 0 : _.organization) == null ? void 0 : _o.copilot_enabled) && showDropdown && /* @__PURE__ */ jsx112("div", { style: styles51.largeAskAIButtonContainer }, /* @__PURE__ */ jsx112(
            "button",
            {
              css: { ...styles51.searchDocsButton },
              onClick: () => {
                if (query && query.length > 0) {
                  onSubmit(query);
                  unfocusInput();
                } else {
                  focusInput();
                }
              },
              "data-testid": "helphub-search"
            },
            /* @__PURE__ */ jsx112(SvgSearchMd, { role: "img", focusable: false }),
            interpolate(_.localizedMessages["helphub.helphub-search-button-label"], _, true, false)
          ), /* @__PURE__ */ jsx112("div", { style: { flex: 1, position: "relative" } }, /* @__PURE__ */ jsx112("div", { style: { top: "50%", position: "absolute", right: "0", width: "100%" } }, /* @__PURE__ */ jsx112(AskAIButton_default2, { onClick: () => startChat(query) }))))
        ))
      );
    };
    Input_default = Input;
  }
});

// commandbar/src/shared/util/hooks/useKeyboardNavigation.tsx
import { useCallback as useCallback22, useEffect as useEffect61, useState as useState40 } from "react";
var NAV_KEYS, isArrowKey, useKeyboardNavigation, useKeyboardNavigation_default;
var init_useKeyboardNavigation = __esm({
  "commandbar/src/shared/util/hooks/useKeyboardNavigation.tsx"() {
    "use strict";
    NAV_KEYS = /* @__PURE__ */ ((NAV_KEYS2) => {
      NAV_KEYS2["ArrowUp"] = "ArrowUp";
      NAV_KEYS2["ArrowDown"] = "ArrowDown";
      return NAV_KEYS2;
    })(NAV_KEYS || {});
    isArrowKey = (key) => key in NAV_KEYS;
    useKeyboardNavigation = (list2, onEnter) => {
      const [currentIndex, setCurrentIndex] = useState40(-1);
      const [selectionMethod, setSelectionMethod] = useState40("keyboard" /* Keyboard */);
      const handleArrowKeys = useCallback22(
        (event) => {
          event.preventDefault();
          const increment = event.key === "ArrowDown" /* ArrowDown */ ? 1 : -1;
          const totalItems = (list2 == null ? void 0 : list2.length) || 0;
          setSelectionMethod("keyboard" /* Keyboard */);
          setCurrentIndex((previousIndex) => {
            const nextIndex = previousIndex !== -1 ? previousIndex + increment : 0;
            return (nextIndex + totalItems) % totalItems;
          });
        },
        [list2 == null ? void 0 : list2.length, setCurrentIndex]
      );
      const handleEnterKey = useCallback22(
        (event) => {
          if (currentIndex !== -1) {
            event.preventDefault();
            const selectedItem = list2 == null ? void 0 : list2[currentIndex];
            if (selectedItem) {
              onEnter(selectedItem);
            }
          }
        },
        [onEnter, currentIndex, list2]
      );
      useEffect61(() => {
        const handleKeyDown2 = (event) => {
          if (isArrowKey(event.key)) {
            handleArrowKeys(event);
          } else if (event.key === "Enter") {
            handleEnterKey(event);
          }
        };
        document.addEventListener("keydown", handleKeyDown2);
        return () => {
          document.removeEventListener("keydown", handleKeyDown2);
        };
      }, [handleArrowKeys, handleEnterKey]);
      const onMouseMove = (index3) => {
        setSelectionMethod("mouse" /* Mouse */);
        setCurrentIndex(index3);
      };
      const onMouseLeave = () => {
        setCurrentIndex(-1);
      };
      return { currentIndex, selectionMethod, onMouseMove, onMouseLeave };
    };
    useKeyboardNavigation_default = useKeyboardNavigation;
  }
});

// commandbar/src/products/helphub/components/NoSearchResults.tsx
import React298 from "react";
var containerStyles3, iconContainerStyles, iconContainerInnerStyles, NoSearchResults;
var init_NoSearchResults = __esm({
  "commandbar/src/products/helphub/components/NoSearchResults.tsx"() {
    "use strict";
    init_react();
    init_useTheme();
    containerStyles3 = {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      padding: "24px 0"
    };
    iconContainerStyles = {
      marginTop: "12px",
      marginBottom: "16px",
      position: "relative",
      boxSizing: "border-box",
      display: "flex",
      flexDirection: "row",
      alignItems: "flex-start",
      padding: "8px 16px",
      gap: "8px",
      width: "112px",
      overflow: "hidden",
      background: "linear-gradient(90deg, #ffedbf 0%, rgba(255, 237, 191, 0) 72.73%)",
      border: "1px solid #a77800",
      borderRadius: "100px",
      color: "#a77800"
    };
    iconContainerInnerStyles = {
      width: "100%",
      height: "100%",
      display: "flex",
      maskImage: "linear-gradient(to right, black 0%, transparent 100%)"
    };
    NoSearchResults = () => {
      const { theme } = useTheme();
      const titleStyles = {
        fontWeight: theme.helpHub.noResultsTitleFontWeight,
        fontSize: theme.helpHub.noResultsTitleFontSize,
        color: theme.helpHub.noResultsTitleColor,
        textAlign: "center"
      };
      const descriptionStyles = {
        fontWeight: theme.helpHub.noResultsDescriptionFontWeight,
        fontSize: theme.helpHub.noResultsDescriptionFontSize,
        color: theme.helpHub.noResultsDescriptionColor,
        textAlign: "center"
      };
      return /* @__PURE__ */ React298.createElement("div", { style: containerStyles3, "data-testid": "helphub-search-no-results" }, /* @__PURE__ */ React298.createElement("div", { style: iconContainerStyles }, /* @__PURE__ */ React298.createElement("div", { style: iconContainerInnerStyles }, /* @__PURE__ */ React298.createElement(SearchSm_default, { width: 32 }), /* @__PURE__ */ React298.createElement(SearchSm_default, { width: 32 }), /* @__PURE__ */ React298.createElement(SearchSm_default, { width: 32 }))), /* @__PURE__ */ React298.createElement("div", { style: titleStyles }, "Hmm. No results found."), /* @__PURE__ */ React298.createElement("div", { style: descriptionStyles }, "Try searching with a question instead."));
    };
  }
});

// internal/src/client/themesV2/helpers/shared.tsx
import React299 from "react";
var leftIcon, rightIcon;
var init_shared = __esm({
  "internal/src/client/themesV2/helpers/shared.tsx"() {
    "use strict";
    init_react();
    init_CheckSquareBroken2();
    init_NotificationBox2();
    leftIcon = (type39) => {
      switch (type39) {
        case "video":
          return /* @__PURE__ */ React299.createElement(Play_default, null);
        case "link":
          return /* @__PURE__ */ React299.createElement(LinkExternal01_default, null);
        case "helpdoc":
          return /* @__PURE__ */ React299.createElement(BookOpen01_default, null);
        case "answer":
          return /* @__PURE__ */ React299.createElement(BookmarkCheck_default, null);
        case "click":
          return /* @__PURE__ */ React299.createElement(CursorClick02_default, null);
        case "open_chat":
          return /* @__PURE__ */ React299.createElement(MessageChatCircle_default, null);
        case "questlist":
        case "checklist":
          return /* @__PURE__ */ React299.createElement(CheckSquareBroken_default2, null);
        case "nudge":
          return /* @__PURE__ */ React299.createElement(NotificationBox_default2, null);
        default:
          return /* @__PURE__ */ React299.createElement(Lightning01_default, null);
      }
    };
    rightIcon = (type39) => {
      switch (type39) {
        case "link":
          return /* @__PURE__ */ React299.createElement(ArrowUpRight_default, null);
        case "click":
        case "video":
        case "helpdoc":
        case "execute_command":
        case "open_chat":
        case "questlist":
        case "checklist":
        case "nudge":
          return /* @__PURE__ */ React299.createElement(ChevronRight_default, null);
        default:
          return null;
      }
    };
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubCard.tsx
import React300 from "react";
import { jsx as jsx113, css as css67 } from "@emotion/core";
var styles47, answerStyles, loadingStyles2, TextContainer, Title2, Content6, SearchContent, LoadingTitle, LoadingContent, AnswerIconContainer, DefaultIconContainer, slug19, StyledHelpHubCard, StyledHelpHubCardMock, StyledHelpHubCard_default;
var init_StyledHelpHubCard = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubCard.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledHelpDocCard();
    init_shared();
    init_StyledIconContainer();
    init_Icon();
    init_useComponentOverrides();
    init_ButtonWithReset();
    init_react();
    styles47 = {
      display: "flex",
      minHeight: "64px",
      padding: "var(--layout-padding)",
      alignItems: "center",
      gap: "12px",
      alignSelf: "stretch",
      textAlign: "left",
      cursor: "pointer",
      borderRadius: "var(--layout-radius-button)",
      border: "1px solid var(--border-primary)",
      background: "var(--background-primary)",
      boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
      "&:hover": {
        border: "1px solid var(--border-primary-hover)",
        background: "var(--background-primary-hover)",
        boxShadow: "var(--form-control-shadow) var(--form-control-shadow-color)",
        "--content-primary": "var(--content-primary-hover)",
        "--content-secondary": "var(--content-secondary-hover)"
      },
      "&:focus": {
        boxShadow: "0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color)",
        border: "1px solid var(--base-accent)"
      },
      "&:focus-visible": {
        outline: "none"
      },
      mark: {
        padding: 0,
        color: "var(--content-secondary)",
        borderRadius: "2px",
        backgroundColor: "var(--highlight-color)"
      }
    };
    answerStyles = {
      background: "linear-gradient(to right, var(--form-control-active-background), var(--background-primary))",
      "&:hover": {
        background: "var(--form-control-focus-ring-color)"
      }
    };
    loadingStyles2 = {
      background: "linear-gradient(89deg, #d9d9d9 13.8%, #c9c9c9 30.92%, #d9d9d9 48.56%)"
    };
    TextContainer = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 1 0;

  overflow: hidden;
`;
    Title2 = styled_browser_esm_default.div`
  color: var(--content-primary);

  /* label/base/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);

  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
    Content6 = styled_browser_esm_default.div`
  color: var(--content-secondary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;
    SearchContent = styled_browser_esm_default(Content6)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  white-space: normal; /* Override to allow wrapping */
`;
    LoadingTitle = styled_browser_esm_default.div`
  width: 195.55px;
  height: 16px;
  border-radius: 4px;
  background: var(--base-white);
`;
    LoadingContent = styled_browser_esm_default.div`
  width: 289.834px;
  height: 12px;
  border-radius: 4px;
  background: var(--base-white);
`;
    AnswerIconContainer = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--base-accent);
`;
    DefaultIconContainer = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--content-secondary);
`;
    slug19 = "contentListItem";
    StyledHelpHubCard = Object.assign(
      React300.forwardRef(
        ({ children, type: type39, label, content, loading, featured, active, page, icon, iconColor, themeV2, ...props2 }, ref12) => {
          const { overrides } = useComponentOverrides_default(slug19, themeV2);
          const LeftIcon2 = icon ? /* @__PURE__ */ jsx113(
            Icon_default,
            {
              icon,
              style: {
                ...iconColor && { color: iconColor },
                // reset featured icon color to white if it is currently black
                ...featured && iconColor === "#000000" && { color: "var(--base-white)" }
              }
            }
          ) : leftIcon(type39);
          return !!featured ? /* @__PURE__ */ jsx113(
            StyledHelpDocCard_default,
            {
              ref: ref12,
              type: type39,
              loading: !!loading,
              label,
              icon: LeftIcon2,
              themeV2,
              style: { height: "150px" },
              ...props2
            }
          ) : !!loading ? /* @__PURE__ */ jsx113(ButtonWithReset_default, { css: [overrides, css67(styles47), css67(loadingStyles2)] }, /* @__PURE__ */ jsx113(LoadingTitle, null), page === "search" && /* @__PURE__ */ jsx113(LoadingContent, null)) : type39 === "answer" ? /* @__PURE__ */ jsx113(ButtonWithReset_default, { css: [overrides, css67(styles47), css67(answerStyles)], ref: ref12, ...props2 }, /* @__PURE__ */ jsx113(AnswerIconContainer, null, LeftIcon2), /* @__PURE__ */ jsx113(TextContainer, null, /* @__PURE__ */ jsx113(Title2, null, label), page === "search" ? /* @__PURE__ */ jsx113(SearchContent, { dangerouslySetInnerHTML: { __html: content } }) : /* @__PURE__ */ jsx113(Content6, { dangerouslySetInnerHTML: { __html: content } })), /* @__PURE__ */ jsx113(DefaultIconContainer, null, active && rightIcon(type39))) : /* @__PURE__ */ jsx113(ButtonWithReset_default, { css: [overrides, css67(styles47)], ref: ref12, ...props2 }, /* @__PURE__ */ jsx113(DefaultIconContainer, null, LeftIcon2), /* @__PURE__ */ jsx113(TextContainer, null, /* @__PURE__ */ jsx113(Title2, null, label), page === "search" ? /* @__PURE__ */ jsx113(SearchContent, { dangerouslySetInnerHTML: { __html: content } }) : /* @__PURE__ */ jsx113(Content6, { dangerouslySetInnerHTML: { __html: content } })), /* @__PURE__ */ jsx113(DefaultIconContainer, null, active && rightIcon(type39)));
        }
      ),
      {
        slug: slug19,
        styles: styles47,
        renderMock: (themeV2, mode) => /* @__PURE__ */ jsx113(StyledHelpHubCardMock, { themeV2, mode })
      }
    );
    StyledHelpHubCardMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug19, { themeV2, mode });
      return /* @__PURE__ */ jsx113(ButtonWithReset_default, { css: [overrides, css67(styles47)] }, /* @__PURE__ */ jsx113(DefaultIconContainer, null, /* @__PURE__ */ jsx113(BookOpen01_default, null)), /* @__PURE__ */ jsx113(TextContainer, null, /* @__PURE__ */ jsx113(Title2, null, "Content item title"), /* @__PURE__ */ jsx113(Content6, { dangerouslySetInnerHTML: { __html: "Search match or beginning of this content item" } })), /* @__PURE__ */ jsx113(DefaultIconContainer, null, /* @__PURE__ */ jsx113(ChevronRight_default, null)));
    };
    StyledHelpHubCard_default = StyledHelpHubCard;
  }
});

// commandbar/src/products/helphub/components/RecommendationCard.tsx
import React301, { useEffect as useEffect62, useRef as useRef41, useState as useState41 } from "react";
import { jsx as jsx114 } from "@emotion/core";
import dayjs6 from "dayjs";
var getRecommendationLabel, CardComponent, LeftIcon, MetaHeader, RightIcon, RecommendationCard, RecommendationCard_default;
var init_RecommendationCard = __esm({
  "commandbar/src/products/helphub/components/RecommendationCard.tsx"() {
    "use strict";
    init_useStyles();
    init_useTheme();
    init_Icon2();
    init_react();
    init_useKeyboardNavigation();
    init_helpdocService();
    init_useStore();
    init_service_selectors2();
    init_LoadingIndicator();
    init_service_selectors3();
    init_StyledHelpHubCard();
    init_ThemeV2Context();
    getRecommendationLabel = async (_, labeledAction, command) => {
      switch (labeledAction.action.type) {
        case "execute_command":
          if (labeledAction.action.meta.command === "") {
            if (labeledAction.action.meta.type === "helpdoc") {
              return "Unlabeled document";
            } else if (labeledAction.action.meta.type === "video") {
              return "Unlabeled video";
            } else {
              return "Unlabeled action";
            }
          } else {
            return (command == null ? void 0 : command.text) || "Unlabeled document";
          }
        case "click":
          return "Unlabeled click";
        case "open_chat":
          return "Open chat";
        case "chat_handoff":
          return "Chat handoff";
        case "questlist":
          const questlistID = labeledAction.action.value;
          const questlist = getChecklistById(_, Number(questlistID));
          return (questlist == null ? void 0 : questlist.title) || "Unlabeled Checklist";
        case "nudge":
          const nudgeID = labeledAction.action.value;
          const nudge = getAllNudges(_).find((c) => c.id === Number(nudgeID));
          if (nudge) {
            return nudge && nudge.slug || (nudge.steps.length === 1 ? nudge.steps[0].title : "Unlabeled Nudge");
          }
          return "Unlabeled Nudge";
        case "link":
          return labeledAction.action.value || "Unlabeled link";
        case "open_copilot":
          return "Open Copilot";
        case "open_helphub":
          return "Open HelpHub";
        case "open_bar":
          return "Open Spotlight";
        default:
          return "Recommendation";
      }
    };
    CardComponent = ({ styles: styles51, labeledAction, command, active, iconComponent }) => {
      var _a2, _b2;
      const { theme } = useTheme();
      const _ = useStore();
      const [label, setLabel] = useState41(null);
      useEffect62(() => {
        getRecommendationLabel(_, labeledAction, command).then((value) => {
          setLabel(value);
        });
      }, [labeledAction]);
      const ariaLabel = labeledAction.cta || (command == null ? void 0 : command.text) || labeledAction.action.type;
      if ((_a2 = command == null ? void 0 : command.thumbnail) == null ? void 0 : _a2.src) {
        return /* @__PURE__ */ jsx114(
          "div",
          {
            style: {
              ...styles51.gridItemPreview,
              overflow: "hidden",
              width: "100%",
              backgroundImage: ((_b2 = command == null ? void 0 : command.thumbnail) == null ? void 0 : _b2.src) ? `url(${command.thumbnail.src})` : "",
              backgroundSize: "cover",
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              border: styles51.gridItemPreview.border.includes("transparent") ? "none" : styles51.gridItemPreview.border,
              ...active && !styles51.gridItemPreview.border.includes("transparent") ? styles51.gridItemPreviewActive : {}
            },
            "aria-label": ariaLabel
          },
          labeledAction.cta.length > 0 && /* @__PURE__ */ jsx114("span", { css: styles51.gridItemTitle }, labeledAction.cta),
          /* @__PURE__ */ jsx114("div", { css: styles51.gridItemPreviewButton, "aria-hidden": true }, iconComponent)
        );
      }
      const activeStyle = active ? {
        ...styles51.gridItemPreviewActive,
        background: theme.helpHubGridItem.hoverBackground
      } : {};
      return /* @__PURE__ */ jsx114(
        "div",
        {
          css: {
            ...styles51.gridItemPreview,
            background: theme.helpHubGridItem.background,
            ...activeStyle
          },
          "aria-label": ariaLabel
        },
        /* @__PURE__ */ jsx114("span", { css: styles51.gridItemTitleWithGradient }, labeledAction.cta || label),
        /* @__PURE__ */ jsx114("div", { css: styles51.gridItemPreviewButton, "aria-hidden": true }, iconComponent)
      );
    };
    LeftIcon = ({ action, command }) => {
      const { theme } = useTheme();
      const _ = useStore();
      if (command) {
        const category = _.spotlight.categories.find((c) => c.id === command.category);
        const customIcon = category && category.icon ? category.icon : command.icon;
        const customIconColor = category && category.icon_color ? category.icon_color : command.icon_color;
        if (customIcon) {
          return /* @__PURE__ */ jsx114(
            Icon_default2,
            {
              size: theme.helpHubListItem.iconSize,
              icon: customIcon,
              color: customIconColor,
              useDefaultSVGColor: !customIconColor
            }
          );
        }
        switch (command.template.type) {
          case "video":
            return /* @__PURE__ */ jsx114(Play_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          case "link":
            return /* @__PURE__ */ jsx114(LinkExternal01_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          case "helpdoc":
            return command.template.type === "helpdoc" && command.template.doc_type === "answer" ? /* @__PURE__ */ jsx114(BookmarkCheck_default, { width: parseInt(theme.helpHubListItem.iconSize, 10), color: "#2755F0" }) : /* @__PURE__ */ jsx114(BookOpen01_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          default:
            return /* @__PURE__ */ jsx114(Lightning01_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
        }
      } else {
        switch (action.type) {
          case "link":
            return /* @__PURE__ */ jsx114(LinkExternal01_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          case "click":
            return /* @__PURE__ */ jsx114(CursorClick02_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          case "open_chat":
            return /* @__PURE__ */ jsx114(MessageChatCircle_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          case "questlist":
            return /* @__PURE__ */ jsx114(CheckSquareBroken_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          case "nudge":
            return /* @__PURE__ */ jsx114(NotificationBox_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
          default:
            return /* @__PURE__ */ jsx114(BookOpen01_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
        }
      }
    };
    MetaHeader = ({ metadata }) => {
      const styles51 = useStyles();
      return /* @__PURE__ */ jsx114("div", { css: styles51.resultCardMeta }, metadata.content_type && /* @__PURE__ */ jsx114("div", { css: styles51.resultCardContentType }, /* @__PURE__ */ jsx114("span", null, metadata.content_type)), metadata.date && /* @__PURE__ */ jsx114("div", { css: styles51.resultCardDate }, /* @__PURE__ */ jsx114("span", null, dayjs6(metadata.date).format("MMMM D YYYY"))));
    };
    RightIcon = ({
      theme,
      type: type39
    }) => {
      switch (type39) {
        case "link":
          return /* @__PURE__ */ jsx114(LinkExternal01_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
        case "click":
        case "video":
        case "helpdoc":
        case "execute_command":
        case "open_chat":
        case "questlist":
        case "nudge":
          return /* @__PURE__ */ jsx114(ChevronRight_default, { width: parseInt(theme.helpHubListItem.iconSize, 10) });
        default:
          return null;
      }
    };
    RecommendationCard = ({
      labeledAction,
      active,
      selectionMethod,
      onClick,
      onMouseMove,
      grid
    }) => {
      var _a2, _b2, _c2, _d, _e, _f, _g;
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const styles51 = useStyles();
      const activeRef = useRef41(null);
      const _ = useStore();
      const [command, setCommand] = useState41(null);
      const [label, setLabel] = useState41(null);
      const [loading, setLoading2] = useState41(false);
      useEffect62(() => {
        var _a3;
        if (labeledAction.action.type !== "execute_command" && labeledAction.action.type !== "link") {
          return;
        }
        if ((_a3 = labeledAction.action.meta) == null ? void 0 : _a3.command) {
          setLoading2(true);
          helpdocService_default.getCommandOrHelpdoc(_, labeledAction.action.meta.command).then((value) => {
            setCommand(value != null ? value : null);
          }).finally(() => {
            setLoading2(false);
          });
        }
      }, [labeledAction.action]);
      useEffect62(() => {
        getRecommendationLabel(_, labeledAction, command).then((value) => {
          setLabel(value);
        });
      }, [labeledAction, command]);
      useEffect62(() => {
        if (active && selectionMethod === "keyboard" /* Keyboard */) {
          (activeRef == null ? void 0 : activeRef.current) && activeRef.current.scrollIntoView({ block: "center" });
        }
      }, [active, selectionMethod]);
      const renderGridCardContent = () => {
        const icon = () => {
          if (command) {
            switch (command.template.type) {
              case "video":
                return /* @__PURE__ */ jsx114(
                  Play_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              case "link":
                return /* @__PURE__ */ jsx114(
                  LinkExternal01_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              case "helpdoc":
                return /* @__PURE__ */ jsx114(
                  BookOpen01_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              default:
                return /* @__PURE__ */ jsx114(
                  Lightning01_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
            }
          } else {
            switch (labeledAction.action.type) {
              case "link":
                return /* @__PURE__ */ jsx114(
                  Link05_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              case "click":
                return /* @__PURE__ */ jsx114(
                  CursorClick02_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              case "open_chat":
                return /* @__PURE__ */ jsx114(
                  MessageChatCircle_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              case "questlist":
                return /* @__PURE__ */ jsx114(
                  CheckSquareBroken_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              case "nudge":
                return /* @__PURE__ */ jsx114(
                  NotificationBox_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
              default:
                return /* @__PURE__ */ jsx114(
                  Lightning01_default,
                  {
                    width: parseInt(theme.helpHubGridItem.iconSize),
                    color: theme.helpHubGridItem.ctaButtonForeground
                  }
                );
            }
          }
        };
        return /* @__PURE__ */ jsx114(
          CardComponent,
          {
            styles: styles51,
            command,
            labeledAction,
            active,
            iconComponent: icon()
          }
        );
      };
      const renderInlineCardContent = () => {
        var _a3, _b3;
        return /* @__PURE__ */ jsx114("div", { css: styles51.resultCardTextContainer }, command && command.template.type === "helpdoc" && (((_a3 = command.template.doc_metadata) == null ? void 0 : _a3.content_type) || ((_b3 = command.template.doc_metadata) == null ? void 0 : _b3.date)) && /* @__PURE__ */ jsx114(MetaHeader, { metadata: command.template.doc_metadata }), /* @__PURE__ */ jsx114("div", { css: styles51.recommendedListItemText }, /* @__PURE__ */ jsx114("span", { css: styles51.recommendedListItemTitle }, labeledAction.cta || label), command && command.explanation && /* @__PURE__ */ jsx114("span", { css: styles51.recommendedListItemDescription }, command.explanation)));
      };
      const renderCardContent = () => grid ? renderGridCardContent() : /* @__PURE__ */ jsx114(React301.Fragment, null, /* @__PURE__ */ jsx114("div", { css: styles51.recommendedListItemIcon, "aria-hidden": true }, /* @__PURE__ */ jsx114(LeftIcon, { action: labeledAction.action, command })), renderInlineCardContent(), /* @__PURE__ */ jsx114("div", { css: { ...styles51.recommendedListItemIcon, opacity: active ? "1" : "0" } }, /* @__PURE__ */ jsx114(
        RightIcon,
        {
          type: labeledAction.action.type === "execute_command" ? command == null ? void 0 : command.template.type : labeledAction.action.type,
          theme
        }
      )));
      const ariaLabel = labeledAction.cta || (command == null ? void 0 : command.text) || labeledAction.action.type;
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx114(
        StyledHelpHubCard_default,
        {
          page: "home",
          ref: activeRef,
          key: JSON.stringify(labeledAction),
          onClick,
          onMouseMove,
          "aria-label": ariaLabel,
          type: (command == null ? void 0 : command.template.type) === "helpdoc" && command.template.doc_type === "answer" ? "answer" : (_b2 = command == null ? void 0 : command.template.type) != null ? _b2 : labeledAction.action.type,
          label: ((_c2 = command == null ? void 0 : command.thumbnail) == null ? void 0 : _c2.src) && !!grid ? labeledAction.cta : (_d = labeledAction.cta || label) != null ? _d : "",
          content: (_e = command == null ? void 0 : command.explanation) != null ? _e : "",
          loading,
          featured: !!grid,
          active,
          backgroundImage: (_g = (_f = command == null ? void 0 : command.thumbnail) == null ? void 0 : _f.src) != null ? _g : void 0,
          icon: command == null ? void 0 : command.icon,
          iconColor: command == null ? void 0 : command.icon_color,
          themeV2
        }
      ) : /* @__PURE__ */ jsx114(
        "button",
        {
          type: "button",
          ref: activeRef,
          key: JSON.stringify(labeledAction),
          css: {
            ...grid ? styles51.gridItem : styles51.recommendedListItem,
            ...active && !grid ? styles51.recommendedListItemActive : {}
          },
          onClick,
          onMouseMove,
          "aria-label": ariaLabel
        },
        loading ? /* @__PURE__ */ jsx114(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%"
            }
          },
          /* @__PURE__ */ jsx114(LoadingIndicator_default, { isLoading: true, size: 30 })
        ) : renderCardContent()
      );
    };
    RecommendationCard_default = RecommendationCard;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubList.tsx
import React302 from "react";
var List, StyledHelpHubList, StyledHelpHubList_default;
var init_StyledHelpHubList = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubList.tsx"() {
    "use strict";
    init_styled_browser_esm();
    List = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--layout-gap, 8px);
  align-self: stretch;
`;
    StyledHelpHubList = React302.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React302.createElement(List, { ref: ref12, ...props2 }, children);
      }
    );
    StyledHelpHubList_default = StyledHelpHubList;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubListHeader.tsx
import React303 from "react";
var Header5, StyledHelpHubListHeader, StyledHelpHubListHeader_default;
var init_StyledHelpHubListHeader = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubListHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Header5 = styled_browser_esm_default.div`
  display: flex;
  padding-bottom: var(--layout-padding);
  justify-content: space-between;
  gap: var(--layout-gap);
  align-items: center;
  align-self: stretch;
`;
    StyledHelpHubListHeader = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React303.createElement(Header5, { ...props2 }, children);
    };
    StyledHelpHubListHeader_default = StyledHelpHubListHeader;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubListTitle.tsx
import React304 from "react";
var Title3, StyledHelpHubListTitle, StyledHelpHubListTitle_default;
var init_StyledHelpHubListTitle = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubListTitle.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Title3 = styled_browser_esm_default.div`
  color: var(--content-primary);

  /* label/lg/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-snug);
`;
    StyledHelpHubListTitle = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React304.createElement(Title3, { ...props2 }, children);
    };
    StyledHelpHubListTitle_default = StyledHelpHubListTitle;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubListSubtitle.tsx
import React305 from "react";
var Subtitle, StyledHelpHubListSubtitle, StyledHelpHubListSubtitle_default;
var init_StyledHelpHubListSubtitle = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubListSubtitle.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Subtitle = styled_browser_esm_default.div`
  color: var(--content-secondary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    StyledHelpHubListSubtitle = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React305.createElement(Subtitle, { ...props2 }, children);
    };
    StyledHelpHubListSubtitle_default = StyledHelpHubListSubtitle;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubListContainer.tsx
import React306 from "react";
var Container14, StyledHelpHubListContainer, StyledHelpHubListContainer_default;
var init_StyledHelpHubListContainer = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubListContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container14 = styled_browser_esm_default.div`
  position: relative;
  display: flex;
  padding: var(--layout-padding);
  top: 48px;
  margin-bottom: 48px;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  overflow-y: auto;
  flex: 1;
`;
    StyledHelpHubListContainer = React306.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React306.createElement(Container14, { ref: ref12, ...props2 }, children);
      }
    );
    StyledHelpHubListContainer_default = StyledHelpHubListContainer;
  }
});

// internal/src/client/themesV2/components/helphub/StyledNoResults.tsx
import React307 from "react";
var Container15, TextContainer2, Title4, Subtitle2, Icon3, StyledNoResults, StyledNoResults_default;
var init_StyledNoResults = __esm({
  "internal/src/client/themesV2/components/helphub/StyledNoResults.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    Container15 = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 56px 8px;
`;
    TextContainer2 = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;
    Title4 = styled_browser_esm_default.span`
  color: var(--content-primary);

  /* label/lg/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-large);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-snug);
`;
    Subtitle2 = styled_browser_esm_default.span`
  color: var(--content-secondary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    Icon3 = styled_browser_esm_default.span`
  color: var(--content-secondary);
`;
    StyledNoResults = () => {
      return /* @__PURE__ */ React307.createElement(Container15, null, /* @__PURE__ */ React307.createElement(Icon3, null, /* @__PURE__ */ React307.createElement(FileSearch02_default, { height: "32px", width: "32px" })), /* @__PURE__ */ React307.createElement(TextContainer2, null, /* @__PURE__ */ React307.createElement(Title4, null, "No results found."), /* @__PURE__ */ React307.createElement(Subtitle2, null, "Try searching with a question instead.")));
    };
    StyledNoResults_default = StyledNoResults;
  }
});

// commandbar/src/products/helphub/components/SearchResults.tsx
import { jsx as jsx115, css as css68 } from "@emotion/core";
import React308, { useEffect as useEffect63, useRef as useRef42 } from "react";
var ResultCard, SearchResults, SearchResults_default;
var init_SearchResults = __esm({
  "commandbar/src/products/helphub/components/SearchResults.tsx"() {
    "use strict";
    init_useStyles();
    init_useTheme();
    init_useStore();
    init_useKeyboardNavigation();
    init_useHasScroll();
    init_Reporting();
    init_NoSearchResults();
    init_RecommendationCard();
    init_router();
    init_StyledHelpHubList();
    init_StyledHelpHubListHeader();
    init_StyledHelpHubListTitle();
    init_StyledHelpHubListSubtitle();
    init_StyledHelpHubListContainer();
    init_StyledHelpHubCard();
    init_StyledNoResults();
    init_track();
    init_ThemeV2Context();
    init_operatingSystem();
    ResultCard = ({ doc, active, selectionMethod, onClick, onMouseMove }) => {
      const styles51 = useStyles();
      const { theme } = useTheme();
      const activeRef = useRef42(null);
      useEffect63(() => {
        if (active && selectionMethod === "keyboard" /* Keyboard */) {
          (activeRef == null ? void 0 : activeRef.current) && activeRef.current.scrollIntoView({ block: "center" });
        }
      }, [active, selectionMethod]);
      return (
        // also include styles for the mark element
        /* @__PURE__ */ jsx115(
          "button",
          {
            css: [
              {
                ...styles51.resultCard,
                ...active && styles51.resultCardActive,
                ...doc.command.template.type === "helpdoc" && doc.command.template.doc_type === "answer" && styles51.resultCardAnswer
              },
              css68`
          mark {
            padding: 0;
            color: ${styles51.highlightMark.color};
            border-radius: ${styles51.highlightMark.borderRadius};
            background-color: ${styles51.highlightMark.backgroundColor};
            transition: background-color ${theme.main.transitionTime} ease;
          }
        `
            ],
            onClick,
            onMouseMove,
            ref: activeRef,
            key: doc.command.id,
            "aria-label": doc.command.text
          },
          /* @__PURE__ */ jsx115("div", { css: styles51.resultCardIcon, "aria-hidden": true }, /* @__PURE__ */ jsx115(
            LeftIcon,
            {
              action: { type: "execute_command", meta: { command: doc.command.id.toString() } },
              command: doc.command
            }
          )),
          /* @__PURE__ */ jsx115("div", { css: styles51.resultCardTextContainer }, doc.command.template.type === "helpdoc" && doc.command.template.doc_metadata && /* @__PURE__ */ jsx115(MetaHeader, { metadata: doc.command.template.doc_metadata }), /* @__PURE__ */ jsx115("div", { css: styles51.resultCardText }, /* @__PURE__ */ jsx115("span", { css: styles51.resultCardTitle }, doc.command.text), doc.excerpt && /* @__PURE__ */ jsx115("div", { css: styles51.resultCardExcerpt, dangerouslySetInnerHTML: { __html: doc.excerpt } }))),
          /* @__PURE__ */ jsx115("div", { css: { ...styles51.resultCardRightCaret, opacity: active ? "1" : "0" } }, /* @__PURE__ */ jsx115(RightIcon, { type: doc.command.template.type, theme }))
        )
      );
    };
    SearchResults = ({ docs }) => {
      var _a2;
      const scrollRef = useRef42(null);
      const { hasScrolled } = useHasScroll_default(scrollRef);
      const _ = useStore();
      const styles51 = useStyles();
      const { navigate } = useRouter();
      const { flags } = _;
      const themeV2 = useThemeV2Context();
      const openDoc = (doc, e) => {
        Track.helphub.searchResultClicked(doc);
        if (((flags == null ? void 0 : flags["switch-open-help-doc-in-new-tab"]) || !!e && getTriggerKey(e)) && typeof doc.command.template.value === "string" && doc.command.template.value !== "") {
          window.open(doc.command.template.value, "_blank");
          return;
        }
        navigate({ page: "docs", params: { docId: doc.command.id } });
      };
      const { currentIndex, selectionMethod, onMouseMove, onMouseLeave } = useKeyboardNavigation_default(docs, openDoc);
      React308.useEffect(() => {
        if (hasScrolled) {
          helpHubEngagement({ query: _.helpHub.query }, "scrolled");
        }
      }, [hasScrolled]);
      const renderContent = () => {
        if (docs.length === 0) {
          return /* @__PURE__ */ jsx115(NoSearchResults, null);
        }
        return (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          /* @__PURE__ */ jsx115(
            "div",
            {
              css: styles51.resultListContainer,
              role: "list",
              "data-testid": "helphub-searchresults-list",
              onMouseLeave
            },
            docs.map((doc, index3) => {
              const active = currentIndex === index3;
              return /* @__PURE__ */ jsx115(
                ResultCard,
                {
                  key: doc.command.id,
                  doc,
                  onClick: () => openDoc(doc),
                  active,
                  selectionMethod,
                  onMouseMove: () => onMouseMove(index3)
                }
              );
            })
          )
        );
      };
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx115(StyledHelpHubListContainer_default, { style: { background: "var(--background-primary)" } }, docs.length > 0 && /* @__PURE__ */ jsx115(StyledHelpHubListHeader_default, null, /* @__PURE__ */ jsx115(StyledHelpHubListTitle_default, null, "Search Results"), /* @__PURE__ */ jsx115(StyledHelpHubListSubtitle_default, null, docs.length, " result", docs.length === 1 ? "" : "s", " found")), docs.length === 0 ? /* @__PURE__ */ jsx115(StyledNoResults_default, null) : /* @__PURE__ */ jsx115(
        StyledHelpHubList_default,
        {
          role: "list",
          "data-testid": "helphub-searchresults-list",
          "aria-label": "Results",
          onMouseLeave
        },
        docs.map((doc, index3) => /* @__PURE__ */ jsx115(
          StyledHelpHubCard_default,
          {
            page: "search",
            key: doc.command.id,
            onClick: () => openDoc(doc),
            onMouseMove: () => onMouseMove(index3),
            type: doc.command.template.type === "helpdoc" && doc.command.template.doc_type === "answer" ? "answer" : doc.command.template.type,
            label: doc.command.text,
            content: doc.excerpt,
            active: currentIndex === index3,
            icon: doc.command.icon,
            iconColor: doc.command.icon_color,
            themeV2
          }
        ))
      )) : /* @__PURE__ */ jsx115("div", { css: styles51.resultList, ref: scrollRef, "data-testid": "helphub-searchresults-wrapper" }, /* @__PURE__ */ jsx115("div", { css: styles51.resultListHeader }, /* @__PURE__ */ jsx115("h1", { css: styles51.resultListHeaderTitle }, "Search Results"), /* @__PURE__ */ jsx115("span", { css: styles51.resultListHeaderResultsFound }, docs.length, " item", docs.length === 1 ? "" : "s", " found")), renderContent());
    };
    SearchResults_default = SearchResults;
  }
});

// commandbar/src/products/helphub/components/ExperienceSearchResults.tsx
import { jsx as jsx116, css as css69 } from "@emotion/core";
import React309, { useEffect as useEffect64, useRef as useRef43 } from "react";
var hitToAction, hitTitle, hitExcerpt, ExperienceResultCard, ExperienceSearchResults, ExperienceSearchResults_default;
var init_ExperienceSearchResults = __esm({
  "commandbar/src/products/helphub/components/ExperienceSearchResults.tsx"() {
    "use strict";
    init_useStyles();
    init_useTheme();
    init_useStore();
    init_useKeyboardNavigation();
    init_useHasScroll();
    init_Reporting();
    init_NoSearchResults();
    init_RecommendationCard();
    init_router();
    init_service_selectors();
    init_service_selectors2();
    init_actions2();
    init_useAction();
    init_service_selectors3();
    init_StyledHelpHubList();
    init_StyledHelpHubListContainer();
    init_StyledHelpHubListHeader();
    init_StyledHelpHubListSubtitle();
    init_StyledHelpHubListTitle();
    init_StyledNoResults();
    init_StyledHelpHubCard();
    init_track();
    init_operatingSystem();
    init_ThemeV2Context();
    init_nudges();
    hitToAction = (hit) => {
      switch (hit.type) {
        case "page":
        case "action":
        case "video":
        case "helpdoc":
          return { type: "execute_command", meta: { command: hit.experience_id.toString() } };
        case "nudge":
          return { type: "nudge", value: hit.experience_id };
        case "checklist":
          return { type: "questlist", value: hit.experience_id };
      }
    };
    hitTitle = (_, hit) => {
      var _a2;
      switch (hit.type) {
        case "page":
        case "action":
        case "video":
        case "helpdoc":
          return hit.experience.text;
        case "nudge":
          const nudge = getNudgeById(_, hit.experience_id);
          return (nudge == null ? void 0 : nudge.slug) || nudge && ((_a2 = getNudgeStep(nudge, 0)) == null ? void 0 : _a2.title) || "Nudge";
        case "checklist":
          const checklist3 = getChecklistById(_, hit.experience_id);
          return (checklist3 == null ? void 0 : checklist3.title) || "Checklist";
      }
    };
    hitExcerpt = (_, hit) => {
      switch (hit.type) {
        case "page":
        case "action":
        case "video":
        case "helpdoc":
          return hit.excerpt;
        case "checklist":
          const checklist3 = getChecklistById(_, hit.experience_id);
          return (checklist3 == null ? void 0 : checklist3.description) || "";
        default:
          return "";
      }
    };
    ExperienceResultCard = ({ hit, active, selectionMethod, onClick, onMouseMove }) => {
      var _a2, _b2, _c2, _d;
      const styles51 = useStyles();
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const activeRef = useRef43(null);
      const _ = useStore();
      const action = hitToAction(hit);
      const excerpt = hitExcerpt(_, hit);
      let doc = null;
      if (hit.type === "page" || hit.type === "action" || hit.type === "video" || hit.type === "helpdoc") {
        doc = commandToHelpHubDoc(hit.experience, hit);
      }
      useEffect64(() => {
        if (active && selectionMethod === "keyboard" /* Keyboard */) {
          (activeRef == null ? void 0 : activeRef.current) && activeRef.current.scrollIntoView({ block: "center" });
        }
      }, [active, selectionMethod]);
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx116(
        StyledHelpHubCard_default,
        {
          page: "search",
          onClick,
          onMouseMove,
          ref: activeRef,
          key: `${hit.type}-${hit.experience_id}`,
          "aria-label": doc ? doc.command.text : hit.type,
          type: (doc == null ? void 0 : doc.command.template.type) === "helpdoc" && doc.command.template.doc_type === "answer" ? "answer" : (_b2 = doc == null ? void 0 : doc.command.template.type) != null ? _b2 : hit.type,
          label: hitTitle(_, hit),
          content: excerpt,
          active,
          icon: doc == null ? void 0 : doc.command.icon,
          iconColor: doc == null ? void 0 : doc.command.icon_color,
          themeV2
        }
      ) : /* @__PURE__ */ jsx116(
        "button",
        {
          css: [
            {
              ...styles51.resultCard,
              ...active && styles51.resultCardActive,
              ...doc && doc.command.template.type === "helpdoc" && doc.command.template.doc_type === "answer" && styles51.resultCardAnswer
            },
            css69`
          mark {
            padding: 0;
            color: ${styles51.highlightMark.color};
            border-radius: ${styles51.highlightMark.borderRadius};
            background-color: ${styles51.highlightMark.backgroundColor};
            transition: background-color ${theme.main.transitionTime} ease;
          }
        `
          ],
          onClick,
          onMouseMove,
          ref: activeRef,
          key: `${hit.type}-${hit.experience_id}`,
          "aria-label": doc ? doc.command.text : hit.type
        },
        /* @__PURE__ */ jsx116("div", { css: styles51.resultCardIcon, "aria-hidden": true }, /* @__PURE__ */ jsx116(LeftIcon, { action, command: hit.experience || null })),
        /* @__PURE__ */ jsx116("div", { css: styles51.resultCardTextContainer }, doc && doc.command.template.type === "helpdoc" && (((_c2 = doc.command.template.doc_metadata) == null ? void 0 : _c2.content_type) || ((_d = doc.command.template.doc_metadata) == null ? void 0 : _d.date)) && /* @__PURE__ */ jsx116(MetaHeader, { metadata: doc.command.template.doc_metadata }), /* @__PURE__ */ jsx116("div", { css: styles51.resultCardText }, /* @__PURE__ */ jsx116("span", { css: styles51.resultCardTitle }, hitTitle(_, hit)), excerpt && /* @__PURE__ */ jsx116("div", { css: styles51.resultCardExcerpt, dangerouslySetInnerHTML: { __html: excerpt } }))),
        /* @__PURE__ */ jsx116("div", { css: { ...styles51.resultCardRightCaret, opacity: active ? "1" : "0" } }, /* @__PURE__ */ jsx116(RightIcon, { type: action.type, theme }))
      );
    };
    ExperienceSearchResults = ({ hits }) => {
      var _a2;
      const scrollRef = useRef43(null);
      const { hasScrolled } = useHasScroll_default(scrollRef);
      const _ = useStore();
      const styles51 = useStyles();
      const { navigate } = useRouter();
      const { flags } = _;
      const executeAction2 = useAction((_2, action, e) => {
        executeActionFromHH(_2, navigate, action, e, "helphub_search");
      });
      const openHit = (hit, e) => {
        var _a3, _b2;
        Track.helphub.searchResultClicked(hit);
        if (((flags == null ? void 0 : flags["switch-open-help-doc-in-new-tab"]) || !!e && getTriggerKey(e)) && hit.type === "helpdoc") {
          if (typeof ((_b2 = (_a3 = hit.experience) == null ? void 0 : _a3.template) == null ? void 0 : _b2.value) == "string" && hit.experience.template.value !== "") {
            window.open(hit.experience.template.value, "_blank");
            return;
          }
        }
        const action = hitToAction(hit);
        executeAction2(action, e);
      };
      const { currentIndex, selectionMethod, onMouseMove, onMouseLeave } = useKeyboardNavigation_default(hits, openHit);
      React309.useEffect(() => {
        if (hasScrolled) {
          helpHubEngagement({ query: _.helpHub.query }, "scrolled");
        }
      }, [hasScrolled]);
      const renderContent = () => {
        if (hits.length === 0) {
          return /* @__PURE__ */ jsx116(NoSearchResults, null);
        }
        return (
          // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
          /* @__PURE__ */ jsx116(
            "div",
            {
              css: styles51.resultListContainer,
              role: "list",
              "data-testid": "helphub-searchresults-list",
              onMouseLeave
            },
            hits.map((hit, index3) => {
              const active = currentIndex === index3;
              return /* @__PURE__ */ jsx116(
                ExperienceResultCard,
                {
                  key: `${hit.type}-${hit.experience_id}`,
                  hit,
                  onClick: (e) => openHit(hit, e),
                  active,
                  selectionMethod,
                  onMouseMove: () => onMouseMove(index3)
                }
              );
            })
          )
        );
      };
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx116(StyledHelpHubListContainer_default, { style: { background: "var(--background-primary)" } }, hits.length > 0 && /* @__PURE__ */ jsx116(StyledHelpHubListHeader_default, null, /* @__PURE__ */ jsx116(StyledHelpHubListTitle_default, null, "Search Results"), /* @__PURE__ */ jsx116(StyledHelpHubListSubtitle_default, null, hits.length, " result", hits.length === 1 ? "" : "s", " found")), hits.length === 0 ? /* @__PURE__ */ jsx116(StyledNoResults_default, null) : /* @__PURE__ */ jsx116(
        StyledHelpHubList_default,
        {
          role: "list",
          "data-testid": "helphub-searchresults-list",
          "aria-label": "Results",
          onMouseLeave
        },
        hits.map((hit, index3) => {
          const active = currentIndex === index3;
          return /* @__PURE__ */ jsx116(
            ExperienceResultCard,
            {
              key: `${hit.type}-${hit.experience_id}`,
              hit,
              onClick: (e) => openHit(hit, e),
              active,
              selectionMethod,
              onMouseMove: () => onMouseMove(index3)
            }
          );
        })
      )) : /* @__PURE__ */ jsx116("div", { css: styles51.resultList, ref: scrollRef, "data-testid": "helphub-searchresults-wrapper" }, /* @__PURE__ */ jsx116("div", { css: styles51.resultListHeader }, /* @__PURE__ */ jsx116("h1", { css: styles51.resultListHeaderTitle }, "Search Results"), /* @__PURE__ */ jsx116("span", { css: styles51.resultListHeaderResultsFound }, hits.length, " item", hits.length === 1 ? "" : "s", " found")), renderContent());
    };
    ExperienceSearchResults_default = ExperienceSearchResults;
  }
});

// commandbar/src/products/helphub/components/RecommendationEmptyState.tsx
import { jsx as jsx117 } from "@emotion/core";
import React310 from "react";
var RecommendationEmptyGrid, RecommendationEmptyList;
var init_RecommendationEmptyState = __esm({
  "commandbar/src/products/helphub/components/RecommendationEmptyState.tsx"() {
    "use strict";
    init_useStyles();
    RecommendationEmptyGrid = () => {
      const styles51 = useStyles();
      return /* @__PURE__ */ jsx117("div", { css: styles51.recommendedGridItemsEmptyContainer }, /* @__PURE__ */ jsx117("div", { css: styles51.recommendedGridItemsEmpty }, /* @__PURE__ */ jsx117("div", { style: styles51.recommendedGridItemsEmptyDot })), /* @__PURE__ */ jsx117("div", { css: styles51.recommendedGridItemsEmpty }, /* @__PURE__ */ jsx117("div", { style: styles51.recommendedGridItemsEmptyDot })));
    };
    RecommendationEmptyList = ({ numListItems }) => {
      const styles51 = useStyles();
      const listItems = Array.from(Array(numListItems).keys());
      return /* @__PURE__ */ jsx117(React310.Fragment, null, listItems.map((key) => /* @__PURE__ */ jsx117("div", { key, css: styles51.recommendedListItemsEmpty }, /* @__PURE__ */ jsx117("div", { style: styles51.recommendedListItemEmptyDot }), /* @__PURE__ */ jsx117("div", null, /* @__PURE__ */ jsx117("div", { style: styles51.recommendedListItemEmptyRowTop }), /* @__PURE__ */ jsx117("div", { style: styles51.recommendedListItemEmptyRowBottom })))));
    };
  }
});

// internal/src/client/themesV2/components/helphub/StyledFeaturedRecommendations.tsx
import React311 from "react";
var Featured, StyledFeaturedRecommendations, StyledFeaturedRecommendations_default;
var init_StyledFeaturedRecommendations = __esm({
  "internal/src/client/themesV2/components/helphub/StyledFeaturedRecommendations.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Featured = styled_browser_esm_default.div`
  display: flex;
  padding-bottom: 16px;
  align-items: flex-start;
  gap: var(--layout-gap);
  align-self: stretch;
`;
    StyledFeaturedRecommendations = React311.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React311.createElement(Featured, { ref: ref12, ...props2 }, children);
      }
    );
    StyledFeaturedRecommendations_default = StyledFeaturedRecommendations;
  }
});

// commandbar/src/products/helphub/components/Recommendations.tsx
import { useEffect as useEffect65, useRef as useRef44, useState as useState42 } from "react";
import { jsx as jsx118 } from "@emotion/core";
import React312 from "react";
var Recommendations, Recommendations_default;
var init_Recommendations = __esm({
  "commandbar/src/products/helphub/components/Recommendations.tsx"() {
    "use strict";
    init_useStore();
    init_useTheme();
    init_useStyles();
    init_useKeyboardNavigation();
    init_useHasScroll();
    init_useAction();
    init_Reporting();
    init_router();
    init_selectors4();
    init_actions2();
    init_RecommendationCard();
    init_RecommendationEmptyState();
    init_ExperienceSearchResults();
    init_StyledHelpHubListContainer();
    init_StyledFeaturedRecommendations();
    init_StyledHelpHubList();
    init_StyledHelpHubListHeader();
    init_StyledHelpHubListTitle();
    init_track();
    init_Interpolate();
    init_location();
    Recommendations = () => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      const { theme } = useTheme();
      const styles51 = useStyles();
      const _ = useStore();
      const { loading: isLoading } = _.helpHub;
      const NUM_GRID = ((_a2 = _.organization) == null ? void 0 : _a2.featured_item_cards) ? 2 : 0;
      const { navigate } = useRouter();
      const executeCustomAction = useAction((_2, action, e) => {
        Track.helphub.recommendationClicked(action);
        executeActionFromHH(_2, navigate, action, e, "helphub_recommendation");
      });
      let fallbackRecs = [];
      if ((_b2 = _.flags) == null ? void 0 : _b2["release-search-experiences-in-help-hub"]) {
        fallbackRecs = _.helpHub.experienceSearchResults.slice(0, 10).map((experience) => {
          return {
            action: hitToAction(experience),
            cta: hitTitle(_, experience)
          };
        });
      } else {
        fallbackRecs = _.helpHub.searchResults.slice(0, 10).map((hubDoc) => {
          return {
            action: {
              type: "execute_command",
              meta: { command: hubDoc.command.id.toString() }
            },
            cta: hubDoc.command.text || ""
          };
        });
      }
      const [recommendations, setRecommendations] = useState42([]);
      useEffect65(() => {
        getHelpHubRecommendations(_).then((recommendations2) => {
          setRecommendations(recommendations2);
        });
      }, [_.helpHub.previewedRecommendationSet, _.helpHub.recommendationSets, _.location]);
      const initialRecs = ((_c2 = _.helpHub.recommendationSets) == null ? void 0 : _c2.length) ? recommendations : fallbackRecs;
      const [gridRecommendations, listRecommendations] = [initialRecs == null ? void 0 : initialRecs.slice(0, NUM_GRID), initialRecs == null ? void 0 : initialRecs.slice(NUM_GRID)];
      const scrollRef = useRef44(null);
      const { hasScrolled } = useHasScroll_default(scrollRef);
      const showRecommendations = initialRecs.length || !isStudioPreview();
      useEffect65(() => {
        if (hasScrolled) {
          helpHubEngagement({ query: _.helpHub.query }, "scrolled");
        }
      }, [hasScrolled]);
      const { currentIndex, selectionMethod, onMouseMove, onMouseLeave } = useKeyboardNavigation_default(
        initialRecs,
        (item) => (item == null ? void 0 : item.action) && executeCustomAction(item == null ? void 0 : item.action)
      );
      return ((_d = _.flags) == null ? void 0 : _d["release-themes-v2"]) ? /* @__PURE__ */ jsx118(StyledHelpHubListContainer_default, { ref: scrollRef }, /* @__PURE__ */ jsx118(StyledHelpHubListHeader_default, null, /* @__PURE__ */ jsx118(StyledHelpHubListTitle_default, null, interpolate(_.localizedMessages["helphub.featured-content-label"], _, true, false))), !isLoading && /* @__PURE__ */ jsx118(StyledHelpHubList_default, { role: "list" }, ((_e = _.organization) == null ? void 0 : _e.featured_item_cards) && /* @__PURE__ */ jsx118(StyledFeaturedRecommendations_default, { role: "group", "aria-label": "Grid Recommendations", onMouseLeave }, showRecommendations ? /* @__PURE__ */ jsx118(React312.Fragment, null, gridRecommendations == null ? void 0 : gridRecommendations.map((labeledAction, index3) => {
        const active = currentIndex === index3;
        return /* @__PURE__ */ jsx118(
          RecommendationCard_default,
          {
            key: `${labeledAction.cta}-${index3}`,
            labeledAction,
            active,
            selectionMethod,
            onClick: (e) => executeCustomAction(labeledAction.action, e),
            onMouseMove: () => onMouseMove(index3),
            grid: true
          }
        );
      })) : /* @__PURE__ */ jsx118(RecommendationEmptyGrid, null)), showRecommendations ? /* @__PURE__ */ jsx118(StyledHelpHubList_default, { role: "list", "aria-label": "Recommendations", onMouseLeave }, listRecommendations == null ? void 0 : listRecommendations.map((labeledAction, index3) => {
        const active = currentIndex === index3 + ((gridRecommendations == null ? void 0 : gridRecommendations.length) || 0);
        return /* @__PURE__ */ jsx118(
          RecommendationCard_default,
          {
            key: `${labeledAction.cta}-${index3}`,
            labeledAction,
            active,
            selectionMethod,
            onClick: (e) => executeCustomAction(labeledAction.action, e),
            onMouseMove: () => onMouseMove(index3 + ((gridRecommendations == null ? void 0 : gridRecommendations.length) || 0))
          }
        );
      })) : /* @__PURE__ */ jsx118(RecommendationEmptyList, { numListItems: ((_f = _.organization) == null ? void 0 : _f.featured_item_cards) ? 3 : 5 }))) : /* @__PURE__ */ jsx118("div", { ref: scrollRef, css: styles51.recommendationsContainer }, !isLoading && /* @__PURE__ */ jsx118(React312.Fragment, null, /* @__PURE__ */ jsx118("h1", { css: styles51.recommendationsHeading }, theme.helpHub.featuredContentLabel), /* @__PURE__ */ jsx118("div", { css: styles51.recommendationsListContainer, role: "list" }, ((_g = _.organization) == null ? void 0 : _g.featured_item_cards) && /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */
      /* @__PURE__ */ jsx118("div", { css: styles51.gridItems, role: "group", "aria-label": "Grid Recommendations", onMouseLeave }, showRecommendations ? /* @__PURE__ */ jsx118(React312.Fragment, null, gridRecommendations == null ? void 0 : gridRecommendations.map((labeledAction, index3) => {
        const active = currentIndex === index3;
        return /* @__PURE__ */ jsx118(
          RecommendationCard_default,
          {
            key: `${labeledAction.cta}-${index3}`,
            labeledAction,
            active,
            selectionMethod,
            onClick: (e) => executeCustomAction(labeledAction.action, e),
            onMouseMove: () => onMouseMove(index3),
            grid: true
          }
        );
      })) : /* @__PURE__ */ jsx118(RecommendationEmptyGrid, null)), showRecommendations ? /* @__PURE__ */ jsx118(React312.Fragment, null, /* @__PURE__ */ jsx118(
        "div",
        {
          css: styles51.recommendedListItems,
          role: "group",
          "aria-label": "Recommendations",
          onMouseLeave
        },
        listRecommendations == null ? void 0 : listRecommendations.map((labeledAction, index3) => {
          const active = currentIndex === index3 + ((gridRecommendations == null ? void 0 : gridRecommendations.length) || 0);
          return /* @__PURE__ */ jsx118(
            RecommendationCard_default,
            {
              key: `${labeledAction.cta}-${index3}`,
              labeledAction,
              active,
              selectionMethod,
              onClick: (e) => executeCustomAction(labeledAction.action, e),
              onMouseMove: () => onMouseMove(index3 + ((gridRecommendations == null ? void 0 : gridRecommendations.length) || 0))
            }
          );
        })
      )) : /* @__PURE__ */ jsx118(RecommendationEmptyList, { numListItems: ((_h = _.organization) == null ? void 0 : _h.featured_item_cards) ? 3 : 5 }))));
    };
    Recommendations_default = Recommendations;
  }
});

// commandbar/src/products/helphub/components/additional_resources_arrow.svg
import * as React313 from "react";
var SvgAdditionalResourcesArrow;
var init_additional_resources_arrow = __esm({
  "commandbar/src/products/helphub/components/additional_resources_arrow.svg"() {
    "use strict";
    SvgAdditionalResourcesArrow = (props2) => /* @__PURE__ */ React313.createElement("svg", { width: 11, height: 7, viewBox: "0 0 11 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props2 }, /* @__PURE__ */ React313.createElement("path", { d: "M10.1384 0.995312L5.47383 6.38431C5.34032 6.53856 5.08322 6.53856 4.94829 6.38431L0.283703 0.995312C0.110415 0.794357 0.266659 0.5 0.546477 0.5H9.87564C10.1555 0.5 10.3117 0.794357 10.1384 0.995312Z", fill: "currentColor" }));
  }
});

// internal/src/client/themesV2/components/helphub/StyledAdditionalResources.tsx
import React314 from "react";
var Container16, Title5, ChevronContainer, StyledAdditionalResources, StyledAdditionalResources_default;
var init_StyledAdditionalResources = __esm({
  "internal/src/client/themesV2/components/helphub/StyledAdditionalResources.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_StyledIconContainer();
    Container16 = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--layout-padding);
  gap: var(--layout-gap);
  flex-shrink: 0;

  border-top: 1px solid var(--border-primary);
  background: var(--background-primary);
`;
    Title5 = styled_browser_esm_default.div`
  display: flex;
  gap: 4px;
  justify-content: center;
  align-items: center;
  color: var(--content-primary);
  cursor: pointer;

  /* label/base/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);
`;
    ChevronContainer = styled_browser_esm_default(StyledIconContainer_default)`
  color: var(--content-secondary);
`;
    StyledAdditionalResources = React314.forwardRef(({ children, title, toggledExpanded, isExpanded: isExpanded2, ...props2 }, ref12) => {
      return /* @__PURE__ */ React314.createElement(Container16, { ref: ref12, ...props2 }, title && /* @__PURE__ */ React314.createElement(
        Title5,
        {
          onClick: toggledExpanded,
          onKeyDown: (e) => {
            if (e.key === "Enter")
              toggledExpanded();
          }
        },
        title,
        /* @__PURE__ */ React314.createElement(ChevronContainer, null, isExpanded2 ? /* @__PURE__ */ React314.createElement(ChevronDown_default, null) : /* @__PURE__ */ React314.createElement(ChevronUp_default, null))
      ), children);
    });
    StyledAdditionalResources_default = StyledAdditionalResources;
  }
});

// internal/src/client/themesV2/components/helphub/StyledAdditionalResourcesLink.tsx
import React315 from "react";
var LinkBlock, LinkTitle, StyledAdditionalResourcesLink, StyledAdditionalResourcesLink_default;
var init_StyledAdditionalResourcesLink = __esm({
  "internal/src/client/themesV2/components/helphub/StyledAdditionalResourcesLink.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Icon();
    init_StyledIconContainer();
    LinkBlock = styled_browser_esm_default.button`
  && {
    all: unset;

    display: flex;
    flex: 1 1 33%;
    align-items: center;
    gap: var(--layout-gap);
    align-self: stretch;
    background: none;
    border: none;
    cursor: pointer;
    border-radius: var(--layout-radius-button);

    &:focus {
      box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
    }

    &:focus-visible {
      outline: none;
    }

    &:hover {
      #link {
        color: var(--content-link-hover);
      }
    }
  }
`;
    LinkTitle = styled_browser_esm_default.div`
  color: var(--content-link);
  text-align: left;

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    StyledAdditionalResourcesLink = ({
      icon,
      title,
      iconColor,
      ...props2
    }) => {
      return /* @__PURE__ */ React315.createElement(LinkBlock, { ...props2 }, /* @__PURE__ */ React315.createElement(StyledIconContainer_default, null, /* @__PURE__ */ React315.createElement(Icon_default, { icon, color: iconColor, useDefaultSVGColor: true })), /* @__PURE__ */ React315.createElement(LinkTitle, { id: "link" }, title));
    };
    StyledAdditionalResourcesLink_default = StyledAdditionalResourcesLink;
  }
});

// internal/src/client/themesV2/components/helphub/StyledAdditionalResourcesLinkContainer.tsx
import React316 from "react";
var LinkContainer, StyledAdditionalResourcesLinkContainer, StyledAdditionalResourcesLinkContainer_default;
var init_StyledAdditionalResourcesLinkContainer = __esm({
  "internal/src/client/themesV2/components/helphub/StyledAdditionalResourcesLinkContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    LinkContainer = styled_browser_esm_default.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 12px;
`;
    StyledAdditionalResourcesLinkContainer = ({ children }) => {
      return /* @__PURE__ */ React316.createElement(LinkContainer, null, children);
    };
    StyledAdditionalResourcesLinkContainer_default = StyledAdditionalResourcesLinkContainer;
  }
});

// internal/src/client/themesV2/components/helphub/StyledAdditionalResourcesCTAContainer.tsx
import React317 from "react";
var CTAButtonContainer, StyledAdditionalResourcesCTAContainer, StyledAdditionalResourcesCTAContainer_default;
var init_StyledAdditionalResourcesCTAContainer = __esm({
  "internal/src/client/themesV2/components/helphub/StyledAdditionalResourcesCTAContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    CTAButtonContainer = styled_browser_esm_default.div`
  display: flex;
  padding-top: 4px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;
    StyledAdditionalResourcesCTAContainer = ({ children }) => {
      return /* @__PURE__ */ React317.createElement(CTAButtonContainer, null, children);
    };
    StyledAdditionalResourcesCTAContainer_default = StyledAdditionalResourcesCTAContainer;
  }
});

// commandbar/src/products/helphub/components/AdditionalResources.tsx
import { jsx as jsx119 } from "@emotion/core";
import { useEffect as useEffect66, useState as useState43 } from "react";
var AdditionalResources, AdditionalResources_default;
var init_AdditionalResources = __esm({
  "commandbar/src/products/helphub/components/AdditionalResources.tsx"() {
    "use strict";
    init_useStyles();
    init_Icon2();
    init_useStore();
    init_useAction();
    init_actions2();
    init_additional_resources_arrow();
    init_global_selectors();
    init_Interpolate();
    init_helpdocService();
    init_router();
    init_StyledAdditionalResources();
    init_StyledAdditionalResourcesLink();
    init_StyledAdditionalResourcesLinkContainer();
    init_StyledAdditionalResourcesCTAContainer();
    init_StyledSecondaryButton();
    init_ThemeV2Context();
    init_track();
    AdditionalResources = () => {
      var _a2;
      const storageKey = "commandbar.helphub.resourcesIsExpanded";
      const storedIsExpanded = sessionStorage.getItem(storageKey);
      const [isExpanded2, setIsExpanded] = useState43(storedIsExpanded ? JSON.parse(storedIsExpanded) : true);
      const [additionalResources, setAdditionalResources] = useState43([]);
      const [primaryCTA, setPrimaryCTA] = useState43(null);
      const [referencedCommands, setReferencedCommands] = useState43([]);
      const styles51 = useStyles();
      const _ = useStore();
      const { helpHub } = _;
      const { navigate } = useRouter();
      const themeV2 = useThemeV2Context();
      useEffect66(() => {
        sessionStorage.setItem(storageKey, JSON.stringify(isExpanded2));
      }, [isExpanded2]);
      useEffect66(() => {
        const getReferencedCommands = async () => {
          const _referencedCommands = await Promise.all(
            helpHub.additionalResources.map((resource) => {
              if (resource.action.type !== "execute_command")
                return Promise.resolve(null);
              return helpdocService_default.getCommandOrHelpdoc(_, resource.action.meta.command);
            })
          );
          setReferencedCommands(_referencedCommands.filter((command) => !!command));
        };
        getReferencedCommands();
      }, [helpHub.additionalResources]);
      const executeAction2 = useAction((_2, action, e) => {
        Track.helphub.additionalResourceClicked(action);
        executeActionFromHH(_2, navigate, action, e, "helphub_additional_resource");
      });
      useEffect66(() => {
        const getAdditionalResources = async () => {
          const resources = helpHub.additionalResources;
          const availabilityPromises = resources.map((resource) => actionIsAvailable(_, resource.action));
          const availabilities = await Promise.all(availabilityPromises);
          const filteredAndSortedResources = resources.filter((resource, index3) => !resource.show_as_primary_cta && availabilities[index3]).sort((a, b) => a.sort_key - b.sort_key);
          setAdditionalResources(filteredAndSortedResources);
        };
        const getPrimaryCTA = async () => {
          const primaryCTA2 = helpHub.additionalResources.find((resource) => resource.show_as_primary_cta);
          if (!primaryCTA2)
            return;
          const isAvailable2 = await actionIsAvailable(_, primaryCTA2.action);
          if (isAvailable2)
            setPrimaryCTA(primaryCTA2);
        };
        getAdditionalResources();
        getPrimaryCTA();
      }, [helpHub.additionalResources, referencedCommands, _]);
      const additionalResourcesContent = additionalResources.length > 0 && /* @__PURE__ */ jsx119("div", null, /* @__PURE__ */ jsx119(
        "div",
        {
          css: styles51.additionalResourcesTitle,
          onClick: () => setIsExpanded(!isExpanded2),
          onKeyDown: (e) => {
            if (e.key === "Enter")
              setIsExpanded(!isExpanded2);
          },
          role: "button",
          tabIndex: 0
        },
        "Additional Resources",
        /* @__PURE__ */ jsx119("div", { css: isExpanded2 ? styles51.additionalResourcesArrowExpanded : styles51.additionalResourcesArrowCollapsed }, /* @__PURE__ */ jsx119(SvgAdditionalResourcesArrow, null))
      ), /* @__PURE__ */ jsx119("div", { css: styles51.additionalResourcesLinkContainer, style: { display: isExpanded2 ? "flex" : "none" } }, additionalResources.map((resource) => /* @__PURE__ */ jsx119(
        "div",
        {
          css: styles51.additionalResourcesLink,
          onClick: (e) => executeAction2(resource.action, e),
          onKeyDown: (e) => {
            if (e.key === "Enter")
              executeAction2(resource.action);
          },
          role: "button",
          tabIndex: 0,
          key: resource.id
        },
        /* @__PURE__ */ jsx119("div", { css: styles51.additionalResourcesLinkIcon }, /* @__PURE__ */ jsx119(
          Icon_default2,
          {
            color: styles51.additionalResourcesLinkIcon.color !== "#000000" ? styles51.additionalResourcesLinkIcon.color : resource.icon_color,
            icon: resource.icon,
            useDefaultSVGColor: true,
            size: styles51.additionalResourcesLinkIcon.height
          }
        )),
        /* @__PURE__ */ jsx119("div", null, interpolate(resource.label, _, true, false))
      ))));
      const primaryCTAContent = primaryCTA && primaryCTA.label.trim() !== "" && /* @__PURE__ */ jsx119(
        "button",
        {
          css: [styles51.additionalResourcesCTA, { marginTop: additionalResources.length > 0 ? "16px" : "0px" }],
          onClick: (e) => executeAction2(primaryCTA.action, e),
          onKeyDown: (e) => {
            if (e.key === "Enter")
              executeAction2(primaryCTA.action);
          },
          tabIndex: 0
        },
        interpolate(primaryCTA.label, _, true, false)
      );
      if (!(primaryCTAContent || additionalResourcesContent))
        return null;
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx119(
        StyledAdditionalResources_default,
        {
          title: additionalResources.length > 0 ? interpolate(_.localizedMessages["helphub.additional-resources-label"], _, true, false) : void 0,
          toggledExpanded: () => setIsExpanded(!isExpanded2),
          isExpanded: isExpanded2,
          "data-testid": "helphub-additional-resources"
        },
        isExpanded2 && /* @__PURE__ */ jsx119(StyledAdditionalResourcesLinkContainer_default, null, additionalResources.map((resource) => /* @__PURE__ */ jsx119(
          StyledAdditionalResourcesLink_default,
          {
            onClick: (e) => executeAction2(resource.action, e),
            onKeyDown: (e) => {
              if (e.key === "Enter")
                executeAction2(resource.action);
            },
            key: resource.id,
            icon: resource.icon,
            title: interpolate(resource.label, _, true, false),
            iconColor: resource.icon_color
          }
        ))),
        primaryCTA && !!primaryCTA.label && /* @__PURE__ */ jsx119(StyledAdditionalResourcesCTAContainer_default, null, /* @__PURE__ */ jsx119(StyledSecondaryButton_default, { themeV2, onClick: (e) => executeAction2(primaryCTA.action, e) }, interpolate(primaryCTA.label, _, true, false)))
      ) : /* @__PURE__ */ jsx119("div", { css: styles51.additionalResourcesContainer, "data-testid": "helphub-additional-resources" }, additionalResourcesContent, primaryCTAContent);
    };
    AdditionalResources_default = AdditionalResources;
  }
});

// commandbar/src/products/helphub/components/LoadingSkeleton.tsx
import { css as css70, keyframes as keyframes14, jsx as jsx120 } from "@emotion/core";
var load, LoadingSkeleton, LoadingSkeleton_default;
var init_LoadingSkeleton = __esm({
  "commandbar/src/products/helphub/components/LoadingSkeleton.tsx"() {
    "use strict";
    load = keyframes14`
  100% {
    transform: translateX(100%);
  }
`;
    LoadingSkeleton = ({ style: style3 }) => {
      return /* @__PURE__ */ jsx120(
        "div",
        {
          css: css70`
        background: #e0e0e0;
        height: 14px;
        margin: 8px;
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          transform: translateX(-100%);
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
          animation: ${load} 1.5s infinite;
        }
      `,
          style: style3
        }
      );
    };
    LoadingSkeleton_default = LoadingSkeleton;
  }
});

// internal/src/client/themesV2/components/helphub/StyledHelpHubFooter.tsx
import React319 from "react";
var HelpHubFooter, StyledHelpHubFooter, StyledHelpHubFooter_default;
var init_StyledHelpHubFooter = __esm({
  "internal/src/client/themesV2/components/helphub/StyledHelpHubFooter.tsx"() {
    "use strict";
    init_styled_browser_esm();
    HelpHubFooter = styled_browser_esm_default.div`
  display: flex;
  width: 100%;
  padding: var(--layout-padding);
  border-radius: 0px 0px var(--layout-radius-card) var(--layout-radius-card);
  justify-content: center;
  align-items: center;
  background: var(--background-primary);
`;
    StyledHelpHubFooter = ({ children, showTopPadding, ...props2 }) => {
      return /* @__PURE__ */ React319.createElement(HelpHubFooter, { style: { ...!showTopPadding && { paddingTop: "0px" } }, ...props2 }, children);
    };
    StyledHelpHubFooter_default = StyledHelpHubFooter;
  }
});

// internal/src/client/themesV2/components/helphub/StyledSuggestedSearch.tsx
import React320 from "react";
var Suggestion3, StyledSuggestedSearches, StyledSuggestedSearch_default;
var init_StyledSuggestedSearch = __esm({
  "internal/src/client/themesV2/components/helphub/StyledSuggestedSearch.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Suggestion3 = styled_browser_esm_default.button`
  && {
    all: unset;

    display: flex;
    min-height: 32px;
    align-items: center;
    gap: var(--layout-gap);
    align-self: stretch;
    background: none;
    border: none;
    cursor: pointer;
    padding: var(--form-control-padding-x);
    border-radius: var(--layout-radius-button);
    text-align: left;

    color: var(--content-secondary);

    /* label/base/medium */
    font-family: var(--font-font-family);
    font-size: var(--font-size-base);
    font-weight: var(--font-weight-medium);
    line-height: var(--font-line-height-normal);

    &:hover {
      background: var(--form-control-active-background);
    }

    &:focus {
      box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
    }

    &:focus-visible {
      outline: none;
    }
  }
`;
    StyledSuggestedSearches = ({ children, ...props2 }) => /* @__PURE__ */ React320.createElement(Suggestion3, { ...props2 }, children);
    StyledSuggestedSearch_default = StyledSuggestedSearches;
  }
});

// internal/src/client/themesV2/components/shared/StyledLoadingSkeleton.tsx
import { css as css71, jsx as jsx121, keyframes as keyframes15 } from "@emotion/core";
var load2, styles48, StyledLoadingSkeleton, StyledLoadingSkeleton_default;
var init_StyledLoadingSkeleton = __esm({
  "internal/src/client/themesV2/components/shared/StyledLoadingSkeleton.tsx"() {
    "use strict";
    load2 = keyframes15`
  100% {
    transform: translateX(100%);
  }
`;
    styles48 = css71({
      height: "16px",
      background: "var(--button-secondary-border-color)",
      borderRadius: "100px",
      overflow: "hidden",
      position: "relative",
      "::after": {
        content: '""',
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
        transform: "translateX(-100%)",
        background: "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)",
        animation: `${load2} 1.5s infinite`
      }
    });
    StyledLoadingSkeleton = ({ style: style3 }) => {
      return /* @__PURE__ */ jsx121("div", { css: styles48, style: style3 });
    };
    StyledLoadingSkeleton_default = StyledLoadingSkeleton;
  }
});

// internal/src/client/themesV2/components/shared/StyledLoadingSkeletonContainer.tsx
import React321 from "react";
var Container17, StyledLoadingSkeletonContainer, StyledLoadingSkeletonContainer_default;
var init_StyledLoadingSkeletonContainer = __esm({
  "internal/src/client/themesV2/components/shared/StyledLoadingSkeletonContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container17 = styled_browser_esm_default.div`
  display: flex;
  padding: 12px 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;
    StyledLoadingSkeletonContainer = ({ children }) => {
      return /* @__PURE__ */ React321.createElement(Container17, null, children);
    };
    StyledLoadingSkeletonContainer_default = StyledLoadingSkeletonContainer;
  }
});

// commandbar/src/products/helphub/components/HelpHub.tsx
import { jsx as jsx122 } from "@emotion/core";
import React322, { useState as useState44 } from "react";
import debounce6 from "lodash/debounce";
var HelpHub2, HelpHub_default;
var init_HelpHub = __esm({
  "commandbar/src/products/helphub/components/HelpHub.tsx"() {
    "use strict";
    init_useAction();
    init_useStore();
    init_useStyles();
    init_actions2();
    init_Reporting();
    init_Input2();
    init_useDelayUnmount();
    init_SearchResults();
    init_ExperienceSearchResults();
    init_Recommendations();
    init_AdditionalResources();
    init_PoweredBy();
    init_useStartChat();
    init_LoadingSkeleton();
    init_StyledHelpHub();
    init_StyledHelpHubFooter();
    init_colors();
    init_StyledPoweredBy();
    init_StyledSuggestedSearch();
    init_StyledLoadingSkeleton();
    init_StyledLoadingSkeletonContainer();
    init_branding();
    init_languages();
    init_track();
    HelpHub2 = () => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      const _ = useStore();
      const { query, searchResults, experienceSearchResults } = _.helpHub;
      const setIsLoading = useAction((_2, loading) => {
        _2.helpHub.loading = loading;
      });
      const [localQuery, setLocalQuery] = useState44(query);
      const setHelpHubQuery2 = useAction(setHelpHubQuery);
      const styles51 = useStyles();
      const startChat = useStartChat();
      const searchSuggestions = _.helpHub.searchSuggestions;
      const debounceOnChangeQuery = React322.useCallback(
        debounce6((value) => {
          setHelpHubQuery2(value);
          setIsLoading(false);
          Track.helphub.searchExecuted(value);
          helpHubEngagement({ query: value }, "search");
        }, 500),
        []
      );
      const debounceReportSearchInput = React322.useCallback(
        debounce6((value) => {
          Track.helphub.searchInput(value);
        }, 500),
        []
      );
      const onChangeQuery = (value) => {
        var _a3;
        setLocalQuery(value);
        debounceReportSearchInput(value);
        if (!((_a3 = _ == null ? void 0 : _.organization) == null ? void 0 : _a3.copilot_enabled)) {
          setIsLoading(true);
          debounceOnChangeQuery(value);
        }
      };
      React322.useEffect(() => {
        setLocalQuery(query);
      }, [query]);
      const submitQuery = (query2) => {
        if (_.helpHub.query === query2)
          return;
        setHelpHubQuery2(query2 || "");
        if (!query2)
          return;
        setIsLoading(true);
        helpHubEngagement({ query: query2 }, "search");
        Track.helphub.searchExecuted(query2);
      };
      const hasAdditionalResources = _.helpHub.additionalResources && _.helpHub.additionalResources.length > 0 && !(_.helpHub.additionalResources.length === 1 && _.helpHub.additionalResources[0].show_as_primary_cta && !_.helpHub.additionalResources[0].label);
      if (_.helpHub.minimized)
        return null;
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx122(StyledHelpHub_default, { fading: true }, /* @__PURE__ */ jsx122(AnimationTransition, { isMounted: true, style: { width: "100%" } }, /* @__PURE__ */ jsx122(
        Input_default,
        {
          query: localQuery,
          onChangeQuery,
          onSubmit: submitQuery,
          children: searchSuggestions.loading ? /* @__PURE__ */ jsx122(StyledLoadingSkeletonContainer_default, null, /* @__PURE__ */ jsx122(StyledLoadingSkeleton_default, { style: { width: "75%" } }), /* @__PURE__ */ jsx122(StyledLoadingSkeleton_default, { style: { width: "60%" } })) : !!((_b2 = _ == null ? void 0 : _.organization) == null ? void 0 : _b2.helphub_suggested_queries_enabled) && !!((_c2 = _ == null ? void 0 : _.organization) == null ? void 0 : _c2.copilot_enabled) ? /* @__PURE__ */ jsx122(React322.Fragment, null, searchSuggestions.continuations.map((continuation) => {
            const selectSuggestedQuery = (query2) => {
              helpHubSuggestedQuery({ query: _.helpHub.query }, continuation);
              Track.helphub.suggestedQueryClicked(continuation);
              startChat(query2);
            };
            return /* @__PURE__ */ jsx122(
              StyledSuggestedSearch_default,
              {
                key: continuation,
                onKeyDown: (e) => {
                  if (e.key === "Enter" || e.keyCode === 13) {
                    selectSuggestedQuery(continuation);
                  }
                },
                onClick: () => {
                  selectSuggestedQuery(continuation);
                }
              },
              continuation
            );
          })) : null
        }
      )), /* @__PURE__ */ jsx122(
        AnimationTransition,
        {
          entry: { keyframes: builtinKeyframes.fadeInSlideDown },
          isMounted: !_.helpHub.loading && !!query,
          style: { width: "100%", overflowY: "auto", display: "flex", flexDirection: "column", flex: 1 }
        },
        ((_d = _.flags) == null ? void 0 : _d["release-search-experiences-in-help-hub"]) ? /* @__PURE__ */ jsx122(ExperienceSearchResults_default, { hits: experienceSearchResults }) : /* @__PURE__ */ jsx122(SearchResults_default, { docs: searchResults })
      ), /* @__PURE__ */ jsx122(
        AnimationTransition,
        {
          entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 100 },
          isMounted: !query,
          style: { width: "100%", overflowY: "auto", display: "flex", flexDirection: "column", flex: 1 }
        },
        /* @__PURE__ */ jsx122(Recommendations_default, null),
        hasAdditionalResources && /* @__PURE__ */ jsx122(AdditionalResources_default, null),
        ((_e = _.organization) == null ? void 0 : _e.branding) === "branded" && /* @__PURE__ */ jsx122(StyledHelpHubFooter_default, { showTopPadding: !hasAdditionalResources }, /* @__PURE__ */ jsx122(
          StyledPoweredBy_default,
          {
            onClick: () => navigateToBrandingSite(_.organization),
            text: translate("Powered by Command AI")
          }
        ))
      )) : /* @__PURE__ */ jsx122("div", { style: { height: "100%", display: "flex", flexDirection: "column" } }, /* @__PURE__ */ jsx122(AnimationTransition, { isMounted: true }, /* @__PURE__ */ jsx122(
        Input_default,
        {
          query: localQuery,
          onChangeQuery,
          onSubmit: submitQuery,
          children: searchSuggestions.loading ? /* @__PURE__ */ jsx122(React322.Fragment, null, /* @__PURE__ */ jsx122(LoadingSkeleton_default, { style: { width: "90%" } }), /* @__PURE__ */ jsx122(LoadingSkeleton_default, { style: { width: "70%" } })) : !!((_f = _ == null ? void 0 : _.organization) == null ? void 0 : _f.helphub_suggested_queries_enabled) && !!((_g = _ == null ? void 0 : _.organization) == null ? void 0 : _g.copilot_enabled) ? /* @__PURE__ */ jsx122(React322.Fragment, null, searchSuggestions.continuations.map((continuation) => {
            const selectSuggestedQuery = (query2) => {
              helpHubSuggestedQuery({ query: _.helpHub.query }, continuation);
              startChat(query2);
            };
            return /* @__PURE__ */ jsx122(
              "div",
              {
                role: "button",
                tabIndex: 0,
                key: continuation,
                css: styles51.chatSuggestion,
                onKeyDown: (e) => {
                  if (e.key === "Enter" || e.keyCode === 13) {
                    selectSuggestedQuery(continuation);
                  }
                },
                onClick: () => {
                  selectSuggestedQuery(continuation);
                }
              },
              /* @__PURE__ */ jsx122("span", { style: { marginLeft: "5px" } }, continuation)
            );
          })) : null
        }
      )), /* @__PURE__ */ jsx122(
        AnimationTransition,
        {
          entry: { keyframes: builtinKeyframes.fadeInSlideDown },
          isMounted: !_.helpHub.loading && !!query,
          style: { overflowY: "auto", flex: 1 }
        },
        ((_h = _.flags) == null ? void 0 : _h["release-search-experiences-in-help-hub"]) ? /* @__PURE__ */ jsx122(ExperienceSearchResults_default, { hits: experienceSearchResults }) : /* @__PURE__ */ jsx122(SearchResults_default, { docs: searchResults })
      ), /* @__PURE__ */ jsx122(
        AnimationTransition,
        {
          entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 100 },
          isMounted: !query,
          style: { overflowY: "auto", display: "flex", flexDirection: "column", flex: 1 }
        },
        /* @__PURE__ */ jsx122(Recommendations_default, null),
        hasAdditionalResources && /* @__PURE__ */ jsx122(AdditionalResources_default, null),
        /* @__PURE__ */ jsx122(
          PoweredBy_default,
          {
            style: {
              padding: "12px",
              justifyContent: "center",
              background: CB_COLORS.white
            }
          }
        )
      ));
    };
    HelpHub_default = HelpHub2;
  }
});

// commandbar/src/shared/util/copilot.ts
import dayjs7 from "dayjs";
var createAiMessage, createUserMessage;
var init_copilot = __esm({
  "commandbar/src/shared/util/copilot.ts"() {
    "use strict";
    createAiMessage = (args) => {
      const { uuid: uuid3 = null, continuations = [], answer, incomplete = false, no_answer = false } = args;
      return {
        uuid: uuid3,
        message_type: "AI",
        incomplete,
        error: "",
        feedback: null,
        no_answer,
        used_fallback: false,
        continuations,
        fallback_ctas: [],
        fallback_labeled_actions: [],
        value: {
          answer,
          command_id: null,
          command_title: "",
          passage_id: null,
          passage_heading: null,
          experiences: [],
          doc: null,
          source_docs: []
        },
        extras: [],
        modified: dayjs7().toString(),
        debug_info: {}
      };
    };
    createUserMessage = (args) => {
      const { uuid: uuid3 = null, question, attachments } = args;
      return {
        uuid: uuid3,
        message_type: "USER",
        value: {
          question,
          command_ids: [],
          attachments: attachments != null ? attachments : []
        },
        modified: dayjs7().toString()
      };
    };
  }
});

// commandbar/src/products/copilot/store/ChatStateMachine.ts
import { createMachine as createMachine8, assign as assign7 } from "xstate";
var AI_MESSAGE_GENERIC_ERROR, DEFAULT_INITIAL_AI_MESSAGE, CONNECTING_WITH_SUPPORT, TRANSFERRING_TO_AGENT, machine, ChatStateMachine_default;
var init_ChatStateMachine = __esm({
  "commandbar/src/products/copilot/store/ChatStateMachine.ts"() {
    "use strict";
    init_search();
    init_Reporting();
    init_copilot();
    init_Logger();
    init_helpdocService();
    init_track();
    AI_MESSAGE_GENERIC_ERROR = "We are getting too many requests right now. Please try again in a moment.";
    DEFAULT_INITIAL_AI_MESSAGE = "Hey there! What can we help with?";
    CONNECTING_WITH_SUPPORT = "Connecting with support! This may take a minute...";
    TRANSFERRING_TO_AGENT = "Got it. Connecting you with an agent.";
    machine = ({
      chatID,
      initialUserMessage,
      organization,
      chatHistory
    }) => createMachine8(
      {
        /** @xstate-layout N4IgpgJg5mDOIC5QGMAWBDALgOgJYDtdNd0AbXAL0gGIBtABgF1FQAHAe1iN3fxZAAeiALQBWAIwBObACYAbDNGiZ9FaIAsADjkAaEAE8R49fU3ZNk+gHYAzHPH1j4mQF8XetFjyFiZSjVpxZiQQDi5iXn4hBGFJM0cZTU1RBST6Gyk9QwRxOWkrdQ1xK00rBPpRNw8MHAB3dG58KAACADN2ACdmgFdYMC6CVm7Maj78CAZgtk5uSJDo4RljbDirPM1ck1F6dSssxBtVbHpJNYl0zTsJKpBPOobiJrbOnr6B-CGR-DAoLFwANzAbTAkAARuhkABrSb8MKzPjzESiErYORaS5WDRyNbqfYIRQ2bA2RQpTQyDJJclyG53bD1RotdpdXr9ZqDYbUMACMDIYZA5DsAC2gvQ42atVQuDQzQwsGa6A6UG6grA+EwsBhIThEQRoGiVhk0hsl2NElEkgtJzxNks2DKEkk4lEdls9kq7luNTpDwIjJeLPen2oArVEMwzVg3VYHA6mE103CPF1gkQBUJNiskmUhU0WnSNjxayJ21Khsk6kSMgKNK99MefuZbzZHw5GHG7FarXjoRmOqiRgN5k2FrkogsKRSeOEzkz2G2JlOVe2JJrXhg3w6WCBHTgHHwfWoEF4YG8-3YkJPrTAmDQwgawjud-3tX63e1Sf7MQc6nMkjsO2SZxElxAxEHUOR6DtZ0SnEUp1HUSRFFXHB136Ldmh3WA9wPfoOk6bBWFILAmUFbArxvVA71wB8aifWAXw6N9ew-REYjiOdDRkcDYLRJRHTxc1pHLGwMmNTN5GRZDsFQzdMG3XdeAPKMIC3JjEzmPURC0ORUVsUpR2NU4LF0UCEGxURsCkFJTCdCCbBSKT2FYVUIyjGNwzuQ9j1Pc8Tyc1VhEjaNOkwGisDU+FPzkbFLPAuQM1yFJnALUzFiOJYEJSewkisZxHOc-BXOC2Nmk83D8MI4jOlI-z8ECtyQrCuMmFhZiNJTMzB2KR0qwKaC9lSlEUhKTE8kceh0ikhUlRVNVSvYUhSB5HVqG+QEOkFAgJharU2uTaI8iExRLEzcQHHLTRC0USzjWSUcDUcXMpsVZVVQ8haluQHVpNVNC5IwhT9zALzvh8i9sGm161QfD7lqTMKCAivtWIrH9LEOEwDUdEo8XEQy5z-JZyWMCtNGema3vmxa4d4H6N3QzDsOBo9QYIM9wch2bQoFamvvhzxEaCVr1P2rTcrndFkQkORtEuEDsmcU5sC0U4sUQqQrHJqH3t576ZIZwGDxZk82d8iGXq5mHdf5jBEZkKYexFz84kg4piTKCDklUGRcccHTthJw0ROArWuapz69d+2T5KwxTgfKjoCKIzASPNinoZ5iObYafAkZYzScjEyzsXLXJHQmitffSSzS40bR0RtUPKczmn8Dpv6Y6Z6hlNUnaE0i1iHFMWRYPRmW8jHeXEGME5ZG0Mc4icCp1CbuaW752m619Z5G1ZdkRjGbaHffdr9Tx44KyrGW-2dPHfcSIkANyuIFHg1edazzefSeJlXj3lsRghkwGGIq7k86n2nrdcwCV0SYgQgUPEGwfzwS0AUDYGZ1CwXfuHVu3oGQ7z-oGDkXIeR8nAaLBANpxAE0UBBC0aZ6DYkLOaWQiFiTyFHLmZQ2D17fTWv0Ta4w6B90dgPAuZ0LBzxOkoTQjhbCSDxOBQkGJcp8RsAheCmsPS0jbEeTsnIBBEHIZ+eyFkHDOiuNLPGtgpyv2OKOUc5jLimGpNor0uiOytGwKCH4BAZSij0a0EGJt8DsxPDogJnjvG+MKh4zsCBTbID+LwSYxjB7FDMcUACxI0QZCnl+KkqIlA7GJOo5Q3C3FeDiV4nxUA-HVM5B0PCidKop2qtgCJ7ZOzRLqbEyJ8TEnJNzkwNJBcNDKzRLIywJ0ZYiSnGdCCxxJCcPduWZQWjqhVP6V4jgi1fSjFVEfYWYiOrGDyESd2sFvZknUfM+Q1C8a5GSm7ZEK9Kk4GqQRD6vovl7KaMEsG4T3HbN+eQJooLfQJNCewJJOpUkiJPhQ8Zdg6FVjsGSNEJlsjCA2BZCaZ14LWEKPFd0myPkgt2WCqAEL-nG0BR04FXSdnfPBZSyFgy4UjKFrtJ2rExw6UUOBeBthMQ41SrI6h2YIIz3SCcGwUlPlstZSyqAjTmlJyqhtBlWymU0upUqqAUKzywqTPC4+e1PzOGcJZWw8gLSXAkLsKcSQfwpEMrmNEFRJLvOwIqlVeD6zUAELAYBckIatDkh0AAFNsegABKYMjLAl6oDb6UZpz0gyBWI9KQ4EygbB9uKwchR0gaDsOw1xHp8DsAgHAfgdxjnIwLsIBQOlJkYixDieZdCR7qFEkoQofapIEG4H4KgEBG35w6sIeCZgyyOFKaW5QKVsVOiWHaYwwEEK5hElJLeP9-RNn3pOiBCAyjK0nmwtY6MFGmVyFYYuphVAmGSEo0lno1xRwNrHIGJ6KFiEKMcD2h1MEDsUYaYsphEhWtyeIfKLkgruVKjUP9lrFAPvAgBOKwlRx4ldo8-l2VcjaAkTw2GG9kyIpMUWdGOxrCGmKJdUyKQfzxSSAock2H320k5s3cjkd6b-UZnHVDrE1iEkwWdK1BJiTiFxioQkdkUhLAseJMj1sv74N-gGZsnxRMF2xD+DMWUnTmmMGSPEjodIlGuWiSwFRXFkrTtrHBFHsD8I2ltfTpzkrHG-JgvSSwV2pmWcrGQHDLD2HsLlBV2zvPRAQpBQVdmrAiuREx1d6jpCmZ2LlILY5XA+s+bU+pcWeUnOiLLcw19xMiRdoW1d9yinbCuJldZsXdUGvi4gZ0c6sTCuM2K1dQFWHkhErlUc0EOvJoNXq7rCAb7HCQScLM9lDTzPSD+cSpSSZoPlUVil-r91QHm-58wOwnQusdMUOTg1ZEX1ka8i6Cm3BuCAA */
        tsTypes: {},
        context: {
          chatID,
          chatHistory: chatHistory.length > 0 ? chatHistory : initialUserMessage ? [] : [
            createAiMessage({
              answer: organization.helphub_chat_welcome_message || DEFAULT_INITIAL_AI_MESSAGE
            })
          ],
          userMessage: null,
          messageToExternal: null,
          userAttachments: [],
          partialResponse: null,
          chatHandoffType: ""
        },
        id: "chat",
        initial: "initialized",
        states: {
          initialized: {
            always: [
              {
                target: "generate response",
                cond: "initialUserMessage specified",
                actions: assign7({ userMessage: initialUserMessage })
              },
              {
                target: "waiting for user input"
              }
            ]
          },
          "waiting for user input": {
            on: {
              send: {
                target: "generate response",
                actions: ["set user message", "set user attachments", "report user message to analytics"]
              },
              "negative feedback": {
                target: "generate response"
              },
              "contact support": "open support chat",
              handoff: {
                target: "handoff.begin handoff",
                actions: ["set handoff type", "set partialResponse to `TRANSFERRING_TO_AGENT`"]
              }
            }
          },
          "generate response": {
            exit: ["commit user message to chat history", "clear partialResponse"],
            invoke: {
              src: "fetch-ai-chat-answer",
              id: "fetch-ai-chat-answer",
              onDone: [
                {
                  target: "waiting for user input",
                  actions: ["append AI response to chat history", "report AI response to analytics", "cache source doc"]
                }
              ],
              onError: [
                {
                  target: "waiting for user input",
                  actions: ["log error", "append error message to chat history"]
                }
              ]
            },
            tags: "loading",
            on: {
              update: {
                actions: "update partialResponse",
                internal: true
              }
            }
          },
          "open support chat": {
            invoke: {
              src: "open-support-chat",
              id: "open-support-chat",
              onError: {
                target: "#chat.waiting for user input",
                actions: ["log error", "append error message to chat history", "clear partialResponse"]
              },
              onDone: {
                target: "#chat.waiting for user input",
                actions: ["append partialResponse to chat history", "clear partialResponse"]
              }
            },
            entry: "set partialResponse to `CONNECTING_WITH_SUPPORT`"
          },
          handoff: {
            on: {
              exit: "waiting for user input"
            },
            states: {
              "begin handoff": {
                invoke: {
                  src: "perform-chat-handoff",
                  onDone: "polling",
                  onError: {
                    target: "#chat.waiting for user input",
                    actions: ["log error", "append error message to chat history"]
                  }
                },
                tags: "loading"
              },
              polling: {
                on: {
                  send: {
                    actions: [
                      "set user message",
                      "set user attachments",
                      "commit user message to chat history",
                      "set message to external",
                      "send to agent"
                    ]
                  }
                },
                states: {
                  polling: {
                    invoke: {
                      src: "retrieve new external messages",
                      onDone: [
                        {
                          target: "#chat.waiting for user input",
                          cond: "agent exited",
                          actions: ["update chat history with external messages", "notify user of transfer"]
                        },
                        {
                          target: "waiting",
                          actions: "update chat history with external messages"
                        }
                      ],
                      onError: {
                        target: "waiting",
                        actions: "log error"
                      }
                    }
                  },
                  waiting: {
                    after: {
                      "500": "polling"
                    }
                  }
                },
                initial: "polling"
              }
            },
            initial: "begin handoff"
          }
        },
        schema: {
          events: {},
          context: {},
          services: {}
        },
        predictableActionArguments: true,
        preserveActionOrder: true,
        strict: true
      },
      {
        actions: {
          "commit user message to chat history": (
            /* add userMessage to chat history and clear userMessage */
            assign7({
              userMessage: null,
              userAttachments: [],
              chatHistory: (context, _event) => {
                const { userMessage, userAttachments } = context;
                if (!userMessage)
                  return context.chatHistory;
                helpHubChatMessage("user", userMessage, false, chatID);
                return [...context.chatHistory, createUserMessage({ question: userMessage, attachments: userAttachments })];
              }
            })
          ),
          "set partialResponse to `CONNECTING_WITH_SUPPORT`": assign7({
            partialResponse: () => createAiMessage({
              answer: CONNECTING_WITH_SUPPORT
            })
          }),
          "set partialResponse to `TRANSFERRING_TO_AGENT`": assign7({
            chatHistory: ({ chatHistory: chatHistory2 }) => [
              ...chatHistory2,
              createAiMessage({
                answer: TRANSFERRING_TO_AGENT
              })
            ]
          }),
          "update partialResponse": assign7({
            partialResponse: (context, event) => event.message
          }),
          "clear partialResponse": assign7({ partialResponse: null }),
          "append partialResponse to chat history": assign7({
            chatHistory: (context, _event) => [
              ...context.chatHistory,
              ...context.partialResponse ? [context.partialResponse] : []
            ]
          }),
          "append AI response to chat history": assign7({
            chatHistory: (context, event) => [...context.chatHistory, event.data]
          }),
          "cache source doc": (context, event) => {
            var _a2;
            if ((_a2 = event.data.value.doc) == null ? void 0 : _a2.command) {
              helpdocService_default.addToCache(event.data.value.doc.command.id, {
                command: event.data.value.doc.command,
                excerpt: "",
                score: [0]
              });
            }
          },
          "report AI response to analytics": (context, event) => {
            Track.copilot.chatMessageSent(context.chatID, event.data);
            const message = event.data;
            if (message.no_answer) {
              noChatResponse(convertInternalChatHistoryToExternal(context.chatHistory));
            }
            helpHubChatMessage(
              "ai",
              message.value.answer,
              message.no_answer && message.extras.length === 0,
              chatID
            );
          },
          "log error": (_context, event) => Logger_default.error("[chat state machine] unhandled error", event.data),
          "append error message to chat history": assign7({
            chatHistory: (context, _event) => [
              ...context.chatHistory,
              createAiMessage({
                answer: AI_MESSAGE_GENERIC_ERROR
              })
            ]
          }),
          "report user message to analytics": (context, event) => {
            Track.copilot.chatMessageSent(
              context.chatID,
              createUserMessage({ question: event.message, attachments: event.attachments })
            );
          },
          "set user message": assign7({ userMessage: (context, event) => event.message }),
          "notify user of transfer": assign7({
            chatHistory: ({ chatHistory: chatHistory2 }) => [
              ...chatHistory2,
              createAiMessage({
                answer: "Your chat with an agent has ended. Is there anything else I can help with?"
              })
            ]
          }),
          "set message to external": assign7({ messageToExternal: (_context, event) => event.message }),
          "set user attachments": assign7({
            userAttachments: (_context, event) => {
              var _a2;
              return (_a2 = event.attachments) != null ? _a2 : [];
            }
          }),
          "update chat history with external messages": assign7({
            chatHistory: (context, event) => [...context.chatHistory, ...event.data.history]
          }),
          "set handoff type": assign7({ chatHandoffType: (_context, event) => event.action.meta.type })
        },
        /* TODO: update ChatStateMachine tests to mock these out */
        services: {},
        guards: {
          "initialUserMessage specified": () => initialUserMessage !== void 0,
          "agent exited": (context, event) => event.data.control === "INTERNAL"
        },
        delays: {}
      }
    );
    ChatStateMachine_default = machine;
  }
});

// commandbar/src/products/copilot/store/ChatMessagePollingMachine.ts
import { createMachine as createMachine9, assign as assign8, sendParent as sendParent2 } from "xstate";
import { escalate } from "xstate/lib/actions";
var ANSWER_POLLING_TIMEOUT_MS, ANSWER_POLLING_REQUEST_TIMEOUT_MS, ANSWER_POLLING_INTERVAL_MS, ANSWER_POLLING_RETRIES, machine2, ChatMessagePollingMachine_default;
var init_ChatMessagePollingMachine = __esm({
  "commandbar/src/products/copilot/store/ChatMessagePollingMachine.ts"() {
    "use strict";
    ANSWER_POLLING_TIMEOUT_MS = 12e4;
    ANSWER_POLLING_REQUEST_TIMEOUT_MS = 25e3;
    ANSWER_POLLING_INTERVAL_MS = 250;
    ANSWER_POLLING_RETRIES = 6;
    machine2 = ({ poll }) => createMachine9(
      {
        /** @xstate-layout N4IgpgJg5mDOIC5QGMAWBDALgAgLZ1nRmwAcB7AGwoEsA7KAYgA9ZMswA6dAM0zACcAFAEYATAAZJ4gJQM0WPASJhSlGvQDa4gLqJQ5WNUzUytPSCaIAHAFYbHAOzDhAZgeTRogJyiHAFgAaEABPRG8-RwA2Lxs-Fy8XP2FY8UiAXzSg+Rx8WEJicio6KA5C9UYIU046ADcyAGtOMq1dJBADIxMzNssEUTiOcVEbBIdhmKs-SKsg0IQAWmFUjlFIyMSHWy9-K18MrIwcpQK1YtLT+gZK2mraOsbzqg1hVv0yQ2NTc17h0Q4XSbCJLCSLOUQuVyzRDzP5WFwSGyuSJ+PybZKpfYgbKKPLKVRFeiPcoMAT8Mj8UoULDccm4IktcwdT7dUC9VwcVxeKxWTag-rCLzCBxQhDCKyRDg2MYQ8HrURwvyY7G5fIqMpndWXUnkynU2n0l6M96dL49ML2URC6UOBxeUHiAWREXyiVrKZiFxS1E2WxKw441X48pE4rMVjsLi8ASCYZSWTK45qi4lTVQBltJldb7Qy2w3lePw+GJuVYivziDh2qY2CFiKZWVx+hQqvGpjgAd3QnUuLDYfEjfCEAAUAPIAGTHAEkAHIAcQA+jOAGoAUQASkuAIJj+cAWQAyvH-S2TgSSp3u2mdEaPlmzQg-H9kTborEfeI-DZRCKwRxHw4fQbeFQTEUQMkyEBaDICA4HMBNcVPcobxNFkLBzSIKx5cUCyLGtpRFRYEklKwfC-GJkTfRUIPgwM21TZDmWzBYxQrEYCzhXlxC8cQXCdEJEBBP5EQAzZwV4sYeKbI4EKTM8OGQMhcBICgwD4Bi71ZRB3xWeE4m8T0AX8AjxQ4dYuJ9aZXAcSIwOo49EyDM4L2Meh1NNTSEAhKxJRsmxIk2W0GyGH9-L-cQpSrKxxAAkYbCkgNW2TDhtX4NzUN6KUK2cL9pjGO0eUCfi+gwjkHF4oKpVtVFwLSIA */
        tsTypes: {},
        id: "chat message polling",
        context: { errorCount: 0, error: null },
        after: {
          [ANSWER_POLLING_TIMEOUT_MS]: [
            {
              target: "#chat message polling.error",
              actions: "set polling timeout reached error",
              internal: true
            }
          ]
        },
        initial: "polling",
        states: {
          polling: {
            invoke: {
              src: "poll",
              id: "poll",
              onDone: [
                {
                  target: "complete",
                  cond: "complete",
                  doneData: (_context, event) => event.data.value,
                  actions: "update"
                },
                {
                  target: "waiting",
                  actions: ["update", "reset error count"]
                }
              ],
              onError: [
                {
                  target: "waiting",
                  cond: "retries remaining",
                  actions: "increment error count"
                },
                "error"
              ]
            },
            after: {
              [ANSWER_POLLING_REQUEST_TIMEOUT_MS]: [
                {
                  target: "#chat message polling.polling",
                  actions: [],
                  meta: {},
                  internal: false
                }
              ]
            }
          },
          complete: {
            type: "final",
            data: (context, event) => event.data
          },
          waiting: {
            after: {
              POLLING_INVERVAL_MS: [
                {
                  target: "#chat message polling.polling",
                  actions: [],
                  meta: {},
                  internal: false
                }
              ]
            }
          },
          error: {
            type: "final",
            entry: "escalate"
          }
        },
        schema: {
          events: {},
          services: {}
        },
        predictableActionArguments: true,
        preserveActionOrder: true
      },
      {
        actions: {
          "set polling timeout reached error": assign8({ error: (_context, _event) => "Polling timeout reached" }),
          update: sendParent2((_context, event) => ({ type: "update", message: event.data })),
          escalate: escalate(
            (context, event) => ("data" in event && event.data ? event.data : context.error) || "Unknown error"
          ),
          "reset error count": assign8({ errorCount: 0 }),
          "increment error count": assign8({ errorCount: (context) => context.errorCount + 1 })
        },
        services: {
          poll
        },
        guards: {
          complete: (context, event) => {
            return event.data.message_type === "AI" && !event.data.incomplete;
          },
          "retries remaining": (context) => context.errorCount <= ANSWER_POLLING_RETRIES
        },
        delays: {
          POLLING_INVERVAL_MS: (context) => 2 ** context.errorCount * ANSWER_POLLING_INTERVAL_MS
        }
      }
    );
    ChatMessagePollingMachine_default = machine2;
  }
});

// node_modules/event-source-polyfill/src/eventsource.js
var require_eventsource = __commonJS({
  "node_modules/event-source-polyfill/src/eventsource.js"(exports, module2) {
    (function(global2) {
      "use strict";
      var setTimeout2 = global2.setTimeout;
      var clearTimeout2 = global2.clearTimeout;
      var XMLHttpRequest2 = global2.XMLHttpRequest;
      var XDomainRequest = global2.XDomainRequest;
      var ActiveXObject = global2.ActiveXObject;
      var NativeEventSource = global2.EventSource;
      var document2 = global2.document;
      var Promise2 = global2.Promise;
      var fetch2 = global2.fetch;
      var Response2 = global2.Response;
      var TextDecoder = global2.TextDecoder;
      var TextEncoder2 = global2.TextEncoder;
      var AbortController2 = global2.AbortController;
      if (typeof window !== "undefined" && typeof document2 !== "undefined" && !("readyState" in document2) && document2.body == null) {
        document2.readyState = "loading";
        window.addEventListener("load", function(event) {
          document2.readyState = "complete";
        }, false);
      }
      if (XMLHttpRequest2 == null && ActiveXObject != null) {
        XMLHttpRequest2 = function() {
          return new ActiveXObject("Microsoft.XMLHTTP");
        };
      }
      if (Object.create == void 0) {
        Object.create = function(C) {
          function F() {
          }
          F.prototype = C;
          return new F();
        };
      }
      if (!Date.now) {
        Date.now = function now() {
          return (/* @__PURE__ */ new Date()).getTime();
        };
      }
      if (AbortController2 == void 0) {
        var originalFetch2 = fetch2;
        fetch2 = function(url, options) {
          var signal = options.signal;
          return originalFetch2(url, { headers: options.headers, credentials: options.credentials, cache: options.cache }).then(function(response2) {
            var reader = response2.body.getReader();
            signal._reader = reader;
            if (signal._aborted) {
              signal._reader.cancel();
            }
            return {
              status: response2.status,
              statusText: response2.statusText,
              headers: response2.headers,
              body: {
                getReader: function() {
                  return reader;
                }
              }
            };
          });
        };
        AbortController2 = function() {
          this.signal = {
            _reader: null,
            _aborted: false
          };
          this.abort = function() {
            if (this.signal._reader != null) {
              this.signal._reader.cancel();
            }
            this.signal._aborted = true;
          };
        };
      }
      function TextDecoderPolyfill() {
        this.bitsNeeded = 0;
        this.codePoint = 0;
      }
      TextDecoderPolyfill.prototype.decode = function(octets) {
        function valid(codePoint2, shift3, octetsCount2) {
          if (octetsCount2 === 1) {
            return codePoint2 >= 128 >> shift3 && codePoint2 << shift3 <= 2047;
          }
          if (octetsCount2 === 2) {
            return codePoint2 >= 2048 >> shift3 && codePoint2 << shift3 <= 55295 || codePoint2 >= 57344 >> shift3 && codePoint2 << shift3 <= 65535;
          }
          if (octetsCount2 === 3) {
            return codePoint2 >= 65536 >> shift3 && codePoint2 << shift3 <= 1114111;
          }
          throw new Error();
        }
        function octetsCount(bitsNeeded2, codePoint2) {
          if (bitsNeeded2 === 6 * 1) {
            return codePoint2 >> 6 > 15 ? 3 : codePoint2 > 31 ? 2 : 1;
          }
          if (bitsNeeded2 === 6 * 2) {
            return codePoint2 > 15 ? 3 : 2;
          }
          if (bitsNeeded2 === 6 * 3) {
            return 3;
          }
          throw new Error();
        }
        var REPLACER = 65533;
        var string38 = "";
        var bitsNeeded = this.bitsNeeded;
        var codePoint = this.codePoint;
        for (var i2 = 0; i2 < octets.length; i2 += 1) {
          var octet = octets[i2];
          if (bitsNeeded !== 0) {
            if (octet < 128 || octet > 191 || !valid(codePoint << 6 | octet & 63, bitsNeeded - 6, octetsCount(bitsNeeded, codePoint))) {
              bitsNeeded = 0;
              codePoint = REPLACER;
              string38 += String.fromCharCode(codePoint);
            }
          }
          if (bitsNeeded === 0) {
            if (octet >= 0 && octet <= 127) {
              bitsNeeded = 0;
              codePoint = octet;
            } else if (octet >= 192 && octet <= 223) {
              bitsNeeded = 6 * 1;
              codePoint = octet & 31;
            } else if (octet >= 224 && octet <= 239) {
              bitsNeeded = 6 * 2;
              codePoint = octet & 15;
            } else if (octet >= 240 && octet <= 247) {
              bitsNeeded = 6 * 3;
              codePoint = octet & 7;
            } else {
              bitsNeeded = 0;
              codePoint = REPLACER;
            }
            if (bitsNeeded !== 0 && !valid(codePoint, bitsNeeded, octetsCount(bitsNeeded, codePoint))) {
              bitsNeeded = 0;
              codePoint = REPLACER;
            }
          } else {
            bitsNeeded -= 6;
            codePoint = codePoint << 6 | octet & 63;
          }
          if (bitsNeeded === 0) {
            if (codePoint <= 65535) {
              string38 += String.fromCharCode(codePoint);
            } else {
              string38 += String.fromCharCode(55296 + (codePoint - 65535 - 1 >> 10));
              string38 += String.fromCharCode(56320 + (codePoint - 65535 - 1 & 1023));
            }
          }
        }
        this.bitsNeeded = bitsNeeded;
        this.codePoint = codePoint;
        return string38;
      };
      var supportsStreamOption = function() {
        try {
          return new TextDecoder().decode(new TextEncoder2().encode("test"), { stream: true }) === "test";
        } catch (error3) {
          console.debug("TextDecoder does not support streaming option. Using polyfill instead: " + error3);
        }
        return false;
      };
      if (TextDecoder == void 0 || TextEncoder2 == void 0 || !supportsStreamOption()) {
        TextDecoder = TextDecoderPolyfill;
      }
      var k = function() {
      };
      function XHRWrapper(xhr) {
        this.withCredentials = false;
        this.readyState = 0;
        this.status = 0;
        this.statusText = "";
        this.responseText = "";
        this.onprogress = k;
        this.onload = k;
        this.onerror = k;
        this.onreadystatechange = k;
        this._contentType = "";
        this._xhr = xhr;
        this._sendTimeout = 0;
        this._abort = k;
      }
      XHRWrapper.prototype.open = function(method, url) {
        this._abort(true);
        var that = this;
        var xhr = this._xhr;
        var state = 1;
        var timeout = 0;
        this._abort = function(silent) {
          if (that._sendTimeout !== 0) {
            clearTimeout2(that._sendTimeout);
            that._sendTimeout = 0;
          }
          if (state === 1 || state === 2 || state === 3) {
            state = 4;
            xhr.onload = k;
            xhr.onerror = k;
            xhr.onabort = k;
            xhr.onprogress = k;
            xhr.onreadystatechange = k;
            xhr.abort();
            if (timeout !== 0) {
              clearTimeout2(timeout);
              timeout = 0;
            }
            if (!silent) {
              that.readyState = 4;
              that.onabort(null);
              that.onreadystatechange();
            }
          }
          state = 0;
        };
        var onStart = function() {
          if (state === 1) {
            var status = 0;
            var statusText = "";
            var contentType = void 0;
            if (!("contentType" in xhr)) {
              try {
                status = xhr.status;
                statusText = xhr.statusText;
                contentType = xhr.getResponseHeader("Content-Type");
              } catch (error3) {
                status = 0;
                statusText = "";
                contentType = void 0;
              }
            } else {
              status = 200;
              statusText = "OK";
              contentType = xhr.contentType;
            }
            if (status !== 0) {
              state = 2;
              that.readyState = 2;
              that.status = status;
              that.statusText = statusText;
              that._contentType = contentType;
              that.onreadystatechange();
            }
          }
        };
        var onProgress = function() {
          onStart();
          if (state === 2 || state === 3) {
            state = 3;
            var responseText = "";
            try {
              responseText = xhr.responseText;
            } catch (error3) {
            }
            that.readyState = 3;
            that.responseText = responseText;
            that.onprogress();
          }
        };
        var onFinish = function(type39, event) {
          if (event == null || event.preventDefault == null) {
            event = {
              preventDefault: k
            };
          }
          onProgress();
          if (state === 1 || state === 2 || state === 3) {
            state = 4;
            if (timeout !== 0) {
              clearTimeout2(timeout);
              timeout = 0;
            }
            that.readyState = 4;
            if (type39 === "load") {
              that.onload(event);
            } else if (type39 === "error") {
              that.onerror(event);
            } else if (type39 === "abort") {
              that.onabort(event);
            } else {
              throw new TypeError();
            }
            that.onreadystatechange();
          }
        };
        var onReadyStateChange = function(event) {
          if (xhr != void 0) {
            if (xhr.readyState === 4) {
              if (!("onload" in xhr) || !("onerror" in xhr) || !("onabort" in xhr)) {
                onFinish(xhr.responseText === "" ? "error" : "load", event);
              }
            } else if (xhr.readyState === 3) {
              if (!("onprogress" in xhr)) {
                onProgress();
              }
            } else if (xhr.readyState === 2) {
              onStart();
            }
          }
        };
        var onTimeout = function() {
          timeout = setTimeout2(function() {
            onTimeout();
          }, 500);
          if (xhr.readyState === 3) {
            onProgress();
          }
        };
        if ("onload" in xhr) {
          xhr.onload = function(event) {
            onFinish("load", event);
          };
        }
        if ("onerror" in xhr) {
          xhr.onerror = function(event) {
            onFinish("error", event);
          };
        }
        if ("onabort" in xhr) {
          xhr.onabort = function(event) {
            onFinish("abort", event);
          };
        }
        if ("onprogress" in xhr) {
          xhr.onprogress = onProgress;
        }
        if ("onreadystatechange" in xhr) {
          xhr.onreadystatechange = function(event) {
            onReadyStateChange(event);
          };
        }
        if ("contentType" in xhr || !("ontimeout" in XMLHttpRequest2.prototype)) {
          url += (url.indexOf("?") === -1 ? "?" : "&") + "padding=true";
        }
        xhr.open(method, url, true);
        if ("readyState" in xhr) {
          timeout = setTimeout2(function() {
            onTimeout();
          }, 0);
        }
      };
      XHRWrapper.prototype.abort = function() {
        this._abort(false);
      };
      XHRWrapper.prototype.getResponseHeader = function(name) {
        return this._contentType;
      };
      XHRWrapper.prototype.setRequestHeader = function(name, value) {
        var xhr = this._xhr;
        if ("setRequestHeader" in xhr) {
          xhr.setRequestHeader(name, value);
        }
      };
      XHRWrapper.prototype.getAllResponseHeaders = function() {
        return this._xhr.getAllResponseHeaders != void 0 ? this._xhr.getAllResponseHeaders() || "" : "";
      };
      XHRWrapper.prototype.send = function() {
        if ((!("ontimeout" in XMLHttpRequest2.prototype) || !("sendAsBinary" in XMLHttpRequest2.prototype) && !("mozAnon" in XMLHttpRequest2.prototype)) && document2 != void 0 && document2.readyState != void 0 && document2.readyState !== "complete") {
          var that = this;
          that._sendTimeout = setTimeout2(function() {
            that._sendTimeout = 0;
            that.send();
          }, 4);
          return;
        }
        var xhr = this._xhr;
        if ("withCredentials" in xhr) {
          xhr.withCredentials = this.withCredentials;
        }
        try {
          xhr.send(void 0);
        } catch (error1) {
          throw error1;
        }
      };
      function toLowerCase(name) {
        return name.replace(/[A-Z]/g, function(c) {
          return String.fromCharCode(c.charCodeAt(0) + 32);
        });
      }
      function HeadersPolyfill(all) {
        var map = /* @__PURE__ */ Object.create(null);
        var array27 = all.split("\r\n");
        for (var i2 = 0; i2 < array27.length; i2 += 1) {
          var line = array27[i2];
          var parts = line.split(": ");
          var name = parts.shift();
          var value = parts.join(": ");
          map[toLowerCase(name)] = value;
        }
        this._map = map;
      }
      HeadersPolyfill.prototype.get = function(name) {
        return this._map[toLowerCase(name)];
      };
      if (XMLHttpRequest2 != null && XMLHttpRequest2.HEADERS_RECEIVED == null) {
        XMLHttpRequest2.HEADERS_RECEIVED = 2;
      }
      function XHRTransport() {
      }
      XHRTransport.prototype.open = function(xhr, onStartCallback, onProgressCallback, onFinishCallback, url, withCredentials, headers) {
        xhr.open("GET", url);
        var offset6 = 0;
        xhr.onprogress = function() {
          var responseText = xhr.responseText;
          var chunk = responseText.slice(offset6);
          offset6 += chunk.length;
          onProgressCallback(chunk);
        };
        xhr.onerror = function(event) {
          event.preventDefault();
          onFinishCallback(new Error("NetworkError"));
        };
        xhr.onload = function() {
          onFinishCallback(null);
        };
        xhr.onabort = function() {
          onFinishCallback(null);
        };
        xhr.onreadystatechange = function() {
          if (xhr.readyState === XMLHttpRequest2.HEADERS_RECEIVED) {
            var status = xhr.status;
            var statusText = xhr.statusText;
            var contentType = xhr.getResponseHeader("Content-Type");
            var headers2 = xhr.getAllResponseHeaders();
            onStartCallback(status, statusText, contentType, new HeadersPolyfill(headers2));
          }
        };
        xhr.withCredentials = withCredentials;
        for (var name in headers) {
          if (Object.prototype.hasOwnProperty.call(headers, name)) {
            xhr.setRequestHeader(name, headers[name]);
          }
        }
        xhr.send();
        return xhr;
      };
      function HeadersWrapper(headers) {
        this._headers = headers;
      }
      HeadersWrapper.prototype.get = function(name) {
        return this._headers.get(name);
      };
      function FetchTransport() {
      }
      FetchTransport.prototype.open = function(xhr, onStartCallback, onProgressCallback, onFinishCallback, url, withCredentials, headers) {
        var reader = null;
        var controller = new AbortController2();
        var signal = controller.signal;
        var textDecoder = new TextDecoder();
        fetch2(url, {
          headers,
          credentials: withCredentials ? "include" : "same-origin",
          signal,
          cache: "no-store"
        }).then(function(response2) {
          reader = response2.body.getReader();
          onStartCallback(response2.status, response2.statusText, response2.headers.get("Content-Type"), new HeadersWrapper(response2.headers));
          return new Promise2(function(resolve, reject) {
            var readNextChunk = function() {
              reader.read().then(function(result) {
                if (result.done) {
                  resolve(void 0);
                } else {
                  var chunk = textDecoder.decode(result.value, { stream: true });
                  onProgressCallback(chunk);
                  readNextChunk();
                }
              })["catch"](function(error3) {
                reject(error3);
              });
            };
            readNextChunk();
          });
        })["catch"](function(error3) {
          if (error3.name === "AbortError") {
            return void 0;
          } else {
            return error3;
          }
        }).then(function(error3) {
          onFinishCallback(error3);
        });
        return {
          abort: function() {
            if (reader != null) {
              reader.cancel();
            }
            controller.abort();
          }
        };
      };
      function EventTarget() {
        this._listeners = /* @__PURE__ */ Object.create(null);
      }
      function throwError(e) {
        setTimeout2(function() {
          throw e;
        }, 0);
      }
      EventTarget.prototype.dispatchEvent = function(event) {
        event.target = this;
        var typeListeners = this._listeners[event.type];
        if (typeListeners != void 0) {
          var length = typeListeners.length;
          for (var i2 = 0; i2 < length; i2 += 1) {
            var listener = typeListeners[i2];
            try {
              if (typeof listener.handleEvent === "function") {
                listener.handleEvent(event);
              } else {
                listener.call(this, event);
              }
            } catch (e) {
              throwError(e);
            }
          }
        }
      };
      EventTarget.prototype.addEventListener = function(type39, listener) {
        type39 = String(type39);
        var listeners = this._listeners;
        var typeListeners = listeners[type39];
        if (typeListeners == void 0) {
          typeListeners = [];
          listeners[type39] = typeListeners;
        }
        var found = false;
        for (var i2 = 0; i2 < typeListeners.length; i2 += 1) {
          if (typeListeners[i2] === listener) {
            found = true;
          }
        }
        if (!found) {
          typeListeners.push(listener);
        }
      };
      EventTarget.prototype.removeEventListener = function(type39, listener) {
        type39 = String(type39);
        var listeners = this._listeners;
        var typeListeners = listeners[type39];
        if (typeListeners != void 0) {
          var filtered = [];
          for (var i2 = 0; i2 < typeListeners.length; i2 += 1) {
            if (typeListeners[i2] !== listener) {
              filtered.push(typeListeners[i2]);
            }
          }
          if (filtered.length === 0) {
            delete listeners[type39];
          } else {
            listeners[type39] = filtered;
          }
        }
      };
      function Event3(type39) {
        this.type = type39;
        this.target = void 0;
      }
      function MessageEvent(type39, options) {
        Event3.call(this, type39);
        this.data = options.data;
        this.lastEventId = options.lastEventId;
      }
      MessageEvent.prototype = Object.create(Event3.prototype);
      function ConnectionEvent(type39, options) {
        Event3.call(this, type39);
        this.status = options.status;
        this.statusText = options.statusText;
        this.headers = options.headers;
      }
      ConnectionEvent.prototype = Object.create(Event3.prototype);
      function ErrorEvent2(type39, options) {
        Event3.call(this, type39);
        this.error = options.error;
      }
      ErrorEvent2.prototype = Object.create(Event3.prototype);
      var WAITING = -1;
      var CONNECTING = 0;
      var OPEN = 1;
      var CLOSED = 2;
      var AFTER_CR = -1;
      var FIELD_START = 0;
      var FIELD = 1;
      var VALUE_START = 2;
      var VALUE = 3;
      var contentTypeRegExp = /^text\/event\-stream(;.*)?$/i;
      var MINIMUM_DURATION = 1e3;
      var MAXIMUM_DURATION = 18e6;
      var parseDuration = function(value, def) {
        var n = value == null ? def : parseInt(value, 10);
        if (n !== n) {
          n = def;
        }
        return clampDuration(n);
      };
      var clampDuration = function(n) {
        return Math.min(Math.max(n, MINIMUM_DURATION), MAXIMUM_DURATION);
      };
      var fire = function(that, f, event) {
        try {
          if (typeof f === "function") {
            f.call(that, event);
          }
        } catch (e) {
          throwError(e);
        }
      };
      function EventSourcePolyfill2(url, options) {
        EventTarget.call(this);
        options = options || {};
        this.onopen = void 0;
        this.onmessage = void 0;
        this.onerror = void 0;
        this.url = void 0;
        this.readyState = void 0;
        this.withCredentials = void 0;
        this.headers = void 0;
        this._close = void 0;
        start2(this, url, options);
      }
      function getBestXHRTransport() {
        return XMLHttpRequest2 != void 0 && "withCredentials" in XMLHttpRequest2.prototype || XDomainRequest == void 0 ? new XMLHttpRequest2() : new XDomainRequest();
      }
      var isFetchSupported = fetch2 != void 0 && Response2 != void 0 && "body" in Response2.prototype;
      function start2(es, url, options) {
        url = String(url);
        var withCredentials = Boolean(options.withCredentials);
        var lastEventIdQueryParameterName = options.lastEventIdQueryParameterName || "lastEventId";
        var initialRetry = clampDuration(1e3);
        var heartbeatTimeout = parseDuration(options.heartbeatTimeout, 45e3);
        var lastEventId = "";
        var retry = initialRetry;
        var wasActivity = false;
        var textLength = 0;
        var headers = options.headers || {};
        var TransportOption = options.Transport;
        var xhr = isFetchSupported && TransportOption == void 0 ? void 0 : new XHRWrapper(TransportOption != void 0 ? new TransportOption() : getBestXHRTransport());
        var transport = TransportOption != null && typeof TransportOption !== "string" ? new TransportOption() : xhr == void 0 ? new FetchTransport() : new XHRTransport();
        var abortController = void 0;
        var timeout = 0;
        var currentState = WAITING;
        var dataBuffer = "";
        var lastEventIdBuffer = "";
        var eventTypeBuffer = "";
        var textBuffer = "";
        var state = FIELD_START;
        var fieldStart = 0;
        var valueStart = 0;
        var onStart = function(status, statusText, contentType, headers2) {
          if (currentState === CONNECTING) {
            if (status === 200 && contentType != void 0 && contentTypeRegExp.test(contentType)) {
              currentState = OPEN;
              wasActivity = Date.now();
              retry = initialRetry;
              es.readyState = OPEN;
              var event = new ConnectionEvent("open", {
                status,
                statusText,
                headers: headers2
              });
              es.dispatchEvent(event);
              fire(es, es.onopen, event);
            } else {
              var message = "";
              if (status !== 200) {
                if (statusText) {
                  statusText = statusText.replace(/\s+/g, " ");
                }
                message = "EventSource's response has a status " + status + " " + statusText + " that is not 200. Aborting the connection.";
              } else {
                message = "EventSource's response has a Content-Type specifying an unsupported type: " + (contentType == void 0 ? "-" : contentType.replace(/\s+/g, " ")) + ". Aborting the connection.";
              }
              close();
              var event = new ConnectionEvent("error", {
                status,
                statusText,
                headers: headers2
              });
              es.dispatchEvent(event);
              fire(es, es.onerror, event);
              console.error(message);
            }
          }
        };
        var onProgress = function(textChunk) {
          if (currentState === OPEN) {
            var n = -1;
            for (var i2 = 0; i2 < textChunk.length; i2 += 1) {
              var c = textChunk.charCodeAt(i2);
              if (c === "\n".charCodeAt(0) || c === "\r".charCodeAt(0)) {
                n = i2;
              }
            }
            var chunk = (n !== -1 ? textBuffer : "") + textChunk.slice(0, n + 1);
            textBuffer = (n === -1 ? textBuffer : "") + textChunk.slice(n + 1);
            if (textChunk !== "") {
              wasActivity = Date.now();
              textLength += textChunk.length;
            }
            for (var position = 0; position < chunk.length; position += 1) {
              var c = chunk.charCodeAt(position);
              if (state === AFTER_CR && c === "\n".charCodeAt(0)) {
                state = FIELD_START;
              } else {
                if (state === AFTER_CR) {
                  state = FIELD_START;
                }
                if (c === "\r".charCodeAt(0) || c === "\n".charCodeAt(0)) {
                  if (state !== FIELD_START) {
                    if (state === FIELD) {
                      valueStart = position + 1;
                    }
                    var field = chunk.slice(fieldStart, valueStart - 1);
                    var value = chunk.slice(valueStart + (valueStart < position && chunk.charCodeAt(valueStart) === " ".charCodeAt(0) ? 1 : 0), position);
                    if (field === "data") {
                      dataBuffer += "\n";
                      dataBuffer += value;
                    } else if (field === "id") {
                      lastEventIdBuffer = value;
                    } else if (field === "event") {
                      eventTypeBuffer = value;
                    } else if (field === "retry") {
                      initialRetry = parseDuration(value, initialRetry);
                      retry = initialRetry;
                    } else if (field === "heartbeatTimeout") {
                      heartbeatTimeout = parseDuration(value, heartbeatTimeout);
                      if (timeout !== 0) {
                        clearTimeout2(timeout);
                        timeout = setTimeout2(function() {
                          onTimeout();
                        }, heartbeatTimeout);
                      }
                    }
                  }
                  if (state === FIELD_START) {
                    if (dataBuffer !== "") {
                      lastEventId = lastEventIdBuffer;
                      if (eventTypeBuffer === "") {
                        eventTypeBuffer = "message";
                      }
                      var event = new MessageEvent(eventTypeBuffer, {
                        data: dataBuffer.slice(1),
                        lastEventId: lastEventIdBuffer
                      });
                      es.dispatchEvent(event);
                      if (eventTypeBuffer === "open") {
                        fire(es, es.onopen, event);
                      } else if (eventTypeBuffer === "message") {
                        fire(es, es.onmessage, event);
                      } else if (eventTypeBuffer === "error") {
                        fire(es, es.onerror, event);
                      }
                      if (currentState === CLOSED) {
                        return;
                      }
                    }
                    dataBuffer = "";
                    eventTypeBuffer = "";
                  }
                  state = c === "\r".charCodeAt(0) ? AFTER_CR : FIELD_START;
                } else {
                  if (state === FIELD_START) {
                    fieldStart = position;
                    state = FIELD;
                  }
                  if (state === FIELD) {
                    if (c === ":".charCodeAt(0)) {
                      valueStart = position + 1;
                      state = VALUE_START;
                    }
                  } else if (state === VALUE_START) {
                    state = VALUE;
                  }
                }
              }
            }
          }
        };
        var onFinish = function(error3) {
          if (currentState === OPEN || currentState === CONNECTING) {
            currentState = WAITING;
            if (timeout !== 0) {
              clearTimeout2(timeout);
              timeout = 0;
            }
            timeout = setTimeout2(function() {
              onTimeout();
            }, retry);
            retry = clampDuration(Math.min(initialRetry * 16, retry * 2));
            es.readyState = CONNECTING;
            var event = new ErrorEvent2("error", { error: error3 });
            es.dispatchEvent(event);
            fire(es, es.onerror, event);
            if (error3 != void 0) {
              console.error(error3);
            }
          }
        };
        var close = function() {
          currentState = CLOSED;
          if (abortController != void 0) {
            abortController.abort();
            abortController = void 0;
          }
          if (timeout !== 0) {
            clearTimeout2(timeout);
            timeout = 0;
          }
          es.readyState = CLOSED;
        };
        var onTimeout = function() {
          timeout = 0;
          if (currentState !== WAITING) {
            if (!wasActivity && abortController != void 0) {
              onFinish(new Error("No activity within " + heartbeatTimeout + " milliseconds. " + (currentState === CONNECTING ? "No response received." : textLength + " chars received.") + " Reconnecting."));
              if (abortController != void 0) {
                abortController.abort();
                abortController = void 0;
              }
            } else {
              var nextHeartbeat = Math.max((wasActivity || Date.now()) + heartbeatTimeout - Date.now(), 1);
              wasActivity = false;
              timeout = setTimeout2(function() {
                onTimeout();
              }, nextHeartbeat);
            }
            return;
          }
          wasActivity = false;
          textLength = 0;
          timeout = setTimeout2(function() {
            onTimeout();
          }, heartbeatTimeout);
          currentState = CONNECTING;
          dataBuffer = "";
          eventTypeBuffer = "";
          lastEventIdBuffer = lastEventId;
          textBuffer = "";
          fieldStart = 0;
          valueStart = 0;
          state = FIELD_START;
          var requestURL = url;
          if (url.slice(0, 5) !== "data:" && url.slice(0, 5) !== "blob:") {
            if (lastEventId !== "") {
              var i2 = url.indexOf("?");
              requestURL = i2 === -1 ? url : url.slice(0, i2 + 1) + url.slice(i2 + 1).replace(/(?:^|&)([^=&]*)(?:=[^&]*)?/g, function(p, paramName) {
                return paramName === lastEventIdQueryParameterName ? "" : p;
              });
              requestURL += (url.indexOf("?") === -1 ? "?" : "&") + lastEventIdQueryParameterName + "=" + encodeURIComponent(lastEventId);
            }
          }
          var withCredentials2 = es.withCredentials;
          var requestHeaders = {};
          requestHeaders["Accept"] = "text/event-stream";
          var headers2 = es.headers;
          if (headers2 != void 0) {
            for (var name in headers2) {
              if (Object.prototype.hasOwnProperty.call(headers2, name)) {
                requestHeaders[name] = headers2[name];
              }
            }
          }
          try {
            abortController = transport.open(xhr, onStart, onProgress, onFinish, requestURL, withCredentials2, requestHeaders);
          } catch (error3) {
            close();
            throw error3;
          }
        };
        es.url = url;
        es.readyState = CONNECTING;
        es.withCredentials = withCredentials;
        es.headers = headers;
        es._close = close;
        onTimeout();
      }
      EventSourcePolyfill2.prototype = Object.create(EventTarget.prototype);
      EventSourcePolyfill2.prototype.CONNECTING = CONNECTING;
      EventSourcePolyfill2.prototype.OPEN = OPEN;
      EventSourcePolyfill2.prototype.CLOSED = CLOSED;
      EventSourcePolyfill2.prototype.close = function() {
        this._close();
      };
      EventSourcePolyfill2.CONNECTING = CONNECTING;
      EventSourcePolyfill2.OPEN = OPEN;
      EventSourcePolyfill2.CLOSED = CLOSED;
      EventSourcePolyfill2.prototype.withCredentials = void 0;
      var R = NativeEventSource;
      if (XMLHttpRequest2 != void 0 && (NativeEventSource == void 0 || !("withCredentials" in NativeEventSource.prototype))) {
        R = EventSourcePolyfill2;
      }
      (function(factory) {
        if (typeof module2 === "object" && typeof module2.exports === "object") {
          var v = factory(exports);
          if (v !== void 0)
            module2.exports = v;
        } else if (false) {
          null(["exports"], factory);
        } else {
          factory(global2);
        }
      })(function(exports2) {
        exports2.EventSourcePolyfill = EventSourcePolyfill2;
        exports2.NativeEventSource = NativeEventSource;
        exports2.EventSource = R;
      });
    })(typeof globalThis === "undefined" ? typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : exports : globalThis);
  }
});

// internal/src/middleware/integrations/salesforceMessagingService.ts
var import_event_source_polyfill, CONVERSATION_CONSTANTS, SalesforceMessagingService;
var init_salesforceMessagingService = __esm({
  "internal/src/middleware/integrations/salesforceMessagingService.ts"() {
    "use strict";
    import_event_source_polyfill = __toESM(require_eventsource());
    init_network();
    CONVERSATION_CONSTANTS = {
      CONVERSATION_MESSAGE: "CONVERSATION_MESSAGE",
      CONVERSATION_PARTICIPANT_CHANGED: "CONVERSATION_PARTICIPANT_CHANGED",
      CONVERSATION_ROUTING_RESULT: "CONVERSATION_ROUTING_RESULT",
      CONVERSATION_DELIVERY_ACKNOWLEDGEMENT: "CONVERSATION_DELIVERY_ACKNOWLEDGEMENT",
      CONVERSATION_CLOSE_CONVERSATION: "CONVERSATION_CLOSE_CONVERSATION"
    };
    SalesforceMessagingService = class {
      constructor(jwt, sfdcOrgId, messagingUrl, lastEventId, caiOrgId, chatId) {
        this.eventSource = null;
        this.lastEventId = "";
        this.handleEvent = async (evt) => {
          var _a2;
          const event = evt;
          if (event && event.lastEventId) {
            this.lastEventId = event.lastEventId;
          }
          const payload = { ...event, chat_id: this.chatId };
          await post(`integrations/sfdc-messaging/${this.caiOrgId}/process_server_event/`, payload);
          if (evt.type === CONVERSATION_CONSTANTS.CONVERSATION_CLOSE_CONVERSATION) {
            (_a2 = this.eventSource) == null ? void 0 : _a2.close();
          }
        };
        this.getEventSourceParams = () => {
          return {
            headers: {
              Authorization: "Bearer " + this.jwt,
              "X-Org-ID": this.sfdcOrgId,
              "Last-Event-ID": this.lastEventId
            },
            heartbeatTimeout: 9e4
          };
        };
        this.handleEventSourceListeners = (eventNames) => {
          eventNames.forEach((eventName) => {
            if (!this.eventSource) {
              throw new Error(`Expected EventSource object to be a valid object, but received: ${this.eventSource}`);
            }
            this.eventSource.addEventListener(eventName, this.handleEvent);
          });
        };
        this.createEventSource = (fullApiPath, eventNames) => {
          const resolveEventSource = (resolve, reject) => {
            try {
              this.eventSource = new import_event_source_polyfill.EventSourcePolyfill(fullApiPath, this.getEventSourceParams());
              this.eventSource.onopen = () => {
                this.handleEventSourceListeners(eventNames);
                resolve();
              };
              this.eventSource.onerror = (error3) => {
                reject(error3);
              };
            } catch (error3) {
              reject(error3);
            }
          };
          return new Promise(resolveEventSource);
        };
        this.subscribeToEventSource = (eventNames) => {
          const messagingUrl = this.messagingUrl;
          return new Promise((resolve, reject) => {
            try {
              this.createEventSource(`${messagingUrl}/eventrouter/v1/sse?_ts=${Date.now()}`, eventNames).then(resolve, (error3) => {
                reject(error3);
              }).catch((error3) => {
                reject(error3);
              });
            } catch (error3) {
              reject(error3);
            }
          });
        };
        this.jwt = jwt;
        this.sfdcOrgId = sfdcOrgId;
        this.messagingUrl = messagingUrl;
        this.lastEventId = lastEventId;
        this.caiOrgId = caiOrgId;
        this.chatId = chatId;
      }
      async subscribe() {
        const eventListeners = [
          CONVERSATION_CONSTANTS.CONVERSATION_MESSAGE,
          CONVERSATION_CONSTANTS.CONVERSATION_PARTICIPANT_CHANGED,
          CONVERSATION_CONSTANTS.CONVERSATION_CLOSE_CONVERSATION,
          CONVERSATION_CONSTANTS.CONVERSATION_ROUTING_RESULT
        ];
        await this.subscribeToEventSource(eventListeners);
      }
    };
  }
});

// internal/src/middleware/chatHandoff.tsx
import * as t43 from "io-ts";
var InitializeHandoffPayloadV, InitializeHandoffResponseV, SendUserMessagePayloadV, SendUserMessageResponseV, FetchUpdatesResponseV, ChatOwnershipV, ExternalChatHandoff, ZendeskSunshineChatHandoff, SalesforceLiveAgentChatHandoff, SalesforceMessagingChatHandoff, instances, getOrCreateChatHandoffInstance;
var init_chatHandoff = __esm({
  "internal/src/middleware/chatHandoff.tsx"() {
    "use strict";
    init_generics();
    init_network();
    init_chat();
    init_salesforceMessagingService();
    InitializeHandoffPayloadV = t43.type({
      user: t43.union([t43.string, t43.null, t43.undefined]),
      chat_id: t43.string
    });
    InitializeHandoffResponseV = t43.type({
      chat_id: t43.string
    });
    SendUserMessagePayloadV = t43.type({
      content: t43.string,
      user: t43.union([t43.string, t43.null, t43.undefined]),
      chat_id: t43.union([t43.string, t43.undefined]),
      attachments: t43.union([t43.array(UserAttachmentV), t43.null, t43.undefined])
    });
    SendUserMessageResponseV = t43.type({
      chat_id: t43.string
    });
    FetchUpdatesResponseV = t43.type({
      chat_id: t43.string,
      control: t43.union([t43.literal("INTERNAL"), t43.literal("EXTERNAL")]),
      history: t43.array(t43.union([AgentMessageV, UserMessageV, AIMessageV]))
    });
    ChatOwnershipV = t43.type({
      control: t43.union([t43.literal("INTERNAL"), t43.literal("EXTERNAL")])
    });
    ExternalChatHandoff = class {
      constructor(integrationType) {
        this.baseUrl = `integrations/${integrationType}`;
      }
      async initialize(orgUID, payload, config2) {
        const result = await post(`${this.baseUrl}/${orgUID}/initialize_handoff/`, payload, config2);
        return decodeToPromise(t43.exact(InitializeHandoffResponseV), result.data);
      }
      async sendUserMessage(orgUID, payload, config2) {
        const result = await post(`${this.baseUrl}/${orgUID}/send_user_message/`, payload, config2);
        return decodeToPromise(t43.exact(SendUserMessageResponseV), result.data);
      }
      async fetchUpdates(orgUID, chatID, startingMessageUuid, config2) {
        const query = startingMessageUuid ? `?starting_message_uuid=${encodeURIComponent(startingMessageUuid)}` : "";
        const result = await get2(`${this.baseUrl}/${orgUID}/${chatID}/fetch_updates${query}`, config2);
        return decodeToPromise(t43.exact(FetchUpdatesResponseV), result.data);
      }
    };
    ZendeskSunshineChatHandoff = class extends ExternalChatHandoff {
      constructor() {
        super("sunshine");
      }
    };
    SalesforceLiveAgentChatHandoff = class extends ExternalChatHandoff {
      constructor() {
        super("sfdc-chat");
      }
    };
    SalesforceMessagingChatHandoff = class extends ExternalChatHandoff {
      constructor() {
        super("sfdc-messaging");
      }
      async initialize(orgUID, payload, config2) {
        const result = await post(`${this.baseUrl}/${orgUID}/initialize_handoff/`, payload, config2);
        this.service = new SalesforceMessagingService(
          result.data.jwt,
          result.data.org_id,
          result.data.base_url,
          result.data.last_event_id,
          orgUID.toString(),
          result.data.chat_id
        );
        await this.service.subscribe();
        return decodeToPromise(t43.exact(InitializeHandoffResponseV), { chat_id: result.data.chat_id });
      }
    };
    instances = /* @__PURE__ */ new Map();
    getOrCreateChatHandoffInstance = (type39) => {
      if (!instances.has(type39)) {
        let newInstance;
        switch (type39) {
          case "zendesk": {
            newInstance = new ZendeskSunshineChatHandoff();
            break;
          }
          case "sfdc_chat": {
            newInstance = new SalesforceLiveAgentChatHandoff();
            break;
          }
          case "sfdc_messaging": {
            newInstance = new SalesforceMessagingChatHandoff();
            break;
          }
          default:
            throw new Error(`Unsupported chat handoff type: ${type39}`);
        }
        instances.set(type39, newInstance);
        return newInstance;
      }
      const instance = instances.get(type39);
      if (instance === void 0) {
        throw new Error(`Instance not found after creation for type: ${type39}`);
      }
      return instance;
    };
  }
});

// commandbar/src/products/copilot/store/useChatState.tsx
import React323, { useEffect as useEffect67, useMemo as useMemo19 } from "react";
import { InterpreterStatus } from "xstate";
import { useInterpret, useSelector as useSelector2 } from "@xstate/react";
var ChatStateContext, PreviewChatStateProvider, ChatStateProvider, defaultChatMachine, MockChatStateProvider, useChatState;
var init_useChatState = __esm({
  "commandbar/src/products/copilot/store/useChatState.tsx"() {
    "use strict";
    init_chat();
    init_globals();
    init_symbols();
    init_ChatStateMachine();
    init_ChatMessagePollingMachine();
    init_search();
    init_useAction();
    init_global_actions();
    init_useStore();
    init_Interpolate();
    init_chatHandoff();
    ChatStateContext = React323.createContext(void 0);
    PreviewChatStateProvider = ({
      chatHistory,
      children,
      isChatHistoryPreview = false
    }) => {
      const chatState = {
        send: () => {
        },
        refreshChatAfterNegativeFeedback: () => {
        },
        contactSupport: () => {
        },
        chatID: "",
        chatHistory,
        partialResponse: null,
        userMessage: null,
        userAttachments: [],
        initialUserMessage: null,
        messageToExternal: null,
        isLoading: false,
        isChatHistoryPreview,
        isReloadingOldChat: false,
        handoff: () => {
        }
      };
      return /* @__PURE__ */ React323.createElement(ChatStateContext.Provider, { value: chatState }, children);
    };
    ChatStateProvider = ({
      isChatMode,
      chatID,
      initialUserMessage,
      organization,
      endUser,
      helphubFilter,
      userPropertiesOverride,
      children,
      initialChatHistory
    }) => {
      const executeAction2 = useAction(executeAction);
      const _ = useStore();
      const { helpHub } = _;
      const helphubFilterRef = React323.useRef(helphubFilter);
      useEffect67(() => {
        helphubFilterRef.current = helphubFilter;
      }, [helphubFilter]);
      const userPropertiesOverrideRef = React323.useRef(userPropertiesOverride);
      useEffect67(() => {
        userPropertiesOverrideRef.current = userPropertiesOverride;
      }, [userPropertiesOverride]);
      const machine3 = useMemo19(
        () => ChatStateMachine_default({
          chatID,
          initialUserMessage,
          organization: {
            ...organization,
            helphub_chat_welcome_message: interpolate(organization.helphub_chat_welcome_message, _, true, false)
          },
          chatHistory: initialChatHistory
        }),
        []
      );
      const chatMachineService = useInterpret(machine3, {
        actions: {
          "send to agent": (context, event) => {
            var _a2;
            getOrCreateChatHandoffInstance(context.chatHandoffType).sendUserMessage(
              organization.id,
              {
                content: (_a2 = context.messageToExternal) != null ? _a2 : "",
                attachments: event.attachments,
                chat_id: chatID,
                user: endUser == null ? void 0 : endUser.slug
              },
              {
                headers: {
                  ...(endUser == null ? void 0 : endUser.hmac) && { "X-USER-AUTHORIZATION": endUser.hmac },
                  ...(endUser == null ? void 0 : endUser.slug) && { "X-USER-ID": endUser.slug }
                }
              }
            );
          }
        },
        services: {
          "open-support-chat": async (context, event) => {
            var _a2;
            const messageId = ((_a2 = context.chatHistory[context.chatHistory.length - 1]) == null ? void 0 : _a2.uuid) || void 0;
            executeAction2(event.action, void 0, { messageId });
          },
          "fetch-ai-chat-answer": (context, _event) => {
            let chatAndMessageId = null;
            const { userMessage: userMessage2, userAttachments: userAttachments2 } = context;
            if (_event.type === "negative feedback") {
              chatAndMessageId = _event.chatAndMessageId;
            } else if (!userMessage2)
              return new Promise((_2, reject) => reject("invalid state; userMessage is `null`"));
            return ChatMessagePollingMachine_default({
              poll: async () => {
                if (!chatAndMessageId) {
                  const previewedCopilotSettings = helpHub.previewedCopilotSettings ? {
                    ...helpHub.previewedCopilotSettings,
                    name: helpHub.previewedCopilotSettings.name ? interpolate(helpHub.previewedCopilotSettings.name, _, true, false) : null
                  } : void 0;
                  const result = await fetchAIChatAnswer(
                    organization,
                    userMessage2,
                    context.chatID,
                    helphubFilterRef.current,
                    endUser,
                    void 0,
                    previewedCopilotSettings,
                    userAttachments2,
                    userPropertiesOverrideRef.current,
                    _.isAdmin
                    /* TODO -- to allow canceling inflight request, thread abortController thru here */
                  );
                  if ("error" in result) {
                    throw result.error;
                  } else {
                    chatAndMessageId = result;
                  }
                }
                return await Chat.readMessage(
                  chatAndMessageId.chat_id,
                  chatAndMessageId.message_id
                );
              }
            });
          },
          "retrieve new external messages": (context) => {
            const lastMessageInHistory = context.chatHistory.filter((message) => message.uuid).slice(-1)[0];
            return getOrCreateChatHandoffInstance(context.chatHandoffType).fetchUpdates(
              organization.id,
              chatID,
              (lastMessageInHistory == null ? void 0 : lastMessageInHistory.uuid) ? lastMessageInHistory == null ? void 0 : lastMessageInHistory.uuid : void 0
            );
          },
          "perform-chat-handoff": ({ chatHandoffType: externalChatHandoffType }) => getOrCreateChatHandoffInstance(externalChatHandoffType).initialize(organization.id, {
            chat_id: chatID,
            user: getSDK()[_user]
          })
        }
      });
      useEffect67(() => {
        if (!isChatMode)
          return;
        if (chatMachineService.status !== InterpreterStatus.NotStarted)
          return;
        chatMachineService.start();
      }, [isChatMode]);
      const chatHistory = useSelector2(chatMachineService, (state) => state.context.chatHistory);
      const partialResponse = useSelector2(chatMachineService, (state) => state.context.partialResponse);
      const userMessage = useSelector2(chatMachineService, (state) => state.context.userMessage);
      const messageToExternal = useSelector2(chatMachineService, (state) => state.context.messageToExternal);
      const userAttachments = useSelector2(chatMachineService, (state) => state.context.userAttachments);
      const isLoading = useSelector2(chatMachineService, (state) => state.hasTag("loading"));
      const chatMachine = {
        send: (message, attachments) => {
          chatMachineService.send({ type: "send", message, attachments });
        },
        refreshChatAfterNegativeFeedback: (chatAndMessageId) => {
          chatMachineService.send({ type: "negative feedback", chatAndMessageId });
        },
        contactSupport: (action) => {
          chatMachineService.send({ type: "contact support", action });
        },
        chatID,
        chatHistory,
        partialResponse,
        userMessage,
        messageToExternal,
        userAttachments,
        initialUserMessage,
        isLoading,
        isChatHistoryPreview: false,
        isReloadingOldChat: initialChatHistory.length > 0,
        handoff: (action) => {
          chatMachineService.send({ type: "handoff", action });
        }
      };
      return /* @__PURE__ */ React323.createElement(ChatStateContext.Provider, { value: chatMachine }, children);
    };
    defaultChatMachine = {
      send: (_message, _attachments) => {
        return;
      },
      refreshChatAfterNegativeFeedback: (_chatAndMessageId) => {
        return;
      },
      contactSupport: (_action) => {
        return;
      },
      chatID: "",
      chatHistory: [],
      partialResponse: null,
      userMessage: null,
      messageToExternal: null,
      userAttachments: [],
      initialUserMessage: null,
      isLoading: false,
      isChatHistoryPreview: false,
      isReloadingOldChat: false,
      handoff: () => {
        return;
      }
    };
    MockChatStateProvider = ({
      chatHistory = [],
      chatMachine,
      children
    }) => {
      const _chatMachine = chatMachine ? { ...defaultChatMachine, ...chatMachine } : { ...defaultChatMachine, chatHistory };
      return /* @__PURE__ */ React323.createElement(ChatStateContext.Provider, { value: _chatMachine }, children);
    };
    useChatState = () => React323.useContext(ChatStateContext);
  }
});

// commandbar/src/products/copilot/components/BotMessage/FeedbackButtons.tsx
import React324 from "react";
import { jsx as jsx123 } from "@emotion/core";
var FeedbackButtons, FeedbackButtons_default;
var init_FeedbackButtons = __esm({
  "commandbar/src/products/copilot/components/BotMessage/FeedbackButtons.tsx"() {
    "use strict";
    init_service_actions();
    init_react();
    init_StyledButtonGroup();
    init_StyledToggleButton();
    init_track();
    init_global_store();
    init_operatingSystem();
    init_useAction();
    init_useChatState();
    init_useStore();
    init_ThemeV2Context();
    FeedbackButtons = ({
      preview,
      message,
      isChatHistoryPreview,
      previewOverrides
    }) => {
      var _a2, _b2;
      const [givenFeedback, setGivenFeedback] = React324.useState(((_a2 = message.feedback) == null ? void 0 : _a2.rating) || null);
      const markFeedbackGiven = useAction(setFeedbackGiven);
      const _ = (
        // eslint-disable-next-line react-hooks/rules-of-hooks
        !preview ? useStore() : emptyGlobalStore()
      );
      const chatState = useChatState();
      const { chatID, refreshChatAfterNegativeFeedback } = chatState;
      const themeV2 = useThemeV2Context();
      const disabled = preview || isChatHistoryPreview;
      const styles51 = {
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 12px",
        gap: "16px",
        width: "40px",
        height: "32px",
        background: "#FFFFFF",
        border: "1px solid rgba(10, 10, 15, 0.24)",
        borderRadius: "4px",
        flex: "none",
        order: "0",
        flexGrow: "0",
        cursor: !disabled ? "pointer" : "default"
      };
      const feedbackGivenStyles = {
        ...styles51,
        border: "1px solid #dd9d23",
        background: "#fff9ef",
        boxShadow: "0px 0px 0px 3px #dd9d2230",
        color: "#dd9d23"
      };
      const giveFeedback = async (feedback) => {
        var _a3;
        if (feedback === givenFeedback) {
          setGivenFeedback(null);
          await markFeedbackGiven(message.value, 0);
        } else {
          setGivenFeedback(feedback);
          Track.copilot.chatMessageFeedback(chatID, (_a3 = message.uuid) != null ? _a3 : "", feedback);
          const newMessage = await markFeedbackGiven(message.value, feedback);
          if (newMessage) {
            refreshChatAfterNegativeFeedback(newMessage);
          }
        }
      };
      return preview && (previewOverrides == null ? void 0 : previewOverrides.useThemeV2) || ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? /* @__PURE__ */ jsx123(
        StyledButtonGroup_default,
        {
          id: "chat-feedback-buttons",
          css: {
            zIndex: 1,
            position: "absolute",
            right: 0,
            gap: "4px",
            borderRadius: "var(--layout-radius-button)",
            border: "1px solid var(--border-primary)",
            background: "var(--background-primary)",
            bottom: "calc(-1/2 * var(--form-control-height))",
            opacity: givenFeedback !== null || isMobileDevice() ? 1 : 0,
            "&:hover": { opacity: "1" }
          }
        },
        /* @__PURE__ */ jsx123(
          StyledToggleButton_default,
          {
            "data-testid": "positive-button",
            themeV2,
            isSelected: givenFeedback === 1,
            disabled,
            onClick: () => giveFeedback(1),
            style: { width: "var(--form-control-height)", borderRadius: "calc(var(--layout-radius-button) - 1px)" }
          },
          /* @__PURE__ */ jsx123(ThumbsUp_default, null)
        ),
        /* @__PURE__ */ jsx123(
          StyledToggleButton_default,
          {
            "data-testid": "negative-button",
            themeV2,
            isSelected: givenFeedback === -1,
            disabled,
            onClick: () => giveFeedback(-1),
            style: { width: "var(--form-control-height)", borderRadius: "calc(var(--layout-radius-button) - 1px)" }
          },
          /* @__PURE__ */ jsx123(ThumbsDown_default, null)
        )
      ) : /* @__PURE__ */ jsx123(
        "div",
        {
          className: "chat-feedback",
          style: {
            display: "flex",
            gap: "8px",
            marginTop: "12px",
            // Override hover styles when feedback has been given or when on mobile since there's no hover on mobile
            opacity: givenFeedback !== null || isMobileDevice() ? 1 : void 0
          }
        },
        /* @__PURE__ */ jsx123(
          "button",
          {
            disabled,
            tabIndex: 0,
            style: givenFeedback === 1 ? feedbackGivenStyles : styles51,
            onClick: () => giveFeedback(1)
          },
          /* @__PURE__ */ jsx123(ThumbsUp_default, { height: 16, width: 16 })
        ),
        /* @__PURE__ */ jsx123(
          "button",
          {
            disabled,
            tabIndex: 0,
            style: givenFeedback === -1 ? feedbackGivenStyles : styles51,
            onClick: () => giveFeedback(-1)
          },
          /* @__PURE__ */ jsx123(ThumbsDown_default, { height: 16, width: 16 })
        )
      );
    };
    FeedbackButtons_default = FeedbackButtons;
  }
});

// commandbar/src/shared/components/ActionButton.tsx
import { jsx as jsx124, css as css72, keyframes as keyframes16 } from "@emotion/core";
var icons2, slide, ActionButton2, ActionButton_default;
var init_ActionButton = __esm({
  "commandbar/src/shared/components/ActionButton.tsx"() {
    "use strict";
    init_react();
    init_useStyles();
    icons2 = {
      Link01: Link01_default,
      Lightning01: Lightning01_default,
      CheckSquareBroken: CheckSquareBroken_default,
      NotificationBox: NotificationBox_default,
      ArrowNarrowRight: ArrowNarrowRight_default,
      Check: Check_default
    };
    slide = keyframes16`
0% {
  background-position: 100% 0%;
}
100% {
  background-position: -200% 0%;
}
`;
    ActionButton2 = ({
      preview = false,
      variant = "primary",
      children,
      icon,
      style: style3,
      disabled,
      disablePreviewClick = false,
      ...rest
    }) => {
      const styles51 = useStyles(preview);
      const Icon5 = icon ? icons2[icon] : null;
      return /* @__PURE__ */ jsx124(
        "button",
        {
          disabled: disabled || preview && disablePreviewClick,
          css: [
            styles51.actionButtons,
            styles51.actionButtons[disabled ? "disabled" : variant],
            preview && disablePreviewClick && `cursor: default;`,
            variant === "primary" && css72`
            animation: ${slide} 3s linear infinite;
          `
          ],
          style: style3,
          ...rest
        },
        /* @__PURE__ */ jsx124(
          "div",
          {
            style: {
              maxWidth: "100%",
              fontSize: "14px",
              fontWeight: 500,
              letterSpacing: 0,
              lineHeight: "16px",
              position: "relative",
              textAlign: "left",
              color: styles51.actionButtons[variant].color
            }
          },
          children
        ),
        Icon5 && /* @__PURE__ */ jsx124(Icon5, { width: 14, height: 14, style: { color: "currentcolor" } })
      );
    };
    ActionButton_default = ActionButton2;
  }
});

// internal/src/client/themesV2/components/copilot/StyledContinuationQuestionsContainer.tsx
import React325 from "react";
var Container18, StyledContinuationQuestionsContainer, StyledContinuationQuestionsContainer_default;
var init_StyledContinuationQuestionsContainer = __esm({
  "internal/src/client/themesV2/components/copilot/StyledContinuationQuestionsContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container18 = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px var(--layout-padding);
  gap: var(--layout-gap);
`;
    StyledContinuationQuestionsContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React325.createElement(Container18, { ...props2 }, children);
    };
    StyledContinuationQuestionsContainer_default = StyledContinuationQuestionsContainer;
  }
});

// commandbar/src/products/copilot/components/Continuations.tsx
import { jsx as jsx125 } from "@emotion/core";
var Continuations, Continuations_default;
var init_Continuations = __esm({
  "commandbar/src/products/copilot/components/Continuations.tsx"() {
    "use strict";
    init_ActionButton();
    init_Reporting();
    init_useChatState();
    init_useStore();
    init_search();
    init_global_store();
    init_StyledContinuationQuestionsContainer();
    init_track();
    init_symbols();
    init_StyledSecondaryButton();
    init_ThemeV2Context();
    Continuations = (props2) => {
      var _a2;
      const chatState = useChatState();
      const { chatHistory, send: send2, chatID } = chatState;
      const { preview, continuations, hidden } = props2;
      const _ = !preview ? useStore() : emptyGlobalStore();
      const themeV2 = useThemeV2Context();
      return ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx125(StyledContinuationQuestionsContainer_default, { style: { ...hidden && { visibility: "hidden" } } }, continuations.slice(0, 2).map((continuation, index3) => {
        if (!continuation)
          return null;
        return /* @__PURE__ */ jsx125(
          StyledSecondaryButton_default,
          {
            themeV2,
            key: index3,
            onClick: () => {
              if (preview)
                return;
              Track.copilot.followUpClicked(chatID, continuation);
              send2(continuation);
              window.CommandBar[_setActiveChat](chatID);
              helpHubContinuationClicked(
                { query: _.helpHub.query },
                convertInternalChatHistoryToExternal(chatHistory),
                continuation
              );
              send2(continuation);
              window.CommandBar[_setActiveChat](chatID);
            },
            disabled: preview,
            textWrap: true
          },
          continuation
        );
      })) : /* @__PURE__ */ jsx125(
        "div",
        {
          style: {
            width: "100%",
            display: "flex",
            flexDirection: "column",
            gap: "8px",
            padding: "0px",
            marginTop: "12px",
            alignItems: "flex-start"
          }
        },
        continuations.slice(0, 2).map((continuation, index3) => {
          if (!continuation)
            return null;
          return /* @__PURE__ */ jsx125(
            ActionButton2,
            {
              preview,
              variant: "continuation",
              disablePreviewClick: true,
              key: index3,
              style: { minWidth: 0, maxWidth: "100%" },
              onClick: () => {
                if (preview)
                  return;
                Track.copilot.followUpClicked(chatID, continuation);
                send2(continuation);
                window.CommandBar[_setActiveChat](chatID);
                helpHubContinuationClicked(
                  { query: _.helpHub.query },
                  convertInternalChatHistoryToExternal(chatHistory),
                  continuation
                );
                send2(continuation);
                window.CommandBar[_setActiveChat](chatID);
              }
            },
            continuation
          );
        })
      );
    };
    Continuations_default = Continuations;
  }
});

// commandbar/src/products/copilot/components/BotMessage/BotMessageText.tsx
import { jsx as jsx126, css as css73 } from "@emotion/core";
import React326, { Fragment as Fragment13, useEffect as useEffect68, useRef as useRef45 } from "react";
var BotMessageText;
var init_BotMessageText = __esm({
  "commandbar/src/products/copilot/components/BotMessage/BotMessageText.tsx"() {
    "use strict";
    init_Logger();
    init_useTheme();
    init_global_store();
    init_sentry();
    init_useStore();
    init_colors();
    init_track();
    init_useChatState();
    init_EnrichedHtml();
    BotMessageText = ({
      preview,
      isLoading,
      answer,
      isFinishedStreaming,
      onFinishStreaming,
      messageId,
      previewOverrides
    }) => {
      var _a2;
      const _ = !preview ? useStore() : emptyGlobalStore();
      const chatState = useChatState();
      const { theme } = useTheme();
      const answerStreamingIndex = React326.useRef(0);
      const useThemesV2 = preview && (previewOverrides == null ? void 0 : previewOverrides.useThemeV2) || ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]);
      const selfClosingTags = /* @__PURE__ */ new Set([
        "area",
        "base",
        "br",
        "col",
        "embed",
        "hr",
        "img",
        "input",
        "link",
        "meta",
        "param",
        "source",
        "track",
        "wbr"
      ]);
      const handleCodeCopyClick = (parent) => async () => {
        var _a3;
        const { children } = parent;
        const { innerText } = Array.from(children)[0];
        try {
          await navigator.clipboard.writeText(innerText);
        } catch (err) {
          (_a3 = getSentry()) == null ? void 0 : _a3.captureException(err);
          Logger_default.error("Failed to copy text to clipboard:", err);
        }
      };
      const isTable = (node) => {
        return node.nodeName.toLowerCase() === "table";
      };
      const getStreamingNodes = (nodes, textNodes) => {
        nodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) {
            if (node.textContent) {
              textNodes.push(
                ...node.textContent.split("").map(
                  (char) => ({
                    content: char,
                    stream: true,
                    type: "text"
                  })
                )
              );
            }
          } else if (isTable(node) || node.nodeName.toLowerCase() === "pre" || node.nodeName.toLowerCase() === "img" || node.nodeName.toLowerCase() === "div" && node.classList.contains("codehilite")) {
            textNodes.push({
              content: node instanceof HTMLElement ? node.outerHTML : "",
              stream: true,
              type: "block"
            });
          } else {
            if (node.childNodes.length > 0) {
              textNodes.push({
                content: `<${node.nodeName.toLowerCase()}>`,
                stream: false,
                type: "text"
              });
              getStreamingNodes(Array.from(node.childNodes), textNodes);
              textNodes.push({
                content: `</${node.nodeName.toLowerCase()}>`,
                stream: false,
                type: "text"
              });
            } else {
              const nodeName = node.nodeName.toLowerCase();
              if (selfClosingTags.has(nodeName)) {
                const attributes2 = Array.from(node.attributes).map((attr2) => `${attr2.name}="${attr2.value}"`).join(" ");
                textNodes.push({
                  content: `<${nodeName}${attributes2 ? " " + attributes2 : ""}>`,
                  stream: false,
                  type: "text"
                });
              } else {
                textNodes.push({
                  content: `<${node.nodeName.toLowerCase()}></${node.nodeName.toLowerCase()}>`,
                  stream: false,
                  type: "text"
                });
              }
            }
          }
        });
        return textNodes;
      };
      const handleNode = (currParentNode, node, fadeIn2) => {
        const { content, stream, type: type39 } = node;
        if (stream) {
          let element;
          if (type39 === "block") {
            const container = document.createElement("div");
            container.innerHTML = content;
            element = container.firstChild;
          } else {
            element = document.createElement("span");
            element.textContent = content;
          }
          if (fadeIn2) {
            element.style.opacity = "0";
            element.style.transition = "opacity 0.25s ease";
            currParentNode.appendChild(element);
            requestAnimationFrame(() => {
              element.style.opacity = "1";
            });
          } else {
            currParentNode.appendChild(element);
          }
        } else {
          if (content.startsWith("</")) {
            if (currParentNode.parentNode) {
              currParentNode = currParentNode.parentNode;
            }
          } else {
            const parser = new DOMParser();
            const doc = parser.parseFromString(content, "text/html");
            const node2 = doc.body.firstChild;
            if (node2) {
              currParentNode.appendChild(node2);
              if (!selfClosingTags.has(node2.nodeName.toLowerCase())) {
                currParentNode = node2;
              }
            }
          }
        }
        return currParentNode;
      };
      const lastMeasuredLength = useRef45(0);
      const lastMeasureTime = useRef45(Date.now());
      const nodesPerSecond = useRef45(100);
      useEffect68(() => {
        const answerDiv = document.getElementById("doc-based-ai-answer");
        const fakeAnswerDiv = document.getElementById("fake-container");
        const answerDivContainer = document.getElementById(`doc-based-ai-answer-container-${messageId}`);
        if (answerDivContainer && answerDiv && fakeAnswerDiv && useThemesV2) {
          let animationFrameId = null;
          const textNodes = getStreamingNodes(Array.from(fakeAnswerDiv.childNodes), []);
          answerDiv.innerHTML = "";
          const firstChild = document.createElement("span");
          answerDiv.appendChild(firstChild);
          let currParentNode = firstChild;
          for (let i2 = 0; i2 < Math.min(textNodes.length, answerStreamingIndex.current); i2++) {
            currParentNode = handleNode(currParentNode, textNodes[i2]);
          }
          answerDivContainer.style.height = `${answerDiv.offsetHeight}px`;
          let lastTimestamp = performance.now();
          const measureInterval = 500;
          const animate = (timestamp) => {
            const elapsed = timestamp - lastTimestamp;
            const availableNodes = textNodes.length - answerStreamingIndex.current;
            const nodesToProcess = Math.min(Math.floor(elapsed / 1e3 * nodesPerSecond.current), availableNodes);
            if (nodesToProcess > 0) {
              lastTimestamp = timestamp;
              const currentTime = Date.now();
              if (currentTime - lastMeasureTime.current >= measureInterval) {
                const timeDiff = (currentTime - lastMeasureTime.current) / 1e3;
                const lengthDiff = textNodes.length - lastMeasuredLength.current;
                if (timeDiff > 0 && lengthDiff > 0) {
                  const inputRate = lengthDiff / timeDiff;
                  const targetNodesPerSecond = Math.max(30, Math.min(300, inputRate));
                  nodesPerSecond.current = nodesPerSecond.current * 0.7 + targetNodesPerSecond * 0.3;
                }
                lastMeasuredLength.current = textNodes.length;
                lastMeasureTime.current = currentTime;
              }
              for (let i2 = 0; i2 < nodesToProcess; i2++) {
                const node = textNodes[answerStreamingIndex.current];
                currParentNode = handleNode(currParentNode, node, true);
                answerStreamingIndex.current += 1;
              }
              answerDivContainer.style.height = `${answerDiv.offsetHeight}px`;
              if (answerStreamingIndex.current >= textNodes.length && !isLoading) {
                onFinishStreaming();
                answerDivContainer.style.height = "unset";
                animationFrameId && cancelAnimationFrame(animationFrameId);
                return;
              }
            }
            animationFrameId = requestAnimationFrame(animate);
          };
          animationFrameId = requestAnimationFrame(animate);
          return () => {
            onFinishStreaming();
            answerDivContainer.style.height = "unset";
            animationFrameId && cancelAnimationFrame(animationFrameId);
          };
        } else if (!useThemesV2 && !isLoading) {
          onFinishStreaming();
        }
      }, [answer, isLoading]);
      useEffect68(() => {
        if (!isLoading && isFinishedStreaming) {
          const highlights = document.querySelectorAll("div.codehilite");
          highlights.forEach((div) => {
            if (div.querySelector("button")) {
              return;
            }
            const copy = document.createElement("button");
            copy.innerHTML = "Copy";
            copy.addEventListener("click", handleCodeCopyClick(div));
            div.append(copy);
          });
        }
      }, [isLoading, isFinishedStreaming]);
      return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        /* @__PURE__ */ jsx126(
          "div",
          {
            id: `doc-based-ai-answer-container-${messageId}`,
            onClick: (e) => {
              if (e.target instanceof HTMLElement) {
                if (e.target.matches("a")) {
                  Track.copilot.linkClicked(chatState.chatID, messageId, e.target.href);
                }
              }
            },
            style: {
              borderRadius: "0px 16px 16px 16px",
              maxWidth: "100%",
              wordWrap: "break-word"
            },
            css: css73`
        & p {
          margin: 0 0 16px 0;
        }
        & p:last-child {
          margin: 0;
        }
        & pre {
          margin: 0;
          overflow: auto;
        }
        & .codehilite {
          margin: 0 0 16px 0;
          overflow: auto;
          position: relative;
        }
        b {
          ${useThemesV2 && `font-weight: var(--font-weight-bold)`}
        }
        strong {
          ${useThemesV2 && `font-weight: var(--font-weight-bold)`}
        }
        table {
          border-collapse: collapse;
          width: 100%;
        }
        th,
        td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        th {
          background-color: #f2f2f2;
        }
        & blockquote {
          border-left: 4px solid #ddd;
          margin: 0;
          padding: 8px 16px;
        }
        & {
          ol,
          ul {
            display: block;
            margin-block-start: 1em;
            margin-block-end: 1em;
            padding-inline-start: 20px;
          }
          ul {
            list-style: disc;
          }

          ol {
            list-style: decimal;
          }

          li {
            display: list-item;
          }

          ul ul,
          ol ul {
            list-style: circle;
          }

          ul li,
          ol li {
            margin-bottom: 8px;
          }

          ol ol ul,
          ol ul ul,
          ul ol ul,
          ul ul ul {
            list-style: square;
          }

          ol ul,
          ul ol,
          ul ul,
          ol ol {
            margin-top: 8px;
            margin-block-start: 0;
            margin-block-end: 0;
          }

          li > ul,
          li > ol {
            margin-top: 8px;
          }

          img,
          table {
            max-width: calc(100% - 32px);
            height: auto;
            border-radius: 4px;
            margin: 0 0 16px 0;
          }
        }
        & p code {
          white-space: pre-wrap;
        }
        & .codehilite button {
          color: white;
          box-sizing: border-box;
          cursor: pointer;
          user-select: none;
          background: rgba(255, 255, 255, 0.2);
          border: 1px solid rgba(0, 0, 0, 0);
          padding: 4px 8px;
          position: absolute;
          top: 3px;
          right: 3px;
          display: none;
          border-radius: 4px;
          transition: all ${theme.main.transitionTime};
        }

        & .codehilite:hover button {
          display: block;
        }
        a {
          color: ${useThemesV2 ? "var(--content-link)" : CB_COLORS.blue500};
        }

        a:hover {
          color: ${useThemesV2 ? "var(--content-link-hover)" : CB_COLORS.blue500};
        }

        a:visited {
          color: ${useThemesV2 ? "var(--content-link-visited)" : "#551A8B"};
        }
        ${useThemesV2 && `
          & img,
          & table,
          & .codehilite,
          & pre {
            opacity: inherit;
            transition: inherit;
          }
        `}
      `
          },
          isLoading || !isFinishedStreaming ? /* @__PURE__ */ jsx126(Fragment13, null, /* @__PURE__ */ jsx126("div", { id: "doc-based-ai-answer", dangerouslySetInnerHTML: useThemesV2 ? void 0 : { __html: answer } }), useThemesV2 && /* @__PURE__ */ jsx126("div", { id: "fake-container", dangerouslySetInnerHTML: { __html: answer }, style: { display: "none" } })) : /* @__PURE__ */ jsx126(EnrichedHtml, { preview, html: answer })
        )
      );
    };
  }
});

// internal/src/client/themesV2/components/copilot/StyledChatContent.tsx
import React327 from "react";
import { css as css74, jsx as jsx127 } from "@emotion/core";
var styles49, loadingStyles3, StyledChatContent, StyledChatContent_default;
var init_StyledChatContent = __esm({
  "internal/src/client/themesV2/components/copilot/StyledChatContent.tsx"() {
    "use strict";
    styles49 = {
      display: "flex",
      width: "100%",
      overflow: "visible",
      flexDirection: "column",
      alignItems: "flex-end",
      gap: "var(--layout-gap)",
      color: "color-mix(in srgb, var(--base-accent) 75%, black)",
      minWidth: 0,
      /* paragraph/lg */
      fontFamily: "var(--font-font-family)",
      fontSize: "var(--font-size-large)",
      fontWeight: "var(--font-weight-medium)",
      lineHeight: "var(--font-line-height-snug)",
      "&:hover #chat-feedback-buttons": {
        opacity: "1"
      },
      "&:hover #chat-message-timestamp": {
        opacity: "1"
      }
    };
    loadingStyles3 = {
      minHeight: "200px"
    };
    StyledChatContent = React327.forwardRef(
      ({ isLoading, isBotMessage, children, ...props2 }, ref12) => {
        return /* @__PURE__ */ jsx127(
          "div",
          {
            ref: ref12,
            css: [css74(styles49), isLoading && css74(loadingStyles3)].filter(Boolean),
            style: { ...isBotMessage && { color: "var(--content-primary)", alignItems: "flex-start" } },
            ...props2
          },
          children
        );
      }
    );
    StyledChatContent_default = StyledChatContent;
  }
});

// internal/src/client/themesV2/components/copilot/StyledTimestamp.tsx
import { jsx as jsx128 } from "@emotion/core";
var Container19, StyledTimestamp, StyledTimestamp_default;
var init_StyledTimestamp = __esm({
  "internal/src/client/themesV2/components/copilot/StyledTimestamp.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_time2();
    Container19 = styled_browser_esm_default.div`
  position: absolute;
  top: calc(-1 * var(--layout-padding));
  right: var(--layout-padding);
  display: flex;
  align-items: center;
  gap: 4px;
  border-radius: var(--layout-radius-button);
  border: 1px solid var(--border-primary);
  background: var(--background-primary);
  padding: 0px var(--form-control-padding-x);
  min-height: 24px;
  white-space: nowrap;

  color: var(--content-secondary);

  /* label/sm/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  opacity: 0;
`;
    StyledTimestamp = ({ time }) => {
      const timeAgo = getTimeSinceDate(time);
      return time ? /* @__PURE__ */ jsx128(Container19, { id: "chat-message-timestamp", css: { "&:hover": { opacity: "1" } } }, /* @__PURE__ */ jsx128(Clock_default, { height: "12px", width: "12px", fill: "var(--background-primary)" }), timeAgo) : null;
    };
    StyledTimestamp_default = StyledTimestamp;
  }
});

// internal/src/client/themesV2/components/copilot/StyledChatMessage.tsx
import React328 from "react";
import { jsx as jsx129 } from "@emotion/core";
var Message, StyledChatMessage, StyledChatMessage_default;
var init_StyledChatMessage = __esm({
  "internal/src/client/themesV2/components/copilot/StyledChatMessage.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledTimestamp();
    Message = styled_browser_esm_default.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 80%;
  padding: var(--layout-padding);
  align-items: flex-start;
  gap: var(--layout-gap);
  background: var(--form-control-active-background);
  border-radius: var(--layout-radius-button);
  width: fit-content;
`;
    StyledChatMessage = React328.forwardRef(
      ({ children, isBotMessage, timestamp, isMounted = true, ...props2 }, ref12) => {
        return isMounted ? /* @__PURE__ */ jsx129(
          Message,
          {
            ref: ref12,
            style: {
              ...isBotMessage && {
                maxWidth: "100%",
                background: "var(--background-secondary)"
              }
            },
            ...props2
          },
          children,
          timestamp && /* @__PURE__ */ jsx129(StyledTimestamp_default, { time: timestamp })
        ) : null;
      }
    );
    StyledChatMessage_default = StyledChatMessage;
  }
});

// internal/src/proxy-editor/editor_routes.ts
var PAGES_ROUTE, ACTIONS_ROUTE, PRODUCT_TOURS_ROUTE, ANNOUNCEMENTS_ROUTE, SURVEYS_ROUTE, getNudgeRoute;
var init_editor_routes = __esm({
  "internal/src/proxy-editor/editor_routes.ts"() {
    "use strict";
    PAGES_ROUTE = "/pages";
    ACTIONS_ROUTE = "/actions";
    PRODUCT_TOURS_ROUTE = "/product-tours";
    ANNOUNCEMENTS_ROUTE = "/announcements";
    SURVEYS_ROUTE = "/surveys";
    getNudgeRoute = ({ type: type39 }) => {
      switch (type39) {
        case "survey":
          return SURVEYS_ROUTE;
        case "product_tour":
          return PRODUCT_TOURS_ROUTE;
        case "announcement":
        default:
          return ANNOUNCEMENTS_ROUTE;
      }
    };
  }
});

// commandbar/src/products/copilot/components/BotMessage/BotMessageAction.tsx
import React329 from "react";
var BotMessageAction, BotMessageAction_default;
var init_BotMessageAction = __esm({
  "commandbar/src/products/copilot/components/BotMessage/BotMessageAction.tsx"() {
    "use strict";
    init_ThemeV2Context();
    init_StyledPrimaryButton();
    init_StyledSecondaryButton();
    init_StyledChatMessage();
    init_useStore();
    init_ActionButton();
    init_global_store();
    init_useChatState();
    init_service_selectors2();
    init_service_actions();
    init_global_actions();
    init_Reporting();
    init_useAction();
    init_nudges();
    init_useMobileExperience();
    init_sentry();
    init_track();
    init_editor_routes();
    init_service_selectors3();
    BotMessageAction = (props2) => {
      var _a2;
      const {
        idx,
        action,
        buttonLabel = "Click here",
        buttonType = "button_primary",
        message,
        preview,
        isChatHistoryPreview,
        previewOverrides
      } = props2;
      const _ = !preview ? useStore() : emptyGlobalStore();
      const chatState = useChatState();
      const themeV2 = useThemeV2Context();
      const disabled = preview || isChatHistoryPreview;
      const setHelpHubMinimized2 = useAction(setHelpHubMinimized);
      const executeAction2 = useAction(executeAction);
      const shouldContactSupport = (action2) => {
        var _a3, _b2, _c2, _d;
        if (!(action2.type === "open_chat" || action2.type === "chat_handoff")) {
          return false;
        }
        if (((_a3 = action2 == null ? void 0 : action2.meta) == null ? void 0 : _a3.type) === "intercom") {
          if (!((_b2 = window.intercomSettings) == null ? void 0 : _b2.user_id)) {
            (_c2 = getSentry()) == null ? void 0 : _c2.captureMessage("Intercom user_id not found on window.intercomSettings", "warning");
          }
          return window.Intercom && (!!((_d = window.intercomSettings) == null ? void 0 : _d.user_id) || !!window.Intercom("getVisitorId"));
        }
        return false;
      };
      const shouldHandoffChat = (action2) => {
        return action2.type === "chat_handoff" && action2.meta.type === "zendesk" || action2.type === "open_chat" && action2.meta.type === "zendesk_handoff" || action2.type === "chat_handoff" && action2.meta.type === "sfdc_chat" || action2.type === "chat_handoff" && action2.meta.type === "sfdc_messaging";
      };
      const shouldMinimizeHelpHub = (action2) => {
        if (action2.type === "nudge") {
          const nudge = getNudgeById(_, action2.value);
          if (nudge) {
            const step = getNudgeStep(nudge, 0);
            if (isCursorStep(nudge, step)) {
              return false;
            }
          }
        }
        if (action2.type === "execute_command") {
          const commandId = action2.meta.command;
          const command = _.commands.find((c) => c.id === parseInt(commandId));
          if ((command == null ? void 0 : command.template.type) === "helpdoc") {
            return false;
          } else if ((command == null ? void 0 : command.template.type) === "trigger" && command.template.value.type === "execute_command") {
            const nestedCommandId = command.template.value.meta.command;
            const nestedCommand = _.commands.find((c) => c.id === parseInt(nestedCommandId));
            if ((nestedCommand == null ? void 0 : nestedCommand.template.type) === "helpdoc") {
              return false;
            }
          }
        }
        return true;
      };
      const onExtraClick = (e) => {
        if (action) {
          if (preview) {
            switch (action.type) {
              case "execute_command":
                const commandId = action.meta.command;
                const command = _.commands.find((c) => c.id === parseInt(commandId));
                if (command) {
                  window.open(
                    `${"https://app.commandbar.com"}/editor${command.template.type === "link" ? PAGES_ROUTE : ACTIONS_ROUTE}/${command.id}`,
                    "_blank"
                  );
                }
                break;
              case "nudge":
                const nudge = getNudgeById(_, action.value);
                if (nudge) {
                  window.open(`/editor${getNudgeRoute(nudge)}/${nudge.id}`, "_blank");
                }
                break;
              case "questlist":
                const checklist3 = getChecklistById(_, action.value);
                if (checklist3) {
                  window.open(`/editor/checklists/${checklist3.id}`, "_blank");
                }
                break;
            }
          } else {
            Track.copilot.experienceClicked(chatState.chatID, action);
            helpHubChatActionClicked(chatState.chatID, action);
            const nativeCallback = getNativeCallback();
            if (window._cbIsWebView && nativeCallback) {
              nativeCallback(JSON.stringify(action));
            } else if (shouldContactSupport(action)) {
              chatState.contactSupport(action);
            } else if (shouldHandoffChat(action)) {
              chatState.handoff(action);
            } else {
              executeAction2(action, e, { chatHistory: chatState.chatHistory }, { type: "copilot" });
              if (shouldMinimizeHelpHub(action)) {
                setHelpHubMinimized2(true);
              }
            }
          }
        } else {
          props2.sendChat(buttonLabel);
        }
      };
      const useThemesV2 = preview && (previewOverrides == null ? void 0 : previewOverrides.useThemeV2) || ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]);
      switch (buttonType) {
        case "button_secondary":
          return useThemesV2 ? /* @__PURE__ */ React329.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "8px" } }, message && /* @__PURE__ */ React329.createElement(StyledChatMessage_default, { isBotMessage: true }, message), /* @__PURE__ */ React329.createElement(StyledSecondaryButton_default, { themeV2, disabled, onClick: onExtraClick, key: idx, textWrap: true }, buttonLabel)) : /* @__PURE__ */ React329.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "4px" } }, message, /* @__PURE__ */ React329.createElement(ActionButton_default, { variant: "secondary", disabled, onClick: onExtraClick, key: idx, preview }, buttonLabel));
        case "button_primary":
          return useThemesV2 ? /* @__PURE__ */ React329.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "8px" } }, message && /* @__PURE__ */ React329.createElement(StyledChatMessage_default, { isBotMessage: true }, message), /* @__PURE__ */ React329.createElement(StyledPrimaryButton_default, { themeV2, disabled, onClick: onExtraClick, key: idx, textWrap: true }, buttonLabel)) : /* @__PURE__ */ React329.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "4px" } }, message, /* @__PURE__ */ React329.createElement(ActionButton_default, { variant: "primary", disabled, onClick: onExtraClick, key: idx, preview }, buttonLabel));
      }
    };
    BotMessageAction_default = BotMessageAction;
  }
});

// commandbar/src/products/copilot/components/BotMessage/BotMessageFooter.tsx
import React330 from "react";
import { jsx as jsx130 } from "@emotion/core";
var Container20, ButtonContainer, LinksContainer, Link, LinkText, BotMessageFooter, BotMessageFooter_default;
var init_BotMessageFooter = __esm({
  "commandbar/src/products/copilot/components/BotMessage/BotMessageFooter.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_useStore();
    init_global_store();
    init_StyledInlineButton();
    init_ThemeV2Context();
    init_StyledIconContainer();
    init_react();
    init_router();
    init_useAction();
    init_command();
    init_service_selectors();
    init_location();
    init_track();
    init_useChatState();
    Container20 = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--layout-gap);
`;
    ButtonContainer = styled_browser_esm_default.div`
  position: relative;
  width: 100%;
  display: flex;
  gap: var(--layout-gap);
  justify-content: space-between;
  align-items: center;
`;
    LinksContainer = styled_browser_esm_default.div`
  display: flex;
  padding: var(--layout-padding);
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: var(--layout-radius-card);
  background: var(--background-primary);
`;
    Link = styled_browser_esm_default.button`
  display: flex;
  max-width: 100%;
  width: fit-content;
  height: var(--form-control-height);
  align-items: center;
  gap: 2px;
  border-radius: var(--layout-radius-button);
  border: none;
  background: none;
  cursor: pointer;

  color: var(--content-link);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  &:hover {
    color: var(--content-link-hover);
  }

  &:focus {
    box-shadow: 0px 0px 0px var(--form-control-focus-ring-width) var(--form-control-focus-ring-color);
  }

  &:focus-visible {
    outline: none;
  }
`;
    LinkText = styled_browser_esm_default.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: underline;
`;
    BotMessageFooter = (props2) => {
      var _a2, _b2;
      const { preview, message } = props2;
      const _ = !preview ? useStore() : emptyGlobalStore();
      const { flags } = _;
      const navigate = !preview ? (_a2 = useRouter()) == null ? void 0 : _a2.navigate : () => {
      };
      const themeV2 = useThemeV2Context();
      const chatState = useChatState();
      const [expanded, setExpanded] = React330.useState((_b2 = _.organization) == null ? void 0 : _b2.copilot_expand_read_more_by_default);
      const getURL = (source) => {
        const createHashAnchor = (heading) => {
          return heading.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "");
        };
        const url = source.command.template.type === "helpdoc" ? source.command.template.value : void 0;
        if (url && source.passage_heading) {
          return `${url}#${createHashAnchor(source.passage_heading)}`;
        }
        return url;
      };
      const setHubDocHeading = useAction((_2, heading) => {
        _2.helpHub.hubDocHeading = heading;
      });
      const handleSourceClick = (e, source) => {
        var _a3, _b3;
        const type39 = getContentType(source.command);
        if (preview) {
          if (type39) {
            let contentEditUrl = "";
            switch (type39) {
              case "source":
                contentEditUrl = `/content/sources/${(_a3 = source.command.integration) == null ? void 0 : _a3.id}/?id=${source.command.id}`;
                break;
              case "answer":
              case "file":
              case "video":
                contentEditUrl = `/content/${type39}s/?id=${source.command.id}`;
                break;
              default:
                break;
            }
            window.open(contentEditUrl, "_blank");
          }
          return;
        }
        const url = getURL(source);
        Track.copilot.sourceClicked(chatState.chatID, message.uuid || "", url || "");
        if (isCopilotOnlyMode(_) && !isStudioPreview() || !((_b3 = _.organization) == null ? void 0 : _b3.helphub_enabled)) {
          if (url) {
            if (source.command.template.operation === "router" && _.callbacks["commandbar-router"]) {
              _.callbacks["commandbar-router"](source.command.template.value);
            } else {
              window.open(url, "_blank");
            }
          } else
            switch (type39) {
              case "answer":
              case "file":
              case "video":
                navigate({ page: "docs", params: { docId: source.command.id } });
                break;
              default:
                break;
            }
          return;
        }
        if ((e.metaKey || e.ctrlKey || (flags == null ? void 0 : flags["switch-open-help-doc-in-new-tab"])) && url) {
          window.open(url, "_blank");
        } else {
          navigate({ page: "docs", params: { docId: source.command.id } });
          if (source.passage_heading && source.passage_heading !== source.command.text) {
            setHubDocHeading(source.passage_heading);
          }
        }
      };
      let usedCommands = [];
      const filteredSources = message.value.source_docs.filter((source) => {
        var _a3;
        if (usedCommands.includes(source.command.id)) {
          return false;
        }
        usedCommands = usedCommands.concat(source.command.id);
        return !source.command.training_only && !((_a3 = source.command.integration) == null ? void 0 : _a3.helphub_view_article_button_hidden);
      });
      return filteredSources.length === 0 ? null : /* @__PURE__ */ jsx130(Container20, null, /* @__PURE__ */ jsx130(ButtonContainer, null, /* @__PURE__ */ jsx130(StyledInlineButton_default, { themeV2, onClick: () => setExpanded((expanded2) => !expanded2) }, "Read more (", filteredSources.length, ")", expanded ? /* @__PURE__ */ jsx130(ChevronUp_default, null) : /* @__PURE__ */ jsx130(ChevronDown_default, null))), expanded && filteredSources.length > 0 && /* @__PURE__ */ jsx130(LinksContainer, null, filteredSources.map((source) => /* @__PURE__ */ jsx130(Link, { key: source.command.id, onClick: (e) => handleSourceClick(e, source) }, /* @__PURE__ */ jsx130(LinkText, null, source.command.text), /* @__PURE__ */ jsx130(StyledIconContainer_default, null, /* @__PURE__ */ jsx130(ArrowUpRight_default, null))))));
    };
    BotMessageFooter_default = BotMessageFooter;
  }
});

// commandbar/src/products/copilot/components/BotMessage/BotMessage.tsx
import { css as css75, jsx as jsx131 } from "@emotion/core";
import React331, { useEffect as useEffect69 } from "react";
import isEqual14 from "lodash/isEqual";
var BotMessage;
var init_BotMessage = __esm({
  "commandbar/src/products/copilot/components/BotMessage/BotMessage.tsx"() {
    "use strict";
    init_global_store();
    init_useStore();
    init_useDelayUnmount();
    init_useStyles();
    init_FeedbackButtons();
    init_Continuations();
    init_BotMessageText();
    init_colors();
    init_actions();
    init_StyledChatContent();
    init_BotMessageAction();
    init_BotMessageFooter();
    init_StyledChatMessage();
    BotMessage = (props2) => {
      var _a2, _b2, _c2;
      const {
        preview,
        isFirstMessage,
        isLastMessage,
        message,
        previousContinuations,
        isChatHistoryPreview,
        isFinishedStreaming,
        onFinishStreaming,
        previewOverrides
      } = props2;
      const _ = !preview ? useStore() : emptyGlobalStore();
      const styles51 = useStyles(preview);
      const isLoading = message.incomplete;
      const searchSuggestions = _.helpHub.searchSuggestions;
      const defaultInitialContinuations = !searchSuggestions.loading ? searchSuggestions.continuations : [];
      const continuations = isFirstMessage ? defaultInitialContinuations : (message.continuations || []).filter((continuation) => !previousContinuations.has(continuation));
      const unmounted = React331.useRef(false);
      useEffect69(() => {
        return () => {
          unmounted.current = true;
        };
      }, []);
      const isAnswerBlankString = React331.useMemo(() => {
        var _a3;
        const strippedAnswer = ((_a3 = message.value.answer) == null ? void 0 : _a3.replace(/<\/?[^>]+(>|$)/g, "").replace(/[\n\r]/g, "").trim()) || "";
        return strippedAnswer.length === 0;
      }, [message.value.answer]);
      const showActionsOnly = (message == null ? void 0 : message.no_answer) && (isLoading || message.extras.length > 0);
      const showFallbackCTA = (message == null ? void 0 : message.no_answer) && message.extras.length === 0;
      const showTextAnswer = !isAnswerBlankString && !showActionsOnly;
      const finishedDisplayingTextAnswer = !isLoading && isFinishedStreaming;
      if (!isLoading && isAnswerBlankString) {
        onFinishStreaming();
      }
      const hasTextReplyButton = message.extras.some((extra) => !extra.action);
      const showFeedbackButtons = !isFirstMessage && !hasTextReplyButton && finishedDisplayingTextAnswer;
      const textAnswerActions = message.value.source_docs.map((doc) => doc == null ? void 0 : doc.command.next_steps).flatMap((next_steps) => next_steps).filter((next_step) => isAction(next_step) && next_step.cta);
      const messageExtrasToDisplay = message.extras.filter((extra) => {
        const extraInTextAnswerActions = textAnswerActions.some(
          (answerAction) => isAction(answerAction) && isEqual14(answerAction.action, extra.action)
        );
        const shouldShowButton = extra.action || isLastMessage;
        return shouldShowButton && !extraInTextAnswerActions;
      });
      return preview && (previewOverrides == null ? void 0 : previewOverrides.useThemeV2) || ((_a2 = _.flags) == null ? void 0 : _a2["release-themes-v2"]) ? /* @__PURE__ */ jsx131(StyledChatContent_default, { isLoading: !finishedDisplayingTextAnswer, isBotMessage: true }, /* @__PURE__ */ jsx131(
        AnimationTransition,
        {
          entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
          isMounted: isLoading && !showTextAnswer
        },
        /* @__PURE__ */ jsx131(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "row",
              gap: "8px",
              padding: "8px 0px",
              justifyContent: "center",
              alignItems: "center",
              height: "40px"
            }
          },
          Array.from({ length: 3 }).map((_2, index3) => /* @__PURE__ */ jsx131(
            "div",
            {
              key: index3,
              css: css75`
                animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;

                @keyframes pulse {
                  0%,
                  100% {
                    opacity: 1;
                  }
                  50% {
                    opacity: 0.5;
                  }
                }
              `,
              style: {
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: CB_COLORS.neutral600,
                animationDelay: `${index3 * 0.25}s`
              }
            }
          ))
        )
      ), /* @__PURE__ */ jsx131(
        StyledChatMessage_default,
        {
          isBotMessage: true,
          timestamp: finishedDisplayingTextAnswer ? message.modified : void 0,
          isMounted: showTextAnswer
        },
        /* @__PURE__ */ jsx131(
          BotMessageText,
          {
            preview,
            isLoading,
            isFinishedStreaming,
            onFinishStreaming,
            answer: message.value.answer,
            messageId: (_b2 = message.uuid) != null ? _b2 : "",
            previewOverrides
          }
        ),
        message.value.source_docs.length > 0 && finishedDisplayingTextAnswer && /* @__PURE__ */ jsx131(BotMessageFooter_default, { preview, message }),
        showFeedbackButtons && /* @__PURE__ */ jsx131(
          FeedbackButtons_default,
          {
            preview,
            isChatHistoryPreview,
            message,
            previewOverrides
          }
        )
      ), /* @__PURE__ */ jsx131(
        AnimationTransition,
        {
          style: { display: "flex", flexDirection: "column", gap: "var(--layout-gap)", width: "100%" },
          entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
          isMounted: finishedDisplayingTextAnswer && (message.fallback_labeled_actions.length > 0 || textAnswerActions.length > 0 || messageExtrasToDisplay.length > 0)
        },
        showFallbackCTA && message.fallback_labeled_actions.map((fallbackAction, idx) => /* @__PURE__ */ jsx131(
          BotMessageAction_default,
          {
            key: idx,
            idx,
            action: fallbackAction.action,
            buttonLabel: fallbackAction.cta,
            sendChat: props2.sendChat,
            preview,
            isChatHistoryPreview,
            previewOverrides
          }
        )),
        textAnswerActions.map((answerCTA, idx) => {
          if (!isAction(answerCTA) || !answerCTA.cta)
            return null;
          return /* @__PURE__ */ jsx131(
            BotMessageAction_default,
            {
              key: idx,
              idx,
              action: answerCTA.action,
              buttonLabel: answerCTA.cta,
              sendChat: props2.sendChat,
              preview,
              isChatHistoryPreview,
              previewOverrides
            }
          );
        }),
        messageExtrasToDisplay.map((extra, idx) => /* @__PURE__ */ jsx131(
          BotMessageAction_default,
          {
            key: idx,
            idx,
            action: extra.action,
            buttonLabel: extra.text,
            buttonType: extra.type,
            message: extra.message,
            sendChat: props2.sendChat,
            preview,
            isChatHistoryPreview,
            previewOverrides
          }
        ))
      )) : /* @__PURE__ */ jsx131(
        "div",
        {
          style: {
            maxWidth: "100%",
            minWidth: 0,
            display: "flex",
            flexDirection: "column",
            ...isLoading && { minHeight: 200 }
          }
        },
        /* @__PURE__ */ jsx131("div", { css: [styles51.feedBackButtonsParent[preview ? "preview" : "regular"]] }, /* @__PURE__ */ jsx131(
          AnimationTransition,
          {
            entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
            isMounted: isLoading && !showTextAnswer
          },
          /* @__PURE__ */ jsx131("div", { style: { display: "flex", flexDirection: "row", gap: "8px", padding: "8px 0px" } }, Array.from({ length: 3 }).map((_2, index3) => /* @__PURE__ */ jsx131(
            "div",
            {
              key: index3,
              css: css75`
                  animation: pulse 1.5s cubic-bezier(0.4, 0, 0.6, 1) infinite;

                  @keyframes pulse {
                    0%,
                    100% {
                      opacity: 1;
                    }
                    50% {
                      opacity: 0.5;
                    }
                  }
                `,
              style: {
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: CB_COLORS.neutral600,
                animationDelay: `${index3 * 0.25}s`
              }
            }
          )))
        ), /* @__PURE__ */ jsx131(
          AnimationTransition,
          {
            style: { display: "flex", flexDirection: "column", gap: "8px", width: "100%" },
            entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
            isMounted: showTextAnswer || message.fallback_labeled_actions.length > 0 || textAnswerActions.length > 0 || messageExtrasToDisplay.length > 0
          },
          showTextAnswer && /* @__PURE__ */ jsx131(
            BotMessageText,
            {
              preview,
              isLoading,
              isFinishedStreaming,
              onFinishStreaming,
              answer: message.value.answer,
              messageId: (_c2 = message.uuid) != null ? _c2 : ""
            }
          ),
          finishedDisplayingTextAnswer && showFallbackCTA && message.fallback_labeled_actions.map((fallbackAction, idx) => /* @__PURE__ */ jsx131(
            BotMessageAction_default,
            {
              key: idx,
              idx,
              action: fallbackAction.action,
              buttonLabel: fallbackAction.cta,
              sendChat: props2.sendChat,
              preview,
              isChatHistoryPreview,
              previewOverrides
            }
          )),
          finishedDisplayingTextAnswer && textAnswerActions.map((answerCTA, idx) => {
            if (!isAction(answerCTA) || !answerCTA.cta)
              return null;
            return /* @__PURE__ */ jsx131(
              BotMessageAction_default,
              {
                key: idx,
                idx,
                action: answerCTA.action,
                buttonLabel: answerCTA.cta,
                sendChat: props2.sendChat,
                preview,
                isChatHistoryPreview,
                previewOverrides
              }
            );
          }),
          finishedDisplayingTextAnswer && messageExtrasToDisplay.map((extra, idx) => /* @__PURE__ */ jsx131(
            BotMessageAction_default,
            {
              key: idx,
              idx,
              action: extra.action,
              buttonLabel: extra.text,
              buttonType: extra.type,
              message: extra.message,
              sendChat: props2.sendChat,
              preview,
              isChatHistoryPreview,
              previewOverrides
            }
          ))
        ), /* @__PURE__ */ jsx131(
          AnimationTransition,
          {
            style: { width: "100%", marginTop: "12px" },
            entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
            isMounted: message.value.source_docs.length > 0 && showTextAnswer
          },
          /* @__PURE__ */ jsx131(BotMessageFooter_default, { preview, message })
        ), /* @__PURE__ */ jsx131(
          AnimationTransition,
          {
            entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
            isMounted: !isChatHistoryPreview && finishedDisplayingTextAnswer && continuations.length > 0 && isLastMessage
          },
          /* @__PURE__ */ jsx131(Continuations, { preview, continuations })
        ), showFeedbackButtons && /* @__PURE__ */ jsx131(FeedbackButtons_default, { preview, isChatHistoryPreview, message }))
      );
    };
  }
});

// internal/src/client/themesV2/components/copilot/StyledBotChatMessageContainer.tsx
import React332 from "react";
var Container21, StyledBotChatMessageContainer, StyledBotChatMessageContainer_default;
var init_StyledBotChatMessageContainer = __esm({
  "internal/src/client/themesV2/components/copilot/StyledBotChatMessageContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container21 = styled_browser_esm_default.div`
  width: 100%;
  display: flex;
  padding: var(--layout-padding);
  gap: var(--layout-gap);
`;
    StyledBotChatMessageContainer = ({ children, ...props2 }) => {
      return /* @__PURE__ */ React332.createElement(Container21, { ...props2 }, children);
    };
    StyledBotChatMessageContainer_default = StyledBotChatMessageContainer;
  }
});

// commandbar/src/products/copilot/components/AgentAvatar.tsx
import React333 from "react";
var AgentAvatar, AgentAvatar_default;
var init_AgentAvatar = __esm({
  "commandbar/src/products/copilot/components/AgentAvatar.tsx"() {
    "use strict";
    AgentAvatar = ({ initials }) => /* @__PURE__ */ React333.createElement(
      "div",
      {
        style: {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "40px",
          height: "40px",
          borderRadius: "var(--form-control-radius, 6px)",
          padding: "6px 12px",
          backgroundColor: "var(--base-accent)",
          color: "var(--button-primary-content, #FFF)",
          textAlign: "center",
          fontSize: "14px",
          fontWeight: 600,
          lineHeight: "21px"
        }
      },
      initials
    );
    AgentAvatar_default = AgentAvatar;
  }
});

// internal/src/client/themesV2/components/copilot/StyledCopilotAttachmentMessage.tsx
import React334 from "react";
import { jsx as jsx132 } from "@emotion/core";
var Container22, TextContainer3, Title6, Subtitle3, StyledImage, StyledCopilotAttachmentMessage, StyledCopilotAttachmentMessage_default;
var init_StyledCopilotAttachmentMessage = __esm({
  "internal/src/client/themesV2/components/copilot/StyledCopilotAttachmentMessage.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledImageDialog();
    Container22 = styled_browser_esm_default.div`
  display: flex;
  align-self: stretch;
  width: 100%;
  overflow: hidden;
  align-items: center;
  padding: var(--layout-padding);
  gap: var(--layout-gap);
  border-radius: var(--layout-radius-card);
  background: var(--background-primary);
`;
    TextContainer3 = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
`;
    Title6 = styled_browser_esm_default.div`
  /* label/base/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);

  overflow: hidden;
  text-overflow: ellipsis;
`;
    Subtitle3 = styled_browser_esm_default.div`
  color: var(--content-secondary);

  /* label/sm/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  overflow: hidden;
  text-overflow: ellipsis;
`;
    StyledImage = styled_browser_esm_default.img`
  cursor: pointer;
  border-radius: var(--layout-radius-button);
  height: 32px;
  width: 32px;
`;
    StyledCopilotAttachmentMessage = ({ themeV2, attachment }) => {
      const [showModal, setShowModal] = React334.useState(false);
      return /* @__PURE__ */ jsx132(Container22, null, /* @__PURE__ */ jsx132(StyledImage, { onClick: () => setShowModal(true), src: attachment.media_preview_url }), /* @__PURE__ */ jsx132(TextContainer3, null, /* @__PURE__ */ jsx132(Title6, null, attachment.title), /* @__PURE__ */ jsx132(Subtitle3, null, attachment.description)), /* @__PURE__ */ jsx132(
        StyledImageDialog_default,
        {
          themeV2,
          src: attachment.media_preview_url,
          visible: showModal,
          onClose: () => setShowModal(false)
        }
      ));
    };
    StyledCopilotAttachmentMessage_default = StyledCopilotAttachmentMessage;
  }
});

// commandbar/src/products/copilot/components/ChatMessage.tsx
import React335 from "react";
import { jsx as jsx133 } from "@emotion/core";
var ChatMessage;
var init_ChatMessage = __esm({
  "commandbar/src/products/copilot/components/ChatMessage.tsx"() {
    "use strict";
    init_useTheme();
    init_BotMessage();
    init_colors();
    init_BotAvatar();
    init_Icon2();
    init_useDelayUnmount();
    init_useStore();
    init_StyledChatMessage();
    init_StyledChatContent();
    init_StyledBotChatMessageContainer();
    init_global_store();
    init_AgentAvatar();
    init_StyledCopilotAttachmentMessage();
    init_ThemeV2Context();
    ChatMessage = React335.forwardRef((props2, ref12) => {
      const {
        message,
        history = [],
        isFirstMessage,
        isLastMessage,
        preview,
        isChatHistoryPreview,
        isFinishedStreaming,
        onFinishStreaming,
        previewOverrides
      } = props2;
      const { helpHub, organization, flags } = !preview ? useStore() : emptyGlobalStore();
      const previouslyAskedQuestions = isLastMessage ? new Set(
        history.slice(0, history.length - 1).flatMap((item) => item.message_type === "USER" ? [item.value.question] : [])
      ) : /* @__PURE__ */ new Set();
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const isUserMessage = message.message_type === "USER";
      const isAgentMessage = message.message_type === "AGENT";
      const renderAvatar = () => {
        var _a2;
        if (isUserMessage) {
          return /* @__PURE__ */ jsx133("div", { style: { width: "40px", height: "40px", flexShrink: 0 } });
        }
        if (isAgentMessage) {
          const getInitials = (name) => {
            const parts = name.trim().split(" ");
            if (parts.length === 1) {
              return parts[0][0].toUpperCase();
            }
            if (parts.length >= 2) {
              const initials = parts[0][0] + parts[1][0];
              return initials.toUpperCase();
            }
            return name[0];
          };
          return /* @__PURE__ */ jsx133(AgentAvatar_default, { initials: getInitials(message.author) });
        }
        const customAvatar = preview ? previewOverrides == null ? void 0 : previewOverrides.customAvatar : helpHub.previewedCopilotSettings !== null ? helpHub.previewedCopilotSettings.avatar : (organization == null ? void 0 : organization.copilot_avatar) || ((_a2 = organization == null ? void 0 : organization.copilot_avatar_v2) == null ? void 0 : _a2.src);
        if (customAvatar) {
          return /* @__PURE__ */ jsx133(
            Icon_default2,
            {
              icon: customAvatar,
              size: "40px",
              style: { width: "40px", height: "40px", flexShrink: 0 },
              useDefaultSVGColor: true
            }
          );
        }
        return /* @__PURE__ */ jsx133(BotAvatar_default, null);
      };
      return preview && (previewOverrides == null ? void 0 : previewOverrides.useThemeV2) || (flags == null ? void 0 : flags["release-themes-v2"]) ? isUserMessage ? /* @__PURE__ */ jsx133(
        AnimationTransition,
        {
          entry: isLastMessage ? { keyframes: builtinKeyframes.fadeInSlideDownExpand, durationMs: 300 } : void 0,
          isMounted: true,
          style: {
            display: "flex",
            justifyContent: "end",
            padding: "var(--layout-padding)",
            ...isFirstMessage && {
              marginTop: "4px"
              // this is to allow the top message timestamp to show up!
            }
          }
        },
        /* @__PURE__ */ jsx133(StyledChatContent_default, { ref: ref12 }, /* @__PURE__ */ jsx133(StyledChatMessage_default, { timestamp: message.modified }, /* @__PURE__ */ jsx133("span", null, message.value.question), message.value.attachments.length > 0 && /* @__PURE__ */ jsx133(StyledCopilotAttachmentMessage_default, { themeV2, attachment: message.value.attachments[0] })))
      ) : /* @__PURE__ */ jsx133(
        StyledBotChatMessageContainer_default,
        {
          style: {
            ...isFirstMessage && {
              marginTop: "4px"
              // this is to allow the top message timestamp to show up!
            },
            ...message.message_type === "AI" && isLastMessage && {
              paddingBottom: "calc(var(--form-control-height)/2 + var(--form-control-focus-ring-width))"
              // this is to allow the feedback buttons on the last bot message to have room for the focus ring
            }
          }
        },
        renderAvatar(),
        message.message_type === "AI" ? /* @__PURE__ */ jsx133(
          BotMessage,
          {
            preview,
            isFirstMessage,
            isLastMessage,
            previousContinuations: previouslyAskedQuestions,
            message,
            sendChat: props2.sendChat,
            isChatHistoryPreview,
            isFinishedStreaming,
            onFinishStreaming,
            previewOverrides
          }
        ) : message.message_type === "AGENT" ? /* @__PURE__ */ jsx133(StyledChatContent_default, { isBotMessage: true }, /* @__PURE__ */ jsx133(StyledChatMessage_default, { isBotMessage: true, timestamp: message.modified }, /* @__PURE__ */ jsx133("span", null, message.value.content), message.value.attachments.length > 0 && /* @__PURE__ */ jsx133(StyledCopilotAttachmentMessage_default, { themeV2, attachment: message.value.attachments[0] }))) : null
      ) : /* @__PURE__ */ jsx133(
        AnimationTransition,
        {
          entry: isFirstMessage ? { keyframes: builtinKeyframes.slideUp(17), durationMs: 300 } : { keyframes: builtinKeyframes.fadeInSlideDown, durationMs: 300 },
          isMounted: true
        },
        /* @__PURE__ */ jsx133(
          "div",
          {
            style: {
              display: "flex",
              flexDirection: "row",
              padding: "16px",
              gap: "16px",
              backgroundColor: isUserMessage ? CB_COLORS.neutral0 : void 0,
              color: CB_COLORS.neutral800
            }
          },
          renderAvatar(),
          /* @__PURE__ */ jsx133(
            "div",
            {
              style: {
                flexGrow: 1,
                minWidth: 0,
                paddingTop: "8px",
                fontSize: "16px",
                lineHeight: "24px",
                fontWeight: 500,
                fontFamily: theme.helpHub.fontFamily,
                fontStyle: "normal"
              }
            },
            isUserMessage ? message.value.attachments.length > 0 && preview ? (
              // TODO: eventually we want to render our copilot preview using our actual styles,
              // so if a user is on themesV2,the preview should reflect that.  in the meantime
              // this is just to render these attachments in the Copilot analytics preview,
              // so should be okay if it doesn't totally match the other copilot styles
              /* @__PURE__ */ jsx133("div", { ref: ref12 }, /* @__PURE__ */ jsx133("span", null, message.value.question), /* @__PURE__ */ jsx133(StyledCopilotAttachmentMessage_default, { themeV2, attachment: message.value.attachments[0] }))
            ) : /* @__PURE__ */ jsx133("div", { ref: ref12 }, message.value.question) : message.message_type === "AI" ? /* @__PURE__ */ jsx133(
              BotMessage,
              {
                preview,
                isFirstMessage,
                isLastMessage,
                previousContinuations: previouslyAskedQuestions,
                message,
                sendChat: props2.sendChat,
                isChatHistoryPreview,
                isFinishedStreaming,
                onFinishStreaming,
                previewOverrides
              }
            ) : message.message_type === "AGENT" ? message.value.attachments.length > 0 && preview ? (
              // TODO: eventually we want to render our copilot preview using our actual styles,
              // so if a user is on themesV2,the preview should reflect that.  in the meantime
              // this is just to render these attachments in the Copilot analytics preview,
              // so should be okay if it doesn't totally match the other copilot styles
              /* @__PURE__ */ jsx133("div", null, /* @__PURE__ */ jsx133("span", null, message.value.content), /* @__PURE__ */ jsx133(StyledCopilotAttachmentMessage_default, { themeV2, attachment: message.value.attachments[0] }))
            ) : /* @__PURE__ */ jsx133("div", null, message.value.content) : null
          )
        )
      );
    });
  }
});

// internal/src/client/themesV2/components/copilot/StyledCopilotInputButtons.tsx
var StyledInputButtons2, StyledCopilotInputButtons_default;
var init_StyledCopilotInputButtons = __esm({
  "internal/src/client/themesV2/components/copilot/StyledCopilotInputButtons.tsx"() {
    "use strict";
    init_styled_browser_esm();
    StyledInputButtons2 = styled_browser_esm_default.div`
  position: absolute;
  right: calc(var(--form-control-padding-x) + var(--layout-padding));
  bottom: calc(min(var(--form-control-height) / 2, var(--form-control-padding-x)) + var(--layout-padding));
  display: flex;
  align-items: flex-start;
`;
    StyledCopilotInputButtons_default = StyledInputButtons2;
  }
});

// internal/src/client/themesV2/components/copilot/StyledCopilotAttachment.tsx
import React336, { forwardRef as forwardRef13 } from "react";
var InsetContainer, StyledImage2, StyledCopilotAttachment, StyledCopilotAttachment_default;
var init_StyledCopilotAttachment = __esm({
  "internal/src/client/themesV2/components/copilot/StyledCopilotAttachment.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_StyledSecondaryIconButton();
    InsetContainer = styled_browser_esm_default.div`
  position: absolute;
  left: calc(var(--form-control-padding-x) + var(--layout-padding));
  top: calc(min(var(--form-control-height) / 2, var(--form-control-padding-x)) + var(--layout-padding));
`;
    StyledImage2 = styled_browser_esm_default.img`
  border-radius: var(--layout-radius-button);
  height: 48px;
  width: 48px;
`;
    StyledCopilotAttachment = forwardRef13(
      ({ themeV2, attachment, onDelete }, ref12) => attachment ? /* @__PURE__ */ React336.createElement(InsetContainer, { ref: ref12 }, /* @__PURE__ */ React336.createElement("div", { style: { position: "relative" } }, /* @__PURE__ */ React336.createElement(StyledImage2, { src: attachment }), /* @__PURE__ */ React336.createElement(
        StyledSecondaryIconButton_default,
        {
          themeV2,
          style: {
            position: "absolute",
            right: "-4px",
            top: "-4px",
            width: "20px",
            height: "20px",
            borderRadius: "100px"
          },
          onClick: onDelete
        },
        /* @__PURE__ */ React336.createElement(XClose_default, { height: "12px", width: "12px" })
      ))) : null
    );
    StyledCopilotAttachment_default = StyledCopilotAttachment;
  }
});

// commandbar/src/products/copilot/components/MessageInput.tsx
import { css as css76, jsx as jsx134 } from "@emotion/core";
import React337, { useRef as useRef46, useEffect as useEffect70, useState as useState45 } from "react";
import { BsStopCircleFill } from "react-icons/bs";
var MessageInput, MessageInput_default;
var init_MessageInput = __esm({
  "commandbar/src/products/copilot/components/MessageInput.tsx"() {
    "use strict";
    init_LoadingIndicator();
    init_useStyles();
    init_react();
    init_colors();
    init_StyledInputContainer();
    init_StyledCopilotInputButtons();
    init_StyledTertiaryIconButton();
    init_useStore();
    init_StyledTextArea();
    init_global_store();
    init_ThemeV2Context();
    init_Interpolate();
    init_network();
    init_Logger();
    init_StyledCopilotAttachment();
    init_useChatState();
    init_StyledSecondaryIconButton();
    init_chat();
    init_useResizeObserver2();
    MessageInput = React337.forwardRef((props2, ref12) => {
      var _a2, _b2;
      const { preview, isLoading, onSubmit, isChatHistoryPreview, streamingBotMessage, previewOverrides } = props2;
      const { chatID } = useChatState();
      const styles51 = useStyles(preview);
      const chatInput = useRef46(null);
      const attachmentUploader = useRef46(null);
      const [attachment, setAttachment] = React337.useState();
      const [attachmentURL, setAttachmentURL] = React337.useState();
      const [query, setQuery] = React337.useState("");
      const _ = !preview ? useStore() : emptyGlobalStore();
      const themeV2 = useThemeV2Context();
      const { ref: inputButtonsRef, width: inputButtonsWidth } = useResizeObserver2_default();
      const { ref: attachmentRef, height: attachmentHeight } = useResizeObserver2_default();
      useEffect70(() => {
        var _a3;
        if (!_.helpHub.previewedCopilotSettings) {
          (_a3 = chatInput.current) == null ? void 0 : _a3.focus();
        }
      }, []);
      useEffect70(() => {
        const uploadImage = async (image) => {
          try {
            const formData = new FormData();
            formData.append("attachment", image);
            const response2 = await post(`ml/chats/${chatID}/upload`, formData);
            const url = response2.data.object_url;
            setAttachmentURL(url);
            if (chatInput.current) {
              chatInput.current.focus();
              chatInput.current.style.height = `calc(${chatInput.current.style.height} + 48px)`;
            }
          } catch (error3) {
            Logger_default.error("Attachment upload failed", error3);
            setAttachment(void 0);
          }
        };
        if (attachment) {
          uploadImage(attachment);
        } else {
          setAttachmentURL(void 0);
        }
      }, [attachment]);
      const handleSubmit = () => {
        onSubmit(
          query,
          attachmentURL ? [{ type: "image_url", media_preview_url: attachmentURL, title: "Photo", description: attachment == null ? void 0 : attachment.name }] : void 0
        );
        setQuery("");
        setAttachment(void 0);
        if (chatInput.current) {
          chatInput.current.style.height = "unset";
          chatInput.current.focus();
        }
      };
      const handleStopAnswerGeneration = () => {
        if (streamingBotMessage && streamingBotMessage.uuid) {
          Chat.abortAnswerGeneration(chatID, streamingBotMessage.uuid);
        }
      };
      const [shouldSubmitAfterAbort, setShouldSubmitAfterAbort] = useState45(false);
      useEffect70(() => {
        const waitUntilNotLoading = async () => {
          if (shouldSubmitAfterAbort && !isLoading) {
            handleSubmit();
            setShouldSubmitAfterAbort(false);
          }
        };
        waitUntilNotLoading();
      }, [isLoading, shouldSubmitAfterAbort]);
      const showAttachmentUploader = ((_a2 = _.flags) == null ? void 0 : _a2["release-copilot-attachments"]) && !attachment;
      const disabled = preview || isChatHistoryPreview;
      return preview && (previewOverrides == null ? void 0 : previewOverrides.useThemeV2) || ((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? /* @__PURE__ */ jsx134(StyledInputContainer_default, { ref: ref12 }, /* @__PURE__ */ jsx134(
        StyledTextArea_default,
        {
          themeV2,
          style: {
            paddingRight: (inputButtonsWidth != null ? inputButtonsWidth : 0) + 8,
            paddingTop: `calc(${attachmentHeight != null ? attachmentHeight : "0"}px + var(--form-control-padding-x) + var(--form-control-height) / 2 - 12px)`,
            maxHeight: "192px",
            cursor: disabled ? "not-allowed" : "auto",
            minHeight: "calc(var(--form-control-height) + 2 * var(--form-control-padding-x))"
          },
          rows: 1,
          inputMode: "search",
          disabled,
          value: query != null ? query : "",
          onKeyDown: (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              if (!!query.trim().length) {
                if (isLoading) {
                  handleStopAnswerGeneration();
                }
                setShouldSubmitAfterAbort(true);
              }
            }
          },
          onChange: (e) => {
            setQuery(e.currentTarget.value);
            e.currentTarget.style.height = "1px";
            e.currentTarget.style.height = e.currentTarget.scrollHeight + 2 + "px";
          },
          "data-testid": "helphub-input",
          placeholder: preview ? previewOverrides == null ? void 0 : previewOverrides.messageInputPlaceholder : interpolate(_.localizedMessages["copilot.chat-input-placeholder"], _, true, false),
          ref: chatInput
        }
      ), /* @__PURE__ */ jsx134(
        StyledCopilotAttachment_default,
        {
          themeV2,
          attachment: attachmentURL,
          onDelete: () => {
            setAttachment(void 0);
            if (chatInput.current) {
              chatInput.current.style.height = "1px";
              chatInput.current.style.height = chatInput.current.scrollHeight + 2 - (attachmentHeight != null ? attachmentHeight : 0) + "px";
            }
          },
          ref: attachmentRef
        }
      ), /* @__PURE__ */ jsx134(StyledCopilotInputButtons_default, { ref: inputButtonsRef }, showAttachmentUploader && /* @__PURE__ */ jsx134(
        StyledTertiaryIconButton_default,
        {
          themeV2,
          disabled,
          onClick: () => {
            var _a3;
            return (_a3 = attachmentUploader.current) == null ? void 0 : _a3.click();
          }
        },
        /* @__PURE__ */ jsx134(Attachment01_default, { style: { transform: "rotate(-45deg)" } }),
        /* @__PURE__ */ jsx134(
          "input",
          {
            type: "file",
            accept: "image/png, image/jpg, image/jpeg",
            ref: attachmentUploader,
            onChange: (e) => {
              var _a3;
              return setAttachment((_a3 = e.target.files) == null ? void 0 : _a3[0]);
            },
            style: { display: "none" }
          }
        )
      ), !isLoading && /* @__PURE__ */ jsx134(
        StyledTertiaryIconButton_default,
        {
          themeV2,
          disabled: disabled || !query.trim().length,
          style: { ...!query.trim().length && { opacity: "0.6" } },
          onClick: handleSubmit
        },
        /* @__PURE__ */ jsx134(Send03_default, null)
      ), isLoading && /* @__PURE__ */ jsx134(StyledSecondaryIconButton_default, { themeV2, disabled, onClick: handleStopAnswerGeneration }, /* @__PURE__ */ jsx134(BsStopCircleFill, null)))) : /* @__PURE__ */ jsx134("div", { css: styles51.chatTextAreaContainer }, /* @__PURE__ */ jsx134("div", { style: styles51.chatTextAreaWrapper }, /* @__PURE__ */ jsx134(
        "textarea",
        {
          inputMode: "search",
          disabled,
          suppressContentEditableWarning: true,
          ref: chatInput,
          placeholder: interpolate(styles51.strings.chatInputPlaceholder, _, true, false),
          onKeyDown: (e) => {
            if (e.key === "Enter" && !isLoading && !!query.trim().length) {
              e.preventDefault();
              handleSubmit();
            }
          },
          onChange: (e) => {
            setQuery(e.currentTarget.value);
            e.currentTarget.style.height = e.currentTarget.scrollHeight + "px";
          },
          css: styles51.chatTextArea,
          rows: 1,
          value: query != null ? query : ""
        }
      ), /* @__PURE__ */ jsx134(
        "div",
        {
          style: {
            display: "flex",
            position: "absolute",
            top: "8px",
            right: "8px"
          },
          css: css76`
            & button {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 32px;
              height: 32px;
              background: none;
              border: none;
              color: ${CB_COLORS.neutral600};
              cursor: pointer;
            }
          `
        },
        /* @__PURE__ */ jsx134("button", { disabled, onClick: () => props2.resetChat() }, /* @__PURE__ */ jsx134(RefreshCw01_default, { width: 16, height: 16 })),
        isLoading ? /* @__PURE__ */ jsx134(
          "div",
          {
            style: { width: "32px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }
          },
          /* @__PURE__ */ jsx134(LoadingIndicator_default, { size: 16, isLoading: true })
        ) : /* @__PURE__ */ jsx134(
          "button",
          {
            disabled,
            onClick: () => {
              if (query && !!query.trim().length) {
                handleSubmit();
              }
            }
          },
          /* @__PURE__ */ jsx134(
            Send03_default,
            {
              width: 16,
              height: 16,
              style: {
                ...!query.length && { opacity: "0.6" }
              }
            }
          )
        )
      )));
    });
    MessageInput_default = MessageInput;
  }
});

// internal/src/client/themesV2/components/copilot/StyledCopilotHeader.tsx
import React338 from "react";
var Header6, StyledCopilotHeader, StyledCopilotHeader_default;
var init_StyledCopilotHeader = __esm({
  "internal/src/client/themesV2/components/copilot/StyledCopilotHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Header6 = styled_browser_esm_default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0px;

  color: var(--content-primary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    StyledCopilotHeader = ({ children }) => {
      return /* @__PURE__ */ React338.createElement(Header6, null, children);
    };
    StyledCopilotHeader_default = StyledCopilotHeader;
  }
});

// internal/src/client/themesV2/components/copilot/StyledChatScrollContainer.tsx
import React339 from "react";
var Container23, StyledChatScrollContainer, StyledChatScrollContainer_default;
var init_StyledChatScrollContainer = __esm({
  "internal/src/client/themesV2/components/copilot/StyledChatScrollContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container23 = styled_browser_esm_default.div`
  overflow: auto;
  overscroll-behavior-y: contain;
  flex: 1;
  width: 100%;
`;
    StyledChatScrollContainer = React339.forwardRef(
      ({ children, ...props2 }, ref12) => {
        return /* @__PURE__ */ React339.createElement(Container23, { ref: ref12, ...props2 }, children);
      }
    );
    StyledChatScrollContainer_default = StyledChatScrollContainer;
  }
});

// internal/src/client/themesV2/components/shared/StyledDropdownMenu.tsx
import React340 from "react";
var Container24, StyledDropdownMenu, StyledDropdownMenu_default;
var init_StyledDropdownMenu = __esm({
  "internal/src/client/themesV2/components/shared/StyledDropdownMenu.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container24 = styled_browser_esm_default.div`
  position: absolute;
  top: calc(var(--form-control-height) + var(--form-control-gap));
  right: 0px;
  display: flex;
  width: 220px;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  border-radius: var(--layout-radius-button);
  border: 1px solid var(--border-primary);
  background: var(--background-primary);
  box-shadow: var(--layout-shadow) var(--layout-shadow-color);
  z-index: 1;
`;
    StyledDropdownMenu = React340.forwardRef(
      ({ children, ...props2 }, ref12) => /* @__PURE__ */ React340.createElement(Container24, { ref: ref12, ...props2 }, children)
    );
    StyledDropdownMenu_default = StyledDropdownMenu;
  }
});

// internal/src/client/themesV2/components/shared/StyledDropdownMenuItem.tsx
import React341 from "react";
var Item, StyledDropdownMenuItem, StyledDropdownMenuItem_default;
var init_StyledDropdownMenuItem = __esm({
  "internal/src/client/themesV2/components/shared/StyledDropdownMenuItem.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Item = styled_browser_esm_default.button`
  display: flex;
  height: var(--form-control-height);
  padding: 0px var(--form-control-padding-x);
  align-items: center;
  gap: var(--form-control-gap);
  align-self: stretch;
  border-radius: var(--layout-radius-button);
  border: none;
  cursor: pointer;

  background: var(--button-secondary-background);
  color: var(--content-secondary);

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);

  &:hover {
    color: var(--content-primary);
    background: var(--background-primary-hover);
  }

  &:focus {
    color: var(--content-primary);
    background: var(--background-primary-hover);
  }

  &:focus-visible {
    outline: none;
  }
`;
    StyledDropdownMenuItem = ({ children, ...props2 }) => /* @__PURE__ */ React341.createElement(Item, { ...props2 }, children);
    StyledDropdownMenuItem_default = StyledDropdownMenuItem;
  }
});

// commandbar/src/products/helphub/components/ChatFooterCTA.tsx
import { jsx as jsx135 } from "@emotion/core";
var ChatFooterCTA, ChatFooterCTA_default;
var init_ChatFooterCTA = __esm({
  "commandbar/src/products/helphub/components/ChatFooterCTA.tsx"() {
    "use strict";
    init_StyledPrimaryButton();
    init_ThemeV2Context();
    ChatFooterCTA = () => {
      const themeV2 = useThemeV2Context();
      return /* @__PURE__ */ jsx135(
        StyledPrimaryButton_default,
        {
          onClick: () => {
            window.open("https://jane.app/contact", "_blank");
          },
          themeV2,
          textWrap: true
        },
        "Chat with our team"
      );
    };
    ChatFooterCTA_default = ChatFooterCTA;
  }
});

// commandbar/src/products/copilot/components/Chat.tsx
import { jsx as jsx136 } from "@emotion/core";
import React342, { useEffect as useEffect71, useRef as useRef47 } from "react";
import dayjs8 from "dayjs";
var Chat2, ChatContainer, mkAIMessage, mkUserMessage, MockChatContainer, HistoricalChatContainer, Chat_default;
var init_Chat = __esm({
  "commandbar/src/products/copilot/components/Chat.tsx"() {
    "use strict";
    init_react();
    init_useStore();
    init_useStyles();
    init_service_selectors();
    init_location();
    init_Reporting();
    init_PoweredBy();
    init_ChatMessage();
    init_MessageInput();
    init_colors();
    init_useDelayUnmount();
    init_useStartChat();
    init_router();
    init_useChatState();
    init_copilot();
    init_StyledHelpHub();
    init_StyledHelpHubFooter();
    init_StyledHeader();
    init_StyledCopilotHeader();
    init_StyledChatScrollContainer();
    init_StyledSecondaryButton();
    init_StyledPoweredBy();
    init_useAction();
    init_branding();
    init_languages();
    init_command();
    init_global_actions();
    init_ThemeV2Context();
    init_track();
    init_symbols();
    init_Interpolate();
    init_StyledSecondaryIconButton();
    init_StyledDropdownMenu();
    init_StyledDropdownMenuItem();
    init_Continuations();
    init_useResizeObserver();
    init_LocalStorage();
    init_ChatFooterCTA();
    Chat2 = () => {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k;
      const { navigate } = useRouter();
      const startChat = useStartChat({
        replace: true
      });
      const _ = useStore();
      const styles51 = useStyles();
      const themeV2 = useThemeV2Context();
      const chatState = useChatState();
      const {
        chatHistory,
        userMessage,
        userAttachments,
        partialResponse,
        isLoading,
        send: send2,
        initialUserMessage,
        chatID,
        isChatHistoryPreview,
        isReloadingOldChat
      } = chatState;
      const fullChatHistory = [
        ...chatHistory,
        ...userMessage ? [createUserMessage({ question: userMessage, attachments: userAttachments })] : [],
        ...partialResponse ? [partialResponse] : []
      ];
      const isFirstRender = useRef47(true);
      const prevWelcomeMessage = useRef47(
        ((_a2 = _.organization) == null ? void 0 : _a2.helphub_chat_welcome_message) ? interpolate((_b2 = _.organization) == null ? void 0 : _b2.helphub_chat_welcome_message, _, true, false) : void 0
      );
      const [showDropdown, setShowDropdown] = React342.useState(false);
      const dropdownMenuRef = useRef47(null);
      const dropdownButtonRef = useRef47(null);
      useEffect71(() => {
        const handleClickOutside = (event) => {
          var _a3;
          const target = event.target;
          if (dropdownMenuRef.current && !dropdownMenuRef.current.contains(target) && !((_a3 = dropdownButtonRef.current) == null ? void 0 : _a3.contains(target))) {
            setShowDropdown(false);
          }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, [dropdownMenuRef]);
      useEffect71(() => {
        var _a3, _b3, _c3, _d2;
        if (isFirstRender.current) {
          isFirstRender.current = false;
          return;
        }
        if (!_.helpHub.previewedCopilotSettings && prevWelcomeMessage.current === (((_a3 = _.organization) == null ? void 0 : _a3.helphub_chat_welcome_message) ? interpolate((_b3 = _.organization) == null ? void 0 : _b3.helphub_chat_welcome_message, _, true, false) : void 0)) {
          return;
        }
        prevWelcomeMessage.current = ((_c3 = _.organization) == null ? void 0 : _c3.helphub_chat_welcome_message) ? interpolate((_d2 = _.organization) == null ? void 0 : _d2.helphub_chat_welcome_message, _, true, false) : void 0;
        const userMessage2 = fullChatHistory.find((message) => message.message_type === "USER");
        const firstMessage = initialUserMessage || (userMessage2 ? userMessage2.value.question : void 0);
        startChat(firstMessage);
      }, [_.helpHub.previewedCopilotSettings, (_c2 = _.organization) == null ? void 0 : _c2.helphub_chat_welcome_message]);
      const chatInput = useRef47(null);
      const chatScrollContainerRef = useRef47(null);
      const resetChat = () => {
        helpHubEngagement({ query: _.helpHub.query }, "chat_reset");
        Track.copilot.chatRestarted(chatID);
        window.CommandBar[_setActiveChat](null);
        startChat();
      };
      useEffect71(() => {
        setTimeout(() => {
          if (!chatScrollContainerRef.current)
            return;
          chatScrollContainerRef.current.scrollTo({
            top: chatScrollContainerRef.current.scrollHeight,
            behavior: "smooth"
          });
        }, 500);
      }, [fullChatHistory.length]);
      useEffect71(() => {
        var _a3;
        if (!isHelpHubMarketingSite) {
          (_a3 = chatInput.current) == null ? void 0 : _a3.focus();
        }
      }, [chatHistory]);
      const sendChat = (query, attachments) => {
        var _a3;
        if (!isStudioPreview() && !((_a3 = _.organization) == null ? void 0 : _a3.copilot_enabled)) {
          return;
        }
        send2(query, attachments);
        window.CommandBar[_setActiveChat](chatID);
        if (chatInput.current) {
          chatInput.current.style.height = "auto";
        }
      };
      const latestMessage = fullChatHistory[fullChatHistory.length - 1];
      const isInitialBotMessage = (fullChatHistory == null ? void 0 : fullChatHistory.length) === 1 && (latestMessage == null ? void 0 : latestMessage.message_type) === "AI";
      const searchSuggestions = _.helpHub.searchSuggestions;
      const defaultInitialContinuations = !searchSuggestions.loading ? searchSuggestions.continuations : [];
      const previouslyAskedQuestions = new Set(
        fullChatHistory.slice(0, fullChatHistory.length - 1).flatMap((item) => item.message_type === "USER" ? [item.value.question] : [])
      );
      const continuations = isInitialBotMessage ? defaultInitialContinuations : ((latestMessage == null ? void 0 : latestMessage.message_type) === "AI" ? (latestMessage == null ? void 0 : latestMessage.continuations) || [] : []).filter(
        (continuation) => !previouslyAskedQuestions.has(continuation)
      );
      const shouldDisplayEmptyAIMessage = latestMessage.message_type === "AI" && latestMessage.no_answer && latestMessage.extras.length > 0;
      const [isFinishedStreaming, setIsFinishedStreaming] = React342.useState(
        shouldDisplayEmptyAIMessage || isChatHistoryPreview || isReloadingOldChat
      );
      React342.useEffect(() => {
        if (shouldDisplayEmptyAIMessage) {
          setIsFinishedStreaming(true);
        }
      }, [shouldDisplayEmptyAIMessage]);
      const finishedDisplayingTextAnswer = !isLoading && isFinishedStreaming;
      const [continuationQsBottom, setContinuationQsBottom] = React342.useState(0);
      const inputContainerRef = useRef47(null);
      const { height: inputHeight } = useResizeObserver_default(inputContainerRef.current);
      const footer = document.getElementById("copilot-branded-footer");
      useEffect71(() => {
        var _a3;
        if (inputHeight || (footer == null ? void 0 : footer.offsetHeight)) {
          setContinuationQsBottom((inputHeight != null ? inputHeight : 0) + ((_a3 = footer == null ? void 0 : footer.offsetHeight) != null ? _a3 : 0));
        }
      }, [inputHeight, footer == null ? void 0 : footer.offsetHeight]);
      if (_.helpHub.minimized) {
        return null;
      }
      return ((_d = _.flags) == null ? void 0 : _d["release-themes-v2"]) ? /* @__PURE__ */ jsx136(AnimationTransition, { isMounted: true, style: { height: "100%", width: "100%" } }, /* @__PURE__ */ jsx136(StyledHelpHub_default, { "data-testid": "helphub-chat-container", style: { position: "relative" } }, /* @__PURE__ */ jsx136(StyledHeader_default, { style: { marginBottom: "-4px" } }, !isCopilotOnlyMode(_) || isChatHistoryPreview ? /* @__PURE__ */ jsx136("div", null, /* @__PURE__ */ jsx136(
        StyledSecondaryButton_default,
        {
          themeV2,
          "data-testid": "helphub-go-back",
          onClick: () => {
            if (isChatHistoryPreview) {
              navigate({ page: "chat-history", params: {} }, { replace: true });
            } else {
              navigate({ page: "home", params: {} }, { replace: true });
              helpHubEngagement({ query: _.helpHub.query }, "chat_closed");
              window.CommandBar[_setActiveChat](null);
            }
            LocalStorage_default.set("copilot.open", false);
          },
          prefixIcon: /* @__PURE__ */ jsx136(ChevronLeft_default, null)
        },
        "Back"
      )) : /* @__PURE__ */ jsx136("div", { style: { width: "75px" } }), /* @__PURE__ */ jsx136(StyledCopilotHeader_default, null, interpolate(
        _.localizedMessages["copilot.chat-label"].replace(
          "{{copilot-name}}",
          ((_e = _.helpHub.previewedCopilotSettings) == null ? void 0 : _e.name) || ((_f = _.organization) == null ? void 0 : _f.copilot_name) || "Copilot"
        ),
        _,
        true,
        false
      )), /* @__PURE__ */ jsx136("div", { style: { position: "relative", width: "75px", display: "flex", justifyContent: "end" } }, /* @__PURE__ */ jsx136("div", { ref: dropdownButtonRef }, /* @__PURE__ */ jsx136(StyledSecondaryIconButton_default, { themeV2, onClick: () => setShowDropdown((show) => !show) }, /* @__PURE__ */ jsx136(DotsVertical_default, null))), showDropdown && /* @__PURE__ */ jsx136(StyledDropdownMenu_default, { ref: dropdownMenuRef }, /* @__PURE__ */ jsx136(
        StyledDropdownMenuItem_default,
        {
          onClick: () => {
            resetChat();
            setShowDropdown(false);
          }
        },
        /* @__PURE__ */ jsx136(Plus_default, null),
        " New chat"
      ), ((_g = _.organization) == null ? void 0 : _g.copilot_chat_history_enabled) && _.endUserStore.verified && /* @__PURE__ */ jsx136(
        StyledDropdownMenuItem_default,
        {
          onClick: () => {
            navigate({ page: "chat-history", params: {} });
            setShowDropdown(false);
            LocalStorage_default.set("copilot.open", false);
          }
        },
        /* @__PURE__ */ jsx136(History_default, null),
        " Chat history"
      )))), /* @__PURE__ */ jsx136(StyledChatScrollContainer_default, { ref: chatScrollContainerRef }, fullChatHistory.map((message, index3) => {
        return /* @__PURE__ */ jsx136(
          ChatMessage,
          {
            key: index3,
            preview: false,
            history: fullChatHistory.slice(0, index3 + 1),
            isFirstMessage: index3 === 0,
            isLastMessage: index3 === fullChatHistory.length - 1,
            message,
            sendChat,
            isChatHistoryPreview,
            isFinishedStreaming,
            onFinishStreaming: () => setIsFinishedStreaming(true)
          }
        );
      }), finishedDisplayingTextAnswer && !isChatHistoryPreview && /* @__PURE__ */ jsx136(Continuations_default, { preview: false, continuations, hidden: true })), /* @__PURE__ */ jsx136(
        AnimationTransition,
        {
          entry: { keyframes: builtinKeyframes.fadeIn, durationMs: 300 },
          isMounted: !isChatHistoryPreview && finishedDisplayingTextAnswer,
          style: {
            position: "absolute",
            bottom: `calc(${continuationQsBottom}px + 2 * var(--layout-padding))`,
            zIndex: 2
          }
        },
        /* @__PURE__ */ jsx136(Continuations_default, { preview: false, continuations })
      ), /* @__PURE__ */ jsx136(
        MessageInput_default,
        {
          ref: inputContainerRef,
          preview: false,
          isChatHistoryPreview,
          isLoading,
          onSubmit: sendChat,
          resetChat,
          streamingBotMessage: latestMessage.message_type === "AI" && latestMessage.incomplete ? latestMessage : void 0
        }
      ), ((_h = _.organization) == null ? void 0 : _h.branding) === "branded" && /* @__PURE__ */ jsx136(StyledHelpHubFooter_default, { id: "copilot-branded-footer" }, /* @__PURE__ */ jsx136(
        StyledPoweredBy_default,
        {
          onClick: () => navigateToBrandingSite(_.organization),
          text: translate("Powered by Command AI")
        }
      )), ((_i = _.flags) == null ? void 0 : _i["show-persistent-copilot-cta"]) && /* @__PURE__ */ jsx136(StyledHelpHubFooter_default, { id: "copilot-branded-footer" }, /* @__PURE__ */ jsx136(ChatFooterCTA_default, null)))) : /* @__PURE__ */ jsx136("div", { style: { height: "100%" }, "data-testid": "helphub-chat-container" }, /* @__PURE__ */ jsx136(AnimationTransition, { isMounted: true, style: { height: "100%" } }, /* @__PURE__ */ jsx136("div", { style: { height: "100%", display: "flex", flexDirection: "column", position: "relative" } }, /* @__PURE__ */ jsx136(
        "div",
        {
          css: {
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "16px",
            color: "#51515C",
            background: CB_COLORS.white,
            alignItems: "center"
          }
        },
        /* @__PURE__ */ jsx136("div", { style: { flex: 1 } }, !isCopilotOnlyMode(_) && /* @__PURE__ */ jsx136(
          "button",
          {
            "data-testid": "helphub-go-back",
            css: { ...styles51.docHeaderButton, width: "72px" },
            onClick: () => {
              navigate({ page: "home", params: {} }, { replace: true });
              helpHubEngagement({ query: _.helpHub.query }, "chat_closed");
              window.CommandBar[_setActiveChat](null);
            }
          },
          /* @__PURE__ */ jsx136(ChevronLeft_default, { height: 14 }),
          /* @__PURE__ */ jsx136("span", null, "Back")
        )),
        /* @__PURE__ */ jsx136(
          "div",
          {
            css: {
              fontSize: "14px",
              fontWeight: 500,
              color: "#000000",
              maxWidth: "50%",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          },
          "Chat with",
          " ",
          interpolate(
            ((_j = _.helpHub.previewedCopilotSettings) == null ? void 0 : _j.name) || ((_k = _.organization) == null ? void 0 : _k.copilot_name) || "Copilot",
            _,
            true,
            false
          )
        ),
        /* @__PURE__ */ jsx136("div", { style: { flex: 1 } })
      ), /* @__PURE__ */ jsx136(
        "div",
        {
          ref: chatScrollContainerRef,
          style: {
            overflowY: "auto",
            overscrollBehaviorY: "contain",
            flexGrow: "1",
            backgroundColor: "#FFF"
          }
        },
        /* @__PURE__ */ jsx136("div", null, fullChatHistory.map((message, index3) => {
          return /* @__PURE__ */ jsx136(
            ChatMessage,
            {
              key: index3,
              preview: false,
              history: fullChatHistory.slice(0, index3 + 1),
              isFirstMessage: index3 === 0,
              isLastMessage: index3 === fullChatHistory.length - 1,
              message,
              sendChat,
              isChatHistoryPreview,
              isFinishedStreaming,
              onFinishStreaming: () => setIsFinishedStreaming(true)
            }
          );
        }))
      ), /* @__PURE__ */ jsx136("div", { style: { width: "100%", flexShrink: "0" } }, /* @__PURE__ */ jsx136(
        MessageInput_default,
        {
          preview: false,
          isChatHistoryPreview,
          isLoading,
          onSubmit: sendChat,
          resetChat
        }
      ), /* @__PURE__ */ jsx136(
        PoweredBy_default,
        {
          style: {
            paddingBottom: "12px",
            justifyContent: "center",
            background: CB_COLORS.white
          }
        }
      )))));
    };
    ChatContainer = () => {
      const { chatId, chatHistory, initialQuery } = useParams();
      const {
        organization,
        endUser,
        helpHub: {
          filter,
          editorCopilotOverrides: { userProperties }
        }
      } = useStore();
      if (!organization)
        return null;
      return /* @__PURE__ */ jsx136(
        ChatStateProvider,
        {
          isChatMode: true,
          chatID: chatId,
          organization,
          endUser,
          helphubFilter: filter,
          initialUserMessage: initialQuery,
          userPropertiesOverride: userProperties,
          initialChatHistory: chatHistory || []
        },
        /* @__PURE__ */ jsx136(Chat2, null)
      );
    };
    mkAIMessage = (text, {
      extras = [],
      continuations = [],
      showDocSource = false,
      modified = dayjs8().toString()
    } = {}) => ({
      message_type: "AI",
      value: {
        answer: text,
        command_id: null,
        command_title: "",
        passage_id: null,
        passage_heading: null,
        doc: null,
        source_docs: showDocSource ? [
          {
            passage_heading: "How to use darkmode",
            command: decode({
              id: -1234,
              text: "How to use darkmode",
              template: { type: "helpdoc", value: "https://example.com/dark-mode" }
            })
          }
        ] : []
      },
      uuid: null,
      error: "",
      incomplete: false,
      no_answer: false,
      used_fallback: false,
      feedback: null,
      continuations,
      fallback_ctas: null,
      fallback_labeled_actions: [],
      extras,
      modified,
      debug_info: {}
    });
    mkUserMessage = (text, {
      modified = dayjs8().toString()
    } = {}) => ({
      message_type: "USER",
      value: {
        question: text,
        command_ids: [],
        attachments: []
      },
      uuid: null,
      modified
    });
    MockChatContainer = () => {
      const [mockChatHistory, setMockChatHistory] = React342.useState(null);
      const addMockCommand2 = useAction(addMockCommand);
      const removeMockCommand2 = useAction(removeMockCommand);
      useEffect71(() => {
        const id2 = Math.random();
        const mockCommand = decode({
          id: id2,
          show_in_spotlight_search: false,
          template: { type: "link", value: "https://example.com/dark-mode" },
          text: "Show me how to use darkmode"
        });
        addMockCommand2(mockCommand);
        const mockChatHistory2 = [
          mkAIMessage("Hi \u{1F44B}, how can I help?", { modified: dayjs8().subtract(3, "minute").toString() }),
          mkUserMessage("where's the darkmode setting?!?", { modified: dayjs8().subtract(2, "minute").toString() }),
          mkAIMessage(
            "You can adjust your display settings, including dark mode, by navigating to Settings -> Appearances -> Display.",
            {
              modified: dayjs8().subtract(2, "minute").toString(),
              showDocSource: true
            }
          ),
          mkUserMessage("do it for me"),
          mkAIMessage("", {
            extras: [
              {
                type: "button_primary",
                text: "Toggle on dark mode",
                action: { type: "execute_command", meta: { command: mockCommand.id.toString() } },
                message: "Use the quick action below to toggle on dark mode."
              }
            ]
          })
        ];
        setMockChatHistory(mockChatHistory2);
        return () => {
          removeMockCommand2(mockCommand);
        };
      }, []);
      return mockChatHistory && /* @__PURE__ */ jsx136(MockChatStateProvider, { chatHistory: mockChatHistory }, /* @__PURE__ */ jsx136(Chat2, null));
    };
    HistoricalChatContainer = () => {
      const { chatHistory } = useParams();
      return chatHistory && /* @__PURE__ */ jsx136(PreviewChatStateProvider, { chatHistory, isChatHistoryPreview: true }, /* @__PURE__ */ jsx136(Chat2, null));
    };
    Chat_default = ChatContainer;
  }
});

// commandbar/src/shared/components/assistance/SomethingWentWrong.tsx
import React343 from "react";
var SomethingWentWrong, SomethingWentWrong_default;
var init_SomethingWentWrong = __esm({
  "commandbar/src/shared/components/assistance/SomethingWentWrong.tsx"() {
    "use strict";
    init_router();
    init_ActionButton();
    SomethingWentWrong = () => {
      const { navigate } = useRouter();
      return /* @__PURE__ */ React343.createElement(
        "div",
        {
          style: {
            padding: "16px",
            color: "#51515C",
            fontSize: "14px"
          }
        },
        /* @__PURE__ */ React343.createElement("p", { style: { fontSize: 18, fontWeight: 500 } }, "Oops! Something went wrong."),
        /* @__PURE__ */ React343.createElement("p", null, "Sorry about that."),
        /* @__PURE__ */ React343.createElement("p", null, /* @__PURE__ */ React343.createElement(ActionButton_default, { onClick: () => navigate({ page: "home", params: {} }) }, "Try again?"))
      );
    };
    SomethingWentWrong_default = SomethingWentWrong;
  }
});

// commandbar/src/products/helphub/components/Loading.tsx
import React344 from "react";
var Loading, Loading_default;
var init_Loading = __esm({
  "commandbar/src/products/helphub/components/Loading.tsx"() {
    "use strict";
    init_LoadingSkeleton();
    Loading = () => {
      const [showSkeleton, setShowSkeleton] = React344.useState(false);
      React344.useEffect(() => {
        const timeout = setTimeout(() => setShowSkeleton(true), 250);
        return () => clearTimeout(timeout);
      }, []);
      if (!showSkeleton)
        return null;
      return /* @__PURE__ */ React344.createElement(
        "div",
        {
          style: {
            display: "flex",
            flexDirection: "column",
            marginTop: 16
          }
        },
        /* @__PURE__ */ React344.createElement(LoadingSkeleton_default, { style: { width: "90%", height: 18 } }),
        /* @__PURE__ */ React344.createElement(LoadingSkeleton_default, { style: { width: "40%", height: 18 } }),
        /* @__PURE__ */ React344.createElement(LoadingSkeleton_default, { style: { width: "70%", height: 18 } }),
        /* @__PURE__ */ React344.createElement(LoadingSkeleton_default, { style: { width: "60%", height: 18 } }),
        /* @__PURE__ */ React344.createElement(LoadingSkeleton_default, { style: { width: "80%", height: 18 } })
      );
    };
    Loading_default = Loading;
  }
});

// commandbar/src/products/copilot/components/StartChat.tsx
import { useEffect as useEffect72, useState as useState46 } from "react";
import React345 from "react";
var StartChat, StartChat_default;
var init_StartChat = __esm({
  "commandbar/src/products/copilot/components/StartChat.tsx"() {
    "use strict";
    init_useStartChat();
    init_Loading();
    init_router();
    StartChat = () => {
      const { initialQuery } = useParams();
      const [showLoading, setShowLoading] = useState46(false);
      useEffect72(() => {
        const timeout = setTimeout(() => setShowLoading(true), 250);
        return () => clearTimeout(timeout);
      }, []);
      const startChat = useStartChat();
      useEffect72(() => {
        startChat(initialQuery);
      }, [initialQuery]);
      return showLoading ? /* @__PURE__ */ React345.createElement(Loading_default, null) : null;
    };
    StartChat_default = StartChat;
  }
});

// commandbar/src/products/helphub/components/NavigateToCurrentHubDoc.tsx
import { useEffect as useEffect73 } from "react";
var NavigateToCurrentHubDoc, NavigateToCurrentHubDoc_default;
var init_NavigateToCurrentHubDoc = __esm({
  "commandbar/src/products/helphub/components/NavigateToCurrentHubDoc.tsx"() {
    "use strict";
    init_useStore();
    init_router();
    NavigateToCurrentHubDoc = () => {
      const _ = useStore();
      const { hubDoc } = _.helpHub;
      const { navigate } = useRouter();
      useEffect73(() => {
        if (hubDoc) {
          navigate({
            page: "docs",
            params: {
              docId: hubDoc.command.id
            }
          });
        }
      }, [hubDoc]);
      return null;
    };
    NavigateToCurrentHubDoc_default = NavigateToCurrentHubDoc;
  }
});

// commandbar/src/products/helphub/components/FetchSearchSuggestions.tsx
import React346 from "react";
var FetchSearchSuggestions, FetchSearchSuggestions_default;
var init_FetchSearchSuggestions = __esm({
  "commandbar/src/products/helphub/components/FetchSearchSuggestions.tsx"() {
    "use strict";
    init_useAction();
    init_useStore();
    init_actions2();
    init_search();
    FetchSearchSuggestions = () => {
      var _a2;
      const _ = useStore();
      const setSearchSuggestions2 = useAction(setSearchSuggestions);
      React346.useEffect(() => {
        let canceled = false;
        (async () => {
          var _a3, _b2, _c2;
          if (((_a3 = _.organization) == null ? void 0 : _a3.copilot_enabled) && ((_b2 = _.organization) == null ? void 0 : _b2.helphub_suggested_queries_enabled)) {
            if (_.organization.helphub_manual_suggested_queries.length > 0) {
              const randomizedItems = [..._.organization.helphub_manual_suggested_queries].sort(() => 0.5 - Math.random()).slice(0, 3);
              if (!canceled)
                setSearchSuggestions2(randomizedItems);
              return;
            }
            const resp = await fetchSearchSuggestions(_.organization.id.toString());
            const suggestions = ((_c2 = resp == null ? void 0 : resp.suggestions) == null ? void 0 : _c2.slice(0, 2)) || [];
            if (!canceled)
              setSearchSuggestions2(suggestions);
          } else {
            setSearchSuggestions2([]);
          }
        })();
        return () => {
          canceled = true;
        };
      }, [(_a2 = _.organization) == null ? void 0 : _a2.helphub_manual_suggested_queries]);
      return null;
    };
    FetchSearchSuggestions_default = FetchSearchSuggestions;
  }
});

// internal/src/client/themesV2/components/copilot/StyledChatHistoryCard.tsx
import { jsx as jsx137 } from "@emotion/core";
import dayjs9 from "dayjs";
var ChatCard, ChatCardContent, ChatCardTitle, ChatCardSubtitle, StyledChatHistoryCard, StyledChatHistoryCard_default;
var init_StyledChatHistoryCard = __esm({
  "internal/src/client/themesV2/components/copilot/StyledChatHistoryCard.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_StyledIconContainer();
    init_react();
    ChatCard = styled_browser_esm_default.div`
  display: flex;
  padding: var(--layout-padding);
  align-items: center;
  gap: 12px;
  align-self: stretch;
  border-bottom: 1px solid var(--border-primary);
  background: var(--background-primary);
  cursor: pointer;

  #chat-history-open-chevron {
    opacity: 0;
  }

  &:hover {
    background: var(--background-primary-hover);

    #chat-history-open-chevron {
      opacity: 1;
    }
  }
`;
    ChatCardContent = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
  flex: 1 0 0;
`;
    ChatCardTitle = styled_browser_esm_default.div`
  color: var(--content-primary);
  overflow: hidden;
  text-overflow: ellipsis;

  /* label/base/semibold */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-semibold);
  line-height: var(--font-line-height-normal);
`;
    ChatCardSubtitle = styled_browser_esm_default.div`
  color: var(--content-secondary);
  overflow: hidden;
  text-overflow: ellipsis;

  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    StyledChatHistoryCard = ({ handleChatClick, chat }) => {
      const getLastModifiedString = (modified) => {
        const daysSince = -dayjs9(modified).diff(dayjs9(), "day");
        return daysSince === 0 ? "Today" : daysSince === 1 ? "Yesterday" : `${daysSince} days ago`;
      };
      const firstUserMessage = chat.messages.find((message) => message.message_type === "USER");
      if (firstUserMessage && firstUserMessage.message_type === "USER") {
        return /* @__PURE__ */ jsx137(ChatCard, { onClick: handleChatClick }, /* @__PURE__ */ jsx137(ChatCardContent, null, /* @__PURE__ */ jsx137(ChatCardTitle, null, firstUserMessage.value.question), /* @__PURE__ */ jsx137(ChatCardSubtitle, null, getLastModifiedString(chat.modified))), /* @__PURE__ */ jsx137(StyledIconContainer_default, { style: { color: "var(--content-secondary)" }, id: "chat-history-open-chevron" }, /* @__PURE__ */ jsx137(ChevronRight_default, null)));
      } else {
        return null;
      }
    };
    StyledChatHistoryCard_default = StyledChatHistoryCard;
  }
});

// commandbar/src/products/copilot/components/ChatHistory.tsx
import { useEffect as useEffect74, useState as useState47 } from "react";
import { jsx as jsx138 } from "@emotion/core";
var EmptyStateContainer, EmptyState, TextContainer4, ChatHistory, ChatHistory_default;
var init_ChatHistory = __esm({
  "commandbar/src/products/copilot/components/ChatHistory.tsx"() {
    "use strict";
    init_react();
    init_symbols();
    init_StyledHeader();
    init_StyledHelpHub();
    init_StyledPrimaryButton();
    init_StyledSecondaryButton();
    init_useStartChat();
    init_ThemeV2Context();
    init_useStore();
    init_router();
    init_StyledChatHistoryCard();
    init_Loading();
    init_globals();
    init_styled_browser_esm();
    init_end_users();
    EmptyStateContainer = styled_browser_esm_default.div`
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`;
    EmptyState = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;
    TextContainer4 = styled_browser_esm_default.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;
    ChatHistory = () => {
      const startChat = useStartChat({
        replace: true
      });
      const _ = useStore();
      const themeV2 = useThemeV2Context();
      const { back, navigate } = useRouter();
      const [allChats, setAllChats] = useState47([]);
      const [loading, setLoading2] = useState47(true);
      const { hmac } = getSDK()[_instanceAttributes];
      useEffect74(() => {
        const getAllChats = async () => {
          var _a2;
          if (hmac && ((_a2 = _.endUser) == null ? void 0 : _a2.identifier)) {
            try {
              const chats = await getChatHistory(hmac, _.endUser.identifier);
              chats && setAllChats(chats);
            } catch (e) {
              setAllChats([]);
            }
          }
          setLoading2(false);
        };
        getAllChats();
      }, []);
      const handleChatClick = (chat) => {
        navigate(
          {
            page: "historical-chat",
            params: { chatHistory: chat.messages }
          },
          { replace: true }
        );
      };
      return /* @__PURE__ */ jsx138(StyledHelpHub_default, { style: { gap: "var(--layout-gap)" }, "data-testid": "helphub-chat-container" }, /* @__PURE__ */ jsx138(StyledHeader_default, null, /* @__PURE__ */ jsx138("div", null, /* @__PURE__ */ jsx138(
        StyledSecondaryButton_default,
        {
          themeV2,
          "data-testid": "helphub-go-back",
          onClick: () => back(),
          prefixIcon: /* @__PURE__ */ jsx138(ChevronLeft_default, null)
        },
        "Back"
      )), /* @__PURE__ */ jsx138("div", null, /* @__PURE__ */ jsx138(StyledPrimaryButton_default, { themeV2, onClick: () => startChat(), prefixIcon: /* @__PURE__ */ jsx138(Plus_default, null) }, "New chat"))), /* @__PURE__ */ jsx138("div", { style: { display: "flex", flexDirection: "column", width: "100%", overflow: "auto", flexGrow: "1" } }, loading ? /* @__PURE__ */ jsx138(Loading_default, null) : allChats.length > 0 ? allChats.filter((chat) => chat.messages.length > 0).map((chat) => /* @__PURE__ */ jsx138(StyledChatHistoryCard_default, { key: chat.id, handleChatClick: () => handleChatClick(chat), chat })) : /* @__PURE__ */ jsx138(EmptyStateContainer, null, /* @__PURE__ */ jsx138(EmptyState, null, /* @__PURE__ */ jsx138(MessageChatSquare_default, { height: "32px", width: "32px", color: "var(--content-secondary)", strokeWidth: "1px" }), /* @__PURE__ */ jsx138(TextContainer4, null, /* @__PURE__ */ jsx138(
        "div",
        {
          style: {
            color: "var(--content-primary)",
            fontFamily: "var(--font-font-family)",
            fontSize: "var(--font-size-large)",
            fontWeight: "var(--font-weight-semibold)",
            lineHeight: "var(--font-line-height-snug)"
          }
        },
        "No chat history"
      ), /* @__PURE__ */ jsx138(
        "div",
        {
          style: {
            color: "var(--content-secondary)",
            fontFamily: "var(--font-font-family)",
            fontSize: "var(--font-size-base)",
            fontWeight: "var(--font-weight-medium)",
            lineHeight: "var(--font-line-height-normal)"
          }
        },
        "Your past chats will appear here"
      ))))));
    };
    ChatHistory_default = ChatHistory;
  }
});

// commandbar/src/shared/components/assistance/AssistanceRouter.tsx
import { jsx as jsx139 } from "@emotion/core";
import { useEffect as useEffect75 } from "react";
var Home, INITIAL_ENTRIES, AssistanceRouter, AssistanceRouter_default;
var init_AssistanceRouter = __esm({
  "commandbar/src/shared/components/assistance/AssistanceRouter.tsx"() {
    "use strict";
    init_router();
    init_HelpHub();
    init_Doc();
    init_Chat();
    init_service_selectors();
    init_SomethingWentWrong();
    init_StartChat();
    init_NavigateToCurrentHubDoc();
    init_useStore();
    init_FetchSearchSuggestions();
    init_useAction();
    init_ChatHistory();
    Home = () => {
      var _a2, _b2;
      const { navigate } = useRouter();
      const _ = useStore();
      const chatOnlyMode = _.organization && (_.helpHub.chatOnly || isCopilotOnlyMode(_));
      const clearInitialPage = useAction((_2) => {
        _2.helpHub.initialPage = null;
      });
      useEffect75(() => {
        if (!_.helpHub.initialPage) {
          if (chatOnlyMode) {
            navigate({ page: "start-chat", params: {} }, { replace: true });
          } else {
            navigate({ page: "help-hub", params: {} }, { replace: true });
          }
          return;
        } else {
          navigate({ page: _.helpHub.initialPage.item.page, params: _.helpHub.initialPage.item.params }, { replace: true });
          clearInitialPage();
        }
      }, [_.helpHub.initialPage, (_b2 = (_a2 = _.helpHub.initialPage) == null ? void 0 : _a2.item.params) == null ? void 0 : _b2.initialQuery]);
      return null;
    };
    INITIAL_ENTRIES = [{ page: "home", params: {} }];
    AssistanceRouter = ({
      initialEntries = INITIAL_ENTRIES,
      onNavigate
    }) => {
      return /* @__PURE__ */ jsx139(MemoryRouter, { initialEntries, onNavigate }, /* @__PURE__ */ jsx139(
        Routes,
        {
          pages: [
            { page: "home", element: Home },
            {
              page: "start-chat",
              /*params: ['initialQuery' (optional)] */
              element: StartChat_default
            },
            { page: "help-hub", element: HelpHub_default },
            {
              page: "docs",
              /*params: ['docId'] */
              element: Doc_default
            },
            {
              page: "chats",
              /*params: ['chatId', 'chatHistory' (optional), 'initialQuery' (optional)] */
              element: Chat_default
            },
            { page: "mock-chat", element: MockChatContainer },
            // used in WidgetTableau
            { page: "error", element: SomethingWentWrong_default },
            { page: "chat-history", element: ChatHistory_default },
            {
              page: "historical-chat",
              /*params: [chatHistory] */
              element: HistoricalChatContainer
            }
          ]
        }
      ), /* @__PURE__ */ jsx139(NavigateToCurrentHubDoc_default, null), /* @__PURE__ */ jsx139(FetchSearchSuggestions_default, null));
    };
    AssistanceRouter_default = AssistanceRouter;
  }
});

// internal/src/client/themesV2/components/shared/StyledAssistanceModal.tsx
import React348 from "react";
var Modal3, StyledAssistanceModal, StyledAssistanceModal_default;
var init_StyledAssistanceModal = __esm({
  "internal/src/client/themesV2/components/shared/StyledAssistanceModal.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    Modal3 = styled_browser_esm_default.div`
  position: fixed;
  display: flex;
  width: var(--helphub-width);
  height: var(--helphub-height);
  max-height: 100vh;
  right: 12px;
  bottom: 12px;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;

  border-radius: var(--layout-radius-card);
  border: 1px solid var(--border-primary);
  background: var(--background-primary);

  box-shadow: var(--layout-shadow) var(--layout-shadow-color);

  z-index: ${Z_default.Z_HELPHUB};
`;
    StyledAssistanceModal = ({
      children,
      modalRef,
      parentCallbackRef,
      ...props2
    }) => {
      return /* @__PURE__ */ React348.createElement(
        Modal3,
        {
          ref: (node) => {
            modalRef.current = node;
            if (parentCallbackRef)
              parentCallbackRef(node);
          },
          ...props2
        },
        children
      );
    };
    StyledAssistanceModal_default = StyledAssistanceModal;
  }
});

// internal/src/client/themesV2/components/shared/StyledAssistanceModalHeader.tsx
import React349 from "react";
import { css as css77, jsx as jsx140 } from "@emotion/core";
var styles50, ButtonContainer2, Icon4, Title7, slug20, StyledAssistanceModalHeader, StyledHeaderMock, StyledAssistanceModalHeader_default;
var init_StyledAssistanceModalHeader = __esm({
  "internal/src/client/themesV2/components/shared/StyledAssistanceModalHeader.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_react();
    init_StyledIconContainer();
    init_useComponentOverrides();
    init_StyledTertiaryIconButton();
    styles50 = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      flexShrink: 0,
      alignSelf: "stretch",
      background: "var(--form-control-active-background)",
      height: "var(--header-height)",
      color: "var(--content-primary)"
    };
    ButtonContainer2 = styled_browser_esm_default.div`
  padding: var(--layout-padding);
  height: 100%;
  display: flex;
  align-items: center;
  gap: 4px;
`;
    Icon4 = styled_browser_esm_default(StyledIconContainer_default)`
  cursor: pointer;
  color: var(--content-secondary);
`;
    Title7 = styled_browser_esm_default.div`
  /* label/base/medium */
  font-family: var(--font-font-family);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-normal);
`;
    slug20 = "assistanceModalHeader";
    StyledAssistanceModalHeader = Object.assign(
      React349.forwardRef(
        ({ children, title, onClose, onMinimize, isMinimized, isMobileDevice: isMobileDevice2, themeV2, ...props2 }, ref12) => {
          const { overrides } = useComponentOverrides_default(slug20, themeV2);
          return /* @__PURE__ */ jsx140("div", { css: [overrides, css77(styles50)], ref: ref12, ...props2 }, /* @__PURE__ */ jsx140(ButtonContainer2, { "data-draggable": "drag-zone", "data-testid": "drag-zone", style: { flex: 1 } }, /* @__PURE__ */ jsx140(Title7, null, title)), /* @__PURE__ */ jsx140(ButtonContainer2, null, !window._cbIsWebView && /* @__PURE__ */ jsx140(React349.Fragment, null, !isMobileDevice2 && /* @__PURE__ */ jsx140(StyledTertiaryIconButton_default, { themeV2, onClick: onMinimize }, isMinimized ? /* @__PURE__ */ jsx140(Expand02_default, null) : /* @__PURE__ */ jsx140(Minus_default, null)), !!onClose && /* @__PURE__ */ jsx140(StyledTertiaryIconButton_default, { themeV2, onClick: onClose }, /* @__PURE__ */ jsx140(XClose_default, null)))));
        }
      ),
      {
        slug: slug20,
        styles: styles50,
        renderMock: (themeV2, mode) => /* @__PURE__ */ jsx140(StyledHeaderMock, { themeV2, mode })
      }
    );
    StyledHeaderMock = ({ themeV2, mode }) => {
      const { overrides } = useComponentOverrides_default(slug20, { themeV2, mode });
      return /* @__PURE__ */ jsx140("div", { css: [overrides, css77(styles50)], style: { width: "350px" } }, /* @__PURE__ */ jsx140(ButtonContainer2, { "data-draggable": "drag-zone", "data-testid": "drag-zone", style: { flex: 1 } }, /* @__PURE__ */ jsx140(Title7, null, "Title bar")), /* @__PURE__ */ jsx140(ButtonContainer2, null, /* @__PURE__ */ jsx140(Icon4, null, /* @__PURE__ */ jsx140(Minus_default, null)), /* @__PURE__ */ jsx140(Icon4, null, /* @__PURE__ */ jsx140(XClose_default, null))));
    };
    StyledAssistanceModalHeader_default = StyledAssistanceModalHeader;
  }
});

// internal/src/client/themesV2/components/shared/StyledAssistanceModalRouterContainer.tsx
import React350 from "react";
var Container25, StyledAssistanceModalRouterContainer, StyledAssistanceModalRouterContainer_default;
var init_StyledAssistanceModalRouterContainer = __esm({
  "internal/src/client/themesV2/components/shared/StyledAssistanceModalRouterContainer.tsx"() {
    "use strict";
    init_styled_browser_esm();
    Container25 = styled_browser_esm_default.div`
  width: 100%;
  height: calc(100% - 40px);
`;
    StyledAssistanceModalRouterContainer = ({ children }) => {
      return /* @__PURE__ */ React350.createElement(Container25, null, children);
    };
    StyledAssistanceModalRouterContainer_default = StyledAssistanceModalRouterContainer;
  }
});

// commandbar/src/shared/components/assistance/AssistanceModal.tsx
import { css as css78, jsx as jsx141 } from "@emotion/core";
import React351, { useEffect as useEffect76, useReducer } from "react";
import ReactDOM10 from "react-dom";
var AssistanceModal, AssistanceModal_default;
var init_AssistanceModal = __esm({
  "commandbar/src/shared/components/assistance/AssistanceModal.tsx"() {
    "use strict";
    init_react();
    init_service_actions();
    init_useAction();
    init_useStyles();
    init_dotsgrid();
    init_xclose();
    init_location();
    init_dispatchCustomEvent();
    init_Resizer();
    init_useStore();
    init_useDisableZoom();
    init_useMobileExperience();
    init_AssistanceRouter();
    init_useTheme();
    init_StyledAssistanceModal();
    init_StyledAssistanceModalHeader();
    init_StyledAssistanceModalRouterContainer();
    init_AnimatedWidget();
    init_track();
    init_Interpolate();
    init_ThemeV2Context();
    AssistanceModal = ({ parentCallbackRef, style: style3, initialEntries }) => {
      const toggleHelpHubVisible2 = useAction(toggleHelpHubVisible);
      const _ = useStore();
      const {
        flags,
        helpHub: { hubDoc, minimized, previewedCopilotSettings, chatOnly },
        organization,
        localizedMessages,
        showWidgetTableau: showWidgetTableau2
      } = _;
      const { isMobileDevice: isMobileDevice2, isStudioMobilePreview, studioMobilePreviewWrapper } = useMobileExperience();
      const { animStyles } = useAnimatedWidget();
      useDisableZoom(isMobileDevice2);
      const setHelpHubMinimized2 = useAction(setHelpHubMinimized);
      const { theme } = useTheme();
      const themeV2 = useThemeV2Context();
      const styles51 = useStyles();
      const modalRef = React351.useRef(null);
      const headerRef = React351.useRef(null);
      const [height, setHeight] = React351.useState(void 0);
      const [width, setWidth] = React351.useState(void 0);
      const [chatOpen, setChatOpen] = React351.useState(false);
      const onNavigate = (item) => {
        setChatOpen(item.page === "chats" || item.page === "mock-chat");
        if (item.page === "chats") {
          Track.copilot.viewed();
        } else if (item.page === "help-hub") {
          Track.helphub.viewed();
        }
      };
      useEffect76(() => {
        if (hubDoc == null ? void 0 : hubDoc.command.id) {
          setHelpHubMinimized2(false);
        }
      }, [hubDoc == null ? void 0 : hubDoc.command.id]);
      const [, forceUpdate] = useReducer((x) => x + 1, 0);
      React351.useEffect(() => {
        if (!isHelpHubMarketingSite)
          return;
        window.addEventListener("resize", forceUpdate);
        return () => window.removeEventListener("resize", forceUpdate);
      }, []);
      const modalStyle = (() => {
        var _a2, _b2, _c2;
        let baseStyle = (flags == null ? void 0 : flags["release-themes-v2"]) ? {} : styles51.modalContainer;
        if (minimized) {
          baseStyle = {
            ...baseStyle,
            height: (_a2 = headerRef.current) == null ? void 0 : _a2.offsetHeight,
            // TODO: Remove the transition entirely when widget animations are released
            ...(!((_b2 = _.flags) == null ? void 0 : _b2["release-widget-animations"]) || !((_c2 = _.flags) == null ? void 0 : _c2["release-themes-v2"])) && {
              transition: "height 0.2s ease-in-out, width 0.2s ease-in-out"
            },
            ...width && { width }
          };
        } else if (isStudioPreview() && !isStudioMobilePreview && !showWidgetTableau2) {
          baseStyle = {
            ...baseStyle,
            height: "calc(80vh - 24px)",
            inset: 32,
            margin: "auto"
          };
        } else if (isHelpHubMarketingSite) {
          const placeholder = document.getElementById("helphub_placeholder__container");
          if (!!placeholder) {
            const { top, left, width: width2, height: height2 } = placeholder.getBoundingClientRect();
            baseStyle = {
              ...baseStyle,
              position: "absolute",
              top: `${top + window.scrollY}px`,
              left: `${left}px`,
              width: `${width2}px`,
              height: `${height2}px`
            };
          }
        } else if (isStudioMobilePreview) {
          baseStyle = {
            ...baseStyle,
            position: "absolute",
            inset: "0px",
            height: "100%",
            width: "100%",
            boxShadow: "none",
            top: "0px",
            bottom: "0px",
            left: "0px",
            right: "0px"
          };
        } else if (isMobileDevice2) {
          baseStyle = {
            ...baseStyle,
            position: "fixed",
            inset: "0px",
            marginBottom: "1px",
            height: "100%",
            width: "auto",
            boxShadow: "none"
          };
        }
        if (style3)
          baseStyle = { ...baseStyle, ...style3 };
        if (!minimized)
          return { ...baseStyle, ...height && { height }, ...width && { width } };
        else
          return baseStyle;
      })();
      React351.useEffect(() => {
        const handleKeydown = (e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            toggleHelpHubVisible2();
          }
        };
        document.addEventListener("keydown", handleKeydown);
        return () => {
          document.removeEventListener("keydown", handleKeydown);
        };
      }, [toggleHelpHubVisible2]);
      React351.useEffect(() => {
        dispatchCustomEvent("commandbar-helphub-shown", {});
      }, []);
      React351.useEffect(() => {
        var _a2, _b2, _c2;
        if (!modalRef.current)
          return;
        if (isMobileDevice2)
          return;
        const bbox = modalRef.current.getBoundingClientRect();
        if (bbox.top > 0)
          return;
        const transform = window.getComputedStyle(modalRef.current).getPropertyValue("transform");
        const translationMatrix = (_a2 = /matrix.*\((.+)\)/.exec(transform)) == null ? void 0 : _a2[1].split(", ");
        const translateX = parseFloat((_b2 = translationMatrix == null ? void 0 : translationMatrix[4]) != null ? _b2 : "0");
        const translateY = parseFloat((_c2 = translationMatrix == null ? void 0 : translationMatrix[5]) != null ? _c2 : "0") - bbox.top;
        modalRef.current.style.transform = `translate(${translateX}px, ${translateY}px)`;
      }, [
        minimized
        /* NOTE: only need to re-evaluate this when the HH is un-minimized */
      ]);
      const containerStyles4 = {
        ...styles51.contentContainer,
        background: theme.helpHub.background,
        position: "relative"
      };
      const content = (flags == null ? void 0 : flags["release-themes-v2"]) ? /* @__PURE__ */ jsx141(
        StyledAssistanceModal_default,
        {
          style: { ...modalStyle, ...animStyles },
          id: "helphub-modal",
          "data-testid": "helphub-modal",
          className: `commandbar-helphub${!showWidgetTableau2 ? "-levelmove" : ""}${!minimized ? " expanded" : ""}`,
          modalRef,
          parentCallbackRef
        },
        modalRef.current && !isHelpHubMarketingSite && /* @__PURE__ */ jsx141(Resizer, { resizeElement: modalRef.current, setHeight, setWidth }),
        /* @__PURE__ */ jsx141(
          StyledAssistanceModalHeader_default,
          {
            themeV2,
            title: interpolate(
              chatOpen || chatOnly || !(organization == null ? void 0 : organization.helphub_enabled) ? localizedMessages["copilot.title"].replace(
                "{{copilot-name}}",
                (previewedCopilotSettings == null ? void 0 : previewedCopilotSettings.name) || (organization == null ? void 0 : organization.copilot_name) || "Copilot"
              ) : localizedMessages["helphub.title"],
              _,
              true,
              false
            ),
            ref: headerRef,
            onMinimize: () => {
              if (isHelpHubMarketingSite || isStudioPreview())
                return;
              setHelpHubMinimized2(!minimized);
            },
            onClose: toggleHelpHubVisible2,
            isMinimized: minimized,
            isMobileDevice: isMobileDevice2
          }
        ),
        /* @__PURE__ */ jsx141(StyledAssistanceModalRouterContainer_default, null, /* @__PURE__ */ jsx141(AssistanceRouter_default, { initialEntries, onNavigate }))
      ) : /* @__PURE__ */ jsx141(
        "div",
        {
          style: modalStyle,
          ref: (node) => {
            modalRef.current = node;
            if (parentCallbackRef)
              parentCallbackRef(node);
          },
          id: "helphub-modal",
          "data-testid": "helphub-modal",
          className: `commandbar-helphub${!showWidgetTableau2 ? "-levelmove" : ""}${!minimized ? " expanded" : ""}`
        },
        modalRef.current && !isHelpHubMarketingSite && /* @__PURE__ */ jsx141(Resizer, { resizeElement: modalRef.current, setHeight, setWidth }),
        /* @__PURE__ */ jsx141("div", { css: { ...styles51.modal, ...isMobileDevice2 && { borderRadius: "0" } } }, /* @__PURE__ */ jsx141("div", { ref: headerRef, css: styles51.headerContainer }, /* @__PURE__ */ jsx141("div", { css: styles51.subheader, "data-draggable": "drag-zone" }, !isMobileDevice2 && /* @__PURE__ */ jsx141(
          "div",
          {
            css: {
              ...styles51.headerIcon,
              display: "flex",
              userSelect: "none",
              cursor: "move"
            }
          },
          /* @__PURE__ */ jsx141(
            SvgDotsgrid,
            {
              css: [
                css78`
                      path {
                        stroke: ${styles51.headerIcon.color};
                        opacity: 1;
                      }
                    `
              ]
            }
          )
        ), chatOpen || chatOnly || !(organization == null ? void 0 : organization.helphub_enabled) ? /* @__PURE__ */ jsx141("div", { css: styles51.headerText }, interpolate((previewedCopilotSettings == null ? void 0 : previewedCopilotSettings.name) || (organization == null ? void 0 : organization.copilot_name) || "Copilot", _, true, false)) : /* @__PURE__ */ jsx141("div", { css: styles51.headerText }, interpolate(styles51.strings.title, _, true, false))), /* @__PURE__ */ jsx141("div", { css: styles51.headerActionIcons }, !window._cbIsWebView && /* @__PURE__ */ jsx141(React351.Fragment, null, !isMobileDevice2 && /* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions*/
        /* @__PURE__ */ jsx141(
          "div",
          {
            css: { ...styles51.headerIcon, ...styles51.headerMinimizeIcon },
            onClick: () => {
              if (isHelpHubMarketingSite || isStudioPreview())
                return;
              setHelpHubMinimized2(!minimized);
            }
          },
          minimized ? /* @__PURE__ */ jsx141(Expand02_default, { width: 16 }) : /* @__PURE__ */ jsx141(Minus_default, { width: 16 })
        ), /* @__PURE__ */ jsx141(
          "div",
          {
            id: "helphub-close-button",
            css: { ...styles51.headerIcon, ...styles51.headerCloseIcon },
            onClick: toggleHelpHubVisible2
          },
          !isHelpHubMarketingSite && /* @__PURE__ */ jsx141(
            SvgXclose,
            {
              css: [
                css78`
                          path {
                            stroke: ${styles51.headerIcon.color};
                            opacity: 1;
                          }
                        `
              ]
            }
          )
        )))), /* @__PURE__ */ jsx141("div", { style: containerStyles4 }, /* @__PURE__ */ jsx141(AssistanceRouter_default, { initialEntries, onNavigate })))
      );
      if (isStudioMobilePreview && studioMobilePreviewWrapper) {
        return ReactDOM10.createPortal(content, studioMobilePreviewWrapper);
      }
      return content;
    };
    AssistanceModal_default = AssistanceModal;
  }
});

// commandbar/src/shared/components/assistance/DraggableAssistanceModal.tsx
import { jsx as jsx142 } from "@emotion/core";
import React352 from "react";
var DraggableAssistanceModal, DraggableAssistanceModal_default;
var init_DraggableAssistanceModal = __esm({
  "commandbar/src/shared/components/assistance/DraggableAssistanceModal.tsx"() {
    "use strict";
    init_useDraggable();
    init_AssistanceModal();
    DraggableAssistanceModal = () => {
      const [modalEl, setModalEl] = React352.useState(null);
      useDraggable_default(modalEl);
      return /* @__PURE__ */ jsx142(AssistanceModal, { parentCallbackRef: setModalEl });
    };
    DraggableAssistanceModal_default = DraggableAssistanceModal;
  }
});

// commandbar/src/shared/components/assistance/AssistanceWidget.tsx
var AssistanceWidget_exports = {};
__export(AssistanceWidget_exports, {
  AssistanceWidget: () => AssistanceWidget,
  default: () => AssistanceWidget_default
});
import React353, { useEffect as useEffect77 } from "react";
var AssistanceWidget, AssistanceWidget_default;
var init_AssistanceWidget = __esm({
  "commandbar/src/shared/components/assistance/AssistanceWidget.tsx"() {
    "use strict";
    init_service_actions();
    init_useAction();
    init_useStore();
    init_Doc();
    init_service_selectors();
    init_helpdocService();
    init_search();
    init_DraggableAssistanceModal();
    init_ThemeV2Context();
    init_globals();
    init_AnimatedWidget();
    init_LocalStorage();
    AssistanceWidget = () => {
      var _a2, _b2;
      const openHelpHub = useAction(setHelpHubVisible);
      const setParsingUrlParams = useAction((_2, value) => {
        _2.helpHub.parsingUrlParams = value;
      });
      const _ = useStore();
      const { organization } = _;
      useEffect77(() => {
        var _a3;
        const urlParams = new URLSearchParams(window.location.search);
        const commandID = urlParams.get("helphub_id" /* COMMAND_ID */);
        const query = decodeURIComponent((_a3 = urlParams.get("helphub_query" /* QUERY */)) != null ? _a3 : "");
        const copilotOpen = !!LocalStorage_default.get("copilot.open", false);
        const copilotMinimized = !!LocalStorage_default.get("copilot.minimized", false);
        if (commandID && (organization == null ? void 0 : organization.id)) {
          setParsingUrlParams(true);
          queryHelpDocs(organization.id, query, _.endUser, _.helpHub.filter).then((docs) => {
            var _a4;
            let article = null;
            const videoCommand = _.commands.find(
              ({ id: id2, template }) => template.type === "video" && String(id2) === String(commandID)
            );
            article = (_a4 = docs.find((doc) => String(doc.command.id) === String(commandID))) != null ? _a4 : videoCommand ? commandToHelpHubDoc(videoCommand) : null;
            return article;
          }).then((article) => {
            if (article) {
              return article;
            } else {
              return helpdocService_default.getHelpdoc(_, commandID);
            }
          }).then((article) => {
            if (article) {
              openHelpHub(true, { query, article });
            } else if (query) {
              openHelpHub(true, { query });
            }
          }).finally(() => {
            setParsingUrlParams(false);
          });
        } else if (query) {
          openHelpHub(true, { query });
          setParsingUrlParams(false);
        } else if (copilotOpen) {
          getSDK().openCopilot({ minimized: copilotMinimized });
        }
        return () => {
          setParsingUrlParams(false);
        };
      }, [organization == null ? void 0 : organization.id]);
      const isMounted = !((_a2 = _.flags) == null ? void 0 : _a2["release-widget-animations"]) || !((_b2 = _.flags) == null ? void 0 : _b2["release-themes-v2"]) ? _.helpHub.visible : true;
      return isMounted ? /* @__PURE__ */ React353.createElement(BindThemeV2ByUUID, { themeUUID: organization == null ? void 0 : organization.helphub_custom_theme }, /* @__PURE__ */ React353.createElement(AnimatedWidget, { widget: "helphub", isMounted: _.helpHub.visible }, /* @__PURE__ */ React353.createElement(DraggableAssistanceModal_default, { key: _.helpHub.key }))) : null;
    };
    AssistanceWidget_default = AssistanceWidget;
  }
});

// commandbar/src/shared/components/admin-facing/WidgetTableau/mock-entities.ts
var checklist2, nudgeStars, nudgeEmoji, nudgeRating, nudgeRating1to10, nudgeSurveyOptionsDropdown, nudgeSurveyOptionsSingle, nudgeSurveyOptionsMulti, nudgeSurveyShortText, nudgeBanner, nudgeSurveyLongText, nudgeAnnouncement, nudgePin, nudgeTooltip;
var init_mock_entities = __esm({
  "commandbar/src/shared/components/admin-facing/WidgetTableau/mock-entities.ts"() {
    "use strict";
    init_checklist();
    init_nudge();
    checklist2 = Checklist.decode({
      id: -1,
      title: "Get Started",
      description: "Get up and running fast",
      show_expression: { type: "LITERAL", value: true },
      trigger: { type: "on_event", meta: { event: "test-event", condition_group: void 0 } },
      items: [
        {
          id: -2,
          title: "Create your first project",
          description: "Setup your first project in TaskHelper",
          goal: {
            type: "cta_clicked"
          },
          action: { type: "no_action" },
          celebrate: true,
          cta: "Create",
          skippable: true
        },
        {
          id: -3,
          title: "Create your first task",
          goal: {
            type: "cta_clicked"
          },
          action: { type: "no_action" },
          celebrate: true
        },
        {
          id: -4,
          title: "Build your first workflow",
          goal: {
            type: "cta_clicked"
          },
          action: { type: "no_action" },
          celebrate: true
        },
        {
          id: -5,
          title: "Setup time tracking",
          goal: {
            type: "cta_clicked"
          },
          action: { type: "no_action" },
          celebrate: true
        },
        {
          id: -6,
          title: "Invite your team",
          goal: {
            type: "cta_clicked"
          },
          action: { type: "no_action" },
          celebrate: true
        }
      ],
      is_live: true,
      _editorState: { expanded: true }
    });
    nudgeStars = Nudge.decode({
      id: -112,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -23,
          title: "How'd we do?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Choose a rating to continue:"
              }
            },
            {
              type: "survey_rating",
              sort_key: 1,
              meta: {
                type: "stars",
                upper_label: "Great",
                lower_label: "Awful",
                options: 5,
                emojis: []
              }
            },
            {
              type: "button",
              sort_key: 2,
              meta: {
                label: "Submit",
                button_type: "primary",
                action: {
                  type: "no_action"
                }
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "rating",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeEmoji = Nudge.decode({
      id: -1,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -1,
          title: "How'd we do?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Choose a rating to continue:"
              }
            },
            {
              type: "survey_rating",
              sort_key: 1,
              meta: {
                type: "emojis",
                lower_label: "Awful",
                upper_label: "Great",
                options: 3,
                emojis: ["\u{1F621}", "\u{1F642}", "\u{1F929}"]
              }
            },
            {
              type: "button",
              sort_key: 2,
              meta: {
                label: "Submit",
                button_type: "primary",
                action: {
                  type: "no_action"
                }
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "rating",
      slug: "test",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeRating = Nudge.decode({
      id: -108,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -19,
          title: "How'd we do?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Choose a rating to continue:"
              }
            },
            {
              type: "survey_rating",
              sort_key: 1,
              meta: {
                type: "numbers",
                lower_label: "Not great",
                upper_label: "Awesome",
                options: 5
              }
            },
            {
              type: "button",
              sort_key: 2,
              meta: {
                label: "Submit",
                button_type: "primary",
                action: {
                  type: "no_action"
                }
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "nps",
      slug: "1-5 rating",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeRating1to10 = Nudge.decode({
      id: -109,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -20,
          title: "How likely are you to recommend us to a friend or colleague?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Choose a rating to continue:"
              }
            },
            {
              type: "survey_rating",
              sort_key: 1,
              meta: {
                type: "numbers",
                lower_label: "Not likely at all",
                upper_label: "Very likely",
                options: 10
              }
            },
            {
              type: "button",
              sort_key: 2,
              meta: {
                label: "Submit",
                button_type: "primary",
                action: {
                  type: "no_action"
                }
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "nps",
      slug: "1-10 rating",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeSurveyOptionsDropdown = Nudge.decode({
      id: -110,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -21,
          title: "How\u2019d you hear about us?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Select from the options below"
              }
            },
            {
              type: "button",
              sort_key: 1,
              meta: {
                label: "Submit",
                action: {
                  type: "no_action"
                }
              }
            },
            {
              type: "survey_list",
              sort_key: 2,
              meta: {
                options: ["Internet search", "Word of mouth", "Other"],
                list_type: "single",
                display_type: "dropdown"
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feedback",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeSurveyOptionsSingle = Nudge.decode({
      id: -113,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -24,
          title: "What's your role?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Tell us a bit about you:"
              }
            },
            {
              type: "button",
              sort_key: 1,
              meta: {
                label: "Submit",
                action: {
                  type: "no_action"
                }
              }
            },
            {
              type: "survey_list",
              sort_key: 2,
              meta: {
                options: ["Product Manager", "Designer", "Engineer"],
                list_type: "single",
                display_type: "list"
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feedback",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeSurveyOptionsMulti = Nudge.decode({
      id: -114,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -24,
          title: "What tools do you use?",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Select all that apply:"
              }
            },
            {
              type: "button",
              sort_key: 1,
              meta: {
                label: "Submit",
                action: {
                  type: "no_action"
                }
              }
            },
            {
              type: "survey_list",
              sort_key: 2,
              meta: {
                options: ["Figma", "CommandBar", "Notion"],
                list_type: "multiple",
                display_type: "list"
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feedback",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeSurveyShortText = Nudge.decode({
      id: -115,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: 11625,
          title: "Stay in the loop",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              meta: {
                value: "What\u2019s your email address?"
              },
              type: "markdown",
              sort_key: 0
            },
            {
              meta: {
                label: "Submit",
                action: {
                  type: "no_action"
                },
                button_type: "primary",
                conditional_actions: []
              },
              type: "button",
              sort_key: 2
            },
            {
              meta: {
                prompt: "you@example.com",
                validation: {
                  required: {
                    value: false,
                    message: null
                  }
                }
              },
              type: "survey_text_short",
              sort_key: 1
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false,
          preview_url: null
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feedback",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeBanner = Nudge.decode({
      id: -115,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: 11625,
          title: "Your trial ends soon.",
          form_factor: {
            type: "banner",
            position: "top",
            placement: "default"
          },
          content: [
            {
              meta: {
                value: "Upgrade to the Pro plan today."
              },
              type: "markdown",
              sort_key: 0
            },
            {
              meta: {
                label: "See Plans",
                action: {
                  type: "no_action"
                },
                button_type: "primary",
                conditional_actions: []
              },
              type: "button",
              sort_key: 2
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false,
          preview_url: null
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feedback",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeSurveyLongText = Nudge.decode({
      id: -115,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: 11625,
          title: "Feedback",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              meta: {
                value: "How can we make this twice as good?"
              },
              type: "markdown",
              sort_key: 0
            },
            {
              meta: {
                label: "Submit",
                action: {
                  type: "no_action"
                },
                button_type: "primary",
                conditional_actions: []
              },
              type: "button",
              sort_key: 2
            },
            {
              meta: {
                prompt: "Your feedback",
                validation: {
                  required: {
                    value: false,
                    message: null
                  }
                }
              },
              type: "survey_text",
              sort_key: 1
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false,
          preview_url: null
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feedback",
      slug: "",
      show_step_counter: true,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "survey"
    });
    nudgeAnnouncement = Nudge.decode({
      id: -114,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -25,
          title: "Introducing chat handoff",
          form_factor: {
            type: "popover",
            position: "center"
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Copilot shares an AI-generated summary with your support team so customers never have to repeat themselves."
              }
            },
            {
              type: "image",
              sort_key: 1,
              meta: {
                src: "https://cdn.commandbar.com/_images/sample-nudge-img.png",
                file_name: "sample-nudge-img.png",
                size: "186.2KB"
              }
            },
            {
              type: "button",
              sort_key: 2,
              meta: {
                label: "Remind me",
                action: {
                  type: "no_action"
                },
                button_type: "secondary"
              }
            },
            {
              type: "button",
              sort_key: 3,
              meta: {
                label: "Show me",
                action: {
                  type: "no_action"
                },
                button_type: "primary"
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "announcement",
      slug: "",
      show_step_counter: false,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      snoozable_on_all_steps: true,
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: false,
      show_in_helphub_search: false,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "announcement"
    });
    nudgePin = Nudge.decode({
      id: -115,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_share_link_viewed"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -26,
          title: "Integrations",
          form_factor: {
            type: "pin",
            anchor: '//*[@id="commandbar-theme-tableau-pin-nudge-anchor"]',
            advance_trigger: "",
            is_open_by_default: true,
            offset: {
              x: "0px",
              y: "0px"
            }
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Connect all the tools you use and love"
              }
            },
            {
              type: "button",
              sort_key: 2,
              meta: {
                label: "Explore Integrations",
                action: {
                  type: "no_action"
                },
                button_type: "primary"
              }
            }
          ],
          is_live: false,
          sort_key: 1,
          archived: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "feature_highlight",
      slug: "",
      show_step_counter: false,
      dismissible: true,
      snoozable: false,
      snooze_label: "Snooze",
      snoozable_on_all_steps: true,
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: true,
      show_in_helphub_search: true,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "product_tour"
    });
    nudgeTooltip = Nudge.decode({
      id: -110,
      organization: "foocorp",
      is_live: true,
      trigger: {
        type: "when_conditions_pass"
      },
      audience: {
        type: "all_users"
      },
      show_expression: {
        type: "LITERAL",
        value: true
      },
      frequency_limit: "until_interaction",
      steps: [
        {
          id: -24,
          title: "Audiences",
          form_factor: {
            type: "tooltip",
            anchor: '//*[@id="commandbar-theme-tableau-tooltip-nudge-anchor"]',
            show_on: "hover",
            marker: {
              type: "icon",
              icon: "infoCircle",
              positioning: {
                position: "left",
                offset: {
                  x: "-16px",
                  y: "0px"
                }
              }
            }
          },
          content: [
            {
              type: "markdown",
              sort_key: 0,
              meta: {
                value: "Define user cohorts for precision targeting"
              }
            }
          ],
          is_live: true,
          sort_key: 1,
          archived: false,
          preview_url: null,
          has_survey_response: false
        }
      ],
      old_nudge_id: null,
      archived: false,
      template_source: "none",
      slug: "Audience Tooltip",
      show_step_counter: false,
      dismissible: true,
      snoozable: false,
      snoozable_on_all_steps: true,
      snooze_label: "Snooze",
      snooze_duration: {
        interval: "day",
        value: 3
      },
      is_scheduled: false,
      scheduled_start_time: null,
      scheduled_end_time: null,
      share_page_url: "",
      share_page_url_or_path: "",
      show_in_spotlight_search: true,
      show_in_helphub_search: true,
      copilot_suggest: false,
      copilot_cta_label: "",
      copilot_description: "",
      type: "product_tour",
      preview_url: null,
      custom_theme: null,
      editor_tags: []
    });
  }
});

// commandbar/src/shared/components/admin-facing/WidgetTableau/index.tsx
var WidgetTableau_exports = {};
__export(WidgetTableau_exports, {
  default: () => WidgetTableau_default
});
import React354, { forwardRef as forwardRef14 } from "react";
import panzoom2 from "panzoom";
var TOOLTIP_ANCHOR_ID, Col, Row, copilotInitialEntries, WidgetTableau, WidgetTableauCanvas, WidgetTableau_default;
var init_WidgetTableau = __esm({
  "commandbar/src/shared/components/admin-facing/WidgetTableau/index.tsx"() {
    "use strict";
    init_Spotlight();
    init_Checklist();
    init_Popover();
    init_RenderNudge();
    init_Pin();
    init_Tooltip2();
    init_useStore();
    init_AssistanceModal();
    init_mock_entities();
    init_service_selectors2();
    init_ThemeV2Context();
    init_Banner();
    TOOLTIP_ANCHOR_ID = "commandbar-theme-tableau-tooltip-nudge-anchor";
    Col = ({ children }) => /* @__PURE__ */ React354.createElement("div", { style: { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 32 } }, children);
    Row = ({ style: style3, children }) => /* @__PURE__ */ React354.createElement(
      "div",
      {
        style: { display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: 32, ...style3 }
      },
      children
    );
    copilotInitialEntries = [{ page: "mock-chat", params: {} }];
    WidgetTableau = forwardRef14((_props, ref12) => {
      const _ = useStore();
      const { mode } = useThemeV2Context();
      const { organization, widgetTableauSelection } = _;
      const PIN_NUDGE_MOCK = /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Pin_default,
        {
          pin: {
            nudge: nudgePin,
            isOpenByDefault: true,
            isShowingMask: false,
            offset: { x: "0px", y: "0px" },
            step: nudgePin.steps[0]
          },
          stepIndex: 0,
          renderMode: 1 /* MOCK */,
          style: {
            position: "static",
            transform: "none",
            width: "var(--popover-width)",
            height: 115
          }
        }
      ));
      const ANNOUNCEMENT_NUDGE_MOCK = /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(Popover3, { nudge: nudgeAnnouncement, stepIndex: 0, renderMode: 1 /* MOCK */ }));
      const LIST_SURVEY_MOCKS = /* @__PURE__ */ React354.createElement(Col, null, /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Popover3,
        {
          ref: (elem) => {
            if (!elem)
              return;
            const option = elem.querySelectorAll("[data-testid=survey-option]")[1];
            if (option instanceof HTMLElement)
              option.click();
          },
          nudge: nudgeSurveyOptionsSingle,
          stepIndex: 0,
          renderMode: 1 /* MOCK */
        }
      )), /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Popover3,
        {
          ref: (elem) => {
            if (!elem)
              return;
            const option = elem.querySelectorAll("[data-testid=survey-option]")[2];
            if (option instanceof HTMLElement)
              option.click();
          },
          nudge: nudgeSurveyOptionsMulti,
          stepIndex: 0,
          renderMode: 1 /* MOCK */
        }
      )));
      const HELPHUB_MOCK = /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(AssistanceModal_default, { style: { position: "static" }, key: "helphub" }));
      const SPOTLIGHT_MOCK = /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(Spotlight, null));
      const COPILOT_MOCK = /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        AssistanceModal_default,
        {
          style: { position: "static" },
          initialEntries: copilotInitialEntries,
          key: "copilot"
        }
      ));
      const CHECKLIST_MOCK = /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Checklist3,
        {
          style: { position: "static" },
          checklist: checklist2,
          isItemCompleted: (checklist3, item) => item === checklist3.items[1]
        }
      ));
      const TOOLTIP_MOCK = /* @__PURE__ */ React354.createElement(React354.Fragment, null, /* @__PURE__ */ React354.createElement("div", { style: { minHeight: "140px" } }, /* @__PURE__ */ React354.createElement("div", { id: TOOLTIP_ANCHOR_ID, style: { width: "16px", height: "16px" } }), /* @__PURE__ */ React354.createElement(
        Tooltip3,
        {
          nudge: nudgeTooltip,
          step: nudgeTooltip.steps[0],
          renderMode: 1 /* MOCK */,
          forceOpen: true,
          autoPlacement: false
        }
      )));
      const RATING_SURVEY_MOCKS = /* @__PURE__ */ React354.createElement(React354.Fragment, null, /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Popover3,
        {
          ref: (elem) => {
            if (!elem)
              return;
            const option = elem.querySelectorAll("[data-testid=survey-option]")[2];
            if (option instanceof HTMLElement)
              option.click();
          },
          nudge: nudgeStars,
          stepIndex: 0,
          renderMode: 1 /* MOCK */
        }
      )), /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Popover3,
        {
          ref: (elem) => {
            if (!elem)
              return;
            const option = elem.querySelectorAll("[data-testid=survey-option]")[1];
            if (option instanceof HTMLElement)
              option.click();
          },
          nudge: nudgeEmoji,
          stepIndex: 0,
          renderMode: 1 /* MOCK */
        }
      )), /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Popover3,
        {
          ref: (elem) => {
            if (!elem)
              return;
            const option = elem.querySelectorAll("[data-testid=survey-option]")[5];
            if (option instanceof HTMLElement)
              option.click();
          },
          nudge: nudgeRating,
          stepIndex: 0,
          renderMode: 1 /* MOCK */
        }
      )), /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
        Popover3,
        {
          ref: (elem) => {
            if (!elem)
              return;
            const option = elem.querySelectorAll("[data-testid=survey-option]")[10];
            if (option instanceof HTMLElement)
              option.click();
          },
          nudge: nudgeRating1to10,
          stepIndex: 0,
          renderMode: 1 /* MOCK */
        }
      )));
      const INPUT_SURVEY_MOCKS = /* @__PURE__ */ React354.createElement(Col, null, /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(Popover3, { nudge: nudgeSurveyOptionsDropdown, stepIndex: 0, renderMode: 1 /* MOCK */ })), /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(Popover3, { nudge: nudgeSurveyShortText, stepIndex: 0, renderMode: 1 /* MOCK */ })), /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(Popover3, { nudge: nudgeSurveyLongText, stepIndex: 0, renderMode: 1 /* MOCK */ })));
      const BANNER_MOCKS = /* @__PURE__ */ React354.createElement(Row, { style: { height: "100px" } }, /* @__PURE__ */ React354.createElement(Col, null, /* @__PURE__ */ React354.createElement("div", { style: { position: "relative", width: "900px" } }, /* @__PURE__ */ React354.createElement(Banner_default, { nudge: nudgeBanner, stepIndex: 0, renderMode: 1 /* MOCK */ }))));
      const SURVEY_MOCKS = /* @__PURE__ */ React354.createElement(React354.Fragment, null, /* @__PURE__ */ React354.createElement(Row, { style: { alignItems: "flex-end" } }, LIST_SURVEY_MOCKS, INPUT_SURVEY_MOCKS), /* @__PURE__ */ React354.createElement(Row, null, RATING_SURVEY_MOCKS));
      const TOUR_MOCKS = /* @__PURE__ */ React354.createElement(Row, null, /* @__PURE__ */ React354.createElement(Col, null, TOOLTIP_MOCK, PIN_NUDGE_MOCK));
      const getConfigNudgeMock = (nudgeId, stepIndex) => {
        const nudge = getNudgeById(_, nudgeId);
        if (!nudge) {
          return null;
        }
        if (nudge.steps[stepIndex].form_factor.type === "pin") {
          return /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
            Pin_default,
            {
              pin: {
                nudge,
                isOpenByDefault: true,
                isShowingMask: false,
                offset: { x: "0px", y: "0px" },
                step: nudge.steps[stepIndex]
              },
              stepIndex,
              renderMode: 1 /* MOCK */,
              style: {
                position: "static",
                transform: "none",
                width: "var(--popover-width)",
                height: 115
              }
            }
          ));
        } else if (nudge.steps[stepIndex].form_factor.type === "tooltip") {
          return /* @__PURE__ */ React354.createElement("div", { style: { minHeight: "140px" } }, /* @__PURE__ */ React354.createElement("div", { id: TOOLTIP_ANCHOR_ID, style: { width: "16px", height: "16px" } }), /* @__PURE__ */ React354.createElement(
            Tooltip3,
            {
              nudge,
              step: {
                ...nudge.steps[stepIndex],
                form_factor: { ...nudge.steps[stepIndex].form_factor, anchor: `//*[@id="${TOOLTIP_ANCHOR_ID}"]` }
              },
              renderMode: 1 /* MOCK */,
              forceOpen: true,
              autoPlacement: false
            }
          ));
        } else if (nudge.steps[stepIndex].form_factor.type === "banner") {
          return /* @__PURE__ */ React354.createElement(Row, { style: { height: "100px" } }, /* @__PURE__ */ React354.createElement(Col, null, /* @__PURE__ */ React354.createElement("div", { style: { position: "relative", width: "642px" } }, /* @__PURE__ */ React354.createElement(Banner_default, { nudge, stepIndex, renderMode: 1 /* MOCK */ }))));
        }
        return /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
          Popover3,
          {
            ref: (elem) => {
              if (!elem)
                return;
              const option = elem.querySelectorAll("[data-testid=survey-option]")[1];
              if (option instanceof HTMLElement) {
                option.click();
              }
            },
            nudge,
            stepIndex,
            renderMode: 1 /* MOCK */
          }
        ));
      };
      const getConfigChecklistMock = (checklistId) => {
        const checklist3 = _.checklists.find((checklist4) => checklist4.id === checklistId);
        if (!checklist3) {
          return null;
        }
        return /* @__PURE__ */ React354.createElement("div", null, /* @__PURE__ */ React354.createElement(
          Checklist3,
          {
            style: { position: "static" },
            checklist: { ...checklist3, _editorState: { expanded: true } },
            isItemCompleted: (checklist4, item) => item === checklist4.items[0]
          }
        ));
      };
      const allMockWidgets = /* @__PURE__ */ React354.createElement(React354.Fragment, null, BANNER_MOCKS, /* @__PURE__ */ React354.createElement(Row, { style: { alignItems: "flex-end" } }, /* @__PURE__ */ React354.createElement(Col, null, TOOLTIP_MOCK, PIN_NUDGE_MOCK, ANNOUNCEMENT_NUDGE_MOCK), LIST_SURVEY_MOCKS, INPUT_SURVEY_MOCKS), /* @__PURE__ */ React354.createElement(Row, null, RATING_SURVEY_MOCKS), /* @__PURE__ */ React354.createElement(Row, { style: { alignItems: "flex-start" } }, (organization == null ? void 0 : organization.bar_enabled) && SPOTLIGHT_MOCK, (organization == null ? void 0 : organization.helphub_enabled) && HELPHUB_MOCK, (organization == null ? void 0 : organization.copilot_enabled) && COPILOT_MOCK, CHECKLIST_MOCK));
      const renderWidgets = () => {
        switch (widgetTableauSelection.type) {
          case "nudge":
            if (widgetTableauSelection.id === "announcement") {
              return /* @__PURE__ */ React354.createElement(React354.Fragment, null, BANNER_MOCKS, ANNOUNCEMENT_NUDGE_MOCK);
            } else if (widgetTableauSelection.id === "tour") {
              return TOUR_MOCKS;
            } else if (widgetTableauSelection.id === "survey") {
              return SURVEY_MOCKS;
            } else if (typeof widgetTableauSelection.id === "number") {
              return getConfigNudgeMock(widgetTableauSelection.id, (widgetTableauSelection == null ? void 0 : widgetTableauSelection.nudgeStepIndex) || 0);
            } else {
              const nudgeId = parseInt(widgetTableauSelection.id);
              if (!Number.isNaN(nudgeId) && nudgeId > 0) {
                return getConfigNudgeMock(nudgeId, (widgetTableauSelection == null ? void 0 : widgetTableauSelection.nudgeStepIndex) || 0);
              }
            }
            break;
          case "checklist":
            if (typeof widgetTableauSelection.id === "number") {
              return getConfigChecklistMock(widgetTableauSelection.id);
            } else if (!Number.isNaN(parseInt(widgetTableauSelection.id))) {
              return getConfigChecklistMock(parseInt(widgetTableauSelection.id));
            } else {
              return CHECKLIST_MOCK;
            }
          case "spotlight":
            return SPOTLIGHT_MOCK;
          case "helphub":
            return HELPHUB_MOCK;
          case "copilot":
            return COPILOT_MOCK;
          case "collection":
            if (!widgetTableauSelection.widgets) {
              return null;
            }
            const hasFirstRow = widgetTableauSelection.widgets.includes("announcement") || widgetTableauSelection.widgets.includes("tour") || widgetTableauSelection.widgets.includes("survey");
            const hasFirstRowsFirstColumn = hasFirstRow && (widgetTableauSelection.widgets.includes("announcement") || widgetTableauSelection.widgets.includes("tour"));
            const hasLastRow = widgetTableauSelection.widgets.includes("spotlight") || widgetTableauSelection.widgets.includes("helphub") || widgetTableauSelection.widgets.includes("copilot") || widgetTableauSelection.widgets.includes("checklist");
            return /* @__PURE__ */ React354.createElement(React354.Fragment, null, widgetTableauSelection.widgets.includes("announcement") && BANNER_MOCKS, hasFirstRow && /* @__PURE__ */ React354.createElement(Row, { style: { alignItems: "flex-end" } }, hasFirstRowsFirstColumn && /* @__PURE__ */ React354.createElement(Col, null, widgetTableauSelection.widgets.includes("announcement") && TOOLTIP_MOCK, widgetTableauSelection.widgets.includes("tour") && PIN_NUDGE_MOCK, widgetTableauSelection.widgets.includes("announcement") && ANNOUNCEMENT_NUDGE_MOCK), widgetTableauSelection.widgets.includes("survey") && /* @__PURE__ */ React354.createElement(React354.Fragment, null, LIST_SURVEY_MOCKS, INPUT_SURVEY_MOCKS)), widgetTableauSelection.widgets.includes("survey") && /* @__PURE__ */ React354.createElement(React354.Fragment, null, /* @__PURE__ */ React354.createElement(Row, null, RATING_SURVEY_MOCKS)), hasLastRow && /* @__PURE__ */ React354.createElement(Row, { style: { alignItems: "flex-start" } }, widgetTableauSelection.widgets.includes("spotlight") && SPOTLIGHT_MOCK, widgetTableauSelection.widgets.includes("helphub") && HELPHUB_MOCK, widgetTableauSelection.widgets.includes("copilot") && COPILOT_MOCK, widgetTableauSelection.widgets.includes("checklist") && CHECKLIST_MOCK));
        }
        return allMockWidgets;
      };
      return /* @__PURE__ */ React354.createElement(
        "div",
        {
          style: {
            borderRadius: "8px",
            display: "inline-block",
            backgroundColor: mode === "light_mode" ? "#F9F9F9" : "#3F424A",
            /* TODO: deduplicate with commandbar.com/src/image/cb_dot_pattern.svg somehow */
            backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABZSURBVHgB7dG7DYBADANQJxexAiXSTXw9uyExBih34SOxQhr83Li2ASIiIiIiIvo7QbLW1jms1zijq9puSDaGLxhhuBPaqyKZTFK+/q6AZOJlg8shqv5ccAGZWRnaKiSy9QAAAABJRU5ErkJggg==)"
          }
        },
        /* @__PURE__ */ React354.createElement(
          "div",
          {
            ref: ref12,
            style: {
              // display: 'grid',
              // gridTemplateColumns: 'auto auto auto',
              // gridGap: 20,
              display: "flex",
              margin: 5e3,
              flexDirection: "column",
              gap: 32
            }
          },
          renderWidgets()
        )
      );
    });
    WidgetTableauCanvas = () => {
      const wrapperRef = React354.useRef(null);
      const contentRef = React354.useRef(null);
      const instance = React354.useRef(null);
      const ref12 = React354.useCallback((elem) => {
        if (!elem) {
          if (instance.current) {
            instance.current.dispose();
            instance.current = null;
          }
          return;
        }
        instance.current = panzoom2(elem, {
          autocenter: true,
          maxZoom: 1,
          minZoom: 0.4,
          zoomDoubleClickSpeed: 1,
          smoothScroll: false,
          initialZoom: 1
        });
        instance.current.on("pan", function() {
          document.body.style.cursor = "grab";
          elem.style["pointerEvents"] = "none";
        });
        instance.current.on("panend", function() {
          document.body.style.cursor = "auto";
          elem.style.removeProperty("pointer-events");
        });
        const content = elem.children[0];
        if (!content)
          return;
        const x = content.clientWidth / 2 - document.body.clientWidth / 2;
        const y = content.clientHeight / 2 - document.body.clientHeight / 2;
        instance.current.moveTo(-x, -y);
      }, []);
      return /* @__PURE__ */ React354.createElement(
        "div",
        {
          style: {
            position: "absolute",
            inset: 0,
            overflow: "clip"
          },
          ref: wrapperRef
        },
        /* @__PURE__ */ React354.createElement("div", { ref: ref12 }, /* @__PURE__ */ React354.createElement(WidgetTableau, { ref: contentRef }))
      );
    };
    WidgetTableau_default = WidgetTableauCanvas;
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/extends.js
function _extends4() {
  _extends4 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i2 = 1; i2 < arguments.length; i2++) {
      var source = arguments[i2];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends4.apply(this, arguments);
}
var init_extends3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/extends.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose3(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i2;
  for (i2 = 0; i2 < sourceKeys.length; i2++) {
    key = sourceKeys[i2];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}
var init_objectWithoutPropertiesLoose2 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties2(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose3(source, excluded);
  var key, i2;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i2 = 0; i2 < sourceSymbolKeys.length; i2++) {
      key = sourceSymbolKeys[i2];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}
var init_objectWithoutProperties2 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js"() {
    init_objectWithoutPropertiesLoose2();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var init_classCallCheck3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof5(o) {
  "@babel/helpers - typeof";
  return _typeof5 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof5(o);
}
var init_typeof5 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/typeof.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function _toPrimitive5(input, hint) {
  if (_typeof5(input) !== "object" || input === null)
    return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== void 0) {
    var res = prim.call(input, hint || "default");
    if (_typeof5(res) !== "object")
      return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
var init_toPrimitive5 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/toPrimitive.js"() {
    init_typeof5();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function _toPropertyKey5(arg) {
  var key = _toPrimitive5(arg, "string");
  return _typeof5(key) === "symbol" ? key : String(key);
}
var init_toPropertyKey5 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/toPropertyKey.js"() {
    init_typeof5();
    init_toPrimitive5();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties3(target, props2) {
  for (var i2 = 0; i2 < props2.length; i2++) {
    var descriptor = props2[i2];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey5(descriptor.key), descriptor);
  }
}
function _createClass3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
var init_createClass3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/createClass.js"() {
    init_toPropertyKey5();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf3(o, p) {
  _setPrototypeOf3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf4(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf3(o, p);
}
var init_setPrototypeOf3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits3(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf3(subClass, superClass);
}
var init_inherits3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/inherits.js"() {
    init_setPrototypeOf3();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf3(o) {
  _getPrototypeOf3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf4(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf3(o);
}
var init_getPrototypeOf3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct3() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
var init_isNativeReflectConstruct3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized3(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
var init_assertThisInitialized3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js"() {
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn3(self2, call) {
  if (call && (_typeof5(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized3(self2);
}
var init_possibleConstructorReturn3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js"() {
    init_typeof5();
    init_assertThisInitialized3();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper3(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct3();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf3(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf3(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn3(this, result);
  };
}
var init_createSuper3 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/createSuper.js"() {
    init_getPrototypeOf3();
    init_isNativeReflectConstruct3();
    init_possibleConstructorReturn3();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty5(obj, key, value) {
  key = _toPropertyKey5(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var init_defineProperty5 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/defineProperty.js"() {
    init_toPropertyKey5();
  }
});

// node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function ownKeys5(e, r) {
  var t44 = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t44.push.apply(t44, o);
  }
  return t44;
}
function _objectSpread24(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t44 = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys5(Object(t44), true).forEach(function(r2) {
      _defineProperty5(e, r2, t44[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t44)) : ownKeys5(Object(t44)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t44, r2));
    });
  }
  return e;
}
var init_objectSpread24 = __esm({
  "node_modules/rc-drawer/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"() {
    init_defineProperty5();
  }
});

// node_modules/rc-util/es/omit.js
function omit2(obj, fields) {
  var clone = _objectSpread22({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function(key) {
      delete clone[key];
    });
  }
  return clone;
}
var init_omit = __esm({
  "node_modules/rc-util/es/omit.js"() {
    init_objectSpread22();
  }
});

// node_modules/rc-drawer/es/utils.js
function dataToArray(vars) {
  if (Array.isArray(vars)) {
    return vars;
  }
  return [vars];
}
function addEventListener(target, eventType, callback, options) {
  if (target.addEventListener) {
    target.addEventListener(eventType, callback, options);
  } else if (target.attachEvent) {
    target.attachEvent("on".concat(eventType), callback);
  }
}
function removeEventListener(target, eventType, callback, options) {
  if (target.removeEventListener) {
    target.removeEventListener(eventType, callback, options);
  } else if (target.attachEvent) {
    target.detachEvent("on".concat(eventType), callback);
  }
}
function transformArguments(arg, cb) {
  var result = typeof arg === "function" ? arg(cb) : arg;
  if (Array.isArray(result)) {
    if (result.length === 2) {
      return result;
    }
    return [result[0], result[1]];
  }
  return [result];
}
var transitionEndObject, transitionStr, transitionEnd, isNumeric, windowIsUndefined, getTouchParentScroll;
var init_utils6 = __esm({
  "node_modules/rc-drawer/es/utils.js"() {
    transitionEndObject = {
      transition: "transitionend",
      WebkitTransition: "webkitTransitionEnd",
      MozTransition: "transitionend",
      OTransition: "oTransitionEnd otransitionend"
    };
    transitionStr = Object.keys(transitionEndObject).filter(function(key) {
      if (typeof document === "undefined") {
        return false;
      }
      var html = document.getElementsByTagName("html")[0];
      return key in (html ? html.style : {});
    })[0];
    transitionEnd = transitionEndObject[transitionStr];
    isNumeric = function isNumeric2(value) {
      return !isNaN(parseFloat(value)) && isFinite(value);
    };
    windowIsUndefined = !(typeof window !== "undefined" && window.document && window.document.createElement);
    getTouchParentScroll = function getTouchParentScroll2(root, currentTarget, differX, differY) {
      if (!currentTarget || currentTarget === document || currentTarget instanceof Document) {
        return false;
      }
      if (currentTarget === root.parentNode) {
        return true;
      }
      var isY = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differY);
      var isX = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differX);
      var scrollY = currentTarget.scrollHeight - currentTarget.clientHeight;
      var scrollX = currentTarget.scrollWidth - currentTarget.clientWidth;
      var style3 = document.defaultView.getComputedStyle(currentTarget);
      var overflowY = style3.overflowY === "auto" || style3.overflowY === "scroll";
      var overflowX = style3.overflowX === "auto" || style3.overflowX === "scroll";
      var y = scrollY && overflowY;
      var x = scrollX && overflowX;
      if (isY && (!y || y && (currentTarget.scrollTop >= scrollY && differY < 0 || currentTarget.scrollTop <= 0 && differY > 0)) || isX && (!x || x && (currentTarget.scrollLeft >= scrollX && differX < 0 || currentTarget.scrollLeft <= 0 && differX > 0))) {
        return getTouchParentScroll2(root, currentTarget.parentNode, differX, differY);
      }
      return false;
    };
  }
});

// node_modules/rc-drawer/es/DrawerChild.js
import * as React355 from "react";
var import_classnames6, _excluded3, currentDrawer, DrawerChild, DrawerChild_default;
var init_DrawerChild = __esm({
  "node_modules/rc-drawer/es/DrawerChild.js"() {
    init_extends3();
    init_objectSpread24();
    init_defineProperty5();
    init_objectWithoutProperties2();
    init_classCallCheck3();
    init_createClass3();
    init_assertThisInitialized3();
    init_inherits3();
    init_createSuper3();
    import_classnames6 = __toESM(require_classnames());
    init_getScrollBarSize();
    init_KeyCode();
    init_omit();
    init_utils6();
    _excluded3 = ["className", "children", "style", "width", "height", "defaultOpen", "open", "prefixCls", "placement", "level", "levelMove", "ease", "duration", "getContainer", "handler", "onChange", "afterVisibleChange", "showMask", "maskClosable", "maskStyle", "onClose", "onHandleClick", "keyboard", "getOpenCount", "scrollLocker", "contentWrapperStyle"];
    currentDrawer = {};
    DrawerChild = /* @__PURE__ */ function(_React$Component) {
      _inherits3(DrawerChild2, _React$Component);
      var _super = _createSuper3(DrawerChild2);
      function DrawerChild2(props2) {
        var _this;
        _classCallCheck3(this, DrawerChild2);
        _this = _super.call(this, props2);
        _this.levelDom = void 0;
        _this.dom = void 0;
        _this.contentWrapper = void 0;
        _this.contentDom = void 0;
        _this.maskDom = void 0;
        _this.handlerDom = void 0;
        _this.drawerId = void 0;
        _this.timeout = void 0;
        _this.passive = void 0;
        _this.startPos = void 0;
        _this.domFocus = function() {
          if (_this.dom) {
            _this.dom.focus();
          }
        };
        _this.removeStartHandler = function(e) {
          if (e.touches.length > 1) {
            _this.startPos = null;
            return;
          }
          _this.startPos = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY
          };
        };
        _this.removeMoveHandler = function(e) {
          if (e.changedTouches.length > 1 || !_this.startPos) {
            return;
          }
          var currentTarget = e.currentTarget;
          var differX = e.changedTouches[0].clientX - _this.startPos.x;
          var differY = e.changedTouches[0].clientY - _this.startPos.y;
          if ((currentTarget === _this.maskDom || currentTarget === _this.handlerDom || currentTarget === _this.contentDom && getTouchParentScroll(currentTarget, e.target, differX, differY)) && e.cancelable) {
            e.preventDefault();
          }
        };
        _this.transitionEnd = function(e) {
          var dom = e.target;
          removeEventListener(dom, transitionEnd, _this.transitionEnd);
          dom.style.transition = "";
        };
        _this.onKeyDown = function(e) {
          if (e.keyCode === KeyCode_default.ESC) {
            var onClose = _this.props.onClose;
            e.stopPropagation();
            if (onClose) {
              onClose(e);
            }
          }
        };
        _this.onWrapperTransitionEnd = function(e) {
          var _this$props = _this.props, open = _this$props.open, afterVisibleChange2 = _this$props.afterVisibleChange;
          if (e.target === _this.contentWrapper && e.propertyName.match(/transform$/)) {
            _this.dom.style.transition = "";
            if (!open && _this.getCurrentDrawerSome()) {
              document.body.style.overflowX = "";
              if (_this.maskDom) {
                _this.maskDom.style.left = "";
                _this.maskDom.style.width = "";
              }
            }
            if (afterVisibleChange2) {
              afterVisibleChange2(!!open);
            }
          }
        };
        _this.openLevelTransition = function() {
          var _this$props2 = _this.props, open = _this$props2.open, width = _this$props2.width, height = _this$props2.height;
          var _this$getHorizontalBo = _this.getHorizontalBoolAndPlacementName(), isHorizontal = _this$getHorizontalBo.isHorizontal, placementName = _this$getHorizontalBo.placementName;
          var contentValue = _this.contentDom ? _this.contentDom.getBoundingClientRect()[isHorizontal ? "width" : "height"] : 0;
          var value = (isHorizontal ? width : height) || contentValue;
          _this.setLevelAndScrolling(open, placementName, value);
        };
        _this.setLevelTransform = function(open, placementName, value, right) {
          var _this$props3 = _this.props, placement = _this$props3.placement, levelMove = _this$props3.levelMove, duration = _this$props3.duration, ease = _this$props3.ease, showMask2 = _this$props3.showMask;
          _this.levelDom.forEach(function(dom) {
            dom.style.transition = "transform ".concat(duration, " ").concat(ease);
            addEventListener(dom, transitionEnd, _this.transitionEnd);
            var levelValue = open ? value : 0;
            if (levelMove) {
              var $levelMove = transformArguments(levelMove, {
                target: dom,
                open
              });
              levelValue = open ? $levelMove[0] : $levelMove[1] || 0;
            }
            var $value = typeof levelValue === "number" ? "".concat(levelValue, "px") : levelValue;
            var placementPos = placement === "left" || placement === "top" ? $value : "-".concat($value);
            placementPos = showMask2 && placement === "right" && right ? "calc(".concat(placementPos, " + ").concat(right, "px)") : placementPos;
            dom.style.transform = levelValue ? "".concat(placementName, "(").concat(placementPos, ")") : "";
          });
        };
        _this.setLevelAndScrolling = function(open, placementName, value) {
          var onChange2 = _this.props.onChange;
          if (!windowIsUndefined) {
            var right = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth ? getScrollBarSize(true) : 0;
            _this.setLevelTransform(open, placementName, value, right);
            _this.toggleScrollingToDrawerAndBody(right);
          }
          if (onChange2) {
            onChange2(open);
          }
        };
        _this.toggleScrollingToDrawerAndBody = function(right) {
          var _this$props4 = _this.props, getContainer = _this$props4.getContainer, showMask2 = _this$props4.showMask, open = _this$props4.open;
          var container = getContainer && getContainer();
          if (container && container.parentNode === document.body && showMask2) {
            var eventArray = ["touchstart"];
            var domArray = [document.body, _this.maskDom, _this.handlerDom, _this.contentDom];
            if (open && document.body.style.overflow !== "hidden") {
              if (right) {
                _this.addScrollingEffect(right);
              }
              document.body.style.touchAction = "none";
              domArray.forEach(function(item, i2) {
                if (!item) {
                  return;
                }
                addEventListener(item, eventArray[i2] || "touchmove", i2 ? _this.removeMoveHandler : _this.removeStartHandler, _this.passive);
              });
            } else if (_this.getCurrentDrawerSome()) {
              document.body.style.touchAction = "";
              if (right) {
                _this.remScrollingEffect(right);
              }
              domArray.forEach(function(item, i2) {
                if (!item) {
                  return;
                }
                removeEventListener(item, eventArray[i2] || "touchmove", i2 ? _this.removeMoveHandler : _this.removeStartHandler, _this.passive);
              });
            }
          }
        };
        _this.addScrollingEffect = function(right) {
          var _this$props5 = _this.props, placement = _this$props5.placement, duration = _this$props5.duration, ease = _this$props5.ease;
          var widthTransition = "width ".concat(duration, " ").concat(ease);
          var transformTransition = "transform ".concat(duration, " ").concat(ease);
          _this.dom.style.transition = "none";
          switch (placement) {
            case "right":
              _this.dom.style.transform = "translateX(-".concat(right, "px)");
              break;
            case "top":
            case "bottom":
              _this.dom.style.width = "calc(100% - ".concat(right, "px)");
              _this.dom.style.transform = "translateZ(0)";
              break;
            default:
              break;
          }
          clearTimeout(_this.timeout);
          _this.timeout = setTimeout(function() {
            if (_this.dom) {
              _this.dom.style.transition = "".concat(transformTransition, ",").concat(widthTransition);
              _this.dom.style.width = "";
              _this.dom.style.transform = "";
            }
          });
        };
        _this.remScrollingEffect = function(right) {
          var _this$props6 = _this.props, placement = _this$props6.placement, duration = _this$props6.duration, ease = _this$props6.ease;
          if (transitionStr) {
            document.body.style.overflowX = "hidden";
          }
          _this.dom.style.transition = "none";
          var heightTransition;
          var widthTransition = "width ".concat(duration, " ").concat(ease);
          var transformTransition = "transform ".concat(duration, " ").concat(ease);
          switch (placement) {
            case "left": {
              _this.dom.style.width = "100%";
              widthTransition = "width 0s ".concat(ease, " ").concat(duration);
              break;
            }
            case "right": {
              _this.dom.style.transform = "translateX(".concat(right, "px)");
              _this.dom.style.width = "100%";
              widthTransition = "width 0s ".concat(ease, " ").concat(duration);
              if (_this.maskDom) {
                _this.maskDom.style.left = "-".concat(right, "px");
                _this.maskDom.style.width = "calc(100% + ".concat(right, "px)");
              }
              break;
            }
            case "top":
            case "bottom": {
              _this.dom.style.width = "calc(100% + ".concat(right, "px)");
              _this.dom.style.height = "100%";
              _this.dom.style.transform = "translateZ(0)";
              heightTransition = "height 0s ".concat(ease, " ").concat(duration);
              break;
            }
            default:
              break;
          }
          clearTimeout(_this.timeout);
          _this.timeout = setTimeout(function() {
            if (_this.dom) {
              _this.dom.style.transition = "".concat(transformTransition, ",").concat(heightTransition ? "".concat(heightTransition, ",") : "").concat(widthTransition);
              _this.dom.style.transform = "";
              _this.dom.style.width = "";
              _this.dom.style.height = "";
            }
          });
        };
        _this.getCurrentDrawerSome = function() {
          return !Object.keys(currentDrawer).some(function(key) {
            return currentDrawer[key];
          });
        };
        _this.getLevelDom = function(_ref) {
          var level = _ref.level, getContainer = _ref.getContainer;
          if (windowIsUndefined) {
            return;
          }
          var container = getContainer && getContainer();
          var parent = container ? container.parentNode : null;
          _this.levelDom = [];
          if (level === "all") {
            var children = parent ? Array.prototype.slice.call(parent.children) : [];
            children.forEach(function(child) {
              if (child.nodeName !== "SCRIPT" && child.nodeName !== "STYLE" && child.nodeName !== "LINK" && child !== container) {
                _this.levelDom.push(child);
              }
            });
          } else if (level) {
            dataToArray(level).forEach(function(key) {
              document.querySelectorAll(key).forEach(function(item) {
                _this.levelDom.push(item);
              });
            });
          }
        };
        _this.getHorizontalBoolAndPlacementName = function() {
          var placement = _this.props.placement;
          var isHorizontal = placement === "left" || placement === "right";
          var placementName = "translate".concat(isHorizontal ? "X" : "Y");
          return {
            isHorizontal,
            placementName
          };
        };
        _this.state = {
          _self: _assertThisInitialized3(_this)
        };
        return _this;
      }
      _createClass3(DrawerChild2, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;
          if (!windowIsUndefined) {
            var passiveSupported2 = false;
            try {
              window.addEventListener("test", null, Object.defineProperty({}, "passive", {
                get: function get10() {
                  passiveSupported2 = true;
                  return null;
                }
              }));
            } catch (err) {
            }
            this.passive = passiveSupported2 ? {
              passive: false
            } : false;
          }
          var _this$props7 = this.props, open = _this$props7.open, getContainer = _this$props7.getContainer, showMask2 = _this$props7.showMask, autoFocus = _this$props7.autoFocus;
          var container = getContainer && getContainer();
          this.drawerId = "drawer_id_".concat(Number((Date.now() + Math.random()).toString().replace(".", Math.round(Math.random() * 9).toString())).toString(16));
          this.getLevelDom(this.props);
          if (open) {
            if (container && container.parentNode === document.body) {
              currentDrawer[this.drawerId] = open;
            }
            this.openLevelTransition();
            this.forceUpdate(function() {
              if (autoFocus) {
                _this2.domFocus();
              }
            });
            if (showMask2) {
              var _this$props$scrollLoc;
              (_this$props$scrollLoc = this.props.scrollLocker) === null || _this$props$scrollLoc === void 0 ? void 0 : _this$props$scrollLoc.lock();
            }
          }
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps) {
          var _this$props8 = this.props, open = _this$props8.open, getContainer = _this$props8.getContainer, scrollLocker = _this$props8.scrollLocker, showMask2 = _this$props8.showMask, autoFocus = _this$props8.autoFocus;
          var container = getContainer && getContainer();
          if (open !== prevProps.open) {
            if (container && container.parentNode === document.body) {
              currentDrawer[this.drawerId] = !!open;
            }
            this.openLevelTransition();
            if (open) {
              if (autoFocus) {
                this.domFocus();
              }
              if (showMask2) {
                scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.lock();
              }
            } else {
              scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.unLock();
            }
          }
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          var _this$props9 = this.props, open = _this$props9.open, scrollLocker = _this$props9.scrollLocker;
          delete currentDrawer[this.drawerId];
          if (open) {
            this.setLevelTransform(false);
            document.body.style.touchAction = "";
          }
          scrollLocker === null || scrollLocker === void 0 ? void 0 : scrollLocker.unLock();
        }
      }, {
        key: "render",
        value: (
          // tslint:disable-next-line:member-ordering
          function render() {
            var _classnames, _this3 = this;
            var _this$props10 = this.props, className = _this$props10.className, children = _this$props10.children, style3 = _this$props10.style, width = _this$props10.width, height = _this$props10.height, defaultOpen2 = _this$props10.defaultOpen, $open = _this$props10.open, prefixCls = _this$props10.prefixCls, placement = _this$props10.placement, level = _this$props10.level, levelMove = _this$props10.levelMove, ease = _this$props10.ease, duration = _this$props10.duration, getContainer = _this$props10.getContainer, handler = _this$props10.handler, onChange2 = _this$props10.onChange, afterVisibleChange2 = _this$props10.afterVisibleChange, showMask2 = _this$props10.showMask, maskClosable = _this$props10.maskClosable, maskStyle = _this$props10.maskStyle, onClose = _this$props10.onClose, onHandleClick = _this$props10.onHandleClick, keyboard = _this$props10.keyboard, getOpenCount = _this$props10.getOpenCount, scrollLocker = _this$props10.scrollLocker, contentWrapperStyle = _this$props10.contentWrapperStyle, props2 = _objectWithoutProperties2(_this$props10, _excluded3);
            var open = this.dom ? $open : false;
            var wrapperClassName = (0, import_classnames6.default)(prefixCls, (_classnames = {}, _defineProperty5(_classnames, "".concat(prefixCls, "-").concat(placement), true), _defineProperty5(_classnames, "".concat(prefixCls, "-open"), open), _defineProperty5(_classnames, className || "", !!className), _defineProperty5(_classnames, "no-mask", !showMask2), _classnames));
            var _this$getHorizontalBo2 = this.getHorizontalBoolAndPlacementName(), placementName = _this$getHorizontalBo2.placementName;
            var placementPos = placement === "left" || placement === "top" ? "-100%" : "100%";
            var transform = open ? "" : "".concat(placementName, "(").concat(placementPos, ")");
            var handlerChildren = handler && /* @__PURE__ */ React355.cloneElement(handler, {
              onClick: function onClick(e) {
                if (handler.props.onClick) {
                  handler.props.onClick();
                }
                if (onHandleClick) {
                  onHandleClick(e);
                }
              },
              ref: function ref12(c) {
                _this3.handlerDom = c;
              }
            });
            return /* @__PURE__ */ React355.createElement("div", _extends4({}, omit2(props2, ["switchScrollingEffect", "autoFocus"]), {
              tabIndex: -1,
              className: wrapperClassName,
              style: style3,
              ref: function ref12(c) {
                _this3.dom = c;
              },
              onKeyDown: open && keyboard ? this.onKeyDown : void 0,
              onTransitionEnd: this.onWrapperTransitionEnd
            }), showMask2 && /* @__PURE__ */ React355.createElement("div", {
              className: "".concat(prefixCls, "-mask"),
              onClick: maskClosable ? onClose : void 0,
              style: maskStyle,
              ref: function ref12(c) {
                _this3.maskDom = c;
              }
            }), /* @__PURE__ */ React355.createElement("div", {
              className: "".concat(prefixCls, "-content-wrapper"),
              style: _objectSpread24({
                transform,
                msTransform: transform,
                width: isNumeric(width) ? "".concat(width, "px") : width,
                height: isNumeric(height) ? "".concat(height, "px") : height
              }, contentWrapperStyle),
              ref: function ref12(c) {
                _this3.contentWrapper = c;
              }
            }, /* @__PURE__ */ React355.createElement("div", {
              className: "".concat(prefixCls, "-content"),
              ref: function ref12(c) {
                _this3.contentDom = c;
              }
            }, children), handlerChildren));
          }
        )
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props2, _ref2) {
          var prevProps = _ref2.prevProps, _self = _ref2._self;
          var nextState = {
            prevProps: props2
          };
          if (prevProps !== void 0) {
            var placement = props2.placement, level = props2.level;
            if (placement !== prevProps.placement) {
              _self.contentDom = null;
            }
            if (level !== prevProps.level) {
              _self.getLevelDom(props2);
            }
          }
          return nextState;
        }
      }]);
      return DrawerChild2;
    }(React355.Component);
    DrawerChild_default = DrawerChild;
  }
});

// node_modules/rc-drawer/es/DrawerWrapper.js
import * as React356 from "react";
var _excluded4, _excluded22, DrawerWrapper, DrawerWrapper_default;
var init_DrawerWrapper = __esm({
  "node_modules/rc-drawer/es/DrawerWrapper.js"() {
    init_extends3();
    init_objectWithoutProperties2();
    init_classCallCheck3();
    init_createClass3();
    init_inherits3();
    init_createSuper3();
    init_PortalWrapper();
    init_DrawerChild();
    _excluded4 = ["defaultOpen", "getContainer", "wrapperClassName", "forceRender", "handler"];
    _excluded22 = ["visible", "afterClose"];
    DrawerWrapper = /* @__PURE__ */ function(_React$Component) {
      _inherits3(DrawerWrapper2, _React$Component);
      var _super = _createSuper3(DrawerWrapper2);
      function DrawerWrapper2(props2) {
        var _this;
        _classCallCheck3(this, DrawerWrapper2);
        _this = _super.call(this, props2);
        _this.dom = void 0;
        _this.onHandleClick = function(e) {
          var _this$props = _this.props, onHandleClick = _this$props.onHandleClick, $open = _this$props.open;
          if (onHandleClick) {
            onHandleClick(e);
          }
          if (typeof $open === "undefined") {
            var open = _this.state.open;
            _this.setState({
              open: !open
            });
          }
        };
        _this.onClose = function(e) {
          var _this$props2 = _this.props, onClose = _this$props2.onClose, open = _this$props2.open;
          if (onClose) {
            onClose(e);
          }
          if (typeof open === "undefined") {
            _this.setState({
              open: false
            });
          }
        };
        var _open = typeof props2.open !== "undefined" ? props2.open : !!props2.defaultOpen;
        _this.state = {
          open: _open
        };
        if ("onMaskClick" in props2) {
          console.warn("`onMaskClick` are removed, please use `onClose` instead.");
        }
        return _this;
      }
      _createClass3(DrawerWrapper2, [{
        key: "render",
        value: (
          // tslint:disable-next-line:member-ordering
          function render() {
            var _this2 = this;
            var _this$props3 = this.props, defaultOpen2 = _this$props3.defaultOpen, getContainer = _this$props3.getContainer, wrapperClassName = _this$props3.wrapperClassName, forceRender = _this$props3.forceRender, handler = _this$props3.handler, props2 = _objectWithoutProperties2(_this$props3, _excluded4);
            var open = this.state.open;
            if (!getContainer) {
              return /* @__PURE__ */ React356.createElement("div", {
                className: wrapperClassName,
                ref: function ref12(c) {
                  _this2.dom = c;
                }
              }, /* @__PURE__ */ React356.createElement(DrawerChild_default, _extends4({}, props2, {
                open,
                handler,
                getContainer: function getContainer2() {
                  return _this2.dom;
                },
                onClose: this.onClose,
                onHandleClick: this.onHandleClick
              })));
            }
            var $forceRender = !!handler || forceRender;
            return /* @__PURE__ */ React356.createElement(PortalWrapper_default, {
              visible: open,
              forceRender: $forceRender,
              getContainer,
              wrapperClassName
            }, function(_ref) {
              var visible = _ref.visible, afterClose = _ref.afterClose, rest = _objectWithoutProperties2(_ref, _excluded22);
              return (
                // react 15，componentWillUnmount 时 Portal 返回 afterClose, visible.
                /* @__PURE__ */ React356.createElement(DrawerChild_default, _extends4({}, props2, rest, {
                  open: visible !== void 0 ? visible : open,
                  afterVisibleChange: afterClose !== void 0 ? afterClose : props2.afterVisibleChange,
                  handler,
                  onClose: _this2.onClose,
                  onHandleClick: _this2.onHandleClick
                }))
              );
            });
          }
        )
      }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(props2, _ref2) {
          var prevProps = _ref2.prevProps;
          var newState = {
            prevProps: props2
          };
          if (typeof prevProps !== "undefined" && props2.open !== prevProps.open) {
            newState.open = props2.open;
          }
          return newState;
        }
      }]);
      return DrawerWrapper2;
    }(React356.Component);
    DrawerWrapper.defaultProps = {
      prefixCls: "drawer",
      placement: "left",
      getContainer: "body",
      defaultOpen: false,
      level: "all",
      duration: ".3s",
      ease: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
      onChange: function onChange() {
      },
      afterVisibleChange: function afterVisibleChange() {
      },
      handler: /* @__PURE__ */ React356.createElement("div", {
        className: "drawer-handle"
      }, /* @__PURE__ */ React356.createElement("i", {
        className: "drawer-handle-icon"
      })),
      showMask: true,
      maskClosable: true,
      maskStyle: {},
      wrapperClassName: "",
      className: "",
      keyboard: true,
      forceRender: false,
      autoFocus: true
    };
    DrawerWrapper_default = DrawerWrapper;
  }
});

// node_modules/rc-drawer/es/index.js
var es_default3;
var init_es3 = __esm({
  "node_modules/rc-drawer/es/index.js"() {
    init_DrawerWrapper();
    es_default3 = DrawerWrapper_default;
  }
});

// commandbar/src/shared/components/admin-facing/Editor/EditorHandle.tsx
import React357 from "react";
var EditorDragger, MIN_Y, _EditorHandle, EditorHandle, EditorHandle_default;
var init_EditorHandle = __esm({
  "commandbar/src/shared/components/admin-facing/Editor/EditorHandle.tsx"() {
    "use strict";
    init_LocalStorage();
    init_react();
    init_styled_browser_esm();
    init_Z();
    EditorDragger = styled_browser_esm_default.div`
  width: 5px;
  cursor: ew-resize;
  padding: 4px 0px 0px;
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  z-index: ${Z_default.Z_DRAGGERS};
  background-color: transparent;
  margin: 11px 0px;
`;
    MIN_Y = 50;
    _EditorHandle = (props2, ref12) => {
      const isMouseDown = React357.useRef(false);
      const isMovingHandle = React357.useRef(false);
      const yPositionAtMouseDown = React357.useRef(null);
      const yOffsetAtMouseDown = React357.useRef(null);
      const handleY = React357.useRef(parseInt(LocalStorage_default.get("handleY", "55").toString()));
      const [, forceUpdate] = React357.useReducer(() => ({}), {});
      const top = Math.max(handleY.current, MIN_Y);
      const MIN_DELTA = 100;
      const onMouseDown = (e) => {
        isMouseDown.current = true;
        yPositionAtMouseDown.current = e.clientY;
        yOffsetAtMouseDown.current = e.clientY - top;
      };
      const onMouseMove = (e) => {
        var _a2;
        if (!isMouseDown.current) {
          return;
        }
        const amountMovedIsSignificant = Math.abs((yPositionAtMouseDown.current || handleY.current) - e.clientY) > MIN_DELTA;
        if (amountMovedIsSignificant) {
          isMovingHandle.current = true;
        }
        const newPosition = e.clientY;
        const newPositionIsInView = newPosition < window.innerHeight && window.innerHeight - newPosition > MIN_DELTA;
        if (newPositionIsInView) {
          handleY.current = newPosition - ((_a2 = yOffsetAtMouseDown.current) != null ? _a2 : 0);
          forceUpdate();
        }
      };
      const onMouseUp = (e) => {
        if (isMouseDown.current) {
          if (isMovingHandle.current) {
            e.stopPropagation();
            isMovingHandle.current = false;
            LocalStorage_default.set("handleY", handleY.current);
          }
          isMouseDown.current = false;
        }
      };
      React357.useEffect(() => {
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("click", onMouseUp, { capture: true });
        return () => {
          document.removeEventListener("mousemove", onMouseMove);
          document.removeEventListener("click", onMouseUp, { capture: true });
        };
      }, []);
      return /* @__PURE__ */ React357.createElement(
        "div",
        {
          role: "button",
          ref: ref12,
          tabIndex: 0,
          onClick: () => {
            if (!isMovingHandle.current) {
              props2.toggleEditor();
            }
          },
          onKeyUp: (e) => {
            if (e.key === "Enter" && !isMovingHandle.current) {
              props2.toggleEditor();
            }
          },
          onMouseDown,
          className: "commandbar-editor-drawer-handle",
          "data-testid": "commandbar-editor-drawer-handle",
          "aria-expanded": props2.isEditorOpen,
          style: {
            borderRadius: "8px 0px 0px 8px",
            top,
            cursor: "pointer",
            userSelect: "none",
            WebkitUserSelect: "none",
            display: "flex",
            flexDirection: "column"
          }
        },
        /* @__PURE__ */ React357.createElement(
          "div",
          {
            id: "editor_nav",
            style: {
              border: `0.5px solid #0000001a`,
              borderRadius: "8px 0px 0px 8px",
              boxShadow: `0px 16px 24px rgba(36, 35, 41, 0.1), 0px 2px 4px rgba(36, 35, 41, 0.1), -2px 0px 4px 0px #0000000f inset`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#fff",
              position: "relative",
              width: "100%",
              flex: 1
            }
          },
          /* @__PURE__ */ React357.createElement(
            "div",
            {
              style: {
                position: "absolute",
                width: 10,
                height: "100%",
                left: 0,
                cursor: "grab"
              }
            }
          ),
          props2.isEditorOpen ? /* @__PURE__ */ React357.createElement(ChevronRightFilled_default, { height: 10 }) : /* @__PURE__ */ React357.createElement(ChevronLeftFilled_default, { height: 10 })
        )
      );
    };
    EditorHandle = React357.forwardRef(_EditorHandle);
    EditorHandle_default = EditorHandle;
  }
});

// commandbar/src/shared/components/admin-facing/Frame.tsx
import React358 from "react";
var _Frame, Frame, Frame_default;
var init_Frame = __esm({
  "commandbar/src/shared/components/admin-facing/Frame.tsx"() {
    "use strict";
    _Frame = (props2, ref12) => {
      const { id: id2, ...otherProps } = props2;
      return /* @__PURE__ */ React358.createElement(
        "iframe",
        {
          title: `commandbar-${id2}`,
          id: `commandbar-${id2}`,
          "data-testid": `commandbar-${id2}`,
          ...otherProps,
          ref: ref12
        }
      );
    };
    Frame = React358.forwardRef(_Frame);
    Frame_default = Frame;
  }
});

// commandbar/src/shared/components/admin-facing/Editor/EditorDrawer.tsx
import React359 from "react";
var MINIMUM_EDITOR_WIDTH, DRAWER_HANDLE_WIDTH, classNameMatcher, ELEMENT_CLASS_NAMES, EditorDrawer, EditorDrawer_default;
var init_EditorDrawer = __esm({
  "commandbar/src/shared/components/admin-facing/Editor/EditorDrawer.tsx"() {
    "use strict";
    init_Z();
    init_useWindowSize();
    init_es3();
    init_EditorHandle();
    init_LocalStorage();
    init_Frame();
    MINIMUM_EDITOR_WIDTH = 525;
    DRAWER_HANDLE_WIDTH = 41;
    classNameMatcher = (event) => (classNames7) => classNames7.some((className) => event.target.className.includes(className));
    ELEMENT_CLASS_NAMES = {
      // elements that should be pushed left by the size of the open editor
      normal: ["commandbar-launcher", "commandbar-checklist"],
      // elements that should be pushed and avoid being covered by the editor handle
      fullHeight: ["commandbar-helphub-levelmove"],
      // elements that should center between the open editor and left window side
      centered: ["commandbar-dialog", "commandbar-popover-container"]
    };
    EditorDrawer = ({ src, open, width, handler, onResizeEditor, onLevelMove }) => {
      var _a2;
      const [isResizing, setIsResizing] = React359.useState(false);
      const windowSize = useWindowSize_default();
      const frameRef = React359.useRef(null);
      const handleMouseDown = (_e) => {
        if (!!frameRef.current) {
          frameRef.current.style.pointerEvents = "none";
        }
        setIsResizing(true);
      };
      const handleMouseMove = (e) => {
        if (!isResizing) {
          return;
        }
        const offsetRight = document.body.offsetWidth - (e.clientX - document.body.offsetLeft);
        const minWidth = MINIMUM_EDITOR_WIDTH;
        const maxWidth = document.body.clientWidth - 100;
        if (offsetRight > minWidth && offsetRight < maxWidth) {
          onResizeEditor(offsetRight);
        }
      };
      const handleMouseUp = (_e) => {
        if (isResizing) {
          if (!!frameRef.current) {
            frameRef.current.style.pointerEvents = "auto";
          }
          LocalStorage_default.set("width", width);
          setIsResizing(false);
          onLevelMove();
        }
      };
      React359.useEffect(() => {
        document.addEventListener("mousemove", handleMouseMove);
        document.addEventListener("mouseup", handleMouseUp);
        return () => {
          document.removeEventListener("mousemove", handleMouseMove);
          document.removeEventListener("mouseup", handleMouseUp);
        };
      });
      const calcLevelMoveCentered = (target) => {
        const targetWidth = target.getBoundingClientRect().width;
        const spaceToTheRight = (windowSize.width - targetWidth) / 2 - 140;
        return spaceToTheRight < width ? Math.round(width - spaceToTheRight) : 0;
      };
      const calcLevelMove = (target, additionalOffset = 0) => {
        if (!open) {
          delete target.dataset.levelMoved;
          return 0;
        }
        const bounds = target.getBoundingClientRect();
        const offsetRight = window.innerWidth - bounds.x - bounds.width;
        const isMoved = target.dataset.levelMoved === "true";
        if (offsetRight < width || isMoved) {
          target.dataset.levelMoved = "true";
          return Math.round(width + additionalOffset);
        }
        return 0;
      };
      const levelMove = (event) => {
        const targetIncludesClassName = classNameMatcher(event);
        let levelMoveValue = 0;
        if (targetIncludesClassName(ELEMENT_CLASS_NAMES.normal)) {
          levelMoveValue = calcLevelMove(event.target);
        } else if (targetIncludesClassName(ELEMENT_CLASS_NAMES.fullHeight)) {
          levelMoveValue = calcLevelMove(event.target, DRAWER_HANDLE_WIDTH);
        } else if (targetIncludesClassName(ELEMENT_CLASS_NAMES.centered)) {
          levelMoveValue = calcLevelMoveCentered(event.target);
        }
        return [levelMoveValue, 1];
      };
      return /* @__PURE__ */ React359.createElement(
        es_default3,
        {
          getContainer: (_a2 = document.getElementById("commandbar-editor-mount")) != null ? _a2 : void 0,
          prefixCls: "commandbar-editor-drawer",
          placement: "right",
          open,
          width: `${width + 10}px`,
          level: [
            ".commandbar-dialog",
            ".commandbar-launcher",
            ".commandbar-popover-container",
            ".commandbar-checklist",
            ".commandbar-helphub-levelmove"
          ],
          levelMove,
          handler,
          style: {
            outline: "none",
            // HACK: For some reason, the Drawer component doesn't respect the zIndex and
            // an additional step up is needed for the drawer handle
            zIndex: Z_default.Z_EDITOR + 1
          },
          maskClosable: false,
          showMask: false,
          autoFocus: false,
          id: "commandbar-editor-drawer",
          "data-testid": "commandbar-editor-drawer"
        },
        /* @__PURE__ */ React359.createElement(
          EditorDragger,
          {
            id: "dragger",
            onMouseDown: (event) => {
              handleMouseDown(event);
            }
          }
        ),
        /* @__PURE__ */ React359.createElement(
          Frame_default,
          {
            ref: frameRef,
            id: "editor",
            src,
            allow: "clipboard-read; clipboard-write",
            width: "98%",
            height: "100%",
            style: { border: "0px", backgroundColor: "rgb(242,242,242)", borderRadius: 12 }
          }
        )
      );
    };
    EditorDrawer.Handle = EditorHandle_default;
    EditorDrawer_default = EditorDrawer;
  }
});

// commandbar/src/shared/components/admin-facing/Sender.ts
var sleep, pollForElementById, waitForElementLoad, checkEditorLoadState, pollForEditorReady, calculateRemainingTime, editorIFrameLoaded, waitForEditorToLoad, onEditorVisibleChange, onClickRecorderComplete, onRouteChange, Sender, Sender_default;
var init_Sender = __esm({
  "commandbar/src/shared/components/admin-facing/Sender.ts"() {
    "use strict";
    init_Portal2();
    sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
    pollForElementById = (elementId, interval = 100, timeout = 1e3) => new Promise((resolve) => {
      const pollForEditorElement = setInterval(() => {
        const editorElement = document.getElementById(elementId);
        if (editorElement) {
          clearInterval(pollForEditorElement);
          resolve(editorElement);
        }
      }, interval);
      setTimeout(() => {
        clearInterval(pollForEditorElement);
        resolve(null);
      }, timeout);
    });
    waitForElementLoad = (element, timeout = 1e3) => new Promise((resolve) => {
      element.addEventListener("load", () => {
        resolve(true);
      });
      setTimeout(() => {
        resolve(false);
      }, timeout);
    });
    checkEditorLoadState = async (timeout) => Promise.race([
      Portal_default2.openChannel("editor")({
        action: "waitForEditorToLoad",
        sender: "commandbar"
      }).then(() => true),
      sleep(timeout).then(() => false)
    ]);
    pollForEditorReady = async (interval, timeout) => new Promise((resolve) => {
      const pollForReady = setInterval(async () => {
        const isReady = await checkEditorLoadState(250);
        if (isReady) {
          clearInterval(pollForReady);
          resolve(true);
        }
      }, interval);
      setTimeout(() => {
        clearInterval(pollForReady);
        resolve(false);
      }, timeout);
    });
    calculateRemainingTime = (endTime) => endTime - Date.now();
    editorIFrameLoaded = false;
    waitForEditorToLoad = async (timeout = 1500, interval = 100) => {
      const timerEnd = Date.now() + timeout;
      if (editorIFrameLoaded) {
        return await pollForEditorReady(interval, calculateRemainingTime(timerEnd));
      }
      const editorElement = await pollForElementById(
        "commandbar-editor",
        interval,
        calculateRemainingTime(timerEnd)
      );
      if (editorElement) {
        editorIFrameLoaded = await waitForElementLoad(editorElement, calculateRemainingTime(timerEnd));
        if (editorIFrameLoaded) {
          return await pollForEditorReady(interval, calculateRemainingTime(timerEnd));
        }
      }
      return false;
    };
    onEditorVisibleChange = async (visible) => {
      const msg = {
        action: "onEditorVisibleChange",
        data: visible,
        sender: "commandbar"
      };
      return await Portal_default2.openChannel("editor")(msg);
    };
    onClickRecorderComplete = async (selectors, id2) => {
      const msg = {
        action: "onClickRecorderComplete",
        selectors,
        id: id2,
        sender: "commandbar"
      };
      return await Portal_default2.openChannel("editor")(msg);
    };
    onRouteChange = (selectedRoute, type39 = "push") => {
      const msg = {
        action: "onRouteChange",
        selectedRoute,
        type: type39,
        sender: "commandbar"
      };
      return Portal_default2.openChannel("editor")(msg);
    };
    Sender = {
      waitForEditorToLoad,
      onEditorVisibleChange,
      onClickRecorderComplete,
      onRouteChange
    };
    Sender_default = Sender;
  }
});

// node_modules/@medv/finder/finder.js
function finder(input, options) {
  start = /* @__PURE__ */ new Date();
  if (input.nodeType !== Node.ELEMENT_NODE) {
    throw new Error(`Can't generate CSS selector for non-element node type.`);
  }
  if ("html" === input.tagName.toLowerCase()) {
    return "html";
  }
  const defaults11 = {
    root: document.body,
    idName: (name) => true,
    className: (name) => true,
    tagName: (name) => true,
    attr: (name, value) => false,
    seedMinLength: 1,
    optimizedMinLength: 2,
    threshold: 1e3,
    maxNumberOfTries: 1e4,
    timeoutMs: void 0
  };
  config = { ...defaults11, ...options };
  rootDocument = findRootDocument(config.root, defaults11);
  let path = bottomUpSearch(input, "all", () => bottomUpSearch(input, "two", () => bottomUpSearch(input, "one", () => bottomUpSearch(input, "none"))));
  if (path) {
    const optimized = sort(optimize(path, input));
    if (optimized.length > 0) {
      path = optimized[0];
    }
    return selector(path);
  } else {
    throw new Error(`Selector was not found.`);
  }
}
function findRootDocument(rootNode, defaults11) {
  if (rootNode.nodeType === Node.DOCUMENT_NODE) {
    return rootNode;
  }
  if (rootNode === defaults11.root) {
    return rootNode.ownerDocument;
  }
  return rootNode;
}
function bottomUpSearch(input, limit, fallback) {
  let path = null;
  let stack = [];
  let current = input;
  let i2 = 0;
  while (current) {
    const elapsedTime = (/* @__PURE__ */ new Date()).getTime() - start.getTime();
    if (config.timeoutMs !== void 0 && elapsedTime > config.timeoutMs) {
      throw new Error(`Timeout: Can't find a unique selector after ${elapsedTime}ms`);
    }
    let level = maybe(id(current)) || maybe(...attr(current)) || maybe(...classNames6(current)) || maybe(tagName(current)) || [any12()];
    const nth = index2(current);
    if (limit == "all") {
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map((node) => nthChild(node, nth)));
      }
    } else if (limit == "two") {
      level = level.slice(0, 1);
      if (nth) {
        level = level.concat(level.filter(dispensableNth).map((node) => nthChild(node, nth)));
      }
    } else if (limit == "one") {
      const [node] = level = level.slice(0, 1);
      if (nth && dispensableNth(node)) {
        level = [nthChild(node, nth)];
      }
    } else if (limit == "none") {
      level = [any12()];
      if (nth) {
        level = [nthChild(level[0], nth)];
      }
    }
    for (let node of level) {
      node.level = i2;
    }
    stack.push(level);
    if (stack.length >= config.seedMinLength) {
      path = findUniquePath(stack, fallback);
      if (path) {
        break;
      }
    }
    current = current.parentElement;
    i2++;
  }
  if (!path) {
    path = findUniquePath(stack, fallback);
  }
  if (!path && fallback) {
    return fallback();
  }
  return path;
}
function findUniquePath(stack, fallback) {
  const paths = sort(combinations(stack));
  if (paths.length > config.threshold) {
    return fallback ? fallback() : null;
  }
  for (let candidate of paths) {
    if (unique(candidate)) {
      return candidate;
    }
  }
  return null;
}
function selector(path) {
  let node = path[0];
  let query = node.name;
  for (let i2 = 1; i2 < path.length; i2++) {
    const level = path[i2].level || 0;
    if (node.level === level - 1) {
      query = `${path[i2].name} > ${query}`;
    } else {
      query = `${path[i2].name} ${query}`;
    }
    node = path[i2];
  }
  return query;
}
function penalty(path) {
  return path.map((node) => node.penalty).reduce((acc, i2) => acc + i2, 0);
}
function unique(path) {
  const css79 = selector(path);
  switch (rootDocument.querySelectorAll(css79).length) {
    case 0:
      throw new Error(`Can't select any node with this selector: ${css79}`);
    case 1:
      return true;
    default:
      return false;
  }
}
function id(input) {
  const elementId = input.getAttribute("id");
  if (elementId && config.idName(elementId)) {
    return {
      name: "#" + CSS.escape(elementId),
      penalty: 0
    };
  }
  return null;
}
function attr(input) {
  const attrs = Array.from(input.attributes).filter((attr2) => config.attr(attr2.name, attr2.value));
  return attrs.map((attr2) => ({
    name: `[${CSS.escape(attr2.name)}="${CSS.escape(attr2.value)}"]`,
    penalty: 0.5
  }));
}
function classNames6(input) {
  const names = Array.from(input.classList).filter(config.className);
  return names.map((name) => ({
    name: "." + CSS.escape(name),
    penalty: 1
  }));
}
function tagName(input) {
  const name = input.tagName.toLowerCase();
  if (config.tagName(name)) {
    return {
      name,
      penalty: 2
    };
  }
  return null;
}
function any12() {
  return {
    name: "*",
    penalty: 3
  };
}
function index2(input) {
  const parent = input.parentNode;
  if (!parent) {
    return null;
  }
  let child = parent.firstChild;
  if (!child) {
    return null;
  }
  let i2 = 0;
  while (child) {
    if (child.nodeType === Node.ELEMENT_NODE) {
      i2++;
    }
    if (child === input) {
      break;
    }
    child = child.nextSibling;
  }
  return i2;
}
function nthChild(node, i2) {
  return {
    name: node.name + `:nth-child(${i2})`,
    penalty: node.penalty + 1
  };
}
function dispensableNth(node) {
  return node.name !== "html" && !node.name.startsWith("#");
}
function maybe(...level) {
  const list2 = level.filter(notEmpty);
  if (list2.length > 0) {
    return list2;
  }
  return null;
}
function notEmpty(value) {
  return value !== null && value !== void 0;
}
function* combinations(stack, path = []) {
  if (stack.length > 0) {
    for (let node of stack[0]) {
      yield* combinations(stack.slice(1, stack.length), path.concat(node));
    }
  } else {
    yield path;
  }
}
function sort(paths) {
  return [...paths].sort((a, b) => penalty(a) - penalty(b));
}
function* optimize(path, input, scope = {
  counter: 0,
  visited: /* @__PURE__ */ new Map()
}) {
  if (path.length > 2 && path.length > config.optimizedMinLength) {
    for (let i2 = 1; i2 < path.length - 1; i2++) {
      if (scope.counter > config.maxNumberOfTries) {
        return;
      }
      scope.counter += 1;
      const newPath = [...path];
      newPath.splice(i2, 1);
      const newPathKey = selector(newPath);
      if (scope.visited.has(newPathKey)) {
        return;
      }
      if (unique(newPath) && same(newPath, input)) {
        yield newPath;
        scope.visited.set(newPathKey, true);
        yield* optimize(newPath, input, scope);
      }
    }
  }
}
function same(path, input) {
  return rootDocument.querySelector(selector(path)) === input;
}
var config, rootDocument, start;
var init_finder = __esm({
  "node_modules/@medv/finder/finder.js"() {
  }
});

// internal/src/client/Recorder/RecorderFocusMask.tsx
import React360 from "react";
var Container26, MaskArea, LABEL_HEIGHT, Label4, truncateSelector, getLabelPositionStyles, RecorderFocusMask;
var init_RecorderFocusMask = __esm({
  "internal/src/client/Recorder/RecorderFocusMask.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_Z();
    Container26 = styled_browser_esm_default.div`
  top: ${(props2) => props2.top}px;
  left: ${(props2) => props2.left}px;
  display: ${(props2) => props2.display};
  position: fixed;
  z-index: ${Z_default.Z_INDEX_MAX.toString()};
  pointer-events: none;

  display: flex;
  flex-direction: column;
  align-items: center;
`;
    MaskArea = styled_browser_esm_default.div`
  outline: 2px solid #4497f7;
  background: rgba(68, 151, 247, 0.1);
  transition: all 100ms ease-in-out;
  width: ${(props2) => props2.width}px;
  height: ${(props2) => props2.height}px;
`;
    LABEL_HEIGHT = 100;
    Label4 = styled_browser_esm_default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${LABEL_HEIGHT}px;
  width: 350px;
  overflow: auto;
  padding: 0 8px;
  border-radius: 4px;
  background-color: #4497f7;
  color: #fff;
  font-size: 12px;
  font-weight: 500;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  ${(props2) => props2.positionStyles}
`;
    truncateSelector = (selector2) => {
      if (!selector2) {
        return;
      }
      const MAX_LENGTH = 200;
      if (selector2.length <= MAX_LENGTH) {
        return selector2;
      }
      return `${selector2.substring(0, MAX_LENGTH)}...]`;
    };
    getLabelPositionStyles = (top, height, left, width) => {
      const VERTICAL_THRESHHOLD = 100;
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const bottomBoundOfVisableScreen = scrollTop + window.innerHeight;
      const bottomBoundOfMask = top + height;
      if (bottomBoundOfMask + VERTICAL_THRESHHOLD + scrollTop < bottomBoundOfVisableScreen) {
        return "top: calc(100% + 8px);";
      }
      if (top >= VERTICAL_THRESHHOLD) {
        return `top: calc(-${LABEL_HEIGHT}px - 8px);`;
      }
      if (bottomBoundOfMask > window.innerHeight) {
        return `
      position: fixed;
      bottom: ${LABEL_HEIGHT + 8}px;
      left: ${left + width / 2}px;
      transform: translateX(-50%);
    `;
      }
      return `
    bottom: ${LABEL_HEIGHT + 8}px;
  `;
    };
    RecorderFocusMask = ({ selector: selector2, top, left, display: display2, width, height }) => {
      const truncatedSelector = truncateSelector(selector2);
      const labelPosition = getLabelPositionStyles(top, height, left, width);
      return /* @__PURE__ */ React360.createElement(Container26, { top, left, display: display2 }, /* @__PURE__ */ React360.createElement(MaskArea, { width, height }), truncatedSelector && /* @__PURE__ */ React360.createElement(Label4, { positionStyles: labelPosition }, truncatedSelector));
    };
  }
});

// internal/src/client/Recorder/index.tsx
import * as React361 from "react";
var Info, mouseWithin, getNudgeDisplayValues, hideNudges, DIGITS, LETTERS, STYLED_COMPONENTS_REGEXP, EMOTION_PREFIX_REGEXP, PROBABLY_AUTO_GENERATED, findSelector, getElementText, Recorder, Recorder_default;
var init_Recorder = __esm({
  "internal/src/client/Recorder/index.tsx"() {
    "use strict";
    init_styled_browser_esm();
    init_finder();
    init_operatingSystem();
    init_RecorderFocusMask();
    init_sentry();
    Info = styled_browser_esm_default.div`
  box-sizing: border-box;
  position: fixed;
  top: 8px;
  left: 50%;
  transform: translateX(-50%);
  width: 500px;
  padding: 12px 16px;
  border-radius: 100px;
  background-color: #0a0a0f;
  color: #fff;
  text-align: center;
  pointer-events: none;

  visibility: ${({ hide: hide4 }) => hide4 ? "hidden" : "visible"};
`;
    mouseWithin = (element, { clientX, clientY }) => {
      if (element) {
        const { width, height, top, left } = element.getBoundingClientRect();
        const maxX = left + width;
        const maxy = top + height;
        return clientY <= maxy && clientY >= top && clientX <= maxX && clientX >= left;
      }
      return false;
    };
    getNudgeDisplayValues = () => {
      const nudgeSelectors = [
        "#commandbar-nudge-container",
        ".rc-dialog-root",
        '[data-testid="commandbar-nudge-mask"]',
        '[data-testid="commandbar-nudge-mask-inner"]'
      ];
      return nudgeSelectors.map((selector2) => {
        const element = document.querySelector(selector2);
        if (element instanceof HTMLElement) {
          const originalDisplay = element.style.display;
          return {
            element,
            originalDisplay: originalDisplay === "" ? "unset" : originalDisplay
          };
        }
        return null;
      }).filter((nudgeData) => Boolean(nudgeData));
    };
    hideNudges = (nudges) => {
      nudges.forEach(({ element }) => {
        element.style.display = "none";
      });
    };
    DIGITS = "[0-9]";
    LETTERS = "[a-zA-Z]";
    STYLED_COMPONENTS_REGEXP = new RegExp(`sc-(${DIGITS}|${LETTERS}){6,}.${LETTERS}{6}`);
    EMOTION_PREFIX_REGEXP = new RegExp(`css-(${DIGITS}|${LETTERS}){6,}`);
    PROBABLY_AUTO_GENERATED = /^[a-zA-Z]{3,}\d{2,}[-_a-zA-Z\d]*$|^[a-zA-Z]{2,}[-_]\d{2,}[-_a-zA-Z\d]*$/;
    findSelector = (el) => {
      const allowedIds = (name) => {
        const dynamicIdRegex = /^(radix-|react-|ng-|vue-|ui-|bs-|mui-).*$/;
        return !name.match(dynamicIdRegex);
      };
      const allowedClassNames = (name) => {
        return !PROBABLY_AUTO_GENERATED.test(name) && !STYLED_COMPONENTS_REGEXP.test(name) && !EMOTION_PREFIX_REGEXP.test(name);
      };
      const allowedAttributes = (name) => {
        const attributes2 = ["aria-label", "name", "role", "data-testid", "data-test-id", "title"];
        return attributes2.includes(name);
      };
      return finder(el, {
        root: document.body,
        // Root of search, defaults to document.body.
        idName: allowedIds,
        // Check if this ID can be used.
        className: allowedClassNames,
        // Check if this class name can be used.
        attr: allowedAttributes,
        // Check if attr name can be used.
        seedMinLength: 1,
        optimizedMinLength: 2,
        threshold: 1e3,
        maxNumberOfTries: 1e4,
        timeoutMs: void 0
      });
    };
    getElementText = (el) => {
      var _a2;
      const text = (_a2 = el.textContent) == null ? void 0 : _a2.trim().replace(/\n\s+/g, " ");
      if (text && text.length > 150) {
        return text.slice(0, 150);
      }
      return text;
    };
    Recorder = class extends React361.Component {
      constructor(props2) {
        super(props2);
        /*********** Workaround to focus on this component on mount **********/
        this.stealFocus = () => {
          const wrapper = document.getElementById("commandbar-recorder-mask");
          this.focusElement = document.createElement("div");
          this.focusElement.style.position = "fixed";
          this.focusElement.tabIndex = -1;
          if (wrapper) {
            wrapper.appendChild(this.focusElement);
            this.focusElement.focus();
          }
        };
        this.removeFocusElement = () => {
          const wrapper = document.getElementById("commandbar-recorder-mask");
          if (this.focusElement && wrapper) {
            wrapper.removeChild(this.focusElement);
          }
        };
        /********************** Set up and tear down event handlers **********/
        this.setupWrapperOnMount = () => {
          document.body.appendChild(this.state.recorderMask);
        };
        this.componentDidMount = () => {
          this.setupWrapperOnMount();
          this.stealFocus();
          document.addEventListener("click", this.disableEvents, true);
          document.addEventListener("mouseover", this.onMouseOverElement);
          document.addEventListener("mousedown", this.onMouseDownElement);
          document.addEventListener("keydown", this.handleKeydown);
          document.addEventListener("keyup", this.handleKeyup);
          document.addEventListener("mousemove", this.toggleInfoDisplay);
        };
        this.componentWillUnmount = () => {
          this.removeFocusElement();
          document.removeEventListener("mouseover", this.onMouseOverElement);
          document.removeEventListener("mousedown", this.onMouseDownElement);
          document.removeEventListener("keydown", this.handleKeydown);
          document.removeEventListener("keyup", this.handleKeyup);
          document.removeEventListener("mousemove", this.toggleInfoDisplay);
          setTimeout(() => {
            document.removeEventListener("click", this.disableEvents, true);
          }, 500);
          document.body.removeChild(this.state.recorderMask);
        };
        /********************** Core functions **********/
        this.cancel = () => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Recorder cancel" });
          this.setState({ mask: { ...this.state.mask, display: "none" } });
          this.setState({ selectors: [], isFindingCSS: false });
          this.state.nudges.forEach(({ element, originalDisplay }) => {
            element.style.display = originalDisplay;
          });
          this.props.onSave([]);
        };
        this.finish = () => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Recorder finish" });
          this.setState({ mask: { ...this.state.mask, display: "none" } });
          this.setState({ isFindingCSS: false });
        };
        this.save = () => {
          var _a2;
          if (this.state.isContinuingRecording) {
            return;
          }
          this.state.nudges.forEach(({ element, originalDisplay }) => {
            element.style.display = originalDisplay;
          });
          (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Recorder save" });
          this.setState({ mask: { ...this.state.mask, display: "none" } });
          this.setState({ isFindingCSS: false });
          this.props.onSave(this.state.selectors);
        };
        this.start = () => {
          var _a2;
          (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Recorder start" });
          this.setState({ isFindingCSS: true });
        };
        /********************** Event handlers **********************/
        this.disableEvents = (e) => {
          if (this.state.isContinuingRecording) {
            return;
          }
          e.stopPropagation();
          e.preventDefault();
        };
        // Shortcuts to save, escape, pause, play
        this.handleKeydown = (e) => {
          var _a2, _b2, _c2;
          const triggerKey = getTriggerKey(e);
          if (e.key === "Shift") {
            this.setState({ isContinuingRecording: true });
          }
          if (triggerKey && e.key === "s") {
            (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Recorder shortcut save" });
            e.preventDefault();
            e.stopPropagation();
            this.save();
          }
          if (e.key === "Escape") {
            (_b2 = getSentry()) == null ? void 0 : _b2.addBreadcrumb({ category: "recorder", message: "Recorder shortcut escape" });
            e.preventDefault();
            e.stopPropagation();
            this.cancel();
          }
          if (e.code === "Space") {
            (_c2 = getSentry()) == null ? void 0 : _c2.addBreadcrumb({ category: "recorder", message: "Recorder shortcut space" });
            e.preventDefault();
            e.stopPropagation();
            if (this.state.isFindingCSS) {
              this.finish();
            } else {
              this.start();
            }
          }
        };
        this.handleKeyup = (e) => {
          if (e.key === "Shift") {
            this.setState({ isContinuingRecording: false }, () => {
              if (this.state.selectors.length > 0) {
                this.save();
              }
            });
          }
        };
        this.moveMaskOverElement = (element, selector2) => {
          const top = element.getBoundingClientRect().top;
          const left = element.getBoundingClientRect().left;
          const width = element.offsetWidth;
          const height = element.offsetHeight;
          this.setState({
            mask: {
              ...this.state.mask,
              // show mask box (in case it was previously hidden)
              // eslint-disable-next-line react/no-direct-mutation-state
              display: "block",
              // move mask box over hovered element
              top,
              left,
              width,
              height,
              selector: selector2
            }
          });
        };
        this.onMouseOverElement = (e) => {
          if (this.state.isFindingCSS) {
            const el = e.target;
            if (el instanceof HTMLElement) {
              if (this.ignoreElement(el)) {
                return;
              }
              const selector2 = this.getSelector(el);
              this.moveMaskOverElement(el, selector2 == null ? void 0 : selector2.selector);
            }
          }
        };
        this.onMouseDownElement = (e) => {
          if (this.state.isFindingCSS) {
            const el = e.target;
            if (el instanceof Element) {
              if (this.ignoreElement(el)) {
                return;
              }
              if (el.id === "commandbar-editor-wrapper") {
                this.setState({ mask: { ...this.state.mask, display: "none" } });
                return;
              }
              if (this.ignoreElement(el)) {
                return;
              }
              const selector2 = this.getSelector(el) || { selector: "html", tag: el.tagName, text: "", attributes: {} };
              this.setState(
                (prevState) => ({
                  selectors: this.props.singleStep ? [selector2] : [...prevState.selectors, selector2]
                }),
                () => {
                  this.save();
                }
              );
            }
            this.setState({ mask: { ...this.state.mask, display: "none" } });
            e.preventDefault();
            e.stopPropagation();
          }
        };
        this.toggleInfoDisplay = (e) => {
          const infoElement = document.getElementById("commandbar-recorder-message");
          const mouseWithinInfo = mouseWithin(infoElement, e);
          if (mouseWithinInfo && !this.state.hideInfo) {
            this.setState({ ...this.state, hideInfo: true });
          } else if (!mouseWithinInfo && this.state.hideInfo) {
            this.setState({ ...this.state, hideInfo: false });
          }
        };
        // figure out if we're hovering over the recorder controls or the app DOM
        this.ignoreElement = (el) => {
          const recorder = document.getElementById("commandbar-recorder-message");
          if (recorder && recorder.contains(el))
            return true;
          const editor = document.getElementById("commandbar-editor-drawer");
          if (editor && editor.contains(el))
            return true;
          const commandbar = document.getElementById("commandbar");
          return commandbar && commandbar.contains(el);
        };
        this.focusElement = void 0;
        const nudges = getNudgeDisplayValues();
        hideNudges(nudges);
        const recorderMask = document.createElement("div");
        recorderMask.setAttribute("id", "commandbar-recorder-mask");
        this.state = {
          isContinuingRecording: false,
          isFindingCSS: true,
          selectors: props2.selectors,
          nudges,
          recorderMask,
          hideInfo: false,
          mask: {
            top: 0,
            left: 0,
            width: 0,
            height: 0,
            display: "none",
            selector: void 0
          }
        };
      }
      componentDidUpdate(prevProps, _prevState) {
        if (!this.arraysEqual(prevProps.selectors, this.props.selectors)) {
          this.setState({ selectors: this.props.selectors });
        }
      }
      getSelector(el) {
        if (el instanceof Element) {
          if (this.ignoreElement(el)) {
            return;
          }
          if (el.id === "commandbar-editor-wrapper") {
            this.setState({ mask: { ...this.state.mask, display: "none" } });
            return;
          }
          if (this.ignoreElement(el)) {
            return;
          }
          const selector2 = findSelector(el);
          const text = getElementText(el) || "";
          const retval = {
            selector: selector2,
            text,
            tag: el.tagName,
            attributes: {}
            // TODO: decide which attributes to include
          };
          return retval;
        }
        return;
      }
      arraysEqual(a, b) {
        if (a === b)
          return true;
        if (a == null || b == null)
          return false;
        if (a.length !== b.length)
          return false;
        for (let i2 = 0; i2 < a.length; ++i2) {
          if (a[i2] !== b[i2])
            return false;
        }
        return true;
      }
      render() {
        return /* @__PURE__ */ React361.createElement(React361.Fragment, null, /* @__PURE__ */ React361.createElement(Info, { id: "commandbar-recorder-message", hide: this.state.hideInfo }, "Choose a target element or press ", /* @__PURE__ */ React361.createElement("b", null, "ESC"), " to cancel"), /* @__PURE__ */ React361.createElement(RecorderFocusMask, { ...this.state.mask }));
      }
    };
    Recorder_default = Recorder;
  }
});

// commandbar/src/shared/components/admin-facing/Editor/index.tsx
var Editor_exports = {};
__export(Editor_exports, {
  default: () => Editor_default
});
import React362 from "react";
import ReactDOM11 from "react-dom";
var Editor, Editor_default;
var init_Editor = __esm({
  "commandbar/src/shared/components/admin-facing/Editor/index.tsx"() {
    "use strict";
    init_LocalStorage();
    init_EditorDrawer();
    init_sentry();
    init_usePortal();
    init_Sender();
    init_location();
    init_useStore();
    init_globals();
    init_symbols();
    init_Recorder();
    Editor = ({ src }) => {
      const _ = useStore();
      const [editorWidth, setEditorWidth] = React362.useState(parseInt(LocalStorage_default.get("width", "770")));
      const [isRecorderOpen, setRecorderOpen] = React362.useState(false);
      const [initialRecorderProps, setInitialRecorderProps] = React362.useState({
        id: -1,
        selectors: [],
        singleStep: false
      });
      const [openOverideHack, setOpenOverrideHack] = React362.useState(null);
      const reapplyLevelMove = () => {
        ReactDOM11.flushSync(() => {
          setOpenOverrideHack(false);
        });
        ReactDOM11.flushSync(() => {
          setOpenOverrideHack(true);
        });
        ReactDOM11.flushSync(() => {
          setOpenOverrideHack(null);
        });
      };
      React362.useEffect(() => {
        const modalNudgeMock = document.getElementsByClassName("commandbar-nudge-modal-mock")[0];
        if (modalNudgeMock) {
          if (_.isEditorVisible) {
            modalNudgeMock.setAttribute("style", `margin-right: ${editorWidth + 8}px`);
          } else {
            modalNudgeMock.setAttribute("style", "margin-right: 0");
          }
        }
      }, [_.isEditorVisible]);
      React362.useEffect(() => {
        const nudgeSteps = document.getElementsByClassName("commandbar-popover-nudge-center");
        Array.from(nudgeSteps).forEach((nudgeStep) => {
          if (nudgeStep instanceof HTMLElement) {
            if (_.isEditorVisible) {
              const openEditorAdjustment = (editorWidth + 16) / 2;
              nudgeStep.style.right = `${openEditorAdjustment}px`;
            } else {
              nudgeStep.style.right = "0";
              nudgeStep.style.transition = "right cubic-bezier(0.78, 0.14, 0.15, 0.86) 0.3s";
            }
          }
        });
      }, [_.isEditorVisible]);
      React362.useEffect(() => {
        const popovers = document.getElementsByClassName("commandbar-popover-nudge-right");
        Array.from(popovers).forEach((popover) => {
          if (popover instanceof HTMLElement) {
            if (_.isEditorVisible) {
              popover.style.right = `${editorWidth + 16}px`;
            } else {
              popover.style.right = "0";
              popover.style.transition = "right cubic-bezier(0.78, 0.14, 0.15, 0.86) 0.3s";
            }
          }
        });
      }, [_.isEditorVisible]);
      React362.useEffect(() => {
        const handle = (_e) => {
          setTimeout(() => {
            if (_.isEditorVisible) {
              reapplyLevelMove();
            }
          }, 200);
        };
        document.addEventListener("CommandBar.opened", handle);
        document.addEventListener("commandbar-launcher-ready", handle);
        document.addEventListener("commandbar-checklist-shown", handle);
        document.addEventListener("commandbar-helphub-shown", handle);
        return () => {
          document.removeEventListener("CommandBar.opened", handle);
          document.removeEventListener("commandbar-launcher-ready", handle);
          document.removeEventListener("commandbar-checklist-shown", handle);
          document.removeEventListener("commandbar-helphub-shown", handle);
        };
      }, [_.isEditorVisible]);
      React362.useEffect(() => {
        window.parent.postMessage("commandbar-editor-loaded", "*");
      }, []);
      React362.useEffect(() => {
        LocalStorage_default.set("editor.open", _.isEditorVisible);
      }, [_.isEditorVisible]);
      const notifyEditorVisibility = async (visible) => {
        if (_.extension.preview.enabled || _.extension.recorder.enabled)
          return;
        const loaded = await Sender_default.waitForEditorToLoad(15e3);
        if (!loaded)
          return;
        await Sender_default.onEditorVisibleChange(visible);
      };
      React362.useEffect(() => {
        if (!isStudioPreview())
          notifyEditorVisibility(!!LocalStorage_default.get("editor.open", false));
      }, [_.isEditorVisible]);
      const openClickRecorder = ({ data }) => {
        var _a2;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Open Recorder", data });
        setRecorderOpen(true);
        getSDK()[_setEditorVisible](false);
        setInitialRecorderProps({
          id: (data == null ? void 0 : data.id) || -1,
          selectors: (data == null ? void 0 : data.selectors) || [],
          singleStep: (data == null ? void 0 : data.singleStep) || false
        });
        return respondSuccess();
      };
      const onClickRecorderComplete2 = (selectors) => {
        var _a2;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "recorder", message: "Complete Recorder", data: { selectors } });
        if (selectors.length > 0) {
          Sender_default.onClickRecorderComplete(selectors, initialRecorderProps.id);
        }
        setRecorderOpen(false);
        getSDK()[_setEditorVisible](true);
        setInitialRecorderProps(() => ({
          ...initialRecorderProps,
          selectors: []
        }));
      };
      const showEditor = ({ data }) => {
        var _a2;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "editor", message: "Show Editor", data });
        getSDK()[_setEditorVisible](true);
        return respondSuccess();
      };
      const hideEditor = ({ data }) => {
        var _a2;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "editor", message: "Hide Editor", data });
        getSDK()[_setEditorVisible](false);
        return respondSuccess();
      };
      const toggleEditorVisible = () => {
        var _a2;
        const visible = !_.isEditorVisible;
        (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({ category: "editor", message: "Change editor visible", data: { visible } });
        getSDK()[_setEditorVisible](visible);
      };
      const receiver = React362.useMemo(() => {
        return {
          editor: {
            showEditor,
            hideEditor,
            openClickRecorder
          }
        };
      }, [_.isEditorVisible]);
      usePortal_default(receiver);
      return /* @__PURE__ */ React362.createElement(React362.Fragment, null, /* @__PURE__ */ React362.createElement("style", null, `
          .commandbar-editor-drawer {
            position: fixed;
            z-index: 2147483644;
            transition: width 0s ease 0.3s, height 0s ease 0.3s, transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
          }
          .commandbar-editor-drawer > * {
            transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86),
              box-shadow 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
          }
          .commandbar-editor-drawer.commandbar-editor-drawer-open {
            transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
          }
          .commandbar-editor-drawer .commandbar-editor-drawer-mask {
            background: #000;
            opacity: 0;
            width: 100%;
            height: 0;
            position: absolute;
            top: 0;
            left: 0;
            transition: opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86), height 0s ease 0.3s;
          }
          .commandbar-editor-drawer-content-wrapper {
            position: absolute;
            background: #fff;
            max-width: unset;
          }
          #editor_nav {
            max-width: unset;
          }
          .commandbar-editor-drawer-content {
            overflow: auto;
            z-index: 1;
            position: relative;
          }
          .commandbar-editor-drawer-handle {
            position: absolute;
            top: 72px;
            width: 41px;
            height: 40px;
            cursor: pointer;
            z-index: 0;
            text-align: center;
            line-height: 40px;
            font-size: 16px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .commandbar-editor-drawer-handle-icon {
            width: 14px;
            height: 2px;
            background: #333;
            position: relative;
            transition: background 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
          }
          .commandbar-editor-drawer-handle-icon:before,
          .commandbar-editor-drawer-handle-icon:after {
            content: '';
            display: block;
            position: absolute;
            background: #333;
            width: 100%;
            height: 2px;
            transition: transform 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
          }
          .commandbar-editor-drawer-handle-icon:before {
            top: -5px;
          }
          .commandbar-editor-drawer-handle-icon:after {
            top: 5px;
          }
          .commandbar-editor-drawer-left,
          .commandbar-editor-drawer-right {
            width: 0%;
            height: 100%;
          }
          .commandbar-editor-drawer-left .commandbar-editor-drawer-content-wrapper,
          .commandbar-editor-drawer-right .commandbar-editor-drawer-content-wrapper,
          .commandbar-editor-drawer-left .commandbar-editor-drawer-content,
          .commandbar-editor-drawer-right .commandbar-editor-drawer-content {
            height: 100%;
          }
          .commandbar-editor-drawer-left.commandbar-editor-drawer-open,
          .commandbar-editor-drawer-right.commandbar-editor-drawer-open {
            width: 100%;
          }
          .commandbar-editor-drawer-left.commandbar-editor-drawer-open.no-mask,
          .commandbar-editor-drawer-right.commandbar-editor-drawer-open.no-mask {
            width: 0%;
          }
          .commandbar-editor-drawer-left {
            top: 0;
            left: 0;
          }
          .commandbar-editor-drawer-left .commandbar-editor-drawer-handle {
            right: -40px;
            box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
            border-radius: 0 4px 4px 0;
          }
          .commandbar-editor-drawer-left.commandbar-editor-drawer-open .commandbar-editor-drawer-content-wrapper {
            box-shadow: 2px 0 8px rgba(0, 0, 0, 0.15);
          }
          .commandbar-editor-drawer-right {
            top: 0;
            right: 0;
          }
          .commandbar-editor-drawer-right .commandbar-editor-drawer-content-wrapper {
            right: 0;
          }
          .commandbar-editor-drawer-right .commandbar-editor-drawer-handle {
            left: -40px;
            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
            border-radius: 4px 0 0 4px;
          }
          .commandbar-editor-drawer-right.commandbar-editor-drawer-open .commandbar-editor-drawer-content-wrapper {
            box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
          }
          .commandbar-editor-drawer-right.commandbar-editor-drawer-open.no-mask {
            right: 1px;
            transform: translateX(1px);
          }
          .commandbar-editor-drawer-top,
          .commandbar-editor-drawer-bottom {
            width: 100%;
            height: 0%;
          }
          .commandbar-editor-drawer-top .commandbar-editor-drawer-content-wrapper,
          .commandbar-editor-drawer-bottom .commandbar-editor-drawer-content-wrapper,
          .commandbar-editor-drawer-top .commandbar-editor-drawer-content,
          .commandbar-editor-drawer-bottom .commandbar-editor-drawer-content {
            width: 100%;
          }
          .commandbar-editor-drawer-top .commandbar-editor-drawer-content,
          .commandbar-editor-drawer-bottom .commandbar-editor-drawer-content {
            height: 100%;
          }
          .commandbar-editor-drawer-top.commandbar-editor-drawer-open,
          .commandbar-editor-drawer-bottom.commandbar-editor-drawer-open {
            height: 100%;
          }
          .commandbar-editor-drawer-top.commandbar-editor-drawer-open.no-mask,
          .commandbar-editor-drawer-bottom.commandbar-editor-drawer-open.no-mask {
            height: 0%;
          }
          .commandbar-editor-drawer-top .commandbar-editor-drawer-handle,
          .commandbar-editor-drawer-bottom .commandbar-editor-drawer-handle {
            left: 50%;
            margin-left: -20px;
          }
          .commandbar-editor-drawer-top {
            top: 0;
            left: 0;
          }
          .commandbar-editor-drawer-top .commandbar-editor-drawer-handle {
            top: auto;
            bottom: -40px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
            border-radius: 0 0 4px 4px;
          }
          .commandbar-editor-drawer-top.commandbar-editor-drawer-open .commandbar-editor-drawer-content-wrapper {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
          }
          .commandbar-editor-drawer-bottom {
            bottom: 0;
            left: 0;
          }
          .commandbar-editor-drawer-bottom .commandbar-editor-drawer-content-wrapper {
            bottom: 0;
          }
          .commandbar-editor-drawer-bottom .commandbar-editor-drawer-handle {
            top: -40px;
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
            border-radius: 4px 4px 0 0;
          }
          .commandbar-editor-drawer-bottom.commandbar-editor-drawer-open .commandbar-editor-drawer-content-wrapper {
            box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.15);
          }
          .commandbar-editor-drawer-bottom.commandbar-editor-drawer-open.no-mask {
            bottom: 1px;
            transform: translateY(1px);
          }
          .commandbar-editor-drawer.commandbar-editor-drawer-open .commandbar-editor-drawer-mask {
            /* opacity: 0.3; */
            height: 100%;
            transition: opacity 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
          }
          .commandbar-editor-drawer.commandbar-editor-drawer-open .commandbar-editor-drawer-handle-icon {
            background: transparent;
          }
          .commandbar-editor-drawer.commandbar-editor-drawer-open .commandbar-editor-drawer-handle-icon:before {
            transform: translateY(5px) rotate(45deg);
          }
          .commandbar-editor-drawer.commandbar-editor-drawer-open .commandbar-editor-drawer-handle-icon:after {
            transform: translateY(-5px) rotate(-45deg);
          }

          /* RC Drawer */

          .commandbar-editor-drawer-content-wrapper {
            margin: 10px 0px;
            box-shadow: none !important;
            height: calc(100% - 20px) !important;
            background-color: transparent !important;
          }

          .commandbar-editor-drawer-content {
            overflow: hidden !important;
          }
        `), /* @__PURE__ */ React362.createElement(
        EditorDrawer_default,
        {
          src,
          open: openOverideHack !== null ? openOverideHack : _.isEditorVisible,
          width: editorWidth,
          handler: /* @__PURE__ */ React362.createElement(EditorDrawer_default.Handle, { isEditorOpen: _.isEditorVisible, toggleEditor: toggleEditorVisible }),
          onResizeEditor: setEditorWidth,
          onLevelMove: reapplyLevelMove
        }
      ), isRecorderOpen && /* @__PURE__ */ React362.createElement(
        Recorder_default,
        {
          selectors: initialRecorderProps.selectors,
          singleStep: initialRecorderProps.singleStep,
          onSave: onClickRecorderComplete2
        }
      ));
    };
    Editor_default = Editor;
  }
});

// core-js-loader-expand:core-js/stable
import "core-js/modules/es.symbol.match-all";
import "core-js/actual/error/constructor";
import "core-js/modules/es.aggregate-error";
import "core-js/modules/es.aggregate-error.cause";
import "core-js/actual/array/at";
import "core-js/es/array/find-last";
import "core-js/es/array/find-last-index";
import "core-js/actual/array/push";
import "core-js/es/array/to-reversed";
import "core-js/modules/es.array.to-sorted";
import "core-js/es/array/to-spliced";
import "core-js/modules/es.array.unscopables.flat";
import "core-js/modules/es.array.unscopables.flat-map";
import "core-js/actual/array/unshift";
import "core-js/es/array/virtual/with";
import "core-js/actual/object/has-own";
import "core-js/modules/es.promise.all-settled";
import "core-js/modules/es.promise.any";
import "core-js/modules/es.promise.finally";
import "core-js/actual/reflect/to-string-tag";
import "core-js/actual/instance/flags";
import "core-js/actual/string/at";
import "core-js/actual/instance/is-well-formed";
import "core-js/modules/es.string.match-all";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.replace-all";
import "core-js/actual/instance/to-well-formed";
import "core-js/modules/es.typed-array.float32-array";
import "core-js/modules/es.typed-array.float64-array";
import "core-js/modules/es.typed-array.int8-array";
import "core-js/modules/es.typed-array.int16-array";
import "core-js/modules/es.typed-array.int32-array";
import "core-js/modules/es.typed-array.uint8-array";
import "core-js/modules/es.typed-array.uint8-clamped-array";
import "core-js/modules/es.typed-array.uint16-array";
import "core-js/modules/es.typed-array.uint32-array";
import "core-js/actual/typed-array/at";
import "core-js/actual/typed-array/fill";
import "core-js/es/typed-array/find-last";
import "core-js/es/typed-array/find-last-index";
import "core-js/actual/typed-array/from";
import "core-js/actual/typed-array/of";
import "core-js/actual/typed-array/set";
import "core-js/actual/typed-array/sort";
import "core-js/es/typed-array/to-reversed";
import "core-js/modules/es.typed-array.to-sorted";
import "core-js/es/typed-array/with";
import "core-js/modules/web.dom-collections.iterator";
import "core-js/modules/web.dom-exception.stack";
import "core-js/actual/clear-immediate";
import "core-js/modules/web.structured-clone";
import "core-js/modules/web.url";
import "core-js/modules/web.url.can-parse";
import "core-js/actual/url/to-json";
import "core-js/modules/web.url-search-params";
import "core-js/modules/web.url-search-params.delete";
import "core-js/modules/web.url-search-params.has";
import "core-js/modules/web.url-search-params.size";

// commandbar/src/index.tsx
init_proxy();
init_symbols();
import "proxy-polyfill";
import "construct-style-sheets-polyfill";
import React365 from "react";
import ReactDOM12 from "react-dom";

// commandbar/src/shared/sdk/deployment.ts
init_Logger();
init_symbols();
init_proxy();
var genSession = () => {
  const len = 12;
  const factor = Math.pow(10, len);
  return Math.floor(factor + Math.random() * 9 * factor).toString();
};
var getConfig = (api, launchcode) => {
  const lc = launchcode != null ? launchcode : localStorage.getItem("commandbar.lc");
  function parseParam(param) {
    const obj = {};
    const pairs = param.split(";");
    pairs.forEach((pair) => {
      const [key, value] = pair.split("=");
      if (key)
        obj[key] = value;
    });
    return obj;
  }
  api = api || "https://api.commandbar.com";
  const commandbar = "__local__";
  let editor = "https://frames-editor-prod.commandbar.com";
  if (!lc) {
    return { api, commandbar, editor };
  }
  let cleanedLaunchCode = lc;
  if (!lc.includes("=")) {
    switch (lc) {
      case "prod":
        cleanedLaunchCode = `api=prod;commandbar=prod`;
        break;
      case "prod-stable":
      case "stable":
        cleanedLaunchCode = `api=stable;commandbar=stable`;
        break;
      case "mobile":
      case "labs":
      case "staging":
        cleanedLaunchCode = `api=labs;commandbar=labs`;
        break;
      case "api-labs":
      case "api-labs-local":
        cleanedLaunchCode = `api=labs;commandbar=prod`;
        break;
      case "branch":
        cleanedLaunchCode = `api=branch;commandbar=branch`;
        break;
      case "local":
        cleanedLaunchCode = `api=labs;commandbar=local`;
        break;
      case "test":
      case "local-dev":
        cleanedLaunchCode = `api=local;commandbar=local`;
        break;
      case "dev":
        cleanedLaunchCode = `api=dev;commandbar=dev`;
        break;
      default:
        if (lc.startsWith("preview")) {
          if (lc.includes("local-dev")) {
            cleanedLaunchCode = `api=local;commandbar=${lc}`;
          } else {
            cleanedLaunchCode = `api=${lc};commandbar=${lc}`;
          }
        }
    }
  }
  const launchCodeParts = parseParam(cleanedLaunchCode);
  if (launchCodeParts["api"]) {
    switch (launchCodeParts["api"]) {
      case "prod":
      case "stable":
        api = "https://api.commandbar.com";
        break;
      case "labs":
      case "staging":
        api = "https://api-labs.commandbar.com";
        break;
      case "dev":
        api = "https://api-dev.commandbar.com";
        break;
      case "local":
        api = "http://localhost:8000";
        break;
      default:
        if (launchCodeParts["api"].startsWith("preview")) {
          const branchIdentifier = launchCodeParts["api"].substring(launchCodeParts["api"].lastIndexOf("_") + 1);
          api = `https://${branchIdentifier}.commandbar.xyz:8000`;
          break;
        }
        Logger_default.warn(`Unknown api launch code: ${launchCodeParts["api"]}`);
        break;
    }
  }
  if (launchCodeParts["commandbar"]) {
    switch (launchCodeParts["commandbar"]) {
      case "prod":
        editor = "https://frames-editor-prod.commandbar.com";
        break;
      case "stable":
        editor = "https://frames-editor-stable.commandbar.com";
        break;
      case "labs":
      case "staging":
        editor = "https://frames-editor-labs.commandbar.com";
        break;
      case "dev":
        editor = "https://frames-editor-dev.commandbar.com";
        break;
      case "local":
        editor = "http://localhost:3003";
        break;
      default:
        if (launchCodeParts["commandbar"].startsWith("preview_")) {
          const branchIdentifier = launchCodeParts["commandbar"].substring(
            launchCodeParts["commandbar"].lastIndexOf("_") + 1
          );
          editor = `https://${branchIdentifier}.editor.commandbar.com`;
        } else if (launchCodeParts["commandbar"].startsWith("preview2_")) {
          const branchIdentifier = launchCodeParts["commandbar"].substring(
            launchCodeParts["commandbar"].lastIndexOf("_") + 1
          );
          editor = `https://${branchIdentifier}.commandbar.xyz:3003`;
        } else {
          Logger_default.warn(`Unknown commandbar launch code: ${lc}`);
        }
        break;
    }
  }
  return { api, commandbar, editor, ...lc && { launchcode: lc } };
};
var deploy = (launchcode) => {
  var _a2;
  Logger_default.blue("[CommandBar] Loading...");
  const sdk = getProxySDK();
  let wrapper = document.getElementById("commandbar-wrapper");
  let container = document.getElementById("commandbar");
  if (!wrapper) {
    wrapper = document.createElement("div");
    wrapper.setAttribute("id", "commandbar-wrapper");
    wrapper.setAttribute("data-commandbar", "1");
    document.body.appendChild(wrapper);
  }
  if (!container) {
    container = document.createElement("div");
    container.setAttribute("id", "commandbar");
    container.setAttribute("data-commandbar", "1");
    wrapper.appendChild(container);
  }
  const session = genSession();
  sdk[_configuration] = {
    ...sdk[_configuration],
    session,
    foobarVersion: "0.5.86",
    ...getConfig((_a2 = sdk[_configuration]) == null ? void 0 : _a2.api, launchcode)
  };
  return container;
};

// commandbar/src/CommandBarContainer.tsx
import React364, { useEffect as useEffect79 } from "react";

// commandbar/src/App.tsx
import React363, { Suspense, useEffect as useEffect78, useMemo as useMemo20, useRef as useRef48 } from "react";

// commandbar/src/style/App.css
init_index();
inject_style('#commandbar-wrapper *,#commandbar-wrapper *:before,#commandbar-wrapper *:after,.commandbar-nudge-modal *,.commandbar-nudge-modal *:before,.commandbar-nudge-modal *:after,.commandbar-nudge-modal-mock *,.commandbar-nudge-modal-mock *:before,.commandbar-nudge-modal-mock *:after{box-sizing:border-box}.commandbar-modal>.rc-dialog>.rc-dialog-content{background-color:transparent}.commandbar-tooltip{z-index:2147483647!important}.commandbar-modal>.rc-dialog>.rc-dialog-content>.rc-dialog-header{max-height:0px!important;padding:0!important}.commandbar-modal>.rc-dialog{left:0;transition:left .3s}.commandbar-modal>.rc-dialog>.rc-dialog-content>.rc-dialog-body{position:relative!important}.commandbar-modal-inline.rc-dialog-wrap{position:relative;height:100%}#commandbar-container>div{height:100%}#commandbar-home>.rc-dialog-root{height:100%}#commandbar-wrapper .rc-header-guidance{background:rgba(174,177,221,1)!important;filter:brightness(135%);border-radius:2px 2px 0 0!important;border-bottom:0px!important;padding:8px 30px 2px!important;margin:0 10px;box-shadow:#00000026 0 3px 10px!important;font-weight:400;text-align:center}@keyframes fontbulger{0%{font-size:10px}30%{font-size:15px}to{font-size:12px}}@keyframes shimmer{0%{background-position:top left}to{background-position:top right}}.commandbar-category-collapse{transform:scaleY(-1);transition:.3s ease-in;cursor:pointer}.commandbar-category-expand{transition:.3s ease-in;cursor:pointer}.commandbar-nudge-modal{display:flex;align-items:center;justify-content:center;z-index:2147483644!important}.commandbar-nudge-modal-mock{display:flex;align-items:center;justify-content:center;margin-right:0;transition:margin-right cubic-bezier(.78,.14,.15,.86) .3s;z-index:2147483644!important}.commandbar-help-doc-title:before{position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(180deg,transparent 66.67%,gray 93.08%);content:""}#commandbar-recorder-mask{background:transparent}');

// commandbar/src/style/animations.css
init_index();
inject_style("@keyframes example{0%{transform:translateY(0)}to{transform:translateY(-30px)}}.rc-header-guidance{animation:example .5s;animation-fill-mode:forwards}.commandbar-opened{animation:onEntry .1s;animation-fill-mode:forwards}@keyframes onSelect{0%{transform:translateZ(0)}50%{transform:translateZ(-.5px)}to{transform:translateZ(0)}}.commandbar-selected{animation:onSelect .4s}@keyframes ScaleEntry{0%{transform:scale(.8);opacity:0}to{transform:scale(1);opacity:1}}.commandbar-scale-entry-animation{animation:ScaleEntry .3s;animation-fill-mode:forwards}@keyframes onEntry{0%{opacity:.3}to{opacity:1}}.commandbar-shortcut-tooltip{opacity:0;animation:tagEntry .2s;animation-delay:.5s;animation-fill-mode:forwards}@keyframes tagExit{0%{transform:scale(1);opacity:1}to{transform:scale(.8);opacity:0}}.commandbar-shortcut-tooltip-remove{animation:tagExit .2s;animation-fill-mode:forwards}.commandbar-shortcut-tooltip,.commandbar-shortcut-tooltip-remove{z-index:99999999;position:absolute;padding:8px 12px;background-color:#000c;font-family:proxima-nova,sans-serif;color:#fff9;border-radius:4px;font-size:13px}.commandbar-shortcut-tooltip-tag{margin-left:10px;padding:2px 5px;border-radius:2px;background-color:gray}#commandbar-launcher{animation:.25s ease-out scaleIn}@keyframes scaleIn{0%{transform:scale(.06)}to{transform:scale(1)}}@keyframes growFromBottom{0%{transform:scaleY(.3)}to{transform:scale(1)}}");

// commandbar/src/shared/services/theming/ThemeContext.tsx
import * as React from "react";
import chroma from "chroma-js";
var defaultBaseTheme = {
  primary: chroma("rgb(174, 177, 221)"),
  background: chroma("rgba(36, 35, 41, 0.98)"),
  font: chroma("rgba(255,255,255,0.85)"),
  fontFamily: "Avenir Next, proxima-nova, sans-serif"
};
var getTheme = (theme) => {
  const fontSecondary = chroma("#808080");
  return {
    ...theme,
    fontSecondary
  };
};
var defaultTheme = getTheme(defaultBaseTheme);
var ThemeContext = React.createContext(defaultTheme);
var ThemeContext_default = ThemeContext;

// commandbar/src/useCommandBarSDK.tsx
import { useEffect as useEffect33 } from "react";

// commandbar/src/shared/sdk/sdk.tsx
init_command();
init_end_users();
init_LocalStorage();
init_Logger();
init_Analytics();
init_Reporting();

// internal/src/client/addContextValidators.tsx
var getFirstType = (first) => {
  if (first === null || first === void 0)
    return 0 /* INVALID */;
  if (typeof first === "object")
    return 1 /* OBJECT */;
  if (typeof first === "string")
    return 2 /* KEY */;
  return 0 /* INVALID */;
};
var getSecondType = (second) => {
  if (typeof second === "function")
    return 1 /* FUNCTION */;
  return 2 /* STATIC */;
};
var getThirdType = (third) => {
  if (third === null || third === void 0 || typeof third === "object" && Object.keys(third).length === 0)
    return 1 /* NONE */;
  if (typeof third === "object")
    return 2 /* OBJECT */;
  return 0 /* INVALID */;
};
var getCase = (firstArgType, secondArgType, thirdArgType) => {
  if (firstArgType === 0 /* INVALID */ || secondArgType === 0 /* INVALID */ || thirdArgType === 0 /* INVALID */) {
    return "Invalid use of addContext";
  }
  switch (firstArgType) {
    case 1 /* OBJECT */:
      return 0 /* OLD_ADD_CONTEXT */;
    case 2 /* KEY */:
      return 1 /* NEW_ADD_CONTEXT */;
  }
};

// commandbar/src/shared/sdk/sdk.tsx
init_CommandBarClientSDK();

// internal/src/client/CommandBarProxySDK.tsx
init_symbols();
function isProxySDK(x) {
  return (x == null ? void 0 : x[_isProxy]) === true;
}

// internal/src/client/CommandBarSDK.tsx
var _reloadTargets = [
  "reloadCommands",
  "reloadOrganization",
  "reloadPlaceholders",
  "reloadNudges",
  "reloadChecklists",
  "reloadHelpHub",
  "reloadThemes"
];

// commandbar/src/shared/sdk/sdk.tsx
init_Disposable();
init_globals();
init_proxy();
init_symbols();

// commandbar/src/shared/store/util/bindActions.ts
var bindActions = (_, actions2) => {
  const bound = {};
  Object.keys(actions2).forEach((k) => {
    bound[k] = actions2[k].bind(null, _);
  });
  return bound;
};

// commandbar/src/shared/sdk/sdk.tsx
init_service_actions4();
init_service_selectors4();
init_service_actions3();
init_service_actions2();
init_service_actions();

// commandbar/src/products/copilot/service-actions.ts
var service_actions_exports5 = {};
__export(service_actions_exports5, {
  previewCopilotSettings: () => previewCopilotSettings
});

// commandbar/src/products/copilot/store/actions.ts
var previewCopilotSettings = (_, settings) => {
  _.helpHub.previewedCopilotSettings = settings;
};

// commandbar/src/shared/sdk/sdk.tsx
init_actions4();
init_global_actions();
init_dispatchCustomEvent();
init_utils3();
init_Hotkey();
init_constants3();
init_config();
init_global_selectors();
init_executable_selectors();
import { unmountComponentAtNode } from "react-dom";
import { ref as ref11, snapshot as snapshot3 } from "valtio";

// commandbar/src/shared/store/util/MultiSearch.ts
var MultiSearch = class {
  constructor(onInputChange) {
    this.createSearchFunction = (type39) => {
      return (query) => {
        if (query === this.lastQuery && this.cachedResults) {
          return Promise.resolve(this.cachedResults).then((results) => results[type39]);
        }
        this.cachedResults = onInputChange(query);
        this.lastQuery = query;
        return Promise.resolve(this.cachedResults).then((results) => results[type39]);
      };
    };
  }
};

// commandbar/src/shared/sdk/sdk.tsx
init_helpers9();
init_service_selectors();
init_helpdocService();
init_search();
init_service_selectors2();
init_sentry();
init_decode();

// commandbar/src/shared/sdk/validators.tsx
import * as t39 from "io-ts";
var HelpHubFilterV = t39.type({
  labels: t39.union([t39.array(t39.string), t39.undefined])
});

// commandbar/src/shared/sdk/sdk.tsx
init_actions4();
init_service_selectors3();

// commandbar/src/shared/services/analytics/v2/client.ts
init_LocalStorage();
init_network();
init_globals();
init_symbols();
init_Logger();
init_sentry();
init_network();

// commandbar/src/shared/services/analytics/v2/event-queue.ts
var EventQueue2 = class {
  constructor(sendEvents3, options = {}) {
    this.maxQueueSize = 5;
    this.flushTimeout = null;
    this.flushTimeoutMs = 3e3;
    this._queue = [];
    const { maxQueueSize, flushTimeoutMs } = options;
    if (maxQueueSize) {
      this.maxQueueSize = maxQueueSize;
    }
    if (flushTimeoutMs) {
      this.flushTimeoutMs = flushTimeoutMs;
    }
    this.sendEvents = sendEvents3;
  }
  enqueue(event, forceFlush) {
    this._queue.push(event);
    if (forceFlush || this._queue.length >= this.maxQueueSize) {
      this.flush();
    } else if (!this.flushTimeout) {
      this.flushTimeout = setTimeout(() => {
        this.flush();
      }, this.flushTimeoutMs);
    }
  }
  clearFlushTimeout() {
    if (this.flushTimeout) {
      clearTimeout(this.flushTimeout);
      this.flushTimeout = null;
    }
  }
  flush(options) {
    this.clearFlushTimeout();
    const events = this._queue.splice(0, this._queue.length);
    if (events.length === 0) {
      return;
    }
    this.sendEvents(events, options || {});
  }
  unload() {
    this.flush({ transport: "sendBeacon" });
  }
};

// commandbar/src/shared/services/analytics/v2/helpers.ts
init_globals();
init_proxy();
init_symbols();
var shouldReportToServer2 = () => {
  var _a2;
  const notSilentMode = !isSilentMode2();
  const notAirgapped = !((_a2 = getSDK()[_configuration]) == null ? void 0 : _a2.airgap);
  const notTesting = true;
  return notSilentMode && notAirgapped && notTesting;
};
var isSilentMode2 = () => {
  var _a2;
  const silent = (_a2 = getSDK()[_configuration]) == null ? void 0 : _a2.silent;
  return silent !== false;
};
var allowedCategories = ["commands", "help_hub_search", "user_inputs_and_deadends", "records", "urls"];
var getEventAttributeBlockList2 = () => {
  var _a2;
  const proxy2 = getProxySDK();
  const eventAttributeBlockList = (_a2 = proxy2[_configuration]) == null ? void 0 : _a2.eventAttributeBlockList;
  return eventAttributeBlockList || allowedCategories;
};

// commandbar/src/shared/services/analytics/v2/client.ts
var getCurrentUTCTimestamp = () => (/* @__PURE__ */ new Date()).toISOString();
var createEnrichment = (key, value) => {
  return [key, value];
};
var defaultEnrichments = (event, meta) => {
  const enrichments = [
    addVersion,
    addIsAdmin,
    addIsSimulated,
    addOrganizationKey,
    addClientVersion,
    addPageProperties,
    addTimestamp,
    addUserAgent,
    addUserProperties,
    addDistinctId,
    addAnonDistinctId,
    addDecide(meta.decide)
  ];
  return enrichments.reduce((acc, [key, value]) => {
    if (acc[key] !== void 0) {
      return acc;
    }
    return {
      ...acc,
      [key]: value()
    };
  }, event);
};
var addVersion = createEnrichment("version", () => 2);
var addIsAdmin = createEnrichment("is_admin", () => LocalStorage_default.get("adm", false) === true);
var addIsSimulated = createEnrichment(
  "is_simulated",
  () => false
  /* TODO: Implement */
);
var addOrganizationKey = createEnrichment("organization_key", () => getSDK()[_configuration].uuid);
var addClientVersion = createEnrichment(
  "client_version",
  () => ({})
  /* TODO: Implement */
);
var addPageProperties = createEnrichment("page", () => ({
  domain: window.location.hostname,
  hash: window.location.hash,
  path: window.location.pathname,
  query: window.location.search,
  title: document.title
}));
var addTimestamp = createEnrichment("timestamp", getCurrentUTCTimestamp);
var addUserAgent = createEnrichment("user_agent", () => navigator.userAgent);
var addUserProperties = createEnrichment("end_user_properties", () => getSDK()[_userProperties] || {});
var addDistinctId = createEnrichment("distinct_id", () => {
  const distinctId = getSDK()[_user];
  return distinctId || "";
});
var addAnonDistinctId = createEnrichment("anon_distinct_id", () => getSDK()[_fingerprint] || null);
var addDecide = (decide2) => createEnrichment("decide", () => decide2 != null ? decide2 : void 0);
var scrubPageProperties = (event) => {
  return {
    ...event,
    page: {
      domain: "",
      hash: "",
      path: "",
      query: "",
      title: ""
    }
  };
};
var scrubUserInput = (event) => {
  const userInputFields = ["inputText"];
  const eventProperties = event.properties;
  const scrubbedProperties = Object.keys(eventProperties).reduce((acc, key) => {
    if (userInputFields.includes(key)) {
      return {
        ...acc,
        [key]: "SCRUBBED"
      };
    } else {
      return {
        ...acc,
        [key]: eventProperties[key]
      };
    }
  }, {});
  return {
    ...event,
    properties: scrubbedProperties,
    nudge: {},
    spotlight: {},
    helphub: {},
    copilot: {}
  };
};
var defaultScrubbers = (event) => {
  const activeScrubbers = getEventAttributeBlockList2();
  const scrubbers = [];
  if (activeScrubbers.includes("urls")) {
    scrubbers.push(["urls", scrubPageProperties]);
  }
  if (activeScrubbers.includes("user_inputs_and_deadends")) {
    scrubbers.push(["user_inputs_and_deadends", scrubUserInput]);
  }
  event["scrubbers"] = [...activeScrubbers];
  return scrubbers.reduce((acc, [category, scrubber]) => {
    if (activeScrubbers.includes(category)) {
      return scrubber(acc);
    }
    return acc;
  }, event);
};
var sendEvents2 = (events, options) => {
  const { transport = "fetch" } = options;
  const body = {
    version: 2,
    events,
    organization_key: getSDK()[_configuration].uuid
  };
  const blob = new Blob([JSON.stringify(body)], { type: "application/json" });
  let baseUrl2 = getBaseURL();
  if (["https://api.commandbar.com"].includes(baseUrl2)) {
    baseUrl2 = "https://t.commandbar.com";
  }
  if ("sendBeacon" in navigator && transport === "sendBeacon") {
    navigator.sendBeacon(`${baseUrl2}/t/`, blob);
  } else {
    post("/t/", blob, { keepalive: true }).catch((e) => {
      var _a2;
      Logger_default.error("Failed to send events to server", e);
      (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
    });
  }
};
var AnalyticsV2 = class {
  constructor(applyEnrichments = defaultEnrichments, applyScrubbers = defaultScrubbers) {
    this.hasBooted = false;
    this.enabled = false;
    this.decide = void 0;
    this.applyEnrichments = defaultEnrichments;
    this.applyScrubbers = defaultScrubbers;
    this.applyEnrichments = applyEnrichments;
    this.applyScrubbers = applyScrubbers;
    this.eventQueue = new EventQueue2((events, options) => {
      var _a2;
      if (!shouldReportToServer2())
        return;
      try {
        const eventsWithSentAt = events.map((e) => {
          return {
            ...e,
            sent_at: getCurrentUTCTimestamp()
          };
        });
        sendEvents2(eventsWithSentAt, options);
      } catch (e) {
        (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
      }
    });
  }
  enable() {
    this.enabled = true;
    window.addEventListener("beforeunload", () => {
      this.eventQueue.unload();
    });
  }
  trackCustomEvent(name, properties = {}) {
    if (name.startsWith("c:")) {
      Logger_default.error("Custom events cannot start with `c:` - received " + name);
      return;
    }
    this.track(name, properties);
  }
  trackCBEvent(name, properties = {}, additionalProperties = {}, forceFlush) {
    this.track(name, properties, additionalProperties, forceFlush);
  }
  track(name, properties = {}, additionalProperties = {}, forceFlush) {
    var _a2;
    const event = {
      name,
      properties,
      ...additionalProperties
    };
    if (!this.hasBooted) {
      Logger_default.warn("Events cannot be tracked before `boot` is called");
      return;
    }
    try {
      const enrichedEvent = this.applyEnrichments(event, { decide: this.decide });
      const scrubbedEvent = this.applyScrubbers(enrichedEvent);
      Logger_default.info("Tracking event", scrubbedEvent);
      if (!this.enabled) {
        Logger_default.info("Analytics is disabled, ignoring event");
        return;
      }
      this.eventQueue.enqueue(scrubbedEvent, forceFlush);
      if (name.startsWith("c:") && !name.startsWith("c:internal:")) {
        const eventSubscriptions = getSDK()[_eventSubscriptions];
        const iterator = eventSubscriptions instanceof Map ? eventSubscriptions.values() : void 0;
        if (iterator) {
          while (true) {
            const { value, done } = iterator.next();
            if (done)
              break;
            const [subscriber, options] = value;
            if (options && options.v2) {
              subscriber(scrubbedEvent.name, scrubbedEvent);
            }
          }
        }
      }
    } catch (error3) {
      Logger_default.warn("Unexpected error logging event; ignoring", { error: error3 });
      (_a2 = getSentry()) == null ? void 0 : _a2.captureException(error3);
    }
  }
  identifyAsAdmin() {
    LocalStorage_default.set("adm", true);
  }
  setBootStatus(hasBooted) {
    this.hasBooted = hasBooted;
  }
  setDecide(decide2) {
    this.decide = decide2;
  }
};

// commandbar/src/shared/sdk/sdk.tsx
init_track();
var TRACK_METHODS = [
  _setDashboard,
  _showGuide,
  _showMessage,
  "addCallback",
  "addCommand",
  "addContext",
  "addEventHandler",
  "addEventSubscriber",
  "addRouter",
  "boot",
  "close",
  "closeAllNudges",
  "closeHelpHub",
  "execute",
  "generateDetailPreview",
  "isOpen",
  "open",
  "openCopilot",
  "openHelpHub",
  "removeCallback",
  "removeCommand",
  "removeContext",
  "resetChecklist",
  "resetNudge",
  "setContext",
  "setTheme",
  "shareCallbacks",
  "shareContext",
  "shutdown",
  "trackEvent",
  "setHelpHubFilter",
  "setThemeMode",
  "setUserProperties",
  "toggleHelpHub",
  "triggerNudge",
  "triggerChecklist"
];
var initializing = false;
async function initSDK(_) {
  if (initializing)
    return null;
  try {
    initializing = true;
    return _initSDK(_);
  } finally {
    initializing = false;
  }
}
async function _initSDK(_) {
  const proxy2 = getProxySDK();
  if (!isProxySDK(proxy2))
    return getSDK();
  Logger_default.info("initializing client SDK...");
  const spotlight = bindActions(_, service_actions_exports2);
  const nudgeActions = bindActions(_, service_actions_exports3);
  const checklistActions = bindActions(_, service_actions_exports4);
  const helphubActions = bindActions(_, service_actions_exports);
  const copilotActions = bindActions(_, service_actions_exports5);
  const globalActions = bindActions(_, global_actions_exports);
  const endUserStoreActions = bindActions(_, actions_exports3);
  let sdk = null;
  const externalSdkMixin = {
    activeExperiences() {
      const { activeChecklist, spotlight: spotlight2, helpHub } = _;
      const { visible: isSpotlightOpen } = spotlight2;
      const { visible: isHelpHubOpen } = helpHub;
      const activeNudges = getRenderingServices(_).map((service) => {
        var _a2, _b2;
        return {
          id: service.id,
          step: ((_b2 = (_a2 = service.getSnapshot()) == null ? void 0 : _a2.context.stepIndex) != null ? _b2 : 0) + 1
          // 1-indexed for end user
        };
      });
      return [
        ...isSpotlightOpen ? [{ type: "spotlight" }] : [],
        ...activeNudges.map(({ id: id2, step }) => ({ type: "nudge", id: id2, step })),
        ...activeChecklist ? [{ type: "checklist", id: activeChecklist.id }] : [],
        ...isHelpHubOpen ? [{ type: "helphub" }] : []
      ];
    },
    addCallback(callbackKey, callbackFn) {
      if (callbackKey.startsWith("commandbar-")) {
        Logger_default.warn("callback name is reserved");
        return;
      }
      globalActions.addCallbacks({ [callbackKey]: callbackFn });
    },
    addCallbacks(callbacks) {
      if (!!Object.keys(callbacks).find((n) => {
        return n.includes("commandbar-");
      })) {
        Logger_default.warn("One or more of the callback names are reserved.");
        return;
      }
      globalActions.addCallbacks(callbacks);
    },
    async addCommand(command) {
      await validateFromClient(command);
      const shortcut_mac = command.shortcut_mac || [];
      const shortcut_win = command.shortcut_win || [];
      const hotkey_mac = command.hotkey_mac || Hotkey_default.toString(shortcut_mac, "mac");
      const hotkey_win = command.hotkey_win || Hotkey_default.toString(shortcut_win, "win");
      let category = command.category || null;
      if (typeof category === "string") {
        const c = _.spotlight.categories.find((category2) => category2.name === command.category);
        if (c) {
          category = c.id;
        } else {
          category = spotlight.addCategory(category);
        }
      }
      const formattedCommand = decode({
        text: command.text,
        template: command.template,
        name: command.name,
        tags: command.tags || [],
        detail: (command == null ? void 0 : command.detail) || null,
        content: (command == null ? void 0 : command.content) || null,
        show_preview: (command == null ? void 0 : command.show_preview) || false,
        shortcut_mac,
        shortcut_win,
        hotkey_mac,
        hotkey_win,
        explanation: command.explanation || "",
        heading: command.heading || "",
        sort_key: command.sort_key || null,
        arguments: command.arguments || {},
        availability_rules: command.availability_rules || [],
        recommend_rules: command.recommend_rules || [],
        confirm: "",
        shortcut: [],
        is_live: true,
        source: "programmatic",
        id: Math.random(),
        // placeholder
        organization: -1,
        category,
        icon: command.icon || null,
        image: command.image || null,
        celebrate: command.celebrate || null,
        recommend_sort_key: null,
        extra: command.extra || null
      });
      globalActions.addCommand(formattedCommand);
    },
    setCategoryConfig(category, config2) {
      var _a2, _b2;
      let categoryId;
      if (typeof category === "number") {
        categoryId = category;
      } else {
        categoryId = (_b2 = (_a2 = _.spotlight.categories.find((c) => c.name === category)) == null ? void 0 : _a2.id) != null ? _b2 : spotlight.addCategory(category);
      }
      spotlight.setCategoryConfig(categoryId, config2);
    },
    addArgumentChoices(key, initial, options) {
      const addContextOptions = {
        renderOptions: {
          labelKey: options == null ? void 0 : options.labelKey,
          descriptionKey: options == null ? void 0 : options.descriptionKey,
          defaultIcon: options == null ? void 0 : options.defaultIcon,
          detail: options == null ? void 0 : options.detail,
          content: options == null ? void 0 : options.content,
          show_preview: options == null ? void 0 : options.show_preview,
          renderAs: options == null ? void 0 : options.renderAs,
          searchTabEnabled: options == null ? void 0 : options.searchTabEnabled
        },
        searchOptions: {
          fields: options == null ? void 0 : options.searchableFields,
          searchFunction: options == null ? void 0 : options.onInputChange
        },
        quickFindOptions: {
          quickFind: false
        }
      };
      this.addContext(key, initial, addContextOptions);
    },
    resetNudge(id2, step) {
      nudgeActions.resetNudge(id2, { step });
    },
    resetChecklist(id2, keepOpen) {
      checklistActions.resetChecklist(id2, keepOpen);
    },
    addPageMetadata(data) {
      _.pageMetadata = { ..._.pageMetadata, ...data };
      Track.internal.sdkMethodCalled("addPageMetadata");
    },
    addMetadata(key, initial, addToUserProperties = false) {
      var _a2;
      this.addContext(key, initial);
      if (addToUserProperties) {
        Logger_default.warn("addMetadata: addToUserProperties is deprecated. Use the setUserProperties method instead.");
        sdk[_userProperties] = { ...sdk[_userProperties], [key]: initial };
      }
      if (!!((_a2 = _.flags) == null ? void 0 : _a2["release-track-metadata-sdk-calls"])) {
        Track.internal.sdkMethodCalled("addMetadata");
      }
    },
    addMetadataBatch(data, addToUserProperties = false) {
      var _a2;
      this.addContext({ ...data });
      if (addToUserProperties) {
        Logger_default.warn("addMetadataBatch: addToUserProperties is deprecated. Use the setUserProperties method instead.");
        sdk[_userProperties] = { ...sdk[_userProperties], ...data };
      }
      if (!!((_a2 = _.flags) == null ? void 0 : _a2["release-track-metadata-sdk-calls"])) {
        Track.internal.sdkMethodCalled("addMetadataBatch");
      }
    },
    trackEvent(key, properties) {
      var _a2, _b2, _c2;
      if (key.startsWith("commandbar-")) {
        Logger_default.warn("event name is reserved");
        return;
      }
      if ((_a2 = _ == null ? void 0 : _.flags) == null ? void 0 : _a2["release-capture-custom-events"]) {
        try {
          (_b2 = sdk == null ? void 0 : sdk[_analytics]) == null ? void 0 : _b2.trackCustomEvent(key, properties);
        } catch (e) {
          (_c2 = getSentry()) == null ? void 0 : _c2.captureException(e);
        }
      }
      trackEvent(_, key, "app", properties);
    },
    addMultiSearch(onInputChange, keys) {
      const multiSearch = new MultiSearch(onInputChange);
      keys.forEach((key) => {
        const searchFunction = multiSearch.createSearchFunction(key);
        const callbackKey = `commandbar-search-${key}`;
        globalActions.addCallbacks({ [callbackKey]: searchFunction });
      });
    },
    addContext(_key, initialValue, options) {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
      const firstArgType = getFirstType(_key);
      const secondArgType = getSecondType(initialValue);
      const thirdArgType = getThirdType(options);
      const _case = getCase(firstArgType, secondArgType, thirdArgType);
      let context = {};
      const callbacks = {};
      let callbackKey;
      switch (_case) {
        case 0 /* OLD_ADD_CONTEXT */:
          context = _key;
          globalActions.addContext(context);
          return;
        case 1 /* NEW_ADD_CONTEXT */:
          const key = _key;
          switch (secondArgType) {
            case 2 /* STATIC */:
              context[key] = initialValue;
              break;
            case 1 /* FUNCTION */:
              const initialValueFnKey = `commandbar-initialvalue-${key}`;
              callbacks[initialValueFnKey] = initialValue;
              if (!_.context.hasOwnProperty(key)) {
                const loaderFn = initialValue;
                new Promise(async (resolve, reject) => {
                  try {
                    const results = await loaderFn();
                    resolve(results);
                  } catch (e) {
                    reject(e);
                  }
                }).then((results) => globalActions.addContext({ [key]: results })).catch((e) => {
                  var _a3;
                  (_a3 = getSentry()) == null ? void 0 : _a3.captureException(e);
                  Logger_default.error(`Function loader caused an error. Key: ${key}`, e);
                  globalActions.addContext({ [key]: [] });
                });
              }
              break;
          }
          if ((_a2 = options == null ? void 0 : options.searchOptions) == null ? void 0 : _a2.searchFunction) {
            const customSearchFunction = (_b2 = options == null ? void 0 : options.searchOptions) == null ? void 0 : _b2.searchFunction;
            if (typeof customSearchFunction !== "function") {
              Logger_default.error("CustomSearchFunction is not a function");
            }
            callbackKey = `commandbar-search-${key}`;
            callbacks[callbackKey] = customSearchFunction;
          }
          let partialContextSettings;
          if (options) {
            partialContextSettings = {
              [key]: {
                description_field: (_c2 = options == null ? void 0 : options.renderOptions) == null ? void 0 : _c2.descriptionKey,
                label_field: (_d = options == null ? void 0 : options.renderOptions) == null ? void 0 : _d.labelKey,
                icon: (_e = options == null ? void 0 : options.renderOptions) == null ? void 0 : _e.defaultIcon,
                detail: (_f = options == null ? void 0 : options.renderOptions) == null ? void 0 : _f.detail,
                content: (_g = options == null ? void 0 : options.renderOptions) == null ? void 0 : _g.content,
                show_preview: (_h = options == null ? void 0 : options.renderOptions) == null ? void 0 : _h.show_preview,
                search: (_i = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _i.quickFind,
                unfurl: (_j = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _j.unfurl,
                auto_execute: (_k = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _k.autoExecute,
                name: (_l = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _l.categoryName,
                sort_key: (_m = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _m.categorySortKey,
                track_recents: (_n = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _n.showInRecents,
                showResources: (_o = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _o.showInDefaultEmptyState,
                max_options_count: (_p = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _p.maxOptionsCount,
                search_fields: (_q = options == null ? void 0 : options.searchOptions) == null ? void 0 : _q.fields,
                sortFunction: (_r = options == null ? void 0 : options.searchOptions) == null ? void 0 : _r.sortFunction,
                onInputChangeOptions: {
                  applySort: (_t = (_s = options == null ? void 0 : options.searchOptions) == null ? void 0 : _s.onInputChangeOptions) == null ? void 0 : _t.applySort
                },
                render_as: (_u = options == null ? void 0 : options.renderOptions) == null ? void 0 : _u.renderAs,
                search_tab_enabled: (_v = options == null ? void 0 : options.renderOptions) == null ? void 0 : _v.searchTabEnabled
              }
            };
          }
          globalActions.setContextState(callbacks, context, partialContextSettings);
          if ((_w = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _w.url) {
            const operation = !!_.callbacks["commandbar-router"] ? "router" : "self";
            sdk.addRecordAction(key, {
              text: `Open ${key}`,
              template: { type: "link", operation, value: (_x = options == null ? void 0 : options.quickFindOptions) == null ? void 0 : _x.url },
              name: `open_${key}`
            });
          }
          return;
        default:
          Logger_default.error(_case, _key, initialValue, options);
          return;
      }
    },
    async addEventHandler(eventHandler) {
      var _a2;
      if (!!((_a2 = _.organization) == null ? void 0 : _a2.allow_event_handlers)) {
        globalActions.addCallbacks({ "commandbar-event-handler": eventHandler });
      } else {
        Logger_default.warn("Event handlers are only available for enterprise customers. Please contact CommandBar.");
      }
      sdkMethodCalled("addEventHandler");
      Track.internal.sdkMethodCalled("addEventHandler");
    },
    async addEventSubscriber(listener, options) {
      var _a2;
      const eventSubscriptions = sdk[_eventSubscriptions];
      if (!eventSubscriptions)
        throw new Error("SDK not initialized properly -- event subscriptions cannot be added");
      if (!((_a2 = _.organization) == null ? void 0 : _a2.allow_event_handlers)) {
        Logger_default.warn("Event handlers are only available for enterprise customers. Please contact CommandBar.");
        return () => {
          return;
        };
      }
      const s = Symbol();
      if (options == null ? void 0 : options.v2) {
        eventSubscriptions.set(s, [listener, options]);
      } else {
        eventSubscriptions.set(s, [listener, void 0]);
      }
      sdkMethodCalled("addEventSubscriber");
      Track.internal.sdkMethodCalled("addEventSubscriber", options);
      return () => {
        eventSubscriptions.delete(s);
      };
    },
    async addRecordAction(recordKey, action, isDefault, showInDefaultList2 = false) {
      await validateFromClient(action);
      let order_key = 1;
      if (action.arguments) {
        Object.values(action.arguments || {}).forEach((a) => {
          if (order_key >= a.order_key) {
            order_key = a.order_key - 1;
          }
        });
      }
      const record12 = {
        type: "context",
        value: recordKey,
        order_key,
        label: "Select from the list below",
        show_in_record_action_list: true,
        show_in_default_list: showInDefaultList2
      };
      const actionWithArguments = {
        ...action,
        arguments: {
          record: record12,
          ...action.arguments
        }
      };
      this.addCommand(actionWithArguments);
      if (isDefault) {
        globalActions.updateLocalContextSetting(recordKey, "default_command_id", action.name);
      }
    },
    addRecords(key, initial, options) {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      const addContextOptions = {
        renderOptions: {
          labelKey: options == null ? void 0 : options.labelKey,
          descriptionKey: options == null ? void 0 : options.descriptionKey,
          defaultIcon: options == null ? void 0 : options.defaultIcon,
          detail: options == null ? void 0 : options.detail,
          content: options == null ? void 0 : options.content,
          show_preview: options == null ? void 0 : options.show_preview,
          renderAs: options == null ? void 0 : options.renderAs,
          searchTabEnabled: options == null ? void 0 : options.searchTabEnabled
        },
        searchOptions: {
          fields: options == null ? void 0 : options.searchableFields,
          searchFunction: options == null ? void 0 : options.onInputChange,
          onInputChangeOptions: {
            applySort: (_a2 = options == null ? void 0 : options.onInputChangeOptions) == null ? void 0 : _a2.applySort
          }
        },
        quickFindOptions: {
          categoryName: (_b2 = options == null ? void 0 : options.recordOptions) == null ? void 0 : _b2.categoryName,
          unfurl: (_c2 = options == null ? void 0 : options.recordOptions) == null ? void 0 : _c2.unfurl,
          categorySortKey: (_d = options == null ? void 0 : options.recordOptions) == null ? void 0 : _d.categorySortKey,
          showInDefaultEmptyState: (_e = options == null ? void 0 : options.recordOptions) == null ? void 0 : _e.showInDefaultEmptyState,
          maxOptionsCount: (_f = options == null ? void 0 : options.recordOptions) == null ? void 0 : _f.maxOptionsCount,
          quickFind: true,
          url: (_g = options == null ? void 0 : options.recordOptions) == null ? void 0 : _g.url,
          showInRecents: (_h = options == null ? void 0 : options.recordOptions) == null ? void 0 : _h.showInRecents
        }
      };
      this.addContext(key, initial, addContextOptions);
    },
    addRouter(routerFn) {
      globalActions.addCallbacks({ "commandbar-router": routerFn });
    },
    addSearch(name, func) {
      const callbackKey = `commandbar-search-${name.replace(/\s+/g, "")}`;
      globalActions.addCallbacks({ [callbackKey]: func });
    },
    async setFormFactor(formFactor) {
      _.spotlight.formFactor = ref11(formFactor);
      sdk[_instanceAttributes].formFactor = formFactor;
    },
    /**
     * Sets the user properties for the current user. These properties will be associated with the user and can be used for targeting.
     * boot() must be called before setUserProperties() can be called.
     *
     * @param userProperties Key-value pairs to be associated with the end user ID CommandBar was booted with.
     */
    async setUserProperties(properties) {
      var _a2, _b2, _c2, _d;
      if (sdk[_user] === void 0) {
        Logger_default.warn("Cannot set user properties before boot has been called.");
        return;
      }
      const userId = sdk[_user];
      if (!userId) {
        Logger_default.warn("Cannot set user properties for an anonymous user.");
        return;
      }
      if (sdk[_configuration].airgap || sdk[_configuration].silent === true && !((_a2 = _.organization) == null ? void 0 : _a2.end_user_shortcuts_enabled)) {
        Logger_default.warn("Cannot set user properties for an airgapped organization.");
        return;
      }
      const { hmac } = sdk[_instanceAttributes];
      try {
        const endUser = await identify(
          sdk[_configuration].uuid,
          userId,
          {
            properties
          },
          hmac
        );
        if (endUser) {
          _.endUser = { ...endUser, hmac };
        } else {
          _.endUser = null;
          sdk[_fingerprint] = createFingerprint();
        }
      } catch (e) {
        Logger_default.error("Failed to fetch end user data", e);
        (_b2 = getSentry()) == null ? void 0 : _b2.captureException(e);
      }
      try {
        const { version } = sdk[_configuration];
        const { env, envOverride, isAdmin } = _;
        const decideResult = await decide(sdk[_configuration].uuid, userId, {
          properties,
          envOverride,
          env,
          version,
          is_admin: isAdmin
        });
        if (decideResult) {
          _.decide = decideResult;
        }
      } catch (e) {
        Logger_default.error("Failed to fetch decide data", e);
        (_c2 = getSentry()) == null ? void 0 : _c2.captureException(e);
      }
      try {
        await refreshEndUserData(_);
      } catch (e) {
        Logger_default.error("Failed to refresh end user data", e);
        (_d = getSentry()) == null ? void 0 : _d.captureException(e);
      }
      sdk[_userProperties] = { ...sdk[_userProperties], ...properties };
      Analytics_default.identify({ user_attributes: JSON.stringify(properties) });
      Track.identify(properties);
      Track.decide(_.decide, properties);
    },
    /**
     * Boot examples:
     *   Anonymous user: .boot()
     *   Old: .boot({id: 'someid', org: 'someorg'})
     *   New: .boot('someid')
     *   New w/ event attrs: .boot('someid', {org: 'someorg'})
     */
    async boot(opts, userProperties, instanceAttributes, metaAttributes = {}) {
      var _a2, _b2, _c2, _d, _e, _f;
      Logger_default.info("booting...", opts, userProperties, instanceAttributes);
      if (instanceAttributes == null ? void 0 : instanceAttributes.impersonateMode) {
        sdk[_configuration].studioImpersonateMode = true;
      }
      if (sdk[_configuration].uuid === void 0) {
        throw new Error(
          "CommandBar: Organization ID is undefined. Call config() to set the organization ID before calling boot()."
        );
      }
      let userId;
      let ctx = {};
      if (!opts) {
        userId = void 0;
      } else if (typeof opts === "string") {
        userId = opts;
        ctx = { ...userProperties };
      } else if (typeof opts === "object") {
        ({ id: userId, ...ctx } = opts);
        if (typeof (opts == null ? void 0 : opts.id) === "string") {
          userId = opts.id;
        } else {
          Logger_default.warn(
            "Booting anonymous user because provided boot object didn't include an id key with a string value"
          );
        }
      } else {
        Logger_default.error("Boot parameter should be a string or key-value pair");
      }
      if (!userId) {
        userId = null;
      }
      globalActions.addContext({ ...ctx, id: userId });
      _.active = true;
      sdk[_userProperties] = { ...userProperties };
      if (instanceAttributes == null ? void 0 : instanceAttributes.products) {
        instanceAttributes.products = instanceAttributes.products.map((product) => {
          if (product === "questlists")
            return "checklists";
          if (product === "bar")
            return "spotlight";
          return product;
        });
      }
      sdk[_instanceAttributes] = { ...DEFAULT_INSTANCE_ATTRIBUTES, ...instanceAttributes };
      sdk[_metaAttributes] = { ...DEFAULT_META_ATTRIBUTES, ...metaAttributes };
      if (LEGACY_INLINE_BAR[sdk[_configuration].uuid]) {
        if (!instanceAttributes || !("formFactor" in instanceAttributes)) {
          sdk[_instanceAttributes] = {
            ...sdk[_instanceAttributes],
            formFactor: { type: "inline", rootElement: "commandbar-inline-root" }
          };
        }
      }
      _.spotlight.formFactor = ref11(sdk[_instanceAttributes].formFactor);
      _.products = sdk[_instanceAttributes].products;
      if (sdk[_user] === userId) {
        Logger_default.info("Same user has been booted already. Not re-loading user");
        return Promise.resolve();
      }
      sdk[_user] = userId;
      Analytics_default.setBootStatus(true);
      sdk[_analytics].setBootStatus(true);
      if ((_a2 = _.flags) == null ? void 0 : _a2["release-analytics-events-refresh"]) {
        sdk[_analytics].enable();
      }
      if (!!userId && !sdk[_configuration].airgap && !sdk[_configuration].studioImpersonateMode && (sdk[_configuration].silent === false || !!((_b2 = _.organization) == null ? void 0 : _b2.end_user_shortcuts_enabled))) {
        try {
          const endUser = await identify(
            sdk[_configuration].uuid,
            userId,
            {
              properties: userProperties
            },
            instanceAttributes == null ? void 0 : instanceAttributes.hmac
          );
          if (endUser) {
            _.endUser = { ...endUser, hmac: instanceAttributes == null ? void 0 : instanceAttributes.hmac };
          } else {
            _.endUser = null;
            sdk[_fingerprint] = createFingerprint();
          }
        } catch (e) {
          Logger_default.error("Failed to fetch end user data", e);
          (_c2 = getSentry()) == null ? void 0 : _c2.captureException(e);
        }
      } else {
        _.endUser = null;
        sdk[_fingerprint] = createFingerprint();
      }
      try {
        const { version } = sdk[_configuration];
        const { env, envOverride, isAdmin } = _;
        const decideResult = await decide(sdk[_configuration].uuid, (_d = _.endUser) == null ? void 0 : _d.slug, {
          properties: userProperties,
          envOverride,
          env,
          version,
          is_admin: isAdmin
        });
        if (decideResult) {
          _.decide = decideResult;
        }
      } catch (e) {
        Logger_default.error("Failed to fetch decide data", e);
        (_e = getSentry()) == null ? void 0 : _e.captureException(e);
      }
      try {
        await refreshEndUserData(_);
      } catch (e) {
        Logger_default.error("Failed to refresh end user data", e);
        (_f = getSentry()) == null ? void 0 : _f.captureException(e);
      }
      startSession(sdk[_configuration].session);
      Analytics_default.identify({ user_attributes: JSON.stringify({ ...ctx, id: userId }) });
      Track.identify({ ...ctx, id: userId });
      Track.decide(_.decide, { ...ctx, id: userId });
    },
    close() {
      spotlight.closeBarAndReset();
    },
    closeAllNudges() {
      var _a2;
      (_a2 = getAllNudgeServices(_)) == null ? void 0 : _a2.forEach((service) => {
        service == null ? void 0 : service.send("DISMISS");
      });
    },
    execute(id2) {
      var _a2;
      const command = getCommandById(_, id2);
      const executeCommand2 = (command2) => {
        globalActions.executeCommand(command2, void 0, () => {
          Logger_default.error(`Command with id ${id2} is unavailable.`);
        });
      };
      if (command) {
        executeCommand2(command);
      } else if ((_a2 = _.organization) == null ? void 0 : _a2.id) {
        helpdocService_default.getHelpdocCommand(_, id2).then((command2) => {
          if (command2) {
            executeCommand2(command2);
          } else {
            Logger_default.error(`Command with id=${id2} wasn't found.`);
          }
        });
      } else {
        Logger_default.error(`CommandBar wasn't initialized successfully`);
      }
    },
    generateDetailPreview(fn) {
      _.detailPreviewGenerator = fn;
    },
    addComponent(key, name, component) {
      _.components[key] = { name, component };
    },
    removeComponent(key) {
      delete _.components[key];
    },
    getCommands(filter = () => true) {
      const shortcutEntries = [];
      getCommands(_).forEach((command) => {
        var _a2;
        let customShortcut = void 0;
        const cmdUID = commandUID(command);
        if (!!((_a2 = _.endUserStore.data.hotkeys) == null ? void 0 : _a2[cmdUID])) {
          customShortcut = _.endUserStore.data.hotkeys[cmdUID];
        }
        const platformString = _.platform === "mac" ? "mac" : "win";
        const commandDetails = {
          command: (command == null ? void 0 : command.id) > 1 ? command.id : command.name,
          commandText: command.text,
          category: command.category,
          callbackKey: command.template.type === "callback" ? command.template.value : void 0,
          source: command.source || "standard",
          shortcut_mac: Hotkey_default.toPlatformSpecificString(command.hotkey_mac, "mac"),
          shortcut_win: Hotkey_default.toPlatformSpecificString(command.hotkey_win, "win"),
          customShortcut: customShortcut ? Hotkey_default.toPlatformSpecificString(customShortcut, platformString) : void 0
        };
        if (filter(commandDetails)) {
          shortcutEntries.push(commandDetails);
        }
      });
      return shortcutEntries;
    },
    isOpen() {
      return _.spotlight.visible;
    },
    open(input, options) {
      spotlight.openBarWithOptionalText("programmatic", {
        startingInput: input,
        categoryFilterID: options == null ? void 0 : options.categoryFilter
      });
    },
    openEditor() {
      openEditor(_);
    },
    async openHelpHub(options = {}) {
      var _a2;
      helphubActions.setHelpHubVisible(false);
      const orgId = (_a2 = _.organization) == null ? void 0 : _a2.id;
      let article;
      if (options.articleId && orgId) {
        const command = getCommandById(_, options.articleId) || await helpdocService_default.getHelpdocCommand(_, options.articleId);
        if (command == null ? void 0 : command.training_only)
          return;
        article = command ? commandToHelpHubDoc(command) : void 0;
      } else if (options.articleId === null) {
        article = null;
      }
      helphubActions.setHelpHubVisible(true, {
        query: options.query,
        article,
        chatOnly: options.chatOnly
      });
    },
    async openCopilot(options = {}) {
      helphubActions.setHelpHubVisible(false);
      helphubActions.navigate({ item: { page: "start-chat", params: { initialQuery: options.query } } });
      helphubActions.setHelpHubVisible(true);
      helphubActions.setHelpHubMinimized(!!options.minimized);
    },
    setHelpHubFilter(_filter) {
      let filter;
      try {
        filter = decodeThrowing2(HelpHubFilterV, _filter);
      } catch (e) {
        throw new Error("Invalid filter; must be of type `{ labels?: string[] }`");
      }
      _.helpHub.filter = filter;
    },
    clearHelpHubFilter() {
      _.helpHub.filter = null;
    },
    closeHelpHub() {
      helphubActions.setHelpHubVisible(false);
      LocalStorage_default.set("copilot.open", false);
    },
    toggleHelpHub() {
      if (_.helpHub.visible) {
        LocalStorage_default.set("copilot.open", false);
      }
      helphubActions.setHelpHubVisible(!_.helpHub.visible);
    },
    removeCallback(callbackKey) {
      globalActions.removeCallback(callbackKey);
    },
    removeCommand(commandName) {
      globalActions.removeCommand(commandName);
    },
    removeContext(keyToRemove) {
      globalActions.removeContext(keyToRemove);
    },
    // if input is null we remove binding
    setSummonHotkey(hotkey) {
      let toSet = null;
      if (hotkey === null) {
        toSet = "";
      } else if (hotkey) {
        hotkey = Hotkey_default.toModString(Hotkey_default.normalize(hotkey), _.platform === "mac" ? "mac" : "win");
        if (Hotkey_default.validate(hotkey)) {
          toSet = hotkey;
        }
      }
      if (toSet === selectDefaultSummonHotkey(_)) {
        toSet = void 0;
      }
      if (toSet !== null) {
        const endUserShortcuts = endUserStoreActions.updateEndUserHotkey(SUMMON_HOTKEY_SLUG, toSet);
        return !!endUserShortcuts && endUserShortcuts[SUMMON_HOTKEY_SLUG] === toSet;
      }
      Logger_default.error(`[CommandBar] ${hotkey} is an invalid hotkey.`);
      return false;
    },
    setCustomComponent(slug21, getComponent) {
      const organization = _.organization;
      const allowCustomization = (organization == null ? void 0 : organization.branding) !== "branded" || (organization == null ? void 0 : organization.id) === "af6750c6";
      if (!!allowCustomization) {
        const validateComponent = (_getComponent, meta) => {
          if (!_getComponent)
            return null;
          if (typeof _getComponent !== "function")
            return null;
          const _component = _getComponent({ step: meta == null ? void 0 : meta.step, activeTab: meta == null ? void 0 : meta.activeTab });
          if (typeof _component === "string" && !isHTML(_component)) {
            Logger_default.warn("Invalid HTML template.");
            return null;
          } else {
            return _component;
          }
        };
        const component = (meta) => validateComponent(getComponent, { step: meta == null ? void 0 : meta.step, activeTab: meta == null ? void 0 : meta.activeTab });
        _.spotlight.userDefinedCustomComponents[slug21] = component;
      } else {
        Logger_default.warn("Custom UI components are only available for enterprise customers. Please contact CommandBar.");
      }
    },
    setContext(context, meta) {
      if (meta !== void 0) {
        if ((meta == null ? void 0 : meta.useCustom) && (meta == null ? void 0 : meta.customID)) {
          LocalStorage_default.set("customcontext", meta.customID);
        } else {
          LocalStorage_default.remove("customcontext");
        }
      } else {
        LocalStorage_default.remove("customcontext");
      }
      globalActions.setContext(context);
    },
    setTheme(theme, color) {
      sdk[_programmaticTheme] = typeof theme === "string" ? theme : "";
      globalActions.setBaseTheme(theme, "setThemeFunction", color);
    },
    shareCallbacks() {
      const callbacks = snapshot3(_.callbacks);
      return Object.fromEntries(
        Object.entries(callbacks).filter(
          ([key]) => !key.startsWith(SDK_INTERNAL_PREFIX) && !key.startsWith("commandbar-initialvalue-" + SDK_INTERNAL_PREFIX)
        )
      );
    },
    shareComponentNamesByKey() {
      const result = {};
      for (const [key, value] of Object.entries(_.components)) {
        if (!value)
          continue;
        result[key] = value.name;
      }
      return result;
    },
    shareContext() {
      return selectContextForExternalUse(_, true);
    },
    isUserVerified() {
      return _.endUserStore.verified;
    },
    shareState() {
      var _a2;
      return {
        isBooted: Analytics_default.hasBooted,
        currentInput: _.spotlight.inputText,
        config: {
          helphub_enabled: isHelpHubWidgetAvailable(_)
        },
        searchFilter: (_a2 = _.spotlight.searchFilter) == null ? void 0 : _a2.inputTag
      };
    },
    shutdown() {
      var _a2;
      _.active = false;
      Analytics_default.setBootStatus(false);
      sdk[_analytics].setBootStatus(false);
      sdk[_user] = void 0;
      (_a2 = getAllNudgeServices(_)) == null ? void 0 : _a2.forEach((service) => {
        service == null ? void 0 : service.send("DISMISS");
      });
      globalActions.setContext({});
    },
    triggerSearchFunctions() {
      const savedInput = _.spotlight.inputText;
      _.spotlight.inputText = " ";
      _.spotlight.inputText = savedInput;
    },
    triggerChecklist(id2) {
      const checklist3 = getChecklistById(_, id2);
      if (checklist3) {
        forceTriggerChecklist(_, checklist3);
      } else {
        console.error(`triggerChecklist: Checklist with id: ${id2} not found`);
      }
    },
    triggerNudge(id2) {
      const nudge = getNudgeById(_, id2);
      if (nudge) {
        nudgeActions.closeAllNudgeMocks();
        nudgeActions.forceTriggerSingleNudge(nudge);
      } else {
        console.error(`triggerNudge: Nudge with id: ${id2} not found`);
      }
    },
    updateContextSettings(key, settings) {
      globalActions.setLocalContextSettings(key, { ...settings });
    },
    unmount() {
      const container = document.getElementById("commandbar");
      if (container)
        unmountComponentAtNode(container);
    },
    setThemeMode(mode) {
      if (["light_mode", "dark_mode", "auto"].includes(mode))
        _.themeV2Mode = mode;
    }
  };
  const internalSDKMixin = {
    [_analytics]: new AnalyticsV2(),
    async [_configure](uid) {
      var _a2, _b2, _c2, _d, _e;
      (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({
        level: "debug",
        category: "internal",
        message: "_configure called",
        data: { uid }
      });
      const airgap = !!sdk[_configuration].config;
      sdk[_configuration].airgap = airgap;
      sdk[_configuration].uuid = uid;
      sdk[_configuration].silent = !!localStorage.getItem("commandbar.takeover") ? true : (_b2 = sdk[_configuration]) == null ? void 0 : _b2["silent"];
      _.env = (_c2 = sdk[_configuration].environment) != null ? _c2 : null;
      _.version = (_d = sdk[_configuration].version) != null ? _d : null;
      _.airgap = airgap;
      const org_id_takeover = localStorage.getItem("commandbar.takeover");
      if (org_id_takeover) {
        (_e = getSentry()) == null ? void 0 : _e.addBreadcrumb({
          level: "debug",
          category: "internal",
          message: "Setting org_id_takeover from localStorage",
          data: { org_id_takeover }
        });
        sdk[_configuration].uuid = org_id_takeover;
        _.env = null;
        _.version = null;
      }
      await sdk[_configUser]();
      dispatchCustomEvent("commandbar-configure-complete", {});
    },
    async [_configUser]() {
      var _a2, _b2;
      (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({
        level: "debug",
        category: "internal",
        message: "_configUser called"
      });
      const token = LocalStorage_default.get("token", "");
      if (!!token) {
        globalActions.setIsAdmin(true);
        const _testMode = !!LocalStorage_default.get("testMode", "");
        globalActions.setTestMode(_testMode);
        try {
          globalActions.setEnvOverride(JSON.parse(LocalStorage_default.get("envOverride", "null")));
        } catch (e) {
          (_b2 = getSentry()) == null ? void 0 : _b2.captureException(e);
          console.warn("Failed to parse env override from LocalStorage", { error: e });
        }
      } else {
        globalActions.setIsAdmin(false);
      }
      const {
        commands,
        categories,
        organization,
        environments,
        placeholders,
        nudges,
        checklists,
        tabs,
        helphub_recommendation_sets,
        helphub_additional_resources,
        flags,
        localized_messages,
        themes,
        keywords
      } = await getConfig2(_);
      globalActions.setCommands(commands);
      globalActions.setTabs(tabs);
      _.environments = environments != null ? environments : null;
      _.flags = flags;
      _.localizedMessages = localized_messages;
      _.themes = themes;
      _.keywords = keywords;
      spotlight.setCategories(categories);
      globalActions.setOrganization(organization, "initial_load");
      spotlight.setPlaceholders(placeholders);
      nudgeActions.initNudges(nudges || []);
      checklistActions.setChecklists(checklists || []);
      helphubActions.setHelpHubRecommendationSets(helphub_recommendation_sets || []);
      _.helpHub.additionalResources = helphub_additional_resources != null ? helphub_additional_resources : null;
      nudgeActions.setupTimedTriggers([...nudges, ...checklists]);
    },
    [_configuration]: {
      api: "",
      editor: "",
      session: "",
      uuid: "",
      cdn: "",
      airgap: false,
      ...proxy2[_configuration]
    },
    [_dispose]() {
      if (proxy2[_disposed])
        return;
      proxy2[_disposed] = true;
      proxy2[_queue].length = 0;
      Object.keys(proxy2).forEach((k) => {
        const v = proxy2[k];
        if (isDisposable(v))
          dispose(v);
        delete proxy2[k];
      });
      _.spotlight.searchOptionsDebouncer.cancel();
      Object.assign(window, { CommandBar: void 0 });
    },
    [_disposed]: false,
    [_userProperties]: void 0,
    [_instanceAttributes]: DEFAULT_INSTANCE_ATTRIBUTES,
    [_metaAttributes]: DEFAULT_META_ATTRIBUTES,
    [_isProxy]: false,
    [_loadEditor](path) {
      const configuration = sdk[_configuration];
      if (!configuration || !configuration.api || !configuration.uuid || !configuration.editor) {
        Logger_default.warn("configuration details are missing; cannot open editor");
        return;
      }
      _.isEditorVisible = !!LocalStorage_default.get("editor.open", false);
      _.isEditorActive = true;
      _.initialEditorPath = path != null ? path : null;
    },
    [_shareEditorRouteWithBar](path) {
      _.editorPathChangeListeners.forEach((l) => l(path));
    },
    [_updateEditorPreviewDevice](device) {
      _.editorPreviewDevice = device;
    },
    [_getEditorPreviewDevice]() {
      return _.editorPreviewDevice;
    },
    // REVIEW: What is the right way to initialize this? It will always equal false as-is.
    [_perf]: false,
    [_programmaticTheme]: void 0,
    [_eventSubscriptions]: /* @__PURE__ */ new Map(),
    async [_reload](reloadTargets = _reloadTargets) {
      const config2 = await getConfig2(_);
      for (const method of reloadTargets) {
        const symbol = Symbol.for(`CommandBar::${String(method)}`);
        const fn = sdk[symbol];
        if (fn instanceof Function) {
          fn(config2);
        }
      }
    },
    async [_reloadCommands](preLoadedConfig) {
      const config2 = preLoadedConfig || await getConfig2(_);
      const { commands, categories, organization, environments } = config2;
      globalActions.setCommands(commands);
      _.environments = environments != null ? environments : null;
      spotlight.setCategories(categories);
      globalActions.setOrganization(organization, "initial_load");
    },
    async [_reloadOrganization](preLoadedConfig) {
      sdk[_programmaticTheme] = void 0;
      const {
        organization,
        environments,
        helphub_additional_resources,
        helphub_recommendation_sets,
        localized_messages,
        keywords
      } = preLoadedConfig || await getConfig2(_);
      globalActions.setOrganization(organization, "reload_organization");
      _.helpHub.additionalResources = helphub_additional_resources != null ? helphub_additional_resources : null;
      _.helpHub.recommendationSets = helphub_recommendation_sets != null ? helphub_recommendation_sets : null;
      _.environments = environments != null ? environments : null;
      _.localizedMessages = localized_messages;
      _.keywords = keywords;
    },
    async [_reloadPlaceholders](preLoadedConfig) {
      const { placeholders } = preLoadedConfig || await getConfig2(_);
      spotlight.setPlaceholders(placeholders);
    },
    async [_reloadNudges](preLoadedConfig) {
      const { nudges } = preLoadedConfig || await getConfig2(_);
      nudgeActions.initNudges(nudges || []);
    },
    async [_reloadThemes](preLoadedConfig) {
      const { themes } = preLoadedConfig || await getConfig2(_);
      _.themes = themes;
    },
    async [_reloadFlags](preLoadedConfig) {
      const { flags } = preLoadedConfig || await getConfig2(_);
      _.flags = flags;
    },
    async [_reloadHelpHub](preLoadedConfig) {
      var _a2, _b2, _c2;
      const { visible, hubDoc, query } = _.helpHub;
      const orgId = (_a2 = _.organization) == null ? void 0 : _a2.id;
      const { helphub_recommendation_sets } = preLoadedConfig || await getConfig2(_);
      _.helpHub.recommendationSets = helphub_recommendation_sets != null ? helphub_recommendation_sets : null;
      if (orgId) {
        if (((_b2 = _.helpHub.recommendationSets) == null ? void 0 : _b2.length) < 1) {
          const docs = await queryHelpDocs(orgId, query != null ? query : "", _.endUser, _.helpHub.filter);
          _.helpHub.searchResults = docs;
        }
        updateHotloadedHelpdocCommands(_);
        if (hubDoc) {
          const doc = await helpdocService_default.getHelpdoc(_, hubDoc.command.id, void 0, true);
          if (doc) {
            helphubActions.setHelpHubVisible(visible, {
              query: query != null ? query : void 0,
              article: doc
            });
          } else {
            helphubActions.setHelpHubDoc(null);
          }
        }
        const { version } = sdk[_configuration];
        const { env, envOverride } = _;
        const decideResult = await decide(sdk[_configuration].uuid, (_c2 = _.endUser) == null ? void 0 : _c2.slug, {
          properties: sdk[_userProperties],
          envOverride,
          env,
          version
        });
        if (decideResult) {
          _.decide = decideResult;
        }
      }
    },
    [_startNudgeDebug](data) {
      const { nudge } = data;
      if (window.CommandBar.isOpen()) {
        window.CommandBar.close();
      }
      nudgeActions.closeAllNudgeMocks();
      nudgeActions.startDebugSession(nudge, void 0, { refreshDecide: true, toStepIndex: 0 });
    },
    async [_stopNudgeDebug]() {
      nudgeActions.stopDebugSession();
    },
    [_showNudgeStepMock](data) {
      var _a2;
      if (window.CommandBar.isOpen()) {
        window.CommandBar.close();
      }
      (_a2 = getAllNudgeServices(_)) == null ? void 0 : _a2.forEach((service) => {
        service == null ? void 0 : service.send("CLOSE");
      });
      nudgeActions.showStepMock(data.nudge, data.stepIndex, { forceOpen: data.forceOpen });
    },
    [_closeNudgeMocks]() {
      nudgeActions.closeAllNudgeMocks();
    },
    [_previewChecklist](data) {
      const { checklist: checklist3, clearData } = data;
      if (clearData) {
        checklistActions.clearChecklistData(checklist3);
        checklist3.items.forEach((item) => {
          if (item.action.type === "nudge") {
            nudgeActions.resetNudge(item.action.value, { dismiss: true });
          }
        });
      }
      if (window.CommandBar.isOpen()) {
        window.CommandBar.close();
      }
      checklistActions.showChecklist(checklist3);
    },
    [_stopChecklistPreview]() {
      checklistActions.hideChecklist();
    },
    [_previewRecommendationSet](data) {
      if (typeof (data == null ? void 0 : data.recommendationSet) !== "undefined") {
        helphubActions.setPreviewRecommendationSet(data.recommendationSet);
      } else {
        helphubActions.setPreviewRecommendationSet(null);
      }
    },
    [_previewCopilotSettings](data) {
      const { settings } = data;
      copilotActions.previewCopilotSettings(settings);
      if (!settings) {
        return;
      }
      if (_.helpHub.visible && !_.helpHub.chatOnly) {
        helphubActions.setHelpHubVisible(false);
      }
      helphubActions.setHelpHubVisible(true, { chatOnly: true });
    },
    [_stopRecommendationSetPreview]() {
      helphubActions.setPreviewRecommendationSet(null);
    },
    async [_reloadChecklists]() {
      const { checklists } = await getConfig2(_);
      checklistActions.setChecklists(checklists || []);
    },
    [_report](event, data) {
      Analytics_default.log(event, { ...data, user_event: true });
    },
    [_search]: "",
    [_sentry]: proxy2[_sentry],
    [_setDashboard](_element) {
    },
    [_setPreviewMode](on) {
      if (_.isAdmin) {
        _.spotlight.previewMode = on;
      }
    },
    [_setTestMode](on) {
      if (_.isAdmin) {
        globalActions.setTestMode(on);
      }
    },
    [_setEditorVisible](visible) {
      _.isEditorVisible = visible;
    },
    [_shareConfig]() {
      return {
        commands: _.commands,
        categories: _.spotlight.categories,
        organization: _.organization || void 0,
        environments: _.environments || void 0,
        placeholders: _.spotlight.placeholders,
        nudges: getAllNudges(_),
        checklists: _.checklists,
        tabs: _.spotlight.tabs
      };
    },
    [_shareProgrammaticCommands]() {
      return _.programmaticCommands;
    },
    [_shareTrackedEvents]() {
      return { trackedEvents: [..._.trackedAppEvents] };
    },
    [_shareContextSettings]() {
      const _localContextSettings = snapshot3(_.localContextSettings);
      const serverContextSettings = snapshot3(_.serverContextSettings);
      const localContextSettings = Object.fromEntries(
        Object.entries(_localContextSettings).filter(([key]) => !key.startsWith(SDK_INTERNAL_PREFIX))
      );
      return {
        local: localContextSettings,
        server: serverContextSettings
      };
    },
    [_showGuide](_eventName, _preview) {
      console.error("This method is deprecated.");
    },
    [_showMessage](_eventName, _preview) {
      console.error("This method is deprecated.");
    },
    [_updateEditorRoute](data) {
      const event = new CustomEvent("updateEditorRoute", { detail: data });
      window.dispatchEvent(event);
    },
    [_startDebug](data) {
      const { product } = data;
      if (product && PRODUCTS.includes(product)) {
        if (product === "nudges") {
          LocalStorage_default.set(`debug:${product}`, "true");
          Logger_default.info(`Enabled debugging for ${product}. Restart the application.`);
        } else {
          Logger_default.error(`Debugging for ${product} is not supported. Supported products: nudges`);
        }
      } else {
        Logger_default.error("startDebug called without a valid product");
      }
    },
    [_stopDebug](product) {
      if (product) {
        LocalStorage_default.remove(`debug:${product}`);
        Logger_default.info(`Disabled debugging for ${product}. Restart the application.`);
      } else {
        for (const product2 of PRODUCTS) {
          LocalStorage_default.remove(`debug:${product2}`);
        }
        Logger_default.info(`Disabled debugging for all products. Restart the application.`);
      }
    },
    [_getDebugSnapshot](data) {
      if (data == null ? void 0 : data.nudgeId) {
        const nudge = getNudgeById(_, data == null ? void 0 : data.nudgeId);
        if (nudge) {
          getDebugSnapshot(_, nudge, data == null ? void 0 : data.stepIndex).then((snapshot4) => {
            var _a2, _b2, _c2, _d, _e;
            (_c2 = getSentry()) == null ? void 0 : _c2.captureMessage(`Nudge debug snapshot: ${((_a2 = snapshot4.nudge) == null ? void 0 : _a2.slug) || ((_b2 = snapshot4.nudge) == null ? void 0 : _b2.id)}`, "info", {
              data: snapshot4,
              captureContext: {
                tags: {
                  product: "nudges"
                }
              }
            });
            console.log(`Nudge snapshot: ${((_d = snapshot4.nudge) == null ? void 0 : _d.slug) || ((_e = snapshot4.nudge) == null ? void 0 : _e.id)}`, snapshot4);
          });
        }
        return;
      }
      const nudges = getAllNudges(_);
      for (const nudge of nudges) {
        getDebugSnapshot(_, nudge).then((snapshot4) => {
          var _a2, _b2, _c2, _d, _e;
          (_c2 = getSentry()) == null ? void 0 : _c2.captureMessage(`Nudge debug snapshot: ${((_a2 = snapshot4.nudge) == null ? void 0 : _a2.slug) || ((_b2 = snapshot4.nudge) == null ? void 0 : _b2.id)}`, "info", {
            data: snapshot4,
            captureContext: {
              tags: {
                product: "nudges"
              }
            }
          });
          console.log(`Nudge snapshot: ${((_d = snapshot4.nudge) == null ? void 0 : _d.slug) || ((_e = snapshot4.nudge) == null ? void 0 : _e.id)}`, snapshot4);
        });
      }
      return;
    },
    [_user]: void 0,
    [_fingerprint]: void 0,
    [_setThemeV2]: (themeV2, mode) => {
      if (!themeV2)
        _.themeV2Override = void 0;
      _.themeV2Override = { themeV2, mode };
    },
    [_showWidgetTableau]: (show, widgetSelection) => {
      _.widgetTableauSelection = widgetSelection;
      _.showWidgetTableau = show;
      setVisible(_, show);
    },
    [_setActiveChat](chatId) {
      _.helpHub.activeChat = chatId;
    },
    [_getActiveChat]() {
      return _.helpHub.activeChat;
    },
    [_updateEditorCopilotOverrides]: (data) => {
      _.helpHub.editorCopilotOverrides = data;
      _.helpHub.activeChat = null;
    }
  };
  const sdkMixin = { ...internalSDKMixin, ...externalSdkMixin };
  TRACK_METHODS.forEach((k) => {
    const s = sdkMixin;
    s[k] = clientWrapper(String(k), s[k]);
  });
  proxy2[_configuration] = sdkMixin[_configuration];
  sdk = Object.assign({}, proxy2, sdkMixin);
  window._CommandBarTmpQueueProcessing = sdk;
  sdk = await processQueueAndInstallGlobalSDK(proxy2, sdk);
  delete window._CommandBarTmpQueueProcessing;
  addBuiltInCallbacks(_);
  addBuiltInEventSubscriptions(_);
  return sdk;
}
var processQueueAndInstallGlobalSDK = async (proxy2, sdk) => {
  var _a2;
  const queue = proxy2[_queue];
  const call = async (item) => {
    var _a3;
    const args = [...item];
    if (sdk[_disposed])
      return;
    const fnName = args[0];
    if (ASYNC_METHODS_SNIPPET.includes(fnName)) {
      args.shift();
      if (args[0] instanceof Function) {
        const resolve = args.shift();
        const reject = args.shift();
        try {
          await sdk[fnName](...args).then(resolve, reject);
        } catch (err) {
          (_a3 = proxy2[_sentry]) == null ? void 0 : _a3.captureException(err);
        }
      } else {
        await sdk[fnName](...args);
      }
    } else {
      await sdk[fnName](...args.slice(1));
    }
  };
  const callAll = async (fnName) => {
    do {
      const i2 = queue.findIndex((item2) => (item2 == null ? void 0 : item2[0]) === fnName);
      if (i2 === -1)
        break;
      const item = queue.splice(i2, 1)[0];
      await call(item);
    } while (true);
  };
  await callAll(_configure);
  const bootFinished = callAll("boot");
  const lingeringBootCalls = [];
  while (queue.length > 0) {
    const item = queue.shift();
    if (!item)
      continue;
    const fnName = item[0];
    if (fnName === "boot") {
      lingeringBootCalls.push(item);
      continue;
    }
    if (fnName === "shutdown") {
      continue;
    }
    if (!(fnName in sdk)) {
      (_a2 = proxy2[_sentry]) == null ? void 0 : _a2.captureException(`CommandBar SDK method ${String(fnName)} is not defined.`);
      continue;
    }
    if (ASYNC_METHODS.includes(fnName)) {
      await call(item);
    } else {
      call(item);
    }
  }
  queue.length = 0;
  bootFinished.then(async () => {
    for (let idx = 0; idx < lingeringBootCalls.length; idx++) {
      const item = lingeringBootCalls[idx];
      await call(item);
    }
    dispatchCustomEvent("commandbar-boot-ready", {});
  });
  sdk = Object.assign(proxy2, sdk);
  return sdk;
};
var clientWrapper = (name, fn) => {
  return (...args) => {
    var _a2;
    if (!!LocalStorage_default.get("editor", "")) {
      window.CommandBarLogs = window.CommandBarLogs || [];
      window.CommandBarLogs.push({ name, args, url: window.location.href, time: Date.now() });
    }
    try {
      return fn(...args);
    } catch (e) {
      (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
      throw e;
    }
  };
};

// commandbar/src/useCommandBarSDK.tsx
init_useMutableState();
var useCommandBarSDK = () => {
  const _ = useMutableState();
  useEffect33(() => {
    initSDK(_);
  }, []);
};
var useCommandBarSDK_default = useCommandBarSDK;

// commandbar/src/shared/services/services/organizationService.ts
var OrganizationService = class {
  getOrganization() {
    return this.organization;
  }
  setOrganization(org) {
    this.organization = org;
  }
};
var organizationService = new OrganizationService();

// commandbar/src/shared/util/useDidUpdate.tsx
import * as React177 from "react";
var useDidUpdate = (fn, dependencies) => {
  const didMount = React177.useRef(false);
  React177.useEffect(() => {
    if (didMount.current) {
      fn();
    } else {
      didMount.current = true;
    }
  }, dependencies);
};
var useDidUpdate_default = useDidUpdate;

// commandbar/src/App.tsx
init_dispatchCustomEvent();
init_Reporting();
init_cache_browser_esm();
import { CacheProvider as CacheProvider2 } from "@emotion/core";

// commandbar/src/shared/services/theming/useCustomTheme.tsx
init_theme3();
import React178, { useState as useState22, useEffect as useEffect35 } from "react";
import chroma8 from "chroma-js";

// internal/src/middleware/skin.tsx
init_generics();
import * as t40 from "io-ts";
var SkinV = t40.intersection(
  [
    t40.type({
      id: t40.string,
      slug: t40.string,
      name: t40.string,
      default: t40.boolean,
      skin: t40.any,
      organization: t40.string
    }),
    t40.partial({
      logo: t40.union([t40.string, t40.null]),
      chat_avatar: t40.union([t40.string, t40.null]),
      frozen: t40.boolean
    })
  ],
  "Skin"
);
var SkinPatchV = t40.partial({
  id: t40.string,
  slug: t40.string,
  name: t40.string,
  default: t40.boolean,
  skin: t40.any,
  organization: t40.string,
  logo: t40.union([t40.string, t40.null]),
  chat_avatar: t40.union([t40.string, t40.null])
});
var SkinPatchMetadataV = t40.partial({
  name: t40.string,
  slug: t40.string
});
var Skin = class {
};
Skin.list = listObject(SkinV, "skins");
Skin.read = readObject(SkinV, "skins");
Skin.update = (skin) => update(SkinV, SkinPatchV, `skins/${skin.slug}`)(skin);
Skin.updateMetadata = (slug21, metadata) => update(SkinV, SkinPatchMetadataV, `skins/${slug21}`)(metadata);
Skin.create = createObject(SkinV, SkinPatchV, "skins");
Skin.delete = deleteObject(SkinV, "skins");

// commandbar/src/shared/util/colors.ts
var isHexColor2 = (str) => {
  return /^#([0-9A-F]{3}){1,2}$/i.test(str);
};
var isRGBColor = (str) => {
  return /(rgb)a?\((\s*\d+%?\s*?,?\s*){2}(\s*\d+%?\s*?,?\s*\)?)(\s*,?\s*\/?\s*(0?\.?\d+%?\s*)?|1|0)?\)$/i.test(str);
};
var isSupportedColor = (str) => {
  if (!!str) {
    return isHexColor2(str) || isRGBColor(str);
  }
  return false;
};

// commandbar/src/shared/services/theming/useCustomTheme.tsx
init_useStore();
var DARK_MODE_BASE_FONT_COLOR = "rgba(255,255,255,0.85)";
var LIGHT_MODE_BASE_FONT_COLOR = "rgba(0,0,0,0.85)";
var pickFontColorForBackground = (backgroundColor) => {
  if (chroma8.contrast(backgroundColor, DARK_MODE_BASE_FONT_COLOR) > 4.5) {
    return DARK_MODE_BASE_FONT_COLOR;
  } else {
    return LIGHT_MODE_BASE_FONT_COLOR;
  }
};
var THEME = {
  dark: {
    background: "rgb(36,35,41)",
    fontColor: DARK_MODE_BASE_FONT_COLOR
  },
  light: { background: "rgba(255,255,255, 1.0)", fontColor: LIGHT_MODE_BASE_FONT_COLOR }
};
var useCustomTheme = (props2) => {
  var _a2, _b2, _c2;
  const { isAdmin, theme } = useStore();
  const [semaphore, setSemaphore] = React178.useState(false);
  const { userTheme, barFormFactor, baseTheme, primaryColor, themeSource, organization, setTheme: setTheme3 } = props2;
  const [prevThemeSource, setPrevThemeSource] = useState22("");
  const primary = isSupportedColor(primaryColor) ? primaryColor : (_c2 = (_a2 = userTheme == null ? void 0 : userTheme.base) == null ? void 0 : _a2.primary) != null ? _c2 : (_b2 = theme == null ? void 0 : theme.base) == null ? void 0 : _b2.primary;
  const setProgrammaticTheme = async (baseTheme2, barFormFactor2) => {
    var _a3, _b3, _c3, _d, _e;
    if (typeof baseTheme2 !== "string") {
      if (!isAdmin) {
        return;
      }
      const { skin, logo } = baseTheme2;
      setTheme3(generateTheme({ ...skin, base: { ...skin.base, ...primaryColor && { primary: primaryColor } } }));
      props2.setLogo(logo != null ? logo : "");
    } else if (["light", "dark"].includes(baseTheme2)) {
      const baseThemeStyles = {
        ...THEME[baseTheme2],
        primary,
        fontFamily: (_b3 = (_a3 = userTheme == null ? void 0 : userTheme.base) == null ? void 0 : _a3.fontFamily) != null ? _b3 : "Avenir Next, proxima-nova, sans-serif"
      };
      setTheme3(generateTheme({ ...userTheme, base: baseThemeStyles }, barFormFactor2));
    } else if (isSupportedColor(baseTheme2)) {
      const fontColor = pickFontColorForBackground(baseTheme2);
      const baseThemeStyles = {
        background: baseTheme2,
        fontColor,
        primary,
        fontFamily: (_d = (_c3 = userTheme == null ? void 0 : userTheme.base) == null ? void 0 : _c3.fontFamily) != null ? _d : "Avenir Next, proxima-nova, sans-serif"
      };
      setTheme3(generateTheme({ ...userTheme, base: baseThemeStyles }, barFormFactor2));
    } else {
      if (!organization)
        return;
      if (baseTheme2 === "reset")
        return;
      try {
        const data = await Skin.read(baseTheme2 != null ? baseTheme2 : "", { org: organization.id.toString() });
        setTheme3(
          generateTheme(
            { ...data.skin, base: { ...data.skin.base, ...primaryColor && { primary: primaryColor } } },
            barFormFactor2
          )
        );
        props2.setLogo((_e = data == null ? void 0 : data.logo) != null ? _e : "");
      } catch (err) {
        console.warn(`Theme slug ${baseTheme2} not found.`);
      }
    }
  };
  React178.useEffect(() => {
    if (baseTheme) {
      setProgrammaticTheme(baseTheme, barFormFactor);
      return;
    }
    if (userTheme !== void 0) {
      setTheme3(generateTheme(userTheme, barFormFactor));
    }
  }, [userTheme, baseTheme, themeSource]);
  React178.useEffect(() => {
    if (baseTheme) {
      setTheme3(void 0);
      setProgrammaticTheme(baseTheme, barFormFactor);
      return;
    }
    if (userTheme !== void 0) {
      setTheme3(generateTheme(userTheme, barFormFactor));
    }
  }, [barFormFactor]);
  useEffect35(() => {
    setPrevThemeSource(themeSource);
  }, [themeSource]);
  useEffect35(() => {
    if (baseTheme && !semaphore && prevThemeSource === "setThemeFunction") {
      setProgrammaticTheme(baseTheme, barFormFactor);
    }
  }, [prevThemeSource, themeSource, baseTheme, barFormFactor]);
  React178.useEffect(() => {
    if (!semaphore) {
      setSemaphore(true);
    }
  }, [theme, semaphore]);
  return {
    userTheme: props2.userTheme,
    theme
  };
};
var useCustomTheme_default = useCustomTheme;

// commandbar/src/App.tsx
init_operatingSystem();
init_globals();
init_symbols();
init_service_actions4();
init_service_selectors4();
init_global_actions();
init_useAction();
import { ThemeProvider } from "emotion-theming";

// commandbar/src/shared/util/hooks/useLoadEditor.tsx
init_globals();
init_symbols();
init_LocalStorage();
init_sentry();
import React179 from "react";
var LOCAL_STORAGE_FLAG = "editor";
var QUERY_PARAM_FLAG = "cb_editor";
var useLoadEditor = () => {
  React179.useEffect(() => {
    var _a2;
    let showEditor = LocalStorage_default.get(LOCAL_STORAGE_FLAG, "");
    try {
      const searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has(QUERY_PARAM_FLAG)) {
        showEditor = true;
        searchParams.delete("cb_editor");
        const newPath = !!searchParams.toString() ? `${window.location.pathname}?${searchParams.toString()}` : window.location.pathname;
        window.history.replaceState(null, null, newPath);
      }
    } catch (e) {
      (_a2 = getSentry()) == null ? void 0 : _a2.captureException(e);
    }
    if (!!showEditor && true) {
      getSDK()[_loadEditor]();
    }
  }, []);
};

// commandbar/src/App.tsx
init_useStore();

// commandbar/src/shared/util/useFocusReturnToPreviousElement.ts
init_sentry();
import { useEffect as useEffect36, useRef as useRef27 } from "react";
var isEventTargetFocusable = (eventTarget) => eventTarget && eventTarget instanceof Element && !eventTarget.closest("#commandbar");
var isElementExistsInDOM = (element) => document.body.contains(element);
var useFocusReturnToPreviousElement = (isCommandBarVisible) => {
  const sentry = getSentry();
  const lastFocusedElement = useRef27(null);
  const lastBlurEventTimestamp = useRef27(0);
  const blurEventHandler = (event) => {
    const { target } = event;
    if (isEventTargetFocusable(target)) {
      lastFocusedElement.current = target;
      lastBlurEventTimestamp.current = Date.now();
    }
  };
  useEffect36(() => {
    try {
      if (isCommandBarVisible) {
        const elementWasFocusedRecently = lastFocusedElement.current && Date.now() - lastBlurEventTimestamp.current < 500;
        if (!elementWasFocusedRecently) {
          lastFocusedElement.current = null;
        }
      }
      if (!isCommandBarVisible && lastFocusedElement.current && isElementExistsInDOM(lastFocusedElement.current)) {
        setTimeout(() => {
          lastFocusedElement.current.focus({ preventScroll: true });
        }, 1);
      }
    } catch (err) {
      sentry == null ? void 0 : sentry.captureException(err);
    }
  }, [isCommandBarVisible]);
  useEffect36(() => {
    document.addEventListener("blur", blurEventHandler, true);
    return () => {
      document.removeEventListener("blur", blurEventHandler);
    };
  }, []);
};

// commandbar/src/App.tsx
var import_mousetrap_fork3 = __toESM(require_mousetrap_fork());
init_Z();
init_Logger();
init_useCommandBarContainer();
init_location();
init_useEmotionBugWorkaroundStyleContainer();
init_sentry();
init_useToast();
init_useMobileExperience();
init_useMask();
init_Confetti();
init_ThemeV2Context();

// commandbar/src/shared/store/themeV2/selectors.ts
var selectGlobalThemeAndMode = (_) => {
  var _a2;
  if (_.themeV2Override && _.themeV2Override.themeV2 && _.themeV2Override.mode) {
    return _.themeV2Override;
  }
  const mode = (() => {
    if (_.themeV2Mode === "auto") {
      if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
        return "dark_mode";
      } else {
        return "light_mode";
      }
    }
    return _.themeV2Mode;
  })();
  return {
    themeV2: (_a2 = _.themes.find((t44) => t44.default)) == null ? void 0 : _a2.themeV2,
    mode
  };
};

// commandbar/src/App.tsx
init_usePortal();

// commandbar/src/shared/components/admin-facing/Receiver.ts
init_usePortal();
init_LocalStorage();
init_globals();
init_proxy();
init_symbols();
init_Logger();

// commandbar/src/shared/util/checks.ts
var assertStrictEqual = (actual, expected) => {
  if (actual !== expected) {
    throw new Error(`AssertionError: ${actual} !== ${expected}`);
  }
};
var BrowserEnvironmentTestSuite = {
  title: "Browser Environment",
  tests: [
    {
      description: "Browser API checks",
      testFunction: async () => {
        try {
          assertStrictEqual(typeof Promise, "function");
          assertStrictEqual("resolve" in Promise, true);
          assertStrictEqual("reject" in Promise, true);
          assertStrictEqual(typeof Promise.resolve, "function");
          assertStrictEqual(typeof Promise.reject, "function");
          let result = false;
          await Promise.resolve(42).finally(() => result = true);
          assertStrictEqual(result, true);
          return true;
        } catch (err) {
          console.log("CommandBar checks", err);
          return false;
        }
      }
    }
  ]
};
var ConfigurationTestSuite = {
  title: "CommandBar Configuration",
  tests: [
    {
      description: ".boot() is called once",
      testFunction: () => {
        try {
          const logs = window.CommandBarLogs || [];
          const isBootCalledOnce = logs.filter((log2) => log2.name === "boot").length <= 1;
          assertStrictEqual(isBootCalledOnce, true);
          return true;
        } catch (err) {
          console.log("CommandBar checks", err);
          return false;
        }
      }
    }
  ]
};
var Checks = [BrowserEnvironmentTestSuite, ConfigurationTestSuite];
var runChecks = async () => {
  const results = [];
  for (const { title, tests } of Checks) {
    for (const { description, testFunction } of tests) {
      const passed = await testFunction();
      results.push({
        check: `[${title}]: ${description}`,
        status: passed ? "Passed" : "Failed"
      });
    }
  }
  return results;
};

// commandbar/src/shared/components/admin-facing/Receiver.ts
init_location();
init_dom();
init_sentry();
var client = async ({ data }) => {
  var _a2, _b2;
  const { target: _, ...toSend } = data;
  const params = (_a2 = toSend == null ? void 0 : toSend.data) != null ? _a2 : [];
  const method = toSend == null ? void 0 : toSend.method;
  try {
    const sdk = getProxySDK();
    const fn = sdk[method] || sdk[Symbol.for(`CommandBar::${String(method)}`)];
    let result;
    if (fn instanceof Function) {
      result = fn(...params);
    } else if (fn != null) {
      result = fn;
    } else {
      throw new Error("unknown method");
    }
    return respondSuccess({ result, method });
  } catch (err) {
    Logger_default.error("Proxy client receiver error", err);
    (_b2 = getSentry()) == null ? void 0 : _b2.captureException(err);
    return respondError(String(err));
  }
};
var onCMDK = () => {
  const sdk = getSDK();
  if (isStudioPreview()) {
    sdk.isOpen() ? sdk.close() : sdk.open();
  }
  return respondSuccess();
};
var synToken = ({ data }) => {
  const { token } = data == null ? void 0 : data.data;
  if (!!token) {
    LocalStorage_default.set("token", token);
    if (!isStudioPreview()) {
      LocalStorage_default.set("editor", "1");
    }
    getSDK()[_configUser]();
  } else {
    LocalStorage_default.remove("token");
  }
  return respondSuccess();
};
var secureEditor = () => {
  if (!isStudioPreview()) {
    LocalStorage_default.set("editor", "1");
  }
  return respondSuccess();
};
var logout = () => {
  LocalStorage_default.remove("token");
  LocalStorage_default.remove("editor");
  getSDK()[_configUser]();
  return respondSuccess();
};
var shareHostURL = () => {
  return respondSuccess({ url: window.location.href });
};
var shareLogs = () => {
  return respondSuccess({ logs: window.CommandBarLogs || [] });
};
var getProgrammaticTheme = () => {
  return respondSuccess({ data: getSDK()[_programmaticTheme] });
};
var shareConfiguration = () => {
  return respondSuccess({ data: getSDK()[_configuration] });
};
var shareUser = () => {
  return respondSuccess({ data: getSDK()[_user] });
};
var shareChecks = async () => {
  const results = await runChecks();
  return respondSuccess({ data: results });
};
var shareIsOpen = () => {
  return respondSuccess({ isOpen: getSDK().isOpen() });
};
var shareCallbacks = () => {
  const callbacks = getSDK().shareCallbacks() || {};
  return respondSuccess({ callbacks: Object.keys(callbacks) });
};
var shareComponentNamesByKey = () => {
  const componentNamesByKey = getSDK().shareComponentNamesByKey() || {};
  return respondSuccess({ components: componentNamesByKey });
};
var setTheme2 = ({ data }) => {
  const slug21 = data == null ? void 0 : data.data;
  getSDK().setTheme(slug21);
  return respondSuccess({});
};
var setThemeV2 = ({ data }) => {
  if (!data || !data.data)
    return;
  getSDK()[_setThemeV2](data.data.themeV2, data.data.mode);
  return respondSuccess({});
};
var showWidgetTableau = ({ data }) => {
  if (!data)
    return;
  getSDK()[_showWidgetTableau](Boolean(data.data.show), data.data.widgetSelection);
  return respondSuccess({});
};
var shareOrganizationID = () => {
  const { uuid: uuid3 } = getSDK()[_configuration];
  return respondSuccess({ data: uuid3 });
};
var checkIfSelectorValid = ({ data }) => {
  const selector2 = data == null ? void 0 : data.data;
  const result = checkSelectorAndVisibility(selector2);
  return respondSuccess({ elementFound: result.elementFound, elementVisible: result.elementVisible });
};
var getActiveChat = () => {
  const chatId = getSDK()[_getActiveChat]();
  return respondSuccess({ chatId });
};
var Receiver = {
  editor: {
    client,
    logout,
    synToken,
    onCMDK,
    shareHostURL,
    shareLogs,
    getProgrammaticTheme,
    shareUser,
    shareIsOpen,
    shareCallbacks,
    shareComponentNamesByKey,
    checkIfSelectorValid,
    shareChecks,
    secureEditor,
    setTheme: setTheme2,
    setThemeV2,
    showWidgetTableau,
    shareConfiguration,
    shareOrganizationID,
    getActiveChat
  }
};
var Receiver_default = Receiver;

// commandbar/src/App.tsx
init_BannerContext();

// commandbar/src/PreviewPane.tsx
init_useStore();
init_ThemeV2Context();
import panzoom from "panzoom";
import React181 from "react";
var PreviewPane = ({ children }) => {
  const instance = React181.useRef(null);
  const { widgetTableauSelection } = useStore();
  const { mode } = useThemeV2Context();
  const ref12 = React181.useCallback(
    (elem) => {
      if (!elem) {
        if (instance.current) {
          instance.current.dispose();
          instance.current = null;
        }
        return;
      }
      instance.current = panzoom(elem, {
        maxZoom: 1,
        minZoom: 0.4,
        zoomDoubleClickSpeed: 1,
        smoothScroll: false,
        initialZoom: 1,
        filterKey: function() {
          return true;
        }
      });
      instance.current.on("pan", function() {
        document.body.style.cursor = "grab";
        elem.style["pointerEvents"] = "none";
      });
      instance.current.on("panend", function() {
        document.body.style.cursor = "auto";
        elem.style.removeProperty("pointer-events");
      });
      const content = elem.children[0];
      if (!content)
        return;
      elem.addEventListener("mousedown", handleMouseDown);
      elem.addEventListener("wheel", handleWheel);
      return () => {
        elem.removeEventListener("mousedown", handleMouseDown);
        elem.removeEventListener("wheel", handleWheel);
      };
    },
    [widgetTableauSelection]
  );
  const handleMouseDown = (event) => {
    var _a2, _b2;
    const target = event.target;
    const isOutsideCommandBarWidget = (target == null ? void 0 : target.id) === "panzoom-container";
    if (isOutsideCommandBarWidget) {
      (_a2 = instance.current) == null ? void 0 : _a2.resume();
    } else {
      (_b2 = instance.current) == null ? void 0 : _b2.pause();
    }
  };
  const handleWheel = (event) => {
    var _a2, _b2;
    const target = event.target;
    const isOutsideCommandBarWidget = (target == null ? void 0 : target.id) === "panzoom-container";
    if (isOutsideCommandBarWidget) {
      (_a2 = instance.current) == null ? void 0 : _a2.resume();
    } else {
      (_b2 = instance.current) == null ? void 0 : _b2.pause();
    }
  };
  return /* @__PURE__ */ React181.createElement(
    "div",
    {
      style: {
        position: "absolute",
        inset: 0,
        overflow: "clip",
        backgroundColor: mode === "light_mode" ? "#F9F9F9" : "#3F424A",
        /* TODO: deduplicate with commandbar.com/src/image/cb_dot_pattern.svg somehow */
        backgroundImage: "url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABZSURBVHgB7dG7DYBADANQJxexAiXSTXw9uyExBih34SOxQhr83Li2ASIiIiIiIvo7QbLW1jms1zijq9puSDaGLxhhuBPaqyKZTFK+/q6AZOJlg8shqv5ccAGZWRnaKiSy9QAAAABJRU5ErkJggg==)"
      }
    },
    /* @__PURE__ */ React181.createElement("div", { id: "panzoom-container", style: { width: "100%", height: "100%" }, ref: ref12 }, children)
  );
};
var PreviewPane_default = PreviewPane;

// commandbar/src/App.tsx
var LazyChecklistContainer = React363.lazy(() => Promise.resolve().then(() => (init_Checklist(), Checklist_exports)));
var LazySpotlight = React363.lazy(() => Promise.resolve().then(() => (init_Spotlight(), Spotlight_exports)));
var LazySpotlightLauncherContainer = React363.lazy(
  () => Promise.resolve().then(() => (init_SpotlightLauncherContainer(), SpotlightLauncherContainer_exports))
);
var LazyNudges = React363.lazy(() => Promise.resolve().then(() => (init_Nudges(), Nudges_exports)));
var LazyAssistanceLauncher = React363.lazy(() => Promise.resolve().then(() => (init_AssistanceLauncher(), AssistanceLauncher_exports)));
var LazyAssistanceWidget = React363.lazy(() => Promise.resolve().then(() => (init_AssistanceWidget(), AssistanceWidget_exports)));
var LazyWidgetTableau = React363.lazy(() => Promise.resolve().then(() => (init_WidgetTableau(), WidgetTableau_exports)));
var LazyEditor = React363.lazy(() => Promise.resolve().then(() => (init_Editor(), Editor_exports)));
var MTBody = new import_mousetrap_fork3.default(document.body, true);
var CommandBarWidgets = () => {
  const _ = useStore();
  const { organization } = _;
  const { isStudioMobilePreview } = useMobileExperience();
  const { generatedCSSClassname } = useThemeV2Context();
  const showSpotlight = _.products.includes("spotlight") && (organization == null ? void 0 : organization.bar_enabled);
  const showNudges = _.products.includes("nudges");
  const showChecklists = _.products.includes("checklists");
  const showAssistance = _.products.includes("help_hub") && ((organization == null ? void 0 : organization.helphub_enabled) || (organization == null ? void 0 : organization.copilot_enabled));
  const renderSpotlight = () => {
    if (showSpotlight) {
      return /* @__PURE__ */ React363.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React363.createElement(LazySpotlight, null), /* @__PURE__ */ React363.createElement(LazySpotlightLauncherContainer, null));
    }
  };
  const renderNudges = () => {
    var _a2;
    if (showNudges) {
      const commandBarWrapper = document.getElementById(
        isStudioMobilePreview ? "commandbar-mobile-preview-wrapper" : "commandbar-wrapper"
      );
      const commandBarWrapperRect = commandBarWrapper == null ? void 0 : commandBarWrapper.getBoundingClientRect();
      return /* @__PURE__ */ React363.createElement(React363.Fragment, null, /* @__PURE__ */ React363.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React363.createElement(LazyNudges, null)), /* @__PURE__ */ React363.createElement(MaskContainer, null), /* @__PURE__ */ React363.createElement(
        ToastContainer,
        {
          containerStyle: {
            zIndex: Z_default.Z_NUDGE,
            marginTop: isStudioPreview() ? "51px" : void 0,
            marginLeft: isStudioPreview() ? `${(_a2 = commandBarWrapperRect == null ? void 0 : commandBarWrapperRect.left) != null ? _a2 : 0}px` : void 0
          }
        }
      ), /* @__PURE__ */ React363.createElement(BannerContainer, null));
    }
  };
  const renderChecklists = () => {
    if (showChecklists) {
      return /* @__PURE__ */ React363.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React363.createElement(LazyChecklistContainer, null));
    }
  };
  const renderAssistance = () => {
    if (showAssistance) {
      return /* @__PURE__ */ React363.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React363.createElement(LazyAssistanceLauncher, null), /* @__PURE__ */ React363.createElement(LazyAssistanceWidget, null));
    }
  };
  const isStudioPreviewVal = useMemo20(() => {
    const retval = isStudioPreview();
    return retval;
  }, []);
  return /* @__PURE__ */ React363.createElement("div", { className: generatedCSSClassname, id: "commandbar-themeV2-root" }, _.showWidgetTableau ? /* @__PURE__ */ React363.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React363.createElement(LazyWidgetTableau, null)) : isStudioPreviewVal ? /* @__PURE__ */ React363.createElement(PreviewPane_default, null, renderSpotlight(), /* @__PURE__ */ React363.createElement(Confetti_default, null), renderChecklists(), renderNudges(), renderAssistance()) : /* @__PURE__ */ React363.createElement(React363.Fragment, null, renderSpotlight(), /* @__PURE__ */ React363.createElement(Confetti_default, null), renderChecklists(), renderNudges(), renderAssistance()));
};
var App = ({ children }) => {
  var _a2;
  useCommandBarSDK_default();
  useLoadEditor();
  const sentry = getSentry();
  const _ = useStore();
  const setLogo2 = useAction(setLogo);
  const setTheme3 = useAction(setTheme);
  const { organization, themeSource, baseTheme, primaryColor } = _;
  const { visible } = _.spotlight;
  useFocusReturnToPreviousElement(visible);
  const booted = useRef48(_.active);
  const { isMobileDevice: isMobileDevice2 } = useMobileExperience();
  const container = document.getElementById("commandbar-wrapper");
  const styleContainer = useEmotionBugWorkaroundStyleContainer_default(container != null ? container : document.head);
  const emotionCache = useMemo20(() => {
    var _a3, _b2;
    const sdk = getSDK();
    return cache_browser_esm_default({
      key: "commandbar-toplevel",
      container: styleContainer,
      // INFO: speedy mode does not work with Ruby on Rails
      // https://github.com/emotion-js/emotion/discussions/2903
      speedy: !((_a3 = _.flags) == null ? void 0 : _a3["support-ruby-on-rails"]),
      nonce: (_b2 = sdk[_configuration]) == null ? void 0 : _b2.nonce
    });
  }, [styleContainer, (_a2 = _.flags) == null ? void 0 : _a2["support-ruby-on-rails"]]);
  const theme = useCustomTheme_default({
    userTheme: organization == null ? void 0 : organization.theme,
    barFormFactor: _.spotlight.formFactor,
    baseTheme,
    primaryColor,
    themeSource,
    organization,
    setLogo: setLogo2,
    setTheme: setTheme3
  });
  useEffect78(() => {
    organizationService.setOrganization(organization);
  }, [organization]);
  const reportEndSession = () => {
    endSession();
  };
  React363.useEffect(() => {
    window.addEventListener("beforeunload", reportEndSession);
    return () => window.removeEventListener("beforeunload", reportEndSession);
  }, []);
  usePortal_default(Receiver_default);
  const refocusInputOnVisibilityChange = () => {
    if (_.active) {
      if (_.spotlight.refContainer.current !== null) {
        if (visible && !isMobileDevice2) {
          _.spotlight.refContainer.current.focus();
        } else {
          _.spotlight.refContainer.current.blur();
        }
      }
    }
  };
  useDidUpdate_default(refocusInputOnVisibilityChange, [visible]);
  useEffect78(() => {
    if (visible) {
      dispatchCustomEvent("CommandBar.opened", { detail: { open: true } });
    }
  }, [visible]);
  const handleOnCMDK = useAction((_2, e) => {
    var _a3;
    if (!isStudioPreview() && !isTextSelected() && _2.active && _2.products.includes("spotlight") && ((_a3 = _2.organization) == null ? void 0 : _a3.bar_enabled)) {
      e.stopPropagation();
      e.preventDefault();
      toggleBar(_2, "keyboard");
      dispatchCustomEvent("commandbar-shortcut-executed", {
        detail: { keys: `${osControlKey().toLowerCase() === "ctrl" ? "ctrl" : "command"}+k` }
      });
    }
  });
  const isTextSelected = () => {
    try {
      if (typeof window.getSelection != "undefined") {
        return (window.getSelection() || "").toString().length > 0;
      }
      return false;
    } catch (err) {
      sentry == null ? void 0 : sentry.captureException(err);
      return false;
    }
  };
  const summonHotkey = selectSummonHotkey(useStore());
  React363.useEffect(() => {
    MTBody.reset();
    MTBody.bind(summonHotkey, (e) => {
      handleOnCMDK(e);
    });
  }, [handleOnCMDK, summonHotkey]);
  React363.useEffect(() => {
    if (_.active) {
      booted.current = true;
      const sdk = getSDK();
      sentry == null ? void 0 : sentry.setUser({
        configuration: sdk[_configuration],
        organization,
        organizationId: sdk[_configuration].uuid,
        organizationName: organization == null ? void 0 : organization.name,
        session: sdk[_configuration].session,
        userId: sdk[_user] || void 0
      });
    }
  }, [_.active, organization]);
  React363.useEffect(() => {
    const timeout = setTimeout(() => {
      if (!booted.current && !localStorage.getItem("adm")) {
        console.warn(
          "\u{1F44B} CommandBar is almost ready. You just need to call `boot()` to make it available in your app. Learn more: https://www.commandbar.com/docs/sdk/lifecycle/boot/"
        );
        error2("not_booted", {});
      }
    }, 15e3);
    return () => clearTimeout(timeout);
  }, []);
  if (theme.theme === void 0) {
    return null;
  }
  const shouldLoadEditorDrawer = _.isEditorActive && !isStudioPreview() && !_.extension.recorder.enabled && !_.extension.preview.enabled;
  return /* @__PURE__ */ React363.createElement(React363.Fragment, null, /* @__PURE__ */ React363.createElement(CacheProvider2, { value: emotionCache }, /* @__PURE__ */ React363.createElement(ThemeProvider, { theme }, /* @__PURE__ */ React363.createElement(ThemeContext_default.Provider, { value: defaultTheme }, _.active ? /* @__PURE__ */ React363.createElement(CommandBarWidgets, null) : null, children))), shouldLoadEditorDrawer && /* @__PURE__ */ React363.createElement(Suspense, { fallback: null }, /* @__PURE__ */ React363.createElement(LazyEditor, { src: getSDK()[_configuration].editor })));
};
var AppContainer = (props2) => {
  const _ = useStore();
  const themeAndMode = selectGlobalThemeAndMode(_);
  const formFactor = _.spotlight.formFactor;
  const commandBarContainerContext = useMemo20(() => {
    if (formFactor.type === "inline") {
      const inlineRootElement = typeof formFactor.rootElement === "string" ? document.getElementById(formFactor.rootElement) : formFactor.rootElement;
      if (!inlineRootElement) {
        Logger_default.error("Unable to mount; root element for 'inline' bar not found", formFactor.rootElement);
        return null;
      }
      const root = (() => {
        const n = inlineRootElement.getRootNode();
        if (n instanceof ShadowRoot) {
          return n;
        }
        return document;
      })();
      return {
        container: inlineRootElement,
        root
      };
    } else {
      return {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        container: document.getElementById("commandbar"),
        root: document
      };
    }
  }, [formFactor]);
  if (!commandBarContainerContext)
    return null;
  return /* @__PURE__ */ React363.createElement(CommandBarContainerContext.Provider, { value: commandBarContainerContext }, /* @__PURE__ */ React363.createElement(BindThemeV2, { themeV2: themeAndMode.themeV2, mode: themeAndMode.mode }, /* @__PURE__ */ React363.createElement(App, { ...props2 })));
};
var App_default2 = AppContainer;

// commandbar/src/CommandBarContainer.tsx
init_globals();
init_Disposable();
init_symbols();
init_GlobalStoreProvider();
init_sentry();
var CommandBarContainer = (props2) => {
  const [initialized, setInitialized] = React364.useState(false);
  useEffect79(
    () => () => {
      var _a2;
      (_a2 = getSentry()) == null ? void 0 : _a2.addBreadcrumb({
        level: "debug",
        category: "internal",
        message: "Disposing CommandBar"
      });
      dispose(getSDK());
    },
    []
  );
  useEffect79(() => {
    getSDK()[_configure](props2.orgID);
    if (typeof props2.userID !== "undefined") {
      getSDK().boot(props2.userID);
    }
    setInitialized(true);
  }, [props2.orgID]);
  return /* @__PURE__ */ React364.createElement(SentryErrorBoundary, null, /* @__PURE__ */ React364.createElement(GlobalStoreProvider, null, initialized && /* @__PURE__ */ React364.createElement(App_default2, null, props2.children)));
};

// commandbar/src/index.tsx
init_LocalStorage();
init_sentry();
getProxySDK();
initSentryAndAddToSdk();
if (LocalStorage_default.get("debug:nudges", false)) {
  import("@xstate/inspect").then(({ inspect }) => {
    inspect({
      iframe: false
      // open in new window
    });
  });
}
var loadedFromStaticBundle = true;
var _a, _b, _c;
if (!loadedFromStaticBundle && true) {
  const sdk = getProxySDK();
  const uid = (_a = sdk[_configuration]) == null ? void 0 : _a.uuid;
  const props2 = {
    orgID: "42424242",
    userID: "test-user"
  };
  (_b = getSentry()) == null ? void 0 : _b.addBreadcrumb({
    level: "debug",
    category: "internal",
    message: "Initializing CommandBar",
    data: {
      orgID: uid
    }
  });
  if (!uid) {
    if (true) {
      console.warn("[COMMANDBAR] configuration is missing!");
      (_c = getSentry()) == null ? void 0 : _c.captureException(new Error("CommandBar configuration is missing!"));
      props2.orgID = "";
    } else if (false) {
      console.info("[COMMANDBAR] init with development defaults: orgID=42424242, orgName=test-org, userID=test-user");
    }
  } else {
    props2.orgID = uid;
    props2.userID = void 0;
  }
  if (!props2.orgID) {
    console.warn("[COMMANDBAR] org ID is invalid; please contact CommandBar for assistance.", props2.orgID);
  }
  const container = deploy();
  ReactDOM12.render(/* @__PURE__ */ React365.createElement(CommandBarContainer, { ...props2 }), container);
}
var SUPPORTED_FOOBAR_INIT_DEPLOYMENT_OPTIONS = ["dev", "labs", "prod"];
var init = async (orgID, initOptions) => {
  var _a2, _b2, _c2;
  let providedLC = initOptions && initOptions.deployment;
  if (providedLC && !SUPPORTED_FOOBAR_INIT_DEPLOYMENT_OPTIONS.includes(providedLC)) {
    console.warn(
      `[COMMANDBAR] Unsupported \`deployment\` option in \`init\` (supported options: ${SUPPORTED_FOOBAR_INIT_DEPLOYMENT_OPTIONS.join(
        ", "
      )})`
    );
    providedLC = void 0;
  }
  const lc = localStorage.getItem("commandbar.lc") || providedLC || "";
  const forceStaticBundle = localStorage.getItem("commandbar.fsb") || "";
  const sdk = getProxySDK();
  sdk[_configuration].environment = initOptions == null ? void 0 : initOptions.environment;
  sdk[_configuration].version = initOptions == null ? void 0 : initOptions.version;
  sdk[_configuration].config = initOptions == null ? void 0 : initOptions.config;
  sdk[_configuration].nonce = initOptions == null ? void 0 : initOptions.nonce;
  sdk[_configuration].api = initOptions == null ? void 0 : initOptions.apiOrigin;
  sdk[_configuration].cdn = initOptions == null ? void 0 : initOptions.cdnOrigin;
  if (!!lc && !!!forceStaticBundle) {
    console.warn(`[COMMANDBAR] Overwriting @commandbar/foobar for ${lc}`);
    const loadScript = (src, async = false) => {
      const el = document.createElement("script");
      el.type = "text/javascript";
      el.async = async;
      el.src = src;
      document.head.appendChild(el);
    };
    let origin = lc.includes("local") ? "http://localhost:8000" : (initOptions == null ? void 0 : initOptions.apiOrigin) || "https://api.commandbar.com";
    if (lc.includes("api=preview")) {
      const branchIdentifier = lc.split(";").filter((str) => str.includes("api"))[0].split("_").pop();
      origin = `https://${branchIdentifier}.commandbar.xyz:8000`;
    }
    const params2 = new URLSearchParams({
      version: "2",
      lc
    });
    if (!!(initOptions == null ? void 0 : initOptions.nonce)) {
      params2.append("nonce", initOptions.nonce);
    }
    if (!!(initOptions == null ? void 0 : initOptions.silentMode)) {
      params2.append("silent", "true");
    }
    if (!!(initOptions == null ? void 0 : initOptions.cdnOrigin)) {
      params2.append("cdn", initOptions.cdnOrigin);
    }
    const latestSrc = `${origin}/latest/${orgID}?${params2.toString()}`;
    if (sdk[_configuration])
      sdk[_configuration].uuid = orgID;
    loadScript(latestSrc, true);
    return;
  }
  const container = deploy(lc);
  const api = (_b2 = (_a2 = sdk[_configuration]) == null ? void 0 : _a2.api) != null ? _b2 : "https://api.commandbar.com";
  let params = "";
  try {
    if (true) {
      params = new URLSearchParams({
        version: "0.5.86",
        environment: window.location.hostname
      }).toString();
      params = `?${params}`;
    }
  } catch (err) {
    (_c2 = getSentry()) == null ? void 0 : _c2.captureException(err);
  }
  async function fetchWithDefault(url, defaultResponse2) {
    try {
      const response2 = await fetch(url);
      if (!response2.ok) {
        return defaultResponse2;
      }
      return await response2.json();
    } catch (e) {
      return defaultResponse2;
    }
  }
  const defaultResponse = {
    silent_mode: true,
    event_attribute_block_list: [],
    deployment_can_install_foobar: true
  };
  const b_response = !!(initOptions == null ? void 0 : initOptions.disable_analytics) || !!(initOptions == null ? void 0 : initOptions.silentMode) ? defaultResponse : await fetchWithDefault(`${api}/organizations/${orgID}/b/${params}`, defaultResponse);
  sdk[_configuration].silent = b_response.silent_mode;
  sdk[_configuration].eventAttributeBlockList = b_response.event_attribute_block_list;
  if (b_response.deployment_can_install_foobar === true) {
    ReactDOM12.render(/* @__PURE__ */ React365.createElement(CommandBarContainer, { orgID }), container);
    return container;
  } else {
    console.error(
      "[COMMANDBAR] This organization is not authorized to use @commandbar/foobar. Please message the CommandBar team."
    );
    return;
  }
};
var src_default = init;
export {
  SUPPORTED_FOOBAR_INIT_DEPLOYMENT_OPTIONS,
  src_default as default,
  init
};
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)

react-is/cjs/react-is.production.min.js:
  (** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

event-source-polyfill/src/eventsource.js:
  (** @license
   * eventsource.js
   * Available under MIT License (MIT)
   * https://github.com/Yaffle/EventSource/
   *)
*/
